(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5906"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5906"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cc6u1", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gfEwi"));

});
parcelRegister("gfEwi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $bd4d7a771fe61853$export$ffb0004e005737fa; }, function (v) { return $bd4d7a771fe61853$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $bd4d7a771fe61853$export$34b9dba7ce09269b; }, function (v) { return $bd4d7a771fe61853$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $bd4d7a771fe61853$export$25062201e9e25d76; }, function (v) { return $bd4d7a771fe61853$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bd4d7a771fe61853$export$ffb0004e005737fa;
var $bd4d7a771fe61853$export$34b9dba7ce09269b;
var $bd4d7a771fe61853$export$25062201e9e25d76;
"use strict";

var $fIwXP = parcelRequire("fIwXP");
var $bd4d7a771fe61853$var$k = Symbol.for("react.element"), $bd4d7a771fe61853$var$l = Symbol.for("react.fragment"), $bd4d7a771fe61853$var$m = Object.prototype.hasOwnProperty, $bd4d7a771fe61853$var$n = $fIwXP.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $bd4d7a771fe61853$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $bd4d7a771fe61853$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$bd4d7a771fe61853$var$m.call(a, b) && !$bd4d7a771fe61853$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $bd4d7a771fe61853$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $bd4d7a771fe61853$var$n.current
    };
}
$bd4d7a771fe61853$export$ffb0004e005737fa = $bd4d7a771fe61853$var$l;
$bd4d7a771fe61853$export$34b9dba7ce09269b = $bd4d7a771fe61853$var$q;
$bd4d7a771fe61853$export$25062201e9e25d76 = $bd4d7a771fe61853$var$q;

});
parcelRegister("fIwXP", function(module, exports) {
"use strict";

module.exports = (parcelRequire("56YRW"));

});
parcelRegister("56YRW", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $3b8cba9a6536b6a4$export$dca3b0875bd9a954; }, function (v) { return $3b8cba9a6536b6a4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $3b8cba9a6536b6a4$export$16fa2f45be04daa8; }, function (v) { return $3b8cba9a6536b6a4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $3b8cba9a6536b6a4$export$ffb0004e005737fa; }, function (v) { return $3b8cba9a6536b6a4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $3b8cba9a6536b6a4$export$e2c29f18771995cb; }, function (v) { return $3b8cba9a6536b6a4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $3b8cba9a6536b6a4$export$221d75b3f55bb0bd; }, function (v) { return $3b8cba9a6536b6a4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $3b8cba9a6536b6a4$export$5f8d39834fd61797; }, function (v) { return $3b8cba9a6536b6a4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $3b8cba9a6536b6a4$export$74bf444e3cd11ea5; }, function (v) { return $3b8cba9a6536b6a4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $3b8cba9a6536b6a4$export$ae55be85d98224ed; }, function (v) { return $3b8cba9a6536b6a4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $3b8cba9a6536b6a4$export$e530037191fcd5d7; }, function (v) { return $3b8cba9a6536b6a4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $3b8cba9a6536b6a4$export$fd42f52fd3ae1109; }, function (v) { return $3b8cba9a6536b6a4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $3b8cba9a6536b6a4$export$c8a8987d4410bf2d; }, function (v) { return $3b8cba9a6536b6a4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $3b8cba9a6536b6a4$export$d38cd72104c1f0e9; }, function (v) { return $3b8cba9a6536b6a4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $3b8cba9a6536b6a4$export$7d1e3a5e95ceca43; }, function (v) { return $3b8cba9a6536b6a4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $3b8cba9a6536b6a4$export$257a8862b851cb5b; }, function (v) { return $3b8cba9a6536b6a4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $3b8cba9a6536b6a4$export$a8257692ac88316c; }, function (v) { return $3b8cba9a6536b6a4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $3b8cba9a6536b6a4$export$488013bae63b21da; }, function (v) { return $3b8cba9a6536b6a4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $3b8cba9a6536b6a4$export$7c73462e0d25e514; }, function (v) { return $3b8cba9a6536b6a4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $3b8cba9a6536b6a4$export$7568632d0d33d16d; }, function (v) { return $3b8cba9a6536b6a4$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $3b8cba9a6536b6a4$export$88948ce120ea2619; }, function (v) { return $3b8cba9a6536b6a4$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $3b8cba9a6536b6a4$export$35808ee640e87ca7; }, function (v) { return $3b8cba9a6536b6a4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $3b8cba9a6536b6a4$export$fae74005e78b1a27; }, function (v) { return $3b8cba9a6536b6a4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $3b8cba9a6536b6a4$export$dc8fbce3eb94dc1e; }, function (v) { return $3b8cba9a6536b6a4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $3b8cba9a6536b6a4$export$6a7bc4e911dc01cf; }, function (v) { return $3b8cba9a6536b6a4$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $3b8cba9a6536b6a4$export$6d9c69b0de29b591; }, function (v) { return $3b8cba9a6536b6a4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $3b8cba9a6536b6a4$export$f680877a34711e37; }, function (v) { return $3b8cba9a6536b6a4$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $3b8cba9a6536b6a4$export$d5a552a76deda3c2; }, function (v) { return $3b8cba9a6536b6a4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $3b8cba9a6536b6a4$export$aaabe4eda9ed9969; }, function (v) { return $3b8cba9a6536b6a4$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $3b8cba9a6536b6a4$export$e5c5a5f917a5871c; }, function (v) { return $3b8cba9a6536b6a4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $3b8cba9a6536b6a4$export$1538c33de8887b59; }, function (v) { return $3b8cba9a6536b6a4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $3b8cba9a6536b6a4$export$13e3392192263954; }, function (v) { return $3b8cba9a6536b6a4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $3b8cba9a6536b6a4$export$b8f5890fc79d6aca; }, function (v) { return $3b8cba9a6536b6a4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $3b8cba9a6536b6a4$export$60241385465d0a34; }, function (v) { return $3b8cba9a6536b6a4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $3b8cba9a6536b6a4$export$306c0aa65ff9ec16; }, function (v) { return $3b8cba9a6536b6a4$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $3b8cba9a6536b6a4$export$7b286972b8d8ccbf; }, function (v) { return $3b8cba9a6536b6a4$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $3b8cba9a6536b6a4$export$83d89fbfd8236492; }, function (v) { return $3b8cba9a6536b6a4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $YtE9h = parcelRequire("YtE9h");
var $3b8cba9a6536b6a4$export$dca3b0875bd9a954;
var $3b8cba9a6536b6a4$export$16fa2f45be04daa8;
var $3b8cba9a6536b6a4$export$ffb0004e005737fa;
var $3b8cba9a6536b6a4$export$e2c29f18771995cb;
var $3b8cba9a6536b6a4$export$221d75b3f55bb0bd;
var $3b8cba9a6536b6a4$export$5f8d39834fd61797;
var $3b8cba9a6536b6a4$export$74bf444e3cd11ea5;
var $3b8cba9a6536b6a4$export$ae55be85d98224ed;
var $3b8cba9a6536b6a4$export$e530037191fcd5d7;
var $3b8cba9a6536b6a4$export$fd42f52fd3ae1109;
var $3b8cba9a6536b6a4$export$c8a8987d4410bf2d;
var $3b8cba9a6536b6a4$export$d38cd72104c1f0e9;
var $3b8cba9a6536b6a4$export$7d1e3a5e95ceca43;
var $3b8cba9a6536b6a4$export$257a8862b851cb5b;
var $3b8cba9a6536b6a4$export$a8257692ac88316c;
var $3b8cba9a6536b6a4$export$488013bae63b21da;
var $3b8cba9a6536b6a4$export$7c73462e0d25e514;
var $3b8cba9a6536b6a4$export$7568632d0d33d16d;
var $3b8cba9a6536b6a4$export$88948ce120ea2619;
var $3b8cba9a6536b6a4$export$35808ee640e87ca7;
var $3b8cba9a6536b6a4$export$fae74005e78b1a27;
var $3b8cba9a6536b6a4$export$dc8fbce3eb94dc1e;
var $3b8cba9a6536b6a4$export$6a7bc4e911dc01cf;
var $3b8cba9a6536b6a4$export$6d9c69b0de29b591;
var $3b8cba9a6536b6a4$export$f680877a34711e37;
var $3b8cba9a6536b6a4$export$d5a552a76deda3c2;
var $3b8cba9a6536b6a4$export$aaabe4eda9ed9969;
var $3b8cba9a6536b6a4$export$e5c5a5f917a5871c;
var $3b8cba9a6536b6a4$export$1538c33de8887b59;
var $3b8cba9a6536b6a4$export$13e3392192263954;
var $3b8cba9a6536b6a4$export$b8f5890fc79d6aca;
var $3b8cba9a6536b6a4$export$60241385465d0a34;
var $3b8cba9a6536b6a4$export$306c0aa65ff9ec16;
var $3b8cba9a6536b6a4$export$7b286972b8d8ccbf;
var $3b8cba9a6536b6a4$export$83d89fbfd8236492;
"use strict";
var $3b8cba9a6536b6a4$var$l = Symbol.for("react.element"), $3b8cba9a6536b6a4$var$n = Symbol.for("react.portal"), $3b8cba9a6536b6a4$var$p = Symbol.for("react.fragment"), $3b8cba9a6536b6a4$var$q = Symbol.for("react.strict_mode"), $3b8cba9a6536b6a4$var$r = Symbol.for("react.profiler"), $3b8cba9a6536b6a4$var$t = Symbol.for("react.provider"), $3b8cba9a6536b6a4$var$u = Symbol.for("react.context"), $3b8cba9a6536b6a4$var$v = Symbol.for("react.forward_ref"), $3b8cba9a6536b6a4$var$w = Symbol.for("react.suspense"), $3b8cba9a6536b6a4$var$x = Symbol.for("react.memo"), $3b8cba9a6536b6a4$var$y = Symbol.for("react.lazy"), $3b8cba9a6536b6a4$var$z = Symbol.iterator;
function $3b8cba9a6536b6a4$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $3b8cba9a6536b6a4$var$z && a[$3b8cba9a6536b6a4$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $3b8cba9a6536b6a4$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $3b8cba9a6536b6a4$var$C = Object.assign, $3b8cba9a6536b6a4$var$D = {};
function $3b8cba9a6536b6a4$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $3b8cba9a6536b6a4$var$D;
    this.updater = e || $3b8cba9a6536b6a4$var$B;
}
$3b8cba9a6536b6a4$var$E.prototype.isReactComponent = {};
$3b8cba9a6536b6a4$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$3b8cba9a6536b6a4$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $3b8cba9a6536b6a4$var$F() {}
$3b8cba9a6536b6a4$var$F.prototype = $3b8cba9a6536b6a4$var$E.prototype;
function $3b8cba9a6536b6a4$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $3b8cba9a6536b6a4$var$D;
    this.updater = e || $3b8cba9a6536b6a4$var$B;
}
var $3b8cba9a6536b6a4$var$H = $3b8cba9a6536b6a4$var$G.prototype = new $3b8cba9a6536b6a4$var$F;
$3b8cba9a6536b6a4$var$H.constructor = $3b8cba9a6536b6a4$var$G;
$3b8cba9a6536b6a4$var$C($3b8cba9a6536b6a4$var$H, $3b8cba9a6536b6a4$var$E.prototype);
$3b8cba9a6536b6a4$var$H.isPureReactComponent = !0;
var $3b8cba9a6536b6a4$var$I = Array.isArray, $3b8cba9a6536b6a4$var$J = Object.prototype.hasOwnProperty, $3b8cba9a6536b6a4$var$K = {
    current: null
}, $3b8cba9a6536b6a4$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $3b8cba9a6536b6a4$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$3b8cba9a6536b6a4$var$J.call(b, d) && !$3b8cba9a6536b6a4$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $3b8cba9a6536b6a4$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $3b8cba9a6536b6a4$var$K.current
    };
}
function $3b8cba9a6536b6a4$var$N(a, b) {
    return {
        $$typeof: $3b8cba9a6536b6a4$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $3b8cba9a6536b6a4$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $3b8cba9a6536b6a4$var$l;
}
function $3b8cba9a6536b6a4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $3b8cba9a6536b6a4$var$P = /\/+/g;
function $3b8cba9a6536b6a4$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $3b8cba9a6536b6a4$var$escape("" + a.key) : b.toString(36);
}
function $3b8cba9a6536b6a4$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $YtE9h._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $3b8cba9a6536b6a4$var$l:
                case $3b8cba9a6536b6a4$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $3b8cba9a6536b6a4$var$Q(h, 0) : d, $3b8cba9a6536b6a4$var$I(c) ? (e = "", null != a && (e = a.replace($3b8cba9a6536b6a4$var$P, "$&/") + "/"), $3b8cba9a6536b6a4$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($3b8cba9a6536b6a4$var$O(c) && (c = $3b8cba9a6536b6a4$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($3b8cba9a6536b6a4$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($3b8cba9a6536b6a4$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $3b8cba9a6536b6a4$var$Q(k, g);
        h += $3b8cba9a6536b6a4$var$R(k, b, e, f, c);
    }
    else if (f = $3b8cba9a6536b6a4$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $3b8cba9a6536b6a4$var$Q(k, g++), h += $3b8cba9a6536b6a4$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $3b8cba9a6536b6a4$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $3b8cba9a6536b6a4$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $3b8cba9a6536b6a4$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $3b8cba9a6536b6a4$var$U = {
    current: null
}, $3b8cba9a6536b6a4$var$V = {
    transition: null
}, $3b8cba9a6536b6a4$var$W = {
    ReactCurrentDispatcher: $3b8cba9a6536b6a4$var$U,
    ReactCurrentBatchConfig: $3b8cba9a6536b6a4$var$V,
    ReactCurrentOwner: $3b8cba9a6536b6a4$var$K
};
$3b8cba9a6536b6a4$export$dca3b0875bd9a954 = {
    map: $3b8cba9a6536b6a4$var$S,
    forEach: function forEach(a, b, e) {
        $3b8cba9a6536b6a4$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $3b8cba9a6536b6a4$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $3b8cba9a6536b6a4$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$3b8cba9a6536b6a4$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$3b8cba9a6536b6a4$export$16fa2f45be04daa8 = $3b8cba9a6536b6a4$var$E;
$3b8cba9a6536b6a4$export$ffb0004e005737fa = $3b8cba9a6536b6a4$var$p;
$3b8cba9a6536b6a4$export$e2c29f18771995cb = $3b8cba9a6536b6a4$var$r;
$3b8cba9a6536b6a4$export$221d75b3f55bb0bd = $3b8cba9a6536b6a4$var$G;
$3b8cba9a6536b6a4$export$5f8d39834fd61797 = $3b8cba9a6536b6a4$var$q;
$3b8cba9a6536b6a4$export$74bf444e3cd11ea5 = $3b8cba9a6536b6a4$var$w;
$3b8cba9a6536b6a4$export$ae55be85d98224ed = $3b8cba9a6536b6a4$var$W;
$3b8cba9a6536b6a4$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $3b8cba9a6536b6a4$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $3b8cba9a6536b6a4$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$3b8cba9a6536b6a4$var$J.call(b, f) && !$3b8cba9a6536b6a4$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $3b8cba9a6536b6a4$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$3b8cba9a6536b6a4$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $3b8cba9a6536b6a4$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $3b8cba9a6536b6a4$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$3b8cba9a6536b6a4$export$c8a8987d4410bf2d = $3b8cba9a6536b6a4$var$M;
$3b8cba9a6536b6a4$export$d38cd72104c1f0e9 = function(a) {
    var b = $3b8cba9a6536b6a4$var$M.bind(null, a);
    b.type = a;
    return b;
};
$3b8cba9a6536b6a4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$3b8cba9a6536b6a4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $3b8cba9a6536b6a4$var$v,
        render: a
    };
};
$3b8cba9a6536b6a4$export$a8257692ac88316c = $3b8cba9a6536b6a4$var$O;
$3b8cba9a6536b6a4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $3b8cba9a6536b6a4$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $3b8cba9a6536b6a4$var$T
    };
};
$3b8cba9a6536b6a4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $3b8cba9a6536b6a4$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$3b8cba9a6536b6a4$export$7568632d0d33d16d = function(a) {
    var b = $3b8cba9a6536b6a4$var$V.transition;
    $3b8cba9a6536b6a4$var$V.transition = {};
    try {
        a();
    } finally{
        $3b8cba9a6536b6a4$var$V.transition = b;
    }
};
$3b8cba9a6536b6a4$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$3b8cba9a6536b6a4$export$35808ee640e87ca7 = function(a, b) {
    return $3b8cba9a6536b6a4$var$U.current.useCallback(a, b);
};
$3b8cba9a6536b6a4$export$fae74005e78b1a27 = function(a) {
    return $3b8cba9a6536b6a4$var$U.current.useContext(a);
};
$3b8cba9a6536b6a4$export$dc8fbce3eb94dc1e = function() {};
$3b8cba9a6536b6a4$export$6a7bc4e911dc01cf = function(a) {
    return $3b8cba9a6536b6a4$var$U.current.useDeferredValue(a);
};
$3b8cba9a6536b6a4$export$6d9c69b0de29b591 = function(a, b) {
    return $3b8cba9a6536b6a4$var$U.current.useEffect(a, b);
};
$3b8cba9a6536b6a4$export$f680877a34711e37 = function() {
    return $3b8cba9a6536b6a4$var$U.current.useId();
};
$3b8cba9a6536b6a4$export$d5a552a76deda3c2 = function(a, b, e) {
    return $3b8cba9a6536b6a4$var$U.current.useImperativeHandle(a, b, e);
};
$3b8cba9a6536b6a4$export$aaabe4eda9ed9969 = function(a, b) {
    return $3b8cba9a6536b6a4$var$U.current.useInsertionEffect(a, b);
};
$3b8cba9a6536b6a4$export$e5c5a5f917a5871c = function(a, b) {
    return $3b8cba9a6536b6a4$var$U.current.useLayoutEffect(a, b);
};
$3b8cba9a6536b6a4$export$1538c33de8887b59 = function(a, b) {
    return $3b8cba9a6536b6a4$var$U.current.useMemo(a, b);
};
$3b8cba9a6536b6a4$export$13e3392192263954 = function(a, b, e) {
    return $3b8cba9a6536b6a4$var$U.current.useReducer(a, b, e);
};
$3b8cba9a6536b6a4$export$b8f5890fc79d6aca = function(a) {
    return $3b8cba9a6536b6a4$var$U.current.useRef(a);
};
$3b8cba9a6536b6a4$export$60241385465d0a34 = function(a) {
    return $3b8cba9a6536b6a4$var$U.current.useState(a);
};
$3b8cba9a6536b6a4$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $3b8cba9a6536b6a4$var$U.current.useSyncExternalStore(a, b, e);
};
$3b8cba9a6536b6a4$export$7b286972b8d8ccbf = function() {
    return $3b8cba9a6536b6a4$var$U.current.useTransition();
};
$3b8cba9a6536b6a4$export$83d89fbfd8236492 = "18.2.0";

});
parcelRegister("YtE9h", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $0b5c99e6a0876eaa$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $0b5c99e6a0876eaa$export$5f0017c582d45a2d; });
function $0b5c99e6a0876eaa$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});





parcelRegister("fsZ8I", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b428e590a835ea4b$export$ae55be85d98224ed; }, function (v) { return $b428e590a835ea4b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b428e590a835ea4b$export$d39a5bbd09211389; }, function (v) { return $b428e590a835ea4b$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b428e590a835ea4b$export$882461b6382ed46c; }, function (v) { return $b428e590a835ea4b$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b428e590a835ea4b$export$466bfc07425424d5; }, function (v) { return $b428e590a835ea4b$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b428e590a835ea4b$export$cd75ccfd720a3cd4; }, function (v) { return $b428e590a835ea4b$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b428e590a835ea4b$export$fa8d919ba61d84db; }, function (v) { return $b428e590a835ea4b$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b428e590a835ea4b$export$757ceba2d55c277e; }, function (v) { return $b428e590a835ea4b$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b428e590a835ea4b$export$b3890eb0ae9dca99; }, function (v) { return $b428e590a835ea4b$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b428e590a835ea4b$export$502457920280e6be; }, function (v) { return $b428e590a835ea4b$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b428e590a835ea4b$export$c78a37762a8d58e1; }, function (v) { return $b428e590a835ea4b$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b428e590a835ea4b$export$dc54d992c10e8a18; }, function (v) { return $b428e590a835ea4b$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b428e590a835ea4b$export$83d89fbfd8236492; }, function (v) { return $b428e590a835ea4b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $YtE9h = parcelRequire("YtE9h");
var $b428e590a835ea4b$export$ae55be85d98224ed;
var $b428e590a835ea4b$export$d39a5bbd09211389;
var $b428e590a835ea4b$export$882461b6382ed46c;
var $b428e590a835ea4b$export$466bfc07425424d5;
var $b428e590a835ea4b$export$cd75ccfd720a3cd4;
var $b428e590a835ea4b$export$fa8d919ba61d84db;
var $b428e590a835ea4b$export$757ceba2d55c277e;
var $b428e590a835ea4b$export$b3890eb0ae9dca99;
var $b428e590a835ea4b$export$502457920280e6be;
var $b428e590a835ea4b$export$c78a37762a8d58e1;
var $b428e590a835ea4b$export$dc54d992c10e8a18;
var $b428e590a835ea4b$export$83d89fbfd8236492;
"use strict";

var $fIwXP = parcelRequire("fIwXP");

var $go0bk = parcelRequire("go0bk");
function $b428e590a835ea4b$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b428e590a835ea4b$var$da = new Set, $b428e590a835ea4b$var$ea = {};
function $b428e590a835ea4b$var$fa(a, b) {
    $b428e590a835ea4b$var$ha(a, b);
    $b428e590a835ea4b$var$ha(a + "Capture", b);
}
function $b428e590a835ea4b$var$ha(a, b) {
    $b428e590a835ea4b$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b428e590a835ea4b$var$da.add(b[a]);
}
var $b428e590a835ea4b$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b428e590a835ea4b$var$ja = Object.prototype.hasOwnProperty, $b428e590a835ea4b$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b428e590a835ea4b$var$la = {}, $b428e590a835ea4b$var$ma = {};
function $b428e590a835ea4b$var$oa(a) {
    if ($b428e590a835ea4b$var$ja.call($b428e590a835ea4b$var$ma, a)) return !0;
    if ($b428e590a835ea4b$var$ja.call($b428e590a835ea4b$var$la, a)) return !1;
    if ($b428e590a835ea4b$var$ka.test(a)) return $b428e590a835ea4b$var$ma[a] = !0;
    $b428e590a835ea4b$var$la[a] = !0;
    return !1;
}
function $b428e590a835ea4b$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $YtE9h._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b428e590a835ea4b$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b428e590a835ea4b$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b428e590a835ea4b$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b428e590a835ea4b$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b428e590a835ea4b$var$z[b] = new $b428e590a835ea4b$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b428e590a835ea4b$var$ra = /[\-:]([a-z])/g;
function $b428e590a835ea4b$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b428e590a835ea4b$var$ra, $b428e590a835ea4b$var$sa);
    $b428e590a835ea4b$var$z[b] = new $b428e590a835ea4b$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b428e590a835ea4b$var$ra, $b428e590a835ea4b$var$sa);
    $b428e590a835ea4b$var$z[b] = new $b428e590a835ea4b$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b428e590a835ea4b$var$ra, $b428e590a835ea4b$var$sa);
    $b428e590a835ea4b$var$z[b] = new $b428e590a835ea4b$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b428e590a835ea4b$var$z.xlinkHref = new $b428e590a835ea4b$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b428e590a835ea4b$var$ta(a, b, c, d) {
    var e = $b428e590a835ea4b$var$z.hasOwnProperty(b) ? $b428e590a835ea4b$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b428e590a835ea4b$var$qa(b, c, e, d) && (c = null), d || null === e ? $b428e590a835ea4b$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b428e590a835ea4b$var$ua = $fIwXP.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b428e590a835ea4b$var$va = Symbol.for("react.element"), $b428e590a835ea4b$var$wa = Symbol.for("react.portal"), $b428e590a835ea4b$var$ya = Symbol.for("react.fragment"), $b428e590a835ea4b$var$za = Symbol.for("react.strict_mode"), $b428e590a835ea4b$var$Aa = Symbol.for("react.profiler"), $b428e590a835ea4b$var$Ba = Symbol.for("react.provider"), $b428e590a835ea4b$var$Ca = Symbol.for("react.context"), $b428e590a835ea4b$var$Da = Symbol.for("react.forward_ref"), $b428e590a835ea4b$var$Ea = Symbol.for("react.suspense"), $b428e590a835ea4b$var$Fa = Symbol.for("react.suspense_list"), $b428e590a835ea4b$var$Ga = Symbol.for("react.memo"), $b428e590a835ea4b$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b428e590a835ea4b$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b428e590a835ea4b$var$Ja = Symbol.iterator;
function $b428e590a835ea4b$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b428e590a835ea4b$var$Ja && a[$b428e590a835ea4b$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b428e590a835ea4b$var$A = Object.assign, $b428e590a835ea4b$var$La;
function $b428e590a835ea4b$var$Ma(a) {
    if (void 0 === $b428e590a835ea4b$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b428e590a835ea4b$var$La = b && b[1] || "";
    }
    return "\n" + $b428e590a835ea4b$var$La + a;
}
var $b428e590a835ea4b$var$Na = !1;
function $b428e590a835ea4b$var$Oa(a, b) {
    if (!a || $b428e590a835ea4b$var$Na) return "";
    $b428e590a835ea4b$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b428e590a835ea4b$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b428e590a835ea4b$var$Ma(a) : "";
}
function $b428e590a835ea4b$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b428e590a835ea4b$var$Ma(a.type);
        case 16:
            return $b428e590a835ea4b$var$Ma("Lazy");
        case 13:
            return $b428e590a835ea4b$var$Ma("Suspense");
        case 19:
            return $b428e590a835ea4b$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b428e590a835ea4b$var$Oa(a.type, !1), a;
        case 11:
            return a = $b428e590a835ea4b$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b428e590a835ea4b$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b428e590a835ea4b$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b428e590a835ea4b$var$ya:
            return "Fragment";
        case $b428e590a835ea4b$var$wa:
            return "Portal";
        case $b428e590a835ea4b$var$Aa:
            return "Profiler";
        case $b428e590a835ea4b$var$za:
            return "StrictMode";
        case $b428e590a835ea4b$var$Ea:
            return "Suspense";
        case $b428e590a835ea4b$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b428e590a835ea4b$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b428e590a835ea4b$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b428e590a835ea4b$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b428e590a835ea4b$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b428e590a835ea4b$var$Qa(a.type) || "Memo";
        case $b428e590a835ea4b$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b428e590a835ea4b$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b428e590a835ea4b$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b428e590a835ea4b$var$Qa(b);
        case 8:
            return b === $b428e590a835ea4b$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b428e590a835ea4b$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $YtE9h._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b428e590a835ea4b$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b428e590a835ea4b$var$Ua(a) {
    var b = $b428e590a835ea4b$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b428e590a835ea4b$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b428e590a835ea4b$var$Ua(a));
}
function $b428e590a835ea4b$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b428e590a835ea4b$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b428e590a835ea4b$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b428e590a835ea4b$var$Ya(a, b) {
    var c = b.checked;
    return $b428e590a835ea4b$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b428e590a835ea4b$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b428e590a835ea4b$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b428e590a835ea4b$var$ab(a, b) {
    b = b.checked;
    null != b && $b428e590a835ea4b$var$ta(a, "checked", b, !1);
}
function $b428e590a835ea4b$var$bb(a, b) {
    $b428e590a835ea4b$var$ab(a, b);
    var c = $b428e590a835ea4b$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b428e590a835ea4b$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b428e590a835ea4b$var$cb(a, b.type, $b428e590a835ea4b$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b428e590a835ea4b$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b428e590a835ea4b$var$cb(a, b, c) {
    if ("number" !== b || $b428e590a835ea4b$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b428e590a835ea4b$var$eb = Array.isArray;
function $b428e590a835ea4b$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b428e590a835ea4b$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b428e590a835ea4b$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b428e590a835ea4b$var$p(91));
    return $b428e590a835ea4b$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b428e590a835ea4b$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b428e590a835ea4b$var$p(92));
            if ($b428e590a835ea4b$var$eb(c)) {
                if (1 < c.length) throw Error($b428e590a835ea4b$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b428e590a835ea4b$var$Sa(c)
    };
}
function $b428e590a835ea4b$var$ib(a, b) {
    var c = $b428e590a835ea4b$var$Sa(b.value), d = $b428e590a835ea4b$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b428e590a835ea4b$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b428e590a835ea4b$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b428e590a835ea4b$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b428e590a835ea4b$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b428e590a835ea4b$var$mb, $b428e590a835ea4b$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b428e590a835ea4b$var$mb = $b428e590a835ea4b$var$mb || document.createElement("div");
        $b428e590a835ea4b$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b428e590a835ea4b$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b428e590a835ea4b$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b428e590a835ea4b$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b428e590a835ea4b$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b428e590a835ea4b$var$pb).forEach(function(a) {
    $b428e590a835ea4b$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b428e590a835ea4b$var$pb[b] = $b428e590a835ea4b$var$pb[a];
    });
});
function $b428e590a835ea4b$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b428e590a835ea4b$var$pb.hasOwnProperty(a) && $b428e590a835ea4b$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b428e590a835ea4b$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b428e590a835ea4b$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b428e590a835ea4b$var$tb = $b428e590a835ea4b$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b428e590a835ea4b$var$ub(a, b) {
    if (b) {
        if ($b428e590a835ea4b$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b428e590a835ea4b$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b428e590a835ea4b$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b428e590a835ea4b$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b428e590a835ea4b$var$p(62));
    }
}
function $b428e590a835ea4b$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b428e590a835ea4b$var$wb = null;
function $b428e590a835ea4b$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b428e590a835ea4b$var$yb = null, $b428e590a835ea4b$var$zb = null, $b428e590a835ea4b$var$Ab = null;
function $b428e590a835ea4b$var$Bb(a) {
    if (a = $b428e590a835ea4b$var$Cb(a)) {
        if ("function" !== typeof $b428e590a835ea4b$var$yb) throw Error($b428e590a835ea4b$var$p(280));
        var b = a.stateNode;
        b && (b = $b428e590a835ea4b$var$Db(b), $b428e590a835ea4b$var$yb(a.stateNode, a.type, b));
    }
}
function $b428e590a835ea4b$var$Eb(a) {
    $b428e590a835ea4b$var$zb ? $b428e590a835ea4b$var$Ab ? $b428e590a835ea4b$var$Ab.push(a) : $b428e590a835ea4b$var$Ab = [
        a
    ] : $b428e590a835ea4b$var$zb = a;
}
function $b428e590a835ea4b$var$Fb() {
    if ($b428e590a835ea4b$var$zb) {
        var a = $b428e590a835ea4b$var$zb, b = $b428e590a835ea4b$var$Ab;
        $b428e590a835ea4b$var$Ab = $b428e590a835ea4b$var$zb = null;
        $b428e590a835ea4b$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b428e590a835ea4b$var$Bb(b[a]);
    }
}
function $b428e590a835ea4b$var$Gb(a, b) {
    return a(b);
}
function $b428e590a835ea4b$var$Hb() {}
var $b428e590a835ea4b$var$Ib = !1;
function $b428e590a835ea4b$var$Jb(a, b, c) {
    if ($b428e590a835ea4b$var$Ib) return a(b, c);
    $b428e590a835ea4b$var$Ib = !0;
    try {
        return $b428e590a835ea4b$var$Gb(a, b, c);
    } finally{
        if ($b428e590a835ea4b$var$Ib = !1, null !== $b428e590a835ea4b$var$zb || null !== $b428e590a835ea4b$var$Ab) $b428e590a835ea4b$var$Hb(), $b428e590a835ea4b$var$Fb();
    }
}
function $b428e590a835ea4b$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b428e590a835ea4b$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b428e590a835ea4b$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $YtE9h._)(c)));
    return c;
}
var $b428e590a835ea4b$var$Lb = !1;
if ($b428e590a835ea4b$var$ia) try {
    var $b428e590a835ea4b$var$Mb = {};
    Object.defineProperty($b428e590a835ea4b$var$Mb, "passive", {
        get: function get() {
            $b428e590a835ea4b$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b428e590a835ea4b$var$Mb, $b428e590a835ea4b$var$Mb);
    window.removeEventListener("test", $b428e590a835ea4b$var$Mb, $b428e590a835ea4b$var$Mb);
} catch (a) {
    $b428e590a835ea4b$var$Lb = !1;
}
function $b428e590a835ea4b$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b428e590a835ea4b$var$Ob = !1, $b428e590a835ea4b$var$Pb = null, $b428e590a835ea4b$var$Qb = !1, $b428e590a835ea4b$var$Rb = null, $b428e590a835ea4b$var$Sb = {
    onError: function onError(a) {
        $b428e590a835ea4b$var$Ob = !0;
        $b428e590a835ea4b$var$Pb = a;
    }
};
function $b428e590a835ea4b$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b428e590a835ea4b$var$Ob = !1;
    $b428e590a835ea4b$var$Pb = null;
    $b428e590a835ea4b$var$Nb.apply($b428e590a835ea4b$var$Sb, arguments);
}
function $b428e590a835ea4b$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b428e590a835ea4b$var$Tb.apply(this, arguments);
    if ($b428e590a835ea4b$var$Ob) {
        if ($b428e590a835ea4b$var$Ob) {
            var l = $b428e590a835ea4b$var$Pb;
            $b428e590a835ea4b$var$Ob = !1;
            $b428e590a835ea4b$var$Pb = null;
        } else throw Error($b428e590a835ea4b$var$p(198));
        $b428e590a835ea4b$var$Qb || ($b428e590a835ea4b$var$Qb = !0, $b428e590a835ea4b$var$Rb = l);
    }
}
function $b428e590a835ea4b$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b428e590a835ea4b$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b428e590a835ea4b$var$Xb(a) {
    if ($b428e590a835ea4b$var$Vb(a) !== a) throw Error($b428e590a835ea4b$var$p(188));
}
function $b428e590a835ea4b$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b428e590a835ea4b$var$Vb(a);
        if (null === b) throw Error($b428e590a835ea4b$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b428e590a835ea4b$var$Xb(e), a;
                if (f === d) return $b428e590a835ea4b$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b428e590a835ea4b$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b428e590a835ea4b$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b428e590a835ea4b$var$p(190));
    }
    if (3 !== c.tag) throw Error($b428e590a835ea4b$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b428e590a835ea4b$var$Zb(a) {
    a = $b428e590a835ea4b$var$Yb(a);
    return null !== a ? $b428e590a835ea4b$var$$b(a) : null;
}
function $b428e590a835ea4b$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b428e590a835ea4b$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b428e590a835ea4b$var$ac = $go0bk.unstable_scheduleCallback, $b428e590a835ea4b$var$bc = $go0bk.unstable_cancelCallback, $b428e590a835ea4b$var$cc = $go0bk.unstable_shouldYield, $b428e590a835ea4b$var$dc = $go0bk.unstable_requestPaint, $b428e590a835ea4b$var$B = $go0bk.unstable_now, $b428e590a835ea4b$var$ec = $go0bk.unstable_getCurrentPriorityLevel, $b428e590a835ea4b$var$fc = $go0bk.unstable_ImmediatePriority, $b428e590a835ea4b$var$gc = $go0bk.unstable_UserBlockingPriority, $b428e590a835ea4b$var$hc = $go0bk.unstable_NormalPriority, $b428e590a835ea4b$var$ic = $go0bk.unstable_LowPriority, $b428e590a835ea4b$var$jc = $go0bk.unstable_IdlePriority, $b428e590a835ea4b$var$kc = null, $b428e590a835ea4b$var$lc = null;
function $b428e590a835ea4b$var$mc(a) {
    if ($b428e590a835ea4b$var$lc && "function" === typeof $b428e590a835ea4b$var$lc.onCommitFiberRoot) try {
        $b428e590a835ea4b$var$lc.onCommitFiberRoot($b428e590a835ea4b$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b428e590a835ea4b$var$oc = Math.clz32 ? Math.clz32 : $b428e590a835ea4b$var$nc, $b428e590a835ea4b$var$pc = Math.log, $b428e590a835ea4b$var$qc = Math.LN2;
function $b428e590a835ea4b$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b428e590a835ea4b$var$pc(a) / $b428e590a835ea4b$var$qc | 0) | 0;
}
var $b428e590a835ea4b$var$rc = 64, $b428e590a835ea4b$var$sc = 4194304;
function $b428e590a835ea4b$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b428e590a835ea4b$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b428e590a835ea4b$var$tc(h) : (f &= g, 0 !== f && (d = $b428e590a835ea4b$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b428e590a835ea4b$var$tc(g) : 0 !== f && (d = $b428e590a835ea4b$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b428e590a835ea4b$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b428e590a835ea4b$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b428e590a835ea4b$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b428e590a835ea4b$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b428e590a835ea4b$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b428e590a835ea4b$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b428e590a835ea4b$var$yc() {
    var a = $b428e590a835ea4b$var$rc;
    $b428e590a835ea4b$var$rc <<= 1;
    0 === ($b428e590a835ea4b$var$rc & 4194240) && ($b428e590a835ea4b$var$rc = 64);
    return a;
}
function $b428e590a835ea4b$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b428e590a835ea4b$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b428e590a835ea4b$var$oc(b);
    a[b] = c;
}
function $b428e590a835ea4b$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b428e590a835ea4b$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b428e590a835ea4b$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b428e590a835ea4b$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b428e590a835ea4b$var$C = 0;
function $b428e590a835ea4b$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b428e590a835ea4b$var$Ec, $b428e590a835ea4b$var$Fc, $b428e590a835ea4b$var$Gc, $b428e590a835ea4b$var$Hc, $b428e590a835ea4b$var$Ic, $b428e590a835ea4b$var$Jc = !1, $b428e590a835ea4b$var$Kc = [], $b428e590a835ea4b$var$Lc = null, $b428e590a835ea4b$var$Mc = null, $b428e590a835ea4b$var$Nc = null, $b428e590a835ea4b$var$Oc = new Map, $b428e590a835ea4b$var$Pc = new Map, $b428e590a835ea4b$var$Qc = [], $b428e590a835ea4b$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b428e590a835ea4b$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b428e590a835ea4b$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b428e590a835ea4b$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b428e590a835ea4b$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b428e590a835ea4b$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b428e590a835ea4b$var$Pc.delete(b.pointerId);
    }
}
function $b428e590a835ea4b$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b428e590a835ea4b$var$Cb(b), null !== b && $b428e590a835ea4b$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b428e590a835ea4b$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b428e590a835ea4b$var$Lc = $b428e590a835ea4b$var$Tc($b428e590a835ea4b$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b428e590a835ea4b$var$Mc = $b428e590a835ea4b$var$Tc($b428e590a835ea4b$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b428e590a835ea4b$var$Nc = $b428e590a835ea4b$var$Tc($b428e590a835ea4b$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b428e590a835ea4b$var$Oc.set(f, $b428e590a835ea4b$var$Tc($b428e590a835ea4b$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b428e590a835ea4b$var$Pc.set(f, $b428e590a835ea4b$var$Tc($b428e590a835ea4b$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b428e590a835ea4b$var$Vc(a) {
    var b = $b428e590a835ea4b$var$Wc(a.target);
    if (null !== b) {
        var c = $b428e590a835ea4b$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b428e590a835ea4b$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b428e590a835ea4b$var$Ic(a.priority, function() {
                        $b428e590a835ea4b$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b428e590a835ea4b$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b428e590a835ea4b$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b428e590a835ea4b$var$wb = d;
            c.target.dispatchEvent(d);
            $b428e590a835ea4b$var$wb = null;
        } else return b = $b428e590a835ea4b$var$Cb(c), null !== b && $b428e590a835ea4b$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b428e590a835ea4b$var$Zc(a, b, c) {
    $b428e590a835ea4b$var$Xc(a) && c.delete(b);
}
function $b428e590a835ea4b$var$$c() {
    $b428e590a835ea4b$var$Jc = !1;
    null !== $b428e590a835ea4b$var$Lc && $b428e590a835ea4b$var$Xc($b428e590a835ea4b$var$Lc) && ($b428e590a835ea4b$var$Lc = null);
    null !== $b428e590a835ea4b$var$Mc && $b428e590a835ea4b$var$Xc($b428e590a835ea4b$var$Mc) && ($b428e590a835ea4b$var$Mc = null);
    null !== $b428e590a835ea4b$var$Nc && $b428e590a835ea4b$var$Xc($b428e590a835ea4b$var$Nc) && ($b428e590a835ea4b$var$Nc = null);
    $b428e590a835ea4b$var$Oc.forEach($b428e590a835ea4b$var$Zc);
    $b428e590a835ea4b$var$Pc.forEach($b428e590a835ea4b$var$Zc);
}
function $b428e590a835ea4b$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b428e590a835ea4b$var$Jc || ($b428e590a835ea4b$var$Jc = !0, $go0bk.unstable_scheduleCallback($go0bk.unstable_NormalPriority, $b428e590a835ea4b$var$$c)));
}
function $b428e590a835ea4b$var$bd(a) {
    function b(b) {
        return $b428e590a835ea4b$var$ad(b, a);
    }
    if (0 < $b428e590a835ea4b$var$Kc.length) {
        $b428e590a835ea4b$var$ad($b428e590a835ea4b$var$Kc[0], a);
        for(var c = 1; c < $b428e590a835ea4b$var$Kc.length; c++){
            var d = $b428e590a835ea4b$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b428e590a835ea4b$var$Lc && $b428e590a835ea4b$var$ad($b428e590a835ea4b$var$Lc, a);
    null !== $b428e590a835ea4b$var$Mc && $b428e590a835ea4b$var$ad($b428e590a835ea4b$var$Mc, a);
    null !== $b428e590a835ea4b$var$Nc && $b428e590a835ea4b$var$ad($b428e590a835ea4b$var$Nc, a);
    $b428e590a835ea4b$var$Oc.forEach(b);
    $b428e590a835ea4b$var$Pc.forEach(b);
    for(c = 0; c < $b428e590a835ea4b$var$Qc.length; c++)d = $b428e590a835ea4b$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b428e590a835ea4b$var$Qc.length && (c = $b428e590a835ea4b$var$Qc[0], null === c.blockedOn);)$b428e590a835ea4b$var$Vc(c), null === c.blockedOn && $b428e590a835ea4b$var$Qc.shift();
}
var $b428e590a835ea4b$var$cd = $b428e590a835ea4b$var$ua.ReactCurrentBatchConfig, $b428e590a835ea4b$var$dd = !0;
function $b428e590a835ea4b$var$ed(a, b, c, d) {
    var e = $b428e590a835ea4b$var$C, f = $b428e590a835ea4b$var$cd.transition;
    $b428e590a835ea4b$var$cd.transition = null;
    try {
        $b428e590a835ea4b$var$C = 1, $b428e590a835ea4b$var$fd(a, b, c, d);
    } finally{
        $b428e590a835ea4b$var$C = e, $b428e590a835ea4b$var$cd.transition = f;
    }
}
function $b428e590a835ea4b$var$gd(a, b, c, d) {
    var e = $b428e590a835ea4b$var$C, f = $b428e590a835ea4b$var$cd.transition;
    $b428e590a835ea4b$var$cd.transition = null;
    try {
        $b428e590a835ea4b$var$C = 4, $b428e590a835ea4b$var$fd(a, b, c, d);
    } finally{
        $b428e590a835ea4b$var$C = e, $b428e590a835ea4b$var$cd.transition = f;
    }
}
function $b428e590a835ea4b$var$fd(a, b, c, d) {
    if ($b428e590a835ea4b$var$dd) {
        var e = $b428e590a835ea4b$var$Yc(a, b, c, d);
        if (null === e) $b428e590a835ea4b$var$hd(a, b, d, $b428e590a835ea4b$var$id, c), $b428e590a835ea4b$var$Sc(a, d);
        else if ($b428e590a835ea4b$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b428e590a835ea4b$var$Sc(a, d), b & 4 && -1 < $b428e590a835ea4b$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b428e590a835ea4b$var$Cb(e);
                null !== f && $b428e590a835ea4b$var$Ec(f);
                f = $b428e590a835ea4b$var$Yc(a, b, c, d);
                null === f && $b428e590a835ea4b$var$hd(a, b, d, $b428e590a835ea4b$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b428e590a835ea4b$var$hd(a, b, d, null, c);
    }
}
var $b428e590a835ea4b$var$id = null;
function $b428e590a835ea4b$var$Yc(a, b, c, d) {
    $b428e590a835ea4b$var$id = null;
    a = $b428e590a835ea4b$var$xb(d);
    a = $b428e590a835ea4b$var$Wc(a);
    if (null !== a) {
        if (b = $b428e590a835ea4b$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b428e590a835ea4b$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b428e590a835ea4b$var$id = a;
    return null;
}
function $b428e590a835ea4b$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b428e590a835ea4b$var$ec()){
                case $b428e590a835ea4b$var$fc:
                    return 1;
                case $b428e590a835ea4b$var$gc:
                    return 4;
                case $b428e590a835ea4b$var$hc:
                case $b428e590a835ea4b$var$ic:
                    return 16;
                case $b428e590a835ea4b$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b428e590a835ea4b$var$kd = null, $b428e590a835ea4b$var$ld = null, $b428e590a835ea4b$var$md = null;
function $b428e590a835ea4b$var$nd() {
    if ($b428e590a835ea4b$var$md) return $b428e590a835ea4b$var$md;
    var a, b = $b428e590a835ea4b$var$ld, c = b.length, d, e = "value" in $b428e590a835ea4b$var$kd ? $b428e590a835ea4b$var$kd.value : $b428e590a835ea4b$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b428e590a835ea4b$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b428e590a835ea4b$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b428e590a835ea4b$var$pd() {
    return !0;
}
function $b428e590a835ea4b$var$qd() {
    return !1;
}
function $b428e590a835ea4b$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b428e590a835ea4b$var$pd : $b428e590a835ea4b$var$qd;
        this.isPropagationStopped = $b428e590a835ea4b$var$qd;
        return this;
    }
    $b428e590a835ea4b$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $YtE9h._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $b428e590a835ea4b$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $YtE9h._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $b428e590a835ea4b$var$pd);
        },
        persist: function persist() {},
        isPersistent: $b428e590a835ea4b$var$pd
    });
    return b;
}
var $b428e590a835ea4b$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b428e590a835ea4b$var$td = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$sd), $b428e590a835ea4b$var$ud = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$sd, {
    view: 0,
    detail: 0
}), $b428e590a835ea4b$var$vd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$ud), $b428e590a835ea4b$var$wd, $b428e590a835ea4b$var$xd, $b428e590a835ea4b$var$yd, $b428e590a835ea4b$var$Ad = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b428e590a835ea4b$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b428e590a835ea4b$var$yd && ($b428e590a835ea4b$var$yd && "mousemove" === a.type ? ($b428e590a835ea4b$var$wd = a.screenX - $b428e590a835ea4b$var$yd.screenX, $b428e590a835ea4b$var$xd = a.screenY - $b428e590a835ea4b$var$yd.screenY) : $b428e590a835ea4b$var$xd = $b428e590a835ea4b$var$wd = 0, $b428e590a835ea4b$var$yd = a);
        return $b428e590a835ea4b$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $b428e590a835ea4b$var$xd;
    }
}), $b428e590a835ea4b$var$Bd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Ad), $b428e590a835ea4b$var$Cd = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$Ad, {
    dataTransfer: 0
}), $b428e590a835ea4b$var$Dd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Cd), $b428e590a835ea4b$var$Ed = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$ud, {
    relatedTarget: 0
}), $b428e590a835ea4b$var$Fd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Ed), $b428e590a835ea4b$var$Gd = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b428e590a835ea4b$var$Hd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Gd), $b428e590a835ea4b$var$Id = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b428e590a835ea4b$var$Jd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Id), $b428e590a835ea4b$var$Kd = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$sd, {
    data: 0
}), $b428e590a835ea4b$var$Ld = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Kd), $b428e590a835ea4b$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b428e590a835ea4b$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b428e590a835ea4b$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b428e590a835ea4b$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b428e590a835ea4b$var$Od[a]) ? !!b[a] : !1;
}
function $b428e590a835ea4b$var$zd() {
    return $b428e590a835ea4b$var$Pd;
}
var $b428e590a835ea4b$var$Qd = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $b428e590a835ea4b$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b428e590a835ea4b$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b428e590a835ea4b$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b428e590a835ea4b$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $b428e590a835ea4b$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $b428e590a835ea4b$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b428e590a835ea4b$var$Rd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Qd), $b428e590a835ea4b$var$Sd = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b428e590a835ea4b$var$Td = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Sd), $b428e590a835ea4b$var$Ud = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b428e590a835ea4b$var$zd
}), $b428e590a835ea4b$var$Vd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Ud), $b428e590a835ea4b$var$Wd = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b428e590a835ea4b$var$Xd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Wd), $b428e590a835ea4b$var$Yd = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b428e590a835ea4b$var$Zd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Yd), $b428e590a835ea4b$var$$d = [
    9,
    13,
    27,
    32
], $b428e590a835ea4b$var$ae = $b428e590a835ea4b$var$ia && "CompositionEvent" in window, $b428e590a835ea4b$var$be = null;
$b428e590a835ea4b$var$ia && "documentMode" in document && ($b428e590a835ea4b$var$be = document.documentMode);
var $b428e590a835ea4b$var$ce = $b428e590a835ea4b$var$ia && "TextEvent" in window && !$b428e590a835ea4b$var$be, $b428e590a835ea4b$var$de = $b428e590a835ea4b$var$ia && (!$b428e590a835ea4b$var$ae || $b428e590a835ea4b$var$be && 8 < $b428e590a835ea4b$var$be && 11 >= $b428e590a835ea4b$var$be), $b428e590a835ea4b$var$ee = String.fromCharCode(32), $b428e590a835ea4b$var$fe = !1;
function $b428e590a835ea4b$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b428e590a835ea4b$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b428e590a835ea4b$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b428e590a835ea4b$var$ie = !1;
function $b428e590a835ea4b$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b428e590a835ea4b$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b428e590a835ea4b$var$fe = !0;
            return $b428e590a835ea4b$var$ee;
        case "textInput":
            return a = b.data, a === $b428e590a835ea4b$var$ee && $b428e590a835ea4b$var$fe ? null : a;
        default:
            return null;
    }
}
function $b428e590a835ea4b$var$ke(a, b) {
    if ($b428e590a835ea4b$var$ie) return "compositionend" === a || !$b428e590a835ea4b$var$ae && $b428e590a835ea4b$var$ge(a, b) ? (a = $b428e590a835ea4b$var$nd(), $b428e590a835ea4b$var$md = $b428e590a835ea4b$var$ld = $b428e590a835ea4b$var$kd = null, $b428e590a835ea4b$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b428e590a835ea4b$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b428e590a835ea4b$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b428e590a835ea4b$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b428e590a835ea4b$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b428e590a835ea4b$var$ne(a, b, c, d) {
    $b428e590a835ea4b$var$Eb(d);
    b = $b428e590a835ea4b$var$oe(b, "onChange");
    0 < b.length && (c = new $b428e590a835ea4b$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b428e590a835ea4b$var$pe = null, $b428e590a835ea4b$var$qe = null;
function $b428e590a835ea4b$var$re(a) {
    $b428e590a835ea4b$var$se(a, 0);
}
function $b428e590a835ea4b$var$te(a) {
    var b = $b428e590a835ea4b$var$ue(a);
    if ($b428e590a835ea4b$var$Wa(b)) return a;
}
function $b428e590a835ea4b$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b428e590a835ea4b$var$we = !1;
if ($b428e590a835ea4b$var$ia) {
    var $b428e590a835ea4b$var$xe;
    if ($b428e590a835ea4b$var$ia) {
        var $b428e590a835ea4b$var$ye = "oninput" in document;
        if (!$b428e590a835ea4b$var$ye) {
            var $b428e590a835ea4b$var$ze = document.createElement("div");
            $b428e590a835ea4b$var$ze.setAttribute("oninput", "return;");
            $b428e590a835ea4b$var$ye = "function" === typeof $b428e590a835ea4b$var$ze.oninput;
        }
        $b428e590a835ea4b$var$xe = $b428e590a835ea4b$var$ye;
    } else $b428e590a835ea4b$var$xe = !1;
    $b428e590a835ea4b$var$we = $b428e590a835ea4b$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b428e590a835ea4b$var$Ae() {
    $b428e590a835ea4b$var$pe && ($b428e590a835ea4b$var$pe.detachEvent("onpropertychange", $b428e590a835ea4b$var$Be), $b428e590a835ea4b$var$qe = $b428e590a835ea4b$var$pe = null);
}
function $b428e590a835ea4b$var$Be(a) {
    if ("value" === a.propertyName && $b428e590a835ea4b$var$te($b428e590a835ea4b$var$qe)) {
        var b = [];
        $b428e590a835ea4b$var$ne(b, $b428e590a835ea4b$var$qe, a, $b428e590a835ea4b$var$xb(a));
        $b428e590a835ea4b$var$Jb($b428e590a835ea4b$var$re, b);
    }
}
function $b428e590a835ea4b$var$Ce(a, b, c) {
    "focusin" === a ? ($b428e590a835ea4b$var$Ae(), $b428e590a835ea4b$var$pe = b, $b428e590a835ea4b$var$qe = c, $b428e590a835ea4b$var$pe.attachEvent("onpropertychange", $b428e590a835ea4b$var$Be)) : "focusout" === a && $b428e590a835ea4b$var$Ae();
}
function $b428e590a835ea4b$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b428e590a835ea4b$var$te($b428e590a835ea4b$var$qe);
}
function $b428e590a835ea4b$var$Ee(a, b) {
    if ("click" === a) return $b428e590a835ea4b$var$te(b);
}
function $b428e590a835ea4b$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b428e590a835ea4b$var$te(b);
}
function $b428e590a835ea4b$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b428e590a835ea4b$var$He = "function" === typeof Object.is ? Object.is : $b428e590a835ea4b$var$Ge;
function $b428e590a835ea4b$var$Ie(a, b) {
    if ($b428e590a835ea4b$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b428e590a835ea4b$var$ja.call(b, e) || !$b428e590a835ea4b$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b428e590a835ea4b$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b428e590a835ea4b$var$Ke(a, b) {
    var c = $b428e590a835ea4b$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b428e590a835ea4b$var$Je(c);
    }
}
function $b428e590a835ea4b$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b428e590a835ea4b$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b428e590a835ea4b$var$Me() {
    for(var a = window, b = $b428e590a835ea4b$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b428e590a835ea4b$var$Xa(a.document);
    }
    return b;
}
function $b428e590a835ea4b$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b428e590a835ea4b$var$Oe(a) {
    var b = $b428e590a835ea4b$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b428e590a835ea4b$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b428e590a835ea4b$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b428e590a835ea4b$var$Ke(c, f);
                var g = $b428e590a835ea4b$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b428e590a835ea4b$var$Pe = $b428e590a835ea4b$var$ia && "documentMode" in document && 11 >= document.documentMode, $b428e590a835ea4b$var$Qe = null, $b428e590a835ea4b$var$Re = null, $b428e590a835ea4b$var$Se = null, $b428e590a835ea4b$var$Te = !1;
function $b428e590a835ea4b$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b428e590a835ea4b$var$Te || null == $b428e590a835ea4b$var$Qe || $b428e590a835ea4b$var$Qe !== $b428e590a835ea4b$var$Xa(d) || (d = $b428e590a835ea4b$var$Qe, "selectionStart" in d && $b428e590a835ea4b$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b428e590a835ea4b$var$Se && $b428e590a835ea4b$var$Ie($b428e590a835ea4b$var$Se, d) || ($b428e590a835ea4b$var$Se = d, d = $b428e590a835ea4b$var$oe($b428e590a835ea4b$var$Re, "onSelect"), 0 < d.length && (b = new $b428e590a835ea4b$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b428e590a835ea4b$var$Qe)));
}
function $b428e590a835ea4b$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b428e590a835ea4b$var$We = {
    animationend: $b428e590a835ea4b$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b428e590a835ea4b$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b428e590a835ea4b$var$Ve("Animation", "AnimationStart"),
    transitionend: $b428e590a835ea4b$var$Ve("Transition", "TransitionEnd")
}, $b428e590a835ea4b$var$Xe = {}, $b428e590a835ea4b$var$Ye = {};
$b428e590a835ea4b$var$ia && ($b428e590a835ea4b$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b428e590a835ea4b$var$We.animationend.animation, delete $b428e590a835ea4b$var$We.animationiteration.animation, delete $b428e590a835ea4b$var$We.animationstart.animation), "TransitionEvent" in window || delete $b428e590a835ea4b$var$We.transitionend.transition);
function $b428e590a835ea4b$var$Ze(a) {
    if ($b428e590a835ea4b$var$Xe[a]) return $b428e590a835ea4b$var$Xe[a];
    if (!$b428e590a835ea4b$var$We[a]) return a;
    var b = $b428e590a835ea4b$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b428e590a835ea4b$var$Ye) return $b428e590a835ea4b$var$Xe[a] = b[c];
    return a;
}
var $b428e590a835ea4b$var$$e = $b428e590a835ea4b$var$Ze("animationend"), $b428e590a835ea4b$var$af = $b428e590a835ea4b$var$Ze("animationiteration"), $b428e590a835ea4b$var$bf = $b428e590a835ea4b$var$Ze("animationstart"), $b428e590a835ea4b$var$cf = $b428e590a835ea4b$var$Ze("transitionend"), $b428e590a835ea4b$var$df = new Map, $b428e590a835ea4b$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b428e590a835ea4b$var$ff(a, b) {
    $b428e590a835ea4b$var$df.set(a, b);
    $b428e590a835ea4b$var$fa(b, [
        a
    ]);
}
for(var $b428e590a835ea4b$var$gf = 0; $b428e590a835ea4b$var$gf < $b428e590a835ea4b$var$ef.length; $b428e590a835ea4b$var$gf++){
    var $b428e590a835ea4b$var$hf = $b428e590a835ea4b$var$ef[$b428e590a835ea4b$var$gf], $b428e590a835ea4b$var$jf = $b428e590a835ea4b$var$hf.toLowerCase(), $b428e590a835ea4b$var$kf = $b428e590a835ea4b$var$hf[0].toUpperCase() + $b428e590a835ea4b$var$hf.slice(1);
    $b428e590a835ea4b$var$ff($b428e590a835ea4b$var$jf, "on" + $b428e590a835ea4b$var$kf);
}
$b428e590a835ea4b$var$ff($b428e590a835ea4b$var$$e, "onAnimationEnd");
$b428e590a835ea4b$var$ff($b428e590a835ea4b$var$af, "onAnimationIteration");
$b428e590a835ea4b$var$ff($b428e590a835ea4b$var$bf, "onAnimationStart");
$b428e590a835ea4b$var$ff("dblclick", "onDoubleClick");
$b428e590a835ea4b$var$ff("focusin", "onFocus");
$b428e590a835ea4b$var$ff("focusout", "onBlur");
$b428e590a835ea4b$var$ff($b428e590a835ea4b$var$cf, "onTransitionEnd");
$b428e590a835ea4b$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b428e590a835ea4b$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b428e590a835ea4b$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b428e590a835ea4b$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b428e590a835ea4b$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b428e590a835ea4b$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b428e590a835ea4b$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b428e590a835ea4b$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b428e590a835ea4b$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b428e590a835ea4b$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b428e590a835ea4b$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b428e590a835ea4b$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b428e590a835ea4b$var$lf));
function $b428e590a835ea4b$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b428e590a835ea4b$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b428e590a835ea4b$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b428e590a835ea4b$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b428e590a835ea4b$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b428e590a835ea4b$var$Qb) throw a = $b428e590a835ea4b$var$Rb, $b428e590a835ea4b$var$Qb = !1, $b428e590a835ea4b$var$Rb = null, a;
}
function $b428e590a835ea4b$var$D(a, b) {
    var c = b[$b428e590a835ea4b$var$of];
    void 0 === c && (c = b[$b428e590a835ea4b$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b428e590a835ea4b$var$pf(b, a, 2, !1), c.add(d));
}
function $b428e590a835ea4b$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b428e590a835ea4b$var$pf(c, a, d, b);
}
var $b428e590a835ea4b$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b428e590a835ea4b$var$sf(a) {
    if (!a[$b428e590a835ea4b$var$rf]) {
        a[$b428e590a835ea4b$var$rf] = !0;
        $b428e590a835ea4b$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b428e590a835ea4b$var$mf.has(b) || $b428e590a835ea4b$var$qf(b, !1, a), $b428e590a835ea4b$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b428e590a835ea4b$var$rf] || (b[$b428e590a835ea4b$var$rf] = !0, $b428e590a835ea4b$var$qf("selectionchange", !1, b));
    }
}
function $b428e590a835ea4b$var$pf(a, b, c, d) {
    switch($b428e590a835ea4b$var$jd(b)){
        case 1:
            var e = $b428e590a835ea4b$var$ed;
            break;
        case 4:
            e = $b428e590a835ea4b$var$gd;
            break;
        default:
            e = $b428e590a835ea4b$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b428e590a835ea4b$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b428e590a835ea4b$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b428e590a835ea4b$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b428e590a835ea4b$var$Jb(function() {
        var _$d = f, _$e = $b428e590a835ea4b$var$xb(c), g = [];
        a: {
            var h = $b428e590a835ea4b$var$df.get(a);
            if (void 0 !== h) {
                var k = $b428e590a835ea4b$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b428e590a835ea4b$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b428e590a835ea4b$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b428e590a835ea4b$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b428e590a835ea4b$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b428e590a835ea4b$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b428e590a835ea4b$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b428e590a835ea4b$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b428e590a835ea4b$var$Vd;
                        break;
                    case $b428e590a835ea4b$var$$e:
                    case $b428e590a835ea4b$var$af:
                    case $b428e590a835ea4b$var$bf:
                        k = $b428e590a835ea4b$var$Hd;
                        break;
                    case $b428e590a835ea4b$var$cf:
                        k = $b428e590a835ea4b$var$Xd;
                        break;
                    case "scroll":
                        k = $b428e590a835ea4b$var$vd;
                        break;
                    case "wheel":
                        k = $b428e590a835ea4b$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b428e590a835ea4b$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b428e590a835ea4b$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b428e590a835ea4b$var$Kb(w, x), null != F && t.push($b428e590a835ea4b$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b428e590a835ea4b$var$wb && (n = c.relatedTarget || c.fromElement) && ($b428e590a835ea4b$var$Wc(n) || n[$b428e590a835ea4b$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $b428e590a835ea4b$var$Wc(n) : null, null !== n && (J = $b428e590a835ea4b$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $b428e590a835ea4b$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b428e590a835ea4b$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b428e590a835ea4b$var$ue(k);
                        u = null == n ? h : $b428e590a835ea4b$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b428e590a835ea4b$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b428e590a835ea4b$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b428e590a835ea4b$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b428e590a835ea4b$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b428e590a835ea4b$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b428e590a835ea4b$var$vf(t);
                                x = $b428e590a835ea4b$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b428e590a835ea4b$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b428e590a835ea4b$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $b428e590a835ea4b$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b428e590a835ea4b$var$ve;
                else if ($b428e590a835ea4b$var$me(h)) {
                    if ($b428e590a835ea4b$var$we) na = $b428e590a835ea4b$var$Fe;
                    else {
                        na = $b428e590a835ea4b$var$De;
                        var xa = $b428e590a835ea4b$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b428e590a835ea4b$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $b428e590a835ea4b$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b428e590a835ea4b$var$cb(h, "number", h.value);
            }
            xa = _$d ? $b428e590a835ea4b$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($b428e590a835ea4b$var$me(xa) || "true" === xa.contentEditable) $b428e590a835ea4b$var$Qe = xa, $b428e590a835ea4b$var$Re = _$d, $b428e590a835ea4b$var$Se = null;
                    break;
                case "focusout":
                    $b428e590a835ea4b$var$Se = $b428e590a835ea4b$var$Re = $b428e590a835ea4b$var$Qe = null;
                    break;
                case "mousedown":
                    $b428e590a835ea4b$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b428e590a835ea4b$var$Te = !1;
                    $b428e590a835ea4b$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($b428e590a835ea4b$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b428e590a835ea4b$var$Ue(g, c, _$e);
            }
            var $a;
            if ($b428e590a835ea4b$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b428e590a835ea4b$var$ie ? $b428e590a835ea4b$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b428e590a835ea4b$var$de && "ko" !== c.locale && ($b428e590a835ea4b$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b428e590a835ea4b$var$ie && ($a = $b428e590a835ea4b$var$nd()) : ($b428e590a835ea4b$var$kd = _$e, $b428e590a835ea4b$var$ld = "value" in $b428e590a835ea4b$var$kd ? $b428e590a835ea4b$var$kd.value : $b428e590a835ea4b$var$kd.textContent, $b428e590a835ea4b$var$ie = !0)), xa = $b428e590a835ea4b$var$oe(_$d, ba), 0 < xa.length && (ba = new $b428e590a835ea4b$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b428e590a835ea4b$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b428e590a835ea4b$var$ce ? $b428e590a835ea4b$var$je(a, c) : $b428e590a835ea4b$var$ke(a, c)) _$d = $b428e590a835ea4b$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $b428e590a835ea4b$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $b428e590a835ea4b$var$se(g, b);
    });
}
function $b428e590a835ea4b$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b428e590a835ea4b$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b428e590a835ea4b$var$Kb(a, c), null != f && d.unshift($b428e590a835ea4b$var$tf(a, f, e)), f = $b428e590a835ea4b$var$Kb(a, b), null != f && d.push($b428e590a835ea4b$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b428e590a835ea4b$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b428e590a835ea4b$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b428e590a835ea4b$var$Kb(c, f), null != k && g.unshift($b428e590a835ea4b$var$tf(c, k, h))) : e || (k = $b428e590a835ea4b$var$Kb(c, f), null != k && g.push($b428e590a835ea4b$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b428e590a835ea4b$var$xf = /\r\n?/g, $b428e590a835ea4b$var$yf = /\u0000|\uFFFD/g;
function $b428e590a835ea4b$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b428e590a835ea4b$var$xf, "\n").replace($b428e590a835ea4b$var$yf, "");
}
function $b428e590a835ea4b$var$Af(a, b, c) {
    b = $b428e590a835ea4b$var$zf(b);
    if ($b428e590a835ea4b$var$zf(a) !== b && c) throw Error($b428e590a835ea4b$var$p(425));
}
function $b428e590a835ea4b$var$Bf() {}
var $b428e590a835ea4b$var$Cf = null, $b428e590a835ea4b$var$Df = null;
function $b428e590a835ea4b$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b428e590a835ea4b$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b428e590a835ea4b$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b428e590a835ea4b$var$Hf = "function" === typeof Promise ? Promise : void 0, $b428e590a835ea4b$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b428e590a835ea4b$var$Hf ? function Jf(a) {
    return $b428e590a835ea4b$var$Hf.resolve(null).then(a).catch($b428e590a835ea4b$var$If);
} : $b428e590a835ea4b$var$Ff;
function $b428e590a835ea4b$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b428e590a835ea4b$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b428e590a835ea4b$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b428e590a835ea4b$var$bd(b);
}
function $b428e590a835ea4b$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b428e590a835ea4b$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b428e590a835ea4b$var$Nf = Math.random().toString(36).slice(2), $b428e590a835ea4b$var$Of = "__reactFiber$" + $b428e590a835ea4b$var$Nf, $b428e590a835ea4b$var$Pf = "__reactProps$" + $b428e590a835ea4b$var$Nf, $b428e590a835ea4b$var$uf = "__reactContainer$" + $b428e590a835ea4b$var$Nf, $b428e590a835ea4b$var$of = "__reactEvents$" + $b428e590a835ea4b$var$Nf, $b428e590a835ea4b$var$Qf = "__reactListeners$" + $b428e590a835ea4b$var$Nf, $b428e590a835ea4b$var$Rf = "__reactHandles$" + $b428e590a835ea4b$var$Nf;
function $b428e590a835ea4b$var$Wc(a) {
    var b = a[$b428e590a835ea4b$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b428e590a835ea4b$var$uf] || c[$b428e590a835ea4b$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b428e590a835ea4b$var$Mf(a); null !== a;){
                if (c = a[$b428e590a835ea4b$var$Of]) return c;
                a = $b428e590a835ea4b$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b428e590a835ea4b$var$Cb(a) {
    a = a[$b428e590a835ea4b$var$Of] || a[$b428e590a835ea4b$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b428e590a835ea4b$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b428e590a835ea4b$var$p(33));
}
function $b428e590a835ea4b$var$Db(a) {
    return a[$b428e590a835ea4b$var$Pf] || null;
}
var $b428e590a835ea4b$var$Sf = [], $b428e590a835ea4b$var$Tf = -1;
function $b428e590a835ea4b$var$Uf(a) {
    return {
        current: a
    };
}
function $b428e590a835ea4b$var$E(a) {
    0 > $b428e590a835ea4b$var$Tf || (a.current = $b428e590a835ea4b$var$Sf[$b428e590a835ea4b$var$Tf], $b428e590a835ea4b$var$Sf[$b428e590a835ea4b$var$Tf] = null, $b428e590a835ea4b$var$Tf--);
}
function $b428e590a835ea4b$var$G(a, b) {
    $b428e590a835ea4b$var$Tf++;
    $b428e590a835ea4b$var$Sf[$b428e590a835ea4b$var$Tf] = a.current;
    a.current = b;
}
var $b428e590a835ea4b$var$Vf = {}, $b428e590a835ea4b$var$H = $b428e590a835ea4b$var$Uf($b428e590a835ea4b$var$Vf), $b428e590a835ea4b$var$Wf = $b428e590a835ea4b$var$Uf(!1), $b428e590a835ea4b$var$Xf = $b428e590a835ea4b$var$Vf;
function $b428e590a835ea4b$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b428e590a835ea4b$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b428e590a835ea4b$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b428e590a835ea4b$var$$f() {
    $b428e590a835ea4b$var$E($b428e590a835ea4b$var$Wf);
    $b428e590a835ea4b$var$E($b428e590a835ea4b$var$H);
}
function $b428e590a835ea4b$var$ag(a, b, c) {
    if ($b428e590a835ea4b$var$H.current !== $b428e590a835ea4b$var$Vf) throw Error($b428e590a835ea4b$var$p(168));
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$H, b);
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$Wf, c);
}
function $b428e590a835ea4b$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b428e590a835ea4b$var$p(108, $b428e590a835ea4b$var$Ra(a) || "Unknown", e));
    return $b428e590a835ea4b$var$A({}, c, d);
}
function $b428e590a835ea4b$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b428e590a835ea4b$var$Vf;
    $b428e590a835ea4b$var$Xf = $b428e590a835ea4b$var$H.current;
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$H, a);
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$Wf, $b428e590a835ea4b$var$Wf.current);
    return !0;
}
function $b428e590a835ea4b$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b428e590a835ea4b$var$p(169));
    c ? (a = $b428e590a835ea4b$var$bg(a, b, $b428e590a835ea4b$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b428e590a835ea4b$var$E($b428e590a835ea4b$var$Wf), $b428e590a835ea4b$var$E($b428e590a835ea4b$var$H), $b428e590a835ea4b$var$G($b428e590a835ea4b$var$H, a)) : $b428e590a835ea4b$var$E($b428e590a835ea4b$var$Wf);
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$Wf, c);
}
var $b428e590a835ea4b$var$eg = null, $b428e590a835ea4b$var$fg = !1, $b428e590a835ea4b$var$gg = !1;
function $b428e590a835ea4b$var$hg(a) {
    null === $b428e590a835ea4b$var$eg ? $b428e590a835ea4b$var$eg = [
        a
    ] : $b428e590a835ea4b$var$eg.push(a);
}
function $b428e590a835ea4b$var$ig(a) {
    $b428e590a835ea4b$var$fg = !0;
    $b428e590a835ea4b$var$hg(a);
}
function $b428e590a835ea4b$var$jg() {
    if (!$b428e590a835ea4b$var$gg && null !== $b428e590a835ea4b$var$eg) {
        $b428e590a835ea4b$var$gg = !0;
        var a = 0, b = $b428e590a835ea4b$var$C;
        try {
            var c = $b428e590a835ea4b$var$eg;
            for($b428e590a835ea4b$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b428e590a835ea4b$var$eg = null;
            $b428e590a835ea4b$var$fg = !1;
        } catch (e) {
            throw null !== $b428e590a835ea4b$var$eg && ($b428e590a835ea4b$var$eg = $b428e590a835ea4b$var$eg.slice(a + 1)), $b428e590a835ea4b$var$ac($b428e590a835ea4b$var$fc, $b428e590a835ea4b$var$jg), e;
        } finally{
            $b428e590a835ea4b$var$C = b, $b428e590a835ea4b$var$gg = !1;
        }
    }
    return null;
}
var $b428e590a835ea4b$var$kg = [], $b428e590a835ea4b$var$lg = 0, $b428e590a835ea4b$var$mg = null, $b428e590a835ea4b$var$ng = 0, $b428e590a835ea4b$var$og = [], $b428e590a835ea4b$var$pg = 0, $b428e590a835ea4b$var$qg = null, $b428e590a835ea4b$var$rg = 1, $b428e590a835ea4b$var$sg = "";
function $b428e590a835ea4b$var$tg(a, b) {
    $b428e590a835ea4b$var$kg[$b428e590a835ea4b$var$lg++] = $b428e590a835ea4b$var$ng;
    $b428e590a835ea4b$var$kg[$b428e590a835ea4b$var$lg++] = $b428e590a835ea4b$var$mg;
    $b428e590a835ea4b$var$mg = a;
    $b428e590a835ea4b$var$ng = b;
}
function $b428e590a835ea4b$var$ug(a, b, c) {
    $b428e590a835ea4b$var$og[$b428e590a835ea4b$var$pg++] = $b428e590a835ea4b$var$rg;
    $b428e590a835ea4b$var$og[$b428e590a835ea4b$var$pg++] = $b428e590a835ea4b$var$sg;
    $b428e590a835ea4b$var$og[$b428e590a835ea4b$var$pg++] = $b428e590a835ea4b$var$qg;
    $b428e590a835ea4b$var$qg = a;
    var d = $b428e590a835ea4b$var$rg;
    a = $b428e590a835ea4b$var$sg;
    var e = 32 - $b428e590a835ea4b$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b428e590a835ea4b$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b428e590a835ea4b$var$rg = 1 << 32 - $b428e590a835ea4b$var$oc(b) + e | c << e | d;
        $b428e590a835ea4b$var$sg = f + a;
    } else $b428e590a835ea4b$var$rg = 1 << f | c << e | d, $b428e590a835ea4b$var$sg = a;
}
function $b428e590a835ea4b$var$vg(a) {
    null !== a.return && ($b428e590a835ea4b$var$tg(a, 1), $b428e590a835ea4b$var$ug(a, 1, 0));
}
function $b428e590a835ea4b$var$wg(a) {
    for(; a === $b428e590a835ea4b$var$mg;)$b428e590a835ea4b$var$mg = $b428e590a835ea4b$var$kg[--$b428e590a835ea4b$var$lg], $b428e590a835ea4b$var$kg[$b428e590a835ea4b$var$lg] = null, $b428e590a835ea4b$var$ng = $b428e590a835ea4b$var$kg[--$b428e590a835ea4b$var$lg], $b428e590a835ea4b$var$kg[$b428e590a835ea4b$var$lg] = null;
    for(; a === $b428e590a835ea4b$var$qg;)$b428e590a835ea4b$var$qg = $b428e590a835ea4b$var$og[--$b428e590a835ea4b$var$pg], $b428e590a835ea4b$var$og[$b428e590a835ea4b$var$pg] = null, $b428e590a835ea4b$var$sg = $b428e590a835ea4b$var$og[--$b428e590a835ea4b$var$pg], $b428e590a835ea4b$var$og[$b428e590a835ea4b$var$pg] = null, $b428e590a835ea4b$var$rg = $b428e590a835ea4b$var$og[--$b428e590a835ea4b$var$pg], $b428e590a835ea4b$var$og[$b428e590a835ea4b$var$pg] = null;
}
var $b428e590a835ea4b$var$xg = null, $b428e590a835ea4b$var$yg = null, $b428e590a835ea4b$var$I = !1, $b428e590a835ea4b$var$zg = null;
function $b428e590a835ea4b$var$Ag(a, b) {
    var c = $b428e590a835ea4b$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b428e590a835ea4b$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b428e590a835ea4b$var$xg = a, $b428e590a835ea4b$var$yg = $b428e590a835ea4b$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b428e590a835ea4b$var$xg = a, $b428e590a835ea4b$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b428e590a835ea4b$var$qg ? {
                id: $b428e590a835ea4b$var$rg,
                overflow: $b428e590a835ea4b$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b428e590a835ea4b$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b428e590a835ea4b$var$xg = a, $b428e590a835ea4b$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b428e590a835ea4b$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b428e590a835ea4b$var$Eg(a) {
    if ($b428e590a835ea4b$var$I) {
        var b = $b428e590a835ea4b$var$yg;
        if (b) {
            var c = b;
            if (!$b428e590a835ea4b$var$Cg(a, b)) {
                if ($b428e590a835ea4b$var$Dg(a)) throw Error($b428e590a835ea4b$var$p(418));
                b = $b428e590a835ea4b$var$Lf(c.nextSibling);
                var d = $b428e590a835ea4b$var$xg;
                b && $b428e590a835ea4b$var$Cg(a, b) ? $b428e590a835ea4b$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b428e590a835ea4b$var$I = !1, $b428e590a835ea4b$var$xg = a);
            }
        } else {
            if ($b428e590a835ea4b$var$Dg(a)) throw Error($b428e590a835ea4b$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b428e590a835ea4b$var$I = !1;
            $b428e590a835ea4b$var$xg = a;
        }
    }
}
function $b428e590a835ea4b$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b428e590a835ea4b$var$xg = a;
}
function $b428e590a835ea4b$var$Gg(a) {
    if (a !== $b428e590a835ea4b$var$xg) return !1;
    if (!$b428e590a835ea4b$var$I) return $b428e590a835ea4b$var$Fg(a), $b428e590a835ea4b$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b428e590a835ea4b$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b428e590a835ea4b$var$yg)) {
        if ($b428e590a835ea4b$var$Dg(a)) throw $b428e590a835ea4b$var$Hg(), Error($b428e590a835ea4b$var$p(418));
        for(; b;)$b428e590a835ea4b$var$Ag(a, b), b = $b428e590a835ea4b$var$Lf(b.nextSibling);
    }
    $b428e590a835ea4b$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b428e590a835ea4b$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b428e590a835ea4b$var$yg = $b428e590a835ea4b$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b428e590a835ea4b$var$yg = null;
        }
    } else $b428e590a835ea4b$var$yg = $b428e590a835ea4b$var$xg ? $b428e590a835ea4b$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b428e590a835ea4b$var$Hg() {
    for(var a = $b428e590a835ea4b$var$yg; a;)a = $b428e590a835ea4b$var$Lf(a.nextSibling);
}
function $b428e590a835ea4b$var$Ig() {
    $b428e590a835ea4b$var$yg = $b428e590a835ea4b$var$xg = null;
    $b428e590a835ea4b$var$I = !1;
}
function $b428e590a835ea4b$var$Jg(a) {
    null === $b428e590a835ea4b$var$zg ? $b428e590a835ea4b$var$zg = [
        a
    ] : $b428e590a835ea4b$var$zg.push(a);
}
var $b428e590a835ea4b$var$Kg = $b428e590a835ea4b$var$ua.ReactCurrentBatchConfig;
function $b428e590a835ea4b$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $b428e590a835ea4b$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $b428e590a835ea4b$var$Mg = $b428e590a835ea4b$var$Uf(null), $b428e590a835ea4b$var$Ng = null, $b428e590a835ea4b$var$Og = null, $b428e590a835ea4b$var$Pg = null;
function $b428e590a835ea4b$var$Qg() {
    $b428e590a835ea4b$var$Pg = $b428e590a835ea4b$var$Og = $b428e590a835ea4b$var$Ng = null;
}
function $b428e590a835ea4b$var$Rg(a) {
    var b = $b428e590a835ea4b$var$Mg.current;
    $b428e590a835ea4b$var$E($b428e590a835ea4b$var$Mg);
    a._currentValue = b;
}
function $b428e590a835ea4b$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b428e590a835ea4b$var$Tg(a, b) {
    $b428e590a835ea4b$var$Ng = a;
    $b428e590a835ea4b$var$Pg = $b428e590a835ea4b$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b428e590a835ea4b$var$Ug = !0), a.firstContext = null);
}
function $b428e590a835ea4b$var$Vg(a) {
    var b = a._currentValue;
    if ($b428e590a835ea4b$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b428e590a835ea4b$var$Og) {
            if (null === $b428e590a835ea4b$var$Ng) throw Error($b428e590a835ea4b$var$p(308));
            $b428e590a835ea4b$var$Og = a;
            $b428e590a835ea4b$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b428e590a835ea4b$var$Og = $b428e590a835ea4b$var$Og.next = a;
    }
    return b;
}
var $b428e590a835ea4b$var$Wg = null;
function $b428e590a835ea4b$var$Xg(a) {
    null === $b428e590a835ea4b$var$Wg ? $b428e590a835ea4b$var$Wg = [
        a
    ] : $b428e590a835ea4b$var$Wg.push(a);
}
function $b428e590a835ea4b$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b428e590a835ea4b$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b428e590a835ea4b$var$Zg(a, d);
}
function $b428e590a835ea4b$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b428e590a835ea4b$var$$g = !1;
function $b428e590a835ea4b$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b428e590a835ea4b$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b428e590a835ea4b$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b428e590a835ea4b$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b428e590a835ea4b$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b428e590a835ea4b$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b428e590a835ea4b$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b428e590a835ea4b$var$Zg(a, c);
}
function $b428e590a835ea4b$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b428e590a835ea4b$var$Cc(a, c);
    }
}
function $b428e590a835ea4b$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b428e590a835ea4b$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $b428e590a835ea4b$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b428e590a835ea4b$var$A({}, q, r);
                            break a;
                        case 2:
                            $b428e590a835ea4b$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b428e590a835ea4b$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b428e590a835ea4b$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b428e590a835ea4b$var$p(191, e));
            e.call(d);
        }
    }
}
var $b428e590a835ea4b$var$jh = (new $fIwXP.Component).refs;
function $b428e590a835ea4b$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b428e590a835ea4b$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b428e590a835ea4b$var$nh = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $b428e590a835ea4b$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $b428e590a835ea4b$var$L(), e = $b428e590a835ea4b$var$lh(a), f = $b428e590a835ea4b$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b428e590a835ea4b$var$dh(a, f, e);
        null !== b && ($b428e590a835ea4b$var$mh(b, a, e, d), $b428e590a835ea4b$var$eh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $b428e590a835ea4b$var$L(), e = $b428e590a835ea4b$var$lh(a), f = $b428e590a835ea4b$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b428e590a835ea4b$var$dh(a, f, e);
        null !== b && ($b428e590a835ea4b$var$mh(b, a, e, d), $b428e590a835ea4b$var$eh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $b428e590a835ea4b$var$L(), d = $b428e590a835ea4b$var$lh(a), e = $b428e590a835ea4b$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b428e590a835ea4b$var$dh(a, e, d);
        null !== b && ($b428e590a835ea4b$var$mh(b, a, d, c), $b428e590a835ea4b$var$eh(b, a, d));
    }
};
function $b428e590a835ea4b$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b428e590a835ea4b$var$Ie(c, d) || !$b428e590a835ea4b$var$Ie(e, f) : !0;
}
function $b428e590a835ea4b$var$ph(a, b, c) {
    var d = !1, e = $b428e590a835ea4b$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b428e590a835ea4b$var$Vg(f) : (e = $b428e590a835ea4b$var$Zf(b) ? $b428e590a835ea4b$var$Xf : $b428e590a835ea4b$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b428e590a835ea4b$var$Yf(a, e) : $b428e590a835ea4b$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b428e590a835ea4b$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b428e590a835ea4b$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b428e590a835ea4b$var$nh.enqueueReplaceState(b, b.state, null);
}
function $b428e590a835ea4b$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $b428e590a835ea4b$var$jh;
    $b428e590a835ea4b$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b428e590a835ea4b$var$Vg(f) : (f = $b428e590a835ea4b$var$Zf(b) ? $b428e590a835ea4b$var$Xf : $b428e590a835ea4b$var$H.current, e.context = $b428e590a835ea4b$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b428e590a835ea4b$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b428e590a835ea4b$var$nh.enqueueReplaceState(e, e.state, null), $b428e590a835ea4b$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b428e590a835ea4b$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b428e590a835ea4b$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b428e590a835ea4b$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                _$b === $b428e590a835ea4b$var$jh && (_$b = e.refs = {});
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b428e590a835ea4b$var$p(284));
        if (!c._owner) throw Error($b428e590a835ea4b$var$p(290, a));
    }
    return a;
}
function $b428e590a835ea4b$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b428e590a835ea4b$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b428e590a835ea4b$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $b428e590a835ea4b$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b428e590a835ea4b$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b428e590a835ea4b$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b428e590a835ea4b$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b428e590a835ea4b$var$Ha && $b428e590a835ea4b$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $b428e590a835ea4b$var$sh(a, b, c), d.return = a, d;
        d = $b428e590a835ea4b$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b428e590a835ea4b$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b428e590a835ea4b$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b428e590a835ea4b$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b428e590a835ea4b$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b428e590a835ea4b$var$va:
                    return c = $b428e590a835ea4b$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $b428e590a835ea4b$var$sh(a, null, b), c.return = a, c;
                case $b428e590a835ea4b$var$wa:
                    return b = $b428e590a835ea4b$var$zh(b, a.mode, c), b.return = a, b;
                case $b428e590a835ea4b$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b428e590a835ea4b$var$eb(b) || $b428e590a835ea4b$var$Ka(b)) return b = $b428e590a835ea4b$var$Ah(b, a.mode, c, null), b.return = a, b;
            $b428e590a835ea4b$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b428e590a835ea4b$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b428e590a835ea4b$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b428e590a835ea4b$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b428e590a835ea4b$var$eb(c) || $b428e590a835ea4b$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b428e590a835ea4b$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b428e590a835ea4b$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b428e590a835ea4b$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b428e590a835ea4b$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b428e590a835ea4b$var$eb(d) || $b428e590a835ea4b$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b428e590a835ea4b$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b428e590a835ea4b$var$I && $b428e590a835ea4b$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b428e590a835ea4b$var$I && $b428e590a835ea4b$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b428e590a835ea4b$var$I && $b428e590a835ea4b$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b428e590a835ea4b$var$Ka(h);
        if ("function" !== typeof l) throw Error($b428e590a835ea4b$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b428e590a835ea4b$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b428e590a835ea4b$var$I && $b428e590a835ea4b$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b428e590a835ea4b$var$I && $b428e590a835ea4b$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b428e590a835ea4b$var$I && $b428e590a835ea4b$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b428e590a835ea4b$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b428e590a835ea4b$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b428e590a835ea4b$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b428e590a835ea4b$var$Ha && $b428e590a835ea4b$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b428e590a835ea4b$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b428e590a835ea4b$var$ya ? (d = $b428e590a835ea4b$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b428e590a835ea4b$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $b428e590a835ea4b$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b428e590a835ea4b$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b428e590a835ea4b$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b428e590a835ea4b$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b428e590a835ea4b$var$eb(f)) return n(a, d, f, h);
            if ($b428e590a835ea4b$var$Ka(f)) return t(a, d, f, h);
            $b428e590a835ea4b$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b428e590a835ea4b$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b428e590a835ea4b$var$Bh = $b428e590a835ea4b$var$vh(!0), $b428e590a835ea4b$var$Ch = $b428e590a835ea4b$var$vh(!1), $b428e590a835ea4b$var$Dh = {}, $b428e590a835ea4b$var$Eh = $b428e590a835ea4b$var$Uf($b428e590a835ea4b$var$Dh), $b428e590a835ea4b$var$Fh = $b428e590a835ea4b$var$Uf($b428e590a835ea4b$var$Dh), $b428e590a835ea4b$var$Gh = $b428e590a835ea4b$var$Uf($b428e590a835ea4b$var$Dh);
function $b428e590a835ea4b$var$Hh(a) {
    if (a === $b428e590a835ea4b$var$Dh) throw Error($b428e590a835ea4b$var$p(174));
    return a;
}
function $b428e590a835ea4b$var$Ih(a, b) {
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$Gh, b);
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$Fh, a);
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$Eh, $b428e590a835ea4b$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b428e590a835ea4b$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b428e590a835ea4b$var$lb(b, a);
    }
    $b428e590a835ea4b$var$E($b428e590a835ea4b$var$Eh);
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$Eh, b);
}
function $b428e590a835ea4b$var$Jh() {
    $b428e590a835ea4b$var$E($b428e590a835ea4b$var$Eh);
    $b428e590a835ea4b$var$E($b428e590a835ea4b$var$Fh);
    $b428e590a835ea4b$var$E($b428e590a835ea4b$var$Gh);
}
function $b428e590a835ea4b$var$Kh(a) {
    $b428e590a835ea4b$var$Hh($b428e590a835ea4b$var$Gh.current);
    var b = $b428e590a835ea4b$var$Hh($b428e590a835ea4b$var$Eh.current);
    var c = $b428e590a835ea4b$var$lb(b, a.type);
    b !== c && ($b428e590a835ea4b$var$G($b428e590a835ea4b$var$Fh, a), $b428e590a835ea4b$var$G($b428e590a835ea4b$var$Eh, c));
}
function $b428e590a835ea4b$var$Lh(a) {
    $b428e590a835ea4b$var$Fh.current === a && ($b428e590a835ea4b$var$E($b428e590a835ea4b$var$Eh), $b428e590a835ea4b$var$E($b428e590a835ea4b$var$Fh));
}
var $b428e590a835ea4b$var$M = $b428e590a835ea4b$var$Uf(0);
function $b428e590a835ea4b$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b428e590a835ea4b$var$Nh = [];
function $b428e590a835ea4b$var$Oh() {
    for(var a = 0; a < $b428e590a835ea4b$var$Nh.length; a++)$b428e590a835ea4b$var$Nh[a]._workInProgressVersionPrimary = null;
    $b428e590a835ea4b$var$Nh.length = 0;
}
var $b428e590a835ea4b$var$Ph = $b428e590a835ea4b$var$ua.ReactCurrentDispatcher, $b428e590a835ea4b$var$Qh = $b428e590a835ea4b$var$ua.ReactCurrentBatchConfig, $b428e590a835ea4b$var$Rh = 0, $b428e590a835ea4b$var$N = null, $b428e590a835ea4b$var$O = null, $b428e590a835ea4b$var$P = null, $b428e590a835ea4b$var$Sh = !1, $b428e590a835ea4b$var$Th = !1, $b428e590a835ea4b$var$Uh = 0, $b428e590a835ea4b$var$Vh = 0;
function $b428e590a835ea4b$var$Q() {
    throw Error($b428e590a835ea4b$var$p(321));
}
function $b428e590a835ea4b$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b428e590a835ea4b$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b428e590a835ea4b$var$Xh(a, b, c, d, e, f) {
    $b428e590a835ea4b$var$Rh = f;
    $b428e590a835ea4b$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b428e590a835ea4b$var$Ph.current = null === a || null === a.memoizedState ? $b428e590a835ea4b$var$Yh : $b428e590a835ea4b$var$Zh;
    a = c(d, e);
    if ($b428e590a835ea4b$var$Th) {
        f = 0;
        do {
            $b428e590a835ea4b$var$Th = !1;
            $b428e590a835ea4b$var$Uh = 0;
            if (25 <= f) throw Error($b428e590a835ea4b$var$p(301));
            f += 1;
            $b428e590a835ea4b$var$P = $b428e590a835ea4b$var$O = null;
            b.updateQueue = null;
            $b428e590a835ea4b$var$Ph.current = $b428e590a835ea4b$var$$h;
            a = c(d, e);
        }while ($b428e590a835ea4b$var$Th);
    }
    $b428e590a835ea4b$var$Ph.current = $b428e590a835ea4b$var$ai;
    b = null !== $b428e590a835ea4b$var$O && null !== $b428e590a835ea4b$var$O.next;
    $b428e590a835ea4b$var$Rh = 0;
    $b428e590a835ea4b$var$P = $b428e590a835ea4b$var$O = $b428e590a835ea4b$var$N = null;
    $b428e590a835ea4b$var$Sh = !1;
    if (b) throw Error($b428e590a835ea4b$var$p(300));
    return a;
}
function $b428e590a835ea4b$var$bi() {
    var a = 0 !== $b428e590a835ea4b$var$Uh;
    $b428e590a835ea4b$var$Uh = 0;
    return a;
}
function $b428e590a835ea4b$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b428e590a835ea4b$var$P ? $b428e590a835ea4b$var$N.memoizedState = $b428e590a835ea4b$var$P = a : $b428e590a835ea4b$var$P = $b428e590a835ea4b$var$P.next = a;
    return $b428e590a835ea4b$var$P;
}
function $b428e590a835ea4b$var$di() {
    if (null === $b428e590a835ea4b$var$O) {
        var a = $b428e590a835ea4b$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b428e590a835ea4b$var$O.next;
    var b = null === $b428e590a835ea4b$var$P ? $b428e590a835ea4b$var$N.memoizedState : $b428e590a835ea4b$var$P.next;
    if (null !== b) $b428e590a835ea4b$var$P = b, $b428e590a835ea4b$var$O = a;
    else {
        if (null === a) throw Error($b428e590a835ea4b$var$p(310));
        $b428e590a835ea4b$var$O = a;
        a = {
            memoizedState: $b428e590a835ea4b$var$O.memoizedState,
            baseState: $b428e590a835ea4b$var$O.baseState,
            baseQueue: $b428e590a835ea4b$var$O.baseQueue,
            queue: $b428e590a835ea4b$var$O.queue,
            next: null
        };
        null === $b428e590a835ea4b$var$P ? $b428e590a835ea4b$var$N.memoizedState = $b428e590a835ea4b$var$P = a : $b428e590a835ea4b$var$P = $b428e590a835ea4b$var$P.next = a;
    }
    return $b428e590a835ea4b$var$P;
}
function $b428e590a835ea4b$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b428e590a835ea4b$var$fi(a) {
    var b = $b428e590a835ea4b$var$di(), c = b.queue;
    if (null === c) throw Error($b428e590a835ea4b$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b428e590a835ea4b$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b428e590a835ea4b$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b428e590a835ea4b$var$N.lanes |= m;
                $b428e590a835ea4b$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b428e590a835ea4b$var$He(d, b.memoizedState) || ($b428e590a835ea4b$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b428e590a835ea4b$var$N.lanes |= f, $b428e590a835ea4b$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b428e590a835ea4b$var$gi(a) {
    var b = $b428e590a835ea4b$var$di(), c = b.queue;
    if (null === c) throw Error($b428e590a835ea4b$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b428e590a835ea4b$var$He(f, b.memoizedState) || ($b428e590a835ea4b$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b428e590a835ea4b$var$hi() {}
function $b428e590a835ea4b$var$ii(a, b) {
    var c = $b428e590a835ea4b$var$N, d = $b428e590a835ea4b$var$di(), e = b(), f = !$b428e590a835ea4b$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b428e590a835ea4b$var$Ug = !0);
    d = d.queue;
    $b428e590a835ea4b$var$ji($b428e590a835ea4b$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b428e590a835ea4b$var$P && $b428e590a835ea4b$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b428e590a835ea4b$var$li(9, $b428e590a835ea4b$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $b428e590a835ea4b$var$R) throw Error($b428e590a835ea4b$var$p(349));
        0 !== ($b428e590a835ea4b$var$Rh & 30) || $b428e590a835ea4b$var$ni(c, b, e);
    }
    return e;
}
function $b428e590a835ea4b$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b428e590a835ea4b$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b428e590a835ea4b$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b428e590a835ea4b$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b428e590a835ea4b$var$oi(b) && $b428e590a835ea4b$var$pi(a);
}
function $b428e590a835ea4b$var$ki(a, b, c) {
    return c(function() {
        $b428e590a835ea4b$var$oi(b) && $b428e590a835ea4b$var$pi(a);
    });
}
function $b428e590a835ea4b$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b428e590a835ea4b$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b428e590a835ea4b$var$pi(a) {
    var b = $b428e590a835ea4b$var$Zg(a, 1);
    null !== b && $b428e590a835ea4b$var$mh(b, a, 1, -1);
}
function $b428e590a835ea4b$var$qi(a) {
    var b = $b428e590a835ea4b$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b428e590a835ea4b$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b428e590a835ea4b$var$ri.bind(null, $b428e590a835ea4b$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b428e590a835ea4b$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b428e590a835ea4b$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b428e590a835ea4b$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b428e590a835ea4b$var$si() {
    return $b428e590a835ea4b$var$di().memoizedState;
}
function $b428e590a835ea4b$var$ti(a, b, c, d) {
    var e = $b428e590a835ea4b$var$ci();
    $b428e590a835ea4b$var$N.flags |= a;
    e.memoizedState = $b428e590a835ea4b$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b428e590a835ea4b$var$ui(a, b, c, d) {
    var e = $b428e590a835ea4b$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b428e590a835ea4b$var$O) {
        var g = $b428e590a835ea4b$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $b428e590a835ea4b$var$Wh(d, g.deps)) {
            e.memoizedState = $b428e590a835ea4b$var$li(b, c, f, d);
            return;
        }
    }
    $b428e590a835ea4b$var$N.flags |= a;
    e.memoizedState = $b428e590a835ea4b$var$li(1 | b, c, f, d);
}
function $b428e590a835ea4b$var$vi(a, b) {
    return $b428e590a835ea4b$var$ti(8390656, 8, a, b);
}
function $b428e590a835ea4b$var$ji(a, b) {
    return $b428e590a835ea4b$var$ui(2048, 8, a, b);
}
function $b428e590a835ea4b$var$wi(a, b) {
    return $b428e590a835ea4b$var$ui(4, 2, a, b);
}
function $b428e590a835ea4b$var$xi(a, b) {
    return $b428e590a835ea4b$var$ui(4, 4, a, b);
}
function $b428e590a835ea4b$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b428e590a835ea4b$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b428e590a835ea4b$var$ui(4, 4, $b428e590a835ea4b$var$yi.bind(null, b, a), c);
}
function $b428e590a835ea4b$var$Ai() {}
function $b428e590a835ea4b$var$Bi(a, b) {
    var c = $b428e590a835ea4b$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b428e590a835ea4b$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b428e590a835ea4b$var$Ci(a, b) {
    var c = $b428e590a835ea4b$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b428e590a835ea4b$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b428e590a835ea4b$var$Di(a, b, c) {
    if (0 === ($b428e590a835ea4b$var$Rh & 21)) return a.baseState && (a.baseState = !1, $b428e590a835ea4b$var$Ug = !0), a.memoizedState = c;
    $b428e590a835ea4b$var$He(c, b) || (c = $b428e590a835ea4b$var$yc(), $b428e590a835ea4b$var$N.lanes |= c, $b428e590a835ea4b$var$hh |= c, a.baseState = !0);
    return b;
}
function $b428e590a835ea4b$var$Ei(a, b) {
    var c = $b428e590a835ea4b$var$C;
    $b428e590a835ea4b$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b428e590a835ea4b$var$Qh.transition;
    $b428e590a835ea4b$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b428e590a835ea4b$var$C = c, $b428e590a835ea4b$var$Qh.transition = d;
    }
}
function $b428e590a835ea4b$var$Fi() {
    return $b428e590a835ea4b$var$di().memoizedState;
}
function $b428e590a835ea4b$var$Gi(a, b, c) {
    var d = $b428e590a835ea4b$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b428e590a835ea4b$var$Hi(a)) $b428e590a835ea4b$var$Ii(b, c);
    else if (c = $b428e590a835ea4b$var$Yg(a, b, c, d), null !== c) {
        var e = $b428e590a835ea4b$var$L();
        $b428e590a835ea4b$var$mh(c, a, d, e);
        $b428e590a835ea4b$var$Ji(c, b, d);
    }
}
function $b428e590a835ea4b$var$ri(a, b, c) {
    var d = $b428e590a835ea4b$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b428e590a835ea4b$var$Hi(a)) $b428e590a835ea4b$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b428e590a835ea4b$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b428e590a835ea4b$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b428e590a835ea4b$var$Yg(a, b, e, d);
        null !== c && (e = $b428e590a835ea4b$var$L(), $b428e590a835ea4b$var$mh(c, a, d, e), $b428e590a835ea4b$var$Ji(c, b, d));
    }
}
function $b428e590a835ea4b$var$Hi(a) {
    var b = a.alternate;
    return a === $b428e590a835ea4b$var$N || null !== b && b === $b428e590a835ea4b$var$N;
}
function $b428e590a835ea4b$var$Ii(a, b) {
    $b428e590a835ea4b$var$Th = $b428e590a835ea4b$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b428e590a835ea4b$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b428e590a835ea4b$var$Cc(a, c);
    }
}
var $b428e590a835ea4b$var$ai = {
    readContext: $b428e590a835ea4b$var$Vg,
    useCallback: $b428e590a835ea4b$var$Q,
    useContext: $b428e590a835ea4b$var$Q,
    useEffect: $b428e590a835ea4b$var$Q,
    useImperativeHandle: $b428e590a835ea4b$var$Q,
    useInsertionEffect: $b428e590a835ea4b$var$Q,
    useLayoutEffect: $b428e590a835ea4b$var$Q,
    useMemo: $b428e590a835ea4b$var$Q,
    useReducer: $b428e590a835ea4b$var$Q,
    useRef: $b428e590a835ea4b$var$Q,
    useState: $b428e590a835ea4b$var$Q,
    useDebugValue: $b428e590a835ea4b$var$Q,
    useDeferredValue: $b428e590a835ea4b$var$Q,
    useTransition: $b428e590a835ea4b$var$Q,
    useMutableSource: $b428e590a835ea4b$var$Q,
    useSyncExternalStore: $b428e590a835ea4b$var$Q,
    useId: $b428e590a835ea4b$var$Q,
    unstable_isNewReconciler: !1
}, $b428e590a835ea4b$var$Yh = {
    readContext: $b428e590a835ea4b$var$Vg,
    useCallback: function useCallback(a, b) {
        $b428e590a835ea4b$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b428e590a835ea4b$var$Vg,
    useEffect: $b428e590a835ea4b$var$vi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b428e590a835ea4b$var$ti(4194308, 4, $b428e590a835ea4b$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $b428e590a835ea4b$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $b428e590a835ea4b$var$ti(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $b428e590a835ea4b$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $b428e590a835ea4b$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b428e590a835ea4b$var$Gi.bind(null, $b428e590a835ea4b$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $b428e590a835ea4b$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b428e590a835ea4b$var$qi,
    useDebugValue: $b428e590a835ea4b$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        return $b428e590a835ea4b$var$ci().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $b428e590a835ea4b$var$qi(!1), b = a[0];
        a = $b428e590a835ea4b$var$Ei.bind(null, a[1]);
        $b428e590a835ea4b$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $b428e590a835ea4b$var$N, e = $b428e590a835ea4b$var$ci();
        if ($b428e590a835ea4b$var$I) {
            if (void 0 === c) throw Error($b428e590a835ea4b$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b428e590a835ea4b$var$R) throw Error($b428e590a835ea4b$var$p(349));
            0 !== ($b428e590a835ea4b$var$Rh & 30) || $b428e590a835ea4b$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b428e590a835ea4b$var$vi($b428e590a835ea4b$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b428e590a835ea4b$var$li(9, $b428e590a835ea4b$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $b428e590a835ea4b$var$ci(), b = $b428e590a835ea4b$var$R.identifierPrefix;
        if ($b428e590a835ea4b$var$I) {
            var c = $b428e590a835ea4b$var$sg;
            var d = $b428e590a835ea4b$var$rg;
            c = (d & ~(1 << 32 - $b428e590a835ea4b$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b428e590a835ea4b$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b428e590a835ea4b$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b428e590a835ea4b$var$Zh = {
    readContext: $b428e590a835ea4b$var$Vg,
    useCallback: $b428e590a835ea4b$var$Bi,
    useContext: $b428e590a835ea4b$var$Vg,
    useEffect: $b428e590a835ea4b$var$ji,
    useImperativeHandle: $b428e590a835ea4b$var$zi,
    useInsertionEffect: $b428e590a835ea4b$var$wi,
    useLayoutEffect: $b428e590a835ea4b$var$xi,
    useMemo: $b428e590a835ea4b$var$Ci,
    useReducer: $b428e590a835ea4b$var$fi,
    useRef: $b428e590a835ea4b$var$si,
    useState: function useState() {
        return $b428e590a835ea4b$var$fi($b428e590a835ea4b$var$ei);
    },
    useDebugValue: $b428e590a835ea4b$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $b428e590a835ea4b$var$di();
        return $b428e590a835ea4b$var$Di(b, $b428e590a835ea4b$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $b428e590a835ea4b$var$fi($b428e590a835ea4b$var$ei)[0], b = $b428e590a835ea4b$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b428e590a835ea4b$var$hi,
    useSyncExternalStore: $b428e590a835ea4b$var$ii,
    useId: $b428e590a835ea4b$var$Fi,
    unstable_isNewReconciler: !1
}, $b428e590a835ea4b$var$$h = {
    readContext: $b428e590a835ea4b$var$Vg,
    useCallback: $b428e590a835ea4b$var$Bi,
    useContext: $b428e590a835ea4b$var$Vg,
    useEffect: $b428e590a835ea4b$var$ji,
    useImperativeHandle: $b428e590a835ea4b$var$zi,
    useInsertionEffect: $b428e590a835ea4b$var$wi,
    useLayoutEffect: $b428e590a835ea4b$var$xi,
    useMemo: $b428e590a835ea4b$var$Ci,
    useReducer: $b428e590a835ea4b$var$gi,
    useRef: $b428e590a835ea4b$var$si,
    useState: function useState() {
        return $b428e590a835ea4b$var$gi($b428e590a835ea4b$var$ei);
    },
    useDebugValue: $b428e590a835ea4b$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $b428e590a835ea4b$var$di();
        return null === $b428e590a835ea4b$var$O ? b.memoizedState = a : $b428e590a835ea4b$var$Di(b, $b428e590a835ea4b$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $b428e590a835ea4b$var$gi($b428e590a835ea4b$var$ei)[0], b = $b428e590a835ea4b$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b428e590a835ea4b$var$hi,
    useSyncExternalStore: $b428e590a835ea4b$var$ii,
    useId: $b428e590a835ea4b$var$Fi,
    unstable_isNewReconciler: !1
};
function $b428e590a835ea4b$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $b428e590a835ea4b$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b428e590a835ea4b$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b428e590a835ea4b$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b428e590a835ea4b$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $b428e590a835ea4b$var$Oi(a, b, c) {
    c = $b428e590a835ea4b$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b428e590a835ea4b$var$Pi || ($b428e590a835ea4b$var$Pi = !0, $b428e590a835ea4b$var$Qi = d);
        $b428e590a835ea4b$var$Mi(a, b);
    };
    return c;
}
function $b428e590a835ea4b$var$Ri(a, b, c) {
    c = $b428e590a835ea4b$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b428e590a835ea4b$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b428e590a835ea4b$var$Mi(a, b);
        "function" !== typeof d && (null === $b428e590a835ea4b$var$Si ? $b428e590a835ea4b$var$Si = new Set([
            this
        ]) : $b428e590a835ea4b$var$Si.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $b428e590a835ea4b$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b428e590a835ea4b$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b428e590a835ea4b$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $b428e590a835ea4b$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b428e590a835ea4b$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b428e590a835ea4b$var$ch(-1, 1), b.tag = 2, $b428e590a835ea4b$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b428e590a835ea4b$var$Xi = $b428e590a835ea4b$var$ua.ReactCurrentOwner, $b428e590a835ea4b$var$Ug = !1;
function $b428e590a835ea4b$var$Yi(a, b, c, d) {
    b.child = null === a ? $b428e590a835ea4b$var$Ch(b, null, c, d) : $b428e590a835ea4b$var$Bh(b, a.child, c, d);
}
function $b428e590a835ea4b$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b428e590a835ea4b$var$Tg(b, e);
    d = $b428e590a835ea4b$var$Xh(a, b, c, d, f, e);
    c = $b428e590a835ea4b$var$bi();
    if (null !== a && !$b428e590a835ea4b$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b428e590a835ea4b$var$$i(a, b, e);
    $b428e590a835ea4b$var$I && c && $b428e590a835ea4b$var$vg(b);
    b.flags |= 1;
    $b428e590a835ea4b$var$Yi(a, b, d, e);
    return b.child;
}
function $b428e590a835ea4b$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b428e590a835ea4b$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b428e590a835ea4b$var$cj(a, b, f, d, e);
        a = $b428e590a835ea4b$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b428e590a835ea4b$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b428e590a835ea4b$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $b428e590a835ea4b$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b428e590a835ea4b$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b428e590a835ea4b$var$Ie(f, d) && a.ref === b.ref) {
            if ($b428e590a835ea4b$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b428e590a835ea4b$var$Ug = !0);
            else return b.lanes = a.lanes, $b428e590a835ea4b$var$$i(a, b, e);
        }
    }
    return $b428e590a835ea4b$var$dj(a, b, c, d, e);
}
function $b428e590a835ea4b$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b428e590a835ea4b$var$G($b428e590a835ea4b$var$fj, $b428e590a835ea4b$var$gj), $b428e590a835ea4b$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b428e590a835ea4b$var$G($b428e590a835ea4b$var$fj, $b428e590a835ea4b$var$gj), $b428e590a835ea4b$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b428e590a835ea4b$var$G($b428e590a835ea4b$var$fj, $b428e590a835ea4b$var$gj);
            $b428e590a835ea4b$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b428e590a835ea4b$var$G($b428e590a835ea4b$var$fj, $b428e590a835ea4b$var$gj), $b428e590a835ea4b$var$gj |= d;
    $b428e590a835ea4b$var$Yi(a, b, e, c);
    return b.child;
}
function $b428e590a835ea4b$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b428e590a835ea4b$var$dj(a, b, c, d, e) {
    var f = $b428e590a835ea4b$var$Zf(c) ? $b428e590a835ea4b$var$Xf : $b428e590a835ea4b$var$H.current;
    f = $b428e590a835ea4b$var$Yf(b, f);
    $b428e590a835ea4b$var$Tg(b, e);
    c = $b428e590a835ea4b$var$Xh(a, b, c, d, f, e);
    d = $b428e590a835ea4b$var$bi();
    if (null !== a && !$b428e590a835ea4b$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b428e590a835ea4b$var$$i(a, b, e);
    $b428e590a835ea4b$var$I && d && $b428e590a835ea4b$var$vg(b);
    b.flags |= 1;
    $b428e590a835ea4b$var$Yi(a, b, c, e);
    return b.child;
}
function $b428e590a835ea4b$var$ij(a, b, c, d, e) {
    if ($b428e590a835ea4b$var$Zf(c)) {
        var f = !0;
        $b428e590a835ea4b$var$cg(b);
    } else f = !1;
    $b428e590a835ea4b$var$Tg(b, e);
    if (null === b.stateNode) $b428e590a835ea4b$var$jj(a, b), $b428e590a835ea4b$var$ph(b, c, d), $b428e590a835ea4b$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b428e590a835ea4b$var$Vg(l) : (l = $b428e590a835ea4b$var$Zf(c) ? $b428e590a835ea4b$var$Xf : $b428e590a835ea4b$var$H.current, l = $b428e590a835ea4b$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b428e590a835ea4b$var$qh(b, g, d, l);
        $b428e590a835ea4b$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $b428e590a835ea4b$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b428e590a835ea4b$var$Wf.current || $b428e590a835ea4b$var$$g ? ("function" === typeof m && ($b428e590a835ea4b$var$kh(b, c, m, d), k = b.memoizedState), (h = $b428e590a835ea4b$var$$g || $b428e590a835ea4b$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b428e590a835ea4b$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b428e590a835ea4b$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b428e590a835ea4b$var$Vg(k) : (k = $b428e590a835ea4b$var$Zf(c) ? $b428e590a835ea4b$var$Xf : $b428e590a835ea4b$var$H.current, k = $b428e590a835ea4b$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b428e590a835ea4b$var$qh(b, g, d, k);
        $b428e590a835ea4b$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $b428e590a835ea4b$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b428e590a835ea4b$var$Wf.current || $b428e590a835ea4b$var$$g ? ("function" === typeof y && ($b428e590a835ea4b$var$kh(b, c, y, d), n = b.memoizedState), (l = $b428e590a835ea4b$var$$g || $b428e590a835ea4b$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b428e590a835ea4b$var$kj(a, b, c, d, f, e);
}
function $b428e590a835ea4b$var$kj(a, b, c, d, e, f) {
    $b428e590a835ea4b$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b428e590a835ea4b$var$dg(b, c, !1), $b428e590a835ea4b$var$$i(a, b, f);
    d = b.stateNode;
    $b428e590a835ea4b$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b428e590a835ea4b$var$Bh(b, a.child, null, f), b.child = $b428e590a835ea4b$var$Bh(b, null, h, f)) : $b428e590a835ea4b$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b428e590a835ea4b$var$dg(b, c, !0);
    return b.child;
}
function $b428e590a835ea4b$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b428e590a835ea4b$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b428e590a835ea4b$var$ag(a, b.context, !1);
    $b428e590a835ea4b$var$Ih(a, b.containerInfo);
}
function $b428e590a835ea4b$var$mj(a, b, c, d, e) {
    $b428e590a835ea4b$var$Ig();
    $b428e590a835ea4b$var$Jg(e);
    b.flags |= 256;
    $b428e590a835ea4b$var$Yi(a, b, c, d);
    return b.child;
}
var $b428e590a835ea4b$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b428e590a835ea4b$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b428e590a835ea4b$var$pj(a, b, c) {
    var d = b.pendingProps, e = $b428e590a835ea4b$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$M, e & 1);
    if (null === a) {
        $b428e590a835ea4b$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b428e590a835ea4b$var$qj(g, d, 0, null), a = $b428e590a835ea4b$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b428e590a835ea4b$var$oj(c), b.memoizedState = $b428e590a835ea4b$var$nj, a) : $b428e590a835ea4b$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b428e590a835ea4b$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b428e590a835ea4b$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b428e590a835ea4b$var$wh(h, f) : (f = $b428e590a835ea4b$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b428e590a835ea4b$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b428e590a835ea4b$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b428e590a835ea4b$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b428e590a835ea4b$var$rj(a, b) {
    b = $b428e590a835ea4b$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b428e590a835ea4b$var$tj(a, b, c, d) {
    null !== d && $b428e590a835ea4b$var$Jg(d);
    $b428e590a835ea4b$var$Bh(b, a.child, null, c);
    a = $b428e590a835ea4b$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b428e590a835ea4b$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b428e590a835ea4b$var$Li(Error($b428e590a835ea4b$var$p(422))), $b428e590a835ea4b$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b428e590a835ea4b$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b428e590a835ea4b$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b428e590a835ea4b$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $b428e590a835ea4b$var$oj(g);
        b.memoizedState = $b428e590a835ea4b$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b428e590a835ea4b$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b428e590a835ea4b$var$p(419));
        d = $b428e590a835ea4b$var$Li(f, d, void 0);
        return $b428e590a835ea4b$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b428e590a835ea4b$var$Ug || h) {
        d = $b428e590a835ea4b$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b428e590a835ea4b$var$Zg(a, e), $b428e590a835ea4b$var$mh(d, a, e, -1));
        }
        $b428e590a835ea4b$var$uj();
        d = $b428e590a835ea4b$var$Li(Error($b428e590a835ea4b$var$p(421)));
        return $b428e590a835ea4b$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b428e590a835ea4b$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b428e590a835ea4b$var$yg = $b428e590a835ea4b$var$Lf(e.nextSibling);
    $b428e590a835ea4b$var$xg = b;
    $b428e590a835ea4b$var$I = !0;
    $b428e590a835ea4b$var$zg = null;
    null !== a && ($b428e590a835ea4b$var$og[$b428e590a835ea4b$var$pg++] = $b428e590a835ea4b$var$rg, $b428e590a835ea4b$var$og[$b428e590a835ea4b$var$pg++] = $b428e590a835ea4b$var$sg, $b428e590a835ea4b$var$og[$b428e590a835ea4b$var$pg++] = $b428e590a835ea4b$var$qg, $b428e590a835ea4b$var$rg = a.id, $b428e590a835ea4b$var$sg = a.overflow, $b428e590a835ea4b$var$qg = b);
    b = $b428e590a835ea4b$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b428e590a835ea4b$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b428e590a835ea4b$var$Sg(a.return, b, c);
}
function $b428e590a835ea4b$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b428e590a835ea4b$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b428e590a835ea4b$var$Yi(a, b, d.children, c);
    d = $b428e590a835ea4b$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b428e590a835ea4b$var$wj(a, c, b);
            else if (19 === a.tag) $b428e590a835ea4b$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b428e590a835ea4b$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b428e590a835ea4b$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b428e590a835ea4b$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b428e590a835ea4b$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $b428e590a835ea4b$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b428e590a835ea4b$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b428e590a835ea4b$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b428e590a835ea4b$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b428e590a835ea4b$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b428e590a835ea4b$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b428e590a835ea4b$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b428e590a835ea4b$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $b428e590a835ea4b$var$lj(b);
            $b428e590a835ea4b$var$Ig();
            break;
        case 5:
            $b428e590a835ea4b$var$Kh(b);
            break;
        case 1:
            $b428e590a835ea4b$var$Zf(b.type) && $b428e590a835ea4b$var$cg(b);
            break;
        case 4:
            $b428e590a835ea4b$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b428e590a835ea4b$var$G($b428e590a835ea4b$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b428e590a835ea4b$var$G($b428e590a835ea4b$var$M, $b428e590a835ea4b$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b428e590a835ea4b$var$pj(a, b, c);
                $b428e590a835ea4b$var$G($b428e590a835ea4b$var$M, $b428e590a835ea4b$var$M.current & 1);
                a = $b428e590a835ea4b$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b428e590a835ea4b$var$G($b428e590a835ea4b$var$M, $b428e590a835ea4b$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b428e590a835ea4b$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b428e590a835ea4b$var$G($b428e590a835ea4b$var$M, $b428e590a835ea4b$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b428e590a835ea4b$var$ej(a, b, c);
    }
    return $b428e590a835ea4b$var$$i(a, b, c);
}
var $b428e590a835ea4b$var$Aj, $b428e590a835ea4b$var$Bj, $b428e590a835ea4b$var$Cj, $b428e590a835ea4b$var$Dj;
$b428e590a835ea4b$var$Aj = function Aj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b428e590a835ea4b$var$Bj = function Bj() {};
$b428e590a835ea4b$var$Cj = function Cj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b428e590a835ea4b$var$Hh($b428e590a835ea4b$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b428e590a835ea4b$var$Ya(a, e);
                d = $b428e590a835ea4b$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b428e590a835ea4b$var$A({}, e, {
                    value: void 0
                });
                d = $b428e590a835ea4b$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b428e590a835ea4b$var$gb(a, e);
                d = $b428e590a835ea4b$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b428e590a835ea4b$var$Bf);
        }
        $b428e590a835ea4b$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b428e590a835ea4b$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b428e590a835ea4b$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b428e590a835ea4b$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b428e590a835ea4b$var$Dj = function Dj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b428e590a835ea4b$var$Ej(a, b) {
    if (!$b428e590a835ea4b$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b428e590a835ea4b$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b428e590a835ea4b$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $b428e590a835ea4b$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b428e590a835ea4b$var$S(b), null;
        case 1:
            return $b428e590a835ea4b$var$Zf(b.type) && $b428e590a835ea4b$var$$f(), $b428e590a835ea4b$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b428e590a835ea4b$var$Jh();
            $b428e590a835ea4b$var$E($b428e590a835ea4b$var$Wf);
            $b428e590a835ea4b$var$E($b428e590a835ea4b$var$H);
            $b428e590a835ea4b$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b428e590a835ea4b$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b428e590a835ea4b$var$zg && ($b428e590a835ea4b$var$Gj($b428e590a835ea4b$var$zg), $b428e590a835ea4b$var$zg = null));
            $b428e590a835ea4b$var$Bj(a, b);
            $b428e590a835ea4b$var$S(b);
            return null;
        case 5:
            $b428e590a835ea4b$var$Lh(b);
            var e = $b428e590a835ea4b$var$Hh($b428e590a835ea4b$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b428e590a835ea4b$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b428e590a835ea4b$var$p(166));
                    $b428e590a835ea4b$var$S(b);
                    return null;
                }
                a = $b428e590a835ea4b$var$Hh($b428e590a835ea4b$var$Eh.current);
                if ($b428e590a835ea4b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b428e590a835ea4b$var$Of] = b;
                    d[$b428e590a835ea4b$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b428e590a835ea4b$var$D("cancel", d);
                            $b428e590a835ea4b$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b428e590a835ea4b$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b428e590a835ea4b$var$lf.length; e++)$b428e590a835ea4b$var$D($b428e590a835ea4b$var$lf[e], d);
                            break;
                        case "source":
                            $b428e590a835ea4b$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b428e590a835ea4b$var$D("error", d);
                            $b428e590a835ea4b$var$D("load", d);
                            break;
                        case "details":
                            $b428e590a835ea4b$var$D("toggle", d);
                            break;
                        case "input":
                            $b428e590a835ea4b$var$Za(d, f);
                            $b428e590a835ea4b$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b428e590a835ea4b$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b428e590a835ea4b$var$hb(d, f), $b428e590a835ea4b$var$D("invalid", d);
                    }
                    $b428e590a835ea4b$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b428e590a835ea4b$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b428e590a835ea4b$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b428e590a835ea4b$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b428e590a835ea4b$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b428e590a835ea4b$var$Va(d);
                            $b428e590a835ea4b$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b428e590a835ea4b$var$Va(d);
                            $b428e590a835ea4b$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b428e590a835ea4b$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b428e590a835ea4b$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b428e590a835ea4b$var$Of] = b;
                    a[$b428e590a835ea4b$var$Pf] = d;
                    $b428e590a835ea4b$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b428e590a835ea4b$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b428e590a835ea4b$var$D("cancel", a);
                                $b428e590a835ea4b$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b428e590a835ea4b$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b428e590a835ea4b$var$lf.length; e++)$b428e590a835ea4b$var$D($b428e590a835ea4b$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b428e590a835ea4b$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b428e590a835ea4b$var$D("error", a);
                                $b428e590a835ea4b$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b428e590a835ea4b$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b428e590a835ea4b$var$Za(a, d);
                                e = $b428e590a835ea4b$var$Ya(a, d);
                                $b428e590a835ea4b$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b428e590a835ea4b$var$A({}, d, {
                                    value: void 0
                                });
                                $b428e590a835ea4b$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b428e590a835ea4b$var$hb(a, d);
                                e = $b428e590a835ea4b$var$gb(a, d);
                                $b428e590a835ea4b$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b428e590a835ea4b$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b428e590a835ea4b$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b428e590a835ea4b$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b428e590a835ea4b$var$ob(a, k) : "number" === typeof k && $b428e590a835ea4b$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b428e590a835ea4b$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b428e590a835ea4b$var$D("scroll", a) : null != k && $b428e590a835ea4b$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b428e590a835ea4b$var$Va(a);
                                $b428e590a835ea4b$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b428e590a835ea4b$var$Va(a);
                                $b428e590a835ea4b$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b428e590a835ea4b$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b428e590a835ea4b$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b428e590a835ea4b$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b428e590a835ea4b$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b428e590a835ea4b$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b428e590a835ea4b$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b428e590a835ea4b$var$p(166));
                c = $b428e590a835ea4b$var$Hh($b428e590a835ea4b$var$Gh.current);
                $b428e590a835ea4b$var$Hh($b428e590a835ea4b$var$Eh.current);
                if ($b428e590a835ea4b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b428e590a835ea4b$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b428e590a835ea4b$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b428e590a835ea4b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b428e590a835ea4b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b428e590a835ea4b$var$Of] = b, b.stateNode = d;
            }
            $b428e590a835ea4b$var$S(b);
            return null;
        case 13:
            $b428e590a835ea4b$var$E($b428e590a835ea4b$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b428e590a835ea4b$var$I && null !== $b428e590a835ea4b$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b428e590a835ea4b$var$Hg(), $b428e590a835ea4b$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b428e590a835ea4b$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b428e590a835ea4b$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b428e590a835ea4b$var$p(317));
                        f[$b428e590a835ea4b$var$Of] = b;
                    } else $b428e590a835ea4b$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b428e590a835ea4b$var$S(b);
                    f = !1;
                } else null !== $b428e590a835ea4b$var$zg && ($b428e590a835ea4b$var$Gj($b428e590a835ea4b$var$zg), $b428e590a835ea4b$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b428e590a835ea4b$var$M.current & 1) ? 0 === $b428e590a835ea4b$var$T && ($b428e590a835ea4b$var$T = 3) : $b428e590a835ea4b$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b428e590a835ea4b$var$S(b);
            return null;
        case 4:
            return $b428e590a835ea4b$var$Jh(), $b428e590a835ea4b$var$Bj(a, b), null === a && $b428e590a835ea4b$var$sf(b.stateNode.containerInfo), $b428e590a835ea4b$var$S(b), null;
        case 10:
            return $b428e590a835ea4b$var$Rg(b.type._context), $b428e590a835ea4b$var$S(b), null;
        case 17:
            return $b428e590a835ea4b$var$Zf(b.type) && $b428e590a835ea4b$var$$f(), $b428e590a835ea4b$var$S(b), null;
        case 19:
            $b428e590a835ea4b$var$E($b428e590a835ea4b$var$M);
            f = b.memoizedState;
            if (null === f) return $b428e590a835ea4b$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b428e590a835ea4b$var$Ej(f, !1);
                else {
                    if (0 !== $b428e590a835ea4b$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b428e590a835ea4b$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b428e590a835ea4b$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b428e590a835ea4b$var$G($b428e590a835ea4b$var$M, $b428e590a835ea4b$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b428e590a835ea4b$var$B() > $b428e590a835ea4b$var$Hj && (b.flags |= 128, d = !0, $b428e590a835ea4b$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b428e590a835ea4b$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b428e590a835ea4b$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b428e590a835ea4b$var$I) return $b428e590a835ea4b$var$S(b), null;
                    } else 2 * $b428e590a835ea4b$var$B() - f.renderingStartTime > $b428e590a835ea4b$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $b428e590a835ea4b$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b428e590a835ea4b$var$B(), b.sibling = null, c = $b428e590a835ea4b$var$M.current, $b428e590a835ea4b$var$G($b428e590a835ea4b$var$M, d ? c & 1 | 2 : c & 1), b;
            $b428e590a835ea4b$var$S(b);
            return null;
        case 22:
        case 23:
            return $b428e590a835ea4b$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b428e590a835ea4b$var$gj & 1073741824) && ($b428e590a835ea4b$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b428e590a835ea4b$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b428e590a835ea4b$var$p(156, b.tag));
}
function $b428e590a835ea4b$var$Jj(a, b) {
    $b428e590a835ea4b$var$wg(b);
    switch(b.tag){
        case 1:
            return $b428e590a835ea4b$var$Zf(b.type) && $b428e590a835ea4b$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b428e590a835ea4b$var$Jh(), $b428e590a835ea4b$var$E($b428e590a835ea4b$var$Wf), $b428e590a835ea4b$var$E($b428e590a835ea4b$var$H), $b428e590a835ea4b$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b428e590a835ea4b$var$Lh(b), null;
        case 13:
            $b428e590a835ea4b$var$E($b428e590a835ea4b$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b428e590a835ea4b$var$p(340));
                $b428e590a835ea4b$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b428e590a835ea4b$var$E($b428e590a835ea4b$var$M), null;
        case 4:
            return $b428e590a835ea4b$var$Jh(), null;
        case 10:
            return $b428e590a835ea4b$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $b428e590a835ea4b$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b428e590a835ea4b$var$Kj = !1, $b428e590a835ea4b$var$U = !1, $b428e590a835ea4b$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $b428e590a835ea4b$var$V = null;
function $b428e590a835ea4b$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b428e590a835ea4b$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b428e590a835ea4b$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b428e590a835ea4b$var$W(a, b, d);
    }
}
var $b428e590a835ea4b$var$Oj = !1;
function $b428e590a835ea4b$var$Pj(a, b) {
    $b428e590a835ea4b$var$Cf = $b428e590a835ea4b$var$dd;
    a = $b428e590a835ea4b$var$Me();
    if ($b428e590a835ea4b$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b428e590a835ea4b$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b428e590a835ea4b$var$dd = !1;
    for($b428e590a835ea4b$var$V = b; null !== $b428e590a835ea4b$var$V;)if (b = $b428e590a835ea4b$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b428e590a835ea4b$var$V = a;
    else for(; null !== $b428e590a835ea4b$var$V;){
        b = $b428e590a835ea4b$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b428e590a835ea4b$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b428e590a835ea4b$var$p(163));
            }
        } catch (F) {
            $b428e590a835ea4b$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b428e590a835ea4b$var$V = a;
            break;
        }
        $b428e590a835ea4b$var$V = b.return;
    }
    n = $b428e590a835ea4b$var$Oj;
    $b428e590a835ea4b$var$Oj = !1;
    return n;
}
function $b428e590a835ea4b$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b428e590a835ea4b$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b428e590a835ea4b$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b428e590a835ea4b$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b428e590a835ea4b$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b428e590a835ea4b$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b428e590a835ea4b$var$Of], delete b[$b428e590a835ea4b$var$Pf], delete b[$b428e590a835ea4b$var$of], delete b[$b428e590a835ea4b$var$Qf], delete b[$b428e590a835ea4b$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b428e590a835ea4b$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b428e590a835ea4b$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b428e590a835ea4b$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b428e590a835ea4b$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b428e590a835ea4b$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b428e590a835ea4b$var$Wj(a, b, c), a = a.sibling; null !== a;)$b428e590a835ea4b$var$Wj(a, b, c), a = a.sibling;
}
function $b428e590a835ea4b$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b428e590a835ea4b$var$Xj(a, b, c), a = a.sibling; null !== a;)$b428e590a835ea4b$var$Xj(a, b, c), a = a.sibling;
}
var $b428e590a835ea4b$var$X = null, $b428e590a835ea4b$var$Yj = !1;
function $b428e590a835ea4b$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$b428e590a835ea4b$var$ak(a, b, c), c = c.sibling;
}
function $b428e590a835ea4b$var$ak(a, b, c) {
    if ($b428e590a835ea4b$var$lc && "function" === typeof $b428e590a835ea4b$var$lc.onCommitFiberUnmount) try {
        $b428e590a835ea4b$var$lc.onCommitFiberUnmount($b428e590a835ea4b$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b428e590a835ea4b$var$U || $b428e590a835ea4b$var$Mj(c, b);
        case 6:
            var d = $b428e590a835ea4b$var$X, e = $b428e590a835ea4b$var$Yj;
            $b428e590a835ea4b$var$X = null;
            $b428e590a835ea4b$var$Zj(a, b, c);
            $b428e590a835ea4b$var$X = d;
            $b428e590a835ea4b$var$Yj = e;
            null !== $b428e590a835ea4b$var$X && ($b428e590a835ea4b$var$Yj ? (a = $b428e590a835ea4b$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b428e590a835ea4b$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b428e590a835ea4b$var$X && ($b428e590a835ea4b$var$Yj ? (a = $b428e590a835ea4b$var$X, c = c.stateNode, 8 === a.nodeType ? $b428e590a835ea4b$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b428e590a835ea4b$var$Kf(a, c), $b428e590a835ea4b$var$bd(a)) : $b428e590a835ea4b$var$Kf($b428e590a835ea4b$var$X, c.stateNode));
            break;
        case 4:
            d = $b428e590a835ea4b$var$X;
            e = $b428e590a835ea4b$var$Yj;
            $b428e590a835ea4b$var$X = c.stateNode.containerInfo;
            $b428e590a835ea4b$var$Yj = !0;
            $b428e590a835ea4b$var$Zj(a, b, c);
            $b428e590a835ea4b$var$X = d;
            $b428e590a835ea4b$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b428e590a835ea4b$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b428e590a835ea4b$var$Nj(c, b, g) : 0 !== (f & 4) && $b428e590a835ea4b$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b428e590a835ea4b$var$Zj(a, b, c);
            break;
        case 1:
            if (!$b428e590a835ea4b$var$U && ($b428e590a835ea4b$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b428e590a835ea4b$var$W(c, b, h);
            }
            $b428e590a835ea4b$var$Zj(a, b, c);
            break;
        case 21:
            $b428e590a835ea4b$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b428e590a835ea4b$var$U = (d = $b428e590a835ea4b$var$U) || null !== c.memoizedState, $b428e590a835ea4b$var$Zj(a, b, c), $b428e590a835ea4b$var$U = d) : $b428e590a835ea4b$var$Zj(a, b, c);
            break;
        default:
            $b428e590a835ea4b$var$Zj(a, b, c);
    }
}
function $b428e590a835ea4b$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b428e590a835ea4b$var$Lj);
        b.forEach(function(b) {
            var d = $b428e590a835ea4b$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b428e590a835ea4b$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b428e590a835ea4b$var$X = h.stateNode;
                        $b428e590a835ea4b$var$Yj = !1;
                        break a;
                    case 3:
                        $b428e590a835ea4b$var$X = h.stateNode.containerInfo;
                        $b428e590a835ea4b$var$Yj = !0;
                        break a;
                    case 4:
                        $b428e590a835ea4b$var$X = h.stateNode.containerInfo;
                        $b428e590a835ea4b$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b428e590a835ea4b$var$X) throw Error($b428e590a835ea4b$var$p(160));
            $b428e590a835ea4b$var$ak(f, g, e);
            $b428e590a835ea4b$var$X = null;
            $b428e590a835ea4b$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b428e590a835ea4b$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b428e590a835ea4b$var$ek(b, a), b = b.sibling;
}
function $b428e590a835ea4b$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b428e590a835ea4b$var$dk(b, a);
            $b428e590a835ea4b$var$fk(a);
            if (d & 4) {
                try {
                    $b428e590a835ea4b$var$Qj(3, a, a.return), $b428e590a835ea4b$var$Rj(3, a);
                } catch (t) {
                    $b428e590a835ea4b$var$W(a, a.return, t);
                }
                try {
                    $b428e590a835ea4b$var$Qj(5, a, a.return);
                } catch (t) {
                    $b428e590a835ea4b$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b428e590a835ea4b$var$dk(b, a);
            $b428e590a835ea4b$var$fk(a);
            d & 512 && null !== c && $b428e590a835ea4b$var$Mj(c, c.return);
            break;
        case 5:
            $b428e590a835ea4b$var$dk(b, a);
            $b428e590a835ea4b$var$fk(a);
            d & 512 && null !== c && $b428e590a835ea4b$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b428e590a835ea4b$var$ob(e, "");
                } catch (t) {
                    $b428e590a835ea4b$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b428e590a835ea4b$var$ab(e, f);
                    $b428e590a835ea4b$var$vb(h, g);
                    var l = $b428e590a835ea4b$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b428e590a835ea4b$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b428e590a835ea4b$var$nb(e, q) : "children" === m ? $b428e590a835ea4b$var$ob(e, q) : $b428e590a835ea4b$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b428e590a835ea4b$var$bb(e, f);
                            break;
                        case "textarea":
                            $b428e590a835ea4b$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b428e590a835ea4b$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b428e590a835ea4b$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b428e590a835ea4b$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b428e590a835ea4b$var$Pf] = f;
                } catch (t) {
                    $b428e590a835ea4b$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b428e590a835ea4b$var$dk(b, a);
            $b428e590a835ea4b$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b428e590a835ea4b$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b428e590a835ea4b$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b428e590a835ea4b$var$dk(b, a);
            $b428e590a835ea4b$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b428e590a835ea4b$var$bd(b.containerInfo);
            } catch (t) {
                $b428e590a835ea4b$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b428e590a835ea4b$var$dk(b, a);
            $b428e590a835ea4b$var$fk(a);
            break;
        case 13:
            $b428e590a835ea4b$var$dk(b, a);
            $b428e590a835ea4b$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b428e590a835ea4b$var$gk = $b428e590a835ea4b$var$B()));
            d & 4 && $b428e590a835ea4b$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b428e590a835ea4b$var$U = (l = $b428e590a835ea4b$var$U) || m, $b428e590a835ea4b$var$dk(b, a), $b428e590a835ea4b$var$U = l) : $b428e590a835ea4b$var$dk(b, a);
            $b428e590a835ea4b$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b428e590a835ea4b$var$V = a, m = a.child; null !== m;){
                    for(q = $b428e590a835ea4b$var$V = m; null !== $b428e590a835ea4b$var$V;){
                        r = $b428e590a835ea4b$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b428e590a835ea4b$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $b428e590a835ea4b$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b428e590a835ea4b$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b428e590a835ea4b$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b428e590a835ea4b$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b428e590a835ea4b$var$V = y) : $b428e590a835ea4b$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b428e590a835ea4b$var$rb("display", g));
                            } catch (t) {
                                $b428e590a835ea4b$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b428e590a835ea4b$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b428e590a835ea4b$var$dk(b, a);
            $b428e590a835ea4b$var$fk(a);
            d & 4 && $b428e590a835ea4b$var$bk(a);
            break;
        case 21:
            break;
        default:
            $b428e590a835ea4b$var$dk(b, a), $b428e590a835ea4b$var$fk(a);
    }
}
function $b428e590a835ea4b$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b428e590a835ea4b$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b428e590a835ea4b$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b428e590a835ea4b$var$ob(e, ""), d.flags &= -33);
                    var f = $b428e590a835ea4b$var$Vj(a);
                    $b428e590a835ea4b$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b428e590a835ea4b$var$Vj(a);
                    $b428e590a835ea4b$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($b428e590a835ea4b$var$p(161));
            }
        } catch (k) {
            $b428e590a835ea4b$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b428e590a835ea4b$var$ik(a, b, c) {
    $b428e590a835ea4b$var$V = a;
    $b428e590a835ea4b$var$jk(a, b, c);
}
function $b428e590a835ea4b$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b428e590a835ea4b$var$V;){
        var e = $b428e590a835ea4b$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b428e590a835ea4b$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b428e590a835ea4b$var$U;
                h = $b428e590a835ea4b$var$Kj;
                var l = $b428e590a835ea4b$var$U;
                $b428e590a835ea4b$var$Kj = g;
                if (($b428e590a835ea4b$var$U = k) && !l) for($b428e590a835ea4b$var$V = e; null !== $b428e590a835ea4b$var$V;)g = $b428e590a835ea4b$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b428e590a835ea4b$var$kk(e) : null !== k ? (k.return = g, $b428e590a835ea4b$var$V = k) : $b428e590a835ea4b$var$kk(e);
                for(; null !== f;)$b428e590a835ea4b$var$V = f, $b428e590a835ea4b$var$jk(f, b, c), f = f.sibling;
                $b428e590a835ea4b$var$V = e;
                $b428e590a835ea4b$var$Kj = h;
                $b428e590a835ea4b$var$U = l;
            }
            $b428e590a835ea4b$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b428e590a835ea4b$var$V = f) : $b428e590a835ea4b$var$lk(a, b, c);
    }
}
function $b428e590a835ea4b$var$lk(a) {
    for(; null !== $b428e590a835ea4b$var$V;){
        var b = $b428e590a835ea4b$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b428e590a835ea4b$var$U || $b428e590a835ea4b$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b428e590a835ea4b$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b428e590a835ea4b$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b428e590a835ea4b$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b428e590a835ea4b$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b428e590a835ea4b$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b428e590a835ea4b$var$p(163));
                }
                $b428e590a835ea4b$var$U || b.flags & 512 && $b428e590a835ea4b$var$Sj(b);
            } catch (r) {
                $b428e590a835ea4b$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b428e590a835ea4b$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b428e590a835ea4b$var$V = c;
            break;
        }
        $b428e590a835ea4b$var$V = b.return;
    }
}
function $b428e590a835ea4b$var$hk(a) {
    for(; null !== $b428e590a835ea4b$var$V;){
        var b = $b428e590a835ea4b$var$V;
        if (b === a) {
            $b428e590a835ea4b$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b428e590a835ea4b$var$V = c;
            break;
        }
        $b428e590a835ea4b$var$V = b.return;
    }
}
function $b428e590a835ea4b$var$kk(a) {
    for(; null !== $b428e590a835ea4b$var$V;){
        var b = $b428e590a835ea4b$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b428e590a835ea4b$var$Rj(4, b);
                    } catch (k) {
                        $b428e590a835ea4b$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b428e590a835ea4b$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b428e590a835ea4b$var$Sj(b);
                    } catch (k) {
                        $b428e590a835ea4b$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b428e590a835ea4b$var$Sj(b);
                    } catch (k) {
                        $b428e590a835ea4b$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b428e590a835ea4b$var$W(b, b.return, k);
        }
        if (b === a) {
            $b428e590a835ea4b$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b428e590a835ea4b$var$V = h;
            break;
        }
        $b428e590a835ea4b$var$V = b.return;
    }
}
var $b428e590a835ea4b$var$mk = Math.ceil, $b428e590a835ea4b$var$nk = $b428e590a835ea4b$var$ua.ReactCurrentDispatcher, $b428e590a835ea4b$var$ok = $b428e590a835ea4b$var$ua.ReactCurrentOwner, $b428e590a835ea4b$var$pk = $b428e590a835ea4b$var$ua.ReactCurrentBatchConfig, $b428e590a835ea4b$var$K = 0, $b428e590a835ea4b$var$R = null, $b428e590a835ea4b$var$Y = null, $b428e590a835ea4b$var$Z = 0, $b428e590a835ea4b$var$gj = 0, $b428e590a835ea4b$var$fj = $b428e590a835ea4b$var$Uf(0), $b428e590a835ea4b$var$T = 0, $b428e590a835ea4b$var$qk = null, $b428e590a835ea4b$var$hh = 0, $b428e590a835ea4b$var$rk = 0, $b428e590a835ea4b$var$sk = 0, $b428e590a835ea4b$var$tk = null, $b428e590a835ea4b$var$uk = null, $b428e590a835ea4b$var$gk = 0, $b428e590a835ea4b$var$Hj = Infinity, $b428e590a835ea4b$var$vk = null, $b428e590a835ea4b$var$Pi = !1, $b428e590a835ea4b$var$Qi = null, $b428e590a835ea4b$var$Si = null, $b428e590a835ea4b$var$wk = !1, $b428e590a835ea4b$var$xk = null, $b428e590a835ea4b$var$yk = 0, $b428e590a835ea4b$var$zk = 0, $b428e590a835ea4b$var$Ak = null, $b428e590a835ea4b$var$Bk = -1, $b428e590a835ea4b$var$Ck = 0;
function $b428e590a835ea4b$var$L() {
    return 0 !== ($b428e590a835ea4b$var$K & 6) ? $b428e590a835ea4b$var$B() : -1 !== $b428e590a835ea4b$var$Bk ? $b428e590a835ea4b$var$Bk : $b428e590a835ea4b$var$Bk = $b428e590a835ea4b$var$B();
}
function $b428e590a835ea4b$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b428e590a835ea4b$var$K & 2) && 0 !== $b428e590a835ea4b$var$Z) return $b428e590a835ea4b$var$Z & -$b428e590a835ea4b$var$Z;
    if (null !== $b428e590a835ea4b$var$Kg.transition) return 0 === $b428e590a835ea4b$var$Ck && ($b428e590a835ea4b$var$Ck = $b428e590a835ea4b$var$yc()), $b428e590a835ea4b$var$Ck;
    a = $b428e590a835ea4b$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b428e590a835ea4b$var$jd(a.type);
    return a;
}
function $b428e590a835ea4b$var$mh(a, b, c, d) {
    if (50 < $b428e590a835ea4b$var$zk) throw $b428e590a835ea4b$var$zk = 0, $b428e590a835ea4b$var$Ak = null, Error($b428e590a835ea4b$var$p(185));
    $b428e590a835ea4b$var$Ac(a, c, d);
    if (0 === ($b428e590a835ea4b$var$K & 2) || a !== $b428e590a835ea4b$var$R) a === $b428e590a835ea4b$var$R && (0 === ($b428e590a835ea4b$var$K & 2) && ($b428e590a835ea4b$var$rk |= c), 4 === $b428e590a835ea4b$var$T && $b428e590a835ea4b$var$Dk(a, $b428e590a835ea4b$var$Z)), $b428e590a835ea4b$var$Ek(a, d), 1 === c && 0 === $b428e590a835ea4b$var$K && 0 === (b.mode & 1) && ($b428e590a835ea4b$var$Hj = $b428e590a835ea4b$var$B() + 500, $b428e590a835ea4b$var$fg && $b428e590a835ea4b$var$jg());
}
function $b428e590a835ea4b$var$Ek(a, b) {
    var c = a.callbackNode;
    $b428e590a835ea4b$var$wc(a, b);
    var d = $b428e590a835ea4b$var$uc(a, a === $b428e590a835ea4b$var$R ? $b428e590a835ea4b$var$Z : 0);
    if (0 === d) null !== c && $b428e590a835ea4b$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b428e590a835ea4b$var$bc(c);
        if (1 === b) 0 === a.tag ? $b428e590a835ea4b$var$ig($b428e590a835ea4b$var$Fk.bind(null, a)) : $b428e590a835ea4b$var$hg($b428e590a835ea4b$var$Fk.bind(null, a)), $b428e590a835ea4b$var$Jf(function() {
            0 === ($b428e590a835ea4b$var$K & 6) && $b428e590a835ea4b$var$jg();
        }), c = null;
        else {
            switch($b428e590a835ea4b$var$Dc(d)){
                case 1:
                    c = $b428e590a835ea4b$var$fc;
                    break;
                case 4:
                    c = $b428e590a835ea4b$var$gc;
                    break;
                case 16:
                    c = $b428e590a835ea4b$var$hc;
                    break;
                case 536870912:
                    c = $b428e590a835ea4b$var$jc;
                    break;
                default:
                    c = $b428e590a835ea4b$var$hc;
            }
            c = $b428e590a835ea4b$var$Gk(c, $b428e590a835ea4b$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b428e590a835ea4b$var$Hk(a, b) {
    $b428e590a835ea4b$var$Bk = -1;
    $b428e590a835ea4b$var$Ck = 0;
    if (0 !== ($b428e590a835ea4b$var$K & 6)) throw Error($b428e590a835ea4b$var$p(327));
    var c = a.callbackNode;
    if ($b428e590a835ea4b$var$Ik() && a.callbackNode !== c) return null;
    var d = $b428e590a835ea4b$var$uc(a, a === $b428e590a835ea4b$var$R ? $b428e590a835ea4b$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b428e590a835ea4b$var$Jk(a, d);
    else {
        b = d;
        var e = $b428e590a835ea4b$var$K;
        $b428e590a835ea4b$var$K |= 2;
        var f = $b428e590a835ea4b$var$Kk();
        if ($b428e590a835ea4b$var$R !== a || $b428e590a835ea4b$var$Z !== b) $b428e590a835ea4b$var$vk = null, $b428e590a835ea4b$var$Hj = $b428e590a835ea4b$var$B() + 500, $b428e590a835ea4b$var$Lk(a, b);
        for(;;)try {
            $b428e590a835ea4b$var$Mk();
            break;
        } catch (h) {
            $b428e590a835ea4b$var$Nk(a, h);
        }
        $b428e590a835ea4b$var$Qg();
        $b428e590a835ea4b$var$nk.current = f;
        $b428e590a835ea4b$var$K = e;
        null !== $b428e590a835ea4b$var$Y ? b = 0 : ($b428e590a835ea4b$var$R = null, $b428e590a835ea4b$var$Z = 0, b = $b428e590a835ea4b$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b428e590a835ea4b$var$xc(a), 0 !== e && (d = e, b = $b428e590a835ea4b$var$Ok(a, e)));
        if (1 === b) throw c = $b428e590a835ea4b$var$qk, $b428e590a835ea4b$var$Lk(a, 0), $b428e590a835ea4b$var$Dk(a, d), $b428e590a835ea4b$var$Ek(a, $b428e590a835ea4b$var$B()), c;
        if (6 === b) $b428e590a835ea4b$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b428e590a835ea4b$var$Pk(e) && (b = $b428e590a835ea4b$var$Jk(a, d), 2 === b && (f = $b428e590a835ea4b$var$xc(a), 0 !== f && (d = f, b = $b428e590a835ea4b$var$Ok(a, f))), 1 === b)) throw c = $b428e590a835ea4b$var$qk, $b428e590a835ea4b$var$Lk(a, 0), $b428e590a835ea4b$var$Dk(a, d), $b428e590a835ea4b$var$Ek(a, $b428e590a835ea4b$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b428e590a835ea4b$var$p(345));
                case 2:
                    $b428e590a835ea4b$var$Qk(a, $b428e590a835ea4b$var$uk, $b428e590a835ea4b$var$vk);
                    break;
                case 3:
                    $b428e590a835ea4b$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $b428e590a835ea4b$var$gk + 500 - $b428e590a835ea4b$var$B(), 10 < b)) {
                        if (0 !== $b428e590a835ea4b$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b428e590a835ea4b$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b428e590a835ea4b$var$Ff($b428e590a835ea4b$var$Qk.bind(null, a, $b428e590a835ea4b$var$uk, $b428e590a835ea4b$var$vk), b);
                        break;
                    }
                    $b428e590a835ea4b$var$Qk(a, $b428e590a835ea4b$var$uk, $b428e590a835ea4b$var$vk);
                    break;
                case 4:
                    $b428e590a835ea4b$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b428e590a835ea4b$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b428e590a835ea4b$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b428e590a835ea4b$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b428e590a835ea4b$var$Ff($b428e590a835ea4b$var$Qk.bind(null, a, $b428e590a835ea4b$var$uk, $b428e590a835ea4b$var$vk), d);
                        break;
                    }
                    $b428e590a835ea4b$var$Qk(a, $b428e590a835ea4b$var$uk, $b428e590a835ea4b$var$vk);
                    break;
                case 5:
                    $b428e590a835ea4b$var$Qk(a, $b428e590a835ea4b$var$uk, $b428e590a835ea4b$var$vk);
                    break;
                default:
                    throw Error($b428e590a835ea4b$var$p(329));
            }
        }
    }
    $b428e590a835ea4b$var$Ek(a, $b428e590a835ea4b$var$B());
    return a.callbackNode === c ? $b428e590a835ea4b$var$Hk.bind(null, a) : null;
}
function $b428e590a835ea4b$var$Ok(a, b) {
    var c = $b428e590a835ea4b$var$tk;
    a.current.memoizedState.isDehydrated && ($b428e590a835ea4b$var$Lk(a, b).flags |= 256);
    a = $b428e590a835ea4b$var$Jk(a, b);
    2 !== a && (b = $b428e590a835ea4b$var$uk, $b428e590a835ea4b$var$uk = c, null !== b && $b428e590a835ea4b$var$Gj(b));
    return a;
}
function $b428e590a835ea4b$var$Gj(a) {
    null === $b428e590a835ea4b$var$uk ? $b428e590a835ea4b$var$uk = a : $b428e590a835ea4b$var$uk.push.apply($b428e590a835ea4b$var$uk, a);
}
function $b428e590a835ea4b$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b428e590a835ea4b$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b428e590a835ea4b$var$Dk(a, b) {
    b &= ~$b428e590a835ea4b$var$sk;
    b &= ~$b428e590a835ea4b$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b428e590a835ea4b$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b428e590a835ea4b$var$Fk(a) {
    if (0 !== ($b428e590a835ea4b$var$K & 6)) throw Error($b428e590a835ea4b$var$p(327));
    $b428e590a835ea4b$var$Ik();
    var b = $b428e590a835ea4b$var$uc(a, 0);
    if (0 === (b & 1)) return $b428e590a835ea4b$var$Ek(a, $b428e590a835ea4b$var$B()), null;
    var c = $b428e590a835ea4b$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b428e590a835ea4b$var$xc(a);
        0 !== d && (b = d, c = $b428e590a835ea4b$var$Ok(a, d));
    }
    if (1 === c) throw c = $b428e590a835ea4b$var$qk, $b428e590a835ea4b$var$Lk(a, 0), $b428e590a835ea4b$var$Dk(a, b), $b428e590a835ea4b$var$Ek(a, $b428e590a835ea4b$var$B()), c;
    if (6 === c) throw Error($b428e590a835ea4b$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b428e590a835ea4b$var$Qk(a, $b428e590a835ea4b$var$uk, $b428e590a835ea4b$var$vk);
    $b428e590a835ea4b$var$Ek(a, $b428e590a835ea4b$var$B());
    return null;
}
function $b428e590a835ea4b$var$Rk(a, b) {
    var c = $b428e590a835ea4b$var$K;
    $b428e590a835ea4b$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b428e590a835ea4b$var$K = c, 0 === $b428e590a835ea4b$var$K && ($b428e590a835ea4b$var$Hj = $b428e590a835ea4b$var$B() + 500, $b428e590a835ea4b$var$fg && $b428e590a835ea4b$var$jg());
    }
}
function $b428e590a835ea4b$var$Sk(a) {
    null !== $b428e590a835ea4b$var$xk && 0 === $b428e590a835ea4b$var$xk.tag && 0 === ($b428e590a835ea4b$var$K & 6) && $b428e590a835ea4b$var$Ik();
    var b = $b428e590a835ea4b$var$K;
    $b428e590a835ea4b$var$K |= 1;
    var c = $b428e590a835ea4b$var$pk.transition, d = $b428e590a835ea4b$var$C;
    try {
        if ($b428e590a835ea4b$var$pk.transition = null, $b428e590a835ea4b$var$C = 1, a) return a();
    } finally{
        $b428e590a835ea4b$var$C = d, $b428e590a835ea4b$var$pk.transition = c, $b428e590a835ea4b$var$K = b, 0 === ($b428e590a835ea4b$var$K & 6) && $b428e590a835ea4b$var$jg();
    }
}
function $b428e590a835ea4b$var$Ij() {
    $b428e590a835ea4b$var$gj = $b428e590a835ea4b$var$fj.current;
    $b428e590a835ea4b$var$E($b428e590a835ea4b$var$fj);
}
function $b428e590a835ea4b$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b428e590a835ea4b$var$Gf(c));
    if (null !== $b428e590a835ea4b$var$Y) for(c = $b428e590a835ea4b$var$Y.return; null !== c;){
        var d = c;
        $b428e590a835ea4b$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b428e590a835ea4b$var$$f();
                break;
            case 3:
                $b428e590a835ea4b$var$Jh();
                $b428e590a835ea4b$var$E($b428e590a835ea4b$var$Wf);
                $b428e590a835ea4b$var$E($b428e590a835ea4b$var$H);
                $b428e590a835ea4b$var$Oh();
                break;
            case 5:
                $b428e590a835ea4b$var$Lh(d);
                break;
            case 4:
                $b428e590a835ea4b$var$Jh();
                break;
            case 13:
                $b428e590a835ea4b$var$E($b428e590a835ea4b$var$M);
                break;
            case 19:
                $b428e590a835ea4b$var$E($b428e590a835ea4b$var$M);
                break;
            case 10:
                $b428e590a835ea4b$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $b428e590a835ea4b$var$Ij();
        }
        c = c.return;
    }
    $b428e590a835ea4b$var$R = a;
    $b428e590a835ea4b$var$Y = a = $b428e590a835ea4b$var$wh(a.current, null);
    $b428e590a835ea4b$var$Z = $b428e590a835ea4b$var$gj = b;
    $b428e590a835ea4b$var$T = 0;
    $b428e590a835ea4b$var$qk = null;
    $b428e590a835ea4b$var$sk = $b428e590a835ea4b$var$rk = $b428e590a835ea4b$var$hh = 0;
    $b428e590a835ea4b$var$uk = $b428e590a835ea4b$var$tk = null;
    if (null !== $b428e590a835ea4b$var$Wg) {
        for(b = 0; b < $b428e590a835ea4b$var$Wg.length; b++)if (c = $b428e590a835ea4b$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b428e590a835ea4b$var$Wg = null;
    }
    return a;
}
function $b428e590a835ea4b$var$Nk(a, b) {
    do {
        var c = $b428e590a835ea4b$var$Y;
        try {
            $b428e590a835ea4b$var$Qg();
            $b428e590a835ea4b$var$Ph.current = $b428e590a835ea4b$var$ai;
            if ($b428e590a835ea4b$var$Sh) {
                for(var d = $b428e590a835ea4b$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b428e590a835ea4b$var$Sh = !1;
            }
            $b428e590a835ea4b$var$Rh = 0;
            $b428e590a835ea4b$var$P = $b428e590a835ea4b$var$O = $b428e590a835ea4b$var$N = null;
            $b428e590a835ea4b$var$Th = !1;
            $b428e590a835ea4b$var$Uh = 0;
            $b428e590a835ea4b$var$ok.current = null;
            if (null === c || null === c.return) {
                $b428e590a835ea4b$var$T = 1;
                $b428e590a835ea4b$var$qk = b;
                $b428e590a835ea4b$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b428e590a835ea4b$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b428e590a835ea4b$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b428e590a835ea4b$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $b428e590a835ea4b$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b428e590a835ea4b$var$Ti(f, l, b);
                            $b428e590a835ea4b$var$uj();
                            break a;
                        }
                        k = Error($b428e590a835ea4b$var$p(426));
                    }
                } else if ($b428e590a835ea4b$var$I && h.mode & 1) {
                    var J = $b428e590a835ea4b$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b428e590a835ea4b$var$Wi(J, g, h, f, b);
                        $b428e590a835ea4b$var$Jg($b428e590a835ea4b$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $b428e590a835ea4b$var$Ki(k, h);
                4 !== $b428e590a835ea4b$var$T && ($b428e590a835ea4b$var$T = 2);
                null === $b428e590a835ea4b$var$tk ? $b428e590a835ea4b$var$tk = [
                    f
                ] : $b428e590a835ea4b$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b428e590a835ea4b$var$Oi(f, k, b);
                            $b428e590a835ea4b$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b428e590a835ea4b$var$Si || !$b428e590a835ea4b$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b428e590a835ea4b$var$Ri(f, h, b);
                                $b428e590a835ea4b$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b428e590a835ea4b$var$Tk(c);
        } catch (na) {
            b = na;
            $b428e590a835ea4b$var$Y === c && null !== c && ($b428e590a835ea4b$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b428e590a835ea4b$var$Kk() {
    var a = $b428e590a835ea4b$var$nk.current;
    $b428e590a835ea4b$var$nk.current = $b428e590a835ea4b$var$ai;
    return null === a ? $b428e590a835ea4b$var$ai : a;
}
function $b428e590a835ea4b$var$uj() {
    if (0 === $b428e590a835ea4b$var$T || 3 === $b428e590a835ea4b$var$T || 2 === $b428e590a835ea4b$var$T) $b428e590a835ea4b$var$T = 4;
    null === $b428e590a835ea4b$var$R || 0 === ($b428e590a835ea4b$var$hh & 268435455) && 0 === ($b428e590a835ea4b$var$rk & 268435455) || $b428e590a835ea4b$var$Dk($b428e590a835ea4b$var$R, $b428e590a835ea4b$var$Z);
}
function $b428e590a835ea4b$var$Jk(a, b) {
    var c = $b428e590a835ea4b$var$K;
    $b428e590a835ea4b$var$K |= 2;
    var d = $b428e590a835ea4b$var$Kk();
    if ($b428e590a835ea4b$var$R !== a || $b428e590a835ea4b$var$Z !== b) $b428e590a835ea4b$var$vk = null, $b428e590a835ea4b$var$Lk(a, b);
    for(;;)try {
        $b428e590a835ea4b$var$Uk();
        break;
    } catch (e) {
        $b428e590a835ea4b$var$Nk(a, e);
    }
    $b428e590a835ea4b$var$Qg();
    $b428e590a835ea4b$var$K = c;
    $b428e590a835ea4b$var$nk.current = d;
    if (null !== $b428e590a835ea4b$var$Y) throw Error($b428e590a835ea4b$var$p(261));
    $b428e590a835ea4b$var$R = null;
    $b428e590a835ea4b$var$Z = 0;
    return $b428e590a835ea4b$var$T;
}
function $b428e590a835ea4b$var$Uk() {
    for(; null !== $b428e590a835ea4b$var$Y;)$b428e590a835ea4b$var$Vk($b428e590a835ea4b$var$Y);
}
function $b428e590a835ea4b$var$Mk() {
    for(; null !== $b428e590a835ea4b$var$Y && !$b428e590a835ea4b$var$cc();)$b428e590a835ea4b$var$Vk($b428e590a835ea4b$var$Y);
}
function $b428e590a835ea4b$var$Vk(a) {
    var b = $b428e590a835ea4b$var$Wk(a.alternate, a, $b428e590a835ea4b$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b428e590a835ea4b$var$Tk(a) : $b428e590a835ea4b$var$Y = b;
    $b428e590a835ea4b$var$ok.current = null;
}
function $b428e590a835ea4b$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b428e590a835ea4b$var$Fj(c, b, $b428e590a835ea4b$var$gj), null !== c) {
                $b428e590a835ea4b$var$Y = c;
                return;
            }
        } else {
            c = $b428e590a835ea4b$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b428e590a835ea4b$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b428e590a835ea4b$var$T = 6;
                $b428e590a835ea4b$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b428e590a835ea4b$var$Y = b;
            return;
        }
        $b428e590a835ea4b$var$Y = b = a;
    }while (null !== b);
    0 === $b428e590a835ea4b$var$T && ($b428e590a835ea4b$var$T = 5);
}
function $b428e590a835ea4b$var$Qk(a, b, c) {
    var d = $b428e590a835ea4b$var$C, e = $b428e590a835ea4b$var$pk.transition;
    try {
        $b428e590a835ea4b$var$pk.transition = null, $b428e590a835ea4b$var$C = 1, $b428e590a835ea4b$var$Xk(a, b, c, d);
    } finally{
        $b428e590a835ea4b$var$pk.transition = e, $b428e590a835ea4b$var$C = d;
    }
    return null;
}
function $b428e590a835ea4b$var$Xk(a, b, c, d) {
    do $b428e590a835ea4b$var$Ik();
    while (null !== $b428e590a835ea4b$var$xk);
    if (0 !== ($b428e590a835ea4b$var$K & 6)) throw Error($b428e590a835ea4b$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b428e590a835ea4b$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b428e590a835ea4b$var$Bc(a, f);
    a === $b428e590a835ea4b$var$R && ($b428e590a835ea4b$var$Y = $b428e590a835ea4b$var$R = null, $b428e590a835ea4b$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b428e590a835ea4b$var$wk || ($b428e590a835ea4b$var$wk = !0, $b428e590a835ea4b$var$Gk($b428e590a835ea4b$var$hc, function() {
        $b428e590a835ea4b$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b428e590a835ea4b$var$pk.transition;
        $b428e590a835ea4b$var$pk.transition = null;
        var g = $b428e590a835ea4b$var$C;
        $b428e590a835ea4b$var$C = 1;
        var h = $b428e590a835ea4b$var$K;
        $b428e590a835ea4b$var$K |= 4;
        $b428e590a835ea4b$var$ok.current = null;
        $b428e590a835ea4b$var$Pj(a, c);
        $b428e590a835ea4b$var$ek(c, a);
        $b428e590a835ea4b$var$Oe($b428e590a835ea4b$var$Df);
        $b428e590a835ea4b$var$dd = !!$b428e590a835ea4b$var$Cf;
        $b428e590a835ea4b$var$Df = $b428e590a835ea4b$var$Cf = null;
        a.current = c;
        $b428e590a835ea4b$var$ik(c, a, e);
        $b428e590a835ea4b$var$dc();
        $b428e590a835ea4b$var$K = h;
        $b428e590a835ea4b$var$C = g;
        $b428e590a835ea4b$var$pk.transition = f;
    } else a.current = c;
    $b428e590a835ea4b$var$wk && ($b428e590a835ea4b$var$wk = !1, $b428e590a835ea4b$var$xk = a, $b428e590a835ea4b$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($b428e590a835ea4b$var$Si = null);
    $b428e590a835ea4b$var$mc(c.stateNode, d);
    $b428e590a835ea4b$var$Ek(a, $b428e590a835ea4b$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b428e590a835ea4b$var$Pi) throw $b428e590a835ea4b$var$Pi = !1, a = $b428e590a835ea4b$var$Qi, $b428e590a835ea4b$var$Qi = null, a;
    0 !== ($b428e590a835ea4b$var$yk & 1) && 0 !== a.tag && $b428e590a835ea4b$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b428e590a835ea4b$var$Ak ? $b428e590a835ea4b$var$zk++ : ($b428e590a835ea4b$var$zk = 0, $b428e590a835ea4b$var$Ak = a) : $b428e590a835ea4b$var$zk = 0;
    $b428e590a835ea4b$var$jg();
    return null;
}
function $b428e590a835ea4b$var$Ik() {
    if (null !== $b428e590a835ea4b$var$xk) {
        var a = $b428e590a835ea4b$var$Dc($b428e590a835ea4b$var$yk), b = $b428e590a835ea4b$var$pk.transition, c = $b428e590a835ea4b$var$C;
        try {
            $b428e590a835ea4b$var$pk.transition = null;
            $b428e590a835ea4b$var$C = 16 > a ? 16 : a;
            if (null === $b428e590a835ea4b$var$xk) var d = !1;
            else {
                a = $b428e590a835ea4b$var$xk;
                $b428e590a835ea4b$var$xk = null;
                $b428e590a835ea4b$var$yk = 0;
                if (0 !== ($b428e590a835ea4b$var$K & 6)) throw Error($b428e590a835ea4b$var$p(331));
                var e = $b428e590a835ea4b$var$K;
                $b428e590a835ea4b$var$K |= 4;
                for($b428e590a835ea4b$var$V = a.current; null !== $b428e590a835ea4b$var$V;){
                    var f = $b428e590a835ea4b$var$V, g = f.child;
                    if (0 !== ($b428e590a835ea4b$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b428e590a835ea4b$var$V = l; null !== $b428e590a835ea4b$var$V;){
                                    var m = $b428e590a835ea4b$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b428e590a835ea4b$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b428e590a835ea4b$var$V = q;
                                    else for(; null !== $b428e590a835ea4b$var$V;){
                                        m = $b428e590a835ea4b$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b428e590a835ea4b$var$Tj(m);
                                        if (m === l) {
                                            $b428e590a835ea4b$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b428e590a835ea4b$var$V = r;
                                            break;
                                        }
                                        $b428e590a835ea4b$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b428e590a835ea4b$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b428e590a835ea4b$var$V = g;
                    else b: for(; null !== $b428e590a835ea4b$var$V;){
                        f = $b428e590a835ea4b$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b428e590a835ea4b$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b428e590a835ea4b$var$V = x;
                            break b;
                        }
                        $b428e590a835ea4b$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b428e590a835ea4b$var$V = w; null !== $b428e590a835ea4b$var$V;){
                    g = $b428e590a835ea4b$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b428e590a835ea4b$var$V = u;
                    else b: for(g = w; null !== $b428e590a835ea4b$var$V;){
                        h = $b428e590a835ea4b$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b428e590a835ea4b$var$Rj(9, h);
                            }
                        } catch (na) {
                            $b428e590a835ea4b$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b428e590a835ea4b$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b428e590a835ea4b$var$V = F;
                            break b;
                        }
                        $b428e590a835ea4b$var$V = h.return;
                    }
                }
                $b428e590a835ea4b$var$K = e;
                $b428e590a835ea4b$var$jg();
                if ($b428e590a835ea4b$var$lc && "function" === typeof $b428e590a835ea4b$var$lc.onPostCommitFiberRoot) try {
                    $b428e590a835ea4b$var$lc.onPostCommitFiberRoot($b428e590a835ea4b$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b428e590a835ea4b$var$C = c, $b428e590a835ea4b$var$pk.transition = b;
        }
    }
    return !1;
}
function $b428e590a835ea4b$var$Yk(a, b, c) {
    b = $b428e590a835ea4b$var$Ki(c, b);
    b = $b428e590a835ea4b$var$Oi(a, b, 1);
    a = $b428e590a835ea4b$var$dh(a, b, 1);
    b = $b428e590a835ea4b$var$L();
    null !== a && ($b428e590a835ea4b$var$Ac(a, 1, b), $b428e590a835ea4b$var$Ek(a, b));
}
function $b428e590a835ea4b$var$W(a, b, c) {
    if (3 === a.tag) $b428e590a835ea4b$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b428e590a835ea4b$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b428e590a835ea4b$var$Si || !$b428e590a835ea4b$var$Si.has(d))) {
                a = $b428e590a835ea4b$var$Ki(c, a);
                a = $b428e590a835ea4b$var$Ri(b, a, 1);
                b = $b428e590a835ea4b$var$dh(b, a, 1);
                a = $b428e590a835ea4b$var$L();
                null !== b && ($b428e590a835ea4b$var$Ac(b, 1, a), $b428e590a835ea4b$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b428e590a835ea4b$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b428e590a835ea4b$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $b428e590a835ea4b$var$R === a && ($b428e590a835ea4b$var$Z & c) === c && (4 === $b428e590a835ea4b$var$T || 3 === $b428e590a835ea4b$var$T && ($b428e590a835ea4b$var$Z & 130023424) === $b428e590a835ea4b$var$Z && 500 > $b428e590a835ea4b$var$B() - $b428e590a835ea4b$var$gk ? $b428e590a835ea4b$var$Lk(a, 0) : $b428e590a835ea4b$var$sk |= c);
    $b428e590a835ea4b$var$Ek(a, b);
}
function $b428e590a835ea4b$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b428e590a835ea4b$var$sc, $b428e590a835ea4b$var$sc <<= 1, 0 === ($b428e590a835ea4b$var$sc & 130023424) && ($b428e590a835ea4b$var$sc = 4194304)));
    var c = $b428e590a835ea4b$var$L();
    a = $b428e590a835ea4b$var$Zg(a, b);
    null !== a && ($b428e590a835ea4b$var$Ac(a, b, c), $b428e590a835ea4b$var$Ek(a, c));
}
function $b428e590a835ea4b$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b428e590a835ea4b$var$Zk(a, c);
}
function $b428e590a835ea4b$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b428e590a835ea4b$var$p(314));
    }
    null !== d && d.delete(b);
    $b428e590a835ea4b$var$Zk(a, c);
}
var $b428e590a835ea4b$var$Wk;
$b428e590a835ea4b$var$Wk = function Wk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b428e590a835ea4b$var$Wf.current) $b428e590a835ea4b$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b428e590a835ea4b$var$Ug = !1, $b428e590a835ea4b$var$zj(a, b, c);
            $b428e590a835ea4b$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b428e590a835ea4b$var$Ug = !1, $b428e590a835ea4b$var$I && 0 !== (b.flags & 1048576) && $b428e590a835ea4b$var$ug(b, $b428e590a835ea4b$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b428e590a835ea4b$var$jj(a, b);
            a = b.pendingProps;
            var e = $b428e590a835ea4b$var$Yf(b, $b428e590a835ea4b$var$H.current);
            $b428e590a835ea4b$var$Tg(b, c);
            e = $b428e590a835ea4b$var$Xh(null, b, d, a, e, c);
            var f = $b428e590a835ea4b$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b428e590a835ea4b$var$Zf(d) ? (f = !0, $b428e590a835ea4b$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b428e590a835ea4b$var$ah(b), e.updater = $b428e590a835ea4b$var$nh, b.stateNode = e, e._reactInternals = b, $b428e590a835ea4b$var$rh(b, d, a, c), b = $b428e590a835ea4b$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $b428e590a835ea4b$var$I && f && $b428e590a835ea4b$var$vg(b), $b428e590a835ea4b$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b428e590a835ea4b$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b428e590a835ea4b$var$$k(d);
                a = $b428e590a835ea4b$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $b428e590a835ea4b$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b428e590a835ea4b$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b428e590a835ea4b$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b428e590a835ea4b$var$aj(null, b, d, $b428e590a835ea4b$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($b428e590a835ea4b$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b428e590a835ea4b$var$Lg(d, e), $b428e590a835ea4b$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b428e590a835ea4b$var$Lg(d, e), $b428e590a835ea4b$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $b428e590a835ea4b$var$lj(b);
                if (null === a) throw Error($b428e590a835ea4b$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b428e590a835ea4b$var$bh(a, b);
                $b428e590a835ea4b$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b428e590a835ea4b$var$Ki(Error($b428e590a835ea4b$var$p(423)), b);
                        b = $b428e590a835ea4b$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b428e590a835ea4b$var$Ki(Error($b428e590a835ea4b$var$p(424)), b);
                        b = $b428e590a835ea4b$var$mj(a, b, d, c, e);
                        break a;
                    } else for($b428e590a835ea4b$var$yg = $b428e590a835ea4b$var$Lf(b.stateNode.containerInfo.firstChild), $b428e590a835ea4b$var$xg = b, $b428e590a835ea4b$var$I = !0, $b428e590a835ea4b$var$zg = null, c = $b428e590a835ea4b$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b428e590a835ea4b$var$Ig();
                    if (d === e) {
                        b = $b428e590a835ea4b$var$$i(a, b, c);
                        break a;
                    }
                    $b428e590a835ea4b$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b428e590a835ea4b$var$Kh(b), null === a && $b428e590a835ea4b$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b428e590a835ea4b$var$Ef(d, e) ? g = null : null !== f && $b428e590a835ea4b$var$Ef(d, f) && (b.flags |= 32), $b428e590a835ea4b$var$hj(a, b), $b428e590a835ea4b$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $b428e590a835ea4b$var$Eg(b), null;
        case 13:
            return $b428e590a835ea4b$var$pj(a, b, c);
        case 4:
            return $b428e590a835ea4b$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b428e590a835ea4b$var$Bh(b, null, d, c) : $b428e590a835ea4b$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b428e590a835ea4b$var$Lg(d, e), $b428e590a835ea4b$var$Zi(a, b, d, e, c);
        case 7:
            return $b428e590a835ea4b$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b428e590a835ea4b$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b428e590a835ea4b$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b428e590a835ea4b$var$G($b428e590a835ea4b$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b428e590a835ea4b$var$He(f.value, g)) {
                        if (f.children === e.children && !$b428e590a835ea4b$var$Wf.current) {
                            b = $b428e590a835ea4b$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b428e590a835ea4b$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b428e590a835ea4b$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b428e590a835ea4b$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b428e590a835ea4b$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b428e590a835ea4b$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b428e590a835ea4b$var$Tg(b, c), e = $b428e590a835ea4b$var$Vg(e), d = d(e), b.flags |= 1, $b428e590a835ea4b$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b428e590a835ea4b$var$Lg(d, b.pendingProps), e = $b428e590a835ea4b$var$Lg(d.type, e), $b428e590a835ea4b$var$aj(a, b, d, e, c);
        case 15:
            return $b428e590a835ea4b$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b428e590a835ea4b$var$Lg(d, e), $b428e590a835ea4b$var$jj(a, b), b.tag = 1, $b428e590a835ea4b$var$Zf(d) ? (a = !0, $b428e590a835ea4b$var$cg(b)) : a = !1, $b428e590a835ea4b$var$Tg(b, c), $b428e590a835ea4b$var$ph(b, d, e), $b428e590a835ea4b$var$rh(b, d, e, c), $b428e590a835ea4b$var$kj(null, b, d, !0, a, c);
        case 19:
            return $b428e590a835ea4b$var$yj(a, b, c);
        case 22:
            return $b428e590a835ea4b$var$ej(a, b, c);
    }
    throw Error($b428e590a835ea4b$var$p(156, b.tag));
};
function $b428e590a835ea4b$var$Gk(a, b) {
    return $b428e590a835ea4b$var$ac(a, b);
}
function $b428e590a835ea4b$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b428e590a835ea4b$var$Bg(a, b, c, d) {
    return new $b428e590a835ea4b$var$al(a, b, c, d);
}
function $b428e590a835ea4b$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b428e590a835ea4b$var$$k(a) {
    if ("function" === typeof a) return $b428e590a835ea4b$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b428e590a835ea4b$var$Da) return 11;
        if (a === $b428e590a835ea4b$var$Ga) return 14;
    }
    return 2;
}
function $b428e590a835ea4b$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $b428e590a835ea4b$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b428e590a835ea4b$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b428e590a835ea4b$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b428e590a835ea4b$var$ya:
            return $b428e590a835ea4b$var$Ah(c.children, e, f, b);
        case $b428e590a835ea4b$var$za:
            g = 8;
            e |= 8;
            break;
        case $b428e590a835ea4b$var$Aa:
            return a = $b428e590a835ea4b$var$Bg(12, c, b, e | 2), a.elementType = $b428e590a835ea4b$var$Aa, a.lanes = f, a;
        case $b428e590a835ea4b$var$Ea:
            return a = $b428e590a835ea4b$var$Bg(13, c, b, e), a.elementType = $b428e590a835ea4b$var$Ea, a.lanes = f, a;
        case $b428e590a835ea4b$var$Fa:
            return a = $b428e590a835ea4b$var$Bg(19, c, b, e), a.elementType = $b428e590a835ea4b$var$Fa, a.lanes = f, a;
        case $b428e590a835ea4b$var$Ia:
            return $b428e590a835ea4b$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b428e590a835ea4b$var$Ba:
                    g = 10;
                    break a;
                case $b428e590a835ea4b$var$Ca:
                    g = 9;
                    break a;
                case $b428e590a835ea4b$var$Da:
                    g = 11;
                    break a;
                case $b428e590a835ea4b$var$Ga:
                    g = 14;
                    break a;
                case $b428e590a835ea4b$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b428e590a835ea4b$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $YtE9h._)(a), ""));
    }
    b = $b428e590a835ea4b$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b428e590a835ea4b$var$Ah(a, b, c, d) {
    a = $b428e590a835ea4b$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b428e590a835ea4b$var$qj(a, b, c, d) {
    a = $b428e590a835ea4b$var$Bg(22, a, d, b);
    a.elementType = $b428e590a835ea4b$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b428e590a835ea4b$var$xh(a, b, c) {
    a = $b428e590a835ea4b$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b428e590a835ea4b$var$zh(a, b, c) {
    b = $b428e590a835ea4b$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b428e590a835ea4b$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b428e590a835ea4b$var$zc(0);
    this.expirationTimes = $b428e590a835ea4b$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b428e590a835ea4b$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b428e590a835ea4b$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $b428e590a835ea4b$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b428e590a835ea4b$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b428e590a835ea4b$var$ah(f);
    return a;
}
function $b428e590a835ea4b$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b428e590a835ea4b$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b428e590a835ea4b$var$el(a) {
    if (!a) return $b428e590a835ea4b$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b428e590a835ea4b$var$Vb(a) !== a || 1 !== a.tag) throw Error($b428e590a835ea4b$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b428e590a835ea4b$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b428e590a835ea4b$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b428e590a835ea4b$var$Zf(c)) return $b428e590a835ea4b$var$bg(a, c, b);
    }
    return b;
}
function $b428e590a835ea4b$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $b428e590a835ea4b$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $b428e590a835ea4b$var$el(null);
    c = a.current;
    d = $b428e590a835ea4b$var$L();
    e = $b428e590a835ea4b$var$lh(c);
    f = $b428e590a835ea4b$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b428e590a835ea4b$var$dh(c, f, e);
    a.current.lanes = e;
    $b428e590a835ea4b$var$Ac(a, e, d);
    $b428e590a835ea4b$var$Ek(a, d);
    return a;
}
function $b428e590a835ea4b$var$gl(a, b, c, d) {
    var e = b.current, f = $b428e590a835ea4b$var$L(), g = $b428e590a835ea4b$var$lh(e);
    c = $b428e590a835ea4b$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b428e590a835ea4b$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b428e590a835ea4b$var$dh(e, b, g);
    null !== a && ($b428e590a835ea4b$var$mh(a, e, g, f), $b428e590a835ea4b$var$eh(a, e, g));
    return g;
}
function $b428e590a835ea4b$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b428e590a835ea4b$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b428e590a835ea4b$var$jl(a, b) {
    $b428e590a835ea4b$var$il(a, b);
    (a = a.alternate) && $b428e590a835ea4b$var$il(a, b);
}
function $b428e590a835ea4b$var$kl() {
    return null;
}
var $b428e590a835ea4b$var$ll = "function" === typeof reportError ? reportError : function ll(a) {
    console.error(a);
};
function $b428e590a835ea4b$var$ml(a) {
    this._internalRoot = a;
}
$b428e590a835ea4b$var$nl.prototype.render = $b428e590a835ea4b$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b428e590a835ea4b$var$p(409));
    $b428e590a835ea4b$var$gl(a, b, null, null);
};
$b428e590a835ea4b$var$nl.prototype.unmount = $b428e590a835ea4b$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b428e590a835ea4b$var$Sk(function() {
            $b428e590a835ea4b$var$gl(null, a, null, null);
        });
        b[$b428e590a835ea4b$var$uf] = null;
    }
};
function $b428e590a835ea4b$var$nl(a) {
    this._internalRoot = a;
}
$b428e590a835ea4b$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b428e590a835ea4b$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b428e590a835ea4b$var$Qc.length && 0 !== b && b < $b428e590a835ea4b$var$Qc[c].priority; c++);
        $b428e590a835ea4b$var$Qc.splice(c, 0, a);
        0 === c && $b428e590a835ea4b$var$Vc(a);
    }
};
function $b428e590a835ea4b$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b428e590a835ea4b$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b428e590a835ea4b$var$ql() {}
function $b428e590a835ea4b$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $b428e590a835ea4b$var$hl(g);
                f.call(_$a);
            };
        }
        var g = $b428e590a835ea4b$var$fl(b, d, a, 0, null, !1, !1, "", $b428e590a835ea4b$var$ql);
        a._reactRootContainer = g;
        a[$b428e590a835ea4b$var$uf] = g.current;
        $b428e590a835ea4b$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b428e590a835ea4b$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $b428e590a835ea4b$var$hl(k);
            h.call(_$a);
        };
    }
    var k = $b428e590a835ea4b$var$cl(a, 0, !1, null, null, !1, !1, "", $b428e590a835ea4b$var$ql);
    a._reactRootContainer = k;
    a[$b428e590a835ea4b$var$uf] = k.current;
    $b428e590a835ea4b$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b428e590a835ea4b$var$Sk(function() {
        $b428e590a835ea4b$var$gl(b, k, c, d);
    });
    return k;
}
function $b428e590a835ea4b$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $b428e590a835ea4b$var$hl(g);
                h.call(_$a);
            };
        }
        $b428e590a835ea4b$var$gl(b, g, a, e);
    } else g = $b428e590a835ea4b$var$rl(c, b, a, e, d);
    return $b428e590a835ea4b$var$hl(g);
}
$b428e590a835ea4b$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b428e590a835ea4b$var$tc(b.pendingLanes);
                0 !== c && ($b428e590a835ea4b$var$Cc(b, c | 1), $b428e590a835ea4b$var$Ek(b, $b428e590a835ea4b$var$B()), 0 === ($b428e590a835ea4b$var$K & 6) && ($b428e590a835ea4b$var$Hj = $b428e590a835ea4b$var$B() + 500, $b428e590a835ea4b$var$jg()));
            }
            break;
        case 13:
            $b428e590a835ea4b$var$Sk(function() {
                var b = $b428e590a835ea4b$var$Zg(a, 1);
                if (null !== b) {
                    var c = $b428e590a835ea4b$var$L();
                    $b428e590a835ea4b$var$mh(b, a, 1, c);
                }
            }), $b428e590a835ea4b$var$jl(a, 1);
    }
};
$b428e590a835ea4b$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $b428e590a835ea4b$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $b428e590a835ea4b$var$L();
            $b428e590a835ea4b$var$mh(b, a, 134217728, c);
        }
        $b428e590a835ea4b$var$jl(a, 134217728);
    }
};
$b428e590a835ea4b$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $b428e590a835ea4b$var$lh(a), c = $b428e590a835ea4b$var$Zg(a, b);
        if (null !== c) {
            var d = $b428e590a835ea4b$var$L();
            $b428e590a835ea4b$var$mh(c, a, b, d);
        }
        $b428e590a835ea4b$var$jl(a, b);
    }
};
$b428e590a835ea4b$var$Hc = function Hc() {
    return $b428e590a835ea4b$var$C;
};
$b428e590a835ea4b$var$Ic = function Ic(a, b) {
    var c = $b428e590a835ea4b$var$C;
    try {
        return $b428e590a835ea4b$var$C = a, b();
    } finally{
        $b428e590a835ea4b$var$C = c;
    }
};
$b428e590a835ea4b$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $b428e590a835ea4b$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b428e590a835ea4b$var$Db(d);
                        if (!e) throw Error($b428e590a835ea4b$var$p(90));
                        $b428e590a835ea4b$var$Wa(d);
                        $b428e590a835ea4b$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b428e590a835ea4b$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b428e590a835ea4b$var$fb(a, !!c.multiple, b, !1);
    }
};
$b428e590a835ea4b$var$Gb = $b428e590a835ea4b$var$Rk;
$b428e590a835ea4b$var$Hb = $b428e590a835ea4b$var$Sk;
var $b428e590a835ea4b$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $b428e590a835ea4b$var$Cb,
        $b428e590a835ea4b$var$ue,
        $b428e590a835ea4b$var$Db,
        $b428e590a835ea4b$var$Eb,
        $b428e590a835ea4b$var$Fb,
        $b428e590a835ea4b$var$Rk
    ]
}, $b428e590a835ea4b$var$ul = {
    findFiberByHostInstance: $b428e590a835ea4b$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $b428e590a835ea4b$var$vl = {
    bundleType: $b428e590a835ea4b$var$ul.bundleType,
    version: $b428e590a835ea4b$var$ul.version,
    rendererPackageName: $b428e590a835ea4b$var$ul.rendererPackageName,
    rendererConfig: $b428e590a835ea4b$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b428e590a835ea4b$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $b428e590a835ea4b$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b428e590a835ea4b$var$ul.findFiberByHostInstance || $b428e590a835ea4b$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b428e590a835ea4b$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b428e590a835ea4b$var$wl.isDisabled && $b428e590a835ea4b$var$wl.supportsFiber) try {
        $b428e590a835ea4b$var$kc = $b428e590a835ea4b$var$wl.inject($b428e590a835ea4b$var$vl), $b428e590a835ea4b$var$lc = $b428e590a835ea4b$var$wl;
    } catch (a) {}
}
$b428e590a835ea4b$export$ae55be85d98224ed = $b428e590a835ea4b$var$tl;
$b428e590a835ea4b$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b428e590a835ea4b$var$ol(b)) throw Error($b428e590a835ea4b$var$p(200));
    return $b428e590a835ea4b$var$dl(a, b, null, c);
};
$b428e590a835ea4b$export$882461b6382ed46c = function(a, b) {
    if (!$b428e590a835ea4b$var$ol(a)) throw Error($b428e590a835ea4b$var$p(299));
    var c = !1, d = "", e = $b428e590a835ea4b$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b428e590a835ea4b$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$b428e590a835ea4b$var$uf] = b.current;
    $b428e590a835ea4b$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b428e590a835ea4b$var$ml(b);
};
$b428e590a835ea4b$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b428e590a835ea4b$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b428e590a835ea4b$var$p(268, a));
    }
    a = $b428e590a835ea4b$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b428e590a835ea4b$export$cd75ccfd720a3cd4 = function(a) {
    return $b428e590a835ea4b$var$Sk(a);
};
$b428e590a835ea4b$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b428e590a835ea4b$var$pl(b)) throw Error($b428e590a835ea4b$var$p(200));
    return $b428e590a835ea4b$var$sl(null, a, b, !0, c);
};
$b428e590a835ea4b$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b428e590a835ea4b$var$ol(a)) throw Error($b428e590a835ea4b$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b428e590a835ea4b$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b428e590a835ea4b$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b428e590a835ea4b$var$uf] = b.current;
    $b428e590a835ea4b$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b428e590a835ea4b$var$nl(b);
};
$b428e590a835ea4b$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b428e590a835ea4b$var$pl(b)) throw Error($b428e590a835ea4b$var$p(200));
    return $b428e590a835ea4b$var$sl(null, a, b, !1, c);
};
$b428e590a835ea4b$export$502457920280e6be = function(a) {
    if (!$b428e590a835ea4b$var$pl(a)) throw Error($b428e590a835ea4b$var$p(40));
    return a._reactRootContainer ? ($b428e590a835ea4b$var$Sk(function() {
        $b428e590a835ea4b$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b428e590a835ea4b$var$uf] = null;
        });
    }), !0) : !1;
};
$b428e590a835ea4b$export$c78a37762a8d58e1 = $b428e590a835ea4b$var$Rk;
$b428e590a835ea4b$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b428e590a835ea4b$var$pl(c)) throw Error($b428e590a835ea4b$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b428e590a835ea4b$var$p(38));
    return $b428e590a835ea4b$var$sl(a, b, c, !1, d);
};
$b428e590a835ea4b$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("go0bk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4T7oT"));

});
parcelRegister("4T7oT", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $38f20a15ebe50fce$export$c4744153514ff05d; }, function (v) { return $38f20a15ebe50fce$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $38f20a15ebe50fce$export$3e506c1ccc9cc1a7; }, function (v) { return $38f20a15ebe50fce$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $38f20a15ebe50fce$export$e26fe2ed2fa76875; }, function (v) { return $38f20a15ebe50fce$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $38f20a15ebe50fce$export$502329bbf4b505b1; }, function (v) { return $38f20a15ebe50fce$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $38f20a15ebe50fce$export$6e3807111c4874c4; }, function (v) { return $38f20a15ebe50fce$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $38f20a15ebe50fce$export$c27134553091fb3a; }, function (v) { return $38f20a15ebe50fce$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $38f20a15ebe50fce$export$33ee1acdc04fd2a2; }, function (v) { return $38f20a15ebe50fce$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $38f20a15ebe50fce$export$b00a404bbd5edef2; }, function (v) { return $38f20a15ebe50fce$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $38f20a15ebe50fce$export$8352ce38b91d0c62; }, function (v) { return $38f20a15ebe50fce$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $38f20a15ebe50fce$export$d66a1c1c77bd778b; }, function (v) { return $38f20a15ebe50fce$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $38f20a15ebe50fce$export$d3dfb8e4810cb555; }, function (v) { return $38f20a15ebe50fce$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $38f20a15ebe50fce$export$839f9183b0465a69; }, function (v) { return $38f20a15ebe50fce$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $38f20a15ebe50fce$export$72fdf0e06517287b; }, function (v) { return $38f20a15ebe50fce$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $38f20a15ebe50fce$export$4b844e58a3e414b4; }, function (v) { return $38f20a15ebe50fce$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $38f20a15ebe50fce$export$816d2913ae6b83b1; }, function (v) { return $38f20a15ebe50fce$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $38f20a15ebe50fce$export$61bcfe829111a1d0; }, function (v) { return $38f20a15ebe50fce$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $38f20a15ebe50fce$export$7ee8c9beb337bc3f; }, function (v) { return $38f20a15ebe50fce$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $38f20a15ebe50fce$export$b5836b71941fa3ed; }, function (v) { return $38f20a15ebe50fce$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $38f20a15ebe50fce$export$cf845f2c119da08a; }, function (v) { return $38f20a15ebe50fce$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $38f20a15ebe50fce$export$c4744153514ff05d;
var $38f20a15ebe50fce$export$3e506c1ccc9cc1a7;
var $38f20a15ebe50fce$export$e26fe2ed2fa76875;
var $38f20a15ebe50fce$export$502329bbf4b505b1;
var $38f20a15ebe50fce$export$6e3807111c4874c4;
var $38f20a15ebe50fce$export$c27134553091fb3a;
var $38f20a15ebe50fce$export$33ee1acdc04fd2a2;
var $38f20a15ebe50fce$export$b00a404bbd5edef2;
var $38f20a15ebe50fce$export$8352ce38b91d0c62;
var $38f20a15ebe50fce$export$d66a1c1c77bd778b;
var $38f20a15ebe50fce$export$d3dfb8e4810cb555;
var $38f20a15ebe50fce$export$839f9183b0465a69;
var $38f20a15ebe50fce$export$72fdf0e06517287b;
var $38f20a15ebe50fce$export$4b844e58a3e414b4;
var $38f20a15ebe50fce$export$816d2913ae6b83b1;
var $38f20a15ebe50fce$export$61bcfe829111a1d0;
var $38f20a15ebe50fce$export$7ee8c9beb337bc3f;
var $38f20a15ebe50fce$export$b5836b71941fa3ed;
var $38f20a15ebe50fce$export$cf845f2c119da08a;
"use strict";
function $38f20a15ebe50fce$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $38f20a15ebe50fce$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $38f20a15ebe50fce$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $38f20a15ebe50fce$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $38f20a15ebe50fce$var$g(C, c)) n < e && 0 > $38f20a15ebe50fce$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $38f20a15ebe50fce$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $38f20a15ebe50fce$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $38f20a15ebe50fce$var$l = performance;
    $38f20a15ebe50fce$export$c4744153514ff05d = function() {
        return $38f20a15ebe50fce$var$l.now();
    };
} else {
    var $38f20a15ebe50fce$var$p = Date, $38f20a15ebe50fce$var$q = $38f20a15ebe50fce$var$p.now();
    $38f20a15ebe50fce$export$c4744153514ff05d = function() {
        return $38f20a15ebe50fce$var$p.now() - $38f20a15ebe50fce$var$q;
    };
}
var $38f20a15ebe50fce$var$r = [], $38f20a15ebe50fce$var$t = [], $38f20a15ebe50fce$var$u = 1, $38f20a15ebe50fce$var$v = null, $38f20a15ebe50fce$var$y = 3, $38f20a15ebe50fce$var$z = !1, $38f20a15ebe50fce$var$A = !1, $38f20a15ebe50fce$var$B = !1, $38f20a15ebe50fce$var$D = "function" === typeof setTimeout ? setTimeout : null, $38f20a15ebe50fce$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $38f20a15ebe50fce$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $38f20a15ebe50fce$var$G(a) {
    for(var b = $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$t); null !== b;){
        if (null === b.callback) $38f20a15ebe50fce$var$k($38f20a15ebe50fce$var$t);
        else if (b.startTime <= a) $38f20a15ebe50fce$var$k($38f20a15ebe50fce$var$t), b.sortIndex = b.expirationTime, $38f20a15ebe50fce$var$f($38f20a15ebe50fce$var$r, b);
        else break;
        b = $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$t);
    }
}
function $38f20a15ebe50fce$var$H(a) {
    $38f20a15ebe50fce$var$B = !1;
    $38f20a15ebe50fce$var$G(a);
    if (!$38f20a15ebe50fce$var$A) {
        if (null !== $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$r)) $38f20a15ebe50fce$var$A = !0, $38f20a15ebe50fce$var$I($38f20a15ebe50fce$var$J);
        else {
            var b = $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$t);
            null !== b && $38f20a15ebe50fce$var$K($38f20a15ebe50fce$var$H, b.startTime - a);
        }
    }
}
function $38f20a15ebe50fce$var$J(a, b) {
    $38f20a15ebe50fce$var$A = !1;
    $38f20a15ebe50fce$var$B && ($38f20a15ebe50fce$var$B = !1, $38f20a15ebe50fce$var$E($38f20a15ebe50fce$var$L), $38f20a15ebe50fce$var$L = -1);
    $38f20a15ebe50fce$var$z = !0;
    var c = $38f20a15ebe50fce$var$y;
    try {
        $38f20a15ebe50fce$var$G(b);
        for($38f20a15ebe50fce$var$v = $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$r); null !== $38f20a15ebe50fce$var$v && (!($38f20a15ebe50fce$var$v.expirationTime > b) || a && !$38f20a15ebe50fce$var$M());){
            var d = $38f20a15ebe50fce$var$v.callback;
            if ("function" === typeof d) {
                $38f20a15ebe50fce$var$v.callback = null;
                $38f20a15ebe50fce$var$y = $38f20a15ebe50fce$var$v.priorityLevel;
                var e = d($38f20a15ebe50fce$var$v.expirationTime <= b);
                b = $38f20a15ebe50fce$export$c4744153514ff05d();
                "function" === typeof e ? $38f20a15ebe50fce$var$v.callback = e : $38f20a15ebe50fce$var$v === $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$r) && $38f20a15ebe50fce$var$k($38f20a15ebe50fce$var$r);
                $38f20a15ebe50fce$var$G(b);
            } else $38f20a15ebe50fce$var$k($38f20a15ebe50fce$var$r);
            $38f20a15ebe50fce$var$v = $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$r);
        }
        if (null !== $38f20a15ebe50fce$var$v) var w = !0;
        else {
            var m = $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$t);
            null !== m && $38f20a15ebe50fce$var$K($38f20a15ebe50fce$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $38f20a15ebe50fce$var$v = null, $38f20a15ebe50fce$var$y = c, $38f20a15ebe50fce$var$z = !1;
    }
}
var $38f20a15ebe50fce$var$N = !1, $38f20a15ebe50fce$var$O = null, $38f20a15ebe50fce$var$L = -1, $38f20a15ebe50fce$var$P = 5, $38f20a15ebe50fce$var$Q = -1;
function $38f20a15ebe50fce$var$M() {
    return $38f20a15ebe50fce$export$c4744153514ff05d() - $38f20a15ebe50fce$var$Q < $38f20a15ebe50fce$var$P ? !1 : !0;
}
function $38f20a15ebe50fce$var$R() {
    if (null !== $38f20a15ebe50fce$var$O) {
        var a = $38f20a15ebe50fce$export$c4744153514ff05d();
        $38f20a15ebe50fce$var$Q = a;
        var b = !0;
        try {
            b = $38f20a15ebe50fce$var$O(!0, a);
        } finally{
            b ? $38f20a15ebe50fce$var$S() : ($38f20a15ebe50fce$var$N = !1, $38f20a15ebe50fce$var$O = null);
        }
    } else $38f20a15ebe50fce$var$N = !1;
}
var $38f20a15ebe50fce$var$S;
if ("function" === typeof $38f20a15ebe50fce$var$F) $38f20a15ebe50fce$var$S = function S() {
    $38f20a15ebe50fce$var$F($38f20a15ebe50fce$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $38f20a15ebe50fce$var$T = new MessageChannel, $38f20a15ebe50fce$var$U = $38f20a15ebe50fce$var$T.port2;
    $38f20a15ebe50fce$var$T.port1.onmessage = $38f20a15ebe50fce$var$R;
    $38f20a15ebe50fce$var$S = function S() {
        $38f20a15ebe50fce$var$U.postMessage(null);
    };
} else $38f20a15ebe50fce$var$S = function S() {
    $38f20a15ebe50fce$var$D($38f20a15ebe50fce$var$R, 0);
};
function $38f20a15ebe50fce$var$I(a) {
    $38f20a15ebe50fce$var$O = a;
    $38f20a15ebe50fce$var$N || ($38f20a15ebe50fce$var$N = !0, $38f20a15ebe50fce$var$S());
}
function $38f20a15ebe50fce$var$K(a, b) {
    $38f20a15ebe50fce$var$L = $38f20a15ebe50fce$var$D(function() {
        a($38f20a15ebe50fce$export$c4744153514ff05d());
    }, b);
}
$38f20a15ebe50fce$export$3e506c1ccc9cc1a7 = 5;
$38f20a15ebe50fce$export$e26fe2ed2fa76875 = 1;
$38f20a15ebe50fce$export$502329bbf4b505b1 = 4;
$38f20a15ebe50fce$export$6e3807111c4874c4 = 3;
$38f20a15ebe50fce$export$c27134553091fb3a = null;
$38f20a15ebe50fce$export$33ee1acdc04fd2a2 = 2;
$38f20a15ebe50fce$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$38f20a15ebe50fce$export$8352ce38b91d0c62 = function() {
    $38f20a15ebe50fce$var$A || $38f20a15ebe50fce$var$z || ($38f20a15ebe50fce$var$A = !0, $38f20a15ebe50fce$var$I($38f20a15ebe50fce$var$J));
};
$38f20a15ebe50fce$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $38f20a15ebe50fce$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$38f20a15ebe50fce$export$d3dfb8e4810cb555 = function() {
    return $38f20a15ebe50fce$var$y;
};
$38f20a15ebe50fce$export$839f9183b0465a69 = function() {
    return $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$r);
};
$38f20a15ebe50fce$export$72fdf0e06517287b = function(a) {
    switch($38f20a15ebe50fce$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $38f20a15ebe50fce$var$y;
    }
    var c = $38f20a15ebe50fce$var$y;
    $38f20a15ebe50fce$var$y = b;
    try {
        return a();
    } finally{
        $38f20a15ebe50fce$var$y = c;
    }
};
$38f20a15ebe50fce$export$4b844e58a3e414b4 = function() {};
$38f20a15ebe50fce$export$816d2913ae6b83b1 = function() {};
$38f20a15ebe50fce$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $38f20a15ebe50fce$var$y;
    $38f20a15ebe50fce$var$y = a;
    try {
        return b();
    } finally{
        $38f20a15ebe50fce$var$y = c;
    }
};
$38f20a15ebe50fce$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $38f20a15ebe50fce$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $38f20a15ebe50fce$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $38f20a15ebe50fce$var$f($38f20a15ebe50fce$var$t, a), null === $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$r) && a === $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$t) && ($38f20a15ebe50fce$var$B ? ($38f20a15ebe50fce$var$E($38f20a15ebe50fce$var$L), $38f20a15ebe50fce$var$L = -1) : $38f20a15ebe50fce$var$B = !0, $38f20a15ebe50fce$var$K($38f20a15ebe50fce$var$H, c - d))) : (a.sortIndex = e, $38f20a15ebe50fce$var$f($38f20a15ebe50fce$var$r, a), $38f20a15ebe50fce$var$A || $38f20a15ebe50fce$var$z || ($38f20a15ebe50fce$var$A = !0, $38f20a15ebe50fce$var$I($38f20a15ebe50fce$var$J)));
    return a;
};
$38f20a15ebe50fce$export$b5836b71941fa3ed = $38f20a15ebe50fce$var$M;
$38f20a15ebe50fce$export$cf845f2c119da08a = function(a) {
    var b = $38f20a15ebe50fce$var$y;
    return function() {
        var c = $38f20a15ebe50fce$var$y;
        $38f20a15ebe50fce$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $38f20a15ebe50fce$var$y = c;
        }
    };
};

});



parcelRegister("gHY9J", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $c29f5337323ae6dd$export$bf730a2d8bf68b42; }, function (v) { return $c29f5337323ae6dd$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c29f5337323ae6dd$export$bf730a2d8bf68b42;
"use strict";

var $fIwXP = parcelRequire("fIwXP");
function $c29f5337323ae6dd$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c29f5337323ae6dd$var$p = "function" === typeof Object.is ? Object.is : $c29f5337323ae6dd$var$n, $c29f5337323ae6dd$var$q = $fIwXP.useSyncExternalStore, $c29f5337323ae6dd$var$r = $fIwXP.useRef, $c29f5337323ae6dd$var$t = $fIwXP.useEffect, $c29f5337323ae6dd$var$u = $fIwXP.useMemo, $c29f5337323ae6dd$var$v = $fIwXP.useDebugValue;
$c29f5337323ae6dd$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $c29f5337323ae6dd$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $c29f5337323ae6dd$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var _$b = f.value;
                    if (h(_$b, a)) return k = _$b;
                }
                return k = a;
            }
            _$b = k;
            if ($c29f5337323ae6dd$var$p(d, a)) return _$b;
            var _$e = l(a);
            if (void 0 !== h && h(_$b, _$e)) return _$b;
            d = a;
            return k = _$e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $c29f5337323ae6dd$var$q(a, c[0], c[1]);
    $c29f5337323ae6dd$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $c29f5337323ae6dd$var$v(d);
    return d;
};

});

parcelRegister("kjN8l", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $dB152 = parcelRequire("dB152");
function $ecabb1e2a9ddf03f$var$emptyFunction() {}
function $ecabb1e2a9ddf03f$var$emptyFunctionWithReset() {}
$ecabb1e2a9ddf03f$var$emptyFunctionWithReset.resetWarningCache = $ecabb1e2a9ddf03f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $dB152) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $ecabb1e2a9ddf03f$var$emptyFunctionWithReset,
        resetWarningCache: $ecabb1e2a9ddf03f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("dB152", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $9e5f918fe595f414$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $9e5f918fe595f414$var$ReactPropTypesSecret;

});


parcelRegister("1wVsT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $11d55af27ee762da$var$_react = $11d55af27ee762da$var$_interopRequireDefault((parcelRequire("fIwXP")));

var $2Qs16 = parcelRequire("2Qs16");

var $11d55af27ee762da$var$_json2mq = $11d55af27ee762da$var$_interopRequireDefault((parcelRequire("jTrNc")));

var $11d55af27ee762da$var$_defaultProps = $11d55af27ee762da$var$_interopRequireDefault((parcelRequire("ZEwRt")));

var $8XSk1 = parcelRequire("8XSk1");
function $11d55af27ee762da$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $11d55af27ee762da$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $11d55af27ee762da$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $11d55af27ee762da$var$_typeof(o);
}
function $11d55af27ee762da$var$_extends() {
    $11d55af27ee762da$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $11d55af27ee762da$var$_extends.apply(this, arguments);
}
function $11d55af27ee762da$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $11d55af27ee762da$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $11d55af27ee762da$var$ownKeys(Object(t), !0).forEach(function(r) {
            $11d55af27ee762da$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $11d55af27ee762da$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $11d55af27ee762da$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $11d55af27ee762da$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $11d55af27ee762da$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $11d55af27ee762da$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $11d55af27ee762da$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $11d55af27ee762da$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $11d55af27ee762da$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $11d55af27ee762da$var$_setPrototypeOf(subClass, superClass);
}
function $11d55af27ee762da$var$_setPrototypeOf(o, p) {
    $11d55af27ee762da$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $11d55af27ee762da$var$_setPrototypeOf(o, p);
}
function $11d55af27ee762da$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $11d55af27ee762da$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $11d55af27ee762da$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $11d55af27ee762da$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $11d55af27ee762da$var$_possibleConstructorReturn(this, result);
    };
}
function $11d55af27ee762da$var$_possibleConstructorReturn(self, call) {
    if (call && ($11d55af27ee762da$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $11d55af27ee762da$var$_assertThisInitialized(self);
}
function $11d55af27ee762da$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $11d55af27ee762da$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($11d55af27ee762da$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $11d55af27ee762da$var$_getPrototypeOf(o) {
    $11d55af27ee762da$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $11d55af27ee762da$var$_getPrototypeOf(o);
}
function $11d55af27ee762da$var$_defineProperty(obj, key, value) {
    key = $11d55af27ee762da$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $11d55af27ee762da$var$_toPropertyKey(t) {
    var i = $11d55af27ee762da$var$_toPrimitive(t, "string");
    return "symbol" == $11d55af27ee762da$var$_typeof(i) ? i : String(i);
}
function $11d55af27ee762da$var$_toPrimitive(t, r) {
    if ("object" != $11d55af27ee762da$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $11d55af27ee762da$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

var $11d55af27ee762da$var$enquire = (0, $8XSk1.canUseDOM)() && (parcelRequire("4RUun"));
var $11d55af27ee762da$var$Slider = module.exports["default"] = /*#__PURE__*/ function(_React$Component) {
    $11d55af27ee762da$var$_inherits(Slider, _React$Component);
    var _super = $11d55af27ee762da$var$_createSuper(Slider);
    function Slider(props) {
        var _this;
        $11d55af27ee762da$var$_classCallCheck(this, Slider);
        _this = _super.call(this, props);
        $11d55af27ee762da$var$_defineProperty($11d55af27ee762da$var$_assertThisInitialized(_this), "innerSliderRefHandler", function(ref) {
            return _this.innerSlider = ref;
        });
        $11d55af27ee762da$var$_defineProperty($11d55af27ee762da$var$_assertThisInitialized(_this), "slickPrev", function() {
            return _this.innerSlider.slickPrev();
        });
        $11d55af27ee762da$var$_defineProperty($11d55af27ee762da$var$_assertThisInitialized(_this), "slickNext", function() {
            return _this.innerSlider.slickNext();
        });
        $11d55af27ee762da$var$_defineProperty($11d55af27ee762da$var$_assertThisInitialized(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return _this.innerSlider.slickGoTo(slide, dontAnimate);
        });
        $11d55af27ee762da$var$_defineProperty($11d55af27ee762da$var$_assertThisInitialized(_this), "slickPause", function() {
            return _this.innerSlider.pause("paused");
        });
        $11d55af27ee762da$var$_defineProperty($11d55af27ee762da$var$_assertThisInitialized(_this), "slickPlay", function() {
            return _this.innerSlider.autoPlay("play");
        });
        _this.state = {
            breakpoint: null
        };
        _this._responsiveMediaHandlers = [];
        return _this;
    }
    $11d55af27ee762da$var$_createClass(Slider, [
        {
            key: "media",
            value: function media(query, handler) {
                // javascript handler for  css media query
                $11d55af27ee762da$var$enquire.register(query, handler);
                this._responsiveMediaHandlers.push({
                    query: query,
                    handler: handler
                });
            } // handles responsive breakpoints
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                // performance monitoring
                //if (process.env.NODE_ENV !== 'production') {
                //const { whyDidYouUpdate } = require('why-did-you-update')
                //whyDidYouUpdate(React)
                //}
                if (this.props.responsive) {
                    var breakpoints = this.props.responsive.map(function(breakpt) {
                        return breakpt.breakpoint;
                    });
                    // sort them in increasing order of their numerical value
                    breakpoints.sort(function(x, y) {
                        return x - y;
                    });
                    breakpoints.forEach(function(breakpoint, index) {
                        // media query for each breakpoint
                        var bQuery;
                        if (index === 0) bQuery = (0, $11d55af27ee762da$var$_json2mq["default"])({
                            minWidth: 0,
                            maxWidth: breakpoint
                        });
                        else bQuery = (0, $11d55af27ee762da$var$_json2mq["default"])({
                            minWidth: breakpoints[index - 1] + 1,
                            maxWidth: breakpoint
                        });
                        // when not using server side rendering
                        (0, $8XSk1.canUseDOM)() && _this2.media(bQuery, function() {
                            _this2.setState({
                                breakpoint: breakpoint
                            });
                        });
                    });
                    // Register media query for full screen. Need to support resize from small to large
                    // convert javascript object to media query string
                    var query = (0, $11d55af27ee762da$var$_json2mq["default"])({
                        minWidth: breakpoints.slice(-1)[0]
                    });
                    (0, $8XSk1.canUseDOM)() && this.media(query, function() {
                        _this2.setState({
                            breakpoint: null
                        });
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._responsiveMediaHandlers.forEach(function(obj) {
                    $11d55af27ee762da$var$enquire.unregister(obj.query, obj.handler);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var settings;
                var newProps;
                if (this.state.breakpoint) {
                    newProps = this.props.responsive.filter(function(resp) {
                        return resp.breakpoint === _this3.state.breakpoint;
                    });
                    settings = newProps[0].settings === "unslick" ? "unslick" : $11d55af27ee762da$var$_objectSpread($11d55af27ee762da$var$_objectSpread($11d55af27ee762da$var$_objectSpread({}, $11d55af27ee762da$var$_defaultProps["default"]), this.props), newProps[0].settings);
                } else settings = $11d55af27ee762da$var$_objectSpread($11d55af27ee762da$var$_objectSpread({}, $11d55af27ee762da$var$_defaultProps["default"]), this.props);
                // force scrolling by one if centerMode is on
                if (settings.centerMode) {
                    settings.slidesToScroll;
                    settings.slidesToScroll = 1;
                }
                // force showing one slide and scrolling by one if the fade mode is on
                if (settings.fade) {
                    settings.slidesToShow;
                    settings.slidesToScroll;
                    settings.slidesToShow = 1;
                    settings.slidesToScroll = 1;
                }
                // makes sure that children is an array, even when there is only 1 child
                var children = $11d55af27ee762da$var$_react["default"].Children.toArray(this.props.children);
                // Children may contain false or null, so we should filter them
                // children may also contain string filled with spaces (in certain cases where we use jsx strings)
                children = children.filter(function(child) {
                    if (typeof child === "string") return !!child.trim();
                    return !!child;
                });
                // rows and slidesPerRow logic is handled here
                if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
                    console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
                    settings.variableWidth = false;
                }
                var newChildren = [];
                var currentWidth = null;
                for(var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow){
                    var newSlide = [];
                    for(var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow){
                        var row = [];
                        for(var k = j; k < j + settings.slidesPerRow; k += 1){
                            if (settings.variableWidth && children[k].props.style) currentWidth = children[k].props.style.width;
                            if (k >= children.length) break;
                            row.push(/*#__PURE__*/ $11d55af27ee762da$var$_react["default"].cloneElement(children[k], {
                                key: 100 * i + 10 * j + k,
                                tabIndex: -1,
                                style: {
                                    width: "".concat(100 / settings.slidesPerRow, "%"),
                                    display: "inline-block"
                                }
                            }));
                        }
                        newSlide.push(/*#__PURE__*/ $11d55af27ee762da$var$_react["default"].createElement("div", {
                            key: 10 * i + j
                        }, row));
                    }
                    if (settings.variableWidth) newChildren.push(/*#__PURE__*/ $11d55af27ee762da$var$_react["default"].createElement("div", {
                        key: i,
                        style: {
                            width: currentWidth
                        }
                    }, newSlide));
                    else newChildren.push(/*#__PURE__*/ $11d55af27ee762da$var$_react["default"].createElement("div", {
                        key: i
                    }, newSlide));
                }
                if (settings === "unslick") {
                    var className = "regular slider " + (this.props.className || "");
                    return /*#__PURE__*/ $11d55af27ee762da$var$_react["default"].createElement("div", {
                        className: className
                    }, children);
                } else if (newChildren.length <= settings.slidesToShow && !settings.infinite) settings.unslick = true;
                return /*#__PURE__*/ $11d55af27ee762da$var$_react["default"].createElement($2Qs16.InnerSlider, $11d55af27ee762da$var$_extends({
                    style: this.props.style,
                    ref: this.innerSliderRefHandler
                }, (0, $8XSk1.filterSettings)(settings)), newChildren);
            }
        }
    ]);
    return Slider;
}($11d55af27ee762da$var$_react["default"].Component);

});
parcelRegister("2Qs16", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InnerSlider = void 0;

var $21262ba2c71116ec$var$_react = $21262ba2c71116ec$var$_interopRequireDefault((parcelRequire("fIwXP")));

var $21262ba2c71116ec$var$_initialState = $21262ba2c71116ec$var$_interopRequireDefault((parcelRequire("hFtm3")));

var $21262ba2c71116ec$var$_lodash = $21262ba2c71116ec$var$_interopRequireDefault((parcelRequire("krOQK")));

var $21262ba2c71116ec$var$_classnames = $21262ba2c71116ec$var$_interopRequireDefault((parcelRequire("eR2a2")));

var $8XSk1 = parcelRequire("8XSk1");

var $2DkJA = parcelRequire("2DkJA");

var $bmMxA = parcelRequire("bmMxA");

var $49Fws = parcelRequire("49Fws");

var $21262ba2c71116ec$var$_resizeObserverPolyfill = $21262ba2c71116ec$var$_interopRequireDefault((parcelRequire("4EfKw")));
function $21262ba2c71116ec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $21262ba2c71116ec$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $21262ba2c71116ec$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $21262ba2c71116ec$var$_typeof(o);
}
function $21262ba2c71116ec$var$_extends() {
    $21262ba2c71116ec$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $21262ba2c71116ec$var$_extends.apply(this, arguments);
}
function $21262ba2c71116ec$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $21262ba2c71116ec$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $21262ba2c71116ec$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $21262ba2c71116ec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $21262ba2c71116ec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $21262ba2c71116ec$var$ownKeys(Object(t), !0).forEach(function(r) {
            $21262ba2c71116ec$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $21262ba2c71116ec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $21262ba2c71116ec$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $21262ba2c71116ec$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $21262ba2c71116ec$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $21262ba2c71116ec$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $21262ba2c71116ec$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $21262ba2c71116ec$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $21262ba2c71116ec$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $21262ba2c71116ec$var$_setPrototypeOf(subClass, superClass);
}
function $21262ba2c71116ec$var$_setPrototypeOf(o, p) {
    $21262ba2c71116ec$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $21262ba2c71116ec$var$_setPrototypeOf(o, p);
}
function $21262ba2c71116ec$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $21262ba2c71116ec$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $21262ba2c71116ec$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $21262ba2c71116ec$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $21262ba2c71116ec$var$_possibleConstructorReturn(this, result);
    };
}
function $21262ba2c71116ec$var$_possibleConstructorReturn(self, call) {
    if (call && ($21262ba2c71116ec$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $21262ba2c71116ec$var$_assertThisInitialized(self);
}
function $21262ba2c71116ec$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $21262ba2c71116ec$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($21262ba2c71116ec$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $21262ba2c71116ec$var$_getPrototypeOf(o) {
    $21262ba2c71116ec$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $21262ba2c71116ec$var$_getPrototypeOf(o);
}
function $21262ba2c71116ec$var$_defineProperty(obj, key, value) {
    key = $21262ba2c71116ec$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $21262ba2c71116ec$var$_toPropertyKey(t) {
    var i = $21262ba2c71116ec$var$_toPrimitive(t, "string");
    return "symbol" == $21262ba2c71116ec$var$_typeof(i) ? i : String(i);
}
function $21262ba2c71116ec$var$_toPrimitive(t, r) {
    if ("object" != $21262ba2c71116ec$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $21262ba2c71116ec$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $21262ba2c71116ec$var$InnerSlider = module.exports.InnerSlider = /*#__PURE__*/ function(_React$Component) {
    $21262ba2c71116ec$var$_inherits(InnerSlider, _React$Component);
    var _super = $21262ba2c71116ec$var$_createSuper(InnerSlider);
    function InnerSlider(props) {
        var _this;
        $21262ba2c71116ec$var$_classCallCheck(this, InnerSlider);
        _this = _super.call(this, props);
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "listRefHandler", function(ref) {
            return _this.list = ref;
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "trackRefHandler", function(ref) {
            return _this.track = ref;
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "adaptHeight", function() {
            if (_this.props.adaptiveHeight && _this.list) {
                var elem = _this.list.querySelector('[data-index="'.concat(_this.state.currentSlide, '"]'));
                _this.list.style.height = (0, $8XSk1.getHeight)(elem) + "px";
            }
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "componentDidMount", function() {
            _this.props.onInit && _this.props.onInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $8XSk1.getOnDemandLazySlides)($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            var spec = $21262ba2c71116ec$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props);
            _this.updateState(spec, true, function() {
                _this.adaptHeight();
                _this.props.autoplay && _this.autoPlay("update");
            });
            if (_this.props.lazyLoad === "progressive") _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
            _this.ro = new $21262ba2c71116ec$var$_resizeObserverPolyfill["default"](function() {
                if (_this.state.animating) {
                    _this.onWindowResized(false); // don't set trackStyle hence don't break animation
                    _this.callbackTimers.push(setTimeout(function() {
                        return _this.onWindowResized();
                    }, _this.props.speed));
                } else _this.onWindowResized();
            });
            _this.ro.observe(_this.list);
            document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(slide) {
                slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
                slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
            });
            if (window.addEventListener) window.addEventListener("resize", _this.onWindowResized);
            else window.attachEvent("onresize", _this.onWindowResized);
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "componentWillUnmount", function() {
            if (_this.animationEndCallback) clearTimeout(_this.animationEndCallback);
            if (_this.lazyLoadTimer) clearInterval(_this.lazyLoadTimer);
            if (_this.callbackTimers.length) {
                _this.callbackTimers.forEach(function(timer) {
                    return clearTimeout(timer);
                });
                _this.callbackTimers = [];
            }
            if (window.addEventListener) window.removeEventListener("resize", _this.onWindowResized);
            else window.detachEvent("onresize", _this.onWindowResized);
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            _this.ro.disconnect();
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "componentDidUpdate", function(prevProps) {
            _this.checkImagesLoad();
            _this.props.onReInit && _this.props.onReInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $8XSk1.getOnDemandLazySlides)($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            // if (this.props.onLazyLoad) {
            //   this.props.onLazyLoad([leftMostSlide])
            // }
            _this.adaptHeight();
            var spec = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            var setTrackStyle = _this.didPropsChange(prevProps);
            setTrackStyle && _this.updateState(spec, setTrackStyle, function() {
                if (_this.state.currentSlide >= $21262ba2c71116ec$var$_react["default"].Children.count(_this.props.children)) _this.changeSlide({
                    message: "index",
                    index: $21262ba2c71116ec$var$_react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
                    currentSlide: _this.state.currentSlide
                });
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            });
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "onWindowResized", function(setTrackStyle) {
            if (_this.debouncedResize) _this.debouncedResize.cancel();
            _this.debouncedResize = (0, $21262ba2c71116ec$var$_lodash["default"])(function() {
                return _this.resizeWindow(setTrackStyle);
            }, 50);
            _this.debouncedResize();
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "resizeWindow", function() {
            var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var isTrackMounted = Boolean(_this.track && _this.track.node);
            // prevent warning: setting state on unmounted component (server side rendering)
            if (!isTrackMounted) return;
            var spec = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            _this.updateState(spec, setTrackStyle, function() {
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            });
            // animating state should be cleared while resizing, otherwise autoplay stops working
            _this.setState({
                animating: false
            });
            clearTimeout(_this.animationEndCallback);
            delete _this.animationEndCallback;
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "updateState", function(spec, setTrackStyle, callback) {
            var updatedState = (0, $8XSk1.initializedState)(spec);
            spec = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, spec), updatedState), {}, {
                slideIndex: updatedState.currentSlide
            });
            var targetLeft = (0, $8XSk1.getTrackLeft)(spec);
            spec = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, spec), {}, {
                left: targetLeft
            });
            var trackStyle = (0, $8XSk1.getTrackCSS)(spec);
            if (setTrackStyle || $21262ba2c71116ec$var$_react["default"].Children.count(_this.props.children) !== $21262ba2c71116ec$var$_react["default"].Children.count(spec.children)) updatedState["trackStyle"] = trackStyle;
            _this.setState(updatedState, callback);
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "ssrInit", function() {
            if (_this.props.variableWidth) {
                var _trackWidth = 0, _trackLeft = 0;
                var childrenWidths = [];
                var preClones = (0, $8XSk1.getPreClones)($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                var postClones = (0, $8XSk1.getPostClones)($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                _this.props.children.forEach(function(child) {
                    childrenWidths.push(child.props.style.width);
                    _trackWidth += child.props.style.width;
                });
                for(var i = 0; i < preClones; i++){
                    _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
                    _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
                }
                for(var _i = 0; _i < postClones; _i++)_trackWidth += childrenWidths[_i];
                for(var _i2 = 0; _i2 < _this.state.currentSlide; _i2++)_trackLeft += childrenWidths[_i2];
                var _trackStyle = {
                    width: _trackWidth + "px",
                    left: -_trackLeft + "px"
                };
                if (_this.props.centerMode) {
                    var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
                    _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
                }
                return {
                    trackStyle: _trackStyle
                };
            }
            var childrenCount = $21262ba2c71116ec$var$_react["default"].Children.count(_this.props.children);
            var spec = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state), {}, {
                slideCount: childrenCount
            });
            var slideCount = (0, $8XSk1.getPreClones)(spec) + (0, $8XSk1.getPostClones)(spec) + childrenCount;
            var trackWidth = 100 / _this.props.slidesToShow * slideCount;
            var slideWidth = 100 / slideCount;
            var trackLeft = -slideWidth * ((0, $8XSk1.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
            if (_this.props.centerMode) trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
            var trackStyle = {
                width: trackWidth + "%",
                left: trackLeft + "%"
            };
            return {
                slideWidth: slideWidth + "%",
                trackStyle: trackStyle
            };
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "checkImagesLoad", function() {
            var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
            var imagesCount = images.length, loadedCount = 0;
            Array.prototype.forEach.call(images, function(image) {
                var handler = function handler() {
                    return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
                };
                if (!image.onclick) image.onclick = function() {
                    return image.parentNode.focus();
                };
                else {
                    var prevClickHandler = image.onclick;
                    image.onclick = function(e) {
                        prevClickHandler(e);
                        image.parentNode.focus();
                    };
                }
                if (!image.onload) {
                    if (_this.props.lazyLoad) image.onload = function() {
                        _this.adaptHeight();
                        _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
                    };
                    else {
                        image.onload = handler;
                        image.onerror = function() {
                            handler();
                            _this.props.onLazyLoadError && _this.props.onLazyLoadError();
                        };
                    }
                }
            });
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "progressiveLazyLoad", function() {
            var slidesToLoad = [];
            var spec = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state);
            for(var index = _this.state.currentSlide; index < _this.state.slideCount + (0, $8XSk1.getPostClones)(spec); index++)if (_this.state.lazyLoadedList.indexOf(index) < 0) {
                slidesToLoad.push(index);
                break;
            }
            for(var _index = _this.state.currentSlide - 1; _index >= -(0, $8XSk1.getPreClones)(spec); _index--)if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
                slidesToLoad.push(_index);
                break;
            }
            if (slidesToLoad.length > 0) {
                _this.setState(function(state) {
                    return {
                        lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
                    };
                });
                if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
            } else if (_this.lazyLoadTimer) {
                clearInterval(_this.lazyLoadTimer);
                delete _this.lazyLoadTimer;
            }
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "slideHandler", function(index) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var _this$props = _this.props, asNavFor = _this$props.asNavFor, beforeChange = _this$props.beforeChange, onLazyLoad = _this$props.onLazyLoad, speed = _this$props.speed, afterChange = _this$props.afterChange; // capture currentslide before state is updated
            var currentSlide = _this.state.currentSlide;
            var _slideHandler = (0, $8XSk1.slideHandler)($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({
                index: index
            }, _this.props), _this.state), {}, {
                trackRef: _this.track,
                useCSS: _this.props.useCSS && !dontAnimate
            })), state = _slideHandler.state, nextState = _slideHandler.nextState;
            if (!state) return;
            beforeChange && beforeChange(currentSlide, state.currentSlide);
            var slidesToLoad = state.lazyLoadedList.filter(function(value) {
                return _this.state.lazyLoadedList.indexOf(value) < 0;
            });
            onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
            if (!_this.props.waitForAnimate && _this.animationEndCallback) {
                clearTimeout(_this.animationEndCallback);
                afterChange && afterChange(currentSlide);
                delete _this.animationEndCallback;
            }
            _this.setState(state, function() {
                // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
                if (asNavFor && _this.asNavForIndex !== index) {
                    _this.asNavForIndex = index;
                    asNavFor.innerSlider.slideHandler(index);
                }
                if (!nextState) return;
                _this.animationEndCallback = setTimeout(function() {
                    var animating = nextState.animating, firstBatch = $21262ba2c71116ec$var$_objectWithoutProperties(nextState, [
                        "animating"
                    ]);
                    _this.setState(firstBatch, function() {
                        _this.callbackTimers.push(setTimeout(function() {
                            return _this.setState({
                                animating: animating
                            });
                        }, 10));
                        afterChange && afterChange(state.currentSlide);
                        delete _this.animationEndCallback;
                    });
                }, speed);
            });
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "changeSlide", function(options) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var spec = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state);
            var targetSlide = (0, $8XSk1.changeSlide)(spec, options);
            if (targetSlide !== 0 && !targetSlide) return;
            if (dontAnimate === true) _this.slideHandler(targetSlide, dontAnimate);
            else _this.slideHandler(targetSlide);
            _this.props.autoplay && _this.autoPlay("update");
            if (_this.props.focusOnSelect) {
                var nodes = _this.list.querySelectorAll(".slick-current");
                nodes[0] && nodes[0].focus();
            }
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "clickHandler", function(e) {
            if (_this.clickable === false) {
                e.stopPropagation();
                e.preventDefault();
            }
            _this.clickable = true;
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "keyHandler", function(e) {
            var dir = (0, $8XSk1.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
            dir !== "" && _this.changeSlide({
                message: dir
            });
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "selectHandler", function(options) {
            _this.changeSlide(options);
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "disableBodyScroll", function() {
            var preventDefault = function preventDefault(e) {
                e = e || window.event;
                if (e.preventDefault) e.preventDefault();
                e.returnValue = false;
            };
            window.ontouchmove = preventDefault;
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "enableBodyScroll", function() {
            window.ontouchmove = null;
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "swipeStart", function(e) {
            if (_this.props.verticalSwiping) _this.disableBodyScroll();
            var state = (0, $8XSk1.swipeStart)(e, _this.props.swipe, _this.props.draggable);
            state !== "" && _this.setState(state);
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "swipeMove", function(e) {
            var state = (0, $8XSk1.swipeMove)(e, $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            if (state["swiping"]) _this.clickable = false;
            _this.setState(state);
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "swipeEnd", function(e) {
            var state = (0, $8XSk1.swipeEnd)(e, $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            var triggerSlideHandler = state["triggerSlideHandler"];
            delete state["triggerSlideHandler"];
            _this.setState(state);
            if (triggerSlideHandler === undefined) return;
            _this.slideHandler(triggerSlideHandler);
            if (_this.props.verticalSwiping) _this.enableBodyScroll();
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "touchEnd", function(e) {
            _this.swipeEnd(e);
            _this.clickable = true;
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "slickPrev", function() {
            // this and fellow methods are wrapped in setTimeout
            // to make sure initialize setState has happened before
            // any of such methods are called
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "previous"
                });
            }, 0));
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "slickNext", function() {
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "next"
                });
            }, 0));
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            slide = Number(slide);
            if (isNaN(slide)) return "";
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "index",
                    index: slide,
                    currentSlide: _this.state.currentSlide
                }, dontAnimate);
            }, 0));
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "play", function() {
            var nextIndex;
            if (_this.props.rtl) nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
            else {
                if ((0, $8XSk1.canGoNext)($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state))) nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
                else return false;
            }
            _this.slideHandler(nextIndex);
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "autoPlay", function(playType) {
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            var autoplaying = _this.state.autoplaying;
            if (playType === "update") {
                if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") return;
            } else if (playType === "leave") {
                if (autoplaying === "paused" || autoplaying === "focused") return;
            } else if (playType === "blur") {
                if (autoplaying === "paused" || autoplaying === "hovered") return;
            }
            _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
            _this.setState({
                autoplaying: "playing"
            });
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "pause", function(pauseType) {
            if (_this.autoplayTimer) {
                clearInterval(_this.autoplayTimer);
                _this.autoplayTimer = null;
            }
            var autoplaying = _this.state.autoplaying;
            if (pauseType === "paused") _this.setState({
                autoplaying: "paused"
            });
            else if (pauseType === "focused") {
                if (autoplaying === "hovered" || autoplaying === "playing") _this.setState({
                    autoplaying: "focused"
                });
            } else // pauseType  is 'hovered'
            if (autoplaying === "playing") _this.setState({
                autoplaying: "hovered"
            });
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "onDotsOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "onDotsLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "onTrackOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "onTrackLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "onSlideFocus", function() {
            return _this.props.autoplay && _this.pause("focused");
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "onSlideBlur", function() {
            return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "render", function() {
            var className = (0, $21262ba2c71116ec$var$_classnames["default"])("slick-slider", _this.props.className, {
                "slick-vertical": _this.props.vertical,
                "slick-initialized": true
            });
            var spec = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state);
            var trackProps = (0, $8XSk1.extractObject)(spec, [
                "fade",
                "cssEase",
                "speed",
                "infinite",
                "centerMode",
                "focusOnSelect",
                "currentSlide",
                "lazyLoad",
                "lazyLoadedList",
                "rtl",
                "slideWidth",
                "slideHeight",
                "listHeight",
                "vertical",
                "slidesToShow",
                "slidesToScroll",
                "slideCount",
                "trackStyle",
                "variableWidth",
                "unslick",
                "centerPadding",
                "targetSlide",
                "useCSS"
            ]);
            var pauseOnHover = _this.props.pauseOnHover;
            trackProps = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, trackProps), {}, {
                onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
                onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
                onMouseOver: pauseOnHover ? _this.onTrackOver : null,
                focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
            });
            var dots;
            if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
                var dotProps = (0, $8XSk1.extractObject)(spec, [
                    "dotsClass",
                    "slideCount",
                    "slidesToShow",
                    "currentSlide",
                    "slidesToScroll",
                    "clickHandler",
                    "children",
                    "customPaging",
                    "infinite",
                    "appendDots"
                ]);
                var pauseOnDotsHover = _this.props.pauseOnDotsHover;
                dotProps = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, dotProps), {}, {
                    clickHandler: _this.changeSlide,
                    onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
                    onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
                    onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
                });
                dots = /*#__PURE__*/ $21262ba2c71116ec$var$_react["default"].createElement($bmMxA.Dots, dotProps);
            }
            var prevArrow, nextArrow;
            var arrowProps = (0, $8XSk1.extractObject)(spec, [
                "infinite",
                "centerMode",
                "currentSlide",
                "slideCount",
                "slidesToShow",
                "prevArrow",
                "nextArrow"
            ]);
            arrowProps.clickHandler = _this.changeSlide;
            if (_this.props.arrows) {
                prevArrow = /*#__PURE__*/ $21262ba2c71116ec$var$_react["default"].createElement($49Fws.PrevArrow, arrowProps);
                nextArrow = /*#__PURE__*/ $21262ba2c71116ec$var$_react["default"].createElement($49Fws.NextArrow, arrowProps);
            }
            var verticalHeightStyle = null;
            if (_this.props.vertical) verticalHeightStyle = {
                height: _this.state.listHeight
            };
            var centerPaddingStyle = null;
            if (_this.props.vertical === false) {
                if (_this.props.centerMode === true) centerPaddingStyle = {
                    padding: "0px " + _this.props.centerPadding
                };
            } else if (_this.props.centerMode === true) centerPaddingStyle = {
                padding: _this.props.centerPadding + " 0px"
            };
            var listStyle = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, verticalHeightStyle), centerPaddingStyle);
            var touchMove = _this.props.touchMove;
            var listProps = {
                className: "slick-list",
                style: listStyle,
                onClick: _this.clickHandler,
                onMouseDown: touchMove ? _this.swipeStart : null,
                onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onMouseUp: touchMove ? _this.swipeEnd : null,
                onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onTouchStart: touchMove ? _this.swipeStart : null,
                onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onTouchEnd: touchMove ? _this.touchEnd : null,
                onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onKeyDown: _this.props.accessibility ? _this.keyHandler : null
            };
            var innerSliderProps = {
                className: className,
                dir: "ltr",
                style: _this.props.style
            };
            if (_this.props.unslick) {
                listProps = {
                    className: "slick-list"
                };
                innerSliderProps = {
                    className: className
                };
            }
            return /*#__PURE__*/ $21262ba2c71116ec$var$_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/ $21262ba2c71116ec$var$_react["default"].createElement("div", $21262ba2c71116ec$var$_extends({
                ref: _this.listRefHandler
            }, listProps), /*#__PURE__*/ $21262ba2c71116ec$var$_react["default"].createElement($2DkJA.Track, $21262ba2c71116ec$var$_extends({
                ref: _this.trackRefHandler
            }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
        });
        _this.list = null;
        _this.track = null;
        _this.state = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, $21262ba2c71116ec$var$_initialState["default"]), {}, {
            currentSlide: _this.props.initialSlide,
            targetSlide: _this.props.initialSlide ? _this.props.initialSlide : 0,
            slideCount: $21262ba2c71116ec$var$_react["default"].Children.count(_this.props.children)
        });
        _this.callbackTimers = [];
        _this.clickable = true;
        _this.debouncedResize = null;
        var ssrState = _this.ssrInit();
        _this.state = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.state), ssrState);
        return _this;
    }
    $21262ba2c71116ec$var$_createClass(InnerSlider, [
        {
            key: "didPropsChange",
            value: function didPropsChange(prevProps) {
                var setTrackStyle = false;
                for(var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++){
                    var key = _Object$keys[_i3];
                    if (!prevProps.hasOwnProperty(key)) {
                        setTrackStyle = true;
                        break;
                    }
                    if ($21262ba2c71116ec$var$_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function" || isNaN(prevProps[key])) continue;
                    if (prevProps[key] !== this.props[key]) {
                        setTrackStyle = true;
                        break;
                    }
                }
                return setTrackStyle || $21262ba2c71116ec$var$_react["default"].Children.count(this.props.children) !== $21262ba2c71116ec$var$_react["default"].Children.count(prevProps.children);
            }
        }
    ]);
    return InnerSlider;
}($21262ba2c71116ec$var$_react["default"].Component);

});
parcelRegister("hFtm3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $cdcd093a5ade8651$var$initialState = {
    animating: false,
    autoplaying: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    dragging: false,
    edgeDragged: false,
    initialized: false,
    lazyLoadedList: [],
    listHeight: null,
    listWidth: null,
    scrolling: false,
    slideCount: null,
    slideHeight: null,
    slideWidth: null,
    swipeLeft: null,
    swiped: false,
    // used by swipeEvent. differentites between touch and swipe.
    swiping: false,
    touchObject: {
        startX: 0,
        startY: 0,
        curX: 0,
        curY: 0
    },
    trackStyle: {},
    trackWidth: 0,
    targetSlide: 0
};
var $cdcd093a5ade8651$var$_default = module.exports["default"] = $cdcd093a5ade8651$var$initialState;

});

parcelRegister("krOQK", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ 
var $YtE9h = parcelRequire("YtE9h");
var $ee2dc5fddd2d168b$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $ee2dc5fddd2d168b$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $ee2dc5fddd2d168b$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $ee2dc5fddd2d168b$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $ee2dc5fddd2d168b$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $ee2dc5fddd2d168b$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $ee2dc5fddd2d168b$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $ee2dc5fddd2d168b$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $ee2dc5fddd2d168b$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $ee2dc5fddd2d168b$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $ee2dc5fddd2d168b$var$root = $ee2dc5fddd2d168b$var$freeGlobal || $ee2dc5fddd2d168b$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $ee2dc5fddd2d168b$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ee2dc5fddd2d168b$var$objectToString = $ee2dc5fddd2d168b$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ee2dc5fddd2d168b$var$nativeMax = Math.max, $ee2dc5fddd2d168b$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $ee2dc5fddd2d168b$var$now = function now() {
    return $ee2dc5fddd2d168b$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $ee2dc5fddd2d168b$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($ee2dc5fddd2d168b$var$FUNC_ERROR_TEXT);
    wait = $ee2dc5fddd2d168b$var$toNumber(wait) || 0;
    if ($ee2dc5fddd2d168b$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $ee2dc5fddd2d168b$var$nativeMax($ee2dc5fddd2d168b$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $ee2dc5fddd2d168b$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $ee2dc5fddd2d168b$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($ee2dc5fddd2d168b$var$now());
    }
    function debounced() {
        var time = $ee2dc5fddd2d168b$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $ee2dc5fddd2d168b$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value);
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $ee2dc5fddd2d168b$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $ee2dc5fddd2d168b$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) == "symbol" || $ee2dc5fddd2d168b$var$isObjectLike(value) && $ee2dc5fddd2d168b$var$objectToString.call(value) == $ee2dc5fddd2d168b$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $ee2dc5fddd2d168b$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($ee2dc5fddd2d168b$var$isSymbol(value)) return $ee2dc5fddd2d168b$var$NAN;
    if ($ee2dc5fddd2d168b$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $ee2dc5fddd2d168b$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($ee2dc5fddd2d168b$var$reTrim, "");
    var isBinary = $ee2dc5fddd2d168b$var$reIsBinary.test(value);
    return isBinary || $ee2dc5fddd2d168b$var$reIsOctal.test(value) ? $ee2dc5fddd2d168b$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $ee2dc5fddd2d168b$var$reIsBadHex.test(value) ? $ee2dc5fddd2d168b$var$NAN : +value;
}
module.exports = $ee2dc5fddd2d168b$var$debounce;

});

parcelRegister("eR2a2", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("8XSk1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkSpecKeys = module.exports.checkNavigable = module.exports.changeSlide = module.exports.canUseDOM = module.exports.canGoNext = void 0;
module.exports.clamp = $686df89f63b82ce3$var$clamp;
module.exports.extractObject = void 0;
module.exports.filterSettings = $686df89f63b82ce3$var$filterSettings;
module.exports.validSettings = module.exports.swipeStart = module.exports.swipeMove = module.exports.swipeEnd = module.exports.slidesOnRight = module.exports.slidesOnLeft = module.exports.slideHandler = module.exports.siblingDirection = module.exports.safePreventDefault = module.exports.lazyStartIndex = module.exports.lazySlidesOnRight = module.exports.lazySlidesOnLeft = module.exports.lazyEndIndex = module.exports.keyHandler = module.exports.initializedState = module.exports.getWidth = module.exports.getTrackLeft = module.exports.getTrackCSS = module.exports.getTrackAnimateCSS = module.exports.getTotalSlides = module.exports.getSwipeDirection = module.exports.getSlideCount = module.exports.getRequiredLazySlides = module.exports.getPreClones = module.exports.getPostClones = module.exports.getOnDemandLazySlides = module.exports.getNavigableIndexes = module.exports.getHeight = void 0;

var $686df89f63b82ce3$var$_react = $686df89f63b82ce3$var$_interopRequireDefault((parcelRequire("fIwXP")));

var $686df89f63b82ce3$var$_defaultProps = $686df89f63b82ce3$var$_interopRequireDefault((parcelRequire("ZEwRt")));
function $686df89f63b82ce3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $686df89f63b82ce3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $686df89f63b82ce3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $686df89f63b82ce3$var$_typeof(o);
}
function $686df89f63b82ce3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $686df89f63b82ce3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $686df89f63b82ce3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $686df89f63b82ce3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $686df89f63b82ce3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $686df89f63b82ce3$var$_defineProperty(obj, key, value) {
    key = $686df89f63b82ce3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $686df89f63b82ce3$var$_toPropertyKey(t) {
    var i = $686df89f63b82ce3$var$_toPrimitive(t, "string");
    return "symbol" == $686df89f63b82ce3$var$_typeof(i) ? i : String(i);
}
function $686df89f63b82ce3$var$_toPrimitive(t, r) {
    if ("object" != $686df89f63b82ce3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $686df89f63b82ce3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $686df89f63b82ce3$var$clamp(number, lowerBound, upperBound) {
    return Math.max(lowerBound, Math.min(number, upperBound));
}
var $686df89f63b82ce3$var$safePreventDefault = module.exports.safePreventDefault = function safePreventDefault(event) {
    var passiveEvents = [
        "onTouchStart",
        "onTouchMove",
        "onWheel"
    ];
    if (!passiveEvents.includes(event._reactName)) event.preventDefault();
};
var $686df89f63b82ce3$var$getOnDemandLazySlides = module.exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
    var onDemandSlides = [];
    var startIndex = $686df89f63b82ce3$var$lazyStartIndex(spec);
    var endIndex = $686df89f63b82ce3$var$lazyEndIndex(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)if (spec.lazyLoadedList.indexOf(slideIndex) < 0) onDemandSlides.push(slideIndex);
    return onDemandSlides;
};
// return list of slides that need to be present
var $686df89f63b82ce3$var$getRequiredLazySlides = module.exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
    var requiredSlides = [];
    var startIndex = $686df89f63b82ce3$var$lazyStartIndex(spec);
    var endIndex = $686df89f63b82ce3$var$lazyEndIndex(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)requiredSlides.push(slideIndex);
    return requiredSlides;
};
// startIndex that needs to be present
var $686df89f63b82ce3$var$lazyStartIndex = module.exports.lazyStartIndex = function lazyStartIndex(spec) {
    return spec.currentSlide - $686df89f63b82ce3$var$lazySlidesOnLeft(spec);
};
var $686df89f63b82ce3$var$lazyEndIndex = module.exports.lazyEndIndex = function lazyEndIndex(spec) {
    return spec.currentSlide + $686df89f63b82ce3$var$lazySlidesOnRight(spec);
};
var $686df89f63b82ce3$var$lazySlidesOnLeft = module.exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
    return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var $686df89f63b82ce3$var$lazySlidesOnRight = module.exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
    return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};
// get width of an element
var $686df89f63b82ce3$var$getWidth = module.exports.getWidth = function getWidth(elem) {
    return elem && elem.offsetWidth || 0;
};
var $686df89f63b82ce3$var$getHeight = module.exports.getHeight = function getHeight(elem) {
    return elem && elem.offsetHeight || 0;
};
var $686df89f63b82ce3$var$getSwipeDirection = module.exports.getSwipeDirection = function getSwipeDirection(touchObject) {
    var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var xDist, yDist, r, swipeAngle;
    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) swipeAngle = 360 - Math.abs(swipeAngle);
    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) return "left";
    if (swipeAngle >= 135 && swipeAngle <= 225) return "right";
    if (verticalSwiping === true) {
        if (swipeAngle >= 35 && swipeAngle <= 135) return "up";
        else return "down";
    }
    return "vertical";
};
// whether or not we can go next
var $686df89f63b82ce3$var$canGoNext = module.exports.canGoNext = function canGoNext(spec) {
    var canGo = true;
    if (!spec.infinite) {
        if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) canGo = false;
        else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) canGo = false;
    }
    return canGo;
};
// given an object and a list of keys, return new object with given keys
var $686df89f63b82ce3$var$extractObject = module.exports.extractObject = function extractObject(spec, keys) {
    var newObject = {};
    keys.forEach(function(key) {
        return newObject[key] = spec[key];
    });
    return newObject;
};
// get initialized state
var $686df89f63b82ce3$var$initializedState = module.exports.initializedState = function initializedState(spec) {
    // spec also contains listRef, trackRef
    var slideCount = $686df89f63b82ce3$var$_react["default"].Children.count(spec.children);
    var listNode = spec.listRef;
    var listWidth = Math.ceil($686df89f63b82ce3$var$getWidth(listNode));
    var trackNode = spec.trackRef && spec.trackRef.node;
    var trackWidth = Math.ceil($686df89f63b82ce3$var$getWidth(trackNode));
    var slideWidth;
    if (!spec.vertical) {
        var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
        if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") centerPaddingAdj *= listWidth / 100;
        slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
    } else slideWidth = listWidth;
    var slideHeight = listNode && $686df89f63b82ce3$var$getHeight(listNode.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * spec.slidesToShow;
    var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
    if (spec.rtl && spec.currentSlide === undefined) currentSlide = slideCount - 1 - spec.initialSlide;
    var lazyLoadedList = spec.lazyLoadedList || [];
    var slidesToLoad = $686df89f63b82ce3$var$getOnDemandLazySlides($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
        currentSlide: currentSlide,
        lazyLoadedList: lazyLoadedList
    }));
    lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
    var state = {
        slideCount: slideCount,
        slideWidth: slideWidth,
        listWidth: listWidth,
        trackWidth: trackWidth,
        currentSlide: currentSlide,
        slideHeight: slideHeight,
        listHeight: listHeight,
        lazyLoadedList: lazyLoadedList
    };
    if (spec.autoplaying === null && spec.autoplay) state["autoplaying"] = "playing";
    return state;
};
var $686df89f63b82ce3$var$slideHandler = module.exports.slideHandler = function slideHandler(spec) {
    var waitForAnimate = spec.waitForAnimate, animating = spec.animating, fade = spec.fade, infinite = spec.infinite, index = spec.index, slideCount = spec.slideCount, lazyLoad = spec.lazyLoad, currentSlide = spec.currentSlide, centerMode = spec.centerMode, slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, useCSS = spec.useCSS;
    var lazyLoadedList = spec.lazyLoadedList;
    if (waitForAnimate && animating) return {};
    var animationSlide = index, finalSlide, animationLeft, finalLeft;
    var state = {}, nextState = {};
    var targetSlide = infinite ? index : $686df89f63b82ce3$var$clamp(index, 0, slideCount - 1);
    if (fade) {
        if (!infinite && (index < 0 || index >= slideCount)) return {};
        if (index < 0) animationSlide = index + slideCount;
        else if (index >= slideCount) animationSlide = index - slideCount;
        if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) lazyLoadedList = lazyLoadedList.concat(animationSlide);
        state = {
            animating: true,
            currentSlide: animationSlide,
            lazyLoadedList: lazyLoadedList,
            targetSlide: animationSlide
        };
        nextState = {
            animating: false,
            targetSlide: animationSlide
        };
    } else {
        finalSlide = animationSlide;
        if (animationSlide < 0) {
            finalSlide = animationSlide + slideCount;
            if (!infinite) finalSlide = 0;
            else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
        } else if (!$686df89f63b82ce3$var$canGoNext(spec) && animationSlide > currentSlide) animationSlide = finalSlide = currentSlide;
        else if (centerMode && animationSlide >= slideCount) {
            animationSlide = infinite ? slideCount : slideCount - 1;
            finalSlide = infinite ? 0 : slideCount - 1;
        } else if (animationSlide >= slideCount) {
            finalSlide = animationSlide - slideCount;
            if (!infinite) finalSlide = slideCount - slidesToShow;
            else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
        }
        if (!infinite && animationSlide + slidesToShow >= slideCount) finalSlide = slideCount - slidesToShow;
        animationLeft = $686df89f63b82ce3$var$getTrackLeft($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
            slideIndex: animationSlide
        }));
        finalLeft = $686df89f63b82ce3$var$getTrackLeft($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
            slideIndex: finalSlide
        }));
        if (!infinite) {
            if (animationLeft === finalLeft) animationSlide = finalSlide;
            animationLeft = finalLeft;
        }
        if (lazyLoad) lazyLoadedList = lazyLoadedList.concat($686df89f63b82ce3$var$getOnDemandLazySlides($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
            currentSlide: animationSlide
        })));
        if (!useCSS) state = {
            currentSlide: finalSlide,
            trackStyle: $686df89f63b82ce3$var$getTrackCSS($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
                left: finalLeft
            })),
            lazyLoadedList: lazyLoadedList,
            targetSlide: targetSlide
        };
        else {
            state = {
                animating: true,
                currentSlide: finalSlide,
                trackStyle: $686df89f63b82ce3$var$getTrackAnimateCSS($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
                    left: animationLeft
                })),
                lazyLoadedList: lazyLoadedList,
                targetSlide: targetSlide
            };
            nextState = {
                animating: false,
                currentSlide: finalSlide,
                trackStyle: $686df89f63b82ce3$var$getTrackCSS($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
                    left: finalLeft
                })),
                swipeLeft: null,
                targetSlide: targetSlide
            };
        }
    }
    return {
        state: state,
        nextState: nextState
    };
};
var $686df89f63b82ce3$var$changeSlide = module.exports.changeSlide = function changeSlide(spec, options) {
    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
    var slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, slideCount = spec.slideCount, currentSlide = spec.currentSlide, previousTargetSlide = spec.targetSlide, lazyLoad = spec.lazyLoad, infinite = spec.infinite;
    unevenOffset = slideCount % slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
    if (options.message === "previous") {
        slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
        targetSlide = currentSlide - slideOffset;
        if (lazyLoad && !infinite) {
            previousInt = currentSlide - slideOffset;
            targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
        }
        if (!infinite) targetSlide = previousTargetSlide - slidesToScroll;
    } else if (options.message === "next") {
        slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
        targetSlide = currentSlide + slideOffset;
        if (lazyLoad && !infinite) targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
        if (!infinite) targetSlide = previousTargetSlide + slidesToScroll;
    } else if (options.message === "dots") // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    else if (options.message === "children") {
        // Click on the slides
        targetSlide = options.index;
        if (infinite) {
            var direction = $686df89f63b82ce3$var$siblingDirection($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
                targetSlide: targetSlide
            }));
            if (targetSlide > options.currentSlide && direction === "left") targetSlide = targetSlide - slideCount;
            else if (targetSlide < options.currentSlide && direction === "right") targetSlide = targetSlide + slideCount;
        }
    } else if (options.message === "index") targetSlide = Number(options.index);
    return targetSlide;
};
var $686df89f63b82ce3$var$keyHandler = module.exports.keyHandler = function keyHandler(e, accessibility, rtl) {
    if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
    if (e.keyCode === 37) return rtl ? "next" : "previous";
    if (e.keyCode === 39) return rtl ? "previous" : "next";
    return "";
};
var $686df89f63b82ce3$var$swipeStart = module.exports.swipeStart = function swipeStart(e, swipe, draggable) {
    e.target.tagName === "IMG" && $686df89f63b82ce3$var$safePreventDefault(e);
    if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
    return {
        dragging: true,
        touchObject: {
            startX: e.touches ? e.touches[0].pageX : e.clientX,
            startY: e.touches ? e.touches[0].pageY : e.clientY,
            curX: e.touches ? e.touches[0].pageX : e.clientX,
            curY: e.touches ? e.touches[0].pageY : e.clientY
        }
    };
};
var $686df89f63b82ce3$var$swipeMove = module.exports.swipeMove = function swipeMove(e, spec) {
    // spec also contains, trackRef and slideIndex
    var scrolling = spec.scrolling, animating = spec.animating, vertical = spec.vertical, swipeToSlide = spec.swipeToSlide, verticalSwiping = spec.verticalSwiping, rtl = spec.rtl, currentSlide = spec.currentSlide, edgeFriction = spec.edgeFriction, edgeDragged = spec.edgeDragged, onEdge = spec.onEdge, swiped = spec.swiped, swiping = spec.swiping, slideCount = spec.slideCount, slidesToScroll = spec.slidesToScroll, infinite = spec.infinite, touchObject = spec.touchObject, swipeEvent = spec.swipeEvent, listHeight = spec.listHeight, listWidth = spec.listWidth;
    if (scrolling) return;
    if (animating) return $686df89f63b82ce3$var$safePreventDefault(e);
    if (vertical && swipeToSlide && verticalSwiping) $686df89f63b82ce3$var$safePreventDefault(e);
    var swipeLeft, state = {};
    var curLeft = $686df89f63b82ce3$var$getTrackLeft(spec);
    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
    if (!verticalSwiping && !swiping && verticalSwipeLength > 10) return {
        scrolling: true
    };
    if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
    var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
    if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
    var dotCount = Math.ceil(slideCount / slidesToScroll);
    var swipeDirection = $686df89f63b82ce3$var$getSwipeDirection(spec.touchObject, verticalSwiping);
    var touchSwipeLength = touchObject.swipeLength;
    if (!infinite) {
        if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !$686df89f63b82ce3$var$canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
            touchSwipeLength = touchObject.swipeLength * edgeFriction;
            if (edgeDragged === false && onEdge) {
                onEdge(swipeDirection);
                state["edgeDragged"] = true;
            }
        }
    }
    if (!swiped && swipeEvent) {
        swipeEvent(swipeDirection);
        state["swiped"] = true;
    }
    if (!vertical) {
        if (!rtl) swipeLeft = curLeft + touchSwipeLength * positionOffset;
        else swipeLeft = curLeft - touchSwipeLength * positionOffset;
    } else swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
    if (verticalSwiping) swipeLeft = curLeft + touchSwipeLength * positionOffset;
    state = $686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, state), {}, {
        touchObject: touchObject,
        swipeLeft: swipeLeft,
        trackStyle: $686df89f63b82ce3$var$getTrackCSS($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
            left: swipeLeft
        }))
    });
    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) return state;
    if (touchObject.swipeLength > 10) {
        state["swiping"] = true;
        $686df89f63b82ce3$var$safePreventDefault(e);
    }
    return state;
};
var $686df89f63b82ce3$var$swipeEnd = module.exports.swipeEnd = function swipeEnd(e, spec) {
    var dragging = spec.dragging, swipe = spec.swipe, touchObject = spec.touchObject, listWidth = spec.listWidth, touchThreshold = spec.touchThreshold, verticalSwiping = spec.verticalSwiping, listHeight = spec.listHeight, swipeToSlide = spec.swipeToSlide, scrolling = spec.scrolling, onSwipe = spec.onSwipe, targetSlide = spec.targetSlide, currentSlide = spec.currentSlide, infinite = spec.infinite;
    if (!dragging) {
        if (swipe) $686df89f63b82ce3$var$safePreventDefault(e);
        return {};
    }
    var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
    var swipeDirection = $686df89f63b82ce3$var$getSwipeDirection(touchObject, verticalSwiping);
    // reset the state of touch related state variables.
    var state = {
        dragging: false,
        edgeDragged: false,
        scrolling: false,
        swiping: false,
        swiped: false,
        swipeLeft: null,
        touchObject: {}
    };
    if (scrolling) return state;
    if (!touchObject.swipeLength) return state;
    if (touchObject.swipeLength > minSwipe) {
        $686df89f63b82ce3$var$safePreventDefault(e);
        if (onSwipe) onSwipe(swipeDirection);
        var slideCount, newSlide;
        var activeSlide = infinite ? currentSlide : targetSlide;
        switch(swipeDirection){
            case "left":
            case "up":
                newSlide = activeSlide + $686df89f63b82ce3$var$getSlideCount(spec);
                slideCount = swipeToSlide ? $686df89f63b82ce3$var$checkNavigable(spec, newSlide) : newSlide;
                state["currentDirection"] = 0;
                break;
            case "right":
            case "down":
                newSlide = activeSlide - $686df89f63b82ce3$var$getSlideCount(spec);
                slideCount = swipeToSlide ? $686df89f63b82ce3$var$checkNavigable(spec, newSlide) : newSlide;
                state["currentDirection"] = 1;
                break;
            default:
                slideCount = activeSlide;
        }
        state["triggerSlideHandler"] = slideCount;
    } else {
        // Adjust the track back to it's original position.
        var currentLeft = $686df89f63b82ce3$var$getTrackLeft(spec);
        state["trackStyle"] = $686df89f63b82ce3$var$getTrackAnimateCSS($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
            left: currentLeft
        }));
    }
    return state;
};
var $686df89f63b82ce3$var$getNavigableIndexes = module.exports.getNavigableIndexes = function getNavigableIndexes(spec) {
    var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
    var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
    var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
    var indexes = [];
    while(breakpoint < max){
        indexes.push(breakpoint);
        breakpoint = counter + spec.slidesToScroll;
        counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
    }
    return indexes;
};
var $686df89f63b82ce3$var$checkNavigable = module.exports.checkNavigable = function checkNavigable(spec, index) {
    var navigables = $686df89f63b82ce3$var$getNavigableIndexes(spec);
    var prevNavigable = 0;
    if (index > navigables[navigables.length - 1]) index = navigables[navigables.length - 1];
    else for(var n in navigables){
        if (index < navigables[n]) {
            index = prevNavigable;
            break;
        }
        prevNavigable = navigables[n];
    }
    return index;
};
var $686df89f63b82ce3$var$getSlideCount = module.exports.getSlideCount = function getSlideCount(spec) {
    var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
    if (spec.swipeToSlide) {
        var swipedSlide;
        var slickList = spec.listRef;
        var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
        Array.from(slides).every(function(slide) {
            if (!spec.vertical) {
                if (slide.offsetLeft - centerOffset + $686df89f63b82ce3$var$getWidth(slide) / 2 > spec.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            } else if (slide.offsetTop + $686df89f63b82ce3$var$getHeight(slide) / 2 > spec.swipeLeft * -1) {
                swipedSlide = slide;
                return false;
            }
            return true;
        });
        if (!swipedSlide) return 0;
        var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
        var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
        return slidesTraversed;
    } else return spec.slidesToScroll;
};
var $686df89f63b82ce3$var$checkSpecKeys = module.exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
    return keysArray.reduce(function(value, key) {
        return value && spec.hasOwnProperty(key);
    }, true) ? null : console.error("Keys Missing:", spec);
};
var $686df89f63b82ce3$var$getTrackCSS = module.exports.getTrackCSS = function getTrackCSS(spec) {
    $686df89f63b82ce3$var$checkSpecKeys(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth"
    ]);
    var trackWidth, trackHeight;
    var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
    if (!spec.vertical) trackWidth = $686df89f63b82ce3$var$getTotalSlides(spec) * spec.slideWidth;
    else trackHeight = trackChildren * spec.slideHeight;
    var style = {
        opacity: 1,
        transition: "",
        WebkitTransition: ""
    };
    if (spec.useTransform) {
        var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
        style = $686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, style), {}, {
            WebkitTransform: WebkitTransform,
            transform: transform,
            msTransform: msTransform
        });
    } else if (spec.vertical) style["top"] = spec.left;
    else style["left"] = spec.left;
    if (spec.fade) style = {
        opacity: 1
    };
    if (trackWidth) style.width = trackWidth;
    if (trackHeight) style.height = trackHeight;
    // Fallback for IE8
    if (window && !window.addEventListener && window.attachEvent) {
        if (!spec.vertical) style.marginLeft = spec.left + "px";
        else style.marginTop = spec.left + "px";
    }
    return style;
};
var $686df89f63b82ce3$var$getTrackAnimateCSS = module.exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
    $686df89f63b82ce3$var$checkSpecKeys(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth",
        "speed",
        "cssEase"
    ]);
    var style = $686df89f63b82ce3$var$getTrackCSS(spec);
    // useCSS is true by default so it can be undefined
    if (spec.useTransform) {
        style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
        style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
    } else if (spec.vertical) style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    else style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    return style;
};
var $686df89f63b82ce3$var$getTrackLeft = module.exports.getTrackLeft = function getTrackLeft(spec) {
    if (spec.unslick) return 0;
    $686df89f63b82ce3$var$checkSpecKeys(spec, [
        "slideIndex",
        "trackRef",
        "infinite",
        "centerMode",
        "slideCount",
        "slidesToShow",
        "slidesToScroll",
        "slideWidth",
        "listWidth",
        "variableWidth",
        "slideHeight"
    ]);
    var slideIndex = spec.slideIndex, trackRef = spec.trackRef, infinite = spec.infinite, centerMode = spec.centerMode, slideCount = spec.slideCount, slidesToShow = spec.slidesToShow, slidesToScroll = spec.slidesToScroll, slideWidth = spec.slideWidth, listWidth = spec.listWidth, variableWidth = spec.variableWidth, slideHeight = spec.slideHeight, fade = spec.fade, vertical = spec.vertical;
    var slideOffset = 0;
    var targetLeft;
    var targetSlide;
    var verticalOffset = 0;
    if (fade || spec.slideCount === 1) return 0;
    var slidesToOffset = 0;
    if (infinite) {
        slidesToOffset = -$686df89f63b82ce3$var$getPreClones(spec); // bring active slide to the beginning of visual area
        // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
        // shift current slide to center of the frame
        if (centerMode) slidesToOffset += parseInt(slidesToShow / 2);
    } else {
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = slidesToShow - slideCount % slidesToScroll;
        if (centerMode) slidesToOffset = parseInt(slidesToShow / 2);
    }
    slideOffset = slidesToOffset * slideWidth;
    verticalOffset = slidesToOffset * slideHeight;
    if (!vertical) targetLeft = slideIndex * slideWidth * -1 + slideOffset;
    else targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
    if (variableWidth === true) {
        var targetSlideIndex;
        var trackElem = trackRef && trackRef.node;
        targetSlideIndex = slideIndex + $686df89f63b82ce3$var$getPreClones(spec);
        targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
        targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
        if (centerMode === true) {
            targetSlideIndex = infinite ? slideIndex + $686df89f63b82ce3$var$getPreClones(spec) : slideIndex;
            targetSlide = trackElem && trackElem.children[targetSlideIndex];
            targetLeft = 0;
            for(var slide = 0; slide < targetSlideIndex; slide++)targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
            targetLeft -= parseInt(spec.centerPadding);
            targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
        }
    }
    return targetLeft;
};
var $686df89f63b82ce3$var$getPreClones = module.exports.getPreClones = function getPreClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    if (spec.variableWidth) return spec.slideCount;
    return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
var $686df89f63b82ce3$var$getPostClones = module.exports.getPostClones = function getPostClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    return spec.slideCount;
};
var $686df89f63b82ce3$var$getTotalSlides = module.exports.getTotalSlides = function getTotalSlides(spec) {
    return spec.slideCount === 1 ? 1 : $686df89f63b82ce3$var$getPreClones(spec) + spec.slideCount + $686df89f63b82ce3$var$getPostClones(spec);
};
var $686df89f63b82ce3$var$siblingDirection = module.exports.siblingDirection = function siblingDirection(spec) {
    if (spec.targetSlide > spec.currentSlide) {
        if (spec.targetSlide > spec.currentSlide + $686df89f63b82ce3$var$slidesOnRight(spec)) return "left";
        return "right";
    } else {
        if (spec.targetSlide < spec.currentSlide - $686df89f63b82ce3$var$slidesOnLeft(spec)) return "right";
        return "left";
    }
};
var $686df89f63b82ce3$var$slidesOnRight = module.exports.slidesOnRight = function slidesOnRight(_ref) {
    var slidesToShow = _ref.slidesToShow, centerMode = _ref.centerMode, rtl = _ref.rtl, centerPadding = _ref.centerPadding;
    // returns no of slides on the right of active slide
    if (centerMode) {
        var right = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) right += 1;
        if (rtl && slidesToShow % 2 === 0) right += 1;
        return right;
    }
    if (rtl) return 0;
    return slidesToShow - 1;
};
var $686df89f63b82ce3$var$slidesOnLeft = module.exports.slidesOnLeft = function slidesOnLeft(_ref2) {
    var slidesToShow = _ref2.slidesToShow, centerMode = _ref2.centerMode, rtl = _ref2.rtl, centerPadding = _ref2.centerPadding;
    // returns no of slides on the left of active slide
    if (centerMode) {
        var left = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) left += 1;
        if (!rtl && slidesToShow % 2 === 0) left += 1;
        return left;
    }
    if (rtl) return slidesToShow - 1;
    return 0;
};
var $686df89f63b82ce3$var$canUseDOM = module.exports.canUseDOM = function canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};
var $686df89f63b82ce3$var$validSettings = module.exports.validSettings = Object.keys($686df89f63b82ce3$var$_defaultProps["default"]);
function $686df89f63b82ce3$var$filterSettings(settings) {
    return $686df89f63b82ce3$var$validSettings.reduce(function(acc, settingName) {
        if (settings.hasOwnProperty(settingName)) acc[settingName] = settings[settingName];
        return acc;
    }, {});
}

});
parcelRegister("ZEwRt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $0b9522d7091ded2b$var$_react = $0b9522d7091ded2b$var$_interopRequireDefault((parcelRequire("fIwXP")));
function $0b9522d7091ded2b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $0b9522d7091ded2b$var$defaultProps = {
    accessibility: true,
    adaptiveHeight: false,
    afterChange: null,
    appendDots: function appendDots(dots) {
        return /*#__PURE__*/ $0b9522d7091ded2b$var$_react["default"].createElement("ul", {
            style: {
                display: "block"
            }
        }, dots);
    },
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    beforeChange: null,
    centerMode: false,
    centerPadding: "50px",
    className: "",
    cssEase: "ease",
    customPaging: function customPaging(i) {
        return /*#__PURE__*/ $0b9522d7091ded2b$var$_react["default"].createElement("button", null, i + 1);
    },
    dots: false,
    dotsClass: "slick-dots",
    draggable: true,
    easing: "linear",
    edgeFriction: 0.35,
    fade: false,
    focusOnSelect: false,
    infinite: true,
    initialSlide: 0,
    lazyLoad: null,
    nextArrow: null,
    onEdge: null,
    onInit: null,
    onLazyLoadError: null,
    onReInit: null,
    pauseOnDotsHover: false,
    pauseOnFocus: false,
    pauseOnHover: true,
    prevArrow: null,
    responsive: null,
    rows: 1,
    rtl: false,
    slide: "div",
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    swipe: true,
    swipeEvent: null,
    swipeToSlide: false,
    touchMove: true,
    touchThreshold: 5,
    useCSS: true,
    useTransform: true,
    variableWidth: false,
    vertical: false,
    waitForAnimate: true,
    asNavFor: null
};
var $0b9522d7091ded2b$var$_default = module.exports["default"] = $0b9522d7091ded2b$var$defaultProps;

});


parcelRegister("2DkJA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Track = void 0;

var $1eaf4eb0427faf1e$var$_react = $1eaf4eb0427faf1e$var$_interopRequireDefault((parcelRequire("fIwXP")));

var $1eaf4eb0427faf1e$var$_classnames = $1eaf4eb0427faf1e$var$_interopRequireDefault((parcelRequire("eR2a2")));

var $8XSk1 = parcelRequire("8XSk1");
function $1eaf4eb0427faf1e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1eaf4eb0427faf1e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1eaf4eb0427faf1e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1eaf4eb0427faf1e$var$_typeof(o);
}
function $1eaf4eb0427faf1e$var$_extends() {
    $1eaf4eb0427faf1e$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1eaf4eb0427faf1e$var$_extends.apply(this, arguments);
}
function $1eaf4eb0427faf1e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1eaf4eb0427faf1e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $1eaf4eb0427faf1e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $1eaf4eb0427faf1e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1eaf4eb0427faf1e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1eaf4eb0427faf1e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1eaf4eb0427faf1e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1eaf4eb0427faf1e$var$_setPrototypeOf(subClass, superClass);
}
function $1eaf4eb0427faf1e$var$_setPrototypeOf(o, p) {
    $1eaf4eb0427faf1e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1eaf4eb0427faf1e$var$_setPrototypeOf(o, p);
}
function $1eaf4eb0427faf1e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1eaf4eb0427faf1e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1eaf4eb0427faf1e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1eaf4eb0427faf1e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1eaf4eb0427faf1e$var$_possibleConstructorReturn(this, result);
    };
}
function $1eaf4eb0427faf1e$var$_possibleConstructorReturn(self, call) {
    if (call && ($1eaf4eb0427faf1e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1eaf4eb0427faf1e$var$_assertThisInitialized(self);
}
function $1eaf4eb0427faf1e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1eaf4eb0427faf1e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1eaf4eb0427faf1e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1eaf4eb0427faf1e$var$_getPrototypeOf(o) {
    $1eaf4eb0427faf1e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1eaf4eb0427faf1e$var$_getPrototypeOf(o);
}
function $1eaf4eb0427faf1e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1eaf4eb0427faf1e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1eaf4eb0427faf1e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1eaf4eb0427faf1e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1eaf4eb0427faf1e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1eaf4eb0427faf1e$var$_defineProperty(obj, key, value) {
    key = $1eaf4eb0427faf1e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1eaf4eb0427faf1e$var$_toPropertyKey(t) {
    var i = $1eaf4eb0427faf1e$var$_toPrimitive(t, "string");
    return "symbol" == $1eaf4eb0427faf1e$var$_typeof(i) ? i : String(i);
}
function $1eaf4eb0427faf1e$var$_toPrimitive(t, r) {
    if ("object" != $1eaf4eb0427faf1e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1eaf4eb0427faf1e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var $1eaf4eb0427faf1e$var$getSlideClasses = function getSlideClasses(spec) {
    var slickActive, slickCenter, slickCloned;
    var centerOffset, index;
    if (spec.rtl) index = spec.slideCount - 1 - spec.index;
    else index = spec.index;
    slickCloned = index < 0 || index >= spec.slideCount;
    if (spec.centerMode) {
        centerOffset = Math.floor(spec.slidesToShow / 2);
        slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
        if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) slickActive = true;
    } else slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
    var focusedSlide;
    if (spec.targetSlide < 0) focusedSlide = spec.targetSlide + spec.slideCount;
    else if (spec.targetSlide >= spec.slideCount) focusedSlide = spec.targetSlide - spec.slideCount;
    else focusedSlide = spec.targetSlide;
    var slickCurrent = index === focusedSlide;
    return {
        "slick-slide": true,
        "slick-active": slickActive,
        "slick-center": slickCenter,
        "slick-cloned": slickCloned,
        "slick-current": slickCurrent // dubious in case of RTL
    };
};
var $1eaf4eb0427faf1e$var$getSlideStyle = function getSlideStyle(spec) {
    var style = {};
    if (spec.variableWidth === undefined || spec.variableWidth === false) style.width = spec.slideWidth;
    if (spec.fade) {
        style.position = "relative";
        if (spec.vertical) style.top = -spec.index * parseInt(spec.slideHeight);
        else style.left = -spec.index * parseInt(spec.slideWidth);
        style.opacity = spec.currentSlide === spec.index ? 1 : 0;
        style.zIndex = spec.currentSlide === spec.index ? 999 : 998;
        if (spec.useCSS) style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
    return style;
};
var $1eaf4eb0427faf1e$var$getKey = function getKey(child, fallbackKey) {
    return child.key || fallbackKey;
};
var $1eaf4eb0427faf1e$var$renderSlides = function renderSlides(spec) {
    var key;
    var slides = [];
    var preCloneSlides = [];
    var postCloneSlides = [];
    var childrenCount = $1eaf4eb0427faf1e$var$_react["default"].Children.count(spec.children);
    var startIndex = (0, $8XSk1.lazyStartIndex)(spec);
    var endIndex = (0, $8XSk1.lazyEndIndex)(spec);
    $1eaf4eb0427faf1e$var$_react["default"].Children.forEach(spec.children, function(elem, index) {
        var child;
        var childOnClickOptions = {
            message: "children",
            index: index,
            slidesToScroll: spec.slidesToScroll,
            currentSlide: spec.currentSlide
        };
        // in case of lazyLoad, whether or not we want to fetch the slide
        if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) child = elem;
        else child = /*#__PURE__*/ $1eaf4eb0427faf1e$var$_react["default"].createElement("div", null);
        var childStyle = $1eaf4eb0427faf1e$var$getSlideStyle($1eaf4eb0427faf1e$var$_objectSpread($1eaf4eb0427faf1e$var$_objectSpread({}, spec), {}, {
            index: index
        }));
        var slideClass = child.props.className || "";
        var slideClasses = $1eaf4eb0427faf1e$var$getSlideClasses($1eaf4eb0427faf1e$var$_objectSpread($1eaf4eb0427faf1e$var$_objectSpread({}, spec), {}, {
            index: index
        }));
        // push a cloned element of the desired slide
        slides.push(/*#__PURE__*/ $1eaf4eb0427faf1e$var$_react["default"].cloneElement(child, {
            key: "original" + $1eaf4eb0427faf1e$var$getKey(child, index),
            "data-index": index,
            className: (0, $1eaf4eb0427faf1e$var$_classnames["default"])(slideClasses, slideClass),
            tabIndex: "-1",
            "aria-hidden": !slideClasses["slick-active"],
            style: $1eaf4eb0427faf1e$var$_objectSpread($1eaf4eb0427faf1e$var$_objectSpread({
                outline: "none"
            }, child.props.style || {}), childStyle),
            onClick: function onClick(e) {
                child.props && child.props.onClick && child.props.onClick(e);
                if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
            }
        }));
        // if slide needs to be precloned or postcloned
        if (spec.infinite && spec.fade === false) {
            var preCloneNo = childrenCount - index;
            if (preCloneNo <= (0, $8XSk1.getPreClones)(spec)) {
                key = -preCloneNo;
                if (key >= startIndex) child = elem;
                slideClasses = $1eaf4eb0427faf1e$var$getSlideClasses($1eaf4eb0427faf1e$var$_objectSpread($1eaf4eb0427faf1e$var$_objectSpread({}, spec), {}, {
                    index: key
                }));
                preCloneSlides.push(/*#__PURE__*/ $1eaf4eb0427faf1e$var$_react["default"].cloneElement(child, {
                    key: "precloned" + $1eaf4eb0427faf1e$var$getKey(child, key),
                    "data-index": key,
                    tabIndex: "-1",
                    className: (0, $1eaf4eb0427faf1e$var$_classnames["default"])(slideClasses, slideClass),
                    "aria-hidden": !slideClasses["slick-active"],
                    style: $1eaf4eb0427faf1e$var$_objectSpread($1eaf4eb0427faf1e$var$_objectSpread({}, child.props.style || {}), childStyle),
                    onClick: function onClick(e) {
                        child.props && child.props.onClick && child.props.onClick(e);
                        if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                    }
                }));
            }
            key = childrenCount + index;
            if (key < endIndex) child = elem;
            slideClasses = $1eaf4eb0427faf1e$var$getSlideClasses($1eaf4eb0427faf1e$var$_objectSpread($1eaf4eb0427faf1e$var$_objectSpread({}, spec), {}, {
                index: key
            }));
            postCloneSlides.push(/*#__PURE__*/ $1eaf4eb0427faf1e$var$_react["default"].cloneElement(child, {
                key: "postcloned" + $1eaf4eb0427faf1e$var$getKey(child, key),
                "data-index": key,
                tabIndex: "-1",
                className: (0, $1eaf4eb0427faf1e$var$_classnames["default"])(slideClasses, slideClass),
                "aria-hidden": !slideClasses["slick-active"],
                style: $1eaf4eb0427faf1e$var$_objectSpread($1eaf4eb0427faf1e$var$_objectSpread({}, child.props.style || {}), childStyle),
                onClick: function onClick(e) {
                    child.props && child.props.onClick && child.props.onClick(e);
                    if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                }
            }));
        }
    });
    if (spec.rtl) return preCloneSlides.concat(slides, postCloneSlides).reverse();
    else return preCloneSlides.concat(slides, postCloneSlides);
};
var $1eaf4eb0427faf1e$var$Track = module.exports.Track = /*#__PURE__*/ function(_React$PureComponent) {
    $1eaf4eb0427faf1e$var$_inherits(Track, _React$PureComponent);
    var _super = $1eaf4eb0427faf1e$var$_createSuper(Track);
    function Track() {
        var _this;
        $1eaf4eb0427faf1e$var$_classCallCheck(this, Track);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $1eaf4eb0427faf1e$var$_defineProperty($1eaf4eb0427faf1e$var$_assertThisInitialized(_this), "node", null);
        $1eaf4eb0427faf1e$var$_defineProperty($1eaf4eb0427faf1e$var$_assertThisInitialized(_this), "handleRef", function(ref) {
            _this.node = ref;
        });
        return _this;
    }
    $1eaf4eb0427faf1e$var$_createClass(Track, [
        {
            key: "render",
            value: function render() {
                var slides = $1eaf4eb0427faf1e$var$renderSlides(this.props);
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave;
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                return /*#__PURE__*/ $1eaf4eb0427faf1e$var$_react["default"].createElement("div", $1eaf4eb0427faf1e$var$_extends({
                    ref: this.handleRef,
                    className: "slick-track",
                    style: this.props.trackStyle
                }, mouseEvents), slides);
            }
        }
    ]);
    return Track;
}($1eaf4eb0427faf1e$var$_react["default"].PureComponent);

});

parcelRegister("bmMxA", function(module, exports) {
"use strict";
function $846766efbe3c4105$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $846766efbe3c4105$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $846766efbe3c4105$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dots = void 0;

var $846766efbe3c4105$var$_react = $846766efbe3c4105$var$_interopRequireDefault((parcelRequire("fIwXP")));

var $846766efbe3c4105$var$_classnames = $846766efbe3c4105$var$_interopRequireDefault((parcelRequire("eR2a2")));

var $8XSk1 = parcelRequire("8XSk1");
function $846766efbe3c4105$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $846766efbe3c4105$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $846766efbe3c4105$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $846766efbe3c4105$var$ownKeys(Object(t), !0).forEach(function(r) {
            $846766efbe3c4105$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $846766efbe3c4105$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $846766efbe3c4105$var$_defineProperty(obj, key, value) {
    key = $846766efbe3c4105$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $846766efbe3c4105$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $846766efbe3c4105$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $846766efbe3c4105$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $846766efbe3c4105$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $846766efbe3c4105$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $846766efbe3c4105$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $846766efbe3c4105$var$_toPropertyKey(t) {
    var i = $846766efbe3c4105$var$_toPrimitive(t, "string");
    return "symbol" == $846766efbe3c4105$var$_typeof(i) ? i : String(i);
}
function $846766efbe3c4105$var$_toPrimitive(t, r) {
    if ("object" != $846766efbe3c4105$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $846766efbe3c4105$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $846766efbe3c4105$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $846766efbe3c4105$var$_setPrototypeOf(subClass, superClass);
}
function $846766efbe3c4105$var$_setPrototypeOf(o, p) {
    $846766efbe3c4105$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $846766efbe3c4105$var$_setPrototypeOf(o, p);
}
function $846766efbe3c4105$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $846766efbe3c4105$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $846766efbe3c4105$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $846766efbe3c4105$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $846766efbe3c4105$var$_possibleConstructorReturn(this, result);
    };
}
function $846766efbe3c4105$var$_possibleConstructorReturn(self, call) {
    if (call && ($846766efbe3c4105$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $846766efbe3c4105$var$_assertThisInitialized(self);
}
function $846766efbe3c4105$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $846766efbe3c4105$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($846766efbe3c4105$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $846766efbe3c4105$var$_getPrototypeOf(o) {
    $846766efbe3c4105$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $846766efbe3c4105$var$_getPrototypeOf(o);
}
var $846766efbe3c4105$var$getDotCount = function getDotCount(spec) {
    var dots;
    if (spec.infinite) dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
    else dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
    return dots;
};
var $846766efbe3c4105$var$Dots = module.exports.Dots = /*#__PURE__*/ function(_React$PureComponent) {
    $846766efbe3c4105$var$_inherits(Dots, _React$PureComponent);
    var _super = $846766efbe3c4105$var$_createSuper(Dots);
    function Dots() {
        $846766efbe3c4105$var$_classCallCheck(this, Dots);
        return _super.apply(this, arguments);
    }
    $846766efbe3c4105$var$_createClass(Dots, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                // In Autoplay the focus stays on clicked button even after transition
                // to next slide. That only goes away by click somewhere outside
                e.preventDefault();
                this.props.clickHandler(options);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave, infinite = _this$props.infinite, slidesToScroll = _this$props.slidesToScroll, slidesToShow = _this$props.slidesToShow, slideCount = _this$props.slideCount, currentSlide = _this$props.currentSlide;
                var dotCount = $846766efbe3c4105$var$getDotCount({
                    slideCount: slideCount,
                    slidesToScroll: slidesToScroll,
                    slidesToShow: slidesToShow,
                    infinite: infinite
                });
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                var dots = [];
                for(var i = 0; i < dotCount; i++){
                    var _rightBound = (i + 1) * slidesToScroll - 1;
                    var rightBound = infinite ? _rightBound : (0, $8XSk1.clamp)(_rightBound, 0, slideCount - 1);
                    var _leftBound = rightBound - (slidesToScroll - 1);
                    var leftBound = infinite ? _leftBound : (0, $8XSk1.clamp)(_leftBound, 0, slideCount - 1);
                    var className = (0, $846766efbe3c4105$var$_classnames["default"])({
                        "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
                    });
                    var dotOptions = {
                        message: "dots",
                        index: i,
                        slidesToScroll: slidesToScroll,
                        currentSlide: currentSlide
                    };
                    var onClick = this.clickHandler.bind(this, dotOptions);
                    dots = dots.concat(/*#__PURE__*/ $846766efbe3c4105$var$_react["default"].createElement("li", {
                        key: i,
                        className: className
                    }, /*#__PURE__*/ $846766efbe3c4105$var$_react["default"].cloneElement(this.props.customPaging(i), {
                        onClick: onClick
                    })));
                }
                return /*#__PURE__*/ $846766efbe3c4105$var$_react["default"].cloneElement(this.props.appendDots(dots), $846766efbe3c4105$var$_objectSpread({
                    className: this.props.dotsClass
                }, mouseEvents));
            }
        }
    ]);
    return Dots;
}($846766efbe3c4105$var$_react["default"].PureComponent);

});

parcelRegister("49Fws", function(module, exports) {
"use strict";
function $306836309029bd48$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $306836309029bd48$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $306836309029bd48$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrevArrow = module.exports.NextArrow = void 0;

var $306836309029bd48$var$_react = $306836309029bd48$var$_interopRequireDefault((parcelRequire("fIwXP")));

var $306836309029bd48$var$_classnames = $306836309029bd48$var$_interopRequireDefault((parcelRequire("eR2a2")));

var $8XSk1 = parcelRequire("8XSk1");
function $306836309029bd48$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $306836309029bd48$var$_extends() {
    $306836309029bd48$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $306836309029bd48$var$_extends.apply(this, arguments);
}
function $306836309029bd48$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $306836309029bd48$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $306836309029bd48$var$ownKeys(Object(t), !0).forEach(function(r) {
            $306836309029bd48$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $306836309029bd48$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $306836309029bd48$var$_defineProperty(obj, key, value) {
    key = $306836309029bd48$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $306836309029bd48$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $306836309029bd48$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $306836309029bd48$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $306836309029bd48$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $306836309029bd48$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $306836309029bd48$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $306836309029bd48$var$_toPropertyKey(t) {
    var i = $306836309029bd48$var$_toPrimitive(t, "string");
    return "symbol" == $306836309029bd48$var$_typeof(i) ? i : String(i);
}
function $306836309029bd48$var$_toPrimitive(t, r) {
    if ("object" != $306836309029bd48$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $306836309029bd48$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $306836309029bd48$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $306836309029bd48$var$_setPrototypeOf(subClass, superClass);
}
function $306836309029bd48$var$_setPrototypeOf(o, p) {
    $306836309029bd48$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $306836309029bd48$var$_setPrototypeOf(o, p);
}
function $306836309029bd48$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $306836309029bd48$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $306836309029bd48$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $306836309029bd48$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $306836309029bd48$var$_possibleConstructorReturn(this, result);
    };
}
function $306836309029bd48$var$_possibleConstructorReturn(self, call) {
    if (call && ($306836309029bd48$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $306836309029bd48$var$_assertThisInitialized(self);
}
function $306836309029bd48$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $306836309029bd48$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($306836309029bd48$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $306836309029bd48$var$_getPrototypeOf(o) {
    $306836309029bd48$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $306836309029bd48$var$_getPrototypeOf(o);
}
var $306836309029bd48$var$PrevArrow = module.exports.PrevArrow = /*#__PURE__*/ function(_React$PureComponent) {
    $306836309029bd48$var$_inherits(PrevArrow, _React$PureComponent);
    var _super = $306836309029bd48$var$_createSuper(PrevArrow);
    function PrevArrow() {
        $306836309029bd48$var$_classCallCheck(this, PrevArrow);
        return _super.apply(this, arguments);
    }
    $306836309029bd48$var$_createClass(PrevArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var prevClasses = {
                    "slick-arrow": true,
                    "slick-prev": true
                };
                var prevHandler = this.clickHandler.bind(this, {
                    message: "previous"
                });
                if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
                    prevClasses["slick-disabled"] = true;
                    prevHandler = null;
                }
                var prevArrowProps = {
                    key: "0",
                    "data-role": "none",
                    className: (0, $306836309029bd48$var$_classnames["default"])(prevClasses),
                    style: {
                        display: "block"
                    },
                    onClick: prevHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var prevArrow;
                if (this.props.prevArrow) prevArrow = /*#__PURE__*/ $306836309029bd48$var$_react["default"].cloneElement(this.props.prevArrow, $306836309029bd48$var$_objectSpread($306836309029bd48$var$_objectSpread({}, prevArrowProps), customProps));
                else prevArrow = /*#__PURE__*/ $306836309029bd48$var$_react["default"].createElement("button", $306836309029bd48$var$_extends({
                    key: "0",
                    type: "button"
                }, prevArrowProps), " ", "Previous");
                return prevArrow;
            }
        }
    ]);
    return PrevArrow;
}($306836309029bd48$var$_react["default"].PureComponent);
var $306836309029bd48$var$NextArrow = module.exports.NextArrow = /*#__PURE__*/ function(_React$PureComponent2) {
    $306836309029bd48$var$_inherits(NextArrow, _React$PureComponent2);
    var _super2 = $306836309029bd48$var$_createSuper(NextArrow);
    function NextArrow() {
        $306836309029bd48$var$_classCallCheck(this, NextArrow);
        return _super2.apply(this, arguments);
    }
    $306836309029bd48$var$_createClass(NextArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var nextClasses = {
                    "slick-arrow": true,
                    "slick-next": true
                };
                var nextHandler = this.clickHandler.bind(this, {
                    message: "next"
                });
                if (!(0, $8XSk1.canGoNext)(this.props)) {
                    nextClasses["slick-disabled"] = true;
                    nextHandler = null;
                }
                var nextArrowProps = {
                    key: "1",
                    "data-role": "none",
                    className: (0, $306836309029bd48$var$_classnames["default"])(nextClasses),
                    style: {
                        display: "block"
                    },
                    onClick: nextHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var nextArrow;
                if (this.props.nextArrow) nextArrow = /*#__PURE__*/ $306836309029bd48$var$_react["default"].cloneElement(this.props.nextArrow, $306836309029bd48$var$_objectSpread($306836309029bd48$var$_objectSpread({}, nextArrowProps), customProps));
                else nextArrow = /*#__PURE__*/ $306836309029bd48$var$_react["default"].createElement("button", $306836309029bd48$var$_extends({
                    key: "1",
                    type: "button"
                }, nextArrowProps), " ", "Next");
                return nextArrow;
            }
        }
    ]);
    return NextArrow;
}($306836309029bd48$var$_react["default"].PureComponent);

});

parcelRegister("4EfKw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $36271d587aa793ca$export$2e2bcd8739ae039; });
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $36271d587aa793ca$var$MapShim = function() {
    if (typeof Map !== "undefined") return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function get() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $36271d587aa793ca$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
// Returns global object of a current environment.
var $36271d587aa793ca$var$global$1 = function() {
    if (typeof $parcel$global !== "undefined" && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== "undefined" && self.Math === Math) return self;
    if (typeof window !== "undefined" && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function("return this")();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $36271d587aa793ca$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === "function") // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($36271d587aa793ca$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $36271d587aa793ca$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $36271d587aa793ca$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $36271d587aa793ca$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $36271d587aa793ca$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $36271d587aa793ca$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $36271d587aa793ca$var$transitionKeys = [
    "top",
    "right",
    "bottom",
    "left",
    "width",
    "height",
    "size",
    "weight"
];
// Check if MutationObserver is available.
var $36271d587aa793ca$var$mutationObserverSupported = typeof MutationObserver !== "undefined";
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $36271d587aa793ca$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $36271d587aa793ca$var$throttle(this.refresh.bind(this), $36271d587aa793ca$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$36271d587aa793ca$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener("transitionend", this.onTransitionEnd_);
        window.addEventListener("resize", this.refresh);
        if ($36271d587aa793ca$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener("DOMSubtreeModified", this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$36271d587aa793ca$var$isBrowser || !this.connected_) return;
        document.removeEventListener("transitionend", this.onTransitionEnd_);
        window.removeEventListener("resize", this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener("DOMSubtreeModified", this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $36271d587aa793ca$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $36271d587aa793ca$var$defineConfigurable = function defineConfigurable(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $36271d587aa793ca$var$getWindowOf = function getWindowOf(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $36271d587aa793ca$var$global$1;
};
// Placeholder of an empty content rectangle.
var $36271d587aa793ca$var$emptyRect = $36271d587aa793ca$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $36271d587aa793ca$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $36271d587aa793ca$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles["border-" + position + "-width"];
        return size + $36271d587aa793ca$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $36271d587aa793ca$var$getPaddings(styles) {
    var positions = [
        "top",
        "right",
        "bottom",
        "left"
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles["padding-" + position];
        paddings[position] = $36271d587aa793ca$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $36271d587aa793ca$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $36271d587aa793ca$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $36271d587aa793ca$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $36271d587aa793ca$var$emptyRect;
    var styles = $36271d587aa793ca$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $36271d587aa793ca$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $36271d587aa793ca$var$toFloat(styles.width), height = $36271d587aa793ca$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === "border-box") {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $36271d587aa793ca$var$getBordersSize(styles, "left", "right") + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $36271d587aa793ca$var$getBordersSize(styles, "top", "bottom") + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$36271d587aa793ca$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $36271d587aa793ca$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $36271d587aa793ca$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== "undefined") return function(target) {
        return target instanceof $36271d587aa793ca$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $36271d587aa793ca$var$getWindowOf(target).SVGElement && typeof target.getBBox === "function";
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $36271d587aa793ca$var$isDocumentElement(target) {
    return target === $36271d587aa793ca$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $36271d587aa793ca$var$getContentRect(target) {
    if (!$36271d587aa793ca$var$isBrowser) return $36271d587aa793ca$var$emptyRect;
    if ($36271d587aa793ca$var$isSVGGraphicsElement(target)) return $36271d587aa793ca$var$getSVGContentRect(target);
    return $36271d587aa793ca$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $36271d587aa793ca$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $36271d587aa793ca$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $36271d587aa793ca$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $36271d587aa793ca$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $36271d587aa793ca$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $36271d587aa793ca$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $36271d587aa793ca$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $36271d587aa793ca$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $36271d587aa793ca$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $36271d587aa793ca$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $36271d587aa793ca$var$MapShim();
        if (typeof callback !== "function") throw new TypeError("The callback provided as parameter 1 is not a function.");
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $36271d587aa793ca$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $36271d587aa793ca$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $36271d587aa793ca$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $36271d587aa793ca$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $36271d587aa793ca$var$observers = typeof WeakMap !== "undefined" ? new WeakMap() : new $36271d587aa793ca$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $36271d587aa793ca$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var controller = $36271d587aa793ca$var$ResizeObserverController.getInstance();
        var observer = new $36271d587aa793ca$var$ResizeObserverSPI(callback, controller, this);
        $36271d587aa793ca$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    "observe",
    "unobserve",
    "disconnect"
].forEach(function(method) {
    $36271d587aa793ca$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $36271d587aa793ca$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $36271d587aa793ca$var$index = function() {
    // Export existing implementation if available.
    if (typeof $36271d587aa793ca$var$global$1.ResizeObserver !== "undefined") return $36271d587aa793ca$var$global$1.ResizeObserver;
    return $36271d587aa793ca$var$ResizeObserver;
}();
var $36271d587aa793ca$export$2e2bcd8739ae039 = $36271d587aa793ca$var$index;

});


parcelRegister("jTrNc", function(module, exports) {

var $lJYuL = parcelRequire("lJYuL");
var $e7b8b669f720bf18$var$isDimension = function isDimension(feature) {
    var re = /[height|width]$/;
    return re.test(feature);
};
var $e7b8b669f720bf18$var$obj2mq = function obj2mq(obj) {
    var mq = "";
    var features = Object.keys(obj);
    features.forEach(function(feature, index) {
        var value = obj[feature];
        feature = $lJYuL(feature);
        // Add px to dimension features
        if ($e7b8b669f720bf18$var$isDimension(feature) && typeof value === "number") value = value + "px";
        if (value === true) mq += feature;
        else if (value === false) mq += "not " + feature;
        else mq += "(" + feature + ": " + value + ")";
        if (index < features.length - 1) mq += " and ";
    });
    return mq;
};
var $e7b8b669f720bf18$var$json2mq = function json2mq(query) {
    var mq = "";
    if (typeof query === "string") return query;
    // Handling array of media queries
    if (query instanceof Array) {
        query.forEach(function(q, index) {
            mq += $e7b8b669f720bf18$var$obj2mq(q);
            if (index < query.length - 1) mq += ", ";
        });
        return mq;
    }
    // Handling single media query
    return $e7b8b669f720bf18$var$obj2mq(query);
};
module.exports = $e7b8b669f720bf18$var$json2mq;

});
parcelRegister("lJYuL", function(module, exports) {
var $fd3cba07ea16954e$var$camel2hyphen = function camel2hyphen(str) {
    return str.replace(/[A-Z]/g, function(match) {
        return "-" + match.toLowerCase();
    }).toLowerCase();
};
module.exports = $fd3cba07ea16954e$var$camel2hyphen;

});


parcelRegister("4RUun", function(module, exports) {

var $4HAd6 = parcelRequire("4HAd6");
module.exports = new $4HAd6();

});
parcelRegister("4HAd6", function(module, exports) {

var $3fyy4 = parcelRequire("3fyy4");

var $32NXA = parcelRequire("32NXA");
var $36c7443521185ca6$var$each = $32NXA.each;
var $36c7443521185ca6$var$isFunction = $32NXA.isFunction;
var $36c7443521185ca6$var$isArray = $32NXA.isArray;
/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */ function $36c7443521185ca6$var$MediaQueryDispatch() {
    if (!window.matchMedia) throw new Error("matchMedia not present, legacy browsers require a polyfill");
    this.queries = {};
    this.browserIsIncapable = !window.matchMedia("only all").matches;
}
$36c7443521185ca6$var$MediaQueryDispatch.prototype = {
    constructor: $36c7443521185ca6$var$MediaQueryDispatch,
    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */ register: function register(q, options, shouldDegrade) {
        var queries = this.queries, isUnconditional = shouldDegrade && this.browserIsIncapable;
        if (!queries[q]) queries[q] = new $3fyy4(q, isUnconditional);
        //normalise to object in an array
        if ($36c7443521185ca6$var$isFunction(options)) options = {
            match: options
        };
        if (!$36c7443521185ca6$var$isArray(options)) options = [
            options
        ];
        $36c7443521185ca6$var$each(options, function(handler) {
            if ($36c7443521185ca6$var$isFunction(handler)) handler = {
                match: handler
            };
            queries[q].addHandler(handler);
        });
        return this;
    },
    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */ unregister: function unregister(q, handler) {
        var query = this.queries[q];
        if (query) {
            if (handler) query.removeHandler(handler);
            else {
                query.clear();
                delete this.queries[q];
            }
        }
        return this;
    }
};
module.exports = $36c7443521185ca6$var$MediaQueryDispatch;

});
parcelRegister("3fyy4", function(module, exports) {

var $9Lsgs = parcelRequire("9Lsgs");

var $32NXA = parcelRequire("32NXA");
var $25dd9270f3305f11$require$each = $32NXA.each;
/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */ function $25dd9270f3305f11$var$MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);
    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}
$25dd9270f3305f11$var$MediaQuery.prototype = {
    constuctor: $25dd9270f3305f11$var$MediaQuery,
    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */ addHandler: function addHandler(handler) {
        var qh = new $9Lsgs(handler);
        this.handlers.push(qh);
        this.matches() && qh.on();
    },
    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */ removeHandler: function removeHandler(handler) {
        var handlers = this.handlers;
        $25dd9270f3305f11$require$each(handlers, function(h, i) {
            if (h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i, 1); //remove from array and exit each early
            }
        });
    },
    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */ matches: function matches() {
        return this.mql.matches || this.isUnconditional;
    },
    /**
     * Clears all handlers and unbinds events
     */ clear: function clear() {
        $25dd9270f3305f11$require$each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },
    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */ assess: function assess() {
        var action = this.matches() ? "on" : "off";
        $25dd9270f3305f11$require$each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};
module.exports = $25dd9270f3305f11$var$MediaQuery;

});
parcelRegister("9Lsgs", function(module, exports) {
/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */ function $71be6d9392596ac0$var$QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}
$71be6d9392596ac0$var$QueryHandler.prototype = {
    constructor: $71be6d9392596ac0$var$QueryHandler,
    /**
     * coordinates setup of the handler
     *
     * @function
     */ setup: function setup() {
        if (this.options.setup) this.options.setup();
        this.initialised = true;
    },
    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */ on: function on() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },
    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */ off: function off() {
        this.options.unmatch && this.options.unmatch();
    },
    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */ destroy: function destroy() {
        this.options.destroy ? this.options.destroy() : this.off();
    },
    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */ equals: function equals(target) {
        return this.options === target || this.options.match === target;
    }
};
module.exports = $71be6d9392596ac0$var$QueryHandler;

});

parcelRegister("32NXA", function(module, exports) {
/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */ function $237850073447f175$var$each(collection, fn) {
    var i = 0, length = collection.length, cont;
    for(i; i < length; i++){
        cont = fn(collection[i], i);
        if (cont === false) break; //allow early exit
    }
}
/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */ function $237850073447f175$var$isArray(target) {
    return Object.prototype.toString.apply(target) === "[object Array]";
}
/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */ function $237850073447f175$var$isFunction(target) {
    return typeof target === "function";
}
module.exports = {
    isFunction: $237850073447f175$var$isFunction,
    isArray: $237850073447f175$var$isArray,
    each: $237850073447f175$var$each
};

});





parcelRegister("5icQr", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return isDraft; });
$parcel$export(module.exports, "isDraftable", function () { return isDraftable; });
$parcel$export(module.exports, "current", function () { return current; });
$parcel$export(module.exports, "produce", function () { return produce; });

var $fWfWu = parcelRequire("fWfWu");

var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $hD5pT = parcelRequire("hD5pT");

var $5dLwP = parcelRequire("5dLwP");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");

var $fPaN7 = parcelRequire("fPaN7");

var $lMNAp = parcelRequire("lMNAp");
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (__getOwnPropSymbols) try {
        for(var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    throw new Error("[Immer] minified error nr: ".concat(error, ". Full error at: https://bit.ly/3cXEKWf"));
}
// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_a = value.constructor) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    var proto = getPrototypeOf(value);
    if (proto === null) return true;
    var Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
    if (getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach(function(key) {
        iter(key, obj[key], obj);
    });
    else obj.forEach(function(entry, index) {
        return iter(index, entry, obj);
    });
}
function getArchtype(thing) {
    var state = thing[DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function has(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
    var t = getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function isMap(target) {
    return target instanceof Map;
}
function isSet(target) {
    return target instanceof Set;
}
function latest(state) {
    return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    if (!strict && isPlainObject(base)) {
        if (!getPrototypeOf(base)) {
            var obj = /* @__PURE__ */ Object.create(null);
            return Object.assign(obj, base);
        }
        return __spreadValues({}, base);
    }
    var descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[DRAFT_STATE];
    var keys = Reflect.ownKeys(descriptors);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var desc = descriptors[key];
        if (desc.writable === false) {
            desc.writable = true;
            desc.configurable = true;
        }
        if (desc.get || desc.set) descriptors[key] = {
            configurable: true,
            writable: true,
            // could live with !!desc.set as well here...
            enumerable: desc.enumerable,
            value: base[key]
        };
    }
    return Object.create(getPrototypeOf(base), descriptors);
}
function freeze(obj) {
    var deep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(function(param) {
        var _param = (0, $kB67t._)(param, 2), key = _param[0], value = _param[1];
        return freeze(value, true);
    });
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
function isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
    var plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
function getCurrentScope() {
    return currentScope;
}
function createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
function enterScope(immer2) {
    return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
    var state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    var baseDraft = scope.drafts_[0];
    var isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) {
            result = finalize(scope, result);
            if (!scope.parent_) maybeFreeze(scope, result);
        }
        if (scope.patches_) getPlugin("Patches").generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = finalize(scope, baseDraft, []);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
    if (isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    if (!state) {
        each(value, function(key, childValue) {
            return finalizeProperty(rootScope, state, value, key, childValue, path);
        });
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        var result = state.copy_;
        var resultEach = result;
        var isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        each(resultEach, function(key, childValue) {
            return finalizeProperty(rootScope, state, result, key, childValue, path, isSet2);
        });
        maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (isDraft(childValue)) {
        var path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        var res = finalize(rootScope, childValue, path);
        set(targetObject, prop, res);
        if (isDraft(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if (isDraftable(childValue) && !isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && (typeof prop === "undefined" ? "undefined" : (0, $YtE9h._)(prop)) !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) maybeFreeze(rootScope, childValue);
    }
}
function maybeFreeze(scope, value) {
    var deep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    var isArray = Array.isArray(base);
    var state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    var target = state;
    var traps = objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    var _Proxy_revocable = Proxy.revocable(target, traps), revoke = _Proxy_revocable.revoke, proxy = _Proxy_revocable.proxy;
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var objectTraps = {
    get: function(state, prop) {
        if (prop === DRAFT_STATE) return state;
        var source = latest(state);
        if (!has(source, prop)) return readPropFromProto(state, source, prop);
        var value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            return state.copy_[prop] = createProxy(value, state);
        }
        return value;
    },
    has: function(state, prop) {
        return prop in latest(state);
    },
    ownKeys: function(state) {
        return Reflect.ownKeys(latest(state));
    },
    set: function(state, prop, value) {
        var desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            var current2 = peek(latest(state), prop);
            var currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty: function(state, prop) {
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            prepareCopy(state);
            markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor: function(state, prop) {
        var owner = latest(state);
        var desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty: function() {
        die(11);
    },
    getPrototypeOf: function(state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf: function() {
        die(12);
    }
};
var arrayTraps = {};
each(objectTraps, function(key, fn) {
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    var state = draft[DRAFT_STATE];
    var source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    var desc = getDescriptorFromProto(source, prop);
    return desc ? "value" in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    var proto = getPrototypeOf(source);
    while(proto){
        var desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var Immer2 = /*#__PURE__*/ function() {
    "use strict";
    function Immer2(config) {
        var _this = this;
        (0, $bB0zn._)(this, Immer2);
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = function(base, recipe, patchListener) {
            if (typeof base === "function" && typeof recipe !== "function") {
                var defaultBase = recipe;
                recipe = base;
                var self = _this;
                return function curriedProduce() {
                    var _this = this;
                    var base2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultBase;
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var _recipe;
                    return self.produce(base2, function(draft) {
                        return (_recipe = recipe).call.apply(_recipe, [
                            _this,
                            draft
                        ].concat((0, $2Xzd1._)(args)));
                    });
                };
            }
            if (typeof recipe !== "function") die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") die(7);
            var result;
            if (isDraftable(base)) {
                var scope = enterScope(_this);
                var proxy = createProxy(base, void 0);
                var hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (_this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    var p = [];
                    var ip = [];
                    getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = function(base, recipe) {
            var _this1 = _this;
            if (typeof base === "function") return function(state) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                return _this1.produceWithPatches(state, function(draft) {
                    return base.apply(void 0, [
                        draft
                    ].concat((0, $2Xzd1._)(args)));
                });
            };
            var patches, inversePatches;
            var result = _this.produce(base, recipe, function(p, ip) {
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    (0, $6QEWP._)(Immer2, [
        {
            key: "createDraft",
            value: function createDraft(base) {
                if (!isDraftable(base)) die(8);
                if (isDraft(base)) base = current(base);
                var scope = enterScope(this);
                var proxy = createProxy(base, void 0);
                proxy[DRAFT_STATE].isManual_ = true;
                leaveScope(scope);
                return proxy;
            }
        },
        {
            key: "finishDraft",
            value: function finishDraft(draft, patchListener) {
                var state = draft && draft[DRAFT_STATE];
                if (!state || !state.isManual_) die(9);
                var scope = state.scope_;
                usePatchesInScope(scope, patchListener);
                return processResult(void 0, scope);
            }
        },
        {
            /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ key: "setAutoFreeze",
            value: function setAutoFreeze(value) {
                this.autoFreeze_ = value;
            }
        },
        {
            /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ key: "setUseStrictShallowCopy",
            value: function setUseStrictShallowCopy(value) {
                this.useStrictShallowCopy_ = value;
            }
        },
        {
            key: "applyPatches",
            value: function applyPatches(base, patches) {
                var i;
                for(i = patches.length - 1; i >= 0; i--){
                    var patch = patches[i];
                    if (patch.path.length === 0 && patch.op === "replace") {
                        base = patch.value;
                        break;
                    }
                }
                if (i > -1) patches = patches.slice(i + 1);
                var applyPatchesImpl = getPlugin("Patches").applyPatches_;
                if (isDraft(base)) return applyPatchesImpl(base, patches);
                return this.produce(base, function(draft) {
                    return applyPatchesImpl(draft, patches);
                });
            }
        }
    ]);
    return Immer2;
}();
function createProxy(value, parent) {
    var draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
    var scope = parent ? parent.scope_ : getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    var copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = shallowCopy(value, true);
    each(copy, function(key, childValue) {
        set(copy, key, currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    var errorOffset = 16;
    var REPLACE = "replace";
    var ADD = "add";
    var REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, assigned_ = state.assigned_;
        var copy_ = state.copy_;
        if (copy_.length < base_.length) {
            var ref;
            ref = [
                copy_,
                base_
            ], base_ = ref[0], copy_ = ref[1], ref;
            var ref1;
            ref1 = [
                inversePatches,
                patches
            ], patches = ref1[0], inversePatches = ref1[1], ref1;
        }
        for(var i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            var path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(var i1 = base_.length; i1 < copy_.length; i1++){
            var path1 = basePath.concat([
                i1
            ]);
            patches.push({
                op: ADD,
                path: path1,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i1])
            });
        }
        for(var i2 = copy_.length - 1; base_.length <= i2; --i2){
            var path2 = basePath.concat([
                i2
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path2
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        each(state.assigned_, function(key, assignedValue) {
            var origValue = get(base_, key);
            var value = get(copy_, key);
            var op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            var path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        var i = 0;
        base_.forEach(function(value) {
            if (!copy_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach(function(value) {
            if (!base_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach(function(patch) {
            var path = patch.path, op = patch.op;
            var base = draft;
            for(var i = 0; i < path.length - 1; i++){
                var parentType = getArchtype(base);
                var p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") die(errorOffset + 3);
                base = get(base, p);
                if (typeof base !== "object") die(errorOffset + 2, path.join("/"));
            }
            var type = getArchtype(base);
            var value = deepClonePatchValue(patch.value);
            var key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(function(param) {
            var _param = (0, $kB67t._)(param, 2), k = _param[0], v = _param[1];
            return [
                k,
                deepClonePatchValue(v)
            ];
        }));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        var cloned = Object.create(getPrototypeOf(obj));
        for(var key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    var DraftMap = /*#__PURE__*/ function(Map1) {
        "use strict";
        (0, $5dLwP._)(DraftMap, Map1);
        var _super = (0, $lMNAp._)(DraftMap);
        function DraftMap(target, parent) {
            (0, $bB0zn._)(this, DraftMap);
            var _this;
            _this = _super.call(this);
            _this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: (0, $fWfWu._)(_this),
                isManual_: false,
                revoked_: false
            };
            return _this;
        }
        (0, $6QEWP._)(DraftMap, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(key) {
                    return latest(this[DRAFT_STATE]).has(key);
                }
            },
            {
                key: "set",
                value: function set(key, value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!latest(state).has(key) || latest(state).get(key) !== value) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_.set(key, true);
                        state.copy_.set(key, value);
                        state.assigned_.set(key, true);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(key) {
                    if (!this.has(key)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareMapCopy(state);
                    markChanged(state);
                    if (state.base_.has(key)) state.assigned_.set(key, false);
                    else state.assigned_.delete(key);
                    state.copy_.delete(key);
                    return true;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_ = /* @__PURE__ */ new Map();
                        each(state.base_, function(key) {
                            state.assigned_.set(key, false);
                        });
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var _this = this;
                    var state = this[DRAFT_STATE];
                    latest(state).forEach(function(_value, key, _map) {
                        cb.call(thisArg, _this.get(key), key, _this);
                    });
                }
            },
            {
                key: "get",
                value: function get(key) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    var value = latest(state).get(key);
                    if (state.finalized_ || !isDraftable(value)) return value;
                    if (value !== state.base_.get(key)) return value;
                    var draft = createProxy(value, state);
                    prepareMapCopy(state);
                    state.copy_.set(key, draft);
                    return draft;
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return latest(this[DRAFT_STATE]).keys();
                }
            },
            {
                key: "values",
                value: function values() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $hD5pT._)(_obj, Symbol.iterator, function() {
                        return _this.values();
                    }), (0, $hD5pT._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: value
                        };
                    }), _obj;
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $hD5pT._)(_obj, Symbol.iterator, function() {
                        return _this.entries();
                    }), (0, $hD5pT._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: [
                                r.value,
                                value
                            ]
                        };
                    }), _obj;
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.entries();
                }
            }
        ]);
        return DraftMap;
    }((0, $fPaN7._)(Map));
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    var DraftSet = /*#__PURE__*/ function(Set1) {
        "use strict";
        (0, $5dLwP._)(DraftSet, Set1);
        var _super = (0, $lMNAp._)(DraftSet);
        function DraftSet(target, parent) {
            (0, $bB0zn._)(this, DraftSet);
            var _this;
            _this = _super.call(this);
            _this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: (0, $fWfWu._)(_this),
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
            return _this;
        }
        (0, $6QEWP._)(DraftSet, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!state.copy_) return state.base_.has(value);
                    if (state.copy_.has(value)) return true;
                    if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
                    return false;
                }
            },
            {
                key: "add",
                value: function add(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!this.has(value)) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.add(value);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(value) {
                    if (!this.has(value)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    markChanged(state);
                    return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "values",
                value: function values() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.values();
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.entries();
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return this.values();
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.values();
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var iterator = this.values();
                    var result = iterator.next();
                    while(!result.done){
                        cb.call(thisArg, result.value, result.value, this);
                        result = iterator.next();
                    }
                }
            }
        ]);
        return DraftSet;
    }((0, $fPaN7._)(Set));
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach(function(value) {
                if (isDraftable(value)) {
                    var draft = createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(immer);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
    return value;
}
function castImmutable(value) {
    return value;
}

});
parcelRegister("fWfWu", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $02fe9748b9e38ccb$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $02fe9748b9e38ccb$export$f3b8ed2e4a5d10b8; });
function $02fe9748b9e38ccb$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("bB0zn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8713978b2328d32b$export$2996f80ef42b8419; });
function $8713978b2328d32b$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("6QEWP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4fc75ccb937ab1df$export$d60067ff2358eee8; });
function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("hD5pT", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $cd5a47cf8ef6d766$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $cd5a47cf8ef6d766$export$1e71eb4bef00f6b0; });
function $cd5a47cf8ef6d766$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("5dLwP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3cd308d6b98edc5a$export$7e4530ad35d3bb8; });

var $eZsRM = parcelRequire("eZsRM");
function $3cd308d6b98edc5a$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $eZsRM._set_prototype_of)(subClass, superClass);
}

});
parcelRegister("eZsRM", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $ae9d277b5847b878$export$c2c98ac76e997b63; });
function $ae9d277b5847b878$export$c2c98ac76e997b63(o, p) {
    $ae9d277b5847b878$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ae9d277b5847b878$export$c2c98ac76e997b63(o, p);
}

});


parcelRegister("kB67t", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $efec029548ccee7f$export$fdf2a89c76341bbf; });

var $Q9cvz = parcelRequire("Q9cvz");

var $c4AWK = parcelRequire("c4AWK");

var $dNApw = parcelRequire("dNApw");

var $ihB7G = parcelRequire("ihB7G");
function $efec029548ccee7f$export$fdf2a89c76341bbf(arr, i) {
    return (0, $Q9cvz._array_with_holes)(arr) || (0, $c4AWK._iterable_to_array_limit)(arr, i) || (0, $ihB7G._unsupported_iterable_to_array)(arr, i) || (0, $dNApw._non_iterable_rest)();
}

});
parcelRegister("Q9cvz", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $09cbfe85151ea6c6$export$e6256bf45c68d561; });
function $09cbfe85151ea6c6$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("c4AWK", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $8ca2848f896a6803$export$2fd15edff6687200; });
function $8ca2848f896a6803$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("dNApw", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $a0bc1859061deae1$export$60dbc22abd7da546; });
function $a0bc1859061deae1$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ihB7G", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $d4f69c5c6c4654b1$export$a5be06335b3a083c; });

var $gNF1f = parcelRequire("gNF1f");
function $d4f69c5c6c4654b1$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gNF1f._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gNF1f._array_like_to_array)(o, minLen);
}

});
parcelRegister("gNF1f", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $c3b10a83b523f372$export$79e617b1955a2616; });
function $c3b10a83b523f372$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("2Xzd1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $227c6742e0ff6f82$export$1b5e630bc3aea29f; });

var $gUOYc = parcelRequire("gUOYc");

var $Q6yVl = parcelRequire("Q6yVl");

var $4S8xA = parcelRequire("4S8xA");

var $ihB7G = parcelRequire("ihB7G");
function $227c6742e0ff6f82$export$1b5e630bc3aea29f(arr) {
    return (0, $gUOYc._array_without_holes)(arr) || (0, $Q6yVl._iterable_to_array)(arr) || (0, $ihB7G._unsupported_iterable_to_array)(arr) || (0, $4S8xA._non_iterable_spread)();
}

});
parcelRegister("gUOYc", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $c50969dc1df61e8b$export$7e0947b5ad3404e2; });

var $gNF1f = parcelRequire("gNF1f");
function $c50969dc1df61e8b$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $gNF1f._array_like_to_array)(arr);
}

});

parcelRegister("Q6yVl", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $09c9f293d010c0e1$export$1eb58a6e75231000; });
function $09c9f293d010c0e1$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("4S8xA", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $38c2d4931cb7a7c4$export$e6f3c4780d19eb2b; });
function $38c2d4931cb7a7c4$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("fPaN7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b853fd5b3c362aee$export$2466d533fda16e33; });

var $f5KHm = parcelRequire("f5KHm");

var $ZhYhU = parcelRequire("ZhYhU");

var $cHvTP = parcelRequire("cHvTP");

var $eZsRM = parcelRequire("eZsRM");
function $b853fd5b3c362aee$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $b853fd5b3c362aee$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $cHvTP._is_native_function)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $f5KHm._construct)(Class, arguments, (0, $ZhYhU._get_prototype_of)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $eZsRM._set_prototype_of)(Wrapper, Class);
    };
    return $b853fd5b3c362aee$export$2466d533fda16e33(Class);
}

});
parcelRegister("f5KHm", function(module, exports) {

$parcel$export(module.exports, "_construct", function () { return $afcb8bf546bf0e4a$export$2d841144c5f8c4ab; });
$parcel$export(module.exports, "_", function () { return $afcb8bf546bf0e4a$export$2d841144c5f8c4ab; });

var $bFohN = parcelRequire("bFohN");

var $eZsRM = parcelRequire("eZsRM");
function $afcb8bf546bf0e4a$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $bFohN._is_native_reflect_construct)()) $afcb8bf546bf0e4a$export$2d841144c5f8c4ab = Reflect.construct;
    else $afcb8bf546bf0e4a$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $eZsRM._set_prototype_of)(instance, Class.prototype);
        return instance;
    };
    return $afcb8bf546bf0e4a$export$2d841144c5f8c4ab.apply(null, arguments);
}

});
parcelRegister("bFohN", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $87e65cc21f1ac8a6$export$685354647fba1516; });
function $87e65cc21f1ac8a6$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRegister("ZhYhU", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $0b83a35ce2cd1792$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $0b83a35ce2cd1792$export$f09211a7d3c496a1; });
function $0b83a35ce2cd1792$export$f09211a7d3c496a1(o) {
    $0b83a35ce2cd1792$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0b83a35ce2cd1792$export$f09211a7d3c496a1(o);
}

});

parcelRegister("cHvTP", function(module, exports) {

$parcel$export(module.exports, "_is_native_function", function () { return $93f23ebd967272a8$export$514eda94019f4334; });
function $93f23ebd967272a8$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("lMNAp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fdc48b7b7f0be826$export$8dd05c13f5255580; });

var $ZhYhU = parcelRequire("ZhYhU");

var $bFohN = parcelRequire("bFohN");

var $oIOMH = parcelRequire("oIOMH");
function $fdc48b7b7f0be826$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $bFohN._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $ZhYhU._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $ZhYhU._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $oIOMH._possible_constructor_return)(this, result);
    };
}

});
parcelRegister("oIOMH", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $04a501f287790d91$export$ef97c660ca164e52; });

var $fWfWu = parcelRequire("fWfWu");

var $YtE9h = parcelRequire("YtE9h");
function $04a501f287790d91$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $YtE9h._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $fWfWu._assert_this_initialized)(self);
}

});



parcelRegister("c38Wl", function(module, exports) {


module.exports = (parcelRequire("jrcmb"))((parcelRequire("451Sc")).resolve("5Whcg")).then(function() {
    return parcelRequire("dhpq2");
});

});
parcelRegister("jrcmb", function(module, exports) {
"use strict";

var $bnxiY = parcelRequire("bnxiY");
module.exports = $bnxiY(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("bnxiY", function(module, exports) {
"use strict";
var $848bad63e2eca00a$var$cachedBundles = {};
var $848bad63e2eca00a$var$cachedPreloads = {};
var $848bad63e2eca00a$var$cachedPrefetches = {};
function $848bad63e2eca00a$var$getCache(type) {
    switch(type){
        case "preload":
            return $848bad63e2eca00a$var$cachedPreloads;
        case "prefetch":
            return $848bad63e2eca00a$var$cachedPrefetches;
        default:
            return $848bad63e2eca00a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $848bad63e2eca00a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




var $kB67t = parcelRequire("kB67t");

var $cc6u1 = parcelRequire("cc6u1");

var $fIwXP = parcelRequire("fIwXP");
var $fb34d4b6d3b01836$exports = {};

$parcel$export($fb34d4b6d3b01836$exports, "createRoot", function () { return $fb34d4b6d3b01836$export$882461b6382ed46c; }, function (v) { return $fb34d4b6d3b01836$export$882461b6382ed46c = v; });
$parcel$export($fb34d4b6d3b01836$exports, "hydrateRoot", function () { return $fb34d4b6d3b01836$export$757ceba2d55c277e; }, function (v) { return $fb34d4b6d3b01836$export$757ceba2d55c277e = v; });
var $fb34d4b6d3b01836$export$882461b6382ed46c;
var $fb34d4b6d3b01836$export$757ceba2d55c277e;
"use strict";
var $708acee34f03ee3d$exports = {};
"use strict";
function $708acee34f03ee3d$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($708acee34f03ee3d$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$708acee34f03ee3d$var$checkDCE();

$708acee34f03ee3d$exports = (parcelRequire("fsZ8I"));


var $fb34d4b6d3b01836$var$i;
$fb34d4b6d3b01836$export$882461b6382ed46c = $708acee34f03ee3d$exports.createRoot;
$fb34d4b6d3b01836$export$757ceba2d55c277e = $708acee34f03ee3d$exports.hydrateRoot;



var $kB67t = parcelRequire("kB67t");

var $cc6u1 = parcelRequire("cc6u1");
var $cc25cc9a913d8a70$export$31adfacaf07ffe63 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
var $cc25cc9a913d8a70$export$8878ead86ed0da0b = "https://png.pngtree.com/png-vector/20220705/ourmid/pngtree-food-logo-png-image_5687686.png";
var $cc25cc9a913d8a70$export$b77c1aa4fb57bd1c = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=13.0826802&lng=80.2707184&restaurantId=";
var $cc25cc9a913d8a70$export$e3a95270a7f281c1 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/2xempty_cart_yfxml0";
var $cc25cc9a913d8a70$export$85dc8a20c452aa8a = "https://www.swiggy.com/dapi/restaurants/list/v5?lat=13.0826802&lng=80.2707184&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";
var $cc25cc9a913d8a70$export$c77d3f7c7cde7bd0 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_288,h_360/";



var $fIwXP = parcelRequire("fIwXP");
/**
 * React Router DOM v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $554ed4b40b13e16f$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var $bB0zn = parcelRequire("bB0zn");

var $kB67t = parcelRequire("kB67t");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $YtE9h = parcelRequire("YtE9h");
var $fc5e3658b603cf39$var$extendStatics = function extendStatics1(d, b) {
    $fc5e3658b603cf39$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $fc5e3658b603cf39$var$extendStatics(d, b);
};
function $fc5e3658b603cf39$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $fc5e3658b603cf39$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $fc5e3658b603cf39$export$18ce0697a983be9b = function __assign1() {
    $fc5e3658b603cf39$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc5e3658b603cf39$export$18ce0697a983be9b.apply(this, arguments);
};
function $fc5e3658b603cf39$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $fc5e3658b603cf39$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $fc5e3658b603cf39$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $fc5e3658b603cf39$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $fc5e3658b603cf39$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $fc5e3658b603cf39$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $YtE9h._)(x)) === "symbol" ? x : "".concat(x);
}
function $fc5e3658b603cf39$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $YtE9h._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $fc5e3658b603cf39$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $fc5e3658b603cf39$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $fc5e3658b603cf39$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $fc5e3658b603cf39$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $fc5e3658b603cf39$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $fc5e3658b603cf39$export$45d3717a4c69092e(o, m, p);
}
function $fc5e3658b603cf39$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $fc5e3658b603cf39$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $fc5e3658b603cf39$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($fc5e3658b603cf39$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $fc5e3658b603cf39$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $fc5e3658b603cf39$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $fc5e3658b603cf39$export$10c90e4f7922046c(v) {
    return this instanceof $fc5e3658b603cf39$export$10c90e4f7922046c ? (this.v = v, this) : new $fc5e3658b603cf39$export$10c90e4f7922046c(v);
}
function $fc5e3658b603cf39$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $fc5e3658b603cf39$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $fc5e3658b603cf39$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $fc5e3658b603cf39$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $fc5e3658b603cf39$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $fc5e3658b603cf39$export$19a8beecd37a4c45 === "function" ? $fc5e3658b603cf39$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $fc5e3658b603cf39$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $fc5e3658b603cf39$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $fc5e3658b603cf39$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $fc5e3658b603cf39$export$45d3717a4c69092e(result, mod, k);
    }
    $fc5e3658b603cf39$var$__setModuleDefault(result, mod);
    return result;
}
function $fc5e3658b603cf39$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $fc5e3658b603cf39$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $fc5e3658b603cf39$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $fc5e3658b603cf39$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $fc5e3658b603cf39$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $fc5e3658b603cf39$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $fc5e3658b603cf39$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $fc5e3658b603cf39$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $fc5e3658b603cf39$export$2e2bcd8739ae039 = {
    __extends: $fc5e3658b603cf39$export$a8ba968b8961cb8a,
    __assign: $fc5e3658b603cf39$export$18ce0697a983be9b,
    __rest: $fc5e3658b603cf39$export$3c9a16f847548506,
    __decorate: $fc5e3658b603cf39$export$29e00dfd3077644b,
    __param: $fc5e3658b603cf39$export$d5ad3fd78186038f,
    __metadata: $fc5e3658b603cf39$export$f1db080c865becb9,
    __awaiter: $fc5e3658b603cf39$export$1050f835b63b671e,
    __generator: $fc5e3658b603cf39$export$67ebef60e6f28a6,
    __createBinding: $fc5e3658b603cf39$export$45d3717a4c69092e,
    __exportStar: $fc5e3658b603cf39$export$f33643c0debef087,
    __values: $fc5e3658b603cf39$export$19a8beecd37a4c45,
    __read: $fc5e3658b603cf39$export$8d051b38c9118094,
    __spread: $fc5e3658b603cf39$export$afc72e2116322959,
    __spreadArrays: $fc5e3658b603cf39$export$6388937ca91ccae8,
    __spreadArray: $fc5e3658b603cf39$export$1216008129fb82ed,
    __await: $fc5e3658b603cf39$export$10c90e4f7922046c,
    __asyncGenerator: $fc5e3658b603cf39$export$e427f37a30a4de9b,
    __asyncDelegator: $fc5e3658b603cf39$export$bbd80228419bb833,
    __asyncValues: $fc5e3658b603cf39$export$e3b29a3d6162315f,
    __makeTemplateObject: $fc5e3658b603cf39$export$4fb47efe1390b86f,
    __importStar: $fc5e3658b603cf39$export$c21735bcef00d192,
    __importDefault: $fc5e3658b603cf39$export$da59b14a69baef04,
    __classPrivateFieldGet: $fc5e3658b603cf39$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $fc5e3658b603cf39$export$d40a35129aaff81f,
    __classPrivateFieldIn: $fc5e3658b603cf39$export$81fdc39f203e4e04,
    __addDisposableResource: $fc5e3658b603cf39$export$88ac25d8e944e405,
    __disposeResources: $fc5e3658b603cf39$export$8f076105dc360e92
};



var $fIwXP = parcelRequire("fIwXP");

/**
 * @remix-run/router v1.15.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $hD5pT = parcelRequire("hD5pT");

var $5dLwP = parcelRequire("5dLwP");

var $kB67t = parcelRequire("kB67t");

var $Q9cvz = parcelRequire("Q9cvz");

var $Q6yVl = parcelRequire("Q6yVl");

var $dNApw = parcelRequire("dNApw");

var $ihB7G = parcelRequire("ihB7G");
function $89eb4a55c543f071$export$e62c166da838fa3(arr) {
    return (0, $Q9cvz._array_with_holes)(arr) || (0, $Q6yVl._iterable_to_array)(arr) || (0, $ihB7G._unsupported_iterable_to_array)(arr) || (0, $dNApw._non_iterable_rest)();
}



var $2Xzd1 = parcelRequire("2Xzd1");

var $fPaN7 = parcelRequire("fPaN7");

var $lMNAp = parcelRequire("lMNAp");


function $dc332a6010e2a7ab$var$_extends() {
    $dc332a6010e2a7ab$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dc332a6010e2a7ab$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $dc332a6010e2a7ab$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($dc332a6010e2a7ab$export$e19cd5f9376f8cee || ($dc332a6010e2a7ab$export$e19cd5f9376f8cee = {}));
var $dc332a6010e2a7ab$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $dc332a6010e2a7ab$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = $dc332a6010e2a7ab$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $dc332a6010e2a7ab$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $dc332a6010e2a7ab$export$fe53371bee54353d(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? $dc332a6010e2a7ab$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $dc332a6010e2a7ab$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return $dc332a6010e2a7ab$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $dc332a6010e2a7ab$export$fe53371bee54353d(to);
    }
    return $dc332a6010e2a7ab$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $dc332a6010e2a7ab$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = $dc332a6010e2a7ab$export$8ccf933b0513f8d0(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $dc332a6010e2a7ab$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $dc332a6010e2a7ab$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $dc332a6010e2a7ab$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $dc332a6010e2a7ab$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $dc332a6010e2a7ab$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $dc332a6010e2a7ab$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $dc332a6010e2a7ab$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $dc332a6010e2a7ab$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $dc332a6010e2a7ab$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = $dc332a6010e2a7ab$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $dc332a6010e2a7ab$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $dc332a6010e2a7ab$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $dc332a6010e2a7ab$export$fe53371bee54353d(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $dc332a6010e2a7ab$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $dc332a6010e2a7ab$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($dc332a6010e2a7ab$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Push;
        var location = $dc332a6010e2a7ab$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = $dc332a6010e2a7ab$var$getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Replace;
        var location = $dc332a6010e2a7ab$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = $dc332a6010e2a7ab$var$getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : $dc332a6010e2a7ab$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $dc332a6010e2a7ab$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($dc332a6010e2a7ab$var$PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener($dc332a6010e2a7ab$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $dc332a6010e2a7ab$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($dc332a6010e2a7ab$var$ResultType || ($dc332a6010e2a7ab$var$ResultType = {}));
var $dc332a6010e2a7ab$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $dc332a6010e2a7ab$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $dc332a6010e2a7ab$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $2Xzd1._)(parentPath).concat([
            index
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        $dc332a6010e2a7ab$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $dc332a6010e2a7ab$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($dc332a6010e2a7ab$var$isIndexRoute(route)) {
            var indexRoute = $dc332a6010e2a7ab$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = $dc332a6010e2a7ab$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $dc332a6010e2a7ab$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $dc332a6010e2a7ab$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    var location = typeof locationArg === "string" ? $dc332a6010e2a7ab$export$8ccf933b0513f8d0(locationArg) : locationArg;
    var pathname = $dc332a6010e2a7ab$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = $dc332a6010e2a7ab$var$flattenRoutes(routes);
    $dc332a6010e2a7ab$var$rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        var decoded = $dc332a6010e2a7ab$var$decodePath(pathname);
        matches = $dc332a6010e2a7ab$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $dc332a6010e2a7ab$export$b3fac024fad9e8ff(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $dc332a6010e2a7ab$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $dc332a6010e2a7ab$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = $dc332a6010e2a7ab$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $dc332a6010e2a7ab$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $dc332a6010e2a7ab$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $dc332a6010e2a7ab$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = $dc332a6010e2a7ab$var$explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $dc332a6010e2a7ab$var$explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $89eb4a55c543f071$export$e62c166da838fa3)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = $dc332a6010e2a7ab$var$explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $2Xzd1._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $2Xzd1._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function $dc332a6010e2a7ab$var$rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : $dc332a6010e2a7ab$var$compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var $dc332a6010e2a7ab$var$paramRe = /^:[\w-]+$/;
var $dc332a6010e2a7ab$var$dynamicSegmentValue = 3;
var $dc332a6010e2a7ab$var$indexRouteValue = 2;
var $dc332a6010e2a7ab$var$emptySegmentValue = 1;
var $dc332a6010e2a7ab$var$staticSegmentValue = 10;
var $dc332a6010e2a7ab$var$splatPenalty = -2;
var $dc332a6010e2a7ab$var$isSplat = function(s) {
    return s === "*";
};
function $dc332a6010e2a7ab$var$computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some($dc332a6010e2a7ab$var$isSplat)) initialScore += $dc332a6010e2a7ab$var$splatPenalty;
    if (index) initialScore += $dc332a6010e2a7ab$var$indexRouteValue;
    return segments.filter(function(s) {
        return !$dc332a6010e2a7ab$var$isSplat(s);
    }).reduce(function(score, segment) {
        return score + ($dc332a6010e2a7ab$var$paramRe.test(segment) ? $dc332a6010e2a7ab$var$dynamicSegmentValue : segment === "" ? $dc332a6010e2a7ab$var$emptySegmentValue : $dc332a6010e2a7ab$var$staticSegmentValue);
    }, initialScore);
}
function $dc332a6010e2a7ab$var$compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $dc332a6010e2a7ab$var$matchRouteBranch(branch, pathname) {
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = $dc332a6010e2a7ab$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        var route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $dc332a6010e2a7ab$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $dc332a6010e2a7ab$export$a5c6d149b50c1d86($dc332a6010e2a7ab$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $dc332a6010e2a7ab$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $dc332a6010e2a7ab$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $dc332a6010e2a7ab$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $kB67t._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            $dc332a6010e2a7ab$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $dc332a6010e2a7ab$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $kB67t._)($dc332a6010e2a7ab$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo, _ref, index) {
        var paramName = _ref.paramName, isOptional = _ref.isOptional;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $dc332a6010e2a7ab$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $dc332a6010e2a7ab$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $dc332a6010e2a7ab$var$decodePath(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        $dc332a6010e2a7ab$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $dc332a6010e2a7ab$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $dc332a6010e2a7ab$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? $dc332a6010e2a7ab$export$8ccf933b0513f8d0(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $dc332a6010e2a7ab$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $dc332a6010e2a7ab$var$normalizeSearch(search),
        hash: $dc332a6010e2a7ab$var$normalizeHash(hash)
    };
}
function $dc332a6010e2a7ab$var$resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $dc332a6010e2a7ab$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $dc332a6010e2a7ab$var$getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $dc332a6010e2a7ab$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    var pathMatches = $dc332a6010e2a7ab$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map(function(match, idx) {
        return idx === matches.length - 1 ? match.pathname : match.pathnameBase;
    });
    return pathMatches.map(function(match) {
        return match.pathnameBase;
    });
}
/**
 * @private
 */ function $dc332a6010e2a7ab$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = $dc332a6010e2a7ab$export$8ccf933b0513f8d0(toArg);
    else {
        to = $dc332a6010e2a7ab$var$_extends({}, toArg);
        $dc332a6010e2a7ab$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $dc332a6010e2a7ab$var$getInvalidPathError("?", "pathname", "search", to));
        $dc332a6010e2a7ab$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $dc332a6010e2a7ab$var$getInvalidPathError("#", "pathname", "hash", to));
        $dc332a6010e2a7ab$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $dc332a6010e2a7ab$var$getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = $dc332a6010e2a7ab$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $dc332a6010e2a7ab$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $dc332a6010e2a7ab$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ var $dc332a6010e2a7ab$export$86d9a7913e44197e = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var $dc332a6010e2a7ab$export$a5c6d149b50c1d86 = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var $dc332a6010e2a7ab$var$normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var $dc332a6010e2a7ab$var$normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var $dc332a6010e2a7ab$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $dc332a6010e2a7ab$var$_extends({}, responseInit, {
        headers: headers
    }));
};
var $dc332a6010e2a7ab$export$42a99a7a4bc0e76a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $5dLwP._)(AbortedDeferredError, Error1);
    var _super = (0, $lMNAp._)(AbortedDeferredError);
    function AbortedDeferredError() {
        (0, $bB0zn._)(this, AbortedDeferredError);
        return _super.apply(this, arguments);
    }
    return AbortedDeferredError;
}((0, $fPaN7._)(Error));
var $dc332a6010e2a7ab$export$61d759255b4eec65 = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $bB0zn._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $dc332a6010e2a7ab$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new $dc332a6010e2a7ab$export$42a99a7a4bc0e76a("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref2) {
            var _$_ref2 = (0, $kB67t._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
            return Object.assign(acc, (0, $hD5pT._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $6QEWP._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof $dc332a6010e2a7ab$export$42a99a7a4bc0e76a) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function() {
                    var aborted, onAbort;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                $dc332a6010e2a7ab$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref3) {
                    var _$_ref3 = (0, $kB67t._)(_ref3, 2), key = _$_ref3[0], value = _$_ref3[1];
                    return Object.assign(acc, (0, $hD5pT._)({}, key, $dc332a6010e2a7ab$var$unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function $dc332a6010e2a7ab$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $dc332a6010e2a7ab$var$unwrapTrackedPromise(value) {
    if (!$dc332a6010e2a7ab$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var $dc332a6010e2a7ab$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $dc332a6010e2a7ab$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $dc332a6010e2a7ab$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $dc332a6010e2a7ab$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $dc332a6010e2a7ab$export$a6cd19cd1951a23c = function(url, init) {
    var response = $dc332a6010e2a7ab$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ var $dc332a6010e2a7ab$export$6c6580e81da25755 = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, $bB0zn._)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $dc332a6010e2a7ab$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var $dc332a6010e2a7ab$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var $dc332a6010e2a7ab$var$validMutationMethods = new Set($dc332a6010e2a7ab$var$validMutationMethodsArr);
var $dc332a6010e2a7ab$var$validRequestMethodsArr = [
    "get"
].concat((0, $2Xzd1._)($dc332a6010e2a7ab$var$validMutationMethodsArr));
var $dc332a6010e2a7ab$var$validRequestMethods = new Set($dc332a6010e2a7ab$var$validRequestMethodsArr);
var $dc332a6010e2a7ab$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var $dc332a6010e2a7ab$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var $dc332a6010e2a7ab$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $dc332a6010e2a7ab$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $dc332a6010e2a7ab$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var $dc332a6010e2a7ab$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $dc332a6010e2a7ab$var$defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var $dc332a6010e2a7ab$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $dc332a6010e2a7ab$export$baddd0131ee8c05b(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    $dc332a6010e2a7ab$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $dc332a6010e2a7ab$var$defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = $dc332a6010e2a7ab$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    // Config driven behavior flags
    var future = $dc332a6010e2a7ab$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = $dc332a6010e2a7ab$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = $dc332a6010e2a7ab$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = $dc332a6010e2a7ab$var$getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $hD5pT._)({}, route.id, error);
    }
    var initialized;
    var hasLazyRoutes = initialMatches.some(function(m) {
        return m.route.lazy;
    });
    var hasLoaders = initialMatches.some(function(m) {
        return m.route.loader;
    });
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        var errors = init.hydrationData ? init.hydrationData.errors : null;
        var isRouteInitialized = function(m) {
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            var idx = initialMatches.findIndex(function(m) {
                return errors[m.route.id] !== undefined;
            });
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $dc332a6010e2a7ab$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    var pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    var appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    var removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    var activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    var deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $dc332a6010e2a7ab$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $dc332a6010e2a7ab$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $dc332a6010e2a7ab$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return $dc332a6010e2a7ab$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($dc332a6010e2a7ab$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $dc332a6010e2a7ab$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        var completedFetchers = [];
        var deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        (0, $2Xzd1._)(subscribers).forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            });
        });
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach(function(key) {
                return state.fetchers.delete(key);
            });
            deletedFetchersKeys.forEach(function(key) {
                return deleteFetcher(key);
            });
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        var flushSync = (_temp === void 0 ? {} : _temp).flushSync;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && $dc332a6010e2a7ab$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? $dc332a6010e2a7ab$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, $dc332a6010e2a7ab$export$386d57f03f0b2883);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $dc332a6010e2a7ab$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        var viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($dc332a6010e2a7ab$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $dc332a6010e2a7ab$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = $dc332a6010e2a7ab$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = $dc332a6010e2a7ab$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = $dc332a6010e2a7ab$var$createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = $dc332a6010e2a7ab$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Push;
                        if (userReplace === true) historyAction = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && $dc332a6010e2a7ab$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        flushSync = (opts && opts.unstable_flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, $dc332a6010e2a7ab$export$386d57f03f0b2883);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.unstable_viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, flushSync, error, _getShortCircuitMatches, notFoundMatches, route, request, pendingActionData, pendingError, actionOutput, _ref, shortCircuited, loaderData, errors;
            return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = $dc332a6010e2a7ab$export$2708184779ceb39d(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            error = $dc332a6010e2a7ab$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches = $dc332a6010e2a7ab$var$getShortCircuitMatches(routesToUse), notFoundMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            // Cancel all pending deferred on 404s since we don't keep any routes
                            cancelActiveDeferreds();
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $hD5pT._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial load will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && $dc332a6010e2a7ab$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $dc332a6010e2a7ab$var$isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = $dc332a6010e2a7ab$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingError = (0, $hD5pT._)({}, $dc332a6010e2a7ab$var$findNearestBoundary(matches).route.id, opts.pendingError);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && $dc332a6010e2a7ab$var$isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 2:
                        actionOutput = _state.sent();
                        if (actionOutput.shortCircuited) return [
                            2
                        ];
                        pendingActionData = actionOutput.pendingActionData;
                        pendingError = actionOutput.pendingActionError;
                        loadingNavigation = $dc332a6010e2a7ab$var$getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        // Create a GET request for the loaders
                        request = new Request(request.url, {
                            signal: request.signal
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, $dc332a6010e2a7ab$var$_extends({
                            matches: matches
                        }, pendingActionData ? {
                            actionData: pendingActionData
                        } : {}, {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(request, location, submission, matches, opts) {
            var navigation, result, actionMatch, replace, boundaryMatch;
            return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        // Put us in a submitting state
                        navigation = $dc332a6010e2a7ab$var$getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        actionMatch = $dc332a6010e2a7ab$var$getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        result = {
                            type: $dc332a6010e2a7ab$var$ResultType.error,
                            error: $dc332a6010e2a7ab$var$getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $dc332a6010e2a7ab$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 3;
                    case 3:
                        if (!$dc332a6010e2a7ab$var$isRedirectResult(result)) return [
                            3,
                            5
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else // If the user didn't explicity indicate replace behavior, replace if
                        // we redirected to the exact same location we're currently at to avoid
                        // double back-buttons
                        replace = result.location === state.location.pathname + state.location.search;
                        return [
                            4,
                            startRedirectNavigation(state, result, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        if ($dc332a6010e2a7ab$var$isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = $dc332a6010e2a7ab$var$findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions are REPLACE navigations, but if the
                            // action threw an error that'll be rendered in an errorElement, we fall
                            // back to PUSH so that the user can use the back button to get back to
                            // the pre-submission form location to try again
                            if ((opts && opts.replace) !== true) pendingAction = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Push;
                            return [
                                2,
                                {
                                    // Send back an empty object we can use to clear out any prior actionData
                                    pendingActionData: {},
                                    pendingActionError: (0, $hD5pT._)({}, boundaryMatch.route.id, result.error)
                                }
                            ];
                        }
                        if ($dc332a6010e2a7ab$var$isDeferredResult(result)) throw $dc332a6010e2a7ab$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        return [
                            2,
                            {
                                pendingActionData: (0, $hD5pT._)({}, actionMatch.route.id, result.data)
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
            var loadingNavigation, activeSubmission, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, actionData, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation || $dc332a6010e2a7ab$var$getLoadingNavigation(location, submission);
                        // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission || $dc332a6010e2a7ab$var$getSubmissionFromNavigation(loadingNavigation);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $kB67t._)($dc332a6010e2a7ab$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, $dc332a6010e2a7ab$var$_extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingError || null
                            }, pendingActionData ? {
                                actionData: pendingActionData
                            } : {}, updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        // If we have partialHydration enabled, then don't update the state for the
                        // initial data load since it's not a "navigation"
                        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
                            revalidatingFetchers.forEach(function(rf) {
                                var fetcher = state.fetchers.get(rf.key);
                                var revalidatingFetcher = $dc332a6010e2a7ab$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                                state.fetchers.set(rf.key, revalidatingFetcher);
                            });
                            actionData = pendingActionData || state.actionData;
                            updateState($dc332a6010e2a7ab$var$_extends({
                                navigation: loadingNavigation
                            }, actionData ? Object.keys(actionData).length === 0 ? {
                                actionData: null
                            } : {
                                actionData: actionData
                            } : {}, revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 1:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = $dc332a6010e2a7ab$var$findRedirect(results);
                        if (!redirect) return [
                            3,
                            3
                        ];
                        if (redirect.idx >= matchesToLoad.length) {
                            // If this redirect came from a fetcher make sure we mark it in
                            // fetchRedirectIds so it doesn't get revalidated on the next set of
                            // loader executions
                            fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                            fetchRedirectIds.add(fetcherKey);
                        }
                        return [
                            4,
                            startRedirectNavigation(state, redirect.result, {
                                replace: replace
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 3:
                        // Process and commit output from loaders
                        _processLoaderData = $dc332a6010e2a7ab$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        // During partial hydration, preserve SSR errors for routes that don't re-run
                        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter(function(_ref2) {
                            var _$_ref2 = (0, $kB67t._)(_ref2, 1), id = _$_ref2[0];
                            return !matchesToLoad.some(function(m) {
                                return m.route.id === id;
                            });
                        }).forEach(function(_ref3) {
                            var _$_ref3 = (0, $kB67t._)(_ref3, 2), routeId = _$_ref3[0], error = _$_ref3[1];
                            errors = Object.assign(errors || {}, (0, $hD5pT._)({}, routeId, error));
                        });
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            $dc332a6010e2a7ab$var$_extends({
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        var flushSync = (opts && opts.unstable_flushSync) === true;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = $dc332a6010e2a7ab$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        var matches = $dc332a6010e2a7ab$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $dc332a6010e2a7ab$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        var _normalizeNavigateOptions = $dc332a6010e2a7ab$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        var match = $dc332a6010e2a7ab$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $dc332a6010e2a7ab$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(key, routeId, path, match, requestMatches, flushSync, submission) {
            var error, existingFetcher, abortController, fetchRequest, originatingLoadId, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, doneFetcher;
            return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!match.route.action && !match.route.lazy) {
                            error = $dc332a6010e2a7ab$var$getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            });
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, $dc332a6010e2a7ab$var$getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        // Call the action for the fetcher
                        abortController = new AbortController();
                        fetchRequest = $dc332a6010e2a7ab$var$createClientSideRequest(init.history, path, abortController.signal, submission);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $dc332a6010e2a7ab$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)
                        ];
                    case 1:
                        actionResult = _state.sent();
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
                        // or redirects processed for unmounted fetchers so we just revert them to
                        // idle
                        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
                            if ($dc332a6010e2a7ab$var$isRedirectResult(actionResult) || $dc332a6010e2a7ab$var$isErrorResult(actionResult)) {
                                updateFetcherState(key, $dc332a6010e2a7ab$var$getDoneFetcher(undefined));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if ($dc332a6010e2a7ab$var$isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    // A new navigation was kicked off after our action started, so that
                                    // should take precedence over this redirect navigation.  We already
                                    // set isRevalidationRequired so all loaders for the new route should
                                    // fire unless opted out via shouldRevalidate
                                    updateFetcherState(key, $dc332a6010e2a7ab$var$getDoneFetcher(undefined));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, $dc332a6010e2a7ab$var$getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(state, actionResult, {
                                            fetcherSubmission: submission
                                        })
                                    ];
                                }
                            }
                            // Process any non-redirect errors thrown
                            if ($dc332a6010e2a7ab$var$isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        if ($dc332a6010e2a7ab$var$isDeferredResult(actionResult)) throw $dc332a6010e2a7ab$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = $dc332a6010e2a7ab$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? $dc332a6010e2a7ab$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
                        $dc332a6010e2a7ab$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = $dc332a6010e2a7ab$var$getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $kB67t._)($dc332a6010e2a7ab$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, (0, $hD5pT._)({}, match.route.id, actionResult.data), undefined // No need to send through errors since we short circuit above
                        ), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = $dc332a6010e2a7ab$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 2:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = $dc332a6010e2a7ab$var$findRedirect(results);
                        if (redirect) {
                            if (redirect.idx >= matchesToLoad.length) {
                                // If this redirect came from a fetcher make sure we mark it in
                                // fetchRedirectIds so it doesn't get revalidated on the next set of
                                // loader executions
                                fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                                fetchRedirectIds.add(fetcherKey);
                            }
                            return [
                                2,
                                startRedirectNavigation(state, redirect.result)
                            ];
                        }
                        // Process and commit output from loaders
                        _processLoaderData = $dc332a6010e2a7ab$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher = $dc332a6010e2a7ab$var$getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            $dc332a6010e2a7ab$export$3e9cee6b33872309(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState({
                                errors: errors,
                                loaderData: $dc332a6010e2a7ab$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(key, routeId, path, match, matches, flushSync, submission) {
            var existingFetcher, abortController, fetchRequest, originatingLoadId, result;
            return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, $dc332a6010e2a7ab$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
                            flushSync: flushSync
                        });
                        // Call the loader for this fetcher route match
                        abortController = new AbortController();
                        fetchRequest = $dc332a6010e2a7ab$var$createClientSideRequest(init.history, path, abortController.signal);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $dc332a6010e2a7ab$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)
                        ];
                    case 1:
                        result = _state.sent();
                        if (!$dc332a6010e2a7ab$var$isDeferredResult(result)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            $dc332a6010e2a7ab$var$resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 2:
                        result = _state.sent() || result;
                        _state.label = 3;
                    case 3:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        // We don't want errors bubbling up or redirects followed for unmounted
                        // fetchers, so short circuit here if it was removed from the UI
                        if (deletedFetchers.has(key)) {
                            updateFetcherState(key, $dc332a6010e2a7ab$var$getDoneFetcher(undefined));
                            return [
                                2
                            ];
                        }
                        if (!$dc332a6010e2a7ab$var$isRedirectResult(result)) return [
                            3,
                            6
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            4
                        ];
                        // A new navigation was kicked off after our loader started, so that
                        // should take precedence over this redirect navigation
                        updateFetcherState(key, $dc332a6010e2a7ab$var$getDoneFetcher(undefined));
                        return [
                            2
                        ];
                    case 4:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(state, result)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        // Process any non-redirect errors thrown
                        if ($dc332a6010e2a7ab$var$isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        $dc332a6010e2a7ab$export$3e9cee6b33872309(!$dc332a6010e2a7ab$var$isDeferredResult(result), "Unhandled fetcher deferred data");
                        // Put the fetcher back into an idle state
                        updateFetcherState(key, $dc332a6010e2a7ab$var$getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(state, redirect, _temp2) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(state, redirect, _temp2) {
            var _ref, submission, fetcherSubmission, replace, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp2 === void 0 ? {} : _temp2, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, replace = _ref.replace;
                        if (redirect.revalidate) isRevalidationRequired = true;
                        redirectLocation = $dc332a6010e2a7ab$var$createLocation(state.location, redirect.location, {
                            _isRedirect: true
                        });
                        $dc332a6010e2a7ab$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if ($dc332a6010e2a7ab$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                                url = init.history.createURL(redirect.location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                $dc332a6010e2a7ab$export$b69e3301ce081aa3(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(redirect.location);
                                else routerWindow.location.assign(redirect.location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true ? $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Replace : $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Push;
                        // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $dc332a6010e2a7ab$var$getSubmissionFromNavigation(state.navigation);
                        // If this was a 307/308 submission we want to preserve the HTTP method and
                        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
                        // redirected location
                        activeSubmission = submission || fetcherSubmission;
                        if (!($dc332a6010e2a7ab$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $dc332a6010e2a7ab$var$isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: $dc332a6010e2a7ab$var$_extends({}, activeSubmission, {
                                    formAction: redirect.location
                                }),
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        // If we have a navigation submission, we will preserve it through the
                        // redirect navigation
                        overrideNavigation = $dc332a6010e2a7ab$var$getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
            var results, loaderResults, fetcherResults;
            return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all((0, $2Xzd1._)(matchesToLoad.map(function(match) {
                                return $dc332a6010e2a7ab$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                            })).concat((0, $2Xzd1._)(fetchersToLoad.map(function(f) {
                                if (f.matches && f.match && f.controller) return $dc332a6010e2a7ab$var$callLoaderOrAction("loader", $dc332a6010e2a7ab$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                                else {
                                    var error = {
                                        type: $dc332a6010e2a7ab$var$ResultType.error,
                                        error: $dc332a6010e2a7ab$var$getInternalRouterError(404, {
                                            pathname: f.path
                                        })
                                    };
                                    return error;
                                }
                            }))))
                        ];
                    case 1:
                        results = _state.sent();
                        loaderResults = results.slice(0, matchesToLoad.length);
                        fetcherResults = results.slice(matchesToLoad.length);
                        return [
                            4,
                            Promise.all([
                                $dc332a6010e2a7ab$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(function() {
                                    return request.signal;
                                }), false, state.loaderData),
                                $dc332a6010e2a7ab$var$resolveDeferredResults(currentMatches, fetchersToLoad.map(function(f) {
                                    return f.match;
                                }), fetcherResults, fetchersToLoad.map(function(f) {
                                    return f.controller ? f.controller.signal : null;
                                }), true)
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                results: results,
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $2Xzd1._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        var boundaryMatch = $dc332a6010e2a7ab$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $hD5pT._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $dc332a6010e2a7ab$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            var count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        $dc332a6010e2a7ab$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = $dc332a6010e2a7ab$var$getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                $dc332a6010e2a7ab$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    $dc332a6010e2a7ab$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || $dc332a6010e2a7ab$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || $dc332a6010e2a7ab$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $dc332a6010e2a7ab$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        var currentLocation = _ref4.currentLocation, nextLocation = _ref4.nextLocation, historyAction = _ref4.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $dc332a6010e2a7ab$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $kB67t._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $dc332a6010e2a7ab$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return $dc332a6010e2a7ab$export$b3fac024fad9e8ff(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $dc332a6010e2a7ab$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var $dc332a6010e2a7ab$export$4d0306f8f6a4585b = Symbol("deferred");
function $dc332a6010e2a7ab$export$3336b097a6fbc59a(routes, opts) {
    $dc332a6010e2a7ab$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $dc332a6010e2a7ab$var$defaultMapRouteProperties;
    // Config driven behavior flags
    var future = $dc332a6010e2a7ab$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    var dataRoutes = $dc332a6010e2a7ab$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp3) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(request, _temp3) {
            var requestContext, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestContext = (_temp3 === void 0 ? {} : _temp3).requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $dc332a6010e2a7ab$var$createLocation("", $dc332a6010e2a7ab$export$fe53371bee54353d(url), null, "default");
                        matches = $dc332a6010e2a7ab$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$dc332a6010e2a7ab$var$isValidMethod(method) && method !== "HEAD") {
                            error = $dc332a6010e2a7ab$var$getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = $dc332a6010e2a7ab$var$getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $hD5pT._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = $dc332a6010e2a7ab$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = $dc332a6010e2a7ab$var$getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $hD5pT._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($dc332a6010e2a7ab$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            $dc332a6010e2a7ab$var$_extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp4) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(request, _temp4) {
            var _ref, routeId, requestContext, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp4 === void 0 ? {} : _temp4, routeId = _ref.routeId, requestContext = _ref.requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $dc332a6010e2a7ab$var$createLocation("", $dc332a6010e2a7ab$export$fe53371bee54353d(url), null, "default");
                        matches = $dc332a6010e2a7ab$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$dc332a6010e2a7ab$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $dc332a6010e2a7ab$var$getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw $dc332a6010e2a7ab$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : $dc332a6010e2a7ab$var$getTargetMatch(matches, location);
                        if (routeId && !match) throw $dc332a6010e2a7ab$var$getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw $dc332a6010e2a7ab$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($dc332a6010e2a7ab$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$dc332a6010e2a7ab$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(request, location, matches, requestContext, routeMatch) {
            var result, result1, e;
            return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $dc332a6010e2a7ab$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!$dc332a6010e2a7ab$var$isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || $dc332a6010e2a7ab$var$getTargetMatch(matches, location), requestContext, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            $dc332a6010e2a7ab$var$isResponse(result1) ? result1 : $dc332a6010e2a7ab$var$_extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction, we throw
                        // it to bail out and then return or throw here based on whether the user
                        // returned or threw
                        if ($dc332a6010e2a7ab$var$isQueryRouteResponse(e)) {
                            if (e.type === $dc332a6010e2a7ab$var$ResultType.error) throw e.response;
                            return [
                                2,
                                e.response
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if ($dc332a6010e2a7ab$var$isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(request, matches, actionMatch, requestContext, isRouteRequest) {
            var result, error, error1, boundaryMatch, context, loaderRequest, context1;
            return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = $dc332a6010e2a7ab$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: $dc332a6010e2a7ab$var$ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $dc332a6010e2a7ab$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                                isStaticRequest: true,
                                isRouteRequest: isRouteRequest,
                                requestContext: requestContext
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) $dc332a6010e2a7ab$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        _state.label = 3;
                    case 3:
                        if ($dc332a6010e2a7ab$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.status,
                            headers: {
                                Location: result.location
                            }
                        });
                        if ($dc332a6010e2a7ab$var$isDeferredResult(result)) {
                            error1 = $dc332a6010e2a7ab$var$getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: $dc332a6010e2a7ab$var$ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if ($dc332a6010e2a7ab$var$isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $hD5pT._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        if (!$dc332a6010e2a7ab$var$isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = $dc332a6010e2a7ab$var$findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, undefined, (0, $hD5pT._)({}, boundaryMatch.route.id, result.error))
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            $dc332a6010e2a7ab$var$_extends({}, context, {
                                statusCode: $dc332a6010e2a7ab$export$972111febbeef05b(result.error) ? result.error.status : 500,
                                actionData: null,
                                actionHeaders: $dc332a6010e2a7ab$var$_extends({}, result.headers ? (0, $hD5pT._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        // Create a GET request for the loaders
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            $dc332a6010e2a7ab$var$_extends({}, context1, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionData: (0, $hD5pT._)({}, actionMatch.route.id, result.data),
                                actionHeaders: $dc332a6010e2a7ab$var$_extends({}, result.headers ? (0, $hD5pT._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(request, matches, requestContext, routeMatch, pendingActionError) {
            var isRouteRequest, requestMatches, matchesToLoad, results, activeDeferreds, context, executedLoaders;
            return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $dc332a6010e2a7ab$var$getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : $dc332a6010e2a7ab$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $hD5pT._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionError || null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            Promise.all((0, $2Xzd1._)(matchesToLoad.map(function(match) {
                                return $dc332a6010e2a7ab$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                                    isStaticRequest: true,
                                    isRouteRequest: isRouteRequest,
                                    requestContext: requestContext
                                });
                            })))
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) $dc332a6010e2a7ab$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = $dc332a6010e2a7ab$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
                        // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            $dc332a6010e2a7ab$var$_extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $dc332a6010e2a7ab$export$fec11da027c70692(routes, context, error) {
    var newContext = $dc332a6010e2a7ab$var$_extends({}, context, {
        statusCode: $dc332a6010e2a7ab$export$972111febbeef05b(error) ? error.status : 500,
        errors: (0, $hD5pT._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function $dc332a6010e2a7ab$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $dc332a6010e2a7ab$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $dc332a6010e2a7ab$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = $dc332a6010e2a7ab$export$cae722b0cc860f13(to ? to : ".", $dc332a6010e2a7ab$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $dc332a6010e2a7ab$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$dc332a6010e2a7ab$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $dc332a6010e2a7ab$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $dc332a6010e2a7ab$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $dc332a6010e2a7ab$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$dc332a6010e2a7ab$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$dc332a6010e2a7ab$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $dc332a6010e2a7ab$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: $dc332a6010e2a7ab$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = $dc332a6010e2a7ab$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$dc332a6010e2a7ab$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref5) {
                var _$_ref5 = (0, $kB67t._)(_ref5, 2), name = _$_ref5[0], value = _$_ref5[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$dc332a6010e2a7ab$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $dc332a6010e2a7ab$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = $dc332a6010e2a7ab$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $dc332a6010e2a7ab$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $dc332a6010e2a7ab$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $dc332a6010e2a7ab$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($dc332a6010e2a7ab$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = $dc332a6010e2a7ab$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $dc332a6010e2a7ab$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $dc332a6010e2a7ab$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $dc332a6010e2a7ab$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var boundaryMatches = matches;
    if (boundaryId) {
        var index = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $dc332a6010e2a7ab$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    var actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    var boundaryMatches = $dc332a6010e2a7ab$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        var route = match.route;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($dc332a6010e2a7ab$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return $dc332a6010e2a7ab$var$shouldRevalidateLoader(match, $dc332a6010e2a7ab$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $dc332a6010e2a7ab$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || deletedFetchers.has(key)) return;
        var fetcherMatches = $dc332a6010e2a7ab$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = $dc332a6010e2a7ab$var$getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $dc332a6010e2a7ab$var$shouldRevalidateLoader(fetcherMatch, $dc332a6010e2a7ab$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $dc332a6010e2a7ab$var$isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $dc332a6010e2a7ab$var$isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $dc332a6010e2a7ab$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $dc332a6010e2a7ab$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return $dc332a6010e2a7ab$var$_loadLazyRouteModule.apply(this, arguments);
}
function $dc332a6010e2a7ab$var$_loadLazyRouteModule() {
    $dc332a6010e2a7ab$var$_loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    $dc332a6010e2a7ab$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
                    // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        $dc332a6010e2a7ab$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
                        if (!isPropertyStaticallyDefined && !$dc332a6010e2a7ab$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, $dc332a6010e2a7ab$var$_extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return $dc332a6010e2a7ab$var$_loadLazyRouteModule.apply(this, arguments);
}
function $dc332a6010e2a7ab$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    return $dc332a6010e2a7ab$var$_callLoaderOrAction.apply(this, arguments);
}
function $dc332a6010e2a7ab$var$_callLoaderOrAction() {
    $dc332a6010e2a7ab$var$_callLoaderOrAction = (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
        var resultType, result, onReject, runHandler, handler, handlerError, values, url, pathname, url1, pathname1, e, status, location, currentUrl, url2, isSameBasename, queryRouteResponse, data, contentType, e1, _result$init, _result$init2;
        return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (opts === void 0) opts = {};
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        return Promise.race([
                            handler({
                                request: request,
                                params: match.params,
                                context: opts.requestContext
                            }),
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!match.route.lazy) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            $dc332a6010e2a7ab$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                        ])
                    ];
                case 2:
                    values = _state.sent();
                    if (handlerError) throw handlerError;
                    result = values[0];
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        $dc332a6010e2a7ab$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still run even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw $dc332a6010e2a7ab$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: $dc332a6010e2a7ab$var$ResultType.data,
                            data: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw $dc332a6010e2a7ab$var$getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    $dc332a6010e2a7ab$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    resultType = $dc332a6010e2a7ab$var$ResultType.error;
                    result = e;
                    return [
                        3,
                        14
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    if (!$dc332a6010e2a7ab$var$isResponse(result)) return [
                        3,
                        24
                    ];
                    status = result.status;
                    // Process redirects
                    if ($dc332a6010e2a7ab$var$redirectStatusCodes.has(status)) {
                        location = result.headers.get("Location");
                        $dc332a6010e2a7ab$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
                        // Support relative routing in internal redirects
                        if (!$dc332a6010e2a7ab$var$ABSOLUTE_URL_REGEX.test(location)) location = $dc332a6010e2a7ab$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
                        else if (!opts.isStaticRequest) {
                            // Strip off the protocol+origin for same-origin + same-basename absolute
                            // redirects. If this is a static request, we can let it go back to the
                            // browser as-is
                            currentUrl = new URL(request.url);
                            url2 = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                            isSameBasename = $dc332a6010e2a7ab$export$b69e3301ce081aa3(url2.pathname, basename) != null;
                            if (url2.origin === currentUrl.origin && isSameBasename) location = url2.pathname + url2.search + url2.hash;
                        }
                        // Don't process redirects in the router during static requests requests.
                        // Instead, throw the Response and let the server handle it with an HTTP
                        // redirect.  We also update the Location header in place in this flow so
                        // basename and relative routing is taken into account
                        if (opts.isStaticRequest) {
                            result.headers.set("Location", location);
                            throw result;
                        }
                        return [
                            2,
                            {
                                type: $dc332a6010e2a7ab$var$ResultType.redirect,
                                status: status,
                                location: location,
                                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
                            }
                        ];
                    }
                    // For SSR single-route requests, we want to hand Responses back directly
                    // without unwrapping.  We do this with the QueryRouteResponse wrapper
                    // interface so we can know whether it was returned or thrown
                    if (opts.isRouteRequest) {
                        queryRouteResponse = {
                            type: resultType === $dc332a6010e2a7ab$var$ResultType.error ? $dc332a6010e2a7ab$var$ResultType.error : $dc332a6010e2a7ab$var$ResultType.data,
                            response: result
                        };
                        throw queryRouteResponse;
                    }
                    _state.label = 15;
                case 15:
                    _state.trys.push([
                        15,
                        22,
                        ,
                        23
                    ]);
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        19
                    ];
                    if (!(result.body == null)) return [
                        3,
                        16
                    ];
                    data = null;
                    return [
                        3,
                        18
                    ];
                case 16:
                    return [
                        4,
                        result.json()
                    ];
                case 17:
                    data = _state.sent();
                    _state.label = 18;
                case 18:
                    return [
                        3,
                        21
                    ];
                case 19:
                    return [
                        4,
                        result.text()
                    ];
                case 20:
                    data = _state.sent();
                    _state.label = 21;
                case 21:
                    return [
                        3,
                        23
                    ];
                case 22:
                    e1 = _state.sent();
                    return [
                        2,
                        {
                            type: $dc332a6010e2a7ab$var$ResultType.error,
                            error: e1
                        }
                    ];
                case 23:
                    if (resultType === $dc332a6010e2a7ab$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: new $dc332a6010e2a7ab$export$6c6580e81da25755(status, result.statusText, data),
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: $dc332a6010e2a7ab$var$ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 24:
                    if (resultType === $dc332a6010e2a7ab$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: result
                        }
                    ];
                    if ($dc332a6010e2a7ab$export$fbcedacb60443473(result)) {
                        ;
                        return [
                            2,
                            {
                                type: $dc332a6010e2a7ab$var$ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $dc332a6010e2a7ab$var$ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    });
    return $dc332a6010e2a7ab$var$_callLoaderOrAction.apply(this, arguments);
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $dc332a6010e2a7ab$var$createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL($dc332a6010e2a7ab$var$stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && $dc332a6010e2a7ab$var$isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $dc332a6010e2a7ab$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $dc332a6010e2a7ab$var$convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function $dc332a6010e2a7ab$var$convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function $dc332a6010e2a7ab$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach(function(result, index) {
        var id = matchesToLoad[index].route.id;
        $dc332a6010e2a7ab$export$3e9cee6b33872309(!$dc332a6010e2a7ab$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($dc332a6010e2a7ab$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            var boundaryMatch = $dc332a6010e2a7ab$var$findNearestBoundary(matches, id);
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $dc332a6010e2a7ab$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($dc332a6010e2a7ab$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $dc332a6010e2a7ab$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = $dc332a6010e2a7ab$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    for(var index = 0; index < revalidatingFetchers.length; index++){
        var _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, match = _revalidatingFetchers_index.match, controller = _revalidatingFetchers_index.controller;
        $dc332a6010e2a7ab$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        var result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($dc332a6010e2a7ab$var$isErrorResult(result)) {
            var boundaryMatch = $dc332a6010e2a7ab$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $dc332a6010e2a7ab$var$_extends({}, errors, (0, $hD5pT._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if ($dc332a6010e2a7ab$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $dc332a6010e2a7ab$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($dc332a6010e2a7ab$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $dc332a6010e2a7ab$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = $dc332a6010e2a7ab$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $dc332a6010e2a7ab$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = $dc332a6010e2a7ab$var$_extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $dc332a6010e2a7ab$var$findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $2Xzd1._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function $dc332a6010e2a7ab$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $dc332a6010e2a7ab$var$getInternalRouterError(status, _temp5) {
    var _ref = _temp5 === void 0 ? {} : _temp5, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $dc332a6010e2a7ab$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $dc332a6010e2a7ab$var$findRedirect(results) {
    for(var i = results.length - 1; i >= 0; i--){
        var result = results[i];
        if ($dc332a6010e2a7ab$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $dc332a6010e2a7ab$var$stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? $dc332a6010e2a7ab$export$8ccf933b0513f8d0(path) : path;
    return $dc332a6010e2a7ab$export$fe53371bee54353d($dc332a6010e2a7ab$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $dc332a6010e2a7ab$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $dc332a6010e2a7ab$var$isDeferredResult(result) {
    return result.type === $dc332a6010e2a7ab$var$ResultType.deferred;
}
function $dc332a6010e2a7ab$var$isErrorResult(result) {
    return result.type === $dc332a6010e2a7ab$var$ResultType.error;
}
function $dc332a6010e2a7ab$var$isRedirectResult(result) {
    return (result && result.type) === $dc332a6010e2a7ab$var$ResultType.redirect;
}
function $dc332a6010e2a7ab$export$fbcedacb60443473(value) {
    var deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $dc332a6010e2a7ab$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $dc332a6010e2a7ab$var$isRedirectResponse(result) {
    if (!$dc332a6010e2a7ab$var$isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $dc332a6010e2a7ab$var$isQueryRouteResponse(obj) {
    return obj && $dc332a6010e2a7ab$var$isResponse(obj.response) && (obj.type === $dc332a6010e2a7ab$var$ResultType.data || obj.type === $dc332a6010e2a7ab$var$ResultType.error);
}
function $dc332a6010e2a7ab$var$isValidMethod(method) {
    return $dc332a6010e2a7ab$var$validRequestMethods.has(method.toLowerCase());
}
function $dc332a6010e2a7ab$var$isMutationMethod(method) {
    return $dc332a6010e2a7ab$var$validMutationMethods.has(method.toLowerCase());
}
function $dc332a6010e2a7ab$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    return $dc332a6010e2a7ab$var$_resolveDeferredResults.apply(this, arguments);
}
function $dc332a6010e2a7ab$var$_resolveDeferredResults() {
    $dc332a6010e2a7ab$var$_resolveDeferredResults = (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
        var _loop, index;
        return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var result, match, currentMatch, isRevalidatingLoader, signal;
                        return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    result = results[index];
                                    match = matchesToLoad[index];
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !$dc332a6010e2a7ab$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!($dc332a6010e2a7ab$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader))) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    signal = signals[index];
                                    $dc332a6010e2a7ab$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        $dc332a6010e2a7ab$var$resolveDeferredData(result, signal, isFetcher).then(function(result) {
                                            if (result) results[index] = result || results[index];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < results.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $fc5e3658b603cf39$export$19a8beecd37a4c45)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $dc332a6010e2a7ab$var$_resolveDeferredResults.apply(this, arguments);
}
function $dc332a6010e2a7ab$var$resolveDeferredData(result, signal, unwrap) {
    return $dc332a6010e2a7ab$var$_resolveDeferredData.apply(this, arguments);
}
function $dc332a6010e2a7ab$var$_resolveDeferredData() {
    $dc332a6010e2a7ab$var$_resolveDeferredData = (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(result, signal, unwrap) {
        var aborted;
        return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: $dc332a6010e2a7ab$var$ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: $dc332a6010e2a7ab$var$ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $dc332a6010e2a7ab$var$ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return $dc332a6010e2a7ab$var$_resolveDeferredData.apply(this, arguments);
}
function $dc332a6010e2a7ab$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function $dc332a6010e2a7ab$var$getTargetMatch(matches, location) {
    var search = typeof location === "string" ? $dc332a6010e2a7ab$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $dc332a6010e2a7ab$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = $dc332a6010e2a7ab$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $dc332a6010e2a7ab$var$getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $dc332a6010e2a7ab$var$getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function $dc332a6010e2a7ab$var$getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $dc332a6010e2a7ab$var$getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function $dc332a6010e2a7ab$var$getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $dc332a6010e2a7ab$var$getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $dc332a6010e2a7ab$var$restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem($dc332a6010e2a7ab$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $kB67t._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $dc332a6010e2a7ab$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $kB67t._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $2Xzd1._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem($dc332a6010e2a7ab$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $dc332a6010e2a7ab$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $5dLwP = parcelRequire("5dLwP");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $lMNAp = parcelRequire("lMNAp");

var $fIwXP = parcelRequire("fIwXP");

function $9e36fd5982483bee$var$_extends() {
    $9e36fd5982483bee$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9e36fd5982483bee$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $9e36fd5982483bee$export$3add0d5dce533e2e = /*#__PURE__*/ $fIwXP.createContext(null);
var $9e36fd5982483bee$export$145dfa71566a64dc = /*#__PURE__*/ $fIwXP.createContext(null);
var $9e36fd5982483bee$var$AwaitContext = /*#__PURE__*/ $fIwXP.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $9e36fd5982483bee$export$26749e8557646306 = /*#__PURE__*/ $fIwXP.createContext(null);
var $9e36fd5982483bee$export$c7914228fb69b0f5 = /*#__PURE__*/ $fIwXP.createContext(null);
var $9e36fd5982483bee$export$9072aa6dd1f93057 = /*#__PURE__*/ $fIwXP.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $9e36fd5982483bee$var$RouteErrorContext = /*#__PURE__*/ $fIwXP.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $9e36fd5982483bee$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    var _React_useContext = $fIwXP.useContext($9e36fd5982483bee$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $9e36fd5982483bee$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $dc332a6010e2a7ab$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $9e36fd5982483bee$export$9c954a9d03d32f4a() {
    return $fIwXP.useContext($9e36fd5982483bee$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $9e36fd5982483bee$export$45d76561a5302f2b() {
    !$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    return $fIwXP.useContext($9e36fd5982483bee$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $9e36fd5982483bee$export$1b3f31771c5d07c() {
    return $fIwXP.useContext($9e36fd5982483bee$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $9e36fd5982483bee$export$6c330e8992e8a295(pattern) {
    !$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    var pathname = $9e36fd5982483bee$export$45d76561a5302f2b().pathname;
    return $fIwXP.useMemo(function() {
        return (0, $dc332a6010e2a7ab$export$81336c211d5ff295)(pattern, pathname);
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $9e36fd5982483bee$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $9e36fd5982483bee$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $fIwXP.useContext($9e36fd5982483bee$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $fIwXP.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $9e36fd5982483bee$export$9770f232ac06a008() {
    var isDataRoute = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $9e36fd5982483bee$var$useNavigateStable() : $9e36fd5982483bee$var$useNavigateUnstable();
}
function $9e36fd5982483bee$var$useNavigateUnstable() {
    !$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    var dataRouterContext = $fIwXP.useContext($9e36fd5982483bee$export$3add0d5dce533e2e);
    var _React_useContext = $fIwXP.useContext($9e36fd5982483bee$export$26749e8557646306), basename = _React_useContext.basename, future = _React_useContext.future, navigator = _React_useContext.navigator;
    var matches = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057).matches;
    var _useLocation = $9e36fd5982483bee$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $dc332a6010e2a7ab$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    var activeRef = $fIwXP.useRef(false);
    $9e36fd5982483bee$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $fIwXP.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $dc332a6010e2a7ab$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $dc332a6010e2a7ab$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $9e36fd5982483bee$var$OutletContext = /*#__PURE__*/ $fIwXP.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $9e36fd5982483bee$export$4138103a3ae699cc() {
    return $fIwXP.useContext($9e36fd5982483bee$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $9e36fd5982483bee$export$a3be3530d8e40d0b(context) {
    var outlet = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $9e36fd5982483bee$export$99eaa27ddbbb95ef() {
    var matches = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $9e36fd5982483bee$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var future = $fIwXP.useContext($9e36fd5982483bee$export$26749e8557646306).future;
    var matches = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057).matches;
    var _useLocation = $9e36fd5982483bee$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $dc332a6010e2a7ab$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $fIwXP.useMemo(function() {
        return (0, $dc332a6010e2a7ab$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $9e36fd5982483bee$export$5d3fca4a98652595(routes, locationArg) {
    return $9e36fd5982483bee$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $9e36fd5982483bee$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    var navigator = $fIwXP.useContext($9e36fd5982483bee$export$26749e8557646306).navigator;
    var _React_useContext = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $9e36fd5982483bee$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $dc332a6010e2a7ab$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        var segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    var matches = (0, $dc332a6010e2a7ab$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $9e36fd5982483bee$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $dc332a6010e2a7ab$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $dc332a6010e2a7ab$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $9e36fd5982483bee$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $dc332a6010e2a7ab$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $9e36fd5982483bee$var$DefaultErrorComponent() {
    var error = $9e36fd5982483bee$export$ed527bf60f6e05f2();
    var message = (0, $dc332a6010e2a7ab$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $fIwXP.createElement($fIwXP.Fragment, null, /*#__PURE__*/ $fIwXP.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $fIwXP.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $fIwXP.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $9e36fd5982483bee$var$defaultErrorElement = /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$DefaultErrorComponent, null);
var $9e36fd5982483bee$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $5dLwP._)(RenderErrorBoundary, _React_Component);
    var _super = (0, $lMNAp._)(RenderErrorBoundary);
    function RenderErrorBoundary(props) {
        (0, $bB0zn._)(this, RenderErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $6QEWP._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error !== undefined ? /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error !== undefined ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($fIwXP.Component);
function $9e36fd5982483bee$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $fIwXP.useContext($9e36fd5982483bee$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $9e36fd5982483bee$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]);
        });
        !(errorIndex >= 0) && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(var i = 0; i < renderedMatches.length; i++){
        var match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            var loaderData = dataRouterState.loaderData, errors1 = dataRouterState.errors;
            var needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors1 || errors1[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        // Only data routers handle errors/fallbacks
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $9e36fd5982483bee$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $9e36fd5982483bee$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $fIwXP.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $9e36fd5982483bee$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($9e36fd5982483bee$var$DataRouterHook || {});
var $9e36fd5982483bee$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($9e36fd5982483bee$var$DataRouterStateHook || {});
function $9e36fd5982483bee$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $9e36fd5982483bee$var$useDataRouterContext(hookName) {
    var ctx = $fIwXP.useContext($9e36fd5982483bee$export$3add0d5dce533e2e);
    !ctx && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    return ctx;
}
function $9e36fd5982483bee$var$useDataRouterState(hookName) {
    var state = $fIwXP.useContext($9e36fd5982483bee$export$145dfa71566a64dc);
    !state && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    return state;
}
function $9e36fd5982483bee$var$useRouteContext(hookName) {
    var route = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057);
    !route && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $9e36fd5982483bee$var$useCurrentRouteId(hookName) {
    var route = $9e36fd5982483bee$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $9e36fd5982483bee$export$5fc8298006ad9e58() {
    return $9e36fd5982483bee$var$useCurrentRouteId($9e36fd5982483bee$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $9e36fd5982483bee$export$d0fd4b7106de2769() {
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $9e36fd5982483bee$export$600dc272ed516c15() {
    var dataRouterContext = $9e36fd5982483bee$var$useDataRouterContext($9e36fd5982483bee$var$DataRouterHook.UseRevalidator);
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseRevalidator);
    return $fIwXP.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $9e36fd5982483bee$export$2378eb7f5ff86053() {
    var _useDataRouterState = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $fIwXP.useMemo(function() {
        return matches.map(function(m) {
            return (0, $dc332a6010e2a7ab$export$b3fac024fad9e8ff)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $9e36fd5982483bee$export$1448a5050d252c4d() {
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseLoaderData);
    var routeId = $9e36fd5982483bee$var$useCurrentRouteId($9e36fd5982483bee$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $9e36fd5982483bee$export$fd5d37484eab868d(routeId) {
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $9e36fd5982483bee$export$fdc00f3f26066d5e() {
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseActionData);
    var routeId = $9e36fd5982483bee$var$useCurrentRouteId($9e36fd5982483bee$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $9e36fd5982483bee$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $fIwXP.useContext($9e36fd5982483bee$var$RouteErrorContext);
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseRouteError);
    var routeId = $9e36fd5982483bee$var$useCurrentRouteId($9e36fd5982483bee$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $9e36fd5982483bee$export$78a72ddb39bdd145() {
    var value = $fIwXP.useContext($9e36fd5982483bee$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $9e36fd5982483bee$export$17f53340677d5831() {
    var value = $fIwXP.useContext($9e36fd5982483bee$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $9e36fd5982483bee$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $9e36fd5982483bee$export$b273b3273281a049(shouldBlock) {
    var _useDataRouterContext = $9e36fd5982483bee$var$useDataRouterContext($9e36fd5982483bee$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $kB67t._)($fIwXP.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $fIwXP.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $9e36fd5982483bee$var$_extends({}, currentLocation, {
                pathname: (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $9e36fd5982483bee$var$_extends({}, nextLocation, {
                pathname: (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $fIwXP.useEffect(function() {
        var key = String(++$9e36fd5982483bee$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $fIwXP.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $dc332a6010e2a7ab$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $9e36fd5982483bee$var$useNavigateStable() {
    var router = $9e36fd5982483bee$var$useDataRouterContext($9e36fd5982483bee$var$DataRouterHook.UseNavigateStable).router;
    var id = $9e36fd5982483bee$var$useCurrentRouteId($9e36fd5982483bee$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $fIwXP.useRef(false);
    $9e36fd5982483bee$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $fIwXP.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $9e36fd5982483bee$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $9e36fd5982483bee$var$alreadyWarned = {};
function $9e36fd5982483bee$var$warningOnce(key, cond, message) {
    if (!cond && !$9e36fd5982483bee$var$alreadyWarned[key]) $9e36fd5982483bee$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $9e36fd5982483bee$var$START_TRANSITION = "startTransition";
var $9e36fd5982483bee$var$startTransitionImpl = $fIwXP[$9e36fd5982483bee$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $9e36fd5982483bee$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $kB67t._)($fIwXP.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $fIwXP.useCallback(function(newState) {
        if (v7_startTransition && $9e36fd5982483bee$var$startTransitionImpl) $9e36fd5982483bee$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        });
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $fIwXP.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $fIwXP.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $fIwXP.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $fIwXP.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $fIwXP.createElement($fIwXP.Fragment, null, /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $9e36fd5982483bee$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, future = _ref2.future, state = _ref2.state;
    return $9e36fd5982483bee$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $9e36fd5982483bee$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $fIwXP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $dc332a6010e2a7ab$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $kB67t._)($fIwXP.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $fIwXP.useCallback(function(newState) {
        v7_startTransition && $9e36fd5982483bee$var$startTransitionImpl ? $9e36fd5982483bee$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $fIwXP.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $9e36fd5982483bee$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    var _React_useContext = $fIwXP.useContext($9e36fd5982483bee$export$26749e8557646306), future = _React_useContext.future, isStatic = _React_useContext.static;
    var matches = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057).matches;
    var _useLocation = $9e36fd5982483bee$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $9e36fd5982483bee$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $dc332a6010e2a7ab$export$cae722b0cc860f13)(to, (0, $dc332a6010e2a7ab$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $fIwXP.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $9e36fd5982483bee$export$910ae8079b2c2852(props) {
    return $9e36fd5982483bee$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $9e36fd5982483bee$export$e7b0ac011bb776c6(_props) {
    (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $9e36fd5982483bee$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $dc332a6010e2a7ab$export$e19cd5f9376f8cee).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1, future = _ref5.future;
    !!$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $fIwXP.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $9e36fd5982483bee$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        };
    }, [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $dc332a6010e2a7ab$export$8ccf933b0513f8d0)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $fIwXP.useMemo(function() {
        var trailingPathname = (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $9e36fd5982483bee$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $9e36fd5982483bee$export$5d3fca4a98652595($9e36fd5982483bee$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $9e36fd5982483bee$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$ResolveAwait, null, children));
}
var $9e36fd5982483bee$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($9e36fd5982483bee$var$AwaitRenderStatus || {});
var $9e36fd5982483bee$var$neverSettledPromise = new Promise(function() {});
var $9e36fd5982483bee$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $5dLwP._)(AwaitErrorBoundary, _React_Component);
    var _super = (0, $lMNAp._)(AwaitErrorBoundary);
    function AwaitErrorBoundary(props) {
        (0, $bB0zn._)(this, AwaitErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $6QEWP._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $9e36fd5982483bee$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $9e36fd5982483bee$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $9e36fd5982483bee$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = promise._error !== undefined ? $9e36fd5982483bee$var$AwaitRenderStatus.error : promise._data !== undefined ? $9e36fd5982483bee$var$AwaitRenderStatus.success : $9e36fd5982483bee$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $9e36fd5982483bee$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $9e36fd5982483bee$var$AwaitRenderStatus.error && promise._error instanceof (0, $dc332a6010e2a7ab$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
                throw $9e36fd5982483bee$var$neverSettledPromise;
                if (status === $9e36fd5982483bee$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $9e36fd5982483bee$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $9e36fd5982483bee$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($fIwXP.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $9e36fd5982483bee$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $9e36fd5982483bee$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $fIwXP.createElement($fIwXP.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $9e36fd5982483bee$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $fIwXP.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $fIwXP.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $2Xzd1._)(parentPath).concat([
            index
        ]);
        if (element.type === $fIwXP.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $9e36fd5982483bee$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $9e36fd5982483bee$export$e7b0ac011bb776c6) && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $9e36fd5982483bee$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $9e36fd5982483bee$export$daf73786167a7f72(matches) {
    return $9e36fd5982483bee$var$_renderMatches(matches);
}
function $9e36fd5982483bee$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $fIwXP.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $fIwXP.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $fIwXP.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $9e36fd5982483bee$export$f30f7e456d254e83(routes, opts) {
    return (0, $dc332a6010e2a7ab$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $9e36fd5982483bee$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $dc332a6010e2a7ab$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $9e36fd5982483bee$export$52b333d321859367
    }).initialize();
}



function $76a326218c469af1$var$_extends() {
    $76a326218c469af1$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $76a326218c469af1$var$_extends.apply(this, arguments);
}
function $76a326218c469af1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $76a326218c469af1$var$defaultMethod = "get";
var $76a326218c469af1$var$defaultEncType = "application/x-www-form-urlencoded";
function $76a326218c469af1$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $76a326218c469af1$var$isButtonElement(object) {
    return $76a326218c469af1$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $76a326218c469af1$var$isFormElement(object) {
    return $76a326218c469af1$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $76a326218c469af1$var$isInputElement(object) {
    return $76a326218c469af1$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $76a326218c469af1$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $76a326218c469af1$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$76a326218c469af1$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $76a326218c469af1$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $76a326218c469af1$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $76a326218c469af1$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var $76a326218c469af1$var$_formDataSupportsSubmitter = null;
function $76a326218c469af1$var$isFormDataSubmitterSupported() {
    if ($76a326218c469af1$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $76a326218c469af1$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $76a326218c469af1$var$_formDataSupportsSubmitter = true;
    }
    return $76a326218c469af1$var$_formDataSupportsSubmitter;
}
var $76a326218c469af1$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $76a326218c469af1$var$getFormEncType(encType) {
    if (encType != null && !$76a326218c469af1$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $76a326218c469af1$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($76a326218c469af1$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $76a326218c469af1$var$defaultMethod;
        encType = $76a326218c469af1$var$getFormEncType(target.getAttribute("enctype")) || $76a326218c469af1$var$defaultEncType;
        formData = new FormData(target);
    } else if ($76a326218c469af1$var$isButtonElement(target) || $76a326218c469af1$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $76a326218c469af1$var$defaultMethod;
        encType = $76a326218c469af1$var$getFormEncType(target.getAttribute("formenctype")) || $76a326218c469af1$var$getFormEncType(form.getAttribute("enctype")) || $76a326218c469af1$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$76a326218c469af1$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($76a326218c469af1$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $76a326218c469af1$var$defaultMethod;
        action = null;
        encType = $76a326218c469af1$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $76a326218c469af1$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $76a326218c469af1$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $76a326218c469af1$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
var $76a326218c469af1$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $76a326218c469af1$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $76a326218c469af1$export$1f3f55432a00e06d(routes, opts) {
    return (0, $dc332a6010e2a7ab$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $76a326218c469af1$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $dc332a6010e2a7ab$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $76a326218c469af1$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $9e36fd5982483bee$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $76a326218c469af1$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $dc332a6010e2a7ab$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $76a326218c469af1$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $dc332a6010e2a7ab$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $76a326218c469af1$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $9e36fd5982483bee$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $76a326218c469af1$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $76a326218c469af1$var$_extends({}, state, {
        errors: $76a326218c469af1$var$deserializeErrors(state.errors)
    });
    return state;
}
function $76a326218c469af1$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $dc332a6010e2a7ab$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
var $76a326218c469af1$export$7ad602f0e94e62d1 = /*#__PURE__*/ $fIwXP.createContext({
    isTransitioning: false
});
var $76a326218c469af1$export$148fd98d095596d4 = /*#__PURE__*/ $fIwXP.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $76a326218c469af1$var$START_TRANSITION = "startTransition";
var $76a326218c469af1$var$startTransitionImpl = $fIwXP[$76a326218c469af1$var$START_TRANSITION];
var $76a326218c469af1$var$FLUSH_SYNC = "flushSync";
var $76a326218c469af1$var$flushSyncImpl = $708acee34f03ee3d$exports[$76a326218c469af1$var$FLUSH_SYNC];
var $76a326218c469af1$var$USE_ID = "useId";
var $76a326218c469af1$var$useIdImpl = $fIwXP[$76a326218c469af1$var$USE_ID];
function $76a326218c469af1$var$startTransitionSafe(cb) {
    if ($76a326218c469af1$var$startTransitionImpl) $76a326218c469af1$var$startTransitionImpl(cb);
    else cb();
}
function $76a326218c469af1$var$flushSyncSafe(cb) {
    if ($76a326218c469af1$var$flushSyncImpl) $76a326218c469af1$var$flushSyncImpl(cb);
    else cb();
}
var $76a326218c469af1$var$Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $bB0zn._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $76a326218c469af1$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $kB67t._)($fIwXP.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var _React_useState1 = (0, $kB67t._)($fIwXP.useState(), 2), pendingState = _React_useState1[0], setPendingState = _React_useState1[1];
    var _React_useState2 = (0, $kB67t._)($fIwXP.useState({
        isTransitioning: false
    }), 2), vtContext = _React_useState2[0], setVtContext = _React_useState2[1];
    var _React_useState3 = (0, $kB67t._)($fIwXP.useState(), 2), renderDfd = _React_useState3[0], setRenderDfd = _React_useState3[1];
    var _React_useState4 = (0, $kB67t._)($fIwXP.useState(), 2), transition = _React_useState4[0], setTransition = _React_useState4[1];
    var _React_useState5 = (0, $kB67t._)($fIwXP.useState(), 2), interruption = _React_useState5[0], setInterruption = _React_useState5[1];
    var fetcherData = $fIwXP.useRef(new Map());
    var v7_startTransition = (future || {}).v7_startTransition;
    var optInStartTransition = $fIwXP.useCallback(function(cb) {
        if (v7_startTransition) $76a326218c469af1$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    var setState = $fIwXP.useCallback(function(newState, _ref2) {
        var deletedFetchers = _ref2.deletedFetchers, flushSync = _ref2.unstable_flushSync, viewTransitionOpts = _ref2.unstable_viewTransitionOpts;
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        var isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $76a326218c469af1$var$flushSyncSafe(function() {
                return setStateImpl(newState);
            });
            else optInStartTransition(function() {
                return setStateImpl(newState);
            });
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $76a326218c469af1$var$flushSyncSafe(function() {
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            var t = router.window.document.startViewTransition(function() {
                $76a326218c469af1$var$flushSyncSafe(function() {
                    return setStateImpl(newState);
                });
            });
            // Clean up after the animation completes
            t.finished.finally(function() {
                $76a326218c469af1$var$flushSyncSafe(function() {
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $76a326218c469af1$var$flushSyncSafe(function() {
                return setTransition(t);
            });
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $fIwXP.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $fIwXP.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $76a326218c469af1$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $fIwXP.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(/*#__PURE__*/ (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function() {
                return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            optInStartTransition(function() {
                                return setStateImpl(newState);
                            });
                            return [
                                4,
                                renderPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            transition.finished.finally(function() {
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $fIwXP.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $fIwXP.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $fIwXP.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $fIwXP.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $fIwXP.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $fIwXP.createElement($fIwXP.Fragment, null, /*#__PURE__*/ $fIwXP.createElement((0, $9e36fd5982483bee$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $fIwXP.createElement((0, $9e36fd5982483bee$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $fIwXP.createElement($76a326218c469af1$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $fIwXP.createElement($76a326218c469af1$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $fIwXP.createElement((0, $9e36fd5982483bee$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $fIwXP.createElement($76a326218c469af1$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $76a326218c469af1$var$DataRoutes(_ref3) {
    var routes = _ref3.routes, future = _ref3.future, state = _ref3.state;
    return (0, $9e36fd5982483bee$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $76a326218c469af1$export$9ba4e89fdfa1fc54(_ref4) {
    var basename = _ref4.basename, children = _ref4.children, future = _ref4.future, _$window = _ref4.window;
    var historyRef = $fIwXP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $dc332a6010e2a7ab$export$719fc203c4e16dee)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $kB67t._)($fIwXP.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $fIwXP.useCallback(function(newState) {
        v7_startTransition && $76a326218c469af1$var$startTransitionImpl ? $76a326218c469af1$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $fIwXP.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $fIwXP.createElement((0, $9e36fd5982483bee$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $76a326218c469af1$export$7221d69dcfc8e36b(_ref5) {
    var basename = _ref5.basename, children = _ref5.children, future = _ref5.future, _$window = _ref5.window;
    var historyRef = $fIwXP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $dc332a6010e2a7ab$export$b71fdd3798280242)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $kB67t._)($fIwXP.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $fIwXP.useCallback(function(newState) {
        v7_startTransition && $76a326218c469af1$var$startTransitionImpl ? $76a326218c469af1$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $fIwXP.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $fIwXP.createElement((0, $9e36fd5982483bee$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $76a326218c469af1$export$eefb0c834599897e(_ref6) {
    var basename = _ref6.basename, children = _ref6.children, future = _ref6.future, history = _ref6.history;
    var _React_useState = (0, $kB67t._)($fIwXP.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $fIwXP.useCallback(function(newState) {
        v7_startTransition && $76a326218c469af1$var$startTransitionImpl ? $76a326218c469af1$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $fIwXP.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $fIwXP.createElement((0, $9e36fd5982483bee$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
var $76a326218c469af1$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $76a326218c469af1$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ var $76a326218c469af1$export$a6c7ac8248d6e38a = /*#__PURE__*/ $fIwXP.forwardRef(function LinkWithRef(_ref7, ref) {
    var onClick = _ref7.onClick, relative = _ref7.relative, reloadDocument = _ref7.reloadDocument, replace = _ref7.replace, state = _ref7.state, target = _ref7.target, to = _ref7.to, preventScrollReset = _ref7.preventScrollReset, unstable_viewTransition = _ref7.unstable_viewTransition, rest = $76a326218c469af1$var$_objectWithoutPropertiesLoose(_ref7, $76a326218c469af1$var$_excluded);
    var basename = $fIwXP.useContext((0, $9e36fd5982483bee$export$26749e8557646306)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $76a326218c469af1$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($76a326218c469af1$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $9e36fd5982483bee$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var internalOnClick = $76a326218c469af1$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $fIwXP.createElement("a", $76a326218c469af1$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ var $76a326218c469af1$export$b0d92dbee9b5b60d = /*#__PURE__*/ $fIwXP.forwardRef(function NavLinkWithRef(_ref8, ref) {
    var tmp = _ref8["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref8_caseSensitive = _ref8.caseSensitive, caseSensitive = _ref8_caseSensitive === void 0 ? false : _ref8_caseSensitive, tmp1 = _ref8.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref8_end = _ref8.end, end = _ref8_end === void 0 ? false : _ref8_end, styleProp = _ref8.style, to = _ref8.to, unstable_viewTransition = _ref8.unstable_viewTransition, children = _ref8.children, rest = $76a326218c469af1$var$_objectWithoutPropertiesLoose(_ref8, $76a326218c469af1$var$_excluded2);
    var path = (0, $9e36fd5982483bee$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $9e36fd5982483bee$export$45d76561a5302f2b)();
    var routerState = $fIwXP.useContext((0, $9e36fd5982483bee$export$145dfa71566a64dc));
    var _React_useContext = $fIwXP.useContext((0, $9e36fd5982483bee$export$26749e8557646306)), navigator = _React_useContext.navigator, basename = _React_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $76a326218c469af1$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $fIwXP.createElement($76a326218c469af1$export$a6c7ac8248d6e38a, $76a326218c469af1$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $76a326218c469af1$export$a7fed597f4b8afd8 = /*#__PURE__*/ $fIwXP.forwardRef(function(_ref9, forwardedRef) {
    var fetcherKey = _ref9.fetcherKey, navigate = _ref9.navigate, reloadDocument = _ref9.reloadDocument, replace = _ref9.replace, state = _ref9.state, _ref9_method = _ref9.method, method = _ref9_method === void 0 ? $76a326218c469af1$var$defaultMethod : _ref9_method, action = _ref9.action, onSubmit = _ref9.onSubmit, relative = _ref9.relative, preventScrollReset = _ref9.preventScrollReset, unstable_viewTransition = _ref9.unstable_viewTransition, props = $76a326218c469af1$var$_objectWithoutPropertiesLoose(_ref9, $76a326218c469af1$var$_excluded3);
    var submit = $76a326218c469af1$export$47c85c6e3a081d3();
    var formAction = $76a326218c469af1$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $fIwXP.createElement("form", $76a326218c469af1$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $76a326218c469af1$export$11aac1aab828f1fa(_ref10) {
    var getKey = _ref10.getKey, storageKey = _ref10.storageKey;
    $76a326218c469af1$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $76a326218c469af1$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($76a326218c469af1$var$DataRouterHook || ($76a326218c469af1$var$DataRouterHook = {}));
var $76a326218c469af1$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($76a326218c469af1$var$DataRouterStateHook || ($76a326218c469af1$var$DataRouterStateHook = {}));
// Internal hooks
function $76a326218c469af1$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $76a326218c469af1$var$useDataRouterContext(hookName) {
    var ctx = $fIwXP.useContext((0, $9e36fd5982483bee$export$3add0d5dce533e2e));
    !ctx && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    return ctx;
}
function $76a326218c469af1$var$useDataRouterState(hookName) {
    var state = $fIwXP.useContext((0, $9e36fd5982483bee$export$145dfa71566a64dc));
    !state && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $76a326218c469af1$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, unstable_viewTransition = _ref.unstable_viewTransition;
    var navigate = (0, $9e36fd5982483bee$export$9770f232ac06a008)();
    var location = (0, $9e36fd5982483bee$export$45d76561a5302f2b)();
    var path = (0, $9e36fd5982483bee$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $fIwXP.useCallback(function(event) {
        if ($76a326218c469af1$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $dc332a6010e2a7ab$export$fe53371bee54353d)(location) === (0, $dc332a6010e2a7ab$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $76a326218c469af1$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $fIwXP.useRef($76a326218c469af1$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $fIwXP.useRef(false);
    var location = (0, $9e36fd5982483bee$export$45d76561a5302f2b)();
    var searchParams = $fIwXP.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $76a326218c469af1$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $9e36fd5982483bee$export$9770f232ac06a008)();
    var setSearchParams = $fIwXP.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $76a326218c469af1$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $76a326218c469af1$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
var $76a326218c469af1$var$fetcherId = 0;
var $76a326218c469af1$var$getUniqueFetcherId = function() {
    return "__" + String(++$76a326218c469af1$var$fetcherId) + "__";
};
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $76a326218c469af1$export$47c85c6e3a081d3() {
    var router = $76a326218c469af1$var$useDataRouterContext($76a326218c469af1$var$DataRouterHook.UseSubmit).router;
    var basename = $fIwXP.useContext((0, $9e36fd5982483bee$export$26749e8557646306)).basename;
    var currentRouteId = (0, $9e36fd5982483bee$export$5fc8298006ad9e58)();
    return $fIwXP.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $76a326218c469af1$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $76a326218c469af1$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        if (options.navigate === false) {
            var key = options.fetcherKey || $76a326218c469af1$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $76a326218c469af1$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $fIwXP.useContext((0, $9e36fd5982483bee$export$26749e8557646306)).basename;
    var routeContext = $fIwXP.useContext((0, $9e36fd5982483bee$export$9072aa6dd1f93057));
    !routeContext && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    var _routeContext_matches_slice = (0, $kB67t._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $76a326218c469af1$var$_extends({}, (0, $9e36fd5982483bee$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $9e36fd5982483bee$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        var params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $dc332a6010e2a7ab$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $dc332a6010e2a7ab$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $76a326218c469af1$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    var key = (_temp3 === void 0 ? {} : _temp3).key;
    var router = $76a326218c469af1$var$useDataRouterContext($76a326218c469af1$var$DataRouterHook.UseFetcher).router;
    var state = $76a326218c469af1$var$useDataRouterState($76a326218c469af1$var$DataRouterStateHook.UseFetcher);
    var fetcherData = $fIwXP.useContext($76a326218c469af1$export$148fd98d095596d4);
    var route = $fIwXP.useContext((0, $9e36fd5982483bee$export$9072aa6dd1f93057));
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    !route && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var defaultKey = $76a326218c469af1$var$useIdImpl ? $76a326218c469af1$var$useIdImpl() : "";
    var _React_useState = (0, $kB67t._)($fIwXP.useState(key || defaultKey), 2), fetcherKey = _React_useState[0], setFetcherKey = _React_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($76a326218c469af1$var$getUniqueFetcherId());
    // Registration/cleanup
    $fIwXP.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    var load = $fIwXP.useCallback(function(href, opts) {
        !routeId && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = $76a326218c469af1$export$47c85c6e3a081d3();
    var submit = $fIwXP.useCallback(function(target, opts) {
        submitImpl(target, $76a326218c469af1$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    var FetcherForm = $fIwXP.useMemo(function() {
        var FetcherForm = /*#__PURE__*/ $fIwXP.forwardRef(function(props, ref) {
            return /*#__PURE__*/ $fIwXP.createElement($76a326218c469af1$export$a7fed597f4b8afd8, $76a326218c469af1$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    var fetcher = state.fetchers.get(fetcherKey) || (0, $dc332a6010e2a7ab$export$52eace9c284d3585);
    var data = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $fIwXP.useMemo(function() {
        return $76a326218c469af1$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        });
    }, [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $76a326218c469af1$export$fa996778a3a31087() {
    var state = $76a326218c469af1$var$useDataRouterState($76a326218c469af1$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map(function(_ref11) {
        var _$_ref11 = (0, $kB67t._)(_ref11, 2), key = _$_ref11[0], fetcher = _$_ref11[1];
        return $76a326218c469af1$var$_extends({}, fetcher, {
            key: key
        });
    });
}
var $76a326218c469af1$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $76a326218c469af1$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $76a326218c469af1$export$25057cfe5591e3e9(_temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $76a326218c469af1$var$useDataRouterContext($76a326218c469af1$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $76a326218c469af1$var$useDataRouterState($76a326218c469af1$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $fIwXP.useContext((0, $9e36fd5982483bee$export$26749e8557646306)).basename;
    var location = (0, $9e36fd5982483bee$export$45d76561a5302f2b)();
    var matches = (0, $9e36fd5982483bee$export$2378eb7f5ff86053)();
    var navigation = (0, $9e36fd5982483bee$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $fIwXP.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $76a326218c469af1$var$usePageHide($fIwXP.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $76a326218c469af1$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $76a326218c469af1$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($76a326218c469af1$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $fIwXP.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $76a326218c469af1$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $76a326218c469af1$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $fIwXP.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($76a326218c469af1$var$_extends({}, location, {
                    pathname: (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($76a326218c469af1$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $fIwXP.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $76a326218c469af1$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $fIwXP.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $76a326218c469af1$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $fIwXP.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $76a326218c469af1$export$39f4eb3dbd812741(_ref12) {
    var when = _ref12.when, message = _ref12.message;
    var blocker = (0, $9e36fd5982483bee$export$b273b3273281a049)(when);
    $fIwXP.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $fIwXP.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $76a326218c469af1$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    var vtContext = $fIwXP.useContext($76a326218c469af1$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    var basename = $76a326218c469af1$var$useDataRouterContext($76a326218c469af1$var$DataRouterHook.useViewTransitionState).basename;
    var path = (0, $9e36fd5982483bee$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $dc332a6010e2a7ab$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $dc332a6010e2a7ab$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $kB67t = parcelRequire("kB67t");

var $fIwXP = parcelRequire("fIwXP");
var $3c7428cbea0d9bb7$var$useOnlineStatus = function() {
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(true), 2), onlineStatus = _useState[0], setOnlineStatus = _useState[1];
    // check if online
    (0, $fIwXP.useEffect)(function() {
        window.addEventListener("offline", function() {
            setOnlineStatus(false);
        });
        window.addEventListener("online", function() {
            setOnlineStatus(true);
        });
    }, []);
    // boolean value
    return onlineStatus;
};
var $3c7428cbea0d9bb7$export$2e2bcd8739ae039 = $3c7428cbea0d9bb7$var$useOnlineStatus;



var $fIwXP = parcelRequire("fIwXP");
var $0cf10ba694782b3e$var$UserContext = /*#__PURE__*/ (0, $fIwXP.createContext)({
    loggedInUser: "Default User"
});
var $0cf10ba694782b3e$export$2e2bcd8739ae039 = $0cf10ba694782b3e$var$UserContext;



var $hD5pT = parcelRequire("hD5pT");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");

var $fIwXP = parcelRequire("fIwXP");
var $6dda7e3f4bfdb607$exports = {};
"use strict";

$6dda7e3f4bfdb607$exports = (parcelRequire("gHY9J"));


var $c7b80bd183211e5d$var$__defProp = Object.defineProperty;
var $c7b80bd183211e5d$var$__defProps = Object.defineProperties;
var $c7b80bd183211e5d$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $c7b80bd183211e5d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c7b80bd183211e5d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c7b80bd183211e5d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c7b80bd183211e5d$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $c7b80bd183211e5d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $c7b80bd183211e5d$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($c7b80bd183211e5d$var$__hasOwnProp.call(b, prop)) $c7b80bd183211e5d$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($c7b80bd183211e5d$var$__getOwnPropSymbols) try {
        for(var _iterator = $c7b80bd183211e5d$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($c7b80bd183211e5d$var$__propIsEnum.call(b, prop)) $c7b80bd183211e5d$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $c7b80bd183211e5d$var$__spreadProps = function(a, b) {
    return $c7b80bd183211e5d$var$__defProps(a, $c7b80bd183211e5d$var$__getOwnPropDescs(b));
};
var $c7b80bd183211e5d$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($c7b80bd183211e5d$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $c7b80bd183211e5d$var$__getOwnPropSymbols) try {
        for(var _iterator = $c7b80bd183211e5d$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $c7b80bd183211e5d$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
var $c7b80bd183211e5d$var$React = // prettier-ignore
// @ts-ignore
"default" in $fIwXP ? $fIwXP["default"] : $fIwXP;
// src/components/Context.ts
var $c7b80bd183211e5d$var$ContextKey = Symbol.for("react-redux-context");
var $c7b80bd183211e5d$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $c7b80bd183211e5d$var$getContext() {
    var _a;
    if (!$c7b80bd183211e5d$var$React.createContext) return {};
    var contextMap = (_a = $c7b80bd183211e5d$var$gT[$c7b80bd183211e5d$var$ContextKey]) != null ? _a : $c7b80bd183211e5d$var$gT[$c7b80bd183211e5d$var$ContextKey] = /* @__PURE__ */ new Map();
    var realContext = contextMap.get($c7b80bd183211e5d$var$React.createContext);
    if (!realContext) {
        realContext = $c7b80bd183211e5d$var$React.createContext(null);
        contextMap.set($c7b80bd183211e5d$var$React.createContext, realContext);
    }
    return realContext;
}
var $c7b80bd183211e5d$export$cc80c08dc91f1c00 = /* @__PURE__ */ $c7b80bd183211e5d$var$getContext();
// src/utils/useSyncExternalStore.ts
var $c7b80bd183211e5d$var$notInitialized = function() {
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $c7b80bd183211e5d$var$createReduxContextHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    return function useReduxContext2() {
        var contextValue = $c7b80bd183211e5d$var$React.useContext(context);
        return contextValue;
    };
}
var $c7b80bd183211e5d$var$useReduxContext = /* @__PURE__ */ $c7b80bd183211e5d$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $c7b80bd183211e5d$var$useSyncExternalStoreWithSelector = $c7b80bd183211e5d$var$notInitialized;
var $c7b80bd183211e5d$var$initializeUseSelector = function(fn) {
    $c7b80bd183211e5d$var$useSyncExternalStoreWithSelector = fn;
};
var $c7b80bd183211e5d$var$refEquality = function(a, b) {
    return a === b;
};
function $c7b80bd183211e5d$export$2b53f90d2bd1cbfb() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $c7b80bd183211e5d$export$cc80c08dc91f1c00 ? $c7b80bd183211e5d$var$useReduxContext : $c7b80bd183211e5d$var$createReduxContextHook(context);
    var useSelector2 = function(selector) {
        var equalityFnOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _ref = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions, _ref_equalityFn = _ref.equalityFn, equalityFn = _ref_equalityFn === void 0 ? $c7b80bd183211e5d$var$refEquality : _ref_equalityFn, _ref_devModeChecks = _ref.devModeChecks, devModeChecks = _ref_devModeChecks === void 0 ? {} : _ref_devModeChecks;
        var _useReduxContext2 = useReduxContext2(), store = _useReduxContext2.store, subscription = _useReduxContext2.subscription, getServerState = _useReduxContext2.getServerState, stabilityCheck = _useReduxContext2.stabilityCheck, identityFunctionCheck = _useReduxContext2.identityFunctionCheck;
        var firstRun = $c7b80bd183211e5d$var$React.useRef(true);
        var wrappedSelector = $c7b80bd183211e5d$var$React.useCallback((0, $hD5pT._)({}, selector.name, function(state) {
            var selected = selector(state);
            var e, e1;
            return selected;
        })[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        var selectedState = $c7b80bd183211e5d$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $c7b80bd183211e5d$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: function() {
            return useSelector2;
        }
    });
    return useSelector2;
}
var $c7b80bd183211e5d$export$2105062e25df4afe = /* @__PURE__ */ $c7b80bd183211e5d$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $c7b80bd183211e5d$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $c7b80bd183211e5d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $c7b80bd183211e5d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $c7b80bd183211e5d$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $c7b80bd183211e5d$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $c7b80bd183211e5d$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $c7b80bd183211e5d$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $c7b80bd183211e5d$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $c7b80bd183211e5d$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $c7b80bd183211e5d$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $c7b80bd183211e5d$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $c7b80bd183211e5d$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $c7b80bd183211e5d$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $c7b80bd183211e5d$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $c7b80bd183211e5d$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $c7b80bd183211e5d$var$ForwardRef = $c7b80bd183211e5d$var$REACT_FORWARD_REF_TYPE;
var $c7b80bd183211e5d$var$Memo = $c7b80bd183211e5d$var$REACT_MEMO_TYPE;
function $c7b80bd183211e5d$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $c7b80bd183211e5d$var$REACT_FRAGMENT_TYPE || type === $c7b80bd183211e5d$var$REACT_PROFILER_TYPE || type === $c7b80bd183211e5d$var$REACT_STRICT_MODE_TYPE || type === $c7b80bd183211e5d$var$REACT_SUSPENSE_TYPE || type === $c7b80bd183211e5d$var$REACT_SUSPENSE_LIST_TYPE || type === $c7b80bd183211e5d$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $c7b80bd183211e5d$var$REACT_LAZY_TYPE || type.$$typeof === $c7b80bd183211e5d$var$REACT_MEMO_TYPE || type.$$typeof === $c7b80bd183211e5d$var$REACT_PROVIDER_TYPE || type.$$typeof === $c7b80bd183211e5d$var$REACT_CONTEXT_TYPE || type.$$typeof === $c7b80bd183211e5d$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $c7b80bd183211e5d$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $c7b80bd183211e5d$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $c7b80bd183211e5d$var$REACT_ELEMENT_TYPE:
                {
                    var type = object.type;
                    switch(type){
                        case $c7b80bd183211e5d$var$REACT_FRAGMENT_TYPE:
                        case $c7b80bd183211e5d$var$REACT_PROFILER_TYPE:
                        case $c7b80bd183211e5d$var$REACT_STRICT_MODE_TYPE:
                        case $c7b80bd183211e5d$var$REACT_SUSPENSE_TYPE:
                        case $c7b80bd183211e5d$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                var $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $c7b80bd183211e5d$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $c7b80bd183211e5d$var$REACT_CONTEXT_TYPE:
                                    case $c7b80bd183211e5d$var$REACT_FORWARD_REF_TYPE:
                                    case $c7b80bd183211e5d$var$REACT_LAZY_TYPE:
                                    case $c7b80bd183211e5d$var$REACT_MEMO_TYPE:
                                    case $c7b80bd183211e5d$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $c7b80bd183211e5d$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $c7b80bd183211e5d$var$isContextConsumer(object) {
    return $c7b80bd183211e5d$var$typeOf(object) === $c7b80bd183211e5d$var$REACT_CONTEXT_TYPE;
}
function $c7b80bd183211e5d$var$isMemo(object) {
    return $c7b80bd183211e5d$var$typeOf(object) === $c7b80bd183211e5d$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $c7b80bd183211e5d$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $c7b80bd183211e5d$var$verify(selector, methodName) {
    if (!selector) throw new Error("Unexpected value for ".concat(methodName, " in connect."));
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $c7b80bd183211e5d$var$warning("The selector for ".concat(methodName, " of connect did not specify a value for dependsOnOwnProps."));
    }
}
function $c7b80bd183211e5d$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $c7b80bd183211e5d$var$verify(mapStateToProps, "mapStateToProps");
    $c7b80bd183211e5d$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $c7b80bd183211e5d$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $c7b80bd183211e5d$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, param) {
    var areStatesEqual = param.areStatesEqual, areOwnPropsEqual = param.areOwnPropsEqual, areStatePropsEqual = param.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $c7b80bd183211e5d$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, initMapStateToProps = _b.initMapStateToProps, initMapDispatchToProps = _b.initMapDispatchToProps, initMergeProps = _b.initMergeProps, options = $c7b80bd183211e5d$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    return $c7b80bd183211e5d$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $c7b80bd183211e5d$var$bindActionCreators(actionCreators, dispatch) {
    var _loop = function(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return dispatch(actionCreator.apply(void 0, (0, $2Xzd1._)(args)));
        };
    };
    var boundActionCreators = {};
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $c7b80bd183211e5d$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $c7b80bd183211e5d$var$verifyPlainObject(value, displayName, methodName) {
    if (!$c7b80bd183211e5d$var$isPlainObject(value)) $c7b80bd183211e5d$var$warning("".concat(methodName, "() in ").concat(displayName, " must return a plain object. Instead received ").concat(value, "."));
}
// src/connect/wrapMapToProps.ts
function $c7b80bd183211e5d$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        var constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $c7b80bd183211e5d$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $c7b80bd183211e5d$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, param) {
        var displayName = param.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $c7b80bd183211e5d$var$getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $c7b80bd183211e5d$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $c7b80bd183211e5d$var$createInvalidArgFactory(arg, name) {
    return function(dispatch, options) {
        throw new Error("Invalid value of type ".concat(typeof arg === "undefined" ? "undefined" : (0, $YtE9h._)(arg), " for ").concat(name, " argument when connecting component ").concat(options.wrappedComponentName, "."));
    };
}
// src/connect/mapDispatchToProps.ts
function $c7b80bd183211e5d$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $c7b80bd183211e5d$var$wrapMapToPropsConstant(function(dispatch) {
        return(// @ts-ignore
        $c7b80bd183211e5d$var$bindActionCreators(mapDispatchToProps, dispatch));
    }) : !mapDispatchToProps ? $c7b80bd183211e5d$var$wrapMapToPropsConstant(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $c7b80bd183211e5d$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $c7b80bd183211e5d$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $c7b80bd183211e5d$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $c7b80bd183211e5d$var$wrapMapToPropsConstant(function() {
        return {};
    }) : typeof mapStateToProps === "function" ? // @ts-ignore
    $c7b80bd183211e5d$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $c7b80bd183211e5d$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $c7b80bd183211e5d$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $c7b80bd183211e5d$var$__spreadValues($c7b80bd183211e5d$var$__spreadValues($c7b80bd183211e5d$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $c7b80bd183211e5d$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, param) {
        var displayName = param.displayName, areMergedPropsEqual = param.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $c7b80bd183211e5d$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? function() {
        return $c7b80bd183211e5d$var$defaultMergeProps;
    } : typeof mergeProps === "function" ? $c7b80bd183211e5d$var$wrapMergePropsFunc(mergeProps) : $c7b80bd183211e5d$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $c7b80bd183211e5d$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $c7b80bd183211e5d$var$createListenerCollection() {
    var first = null;
    var last = null;
    return {
        clear: function() {
            first = null;
            last = null;
        },
        notify: function() {
            $c7b80bd183211e5d$var$defaultNoopBatch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $c7b80bd183211e5d$var$nullListeners = {
    notify: function() {},
    get: function() {
        return [];
    }
};
function $c7b80bd183211e5d$var$createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = $c7b80bd183211e5d$var$nullListeners;
    var subscriptionsAmount = 0;
    var selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        var cleanupListener = listeners.subscribe(listener);
        var removed = false;
        return function() {
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $c7b80bd183211e5d$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $c7b80bd183211e5d$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: function() {
            return listeners;
        }
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $c7b80bd183211e5d$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $c7b80bd183211e5d$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $c7b80bd183211e5d$var$useIsomorphicLayoutEffect = $c7b80bd183211e5d$var$canUseDOM || $c7b80bd183211e5d$var$isReactNative ? $c7b80bd183211e5d$var$React.useLayoutEffect : $c7b80bd183211e5d$var$React.useEffect;
// src/utils/shallowEqual.ts
function $c7b80bd183211e5d$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $c7b80bd183211e5d$export$d36bdfa510afb180(objA, objB) {
    if ($c7b80bd183211e5d$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$c7b80bd183211e5d$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $c7b80bd183211e5d$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $c7b80bd183211e5d$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $c7b80bd183211e5d$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $c7b80bd183211e5d$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $c7b80bd183211e5d$var$_obj;
var $c7b80bd183211e5d$var$TYPE_STATICS = ($c7b80bd183211e5d$var$_obj = {}, (0, $hD5pT._)($c7b80bd183211e5d$var$_obj, $c7b80bd183211e5d$var$ForwardRef, $c7b80bd183211e5d$var$FORWARD_REF_STATICS), (0, $hD5pT._)($c7b80bd183211e5d$var$_obj, $c7b80bd183211e5d$var$Memo, $c7b80bd183211e5d$var$MEMO_STATICS), $c7b80bd183211e5d$var$_obj);
function $c7b80bd183211e5d$var$getStatics(component) {
    if ($c7b80bd183211e5d$var$isMemo(component)) return $c7b80bd183211e5d$var$MEMO_STATICS;
    return $c7b80bd183211e5d$var$TYPE_STATICS[component["$$typeof"]] || $c7b80bd183211e5d$var$REACT_STATICS;
}
var $c7b80bd183211e5d$var$defineProperty = Object.defineProperty;
var $c7b80bd183211e5d$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $c7b80bd183211e5d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $c7b80bd183211e5d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $c7b80bd183211e5d$var$getPrototypeOf = Object.getPrototypeOf;
var $c7b80bd183211e5d$var$objectPrototype = Object.prototype;
function $c7b80bd183211e5d$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($c7b80bd183211e5d$var$objectPrototype) {
            var inheritedComponent = $c7b80bd183211e5d$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $c7b80bd183211e5d$var$objectPrototype) $c7b80bd183211e5d$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        var keys = $c7b80bd183211e5d$var$getOwnPropertyNames(sourceComponent);
        if ($c7b80bd183211e5d$var$getOwnPropertySymbols) keys = keys.concat($c7b80bd183211e5d$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $c7b80bd183211e5d$var$getStatics(targetComponent);
        var sourceStatics = $c7b80bd183211e5d$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$c7b80bd183211e5d$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $c7b80bd183211e5d$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $c7b80bd183211e5d$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $c7b80bd183211e5d$var$useSyncExternalStore = $c7b80bd183211e5d$var$notInitialized;
var $c7b80bd183211e5d$var$initializeConnect = function(fn) {
    $c7b80bd183211e5d$var$useSyncExternalStore = fn;
};
var $c7b80bd183211e5d$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $c7b80bd183211e5d$var$stringifyComponent = function(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $c7b80bd183211e5d$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $c7b80bd183211e5d$var$useIsomorphicLayoutEffect(function() {
        return effectFunc.apply(void 0, (0, $2Xzd1._)(effectArgs));
    }, dependencies);
}
function $c7b80bd183211e5d$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $c7b80bd183211e5d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return function() {};
    var didUnsubscribe = false;
    var lastThrownError = null;
    var checkForUpdates = function() {
        if (didUnsubscribe || !isMounted.current) return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    var unsubscribeWrapper = function() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $c7b80bd183211e5d$var$strictEqual(a, b) {
    return a === b;
}
var $c7b80bd183211e5d$var$hasWarnedAboutDeprecatedPureOption = false;
function $c7b80bd183211e5d$var$connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
    // @ts-ignore
    pure = _ref.pure, _ref_areStatesEqual = _ref.areStatesEqual, areStatesEqual = _ref_areStatesEqual === void 0 ? $c7b80bd183211e5d$var$strictEqual : _ref_areStatesEqual, _ref_areOwnPropsEqual = _ref.areOwnPropsEqual, areOwnPropsEqual = _ref_areOwnPropsEqual === void 0 ? $c7b80bd183211e5d$export$d36bdfa510afb180 : _ref_areOwnPropsEqual, _ref_areStatePropsEqual = _ref.areStatePropsEqual, areStatePropsEqual = _ref_areStatePropsEqual === void 0 ? $c7b80bd183211e5d$export$d36bdfa510afb180 : _ref_areStatePropsEqual, _ref_areMergedPropsEqual = _ref.areMergedPropsEqual, areMergedPropsEqual = _ref_areMergedPropsEqual === void 0 ? $c7b80bd183211e5d$export$d36bdfa510afb180 : _ref_areMergedPropsEqual, _ref_forwardRef = _ref.// use React's forwardRef to expose a ref of the wrapped component
    forwardRef, forwardRef = _ref_forwardRef === void 0 ? false : _ref_forwardRef, _ref_context = _ref.// the context consumer to use
    context, context = _ref_context === void 0 ? $c7b80bd183211e5d$export$cc80c08dc91f1c00 : _ref_context;
    var Context = context;
    var initMapStateToProps = $c7b80bd183211e5d$var$mapStateToPropsFactory(mapStateToProps);
    var initMapDispatchToProps = $c7b80bd183211e5d$var$mapDispatchToPropsFactory(mapDispatchToProps);
    var initMergeProps = $c7b80bd183211e5d$var$mergePropsFactory(mergeProps);
    var shouldHandleStateChanges = Boolean(mapStateToProps);
    var wrapWithConnect = function(WrappedComponent) {
        var ConnectFunction = function ConnectFunction(props) {
            var _React_useMemo = (0, $kB67t._)($c7b80bd183211e5d$var$React.useMemo(function() {
                var _a = props, reactReduxForwardedRef2 = _a.reactReduxForwardedRef, wrapperProps2 = $c7b80bd183211e5d$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]), 3), propsContext = _React_useMemo[0], reactReduxForwardedRef = _React_useMemo[1], wrapperProps = _React_useMemo[2];
            var ContextToUse = $c7b80bd183211e5d$var$React.useMemo(function() {
                var ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            var contextValue = $c7b80bd183211e5d$var$React.useContext(ContextToUse);
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            var childPropsSelector = $c7b80bd183211e5d$var$React.useMemo(function() {
                return $c7b80bd183211e5d$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            var _React_useMemo1 = (0, $kB67t._)($c7b80bd183211e5d$var$React.useMemo(function() {
                if (!shouldHandleStateChanges) return $c7b80bd183211e5d$var$NO_SUBSCRIPTION_ARRAY;
                var subscription2 = $c7b80bd183211e5d$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                var notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), 2), subscription = _React_useMemo1[0], notifyNestedSubs = _React_useMemo1[1];
            var overriddenContextValue = $c7b80bd183211e5d$var$React.useMemo(function() {
                if (didStoreComeFromProps) return contextValue;
                return $c7b80bd183211e5d$var$__spreadProps($c7b80bd183211e5d$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            var lastChildProps = $c7b80bd183211e5d$var$React.useRef();
            var lastWrapperProps = $c7b80bd183211e5d$var$React.useRef(wrapperProps);
            var childPropsFromStoreUpdate = $c7b80bd183211e5d$var$React.useRef();
            var renderIsScheduled = $c7b80bd183211e5d$var$React.useRef(false);
            var isMounted = $c7b80bd183211e5d$var$React.useRef(false);
            var latestSubscriptionCallbackError = $c7b80bd183211e5d$var$React.useRef();
            $c7b80bd183211e5d$var$useIsomorphicLayoutEffect(function() {
                isMounted.current = true;
                return function() {
                    isMounted.current = false;
                };
            }, []);
            var actualChildPropsSelector = $c7b80bd183211e5d$var$React.useMemo(function() {
                var selector = function() {
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            var subscribeForReact = $c7b80bd183211e5d$var$React.useMemo(function() {
                var subscribe = function(reactListener) {
                    if (!subscription) return function() {};
                    return $c7b80bd183211e5d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $c7b80bd183211e5d$var$useIsomorphicLayoutEffectWithArgs($c7b80bd183211e5d$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            var actualChildProps;
            try {
                actualChildProps = $c7b80bd183211e5d$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? function() {
                    return childPropsSelector(getServerState(), wrapperProps);
                } : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n".concat(latestSubscriptionCallbackError.current.stack, "\n\n");
                throw err;
            }
            $c7b80bd183211e5d$var$useIsomorphicLayoutEffect(function() {
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            var renderedWrappedComponent = $c7b80bd183211e5d$var$React.useMemo(function() {
                return(// @ts-ignore
                /* @__PURE__ */ $c7b80bd183211e5d$var$React.createElement(WrappedComponent, $c7b80bd183211e5d$var$__spreadProps($c7b80bd183211e5d$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            var renderedChild = $c7b80bd183211e5d$var$React.useMemo(function() {
                if (shouldHandleStateChanges) return /* @__PURE__ */ $c7b80bd183211e5d$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        };
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = "Connect(".concat(wrappedComponentName, ")");
        var selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            // @ts-ignore
            initMapStateToProps: initMapStateToProps,
            // @ts-ignore
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        var _Connect = $c7b80bd183211e5d$var$React.memo(ConnectFunction);
        var Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var _forwarded = $c7b80bd183211e5d$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $c7b80bd183211e5d$var$React.createElement(Connect, $c7b80bd183211e5d$var$__spreadProps($c7b80bd183211e5d$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            var forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $c7b80bd183211e5d$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $c7b80bd183211e5d$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $c7b80bd183211e5d$export$64605811ab45167f = $c7b80bd183211e5d$var$connect;
// src/components/Provider.tsx
function $c7b80bd183211e5d$var$Provider(param) {
    var store = param.store, context = param.context, children = param.children, serverState = param.serverState, _param_stabilityCheck = param.stabilityCheck, stabilityCheck = _param_stabilityCheck === void 0 ? "once" : _param_stabilityCheck, _param_identityFunctionCheck = param.identityFunctionCheck, identityFunctionCheck = _param_identityFunctionCheck === void 0 ? "once" : _param_identityFunctionCheck;
    var contextValue = $c7b80bd183211e5d$var$React.useMemo(function() {
        var subscription = $c7b80bd183211e5d$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? function() {
                return serverState;
            } : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    var previousState = $c7b80bd183211e5d$var$React.useMemo(function() {
        return store.getState();
    }, [
        store
    ]);
    $c7b80bd183211e5d$var$useIsomorphicLayoutEffect(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $c7b80bd183211e5d$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $c7b80bd183211e5d$export$2881499e37b75b9a = $c7b80bd183211e5d$var$Provider;
// src/hooks/useStore.ts
function $c7b80bd183211e5d$export$671dba69185d0304() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $c7b80bd183211e5d$export$cc80c08dc91f1c00 ? $c7b80bd183211e5d$var$useReduxContext : // @ts-ignore
    $c7b80bd183211e5d$var$createReduxContextHook(context);
    var useStore2 = function() {
        var store = useReduxContext2().store;
        return store;
    };
    Object.assign(useStore2, {
        withTypes: function() {
            return useStore2;
        }
    });
    return useStore2;
}
var $c7b80bd183211e5d$export$6ccbb43953eebf8 = /* @__PURE__ */ $c7b80bd183211e5d$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $c7b80bd183211e5d$export$bc9b55530897c558() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    var useStore2 = context === $c7b80bd183211e5d$export$cc80c08dc91f1c00 ? $c7b80bd183211e5d$export$6ccbb43953eebf8 : $c7b80bd183211e5d$export$671dba69185d0304(context);
    var useDispatch2 = function() {
        var store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: function() {
            return useDispatch2;
        }
    });
    return useDispatch2;
}
var $c7b80bd183211e5d$export$8ad76b76a4c905f8 = /* @__PURE__ */ $c7b80bd183211e5d$export$bc9b55530897c558();
// src/exports.ts
var $c7b80bd183211e5d$export$712ea50be43a7858 = $c7b80bd183211e5d$var$defaultNoopBatch;
// src/index.ts
$c7b80bd183211e5d$var$initializeUseSelector((0, $6dda7e3f4bfdb607$exports.useSyncExternalStoreWithSelector));
$c7b80bd183211e5d$var$initializeConnect($fIwXP.useSyncExternalStore);


var $f310bc4ea983f747$var$Header = function() {
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)("Login"), 2), btnNameReact = _useState[0], setBtnNameReact = _useState[1];
    var onlineStatus = (0, $3c7428cbea0d9bb7$export$2e2bcd8739ae039)();
    var loggedInUser = (0, $fIwXP.useContext)((0, $0cf10ba694782b3e$export$2e2bcd8739ae039)).loggedInUser;
    // Subscribing to the store using selector
    var cartItems = (0, $c7b80bd183211e5d$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "flex justify-between bg-white shadow-lg ",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "logo-container",
                children: /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                    className: "w-20 py-1 ",
                    src: (0, $cc25cc9a913d8a70$export$8878ead86ed0da0b)
                })
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "flex items-center",
                children: /*#__PURE__*/ (0, $cc6u1.jsxs)("ul", {
                    className: "flex p-4 m-4",
                    children: [
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("li", {
                            className: "px-4",
                            children: [
                                "Online Status: ",
                                onlineStatus ? "\u2705" : "\uD83D\uDD34"
                            ]
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                            className: "px-4",
                            children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: "Home"
                            })
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                            className: "px-4",
                            children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                to: "/about",
                                children: "About Us"
                            })
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                            className: "px-4",
                            children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                to: "/contact",
                                children: "Contact Us"
                            })
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                            className: "px-4 font-bold text-xl",
                            children: /*#__PURE__*/ (0, $cc6u1.jsxs)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                to: "/cart",
                                children: [
                                    "Cart (",
                                    cartItems.length,
                                    ")"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                            className: "login",
                            onClick: function() {
                                btnNameReact === "Login" ? setBtnNameReact("Logout") : setBtnNameReact("Login");
                            },
                            children: btnNameReact
                        })
                    ]
                })
            })
        ]
    });
};
var $f310bc4ea983f747$export$2e2bcd8739ae039 = $f310bc4ea983f747$var$Header;



var $kB67t = parcelRequire("kB67t");

var $cc6u1 = parcelRequire("cc6u1");

var $fIwXP = parcelRequire("fIwXP");

var $cc6u1 = parcelRequire("cc6u1");

function $e70b3d34e23fd891$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e70b3d34e23fd891$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e70b3d34e23fd891$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e70b3d34e23fd891$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e70b3d34e23fd891$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e70b3d34e23fd891$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e70b3d34e23fd891$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e70b3d34e23fd891$var$_typeof(obj);
}
function $e70b3d34e23fd891$var$_wrapRegExp() {
    $e70b3d34e23fd891$var$_wrapRegExp = function _wrapRegExp(re, groups) {
        return new BabelRegExp(re, void 0, groups);
    };
    var _super = RegExp.prototype, _groups = new WeakMap();
    function BabelRegExp(re, flags, groups) {
        var _this = new RegExp(re, flags);
        return _groups.set(_this, groups || _groups.get(re)), $e70b3d34e23fd891$var$_setPrototypeOf(_this, BabelRegExp.prototype);
    }
    function buildGroups(result, re) {
        var g = _groups.get(re);
        return Object.keys(g).reduce(function(groups, name) {
            return groups[name] = result[g[name]], groups;
        }, Object.create(null));
    }
    return $e70b3d34e23fd891$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(str) {
        var result = _super.exec.call(this, str);
        return result && (result.groups = buildGroups(result, this)), result;
    }, BabelRegExp.prototype[Symbol.replace] = function(str, substitution) {
        if ("string" == typeof substitution) {
            var groups = _groups.get(this);
            return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function(_, name) {
                return "$" + groups[name];
            }));
        }
        if ("function" == typeof substitution) {
            var _this = this;
            return _super[Symbol.replace].call(this, str, function() {
                var args = arguments;
                return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
            });
        }
        return _super[Symbol.replace].call(this, str, substitution);
    }, $e70b3d34e23fd891$var$_wrapRegExp.apply(this, arguments);
}
function $e70b3d34e23fd891$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e70b3d34e23fd891$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e70b3d34e23fd891$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e70b3d34e23fd891$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e70b3d34e23fd891$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e70b3d34e23fd891$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e70b3d34e23fd891$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $e70b3d34e23fd891$var$_setPrototypeOf(subClass, superClass);
}
function $e70b3d34e23fd891$var$_setPrototypeOf(o, p) {
    $e70b3d34e23fd891$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e70b3d34e23fd891$var$_setPrototypeOf(o, p);
}
function $e70b3d34e23fd891$var$_slicedToArray(arr, i) {
    return $e70b3d34e23fd891$var$_arrayWithHoles(arr) || $e70b3d34e23fd891$var$_iterableToArrayLimit(arr, i) || $e70b3d34e23fd891$var$_unsupportedIterableToArray(arr, i) || $e70b3d34e23fd891$var$_nonIterableRest();
}
function $e70b3d34e23fd891$var$_toConsumableArray(arr) {
    return $e70b3d34e23fd891$var$_arrayWithoutHoles(arr) || $e70b3d34e23fd891$var$_iterableToArray(arr) || $e70b3d34e23fd891$var$_unsupportedIterableToArray(arr) || $e70b3d34e23fd891$var$_nonIterableSpread();
}
function $e70b3d34e23fd891$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e70b3d34e23fd891$var$_arrayLikeToArray(arr);
}
function $e70b3d34e23fd891$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e70b3d34e23fd891$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e70b3d34e23fd891$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $e70b3d34e23fd891$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e70b3d34e23fd891$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e70b3d34e23fd891$var$_arrayLikeToArray(o, minLen);
}
function $e70b3d34e23fd891$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e70b3d34e23fd891$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e70b3d34e23fd891$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $e70b3d34e23fd891$var$noop = function noop() {};
var $e70b3d34e23fd891$var$_WINDOW = {};
var $e70b3d34e23fd891$var$_DOCUMENT = {};
var $e70b3d34e23fd891$var$_MUTATION_OBSERVER = null;
var $e70b3d34e23fd891$var$_PERFORMANCE = {
    mark: $e70b3d34e23fd891$var$noop,
    measure: $e70b3d34e23fd891$var$noop
};
try {
    if (typeof window !== "undefined") $e70b3d34e23fd891$var$_WINDOW = window;
    if (typeof document !== "undefined") $e70b3d34e23fd891$var$_DOCUMENT = document;
    if (typeof MutationObserver !== "undefined") $e70b3d34e23fd891$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== "undefined") $e70b3d34e23fd891$var$_PERFORMANCE = performance;
} catch (e) {}
var $e70b3d34e23fd891$var$_ref = $e70b3d34e23fd891$var$_WINDOW.navigator || {}, $e70b3d34e23fd891$var$_ref$userAgent = $e70b3d34e23fd891$var$_ref.userAgent, $e70b3d34e23fd891$var$userAgent = $e70b3d34e23fd891$var$_ref$userAgent === void 0 ? "" : $e70b3d34e23fd891$var$_ref$userAgent;
var $e70b3d34e23fd891$var$WINDOW = $e70b3d34e23fd891$var$_WINDOW;
var $e70b3d34e23fd891$var$DOCUMENT = $e70b3d34e23fd891$var$_DOCUMENT;
var $e70b3d34e23fd891$var$MUTATION_OBSERVER = $e70b3d34e23fd891$var$_MUTATION_OBSERVER;
var $e70b3d34e23fd891$var$PERFORMANCE = $e70b3d34e23fd891$var$_PERFORMANCE;
var $e70b3d34e23fd891$var$IS_BROWSER = !!$e70b3d34e23fd891$var$WINDOW.document;
var $e70b3d34e23fd891$var$IS_DOM = !!$e70b3d34e23fd891$var$DOCUMENT.documentElement && !!$e70b3d34e23fd891$var$DOCUMENT.head && typeof $e70b3d34e23fd891$var$DOCUMENT.addEventListener === "function" && typeof $e70b3d34e23fd891$var$DOCUMENT.createElement === "function";
var $e70b3d34e23fd891$var$IS_IE = ~$e70b3d34e23fd891$var$userAgent.indexOf("MSIE") || ~$e70b3d34e23fd891$var$userAgent.indexOf("Trident/");
var $e70b3d34e23fd891$var$_familyProxy, $e70b3d34e23fd891$var$_familyProxy2, $e70b3d34e23fd891$var$_familyProxy3, $e70b3d34e23fd891$var$_familyProxy4, $e70b3d34e23fd891$var$_familyProxy5;
var $e70b3d34e23fd891$var$NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
var $e70b3d34e23fd891$var$UNITS_IN_GRID = 16;
var $e70b3d34e23fd891$var$DEFAULT_CSS_PREFIX = "fa";
var $e70b3d34e23fd891$var$DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
var $e70b3d34e23fd891$var$DATA_FA_I2SVG = "data-fa-i2svg";
var $e70b3d34e23fd891$var$DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element";
var $e70b3d34e23fd891$var$DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending";
var $e70b3d34e23fd891$var$DATA_PREFIX = "data-prefix";
var $e70b3d34e23fd891$var$DATA_ICON = "data-icon";
var $e70b3d34e23fd891$var$HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg";
var $e70b3d34e23fd891$var$MUTATION_APPROACH_ASYNC = "async";
var $e70b3d34e23fd891$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    "HTML",
    "HEAD",
    "STYLE",
    "SCRIPT"
];
var $e70b3d34e23fd891$var$PRODUCTION = function() {
    try {
        return true;
    } catch (e) {
        return false;
    }
}();
var $e70b3d34e23fd891$var$FAMILY_CLASSIC = "classic";
var $e70b3d34e23fd891$var$FAMILY_SHARP = "sharp";
var $e70b3d34e23fd891$var$FAMILIES = [
    $e70b3d34e23fd891$var$FAMILY_CLASSIC,
    $e70b3d34e23fd891$var$FAMILY_SHARP
];
function $e70b3d34e23fd891$var$familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get: function get(target, prop) {
            return prop in target ? target[prop] : target[$e70b3d34e23fd891$var$FAMILY_CLASSIC];
        }
    });
}
var $e70b3d34e23fd891$var$PREFIX_TO_STYLE = $e70b3d34e23fd891$var$familyProxy(($e70b3d34e23fd891$var$_familyProxy = {}, $e70b3d34e23fd891$var$_defineProperty($e70b3d34e23fd891$var$_familyProxy, $e70b3d34e23fd891$var$FAMILY_CLASSIC, {
    "fa": "solid",
    "fas": "solid",
    "fa-solid": "solid",
    "far": "regular",
    "fa-regular": "regular",
    "fal": "light",
    "fa-light": "light",
    "fat": "thin",
    "fa-thin": "thin",
    "fad": "duotone",
    "fa-duotone": "duotone",
    "fab": "brands",
    "fa-brands": "brands",
    "fak": "kit",
    "fakd": "kit",
    "fa-kit": "kit",
    "fa-kit-duotone": "kit"
}), $e70b3d34e23fd891$var$_defineProperty($e70b3d34e23fd891$var$_familyProxy, $e70b3d34e23fd891$var$FAMILY_SHARP, {
    "fa": "solid",
    "fass": "solid",
    "fa-solid": "solid",
    "fasr": "regular",
    "fa-regular": "regular",
    "fasl": "light",
    "fa-light": "light",
    "fast": "thin",
    "fa-thin": "thin"
}), $e70b3d34e23fd891$var$_familyProxy));
var $e70b3d34e23fd891$var$STYLE_TO_PREFIX = $e70b3d34e23fd891$var$familyProxy(($e70b3d34e23fd891$var$_familyProxy2 = {}, $e70b3d34e23fd891$var$_defineProperty($e70b3d34e23fd891$var$_familyProxy2, $e70b3d34e23fd891$var$FAMILY_CLASSIC, {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    duotone: "fad",
    brands: "fab",
    kit: "fak"
}), $e70b3d34e23fd891$var$_defineProperty($e70b3d34e23fd891$var$_familyProxy2, $e70b3d34e23fd891$var$FAMILY_SHARP, {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
}), $e70b3d34e23fd891$var$_familyProxy2));
var $e70b3d34e23fd891$var$PREFIX_TO_LONG_STYLE = $e70b3d34e23fd891$var$familyProxy(($e70b3d34e23fd891$var$_familyProxy3 = {}, $e70b3d34e23fd891$var$_defineProperty($e70b3d34e23fd891$var$_familyProxy3, $e70b3d34e23fd891$var$FAMILY_CLASSIC, {
    fab: "fa-brands",
    fad: "fa-duotone",
    fak: "fa-kit",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
}), $e70b3d34e23fd891$var$_defineProperty($e70b3d34e23fd891$var$_familyProxy3, $e70b3d34e23fd891$var$FAMILY_SHARP, {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
}), $e70b3d34e23fd891$var$_familyProxy3));
var $e70b3d34e23fd891$var$LONG_STYLE_TO_PREFIX = $e70b3d34e23fd891$var$familyProxy(($e70b3d34e23fd891$var$_familyProxy4 = {}, $e70b3d34e23fd891$var$_defineProperty($e70b3d34e23fd891$var$_familyProxy4, $e70b3d34e23fd891$var$FAMILY_CLASSIC, {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-kit": "fak",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
}), $e70b3d34e23fd891$var$_defineProperty($e70b3d34e23fd891$var$_familyProxy4, $e70b3d34e23fd891$var$FAMILY_SHARP, {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
}), $e70b3d34e23fd891$var$_familyProxy4));
var $e70b3d34e23fd891$var$ICON_SELECTION_SYNTAX_PATTERN = /fa(s|r|l|t|d|b|k|ss|sr|sl|st)?[\-\ ]/; // eslint-disable-line no-useless-escape
var $e70b3d34e23fd891$var$LAYERS_TEXT_CLASSNAME = "fa-layers-text";
var $e70b3d34e23fd891$var$FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i;
var $e70b3d34e23fd891$var$FONT_WEIGHT_TO_PREFIX = $e70b3d34e23fd891$var$familyProxy(($e70b3d34e23fd891$var$_familyProxy5 = {}, $e70b3d34e23fd891$var$_defineProperty($e70b3d34e23fd891$var$_familyProxy5, $e70b3d34e23fd891$var$FAMILY_CLASSIC, {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
}), $e70b3d34e23fd891$var$_defineProperty($e70b3d34e23fd891$var$_familyProxy5, $e70b3d34e23fd891$var$FAMILY_SHARP, {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
}), $e70b3d34e23fd891$var$_familyProxy5));
var $e70b3d34e23fd891$var$oneToTen = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $e70b3d34e23fd891$var$oneToTwenty = $e70b3d34e23fd891$var$oneToTen.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]);
var $e70b3d34e23fd891$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    "class",
    "data-prefix",
    "data-icon",
    "data-fa-transform",
    "data-fa-mask"
];
var $e70b3d34e23fd891$var$DUOTONE_CLASSES = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
};
var $e70b3d34e23fd891$var$prefixes = new Set();
Object.keys($e70b3d34e23fd891$var$STYLE_TO_PREFIX[$e70b3d34e23fd891$var$FAMILY_CLASSIC]).map($e70b3d34e23fd891$var$prefixes.add.bind($e70b3d34e23fd891$var$prefixes));
Object.keys($e70b3d34e23fd891$var$STYLE_TO_PREFIX[$e70b3d34e23fd891$var$FAMILY_SHARP]).map($e70b3d34e23fd891$var$prefixes.add.bind($e70b3d34e23fd891$var$prefixes));
var $e70b3d34e23fd891$var$RESERVED_CLASSES = [].concat($e70b3d34e23fd891$var$FAMILIES, $e70b3d34e23fd891$var$_toConsumableArray($e70b3d34e23fd891$var$prefixes), [
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "border",
    "fade",
    "beat-fade",
    "bounce",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "fw",
    "inverse",
    "layers-counter",
    "layers-text",
    "layers",
    "li",
    "pull-left",
    "pull-right",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "stack-1x",
    "stack-2x",
    "stack",
    "ul",
    $e70b3d34e23fd891$var$DUOTONE_CLASSES.GROUP,
    $e70b3d34e23fd891$var$DUOTONE_CLASSES.SWAP_OPACITY,
    $e70b3d34e23fd891$var$DUOTONE_CLASSES.PRIMARY,
    $e70b3d34e23fd891$var$DUOTONE_CLASSES.SECONDARY
]).concat($e70b3d34e23fd891$var$oneToTen.map(function(n) {
    return "".concat(n, "x");
})).concat($e70b3d34e23fd891$var$oneToTwenty.map(function(n) {
    return "w-".concat(n);
}));
var $e70b3d34e23fd891$var$initial = $e70b3d34e23fd891$var$WINDOW.FontAwesomeConfig || {};
function $e70b3d34e23fd891$var$getAttrConfig(attr) {
    var element = $e70b3d34e23fd891$var$DOCUMENT.querySelector("script[" + attr + "]");
    if (element) return element.getAttribute(attr);
}
function $e70b3d34e23fd891$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === "") return true;
    if (val === "false") return false;
    if (val === "true") return true;
    return val;
}
if ($e70b3d34e23fd891$var$DOCUMENT && typeof $e70b3d34e23fd891$var$DOCUMENT.querySelector === "function") {
    var $e70b3d34e23fd891$var$attrs = [
        [
            "data-family-prefix",
            "familyPrefix"
        ],
        [
            "data-css-prefix",
            "cssPrefix"
        ],
        [
            "data-family-default",
            "familyDefault"
        ],
        [
            "data-style-default",
            "styleDefault"
        ],
        [
            "data-replacement-class",
            "replacementClass"
        ],
        [
            "data-auto-replace-svg",
            "autoReplaceSvg"
        ],
        [
            "data-auto-add-css",
            "autoAddCss"
        ],
        [
            "data-auto-a11y",
            "autoA11y"
        ],
        [
            "data-search-pseudo-elements",
            "searchPseudoElements"
        ],
        [
            "data-observe-mutations",
            "observeMutations"
        ],
        [
            "data-mutate-approach",
            "mutateApproach"
        ],
        [
            "data-keep-original-source",
            "keepOriginalSource"
        ],
        [
            "data-measure-performance",
            "measurePerformance"
        ],
        [
            "data-show-missing-icons",
            "showMissingIcons"
        ]
    ];
    $e70b3d34e23fd891$var$attrs.forEach(function(_ref) {
        var _ref2 = $e70b3d34e23fd891$var$_slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = $e70b3d34e23fd891$var$coerce($e70b3d34e23fd891$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $e70b3d34e23fd891$var$initial[key] = val;
    });
}
var $e70b3d34e23fd891$var$_default = {
    styleDefault: "solid",
    familyDefault: "classic",
    cssPrefix: $e70b3d34e23fd891$var$DEFAULT_CSS_PREFIX,
    replacementClass: $e70b3d34e23fd891$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: "async",
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
}; // familyPrefix is deprecated but we must still support it if present
if ($e70b3d34e23fd891$var$initial.familyPrefix) $e70b3d34e23fd891$var$initial.cssPrefix = $e70b3d34e23fd891$var$initial.familyPrefix;
var $e70b3d34e23fd891$var$_config = $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, $e70b3d34e23fd891$var$_default), $e70b3d34e23fd891$var$initial);
if (!$e70b3d34e23fd891$var$_config.autoReplaceSvg) $e70b3d34e23fd891$var$_config.observeMutations = false;
var $e70b3d34e23fd891$var$config = {};
Object.keys($e70b3d34e23fd891$var$_default).forEach(function(key) {
    Object.defineProperty($e70b3d34e23fd891$var$config, key, {
        enumerable: true,
        set: function set(val) {
            $e70b3d34e23fd891$var$_config[key] = val;
            $e70b3d34e23fd891$var$_onChangeCb.forEach(function(cb) {
                return cb($e70b3d34e23fd891$var$config);
            });
        },
        get: function get() {
            return $e70b3d34e23fd891$var$_config[key];
        }
    });
}); // familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty($e70b3d34e23fd891$var$config, "familyPrefix", {
    enumerable: true,
    set: function set(val) {
        $e70b3d34e23fd891$var$_config.cssPrefix = val;
        $e70b3d34e23fd891$var$_onChangeCb.forEach(function(cb) {
            return cb($e70b3d34e23fd891$var$config);
        });
    },
    get: function get() {
        return $e70b3d34e23fd891$var$_config.cssPrefix;
    }
});
$e70b3d34e23fd891$var$WINDOW.FontAwesomeConfig = $e70b3d34e23fd891$var$config;
var $e70b3d34e23fd891$var$_onChangeCb = [];
function $e70b3d34e23fd891$var$onChange(cb) {
    $e70b3d34e23fd891$var$_onChangeCb.push(cb);
    return function() {
        $e70b3d34e23fd891$var$_onChangeCb.splice($e70b3d34e23fd891$var$_onChangeCb.indexOf(cb), 1);
    };
}
var $e70b3d34e23fd891$var$d = $e70b3d34e23fd891$var$UNITS_IN_GRID;
var $e70b3d34e23fd891$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $e70b3d34e23fd891$var$insertCss(css) {
    if (!css || !$e70b3d34e23fd891$var$IS_DOM) return;
    var style = $e70b3d34e23fd891$var$DOCUMENT.createElement("style");
    style.setAttribute("type", "text/css");
    style.innerHTML = css;
    var headChildren = $e70b3d34e23fd891$var$DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || "").toUpperCase();
        if ([
            "STYLE",
            "LINK"
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $e70b3d34e23fd891$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var $e70b3d34e23fd891$var$idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function $e70b3d34e23fd891$var$nextUniqueId() {
    var size = 12;
    var id = "";
    while(size-- > 0)id += $e70b3d34e23fd891$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $e70b3d34e23fd891$var$toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $e70b3d34e23fd891$var$classArray(node) {
    if (node.classList) return $e70b3d34e23fd891$var$toArray(node.classList);
    else return (node.getAttribute("class") || "").split(" ").filter(function(i) {
        return i;
    });
}
function $e70b3d34e23fd891$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $e70b3d34e23fd891$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, '="').concat($e70b3d34e23fd891$var$htmlEscape(attributes[attributeName]), '" ');
    }, "").trim();
}
function $e70b3d34e23fd891$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, "");
}
function $e70b3d34e23fd891$var$transformIsMeaningful(transform) {
    return transform.size !== $e70b3d34e23fd891$var$meaninglessTransform.size || transform.x !== $e70b3d34e23fd891$var$meaninglessTransform.x || transform.y !== $e70b3d34e23fd891$var$meaninglessTransform.y || transform.rotate !== $e70b3d34e23fd891$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $e70b3d34e23fd891$var$transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $e70b3d34e23fd891$var$transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? $e70b3d34e23fd891$var$UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? $e70b3d34e23fd891$var$UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = "";
    if (startCentered && $e70b3d34e23fd891$var$IS_IE) val += "translate(".concat(transform.x / $e70b3d34e23fd891$var$d - width / 2, "em, ").concat(transform.y / $e70b3d34e23fd891$var$d - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $e70b3d34e23fd891$var$d, "em), calc(-50% + ").concat(transform.y / $e70b3d34e23fd891$var$d, "em)) ");
    else val += "translate(".concat(transform.x / $e70b3d34e23fd891$var$d, "em, ").concat(transform.y / $e70b3d34e23fd891$var$d, "em) ");
    val += "scale(".concat(transform.size / $e70b3d34e23fd891$var$d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $e70b3d34e23fd891$var$d * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $e70b3d34e23fd891$var$baseStyles = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    -webkit-transition-delay: 0s;\n            transition-delay: 0s;\n    -webkit-transition-duration: 0s;\n            transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, 0));\n          transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}';
function $e70b3d34e23fd891$var$css() {
    var dcp = $e70b3d34e23fd891$var$DEFAULT_CSS_PREFIX;
    var drc = $e70b3d34e23fd891$var$DEFAULT_REPLACEMENT_CLASS;
    var fp = $e70b3d34e23fd891$var$config.cssPrefix;
    var rc = $e70b3d34e23fd891$var$config.replacementClass;
    var s = $e70b3d34e23fd891$var$baseStyles;
    if (fp !== dcp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dcp, "\\-"), "g");
        var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), "g");
        var rPatt = new RegExp("\\.".concat(drc), "g");
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var $e70b3d34e23fd891$var$_cssInserted = false;
function $e70b3d34e23fd891$var$ensureCss() {
    if ($e70b3d34e23fd891$var$config.autoAddCss && !$e70b3d34e23fd891$var$_cssInserted) {
        $e70b3d34e23fd891$var$insertCss($e70b3d34e23fd891$var$css());
        $e70b3d34e23fd891$var$_cssInserted = true;
    }
}
var $e70b3d34e23fd891$var$InjectCSS = {
    mixout: function mixout() {
        return {
            dom: {
                css: $e70b3d34e23fd891$var$css,
                insertCss: $e70b3d34e23fd891$var$ensureCss
            }
        };
    },
    hooks: function hooks() {
        return {
            beforeDOMElementCreation: function beforeDOMElementCreation() {
                $e70b3d34e23fd891$var$ensureCss();
            },
            beforeI2svg: function beforeI2svg() {
                $e70b3d34e23fd891$var$ensureCss();
            }
        };
    }
};
var $e70b3d34e23fd891$var$w = $e70b3d34e23fd891$var$WINDOW || {};
if (!$e70b3d34e23fd891$var$w[$e70b3d34e23fd891$var$NAMESPACE_IDENTIFIER]) $e70b3d34e23fd891$var$w[$e70b3d34e23fd891$var$NAMESPACE_IDENTIFIER] = {};
if (!$e70b3d34e23fd891$var$w[$e70b3d34e23fd891$var$NAMESPACE_IDENTIFIER].styles) $e70b3d34e23fd891$var$w[$e70b3d34e23fd891$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$e70b3d34e23fd891$var$w[$e70b3d34e23fd891$var$NAMESPACE_IDENTIFIER].hooks) $e70b3d34e23fd891$var$w[$e70b3d34e23fd891$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$e70b3d34e23fd891$var$w[$e70b3d34e23fd891$var$NAMESPACE_IDENTIFIER].shims) $e70b3d34e23fd891$var$w[$e70b3d34e23fd891$var$NAMESPACE_IDENTIFIER].shims = [];
var $e70b3d34e23fd891$var$namespace = $e70b3d34e23fd891$var$w[$e70b3d34e23fd891$var$NAMESPACE_IDENTIFIER];
var $e70b3d34e23fd891$var$functions = [];
var $e70b3d34e23fd891$var$listener = function listener() {
    $e70b3d34e23fd891$var$DOCUMENT.removeEventListener("DOMContentLoaded", listener);
    $e70b3d34e23fd891$var$loaded = 1;
    $e70b3d34e23fd891$var$functions.map(function(fn) {
        return fn();
    });
};
var $e70b3d34e23fd891$var$loaded = false;
if ($e70b3d34e23fd891$var$IS_DOM) {
    $e70b3d34e23fd891$var$loaded = ($e70b3d34e23fd891$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($e70b3d34e23fd891$var$DOCUMENT.readyState);
    if (!$e70b3d34e23fd891$var$loaded) $e70b3d34e23fd891$var$DOCUMENT.addEventListener("DOMContentLoaded", $e70b3d34e23fd891$var$listener);
}
function $e70b3d34e23fd891$var$domready(fn) {
    if (!$e70b3d34e23fd891$var$IS_DOM) return;
    $e70b3d34e23fd891$var$loaded ? setTimeout(fn, 0) : $e70b3d34e23fd891$var$functions.push(fn);
}
function $e70b3d34e23fd891$var$toHtml(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === "string") return $e70b3d34e23fd891$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($e70b3d34e23fd891$var$joinAttributes(attributes), ">").concat(children.map($e70b3d34e23fd891$var$toHtml).join(""), "</").concat(tag, ">");
}
function $e70b3d34e23fd891$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $e70b3d34e23fd891$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $e70b3d34e23fd891$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $e70b3d34e23fd891$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ function $e70b3d34e23fd891$var$ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            var extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) // eslint-disable-line eqeqeq
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
function $e70b3d34e23fd891$var$toHex(unicode) {
    var decoded = $e70b3d34e23fd891$var$ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function $e70b3d34e23fd891$var$codePointAt(string, index) {
    var size = string.length;
    var first = string.charCodeAt(index);
    var second;
    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
function $e70b3d34e23fd891$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $e70b3d34e23fd891$var$defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = $e70b3d34e23fd891$var$normalizeIcons(icons);
    if (typeof $e70b3d34e23fd891$var$namespace.hooks.addPack === "function" && !skipHooks) $e70b3d34e23fd891$var$namespace.hooks.addPack(prefix, $e70b3d34e23fd891$var$normalizeIcons(icons));
    else $e70b3d34e23fd891$var$namespace.styles[prefix] = $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, $e70b3d34e23fd891$var$namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === "fas") $e70b3d34e23fd891$var$defineIcons("fa", icons);
}
var $e70b3d34e23fd891$var$duotonePathRe = [
    /*#__PURE__*/ $e70b3d34e23fd891$var$_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
        d1: 1,
        d2: 2
    }),
    /*#__PURE__*/ $e70b3d34e23fd891$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2,
        cls2: 3,
        d2: 4
    }),
    /*#__PURE__*/ $e70b3d34e23fd891$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2
    })
];
var $e70b3d34e23fd891$var$_LONG_STYLE, $e70b3d34e23fd891$var$_PREFIXES, $e70b3d34e23fd891$var$_PREFIXES_FOR_FAMILY;
var $e70b3d34e23fd891$var$styles = $e70b3d34e23fd891$var$namespace.styles, $e70b3d34e23fd891$var$shims = $e70b3d34e23fd891$var$namespace.shims;
var $e70b3d34e23fd891$var$LONG_STYLE = ($e70b3d34e23fd891$var$_LONG_STYLE = {}, $e70b3d34e23fd891$var$_defineProperty($e70b3d34e23fd891$var$_LONG_STYLE, $e70b3d34e23fd891$var$FAMILY_CLASSIC, Object.values($e70b3d34e23fd891$var$PREFIX_TO_LONG_STYLE[$e70b3d34e23fd891$var$FAMILY_CLASSIC])), $e70b3d34e23fd891$var$_defineProperty($e70b3d34e23fd891$var$_LONG_STYLE, $e70b3d34e23fd891$var$FAMILY_SHARP, Object.values($e70b3d34e23fd891$var$PREFIX_TO_LONG_STYLE[$e70b3d34e23fd891$var$FAMILY_SHARP])), $e70b3d34e23fd891$var$_LONG_STYLE);
var $e70b3d34e23fd891$var$_defaultUsablePrefix = null;
var $e70b3d34e23fd891$var$_byUnicode = {};
var $e70b3d34e23fd891$var$_byLigature = {};
var $e70b3d34e23fd891$var$_byOldName = {};
var $e70b3d34e23fd891$var$_byOldUnicode = {};
var $e70b3d34e23fd891$var$_byAlias = {};
var $e70b3d34e23fd891$var$PREFIXES = ($e70b3d34e23fd891$var$_PREFIXES = {}, $e70b3d34e23fd891$var$_defineProperty($e70b3d34e23fd891$var$_PREFIXES, $e70b3d34e23fd891$var$FAMILY_CLASSIC, Object.keys($e70b3d34e23fd891$var$PREFIX_TO_STYLE[$e70b3d34e23fd891$var$FAMILY_CLASSIC])), $e70b3d34e23fd891$var$_defineProperty($e70b3d34e23fd891$var$_PREFIXES, $e70b3d34e23fd891$var$FAMILY_SHARP, Object.keys($e70b3d34e23fd891$var$PREFIX_TO_STYLE[$e70b3d34e23fd891$var$FAMILY_SHARP])), $e70b3d34e23fd891$var$_PREFIXES);
function $e70b3d34e23fd891$var$isReserved(name) {
    return ~$e70b3d34e23fd891$var$RESERVED_CLASSES.indexOf(name);
}
function $e70b3d34e23fd891$var$getIconName(cssPrefix, cls) {
    var parts = cls.split("-");
    var prefix = parts[0];
    var iconName = parts.slice(1).join("-");
    if (prefix === cssPrefix && iconName !== "" && !$e70b3d34e23fd891$var$isReserved(iconName)) return iconName;
    else return null;
}
var $e70b3d34e23fd891$var$build = function build() {
    var lookup = function lookup(reducer) {
        return $e70b3d34e23fd891$var$reduce($e70b3d34e23fd891$var$styles, function(o, style, prefix) {
            o[prefix] = $e70b3d34e23fd891$var$reduce(style, reducer, {});
            return o;
        }, {});
    };
    $e70b3d34e23fd891$var$_byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === "number";
            });
            aliases.forEach(function(alias) {
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $e70b3d34e23fd891$var$_byLigature = lookup(function(acc, icon, iconName) {
        acc[iconName] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === "string";
            });
            aliases.forEach(function(alias) {
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $e70b3d34e23fd891$var$_byAlias = lookup(function(acc, icon, iconName) {
        var aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach(function(alias) {
            acc[alias] = iconName;
        });
        return acc;
    }); // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    var hasRegular = "far" in $e70b3d34e23fd891$var$styles || $e70b3d34e23fd891$var$config.autoFetchSvg;
    var shimLookups = $e70b3d34e23fd891$var$reduce($e70b3d34e23fd891$var$shims, function(acc, shim) {
        var maybeNameMaybeUnicode = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === "far" && !hasRegular) prefix = "fas";
        if (typeof maybeNameMaybeUnicode === "string") acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === "number") acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $e70b3d34e23fd891$var$_byOldName = shimLookups.names;
    $e70b3d34e23fd891$var$_byOldUnicode = shimLookups.unicodes;
    $e70b3d34e23fd891$var$_defaultUsablePrefix = $e70b3d34e23fd891$var$getCanonicalPrefix($e70b3d34e23fd891$var$config.styleDefault, {
        family: $e70b3d34e23fd891$var$config.familyDefault
    });
};
$e70b3d34e23fd891$var$onChange(function(c) {
    $e70b3d34e23fd891$var$_defaultUsablePrefix = $e70b3d34e23fd891$var$getCanonicalPrefix(c.styleDefault, {
        family: $e70b3d34e23fd891$var$config.familyDefault
    });
});
$e70b3d34e23fd891$var$build();
function $e70b3d34e23fd891$var$byUnicode(prefix, unicode) {
    return ($e70b3d34e23fd891$var$_byUnicode[prefix] || {})[unicode];
}
function $e70b3d34e23fd891$var$byLigature(prefix, ligature) {
    return ($e70b3d34e23fd891$var$_byLigature[prefix] || {})[ligature];
}
function $e70b3d34e23fd891$var$byAlias(prefix, alias) {
    return ($e70b3d34e23fd891$var$_byAlias[prefix] || {})[alias];
}
function $e70b3d34e23fd891$var$byOldName(name) {
    return $e70b3d34e23fd891$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $e70b3d34e23fd891$var$byOldUnicode(unicode) {
    var oldUnicode = $e70b3d34e23fd891$var$_byOldUnicode[unicode];
    var newUnicode = $e70b3d34e23fd891$var$byUnicode("fas", unicode);
    return oldUnicode || (newUnicode ? {
        prefix: "fas",
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $e70b3d34e23fd891$var$getDefaultUsablePrefix() {
    return $e70b3d34e23fd891$var$_defaultUsablePrefix;
}
var $e70b3d34e23fd891$var$emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $e70b3d34e23fd891$var$getCanonicalPrefix(styleOrPrefix) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$family = params.family, family = _params$family === void 0 ? $e70b3d34e23fd891$var$FAMILY_CLASSIC : _params$family;
    var style = $e70b3d34e23fd891$var$PREFIX_TO_STYLE[family][styleOrPrefix];
    var prefix = $e70b3d34e23fd891$var$STYLE_TO_PREFIX[family][styleOrPrefix] || $e70b3d34e23fd891$var$STYLE_TO_PREFIX[family][style];
    var defined = styleOrPrefix in $e70b3d34e23fd891$var$namespace.styles ? styleOrPrefix : null;
    return prefix || defined || null;
}
var $e70b3d34e23fd891$var$PREFIXES_FOR_FAMILY = ($e70b3d34e23fd891$var$_PREFIXES_FOR_FAMILY = {}, $e70b3d34e23fd891$var$_defineProperty($e70b3d34e23fd891$var$_PREFIXES_FOR_FAMILY, $e70b3d34e23fd891$var$FAMILY_CLASSIC, Object.keys($e70b3d34e23fd891$var$PREFIX_TO_LONG_STYLE[$e70b3d34e23fd891$var$FAMILY_CLASSIC])), $e70b3d34e23fd891$var$_defineProperty($e70b3d34e23fd891$var$_PREFIXES_FOR_FAMILY, $e70b3d34e23fd891$var$FAMILY_SHARP, Object.keys($e70b3d34e23fd891$var$PREFIX_TO_LONG_STYLE[$e70b3d34e23fd891$var$FAMILY_SHARP])), $e70b3d34e23fd891$var$_PREFIXES_FOR_FAMILY);
function $e70b3d34e23fd891$var$getCanonicalIcon(values) {
    var _famProps;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
    var famProps = (_famProps = {}, $e70b3d34e23fd891$var$_defineProperty(_famProps, $e70b3d34e23fd891$var$FAMILY_CLASSIC, "".concat($e70b3d34e23fd891$var$config.cssPrefix, "-").concat($e70b3d34e23fd891$var$FAMILY_CLASSIC)), $e70b3d34e23fd891$var$_defineProperty(_famProps, $e70b3d34e23fd891$var$FAMILY_SHARP, "".concat($e70b3d34e23fd891$var$config.cssPrefix, "-").concat($e70b3d34e23fd891$var$FAMILY_SHARP)), _famProps);
    var givenPrefix = null;
    var family = $e70b3d34e23fd891$var$FAMILY_CLASSIC;
    if (values.includes(famProps[$e70b3d34e23fd891$var$FAMILY_CLASSIC]) || values.some(function(v) {
        return $e70b3d34e23fd891$var$PREFIXES_FOR_FAMILY[$e70b3d34e23fd891$var$FAMILY_CLASSIC].includes(v);
    })) family = $e70b3d34e23fd891$var$FAMILY_CLASSIC;
    if (values.includes(famProps[$e70b3d34e23fd891$var$FAMILY_SHARP]) || values.some(function(v) {
        return $e70b3d34e23fd891$var$PREFIXES_FOR_FAMILY[$e70b3d34e23fd891$var$FAMILY_SHARP].includes(v);
    })) family = $e70b3d34e23fd891$var$FAMILY_SHARP;
    var canonical = values.reduce(function(acc, cls) {
        var iconName = $e70b3d34e23fd891$var$getIconName($e70b3d34e23fd891$var$config.cssPrefix, cls);
        if ($e70b3d34e23fd891$var$styles[cls]) {
            cls = $e70b3d34e23fd891$var$LONG_STYLE[family].includes(cls) ? $e70b3d34e23fd891$var$LONG_STYLE_TO_PREFIX[family][cls] : cls;
            givenPrefix = cls;
            acc.prefix = cls;
        } else if ($e70b3d34e23fd891$var$PREFIXES[family].indexOf(cls) > -1) {
            givenPrefix = cls;
            acc.prefix = $e70b3d34e23fd891$var$getCanonicalPrefix(cls, {
                family: family
            });
        } else if (iconName) acc.iconName = iconName;
        else if (cls !== $e70b3d34e23fd891$var$config.replacementClass && cls !== famProps[$e70b3d34e23fd891$var$FAMILY_CLASSIC] && cls !== famProps[$e70b3d34e23fd891$var$FAMILY_SHARP]) acc.rest.push(cls);
        if (!skipLookups && acc.prefix && acc.iconName) {
            var shim = givenPrefix === "fa" ? $e70b3d34e23fd891$var$byOldName(acc.iconName) : {};
            var aliasIconName = $e70b3d34e23fd891$var$byAlias(acc.prefix, acc.iconName);
            if (shim.prefix) givenPrefix = null;
            acc.iconName = shim.iconName || aliasIconName || acc.iconName;
            acc.prefix = shim.prefix || acc.prefix;
            if (acc.prefix === "far" && !$e70b3d34e23fd891$var$styles["far"] && $e70b3d34e23fd891$var$styles["fas"] && !$e70b3d34e23fd891$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
            // but only if we aren't auto-fetching SVGs
            acc.prefix = "fas";
        }
        return acc;
    }, $e70b3d34e23fd891$var$emptyCanonicalIcon());
    if (values.includes("fa-brands") || values.includes("fab")) canonical.prefix = "fab";
    if (values.includes("fa-duotone") || values.includes("fad")) canonical.prefix = "fad";
    if (!canonical.prefix && family === $e70b3d34e23fd891$var$FAMILY_SHARP && ($e70b3d34e23fd891$var$styles["fass"] || $e70b3d34e23fd891$var$config.autoFetchSvg)) {
        canonical.prefix = "fass";
        canonical.iconName = $e70b3d34e23fd891$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
    }
    if (canonical.prefix === "fa" || givenPrefix === "fa") // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $e70b3d34e23fd891$var$getDefaultUsablePrefix() || "fas";
    return canonical;
}
var $e70b3d34e23fd891$var$Library = /*#__PURE__*/ function() {
    function Library() {
        $e70b3d34e23fd891$var$_classCallCheck(this, Library);
        this.definitions = {};
    }
    $e70b3d34e23fd891$var$_createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
                    $e70b3d34e23fd891$var$defineIcons(key, additions[key]); // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change
                    var longPrefix = $e70b3d34e23fd891$var$PREFIX_TO_LONG_STYLE[$e70b3d34e23fd891$var$FAMILY_CLASSIC][key];
                    if (longPrefix) $e70b3d34e23fd891$var$defineIcons(longPrefix, additions[key]);
                    $e70b3d34e23fd891$var$build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    var aliases = icon[2];
                    if (!additions[prefix]) additions[prefix] = {};
                    if (aliases.length > 0) aliases.forEach(function(alias) {
                        if (typeof alias === "string") additions[prefix][alias] = icon;
                    });
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
    return Library;
}();
var $e70b3d34e23fd891$var$_plugins = [];
var $e70b3d34e23fd891$var$_hooks = {};
var $e70b3d34e23fd891$var$providers = {};
var $e70b3d34e23fd891$var$defaultProviderKeys = Object.keys($e70b3d34e23fd891$var$providers);
function $e70b3d34e23fd891$var$registerPlugins(nextPlugins, _ref) {
    var obj = _ref.mixoutsTo;
    $e70b3d34e23fd891$var$_plugins = nextPlugins;
    $e70b3d34e23fd891$var$_hooks = {};
    Object.keys($e70b3d34e23fd891$var$providers).forEach(function(k) {
        if ($e70b3d34e23fd891$var$defaultProviderKeys.indexOf(k) === -1) delete $e70b3d34e23fd891$var$providers[k];
    });
    $e70b3d34e23fd891$var$_plugins.forEach(function(plugin) {
        var mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach(function(tk) {
            if (typeof mixout[tk] === "function") obj[tk] = mixout[tk];
            if ($e70b3d34e23fd891$var$_typeof(mixout[tk]) === "object") Object.keys(mixout[tk]).forEach(function(sk) {
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            var hooks = plugin.hooks();
            Object.keys(hooks).forEach(function(hook) {
                if (!$e70b3d34e23fd891$var$_hooks[hook]) $e70b3d34e23fd891$var$_hooks[hook] = [];
                $e70b3d34e23fd891$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($e70b3d34e23fd891$var$providers);
    });
    return obj;
}
function $e70b3d34e23fd891$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var hookFns = $e70b3d34e23fd891$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        accumulator = hookFn.apply(null, [
            accumulator
        ].concat(args)); // eslint-disable-line no-useless-call
    });
    return accumulator;
}
function $e70b3d34e23fd891$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    var hookFns = $e70b3d34e23fd891$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        hookFn.apply(null, args);
    });
    return undefined;
}
function $e70b3d34e23fd891$var$callProvided() {
    var hook = arguments[0];
    var args = Array.prototype.slice.call(arguments, 1);
    return $e70b3d34e23fd891$var$providers[hook] ? $e70b3d34e23fd891$var$providers[hook].apply(null, args) : undefined;
}
function $e70b3d34e23fd891$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === "fa") iconLookup.prefix = "fas";
    var iconName = iconLookup.iconName;
    var prefix = iconLookup.prefix || $e70b3d34e23fd891$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $e70b3d34e23fd891$var$byAlias(prefix, iconName) || iconName;
    return $e70b3d34e23fd891$var$iconFromMapping($e70b3d34e23fd891$var$library.definitions, prefix, iconName) || $e70b3d34e23fd891$var$iconFromMapping($e70b3d34e23fd891$var$namespace.styles, prefix, iconName);
}
var $e70b3d34e23fd891$var$library = new $e70b3d34e23fd891$var$Library();
var $e70b3d34e23fd891$var$noAuto = function noAuto() {
    $e70b3d34e23fd891$var$config.autoReplaceSvg = false;
    $e70b3d34e23fd891$var$config.observeMutations = false;
    $e70b3d34e23fd891$var$callHooks("noAuto");
};
var $e70b3d34e23fd891$var$dom = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($e70b3d34e23fd891$var$IS_DOM) {
            $e70b3d34e23fd891$var$callHooks("beforeI2svg", params);
            $e70b3d34e23fd891$var$callProvided("pseudoElements2svg", params);
            return $e70b3d34e23fd891$var$callProvided("i2svg", params);
        } else return Promise.reject("Operation requires a DOM of some kind.");
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
        if ($e70b3d34e23fd891$var$config.autoReplaceSvg === false) $e70b3d34e23fd891$var$config.autoReplaceSvg = true;
        $e70b3d34e23fd891$var$config.observeMutations = true;
        $e70b3d34e23fd891$var$domready(function() {
            $e70b3d34e23fd891$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $e70b3d34e23fd891$var$callHooks("watch", params);
        });
    }
};
var $e70b3d34e23fd891$var$parse = {
    icon: function icon(_icon) {
        if (_icon === null) return null;
        if ($e70b3d34e23fd891$var$_typeof(_icon) === "object" && _icon.prefix && _icon.iconName) return {
            prefix: _icon.prefix,
            iconName: $e70b3d34e23fd891$var$byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
        };
        if (Array.isArray(_icon) && _icon.length === 2) {
            var iconName = _icon[1].indexOf("fa-") === 0 ? _icon[1].slice(3) : _icon[1];
            var prefix = $e70b3d34e23fd891$var$getCanonicalPrefix(_icon[0]);
            return {
                prefix: prefix,
                iconName: $e70b3d34e23fd891$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof _icon === "string" && (_icon.indexOf("".concat($e70b3d34e23fd891$var$config.cssPrefix, "-")) > -1 || _icon.match($e70b3d34e23fd891$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            var canonicalIcon = $e70b3d34e23fd891$var$getCanonicalIcon(_icon.split(" "), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $e70b3d34e23fd891$var$getDefaultUsablePrefix(),
                iconName: $e70b3d34e23fd891$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof _icon === "string") {
            var _prefix = $e70b3d34e23fd891$var$getDefaultUsablePrefix();
            return {
                prefix: _prefix,
                iconName: $e70b3d34e23fd891$var$byAlias(_prefix, _icon) || _icon
            };
        }
    }
};
var $e70b3d34e23fd891$export$644d8ea042df96a6 = {
    noAuto: $e70b3d34e23fd891$var$noAuto,
    config: $e70b3d34e23fd891$var$config,
    dom: $e70b3d34e23fd891$var$dom,
    parse: $e70b3d34e23fd891$var$parse,
    library: $e70b3d34e23fd891$var$library,
    findIconDefinition: $e70b3d34e23fd891$var$findIconDefinition,
    toHtml: $e70b3d34e23fd891$var$toHtml
};
var $e70b3d34e23fd891$var$autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? $e70b3d34e23fd891$var$DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys($e70b3d34e23fd891$var$namespace.styles).length > 0 || $e70b3d34e23fd891$var$config.autoFetchSvg) && $e70b3d34e23fd891$var$IS_DOM && $e70b3d34e23fd891$var$config.autoReplaceSvg) $e70b3d34e23fd891$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $e70b3d34e23fd891$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, "abstract", {
        get: abstractCreator
    });
    Object.defineProperty(val, "html", {
        get: function get() {
            return val.abstract.map(function(a) {
                return $e70b3d34e23fd891$var$toHtml(a);
            });
        }
    });
    Object.defineProperty(val, "node", {
        get: function get() {
            if (!$e70b3d34e23fd891$var$IS_DOM) return;
            var container = $e70b3d34e23fd891$var$DOCUMENT.createElement("div");
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $e70b3d34e23fd891$var$asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if ($e70b3d34e23fd891$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes["style"] = $e70b3d34e23fd891$var$joinStyles($e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, styles), {}, {
            "transform-origin": "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: "svg",
            attributes: attributes,
            children: children
        }
    ];
}
function $e70b3d34e23fd891$var$asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat($e70b3d34e23fd891$var$config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: "svg",
            attributes: {
                style: "display: none;"
            },
            children: [
                {
                    tag: "symbol",
                    attributes: $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function $e70b3d34e23fd891$var$makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var isUploadedIcon = prefix === "fak";
    var attrClass = [
        $e70b3d34e23fd891$var$config.replacementClass,
        iconName ? "".concat($e70b3d34e23fd891$var$config.cssPrefix, "-").concat(iconName) : ""
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== "" || !!c;
    }).concat(extra.classes).join(" ");
    var content = {
        children: [],
        attributes: $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, extra.attributes), {}, {
            "data-prefix": prefix,
            "data-icon": iconName,
            "class": attrClass,
            "role": extra.attributes.role || "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 ".concat(width, " ").concat(height)
        })
    };
    var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf("fa-fw") ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$e70b3d34e23fd891$var$DATA_FA_I2SVG] = "";
    if (title) {
        content.children.push({
            tag: "title",
            attributes: {
                id: content.attributes["aria-labelledby"] || "title-".concat(titleId || $e70b3d34e23fd891$var$nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    var args = $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
    });
    var _ref2 = mask.found && main.found ? $e70b3d34e23fd891$var$callProvided("generateAbstractMask", args) || {
        children: [],
        attributes: {}
    } : $e70b3d34e23fd891$var$callProvided("generateAbstractIcon", args) || {
        children: [],
        attributes: {}
    }, children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $e70b3d34e23fd891$var$asSymbol(args);
    else return $e70b3d34e23fd891$var$asIcon(args);
}
function $e70b3d34e23fd891$var$makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, extra.attributes), title ? {
        "title": title
    } : {}), {}, {
        "class": extra.classes.join(" ")
    });
    if (watchable) attributes[$e70b3d34e23fd891$var$DATA_FA_I2SVG] = "";
    var styles = $e70b3d34e23fd891$var$_objectSpread2({}, extra.styles);
    if ($e70b3d34e23fd891$var$transformIsMeaningful(transform)) {
        styles["transform"] = $e70b3d34e23fd891$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles["-webkit-transform"] = styles["transform"];
    }
    var styleString = $e70b3d34e23fd891$var$joinStyles(styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
function $e70b3d34e23fd891$var$makeLayersCounterAbstract(params) {
    var content = params.content, title = params.title, extra = params.extra;
    var attributes = $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, extra.attributes), title ? {
        "title": title
    } : {}), {}, {
        "class": extra.classes.join(" ")
    });
    var styleString = $e70b3d34e23fd891$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
var $e70b3d34e23fd891$var$styles$1 = $e70b3d34e23fd891$var$namespace.styles;
function $e70b3d34e23fd891$var$asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = $e70b3d34e23fd891$var$_slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: "g",
        attributes: {
            class: "".concat($e70b3d34e23fd891$var$config.cssPrefix, "-").concat($e70b3d34e23fd891$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: "path",
                attributes: {
                    class: "".concat($e70b3d34e23fd891$var$config.cssPrefix, "-").concat($e70b3d34e23fd891$var$DUOTONE_CLASSES.SECONDARY),
                    fill: "currentColor",
                    d: vectorData[0]
                }
            },
            {
                tag: "path",
                attributes: {
                    class: "".concat($e70b3d34e23fd891$var$config.cssPrefix, "-").concat($e70b3d34e23fd891$var$DUOTONE_CLASSES.PRIMARY),
                    fill: "currentColor",
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: "path",
        attributes: {
            fill: "currentColor",
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
var $e70b3d34e23fd891$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $e70b3d34e23fd891$var$maybeNotifyMissing(iconName, prefix) {
    if (!$e70b3d34e23fd891$var$PRODUCTION && !$e70b3d34e23fd891$var$config.showMissingIcons && iconName) console.error('Icon with name "'.concat(iconName, '" and prefix "').concat(prefix, '" is missing.'));
}
function $e70b3d34e23fd891$var$findIcon(iconName, prefix) {
    var givenPrefix = prefix;
    if (prefix === "fa" && $e70b3d34e23fd891$var$config.styleDefault !== null) prefix = $e70b3d34e23fd891$var$getDefaultUsablePrefix();
    return new Promise(function(resolve, reject) {
        var val = {
            found: false,
            width: 512,
            height: 512,
            icon: $e70b3d34e23fd891$var$callProvided("missingIconAbstract") || {}
        };
        if (givenPrefix === "fa") {
            var shim = $e70b3d34e23fd891$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $e70b3d34e23fd891$var$styles$1[prefix] && $e70b3d34e23fd891$var$styles$1[prefix][iconName]) {
            var icon = $e70b3d34e23fd891$var$styles$1[prefix][iconName];
            return resolve($e70b3d34e23fd891$var$asFoundIcon(icon));
        }
        $e70b3d34e23fd891$var$maybeNotifyMissing(iconName, prefix);
        resolve($e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, $e70b3d34e23fd891$var$missingIconResolutionMixin), {}, {
            icon: $e70b3d34e23fd891$var$config.showMissingIcons && iconName ? $e70b3d34e23fd891$var$callProvided("missingIconAbstract") || {} : {}
        }));
    });
}
var $e70b3d34e23fd891$var$noop$1 = function noop() {};
var $e70b3d34e23fd891$var$p = $e70b3d34e23fd891$var$config.measurePerformance && $e70b3d34e23fd891$var$PERFORMANCE && $e70b3d34e23fd891$var$PERFORMANCE.mark && $e70b3d34e23fd891$var$PERFORMANCE.measure ? $e70b3d34e23fd891$var$PERFORMANCE : {
    mark: $e70b3d34e23fd891$var$noop$1,
    measure: $e70b3d34e23fd891$var$noop$1
};
var $e70b3d34e23fd891$var$preamble = 'FA "6.5.2"';
var $e70b3d34e23fd891$var$begin = function begin(name) {
    $e70b3d34e23fd891$var$p.mark("".concat($e70b3d34e23fd891$var$preamble, " ").concat(name, " begins"));
    return function() {
        return $e70b3d34e23fd891$var$end(name);
    };
};
var $e70b3d34e23fd891$var$end = function end(name) {
    $e70b3d34e23fd891$var$p.mark("".concat($e70b3d34e23fd891$var$preamble, " ").concat(name, " ends"));
    $e70b3d34e23fd891$var$p.measure("".concat($e70b3d34e23fd891$var$preamble, " ").concat(name), "".concat($e70b3d34e23fd891$var$preamble, " ").concat(name, " begins"), "".concat($e70b3d34e23fd891$var$preamble, " ").concat(name, " ends"));
};
var $e70b3d34e23fd891$var$perf = {
    begin: $e70b3d34e23fd891$var$begin,
    end: $e70b3d34e23fd891$var$end
};
var $e70b3d34e23fd891$var$noop$2 = function noop() {};
function $e70b3d34e23fd891$var$isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute($e70b3d34e23fd891$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === "string";
}
function $e70b3d34e23fd891$var$hasPrefixAndIcon(node) {
    var prefix = node.getAttribute ? node.getAttribute($e70b3d34e23fd891$var$DATA_PREFIX) : null;
    var icon = node.getAttribute ? node.getAttribute($e70b3d34e23fd891$var$DATA_ICON) : null;
    return prefix && icon;
}
function $e70b3d34e23fd891$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($e70b3d34e23fd891$var$config.replacementClass);
}
function $e70b3d34e23fd891$var$getMutator() {
    if ($e70b3d34e23fd891$var$config.autoReplaceSvg === true) return $e70b3d34e23fd891$var$mutators.replace;
    var mutator = $e70b3d34e23fd891$var$mutators[$e70b3d34e23fd891$var$config.autoReplaceSvg];
    return mutator || $e70b3d34e23fd891$var$mutators.replace;
}
function $e70b3d34e23fd891$var$createElementNS(tag) {
    return $e70b3d34e23fd891$var$DOCUMENT.createElementNS("http://www.w3.org/2000/svg", tag);
}
function $e70b3d34e23fd891$var$createElement(tag) {
    return $e70b3d34e23fd891$var$DOCUMENT.createElement(tag);
}
function $e70b3d34e23fd891$var$convertSVG(abstractObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === "svg" ? $e70b3d34e23fd891$var$createElementNS : $e70b3d34e23fd891$var$createElement : _params$ceFn;
    if (typeof abstractObj === "string") return $e70b3d34e23fd891$var$DOCUMENT.createTextNode(abstractObj);
    var tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    var children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($e70b3d34e23fd891$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $e70b3d34e23fd891$var$nodeAsComment(node) {
    var comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
var $e70b3d34e23fd891$var$mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach(function(_abstract) {
                node.parentNode.insertBefore($e70b3d34e23fd891$var$convertSVG(_abstract), node);
            });
            if (node.getAttribute($e70b3d34e23fd891$var$DATA_FA_I2SVG) === null && $e70b3d34e23fd891$var$config.keepOriginalSource) {
                var comment = $e70b3d34e23fd891$var$DOCUMENT.createComment($e70b3d34e23fd891$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var _abstract2 = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$e70b3d34e23fd891$var$classArray(node).indexOf($e70b3d34e23fd891$var$config.replacementClass)) return $e70b3d34e23fd891$var$mutators.replace(mutation);
        var forSvg = new RegExp("".concat($e70b3d34e23fd891$var$config.cssPrefix, "-.*"));
        delete _abstract2[0].attributes.id;
        if (_abstract2[0].attributes.class) {
            var splitClasses = _abstract2[0].attributes.class.split(" ").reduce(function(acc, cls) {
                if (cls === $e70b3d34e23fd891$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            _abstract2[0].attributes.class = splitClasses.toSvg.join(" ");
            if (splitClasses.toNode.length === 0) node.removeAttribute("class");
            else node.setAttribute("class", splitClasses.toNode.join(" "));
        }
        var newInnerHTML = _abstract2.map(function(a) {
            return $e70b3d34e23fd891$var$toHtml(a);
        }).join("\n");
        node.setAttribute($e70b3d34e23fd891$var$DATA_FA_I2SVG, "");
        node.innerHTML = newInnerHTML;
    }
};
function $e70b3d34e23fd891$var$performOperationSync(op) {
    op();
}
function $e70b3d34e23fd891$var$perform(mutations, callback) {
    var callbackFunction = typeof callback === "function" ? callback : $e70b3d34e23fd891$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = $e70b3d34e23fd891$var$performOperationSync;
        if ($e70b3d34e23fd891$var$config.mutateApproach === $e70b3d34e23fd891$var$MUTATION_APPROACH_ASYNC) frame = $e70b3d34e23fd891$var$WINDOW.requestAnimationFrame || $e70b3d34e23fd891$var$performOperationSync;
        frame(function() {
            var mutator = $e70b3d34e23fd891$var$getMutator();
            var mark = $e70b3d34e23fd891$var$perf.begin("mutate");
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var $e70b3d34e23fd891$var$disabled = false;
function $e70b3d34e23fd891$var$disableObservation() {
    $e70b3d34e23fd891$var$disabled = true;
}
function $e70b3d34e23fd891$var$enableObservation() {
    $e70b3d34e23fd891$var$disabled = false;
}
var $e70b3d34e23fd891$var$mo = null;
function $e70b3d34e23fd891$var$observe(options) {
    if (!$e70b3d34e23fd891$var$MUTATION_OBSERVER) return;
    if (!$e70b3d34e23fd891$var$config.observeMutations) return;
    var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? $e70b3d34e23fd891$var$noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? $e70b3d34e23fd891$var$noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? $e70b3d34e23fd891$var$noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? $e70b3d34e23fd891$var$DOCUMENT : _options$observeMutat;
    $e70b3d34e23fd891$var$mo = new $e70b3d34e23fd891$var$MUTATION_OBSERVER(function(objects) {
        if ($e70b3d34e23fd891$var$disabled) return;
        var defaultPrefix = $e70b3d34e23fd891$var$getDefaultUsablePrefix();
        $e70b3d34e23fd891$var$toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === "childList" && mutationRecord.addedNodes.length > 0 && !$e70b3d34e23fd891$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($e70b3d34e23fd891$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === "attributes" && mutationRecord.target.parentNode && $e70b3d34e23fd891$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === "attributes" && $e70b3d34e23fd891$var$isWatched(mutationRecord.target) && ~$e70b3d34e23fd891$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === "class" && $e70b3d34e23fd891$var$hasPrefixAndIcon(mutationRecord.target)) {
                    var _getCanonicalIcon = $e70b3d34e23fd891$var$getCanonicalIcon($e70b3d34e23fd891$var$classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    mutationRecord.target.setAttribute($e70b3d34e23fd891$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($e70b3d34e23fd891$var$DATA_ICON, iconName);
                } else if ($e70b3d34e23fd891$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$e70b3d34e23fd891$var$IS_DOM) return;
    $e70b3d34e23fd891$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $e70b3d34e23fd891$var$disconnect() {
    if (!$e70b3d34e23fd891$var$mo) return;
    $e70b3d34e23fd891$var$mo.disconnect();
}
function $e70b3d34e23fd891$var$styleParser(node) {
    var style = node.getAttribute("style");
    var val = [];
    if (style) val = style.split(";").reduce(function(acc, style) {
        var styles = style.split(":");
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(":").trim();
        return acc;
    }, {});
    return val;
}
function $e70b3d34e23fd891$var$classParser(node) {
    var existingPrefix = node.getAttribute("data-prefix");
    var existingIconName = node.getAttribute("data-icon");
    var innerText = node.innerText !== undefined ? node.innerText.trim() : "";
    var val = $e70b3d34e23fd891$var$getCanonicalIcon($e70b3d34e23fd891$var$classArray(node));
    if (!val.prefix) val.prefix = $e70b3d34e23fd891$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $e70b3d34e23fd891$var$byLigature(val.prefix, node.innerText) || $e70b3d34e23fd891$var$byUnicode(val.prefix, $e70b3d34e23fd891$var$toHex(node.innerText));
    if (!val.iconName && $e70b3d34e23fd891$var$config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function $e70b3d34e23fd891$var$attributesParser(node) {
    var extraAttributes = $e70b3d34e23fd891$var$toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== "class" && acc.name !== "style") acc[attr.name] = attr.value;
        return acc;
    }, {});
    var title = node.getAttribute("title");
    var titleId = node.getAttribute("data-fa-title-id");
    if ($e70b3d34e23fd891$var$config.autoA11y) {
        if (title) extraAttributes["aria-labelledby"] = "".concat($e70b3d34e23fd891$var$config.replacementClass, "-title-").concat(titleId || $e70b3d34e23fd891$var$nextUniqueId());
        else {
            extraAttributes["aria-hidden"] = "true";
            extraAttributes["focusable"] = "false";
        }
    }
    return extraAttributes;
}
function $e70b3d34e23fd891$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $e70b3d34e23fd891$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $e70b3d34e23fd891$var$parseMeta(node) {
    var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    var _classParser = $e70b3d34e23fd891$var$classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraAttributes = $e70b3d34e23fd891$var$attributesParser(node);
    var pluginMeta = $e70b3d34e23fd891$var$chainHooks("parseNodeAttributes", {}, node);
    var extraStyles = parser.styleParser ? $e70b3d34e23fd891$var$styleParser(node) : [];
    return $e70b3d34e23fd891$var$_objectSpread2({
        iconName: iconName,
        title: node.getAttribute("title"),
        titleId: node.getAttribute("data-fa-title-id"),
        prefix: prefix,
        transform: $e70b3d34e23fd891$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
var $e70b3d34e23fd891$var$styles$2 = $e70b3d34e23fd891$var$namespace.styles;
function $e70b3d34e23fd891$var$generateMutation(node) {
    var nodeMeta = $e70b3d34e23fd891$var$config.autoReplaceSvg === "nest" ? $e70b3d34e23fd891$var$parseMeta(node, {
        styleParser: false
    }) : $e70b3d34e23fd891$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($e70b3d34e23fd891$var$LAYERS_TEXT_CLASSNAME)) return $e70b3d34e23fd891$var$callProvided("generateLayersText", node, nodeMeta);
    else return $e70b3d34e23fd891$var$callProvided("generateSvgReplacementMutation", node, nodeMeta);
}
var $e70b3d34e23fd891$var$knownPrefixes = new Set();
$e70b3d34e23fd891$var$FAMILIES.map(function(family) {
    $e70b3d34e23fd891$var$knownPrefixes.add("fa-".concat(family));
});
Object.keys($e70b3d34e23fd891$var$PREFIX_TO_STYLE[$e70b3d34e23fd891$var$FAMILY_CLASSIC]).map($e70b3d34e23fd891$var$knownPrefixes.add.bind($e70b3d34e23fd891$var$knownPrefixes));
Object.keys($e70b3d34e23fd891$var$PREFIX_TO_STYLE[$e70b3d34e23fd891$var$FAMILY_SHARP]).map($e70b3d34e23fd891$var$knownPrefixes.add.bind($e70b3d34e23fd891$var$knownPrefixes));
$e70b3d34e23fd891$var$knownPrefixes = $e70b3d34e23fd891$var$_toConsumableArray($e70b3d34e23fd891$var$knownPrefixes);
function $e70b3d34e23fd891$var$onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$e70b3d34e23fd891$var$IS_DOM) return Promise.resolve();
    var htmlClassList = $e70b3d34e23fd891$var$DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat($e70b3d34e23fd891$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat($e70b3d34e23fd891$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = $e70b3d34e23fd891$var$config.autoFetchSvg ? $e70b3d34e23fd891$var$knownPrefixes : $e70b3d34e23fd891$var$FAMILIES.map(function(f) {
        return "fa-".concat(f);
    }).concat(Object.keys($e70b3d34e23fd891$var$styles$2));
    if (!prefixes.includes("fa")) prefixes.push("fa");
    var prefixesDomQuery = [
        ".".concat($e70b3d34e23fd891$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($e70b3d34e23fd891$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p) {
        return ".".concat(p, ":not([").concat($e70b3d34e23fd891$var$DATA_FA_I2SVG, "])");
    })).join(", ");
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    var candidates = [];
    try {
        candidates = $e70b3d34e23fd891$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e) {}
    if (candidates.length > 0) {
        hclAdd("pending");
        hclRemove("complete");
    } else return Promise.resolve();
    var mark = $e70b3d34e23fd891$var$perf.begin("onTree");
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = $e70b3d34e23fd891$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e) {
            if (!$e70b3d34e23fd891$var$PRODUCTION) {
                if (e.name === "MissingIcon") console.error(e);
            }
        }
        return acc;
    }, []);
    return new Promise(function(resolve, reject) {
        Promise.all(mutations).then(function(resolvedMutations) {
            $e70b3d34e23fd891$var$perform(resolvedMutations, function() {
                hclAdd("active");
                hclAdd("complete");
                hclRemove("pending");
                if (typeof callback === "function") callback();
                mark();
                resolve();
            });
        }).catch(function(e) {
            mark();
            reject(e);
        });
    });
}
function $e70b3d34e23fd891$var$onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $e70b3d34e23fd891$var$generateMutation(node).then(function(mutation) {
        if (mutation) $e70b3d34e23fd891$var$perform([
            mutation
        ], callback);
    });
}
function $e70b3d34e23fd891$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $e70b3d34e23fd891$var$findIconDefinition(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : $e70b3d34e23fd891$var$findIconDefinition(mask || {});
        return next(iconDefinition, $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
var $e70b3d34e23fd891$var$render = function render(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? $e70b3d34e23fd891$var$meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return $e70b3d34e23fd891$var$domVariants($e70b3d34e23fd891$var$_objectSpread2({
        type: "icon"
    }, iconDefinition), function() {
        $e70b3d34e23fd891$var$callHooks("beforeDOMElementCreation", {
            iconDefinition: iconDefinition,
            params: params
        });
        if ($e70b3d34e23fd891$var$config.autoA11y) {
            if (title) attributes["aria-labelledby"] = "".concat($e70b3d34e23fd891$var$config.replacementClass, "-title-").concat(titleId || $e70b3d34e23fd891$var$nextUniqueId());
            else {
                attributes["aria-hidden"] = "true";
                attributes["focusable"] = "false";
            }
        }
        return $e70b3d34e23fd891$var$makeInlineSvgAbstract({
            icons: {
                main: $e70b3d34e23fd891$var$asFoundIcon(icon),
                mask: mask ? $e70b3d34e23fd891$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, $e70b3d34e23fd891$var$meaninglessTransform), transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $e70b3d34e23fd891$var$ReplaceElements = {
    mixout: function mixout() {
        return {
            icon: $e70b3d34e23fd891$var$resolveIcons($e70b3d34e23fd891$var$render)
        };
    },
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.treeCallback = $e70b3d34e23fd891$var$onTree;
                accumulator.nodeCallback = $e70b3d34e23fd891$var$onNode;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.i2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $e70b3d34e23fd891$var$DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function callback() {} : _params$callback;
            return $e70b3d34e23fd891$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
            return new Promise(function(resolve, reject) {
                Promise.all([
                    $e70b3d34e23fd891$var$findIcon(iconName, prefix),
                    mask.iconName ? $e70b3d34e23fd891$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then(function(_ref) {
                    var _ref2 = $e70b3d34e23fd891$var$_slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
                    resolve([
                        node,
                        $e70b3d34e23fd891$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref3) {
            var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform = _ref3.transform, styles = _ref3.styles;
            var styleString = $e70b3d34e23fd891$var$joinStyles(styles);
            if (styleString.length > 0) attributes["style"] = styleString;
            var nextChild;
            if ($e70b3d34e23fd891$var$transformIsMeaningful(transform)) nextChild = $e70b3d34e23fd891$var$callProvided("generateAbstractTransformGrouping", {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $e70b3d34e23fd891$var$Layers = {
    mixout: function mixout() {
        return {
            layer: function layer(assembler) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
                return $e70b3d34e23fd891$var$domVariants({
                    type: "layer"
                }, function() {
                    $e70b3d34e23fd891$var$callHooks("beforeDOMElementCreation", {
                        assembler: assembler,
                        params: params
                    });
                    var children = [];
                    assembler(function(args) {
                        Array.isArray(args) ? args.map(function(a) {
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: "span",
                            attributes: {
                                class: [
                                    "".concat($e70b3d34e23fd891$var$config.cssPrefix, "-layers")
                                ].concat($e70b3d34e23fd891$var$_toConsumableArray(classes)).join(" ")
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $e70b3d34e23fd891$var$LayersCounter = {
    mixout: function mixout() {
        return {
            counter: function counter(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $e70b3d34e23fd891$var$domVariants({
                    type: "counter",
                    content: content
                }, function() {
                    $e70b3d34e23fd891$var$callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return $e70b3d34e23fd891$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($e70b3d34e23fd891$var$config.cssPrefix, "-layers-counter")
                            ].concat($e70b3d34e23fd891$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    }
};
var $e70b3d34e23fd891$var$LayersText = {
    mixout: function mixout() {
        return {
            text: function text(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$transform = params.transform, transform = _params$transform === void 0 ? $e70b3d34e23fd891$var$meaninglessTransform : _params$transform, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $e70b3d34e23fd891$var$domVariants({
                    type: "text",
                    content: content
                }, function() {
                    $e70b3d34e23fd891$var$callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return $e70b3d34e23fd891$var$makeLayersTextAbstract({
                        content: content,
                        transform: $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, $e70b3d34e23fd891$var$meaninglessTransform), transform),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($e70b3d34e23fd891$var$config.cssPrefix, "-layers-text")
                            ].concat($e70b3d34e23fd891$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
            var width = null;
            var height = null;
            if ($e70b3d34e23fd891$var$IS_IE) {
                var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                var boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if ($e70b3d34e23fd891$var$config.autoA11y && !title) extra.attributes["aria-hidden"] = "true";
            return Promise.resolve([
                node,
                $e70b3d34e23fd891$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
var $e70b3d34e23fd891$var$CLEAN_CONTENT_PATTERN = new RegExp('"', "ug");
var $e70b3d34e23fd891$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
function $e70b3d34e23fd891$var$hexValueFromContent(content) {
    var cleaned = content.replace($e70b3d34e23fd891$var$CLEAN_CONTENT_PATTERN, "");
    var codePoint = $e70b3d34e23fd891$var$codePointAt(cleaned, 0);
    var isPrependTen = codePoint >= $e70b3d34e23fd891$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $e70b3d34e23fd891$var$SECONDARY_UNICODE_RANGE[1];
    var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? $e70b3d34e23fd891$var$toHex(cleaned[0]) : $e70b3d34e23fd891$var$toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function $e70b3d34e23fd891$var$replaceForPosition(node, position) {
    var pendingAttribute = "".concat($e70b3d34e23fd891$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(":", "-"));
    return new Promise(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = $e70b3d34e23fd891$var$toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c) {
            return c.getAttribute($e70b3d34e23fd891$var$DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = $e70b3d34e23fd891$var$WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue("font-family").match($e70b3d34e23fd891$var$FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue("font-weight");
        var content = styles.getPropertyValue("content");
        if (alreadyProcessedPseudoElement && !fontFamily) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamily && content !== "none" && content !== "") {
            var _content = styles.getPropertyValue("content");
            var family = ~[
                "Sharp"
            ].indexOf(fontFamily[2]) ? $e70b3d34e23fd891$var$FAMILY_SHARP : $e70b3d34e23fd891$var$FAMILY_CLASSIC;
            var prefix = ~[
                "Solid",
                "Regular",
                "Light",
                "Thin",
                "Duotone",
                "Brands",
                "Kit"
            ].indexOf(fontFamily[2]) ? $e70b3d34e23fd891$var$STYLE_TO_PREFIX[family][fontFamily[2].toLowerCase()] : $e70b3d34e23fd891$var$FONT_WEIGHT_TO_PREFIX[family][fontWeight];
            var _hexValueFromContent = $e70b3d34e23fd891$var$hexValueFromContent(_content), hexValue = _hexValueFromContent.value, isSecondary = _hexValueFromContent.isSecondary;
            var isV4 = fontFamily[0].startsWith("FontAwesome");
            var iconName = $e70b3d34e23fd891$var$byUnicode(prefix, hexValue);
            var iconIdentifier = iconName;
            if (isV4) {
                var iconName4 = $e70b3d34e23fd891$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($e70b3d34e23fd891$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($e70b3d34e23fd891$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = $e70b3d34e23fd891$var$blankMeta();
                var extra = meta.extra;
                extra.attributes[$e70b3d34e23fd891$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $e70b3d34e23fd891$var$findIcon(iconName, prefix).then(function(main) {
                    var _abstract = $e70b3d34e23fd891$var$makeInlineSvgAbstract($e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: $e70b3d34e23fd891$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = $e70b3d34e23fd891$var$DOCUMENT.createElementNS("http://www.w3.org/2000/svg", "svg");
                    if (position === "::before") node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = _abstract.map(function(a) {
                        return $e70b3d34e23fd891$var$toHtml(a);
                    }).join("\n");
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $e70b3d34e23fd891$var$replace(node) {
    return Promise.all([
        $e70b3d34e23fd891$var$replaceForPosition(node, "::before"),
        $e70b3d34e23fd891$var$replaceForPosition(node, "::after")
    ]);
}
function $e70b3d34e23fd891$var$processable(node) {
    return node.parentNode !== document.head && !~$e70b3d34e23fd891$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($e70b3d34e23fd891$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== "svg");
}
function $e70b3d34e23fd891$var$searchPseudoElements(root) {
    if (!$e70b3d34e23fd891$var$IS_DOM) return;
    return new Promise(function(resolve, reject) {
        var operations = $e70b3d34e23fd891$var$toArray(root.querySelectorAll("*")).filter($e70b3d34e23fd891$var$processable).map($e70b3d34e23fd891$var$replace);
        var end = $e70b3d34e23fd891$var$perf.begin("searchPseudoElements");
        $e70b3d34e23fd891$var$disableObservation();
        Promise.all(operations).then(function() {
            end();
            $e70b3d34e23fd891$var$enableObservation();
            resolve();
        }).catch(function() {
            end();
            $e70b3d34e23fd891$var$enableObservation();
            reject();
        });
    });
}
var $e70b3d34e23fd891$var$PseudoElements = {
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.pseudoElementsCallback = $e70b3d34e23fd891$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.pseudoElements2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $e70b3d34e23fd891$var$DOCUMENT : _params$node;
            if ($e70b3d34e23fd891$var$config.searchPseudoElements) $e70b3d34e23fd891$var$searchPseudoElements(node);
        };
    }
};
var $e70b3d34e23fd891$var$_unwatched = false;
var $e70b3d34e23fd891$var$MutationObserver$1 = {
    mixout: function mixout() {
        return {
            dom: {
                unwatch: function unwatch() {
                    $e70b3d34e23fd891$var$disableObservation();
                    $e70b3d34e23fd891$var$_unwatched = true;
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            bootstrap: function bootstrap() {
                $e70b3d34e23fd891$var$observe($e70b3d34e23fd891$var$chainHooks("mutationObserverCallbacks", {}));
            },
            noAuto: function noAuto() {
                $e70b3d34e23fd891$var$disconnect();
            },
            watch: function watch(params) {
                var observeMutationsRoot = params.observeMutationsRoot;
                if ($e70b3d34e23fd891$var$_unwatched) $e70b3d34e23fd891$var$enableObservation();
                else $e70b3d34e23fd891$var$observe($e70b3d34e23fd891$var$chainHooks("mutationObserverCallbacks", {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
var $e70b3d34e23fd891$var$parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(" ").reduce(function(acc, n) {
        var parts = n.toLowerCase().split("-");
        var first = parts[0];
        var rest = parts.slice(1).join("-");
        if (first && rest === "h") {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === "v") {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case "grow":
                acc.size = acc.size + rest;
                break;
            case "shrink":
                acc.size = acc.size - rest;
                break;
            case "left":
                acc.x = acc.x - rest;
                break;
            case "right":
                acc.x = acc.x + rest;
                break;
            case "up":
                acc.y = acc.y - rest;
                break;
            case "down":
                acc.y = acc.y + rest;
                break;
            case "rotate":
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $e70b3d34e23fd891$var$PowerTransforms = {
    mixout: function mixout() {
        return {
            parse: {
                transform: function transform(transformString) {
                    return $e70b3d34e23fd891$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var transformString = node.getAttribute("data-fa-transform");
                if (transformString) accumulator.transform = $e70b3d34e23fd891$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            var main = _ref.main, transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
            var outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            var inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            var path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            var operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: "g",
                attributes: $e70b3d34e23fd891$var$_objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: "g",
                        attributes: $e70b3d34e23fd891$var$_objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
var $e70b3d34e23fd891$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
};
function $e70b3d34e23fd891$var$fillBlack(_abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (_abstract.attributes && (_abstract.attributes.fill || force)) _abstract.attributes.fill = "black";
    return _abstract;
}
function $e70b3d34e23fd891$var$deGroup(_abstract2) {
    if (_abstract2.tag === "g") return _abstract2.children;
    else return [
        _abstract2
    ];
}
var $e70b3d34e23fd891$var$Masks = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var maskData = node.getAttribute("data-fa-mask");
                var mask = !maskData ? $e70b3d34e23fd891$var$emptyCanonicalIcon() : $e70b3d34e23fd891$var$getCanonicalIcon(maskData.split(" ").map(function(i) {
                    return i.trim();
                }));
                if (!mask.prefix) mask.prefix = $e70b3d34e23fd891$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute("data-fa-mask-id");
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractMask = function(_ref) {
            var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
            var mainWidth = main.width, mainPath = main.icon;
            var maskWidth = mask.width, maskPath = mask.icon;
            var trans = $e70b3d34e23fd891$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            var maskRect = {
                tag: "rect",
                attributes: $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, $e70b3d34e23fd891$var$ALL_SPACE), {}, {
                    fill: "white"
                })
            };
            var maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($e70b3d34e23fd891$var$fillBlack)
            } : {};
            var maskInnerGroup = {
                tag: "g",
                attributes: $e70b3d34e23fd891$var$_objectSpread2({}, trans.inner),
                children: [
                    $e70b3d34e23fd891$var$fillBlack($e70b3d34e23fd891$var$_objectSpread2({
                        tag: mainPath.tag,
                        attributes: $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            var maskOuterGroup = {
                tag: "g",
                attributes: $e70b3d34e23fd891$var$_objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            var maskId = "mask-".concat(explicitMaskId || $e70b3d34e23fd891$var$nextUniqueId());
            var clipId = "clip-".concat(explicitMaskId || $e70b3d34e23fd891$var$nextUniqueId());
            var maskTag = {
                tag: "mask",
                attributes: $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, $e70b3d34e23fd891$var$ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: "userSpaceOnUse",
                    maskContentUnits: "userSpaceOnUse"
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            var defs = {
                tag: "defs",
                children: [
                    {
                        tag: "clipPath",
                        attributes: {
                            id: clipId
                        },
                        children: $e70b3d34e23fd891$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: "rect",
                attributes: $e70b3d34e23fd891$var$_objectSpread2({
                    fill: "currentColor",
                    "clip-path": "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")")
                }, $e70b3d34e23fd891$var$ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $e70b3d34e23fd891$var$MissingIconIndicator = {
    provides: function provides(providers) {
        var reduceMotion = false;
        if ($e70b3d34e23fd891$var$WINDOW.matchMedia) reduceMotion = $e70b3d34e23fd891$var$WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches;
        providers.missingIconAbstract = function() {
            var gChildren = [];
            var FILL = {
                fill: "currentColor"
            };
            var ANIMATION_BASE = {
                attributeType: "XML",
                repeatCount: "indefinite",
                dur: "2s"
            }; // Ring
            gChildren.push({
                tag: "path",
                attributes: $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, FILL), {}, {
                    d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
                })
            });
            var OPACITY_ANIMATE = $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: "opacity"
            });
            var dot = {
                tag: "circle",
                attributes: $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, FILL), {}, {
                    cx: "256",
                    cy: "364",
                    r: "28"
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: "animate",
                attributes: $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: "r",
                    values: "28;14;28;28;14;28;"
                })
            }, {
                tag: "animate",
                attributes: $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: "1;0;1;1;0;1;"
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: "path",
                attributes: $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, FILL), {}, {
                    opacity: "1",
                    d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: "animate",
                        attributes: $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: "1;0;0;0;0;1;"
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: "path",
                attributes: $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, FILL), {}, {
                    opacity: "0",
                    d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
                }),
                children: [
                    {
                        tag: "animate",
                        attributes: $e70b3d34e23fd891$var$_objectSpread2($e70b3d34e23fd891$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: "0;0;1;1;0;0;"
                        })
                    }
                ]
            });
            return {
                tag: "g",
                attributes: {
                    "class": "missing"
                },
                children: gChildren
            };
        };
    }
};
var $e70b3d34e23fd891$var$SvgSymbols = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var symbolData = node.getAttribute("data-fa-symbol");
                var symbol = symbolData === null ? false : symbolData === "" ? true : symbolData;
                accumulator["symbol"] = symbol;
                return accumulator;
            }
        };
    }
};
var $e70b3d34e23fd891$var$plugins = [
    $e70b3d34e23fd891$var$InjectCSS,
    $e70b3d34e23fd891$var$ReplaceElements,
    $e70b3d34e23fd891$var$Layers,
    $e70b3d34e23fd891$var$LayersCounter,
    $e70b3d34e23fd891$var$LayersText,
    $e70b3d34e23fd891$var$PseudoElements,
    $e70b3d34e23fd891$var$MutationObserver$1,
    $e70b3d34e23fd891$var$PowerTransforms,
    $e70b3d34e23fd891$var$Masks,
    $e70b3d34e23fd891$var$MissingIconIndicator,
    $e70b3d34e23fd891$var$SvgSymbols
];
$e70b3d34e23fd891$var$registerPlugins($e70b3d34e23fd891$var$plugins, {
    mixoutsTo: $e70b3d34e23fd891$export$644d8ea042df96a6
});
var $e70b3d34e23fd891$export$4f8e844b2782642c = $e70b3d34e23fd891$export$644d8ea042df96a6.noAuto;
var $e70b3d34e23fd891$export$e506a1d27d1eaa20 = $e70b3d34e23fd891$export$644d8ea042df96a6.config;
var $e70b3d34e23fd891$export$b839f963c7dc0e34 = $e70b3d34e23fd891$export$644d8ea042df96a6.library;
var $e70b3d34e23fd891$export$df3a06d6289f983e = $e70b3d34e23fd891$export$644d8ea042df96a6.dom;
var $e70b3d34e23fd891$export$98e6a39c04603d36 = $e70b3d34e23fd891$export$644d8ea042df96a6.parse;
var $e70b3d34e23fd891$export$221fed4a47f597a5 = $e70b3d34e23fd891$export$644d8ea042df96a6.findIconDefinition;
var $e70b3d34e23fd891$export$a10125c086a4df16 = $e70b3d34e23fd891$export$644d8ea042df96a6.toHtml;
var $e70b3d34e23fd891$export$1ca1ec8b29a4ce27 = $e70b3d34e23fd891$export$644d8ea042df96a6.icon;
var $e70b3d34e23fd891$export$50a222d9023da98b = $e70b3d34e23fd891$export$644d8ea042df96a6.layer;
var $e70b3d34e23fd891$export$6f093cfa640b7166 = $e70b3d34e23fd891$export$644d8ea042df96a6.text;
var $e70b3d34e23fd891$export$e575061ef2a070eb = $e70b3d34e23fd891$export$644d8ea042df96a6.counter;


var $0af3593f6965a373$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0af3593f6965a373$var$ReactIs, $0af3593f6965a373$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$0af3593f6965a373$exports = (parcelRequire("kjN8l"))();



var $fIwXP = parcelRequire("fIwXP");
function $69bac3e467faf0d3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $69bac3e467faf0d3$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $69bac3e467faf0d3$var$ownKeys(Object(source), !0).forEach(function(key) {
            $69bac3e467faf0d3$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $69bac3e467faf0d3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $69bac3e467faf0d3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $69bac3e467faf0d3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $69bac3e467faf0d3$var$_typeof(obj);
}
function $69bac3e467faf0d3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $69bac3e467faf0d3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $69bac3e467faf0d3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $69bac3e467faf0d3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $69bac3e467faf0d3$var$_toConsumableArray(arr) {
    return $69bac3e467faf0d3$var$_arrayWithoutHoles(arr) || $69bac3e467faf0d3$var$_iterableToArray(arr) || $69bac3e467faf0d3$var$_unsupportedIterableToArray(arr) || $69bac3e467faf0d3$var$_nonIterableSpread();
}
function $69bac3e467faf0d3$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $69bac3e467faf0d3$var$_arrayLikeToArray(arr);
}
function $69bac3e467faf0d3$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $69bac3e467faf0d3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $69bac3e467faf0d3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $69bac3e467faf0d3$var$_arrayLikeToArray(o, minLen);
}
function $69bac3e467faf0d3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $69bac3e467faf0d3$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// Get CSS class list from a props object
function $69bac3e467faf0d3$var$classList(props) {
    var _classes;
    var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, flash = props.flash, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip = props.flip, size = props.size, rotation = props.rotation, pull = props.pull; // map of CSS class names to properties
    var classes = (_classes = {
        "fa-beat": beat,
        "fa-fade": fade,
        "fa-beat-fade": beatFade,
        "fa-bounce": bounce,
        "fa-shake": shake,
        "fa-flash": flash,
        "fa-spin": spin,
        "fa-spin-reverse": spinReverse,
        "fa-spin-pulse": spinPulse,
        "fa-pulse": pulse,
        "fa-fw": fixedWidth,
        "fa-inverse": inverse,
        "fa-border": border,
        "fa-li": listItem,
        "fa-flip": flip === true,
        "fa-flip-horizontal": flip === "horizontal" || flip === "both",
        "fa-flip-vertical": flip === "vertical" || flip === "both"
    }, $69bac3e467faf0d3$var$_defineProperty(_classes, "fa-".concat(size), typeof size !== "undefined" && size !== null), $69bac3e467faf0d3$var$_defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== "undefined" && rotation !== null && rotation !== 0), $69bac3e467faf0d3$var$_defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== "undefined" && pull !== null), $69bac3e467faf0d3$var$_defineProperty(_classes, "fa-swap-opacity", props.swapOpacity), _classes); // map over all the keys in the classes object
    // return an array of the keys where the value for the key is not null
    return Object.keys(classes).map(function(key) {
        return classes[key] ? key : null;
    }).filter(function(key) {
        return key;
    });
}
// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function $69bac3e467faf0d3$var$_isNumerical(obj) {
    obj = obj - 0; // eslint-disable-next-line no-self-compare
    return obj === obj;
}
function $69bac3e467faf0d3$var$camelize(string) {
    if ($69bac3e467faf0d3$var$_isNumerical(string)) return string;
     // eslint-disable-next-line no-useless-escape
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
        return chr ? chr.toUpperCase() : "";
    }); // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var $69bac3e467faf0d3$var$_excluded = [
    "style"
];
function $69bac3e467faf0d3$var$capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
function $69bac3e467faf0d3$var$styleToObject(style) {
    return style.split(";").map(function(s) {
        return s.trim();
    }).filter(function(s) {
        return s;
    }).reduce(function(acc, pair) {
        var i = pair.indexOf(":");
        var prop = $69bac3e467faf0d3$var$camelize(pair.slice(0, i));
        var value = pair.slice(i + 1).trim();
        prop.startsWith("webkit") ? acc[$69bac3e467faf0d3$var$capitalize(prop)] = value : acc[prop] = value;
        return acc;
    }, {});
}
function $69bac3e467faf0d3$var$convert(createElement, element) {
    var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (typeof element === "string") return element;
    var children = (element.children || []).map(function(child) {
        return $69bac3e467faf0d3$var$convert(createElement, child);
    });
    /* eslint-disable dot-notation */ var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
        var val = element.attributes[key];
        switch(key){
            case "class":
                acc.attrs["className"] = val;
                delete element.attributes["class"];
                break;
            case "style":
                acc.attrs["style"] = $69bac3e467faf0d3$var$styleToObject(val);
                break;
            default:
                if (key.indexOf("aria-") === 0 || key.indexOf("data-") === 0) acc.attrs[key.toLowerCase()] = val;
                else acc.attrs[$69bac3e467faf0d3$var$camelize(key)] = val;
        }
        return acc;
    }, {
        attrs: {}
    });
    var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = $69bac3e467faf0d3$var$_objectWithoutProperties(extraProps, $69bac3e467faf0d3$var$_excluded);
    mixins.attrs["style"] = $69bac3e467faf0d3$var$_objectSpread2($69bac3e467faf0d3$var$_objectSpread2({}, mixins.attrs["style"]), existingStyle);
    /* eslint-enable */ return createElement.apply(void 0, [
        element.tag,
        $69bac3e467faf0d3$var$_objectSpread2($69bac3e467faf0d3$var$_objectSpread2({}, mixins.attrs), remaining)
    ].concat($69bac3e467faf0d3$var$_toConsumableArray(children)));
}
var $69bac3e467faf0d3$var$PRODUCTION = false;
try {
    $69bac3e467faf0d3$var$PRODUCTION = true;
} catch (e) {}
function $69bac3e467faf0d3$var$log() {
    if (!$69bac3e467faf0d3$var$PRODUCTION && console && typeof console.error === "function") {
        var _console;
        (_console = console).error.apply(_console, arguments);
    }
}
function $69bac3e467faf0d3$var$normalizeIconArgs(icon) {
    // this has everything that it needs to be rendered which means it was probably imported
    // directly from an icon svg package
    if (icon && $69bac3e467faf0d3$var$_typeof(icon) === "object" && icon.prefix && icon.iconName && icon.icon) return icon;
    if ((0, $e70b3d34e23fd891$export$98e6a39c04603d36).icon) return (0, $e70b3d34e23fd891$export$98e6a39c04603d36).icon(icon);
     // if the icon is null, there's nothing to do
    if (icon === null) return null;
     // if the icon is an object and has a prefix and an icon name, return it
    if (icon && $69bac3e467faf0d3$var$_typeof(icon) === "object" && icon.prefix && icon.iconName) return icon;
     // if it's an array with length of two
    if (Array.isArray(icon) && icon.length === 2) // use the first item as prefix, second as icon name
    return {
        prefix: icon[0],
        iconName: icon[1]
    };
     // if it's a string, use it as the icon name
    if (typeof icon === "string") return {
        prefix: "fas",
        iconName: icon
    };
}
// creates an object with a key of key
// and a value of value
// if certain conditions are met
function $69bac3e467faf0d3$var$objectWithKey(key, value) {
    // if the value is a non-empty array
    // or it's not an array but it is truthy
    // then create the object with the key and the value
    // if not, return an empty array
    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? $69bac3e467faf0d3$var$_defineProperty({}, key, value) : {};
}
var $69bac3e467faf0d3$export$2b9260d4a45c8710 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).forwardRef(function(props, ref) {
    var iconArgs = props.icon, maskArgs = props.mask, symbol = props.symbol, className = props.className, title = props.title, titleId = props.titleId, maskId = props.maskId;
    var iconLookup = $69bac3e467faf0d3$var$normalizeIconArgs(iconArgs);
    var classes = $69bac3e467faf0d3$var$objectWithKey("classes", [].concat($69bac3e467faf0d3$var$_toConsumableArray($69bac3e467faf0d3$var$classList(props)), $69bac3e467faf0d3$var$_toConsumableArray(className.split(" "))));
    var transform = $69bac3e467faf0d3$var$objectWithKey("transform", typeof props.transform === "string" ? (0, $e70b3d34e23fd891$export$98e6a39c04603d36).transform(props.transform) : props.transform);
    var mask = $69bac3e467faf0d3$var$objectWithKey("mask", $69bac3e467faf0d3$var$normalizeIconArgs(maskArgs));
    var renderedIcon = (0, $e70b3d34e23fd891$export$1ca1ec8b29a4ce27)(iconLookup, $69bac3e467faf0d3$var$_objectSpread2($69bac3e467faf0d3$var$_objectSpread2($69bac3e467faf0d3$var$_objectSpread2($69bac3e467faf0d3$var$_objectSpread2({}, classes), transform), mask), {}, {
        symbol: symbol,
        title: title,
        titleId: titleId,
        maskId: maskId
    }));
    if (!renderedIcon) {
        $69bac3e467faf0d3$var$log("Could not find icon", iconLookup);
        return null;
    }
    var abstract = renderedIcon.abstract;
    var extraProps = {
        ref: ref
    };
    Object.keys(props).forEach(function(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (!$69bac3e467faf0d3$export$2b9260d4a45c8710.defaultProps.hasOwnProperty(key)) extraProps[key] = props[key];
    });
    return $69bac3e467faf0d3$var$convertCurry(abstract[0], extraProps);
});
$69bac3e467faf0d3$export$2b9260d4a45c8710.displayName = "FontAwesomeIcon";
$69bac3e467faf0d3$export$2b9260d4a45c8710.propTypes = {
    beat: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    border: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    beatFade: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    bounce: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).string,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    flash: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    mask: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).string
    ]),
    maskId: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).string,
    fixedWidth: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    inverse: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        true,
        false,
        "horizontal",
        "vertical",
        "both"
    ]),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).string
    ]),
    listItem: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    pull: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        "right",
        "left"
    ]),
    pulse: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    rotation: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        0,
        90,
        180,
        270
    ]),
    shake: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        "2xs",
        "xs",
        "sm",
        "lg",
        "xl",
        "2xl",
        "1x",
        "2x",
        "3x",
        "4x",
        "5x",
        "6x",
        "7x",
        "8x",
        "9x",
        "10x"
    ]),
    spin: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    spinPulse: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    spinReverse: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).string
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).string,
    titleId: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).string,
    transform: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).object
    ]),
    swapOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool
};
$69bac3e467faf0d3$export$2b9260d4a45c8710.defaultProps = {
    border: false,
    className: "",
    mask: null,
    maskId: null,
    fixedWidth: false,
    inverse: false,
    flip: false,
    icon: null,
    listItem: false,
    pull: null,
    pulse: false,
    rotation: null,
    size: null,
    spin: false,
    spinPulse: false,
    spinReverse: false,
    beat: false,
    fade: false,
    beatFade: false,
    bounce: false,
    shake: false,
    symbol: false,
    title: "",
    titleId: null,
    transform: null,
    swapOpacity: false
};
var $69bac3e467faf0d3$var$convertCurry = $69bac3e467faf0d3$var$convert.bind(null, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement);


var $f171a78aa768b9c2$exports = {};
"use strict";
Object.defineProperty($f171a78aa768b9c2$exports, "__esModule", {
    value: true
});
var $f171a78aa768b9c2$var$prefix = "fas";
var $f171a78aa768b9c2$var$iconName = "star";
var $f171a78aa768b9c2$var$width = 576;
var $f171a78aa768b9c2$var$height = 512;
var $f171a78aa768b9c2$var$aliases = [
    11088,
    61446
];
var $f171a78aa768b9c2$var$unicode = "f005";
var $f171a78aa768b9c2$var$svgPathData = "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z";
$f171a78aa768b9c2$exports.definition = {
    prefix: $f171a78aa768b9c2$var$prefix,
    iconName: $f171a78aa768b9c2$var$iconName,
    icon: [
        $f171a78aa768b9c2$var$width,
        $f171a78aa768b9c2$var$height,
        $f171a78aa768b9c2$var$aliases,
        $f171a78aa768b9c2$var$unicode,
        $f171a78aa768b9c2$var$svgPathData
    ]
};
$f171a78aa768b9c2$exports.faStar = $f171a78aa768b9c2$exports.definition;
$f171a78aa768b9c2$exports.prefix = $f171a78aa768b9c2$var$prefix;
$f171a78aa768b9c2$exports.iconName = $f171a78aa768b9c2$var$iconName;
$f171a78aa768b9c2$exports.width = $f171a78aa768b9c2$var$width;
$f171a78aa768b9c2$exports.height = $f171a78aa768b9c2$var$height;
$f171a78aa768b9c2$exports.ligatures = $f171a78aa768b9c2$var$aliases;
$f171a78aa768b9c2$exports.unicode = $f171a78aa768b9c2$var$unicode;
$f171a78aa768b9c2$exports.svgPathData = $f171a78aa768b9c2$var$svgPathData;
$f171a78aa768b9c2$exports.aliases = $f171a78aa768b9c2$var$aliases;


var $d6e6ef2e667bbda8$var$RestaurantCard = function(props) {
    var resData = props.resData;
    var cloudinaryImageId = resData.cloudinaryImageId, name = resData.name, avgRating = resData.avgRating, cuisines = resData.cuisines, aggregatedDiscountInfoV3 = resData.aggregatedDiscountInfoV3, sla = resData.sla, locality = resData.locality;
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "restaurant-card transition-transform transform hover:scale-95",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "image-container relative w-[203px] h-[135px]",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                        className: "overflow-hidden object-cover rounded-2xl w-full h-full",
                        alt: "res-logo",
                        src: (0, $cc25cc9a913d8a70$export$31adfacaf07ffe63) + cloudinaryImageId
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                        className: "rounded-b-2xl font-bold discount-info absolute bottom-0 left-0 w-full bg-gradient-to-t from-black to-transparent text-white p-2",
                        children: /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                            className: "font-semibold",
                            children: [
                                aggregatedDiscountInfoV3 === null || aggregatedDiscountInfoV3 === void 0 ? void 0 : aggregatedDiscountInfoV3.header,
                                " ",
                                aggregatedDiscountInfoV3 === null || aggregatedDiscountInfoV3 === void 0 ? void 0 : aggregatedDiscountInfoV3.subHeader
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "details p-4",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)("h3", {
                        className: "text-lg font-semibold text-[18px] leading-6 text-gray-600 overflow-hidden whitespace-nowrap overflow-ellipsis",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "rating flex items-center text-lg leading-[19px] ",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)((0, $69bac3e467faf0d3$export$2b9260d4a45c8710), {
                                icon: (0, $f171a78aa768b9c2$exports.faStar),
                                className: "text-yellow-500"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                className: "text-green-600",
                                children: avgRating
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                className: "mx-1",
                                children: "\u2022"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                children: sla.slaString
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                        className: "cuisines text-base leading-[19px] font-light text-gray-700 overflow-hidden whitespace-nowrap overflow-ellipsis",
                        children: cuisines.join(", ")
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                        className: "locality text-base leading-[19px] font-light text-gray-700 overflow-hidden whitespace-nowrap overflow-ellipsis ",
                        children: locality
                    })
                ]
            })
        ]
    });
};
var $d6e6ef2e667bbda8$export$2e2bcd8739ae039 = $d6e6ef2e667bbda8$var$RestaurantCard;



var $cc6u1 = parcelRequire("cc6u1");
parcelRequire("fIwXP");

var $YtE9h = parcelRequire("YtE9h");

var $fIwXP = parcelRequire("fIwXP");

function $53c06a248023c09c$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
var $53c06a248023c09c$var$classnames = $53c06a248023c09c$var$createCommonjsModule(function(module) {
    /*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
        var hasOwn = {}.hasOwnProperty;
        function classNames() {
            var classes = [];
            for(var i = 0; i < arguments.length; i++){
                var arg = arguments[i];
                if (!arg) continue;
                var argType = typeof arg === "undefined" ? "undefined" : (0, $YtE9h._)(arg);
                if (argType === "string" || argType === "number") classes.push(arg);
                else if (Array.isArray(arg)) {
                    if (arg.length) {
                        var inner = classNames.apply(null, arg);
                        if (inner) classes.push(inner);
                    }
                } else if (argType === "object") {
                    if (arg.toString === Object.prototype.toString) {
                        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                    } else classes.push(arg.toString());
                }
            }
            return classes.join(" ");
        }
        if (module.exports) {
            classNames.default = classNames;
            module.exports = classNames;
        } else window.classNames = classNames;
    })();
});
function $53c06a248023c09c$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") return;
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $53c06a248023c09c$var$css = ".shimmer-button {\n  border-radius: 4px;\n  height: 38px;\n  width: 120px;\n  margin-bottom: 20px; }\n  .shimmer-button--sm {\n    border-radius: 3px;\n    height: 31px;\n    width: 100px; }\n  .shimmer-button--lg {\n    height: 48px;\n    width: 140px;\n    border-radius: 5px; }\n";
$53c06a248023c09c$var$styleInject($53c06a248023c09c$var$css);
var $53c06a248023c09c$var$defineProperty = function defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $53c06a248023c09c$export$399c7d54452eb442 = function ShimmerButton(_ref) {
    var size = _ref.size;
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: $53c06a248023c09c$var$classnames($53c06a248023c09c$var$defineProperty({
            "shimmer shimmer-button": true
        }, "shimmer-button--" + size, true))
    });
};
$53c06a248023c09c$export$399c7d54452eb442.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        "lg",
        "md",
        "sm"
    ])
};
$53c06a248023c09c$export$399c7d54452eb442.defaultProps = {
    size: "md"
};
var $53c06a248023c09c$export$697f501f4c22166d = function ShimmerCircularImage(_ref) {
    var size = _ref.size, center = _ref.center, className = _ref.className;
    var style = {};
    if (size) {
        style.width = size + "px";
        style.height = size + "px";
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: $53c06a248023c09c$var$classnames({
            "text-center": center
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        style: style,
        className: $53c06a248023c09c$var$classnames($53c06a248023c09c$var$defineProperty({
            "shimmer shimmer-avatar": true
        }, className, className))
    }));
};
$53c06a248023c09c$export$697f501f4c22166d.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number,
    center: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).string
};
$53c06a248023c09c$export$697f501f4c22166d.defaultProps = {
    center: false,
    size: 80
};
var $53c06a248023c09c$export$973ab931129fa7e9 = function ShimmerThumbnail(_ref) {
    var height = _ref.height, width = _ref.width, center = _ref.center, className = _ref.className, fitOnFrame = _ref.fitOnFrame, rounded = _ref.rounded;
    var style = {};
    if (height) style.height = height + "px";
    if (width) style.width = width + "px";
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: $53c06a248023c09c$var$classnames({
            "h-100": fitOnFrame,
            "text-center ": center
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: $53c06a248023c09c$var$classnames($53c06a248023c09c$var$defineProperty({
            "h-100": fitOnFrame,
            "shimmer shimmer-thumbnail": true,
            "border-rounded": rounded
        }, className, className)),
        style: style
    }));
};
$53c06a248023c09c$export$973ab931129fa7e9.propTypes = {
    height: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number,
    center: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).string,
    fitOnFrame: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    rounded: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool
};
$53c06a248023c09c$export$973ab931129fa7e9.defaultProps = {
    canter: false,
    fitOnFrame: false,
    rounded: false,
    height: 250
};
var $53c06a248023c09c$var$css$1 = ".shimmer-avatar {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  margin-bottom: 20px;\n  display: inline-block; }\n\n.shimmer-thumbnail {\n  min-width: 80px;\n  width: 100%;\n  height: 200px;\n  margin-bottom: 20px;\n  display: inline-block; }\n";
$53c06a248023c09c$var$styleInject($53c06a248023c09c$var$css$1);
var $53c06a248023c09c$var$css$2 = ".shimmer-title {\n  margin-bottom: 20px; }\n  .shimmer-title--secondary {\n    margin-bottom: 20px; }\n    .shimmer-title--secondary .shimmer-title-line {\n      height: 16px; }\n  .shimmer-title-line {\n    width: 100%;\n    height: 24px;\n    border-radius: 20px; }\n    .shimmer-title-line:first-child {\n      width: 100% !important; }\n    .shimmer-title-line:last-child {\n      width: 40%; }\n";
$53c06a248023c09c$var$styleInject($53c06a248023c09c$var$css$2);
var $53c06a248023c09c$export$62bbbc04d7c5e7c6 = function ShimmerTitle(_ref) {
    var _classNames;
    var line = _ref.line, gap = _ref.gap, variant = _ref.variant, className = _ref.className;
    var renderLines = function renderLines() {
        var title_lines = [];
        for(var index = 0; index < line; index++)title_lines.push((0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
            className: "shimmer shimmer-title-line",
            key: index
        }));
        return title_lines;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: $53c06a248023c09c$var$classnames((_classNames = {
            grid: true,
            "shimmer-title": variant === "primary",
            "shimmer-title--secondary": variant === "secondary"
        }, $53c06a248023c09c$var$defineProperty(_classNames, "grid-gap-" + gap, gap), $53c06a248023c09c$var$defineProperty(_classNames, className, className), _classNames))
    }, renderLines());
};
$53c06a248023c09c$export$62bbbc04d7c5e7c6.propTypes = {
    line: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number,
    gap: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        10,
        15,
        20,
        30
    ]),
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        "primary",
        "secondary"
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).string
};
$53c06a248023c09c$export$62bbbc04d7c5e7c6.defaultProps = {
    line: 2,
    gap: 10,
    variant: "primary"
};
var $53c06a248023c09c$var$css$3 = ".shimmer-card {\n  border-radius: 8px;\n  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.1);\n  background-color: #ffffff;\n  width: 100%; }\n  .shimmer-card:not(:first-child) {\n    margin-top: 30px; }\n  .shimmer-card--content-center {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center; }\n    .shimmer-card--content-center * {\n      width: 100%;\n      margin: auto; }\n";
$53c06a248023c09c$var$styleInject($53c06a248023c09c$var$css$3);
var $53c06a248023c09c$export$f71f704701cc7071 = function ShimmerCard(_ref) {
    var _classNames;
    var children = _ref.children, className = _ref.className, paddingSize = _ref.paddingSize;
    if (!children) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: $53c06a248023c09c$var$classnames((_classNames = {
            "shimmer-card": true
        }, $53c06a248023c09c$var$defineProperty(_classNames, "p-" + paddingSize, paddingSize), $53c06a248023c09c$var$defineProperty(_classNames, className, className), _classNames))
    }, children);
};
$53c06a248023c09c$export$f71f704701cc7071.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).array
    ]).isRequired,
    paddingSize: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        false,
        20,
        30
    ])
};
$53c06a248023c09c$export$f71f704701cc7071.defaultProps = {
    paddingSize: false
};
var $53c06a248023c09c$export$8c9c634ed03dd9d = function ShimmerSimpleGallery(_ref) {
    var _classNames, _classNames2;
    var row = _ref.row, col = _ref.col, gap = _ref.gap, className = _ref.className, fitOnFrame = _ref.fitOnFrame, imageType = _ref.imageType, imageHeight = _ref.imageHeight, caption = _ref.caption, card = _ref.card;
    var renderPhotos = function renderPhotos() {
        var photos = [];
        var items = row * col;
        for(var index = 0; index < items; index++)photos.push((0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
            key: index
        }, imageType === "thumbnail" && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$973ab931129fa7e9, {
            key: index,
            fitOnFrame: fitOnFrame,
            height: imageHeight,
            className: $53c06a248023c09c$var$classnames({
                "m-0": true
            })
        }), imageType === "circular" && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$697f501f4c22166d, {
            size: imageHeight,
            center: true
        }), caption && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$62bbbc04d7c5e7c6, {
            variant: "secondary",
            className: $53c06a248023c09c$var$classnames({
                "mt-15": imageType === "thumbnail",
                "w-50 ml-auto mr-auto circular-image-caption": imageType === "circular"
            })
        })));
        return photos;
    };
    if (!card) return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: $53c06a248023c09c$var$classnames((_classNames = {
            grid: true
        }, $53c06a248023c09c$var$defineProperty(_classNames, "grid-gap-" + gap, true), $53c06a248023c09c$var$defineProperty(_classNames, "grid-column-" + col, true), $53c06a248023c09c$var$defineProperty(_classNames, className, className), _classNames))
    }, renderPhotos());
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f71f704701cc7071, {
        paddingSize: 20
    }, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: $53c06a248023c09c$var$classnames((_classNames2 = {
            grid: true
        }, $53c06a248023c09c$var$defineProperty(_classNames2, "grid-gap-" + gap, true), $53c06a248023c09c$var$defineProperty(_classNames2, "grid-column-" + col, true), $53c06a248023c09c$var$defineProperty(_classNames2, className, className), _classNames2))
    }, renderPhotos()));
};
$53c06a248023c09c$export$8c9c634ed03dd9d.propTypes = {
    row: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number,
    col: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        2,
        3,
        4
    ]),
    gap: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        20,
        30
    ]),
    fitOnFrame: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    imageType: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        "thumbnail",
        "circular"
    ]),
    imageHeight: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number,
    caption: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    card: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool
};
$53c06a248023c09c$export$8c9c634ed03dd9d.defaultProps = {
    row: 3,
    col: 3,
    gap: 20,
    fitOnFrame: false,
    imageType: "thumbnail",
    caption: false,
    card: false
};
var $53c06a248023c09c$var$css$4 = ".shimmer-gallery-puzzle {\n  height: 540px; }\n\n.circular-image-caption .shimmer-title-line {\n  margin: auto; }\n";
$53c06a248023c09c$var$styleInject($53c06a248023c09c$var$css$4);
var $53c06a248023c09c$export$c09226fd0b9248fd = function ShimmerFeaturedGallery(_ref) {
    var row = _ref.row, col = _ref.col, gap = _ref.gap, card = _ref.card, frameHeight = _ref.frameHeight;
    var style = {};
    if (frameHeight) style.height = frameHeight + "px";
    var renderContent = function renderContent() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
            className: "shimmer-row shimmer-gallery-puzzle",
            style: style
        }, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
            className: "shimmer-col flex-1"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$973ab931129fa7e9, {
            className: "h-100",
            fitOnFrame: true
        })), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
            className: "shimmer-col flex-1"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$8c9c634ed03dd9d, {
            row: row,
            col: col,
            gap: gap,
            className: "h-100",
            fitOnFrame: true
        })));
    };
    if (!card) return renderContent();
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f71f704701cc7071, {
        paddingSize: 20
    }, renderContent());
};
$53c06a248023c09c$export$c09226fd0b9248fd.propTypes = {
    row: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number,
    col: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        2,
        3,
        4
    ]),
    gap: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        20,
        30
    ]),
    card: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    frameHeight: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number
};
$53c06a248023c09c$export$c09226fd0b9248fd.defaultProps = {
    card: false,
    row: 2,
    col: 2,
    gap: 20,
    frameHeight: 600
};
var $53c06a248023c09c$export$b1d53d64a35cfa03 = function ShimmerTableCol() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: "shimmer shimmer-table-col"
    });
};
var $53c06a248023c09c$export$1f21ce2ff8f10a8e = function ShimmerTableRow(_ref) {
    var col = _ref.col, header = _ref.header;
    var renderColumns = function renderColumns() {
        var columns = [];
        for(var index = 0; index < col; index++)columns.push((0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$b1d53d64a35cfa03, {
            key: index
        }));
        return columns;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: $53c06a248023c09c$var$classnames({
            "shimmer-table-row": true,
            "shimmer-table-row--header": header
        })
    }, renderColumns());
};
$53c06a248023c09c$export$1f21ce2ff8f10a8e.propTypes = {
    col: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number.isRequired,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool
};
$53c06a248023c09c$export$1f21ce2ff8f10a8e.defaultProps = {
    col: 5,
    header: false
};
var $53c06a248023c09c$var$css$5 = ".shimmer-table-row {\n  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.1);\n  display: flex;\n  padding: 25px 0;\n  background-color: #ffffff;\n  border-radius: 5px;\n  margin-bottom: 20px; }\n  .shimmer-table-row--header {\n    background-color: transparent;\n    box-shadow: none;\n    margin: 0; }\n  .shimmer-table-row > .shimmer {\n    margin: 0 30px; }\n\n.shimmer-table-col {\n  width: 100%;\n  height: 10px;\n  border-radius: 10px; }\n";
$53c06a248023c09c$var$styleInject($53c06a248023c09c$var$css$5);
var $53c06a248023c09c$export$49f46bfa35d9f4ed = function ShimmerTable(_ref) {
    var row = _ref.row, col = _ref.col;
    var renderRows = function renderRows() {
        var rows = [];
        for(var index = 0; index < row; index++)rows.push((0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$1f21ce2ff8f10a8e, {
            col: col,
            key: index
        }));
        return rows;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$1f21ce2ff8f10a8e, {
        col: col,
        header: true
    }), renderRows());
};
$53c06a248023c09c$export$49f46bfa35d9f4ed.propTypes = {
    row: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number,
    col: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number
};
$53c06a248023c09c$export$49f46bfa35d9f4ed.defaultProps = {
    row: 5,
    col: 5
};
var $53c06a248023c09c$var$css$6 = ".shimmer-badge {\n  width: 80px;\n  height: 24px;\n  border-radius: 20px;\n  margin-bottom: 20px; }\n";
$53c06a248023c09c$var$styleInject($53c06a248023c09c$var$css$6);
var $53c06a248023c09c$export$72eb2c1f271ac333 = function ShimmerBadge(_ref) {
    var width = _ref.width;
    var style = {};
    if (width) style.width = width + "px";
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: "shimmer shimmer-badge",
        style: style
    });
};
$53c06a248023c09c$export$72eb2c1f271ac333.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number
};
var $53c06a248023c09c$var$css$7 = ".shimmer-text {\n  margin-bottom: 30px; }\n  .shimmer-text-line {\n    width: 100%;\n    height: 8px;\n    border-radius: 10px; }\n    .shimmer-text-line:first-child {\n      width: 100% !important; }\n    .shimmer-text-line:last-child {\n      width: 40%; }\n";
$53c06a248023c09c$var$styleInject($53c06a248023c09c$var$css$7);
var $53c06a248023c09c$export$f35c7d979dec8662 = function ShimmerText(_ref) {
    var _classNames;
    var line = _ref.line, gap = _ref.gap, className = _ref.className;
    var renderLines = function renderLines() {
        var text_lines = [];
        for(var index = 0; index < line; index++)text_lines.push((0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
            className: "shimmer shimmer-text-line",
            key: index
        }));
        return text_lines;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: $53c06a248023c09c$var$classnames((_classNames = {
            "grid shimmer-text": true
        }, $53c06a248023c09c$var$defineProperty(_classNames, "grid-gap-" + gap, gap), $53c06a248023c09c$var$defineProperty(_classNames, className, className), _classNames))
    }, renderLines());
};
$53c06a248023c09c$export$f35c7d979dec8662.propTypes = {
    line: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number,
    gap: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        10,
        15,
        20,
        30
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).string
};
$53c06a248023c09c$export$f35c7d979dec8662.defaultProps = {
    line: 5,
    gap: 15
};
var $53c06a248023c09c$var$css$8 = ".shimmer-separator {\n  height: 1px;\n  background-color: #dddddd;\n  margin: 40px 0; }\n";
$53c06a248023c09c$var$styleInject($53c06a248023c09c$var$css$8);
var $53c06a248023c09c$export$f2de27eb84c8765a = function ShimmerSeparator() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: "shimmer-separator"
    });
};
var $53c06a248023c09c$export$7f84737e62455c69 = function ShimmerSocialPost(_ref) {
    var type = _ref.type, title = _ref.title;
    var renderContents = function renderContents() {
        if (type === "image") return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$973ab931129fa7e9, {
            height: 300,
            className: "m-02"
        });
        else if (type === "text") return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, {
            line: 13,
            className: "p-15"
        });
        else return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, {
            line: 3,
            className: "p-15"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$973ab931129fa7e9, {
            height: 300,
            className: "m-02"
        }));
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f71f704701cc7071, null, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: "p-15"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: "flex"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$697f501f4c22166d, null), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: "flex-1 p-15"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$62bbbc04d7c5e7c6, {
        variant: "secondary",
        className: "w-40"
    }))), title && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$62bbbc04d7c5e7c6, {
        line: 1,
        className: "w-40 m-0"
    })), renderContents(), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: "p-15 flex flex-content-between"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$62bbbc04d7c5e7c6, {
        line: 1,
        className: "w-10",
        variant: "secondary"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$62bbbc04d7c5e7c6, {
        line: 1,
        className: "w-10",
        variant: "secondary"
    })));
};
$53c06a248023c09c$export$7f84737e62455c69.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        "text",
        "image",
        "both"
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool
};
$53c06a248023c09c$export$7f84737e62455c69.defaultProps = {
    type: "image",
    title: false
};
var $53c06a248023c09c$export$40380b9af9f6d929 = function ShimmerCategoryItem(_ref) {
    var hasImage = _ref.hasImage, imageType = _ref.imageType, imageWidth = _ref.imageWidth, imageHeight = _ref.imageHeight, title = _ref.title, text = _ref.text, cta = _ref.cta, contentCenter = _ref.contentCenter;
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", null, !hasImage ? (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$62bbbc04d7c5e7c6, {
        variant: "secondary",
        line: 1,
        className: "mb-15 w-80"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: "w-40"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, {
        line: 3,
        gap: 10
    }))) : (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: $53c06a248023c09c$var$classnames({
            flex: true,
            "flex-vertical-center": contentCenter
        })
    }, imageType === "thumbnail" && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$973ab931129fa7e9, {
        width: imageWidth,
        height: imageHeight
    }), imageType === "circular" && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$697f501f4c22166d, {
        size: imageWidth
    }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: "flex-1 p-15"
    }, title && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$62bbbc04d7c5e7c6, {
        variant: "secondary"
    }), text && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, {
        line: 3,
        gap: 10,
        className: "mb-20"
    }), cta && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$399c7d54452eb442, {
        size: "sm"
    }))));
};
$53c06a248023c09c$export$40380b9af9f6d929.propTypes = {
    hasImage: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool.isRequired,
    imageType: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        "circular",
        "thumbnail"
    ]),
    imageWidth: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number,
    imageHeight: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    cta: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    contentCenter: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool
};
$53c06a248023c09c$export$40380b9af9f6d929.defaultProps = {
    hasImage: false,
    imageType: "thumbnail",
    title: false,
    text: false,
    contentCenter: false
};
var $53c06a248023c09c$export$ec67eaf539d05493 = function ShimmerCategoryList(_ref) {
    var items = _ref.items, categoryStyle = _ref.categoryStyle, title = _ref.title;
    var categories = {
        STYLE_ONE: (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$40380b9af9f6d929, null),
        STYLE_TWO: (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$40380b9af9f6d929, {
            hasImage: true,
            imageType: "thumbnail",
            imageWidth: 100,
            imageHeight: 100,
            title: true
        }),
        STYLE_THREE: (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$40380b9af9f6d929, {
            hasImage: true,
            imageType: "circular",
            imageWidth: 100,
            imageHeight: 100,
            title: true
        }),
        STYLE_FOUR: (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$40380b9af9f6d929, {
            hasImage: true,
            imageType: "thumbnail",
            imageWidth: 100,
            imageHeight: 100,
            text: true
        }),
        STYLE_FIVE: (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$40380b9af9f6d929, {
            hasImage: true,
            imageType: "circular",
            imageWidth: 100,
            imageHeight: 100,
            text: true
        }),
        STYLE_SIX: (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$40380b9af9f6d929, {
            hasImage: true,
            imageType: "thumbnail",
            imageWidth: 100,
            imageHeight: 100,
            text: true,
            cta: true
        }),
        STYLE_SEVEN: (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$40380b9af9f6d929, {
            hasImage: true,
            imageType: "circular",
            imageWidth: 100,
            imageHeight: 100,
            text: true,
            cta: true
        })
    };
    var renderItems = function renderItems() {
        var list = [];
        for(var index = 0; index < items; index++)list.push((0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
            key: index
        }, categories[categoryStyle]));
        return list;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f71f704701cc7071, {
        paddingSize: 20
    }, title && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$62bbbc04d7c5e7c6, {
        line: 1,
        className: "w-60"
    }), renderItems());
};
$53c06a248023c09c$export$ec67eaf539d05493.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    items: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number,
    categoryStyle: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        "STYLE_ONE",
        "STYLE_TWO",
        "STYLE_THREE",
        "STYLE_FOUR",
        "STYLE_FIVE",
        "STYLE_SIX",
        "STYLE_SEVEN"
    ])
};
$53c06a248023c09c$export$ec67eaf539d05493.defaultProps = {
    title: false,
    items: 5,
    categoryStyle: "STYLE_ONE"
};
var $53c06a248023c09c$export$655909292232fedc = function ShimmerPostDetails(_ref) {
    var variant = _ref.variant, cta = _ref.cta, card = _ref.card;
    var variants = {
        SIMPLE: (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$62bbbc04d7c5e7c6, {
            line: 1,
            className: "w-40"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$62bbbc04d7c5e7c6, {
            line: 1,
            variant: "secondary",
            className: "w-20 mb-40"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
            className: "w-40 mb-40"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, {
            line: 1,
            className: "mb-15 w-20"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, {
            line: 1,
            className: "mb-15 w-40"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, {
            line: 1,
            className: "mb-30 w-60"
        })), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$62bbbc04d7c5e7c6, {
            line: 1,
            variant: "secondary",
            className: "w-30"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, {
            className: "mb-40"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$62bbbc04d7c5e7c6, {
            line: 1,
            variant: "secondary",
            className: "w-30"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, {
            className: "mb-40"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$62bbbc04d7c5e7c6, {
            line: 1,
            variant: "secondary",
            className: "w-30"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, {
            className: "mb-40"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$62bbbc04d7c5e7c6, {
            line: 1,
            variant: "secondary",
            className: "w-30"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, {
            className: "mb-40"
        }), cta && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$399c7d54452eb442, null)),
        EDITOR: (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$62bbbc04d7c5e7c6, {
            line: 1,
            className: "w-40"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$973ab931129fa7e9, {
            height: 400
        }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, null), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, null), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
            className: "shimmer-row"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
            className: "shimmer-col"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, {
            line: 13
        })), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
            className: "shimmer-col"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$973ab931129fa7e9, {
            height: 300
        }))), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, null), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, null), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, null))
    };
    if (!card) return variants[variant];
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f71f704701cc7071, {
        paddingSize: 30
    }, variants[variant]);
};
$53c06a248023c09c$export$655909292232fedc.propTypes = {
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        "SIMPLE",
        "EDITOR"
    ]),
    cta: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    card: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool
};
$53c06a248023c09c$export$655909292232fedc.defaultProps = {
    variant: "SIMPLE",
    cta: false,
    card: false
};
var $53c06a248023c09c$export$6f1e2cdcdce53633 = function ShimmerPostItem(_ref) {
    var cta = _ref.cta, title = _ref.title, text = _ref.text, imageType = _ref.imageType, imageWidth = _ref.imageWidth, imageHeight = _ref.imageHeight;
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f71f704701cc7071, null, imageType === "thumbnail" && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$973ab931129fa7e9, {
        height: imageHeight,
        width: imageWidth,
        className: imageWidth && imageWidth !== "w-100" ? "m-30 mb-0" : "mb-0"
    }), imageType === "circular" && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$697f501f4c22166d, {
        size: imageWidth,
        className: "m-30 mb-0"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: "p-30"
    }, title && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$62bbbc04d7c5e7c6, {
        variant: "secondary"
    }), text && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, {
        line: 3,
        gap: 10
    }), cta && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$399c7d54452eb442, {
        size: "sm"
    })));
};
$53c06a248023c09c$export$6f1e2cdcdce53633.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    cta: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    imageType: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        "circular",
        "thumbnail"
    ]),
    imageHeight: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number,
    imageWidth: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number
};
$53c06a248023c09c$export$6f1e2cdcdce53633.defaultProps = {
    title: false,
    text: false,
    cta: false,
    imageType: "thumbnail"
};
var $53c06a248023c09c$export$b952781d999a9dfd = function ShimmerPostList(_ref) {
    var _classNames;
    var row = _ref.row, col = _ref.col, gap = _ref.gap, className = _ref.className, postStyle = _ref.postStyle;
    var posts = {
        STYLE_ONE: (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$6f1e2cdcdce53633, {
            title: true,
            text: true,
            cta: true
        }),
        STYLE_TWO: (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$6f1e2cdcdce53633, {
            title: true,
            cta: true
        }),
        STYLE_THREE: (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$6f1e2cdcdce53633, {
            title: true
        }),
        STYLE_FOUR: (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$6f1e2cdcdce53633, {
            text: true,
            cta: true
        }),
        STYLE_FIVE: (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$6f1e2cdcdce53633, {
            text: true
        }),
        STYLE_SIX: (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$6f1e2cdcdce53633, {
            title: true,
            text: true,
            cta: true,
            imageType: "thumbnail",
            imageWidth: 80,
            imageHeight: 80,
            contentCenter: true
        }),
        STYLE_SEVEN: (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$6f1e2cdcdce53633, {
            text: true,
            cta: true,
            imageType: "thumbnail",
            imageWidth: 80,
            imageHeight: 80,
            contentCenter: true
        }),
        STYLE_EIGHT: (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$6f1e2cdcdce53633, {
            title: true,
            cta: true,
            imageType: "thumbnail",
            imageWidth: 80,
            imageHeight: 80,
            contentCenter: true
        })
    };
    var renderPosts = function renderPosts() {
        var list = [];
        var items = row * col;
        for(var index = 0; index < items; index++)list.push((0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
            key: index
        }, posts[postStyle]));
        return list;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: $53c06a248023c09c$var$classnames((_classNames = {
            grid: true
        }, $53c06a248023c09c$var$defineProperty(_classNames, "grid-gap-" + gap, true), $53c06a248023c09c$var$defineProperty(_classNames, "grid-column-" + col, true), $53c06a248023c09c$var$defineProperty(_classNames, className, className), _classNames))
    }, renderPosts());
};
$53c06a248023c09c$export$b952781d999a9dfd.propTypes = {
    row: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number,
    col: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        2,
        3,
        4
    ]),
    gap: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        20,
        30
    ]),
    postStyle: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).oneOf([
        "STYLE_ONE",
        "STYLE_TWO",
        "STYLE_THREE",
        "STYLE_FOUR",
        "STYLE_FIVE",
        "STYLE_SIX",
        "STYLE_SEVEN",
        "STYLE_EIGHT"
    ])
};
$53c06a248023c09c$export$b952781d999a9dfd.defaultProps = {
    row: 3,
    col: 3,
    gap: 20,
    postStyle: "STYLE_ONE"
};
var $53c06a248023c09c$export$e057a94f8fc7d641 = function ShimmerContentBlock(_ref) {
    var card = _ref.card, title = _ref.title, text = _ref.text, cta = _ref.cta, thumbnailWidth = _ref.thumbnailWidth, thumbnailHeight = _ref.thumbnailHeight, reverse = _ref.reverse;
    var renderContent = function renderContent() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
            className: $53c06a248023c09c$var$classnames({
                flex: true,
                "flex-reverse": reverse
            })
        }, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
            className: $53c06a248023c09c$var$classnames({
                flex: true,
                "w-50": !thumbnailWidth
            })
        }, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$973ab931129fa7e9, {
            width: thumbnailWidth,
            height: thumbnailHeight,
            className: "h-100 m-0"
        })), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
            className: " flex-1 p-30"
        }, title && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$62bbbc04d7c5e7c6, {
            className: "w-40",
            line: 1
        }), text && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, null), cta && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$399c7d54452eb442, null)));
    };
    if (!card) return renderContent();
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f71f704701cc7071, null, renderContent());
};
$53c06a248023c09c$export$e057a94f8fc7d641.propTypes = {
    card: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    cta: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    thumbnailWidth: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number,
    thumbnailHeight: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).number,
    reverse: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool
};
$53c06a248023c09c$export$e057a94f8fc7d641.defaultProps = {
    card: true,
    title: false,
    text: false,
    cta: false,
    reverse: false
};
var $53c06a248023c09c$export$c9c934c1772d984e = function ShimmerSectionHeader(_ref) {
    var title = _ref.title, subTitle = _ref.subTitle, center = _ref.center;
    if (!title && !subTitle) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: $53c06a248023c09c$var$classnames({
            "w-60 mb-40": true,
            "ml-auto mr-auto": center
        })
    }, title && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$62bbbc04d7c5e7c6, {
        className: $53c06a248023c09c$var$classnames({
            "w-40": true,
            "ml-auto mr-auto": center
        }),
        line: 1
    }), subTitle && (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("div", {
        className: $53c06a248023c09c$var$classnames({
            "flex-horizontal-center": center
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, {
        line: 1,
        className: "mb-15 w-80"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, {
        line: 1,
        className: "mb-15 w-70"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($53c06a248023c09c$export$f35c7d979dec8662, {
        line: 1,
        className: "mb-15 w-60"
    })));
};
$53c06a248023c09c$export$c9c934c1772d984e.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    subTitle: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool,
    center: (0, (/*@__PURE__*/$parcel$interopDefault($0af3593f6965a373$exports))).bool
};
$53c06a248023c09c$export$c9c934c1772d984e.defaultProps = {
    title: true,
    subTitle: true,
    center: false
};
var $53c06a248023c09c$var$css$9 = '.shimmer {\n  background: linear-gradient(to right, #f6f6f6 8%, #f0f0f0 18%, #f6f6f6 33%);\n  background-size: 1000px 100%;\n  animation: shimmer 2.2s linear infinite forwards; }\n\n@-webkit-keyframes shimmer {\n  0% {\n    background-position: -100% 0; }\n  100% {\n    background-position: 100% 0; } }\n\n@keyframes shimmer {\n  0% {\n    background-position: -1000px 0; }\n  100% {\n    background-position: 1000px 0; } }\n\n/*\n=====\nPadding Styles\n=====\n*/\n.p-30 {\n  padding: 30px; }\n\n.p-20 {\n  padding: 20px; }\n\n.p-15 {\n  padding: 15px; }\n\n/*\n=====\nMargin Styles\n=====\n*/\n.m-0 {\n  margin: 0; }\n\n.m-auto {\n  margin: auto; }\n\n.ml-auto {\n  margin-left: auto; }\n\n.mr-auto {\n  margin-right: auto; }\n\n.m-15 {\n  margin: 15px; }\n\n.m-30 {\n  margin: 30px; }\n\n.mb-0 {\n  margin-bottom: 0px; }\n\n.mb-10 {\n  margin-bottom: 10px; }\n\n.mb-15 {\n  margin-bottom: 15px; }\n\n.mb-20 {\n  margin-bottom: 20px; }\n\n.mt-15 {\n  margin-top: 15px; }\n\n.mb-30 {\n  margin-bottom: 30px; }\n\n.mb-40 {\n  margin-bottom: 40px; }\n\n/*\n=======\nContent Size Styles\n=======\n*/\n.w-10 {\n  width: 10%; }\n\n.w-20 {\n  width: 20%; }\n\n.w-30 {\n  width: 30%; }\n\n.w-40 {\n  width: 40%; }\n\n.w-50 {\n  width: 50%; }\n\n.w-60 {\n  width: 60%; }\n\n.w-70 {\n  width: 70%; }\n\n.w-80 {\n  width: 80%; }\n\n/*\n========\nFlex Styles\n========\n*/\n.flex {\n  display: flex; }\n\n.flex-direction-column {\n  flex-direction: column; }\n\n.flex-horizontal-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center; }\n\n.flex-vertical-center {\n  align-items: center; }\n\n.flex-content-between {\n  justify-content: space-between; }\n\n.flex-reverse {\n  flex-direction: row-reverse; }\n\n.flex-1 {\n  flex-grow: 1; }\n\n/*\n=======\nGrid Styles\n=======\n*/\n.grid {\n  display: grid; }\n\n.grid-gap-10 {\n  gap: 10px; }\n\n.grid-gap-15 {\n  gap: 15px; }\n\n.grid-gap-20 {\n  gap: 20px; }\n\n.grid-gap-30 {\n  gap: 30px; }\n\n.grid-column-2 {\n  grid-template-columns: auto auto; }\n\n.grid-column-3 {\n  grid-template-columns: auto auto auto; }\n\n.grid-column-4 {\n  grid-template-columns: auto auto auto auto; }\n\n.text-center {\n  text-align: center; }\n\n.border-rounded {\n  border-radius: 4px; }\n\n.h-100 {\n  height: 100% !important; }\n\n.shimmer-hr {\n  border-color: #f6f6f6; }\n\n.shimmer-row {\n  display: flex;\n  margin: 0 -15px; }\n  .shimmer-row .shimmer-col,\n  .shimmer-row [class*="shimmer-col-"] {\n    padding-left: 15px;\n    padding-right: 15px;\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n';
$53c06a248023c09c$var$styleInject($53c06a248023c09c$var$css$9);


var $68ce1d77bc18c07c$var$Shimmer = function() {
    return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
        className: "mx-[5.5rem] mt-20 items-center",
        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $53c06a248023c09c$export$8c9c634ed03dd9d), {
            card: true,
            imageHeight: 200,
            caption: true
        })
    });
};
var $68ce1d77bc18c07c$export$2e2bcd8739ae039 = $68ce1d77bc18c07c$var$Shimmer;




var $hD5pT = parcelRequire("hD5pT");
function $ad1c00e896d27009$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $hD5pT._define_property)(target, key, source[key]);
        });
    }
    return target;
}


function $f17388ede13a49cc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f17388ede13a49cc$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $f17388ede13a49cc$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



var $cc6u1 = parcelRequire("cc6u1");

var $fIwXP = parcelRequire("fIwXP");


var $kB67t = parcelRequire("kB67t");


var $fIwXP = parcelRequire("fIwXP");
var $932a91628d18df1f$exports = {};
$932a91628d18df1f$exports = JSON.parse('{"statusCode":0,"data":{"statusMessage":"done successfully","pageOffset":{"nextOffset":"COVCELQ4KICg2YvTn7X5ajCnEzgD","widgetOffset":{"NewListingView_category_bar_chicletranking_TwoRows":"","NewListingView_category_bar_chicletranking_TwoRows_Rendition":"","Restaurant_Group_WebView_PB_Theme":"","Restaurant_Group_WebView_SEO_PB_Theme":"","collectionV5RestaurantListWidget_SimRestoRelevance_food_seo":"10","inlineFacetFilter":"","restaurantCountWidget":""}},"cards":[{"card":{"card":{"@type":"type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget","header":{"title":"What\'s on your mind?","headerStyling":{"padding":{"left":16,"top":16,"bottom":4}}},"layout":{"rows":1,"columns":10,"horizontalScrollEnabled":true,"itemSpacing":24,"widgetPadding":{},"containerStyle":{"containerPadding":{"left":8,"top":8,"right":12,"bottom":4}},"scrollBar":{},"widgetTheme":{"defaultMode":{"backgroundColour":"#FFFFFF","theme":"THEME_TYPE_LIGHT"},"darkMode":{"theme":"THEME_TYPE_DARK"}}},"imageGridCards":{"info":[{"id":"750580","imageId":"v1674029856/PC_Creative%20refresh/3D_bau/banners_new/Pizza.png","action":{"link":"https://www.swiggy.com/collections/83644?collection_id=83644&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2","text":"pizzas","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for pizza","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=83644&tags=layout_CCS_Pizza&search_context=pizza","frequencyCapping":{}},{"id":"750592","imageId":"v1675667625/PC_Creative%20refresh/Biryani_2.png","action":{"link":"https://www.swiggy.com/collections/83649?collection_id=83649&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2","text":"Biryani","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for biryani","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=83649&tags=layout_CCS_Biryani&search_context=biryani","frequencyCapping":{}},{"id":"750223","imageId":"v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Rolls.png","action":{"link":"https://www.swiggy.com/collections/83670?collection_id=83670&tags=layout_CCS_Rolls&type=rcv2","text":"Rolls","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for roll","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=83670&tags=layout_CCS_Rolls","frequencyCapping":{}},{"id":"762797","imageId":"v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Burger.png","action":{"link":"https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2","text":"Burgers","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for burger","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=83637&tags=layout_CCS_Burger&search_context=burger","frequencyCapping":{}},{"id":"749769","imageId":"v1674029852/PC_Creative%20refresh/3D_bau/banners_new/Momos.png","action":{"link":"https://www.swiggy.com/collections/80462?collection_id=80462&tags=layout_CCS_Momos&type=rcv2","text":"Momos","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurant curated for momos","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=80462&tags=layout_CCS_Momos","frequencyCapping":{}},{"id":"750230","imageId":"v1674029860/PC_Creative%20refresh/3D_bau/banners_new/Samosas.png","action":{"link":"https://www.swiggy.com/collections/80397?collection_id=80397&tags=layout_BAU_Contextual%2Csamosa&type=rcv2","text":"Samosa","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for samosa","altTextCta":"open"},"entityId":"80397","frequencyCapping":{}},{"id":"750235","imageId":"v1674029860/PC_Creative%20refresh/3D_bau/banners_new/Sandwich.png","action":{"link":"https://www.swiggy.com/collections/83667?collection_id=83667&tags=layout_CCS_Sandwiches&type=rcv2","text":"Sandwich","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for sandwich","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=83667&tags=layout_CCS_Sandwiches","frequencyCapping":{}},{"id":"750249","imageId":"v1674029859/PC_Creative%20refresh/3D_bau/banners_new/Shawarma.png","action":{"link":"https://www.swiggy.com/collections/80403?collection_id=80403&tags=layout_Shawarma_Contextual&type=rcv2","text":"Shawarma","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurant curated for shawarma","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=80403&tags=layout_Shawarma_Contextual","frequencyCapping":{}},{"id":"750584","imageId":"v1675667626/PC_Creative%20refresh/South_Indian_4.png","action":{"link":"https://www.swiggy.com/collections/83646?collection_id=83646&search_context=southindian&tags=layout_CCS_SouthIndian&type=rcv2","text":"South Indian","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for south indian","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=83646&tags=layout_CCS_SouthIndian&search_context=southindian","frequencyCapping":{}},{"id":"749874","imageId":"v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Cakes.png","action":{"link":"https://www.swiggy.com/collections/83656?collection_id=83656&tags=layout_CCS_Cake&type=rcv2","text":"Cakes","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurant curated for cakes","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=83656&tags=layout_CCS_Cake","frequencyCapping":{}},{"id":"750217","imageId":"v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pav_Bhaji.png","action":{"link":"https://www.swiggy.com/collections/80364?collection_id=80364&tags=layout_PavBhaji_Contextual&type=rcv2","text":"Pav Bhaji","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurant curated for pav bhaji","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=80364&tags=layout_PavBhaji_Contextual","frequencyCapping":{}},{"id":"750588","imageId":"v1674029848/PC_Creative%20refresh/3D_bau/banners_new/Chinese.png","action":{"link":"https://www.swiggy.com/collections/83647?collection_id=83647&tags=layout_CCS_Chinese&type=rcv2","text":"Chinese","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurant curated for chinese","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=83647&tags=layout_CCS_Chinese","frequencyCapping":{}},{"id":"750207","imageId":"v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pasta.png","action":{"link":"https://www.swiggy.com/collections/80480?collection_id=80480&tags=layout_BAU_Contextual%2Cpasta%2Cads_pc_pasta&type=rcv2","text":"Pasta","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurant curated for pasta","altTextCta":"open"},"entityId":"80480","frequencyCapping":{}},{"id":"749864","imageId":"v1674029843/PC_Creative%20refresh/3D_bau/banners_new/Bonda.png","action":{"link":"https://www.swiggy.com/collections/80365?collection_id=80365&tags=layout_BAU_Contextual%2Cbonda%2Clayout_ux4&type=rcv2","text":"Bonda","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurant curated for bonda","altTextCta":"open"},"entityId":"80365","frequencyCapping":{}},{"id":"750239","imageId":"v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Shakes.png","action":{"link":"https://www.swiggy.com/collections/83674?collection_id=83674&tags=layout_CCS_Shakes&type=rcv2","text":"Shake","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurant curated for shakes","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=83674&tags=layout_CCS_Shakes","frequencyCapping":{}},{"id":"750572","imageId":"v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Pure_Veg.png","action":{"link":"https://www.swiggy.com/collections/80439?collection_id=80439&tags=layout_CCS_PureVeg&type=rcv2","text":"Pure Veg","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for veg","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=80439&tags=layout_CCS_PureVeg","frequencyCapping":{}},{"id":"750638","imageId":"v1674029843/PC_Creative%20refresh/3D_bau/banners_new/Juice.png","action":{"link":"https://www.swiggy.com/collections/80446?collection_id=80446&tags=layout_Juices_Contextual&type=rcv2","text":"Juice","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for juice","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=80446&tags=layout_Juices_Contextual","frequencyCapping":{}},{"id":"749774","imageId":"v1674029855/PC_Creative%20refresh/3D_bau/banners_new/Noodles.png","action":{"link":"https://www.swiggy.com/collections/80464?collection_id=80464&tags=layout_BAU_Contextual%2Cnoodles&type=rcv2","text":"Noodles","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurant curated for noodles","altTextCta":"open"},"entityId":"80464","frequencyCapping":{}},{"id":"750132","imageId":"v1674029850/PC_Creative%20refresh/3D_bau/banners_new/Dosa.png","action":{"link":"https://www.swiggy.com/collections/80426?collection_id=80426&tags=layout_CCS_Dosa&type=rcv2","text":"Dosa","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for dosa","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=80426&tags=layout_CCS_Dosa","frequencyCapping":{}},{"id":"750644","imageId":"v1674029846/PC_Creative%20refresh/3D_bau/banners_new/Idli.png","action":{"link":"https://www.swiggy.com/collections/80441?collection_id=80441&searchContext=idli&tags=layout_CCS_Idli&type=rcv2","text":"Idli","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for idly","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=80441&tags=layout_CCS_Idli&searchContext=idli","frequencyCapping":{}}],"style":{"width":{"type":"TYPE_RELATIVE","value":0.2941,"reference":"RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"},"height":{"type":"TYPE_RELATIVE","value":1.2444,"reference":"RELATIVE_DIMENSION_REFERENCE_WIDTH"}}},"id":"whats_on_your_mind","gridElements":{"infoWithStyle":{"@type":"type.googleapis.com/swiggy.gandalf.widgets.v2.ImageInfoLayoutCard","info":[{"id":"750580","imageId":"v1674029856/PC_Creative%20refresh/3D_bau/banners_new/Pizza.png","action":{"link":"https://www.swiggy.com/collections/83644?collection_id=83644&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2","text":"pizzas","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for pizza","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=83644&tags=layout_CCS_Pizza&search_context=pizza","frequencyCapping":{}},{"id":"750592","imageId":"v1675667625/PC_Creative%20refresh/Biryani_2.png","action":{"link":"https://www.swiggy.com/collections/83649?collection_id=83649&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2","text":"Biryani","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for biryani","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=83649&tags=layout_CCS_Biryani&search_context=biryani","frequencyCapping":{}},{"id":"750223","imageId":"v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Rolls.png","action":{"link":"https://www.swiggy.com/collections/83670?collection_id=83670&tags=layout_CCS_Rolls&type=rcv2","text":"Rolls","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for roll","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=83670&tags=layout_CCS_Rolls","frequencyCapping":{}},{"id":"762797","imageId":"v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Burger.png","action":{"link":"https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2","text":"Burgers","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for burger","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=83637&tags=layout_CCS_Burger&search_context=burger","frequencyCapping":{}},{"id":"749769","imageId":"v1674029852/PC_Creative%20refresh/3D_bau/banners_new/Momos.png","action":{"link":"https://www.swiggy.com/collections/80462?collection_id=80462&tags=layout_CCS_Momos&type=rcv2","text":"Momos","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurant curated for momos","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=80462&tags=layout_CCS_Momos","frequencyCapping":{}},{"id":"750230","imageId":"v1674029860/PC_Creative%20refresh/3D_bau/banners_new/Samosas.png","action":{"link":"https://www.swiggy.com/collections/80397?collection_id=80397&tags=layout_BAU_Contextual%2Csamosa&type=rcv2","text":"Samosa","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for samosa","altTextCta":"open"},"entityId":"80397","frequencyCapping":{}},{"id":"750235","imageId":"v1674029860/PC_Creative%20refresh/3D_bau/banners_new/Sandwich.png","action":{"link":"https://www.swiggy.com/collections/83667?collection_id=83667&tags=layout_CCS_Sandwiches&type=rcv2","text":"Sandwich","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for sandwich","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=83667&tags=layout_CCS_Sandwiches","frequencyCapping":{}},{"id":"750249","imageId":"v1674029859/PC_Creative%20refresh/3D_bau/banners_new/Shawarma.png","action":{"link":"https://www.swiggy.com/collections/80403?collection_id=80403&tags=layout_Shawarma_Contextual&type=rcv2","text":"Shawarma","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurant curated for shawarma","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=80403&tags=layout_Shawarma_Contextual","frequencyCapping":{}},{"id":"750584","imageId":"v1675667626/PC_Creative%20refresh/South_Indian_4.png","action":{"link":"https://www.swiggy.com/collections/83646?collection_id=83646&search_context=southindian&tags=layout_CCS_SouthIndian&type=rcv2","text":"South Indian","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for south indian","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=83646&tags=layout_CCS_SouthIndian&search_context=southindian","frequencyCapping":{}},{"id":"749874","imageId":"v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Cakes.png","action":{"link":"https://www.swiggy.com/collections/83656?collection_id=83656&tags=layout_CCS_Cake&type=rcv2","text":"Cakes","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurant curated for cakes","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=83656&tags=layout_CCS_Cake","frequencyCapping":{}},{"id":"750217","imageId":"v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pav_Bhaji.png","action":{"link":"https://www.swiggy.com/collections/80364?collection_id=80364&tags=layout_PavBhaji_Contextual&type=rcv2","text":"Pav Bhaji","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurant curated for pav bhaji","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=80364&tags=layout_PavBhaji_Contextual","frequencyCapping":{}},{"id":"750588","imageId":"v1674029848/PC_Creative%20refresh/3D_bau/banners_new/Chinese.png","action":{"link":"https://www.swiggy.com/collections/83647?collection_id=83647&tags=layout_CCS_Chinese&type=rcv2","text":"Chinese","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurant curated for chinese","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=83647&tags=layout_CCS_Chinese","frequencyCapping":{}},{"id":"750207","imageId":"v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pasta.png","action":{"link":"https://www.swiggy.com/collections/80480?collection_id=80480&tags=layout_BAU_Contextual%2Cpasta%2Cads_pc_pasta&type=rcv2","text":"Pasta","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurant curated for pasta","altTextCta":"open"},"entityId":"80480","frequencyCapping":{}},{"id":"749864","imageId":"v1674029843/PC_Creative%20refresh/3D_bau/banners_new/Bonda.png","action":{"link":"https://www.swiggy.com/collections/80365?collection_id=80365&tags=layout_BAU_Contextual%2Cbonda%2Clayout_ux4&type=rcv2","text":"Bonda","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurant curated for bonda","altTextCta":"open"},"entityId":"80365","frequencyCapping":{}},{"id":"750239","imageId":"v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Shakes.png","action":{"link":"https://www.swiggy.com/collections/83674?collection_id=83674&tags=layout_CCS_Shakes&type=rcv2","text":"Shake","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurant curated for shakes","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=83674&tags=layout_CCS_Shakes","frequencyCapping":{}},{"id":"750572","imageId":"v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Pure_Veg.png","action":{"link":"https://www.swiggy.com/collections/80439?collection_id=80439&tags=layout_CCS_PureVeg&type=rcv2","text":"Pure Veg","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for veg","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=80439&tags=layout_CCS_PureVeg","frequencyCapping":{}},{"id":"750638","imageId":"v1674029843/PC_Creative%20refresh/3D_bau/banners_new/Juice.png","action":{"link":"https://www.swiggy.com/collections/80446?collection_id=80446&tags=layout_Juices_Contextual&type=rcv2","text":"Juice","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for juice","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=80446&tags=layout_Juices_Contextual","frequencyCapping":{}},{"id":"749774","imageId":"v1674029855/PC_Creative%20refresh/3D_bau/banners_new/Noodles.png","action":{"link":"https://www.swiggy.com/collections/80464?collection_id=80464&tags=layout_BAU_Contextual%2Cnoodles&type=rcv2","text":"Noodles","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurant curated for noodles","altTextCta":"open"},"entityId":"80464","frequencyCapping":{}},{"id":"750132","imageId":"v1674029850/PC_Creative%20refresh/3D_bau/banners_new/Dosa.png","action":{"link":"https://www.swiggy.com/collections/80426?collection_id=80426&tags=layout_CCS_Dosa&type=rcv2","text":"Dosa","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for dosa","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=80426&tags=layout_CCS_Dosa","frequencyCapping":{}},{"id":"750644","imageId":"v1674029846/PC_Creative%20refresh/3D_bau/banners_new/Idli.png","action":{"link":"https://www.swiggy.com/collections/80441?collection_id=80441&searchContext=idli&tags=layout_CCS_Idli&type=rcv2","text":"Idli","type":"WEBLINK"},"entityType":"BANNER","accessibility":{"altText":"restaurants curated for idly","altTextCta":"open"},"entityId":"swiggy://collectionV2?collection_id=80441&tags=layout_CCS_Idli&searchContext=idli","frequencyCapping":{}}],"style":{"width":{"type":"TYPE_RELATIVE","value":0.2941,"reference":"RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"},"height":{"type":"TYPE_RELATIVE","value":1.2444,"reference":"RELATIVE_DIMENSION_REFERENCE_WIDTH"}}}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget","header":{"title":"Top restaurant chains in Chennai","action":{},"headerStyling":{"padding":{"left":16,"top":28,"bottom":18}}},"layout":{"rows":1,"columns":20,"horizontalScrollEnabled":true,"itemSpacing":32,"widgetPadding":{},"containerStyle":{"containerPadding":{"left":16,"right":12,"bottom":12}},"scrollBar":{"scrollThumbColor":"#E46D47","scrollTrackColor":"#02060C","width":54,"height":4,"scrollStyling":{"padding":{"top":6,"bottom":24}}},"widgetTheme":{"defaultMode":{"backgroundColour":"#1B3028","theme":"THEME_TYPE_DARK"},"darkMode":{"backgroundColour":"#1B3028","theme":"THEME_TYPE_DARK"}}},"id":"top_brands_for_you","gridElements":{"infoWithStyle":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle","restaurants":[{"info":{"id":"806891","name":"Pizza Hut","cloudinaryImageId":"978358a0d0caba4f4555b8e2147b467d","locality":"Anna Salai","areaName":"Triplicane","costForTwo":"\u20B9350 for two","cuisines":["Pizzas"],"avgRating":4.3,"parentId":"721","avgRatingString":"4.3","totalRatingsString":"100+","sla":{"deliveryTime":35,"lastMileTravel":3,"serviceability":"SERVICEABLE","slaString":"35-40 mins","lastMileTravelString":"3.0 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-17 01:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"Rxawards/_CATEGORY-Pizza.png","description":"Delivery!"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"Delivery!","imageId":"Rxawards/_CATEGORY-Pizza.png"}}]},"textBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"50% OFF","subHeader":"UPTO \u20B9100"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","isNewlyOnboarded":true,"restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/pizza-hut-anna-salai-triplicane-chennai-806891","type":"WEBLINK"}},{"info":{"id":"453068","name":"Chinese Wok","cloudinaryImageId":"e0839ff574213e6f35b3899ebf1fc597","locality":"Express Avenue","areaName":"Royapettah","costForTwo":"\u20B9250 for two","cuisines":["Chinese","Asian","Tibetan","Desserts"],"avgRating":4.2,"parentId":"61955","avgRatingString":"4.2","totalRatingsString":"1K+","sla":{"deliveryTime":47,"lastMileTravel":3.9,"serviceability":"SERVICEABLE","slaString":"45-50 mins","lastMileTravelString":"3.9 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 22:00:00","opened":true},"badges":{},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{},"textBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"ITEMS","subHeader":"AT \u20B9149"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/chinese-wok-express-avenue-royapettah-chennai-453068","type":"WEBLINK"}},{"info":{"id":"37972","name":"McDonald\'s","cloudinaryImageId":"RX_THUMBNAIL/IMAGES/VENDOR/2024/4/1/fe11ced6-89a3-4080-8610-3c743a3bb3f0_37972.jpg","locality":"Anna Salai","areaName":"Anna Salai","costForTwo":"\u20B9400 for two","cuisines":["Burgers","Beverages","Cafe","Desserts"],"avgRating":4.3,"parentId":"630","avgRatingString":"4.3","totalRatingsString":"10K+","sla":{"deliveryTime":33,"lastMileTravel":3.5,"serviceability":"SERVICEABLE","slaString":"30-35 mins","lastMileTravelString":"3.5 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 23:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"Rxawards/_CATEGORY-Burger.png","description":"Delivery!"}]},"isOpen":true,"aggregatedDiscountInfoV2":{},"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"Delivery!","imageId":"Rxawards/_CATEGORY-Burger.png"}}]},"textBased":{},"textExtendedBadges":{}}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/mcdonalds-anna-salai-chennai-37972","type":"WEBLINK"}},{"info":{"id":"708880","name":"KFC","cloudinaryImageId":"RX_THUMBNAIL/IMAGES/VENDOR/2024/4/17/8ba01310-e5b7-4a90-bef3-98a10bc91238_708880.JPG","locality":"Sydenhams Road","areaName":"Periyampet","costForTwo":"\u20B9400 for two","cuisines":["Burgers","Fast Food","Rolls & Wraps"],"avgRating":4.1,"parentId":"547","avgRatingString":"4.1","totalRatingsString":"1K+","sla":{"deliveryTime":35,"lastMileTravel":0.4,"serviceability":"SERVICEABLE","slaString":"25-35 mins","lastMileTravelString":"0.4 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-17 00:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"Rxawards/_CATEGORY-Burger.png","description":"Delivery!"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"Delivery!","imageId":"Rxawards/_CATEGORY-Burger.png"}}]},"textBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"ITEMS","subHeader":"AT \u20B9189"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/kfc-sydenhams-road-periyampet-chennai-708880","type":"WEBLINK"}},{"info":{"id":"545672","name":"Kwality Walls Frozen Dessert and Ice Cream Shop","cloudinaryImageId":"kfxwva6gosuqfbtncvrt","locality":"Mumusamy Lane","areaName":"Egmore","costForTwo":"\u20B9200 for two","cuisines":["Desserts","Ice Cream","Ice Cream Cakes"],"avgRating":4.5,"veg":true,"parentId":"582","avgRatingString":"4.5","totalRatingsString":"100+","sla":{"deliveryTime":29,"lastMileTravel":2.2,"serviceability":"SERVICEABLE","slaString":"25-30 mins","lastMileTravelString":"2.2 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 22:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"pureveg","imageId":"v1695133679/badges/Pure_Veg111.png"}}]},"textBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"50% OFF","subHeader":"UPTO \u20B9100"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/kwality-walls-frozen-dessert-and-ice-cream-shop-mumusamy-lane-egmore-chennai-545672","type":"WEBLINK"}},{"info":{"id":"43185","name":"Palmshore","cloudinaryImageId":"9ae730c95d13d6e26bf0bc9d69119a38","locality":"Egmore","areaName":"Egmore","costForTwo":"\u20B9400 for two","cuisines":["Arabian"],"avgRating":4.3,"parentId":"1689","avgRatingString":"4.3","totalRatingsString":"10K+","sla":{"deliveryTime":34,"lastMileTravel":2.5,"serviceability":"SERVICEABLE","slaString":"30-35 mins","lastMileTravelString":"2.5 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 23:15:00","opened":true},"badges":{"imageBadges":[{"imageId":"Rxawards/_CATEGORY-Coastal.png","description":"Delivery!"},{"imageId":"Rxawards/_CATEGORY-Mughlai.png","description":"Delivery!"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"Delivery!","imageId":"Rxawards/_CATEGORY-Coastal.png"}},{"attributes":{"description":"Delivery!","imageId":"Rxawards/_CATEGORY-Mughlai.png"}}]},"textBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"20% OFF","subHeader":"UPTO \u20B950"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/palmshore-egmore-chennai-43185","type":"WEBLINK"}},{"info":{"id":"14044","name":"Fruit Shop on Greams Road","cloudinaryImageId":"ufryw0c5fuxraq1zx1pq","locality":"Opposite Commissioner Office","areaName":"Egmore","costForTwo":"\u20B9150 for two","cuisines":["Juices","Beverages","Desserts"],"avgRating":4.5,"veg":true,"parentId":"401","avgRatingString":"4.5","totalRatingsString":"1K+","sla":{"deliveryTime":33,"lastMileTravel":1.8,"serviceability":"SERVICEABLE","slaString":"30-35 mins","lastMileTravelString":"1.8 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 23:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}],"textExtendedBadges":[{"iconId":"guiltfree/GF_Logo_android_3x","shortDescription":"options available","fontColor":"#7E808C"}]},"isOpen":true,"aggregatedDiscountInfoV2":{},"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"pureveg","imageId":"v1695133679/badges/Pure_Veg111.png"}}]},"textBased":{},"textExtendedBadges":{"badgeObject":[{"attributes":{"description":"","fontColor":"#7E808C","iconId":"guiltfree/GF_Logo_android_3x","shortDescription":"options available"}}]}}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/fruit-shop-on-greams-road-opposite-commissioner-office-egmore-chennai-14044","type":"WEBLINK"}},{"info":{"id":"33457","name":"Buhari","cloudinaryImageId":"hwbeetykbqbudvijg6yd","locality":"Purasawalkam - Buhari","areaName":"Purasawalkam","costForTwo":"\u20B9600 for two","cuisines":["Biryani","Chinese","South Indian","Arabian","Barbecue","Seafood","Desserts","Beverages"],"avgRating":4.1,"parentId":"164","avgRatingString":"4.1","totalRatingsString":"10K+","sla":{"deliveryTime":28,"lastMileTravel":1.8,"serviceability":"SERVICEABLE","slaString":"25-30 mins","lastMileTravelString":"1.8 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-17 01:00:00","opened":true},"badges":{},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{},"textBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"60% OFF","subHeader":"UPTO \u20B9120"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/buhari-buhari-purasawalkam-chennai-33457","type":"WEBLINK"}},{"info":{"id":"542182","name":"Wow! Momo","cloudinaryImageId":"64fd45fd9f44c1737bc446e470bed666","locality":"Poonamallee High Road","areaName":"Vepary","costForTwo":"\u20B9300 for two","cuisines":["Tibetan","Healthy Food","Asian","Chinese","Snacks","Continental","Desserts","Beverages"],"avgRating":4.3,"parentId":"1776","avgRatingString":"4.3","totalRatingsString":"500+","sla":{"deliveryTime":32,"lastMileTravel":0.5,"serviceability":"SERVICEABLE","slaString":"30-35 mins","lastMileTravelString":"0.5 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-17 00:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"Rxawards/_CATEGORY-Chinese.png","description":"Delivery!"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"Delivery!","imageId":"Rxawards/_CATEGORY-Chinese.png"}}]},"textBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"ITEMS","subHeader":"AT \u20B999"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/wow-momo-poonamallee-high-road-vepary-chennai-542182","type":"WEBLINK"}},{"info":{"id":"16543","name":"A2B - Adyar Ananda Bhavan","cloudinaryImageId":"dsliyhlbtgtnnuxyrpsf","locality":"Purasavakkam","areaName":"Purasavakkam","costForTwo":"\u20B9300 for two","cuisines":["South Indian","Sweets","Chinese"],"avgRating":4.6,"parentId":"22","avgRatingString":"4.6","totalRatingsString":"10K+","sla":{"deliveryTime":34,"lastMileTravel":2.7,"serviceability":"SERVICEABLE","slaString":"30-35 mins","lastMileTravelString":"2.7 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 22:30:00","opened":true},"badges":{"imageBadges":[{"imageId":"Rxawards/_CATEGORY-South%20Indian.png","description":"Delivery!"},{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"Delivery!","imageId":"Rxawards/_CATEGORY-South%20Indian.png"}},{"attributes":{"description":"pureveg","imageId":"v1695133679/badges/Pure_Veg111.png"}}]},"textBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"20% OFF","subHeader":"UPTO \u20B950"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/a2b-adyar-ananda-bhavan-purasavakkam-chennai-16543","type":"WEBLINK"}},{"info":{"id":"176725","name":"Salem RR Biriyani Unavagam","cloudinaryImageId":"3daa979cd6892a3bcdf2f0ecea2b2d98","locality":"Triplicane","areaName":"Triplicane","costForTwo":"\u20B9400 for two","cuisines":["Biryani","Chettinad","Tandoor","Chinese"],"avgRating":3.8,"parentId":"176137","avgRatingString":"3.8","totalRatingsString":"5K+","sla":{"deliveryTime":35,"lastMileTravel":3.8,"serviceability":"SERVICEABLE","slaString":"35-40 mins","lastMileTravelString":"3.8 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 23:00:00","opened":true},"badges":{},"isOpen":true,"aggregatedDiscountInfoV2":{},"type":"F","badgesV2":{"entityBadges":{"imageBased":{},"textBased":{},"textExtendedBadges":{}}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/salem-rr-biriyani-unavagam-triplicane-chennai-176725","type":"WEBLINK"}},{"info":{"id":"257162","name":"The Brooklyn Creamery - Healthy Ice Cream","cloudinaryImageId":"b1b35780a9b1dfeb26d680506d494eaa","locality":"Mahaveer Colony","areaName":"Vepery","costForTwo":"\u20B9200 for two","cuisines":["Healthy Food","Desserts","Ice Cream"],"avgRating":4.6,"veg":true,"parentId":"236673","avgRatingString":"4.6","totalRatingsString":"500+","sla":{"deliveryTime":30,"lastMileTravel":1.4,"serviceability":"SERVICEABLE","slaString":"30-35 mins","lastMileTravelString":"1.4 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-17 02:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}],"textExtendedBadges":[{"iconId":"guiltfree/GF_Logo_android_3x","shortDescription":"brand","fontColor":"#7E808C"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"pureveg","imageId":"v1695133679/badges/Pure_Veg111.png"}}]},"textBased":{},"textExtendedBadges":{"badgeObject":[{"attributes":{"description":"","fontColor":"#7E808C","iconId":"guiltfree/GF_Logo_android_3x","shortDescription":"brand"}}]}}},"aggregatedDiscountInfoV3":{"header":"60% OFF","subHeader":"UPTO \u20B9120"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/the-brooklyn-creamery-healthy-ice-cream-mahaveer-colony-vepery-chennai-257162","type":"WEBLINK"}},{"info":{"id":"430194","name":"SMOOR","cloudinaryImageId":"RX_THUMBNAIL/IMAGES/VENDOR/2024/5/14/a569b154-5735-4691-a3f2-83ef55dd48f8_430194.JPG","locality":"Chennai Corp. Ward - 111","areaName":"Royapettah","costForTwo":"\u20B9350 for two","cuisines":["Desserts","Bakery"],"avgRating":4.6,"parentId":"3506","avgRatingString":"4.6","totalRatingsString":"500+","sla":{"deliveryTime":35,"lastMileTravel":4,"serviceability":"SERVICEABLE","slaString":"30-35 mins","lastMileTravelString":"4.0 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 21:30:00","opened":true},"badges":{"textExtendedBadges":[{"iconId":"v1705582451/Ratnesh_Badges/Perfect_cake.png","shortDescription":"Perfect cake delivery","fontColor":"#7E808C"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{},"textBased":{},"textExtendedBadges":{"badgeObject":[{"attributes":{"description":"","fontColor":"#7E808C","iconId":"v1705582451/Ratnesh_Badges/Perfect_cake.png","shortDescription":"Perfect cake delivery"}}]}}},"aggregatedDiscountInfoV3":{"header":"50% OFF","subHeader":"UPTO \u20B9100"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/smoor-corp-ward-111-royapettah-chennai-430194","type":"WEBLINK"}},{"info":{"id":"464915","name":"Keventers Ice Cream","cloudinaryImageId":"RX_THUMBNAIL/IMAGES/VENDOR/2024/5/6/c225a4e8-4b98-4c14-939b-361c7bcae118_464915.JPG","locality":"Poonamalle High Road","areaName":"Kilpauk","costForTwo":"\u20B9200 for two","cuisines":["Ice Cream","Desserts"],"avgRating":4.4,"veg":true,"parentId":"272044","avgRatingString":"4.4","totalRatingsString":"100+","sla":{"deliveryTime":36,"lastMileTravel":4,"serviceability":"SERVICEABLE","slaString":"35-40 mins","lastMileTravelString":"4.0 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-17 01:00:00","opened":true},"badges":{"textExtendedBadges":[{"iconId":"Ratnesh_Badges/test2.png","shortDescription":"Perfect ice cream delivery","fontColor":"#7E808C"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{},"textBased":{},"textExtendedBadges":{"badgeObject":[{"attributes":{"description":"","fontColor":"#7E808C","iconId":"Ratnesh_Badges/test2.png","shortDescription":"Perfect ice cream delivery"}}]}}},"aggregatedDiscountInfoV3":{"header":"50% OFF","subHeader":"UPTO \u20B9100"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/keventers-ice-cream-poonamalle-high-road-kilpauk-chennai-464915","type":"WEBLINK"}},{"info":{"id":"11479","name":"Burger King","cloudinaryImageId":"e33e1d3ba7d6b2bb0d45e1001b731fcf","locality":"Express Avenue","areaName":"Thousand Lights","costForTwo":"\u20B9350 for two","cuisines":["Burgers","American"],"avgRating":4.2,"parentId":"166","avgRatingString":"4.2","totalRatingsString":"10K+","sla":{"deliveryTime":48,"lastMileTravel":4,"serviceability":"SERVICEABLE","slaString":"45-50 mins","lastMileTravelString":"4.0 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 23:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"Rxawards/_CATEGORY-Burger.png","description":"Delivery!"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"Delivery!","imageId":"Rxawards/_CATEGORY-Burger.png"}}]},"textBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"50% OFF","subHeader":"UPTO \u20B9100"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/burger-king-express-avenue-thousand-lights-chennai-11479","type":"WEBLINK"}},{"info":{"id":"55045","name":"Murugan Idli Shop","cloudinaryImageId":"dlkj9tdzjf6r72ovkuhh","locality":"George Town","areaName":"Poongavanapuram","costForTwo":"\u20B9200 for two","cuisines":["South Indian"],"avgRating":4.4,"veg":true,"parentId":"1248","avgRatingString":"4.4","totalRatingsString":"5K+","sla":{"deliveryTime":26,"lastMileTravel":0.5,"serviceability":"SERVICEABLE","slaString":"25-30 mins","lastMileTravelString":"0.5 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 23:00:00","opened":true},"badges":{},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{},"textBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"10% OFF","subHeader":"UPTO \u20B940"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/murugan-idli-shop-george-town-poongavanapuram-chennai-55045","type":"WEBLINK"}},{"info":{"id":"13298","name":"Tibb\'s Frankie","cloudinaryImageId":"sodmcao0ye0g5cdnumxp","locality":"Venkateshwara Nagar","areaName":"High Court","costForTwo":"\u20B9100 for two","cuisines":["Street Food"],"avgRating":4.2,"parentId":"216056","avgRatingString":"4.2","totalRatingsString":"1K+","sla":{"deliveryTime":33,"lastMileTravel":2.2,"serviceability":"SERVICEABLE","slaString":"30-35 mins","lastMileTravelString":"2.2 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 21:30:00","opened":true},"badges":{"imageBadges":[{"imageId":"Rxawards/_CATEGORY-Rolls.png","description":"Delivery!"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"Delivery!","imageId":"Rxawards/_CATEGORY-Rolls.png"}}]},"textBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"20% OFF","subHeader":"UPTO \u20B950"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/tibbs-frankie-venkateshwara-nagar-high-court-chennai-13298","type":"WEBLINK"}},{"info":{"id":"53934","name":"Ibaco","cloudinaryImageId":"kujznwgh3g3tdqqrmlhu","locality":"Vepery","areaName":"Vepery","costForTwo":"\u20B9800 for two","cuisines":["Ice Cream","Desserts"],"avgRating":4.7,"parentId":"3481","avgRatingString":"4.7","totalRatingsString":"1K+","sla":{"deliveryTime":29,"lastMileTravel":1.9,"serviceability":"SERVICEABLE","slaString":"25-30 mins","lastMileTravelString":"1.9 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 23:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"Rxawards/_CATEGORY-Desserts.png","description":"Delivery!"},{"imageId":"Rxawards/_CATEGORY-Ice-creams.png","description":"Delivery!"},{"imageId":"newg.png","description":"Gourmet"}]},"isOpen":true,"aggregatedDiscountInfoV2":{},"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"Delivery!","imageId":"Rxawards/_CATEGORY-Desserts.png"}},{"attributes":{"description":"Delivery!","imageId":"Rxawards/_CATEGORY-Ice-creams.png"}},{"attributes":{"description":"Gourmet","imageId":"newg.png"}}]},"textBased":{},"textExtendedBadges":{}}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/ibaco-vepery-chennai-53934","type":"WEBLINK"}},{"info":{"id":"62861","name":"Ganga Sweets","cloudinaryImageId":"ojr8bwlh4l1mcjnijmxw","locality":"Purasavakkam","areaName":"Purasavakkam","costForTwo":"\u20B9250 for two","cuisines":["Sweets","Street Food"],"avgRating":4.6,"veg":true,"parentId":"405","avgRatingString":"4.6","totalRatingsString":"1K+","sla":{"deliveryTime":35,"lastMileTravel":2.7,"serviceability":"SERVICEABLE","slaString":"35-40 mins","lastMileTravelString":"2.7 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 22:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"pureveg","imageId":"v1695133679/badges/Pure_Veg111.png"}}]},"textBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"20% OFF","subHeader":"UPTO \u20B950"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/ganga-sweets-purasavakkam-chennai-62861","type":"WEBLINK"}},{"info":{"id":"14834","name":"Hotel Saravana Bhavan","cloudinaryImageId":"drhqc7ptipun2utfohdo","locality":"Egmore","areaName":"Egmore","costForTwo":"\u20B9300 for two","cuisines":["North Indian","South Indian"],"avgRating":4.3,"parentId":"101987","avgRatingString":"4.3","totalRatingsString":"10K+","sla":{"deliveryTime":41,"lastMileTravel":1.9,"serviceability":"SERVICEABLE","slaString":"40-45 mins","lastMileTravelString":"1.9 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 23:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"aggregatedDiscountInfoV2":{},"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"pureveg","imageId":"v1695133679/badges/Pure_Veg111.png"}}]},"textBased":{},"textExtendedBadges":{}}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"https://www.swiggy.com/restaurants/hotel-saravana-bhavan-egmore-chennai-14834","type":"WEBLINK"}}],"theme":"Restaurant_Group_WebView_SEO_PB_Theme","widgetType":"WIDGET_TYPE_POPULAR_BRANDS","style":{"width":{"type":"TYPE_RELATIVE","value":0.41111112,"reference":"RELATIVE_DIMENSION_REFERENCE_DEVICE_WIDTH"},"height":{"type":"TYPE_RELATIVE","value":0.7027027,"reference":"RELATIVE_DIMENSION_REFERENCE_WIDTH"},"layoutAlignment":"LAYOUT_ALIGNMENT_LEFT"},"collectionId":"84124"}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.seo.widgets.v1.BasicContent","title":"Restaurants with online food delivery in Chennai","id":"popular_restaurants_title"}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.gandalf.widgets.v2.InlineViewFilterSortWidget","sortConfigs":[{"key":"relevance","title":"Relevance (Default)","selected":true,"defaultSelection":true},{"key":"deliveryTimeAsc","title":"Delivery Time"},{"key":"modelBasedRatingDesc","title":"Rating"},{"key":"costForTwoAsc","title":"Cost: Low to High"},{"key":"costForTwoDesc","title":"Cost: High to Low"}],"restaurantCount":1740,"facetList":[{"label":"Delivery Time","id":"deliveryTime","selection":"SELECT_TYPE_MULTISELECT","facetInfo":[{"label":"Fast Delivery","id":"deliveryTimefacetquery1","analytics":{},"openFilter":true}],"viewType":"VIEW_TYPE_HALF_CARD","subLabel":"Filter by"},{"label":"Cuisines","id":"catalog_cuisines","selection":"SELECT_TYPE_MULTISELECT","facetInfo":[{"label":"Afghani","id":"query_afghani","analytics":{},"openFilter":true},{"label":"African","id":"query_african","analytics":{},"openFilter":true},{"label":"American","id":"query_american","analytics":{},"openFilter":true},{"label":"Andhra","id":"query_andhra","analytics":{},"openFilter":true},{"label":"Arabian","id":"query_arabian","analytics":{},"openFilter":true},{"label":"Asian","id":"query_asian","analytics":{},"openFilter":true},{"label":"Awadhi","id":"query_awadhi","analytics":{},"openFilter":true},{"label":"Bakery","id":"query_bakery","analytics":{},"openFilter":true},{"label":"Barbecue","id":"query_barbecue","analytics":{},"openFilter":true},{"label":"Bengali","id":"query_bengali","analytics":{},"openFilter":true},{"label":"Beverages","id":"query_beverages","analytics":{},"openFilter":true},{"label":"Biryani","id":"query_biryani","analytics":{},"openFilter":true},{"label":"British","id":"query_british","analytics":{},"openFilter":true},{"label":"Bubble Tea","id":"query_bubble_tea","analytics":{},"openFilter":true},{"label":"Buffalo meat","id":"query_buffalo_meat","analytics":{},"openFilter":true},{"label":"Burger","id":"query_burger","analytics":{},"openFilter":true},{"label":"Burgers","id":"query_burgers","analytics":{},"openFilter":true},{"label":"Burmese","id":"query_burmese","analytics":{},"openFilter":true},{"label":"Cafe","id":"query_cafe","analytics":{},"openFilter":true},{"label":"Cakes and Pastries","id":"query_cakes_and_pastries","analytics":{},"openFilter":true},{"label":"Chaat","id":"query_chaat","analytics":{},"openFilter":true},{"label":"Chettinad","id":"query_chettinad","analytics":{},"openFilter":true},{"label":"Chinese","id":"query_chinese","analytics":{},"openFilter":true},{"label":"Coffee","id":"query_coffee","analytics":{},"openFilter":true},{"label":"Combo","id":"query_combo","analytics":{},"openFilter":true},{"label":"Continental","id":"query_continental","analytics":{},"openFilter":true},{"label":"Desserts","id":"query_desserts","analytics":{},"openFilter":true},{"label":"European","id":"query_european","analytics":{},"openFilter":true},{"label":"FUSION","id":"query_fusion","analytics":{},"openFilter":true},{"label":"Fast Food","id":"query_fast_food","analytics":{},"openFilter":true},{"label":"French","id":"query_french","analytics":{},"openFilter":true},{"label":"Grill","id":"query_grill","analytics":{},"openFilter":true},{"label":"Gujarati","id":"query_gujarati","analytics":{},"openFilter":true},{"label":"Haleem","id":"query_haleem","analytics":{},"openFilter":true},{"label":"Healthy Food","id":"query_healthy_food","analytics":{},"openFilter":true},{"label":"Home Food","id":"query_home_food","analytics":{},"openFilter":true},{"label":"Hyderabadi","id":"query_hyderabadi","analytics":{},"openFilter":true},{"label":"Ice Cream","id":"query_ice_cream","analytics":{},"openFilter":true},{"label":"Ice Cream Cakes","id":"query_ice_cream_cakes","analytics":{},"openFilter":true},{"label":"Ice cream","id":"query_ice_cream","analytics":{},"openFilter":true},{"label":"Indian","id":"query_indian","analytics":{},"openFilter":true},{"label":"Italian","id":"query_italian","analytics":{},"openFilter":true},{"label":"Italian-American","id":"query_italian-american","analytics":{},"openFilter":true},{"label":"Jain","id":"query_jain","analytics":{},"openFilter":true},{"label":"Japanese","id":"query_japanese","analytics":{},"openFilter":true},{"label":"Juices","id":"query_juices","analytics":{},"openFilter":true},{"label":"Kebabs","id":"query_kebabs","analytics":{},"openFilter":true},{"label":"Kerala","id":"query_kerala","analytics":{},"openFilter":true},{"label":"Keto","id":"query_keto","analytics":{},"openFilter":true},{"label":"Korean","id":"query_korean","analytics":{},"openFilter":true},{"label":"Lebanese","id":"query_lebanese","analytics":{},"openFilter":true},{"label":"Lucknowi","id":"query_lucknowi","analytics":{},"openFilter":true},{"label":"Maharashtrian","id":"query_maharashtrian","analytics":{},"openFilter":true},{"label":"Malaysian","id":"query_malaysian","analytics":{},"openFilter":true},{"label":"Mangalorean","id":"query_mangalorean","analytics":{},"openFilter":true},{"label":"Meat","id":"query_meat","analytics":{},"openFilter":true},{"label":"Mediterranean","id":"query_mediterranean","analytics":{},"openFilter":true},{"label":"Mexica","id":"query_mexica","analytics":{},"openFilter":true},{"label":"Mexican","id":"query_mexican","analytics":{},"openFilter":true},{"label":"Middle Eastern","id":"query_middle_eastern","analytics":{},"openFilter":true},{"label":"Momos","id":"query_momos","analytics":{},"openFilter":true},{"label":"Mongolian","id":"query_mongolian","analytics":{},"openFilter":true},{"label":"Mughlai","id":"query_mughlai","analytics":{},"openFilter":true},{"label":"Naga","id":"query_naga","analytics":{},"openFilter":true},{"label":"Navratri Special","id":"query_navratri_special","analytics":{},"openFilter":true},{"label":"North Eastern","id":"query_north_eastern","analytics":{},"openFilter":true},{"label":"North Indian","id":"query_north_indian","analytics":{},"openFilter":true},{"label":"Oriental","id":"query_oriental","analytics":{},"openFilter":true},{"label":"Paan","id":"query_paan","analytics":{},"openFilter":true},{"label":"Pan-Asian","id":"query_pan-asian","analytics":{},"openFilter":true},{"label":"Pastas","id":"query_pastas","analytics":{},"openFilter":true},{"label":"Persian","id":"query_persian","analytics":{},"openFilter":true},{"label":"Pizzas","id":"query_pizzas","analytics":{},"openFilter":true},{"label":"Punjabi","id":"query_punjabi","analytics":{},"openFilter":true},{"label":"Rajasthani","id":"query_rajasthani","analytics":{},"openFilter":true},{"label":"Rolls & Wraps","id":"query_rolls_&_wraps","analytics":{},"openFilter":true},{"label":"Salads","id":"query_salads","analytics":{},"openFilter":true},{"label":"Seafood","id":"query_seafood","analytics":{},"openFilter":true},{"label":"Singaporean","id":"query_singaporean","analytics":{},"openFilter":true},{"label":"Snacks","id":"query_snacks","analytics":{},"openFilter":true},{"label":"South Indian","id":"query_south_indian","analytics":{},"openFilter":true},{"label":"South indian","id":"query_south_indian","analytics":{},"openFilter":true},{"label":"Spanish","id":"query_spanish","analytics":{},"openFilter":true},{"label":"Special Discount from (Garden Cafe Express)","id":"query_special_discount_from_(garden_cafe_express)","analytics":{},"openFilter":true},{"label":"Street Food","id":"query_street_food","analytics":{},"openFilter":true},{"label":"Sushi","id":"query_sushi","analytics":{},"openFilter":true},{"label":"Sweets","id":"query_sweets","analytics":{},"openFilter":true},{"label":"Tandoor","id":"query_tandoor","analytics":{},"openFilter":true},{"label":"Thai","id":"query_thai","analytics":{},"openFilter":true},{"label":"Thalis","id":"query_thalis","analytics":{},"openFilter":true},{"label":"Tibetan","id":"query_tibetan","analytics":{},"openFilter":true},{"label":"Turkish","id":"query_turkish","analytics":{},"openFilter":true},{"label":"Waffle","id":"query_waffle","analytics":{},"openFilter":true},{"label":"rolls","id":"query_rolls","analytics":{},"openFilter":true}],"viewType":"VIEW_TYPE_HALF_CARD","canSearch":true,"subLabel":"Filter by cuisine","openFilter":true},{"label":"Explore","id":"explore","selection":"SELECT_TYPE_MULTISELECT","facetInfo":[{"label":"New on Swiggy","id":"newfacetquery1","analytics":{},"openFilter":true},{"label":"Swiggy Exclusives","id":"isExclusivefacetquery1","analytics":{}}],"viewType":"VIEW_TYPE_HALF_CARD"},{"label":"Ratings","id":"rating","selection":"SELECT_TYPE_MULTISELECT","facetInfo":[{"label":"Ratings 4.5+","id":"ratingfacetquery3","analytics":{}},{"label":"Ratings 4.0+","id":"ratingfacetquery4","analytics":{},"openFilter":true},{"label":"Ratings 3.5+","id":"ratingfacetquery5","analytics":{}}],"viewType":"VIEW_TYPE_HALF_CARD","subLabel":"Filter by"},{"label":"Veg/Non-Veg","id":"isVeg","selection":"SELECT_TYPE_SINGLESELECT","facetInfo":[{"label":"Pure Veg","id":"isVegfacetquery2","analytics":{},"openFilter":true},{"label":"Non Veg","id":"isVegfacetquery3","analytics":{}}],"viewType":"VIEW_TYPE_FLATTENED","subLabel":"Filter by"},{"label":"Offers","id":"restaurantOfferMultiTd","selection":"SELECT_TYPE_SINGLESELECT","facetInfo":[{"label":"Offers","id":"restaurantOfferMultiTdfacetquery3","analytics":{},"openFilter":true}],"viewType":"VIEW_TYPE_FLATTENED","subLabel":"Restaurants with"},{"label":"Cost for two","id":"costForTwo","selection":"SELECT_TYPE_MULTISELECT","facetInfo":[{"label":"Rs. 300-Rs. 600","id":"costForTwofacetquery3","analytics":{},"openFilter":true},{"label":"Greater than Rs. 600","id":"costForTwofacetquery4","analytics":{}},{"label":"Less than Rs. 300","id":"costForTwofacetquery5","analytics":{},"openFilter":true}],"viewType":"VIEW_TYPE_HALF_CARD","subLabel":"Filter by"}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget","layout":{"columns":4},"id":"restaurant_grid_listing","gridElements":{"infoWithStyle":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle","restaurants":[{"info":{"id":"806891","name":"Pizza Hut","cloudinaryImageId":"978358a0d0caba4f4555b8e2147b467d","locality":"Anna Salai","areaName":"Triplicane","costForTwo":"\u20B9350 for two","cuisines":["Pizzas"],"avgRating":4.3,"parentId":"721","avgRatingString":"4.3","totalRatingsString":"100+","sla":{"deliveryTime":35,"lastMileTravel":3,"serviceability":"SERVICEABLE","slaString":"35-40 mins","lastMileTravelString":"3.0 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-17 01:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"Rxawards/_CATEGORY-Pizza.png","description":"Delivery!"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"Delivery!","imageId":"Rxawards/_CATEGORY-Pizza.png"}}]},"textBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"50% OFF","subHeader":"UPTO \u20B9100"},"orderabilityCommunication":{"title":{},"subTitle":{},"message":{},"customIcon":{}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","isNewlyOnboarded":true,"restaurantOfferPresentationInfo":{}},"analytics":{"context":"seo-data-95f8cefc-9bfe-4bf5-b3d3-c13b01c3e890"},"cta":{"link":"https://www.swiggy.com/restaurants/pizza-hut-anna-salai-triplicane-chennai-806891","text":"RESTAURANT_MENU","type":"WEBLINK"},"widgetId":"collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"},{"info":{"id":"453068","name":"Chinese Wok","cloudinaryImageId":"e0839ff574213e6f35b3899ebf1fc597","locality":"Express Avenue","areaName":"Royapettah","costForTwo":"\u20B9250 for two","cuisines":["Chinese","Asian","Tibetan","Desserts"],"avgRating":4.2,"parentId":"61955","avgRatingString":"4.2","totalRatingsString":"1K+","sla":{"deliveryTime":47,"lastMileTravel":3.9,"serviceability":"SERVICEABLE","slaString":"45-50 mins","lastMileTravelString":"3.9 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 22:00:00","opened":true},"badges":{},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{},"textBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"ITEMS","subHeader":"AT \u20B9149"},"orderabilityCommunication":{"title":{},"subTitle":{},"message":{},"customIcon":{}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{"context":"seo-data-95f8cefc-9bfe-4bf5-b3d3-c13b01c3e890"},"cta":{"link":"https://www.swiggy.com/restaurants/chinese-wok-express-avenue-royapettah-chennai-453068","text":"RESTAURANT_MENU","type":"WEBLINK"},"widgetId":"collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"},{"info":{"id":"37972","name":"McDonald\'s","cloudinaryImageId":"RX_THUMBNAIL/IMAGES/VENDOR/2024/4/1/fe11ced6-89a3-4080-8610-3c743a3bb3f0_37972.jpg","locality":"Anna Salai","areaName":"Anna Salai","costForTwo":"\u20B9400 for two","cuisines":["Burgers","Beverages","Cafe","Desserts"],"avgRating":4.3,"parentId":"630","avgRatingString":"4.3","totalRatingsString":"10K+","sla":{"deliveryTime":33,"lastMileTravel":3.5,"serviceability":"SERVICEABLE","slaString":"30-35 mins","lastMileTravelString":"3.5 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 23:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"Rxawards/_CATEGORY-Burger.png","description":"Delivery!"}]},"isOpen":true,"aggregatedDiscountInfoV2":{},"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"Delivery!","imageId":"Rxawards/_CATEGORY-Burger.png"}}]},"textBased":{},"textExtendedBadges":{}}},"orderabilityCommunication":{"title":{},"subTitle":{},"message":{},"customIcon":{}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{"context":"seo-data-95f8cefc-9bfe-4bf5-b3d3-c13b01c3e890"},"cta":{"link":"https://www.swiggy.com/restaurants/mcdonalds-anna-salai-chennai-37972","text":"RESTAURANT_MENU","type":"WEBLINK"},"widgetId":"collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"},{"info":{"id":"708880","name":"KFC","cloudinaryImageId":"RX_THUMBNAIL/IMAGES/VENDOR/2024/4/17/8ba01310-e5b7-4a90-bef3-98a10bc91238_708880.JPG","locality":"Sydenhams Road","areaName":"Periyampet","costForTwo":"\u20B9400 for two","cuisines":["Burgers","Fast Food","Rolls & Wraps"],"avgRating":4.1,"parentId":"547","avgRatingString":"4.1","totalRatingsString":"1K+","sla":{"deliveryTime":35,"lastMileTravel":0.4,"serviceability":"SERVICEABLE","slaString":"25-35 mins","lastMileTravelString":"0.4 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-17 00:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"Rxawards/_CATEGORY-Burger.png","description":"Delivery!"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"Delivery!","imageId":"Rxawards/_CATEGORY-Burger.png"}}]},"textBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"ITEMS","subHeader":"AT \u20B9189"},"orderabilityCommunication":{"title":{},"subTitle":{},"message":{},"customIcon":{}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{"context":"seo-data-95f8cefc-9bfe-4bf5-b3d3-c13b01c3e890"},"cta":{"link":"https://www.swiggy.com/restaurants/kfc-sydenhams-road-periyampet-chennai-708880","text":"RESTAURANT_MENU","type":"WEBLINK"},"widgetId":"collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"},{"info":{"id":"18341","name":"Doveton Cafe","cloudinaryImageId":"dkds8g7ak8rneieejko6","locality":"Purasavakkam","areaName":"Purasavakkam","costForTwo":"\u20B9250 for two","cuisines":["South Indian","Biryani","North Indian","Chinese","Desserts","Beverages","Juices"],"avgRating":4.4,"parentId":"11076","avgRatingString":"4.4","totalRatingsString":"10K+","sla":{"deliveryTime":34,"lastMileTravel":2.5,"serviceability":"SERVICEABLE","slaString":"30-35 mins","lastMileTravelString":"2.5 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 23:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"pureveg","imageId":"v1695133679/badges/Pure_Veg111.png"}}]},"textBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"40% OFF","subHeader":"UPTO \u20B975","discountCalloutInfo":{"message":"Free Delivery","logoCtx":{"logo":"v1655895371/free_delivery_logo_hqipbo.png"}}},"orderabilityCommunication":{"title":{},"subTitle":{},"message":{},"customIcon":{}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{"context":"seo-data-95f8cefc-9bfe-4bf5-b3d3-c13b01c3e890"},"cta":{"link":"https://www.swiggy.com/restaurants/doveton-cafe-purasavakkam-chennai-18341","text":"RESTAURANT_MENU","type":"WEBLINK"},"widgetId":"collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"},{"info":{"id":"545672","name":"Kwality Walls Frozen Dessert and Ice Cream Shop","cloudinaryImageId":"kfxwva6gosuqfbtncvrt","locality":"Mumusamy Lane","areaName":"Egmore","costForTwo":"\u20B9200 for two","cuisines":["Desserts","Ice Cream","Ice Cream Cakes"],"avgRating":4.5,"veg":true,"parentId":"582","avgRatingString":"4.5","totalRatingsString":"100+","sla":{"deliveryTime":29,"lastMileTravel":2.2,"serviceability":"SERVICEABLE","slaString":"25-30 mins","lastMileTravelString":"2.2 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 22:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"pureveg","imageId":"v1695133679/badges/Pure_Veg111.png"}}]},"textBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"50% OFF","subHeader":"UPTO \u20B9100"},"orderabilityCommunication":{"title":{},"subTitle":{},"message":{},"customIcon":{}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{"context":"seo-data-95f8cefc-9bfe-4bf5-b3d3-c13b01c3e890"},"cta":{"link":"https://www.swiggy.com/restaurants/kwality-walls-frozen-dessert-and-ice-cream-shop-mumusamy-lane-egmore-chennai-545672","text":"RESTAURANT_MENU","type":"WEBLINK"},"widgetId":"collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"},{"info":{"id":"505126","name":"Ajnabee Sweets","cloudinaryImageId":"704865d6cd390e557f6307a4ea7d1796","locality":"Kilpauk","areaName":"Purasaiwakkam","costForTwo":"\u20B9300 for two","cuisines":["Sweets","Chaat","Fast Food"],"avgRating":4.5,"veg":true,"parentId":"2959","avgRatingString":"4.5","totalRatingsString":"1K+","sla":{"deliveryTime":36,"lastMileTravel":2.9,"serviceability":"SERVICEABLE","slaString":"35-40 mins","lastMileTravelString":"2.9 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 21:15:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"aggregatedDiscountInfoV2":{},"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"pureveg","imageId":"v1695133679/badges/Pure_Veg111.png"}}]},"textBased":{},"textExtendedBadges":{}}},"orderabilityCommunication":{"title":{},"subTitle":{},"message":{},"customIcon":{}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{"context":"seo-data-95f8cefc-9bfe-4bf5-b3d3-c13b01c3e890"},"cta":{"link":"https://www.swiggy.com/restaurants/ajnabee-sweets-kilpauk-purasaiwakkam-chennai-505126","text":"RESTAURANT_MENU","type":"WEBLINK"},"widgetId":"collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"},{"info":{"id":"43185","name":"Palmshore","cloudinaryImageId":"9ae730c95d13d6e26bf0bc9d69119a38","locality":"Egmore","areaName":"Egmore","costForTwo":"\u20B9400 for two","cuisines":["Arabian"],"avgRating":4.3,"parentId":"1689","avgRatingString":"4.3","totalRatingsString":"10K+","sla":{"deliveryTime":34,"lastMileTravel":2.5,"serviceability":"SERVICEABLE","slaString":"30-35 mins","lastMileTravelString":"2.5 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 23:15:00","opened":true},"badges":{"imageBadges":[{"imageId":"Rxawards/_CATEGORY-Coastal.png","description":"Delivery!"},{"imageId":"Rxawards/_CATEGORY-Mughlai.png","description":"Delivery!"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"Delivery!","imageId":"Rxawards/_CATEGORY-Coastal.png"}},{"attributes":{"description":"Delivery!","imageId":"Rxawards/_CATEGORY-Mughlai.png"}}]},"textBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"20% OFF","subHeader":"UPTO \u20B950"},"orderabilityCommunication":{"title":{},"subTitle":{},"message":{},"customIcon":{}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{"context":"seo-data-95f8cefc-9bfe-4bf5-b3d3-c13b01c3e890"},"cta":{"link":"https://www.swiggy.com/restaurants/palmshore-egmore-chennai-43185","text":"RESTAURANT_MENU","type":"WEBLINK"},"widgetId":"collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"},{"info":{"id":"14044","name":"Fruit Shop on Greams Road","cloudinaryImageId":"ufryw0c5fuxraq1zx1pq","locality":"Opposite Commissioner Office","areaName":"Egmore","costForTwo":"\u20B9150 for two","cuisines":["Juices","Beverages","Desserts"],"avgRating":4.5,"veg":true,"parentId":"401","avgRatingString":"4.5","totalRatingsString":"1K+","sla":{"deliveryTime":33,"lastMileTravel":1.8,"serviceability":"SERVICEABLE","slaString":"30-35 mins","lastMileTravelString":"1.8 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-16 23:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}],"textExtendedBadges":[{"iconId":"guiltfree/GF_Logo_android_3x","shortDescription":"options available","fontColor":"#7E808C"}]},"isOpen":true,"aggregatedDiscountInfoV2":{},"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"pureveg","imageId":"v1695133679/badges/Pure_Veg111.png"}}]},"textBased":{},"textExtendedBadges":{"badgeObject":[{"attributes":{"description":"","fontColor":"#7E808C","iconId":"guiltfree/GF_Logo_android_3x","shortDescription":"options available"}}]}}},"orderabilityCommunication":{"title":{},"subTitle":{},"message":{},"customIcon":{}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{"context":"seo-data-95f8cefc-9bfe-4bf5-b3d3-c13b01c3e890"},"cta":{"link":"https://www.swiggy.com/restaurants/fruit-shop-on-greams-road-opposite-commissioner-office-egmore-chennai-14044","text":"RESTAURANT_MENU","type":"WEBLINK"},"widgetId":"collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"}],"theme":"SeoRestaurantListingGridWidget"}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.seo.widgets.v1.ShowMoreButton","message":"Show More","id":"show_more_button"}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent","title":"Best Places to Eat Across Cities","brands":[{"text":"Best Restaurants in Bangalore","link":"https://www.swiggy.com/city/bangalore/best-restaurants"},{"text":"Best Restaurants in Pune","link":"https://www.swiggy.com/city/pune/best-restaurants"},{"text":"Best Restaurants in Mumbai","link":"https://www.swiggy.com/city/mumbai/best-restaurants"},{"text":"Best Restaurants in Delhi","link":"https://www.swiggy.com/city/delhi/best-restaurants"},{"text":"Best Restaurants in Hyderabad","link":"https://www.swiggy.com/city/hyderabad/best-restaurants"},{"text":"Best Restaurants in Kolkata","link":"https://www.swiggy.com/city/kolkata/best-restaurants"},{"text":"Best Restaurants in Chennai","link":"https://www.swiggy.com/city/chennai/best-restaurants"},{"text":"Best Restaurants in Chandigarh","link":"https://www.swiggy.com/city/chandigarh/best-restaurants"},{"text":"Best Restaurants in Ahmedabad","link":"https://www.swiggy.com/city/ahmedabad/best-restaurants"},{"text":"Best Restaurants in Jaipur","link":"https://www.swiggy.com/city/jaipur/best-restaurants"},{"text":"Best Restaurants in Nagpur","link":"https://www.swiggy.com/city/nagpur/best-restaurants"},{"text":"Best Restaurants in Bhubaneswar","link":"https://www.swiggy.com/city/bhubaneswar/best-restaurants"},{"text":"Best Restaurants in Kochi","link":"https://www.swiggy.com/city/kochi/best-restaurants"},{"text":"Best Restaurants in Surat","link":"https://www.swiggy.com/city/surat/best-restaurants"},{"text":"Best Restaurants in Dehradun","link":"https://www.swiggy.com/city/dehradun/best-restaurants"},{"text":"Best Restaurants in Ludhiana","link":"https://www.swiggy.com/city/ludhiana/best-restaurants"},{"text":"Best Restaurants in Patna","link":"https://www.swiggy.com/city/patna/best-restaurants"},{"text":"Best Restaurants in Mangaluru","link":"https://www.swiggy.com/city/mangaluru/best-restaurants"},{"text":"Best Restaurants in Bhopal","link":"https://www.swiggy.com/city/bhopal/best-restaurants"},{"text":"Best Restaurants in Gurgaon","link":"https://www.swiggy.com/city/gurgaon/best-restaurants"},{"text":"Best Restaurants in Coimbatore","link":"https://www.swiggy.com/city/coimbatore/best-restaurants"},{"text":"Best Restaurants in Agra","link":"https://www.swiggy.com/city/agra/best-restaurants"},{"text":"Best Restaurants in Noida","link":"https://www.swiggy.com/city/noida/best-restaurants"},{"text":"Best Restaurants in Vijayawada","link":"https://www.swiggy.com/city/vijayawada/best-restaurants"},{"text":"Best Restaurants in Guwahati","link":"https://www.swiggy.com/city/guwahati/best-restaurants"},{"text":"Best Restaurants in Mysore","link":"https://www.swiggy.com/city/mysore/best-restaurants"},{"text":"Best Restaurants in Pondicherry","link":"https://www.swiggy.com/city/pondicherry/best-restaurants"},{"text":"Best Restaurants in Thiruvananthapuram","link":"https://www.swiggy.com/city/thiruvananthapuram/best-restaurants"},{"text":"Best Restaurants in Ranchi","link":"https://www.swiggy.com/city/ranchi/best-restaurants"},{"text":"Best Restaurants in Vizag","link":"https://www.swiggy.com/city/vizag/best-restaurants"},{"text":"Best Restaurants in Udaipur","link":"https://www.swiggy.com/city/udaipur/best-restaurants"},{"text":"Best Restaurants in Vadodara","link":"https://www.swiggy.com/city/vadodara/best-restaurants"}],"id":"restaurant_near_me_links"}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent","title":"Best Cuisines Near Me","brands":[{"text":"Chinese Restaurant Near Me","link":"https://www.swiggy.com/chinese-restaurants-near-me"},{"text":"South Indian Restaurant Near Me","link":"https://www.swiggy.com/south-indian-restaurants-near-me"},{"text":"Indian Restaurant Near Me","link":"https://www.swiggy.com/indian-restaurants-near-me"},{"text":"Kerala Restaurant Near Me","link":"https://www.swiggy.com/kerala-restaurants-near-me"},{"text":"Korean Restaurant Near Me","link":"https://www.swiggy.com/korean-restaurants-near-me"},{"text":"North Indian Restaurant Near Me","link":"https://www.swiggy.com/north-indian-restaurants-near-me"},{"text":"Seafood Restaurant Near Me","link":"https://www.swiggy.com/seafood-restaurants-near-me"},{"text":"Bengali Restaurant Near Me","link":"https://www.swiggy.com/bengali-restaurants-near-me"},{"text":"Punjabi Restaurant Near Me","link":"https://www.swiggy.com/punjabi-restaurants-near-me"},{"text":"Italian Restaurant Near Me","link":"https://www.swiggy.com/italian-restaurants-near-me"},{"text":"Andhra Restaurant Near Me","link":"https://www.swiggy.com/andhra-restaurants-near-me"},{"text":"Biryani Restaurant Near Me","link":"https://www.swiggy.com/biryani-restaurants-near-me"},{"text":"Japanese Restaurant Near Me","link":"https://www.swiggy.com/japanese-restaurants-near-me"},{"text":"Arabian Restaurant Near Me","link":"https://www.swiggy.com/arabian-restaurants-near-me"},{"text":"Fast Food Restaurant Near Me","link":"https://www.swiggy.com/fast-food-restaurants-near-me"},{"text":"Jain Restaurant Near Me","link":"https://www.swiggy.com/jain-restaurants-near-me"},{"text":"Gujarati Restaurant Near Me","link":"https://www.swiggy.com/gujarati-restaurants-near-me"},{"text":"Thai Restaurant Near Me","link":"https://www.swiggy.com/thai-restaurants-near-me"},{"text":"Pizzas Restaurant Near Me","link":"https://www.swiggy.com/pizzas-restaurants-near-me"},{"text":"Asian Restaurant Near Me","link":"https://www.swiggy.com/asian-restaurants-near-me"},{"text":"Cafe Restaurant Near Me","link":"https://www.swiggy.com/cafe-restaurants-near-me"},{"text":"Continental Restaurant Near Me","link":"https://www.swiggy.com/continental-restaurants-near-me"},{"text":"Mexican Restaurant Near Me","link":"https://www.swiggy.com/mexican-restaurants-near-me"},{"text":"Mughlai Restaurant Near Me","link":"https://www.swiggy.com/mughlai-restaurants-near-me"},{"text":"Sushi Restaurant Near Me","link":"https://www.swiggy.com/sushi-restaurants-near-me"},{"text":"Mangalorean Restaurant Near Me","link":"https://www.swiggy.com/mangalorean-restaurants-near-me"},{"text":"Tibetan Restaurant Near Me","link":"https://www.swiggy.com/tibetan-restaurants-near-me"},{"text":"Barbecue Restaurant Near Me","link":"https://www.swiggy.com/barbecue-restaurants-near-me"},{"text":"Maharashtrian Restaurant Near Me","link":"https://www.swiggy.com/maharashtrian-restaurants-near-me"},{"text":"Nepalese Restaurant Near Me","link":"https://www.swiggy.com/nepalese-restaurants-near-me"},{"text":"Rajasthani Restaurant Near Me","link":"https://www.swiggy.com/rajasthani-restaurants-near-me"},{"text":"Turkish Restaurant Near Me","link":"https://www.swiggy.com/turkish-restaurants-near-me"}],"id":"restaurant_near_me_links"}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent","title":"Explore Every Restaurants Near Me","brands":[{"text":"Explore Restaurants Near Me","link":"https://www.swiggy.com/restaurants-near-me"},{"text":"Explore Top Rated Restaurants Near Me","link":"https://www.swiggy.com/best-restaurants-near-me"}],"id":"restaurant_near_me_links"}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.seo.widgets.v1.AppInstallLinks","title":"For better experience,download the Swiggy app now","androidAppImage":"portal/m/play_store.png","androidAppLink":"https://play.google.com/store/apps/details?id=in.swiggy.android&referrer=utm_source%3Dswiggy%26utm_medium%3Dheader","iosAppImage":"portal/m/app_store.png","iosAppLink":"https://itunes.apple.com/in/app/id989540920?referrer=utm_source%3Dswiggy%26utm_medium%3Dhomepage","id":"app_install_links"}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.seo.widgets.v1.FooterContent","cities":[{"text":"Bangalore","link":"https://www.swiggy.com/city/bangalore"},{"text":"Gurgaon","link":"https://www.swiggy.com/city/gurgaon"},{"text":"Hyderabad","link":"https://www.swiggy.com/city/hyderabad"},{"text":"Delhi","link":"https://www.swiggy.com/city/delhi"},{"text":"Mumbai","link":"https://www.swiggy.com/city/mumbai"},{"text":"Pune","link":"https://www.swiggy.com/city/pune"},{"text":"Kolkata","link":"https://www.swiggy.com/city/kolkata"},{"text":"Chennai","link":"https://www.swiggy.com/city/chennai"},{"text":"Ahmedabad","link":"https://www.swiggy.com/city/ahmedabad"},{"text":"Chandigarh","link":"https://www.swiggy.com/city/chandigarh"},{"text":"Jaipur","link":"https://www.swiggy.com/city/jaipur"},{"text":"Kochi","link":"https://www.swiggy.com/city/kochi"},{"text":"Coimbatore","link":"https://www.swiggy.com/city/coimbatore"},{"text":"Lucknow","link":"https://www.swiggy.com/city/lucknow"},{"text":"Nagpur","link":"https://www.swiggy.com/city/nagpur"},{"text":"Vadodara","link":"https://www.swiggy.com/city/vadodara"},{"text":"Indore","link":"https://www.swiggy.com/city/indore"},{"text":"Guwahati","link":"https://www.swiggy.com/city/guwahati"},{"text":"Vizag","link":"https://www.swiggy.com/city/vizag"},{"text":"Surat","link":"https://www.swiggy.com/city/surat"},{"text":"Dehradun","link":"https://www.swiggy.com/city/dehradun"},{"text":"Noida","link":"https://www.swiggy.com/city/noida"},{"text":"Ludhiana","link":"https://www.swiggy.com/city/ludhiana"},{"text":"Trichy","link":"https://www.swiggy.com/city/trichy"},{"text":"Vijayawada","link":"https://www.swiggy.com/city/vijayawada"},{"text":"Kanpur","link":"https://www.swiggy.com/city/kanpur"},{"text":"Mysore","link":"https://www.swiggy.com/city/mysore"},{"text":"Nashik","link":"https://www.swiggy.com/city/nashik"},{"text":"Udaipur","link":"https://www.swiggy.com/city/udaipur"},{"text":"Pondicherry","link":"https://www.swiggy.com/city/pondicherry"},{"text":"Agra","link":"https://www.swiggy.com/city/agra"},{"text":"Aurangabad","link":"https://www.swiggy.com/city/aurangabad"},{"text":"Jalandhar","link":"https://www.swiggy.com/city/jalandhar"},{"text":"Kota","link":"https://www.swiggy.com/city/kota"},{"text":"Madurai","link":"https://www.swiggy.com/city/madurai"},{"text":"Allahabad","link":"https://www.swiggy.com/city/allahabad"},{"text":"Manipal","link":"https://www.swiggy.com/city/manipal"},{"text":"Amritsar","link":"https://www.swiggy.com/city/amritsar"},{"text":"Bareilly","link":"https://www.swiggy.com/city/bareilly"},{"text":"Meerut","link":"https://www.swiggy.com/city/meerut"},{"text":"Bhopal","link":"https://www.swiggy.com/city/bhopal"},{"text":"Ooty","link":"https://www.swiggy.com/city/ooty"},{"text":"Bhubaneswar","link":"https://www.swiggy.com/city/bhubaneswar"},{"text":"Raipur","link":"https://www.swiggy.com/city/raipur"},{"text":"Bikaner","link":"https://www.swiggy.com/city/bikaner"},{"text":"Rajkot","link":"https://www.swiggy.com/city/rajkot"},{"text":"Kozhikode","link":"https://www.swiggy.com/city/kozhikode"},{"text":"Central Goa","link":"https://www.swiggy.com/city/central-goa"},{"text":"Sirsa","link":"https://www.swiggy.com/city/sirsa"},{"text":"Gwalior","link":"https://www.swiggy.com/city/gwalior"},{"text":"Thrissur","link":"https://www.swiggy.com/city/thrissur"},{"text":"Kharagpur","link":"https://www.swiggy.com/city/kharagpur"},{"text":"Tirupati","link":"https://www.swiggy.com/city/tirupati"},{"text":"Tirupur","link":"https://www.swiggy.com/city/tirupur"},{"text":"Vellore","link":"https://www.swiggy.com/city/vellore"},{"text":"Thiruvananthapuram","link":"https://www.swiggy.com/city/thiruvananthapuram"},{"text":"Warangal","link":"https://www.swiggy.com/city/warangal"},{"text":"Varanasi","link":"https://www.swiggy.com/city/varanasi"},{"text":"Mangaluru","link":"https://www.swiggy.com/city/mangaluru"},{"text":"Patna","link":"https://www.swiggy.com/city/patna"},{"text":"Ranchi","link":"https://www.swiggy.com/city/ranchi"},{"text":"Faridabad","link":"https://www.swiggy.com/city/faridabad"},{"text":"Guntur","link":"https://www.swiggy.com/city/guntur"},{"text":"Ujjain","link":"https://www.swiggy.com/city/ujjain"},{"text":"Patiala","link":"https://www.swiggy.com/city/patiala"},{"text":"Karnal","link":"https://www.swiggy.com/city/karnal"},{"text":"Kakinada","link":"https://www.swiggy.com/city/kakinada"},{"text":"Rajahmundry","link":"https://www.swiggy.com/city/rajahmundry"},{"text":"Bilaspur","link":"https://www.swiggy.com/city/bilaspur"},{"text":"Bhilai","link":"https://www.swiggy.com/city/bhilai"},{"text":"Anand","link":"https://www.swiggy.com/city/anand"},{"text":"Bhavnagar","link":"https://www.swiggy.com/city/bhavnagar"},{"text":"Jammu","link":"https://www.swiggy.com/city/jammu"},{"text":"Muktsar","link":"https://www.swiggy.com/city/muktsar"},{"text":"Panipat","link":"https://www.swiggy.com/city/panipat"},{"text":"Dhanbad","link":"https://www.swiggy.com/city/dhanbad"},{"text":"Hubli","link":"https://www.swiggy.com/city/hubli"},{"text":"Belgaum","link":"https://www.swiggy.com/city/belgaum"},{"text":"Jabalpur","link":"https://www.swiggy.com/city/jabalpur"},{"text":"Kolhapur","link":"https://www.swiggy.com/city/kolhapur"},{"text":"Solapur","link":"https://www.swiggy.com/city/solapur"},{"text":"Shillong","link":"https://www.swiggy.com/city/shillong"},{"text":"Cuttack","link":"https://www.swiggy.com/city/cuttack"},{"text":"Aligarh","link":"https://www.swiggy.com/city/aligarh"},{"text":"Salem","link":"https://www.swiggy.com/city/salem"},{"text":"Jodhpur","link":"https://www.swiggy.com/city/jodhpur"},{"text":"Ajmer","link":"https://www.swiggy.com/city/ajmer"},{"text":"Jhansi","link":"https://www.swiggy.com/city/jhansi"},{"text":"Gorakhpur","link":"https://www.swiggy.com/city/gorakhpur"},{"text":"Thanjavur","link":"https://www.swiggy.com/city/thanjavur"},{"text":"Erode","link":"https://www.swiggy.com/city/erode"},{"text":"Nellore","link":"https://www.swiggy.com/city/nellore"},{"text":"Rourkela","link":"https://www.swiggy.com/city/rourkela"},{"text":"Anantapur","link":"https://www.swiggy.com/city/anantapur"},{"text":"Kurnool","link":"https://www.swiggy.com/city/kurnool"},{"text":"Ahmednagar","link":"https://www.swiggy.com/city/ahmednagar"},{"text":"Phagwara","link":"https://www.swiggy.com/city/phagwara"},{"text":"Ambala","link":"https://www.swiggy.com/city/ambala"},{"text":"Ballari","link":"https://www.swiggy.com/city/ballari"},{"text":"Saharanpur","link":"https://www.swiggy.com/city/saharanpur"},{"text":"Tirunelveli","link":"https://www.swiggy.com/city/tirunelveli"},{"text":"Bathinda","link":"https://www.swiggy.com/city/bathinda"},{"text":"Mathura","link":"https://www.swiggy.com/city/mathura"},{"text":"Haridwar","link":"https://www.swiggy.com/city/haridwar"},{"text":"Ratnagiri","link":"https://www.swiggy.com/city/ratnagiri"},{"text":"Sangli","link":"https://www.swiggy.com/city/sangli"},{"text":"Amravati","link":"https://www.swiggy.com/city/amravati"},{"text":"Rishikesh","link":"https://www.swiggy.com/city/rishikesh"},{"text":"Nagercoil","link":"https://www.swiggy.com/city/nagercoil"},{"text":"KanyaKumari","link":"https://www.swiggy.com/city/kanyakumari"},{"text":"Kadapa","link":"https://www.swiggy.com/city/kadapa"},{"text":"Nizamabad","link":"https://www.swiggy.com/city/nizamabad"},{"text":"Shivamogga","link":"https://www.swiggy.com/city/shivamogga"},{"text":"Davanagere","link":"https://www.swiggy.com/city/davanagere"},{"text":"Roorkee","link":"https://www.swiggy.com/city/roorkee"},{"text":"Nanded","link":"https://www.swiggy.com/city/nanded"},{"text":"Rewa","link":"https://www.swiggy.com/city/rewa"},{"text":"Satna","link":"https://www.swiggy.com/city/satna"},{"text":"Muzaffarpur","link":"https://www.swiggy.com/city/muzaffarpur"},{"text":"Valsad","link":"https://www.swiggy.com/city/valsad"},{"text":"Vapi","link":"https://www.swiggy.com/city/vapi"},{"text":"Chhapra","link":"https://www.swiggy.com/city/chhapra"},{"text":"Dharamshala","link":"https://www.swiggy.com/city/dharamshala"},{"text":"Kollam","link":"https://www.swiggy.com/city/kollam"},{"text":"Silchar","link":"https://www.swiggy.com/city/silchar"},{"text":"Alappuzha","link":"https://www.swiggy.com/city/alappuzha"},{"text":"Sonipat","link":"https://www.swiggy.com/city/sonipat"},{"text":"Rohtak","link":"https://www.swiggy.com/city/rohtak"},{"text":"Mehsana","link":"https://www.swiggy.com/city/mehsana"},{"text":"Kullu","link":"https://www.swiggy.com/city/kullu"},{"text":"Dhule","link":"https://www.swiggy.com/city/dhule"},{"text":"Dharwad","link":"https://www.swiggy.com/city/dharwad"},{"text":"Latur","link":"https://www.swiggy.com/city/latur"},{"text":"Vizianagaram","link":"https://www.swiggy.com/city/vizianagaram"},{"text":"Khammam","link":"https://www.swiggy.com/city/khammam"},{"text":"Hampi","link":"https://www.swiggy.com/city/hampi"},{"text":"Nainital","link":"https://www.swiggy.com/city/nainital"},{"text":"Akola","link":"https://www.swiggy.com/city/akola"},{"text":"Kalaburagi","link":"https://www.swiggy.com/city/kalaburagi"},{"text":"Gaya","link":"https://www.swiggy.com/city/gaya"},{"text":"Muzaffarnagar","link":"https://www.swiggy.com/city/muzaffarnagar"},{"text":"Dewas","link":"https://www.swiggy.com/city/dewas"},{"text":"Korba","link":"https://www.swiggy.com/city/korba"},{"text":"Mussoorie","link":"https://www.swiggy.com/city/mussoorie"},{"text":"Jalgaon","link":"https://www.swiggy.com/city/jalgaon"},{"text":"Yamuna Nagar","link":"https://www.swiggy.com/city/yamuna-nagar"},{"text":"Bhagalpur","link":"https://www.swiggy.com/city/bhagalpur"},{"text":"Hapur","link":"https://www.swiggy.com/city/hapur"},{"text":"Morena","link":"https://www.swiggy.com/city/morena"},{"text":"Hassan","link":"https://www.swiggy.com/city/hassan"},{"text":"Hisar","link":"https://www.swiggy.com/city/hisar"},{"text":"Godhra","link":"https://www.swiggy.com/city/godhra"},{"text":"Kolar ","link":"https://www.swiggy.com/city/kolar"},{"text":"Rampur","link":"https://www.swiggy.com/city/rampur"},{"text":"Sitapur","link":"https://www.swiggy.com/city/sitapur"},{"text":"Etawah","link":"https://www.swiggy.com/city/etawah"},{"text":"Porbandar","link":"https://www.swiggy.com/city/porbandar"},{"text":"Nadiad","link":"https://www.swiggy.com/city/nadiad"},{"text":"Sagar","link":"https://www.swiggy.com/city/sagar"},{"text":"Morbi","link":"https://www.swiggy.com/city/morbi"},{"text":"Chhindwara","link":"https://www.swiggy.com/city/chhindwara"},{"text":"Tumakuru","link":"https://www.swiggy.com/city/tumakuru"},{"text":"Singrauli","link":"https://www.swiggy.com/city/singrauli"},{"text":"Thoothukudi","link":"https://www.swiggy.com/city/thoothukudi"},{"text":"Katni","link":"https://www.swiggy.com/city/katni"},{"text":"Khandwa","link":"https://www.swiggy.com/city/khandwa"},{"text":"Eluru","link":"https://www.swiggy.com/city/eluru"},{"text":"Malappuram","link":"https://www.swiggy.com/city/malappuram"},{"text":"Dibrugarh","link":"https://www.swiggy.com/city/dibrugarh"},{"text":"Deoghar","link":"https://www.swiggy.com/city/deoghar"},{"text":"Khanna","link":"https://www.swiggy.com/city/khanna"},{"text":"Bidar","link":"https://www.swiggy.com/city/bidar"},{"text":"Madikeri","link":"https://www.swiggy.com/city/madikeri"},{"text":"Haldwani","link":"https://www.swiggy.com/city/haldwani"},{"text":"Farrukhabad","link":"https://www.swiggy.com/city/farrukhabad"},{"text":"Malegaon","link":"https://www.swiggy.com/city/malegaon"},{"text":"Dindigul","link":"https://www.swiggy.com/city/dindigul"},{"text":"Shahjahanpur","link":"https://www.swiggy.com/city/shahjahanpur"},{"text":"Beed","link":"https://www.swiggy.com/city/beed"},{"text":"Junagadh","link":"https://www.swiggy.com/city/junagadh"},{"text":"Asansol","link":"https://www.swiggy.com/city/asansol"},{"text":"Beawar","link":"https://www.swiggy.com/city/beawar"},{"text":"Kishangarh","link":"https://www.swiggy.com/city/kishangarh"},{"text":"Parbhani","link":"https://www.swiggy.com/city/parbhani"},{"text":"Gondia","link":"https://www.swiggy.com/city/gondia"},{"text":"Ichalkaranji","link":"https://www.swiggy.com/city/ichalkaranji"},{"text":"Jalna","link":"https://www.swiggy.com/city/jalna"},{"text":"Yavatmal","link":"https://www.swiggy.com/city/yavatmal"},{"text":"Shivpuri","link":"https://www.swiggy.com/city/shivpuri"},{"text":"Moga","link":"https://www.swiggy.com/city/moga"},{"text":"Abohar","link":"https://www.swiggy.com/city/abohar"},{"text":"Adoni","link":"https://www.swiggy.com/city/adoni"},{"text":"Madanapalle","link":"https://www.swiggy.com/city/madanapalle"},{"text":"Tiruvannamalai","link":"https://www.swiggy.com/city/tiruvannamalai"},{"text":"Satara","link":"https://www.swiggy.com/city/satara"},{"text":"Ambur","link":"https://www.swiggy.com/city/ambur"},{"text":"Karimnagar","link":"https://www.swiggy.com/city/karimnagar"},{"text":"Ratlam","link":"https://www.swiggy.com/city/ratlam"},{"text":"Moradabad","link":"https://www.swiggy.com/city/moradabad"},{"text":"Machilipatnam","link":"https://www.swiggy.com/city/machilipatnam"},{"text":"Ongole","link":"https://www.swiggy.com/city/ongole"},{"text":"Kottayam","link":"https://www.swiggy.com/city/kottayam"},{"text":"Darbhanga","link":"https://www.swiggy.com/city/darbhanga"},{"text":"Kurukshetra","link":"https://www.swiggy.com/city/kurukshetra"},{"text":"Unnao","link":"https://www.swiggy.com/city/unnao"},{"text":"Bulandshahr","link":"https://www.swiggy.com/city/bulandshahr"},{"text":"Durgapur","link":"https://www.swiggy.com/city/durgapur"},{"text":"Siliguri","link":"https://www.swiggy.com/city/siliguri"},{"text":"Pali","link":"https://www.swiggy.com/city/pali"},{"text":"Tadepalligudem","link":"https://www.swiggy.com/city/tadepalligudem"},{"text":"Ramagundam","link":"https://www.swiggy.com/city/ramagundam"},{"text":"Mahbubnagar","link":"https://www.swiggy.com/city/mahbubnagar"},{"text":"Bhiwani","link":"https://www.swiggy.com/city/bhiwani"},{"text":"Cuddalore","link":"https://www.swiggy.com/city/cuddalore"},{"text":"Kaithal","link":"https://www.swiggy.com/city/kaithal"},{"text":"Jagtial","link":"https://www.swiggy.com/city/jagtial"},{"text":"Palakkad","link":"https://www.swiggy.com/city/palakkad"},{"text":"Guna","link":"https://www.swiggy.com/city/guna"},{"text":"Kumbakonam","link":"https://www.swiggy.com/city/kumbakonam"},{"text":"Maunath Bhanjan","link":"https://www.swiggy.com/city/maunath-bhanjan"},{"text":"Baripada","link":"https://www.swiggy.com/city/baripada"},{"text":"Orai","link":"https://www.swiggy.com/city/orai"},{"text":"Bhadrak","link":"https://www.swiggy.com/city/bhadrak"},{"text":"Batala","link":"https://www.swiggy.com/city/batala"},{"text":"Firozpur","link":"https://www.swiggy.com/city/firozpur"},{"text":"Barnala","link":"https://www.swiggy.com/city/barnala"},{"text":"Raigarh","link":"https://www.swiggy.com/city/raigarh"},{"text":"Nagaon","link":"https://www.swiggy.com/city/nagaon"},{"text":"Mainpuri","link":"https://www.swiggy.com/city/mainpuri"},{"text":"Balurghat","link":"https://www.swiggy.com/city/balurghat"},{"text":"Giridih","link":"https://www.swiggy.com/city/giridih"},{"text":"Ghazipur","link":"https://www.swiggy.com/city/ghazipur"},{"text":"Jagdalpur","link":"https://www.swiggy.com/city/jagdalpur"},{"text":"Vidisha","link":"https://www.swiggy.com/city/vidisha"},{"text":"Dimapur","link":"https://www.swiggy.com/city/dimapur"},{"text":"Shikohabad","link":"https://www.swiggy.com/city/shikohabad"},{"text":"Imphal","link":"https://www.swiggy.com/city/imphal"},{"text":"Lakhimpur","link":"https://www.swiggy.com/city/lakhimpur"},{"text":"Rudrapur","link":"https://www.swiggy.com/city/rudrapur"},{"text":"Ambikapur","link":"https://www.swiggy.com/city/ambikapur"},{"text":"Rae Bareli","link":"https://www.swiggy.com/city/rae-bareli"},{"text":"Tinsukia","link":"https://www.swiggy.com/city/tinsukia"},{"text":"Rajapalayam","link":"https://www.swiggy.com/city/rajapalayam"},{"text":"Rajnandgaon","link":"https://www.swiggy.com/city/rajnandgaon"},{"text":"Kashipur","link":"https://www.swiggy.com/city/kashipur"},{"text":"Ranibennur","link":"https://www.swiggy.com/city/ranibennur"},{"text":"Burhanpur","link":"https://www.swiggy.com/city/burhanpur"},{"text":"Bhadravati","link":"https://www.swiggy.com/city/bhadravati"},{"text":"Chittoor","link":"https://www.swiggy.com/city/chittoor"},{"text":"Pudukkottai","link":"https://www.swiggy.com/city/pudukkottai"},{"text":"Hardoi","link":"https://www.swiggy.com/city/hardoi"},{"text":"Basti","link":"https://www.swiggy.com/city/basti"},{"text":"Karaikkudi","link":"https://www.swiggy.com/city/karaikkudi"},{"text":"Lalitpur","link":"https://www.swiggy.com/city/lalitpur"},{"text":"Hospet","link":"https://www.swiggy.com/city/hospet"},{"text":"Budaun","link":"https://www.swiggy.com/city/budaun"},{"text":"Neemuch","link":"https://www.swiggy.com/city/neemuch"},{"text":"Pilibhit","link":"https://www.swiggy.com/city/pilibhit"},{"text":"Barshi","link":"https://www.swiggy.com/city/barshi"},{"text":"Sri Ganganagar","link":"https://www.swiggy.com/city/sri-ganganagar"},{"text":"Wardha","link":"https://www.swiggy.com/city/wardha"},{"text":"Sehore","link":"https://www.swiggy.com/city/sehore"},{"text":"Bhimavaram","link":"https://www.swiggy.com/city/bhimavaram"},{"text":"Hanumangarh","link":"https://www.swiggy.com/city/hanumangarh"},{"text":"Pathankot","link":"https://www.swiggy.com/city/pathankot"},{"text":"Puri","link":"https://www.swiggy.com/city/puri"},{"text":"Fatehpur","link":"https://www.swiggy.com/city/fatehpur"},{"text":"Surendranagar Dudhrej","link":"https://www.swiggy.com/city/surendranagar-dudhrej"},{"text":"Jamnagar","link":"https://www.swiggy.com/city/jamnagar"},{"text":"Bhuj","link":"https://www.swiggy.com/city/bhuj"},{"text":"Gandhidham","link":"https://www.swiggy.com/city/gandhidham"},{"text":"Bharuch","link":"https://www.swiggy.com/city/bharuch"},{"text":"Navsari","link":"https://www.swiggy.com/city/navsari"},{"text":"Amreli","link":"https://www.swiggy.com/city/amreli"},{"text":"Palanpur","link":"https://www.swiggy.com/city/palanpur"},{"text":"Bhilwara","link":"https://www.swiggy.com/city/bhilwara"},{"text":"Suratgarh","link":"https://www.swiggy.com/city/suratgarh"},{"text":"Sikar","link":"https://www.swiggy.com/city/sikar"},{"text":"Churu","link":"https://www.swiggy.com/city/churu"},{"text":"Alwar","link":"https://www.swiggy.com/city/alwar"},{"text":"Bhiwadi","link":"https://www.swiggy.com/city/bhiwadi"},{"text":"Bharatpur","link":"https://www.swiggy.com/city/bharatpur"},{"text":"Mount Abu","link":"https://www.swiggy.com/city/mount-abu"},{"text":"Bundi","link":"https://www.swiggy.com/city/bundi"},{"text":"Sawai Madhopur","link":"https://www.swiggy.com/city/sawai-madhopur"},{"text":"Purulia","link":"https://www.swiggy.com/city/purulia"},{"text":"Bardhaman","link":"https://www.swiggy.com/city/bardhaman"},{"text":"Raniganj","link":"https://www.swiggy.com/city/raniganj"},{"text":"Darjeeling","link":"https://www.swiggy.com/city/darjeeling"},{"text":"Jalpaiguri","link":"https://www.swiggy.com/city/jalpaiguri"},{"text":"Chittorgarh","link":"https://www.swiggy.com/city/chittorgarh"},{"text":"Dholpur","link":"https://www.swiggy.com/city/dholpur"},{"text":"Uluberia","link":"https://www.swiggy.com/city/uluberia"},{"text":"Nabadwip","link":"https://www.swiggy.com/city/nabadwip"},{"text":"Bongaon","link":"https://www.swiggy.com/city/bongaon"},{"text":"Kanchrapara","link":"https://www.swiggy.com/city/kanchrapara"},{"text":"Habra","link":"https://www.swiggy.com/city/habra"},{"text":"Firozabad","link":"https://www.swiggy.com/city/firozabad"},{"text":"Nalgonda","link":"https://www.swiggy.com/city/nalgonda"},{"text":"Chandrapur","link":"https://www.swiggy.com/city/chandrapur"},{"text":"Bijapur","link":"https://www.swiggy.com/city/bijapur"},{"text":"Bhusawal","link":"https://www.swiggy.com/city/bhusawal"},{"text":"Raichur","link":"https://www.swiggy.com/city/raichur"},{"text":"Bahraich","link":"https://www.swiggy.com/city/bahraich"},{"text":"Azamgarh","link":"https://www.swiggy.com/city/azamgarh"},{"text":"Bahadurgarh","link":"https://www.swiggy.com/city/bahadurgarh"},{"text":"Jind","link":"https://www.swiggy.com/city/jind"},{"text":"Rewari","link":"https://www.swiggy.com/city/rewari"},{"text":"Palwal","link":"https://www.swiggy.com/city/palwal"},{"text":"Hathras","link":"https://www.swiggy.com/city/hathras"},{"text":"Sambalpur","link":"https://www.swiggy.com/city/sambalpur"},{"text":"Banda","link":"https://www.swiggy.com/city/banda"},{"text":"Hoshiarpur","link":"https://www.swiggy.com/city/hoshiarpur"},{"text":"Faridkot","link":"https://www.swiggy.com/city/faridkot"},{"text":"Mandsaur","link":"https://www.swiggy.com/city/mandsaur"},{"text":"Suryapet","link":"https://www.swiggy.com/city/suryapet"},{"text":"Adilabad","link":"https://www.swiggy.com/city/adilabad"},{"text":"Narasaraopet","link":"https://www.swiggy.com/city/narasaraopet"},{"text":"Faizabad","link":"https://www.swiggy.com/city/faizabad"},{"text":"Tadpatri","link":"https://www.swiggy.com/city/tadpatri"},{"text":"Gonda","link":"https://www.swiggy.com/city/gonda"},{"text":"Mughalsarai","link":"https://www.swiggy.com/city/mughalsarai"},{"text":"Medinipur","link":"https://www.swiggy.com/city/medinipur"},{"text":"Nagda","link":"https://www.swiggy.com/city/nagda"},{"text":"Raiganj","link":"https://www.swiggy.com/city/raiganj"},{"text":"Deoria City","link":"https://www.swiggy.com/city/deoria-city"},{"text":"Sultanpur","link":"https://www.swiggy.com/city/sultanpur"},{"text":"Shamli","link":"https://www.swiggy.com/city/shamli"},{"text":"Krishnanagar","link":"https://www.swiggy.com/city/krishnanagar"},{"text":"Ballia","link":"https://www.swiggy.com/city/ballia"},{"text":"Guntakal","link":"https://www.swiggy.com/city/guntakal"},{"text":"Miryalaguda","link":"https://www.swiggy.com/city/miryalaguda"},{"text":"Etah","link":"https://www.swiggy.com/city/etah"},{"text":"Berhampore","link":"https://www.swiggy.com/city/berhampore"},{"text":"Gudivada","link":"https://www.swiggy.com/city/gudivada"},{"text":"Haldia","link":"https://www.swiggy.com/city/haldia"},{"text":"Santipur","link":"https://www.swiggy.com/city/santipur"},{"text":"Basirhat","link":"https://www.swiggy.com/city/basirhat"},{"text":"Udgir","link":"https://www.swiggy.com/city/udgir"},{"text":"Proddatur","link":"https://www.swiggy.com/city/proddatur"},{"text":"Nagapattinam","link":"https://www.swiggy.com/city/nagapattinam"},{"text":"Chikmagalur","link":"https://www.swiggy.com/city/chikmagalur"},{"text":"Chandausi","link":"https://www.swiggy.com/city/chandausi"},{"text":"Bhind","link":"https://www.swiggy.com/city/bhind"},{"text":"Mandya","link":"https://www.swiggy.com/city/mandya"},{"text":"Bagalkot","link":"https://www.swiggy.com/city/bagalkot"},{"text":"Nandurbar","link":"https://www.swiggy.com/city/nandurbar"},{"text":"Chitradurga","link":"https://www.swiggy.com/city/chitradurga"},{"text":"Osmanabad","link":"https://www.swiggy.com/city/osmanabad"},{"text":"Modinagar","link":"https://www.swiggy.com/city/modinagar"},{"text":"Gadag-Betigeri","link":"https://www.swiggy.com/city/gadag-betigeri"},{"text":"Hoshangabad","link":"https://www.swiggy.com/city/hoshangabad"},{"text":"Jaunpur","link":"https://www.swiggy.com/city/jaunpur"},{"text":"Port Blair","link":"https://www.swiggy.com/city/port-blair"},{"text":"Jorhat","link":"https://www.swiggy.com/city/jorhat"},{"text":"Nandyal","link":"https://www.swiggy.com/city/nandyal"},{"text":"Biharsharif","link":"https://www.swiggy.com/city/biharsharif"},{"text":"Buxar","link":"https://www.swiggy.com/city/buxar"},{"text":"Siwan","link":"https://www.swiggy.com/city/siwan"},{"text":"Dehri","link":"https://www.swiggy.com/city/dehri"},{"text":"Bettiah","link":"https://www.swiggy.com/city/bettiah"},{"text":"Kishanganj","link":"https://www.swiggy.com/city/kishanganj"},{"text":"Saharsa","link":"https://www.swiggy.com/city/saharsa"},{"text":"Hajipur","link":"https://www.swiggy.com/city/hajipur"},{"text":"Motihari","link":"https://www.swiggy.com/city/motihari"},{"text":"Sasaram","link":"https://www.swiggy.com/city/sasaram"},{"text":"Munger","link":"https://www.swiggy.com/city/munger"},{"text":"Katihar","link":"https://www.swiggy.com/city/katihar"},{"text":"Arrah","link":"https://www.swiggy.com/city/arrah"},{"text":"Srikakulam","link":"https://www.swiggy.com/city/srikakulam"},{"text":"Begusarai","link":"https://www.swiggy.com/city/begusarai"},{"text":"Neyveli","link":"https://www.swiggy.com/city/neyveli"},{"text":"Waidhan","link":"https://www.swiggy.com/city/waidhan"},{"text":"Markapur","link":"https://www.swiggy.com/city/markapur"},{"text":"Chikkaballapur","link":"https://www.swiggy.com/city/chikkaballapur"},{"text":"Bhatkal","link":"https://www.swiggy.com/city/bhatkal"},{"text":"Gokak","link":"https://www.swiggy.com/city/gokak"},{"text":"Itarsi","link":"https://www.swiggy.com/city/itarsi"},{"text":"Dhar","link":"https://www.swiggy.com/city/dhar"},{"text":"Chalisgaon","link":"https://www.swiggy.com/city/chalisgaon"},{"text":"Thiruvallur","link":"https://www.swiggy.com/city/thiruvallur"},{"text":"Namakkal","link":"https://www.swiggy.com/city/namakkal"},{"text":"Dharmapuri","link":"https://www.swiggy.com/city/dharmapuri"},{"text":"Bhandara","link":"https://www.swiggy.com/city/bhandara"},{"text":"Virudhunagar","link":"https://www.swiggy.com/city/virudhunagar"},{"text":"Siddipet","link":"https://www.swiggy.com/city/siddipet"},{"text":"Gadwal","link":"https://www.swiggy.com/city/gadwal"},{"text":"Bodhan-Rural","link":"https://www.swiggy.com/city/bodhan-rural"},{"text":"Kamareddy","link":"https://www.swiggy.com/city/kamareddy"},{"text":"Jhunjhunu","link":"https://www.swiggy.com/city/jhunjhunu"},{"text":"Kapurthala","link":"https://www.swiggy.com/city/kapurthala"},{"text":"Sangrur","link":"https://www.swiggy.com/city/sangrur"},{"text":"Gurdaspur","link":"https://www.swiggy.com/city/gurdaspur"},{"text":"Ramgarh","link":"https://www.swiggy.com/city/ramgarh"},{"text":"Bantwal","link":"https://www.swiggy.com/city/bantwal"},{"text":"Doddaballapura","link":"https://www.swiggy.com/city/doddaballapura"},{"text":"Buldana","link":"https://www.swiggy.com/city/buldana"},{"text":"Karad","link":"https://www.swiggy.com/city/karad"},{"text":"Krishnagiri","link":"https://www.swiggy.com/city/krishnagiri"},{"text":"Tiptur","link":"https://www.swiggy.com/city/tiptur"},{"text":"Bhadrachalam","link":"https://www.swiggy.com/city/bhadrachalam"},{"text":"Mancherial","link":"https://www.swiggy.com/city/mancherial"},{"text":"Balrampur","link":"https://www.swiggy.com/city/balrampur"},{"text":"Bharabanki","link":"https://www.swiggy.com/city/bharabanki"},{"text":"Malout","link":"https://www.swiggy.com/city/malout"},{"text":"Fatehgarh Sahib","link":"https://www.swiggy.com/city/fatehgarh-sahib"},{"text":"Ropar","link":"https://www.swiggy.com/city/ropar"},{"text":"Nangal","link":"https://www.swiggy.com/city/nangal"},{"text":"Narnaul","link":"https://www.swiggy.com/city/narnaul"},{"text":"Naraingarh","link":"https://www.swiggy.com/city/naraingarh"},{"text":"Himmatnagar","link":"https://www.swiggy.com/city/himmatnagar"},{"text":"Dausa","link":"https://www.swiggy.com/city/dausa"},{"text":"Jahanabad","link":"https://www.swiggy.com/city/jahanabad"},{"text":"Samastipur","link":"https://www.swiggy.com/city/samastipur"},{"text":"Purnea","link":"https://www.swiggy.com/city/purnea"},{"text":"Berhampur","link":"https://www.swiggy.com/city/berhampur"},{"text":"Malda","link":"https://www.swiggy.com/city/malda"},{"text":"Tuni","link":"https://www.swiggy.com/city/tuni"},{"text":"Puttur","link":"https://www.swiggy.com/city/puttur"},{"text":"Rayachoty","link":"https://www.swiggy.com/city/rayachoty"},{"text":"Nirmal","link":"https://www.swiggy.com/city/nirmal"},{"text":"Mirzapur","link":"https://www.swiggy.com/city/mirzapur"},{"text":"Tanuku","link":"https://www.swiggy.com/city/tanuku"},{"text":"Dahod","link":"https://www.swiggy.com/city/dahod"},{"text":"Barmer","link":"https://www.swiggy.com/city/barmer"},{"text":"Gangapur City","link":"https://www.swiggy.com/city/gangapur-city"},{"text":"Mandi Gobindgarh","link":"https://www.swiggy.com/city/mandi-gobindgarh"},{"text":"Tarn Taran Sahib","link":"https://www.swiggy.com/city/tarn-taran-sahib"},{"text":"Nakodar","link":"https://www.swiggy.com/city/nakodar"},{"text":"Ankleshwar","link":"https://www.swiggy.com/city/ankleshwar"},{"text":"Vyara","link":"https://www.swiggy.com/city/vyara"},{"text":"Bardoli","link":"https://www.swiggy.com/city/bardoli"},{"text":"Halol","link":"https://www.swiggy.com/city/halol"},{"text":"Bijnor","link":"https://www.swiggy.com/city/bijnor"},{"text":"Sangamner","link":"https://www.swiggy.com/city/sangamner"},{"text":"Baramati","link":"https://www.swiggy.com/city/baramati"},{"text":"Betul","link":"https://www.swiggy.com/city/betul"},{"text":"Chhatarpur","link":"https://www.swiggy.com/city/chhatarpur"},{"text":"Balaghat","link":"https://www.swiggy.com/city/balaghat"},{"text":"Sivakasi","link":"https://www.swiggy.com/city/sivakasi"},{"text":"Viluppuram","link":"https://www.swiggy.com/city/viluppuram"},{"text":"Ramanathapuram","link":"https://www.swiggy.com/city/ramanathapuram"},{"text":"Sirsi","link":"https://www.swiggy.com/city/sirsi"},{"text":"Theni","link":"https://www.swiggy.com/city/theni"},{"text":"Karur","link":"https://www.swiggy.com/city/karur"},{"text":"Karwar","link":"https://www.swiggy.com/city/karwar"},{"text":"Sindhanur","link":"https://www.swiggy.com/city/sindhanur"},{"text":"Kannur","link":"https://www.swiggy.com/city/kannur"},{"text":"Noida 1","link":"https://www.swiggy.com/city/noida-1"},{"text":"Thiruvalla","link":"https://www.swiggy.com/city/thiruvalla"},{"text":"Thodupuzha","link":"https://www.swiggy.com/city/thodupuzha"},{"text":"Kadiri","link":"https://www.swiggy.com/city/kadiri"},{"text":"Kavali","link":"https://www.swiggy.com/city/kavali"},{"text":"Tezpur","link":"https://www.swiggy.com/city/tezpur"},{"text":"Kayamkulam","link":"https://www.swiggy.com/city/kayamkulam"},{"text":"Kottarakkara","link":"https://www.swiggy.com/city/kottarakkara"},{"text":"Mandi Dabwali","link":"https://www.swiggy.com/city/mandi-dabwali"},{"text":"Fatehabad","link":"https://www.swiggy.com/city/fatehabad"},{"text":"Jagraon","link":"https://www.swiggy.com/city/jagraon"},{"text":"Mansa","link":"https://www.swiggy.com/city/mansa"},{"text":"Pinjore City","link":"https://www.swiggy.com/city/pinjore-city"},{"text":"Fazilka","link":"https://www.swiggy.com/city/fazilka"},{"text":"Baddi","link":"https://www.swiggy.com/city/baddi"},{"text":"Solan","link":"https://www.swiggy.com/city/solan"},{"text":"Daltonganj","link":"https://www.swiggy.com/city/daltonganj"},{"text":"Balangir","link":"https://www.swiggy.com/city/balangir"},{"text":"Kothagudem","link":"https://www.swiggy.com/city/kothagudem"},{"text":"Hansi","link":"https://www.swiggy.com/city/hansi"},{"text":"Aurangabad_Bihar","link":"https://www.swiggy.com/city/aurangabadbihar"},{"text":"Gopalganj","link":"https://www.swiggy.com/city/gopalganj"},{"text":"Jharsuguda","link":"https://www.swiggy.com/city/jharsuguda"},{"text":"Tohana","link":"https://www.swiggy.com/city/tohana"},{"text":"Jhalawar","link":"https://www.swiggy.com/city/jhalawar"},{"text":"Sivasagar","link":"https://www.swiggy.com/city/sivasagar"},{"text":"Bagdogra","link":"https://www.swiggy.com/city/bagdogra"},{"text":"Kendrapada","link":"https://www.swiggy.com/city/kendrapada"},{"text":"Mallapuram (Do not Use)","link":"https://www.swiggy.com/city/mallapuram-do-not-use"},{"text":"Veraval","link":"https://www.swiggy.com/city/veraval"},{"text":"Daman","link":"https://www.swiggy.com/city/daman"},{"text":"Chiplun","link":"https://www.swiggy.com/city/chiplun"},{"text":"Silvassa","link":"https://www.swiggy.com/city/silvassa"},{"text":"Lonavla","link":"https://www.swiggy.com/city/lonavla"},{"text":"Bongaigaon","link":"https://www.swiggy.com/city/bongaigaon"},{"text":"Golaghat","link":"https://www.swiggy.com/city/golaghat"},{"text":"Duliajan","link":"https://www.swiggy.com/city/duliajan"},{"text":"Bolpur","link":"https://www.swiggy.com/city/bolpur"},{"text":"Madhubani","link":"https://www.swiggy.com/city/madhubani"},{"text":"Balasore","link":"https://www.swiggy.com/city/balasore"},{"text":"Palampur","link":"https://www.swiggy.com/city/palampur"},{"text":"Kotdwar","link":"https://www.swiggy.com/city/kotdwar"},{"text":"Koppal","link":"https://www.swiggy.com/city/koppal"},{"text":"Chikhli","link":"https://www.swiggy.com/city/chikhli"},{"text":"Dahanu","link":"https://www.swiggy.com/city/dahanu"},{"text":"Itanagar","link":"https://www.swiggy.com/city/itanagar"},{"text":"Rangpo","link":"https://www.swiggy.com/city/rangpo"},{"text":"Aizawl","link":"https://www.swiggy.com/city/aizawl"},{"text":"Gangtok","link":"https://www.swiggy.com/city/gangtok"},{"text":"Mayiladuthurai","link":"https://www.swiggy.com/city/mayiladuthurai"},{"text":"Kannauj","link":"https://www.swiggy.com/city/kannauj"},{"text":"Cooch Behar","link":"https://www.swiggy.com/city/cooch-behar"},{"text":"Palani","link":"https://www.swiggy.com/city/palani"},{"text":"Bilimora","link":"https://www.swiggy.com/city/bilimora"},{"text":"Boisar","link":"https://www.swiggy.com/city/boisar"},{"text":"Kohima","link":"https://www.swiggy.com/city/kohima"},{"text":"Naharlagun","link":"https://www.swiggy.com/city/naharlagun"},{"text":"Dumka","link":"https://www.swiggy.com/city/dumka"},{"text":"Rajsamand","link":"https://www.swiggy.com/city/rajsamand"},{"text":"Gauriganj","link":"https://www.swiggy.com/city/gauriganj"},{"text":"Bodinayakanur","link":"https://www.swiggy.com/city/bodinayakanur"},{"text":"Bhawanipatna","link":"https://www.swiggy.com/city/bhawanipatna"},{"text":"Baran","link":"https://www.swiggy.com/city/baran"},{"text":"Narsinghpur","link":"https://www.swiggy.com/city/narsinghpur"},{"text":"Kovilpatti","link":"https://www.swiggy.com/city/kovilpatti"},{"text":"Pusad","link":"https://www.swiggy.com/city/pusad"},{"text":"Kendujhar","link":"https://www.swiggy.com/city/kendujhar"},{"text":"Manali","link":"https://www.swiggy.com/city/manali"},{"text":"Diu","link":"https://www.swiggy.com/city/diu"},{"text":"Khamgaon","link":"https://www.swiggy.com/city/khamgaon"},{"text":"Ramanagara","link":"https://www.swiggy.com/city/ramanagara"},{"text":"Alipurduar","link":"https://www.swiggy.com/city/alipurduar"},{"text":"Almora","link":"https://www.swiggy.com/city/almora"},{"text":"Jhargram","link":"https://www.swiggy.com/city/jhargram"},{"text":"Arambagh","link":"https://www.swiggy.com/city/arambagh"},{"text":"Bhadohi","link":"https://www.swiggy.com/city/bhadohi"},{"text":"Tenkasi","link":"https://www.swiggy.com/city/tenkasi"},{"text":"Srivilliputhur","link":"https://www.swiggy.com/city/srivilliputhur"},{"text":"Chidambaram","link":"https://www.swiggy.com/city/chidambaram"},{"text":"Rajgarh","link":"https://www.swiggy.com/city/rajgarh"},{"text":"Pratapgarh","link":"https://www.swiggy.com/city/pratapgarh"},{"text":"Washim","link":"https://www.swiggy.com/city/washim"},{"text":"Raghunathpur","link":"https://www.swiggy.com/city/raghunathpur"},{"text":"Suri","link":"https://www.swiggy.com/city/suri"},{"text":"Kadayanallur","link":"https://www.swiggy.com/city/kadayanallur"},{"text":"Thiruvarur","link":"https://www.swiggy.com/city/thiruvarur"},{"text":"Ranaghat-WB","link":"https://www.swiggy.com/city/ranaghat-wb"},{"text":"Wayanad","link":"https://www.swiggy.com/city/wayanad"},{"text":"Perambalur","link":"https://www.swiggy.com/city/perambalur"},{"text":"Paramakudi","link":"https://www.swiggy.com/city/paramakudi"},{"text":"Bela Pratapgarh","link":"https://www.swiggy.com/city/bela-pratapgarh"},{"text":"Mahoba","link":"https://www.swiggy.com/city/mahoba"},{"text":"Sitamarhi","link":"https://www.swiggy.com/city/sitamarhi"},{"text":"Chakdaha","link":"https://www.swiggy.com/city/chakdaha"},{"text":"Khalilabad","link":"https://www.swiggy.com/city/khalilabad"},{"text":"Pattukkottai","link":"https://www.swiggy.com/city/pattukkottai"},{"text":"Tindivanam","link":"https://www.swiggy.com/city/tindivanam"},{"text":"Tiruttani","link":"https://www.swiggy.com/city/tiruttani"},{"text":"Gangarampur","link":"https://www.swiggy.com/city/gangarampur"},{"text":"Dharapuram","link":"https://www.swiggy.com/city/dharapuram"},{"text":"Arakkonam","link":"https://www.swiggy.com/city/arakkonam"},{"text":"Sirkali","link":"https://www.swiggy.com/city/sirkali"},{"text":"Mettupalayam","link":"https://www.swiggy.com/city/mettupalayam"},{"text":"Digboi","link":"https://www.swiggy.com/city/digboi"},{"text":"Biswanath Chariali","link":"https://www.swiggy.com/city/biswanath-chariali"},{"text":"Nalbari","link":"https://www.swiggy.com/city/nalbari"},{"text":"Shirdi city","link":"https://www.swiggy.com/city/shirdi-city"},{"text":"Mukerian","link":"https://www.swiggy.com/city/mukerian"},{"text":"Hosur","link":"https://www.swiggy.com/city/hosur"},{"text":"Palakollu","link":"https://www.swiggy.com/city/palakollu"},{"text":"Ravulapalem","link":"https://www.swiggy.com/city/ravulapalem"},{"text":"Barh","link":"https://www.swiggy.com/city/barh"},{"text":"Palghar","link":"https://www.swiggy.com/city/palghar"},{"text":"Kushalnagar","link":"https://www.swiggy.com/city/kushalnagar"},{"text":"Dungarpur","link":"https://www.swiggy.com/city/dungarpur"},{"text":"Chaibasa","link":"https://www.swiggy.com/city/chaibasa"},{"text":"Haveri","link":"https://www.swiggy.com/city/haveri"},{"text":"Karaikal","link":"https://www.swiggy.com/city/karaikal"},{"text":"Jjajjar","link":"https://www.swiggy.com/city/jjajjar"},{"text":"Kokrajhar","link":"https://www.swiggy.com/city/kokrajhar"},{"text":"Rangia","link":"https://www.swiggy.com/city/rangia"},{"text":"Hamirpur","link":"https://www.swiggy.com/city/hamirpur"},{"text":"Una","link":"https://www.swiggy.com/city/una"},{"text":"Sulthan Bathery","link":"https://www.swiggy.com/city/sulthan-bathery"},{"text":"Rayagada","link":"https://www.swiggy.com/city/rayagada"},{"text":"Paradeep","link":"https://www.swiggy.com/city/paradeep"},{"text":"Mandapeta","link":"https://www.swiggy.com/city/mandapeta"},{"text":"Jamui","link":"https://www.swiggy.com/city/jamui"},{"text":"Pilkhuwa","link":"https://www.swiggy.com/city/pilkhuwa"},{"text":"Parvathipuram","link":"https://www.swiggy.com/city/parvathipuram"},{"text":"Ambajogai","link":"https://www.swiggy.com/city/ambajogai"},{"text":"Araria","link":"https://www.swiggy.com/city/araria"},{"text":"North Lakhimpur","link":"https://www.swiggy.com/city/north-lakhimpur"},{"text":"Rajampet","link":"https://www.swiggy.com/city/rajampet"},{"text":"Udumalaipettai","link":"https://www.swiggy.com/city/udumalaipettai"},{"text":"Tirupattur","link":"https://www.swiggy.com/city/tirupattur"},{"text":"Hojai","link":"https://www.swiggy.com/city/hojai"},{"text":"Khagaria","link":"https://www.swiggy.com/city/khagaria"},{"text":"Dasuya","link":"https://www.swiggy.com/city/dasuya"},{"text":"Gudur","link":"https://www.swiggy.com/city/gudur"},{"text":"Sullurpeta","link":"https://www.swiggy.com/city/sullurpeta"},{"text":"Piler","link":"https://www.swiggy.com/city/piler"},{"text":"SankaranKoil","link":"https://www.swiggy.com/city/sankarankoil"},{"text":"Nabha","link":"https://www.swiggy.com/city/nabha"},{"text":"LPU - Phagwara","link":"https://www.swiggy.com/city/lpu-phagwara"},{"text":"Jangipur","link":"https://www.swiggy.com/city/jangipur"},{"text":"Roha","link":"https://www.swiggy.com/city/roha"}],"id":"footer_content"}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.seo.widgets.v1.MetaContext","citySlug":"chennai","lat":"13.0826802","lng":"80.2707184","userAgent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36","gandalfRequest":"{\\"sortAttribute\\":\\"relevance\\",\\"isFiltered\\":false,\\"queryId\\":\\"seo-data-95f8cefc-9bfe-4bf5-b3d3-c13b01c3e890\\",\\"seoParams\\":{\\"apiName\\":\\"FoodHomePage\\",\\"brandId\\":\\"\\",\\"seoUrl\\":\\"www.swiggy.com\\",\\"pageType\\":\\"FOOD_HOME_PAGE\\"}}","id":"meta_data","metaInfo":{"pageType":"FOOD_HOME_PAGE","pageTitle":"Order Food Online from India\'s Best Food Delivery Service | Swiggy","pageMetaDescription":"Order food online from restaurants and get it delivered. Serving in Bangalore, Hyderabad, Delhi and more. Order Pizzas, Biryanis, from Swiggy.","pageKeywords":"Food delivery, Online food order, Online food dleivery"},"screenType":"filteredCollection","seoParams":{"apiName":"FoodHomePage","seoUrl":"www.swiggy.com","pageType":"FOOD_HOME_PAGE"}}}}],"firstOffsetRequest":true,"cacheExpiryTime":240,"nextFetch":1},"tid":"1f502f68-a7d7-4f4e-b0c0-7ee24ba44000","sid":"dv534645-e105-4c38-bc57-22d35e0bf086","deviceId":"4cc554e8-71a4-85c4-eefa-97dcb988f66d","csrfToken":null}');


var $e38adb64246a2e8a$var$useMenuCarousel = function() {
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(null), 2), imgCarousel = _useState[0], setImgCarousel = _useState[1]; // Set initial value to null
    (0, $fIwXP.useEffect)(function() {
        var fetchImage = function() {
            var _ref = (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function() {
                var json;
                return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                    try {
                        // Directly access the properties of the imported JSON object
                        json = (0, (/*@__PURE__*/$parcel$interopDefault($932a91628d18df1f$exports)));
                        setImgCarousel(json.data.cards[0].card.card);
                    } catch (error) {
                        console.error("Error fetching image carousel data:", error);
                    // Handle error gracefully
                    }
                    return [
                        2
                    ];
                });
            });
            return function fetchImage() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchImage();
    }, []);
    return imgCarousel;
};
var $e38adb64246a2e8a$export$2e2bcd8739ae039 = $e38adb64246a2e8a$var$useMenuCarousel;



var $1580051cd03fa60e$exports = {};
"use strict";
Object.defineProperty($1580051cd03fa60e$exports, "__esModule", {
    value: true
});
$1580051cd03fa60e$exports["default"] = void 0;

var $1580051cd03fa60e$var$_slider = $1580051cd03fa60e$var$_interopRequireDefault((parcelRequire("1wVsT")));
function $1580051cd03fa60e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $1580051cd03fa60e$var$_default = $1580051cd03fa60e$exports["default"] = $1580051cd03fa60e$var$_slider["default"];





var $5c8203742f0e3062$export$82e9f45cca5ba907 = "fas";
var $5c8203742f0e3062$export$f22454595d96c106 = {
    prefix: "fas",
    iconName: "0",
    icon: [
        320,
        512,
        [],
        "30",
        "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160V320c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 96c-53 0-96 43-96 96V320c0 53 43 96 96 96s96-43 96-96V192c0-53-43-96-96-96z"
    ]
};
var $5c8203742f0e3062$export$8398cb2addc9e182 = {
    prefix: "fas",
    iconName: "1",
    icon: [
        256,
        512,
        [],
        "31",
        "M160 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.8 1.6l-96 64C-.5 111.2-4.4 131 5.4 145.8s29.7 18.7 44.4 8.9L96 123.8V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V64z"
    ]
};
var $5c8203742f0e3062$export$ed1a0ff7bd680a1d = {
    prefix: "fas",
    iconName: "2",
    icon: [
        320,
        512,
        [],
        "32",
        "M142.9 96c-21.5 0-42.2 8.5-57.4 23.8L54.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L40.2 74.5C67.5 47.3 104.4 32 142.9 32C223 32 288 97 288 177.1c0 38.5-15.3 75.4-42.5 102.6L109.3 416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L200.2 234.5c15.2-15.2 23.8-35.9 23.8-57.4c0-44.8-36.3-81.1-81.1-81.1z"
    ]
};
var $5c8203742f0e3062$export$74b7ff79ce1818d6 = {
    prefix: "fas",
    iconName: "3",
    icon: [
        320,
        512,
        [],
        "33",
        "M0 64C0 46.3 14.3 32 32 32H272c13.2 0 25 8.1 29.8 20.4s1.5 26.3-8.2 35.2L162.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H105.4C63 480 24.2 456 5.3 418.1l-1.9-3.8c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l1.9 3.8c8.1 16.3 24.8 26.5 42.9 26.5H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H80c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L189.7 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var $5c8203742f0e3062$export$969b2215780d58fd = {
    prefix: "fas",
    iconName: "4",
    icon: [
        384,
        512,
        [],
        "34",
        "M189 77.6c7.5-16 .7-35.1-15.3-42.6s-35.1-.7-42.6 15.3L3 322.4c-4.7 9.9-3.9 21.5 1.9 30.8S21 368 32 368H256v80c0 17.7 14.3 32 32 32s32-14.3 32-32V368h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V304H82.4L189 77.6z"
    ]
};
var $5c8203742f0e3062$export$3919f68a5b3825a9 = {
    prefix: "fas",
    iconName: "5",
    icon: [
        320,
        512,
        [],
        "35",
        "M32.5 58.3C35.3 43.1 48.5 32 64 32H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H90.7L70.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H100.5c-39.4 0-75.4-22.3-93-57.5l-4.1-8.2c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l4.1 8.2c6.8 13.6 20.6 22.1 35.8 22.1H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H32c-9.5 0-18.5-4.2-24.6-11.5s-8.6-16.9-6.9-26.2l32-176z"
    ]
};
var $5c8203742f0e3062$export$580ac17b31ffb5c3 = {
    prefix: "fas",
    iconName: "6",
    icon: [
        320,
        512,
        [],
        "36",
        "M232.4 84.7c11.4-13.5 9.7-33.7-3.8-45.1s-33.7-9.7-45.1 3.8L38.6 214.7C14.7 242.9 1.1 278.4 .1 315.2c0 1.4-.1 2.9-.1 4.3c0 .2 0 .3 0 .5c0 88.4 71.6 160 160 160s160-71.6 160-160c0-85.5-67.1-155.4-151.5-159.8l63.9-75.6zM256 320A96 96 0 1 1 64 320a96 96 0 1 1 192 0z"
    ]
};
var $5c8203742f0e3062$export$ee79cab31be16d23 = {
    prefix: "fas",
    iconName: "7",
    icon: [
        320,
        512,
        [],
        "37",
        "M0 64C0 46.3 14.3 32 32 32H288c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-224 384c-8.9 15.3-28.5 20.4-43.8 11.5s-20.4-28.5-11.5-43.8L232.3 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var $5c8203742f0e3062$export$45d84c4b2c560d2f = {
    prefix: "fas",
    iconName: "8",
    icon: [
        320,
        512,
        [],
        "38",
        "M304 160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 34.6 13.7 66 36 89C20.5 272.3 0 309.8 0 352c0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128c0-42.2-20.5-79.7-52-103c22.3-23 36-54.4 36-89zM176.1 288H192c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64h15.9c0 0 .1 0 .1 0h32c0 0 .1 0 .1 0zm0-64c0 0 0 0 0 0H144c0 0 0 0 0 0c-35.3 0-64-28.7-64-64c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64c0 35.3-28.6 64-64 64z"
    ]
};
var $5c8203742f0e3062$export$a120f1e4223629f2 = {
    prefix: "fas",
    iconName: "9",
    icon: [
        320,
        512,
        [],
        "39",
        "M64 192a96 96 0 1 0 192 0A96 96 0 1 0 64 192zm87.5 159.8C67.1 347.4 0 277.5 0 192C0 103.6 71.6 32 160 32s160 71.6 160 160c0 2.6-.1 5.3-.2 7.9c-1.7 35.7-15.2 70-38.4 97.4l-145 171.4c-11.4 13.5-31.6 15.2-45.1 3.8s-15.2-31.6-3.8-45.1l63.9-75.6z"
    ]
};
var $5c8203742f0e3062$export$38320138fc0262d0 = {
    prefix: "fas",
    iconName: "fill-drip",
    icon: [
        576,
        512,
        [],
        "f576",
        "M41.4 9.4C53.9-3.1 74.1-3.1 86.6 9.4L168 90.7l53.1-53.1c28.1-28.1 73.7-28.1 101.8 0L474.3 189.1c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8L122.7 136 41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm176 221.3L168 181.3 75.9 273.4c-4.2 4.2-7 9.3-8.4 14.6H386.7l42.3-42.3c3.1-3.1 3.1-8.2 0-11.3L277.7 82.9c-3.1-3.1-8.2-3.1-11.3 0L213.3 136l49.4 49.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0zM512 512c-35.3 0-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z"
    ]
};
var $5c8203742f0e3062$export$917a3d30f6cd766 = {
    prefix: "fas",
    iconName: "arrows-to-circle",
    icon: [
        640,
        512,
        [],
        "e4bd",
        "M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7V96c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 4.3-.9 8.5-2.4 12.2c-1.6 3.7-3.8 7.3-6.9 10.3l-.1 .1c-3.1 3-6.6 5.3-10.3 6.9c-3.8 1.6-7.9 2.4-12.2 2.4H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h18.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM114.7 352H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0l.1 0c8.8 0 16.7 3.6 22.5 9.3l.1 .1c3 3.1 5.3 6.6 6.9 10.3c1.6 3.8 2.4 7.9 2.4 12.2v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352zM416 96c0-17.7 14.3-32 32-32s32 14.3 32 32v18.7L585.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 160H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448c-8.8 0-16.8-3.6-22.6-9.3l-.1-.1c-3-3.1-5.3-6.6-6.9-10.3s-2.4-7.8-2.4-12.2l0-.1v0V96zM525.3 352L630.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 397.3V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V320v0c0 0 0-.1 0-.1c0-4.3 .9-8.4 2.4-12.2c1.6-3.8 3.9-7.3 6.9-10.4c5.8-5.8 13.7-9.3 22.5-9.4c0 0 .1 0 .1 0h0 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H525.3z"
    ]
};
var $5c8203742f0e3062$export$a39bab13d51abfd0 = {
    prefix: "fas",
    iconName: "circle-chevron-right",
    icon: [
        512,
        512,
        [
            "chevron-circle-right"
        ],
        "f138",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"
    ]
};
var $5c8203742f0e3062$export$2a5db4f6eba6f2b = $5c8203742f0e3062$export$a39bab13d51abfd0;
var $5c8203742f0e3062$export$c115e8063ee02632 = {
    prefix: "fas",
    iconName: "at",
    icon: [
        512,
        512,
        [
            61946
        ],
        "40",
        "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32v80 32c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $5c8203742f0e3062$export$864bb8d6c21fb792 = {
    prefix: "fas",
    iconName: "trash-can",
    icon: [
        448,
        512,
        [
            61460,
            "trash-alt"
        ],
        "f2ed",
        "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
    ]
};
var $5c8203742f0e3062$export$88df7ff7eb32f9dc = $5c8203742f0e3062$export$864bb8d6c21fb792;
var $5c8203742f0e3062$export$3313bce3924ea7da = {
    prefix: "fas",
    iconName: "text-height",
    icon: [
        576,
        512,
        [],
        "f034",
        "M64 128V96h64l0 320H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H192l0-320h64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H160 48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM502.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V352H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H512V160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
    ]
};
var $5c8203742f0e3062$export$e585697127cda27 = {
    prefix: "fas",
    iconName: "user-xmark",
    icon: [
        640,
        512,
        [
            "user-times"
        ],
        "f235",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM471 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $5c8203742f0e3062$export$45b996d071667753 = $5c8203742f0e3062$export$e585697127cda27;
var $5c8203742f0e3062$export$acb2d72d28cd92d9 = {
    prefix: "fas",
    iconName: "stethoscope",
    icon: [
        576,
        512,
        [
            129658
        ],
        "f0f1",
        "M142.4 21.9c5.6 16.8-3.5 34.9-20.2 40.5L96 71.1V192c0 53 43 96 96 96s96-43 96-96V71.1l-26.1-8.7c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l26.1 8.7C334.4 19.1 352 43.5 352 71.1V192c0 77.2-54.6 141.6-127.3 156.7C231 404.6 278.4 448 336 448c61.9 0 112-50.1 112-112V265.3c-28.3-12.3-48-40.5-48-73.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V336c0 97.2-78.8 176-176 176c-92.9 0-168.9-71.9-175.5-163.1C87.2 334.2 32 269.6 32 192V71.1c0-27.5 17.6-52 43.8-60.7l26.1-8.7c16.8-5.6 34.9 3.5 40.5 20.2zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$6563a67224e7f879 = {
    prefix: "fas",
    iconName: "message",
    icon: [
        512,
        512,
        [
            "comment-alt"
        ],
        "f27a",
        "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"
    ]
};
var $5c8203742f0e3062$export$6e96904d9af0ec4a = $5c8203742f0e3062$export$6563a67224e7f879;
var $5c8203742f0e3062$export$d469b770895f47ac = {
    prefix: "fas",
    iconName: "info",
    icon: [
        192,
        512,
        [],
        "f129",
        "M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V448h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64V256H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $5c8203742f0e3062$export$d56736f5800b3f0d = {
    prefix: "fas",
    iconName: "down-left-and-up-right-to-center",
    icon: [
        512,
        512,
        [
            "compress-alt"
        ],
        "f422",
        "M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H296c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39L439 7zM72 272H216c13.3 0 24 10.7 24 24V440c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8z"
    ]
};
var $5c8203742f0e3062$export$a05650ebe54bede = $5c8203742f0e3062$export$d56736f5800b3f0d;
var $5c8203742f0e3062$export$36b5fbeae4855055 = {
    prefix: "fas",
    iconName: "explosion",
    icon: [
        576,
        512,
        [],
        "e4e9",
        "M499.6 11.3c6.7-10.7 20.5-14.5 31.7-8.5s15.8 19.5 10.6 31L404.8 338.6c2.2 2.3 4.3 4.7 6.3 7.1l97.2-54.7c10.5-5.9 23.6-3.1 30.9 6.4s6.3 23-2.2 31.5l-87 87H378.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H117.8L42.3 363.7c-9.7-6.7-13.1-19.6-7.9-30.3s17.4-15.9 28.7-12.4l97.2 30.4c3-3.9 6.1-7.7 9.4-11.3L107.4 236.3c-6.1-10.1-3.9-23.1 5.1-30.7s22.2-7.5 31.1 .1L246 293.6c1.5-.4 3-.8 4.5-1.1l13.6-142.7c1.2-12.3 11.5-21.7 23.9-21.7s22.7 9.4 23.9 21.7l13.5 141.9L499.6 11.3zM64 448v0H512v0h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64zM288 0c13.3 0 24 10.7 24 24V72c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24z"
    ]
};
var $5c8203742f0e3062$export$ef565d07efe2b5e9 = {
    prefix: "fas",
    iconName: "file-lines",
    icon: [
        384,
        512,
        [
            128441,
            128462,
            61686,
            "file-alt",
            "file-text"
        ],
        "f15c",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$243b47dca32bf0b8 = $5c8203742f0e3062$export$ef565d07efe2b5e9;
var $5c8203742f0e3062$export$f466100bf9bf37a5 = $5c8203742f0e3062$export$ef565d07efe2b5e9;
var $5c8203742f0e3062$export$c38cf504b3bc58a2 = {
    prefix: "fas",
    iconName: "wave-square",
    icon: [
        640,
        512,
        [],
        "f83e",
        "M128 64c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32V416h96V256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H512V448c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V96H192V256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V64z"
    ]
};
var $5c8203742f0e3062$export$a95486586631edc7 = {
    prefix: "fas",
    iconName: "ring",
    icon: [
        512,
        512,
        [],
        "f70b",
        "M64 208c0 7.8 4.4 18.7 17.1 30.3C126.5 214.1 188.9 200 256 200s129.5 14.1 174.9 38.3C443.6 226.7 448 215.8 448 208c0-12.3-10.8-32-47.9-50.6C364.9 139.8 314 128 256 128s-108.9 11.8-144.1 29.4C74.8 176 64 195.7 64 208zm192 40c-47 0-89.3 7.6-122.9 19.7C166.3 280.2 208.8 288 256 288s89.7-7.8 122.9-20.3C345.3 255.6 303 248 256 248zM0 208c0-49.6 39.4-85.8 83.3-107.8C129.1 77.3 190.3 64 256 64s126.9 13.3 172.7 36.2c43.9 22 83.3 58.2 83.3 107.8v96c0 49.6-39.4 85.8-83.3 107.8C382.9 434.7 321.7 448 256 448s-126.9-13.3-172.7-36.2C39.4 389.8 0 353.6 0 304V208z"
    ]
};
var $5c8203742f0e3062$export$fbbc7601eb465ac7 = {
    prefix: "fas",
    iconName: "building-un",
    icon: [
        384,
        512,
        [],
        "e4d9",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM237.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 80v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $5c8203742f0e3062$export$221059e0d5fd8958 = {
    prefix: "fas",
    iconName: "dice-three",
    icon: [
        448,
        512,
        [
            9858
        ],
        "f527",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$31c6cf6f5d38dc0 = {
    prefix: "fas",
    iconName: "calendar-days",
    icon: [
        448,
        512,
        [
            "calendar-alt"
        ],
        "f073",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"
    ]
};
var $5c8203742f0e3062$export$cbc139f33cff356 = $5c8203742f0e3062$export$31c6cf6f5d38dc0;
var $5c8203742f0e3062$export$8bce49e6ae597af8 = {
    prefix: "fas",
    iconName: "anchor-circle-check",
    icon: [
        640,
        512,
        [],
        "e4aa",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $5c8203742f0e3062$export$37584b1a5e175b47 = {
    prefix: "fas",
    iconName: "building-circle-arrow-right",
    icon: [
        640,
        512,
        [],
        "e4d1",
        "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V232.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm96 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm140.7-67.3c-6.2 6.2-6.2 16.4 0 22.6L521.4 352H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"
    ]
};
var $5c8203742f0e3062$export$cc519c9529a46c5c = {
    prefix: "fas",
    iconName: "volleyball",
    icon: [
        512,
        512,
        [
            127952,
            "volleyball-ball"
        ],
        "f45f",
        "M511.8 267.4c-26.1 8.7-53.4 13.8-81 15.1c9.2-105.3-31.5-204.2-103.2-272.4C434.1 41.1 512 139.5 512 256c0 3.8-.1 7.6-.2 11.4zm-3.9 34.7c-5.8 32-17.6 62-34.2 88.7c-97.5 48.5-217.7 42.6-311.9-24.5c23.7-36.2 55.4-67.7 94.5-91.8c79.9 43.2 170.1 50.8 251.6 27.6zm-236-55.5c-2.5-90.9-41.1-172.7-101.9-231.7C196.8 5.2 225.8 0 256 0c2.7 0 5.3 0 7.9 .1c90.8 60.2 145.7 167.2 134.7 282.3c-43.1-2.4-86.4-14.1-126.8-35.9zM138 28.8c20.6 18.3 38.7 39.4 53.7 62.6C95.9 136.1 30.6 220.8 7.3 316.9C2.5 297.4 0 277 0 256C0 157.2 56 71.5 138 28.8zm69.6 90.5c19.5 38.6 31 81.9 32.3 127.7C162.5 294.6 110.9 368.9 90.2 451C66 430.4 45.6 405.4 30.4 377.2c6.7-108.7 71.9-209.9 177.1-257.9zM256 512c-50.7 0-98-14.7-137.8-40.2c5.6-27 14.8-53.1 27.4-77.7C232.2 454.6 338.1 468.8 433 441c-46 44-108.3 71-177 71z"
    ]
};
var $5c8203742f0e3062$export$a15e6fc8e68a76b0 = $5c8203742f0e3062$export$cc519c9529a46c5c;
var $5c8203742f0e3062$export$159982ce2622211e = {
    prefix: "fas",
    iconName: "arrows-up-to-line",
    icon: [
        576,
        512,
        [],
        "e4c2",
        "M32 96l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96zM9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 237.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96zm320 45.3c12.5 12.5 32.8 12.5 45.3 0L416 237.3 416 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3z"
    ]
};
var $5c8203742f0e3062$export$58e2577a373e7d4 = {
    prefix: "fas",
    iconName: "sort-down",
    icon: [
        320,
        512,
        [
            "sort-desc"
        ],
        "f0dd",
        "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"
    ]
};
var $5c8203742f0e3062$export$e24f016f5f78af6a = $5c8203742f0e3062$export$58e2577a373e7d4;
var $5c8203742f0e3062$export$d0163707993a8110 = {
    prefix: "fas",
    iconName: "circle-minus",
    icon: [
        512,
        512,
        [
            "minus-circle"
        ],
        "f056",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $5c8203742f0e3062$export$f3979b49bf57313c = $5c8203742f0e3062$export$d0163707993a8110;
var $5c8203742f0e3062$export$41821b9a6fd703de = {
    prefix: "fas",
    iconName: "door-open",
    icon: [
        576,
        512,
        [],
        "f52b",
        "M320 32c0-9.9-4.5-19.2-12.3-25.2S289.8-1.4 280.2 1l-179.9 45C79 51.3 64 70.5 64 92.5V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 288h32V480 32zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128h96V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512V128c0-35.3-28.7-64-64-64H352v64z"
    ]
};
var $5c8203742f0e3062$export$122a80ae0f87f726 = {
    prefix: "fas",
    iconName: "right-from-bracket",
    icon: [
        512,
        512,
        [
            "sign-out-alt"
        ],
        "f2f5",
        "M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $5c8203742f0e3062$export$c844d6923b7096c2 = $5c8203742f0e3062$export$122a80ae0f87f726;
var $5c8203742f0e3062$export$b5bb295e8ad4ab31 = {
    prefix: "fas",
    iconName: "atom",
    icon: [
        512,
        512,
        [
            9883
        ],
        "f5d2",
        "M256 398.8c-11.8 5.1-23.4 9.7-34.9 13.5c16.7 33.8 31 35.7 34.9 35.7s18.1-1.9 34.9-35.7c-11.4-3.9-23.1-8.4-34.9-13.5zM446 256c33 45.2 44.3 90.9 23.6 128c-20.2 36.3-62.5 49.3-115.2 43.2c-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128c20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2c20.7 37.1 9.4 82.8-23.6 128zm-65.8 67.4c-1.7 14.2-3.9 28-6.7 41.2c31.8 1.4 38.6-8.7 40.2-11.7c2.3-4.2 7-17.9-11.9-48.1c-6.8 6.3-14 12.5-21.6 18.6zm-6.7-175.9c2.8 13.1 5 26.9 6.7 41.2c7.6 6.1 14.8 12.3 21.6 18.6c18.9-30.2 14.2-44 11.9-48.1c-1.6-2.9-8.4-13-40.2-11.7zM290.9 99.7C274.1 65.9 259.9 64 256 64s-18.1 1.9-34.9 35.7c11.4 3.9 23.1 8.4 34.9 13.5c11.8-5.1 23.4-9.7 34.9-13.5zm-159 88.9c1.7-14.3 3.9-28 6.7-41.2c-31.8-1.4-38.6 8.7-40.2 11.7c-2.3 4.2-7 17.9 11.9 48.1c6.8-6.3 14-12.5 21.6-18.6zM110.2 304.8C91.4 335 96 348.7 98.3 352.9c1.6 2.9 8.4 13 40.2 11.7c-2.8-13.1-5-26.9-6.7-41.2c-7.6-6.1-14.8-12.3-21.6-18.6zM336 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$64f1c53b21f310ac = {
    prefix: "fas",
    iconName: "soap",
    icon: [
        512,
        512,
        [
            129532
        ],
        "e06e",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM416 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 160c0 27.6-11.7 52.5-30.4 70.1C422.1 275.7 448 310.8 448 352c0 53-43 96-96 96H160c-53 0-96-43-96-96s43-96 96-96h88.4c-15.2-17-24.4-39.4-24.4-64H96c-53 0-96 43-96 96V416c0 53 43 96 96 96H416c53 0 96-43 96-96V288c0-53-43-96-96-96zM160 288c-35.3 0-64 28.7-64 64s28.7 64 64 64H352c35.3 0 64-28.7 64-64s-28.7-64-64-64H320 160z"
    ]
};
var $5c8203742f0e3062$export$7fe2894454d8eb8a = {
    prefix: "fas",
    iconName: "icons",
    icon: [
        512,
        512,
        [
            "heart-music-camera-bolt"
        ],
        "f86d",
        "M500.3 7.3C507.7 13.3 512 22.4 512 32V176c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V71L352 90.2V208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM74.7 304l11.8-17.8c5.9-8.9 15.9-14.2 26.6-14.2h61.7c10.7 0 20.7 5.3 26.6 14.2L213.3 304H240c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48H74.7zM192 408a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM478.7 278.3L440.3 368H496c6.7 0 12.6 4.1 15 10.4s.6 13.3-4.4 17.7l-128 112c-5.6 4.9-13.9 5.3-19.9 .9s-8.2-12.4-5.3-19.2L391.7 400H336c-6.7 0-12.6-4.1-15-10.4s-.6-13.3 4.4-17.7l128-112c5.6-4.9 13.9-5.3 19.9-.9s8.2 12.4 5.3 19.2zm-339-59.2c-6.5 6.5-17 6.5-23 0L19.9 119.2c-28-29-26.5-76.9 5-103.9c27-23.5 68.4-19 93.4 6.5l10 10.5 9.5-10.5c25-25.5 65.9-30 93.9-6.5c31 27 32.5 74.9 4.5 103.9l-96.4 99.9z"
    ]
};
var $5c8203742f0e3062$export$ec74c13cedb0791d = $5c8203742f0e3062$export$7fe2894454d8eb8a;
var $5c8203742f0e3062$export$4be1b324ac8a71ba = {
    prefix: "fas",
    iconName: "microphone-lines-slash",
    icon: [
        640,
        512,
        [
            "microphone-alt-slash"
        ],
        "f539",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24 16c0 21.2-5.1 41.1-14.2 58.7L416 300.8V256H358.9l-34.5-27c2.9-3.1 7-5 11.6-5h80V192H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zM358.2 378.2C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9z"
    ]
};
var $5c8203742f0e3062$export$d2a53a388f30780 = $5c8203742f0e3062$export$4be1b324ac8a71ba;
var $5c8203742f0e3062$export$ea908d3d80c57d08 = {
    prefix: "fas",
    iconName: "bridge-circle-check",
    icon: [
        640,
        512,
        [],
        "e4c9",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $5c8203742f0e3062$export$f1b881c73328720c = {
    prefix: "fas",
    iconName: "pump-medical",
    icon: [
        448,
        512,
        [],
        "e06a",
        "M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM216 280v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V360H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $5c8203742f0e3062$export$614dc068d88655af = {
    prefix: "fas",
    iconName: "fingerprint",
    icon: [
        512,
        512,
        [],
        "f577",
        "M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5c8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6c-15.2 5-18.7 23.7-8.3 35.9c7.1 8.3 18.8 10.8 29.4 7.9c10.6-2.9 21.8-4.4 33.4-4.4c70.7 0 128 57.3 128 128v24.9c0 25.2-1.5 50.3-4.4 75.3c-1.7 14.6 9.4 27.8 24.2 27.8c11.8 0 21.9-8.6 23.3-20.3c3.3-27.4 5-55 5-82.7V256c0-97.2-78.8-176-176-176zM150.7 148.7c-9.1-10.6-25.3-11.4-33.9-.4C93.7 178 80 215.4 80 256v24.9c0 24.2-2.6 48.4-7.8 71.9C68.8 368.4 80.1 384 96.1 384c10.5 0 19.9-7 22.2-17.3c6.4-28.1 9.7-56.8 9.7-85.8V256c0-27.2 8.5-52.4 22.9-73.1c7.2-10.4 8-24.6-.2-34.2zM256 160c-53 0-96 43-96 96v24.9c0 35.9-4.6 71.5-13.8 106.1c-3.8 14.3 6.7 29 21.5 29c9.5 0 17.9-6.2 20.4-15.4c10.5-39 15.9-79.2 15.9-119.7V256c0-28.7 23.3-52 52-52s52 23.3 52 52v24.9c0 36.3-3.5 72.4-10.4 107.9c-2.7 13.9 7.7 27.2 21.8 27.2c10.2 0 19-7 21-17c7.7-38.8 11.6-78.3 11.6-118.1V256c0-53-43-96-96-96zm24 96c0-13.3-10.7-24-24-24s-24 10.7-24 24v24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3C267.9 411.9 280 346.7 280 280.9V256z"
    ]
};
var $5c8203742f0e3062$export$f7bc8714c970afa4 = {
    prefix: "fas",
    iconName: "hand-point-right",
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M480 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-208 0 0-64 208 0zM320 288c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm64-64c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0c17.7 0 32 14.3 32 32zM288 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm-88-96l.6 0c-5.4 9.4-8.6 20.3-8.6 32c0 13.2 4 25.4 10.8 35.6C177.9 364.3 160 388.1 160 416c0 11.7 3.1 22.6 8.6 32l-8.6 0C71.6 448 0 376.4 0 288l0-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64l27 0c35.3 0 64 28.7 64 64l0 88c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-56c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 56c0 39.8 32.2 72 72 72z"
    ]
};
var $5c8203742f0e3062$export$234a18b2b4d530a3 = {
    prefix: "fas",
    iconName: "magnifying-glass-location",
    icon: [
        512,
        512,
        [
            "search-location"
        ],
        "f689",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM288 176c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0c22.1-27 68.6-89.8 68.6-138.6zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $5c8203742f0e3062$export$c33aba6c251a898a = $5c8203742f0e3062$export$234a18b2b4d530a3;
var $5c8203742f0e3062$export$908d699be6717adc = {
    prefix: "fas",
    iconName: "forward-step",
    icon: [
        320,
        512,
        [
            "step-forward"
        ],
        "f051",
        "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4l192 160L256 241V96c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V271l-11.5 9.6-192 160z"
    ]
};
var $5c8203742f0e3062$export$b303329afce5de18 = $5c8203742f0e3062$export$908d699be6717adc;
var $5c8203742f0e3062$export$e3c56ed54f074063 = {
    prefix: "fas",
    iconName: "face-smile-beam",
    icon: [
        512,
        512,
        [
            128522,
            "smile-beam"
        ],
        "f5b8",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm53.5-96.7l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $5c8203742f0e3062$export$54ada6dc9690e0ca = $5c8203742f0e3062$export$e3c56ed54f074063;
var $5c8203742f0e3062$export$92fad97e19a9fea = {
    prefix: "fas",
    iconName: "flag-checkered",
    icon: [
        448,
        512,
        [
            127937
        ],
        "f11e",
        "M32 0C49.7 0 64 14.3 64 32V48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1V345.8c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V400 334 64 32C0 14.3 14.3 0 32 0zM64 187.1l64-13.9v65.5L64 252.6V318l48.8-12.2c5.1-1.3 10.1-2.4 15.2-3.3V238.7l38.9-8.4c8.3-1.8 16.7-2.5 25.1-2.1l0-64c13.6 .4 27.2 2.6 40.4 6.4l23.6 6.9v66.7l-41.7-12.3c-7.3-2.1-14.8-3.4-22.3-3.8v71.4c21.8 1.9 43.3 6.7 64 14.4V244.2l22.7 6.7c13.5 4 27.3 6.4 41.3 7.4V194c-7.8-.8-15.6-2.3-23.2-4.5l-40.8-12v-62c-13-3.8-25.8-8.8-38.2-15c-8.2-4.1-16.9-7-25.8-8.8v72.4c-13-.4-26 .8-38.7 3.6L128 173.2V98L64 114v73.1zM320 335.7c16.8 1.5 33.9-.7 50-6.8l14-5.2V251.9l-7.9 1.8c-18.4 4.3-37.3 5.7-56.1 4.5v77.4zm64-149.4V115.4c-20.9 6.1-42.4 9.1-64 9.1V194c13.9 1.4 28 .5 41.7-2.6l22.3-5.2z"
    ]
};
var $5c8203742f0e3062$export$e15f65e77f717c29 = {
    prefix: "fas",
    iconName: "football",
    icon: [
        512,
        512,
        [
            127944,
            "football-ball"
        ],
        "f44e",
        "M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7C142.9 61.6 96.7 103.6 66 153.6c-18.3 29.8-30.9 62.3-39.2 95.4L264.5 486.6c13.5-3.3 26.4-7.2 38.6-11.7c66-24.5 112.2-66.5 142.9-116.5c18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zM495.2 205.3c6.1-56.8 1.4-112.2-7.7-156.4c-2.7-12.9-13-22.9-26.1-25.1c-58.2-9.7-109.9-12-155.6-7.9L495.2 205.3zM206.1 496L16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4c2.7 12.9 13 22.9 26.1 25.1c58.2 9.7 109.9 12 155.6 7.9zm54.6-331.3c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6z"
    ]
};
var $5c8203742f0e3062$export$e8fd664711e31704 = $5c8203742f0e3062$export$e15f65e77f717c29;
var $5c8203742f0e3062$export$f629fdee00932a01 = {
    prefix: "fas",
    iconName: "school-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e56c",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$afa58590dfb6fca2 = {
    prefix: "fas",
    iconName: "crop",
    icon: [
        512,
        512,
        [],
        "f125",
        "M448 109.3l54.6-54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L402.7 64 160 64v64l178.7 0L128 338.7V32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H173.3L384 173.3 384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-274.7z"
    ]
};
var $5c8203742f0e3062$export$52783a541b1bb03 = {
    prefix: "fas",
    iconName: "angles-down",
    icon: [
        448,
        512,
        [
            "angle-double-down"
        ],
        "f103",
        "M246.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 402.7 361.4 265.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7 361.4 73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"
    ]
};
var $5c8203742f0e3062$export$fd504117f273ca92 = $5c8203742f0e3062$export$52783a541b1bb03;
var $5c8203742f0e3062$export$a28757068b9a3a9a = {
    prefix: "fas",
    iconName: "users-rectangle",
    icon: [
        640,
        512,
        [],
        "e594",
        "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H544c53 0 96-43 96-96V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zm159.8 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3C119.9 256 96 279.9 96 309.3zM461.2 336h56.1c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6zM372 289c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-8.6-24.3-29.9-42.6-55.9-47zM512 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
    ]
};
var $5c8203742f0e3062$export$b96e695bdcf3f3f5 = {
    prefix: "fas",
    iconName: "people-roof",
    icon: [
        640,
        512,
        [],
        "e537",
        "M335.5 4l288 160c15.4 8.6 21 28.1 12.4 43.5s-28.1 21-43.5 12.4L320 68.6 47.5 220c-15.4 8.6-34.9 3-43.5-12.4s-3-34.9 12.4-43.5L304.5 4c9.7-5.4 21.4-5.4 31.1 0zM320 160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM144 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm312 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM226.9 491.4L200 441.5V480c0 17.7-14.3 32-32 32H120c-17.7 0-32-14.3-32-32V441.5L61.1 491.4c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6h19.5c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8L552 441.5V480c0 17.7-14.3 32-32 32H472c-17.7 0-32-14.3-32-32V441.5l-26.9 49.9c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8L376 345.5V400c0 17.7-14.3 32-32 32H296c-17.7 0-32-14.3-32-32V345.5l-26.9 49.9c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8z"
    ]
};
var $5c8203742f0e3062$export$d12c2d6def120efe = {
    prefix: "fas",
    iconName: "people-line",
    icon: [
        640,
        512,
        [],
        "e534",
        "M360 72a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM144 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM496 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 217.5V272c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V217.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 340.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5z"
    ]
};
var $5c8203742f0e3062$export$b957c27bc5330472 = {
    prefix: "fas",
    iconName: "beer-mug-empty",
    icon: [
        512,
        512,
        [
            "beer"
        ],
        "f0fc",
        "M32 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V96h51.2c42.4 0 76.8 34.4 76.8 76.8V274.9c0 30.4-17.9 57.9-45.6 70.2L384 381.7V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM384 311.6l56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7V172.8c0-7.1-5.7-12.8-12.8-12.8H384V311.6zM160 144c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"
    ]
};
var $5c8203742f0e3062$export$f74725691538983b = $5c8203742f0e3062$export$b957c27bc5330472;
var $5c8203742f0e3062$export$1852c99deca7bee8 = {
    prefix: "fas",
    iconName: "diagram-predecessor",
    icon: [
        512,
        512,
        [],
        "e477",
        "M448 416l0-64L64 352l0 64 384 0zm0 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64zM288 160c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l144 0 16 0 144 0c44.2 0 80 35.8 80 80l0 16 38.1 0c21.4 0 32.1 25.9 17 41L433 239c-9.4 9.4-24.6 9.4-33.9 0L329 169c-15.1-15.1-4.4-41 17-41l38.1 0 0-16c0-8.8-7.2-16-16-16l-80 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$92c58defe6e4c5a7 = {
    prefix: "fas",
    iconName: "arrow-up-long",
    icon: [
        384,
        512,
        [
            "long-arrow-up"
        ],
        "f176",
        "M214.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z"
    ]
};
var $5c8203742f0e3062$export$ede1d50ec4b01670 = $5c8203742f0e3062$export$92c58defe6e4c5a7;
var $5c8203742f0e3062$export$9ebfff5c90672059 = {
    prefix: "fas",
    iconName: "fire-flame-simple",
    icon: [
        384,
        512,
        [
            "burn"
        ],
        "f46a",
        "M372.5 256.5l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6C0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zm-90.8 49.5c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z"
    ]
};
var $5c8203742f0e3062$export$80ed4535efc60402 = $5c8203742f0e3062$export$9ebfff5c90672059;
var $5c8203742f0e3062$export$e6619e43cb090a16 = {
    prefix: "fas",
    iconName: "person",
    icon: [
        320,
        512,
        [
            129485,
            "male"
        ],
        "f183",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152z"
    ]
};
var $5c8203742f0e3062$export$2e21f9dba1630651 = $5c8203742f0e3062$export$e6619e43cb090a16;
var $5c8203742f0e3062$export$c2dee3bd177275a2 = {
    prefix: "fas",
    iconName: "laptop",
    icon: [
        640,
        512,
        [
            128187
        ],
        "f109",
        "M128 32C92.7 32 64 60.7 64 96V352h64V96H512V352h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2z"
    ]
};
var $5c8203742f0e3062$export$82cea4f586f6ec9 = {
    prefix: "fas",
    iconName: "file-csv",
    icon: [
        512,
        512,
        [],
        "f6dd",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H333.1c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$232452c59d77c56e = {
    prefix: "fas",
    iconName: "menorah",
    icon: [
        640,
        512,
        [],
        "f676",
        "M20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4L61.3 49.7c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32S0 81.7 0 64V62.8c0-4.5 .9-8.9 2.7-13.1L20.8 7.4zm96 0C118.8 2.9 123.1 0 128 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L116.8 7.4zm77.8 42.4L212.8 7.4C214.8 2.9 219.1 0 224 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM308.8 7.4C310.8 2.9 315.1 0 320 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L308.8 7.4zm77.8 42.4L404.8 7.4C406.8 2.9 411.1 0 416 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM500.8 7.4C502.8 2.9 507.1 0 512 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L500.8 7.4zm77.8 42.4L596.8 7.4C598.8 2.9 603.1 0 608 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM32 128c17.7 0 32 14.3 32 32V288c0 17.7 14.3 32 32 32H288V160c0-17.7 14.3-32 32-32s32 14.3 32 32V320H544c17.7 0 32-14.3 32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 53-43 96-96 96H352v64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V384H96c-53 0-96-43-96-96V160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H96V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H192V256 160c0-17.7 14.3-32 32-32zm192 0c17.7 0 32 14.3 32 32v96 32H384V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H480V256 160c0-17.7 14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$e1d5ceed99060d76 = {
    prefix: "fas",
    iconName: "truck-plane",
    icon: [
        640,
        512,
        [],
        "e58f",
        "M200 0c-30.6 0-56 54.7-56 86.1V192.5L7.8 274.3C2.9 277.2 0 282.4 0 288v64c0 5.1 2.4 9.8 6.4 12.8s9.3 3.9 14.1 2.5l123.4-37v81.2l-50 40c-3.8 3-6 7.6-6 12.5v32c0 5.1 2.5 10 6.6 13s9.5 3.8 14.4 2.2L200 480.9 290.4 511c-1.6-4.7-2.4-9.8-2.4-15V463.4c-18.2-10.5-30.7-29.7-31.9-51.8l-.1-.1V408 325.5 184l0-1.1 0 0V86.1C256 54.7 231.5 0 200 0zm88 176V400c0 20.9 13.4 38.7 32 45.3V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V448H544v40c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V445.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48zm79.8 78.7c3.3-8.7 11.2-14.7 20.5-14.7H539.7c9.2 0 17.2 6 20.5 14.7L576 304H352l15.8-49.3zM568 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM336 376a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $5c8203742f0e3062$export$fe2d5012d9982673 = {
    prefix: "fas",
    iconName: "record-vinyl",
    icon: [
        512,
        512,
        [],
        "f8d9",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$1d1fbac384a76a12 = {
    prefix: "fas",
    iconName: "face-grin-stars",
    icon: [
        512,
        512,
        [
            129321,
            "grin-stars"
        ],
        "f587",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm407.4 75.5c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM160 120c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L160 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L226.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6zm192 0c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L352 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L418.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6z"
    ]
};
var $5c8203742f0e3062$export$64347a5c8c402ef4 = $5c8203742f0e3062$export$1d1fbac384a76a12;
var $5c8203742f0e3062$export$e74974fac77c468e = {
    prefix: "fas",
    iconName: "bong",
    icon: [
        448,
        512,
        [],
        "f55c",
        "M160 208.5c0 29.1-15.6 53.9-37.2 67.8c-17.2 11.1-31.5 26.1-41.7 43.7H302.9c-10.2-17.6-24.5-32.6-41.7-43.7c-21.6-13.9-37.2-38.7-37.2-67.8V64H160V208.5zM288 64V208.5c0 5.7 3.1 10.9 7.9 14c11.2 7.2 21.5 15.5 30.9 24.8L366.1 208l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l24 24 24 24c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3C374 314.1 384 347.9 384 384c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5H76.1c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5c4.8-3.1 7.9-8.3 7.9-14V64C78.3 64 64 49.7 64 32S78.3 0 96 0h16H272h16c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $5c8203742f0e3062$export$3c8d5c62d76c33b8 = {
    prefix: "fas",
    iconName: "spaghetti-monster-flying",
    icon: [
        640,
        512,
        [
            "pastafarianism"
        ],
        "f67b",
        "M208 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 0c0 16.2-6 31.1-16 42.3l15.6 31.2c18.7-6 39.9-9.5 64.4-9.5s45.8 3.5 64.4 9.5L400 106.3C390 95.1 384 80.2 384 64c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-1.7 0-3.4-.1-5.1-.2L427.8 158c21.1 13.6 37.7 30.2 51.4 46.4c7.1 8.3 13.5 16.6 19.3 24l1.4 1.8c6.3 8.1 11.6 14.8 16.7 20.4C527.3 262.3 532.7 264 536 264c2.5 0 4.3-.6 7.1-3.3c3.7-3.5 7.1-8.8 12.5-17.4l.6-.9c4.6-7.4 11-17.6 19.4-25.7c9.7-9.3 22.9-16.7 40.4-16.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-2.5 0-4.3 .6-7.1 3.3c-3.7 3.5-7.1 8.8-12.5 17.4l-.6 .9c-4.6 7.4-11 17.6-19.4 25.7c-9.7 9.3-22.9 16.7-40.4 16.7c-18.5 0-32.9-8.5-44.3-18.6c-3.1 4-6.6 8.3-10.5 12.7c1.4 4.3 2.8 8.5 4 12.5c.9 3 1.8 5.8 2.6 8.6c3 9.8 5.5 18.2 8.6 25.9c3.9 9.8 7.4 15.4 10.8 18.5c2.6 2.4 5.9 4.3 12.8 4.3c8.7 0 16.9-4.2 33.7-13.2c15-8 35.7-18.8 62.3-18.8c13.3 0 24 10.7 24 24s-10.7 24-24 24c-13.4 0-24.7 5.2-39.7 13.2c-1 .6-2.1 1.1-3.2 1.7C559.9 414 541.4 424 520 424c-18.4 0-33.6-6.1-45.5-17.2c-11.1-10.3-17.9-23.7-22.7-36c-3.6-9-6.7-19.1-9.5-28.5c-16.4 12.3-36.1 23.6-58.9 31.3c3.6 10.8 8.4 23.5 14.4 36.2c7.5 15.9 16.2 30.4 25.8 40.5C433 460.5 441.2 464 448 464c13.3 0 24 10.7 24 24s-10.7 24-24 24c-25.2 0-45-13.5-59.5-28.8c-14.5-15.4-25.7-34.9-34.2-53c-8-17-14.1-33.8-18.3-46.9c-5.2 .4-10.6 .6-16 .6s-10.8-.2-16-.6c-4.2 13-10.3 29.9-18.3 46.9c-8.5 18.1-19.8 37.6-34.2 53C237 498.5 217.2 512 192 512c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.8 0 15-3.5 24.5-13.7c9.5-10.1 18.3-24.6 25.8-40.5c5.9-12.6 10.7-25.4 14.4-36.2c-22.8-7.7-42.5-19-58.9-31.3c-2.9 9.4-6 19.5-9.5 28.5c-4.8 12.2-11.6 25.6-22.7 36C153.6 417.9 138.4 424 120 424c-21.4 0-39.9-10-53.1-17.1l0 0c-1.1-.6-2.2-1.2-3.2-1.7c-15-8-26.3-13.2-39.7-13.2c-13.3 0-24-10.7-24-24s10.7-24 24-24c26.6 0 47.3 10.8 62.3 18.8c16.8 9 25 13.2 33.7 13.2c6.8 0 10.2-1.9 12.8-4.3c3.4-3.2 7-8.8 10.8-18.5c3-7.7 5.6-16.1 8.6-25.9c.8-2.7 1.7-5.6 2.6-8.6c1.2-4 2.6-8.2 4-12.5c-3.9-4.5-7.4-8.8-10.5-12.7C136.9 303.5 122.5 312 104 312c-17.5 0-30.7-7.4-40.4-16.7c-8.4-8.1-14.8-18.3-19.4-25.7l-.6-.9c-5.4-8.6-8.8-13.9-12.5-17.4c-2.8-2.7-4.6-3.3-7.1-3.3c-13.3 0-24-10.7-24-24s10.7-24 24-24c17.5 0 30.7 7.4 40.4 16.7c8.4 8.1 14.8 18.3 19.4 25.7l.6 .9c5.4 8.6 8.8 13.9 12.5 17.4c2.8 2.7 4.6 3.3 7.1 3.3c3.3 0 8.7-1.7 19.4-13.4c5.1-5.6 10.4-12.3 16.7-20.4l1.4-1.8c5.8-7.4 12.2-15.7 19.3-24c13.8-16.2 30.3-32.8 51.4-46.4l-15.1-30.2c-1.7 .1-3.4 .2-5.1 .2c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm208 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $5c8203742f0e3062$export$733efdaec97447be = $5c8203742f0e3062$export$3c8d5c62d76c33b8;
var $5c8203742f0e3062$export$9fe0c42ede2dd003 = {
    prefix: "fas",
    iconName: "arrow-down-up-across-line",
    icon: [
        576,
        512,
        [],
        "e4af",
        "M137.4 502.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V288H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H448V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 109.3V224H192 128 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96zM128 192h64V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192zM448 320H384V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320z"
    ]
};
var $5c8203742f0e3062$export$faf854a434ce6d0c = {
    prefix: "fas",
    iconName: "spoon",
    icon: [
        512,
        512,
        [
            129348,
            61873,
            "utensil-spoon"
        ],
        "f2e5",
        "M245.8 220.9c-14.5-17.6-21.8-39.2-21.8-60.8C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-21.6 0-43.2-7.3-60.8-21.8L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L245.8 220.9z"
    ]
};
var $5c8203742f0e3062$export$fb7af5d245fb9053 = $5c8203742f0e3062$export$faf854a434ce6d0c;
var $5c8203742f0e3062$export$8b503c1d76716ddd = {
    prefix: "fas",
    iconName: "jar-wheat",
    icon: [
        320,
        512,
        [],
        "e517",
        "M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm112 0H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 198 90 224 122.2 224H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7zm48 117.7c-11.7-13.3-28.9-21.7-48-21.7H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 294 90 320 122.2 320H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7zM112 352H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 390 90 416 122.2 416H144v32c0 8.8 7.2 16 16 16s16-7.2 16-16V416h21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7z"
    ]
};
var $5c8203742f0e3062$export$dc2cce064a1e70bb = {
    prefix: "fas",
    iconName: "envelopes-bulk",
    icon: [
        640,
        512,
        [
            "mail-bulk"
        ],
        "f674",
        "M128 0C110.3 0 96 14.3 96 32V224h96V192c0-35.3 28.7-64 64-64H480V32c0-17.7-14.3-32-32-32H128zM256 160c-17.7 0-32 14.3-32 32v32h96c35.3 0 64 28.7 64 64V416H576c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H256zm240 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM64 256c-17.7 0-32 14.3-32 32v13L187.1 415.9c1.4 1 3.1 1.6 4.9 1.6s3.5-.6 4.9-1.6L352 301V288c0-17.7-14.3-32-32-32H64zm288 84.8L216 441.6c-6.9 5.1-15.3 7.9-24 7.9s-17-2.8-24-7.9L32 340.8V480c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V340.8z"
    ]
};
var $5c8203742f0e3062$export$dd24f40c5337e2e1 = $5c8203742f0e3062$export$dc2cce064a1e70bb;
var $5c8203742f0e3062$export$61fa9809253098e5 = {
    prefix: "fas",
    iconName: "file-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e4eb",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $5c8203742f0e3062$export$bf5674308c61894f = {
    prefix: "fas",
    iconName: "circle-h",
    icon: [
        512,
        512,
        [
            9405,
            "hospital-symbol"
        ],
        "f47e",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H192l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H320V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $5c8203742f0e3062$export$c8a3c78d99c23fed = $5c8203742f0e3062$export$bf5674308c61894f;
var $5c8203742f0e3062$export$e1611f373a10a98c = {
    prefix: "fas",
    iconName: "pager",
    icon: [
        512,
        512,
        [
            128223
        ],
        "f815",
        "M0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm64 32v64c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"
    ]
};
var $5c8203742f0e3062$export$853fd1561789e3bb = {
    prefix: "fas",
    iconName: "address-book",
    icon: [
        512,
        512,
        [
            62138,
            "contact-book"
        ],
        "f2b9",
        "M96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM208 288h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM496 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"
    ]
};
var $5c8203742f0e3062$export$594b5a5d4d2e156b = $5c8203742f0e3062$export$853fd1561789e3bb;
var $5c8203742f0e3062$export$eff51ea25b4de135 = {
    prefix: "fas",
    iconName: "strikethrough",
    icon: [
        512,
        512,
        [],
        "f0cc",
        "M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z"
    ]
};
var $5c8203742f0e3062$export$3f85413cb67e7f67 = {
    prefix: "fas",
    iconName: "k",
    icon: [
        320,
        512,
        [
            107
        ],
        "4b",
        "M311 86.3c12.3-12.7 12-32.9-.7-45.2s-32.9-12-45.2 .7l-155.2 160L64 249V64c0-17.7-14.3-32-32-32S0 46.3 0 64V328 448c0 17.7 14.3 32 32 32s32-14.3 32-32V341l64.7-66.7 133 192c10.1 14.5 30 18.1 44.5 8.1s18.1-30 8.1-44.5L174.1 227.4 311 86.3z"
    ]
};
var $5c8203742f0e3062$export$f4d472cf47be4096 = {
    prefix: "fas",
    iconName: "landmark-flag",
    icon: [
        512,
        512,
        [],
        "e51c",
        "M272 0h80c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H272v32H464c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H240V16c0-8.8 7.2-16 16-16h16zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"
    ]
};
var $5c8203742f0e3062$export$c72de95adaca18b8 = {
    prefix: "fas",
    iconName: "pencil",
    icon: [
        512,
        512,
        [
            9999,
            61504,
            "pencil-alt"
        ],
        "f303",
        "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $5c8203742f0e3062$export$8210adc172262df = $5c8203742f0e3062$export$c72de95adaca18b8;
var $5c8203742f0e3062$export$ae65f96ea7a4078d = {
    prefix: "fas",
    iconName: "backward",
    icon: [
        512,
        512,
        [
            9194
        ],
        "f04a",
        "M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3V256v41.7L459.5 440.6zM256 352V256 128 96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V352z"
    ]
};
var $5c8203742f0e3062$export$f1011352b01c1c0 = {
    prefix: "fas",
    iconName: "caret-right",
    icon: [
        256,
        512,
        [],
        "f0da",
        "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"
    ]
};
var $5c8203742f0e3062$export$932912e74adb8939 = {
    prefix: "fas",
    iconName: "comments",
    icon: [
        640,
        512,
        [
            128490,
            61670
        ],
        "f086",
        "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2 0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.3-11.4C134.1 343.3 169.8 352 208 352zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9l0 0 0 0-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z"
    ]
};
var $5c8203742f0e3062$export$6f95f90dd1f6d86b = {
    prefix: "fas",
    iconName: "paste",
    icon: [
        512,
        512,
        [
            "file-clipboard"
        ],
        "f0ea",
        "M160 0c-23.7 0-44.4 12.9-55.4 32H48C21.5 32 0 53.5 0 80V400c0 26.5 21.5 48 48 48H192V176c0-44.2 35.8-80 80-80h48V80c0-26.5-21.5-48-48-48H215.4C204.4 12.9 183.7 0 160 0zM272 128c-26.5 0-48 21.5-48 48V448v16c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V243.9c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1H320 272zM160 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $5c8203742f0e3062$export$ca3229c47de163fa = $5c8203742f0e3062$export$6f95f90dd1f6d86b;
var $5c8203742f0e3062$export$37576dfab037d8bf = {
    prefix: "fas",
    iconName: "code-pull-request",
    icon: [
        512,
        512,
        [],
        "e13c",
        "M305.8 2.1C314.4 5.9 320 14.5 320 24V64h16c70.7 0 128 57.3 128 128V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-35.3-28.7-64-64-64H320v40c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1zM104 80A24 24 0 1 0 56 80a24 24 0 1 0 48 0zm8 73.3V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80c0 32.8-19.7 61-48 73.3zM104 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm328 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $5c8203742f0e3062$export$2c5a9d8548d8810e = {
    prefix: "fas",
    iconName: "clipboard-list",
    icon: [
        384,
        512,
        [],
        "f46d",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"
    ]
};
var $5c8203742f0e3062$export$37396c36c76937bc = {
    prefix: "fas",
    iconName: "truck-ramp-box",
    icon: [
        640,
        512,
        [
            "truck-loading"
        ],
        "f4de",
        "M640 0V400c0 61.9-50.1 112-112 112c-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8V64c0-35.3 28.7-64 64-64H640zM576 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l46.4-12.4 20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3 46.4-12.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2L103.7 384.9c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7z"
    ]
};
var $5c8203742f0e3062$export$f00c152db7d44638 = $5c8203742f0e3062$export$37396c36c76937bc;
var $5c8203742f0e3062$export$76de2a120043c9f8 = {
    prefix: "fas",
    iconName: "user-check",
    icon: [
        640,
        512,
        [],
        "f4fc",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $5c8203742f0e3062$export$a56b2b0a1073620c = {
    prefix: "fas",
    iconName: "vial-virus",
    icon: [
        512,
        512,
        [],
        "e597",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V384c0 53 43 96 96 96c28.6 0 54.2-12.5 71.8-32.3c.1-14.2 5.6-28.3 16.4-39.1c.2-.2 .1-.6-.2-.6c-30.9 0-56-25.1-56-56s25.1-56 56-56c.3 0 .4-.4 .2-.6c-21.9-21.9-21.9-57.3 0-79.2c2.4-2.4 5-4.6 7.8-6.5V96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 96 32zM96 192V96h64v96H96zM216 376c28.8 0 43.2 34.8 22.9 55.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.4-20.4 55.2-5.9 55.2 22.9c0 13.3 10.7 24 24 24s24-10.7 24-24c0-28.8 34.8-43.2 55.2-22.9c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9C444.8 410.8 459.2 376 488 376c13.3 0 24-10.7 24-24s-10.7-24-24-24c-28.8 0-43.2-34.8-22.9-55.2c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0C410.8 259.2 376 244.8 376 216c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 28.8-34.8 43.2-55.2 22.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.4 20.4 5.9 55.2-22.9 55.2c-13.3 0-24 10.7-24 24s10.7 24 24 24zm104-88a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm40 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $5c8203742f0e3062$export$57f2bcd070bff91a = {
    prefix: "fas",
    iconName: "sheet-plastic",
    icon: [
        384,
        512,
        [],
        "e571",
        "M0 448c0 35.3 28.7 64 64 64H224V384c0-17.7 14.3-32 32-32H384V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448zM171.3 75.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm96 32l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM384 384H256V512L384 384z"
    ]
};
var $5c8203742f0e3062$export$890d5e011054935a = {
    prefix: "fas",
    iconName: "blog",
    icon: [
        512,
        512,
        [],
        "f781",
        "M192 32c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192c-17.7 0-32 14.3-32 32zM96 144c0-26.5-21.5-48-48-48S0 117.5 0 144V368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144H128v96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48V144z"
    ]
};
var $5c8203742f0e3062$export$a9174995732e03c5 = {
    prefix: "fas",
    iconName: "user-ninja",
    icon: [
        448,
        512,
        [
            129399
        ],
        "f504",
        "M224 256c-57.2 0-105.6-37.5-122-89.3c-1.1 1.3-2.2 2.6-3.5 3.8c-15.8 15.8-38.8 20.7-53.6 22.1c-8.1 .8-14.6-5.7-13.8-13.8c1.4-14.7 6.3-37.8 22.1-53.6c5.8-5.8 12.6-10.1 19.6-13.4c-7-3.2-13.8-7.6-19.6-13.4C37.4 82.7 32.6 59.7 31.1 44.9c-.8-8.1 5.7-14.6 13.8-13.8c14.7 1.4 37.8 6.3 53.6 22.1c4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zM0 482.3C0 399.5 56.4 330 132.8 309.9c6-1.6 12.2 .9 15.9 5.8l62.5 83.3c6.4 8.5 19.2 8.5 25.6 0l62.5-83.3c3.7-4.9 9.9-7.4 15.9-5.8C391.6 330 448 399.5 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"
    ]
};
var $5c8203742f0e3062$export$5709329dd2b70bdc = {
    prefix: "fas",
    iconName: "person-arrow-up-from-line",
    icon: [
        640,
        512,
        [],
        "e539",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM598.6 121.4l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L464 141.3 464 384c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
    ]
};
var $5c8203742f0e3062$export$4e3fe5b42a6cd494 = {
    prefix: "fas",
    iconName: "scroll-torah",
    icon: [
        640,
        512,
        [
            "torah"
        ],
        "f6a0",
        "M96 480V32C96 14.3 74.5 0 48 0S0 14.3 0 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32zM512 32H128V480H512V32zM592 0c-26.5 0-48 14.3-48 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32V32c0-17.7-21.5-32-48-32zM196 313.7c0-3.2 .9-6.4 2.5-9.2L226.7 256l-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2c0-10.1 8.2-18.3 18.3-18.3H271l31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180h56.7c10.1 0 18.3 8.2 18.3 18.3c0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2c0 10.1-8.2 18.3-18.3 18.3H369l-31.4 53.9c-3.6 6.3-10.3 10.1-17.6 10.1s-13.9-3.8-17.6-10.1L271 332H214.3c-10.1 0-18.3-8.2-18.3-18.3zm124 54.7L341.2 332H298.8L320 368.4zM254.5 256l30.3 52h70.4l30.3-52-30.3-52H284.8l-30.3 52zm144.9 23.8L383 308h32.8l-16.4-28.2zM415.8 204H383l16.4 28.2L415.8 204zM320 143.6L298.8 180h42.4L320 143.6zM224.2 204l16.4 28.2L257 204H224.2zM257 308l-16.4-28.2L224.2 308H257z"
    ]
};
var $5c8203742f0e3062$export$54d07baabd8c2acb = $5c8203742f0e3062$export$4e3fe5b42a6cd494;
var $5c8203742f0e3062$export$3e1327487ce53231 = {
    prefix: "fas",
    iconName: "broom-ball",
    icon: [
        576,
        512,
        [
            "quidditch",
            "quidditch-broom-ball"
        ],
        "f458",
        "M566.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-192 192 34.7 34.7c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H364.3L256 211.7V182.6c0-12.5 10.1-22.6 22.6-22.6c6 0 11.8 2.4 16 6.6l34.7 34.7 192-192c12.5-12.5 32.8-12.5 45.3 0zm-344 225.5L341.1 353.4c3.7 42.7-11.7 85.2-42.3 115.8C271.4 496.6 234.2 512 195.5 512L22.1 512C9.9 512 0 502.1 0 489.9c0-6.3 2.7-12.3 7.3-16.5L133.7 359.7c4.2-3.7-.4-10.4-5.4-7.9L77.2 377.4c-6.1 3-13.2-1.4-13.2-8.2c0-31.5 12.5-61.7 34.8-84l8-8c30.6-30.6 73.1-45.9 115.8-42.3zM464 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var $5c8203742f0e3062$export$c00c446e6db1605f = $5c8203742f0e3062$export$3e1327487ce53231;
var $5c8203742f0e3062$export$791bfe29b97b4d42 = $5c8203742f0e3062$export$3e1327487ce53231;
var $5c8203742f0e3062$export$d20aaceb882ca545 = {
    prefix: "fas",
    iconName: "toggle-off",
    icon: [
        576,
        512,
        [],
        "f204",
        "M384 128c70.7 0 128 57.3 128 128s-57.3 128-128 128H192c-70.7 0-128-57.3-128-128s57.3-128 128-128H384zM576 256c0-106-86-192-192-192H192C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192zM192 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
    ]
};
var $5c8203742f0e3062$export$2a0fcb66c3d79d00 = {
    prefix: "fas",
    iconName: "box-archive",
    icon: [
        512,
        512,
        [
            "archive"
        ],
        "f187",
        "M32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64C0 46.3 14.3 32 32 32zm0 128H480V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V160zm128 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
    ]
};
var $5c8203742f0e3062$export$26b3e1c454273f34 = $5c8203742f0e3062$export$2a0fcb66c3d79d00;
var $5c8203742f0e3062$export$bac321083217fd4 = {
    prefix: "fas",
    iconName: "person-drowning",
    icon: [
        576,
        512,
        [],
        "e545",
        "M192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V96.2c0 54.1 23.5 104 62.2 138.3l-21 146.7c7.8 2.1 15.5 3.3 22.8 3.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c12.4 8.5 26.1 14.8 39.7 18l17.7-97.6c10.7-1.2 21.3-3.1 31.9-5.5l105-23.9c17.2-3.9 28-21.1 24.1-38.3s-21.1-28-38.3-24.1L400 216.6c-41 9.3-83.7 7.5-123.7-5.2c-50.2-16-84.3-62.6-84.3-115.3V64zM320 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM306.5 389.9c-11.1-7.9-25.9-7.9-37 0C247 405.4 219.5 416 192 416c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 469.7 159 480 192 480c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 405.2 410.9 416 384 416c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
var $5c8203742f0e3062$export$6cc91ce23eb3fae1 = {
    prefix: "fas",
    iconName: "arrow-down-9-1",
    icon: [
        576,
        512,
        [
            "sort-numeric-desc",
            "sort-numeric-down-alt"
        ],
        "f886",
        "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM450.7 294c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V416H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V320c0-10.3-4.9-19.9-13.3-26zM418.3 91a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 91zM405.1 203.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
    ]
};
var $5c8203742f0e3062$export$99f058110e2c82a8 = $5c8203742f0e3062$export$6cc91ce23eb3fae1;
var $5c8203742f0e3062$export$857385fda7a5a98e = $5c8203742f0e3062$export$6cc91ce23eb3fae1;
var $5c8203742f0e3062$export$8eee2c17ff89e724 = {
    prefix: "fas",
    iconName: "face-grin-tongue-squint",
    icon: [
        512,
        512,
        [
            128541,
            "grin-tongue-squint"
        ],
        "f58a",
        "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM116 141.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $5c8203742f0e3062$export$4edf34c3def09a31 = $5c8203742f0e3062$export$8eee2c17ff89e724;
var $5c8203742f0e3062$export$4952c502f544cf85 = {
    prefix: "fas",
    iconName: "spray-can",
    icon: [
        512,
        512,
        [],
        "f5bd",
        "M128 0h64c17.7 0 32 14.3 32 32v96H96V32c0-17.7 14.3-32 32-32zM0 256c0-53 43-96 96-96H224c53 0 96 43 96 96V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V256zm240 80A80 80 0 1 0 80 336a80 80 0 1 0 160 0zM256 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM448 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$24b8a0147653649a = {
    prefix: "fas",
    iconName: "truck-monster",
    icon: [
        640,
        512,
        [],
        "f63b",
        "M288 64v64H416L368 64H288zM419.2 25.6L496 128h80c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64H288c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H224V48c0-26.5 21.5-48 48-48h96c20.1 0 39.1 9.5 51.2 25.6zM152 256h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.7 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.3 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.3 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.8 3.7-14.1 6.8-21.7 9C190.1 503.1 180.1 512 168 512H152c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2L63.8 468.9c-8.6-8.6-9.3-21.9-2.3-31.3c-3.7-6.9-6.8-14.1-9-21.8C40.9 414.1 32 404.1 32 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.3-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9c1.7-11.6 11.7-20.6 23.8-20.6zm8 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM448.2 276.6c1.7-11.6 11.7-20.6 23.8-20.6h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.8 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.2 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.2 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.9 3.7-14.1 6.8-21.8 9C510.1 503.1 500.1 512 488 512H472c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2l-11.3-11.3c-8.6-8.6-9.3-21.9-2.2-31.3c-3.7-6.9-6.8-14.1-9-21.8C360.9 414.1 352 404.1 352 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.2-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9zM528 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $5c8203742f0e3062$export$c7f24bdea332f90a = {
    prefix: "fas",
    iconName: "w",
    icon: [
        576,
        512,
        [
            119
        ],
        "57",
        "M20.8 34c16.5-6.2 35 2.2 41.2 18.7l110.2 294L257.3 55c4-13.7 16.5-23 30.7-23s26.7 9.4 30.7 23l85.1 291.7L514 52.8c6.2-16.5 24.6-24.9 41.2-18.7s24.9 24.7 18.7 41.2l-144 384c-4.8 12.9-17.4 21.3-31.2 20.7s-25.7-9.8-29.5-23L288 178.3 206.7 457c-3.9 13.2-15.8 22.5-29.5 23s-26.3-7.8-31.2-20.7L2 75.2C-4.2 58.7 4.2 40.2 20.8 34z"
    ]
};
var $5c8203742f0e3062$export$11afa141d42099d0 = {
    prefix: "fas",
    iconName: "earth-africa",
    icon: [
        512,
        512,
        [
            127757,
            "globe-africa"
        ],
        "f57c",
        "M177.8 63.2l10 17.4c2.8 4.8 4.2 10.3 4.2 15.9v41.4c0 3.9 1.6 7.7 4.3 10.4c6.2 6.2 16.5 5.7 22-1.2l13.6-17c4.7-5.9 12.9-7.7 19.6-4.3l15.2 7.6c3.4 1.7 7.2 2.6 11 2.6c6.5 0 12.8-2.6 17.4-7.2l3.9-3.9c2.9-2.9 7.3-3.6 11-1.8l29.2 14.6c7.8 3.9 12.6 11.8 12.6 20.5c0 10.5-7.1 19.6-17.3 22.2l-35.4 8.8c-7.4 1.8-15.1 1.5-22.4-.9l-32-10.7c-3.3-1.1-6.7-1.7-10.2-1.7c-7 0-13.8 2.3-19.4 6.5L176 212c-10.1 7.6-16 19.4-16 32v28c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16v48c0 17.7 14.3 32 32 32c10.1 0 19.6-4.7 25.6-12.8l25.6-34.1c8.3-11.1 12.8-24.6 12.8-38.4V318.6c0-3.9 2.6-7.3 6.4-8.2l5.3-1.3c11.9-3 20.3-13.7 20.3-26c0-7.1-2.8-13.9-7.8-18.9l-33.5-33.5c-3.7-3.7-3.7-9.7 0-13.4c5.7-5.7 14.1-7.7 21.8-5.1l14.1 4.7c12.3 4.1 25.7-1.5 31.5-13c3.5-7 11.2-10.8 18.9-9.2l27.4 5.5C432 112.4 351.5 48 256 48c-27.7 0-54 5.4-78.2 15.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var $5c8203742f0e3062$export$64af36f3b403a57c = $5c8203742f0e3062$export$11afa141d42099d0;
var $5c8203742f0e3062$export$92ab27739d3a91b2 = {
    prefix: "fas",
    iconName: "rainbow",
    icon: [
        640,
        512,
        [
            127752
        ],
        "f75b",
        "M320 96C178.6 96 64 210.6 64 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C0 175.3 143.3 32 320 32s320 143.3 320 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C576 210.6 461.4 96 320 96zm0 192c-35.3 0-64 28.7-64 64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-70.7 57.3-128 128-128s128 57.3 128 128v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-35.3-28.7-64-64-64zM160 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-123.7 100.3-224 224-224s224 100.3 224 224v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-88.4-71.6-160-160-160s-160 71.6-160 160z"
    ]
};
var $5c8203742f0e3062$export$9429fd8df55155d = {
    prefix: "fas",
    iconName: "circle-notch",
    icon: [
        512,
        512,
        [],
        "f1ce",
        "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"
    ]
};
var $5c8203742f0e3062$export$df1e253fc358ade4 = {
    prefix: "fas",
    iconName: "tablet-screen-button",
    icon: [
        448,
        512,
        [
            "tablet-alt"
        ],
        "f3fa",
        "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM256 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 64H64V384H384V64z"
    ]
};
var $5c8203742f0e3062$export$db0cac088255eacc = $5c8203742f0e3062$export$df1e253fc358ade4;
var $5c8203742f0e3062$export$7bc6e4d977673e69 = {
    prefix: "fas",
    iconName: "paw",
    icon: [
        512,
        512,
        [],
        "f1b0",
        "M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3v-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z"
    ]
};
var $5c8203742f0e3062$export$8bb3c4d5c2f50243 = {
    prefix: "fas",
    iconName: "cloud",
    icon: [
        640,
        512,
        [
            9729
        ],
        "f0c2",
        "M0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z"
    ]
};
var $5c8203742f0e3062$export$b6c20c10ddbd9898 = {
    prefix: "fas",
    iconName: "trowel-bricks",
    icon: [
        512,
        512,
        [],
        "e58a",
        "M240.8 4.8C250.3 10.6 256 20.9 256 32v72h89c3.6-13.8 16.1-24 31-24h88c26.5 0 48 21.5 48 48s-21.5 48-48 48H376c-14.9 0-27.4-10.2-31-24H256v72c0 11.1-5.7 21.4-15.2 27.2s-21.2 6.4-31.1 1.4l-192-96C6.8 151.2 0 140.1 0 128s6.8-23.2 17.7-28.6l192-96c9.9-5 21.7-4.4 31.1 1.4zM288 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V256zM32 384h96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zm192 0H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$ba5dc4287853ecbd = {
    prefix: "fas",
    iconName: "face-flushed",
    icon: [
        512,
        512,
        [
            128563,
            "flushed"
        ],
        "f579",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 384c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm-16-88a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm264-72a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zm-288 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm192 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $5c8203742f0e3062$export$dfd2bd012685aeac = $5c8203742f0e3062$export$ba5dc4287853ecbd;
var $5c8203742f0e3062$export$684703c93d630cc5 = {
    prefix: "fas",
    iconName: "hospital-user",
    icon: [
        576,
        512,
        [],
        "f80d",
        "M48 0C21.5 0 0 21.5 0 48V256H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v64H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v80c0 26.5 21.5 48 48 48H265.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM152 64h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H184v24c0 8.8-7.2 16-16 16H152c-8.8 0-16-7.2-16-16V152H112c-8.8 0-16-7.2-16-16V120c0-8.8 7.2-16 16-16h24V80c0-8.8 7.2-16 16-16zM512 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM288 477.1c0 19.3 15.6 34.9 34.9 34.9H541.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H381.1c-51.4 0-93.1 41.7-93.1 93.1z"
    ]
};
var $5c8203742f0e3062$export$fa95eb7418c0e2b8 = {
    prefix: "fas",
    iconName: "tent-arrow-left-right",
    icon: [
        576,
        512,
        [],
        "e57f",
        "M488.1 6.2c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9L489.5 72 86.5 72l33.5-30.2c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120l402.9 0-33.5 30.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H240h16c17.7 0 32-14.3 32-32V361.9c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7H464h16c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $5c8203742f0e3062$export$c36fb40057e2c3aa = {
    prefix: "fas",
    iconName: "gavel",
    icon: [
        512,
        512,
        [
            "legal"
        ],
        "f0e3",
        "M318.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-120 120c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l4-4L325.4 293.4l-4 4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l120-120c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0l-4 4L330.6 74.6l4-4c12.5-12.5 12.5-32.8 0-45.3l-16-16zm-152 288c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l48 48c12.5 12.5 32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-1.4-1.4L272 285.3 226.7 240 168 298.7l-1.4-1.4z"
    ]
};
var $5c8203742f0e3062$export$59d593c2dacb3781 = $5c8203742f0e3062$export$c36fb40057e2c3aa;
var $5c8203742f0e3062$export$8a910017964bb8c2 = {
    prefix: "fas",
    iconName: "binoculars",
    icon: [
        512,
        512,
        [],
        "f1e5",
        "M128 32h32c17.7 0 32 14.3 32 32V96H96V64c0-17.7 14.3-32 32-32zm64 96V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V388.9c0-34.6 9.4-68.6 27.2-98.3C40.9 267.8 49.7 242.4 53 216L60.5 156c2-16 15.6-28 31.8-28H192zm227.8 0c16.1 0 29.8 12 31.8 28L459 216c3.3 26.4 12.1 51.8 25.8 74.6c17.8 29.7 27.2 63.7 27.2 98.3V448c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V128h99.8zM320 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V96H320V64zm-32 64V288H224V128h64z"
    ]
};
var $5c8203742f0e3062$export$843f63d64e6f7951 = {
    prefix: "fas",
    iconName: "microphone-slash",
    icon: [
        640,
        512,
        [],
        "f131",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 21.2-5.1 41.1-14.2 58.7L416 300.8V96c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zm362.5 407l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2z"
    ]
};
var $5c8203742f0e3062$export$f2adc06617bc0c7 = {
    prefix: "fas",
    iconName: "box-tissue",
    icon: [
        512,
        512,
        [],
        "e05b",
        "M92.5 0H208c40 0 52 24 64 48s24 48 64 48h85.2C436 96 448 108 448 122.8c0 3.4-.7 6.8-1.9 10L409.6 224 384 288H128l-16-64L64.9 35.4c-.6-2.3-.9-4.6-.9-6.9C64 12.8 76.8 0 92.5 0zM79 224l16 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48H384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H418.5l25.6-64H464c26.5 0 48 21.5 48 48V384H0V272c0-26.5 21.5-48 48-48H79zM0 416H512v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V416z"
    ]
};
var $5c8203742f0e3062$export$f26017bdca99338d = {
    prefix: "fas",
    iconName: "motorcycle",
    icon: [
        640,
        512,
        [
            127949
        ],
        "f21c",
        "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h57.7l16.4 30.3L256 192l-45.3-45.3c-12-12-28.3-18.7-45.3-18.7H64c-17.7 0-32 14.3-32 32v32h96c88.4 0 160 71.6 160 160c0 11-1.1 21.7-3.2 32h70.4c-2.1-10.3-3.2-21-3.2-32c0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L418.2 128H480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H459.6c-7.5 0-14.7 2.6-20.5 7.4L391.7 78.9l-14-26c-7-12.9-20.5-21-35.2-21H280zM462.7 311.2l28.2 52.2c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-28.2-52.2c2.3-.3 4.7-.4 7.1-.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-15.5 5.5-29.7 14.7-40.8zM187.3 376c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40h66.4C242.5 268.8 190.5 224 128 224C57.3 224 0 281.3 0 352s57.3 128 128 128c62.5 0 114.5-44.8 125.8-104H187.3zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$e433538b78718fb3 = {
    prefix: "fas",
    iconName: "bell-concierge",
    icon: [
        512,
        512,
        [
            128718,
            "concierge-bell"
        ],
        "f562",
        "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368H480c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
    ]
};
var $5c8203742f0e3062$export$ad92ffbbfbc0fcf3 = $5c8203742f0e3062$export$e433538b78718fb3;
var $5c8203742f0e3062$export$85ba06027671d290 = {
    prefix: "fas",
    iconName: "pen-ruler",
    icon: [
        512,
        512,
        [
            "pencil-ruler"
        ],
        "f5ae",
        "M469.3 19.3l23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4L322.3 75.7l56.4-56.4c25-25 65.5-25 90.5 0zM44.9 353.2L299.7 98.3 413.7 212.3 158.8 467.1c-6.7 6.7-15.1 11.6-24.2 14.2l-104 29.7c-8.4 2.4-17.4 .1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2zM249.4 103.4L103.4 249.4 16 161.9c-18.7-18.7-18.7-49.1 0-67.9L94.1 16c18.7-18.7 49.1-18.7 67.9 0l19.8 19.8c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1l45.1 45.1zM408.6 262.6l45.1 45.1c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1L496 350.1c18.7 18.7 18.7 49.1 0 67.9L417.9 496c-18.7 18.7-49.1 18.7-67.9 0l-87.4-87.4L408.6 262.6z"
    ]
};
var $5c8203742f0e3062$export$e3a7a1affea005f5 = $5c8203742f0e3062$export$85ba06027671d290;
var $5c8203742f0e3062$export$804bfc5c390e1a2a = {
    prefix: "fas",
    iconName: "people-arrows",
    icon: [
        640,
        512,
        [
            "people-arrows-left-right"
        ],
        "e068",
        "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM25.9 233.4C29.3 191.9 64 160 105.6 160h44.8c27 0 51 13.4 65.5 34.1c-2.7 1.9-5.2 4-7.5 6.3l-64 64c-21.9 21.9-21.9 57.3 0 79.2L192 391.2V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM448 64a64 64 0 1 1 128 0A64 64 0 1 1 448 64zM431.6 200.4c-2.3-2.3-4.9-4.4-7.5-6.3c14.5-20.7 38.6-34.1 65.5-34.1h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48H496c-26.5 0-48-21.5-48-48V391.2l47.6-47.6c21.9-21.9 21.9-57.3 0-79.2l-64-64zM272 240v32h96V240c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V336H272v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2z"
    ]
};
var $5c8203742f0e3062$export$da01f044c59e3598 = $5c8203742f0e3062$export$804bfc5c390e1a2a;
var $5c8203742f0e3062$export$1dc6221efb867885 = {
    prefix: "fas",
    iconName: "mars-and-venus-burst",
    icon: [
        640,
        512,
        [],
        "e523",
        "M504 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l39 39-22.2 22.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160c0 80.2 59 146.6 136 158.2V408H352c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v32c0 13.3 10.7 24 24 24s24-10.7 24-24V456h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H424V382.2c77-11.6 136-78 136-158.2c0-31.4-9-60.7-24.7-85.4L560 113.9l39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H504zM400 128a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.1 3.8 9.9 5.1 15.2 3.6C223.6 310.8 208 269.2 208 224c0-60.8 28.3-115 72.4-150.2L220.3 92.1l-29.4-74z"
    ]
};
var $5c8203742f0e3062$export$5b1d41cdd118ea6d = {
    prefix: "fas",
    iconName: "square-caret-right",
    icon: [
        448,
        512,
        [
            "caret-square-right"
        ],
        "f152",
        "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
    ]
};
var $5c8203742f0e3062$export$ae86c9de7e0f62fa = $5c8203742f0e3062$export$5b1d41cdd118ea6d;
var $5c8203742f0e3062$export$b2a906a5928c6404 = {
    prefix: "fas",
    iconName: "scissors",
    icon: [
        512,
        512,
        [
            9984,
            9986,
            9988,
            "cut"
        ],
        "f0c4",
        "M256 192l-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256l-39.5 39.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6c-28.3-28.3-74.1-28.3-102.4 0L256 192zm22.6 150.6L396.8 460.8c28.3 28.3 74.1 28.3 102.4 0c7.1-7.1 7.1-18.5 0-25.6L342.6 278.6l-64 64zM64 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $5c8203742f0e3062$export$66847f2a71b260e7 = $5c8203742f0e3062$export$b2a906a5928c6404;
var $5c8203742f0e3062$export$8db7f2f70484e17e = {
    prefix: "fas",
    iconName: "sun-plant-wilt",
    icon: [
        640,
        512,
        [],
        "e57a",
        "M160 0c-6.3 0-12 3.7-14.6 9.5L120.6 64.9 63.9 43.2c-5.9-2.3-12.6-.8-17 3.6s-5.9 11.1-3.6 17l21.7 56.7L9.5 145.4C3.7 148 0 153.7 0 160s3.7 12 9.5 14.6l55.4 24.8L43.2 256.1c-2.3 5.9-.8 12.6 3.6 17s11.1 5.9 17 3.6l56.7-21.7 24.8 55.4c2.6 5.8 8.3 9.5 14.6 9.5s12-3.7 14.6-9.5l24.8-55.4 56.7 21.7c5.9 2.3 12.6 .8 17-3.6s5.9-11.1 3.6-17l-21.7-56.7 55.4-24.8c5.8-2.6 9.5-8.3 9.5-14.6s-3.7-12-9.5-14.6l-55.4-24.8 21.7-56.7c2.3-5.9 .8-12.6-3.6-17s-11.1-5.9-17-3.6L199.4 64.9 174.6 9.5C172 3.7 166.3 0 160 0zm0 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm312 16c0-17.7 14.3-32 32-32s32 14.3 32 32v53.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C624 318 640 290.7 640 274c0-21.5-9.2-37-24-44.6V176c0-44.2-35.8-80-80-80s-80 35.8-80 80v22.7c-9.8-4.3-20.6-6.7-32-6.7c-44.2 0-80 35.8-80 80v21.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C400 382 416 354.7 416 338c0-21.5-9.2-37-24-44.6V272c0-17.7 14.3-32 32-32s32 14.3 32 32v8V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H504V280v-8V176z"
    ]
};
var $5c8203742f0e3062$export$c00f55f36d386cb7 = {
    prefix: "fas",
    iconName: "toilets-portable",
    icon: [
        576,
        512,
        [],
        "e584",
        "M32 0H224c17.7 0 32 14.3 32 32V64H0V32C0 14.3 14.3 0 32 0zM0 96H24 232h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM192 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zM352 0H544c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32zM320 96h24H552h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H368v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM512 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16z"
    ]
};
var $5c8203742f0e3062$export$a274b02dc75663dc = {
    prefix: "fas",
    iconName: "hockey-puck",
    icon: [
        512,
        512,
        [],
        "f453",
        "M256 256C114.6 256 0 213 0 160s114.6-96 256-96s256 43 256 96s-114.6 96-256 96zm192.3 1.8c24.7-9.3 46.9-21 63.7-35.6V352c0 53-114.6 96-256 96S0 405 0 352V222.3c16.8 14.6 39 26.3 63.7 35.6C114.5 276.9 182.5 288 256 288s141.5-11.1 192.3-30.2z"
    ]
};
var $5c8203742f0e3062$export$36583f5d3d5a971f = {
    prefix: "fas",
    iconName: "table",
    icon: [
        512,
        512,
        [],
        "f0ce",
        "M64 256V160H224v96H64zm0 64H224v96H64V320zm224 96V320H448v96H288zM448 256H288V160H448v96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $5c8203742f0e3062$export$382d3376c7fc7fc5 = {
    prefix: "fas",
    iconName: "magnifying-glass-arrow-right",
    icon: [
        512,
        512,
        [],
        "e521",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM241 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H238.1l-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72z"
    ]
};
var $5c8203742f0e3062$export$73f2bf302381c86a = {
    prefix: "fas",
    iconName: "tachograph-digital",
    icon: [
        640,
        512,
        [
            "digital-tachograph"
        ],
        "f566",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm32 64H320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zM64 368c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM80 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $5c8203742f0e3062$export$b3bf1994f0fefe98 = $5c8203742f0e3062$export$73f2bf302381c86a;
var $5c8203742f0e3062$export$b71a093b86e3da1f = {
    prefix: "fas",
    iconName: "users-slash",
    icon: [
        640,
        512,
        [],
        "e073",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 30.2-10.5 58-28 79.9l-25.2-19.7C408.1 267.7 416 246.8 416 224c0-53-43-96-96-96c-31.1 0-58.7 14.8-76.3 37.7l-40.6-31.8c13-14.2 20.9-33.1 20.9-53.9c0-44.2-35.8-80-80-80C116.3 0 91.9 14.1 77.5 35.5L38.8 5.1zM106.7 192C47.8 192 0 239.8 0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192H106.7zM261.3 352C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c10.5 0 19.5-6 23.9-14.8L324.9 352H261.3zM512 160A80 80 0 1 0 512 0a80 80 0 1 0 0 160z"
    ]
};
var $5c8203742f0e3062$export$57813571c0e10a0a = {
    prefix: "fas",
    iconName: "clover",
    icon: [
        448,
        512,
        [],
        "e139",
        "M216.6 49.9C205.1 38.5 189.5 32 173.3 32C139.4 32 112 59.4 112 93.3v4.9c0 12 3.3 23.7 9.4 34l18.8 31.3c1.1 1.8 1.2 3.1 1 4.2c-.2 1.2-.8 2.5-2 3.6s-2.4 1.8-3.6 2c-1 .2-2.4 .1-4.2-1l-31.3-18.8c-10.3-6.2-22-9.4-34-9.4H61.3C27.4 144 0 171.4 0 205.3c0 16.2 6.5 31.8 17.9 43.3l1.2 1.2c3.4 3.4 3.4 9 0 12.4l-1.2 1.2C6.5 274.9 0 290.5 0 306.7C0 340.6 27.4 368 61.3 368h4.9c12 0 23.7-3.3 34-9.4l31.3-18.8c1.8-1.1 3.1-1.2 4.2-1c1.2 .2 2.5 .8 3.6 2s1.8 2.4 2 3.6c.2 1 .1 2.4-1 4.2l-18.8 31.3c-6.2 10.3-9.4 22-9.4 34v4.9c0 33.8 27.4 61.3 61.3 61.3c16.2 0 31.8-6.5 43.3-17.9l1.2-1.2c3.4-3.4 9-3.4 12.4 0l1.2 1.2c11.5 11.5 27.1 17.9 43.3 17.9c33.8 0 61.3-27.4 61.3-61.3v-4.9c0-12-3.3-23.7-9.4-34l-18.8-31.3c-1.1-1.8-1.2-3.1-1-4.2c.2-1.2 .8-2.5 2-3.6s2.4-1.8 3.6-2c1-.2 2.4-.1 4.2 1l31.3 18.8c10.3 6.2 22 9.4 34 9.4h4.9c33.8 0 61.3-27.4 61.3-61.3c0-16.2-6.5-31.8-17.9-43.3l-1.2-1.2c-3.4-3.4-3.4-9 0-12.4l1.2-1.2c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3h-4.9c-12 0-23.7 3.3-34 9.4l-31.3 18.8c-1.8 1.1-3.1 1.2-4.2 1c-1.2-.2-2.5-.8-3.6-2s-1.8-2.4-2-3.6c-.2-1-.1-2.4 1-4.2l18.8-31.3c6.2-10.3 9.4-22 9.4-34V93.3C336 59.4 308.6 32 274.7 32c-16.2 0-31.8 6.5-43.3 17.9l-1.2 1.2c-3.4 3.4-9 3.4-12.4 0l-1.2-1.2z"
    ]
};
var $5c8203742f0e3062$export$bb06d4a7bb6736fe = {
    prefix: "fas",
    iconName: "reply",
    icon: [
        512,
        512,
        [
            61714,
            "mail-reply"
        ],
        "f3e5",
        "M205 34.8c11.5 5.1 19 16.6 19 29.2v64H336c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H224v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z"
    ]
};
var $5c8203742f0e3062$export$12e45ff70d2646a1 = $5c8203742f0e3062$export$bb06d4a7bb6736fe;
var $5c8203742f0e3062$export$cafa834c96ebcb1a = {
    prefix: "fas",
    iconName: "star-and-crescent",
    icon: [
        512,
        512,
        [
            9770
        ],
        "f699",
        "M0 256C0 114.6 114.6 0 256 0c33 0 64.6 6.3 93.6 17.7c7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-4.8-.3-9.7-.5-14.6-.5c-114.9 0-208 93.1-208 208s93.1 208 208 208c4.9 0 9.8-.2 14.6-.5c7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4C320.6 505.7 289 512 256 512C114.6 512 0 397.4 0 256zM375.4 137.4c3.5-7.1 13.7-7.1 17.2 0l31.5 63.8c1.4 2.8 4.1 4.8 7.2 5.3l70.4 10.2c7.9 1.1 11 10.8 5.3 16.4l-50.9 49.6c-2.3 2.2-3.3 5.4-2.8 8.5l12 70.1c1.3 7.8-6.9 13.8-13.9 10.1l-63-33.1c-2.8-1.5-6.1-1.5-8.9 0l-63 33.1c-7 3.7-15.3-2.3-13.9-10.1l12-70.1c.5-3.1-.5-6.3-2.8-8.5L261 233.1c-5.7-5.6-2.6-15.2 5.3-16.4l70.4-10.2c3.1-.5 5.8-2.4 7.2-5.3l31.5-63.8z"
    ]
};
var $5c8203742f0e3062$export$947ee033a6942aa8 = {
    prefix: "fas",
    iconName: "house-fire",
    icon: [
        640,
        512,
        [],
        "e50c",
        "M288 350.1l0 1.9H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L447.3 128.1c-12.3-1-25 3-34.8 11.7c-35.4 31.6-65.6 67.7-87.3 102.8C304.3 276.5 288 314.9 288 350.1zM480 512c-88.4 0-160-71.6-160-160c0-76.7 62.5-144.7 107.2-179.4c5-3.9 10.9-5.8 16.8-5.8c7.9-.1 16 3.1 22 9.2l46 46 11.3-11.3c11.7-11.7 30.6-12.7 42.3-1C624.5 268 640 320.2 640 352c0 88.4-71.6 160-160 160zm64-111.8c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C453 327.1 416 363.6 416 400.2c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $5c8203742f0e3062$export$814c9edba7b84aa4 = {
    prefix: "fas",
    iconName: "square-minus",
    icon: [
        448,
        512,
        [
            61767,
            "minus-square"
        ],
        "f146",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 200H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $5c8203742f0e3062$export$ffe9387966b3e681 = $5c8203742f0e3062$export$814c9edba7b84aa4;
var $5c8203742f0e3062$export$612d3e1afaf45fa5 = {
    prefix: "fas",
    iconName: "helicopter",
    icon: [
        640,
        512,
        [
            128641
        ],
        "f533",
        "M128 32c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H384v64h32c88.4 0 160 71.6 160 160v64c0 17.7-14.3 32-32 32H384 320c-20.1 0-39.1-9.5-51.2-25.6l-71.4-95.2c-3.5-4.7-8.3-8.3-13.7-10.5L47.2 198.1c-9.5-3.8-16.7-12-19.2-22L5 83.9C2.4 73.8 10.1 64 20.5 64H48c10.1 0 19.6 4.7 25.6 12.8L112 128H320V64H160c-17.7 0-32-14.3-32-32zM384 320H512V288c0-53-43-96-96-96H384V320zM630.6 425.4c12.5 12.5 12.5 32.8 0 45.3l-3.9 3.9c-24 24-56.6 37.5-90.5 37.5H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H536.2c17 0 33.3-6.7 45.3-18.7l3.9-3.9c12.5-12.5 32.8-12.5 45.3 0z"
    ]
};
var $5c8203742f0e3062$export$b4d344633433e50e = {
    prefix: "fas",
    iconName: "compass",
    icon: [
        512,
        512,
        [
            129517
        ],
        "f14e",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm50.7-186.9L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $5c8203742f0e3062$export$a1ab39cd66c4e50e = {
    prefix: "fas",
    iconName: "square-caret-down",
    icon: [
        448,
        512,
        [
            "caret-square-down"
        ],
        "f150",
        "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
    ]
};
var $5c8203742f0e3062$export$61aea18df1c84401 = $5c8203742f0e3062$export$a1ab39cd66c4e50e;
var $5c8203742f0e3062$export$877d3692c1f94bda = {
    prefix: "fas",
    iconName: "file-circle-question",
    icon: [
        576,
        512,
        [],
        "e4ef",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"
    ]
};
var $5c8203742f0e3062$export$94100f4c6ee29932 = {
    prefix: "fas",
    iconName: "laptop-code",
    icon: [
        640,
        512,
        [],
        "f5fc",
        "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 175l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var $5c8203742f0e3062$export$c74a20c81b957b6a = {
    prefix: "fas",
    iconName: "swatchbook",
    icon: [
        512,
        512,
        [],
        "f5c3",
        "M0 32C0 14.3 14.3 0 32 0H160c17.7 0 32 14.3 32 32V416c0 53-43 96-96 96s-96-43-96-96V32zM223.6 425.9c.3-3.3 .4-6.6 .4-9.9V154l75.4-75.4c12.5-12.5 32.8-12.5 45.3 0l90.5 90.5c12.5 12.5 12.5 32.8 0 45.3L223.6 425.9zM182.8 512l192-192H480c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H182.8zM128 64H64v64h64V64zM64 192v64h64V192H64zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $5c8203742f0e3062$export$214f9ce665590486 = {
    prefix: "fas",
    iconName: "prescription-bottle",
    icon: [
        384,
        512,
        [],
        "f485",
        "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V416H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V320H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V224H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V128z"
    ]
};
var $5c8203742f0e3062$export$36e9cf7887265da2 = {
    prefix: "fas",
    iconName: "bars",
    icon: [
        448,
        512,
        [
            "navicon"
        ],
        "f0c9",
        "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $5c8203742f0e3062$export$409fa7bcaa0e4cd9 = $5c8203742f0e3062$export$36e9cf7887265da2;
var $5c8203742f0e3062$export$be015e72863c3635 = {
    prefix: "fas",
    iconName: "people-group",
    icon: [
        640,
        512,
        [],
        "e533",
        "M72 88a56 56 0 1 1 112 0A56 56 0 1 1 72 88zM64 245.7C54 256.9 48 271.8 48 288s6 31.1 16 42.3V245.7zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V389.2C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112h32c24 0 46.2 7.5 64.4 20.3zM448 416V394.5c20-24.7 32-56.2 32-90.5c0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112c0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32zm8-328a56 56 0 1 1 112 0A56 56 0 1 1 456 88zM576 245.7v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM240 304c0 16.2 6 31 16 42.3V261.7c-10 11.3-16 26.1-16 42.3zm144-42.3v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM448 304c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V405.2c-37.8-18-64-56.5-64-101.2c0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112z"
    ]
};
var $5c8203742f0e3062$export$52757ecc5b1e25b9 = {
    prefix: "fas",
    iconName: "hourglass-end",
    icon: [
        384,
        512,
        [
            8987,
            "hourglass-3"
        ],
        "f253",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 25.5-10.1 49.9-28.1 67.9L192 210.7l-67.9-67.9C106.1 124.9 96 100.4 96 75z"
    ]
};
var $5c8203742f0e3062$export$1ec43c81fef8ffd6 = $5c8203742f0e3062$export$52757ecc5b1e25b9;
var $5c8203742f0e3062$export$8e521ef33062b00e = {
    prefix: "fas",
    iconName: "heart-crack",
    icon: [
        512,
        512,
        [
            128148,
            "heart-broken"
        ],
        "f7a9",
        "M119.4 44.1c23.3-3.9 46.8-1.9 68.6 5.3l49.8 77.5-75.4 75.4c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5 .3s3.8-7 1.7-10.4l-60.4-98.1 90.7-75.6c2.6-2.1 3.5-5.7 2.4-8.8L296.8 61.8c28.5-16.7 62.4-23.2 95.7-17.6C461.5 55.6 512 115.2 512 185.1v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141z"
    ]
};
var $5c8203742f0e3062$export$4a565395cb65b282 = $5c8203742f0e3062$export$8e521ef33062b00e;
var $5c8203742f0e3062$export$a47a20ab7bde8c67 = {
    prefix: "fas",
    iconName: "square-up-right",
    icon: [
        448,
        512,
        [
            8599,
            "external-link-square-alt"
        ],
        "f360",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM320 313.4V176c0-8.8-7.2-16-16-16H166.6c-12.5 0-22.6 10.1-22.6 22.6c0 6 2.4 11.8 6.6 16L184 232l-66.3 66.3C114 302 112 306.9 112 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L248 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6z"
    ]
};
var $5c8203742f0e3062$export$e4cdf2977151ee26 = $5c8203742f0e3062$export$a47a20ab7bde8c67;
var $5c8203742f0e3062$export$eca99665af566fe1 = {
    prefix: "fas",
    iconName: "face-kiss-beam",
    icon: [
        512,
        512,
        [
            128537,
            "kiss-beam"
        ],
        "f597",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-84.9l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $5c8203742f0e3062$export$d6ff8a73c0812e63 = $5c8203742f0e3062$export$eca99665af566fe1;
var $5c8203742f0e3062$export$c03de0cc616e77bb = {
    prefix: "fas",
    iconName: "film",
    icon: [
        512,
        512,
        [
            127902
        ],
        "f008",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM48 368v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H416zM48 240v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H416zM48 112v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zM416 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H416zM160 128v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm32 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H192z"
    ]
};
var $5c8203742f0e3062$export$46c6347bff3e04a = {
    prefix: "fas",
    iconName: "ruler-horizontal",
    icon: [
        640,
        512,
        [],
        "f547",
        "M0 336c0 26.5 21.5 48 48 48l544 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0c-26.5 0-48 21.5-48 48L0 336z"
    ]
};
var $5c8203742f0e3062$export$75ce8513e1f1c5c4 = {
    prefix: "fas",
    iconName: "people-robbery",
    icon: [
        576,
        512,
        [],
        "e536",
        "M488.2 59.1C478.1 99.6 441.7 128 400 128s-78.1-28.4-88.2-68.9L303 24.2C298.8 7.1 281.4-3.3 264.2 1S236.7 22.6 241 39.8l8.7 34.9c11 44 40.2 79.6 78.3 99.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V174.3c38.1-20 67.3-55.6 78.3-99.6L559 39.8c4.3-17.1-6.1-34.5-23.3-38.8S501.2 7.1 497 24.2l-8.7 34.9zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zm-8 32c-35.3 0-64 28.7-64 64v96l0 .6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352H88V480c0 17.7 14.3 32 32 32s32-14.3 32-32V252.7l13 20.5c5.9 9.2 16.1 14.9 27 14.9h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H209.6l-37.4-58.9C157.6 142 132.1 128 104.7 128H72z"
    ]
};
var $5c8203742f0e3062$export$1e80f89fe84a215b = {
    prefix: "fas",
    iconName: "lightbulb",
    icon: [
        384,
        512,
        [
            128161
        ],
        "f0eb",
        "M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"
    ]
};
var $5c8203742f0e3062$export$85a918a11b7643c2 = {
    prefix: "fas",
    iconName: "caret-left",
    icon: [
        256,
        512,
        [],
        "f0d9",
        "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"
    ]
};
var $5c8203742f0e3062$export$59573943f9eebbd5 = {
    prefix: "fas",
    iconName: "circle-exclamation",
    icon: [
        512,
        512,
        [
            "exclamation-circle"
        ],
        "f06a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $5c8203742f0e3062$export$220e07e14c5d7e5d = $5c8203742f0e3062$export$59573943f9eebbd5;
var $5c8203742f0e3062$export$5e17b20e0f6b132b = {
    prefix: "fas",
    iconName: "school-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e56d",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"
    ]
};
var $5c8203742f0e3062$export$ca14f1b4d6afb7aa = {
    prefix: "fas",
    iconName: "arrow-right-from-bracket",
    icon: [
        512,
        512,
        [
            "sign-out"
        ],
        "f08b",
        "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 192 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z"
    ]
};
var $5c8203742f0e3062$export$33e2b60243ca6d92 = $5c8203742f0e3062$export$ca14f1b4d6afb7aa;
var $5c8203742f0e3062$export$aca07924996218d8 = {
    prefix: "fas",
    iconName: "circle-chevron-down",
    icon: [
        512,
        512,
        [
            "chevron-circle-down"
        ],
        "f13a",
        "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM135 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 345c-9.4 9.4-24.6 9.4-33.9 0L135 241z"
    ]
};
var $5c8203742f0e3062$export$9926124d75b2ecab = $5c8203742f0e3062$export$aca07924996218d8;
var $5c8203742f0e3062$export$c98fdd5082b333ec = {
    prefix: "fas",
    iconName: "unlock-keyhole",
    icon: [
        448,
        512,
        [
            "unlock-alt"
        ],
        "f13e",
        "M224 64c-44.2 0-80 35.8-80 80v48H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80V144C80 64.5 144.5 0 224 0c57.5 0 107 33.7 130.1 82.3c7.6 16 .8 35.1-15.2 42.6s-35.1 .8-42.6-15.2C283.4 82.6 255.9 64 224 64zm32 320c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h64z"
    ]
};
var $5c8203742f0e3062$export$b19f508797f3d9c3 = $5c8203742f0e3062$export$c98fdd5082b333ec;
var $5c8203742f0e3062$export$af51c741ee9cc090 = {
    prefix: "fas",
    iconName: "cloud-showers-heavy",
    icon: [
        512,
        512,
        [],
        "f740",
        "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zM81.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6S-3.3 490.7 1.9 478.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm120 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm244.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5zM313.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6z"
    ]
};
var $5c8203742f0e3062$export$ca47801915e5a685 = {
    prefix: "fas",
    iconName: "headphones-simple",
    icon: [
        512,
        512,
        [
            "headphones-alt"
        ],
        "f58f",
        "M256 80C141.1 80 48 173.1 48 288V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288C0 146.6 114.6 32 256 32s256 114.6 256 256V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288c0-114.9-93.1-208-208-208zM80 352c0-35.3 28.7-64 64-64h16c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V352zm288-64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h16z"
    ]
};
var $5c8203742f0e3062$export$6f0433fa527dd5be = $5c8203742f0e3062$export$ca47801915e5a685;
var $5c8203742f0e3062$export$b2ce5e79d0eccaf8 = {
    prefix: "fas",
    iconName: "sitemap",
    icon: [
        576,
        512,
        [],
        "f0e8",
        "M208 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-8v40H464c30.9 0 56 25.1 56 56v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-4.4-3.6-8-8-8H312v40h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V280H112c-4.4 0-8 3.6-8 8v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-30.9 25.1-56 56-56H264V192h-8c-26.5 0-48-21.5-48-48V80z"
    ]
};
var $5c8203742f0e3062$export$5f92ac3e804644e3 = {
    prefix: "fas",
    iconName: "circle-dollar-to-slot",
    icon: [
        512,
        512,
        [
            "donate"
        ],
        "f4b9",
        "M326.7 403.7c-22.1 8-45.9 12.3-70.7 12.3s-48.7-4.4-70.7-12.3c-.3-.1-.5-.2-.8-.3c-30-11-56.8-28.7-78.6-51.4C70 314.6 48 263.9 48 208C48 93.1 141.1 0 256 0S464 93.1 464 208c0 55.9-22 106.6-57.9 144c-1 1-2 2.1-3 3.1c-21.4 21.4-47.4 38.1-76.3 48.6zM256 84c-11 0-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104c0-11-9-20-20-20zM48 352H64c19.5 25.9 44 47.7 72.2 64H64v32H256 448V416H375.8c28.2-16.3 52.8-38.1 72.2-64h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z"
    ]
};
var $5c8203742f0e3062$export$40050ae52860cde7 = $5c8203742f0e3062$export$5f92ac3e804644e3;
var $5c8203742f0e3062$export$5f9bd9f6df021f93 = {
    prefix: "fas",
    iconName: "memory",
    icon: [
        576,
        512,
        [],
        "f538",
        "M64 64C28.7 64 0 92.7 0 128v7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6V320H576V248.6c0-6.8-4.4-12.6-10.1-16.3C552.7 223.7 544 208.9 544 192s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3V128c0-35.3-28.7-64-64-64H64zM576 352H0v64c0 17.7 14.3 32 32 32H80V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h48c17.7 0 32-14.3 32-32V352zM192 160v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $5c8203742f0e3062$export$b372a24046126ad8 = {
    prefix: "fas",
    iconName: "road-spikes",
    icon: [
        640,
        512,
        [],
        "e568",
        "M64 116.8c0-15.8 20.5-22 29.3-8.9L192 256V116.8c0-15.8 20.5-22 29.3-8.9L320 256V116.8c0-15.8 20.5-22 29.3-8.9L448 256V116.8c0-15.8 20.5-22 29.3-8.9L606.8 302.2c14.2 21.3-1.1 49.7-26.6 49.7H512 448 384 320 256 192 64V116.8zM32 384H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$e4e44f7b1886fef = {
    prefix: "fas",
    iconName: "fire-burner",
    icon: [
        640,
        512,
        [],
        "e4f1",
        "M345.7 48.3L358 34.5c5.4-6.1 13.3-8.8 20.9-8.9c7.2 0 14.3 2.6 19.9 7.8c19.7 18.3 39.8 43.2 55 70.6C469 131.2 480 162.2 480 192.2C480 280.8 408.7 352 320 352c-89.6 0-160-71.3-160-159.8c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2C273.4 2.3 280.7-.2 288 0c14.1 .3 23.8 11.4 32.7 21.6c0 0 0 0 0 0c2 2.3 4 4.6 6 6.7l19 19.9zM384 240.2c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C293 167.1 256 203.6 256 240.2c0 35.3 28.7 64 64 64s64-28.7 64-64zM32 288c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 64 448 0 0-64c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l0-96zM320 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$6591b1ea509be9da = {
    prefix: "fas",
    iconName: "flag",
    icon: [
        448,
        512,
        [
            127988,
            61725
        ],
        "f024",
        "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V64 368 480c0 17.7 14.3 32 32 32s32-14.3 32-32V352l64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48V32z"
    ]
};
var $5c8203742f0e3062$export$3dcd4ca3f7108a82 = {
    prefix: "fas",
    iconName: "hanukiah",
    icon: [
        640,
        512,
        [
            128334
        ],
        "f6e6",
        "M314.2 3.3C309.1 12.1 296 36.6 296 56c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C324.6 1.2 322.4 0 320 0s-4.6 1.2-5.8 3.3zm-288 48C21.1 60.1 8 84.6 8 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C36.6 49.2 34.4 48 32 48s-4.6 1.2-5.8 3.3zM88 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C101.1 60.1 88 84.6 88 104zm82.2-52.7C165.1 60.1 152 84.6 152 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM216 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C229.1 60.1 216 84.6 216 104zM394.2 51.3C389.1 60.1 376 84.6 376 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM440 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C453.1 60.1 440 84.6 440 104zm82.2-52.7C517.1 60.1 504 84.6 504 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM584 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C597.1 60.1 584 84.6 584 104zM112 160c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm160 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zM352 144c0-17.7-14.3-32-32-32s-32 14.3-32 32V320H96c-17.7 0-32-14.3-32-32V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 53 43 96 96 96H288v64H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H320 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H544c53 0 96-43 96-96V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H352V144z"
    ]
};
var $5c8203742f0e3062$export$5e19aea195b31816 = {
    prefix: "fas",
    iconName: "feather",
    icon: [
        512,
        512,
        [
            129718
        ],
        "f52d",
        "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h68c49.7 0 97.9-14.4 139-41c11.1-7.2 5.5-23-7.8-23c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l81-24.3c2.5-.8 4.8-2.1 6.7-4l22.4-22.4c10.1-10.1 2.9-27.3-11.3-27.3l-32.2 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l112-33.6c4-1.2 7.4-3.9 9.3-7.7C506.4 207.6 512 184.1 512 160c0-41-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330v55.3L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"
    ]
};
var $5c8203742f0e3062$export$2b1464e7557b18eb = {
    prefix: "fas",
    iconName: "volume-low",
    icon: [
        448,
        512,
        [
            128264,
            "volume-down"
        ],
        "f027",
        "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM412.6 181.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"
    ]
};
var $5c8203742f0e3062$export$69fdf57632b6cc29 = $5c8203742f0e3062$export$2b1464e7557b18eb;
var $5c8203742f0e3062$export$3786a0422a3f33ea = {
    prefix: "fas",
    iconName: "comment-slash",
    icon: [
        640,
        512,
        [],
        "f4b3",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512.9 376.7C552.2 340.2 576 292.3 576 240C576 125.1 461.4 32 320 32c-67.7 0-129.3 21.4-175.1 56.3L38.8 5.1zm385.2 425L82.9 161.3C70.7 185.6 64 212.2 64 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c37 0 72.3-6.4 104.1-17.9z"
    ]
};
var $5c8203742f0e3062$export$dd9dc9b4227dbe94 = {
    prefix: "fas",
    iconName: "cloud-sun-rain",
    icon: [
        640,
        512,
        [
            127782
        ],
        "f743",
        "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.2-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zm69.4 276c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm74.5-116.1c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
var $5c8203742f0e3062$export$83632d1150d3541f = {
    prefix: "fas",
    iconName: "compress",
    icon: [
        448,
        512,
        [],
        "f066",
        "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V64zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V64zM320 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"
    ]
};
var $5c8203742f0e3062$export$79d4dac715a51fdf = {
    prefix: "fas",
    iconName: "wheat-awn",
    icon: [
        512,
        512,
        [
            "wheat-alt"
        ],
        "e2cd",
        "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L486.5 231c6.2-6.2 6.2-16.4 0-22.6L475.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3z"
    ]
};
var $5c8203742f0e3062$export$deaf03a29aa05e3a = $5c8203742f0e3062$export$79d4dac715a51fdf;
var $5c8203742f0e3062$export$8736909014b15ca9 = {
    prefix: "fas",
    iconName: "ankh",
    icon: [
        320,
        512,
        [
            9765
        ],
        "f644",
        "M96 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 41.6-20.7 76.6-46.6 104.1c-5.9 6.2-11.8 11.8-17.4 16.7c-5.6-4.9-11.5-10.5-17.4-16.7C116.7 204.6 96 169.6 96 128zM160 0C89.3 0 32 57.3 32 128c0 52.4 21.5 95.5 46.8 128H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H241.2c25.4-32.5 46.8-75.6 46.8-128C288 57.3 230.7 0 160 0z"
    ]
};
var $5c8203742f0e3062$export$bfb254bf3c0bc50b = {
    prefix: "fas",
    iconName: "hands-holding-child",
    icon: [
        640,
        512,
        [],
        "e4fa",
        "M320 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm44.7 164.3L375.8 253c1.6 13.2-7.7 25.1-20.8 26.8s-25.1-7.7-26.8-20.8l-4.4-35h-7.6l-4.4 35c-1.6 13.2-13.6 22.5-26.8 20.8s-22.5-13.6-20.8-26.8l11.1-88.8L255.5 181c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l27.9-23.6C271.3 104.8 295.3 96 320 96s48.7 8.8 67.6 24.7l27.9 23.6c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.4-33.8 2.8l-19.8-16.7zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"
    ]
};
var $5c8203742f0e3062$export$19eff32c0fd4f99f = {
    prefix: "fas",
    iconName: "asterisk",
    icon: [
        384,
        512,
        [
            10033,
            61545
        ],
        "2a",
        "M192 32c17.7 0 32 14.3 32 32V199.5l111.5-66.9c15.2-9.1 34.8-4.2 43.9 11s4.2 34.8-11 43.9L254.2 256l114.3 68.6c15.2 9.1 20.1 28.7 11 43.9s-28.7 20.1-43.9 11L224 312.5V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V312.5L48.5 379.4c-15.2 9.1-34.8 4.2-43.9-11s-4.2-34.8 11-43.9L129.8 256 15.5 187.4c-15.2-9.1-20.1-28.7-11-43.9s28.7-20.1 43.9-11L160 199.5V64c0-17.7 14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$5bb6a0c94ad2f4bb = {
    prefix: "fas",
    iconName: "square-check",
    icon: [
        448,
        512,
        [
            9745,
            9989,
            61510,
            "check-square"
        ],
        "f14a",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $5c8203742f0e3062$export$f0c8040f596df7fe = $5c8203742f0e3062$export$5bb6a0c94ad2f4bb;
var $5c8203742f0e3062$export$a6f8654bcd49a39f = {
    prefix: "fas",
    iconName: "peseta-sign",
    icon: [
        384,
        512,
        [],
        "e221",
        "M64 32C46.3 32 32 46.3 32 64v96c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 96V448c0 17.7 14.3 32 32 32s32-14.3 32-32V352h96c77.4 0 142-55 156.8-128H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-3.2C334 87 269.4 32 192 32H64zM282.5 160H96V96h96c41.8 0 77.4 26.7 90.5 64zM96 224H282.5c-13.2 37.3-48.7 64-90.5 64H96V224z"
    ]
};
var $5c8203742f0e3062$export$4805b8d175aeb9fb = {
    prefix: "fas",
    iconName: "heading",
    icon: [
        448,
        512,
        [
            "header"
        ],
        "f1dc",
        "M0 64C0 46.3 14.3 32 32 32H80h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H112V208H336V96H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h48 48c17.7 0 32 14.3 32 32s-14.3 32-32 32H400V240 416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H368 320c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V272H112V416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V240 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var $5c8203742f0e3062$export$579f9604bb10a61a = $5c8203742f0e3062$export$4805b8d175aeb9fb;
var $5c8203742f0e3062$export$1a989eb1919c64c1 = {
    prefix: "fas",
    iconName: "ghost",
    icon: [
        384,
        512,
        [
            128123
        ],
        "f6e2",
        "M40.1 467.1l-11.2 9c-3.2 2.5-7.1 3.9-11.1 3.9C8 480 0 472 0 462.2V192C0 86 86 0 192 0S384 86 384 192V462.2c0 9.8-8 17.8-17.8 17.8c-4 0-7.9-1.4-11.1-3.9l-11.2-9c-13.4-10.7-32.8-9-44.1 3.9L269.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6l-26.6-30.5c-12.7-14.6-35.4-14.6-48.2 0L141.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6L84.2 471c-11.3-12.9-30.7-14.6-44.1-3.9zM160 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$6cfc59842fedbc16 = {
    prefix: "fas",
    iconName: "list",
    icon: [
        512,
        512,
        [
            "list-squares"
        ],
        "f03a",
        "M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"
    ]
};
var $5c8203742f0e3062$export$e3f160fc949c2b9d = $5c8203742f0e3062$export$6cfc59842fedbc16;
var $5c8203742f0e3062$export$b627121801cad756 = {
    prefix: "fas",
    iconName: "square-phone-flip",
    icon: [
        448,
        512,
        [
            "phone-square-alt"
        ],
        "f87b",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zm-90.7 96.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L280 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C111.1 378 119 384 128 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z"
    ]
};
var $5c8203742f0e3062$export$a41e77f0de98bba7 = $5c8203742f0e3062$export$b627121801cad756;
var $5c8203742f0e3062$export$6675e2bf21fdb87e = {
    prefix: "fas",
    iconName: "cart-plus",
    icon: [
        576,
        512,
        [],
        "f217",
        "M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM252 160c0 11 9 20 20 20h44v44c0 11 9 20 20 20s20-9 20-20V180h44c11 0 20-9 20-20s-9-20-20-20H356V96c0-11-9-20-20-20s-20 9-20 20v44H272c-11 0-20 9-20 20z"
    ]
};
var $5c8203742f0e3062$export$6a66b1b639455bef = {
    prefix: "fas",
    iconName: "gamepad",
    icon: [
        640,
        512,
        [],
        "f11b",
        "M192 64C86 64 0 150 0 256S86 448 192 448H448c106 0 192-86 192-192s-86-192-192-192H192zM496 168a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM392 304a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM168 200c0-13.3 10.7-24 24-24s24 10.7 24 24v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V200z"
    ]
};
var $5c8203742f0e3062$export$aa13d9234890e8d3 = {
    prefix: "fas",
    iconName: "circle-dot",
    icon: [
        512,
        512,
        [
            128280,
            "dot-circle"
        ],
        "f192",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $5c8203742f0e3062$export$92bc269cb244d66a = $5c8203742f0e3062$export$aa13d9234890e8d3;
var $5c8203742f0e3062$export$635e4d8cc8428961 = {
    prefix: "fas",
    iconName: "face-dizzy",
    icon: [
        512,
        512,
        [
            "dizzy"
        ],
        "f567",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-224a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"
    ]
};
var $5c8203742f0e3062$export$89a2b10dabc487e8 = $5c8203742f0e3062$export$635e4d8cc8428961;
var $5c8203742f0e3062$export$1199a8ce85311ab5 = {
    prefix: "fas",
    iconName: "egg",
    icon: [
        384,
        512,
        [
            129370
        ],
        "f7fb",
        "M192 496C86 496 0 394 0 288C0 176 64 16 192 16s192 160 192 272c0 106-86 208-192 208zM154.8 134c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C69.7 226.1 64 259.7 64 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2z"
    ]
};
var $5c8203742f0e3062$export$bf221f0e8296233e = {
    prefix: "fas",
    iconName: "house-medical-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e513",
        "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
    ]
};
var $5c8203742f0e3062$export$295287303c0e9c7c = {
    prefix: "fas",
    iconName: "campground",
    icon: [
        576,
        512,
        [
            9978
        ],
        "f6bb",
        "M377 52c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5L288 60.8 249 12c-11-13.8-31.2-16-45-5s-16 31.2-5 45l48 60L12.3 405.4C4.3 415.4 0 427.7 0 440.4V464c0 26.5 21.5 48 48 48H288 528c26.5 0 48-21.5 48-48V440.4c0-12.7-4.3-25.1-12.3-35L329 112l48-60zM288 448H168.5L288 291.7 407.5 448H288z"
    ]
};
var $5c8203742f0e3062$export$e18e05ffa2045d3b = {
    prefix: "fas",
    iconName: "folder-plus",
    icon: [
        512,
        512,
        [],
        "f65e",
        "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM232 376c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
    ]
};
var $5c8203742f0e3062$export$65a345b33858a655 = {
    prefix: "fas",
    iconName: "futbol",
    icon: [
        512,
        512,
        [
            9917,
            "futbol-ball",
            "soccer-ball"
        ],
        "f1e3",
        "M417.3 360.1l-71.6-4.8c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-17.6 69.6C289.5 445.8 273 448 256 448s-33.5-2.2-49.2-6.4L189.2 372c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-71.6 4.8c-17.6-27.2-28.5-59.2-30.4-93.6L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15l-26.7-66.6C128 109.2 155.3 89 186.7 76.9l55.2 46c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l55.2-46c31.3 12.1 58.7 32.3 79.6 57.9l-26.7 66.6c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9l60.7 38.2c-1.9 34.4-12.8 66.4-30.4 93.6zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"
    ]
};
var $5c8203742f0e3062$export$51a344ca0a215620 = $5c8203742f0e3062$export$65a345b33858a655;
var $5c8203742f0e3062$export$f4a29712c724ba2d = $5c8203742f0e3062$export$65a345b33858a655;
var $5c8203742f0e3062$export$7c8b56f3f296a814 = {
    prefix: "fas",
    iconName: "paintbrush",
    icon: [
        576,
        512,
        [
            128396,
            "paint-brush"
        ],
        "f1fc",
        "M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H208c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"
    ]
};
var $5c8203742f0e3062$export$594db3339e212bc9 = $5c8203742f0e3062$export$7c8b56f3f296a814;
var $5c8203742f0e3062$export$7aa08ad5d562578a = {
    prefix: "fas",
    iconName: "lock",
    icon: [
        448,
        512,
        [
            128274
        ],
        "f023",
        "M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"
    ]
};
var $5c8203742f0e3062$export$84666c793cb2a347 = {
    prefix: "fas",
    iconName: "gas-pump",
    icon: [
        512,
        512,
        [
            9981
        ],
        "f52f",
        "M32 64C32 28.7 60.7 0 96 0H256c35.3 0 64 28.7 64 64V256h8c48.6 0 88 39.4 88 88v32c0 13.3 10.7 24 24 24s24-10.7 24-24V222c-27.6-7.1-48-32.2-48-62V96L384 64c-8.8-8.8-8.8-23.2 0-32s23.2-8.8 32 0l77.3 77.3c12 12 18.7 28.3 18.7 45.3V168v24 32V376c0 39.8-32.2 72-72 72s-72-32.2-72-72V344c0-22.1-17.9-40-40-40h-8V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64zM96 80v96c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"
    ]
};
var $5c8203742f0e3062$export$6e6bd68568c17bbf = {
    prefix: "fas",
    iconName: "hot-tub-person",
    icon: [
        512,
        512,
        [
            "hot-tub"
        ],
        "f593",
        "M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L295.8 82.8C280.7 69.1 272 49.7 272 29.2V24zM0 320v16V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H277.3c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96v64zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm112 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM360 0c-13.3 0-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L407.8 82.8C392.7 69.1 384 49.7 384 29.2V24c0-13.3-10.7-24-24-24zM64 128A64 64 0 1 0 64 0a64 64 0 1 0 0 128z"
    ]
};
var $5c8203742f0e3062$export$4842af92b516c40b = $5c8203742f0e3062$export$6e6bd68568c17bbf;
var $5c8203742f0e3062$export$9a8788ec0e4a9a0b = {
    prefix: "fas",
    iconName: "map-location",
    icon: [
        576,
        512,
        [
            "map-marked"
        ],
        "f59f",
        "M302.8 312C334.9 271.9 408 174.6 408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0zM416 503l144.9-58c9.1-3.6 15.1-12.5 15.1-22.3V152c0-17-17.1-28.6-32.9-22.3l-116 46.4c-.5 1.2-1 2.5-1.5 3.7c-2.9 6.8-6.1 13.7-9.6 20.6V503zM15.1 187.3C6 191 0 199.8 0 209.6V480.4c0 17 17.1 28.6 32.9 22.3L160 451.8V200.4c-3.5-6.9-6.7-13.8-9.6-20.6c-5.6-13.2-10.4-27.4-12.8-41.5l-122.6 49zM384 255c-20.5 31.3-42.3 59.6-56.2 77c-20.5 25.6-59.1 25.6-79.6 0c-13.9-17.4-35.7-45.7-56.2-77V449.4l192 54.9V255z"
    ]
};
var $5c8203742f0e3062$export$df04458e7e32352c = $5c8203742f0e3062$export$9a8788ec0e4a9a0b;
var $5c8203742f0e3062$export$70fd6006b4e54a5 = {
    prefix: "fas",
    iconName: "house-flood-water",
    icon: [
        576,
        512,
        [],
        "e50e",
        "M306.8 6.1C295.6-2 280.4-2 269.2 6.1l-176 128c-11.2 8.2-15.9 22.6-11.6 35.8S98.1 192 112 192h16v73c1.7 1 3.3 2 4.9 3.1c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c1.5-1 3-2 4.5-2.9l-.3-73.2H464c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128zM269.5 309.9C247 325.4 219.5 336 192 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 389.7 159 400 192 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"
    ]
};
var $5c8203742f0e3062$export$1744430f718caf6b = {
    prefix: "fas",
    iconName: "tree",
    icon: [
        448,
        512,
        [
            127794
        ],
        "f1bb",
        "M210.6 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208H104L30.6 281.4c-4.2 4.2-6.6 10-6.6 16C24 309.9 34.1 320 46.6 320H80L5.4 409.5C1.9 413.7 0 419 0 424.5c0 13 10.5 23.5 23.5 23.5H192v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448H424.5c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L368 320h33.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L344 208h24.9c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9z"
    ]
};
var $5c8203742f0e3062$export$cffe7d85a82d8116 = {
    prefix: "fas",
    iconName: "bridge-lock",
    icon: [
        640,
        512,
        [],
        "e4cc",
        "M32 64c0-17.7 14.3-32 32-32H576c17.7 0 32 14.3 32 32s-14.3 32-32 32H536v64h-8c-61.9 0-112 50.1-112 112v24.6c-9.9 5.8-18.2 14.1-23.8 24.1c-17.6-20-43.4-32.7-72.2-32.7c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V384c0-53-43-96-96-96V160h72V96H64C46.3 96 32 81.7 32 64zM408 96v64h80V96H408zm-48 64V96H280v64h80zM152 96v64h80V96H152zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $5c8203742f0e3062$export$15854c4475080853 = {
    prefix: "fas",
    iconName: "sack-dollar",
    icon: [
        512,
        512,
        [
            128176
        ],
        "f81d",
        "M320 96H192L144.6 24.9C137.5 14.2 145.1 0 157.9 0H354.1c12.8 0 20.4 14.2 13.3 24.9L320 96zM192 128H320c3.8 2.5 8.1 5.3 13 8.4C389.7 172.7 512 250.9 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96C0 250.9 122.3 172.7 179 136.4l0 0 0 0c4.8-3.1 9.2-5.9 13-8.4zm84 88c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V424c0 11 9 20 20 20s20-9 20-20V410.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l0 0-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V216z"
    ]
};
var $5c8203742f0e3062$export$ba236543926e3569 = {
    prefix: "fas",
    iconName: "pen-to-square",
    icon: [
        512,
        512,
        [
            "edit"
        ],
        "f044",
        "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"
    ]
};
var $5c8203742f0e3062$export$7be713e57d023733 = $5c8203742f0e3062$export$ba236543926e3569;
var $5c8203742f0e3062$export$6f7218565b1b8d0e = {
    prefix: "fas",
    iconName: "car-side",
    icon: [
        640,
        512,
        [
            128663
        ],
        "f5e4",
        "M171.3 96H224v96H111.3l30.4-75.9C146.5 104 158.2 96 171.3 96zM272 192V96h81.2c9.7 0 18.9 4.4 25 12l67.2 84H272zm256.2 1L428.2 68c-18.2-22.8-45.8-36-75-36H171.3c-39.3 0-74.6 23.9-89.1 60.3L40.6 196.4C16.8 205.8 0 228.9 0 256V368c0 17.7 14.3 32 32 32H65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32V320c0-65.2-48.8-119-111.8-127zM434.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $5c8203742f0e3062$export$cdaf45d4e50ac035 = {
    prefix: "fas",
    iconName: "share-nodes",
    icon: [
        448,
        512,
        [
            "share-alt"
        ],
        "f1e0",
        "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"
    ]
};
var $5c8203742f0e3062$export$f8e8bb0b3aa8c658 = $5c8203742f0e3062$export$cdaf45d4e50ac035;
var $5c8203742f0e3062$export$24c21c3ca00f3625 = {
    prefix: "fas",
    iconName: "heart-circle-minus",
    icon: [
        576,
        512,
        [],
        "e4ff",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"
    ]
};
var $5c8203742f0e3062$export$703272eebf5e3eea = {
    prefix: "fas",
    iconName: "hourglass-half",
    icon: [
        384,
        512,
        [
            "hourglass-2"
        ],
        "f252",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 19-5.6 37.4-16 53H112c-10.3-15.6-16-34-16-53zm16 309c3.5-5.3 7.6-10.3 12.1-14.9L192 301.3l67.9 67.9c4.6 4.6 8.6 9.6 12.1 14.9H112z"
    ]
};
var $5c8203742f0e3062$export$f1052bbf6bf361c0 = $5c8203742f0e3062$export$703272eebf5e3eea;
var $5c8203742f0e3062$export$6a99139787bf9967 = {
    prefix: "fas",
    iconName: "microscope",
    icon: [
        512,
        512,
        [
            128300
        ],
        "f610",
        "M160 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM32 448H320c70.7 0 128-57.3 128-128s-57.3-128-128-128V128c106 0 192 86 192 192c0 49.2-18.5 94-48.9 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm80-64H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$2a9dda2096ce792e = {
    prefix: "fas",
    iconName: "sink",
    icon: [
        512,
        512,
        [],
        "e06d",
        "M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32s14.3 32 32 32s32-14.3 32-32c0-53-43-96-96-96s-96 43-96 96V288H160V264c0-30.9-25.1-56-56-56H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c4.4 0 8 3.6 8 8v24H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H256 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H400V264c0-4.4 3.6-8 8-8h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H408c-30.9 0-56 25.1-56 56v24H288V96zM480 416V384H32v32c0 53 43 96 96 96H384c53 0 96-43 96-96z"
    ]
};
var $5c8203742f0e3062$export$b0137b4600e9ab12 = {
    prefix: "fas",
    iconName: "bag-shopping",
    icon: [
        448,
        512,
        [
            "shopping-bag"
        ],
        "f290",
        "M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64v48H160V112zm-48 48H48c-26.5 0-48 21.5-48 48V416c0 53 43 96 96 96H352c53 0 96-43 96-96V208c0-26.5-21.5-48-48-48H336V112C336 50.1 285.9 0 224 0S112 50.1 112 112v48zm24 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $5c8203742f0e3062$export$5745f8adbc11eb01 = $5c8203742f0e3062$export$b0137b4600e9ab12;
var $5c8203742f0e3062$export$cf79d63ad07d943a = {
    prefix: "fas",
    iconName: "arrow-down-z-a",
    icon: [
        576,
        512,
        [
            "sort-alpha-desc",
            "sort-alpha-down-alt"
        ],
        "f881",
        "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 64c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 96H352c-17.7 0-32-14.3-32-32zm96 192c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 448H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128c5.4-10.8 16.5-17.7 28.6-17.7zM395.8 400h40.4L416 359.6 395.8 400z"
    ]
};
var $5c8203742f0e3062$export$7caf99612a55d427 = $5c8203742f0e3062$export$cf79d63ad07d943a;
var $5c8203742f0e3062$export$e12d23d82d5c8a89 = $5c8203742f0e3062$export$cf79d63ad07d943a;
var $5c8203742f0e3062$export$5030322c5fc886d7 = {
    prefix: "fas",
    iconName: "mitten",
    icon: [
        448,
        512,
        [],
        "f7b5",
        "M352 384H64L5.4 178.9C1.8 166.4 0 153.4 0 140.3C0 62.8 62.8 0 140.3 0h3.4c66 0 123.5 44.9 139.5 108.9l31.4 125.8 17.6-20.1C344.8 200.2 362.9 192 382 192h2.8c34.9 0 63.3 28.3 63.3 63.3c0 15.9-6 31.2-16.8 42.9L352 384zM32 448c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V448z"
    ]
};
var $5c8203742f0e3062$export$49577f913f0fe4d2 = {
    prefix: "fas",
    iconName: "person-rays",
    icon: [
        512,
        512,
        [],
        "e54d",
        "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L328 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H248zM7 7C16.4-2.3 31.6-2.3 41 7l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 41C-2.3 31.6-2.3 16.4 7 7zM471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7zM7 505c-9.4-9.4-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-9.4 9.4-24.6 9.4-33.9 0zm464 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
    ]
};
var $5c8203742f0e3062$export$e5a8f011aef571ac = {
    prefix: "fas",
    iconName: "users",
    icon: [
        640,
        512,
        [],
        "f0c0",
        "M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"
    ]
};
var $5c8203742f0e3062$export$ed3f2918429d029a = {
    prefix: "fas",
    iconName: "eye-slash",
    icon: [
        640,
        512,
        [],
        "f070",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"
    ]
};
var $5c8203742f0e3062$export$a25a266ce0c95019 = {
    prefix: "fas",
    iconName: "flask-vial",
    icon: [
        640,
        512,
        [],
        "e4f3",
        "M175 389.4c-9.8 16-15 34.3-15 53.1c-10 3.5-20.8 5.5-32 5.5c-53 0-96-43-96-96V64C14.3 64 0 49.7 0 32S14.3 0 32 0H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V309.9l-49 79.6zM96 64v96h64V64H96zM352 0H480h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V214.9L629.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H261.4c-38.3 0-69.4-31.1-69.4-69.4c0-12.8 3.6-25.4 10.3-36.4L320 214.9V64c-17.7 0-32-14.3-32-32s14.3-32 32-32h32zm32 64V224c0 5.9-1.6 11.7-4.7 16.8L330.5 320h171l-48.8-79.2c-3.1-5-4.7-10.8-4.7-16.8V64H384z"
    ]
};
var $5c8203742f0e3062$export$f69db0b876f7d753 = {
    prefix: "fas",
    iconName: "hand",
    icon: [
        512,
        512,
        [
            129306,
            9995,
            "hand-paper"
        ],
        "f256",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32z"
    ]
};
var $5c8203742f0e3062$export$6e6216c8b50471bb = $5c8203742f0e3062$export$f69db0b876f7d753;
var $5c8203742f0e3062$export$8de8eb94230028a5 = {
    prefix: "fas",
    iconName: "om",
    icon: [
        512,
        512,
        [
            128329
        ],
        "f679",
        "M379.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6l-16-16zM281 66.7c-2.2-1.5-4.9-2.5-7.7-2.7c-.6 0-1.3-.1-1.9 0c-3.9 .2-7.4 1.7-10.1 4.2c-.9 .8-1.6 1.7-2.3 2.6c-1.7 2.4-2.7 5.3-2.9 8.5c0 .7 0 1.4 0 2.1c.2 2.2 .9 4.3 1.9 6.2l.3 .6c.3 .6 .8 1.4 1.4 2.4c1.2 2 2.9 4.8 5.1 8.2c4.4 6.7 11.1 15.5 20 24.4C302.4 141.1 330.3 160 368 160c31.2 0 56.6-10.4 73.9-20.2c8.7-5 15.6-9.9 20.4-13.8c2.4-1.9 4.3-3.6 5.7-4.9c.7-.6 1.3-1.2 1.7-1.6l.6-.5 .1-.1 .1-.1 0 0 0 0c5.9-5.8 9.5-13.9 9.5-22.8c0-17.7-14.3-32-32-32c-8.7 0-16.7 3.5-22.4 9.2c-.1 .1-.2 .2-.5 .4c-.5 .5-1.5 1.3-2.8 2.4c-2.7 2.2-6.8 5.2-12.1 8.2C399.4 90.4 384.8 96 368 96c-20.8 0-42.4-7-59.5-14.6c-8.4-3.7-15.4-7.5-20.3-10.3c-2.4-1.4-4.3-2.5-5.6-3.3c-.6-.4-1.1-.7-1.4-.9l-.3-.2zM115.2 169.6c8-6 17.9-9.6 28.8-9.6c26.5 0 48 21.5 48 48s-21.5 48-48 48H109.8c-7.6 0-13.8 6.2-13.8 13.8c0 1.5 .2 2.9 .7 4.4l8 24c4.4 13.1 16.6 21.9 30.4 21.9H144h16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-50.8 0-82.7-21.5-102.2-42.8c-9.9-10.8-16.6-21.6-20.9-29.7c-2.1-4-3.6-7.3-4.5-9.6c-.5-1.1-.8-2-1-2.5l-.2-.5c-.3-.9-.7-1.8-1.1-2.6c-1.2-2.2-2.8-4-4.7-5.4c-1.9-1.4-4.1-2.3-6.5-2.8c-1.4-.3-2.9-.3-4.4-.2c-2.5 .2-4.8 1-6.8 2.3c-1.1 .7-2.2 1.5-3.1 2.5c-2.4 2.5-4.1 5.8-4.5 9.5c-.1 .6-.1 1.1-.1 1.7c0 0 0 0 0 0c0 .8 .1 1.7 .2 2.5l0 .1c0 .3 .1 .8 .2 1.3c.2 1.1 .4 2.7 .8 4.6c.8 3.9 2 9.4 3.9 15.9c3.8 13 10.3 30.4 21.3 48C48.7 476.2 89.4 512 160 512c70.7 0 128-57.3 128-128c0-23.3-6.2-45.2-17.1-64h22.6c25.5 0 49.9-10.1 67.9-28.1l26.5-26.5c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32c-25.7 0-41.4-12.5-51.2-25.6c-5-6.7-8.4-13.4-10.5-18.6c-1.1-2.5-1.8-4.6-2.2-6c-.2-.7-.4-1.2-.5-1.5l-.1-.2c-.3-1.3-.8-2.6-1.5-3.8c-1.1-2-2.6-3.8-4.4-5.1c-2.7-2-6-3.2-9.6-3.2l-.2 0c-8 .1-14.6 6.1-15.6 13.9l0 0c0 .3-.1 .6-.2 1.1c-.1 .9-.3 2.1-.4 3.6c-.3 3-.6 7.3-.6 12.4c0 10.1 1.1 23.9 5.8 38.1c4.8 14.3 13.4 29.3 28.6 40.7C368.7 473.3 389.3 480 416 480c53 0 96-43 96-96V288c0-53-43-96-96-96h-5.5c-25.5 0-49.9 10.1-67.9 28.1l-26.5 26.5c-6 6-14.1 9.4-22.6 9.4H245.2c6.9-14.5 10.8-30.8 10.8-48c0-61.9-50.1-112-112-112c-25.2 0-48.5 8.3-67.2 22.4c-14.1 10.6-17 30.7-6.4 44.8s30.7 17 44.8 6.4z"
    ]
};
var $5c8203742f0e3062$export$2571e33fa6c25993 = {
    prefix: "fas",
    iconName: "worm",
    icon: [
        512,
        512,
        [],
        "e599",
        "M256 96c0-53 43-96 96-96h38.4C439.9 0 480 40.1 480 89.6V176v16V376c0 75.1-60.9 136-136 136s-136-60.9-136-136V296c0-22.1-17.9-40-40-40s-40 17.9-40 40V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V296c0-75.1 60.9-136 136-136s136 60.9 136 136v80c0 22.1 17.9 40 40 40s40-17.9 40-40V192H352c-53 0-96-43-96-96zm144-8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $5c8203742f0e3062$export$423555e8708eb4c7 = {
    prefix: "fas",
    iconName: "house-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e50b",
        "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $5c8203742f0e3062$export$cae5752c3e3b6545 = {
    prefix: "fas",
    iconName: "plug",
    icon: [
        384,
        512,
        [
            128268
        ],
        "f1e6",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8C297 398 352 333.4 352 256V224c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $5c8203742f0e3062$export$877e5ae47a854215 = {
    prefix: "fas",
    iconName: "chevron-up",
    icon: [
        512,
        512,
        [],
        "f077",
        "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
    ]
};
var $5c8203742f0e3062$export$2262d6b626de1120 = {
    prefix: "fas",
    iconName: "hand-spock",
    icon: [
        576,
        512,
        [
            128406
        ],
        "f259",
        "M246.9 23.7C242.3 6.6 224.8-3.5 207.7 1.1s-27.2 22.1-22.6 39.2L238 237.8c2.5 9.2-4.5 18.2-14 18.2c-6.4 0-12-4.2-13.9-10.3L166.6 102.7c-5.1-16.9-23-26.4-39.9-21.3s-26.4 23-21.3 39.9l62.8 206.4c2.4 7.9-7.2 13.8-13.2 8.1L99.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L156.8 448c43.1 41.1 100.4 64 160 64h10.9 8.2c.1 0 .1-.1 .1-.1s.1-.1 .1-.1c58.3-3.5 108.6-43.2 125.3-99.7l81.2-275c5-16.9-4.7-34.7-21.6-39.8s-34.7 4.7-39.8 21.6L443.5 247.1c-1.6 5.3-6.4 8.9-12 8.9c-7.9 0-13.8-7.3-12.2-15.1l36-170.3c3.7-17.3-7.4-34.3-24.7-37.9s-34.3 7.4-37.9 24.7L355.1 235.1c-2.6 12.2-13.3 20.9-25.8 20.9c-11.9 0-22.4-8-25.4-19.5l-57-212.8z"
    ]
};
var $5c8203742f0e3062$export$b85a7300fc7960b6 = {
    prefix: "fas",
    iconName: "stopwatch",
    icon: [
        448,
        512,
        [
            9201
        ],
        "f2f2",
        "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H224 176zm72 192V320c0 13.3-10.7 24-24 24s-24-10.7-24-24V192c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $5c8203742f0e3062$export$5a54c83033a0a56a = {
    prefix: "fas",
    iconName: "face-kiss",
    icon: [
        512,
        512,
        [
            128535,
            "kiss"
        ],
        "f596",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$c762a77aabf64fd0 = $5c8203742f0e3062$export$5a54c83033a0a56a;
var $5c8203742f0e3062$export$834071278537f121 = {
    prefix: "fas",
    iconName: "bridge-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e4cb",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $5c8203742f0e3062$export$95a7394c24f57943 = {
    prefix: "fas",
    iconName: "face-grin-tongue",
    icon: [
        512,
        512,
        [
            128539,
            "grin-tongue"
        ],
        "f589",
        "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $5c8203742f0e3062$export$ef222816a43a4b3a = $5c8203742f0e3062$export$95a7394c24f57943;
var $5c8203742f0e3062$export$a831eedd2f59c62f = {
    prefix: "fas",
    iconName: "chess-bishop",
    icon: [
        320,
        512,
        [
            9821
        ],
        "f43a",
        "M128 0C110.3 0 96 14.3 96 32c0 16.1 11.9 29.4 27.4 31.7C78.4 106.8 8 190 8 288c0 47.4 30.8 72.3 56 84.7V400H256V372.7c25.2-12.5 56-37.4 56-84.7c0-37.3-10.2-72.4-25.3-104.1l-99.4 99.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L270.8 154.6c-23.2-38.1-51.8-69.5-74.2-90.9C212.1 61.4 224 48.1 224 32c0-17.7-14.3-32-32-32H128zM48 432L6.6 473.4c-4.2 4.2-6.6 10-6.6 16C0 501.9 10.1 512 22.6 512H297.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L272 432H48z"
    ]
};
var $5c8203742f0e3062$export$1dd161850c5bc64e = {
    prefix: "fas",
    iconName: "face-grin-wink",
    icon: [
        512,
        512,
        [
            "grin-wink"
        ],
        "f58c",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-16.9-79.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$2397fcd34eb12177 = $5c8203742f0e3062$export$1dd161850c5bc64e;
var $5c8203742f0e3062$export$c9c5b76ec992eab4 = {
    prefix: "fas",
    iconName: "ear-deaf",
    icon: [
        512,
        512,
        [
            "deaf",
            "deafness",
            "hard-of-hearing"
        ],
        "f2a4",
        "M502.6 54.6l-40 40c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l40-40c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zm-320 320l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM240 128c-57.6 0-105.1 43.6-111.3 99.5c-1.9 17.6-17.8 30.2-35.3 28.3s-30.2-17.8-28.3-35.3C74.8 132.5 149.4 64 240 64c97.2 0 176 78.8 176 176c0 46-17.7 87.9-46.6 119.3c-12 13-17.4 24.8-17.4 34.7V400c0 61.9-50.1 112-112 112c-17.7 0-32-14.3-32-32s14.3-32 32-32c26.5 0 48-21.5 48-48v-6.1c0-32.9 17.4-59.6 34.4-78c18.4-20 29.6-46.6 29.6-75.9c0-61.9-50.1-112-112-112zm0 80c-17.7 0-32 14.3-32 32c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-17.7-14.3-32-32-32z"
    ]
};
var $5c8203742f0e3062$export$4b666adf83f0de01 = $5c8203742f0e3062$export$c9c5b76ec992eab4;
var $5c8203742f0e3062$export$85c6a9ab2fa2631e = $5c8203742f0e3062$export$c9c5b76ec992eab4;
var $5c8203742f0e3062$export$ebecf90a5676e17a = $5c8203742f0e3062$export$c9c5b76ec992eab4;
var $5c8203742f0e3062$export$3f22db9ae9b6be1c = {
    prefix: "fas",
    iconName: "road-circle-check",
    icon: [
        640,
        512,
        [],
        "e564",
        "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $5c8203742f0e3062$export$d9769fb795c2db82 = {
    prefix: "fas",
    iconName: "dice-five",
    icon: [
        448,
        512,
        [
            9860
        ],
        "f523",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$97d1903b1e012ff7 = {
    prefix: "fas",
    iconName: "square-rss",
    icon: [
        448,
        512,
        [
            "rss-square"
        ],
        "f143",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 136c0-13.3 10.7-24 24-24c137 0 248 111 248 248c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24c83.9 0 152 68.1 152 152c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104c-13.3 0-24-10.7-24-24zm0 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $5c8203742f0e3062$export$89c9b1cca2c11484 = $5c8203742f0e3062$export$97d1903b1e012ff7;
var $5c8203742f0e3062$export$567a897fc092e403 = {
    prefix: "fas",
    iconName: "land-mine-on",
    icon: [
        640,
        512,
        [],
        "e51b",
        "M344 24V168c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM192 320c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v32H192V320zm-77.3 90.5c8.1-16.3 24.8-26.5 42.9-26.5H482.3c18.2 0 34.8 10.3 42.9 26.5l27.6 55.2C563.5 487 548 512 524.2 512H115.8c-23.8 0-39.3-25-28.6-46.3l27.6-55.2zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72z"
    ]
};
var $5c8203742f0e3062$export$7fddf76ec23943d8 = {
    prefix: "fas",
    iconName: "i-cursor",
    icon: [
        256,
        512,
        [],
        "f246",
        "M.1 29.3C-1.4 47 11.7 62.4 29.3 63.9l8 .7C70.5 67.3 96 95 96 128.3V224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v95.7c0 33.3-25.5 61-58.7 63.8l-8 .7C11.7 449.6-1.4 465 .1 482.7s16.9 30.7 34.5 29.2l8-.7c34.1-2.8 64.2-18.9 85.4-42.9c21.2 24 51.2 40.1 85.4 42.9l8 .7c17.6 1.5 33.1-11.6 34.5-29.2s-11.6-33.1-29.2-34.5l-8-.7C185.5 444.7 160 417 160 383.7V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V128.3c0-33.3 25.5-61 58.7-63.8l8-.7c17.6-1.5 30.7-16.9 29.2-34.5S239-1.4 221.3 .1l-8 .7C179.2 3.6 149.2 19.7 128 43.7c-21.2-24-51.2-40-85.4-42.9l-8-.7C17-1.4 1.6 11.7 .1 29.3z"
    ]
};
var $5c8203742f0e3062$export$722e92d2d93ffc68 = {
    prefix: "fas",
    iconName: "stamp",
    icon: [
        512,
        512,
        [],
        "f5bf",
        "M312 201.8c0-17.4 9.2-33.2 19.9-47C344.5 138.5 352 118.1 352 96c0-53-43-96-96-96s-96 43-96 96c0 22.1 7.5 42.5 20.1 58.8c10.7 13.8 19.9 29.6 19.9 47c0 29.9-24.3 54.2-54.2 54.2H112C50.1 256 0 306.1 0 368c0 20.9 13.4 38.7 32 45.3V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V413.3c18.6-6.6 32-24.4 32-45.3c0-61.9-50.1-112-112-112H366.2c-29.9 0-54.2-24.3-54.2-54.2zM416 416v32H96V416H416z"
    ]
};
var $5c8203742f0e3062$export$68b3af7444c89df7 = {
    prefix: "fas",
    iconName: "stairs",
    icon: [
        576,
        512,
        [],
        "e289",
        "M384 64c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v96c0 17.7-14.3 32-32 32H320v96c0 17.7-14.3 32-32 32H192v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V320c0-17.7 14.3-32 32-32h96V192c0-17.7 14.3-32 32-32h96V64z"
    ]
};
var $5c8203742f0e3062$export$aee03ca0815b7c38 = {
    prefix: "fas",
    iconName: "i",
    icon: [
        320,
        512,
        [
            105
        ],
        "49",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96h96V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V96h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 32z"
    ]
};
var $5c8203742f0e3062$export$22a9491150c64fef = {
    prefix: "fas",
    iconName: "hryvnia-sign",
    icon: [
        384,
        512,
        [
            8372,
            "hryvnia"
        ],
        "f6f2",
        "M121.9 116.2C138.3 103.1 158.7 96 179.6 96H223c27.1 0 49 21.9 49 49c0 11.5-4 22.4-11.1 31H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H155.5l-50.6 28.9c-1.7 1-3.4 2-5.1 3.1H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H52.3c-2.8 9.9-4.3 20.4-4.3 31c0 62.4 50.6 113 113 113h43.4c35.5 0 70-12.1 97.7-34.3L308 441c13.8-11 16-31.2 5-45s-31.2-16-45-5l-5.9 4.7c-16.4 13.1-36.7 20.2-57.7 20.2H161c-27.1 0-49-21.9-49-49c0-11.5 4-22.4 11.1-31H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H228.5l50.6-28.9c1.7-1 3.4-2 5.1-3.1H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H331.7c2.8-10 4.3-20.4 4.3-31c0-62.4-50.6-113-113-113H179.6c-35.5 0-70 12.1-97.7 34.3L76 71c-13.8 11-16 31.2-5 45s31.2 16 45 5l5.9-4.7z"
    ]
};
var $5c8203742f0e3062$export$33d5f94bd6f75f59 = $5c8203742f0e3062$export$22a9491150c64fef;
var $5c8203742f0e3062$export$6380e2ed6e69d350 = {
    prefix: "fas",
    iconName: "pills",
    icon: [
        576,
        512,
        [],
        "f484",
        "M112 96c-26.5 0-48 21.5-48 48V256h96V144c0-26.5-21.5-48-48-48zM0 144C0 82.1 50.1 32 112 32s112 50.1 112 112V368c0 61.9-50.1 112-112 112S0 429.9 0 368V144zM554.9 399.4c-7.1 12.3-23.7 13.1-33.8 3.1L333.5 214.9c-10-10-9.3-26.7 3.1-33.8C360 167.7 387.1 160 416 160c88.4 0 160 71.6 160 160c0 28.9-7.7 56-21.1 79.4zm-59.5 59.5C472 472.3 444.9 480 416 480c-88.4 0-160-71.6-160-160c0-28.9 7.7-56 21.1-79.4c7.1-12.3 23.7-13.1 33.8-3.1L498.5 425.1c10 10 9.3 26.7-3.1 33.8z"
    ]
};
var $5c8203742f0e3062$export$bdbabf493c478cde = {
    prefix: "fas",
    iconName: "face-grin-wide",
    icon: [
        512,
        512,
        [
            128515,
            "grin-alt"
        ],
        "f581",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM208 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm128 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"
    ]
};
var $5c8203742f0e3062$export$b4abebfe416d36ba = $5c8203742f0e3062$export$bdbabf493c478cde;
var $5c8203742f0e3062$export$3a1fa2d16f90d635 = {
    prefix: "fas",
    iconName: "tooth",
    icon: [
        448,
        512,
        [
            129463
        ],
        "f5c9",
        "M186.1 52.1C169.3 39.1 148.7 32 127.5 32C74.7 32 32 74.7 32 127.5v6.2c0 15.8 3.7 31.3 10.7 45.5l23.5 47.1c4.5 8.9 7.6 18.4 9.4 28.2l36.7 205.8c2 11.2 11.6 19.4 22.9 19.8s21.4-7.4 24-18.4l28.9-121.3C192.2 323.7 207 312 224 312s31.8 11.7 35.8 28.3l28.9 121.3c2.6 11.1 12.7 18.8 24 18.4s20.9-8.6 22.9-19.8l36.7-205.8c1.8-9.8 4.9-19.3 9.4-28.2l23.5-47.1c7.1-14.1 10.7-29.7 10.7-45.5v-2.1c0-55-44.6-99.6-99.6-99.6c-24.1 0-47.4 8.8-65.6 24.6l-3.2 2.8 19.5 15.2c7 5.4 8.2 15.5 2.8 22.5s-15.5 8.2-22.5 2.8l-24.4-19-37-28.8z"
    ]
};
var $5c8203742f0e3062$export$6fb446f784f6b9b3 = {
    prefix: "fas",
    iconName: "v",
    icon: [
        384,
        512,
        [
            118
        ],
        "56",
        "M19.7 34.5c16.3-6.8 35 .9 41.8 17.2L192 364.8 322.5 51.7c6.8-16.3 25.5-24 41.8-17.2s24 25.5 17.2 41.8l-160 384c-5 11.9-16.6 19.7-29.5 19.7s-24.6-7.8-29.5-19.7L2.5 76.3c-6.8-16.3 .9-35 17.2-41.8z"
    ]
};
var $5c8203742f0e3062$export$469d376940e10d37 = {
    prefix: "fas",
    iconName: "bangladeshi-taka-sign",
    icon: [
        384,
        512,
        [],
        "e2e6",
        "M36 32.2C18.4 30.1 2.4 42.5 .2 60S10.5 93.6 28 95.8l7.9 1c16 2 28 15.6 28 31.8V160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V384c0 53 43 96 96 96h32c106 0 192-86 192-192V256c0-53-43-96-96-96H272c-17.7 0-32 14.3-32 32s14.3 32 32 32h16c17.7 0 32 14.3 32 32v32c0 70.7-57.3 128-128 128H160c-17.7 0-32-14.3-32-32V224h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V128.5c0-48.4-36.1-89.3-84.1-95.3l-7.9-1z"
    ]
};
var $5c8203742f0e3062$export$36cb1885ad7a570f = {
    prefix: "fas",
    iconName: "bicycle",
    icon: [
        640,
        512,
        [
            128690
        ],
        "f206",
        "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h25.7l34.6 64H222.9l-27.4-38C191 99.7 183.7 96 176 96H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h43.7l22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h49c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L375.4 48.8C369.8 38.4 359 32 347.2 32H312zM458.6 303.7l32.3 59.7c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-32.3-59.7c3.6-.6 7.4-.9 11.2-.9c39.8 0 72 32.2 72 72s-32.2 72-72 72s-72-32.2-72-72c0-18.6 7-35.5 18.6-48.3zM133.2 368h65c-7.3 32.1-36 56-70.2 56c-39.8 0-72-32.2-72-72s32.2-72 72-72c1.7 0 3.4 .1 5.1 .2l-24.2 48.5c-9 18.1 4.1 39.4 24.3 39.4zm33.7-48l50.7-101.3 72.9 101.2-.1 .1H166.8zm90.6-128H365.9L317 274.8 257.4 192z"
    ]
};
var $5c8203742f0e3062$export$76d998742bc186eb = {
    prefix: "fas",
    iconName: "staff-snake",
    icon: [
        384,
        512,
        [
            "rod-asclepius",
            "rod-snake",
            "staff-aesculapius"
        ],
        "e579",
        "M222.6 43.2l-.1 4.8H288c53 0 96 43 96 96s-43 96-96 96H248V160h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H248 220l-4.5 144H256c53 0 96 43 96 96s-43 96-96 96H240V384h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H213l-3.1 99.5L208.5 495l0 1c-.3 8.9-7.6 16-16.5 16s-16.2-7.1-16.5-16l0-1-1-31H136c-22.1 0-40-17.9-40-40s17.9-40 40-40h36l-1-32H152c-53 0-96-43-96-96c0-47.6 34.6-87.1 80-94.7V256c0 8.8 7.2 16 16 16h16.5L164 128H136 122.6c-9 18.9-28.3 32-50.6 32H56c-30.9 0-56-25.1-56-56S25.1 48 56 48h8 8 89.5l-.1-4.8L161 32c0-.7 0-1.3 0-1.9c.5-16.6 14.1-30 31-30s30.5 13.4 31 30c0 .6 0 1.3 0 1.9l-.4 11.2zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $5c8203742f0e3062$export$f2c3e92ee37a8d89 = $5c8203742f0e3062$export$76d998742bc186eb;
var $5c8203742f0e3062$export$5d61dcb598296af0 = $5c8203742f0e3062$export$76d998742bc186eb;
var $5c8203742f0e3062$export$97c8a2cdba3b7700 = $5c8203742f0e3062$export$76d998742bc186eb;
var $5c8203742f0e3062$export$b293ee8fb8e6b0c4 = {
    prefix: "fas",
    iconName: "head-side-cough-slash",
    icon: [
        640,
        512,
        [],
        "e062",
        "M448 325.8l44 34.5c8.1 1.4 14.8 6.8 18 14.1L552.9 408c10.6 .4 19.5 7.6 22.2 17.4l39.1 30.6c.6 0 1.2-.1 1.8-.1c11.1 0 20.4 7.5 23.2 17.8h-3.9c6.2 8.5 6.4 20.4-.4 29c-8.2 10.4-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L89.6 44.9C127 16.7 173.5 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v0 5.8zM0 224.2c0-38.7 9.8-75.1 27.1-106.9L341.8 365.3l-2.5 .3c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9l62 3.9 43 33.9C439.3 466.2 421.2 480 400 480H320v8c0 13.3-10.7 24-24 24H256v0H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM616 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $5c8203742f0e3062$export$fb6bd43f079f72e2 = {
    prefix: "fas",
    iconName: "truck-medical",
    icon: [
        640,
        512,
        [
            128657,
            "ambulance"
        ],
        "f0f9",
        "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM176 80v48l-48 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V192h48c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H240V80c0-8.8-7.2-16-16-16H192c-8.8 0-16 7.2-16 16z"
    ]
};
var $5c8203742f0e3062$export$f5c7042778b51765 = $5c8203742f0e3062$export$fb6bd43f079f72e2;
var $5c8203742f0e3062$export$e23367e54f665590 = {
    prefix: "fas",
    iconName: "wheat-awn-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e598",
        "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c22.5 22.5 53.3 31.5 82.4 27c0-1 0-2.1 0-3.1c0-33.1 9.1-64.1 25-90.6c-15.5-8.7-32.5-13.8-49.8-15.5l31.9-31.9 12.2 12.2c6 6 12.6 11.1 19.7 15.2c27.5-34 67.3-57.5 112.6-63.8c-4.1-3.8-8.4-7.3-12.9-10.5L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$b23df6bafb174693 = {
    prefix: "fas",
    iconName: "snowman",
    icon: [
        512,
        512,
        [
            9731,
            9924
        ],
        "f7d0",
        "M341.1 140.6c-2 3.9-1.6 8.6 1.2 12c7 8.5 12.9 18.1 17.2 28.4L408 160.2V120c0-13.3 10.7-24 24-24s24 10.7 24 24v19.6l22.5-9.7c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5l-56 24-73.6 31.5c-.5 9.5-2.1 18.6-4.8 27.3c-1.2 3.8-.1 8 2.8 10.8C396.7 296.9 416 338.2 416 384c0 44.7-18.3 85-47.8 114.1c-9.9 9.7-23.7 13.9-37.5 13.9H181.3c-13.9 0-27.7-4.2-37.5-13.9C114.3 469 96 428.7 96 384c0-45.8 19.3-87.1 50.1-116.3c2.9-2.8 4-6.9 2.8-10.8c-2.7-8.7-4.3-17.9-4.8-27.3L70.5 198.1l-56-24C2.4 168.8-3.3 154.7 1.9 142.5s19.3-17.8 31.5-12.6L56 139.6V120c0-13.3 10.7-24 24-24s24 10.7 24 24v40.2L152.6 181c4.3-10.3 10.1-19.9 17.2-28.4c2.8-3.4 3.3-8.1 1.2-12C164 127.2 160 112.1 160 96c0-53 43-96 96-96s96 43 96 96c0 16.1-4 31.2-10.9 44.6zM224 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM288 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 24v3.2c0 3.2 .8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9V120c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
    ]
};
var $5c8203742f0e3062$export$55ceb5d0c144580a = {
    prefix: "fas",
    iconName: "mortar-pestle",
    icon: [
        512,
        512,
        [],
        "f5a7",
        "M504.3 11.1C493.3-1.6 474.5-3.7 461 6.2L252.3 160H397.3L502.6 54.6c11.8-11.8 12.6-30.8 1.6-43.5zM32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32c0 82.5 43.4 147.7 123.9 176.2c-11.1 13.9-19.4 30.3-23.9 48.1C127.6 497.4 142.3 512 160 512H352c17.7 0 32.4-14.6 28.1-31.7c-4.5-17.8-12.8-34.1-23.9-48.1C436.6 403.7 480 338.5 480 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $5c8203742f0e3062$export$f3e925217e396f44 = {
    prefix: "fas",
    iconName: "road-barrier",
    icon: [
        640,
        512,
        [],
        "e562",
        "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V266.3L149.2 96H64V64c0-17.7-14.3-32-32-32zM405.2 96H330.8l-5.4 10.7L234.8 288h74.3l5.4-10.7L405.2 96zM362.8 288h74.3l5.4-10.7L533.2 96H458.8l-5.4 10.7L362.8 288zM202.8 96l-5.4 10.7L106.8 288h74.3l5.4-10.7L277.2 96H202.8zm288 192H576V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v53.7L490.8 288z"
    ]
};
var $5c8203742f0e3062$export$51e9b8434982947d = {
    prefix: "fas",
    iconName: "school",
    icon: [
        640,
        512,
        [
            127979
        ],
        "f549",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H256V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96H592c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V208zM96 320h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V336zM232 176a88 88 0 1 1 176 0 88 88 0 1 1 -176 0zm88-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16z"
    ]
};
var $5c8203742f0e3062$export$4a284575edd6f1af = {
    prefix: "fas",
    iconName: "igloo",
    icon: [
        576,
        512,
        [],
        "f7ae",
        "M320 33.8V160H48.5C100.2 82.8 188.1 32 288 32c10.8 0 21.5 .6 32 1.8zM352 160V39.1C424.9 55.7 487.2 99.8 527.5 160H352zM29.9 192H96V320H0c0-46 10.8-89.4 29.9-128zM192 320H128V192H448V320H384v32H576v80c0 26.5-21.5 48-48 48H352V352c0-35.3-28.7-64-64-64s-64 28.7-64 64V480H48c-26.5 0-48-21.5-48-48V352H192V320zm288 0V192h66.1c19.2 38.6 29.9 82 29.9 128H480z"
    ]
};
var $5c8203742f0e3062$export$e5a289fb22ffb8cb = {
    prefix: "fas",
    iconName: "joint",
    icon: [
        640,
        512,
        [],
        "f595",
        "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9v11c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-29.7-11.8-58.2-32.8-79.2l-21-21C463.2 117.8 448 81.2 448 43V32zM576 256c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8v11zM229.8 360c-4.7-2.3-10-2.7-15.2-2c-37.8 5.6-75.2 14.3-106.9 22.8C81.3 388 58.3 395.1 42 400.4c-8.2 2.7-14.7 4.9-19.2 6.5c-2.3 .8-4 1.4-5.2 1.8l-1.3 .5C6.8 412.5 0 421.4 0 432s6.8 19.5 16.3 22.7l1.3 .5c1.2 .4 3 1.1 5.2 1.8c4.5 1.6 11 3.8 19.2 6.5c16.3 5.4 39.2 12.5 65.7 19.6C160.3 497.3 228.8 512 288 512h67.3c4.1 0 6.3-5.1 3.6-8.3L256.5 380.8c-7.4-8.9-16.5-15.9-26.7-20.8zM445 512h19 51.3c4.1 0 6.3-5.1 3.6-8.3L416.5 380.8C401.3 362.5 378.8 352 355 352H336 288c-1.1 0-2.3 0-3.4 0c-4.1 0-6.2 5.1-3.5 8.3L383.5 483.2C398.7 501.5 421.2 512 445 512zm-3.9-151.7L543.5 483.2c14.6 17.5 35.9 27.9 58.6 28.7c21.1-1.1 37.9-18.6 37.9-39.9V392c0-22.1-17.9-40-40-40H444.7c-4.1 0-6.3 5.1-3.6 8.3z"
    ]
};
var $5c8203742f0e3062$export$6bce1afb61f2eb66 = {
    prefix: "fas",
    iconName: "angle-right",
    icon: [
        320,
        512,
        [
            8250
        ],
        "f105",
        "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
    ]
};
var $5c8203742f0e3062$export$5b05f097fa38352a = {
    prefix: "fas",
    iconName: "horse",
    icon: [
        576,
        512,
        [
            128014
        ],
        "f6f0",
        "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 448C377.3 0 320 57.3 320 128H224 203.2 148.8c-30.7 0-57.6 16.3-72.5 40.8C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7h0v-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $5c8203742f0e3062$export$5a2b164552deda9f = {
    prefix: "fas",
    iconName: "q",
    icon: [
        448,
        512,
        [
            113
        ],
        "51",
        "M64 256c0 88.4 71.6 160 160 160c28.9 0 56-7.7 79.4-21.1l-72-86.4c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l70.9 85.1C371.9 325.8 384 292.3 384 256c0-88.4-71.6-160-160-160S64 167.6 64 256zM344.9 444.6C310 467 268.5 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7l47.3 56.8c11.3 13.6 9.5 33.8-4.1 45.1s-33.8 9.5-45.1-4.1l-46.6-55.9z"
    ]
};
var $5c8203742f0e3062$export$9f5c2b0db8eedeac = {
    prefix: "fas",
    iconName: "g",
    icon: [
        448,
        512,
        [
            103
        ],
        "47",
        "M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c77.4 0 142-55 156.8-128H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H400c25.8 0 49.6 21.4 47.2 50.6C437.8 389.6 341.4 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c13.2 11.8 14.3 32 2.5 45.2s-32 14.3-45.2 2.5C302.3 111.4 265 96 224 96z"
    ]
};
var $5c8203742f0e3062$export$b2d79133c81d6697 = {
    prefix: "fas",
    iconName: "notes-medical",
    icon: [
        512,
        512,
        [],
        "f481",
        "M96 352V96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V293.5c0 17-6.7 33.3-18.7 45.3l-58.5 58.5c-12 12-28.3 18.7-45.3 18.7H160c-35.3 0-64-28.7-64-64zM272 128c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256h48c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H320V144c0-8.8-7.2-16-16-16H272zm24 336c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 224c0 48.6 39.4 88 88 88H296z"
    ]
};
var $5c8203742f0e3062$export$a3f1d7f13c202adc = {
    prefix: "fas",
    iconName: "temperature-half",
    icon: [
        320,
        512,
        [
            127777,
            "temperature-2",
            "thermometer-2",
            "thermometer-half"
        ],
        "f2c9",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V208c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $5c8203742f0e3062$export$8176e649df45b32c = $5c8203742f0e3062$export$a3f1d7f13c202adc;
var $5c8203742f0e3062$export$4dd764ac8d512682 = $5c8203742f0e3062$export$a3f1d7f13c202adc;
var $5c8203742f0e3062$export$2090f040324b4449 = $5c8203742f0e3062$export$a3f1d7f13c202adc;
var $5c8203742f0e3062$export$18659308f17918a5 = {
    prefix: "fas",
    iconName: "dong-sign",
    icon: [
        384,
        512,
        [],
        "e169",
        "M288 32c-17.7 0-32 14.3-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v49.1c-18.8-10.9-40.7-17.1-64-17.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32V288 128c17.7 0 32-14.3 32-32s-14.3-32-32-32c0-17.7-14.3-32-32-32zM128 288a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $5c8203742f0e3062$export$ba6fd4a436804a48 = {
    prefix: "fas",
    iconName: "capsules",
    icon: [
        576,
        512,
        [],
        "f46b",
        "M64 144c0-26.5 21.5-48 48-48s48 21.5 48 48V256H64V144zM0 144V368c0 61.9 50.1 112 112 112s112-50.1 112-112V189.6c1.8 19.1 8.2 38 19.8 54.8L372.3 431.7c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3C391.8 61.5 321.9 49 271.3 85.2c-28 20-44.3 50.8-47.3 83V144c0-61.9-50.1-112-112-112S0 82.1 0 144zm296.6 64.2c-16-23.3-10-55.3 11.9-71c21.2-15.1 50.5-10.3 66 12.2l67 97.6L361.6 303l-65-94.8zM491 407.7c-.8 .6-1.6 1.1-2.4 1.6l4-2.8c-.5 .4-1 .8-1.6 1.2z"
    ]
};
var $5c8203742f0e3062$export$48a38da471b097a2 = {
    prefix: "fas",
    iconName: "poo-storm",
    icon: [
        448,
        512,
        [
            "poo-bolt"
        ],
        "f75a",
        "M236.9 .2c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.3c2.8 8.2 4.3 16.9 4.3 26.1c0 21.7-8.5 37.2-21.9 47.6c-13.8 10.8-34 17-57.8 17H128c-35.3 0-64 28.7-64 64c0 12.2 3.4 23.5 9.3 33.2C31.7 216.2 0 252.4 0 296c0 40.9 28 75.4 65.8 85.2c-5.3-18.5 1-38.5 16.2-50.7l160-128c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L285.7 320H304c20.4 0 38.5 12.9 45.3 32.1c3.7 10.6 3.5 21.8 0 31.9H360c48.6 0 88-39.4 88-88c0-43.6-31.7-79.8-73.3-86.8c5.9-9.7 9.3-21.1 9.3-33.2c0-35.3-28.7-64-64-64h-1.4c.9-5.4 1.4-10.9 1.4-16.6c0-48.7-36.1-88.9-83.1-95.2zm45.1 227.4c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L129.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H233.9l52.4-104.8c3.4-6.7 1.6-14.9-4.3-19.6z"
    ]
};
var $5c8203742f0e3062$export$9a24e77f74d9cbd9 = $5c8203742f0e3062$export$48a38da471b097a2;
var $5c8203742f0e3062$export$c8a28356e07b9ccb = {
    prefix: "fas",
    iconName: "face-frown-open",
    icon: [
        512,
        512,
        [
            128550,
            "frown-open"
        ],
        "f57a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-122 174.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8z"
    ]
};
var $5c8203742f0e3062$export$c4775e66bed5d96 = $5c8203742f0e3062$export$c8a28356e07b9ccb;
var $5c8203742f0e3062$export$cdc9f5e7e94e76da = {
    prefix: "fas",
    iconName: "hand-point-up",
    icon: [
        384,
        512,
        [
            9757
        ],
        "f0a6",
        "M32 32C32 14.3 46.3 0 64 0S96 14.3 96 32V240H32V32zM224 192c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm160 96c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H162.3c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363V336c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"
    ]
};
var $5c8203742f0e3062$export$608138a7337b5d1a = {
    prefix: "fas",
    iconName: "money-bill",
    icon: [
        576,
        512,
        [],
        "f0d6",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $5c8203742f0e3062$export$4ed9da5c3cca0ef1 = {
    prefix: "fas",
    iconName: "bookmark",
    icon: [
        384,
        512,
        [
            128278,
            61591
        ],
        "f02e",
        "M0 48V487.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400 345.7 507.6c4.1 2.9 9 4.4 14 4.4c13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z"
    ]
};
var $5c8203742f0e3062$export$97c42b56d462df72 = {
    prefix: "fas",
    iconName: "align-justify",
    icon: [
        448,
        512,
        [],
        "f039",
        "M448 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32zm0 256c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 192c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM448 448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32z"
    ]
};
var $5c8203742f0e3062$export$20932e4d438e4e4c = {
    prefix: "fas",
    iconName: "umbrella-beach",
    icon: [
        576,
        512,
        [
            127958
        ],
        "f5ca",
        "M346.3 271.8l-60.1-21.9L214 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H282.1l64.1-176.2zm121.1-.2l-3.3 9.1 67.7 24.6c18.1 6.6 38-4.2 39.6-23.4c6.5-78.5-23.9-155.5-80.8-208.5c2 8 3.2 16.3 3.4 24.8l.2 6c1.8 57-7.3 113.8-26.8 167.4zM462 99.1c-1.1-34.4-22.5-64.8-54.4-77.4c-.9-.4-1.9-.7-2.8-1.1c-33-11.7-69.8-2.4-93.1 23.8l-4 4.5C272.4 88.3 245 134.2 226.8 184l-3.3 9.1L434 269.7l3.3-9.1c18.1-49.8 26.6-102.5 24.9-155.5l-.2-6zM107.2 112.9c-11.1 15.7-2.8 36.8 15.3 43.4l71 25.8 3.3-9.1c19.5-53.6 49.1-103 87.1-145.5l4-4.5c6.2-6.9 13.1-13 20.5-18.2c-79.6 2.5-154.7 42.2-201.2 108z"
    ]
};
var $5c8203742f0e3062$export$5e975cb293c48461 = {
    prefix: "fas",
    iconName: "helmet-un",
    icon: [
        512,
        512,
        [],
        "e503",
        "M479.5 224C471.2 98.9 367.2 0 240 0C107.5 0 0 107.5 0 240v56.3C0 344.8 39.2 384 87.7 384H200h14.9L343.5 505.4c4.5 4.2 10.4 6.6 16.5 6.6h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H369.5l-1.5-1.5V288h80 32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.5zM320 417.2l-78-73.7L274.4 288H320V417.2zM285.3 103.1l34.7 52V112c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM160 112v64c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $5c8203742f0e3062$export$554720e3bf74fe90 = {
    prefix: "fas",
    iconName: "bullseye",
    icon: [
        512,
        512,
        [],
        "f140",
        "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $5c8203742f0e3062$export$ab07061fe21a3a8e = {
    prefix: "fas",
    iconName: "bacon",
    icon: [
        576,
        512,
        [
            129363
        ],
        "f7e5",
        "M439.2 1.2c11.2-3.2 23.2-.1 31.4 8.1L518 56.7l-26.5 7.9c-58 16.6-98.1 39.6-129.6 67.4c-31.2 27.5-53.2 59.1-75.1 90.9l-2.3 3.3C241.6 288.7 195 356.6 72.8 417.7L37.9 435.2 9.4 406.6c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C136.1 296.2 180.9 231 223.3 169.3l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8zM61.8 459l25.4-12.7c129.5-64.7 179.9-138.1 223.8-202l2.2-3.3c22.1-32.1 42.1-60.5 69.9-85.1c27.5-24.3 63.4-45.2 117.3-60.6l0 0 .2-.1 43.1-12.9 23 23c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2c-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6L61.8 459z"
    ]
};
var $5c8203742f0e3062$export$f6dcbf0a940428f4 = {
    prefix: "fas",
    iconName: "hand-point-down",
    icon: [
        384,
        512,
        [],
        "f0a7",
        "M32 480c0 17.7 14.3 32 32 32s32-14.3 32-32V272H32V480zM224 320c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-64 64c17.7 0 32-14.3 32-32V304c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 17.7 14.3 32 32 32zm160-96c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-96-88l0 .6c9.4-5.4 20.3-8.6 32-8.6c13.2 0 25.4 4 35.6 10.8c8.7-24.9 32.5-42.8 60.4-42.8c11.7 0 22.6 3.1 32 8.6V160C384 71.6 312.4 0 224 0H162.3C119.8 0 79.1 16.9 49.1 46.9L37.5 58.5C13.5 82.5 0 115.1 0 149v27c0 35.3 28.7 64 64 64h88c22.1 0 40-17.9 40-40s-17.9-40-40-40H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h56c39.8 0 72 32.2 72 72z"
    ]
};
var $5c8203742f0e3062$export$c2af1be14cd87640 = {
    prefix: "fas",
    iconName: "arrow-up-from-bracket",
    icon: [
        448,
        512,
        [],
        "e09a",
        "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 109.3 192 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-64z"
    ]
};
var $5c8203742f0e3062$export$72b780186370e953 = {
    prefix: "fas",
    iconName: "folder",
    icon: [
        512,
        512,
        [
            128193,
            128447,
            61716,
            "folder-blank"
        ],
        "f07b",
        "M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"
    ]
};
var $5c8203742f0e3062$export$9ef114244d26da0 = $5c8203742f0e3062$export$72b780186370e953;
var $5c8203742f0e3062$export$5e0c19cf315ac1bf = {
    prefix: "fas",
    iconName: "file-waveform",
    icon: [
        448,
        512,
        [
            "file-medical-alt"
        ],
        "f478",
        "M96 0C60.7 0 32 28.7 32 64V288H144c6.1 0 11.6 3.4 14.3 8.8L176 332.2l49.7-99.4c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8L281.9 288H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-6.1 0-11.6-3.4-14.3-8.8L240 275.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L134.1 320H32V448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V160H288c-17.7 0-32-14.3-32-32V0H96zM288 0V128H416L288 0z"
    ]
};
var $5c8203742f0e3062$export$ef02a0f5b39aa61f = $5c8203742f0e3062$export$5e0c19cf315ac1bf;
var $5c8203742f0e3062$export$4c4e509518093d6d = {
    prefix: "fas",
    iconName: "radiation",
    icon: [
        512,
        512,
        [],
        "f7b9",
        "M216 186.7c-23.9 13.8-40 39.7-40 69.3L32 256C14.3 256-.2 241.6 2 224.1C10.7 154 47.8 92.7 101.3 52c14.1-10.7 33.8-5.3 42.7 10l72 124.7zM256 336c14.6 0 28.2-3.9 40-10.7l72 124.8c8.8 15.3 3.7 35.1-12.6 41.9c-30.6 12.9-64.2 20-99.4 20s-68.9-7.1-99.4-20c-16.3-6.9-21.4-26.6-12.6-41.9l72-124.8c11.8 6.8 25.4 10.7 40 10.7zm224-80l-144 0c0-29.6-16.1-55.5-40-69.3L368 62c8.8-15.3 28.6-20.7 42.7-10c53.6 40.7 90.6 102 99.4 172.1c2.2 17.5-12.4 31.9-30 31.9zM256 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $5c8203742f0e3062$export$8760a1de19ea40b9 = {
    prefix: "fas",
    iconName: "chart-simple",
    icon: [
        448,
        512,
        [],
        "e473",
        "M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"
    ]
};
var $5c8203742f0e3062$export$aa05fce255a5d269 = {
    prefix: "fas",
    iconName: "mars-stroke",
    icon: [
        512,
        512,
        [
            9894
        ],
        "f229",
        "M376 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L370.3 96.4 345 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l25.4 25.4L307.8 159c-28.4-19.5-62.7-31-99.8-31c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l28.6-28.6L407 201c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-25.4-25.4 22.1-22.1L471 153c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H376zm88 48h0v0l0 0zM96 304a112 112 0 1 1 224 0A112 112 0 1 1 96 304z"
    ]
};
var $5c8203742f0e3062$export$aa014b06d2d70598 = {
    prefix: "fas",
    iconName: "vial",
    icon: [
        512,
        512,
        [
            129514
        ],
        "f492",
        "M342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L28.1 342.6C10.1 360.6 0 385 0 410.5V416c0 53 43 96 96 96h5.5c25.5 0 49.9-10.1 67.9-28.1L448 205.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-32-32-96-96-32-32zM205.3 256L352 109.3 402.7 160l-96 96H205.3z"
    ]
};
var $5c8203742f0e3062$export$dbfb0a9f89ad94a4 = {
    prefix: "fas",
    iconName: "gauge",
    icon: [
        512,
        512,
        [
            "dashboard",
            "gauge-med",
            "tachometer-alt-average"
        ],
        "f624",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $5c8203742f0e3062$export$b7ce24136743d0f1 = $5c8203742f0e3062$export$dbfb0a9f89ad94a4;
var $5c8203742f0e3062$export$f948a9dd257979f3 = $5c8203742f0e3062$export$dbfb0a9f89ad94a4;
var $5c8203742f0e3062$export$6f22c345e5a92d1a = $5c8203742f0e3062$export$dbfb0a9f89ad94a4;
var $5c8203742f0e3062$export$5325fc72e75360b4 = {
    prefix: "fas",
    iconName: "wand-magic-sparkles",
    icon: [
        576,
        512,
        [
            "magic-wand-sparkles"
        ],
        "e2ca",
        "M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"
    ]
};
var $5c8203742f0e3062$export$c93286938249f0da = $5c8203742f0e3062$export$5325fc72e75360b4;
var $5c8203742f0e3062$export$86923e6fe1b42f5e = {
    prefix: "fas",
    iconName: "e",
    icon: [
        320,
        512,
        [
            101
        ],
        "45",
        "M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"
    ]
};
var $5c8203742f0e3062$export$eff4bdcafd3b8d1c = {
    prefix: "fas",
    iconName: "pen-clip",
    icon: [
        512,
        512,
        [
            "pen-alt"
        ],
        "f305",
        "M453.3 19.3l39.4 39.4c25 25 25 65.5 0 90.5l-52.1 52.1 0 0-1-1 0 0-16-16-96-96-17-17 52.1-52.1c25-25 65.5-25 90.5 0zM241 114.9c-9.4-9.4-24.6-9.4-33.9 0L105 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L173.1 81c28.1-28.1 73.7-28.1 101.8 0L288 94.1l17 17 96 96 16 16 1 1-17 17L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8L254.1 128 241 114.9z"
    ]
};
var $5c8203742f0e3062$export$a3d3e92e430d3beb = $5c8203742f0e3062$export$eff4bdcafd3b8d1c;
var $5c8203742f0e3062$export$4f25939fdf728c27 = {
    prefix: "fas",
    iconName: "bridge-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e4ca",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$f5699fa0844e0188 = {
    prefix: "fas",
    iconName: "user",
    icon: [
        448,
        512,
        [
            128100,
            62144
        ],
        "f007",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"
    ]
};
var $5c8203742f0e3062$export$c8c95c2f9937bf6a = {
    prefix: "fas",
    iconName: "school-circle-check",
    icon: [
        640,
        512,
        [],
        "e56b",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"
    ]
};
var $5c8203742f0e3062$export$3b934e22d1851a3b = {
    prefix: "fas",
    iconName: "dumpster",
    icon: [
        576,
        512,
        [],
        "f793",
        "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0H428.5L402.9 32H304V160zm157.1 0h94c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l25.6 128zM32 192l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H448c0 17.7 14.3 32 32 32s32-14.3 32-32l20-160h12c17.7 0 32-14.3 32-32s-14.3-32-32-32h-4l4-32H32z"
    ]
};
var $5c8203742f0e3062$export$ecbd233b96906ee1 = {
    prefix: "fas",
    iconName: "van-shuttle",
    icon: [
        640,
        512,
        [
            128656,
            "shuttle-van"
        ],
        "f5b6",
        "M64 104v88h96V96H72c-4.4 0-8 3.6-8 8zm482 88L465.1 96H384v96H546zm-226 0V96H224v96h96zM592 384H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V104C0 64.2 32.2 32 72 32H192 352 465.1c18.9 0 36.8 8.3 49 22.8L625 186.5c9.7 11.5 15 26.1 15 41.2V336c0 26.5-21.5 48-48 48zm-64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $5c8203742f0e3062$export$9d63d851db698c09 = $5c8203742f0e3062$export$ecbd233b96906ee1;
var $5c8203742f0e3062$export$d65aef1ed7db1dae = {
    prefix: "fas",
    iconName: "building-user",
    icon: [
        640,
        512,
        [],
        "e4da",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h89.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM576 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM352 477.1c0 19.3 15.6 34.9 34.9 34.9H605.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H445.1c-51.4 0-93.1 41.7-93.1 93.1z"
    ]
};
var $5c8203742f0e3062$export$2c5163541229363 = {
    prefix: "fas",
    iconName: "square-caret-left",
    icon: [
        448,
        512,
        [
            "caret-square-left"
        ],
        "f191",
        "M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 256c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
    ]
};
var $5c8203742f0e3062$export$d0c8ba444f1f9581 = $5c8203742f0e3062$export$2c5163541229363;
var $5c8203742f0e3062$export$73801ed54b42fabe = {
    prefix: "fas",
    iconName: "highlighter",
    icon: [
        576,
        512,
        [],
        "f591",
        "M315 315l158.4-215L444.1 70.6 229 229 315 315zm-187 5l0 0V248.3c0-15.3 7.2-29.6 19.5-38.6L420.6 8.4C428 2.9 437 0 446.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5c0 9.2-2.9 18.2-8.4 25.6L334.4 396.5c-9 12.3-23.4 19.5-38.6 19.5H224l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3L128 320zM7 466.3l63-63 70.6 70.6-31 31c-4.5 4.5-10.6 7-17 7H24c-13.3 0-24-10.7-24-24v-4.7c0-6.4 2.5-12.5 7-17z"
    ]
};
var $5c8203742f0e3062$export$fa6ecc35e7315db = {
    prefix: "fas",
    iconName: "key",
    icon: [
        512,
        512,
        [
            128273
        ],
        "f084",
        "M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
    ]
};
var $5c8203742f0e3062$export$dacae2b4ec565333 = {
    prefix: "fas",
    iconName: "bullhorn",
    icon: [
        512,
        512,
        [
            128226,
            128363
        ],
        "f0a1",
        "M480 32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9L381.7 53c-48 48-113.1 75-181 75H192 160 64c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64l0 128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352l8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V300.4c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4V32zm-64 76.7V240 371.3C357.2 317.8 280.5 288 200.7 288H192V192h8.7c79.8 0 156.5-29.8 215.3-83.3z"
    ]
};
var $5c8203742f0e3062$export$b1b1cdce4a19c682 = {
    prefix: "fas",
    iconName: "globe",
    icon: [
        512,
        512,
        [
            127760
        ],
        "f0ac",
        "M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z"
    ]
};
var $5c8203742f0e3062$export$20d991385719b5b4 = {
    prefix: "fas",
    iconName: "synagogue",
    icon: [
        640,
        512,
        [
            128333
        ],
        "f69b",
        "M309.8 3.7c5.9-4.9 14.6-4.9 20.5 0l121 100.8C469.5 119.7 480 142.2 480 166V280.1 512H464 352V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v96H176 160V280.1 166c0-23.7 10.5-46.3 28.8-61.5L309.8 3.7zM512 512V244.5l28.1-31.2c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3l63.8 70.9c7.9 8.8 12.3 20.3 12.3 32.1V448c0 35.3-28.7 64-64 64H512zM128 244.5V512H64c-35.3 0-64-28.7-64-64V316.3c0-11.9 4.4-23.3 12.3-32.1l63.8-70.9c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3L128 244.5zM327 124.3c-3.1-5.4-10.9-5.4-13.9 0l-15.9 28.1-32.3-.3c-6.2-.1-10.1 6.7-7 12.1L274.3 192l-16.4 27.8c-3.2 5.4 .7 12.1 7 12.1l32.3-.3L313 259.7c3.1 5.4 10.9 5.4 13.9 0l15.9-28.1 32.3 .3c6.2 .1 10.1-6.7 7-12.1L365.7 192l16.4-27.8c3.2-5.4-.7-12.1-7-12.1l-32.3 .3L327 124.3z"
    ]
};
var $5c8203742f0e3062$export$f3d75c19191f1688 = {
    prefix: "fas",
    iconName: "person-half-dress",
    icon: [
        320,
        512,
        [],
        "e548",
        "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm8 352V128h6.9c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352h0zM58.2 182.3c19.9-33.1 55.3-53.5 93.8-54.3V384h0v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2z"
    ]
};
var $5c8203742f0e3062$export$4d6835e7175dec24 = {
    prefix: "fas",
    iconName: "road-bridge",
    icon: [
        640,
        512,
        [],
        "e563",
        "M352 0H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM480 200c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V224c0-13.3-10.7-24-24-24zm24 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V384zM480 40c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-13.3-10.7-24-24-24zM32 96H288v64H248v64h40v96c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V416c0-53-43-96-96-96V224H72V160H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm168 64H120v64h80V160z"
    ]
};
var $5c8203742f0e3062$export$4ac9c4c370f7b157 = {
    prefix: "fas",
    iconName: "location-arrow",
    icon: [
        448,
        512,
        [],
        "f124",
        "M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H224V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z"
    ]
};
var $5c8203742f0e3062$export$a2c1c457834fc6d8 = {
    prefix: "fas",
    iconName: "c",
    icon: [
        384,
        512,
        [
            99
        ],
        "43",
        "M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3s155.8 62.5 218.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8s221.3-87.5 308.8 0c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"
    ]
};
var $5c8203742f0e3062$export$2d33c367b2b091ac = {
    prefix: "fas",
    iconName: "tablet-button",
    icon: [
        448,
        512,
        [],
        "f10a",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$6f08294ba8a2459c = {
    prefix: "fas",
    iconName: "building-lock",
    icon: [
        576,
        512,
        [],
        "e4d6",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h88.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-23.7 12.9-44.4 32-55.4V272c0-30.5 12.2-58.2 32-78.4V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM464 240c17.7 0 32 14.3 32 32v48H432V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $5c8203742f0e3062$export$c9f93c4667edc585 = {
    prefix: "fas",
    iconName: "pizza-slice",
    icon: [
        512,
        512,
        [],
        "f818",
        "M169.7 .9c-22.8-1.6-41.9 14-47.5 34.7L110.4 80c.5 0 1.1 0 1.6 0c176.7 0 320 143.3 320 320c0 .5 0 1.1 0 1.6l44.4-11.8c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7 .9zM399.8 410.2c.1-3.4 .2-6.8 .2-10.2c0-159.1-128.9-288-288-288c-3.4 0-6.8 .1-10.2 .2L.5 491.9c-1.5 5.5 .1 11.4 4.1 15.4s9.9 5.6 15.4 4.1L399.8 410.2zM176 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM96 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $5c8203742f0e3062$export$53e23123cc9a6796 = {
    prefix: "fas",
    iconName: "money-bill-wave",
    icon: [
        576,
        512,
        [],
        "f53a",
        "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM64 352c35.3 0 64 28.7 64 64H64V352zm64-208c0 35.3-28.7 64-64 64V144h64zM512 304v64H448c0-35.3 28.7-64 64-64zM448 96h64v64c-35.3 0-64-28.7-64-64z"
    ]
};
var $5c8203742f0e3062$export$2acab8312b7a999b = {
    prefix: "fas",
    iconName: "chart-area",
    icon: [
        512,
        512,
        [
            "area-chart"
        ],
        "f1fe",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm96 288H448c17.7 0 32-14.3 32-32V251.8c0-7.6-2.7-15-7.7-20.8l-65.8-76.8c-12.1-14.2-33.7-15-46.9-1.8l-21 21c-10 10-26.4 9.2-35.4-1.6l-39.2-47c-12.6-15.1-35.7-15.4-48.7-.6L135.9 215c-5.1 5.8-7.9 13.3-7.9 21.1v84c0 17.7 14.3 32 32 32z"
    ]
};
var $5c8203742f0e3062$export$fc2e595f0e0612cb = $5c8203742f0e3062$export$2acab8312b7a999b;
var $5c8203742f0e3062$export$9a3d31c75a465b9a = {
    prefix: "fas",
    iconName: "house-flag",
    icon: [
        640,
        512,
        [],
        "e50d",
        "M480 0c-17.7 0-32 14.3-32 32V192 512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H512c0-17.7-14.3-32-32-32zM416 159L276.8 39.7c-12-10.3-29.7-10.3-41.7 0l-224 192C1 240.4-2.7 254.5 2 267.1S18.6 288 32 288H64V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v96c0 17.7 14.3 32 32 32h64.7l.2 0h-1V159z"
    ]
};
var $5c8203742f0e3062$export$d7ccc6651f90f7cc = {
    prefix: "fas",
    iconName: "person-circle-minus",
    icon: [
        576,
        512,
        [],
        "e540",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"
    ]
};
var $5c8203742f0e3062$export$76f704d256def3c7 = {
    prefix: "fas",
    iconName: "ban",
    icon: [
        512,
        512,
        [
            128683,
            "cancel"
        ],
        "f05e",
        "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var $5c8203742f0e3062$export$6d25ef56192f6d69 = $5c8203742f0e3062$export$76f704d256def3c7;
var $5c8203742f0e3062$export$e0ce7d1aba7105e7 = {
    prefix: "fas",
    iconName: "camera-rotate",
    icon: [
        640,
        512,
        [],
        "e0d8",
        "M213.1 64.8L202.7 96H128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H437.3L426.9 64.8C420.4 45.2 402.1 32 381.4 32H258.6c-20.7 0-39 13.2-45.5 32.8zM448 256c0 8.8-7.2 16-16 16H355.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3V256zM192 320c0-8.8 7.2-16 16-16h76.7c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3V320z"
    ]
};
var $5c8203742f0e3062$export$43832c90c10a7a31 = {
    prefix: "fas",
    iconName: "spray-can-sparkles",
    icon: [
        512,
        512,
        [
            "air-freshener"
        ],
        "f5d0",
        "M96 32v96H224V32c0-17.7-14.3-32-32-32H128C110.3 0 96 14.3 96 32zm0 128c-53 0-96 43-96 96V464c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V256c0-53-43-96-96-96H96zm64 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM384 48c0-1.4-1-3-2.2-3.6L352 32 339.6 2.2C339 1 337.4 0 336 0s-3 1-3.6 2.2L320 32 290.2 44.4C289 45 288 46.6 288 48c0 1.4 1 3 2.2 3.6L320 64l12.4 29.8C333 95 334.6 96 336 96s3-1 3.6-2.2L352 64l29.8-12.4C383 51 384 49.4 384 48zm76.4 45.8C461 95 462.6 96 464 96s3-1 3.6-2.2L480 64l29.8-12.4C511 51 512 49.4 512 48c0-1.4-1-3-2.2-3.6L480 32 467.6 2.2C467 1 465.4 0 464 0s-3 1-3.6 2.2L448 32 418.2 44.4C417 45 416 46.6 416 48c0 1.4 1 3 2.2 3.6L448 64l12.4 29.8zm7.2 100.4c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L448 224l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L448 256l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 256l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6c0-1.4-1-3-2.2-3.6L480 224l-12.4-29.8zM448 144c0-1.4-1-3-2.2-3.6L416 128 403.6 98.2C403 97 401.4 96 400 96s-3 1-3.6 2.2L384 128l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L384 160l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L416 160l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6z"
    ]
};
var $5c8203742f0e3062$export$a5e63e89b5ccee83 = $5c8203742f0e3062$export$43832c90c10a7a31;
var $5c8203742f0e3062$export$a3b0eb2cd7942125 = {
    prefix: "fas",
    iconName: "star",
    icon: [
        576,
        512,
        [
            11088,
            61446
        ],
        "f005",
        "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
    ]
};
var $5c8203742f0e3062$export$cb8434288c91ae83 = {
    prefix: "fas",
    iconName: "repeat",
    icon: [
        512,
        512,
        [
            128257
        ],
        "f363",
        "M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32V64H160C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96H192V352c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V448H352c88.4 0 160-71.6 160-160z"
    ]
};
var $5c8203742f0e3062$export$9d0a89fcd084abb = {
    prefix: "fas",
    iconName: "cross",
    icon: [
        384,
        512,
        [
            128327,
            10013
        ],
        "f654",
        "M176 0c-26.5 0-48 21.5-48 48v80H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h80V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V256h80c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H256V48c0-26.5-21.5-48-48-48H176z"
    ]
};
var $5c8203742f0e3062$export$6e7cf270cda52323 = {
    prefix: "fas",
    iconName: "box",
    icon: [
        448,
        512,
        [
            128230
        ],
        "f466",
        "M50.7 58.5L0 160H208V32H93.7C75.5 32 58.9 42.3 50.7 58.5zM240 160H448L397.3 58.5C389.1 42.3 372.5 32 354.3 32H240V160zm208 32H0V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192z"
    ]
};
var $5c8203742f0e3062$export$63f2d9e5f4689aa8 = {
    prefix: "fas",
    iconName: "venus-mars",
    icon: [
        640,
        512,
        [
            9892
        ],
        "f228",
        "M176 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H208v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C62.1 334.1 0 262.3 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c19.3-10.1 36.9-23.1 52.1-38.4c20 18.5 46.7 29.8 76.1 29.8c61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3 .7-21.1 2c-4.9-21.5-13-41.7-24-60.2C369.3 66 384.4 64 400 64c37 0 71.4 11.4 99.8 31l20.6-20.6L487 41c-6.9-6.9-8.9-17.2-5.2-26.2S494.3 0 504 0H616c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L545 140.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z"
    ]
};
var $5c8203742f0e3062$export$e4f903bc63db445 = {
    prefix: "fas",
    iconName: "arrow-pointer",
    icon: [
        320,
        512,
        [
            "mouse-pointer"
        ],
        "f245",
        "M0 55.2V426c0 12.2 9.9 22 22 22c6.3 0 12.4-2.7 16.6-7.5L121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320H297.9c12.2 0 22.1-9.9 22.1-22.1c0-6.3-2.7-12.3-7.4-16.5L38.6 37.9C34.3 34.1 28.9 32 23.2 32C10.4 32 0 42.4 0 55.2z"
    ]
};
var $5c8203742f0e3062$export$2e19a69cc26b147 = $5c8203742f0e3062$export$e4f903bc63db445;
var $5c8203742f0e3062$export$8d2b1b230601e804 = {
    prefix: "fas",
    iconName: "maximize",
    icon: [
        512,
        512,
        [
            "expand-arrows-alt"
        ],
        "f31e",
        "M200 32H56C42.7 32 32 42.7 32 56V200c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 79 79-79 79L73 295c-6.9-6.9-17.2-8.9-26.2-5.2S32 302.3 32 312V456c0 13.3 10.7 24 24 24H200c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H456c13.3 0 24-10.7 24-24V312c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S209.7 32 200 32z"
    ]
};
var $5c8203742f0e3062$export$6219dcd88b5fa6c2 = $5c8203742f0e3062$export$8d2b1b230601e804;
var $5c8203742f0e3062$export$bab2cd86f8c65657 = {
    prefix: "fas",
    iconName: "charging-station",
    icon: [
        576,
        512,
        [],
        "f5e7",
        "M96 0C60.7 0 32 28.7 32 64V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32V304h16c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V252.3c32.5-10.2 56-40.5 56-76.3V144c0-8.8-7.2-16-16-16H544V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H480V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16v32c0 35.8 23.5 66.1 56 76.3V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V344c0-48.6-39.4-88-88-88H320V64c0-35.3-28.7-64-64-64H96zM216.9 82.7c6 4 8.5 11.5 6.3 18.3l-25 74.9H256c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-112 96c-5.5 4.7-13.4 5.1-19.3 1.1s-8.5-11.5-6.3-18.3l25-74.9H96c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7l112-96c5.5-4.7 13.4-5.1 19.3-1.1z"
    ]
};
var $5c8203742f0e3062$export$b17d50542d1fc340 = {
    prefix: "fas",
    iconName: "shapes",
    icon: [
        512,
        512,
        [
            "triangle-circle-square"
        ],
        "f61f",
        "M315.4 15.5C309.7 5.9 299.2 0 288 0s-21.7 5.9-27.4 15.5l-96 160c-5.9 9.9-6.1 22.2-.4 32.2s16.3 16.2 27.8 16.2H384c11.5 0 22.2-6.2 27.8-16.2s5.5-22.3-.4-32.2l-96-160zM288 312V456c0 22.1 17.9 40 40 40H472c22.1 0 40-17.9 40-40V312c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40zM128 512a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"
    ]
};
var $5c8203742f0e3062$export$34261e5aea24fc1d = $5c8203742f0e3062$export$b17d50542d1fc340;
var $5c8203742f0e3062$export$ee94b652453ad208 = {
    prefix: "fas",
    iconName: "shuffle",
    icon: [
        512,
        512,
        [
            128256,
            "random"
        ],
        "f074",
        "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160H352c-10.1 0-19.6 4.7-25.6 12.8L284 229.3 244 176l31.2-41.6C293.3 110.2 321.8 96 352 96h32V64c0-12.9 7.8-24.6 19.8-29.6zM164 282.7L204 336l-31.2 41.6C154.7 401.8 126.2 416 96 416H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c10.1 0 19.6-4.7 25.6-12.8L164 282.7zm274.6 188c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V416H352c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c30.2 0 58.7 14.2 76.8 38.4L326.4 339.2c6 8.1 15.5 12.8 25.6 12.8h32V320c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64z"
    ]
};
var $5c8203742f0e3062$export$8357bf8cc666d5f0 = $5c8203742f0e3062$export$ee94b652453ad208;
var $5c8203742f0e3062$export$f48814ae62850c74 = {
    prefix: "fas",
    iconName: "person-running",
    icon: [
        448,
        512,
        [
            127939,
            "running"
        ],
        "f70c",
        "M320 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM125.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L137.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L238 299l30.9-82.4 5.1 12.3C289 264.7 323.9 288 362.7 288H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H362.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3L57.4 153.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM91.2 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h69.6c19 0 36.2-11.2 43.9-28.5L157 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L91.2 352z"
    ]
};
var $5c8203742f0e3062$export$5dfd1cb43dc9eadb = $5c8203742f0e3062$export$f48814ae62850c74;
var $5c8203742f0e3062$export$7955f08360418647 = {
    prefix: "fas",
    iconName: "mobile-retro",
    icon: [
        320,
        512,
        [],
        "e527",
        "M0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm64 96v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"
    ]
};
var $5c8203742f0e3062$export$523960de087f5198 = {
    prefix: "fas",
    iconName: "grip-lines-vertical",
    icon: [
        192,
        512,
        [],
        "f7a5",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"
    ]
};
var $5c8203742f0e3062$export$6daa96b1986e2ef0 = {
    prefix: "fas",
    iconName: "spider",
    icon: [
        512,
        512,
        [
            128375
        ],
        "f717",
        "M158.4 32.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L81.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4L70.8 190.3c-2.4-.8-4.3-2.7-5.1-5.1L46.8 128.4C42.6 115.8 29 109 16.4 113.2S-3 131 1.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4L116.1 256 55.6 276.2c-16.7 5.6-29.8 18.7-35.4 35.4L1.2 368.4C-3 381 3.8 394.6 16.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l80.4-26.8L93.7 352.3C78.1 368 73.1 391.4 81.1 412l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5L160 353.9c1 52.1 43.6 94.1 96 94.1s95-41.9 96-94.1l32.3 32.3c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8L430.9 412c7.9-20.7 3-44.1-12.7-59.7l-57.4-57.4 80.4 26.8c2.4 .8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L395.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1l-80.4 26.8 57.4-57.4c15.6-15.6 20.6-39 12.7-59.7L398.4 15.4C393.6 3 379.8-3.2 367.4 1.6s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L336 174.1V160c0-31.8-18.6-59.3-45.5-72.2c-9.1-4.4-18.5 3.3-18.5 13.4V112c0 8.8-7.2 16-16 16s-16-7.2-16-16V101.2c0-10.1-9.4-17.7-18.5-13.4C194.6 100.7 176 128.2 176 160v14.1l-48.3-48.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6z"
    ]
};
var $5c8203742f0e3062$export$740142a89118fbc0 = {
    prefix: "fas",
    iconName: "hands-bound",
    icon: [
        640,
        512,
        [],
        "e4f9",
        "M96 32C96 14.3 81.7 0 64 0S32 14.3 32 32V96v59.1 .7V192v21.9c0 14.2 5.1 27.9 14.3 38.7L131.6 352H128c-13.3 0-24 10.7-24 24s10.7 24 24 24h32H288h64H480h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-3.6l85.3-99.5c9.2-10.8 14.3-24.5 14.3-38.7V192 155.8v-.7V96 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V96v48.8l-69.3 92.4c-5.7 7.6-16.1 9.6-24.2 4.8c-9.7-5.7-12.1-18.7-5.1-27.5L473 180c10.8-13.5 8.9-33.3-4.4-44.5s-33-9.8-44.5 3.2l-46.7 52.5C361 209.7 352 233.4 352 258.1V320v32H288V320 258.1c0-24.6-9-48.4-25.4-66.8l-46.7-52.5c-11.5-13-31.3-14.4-44.5-3.2s-15.2 30.9-4.4 44.5l27.6 34.5c7 8.8 4.7 21.8-5.1 27.5c-8.1 4.8-18.6 2.7-24.2-4.8L96 144.8V96 32zm64 448v32H288V480h64v32H480V480h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H480 352 288 160 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h32z"
    ]
};
var $5c8203742f0e3062$export$a3dced32d48cb1ea = {
    prefix: "fas",
    iconName: "file-invoice-dollar",
    icon: [
        384,
        512,
        [],
        "f571",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm128 72c8.8 0 16 7.2 16 16v17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1 0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1V440c0 8.8-7.2 16-16 16s-16-7.2-16-16V422.2c-11.2-2.1-21.7-5.7-30.9-8.9l0 0 0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4l0 0 0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7V232c0-8.8 7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$f201ba865ea1b8dc = {
    prefix: "fas",
    iconName: "plane-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e556",
        "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$8cf137aceaaf4de0 = {
    prefix: "fas",
    iconName: "x-ray",
    icon: [
        512,
        512,
        [],
        "f497",
        "M0 64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32V416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V96C14.3 96 0 81.7 0 64zM256 96c-8.8 0-16 7.2-16 16v32H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48H128c-8.8 0-16 7.2-16 16s7.2 16 16 16H240v70.6L189.1 307c-5.2-2-10.6-3-16.2-3h-2.1c-23.6 0-42.8 19.2-42.8 42.8c0 9.6 3.2 18.9 9.1 26.4l18.2 23.2c9.7 12.4 24.6 19.6 40.3 19.6H316.4c15.7 0 30.6-7.2 40.3-19.6l18.2-23.2c5.9-7.5 9.1-16.8 9.1-26.4c0-23.6-19.2-42.8-42.8-42.8H339c-5.5 0-11 1-16.2 3L272 326.6V256H384c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V176h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16zM208 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var $5c8203742f0e3062$export$761e747b06ed2e1f = {
    prefix: "fas",
    iconName: "spell-check",
    icon: [
        576,
        512,
        [],
        "f891",
        "M112 0C99.1 0 87.4 7.8 82.5 19.7l-66.7 160-13.3 32c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L66.7 224h90.7l5.1 12.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-13.3-32-66.7-160C136.6 7.8 124.9 0 112 0zm18.7 160H93.3L112 115.2 130.7 160zM256 32v96 96c0 17.7 14.3 32 32 32h80c44.2 0 80-35.8 80-80c0-23.1-9.8-43.8-25.4-58.4c6-11.2 9.4-24 9.4-37.6c0-44.2-35.8-80-80-80H288c-17.7 0-32 14.3-32 32zm96 64H320V64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-32 64h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320V160zM566.6 310.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L352 434.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l192-192z"
    ]
};
var $5c8203742f0e3062$export$f54d004dd5f1cb5e = {
    prefix: "fas",
    iconName: "slash",
    icon: [
        640,
        512,
        [],
        "f715",
        "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"
    ]
};
var $5c8203742f0e3062$export$72cf138e5ddda6eb = {
    prefix: "fas",
    iconName: "computer-mouse",
    icon: [
        384,
        512,
        [
            128433,
            "mouse"
        ],
        "f8cc",
        "M0 192H176V0H160C71.6 0 0 71.6 0 160v32zm0 32V352c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V224H192 0zm384-32V160C384 71.6 312.4 0 224 0H208V192H384z"
    ]
};
var $5c8203742f0e3062$export$198b96b894c66074 = $5c8203742f0e3062$export$72cf138e5ddda6eb;
var $5c8203742f0e3062$export$a02c5909359525be = {
    prefix: "fas",
    iconName: "arrow-right-to-bracket",
    icon: [
        512,
        512,
        [
            "sign-in"
        ],
        "f090",
        "M352 96l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm-9.4 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
    ]
};
var $5c8203742f0e3062$export$a55eff0ca4f9c3df = $5c8203742f0e3062$export$a02c5909359525be;
var $5c8203742f0e3062$export$b3d636689da4a3e5 = {
    prefix: "fas",
    iconName: "shop-slash",
    icon: [
        640,
        512,
        [
            "store-alt-slash"
        ],
        "e070",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V224H512V376L384 275.7V224H320v1.5L277.2 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L74.1 32.8 38.8 5.1zM36.8 192h85L21 112.5 6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM320 384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V398.5l-64-50.4V384zM544 512l-.3 0h.6l-.3 0z"
    ]
};
var $5c8203742f0e3062$export$b932a586f6ff48b4 = $5c8203742f0e3062$export$b3d636689da4a3e5;
var $5c8203742f0e3062$export$1bf820d499b6202e = {
    prefix: "fas",
    iconName: "server",
    icon: [
        512,
        512,
        [],
        "f233",
        "M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $5c8203742f0e3062$export$61c2a6b698f55df6 = {
    prefix: "fas",
    iconName: "virus-covid-slash",
    icon: [
        640,
        512,
        [],
        "e4a9",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c11.4-19.5 19.1-41.4 22.3-64.7H528v16c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H494.4c-4.2-30.7-16.3-58.8-34.1-82.3L484 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L472.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L450.1 92l-23.8 23.8C402.8 97.9 374.7 85.8 344 81.6V48h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h16V81.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L134.1 79.8 38.8 5.1zm362.5 407L149.2 213.5c-1.5 6-2.7 12.2-3.5 18.5H112V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V280h33.6c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2z"
    ]
};
var $5c8203742f0e3062$export$452410c103c2403b = {
    prefix: "fas",
    iconName: "shop-lock",
    icon: [
        640,
        512,
        [],
        "e4a5",
        "M36.8 192H449.6c20.2-19.8 47.9-32 78.4-32c30.5 0 58.1 12.2 78.3 31.9c18.9-1.6 33.7-17.4 33.7-36.7c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM384 224H320V384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 352 224zm144 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $5c8203742f0e3062$export$f0c28584caa8f4b = {
    prefix: "fas",
    iconName: "hourglass-start",
    icon: [
        384,
        512,
        [
            "hourglass-1"
        ],
        "f251",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM288 437v11H96V437c0-25.5 10.1-49.9 28.1-67.9L192 301.3l67.9 67.9c18 18 28.1 42.4 28.1 67.9z"
    ]
};
var $5c8203742f0e3062$export$87929336ab5c59cd = $5c8203742f0e3062$export$f0c28584caa8f4b;
var $5c8203742f0e3062$export$f35a116a762ef8fc = {
    prefix: "fas",
    iconName: "blender-phone",
    icon: [
        576,
        512,
        [],
        "f6b6",
        "M224 352L196.8 52.3C194.2 24.2 216.3 0 244.6 0H534.1c21.1 0 36.4 20.1 30.9 40.4L558.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H549.8l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H523.6l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L480 352H224zm-16 32H496c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM147.5 30.7c10.8 6.7 15.3 21 10.6 33.4l-22 57.8c-4.2 10.9-14.5 17.6-25.3 16.4l-33.3-3.6c-13.6 42.2-13.6 88.4 0 130.7l33.3-3.6c10.9-1.2 21.2 5.5 25.3 16.4l22 57.8c4.7 12.4 .2 26.7-10.6 33.4l-44 27.2c-9.7 6-21.9 4.2-29.8-4.3C-24.6 286-24.6 114 73.7 7.8C81.6-.7 93.8-2.5 103.5 3.5l44 27.2z"
    ]
};
var $5c8203742f0e3062$export$6c0cfe6d58faf860 = {
    prefix: "fas",
    iconName: "building-wheat",
    icon: [
        640,
        512,
        [],
        "e4db",
        "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm384 80v16c0 44.2-35.8 80-80 80H544V272c0-44.2 35.8-80 80-80h16zm0 128c0 44.2-35.8 80-80 80H544V384c0-44.2 35.8-80 80-80h16v16zm0 112c0 44.2-35.8 80-80 80H544V496c0-44.2 35.8-80 80-80h16v16zM512 496v16H496c-44.2 0-80-35.8-80-80V416h16c44.2 0 80 35.8 80 80zm0-96H496c-44.2 0-80-35.8-80-80V304h16c44.2 0 80 35.8 80 80v16zm0-128v16H496c-44.2 0-80-35.8-80-80V192h16c44.2 0 80 35.8 80 80zM528 32c13.3 0 24 10.7 24 24V160c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-13.3 10.7-24 24-24zm96 64v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24zM456 72c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24z"
    ]
};
var $5c8203742f0e3062$export$9b94ed8d16d281f9 = {
    prefix: "fas",
    iconName: "person-breastfeeding",
    icon: [
        448,
        512,
        [],
        "e53a",
        "M224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM436.8 382.8L373.5 462c-16.6 20.7-46.8 24.1-67.5 7.5c-17.6-14.1-22.7-38.1-13.5-57.7l-.8-.1c-38.9-5.6-74.3-25.1-99.7-54.8V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 .8 0 1.6 .1 2.4l101.4 50.7c23.7 11.9 33.3 40.7 21.5 64.4s-40.7 33.3-64.4 21.5L27.2 427.3c-1.1-.5-2.2-1.1-3.3-1.7c-4.9-2.8-9.2-6.4-12.6-10.6c-4.6-5.4-7.8-11.7-9.6-18.4c-3.3-12-1.9-25.2 4.8-36.6c.6-1.1 1.3-2.2 2-3.2L75.6 256.1c26.7-40.1 71.7-64.1 119.8-64.1h75.2c46.5 0 90.1 22.5 117.2 60.3l50.7 70.9c2.2 3 4 6.1 5.5 9.4c2.9 6.7 4.3 13.8 4 20.8c-.3 10.6-4.2 21-11.2 29.4zM320 332a44 44 0 1 0 -88 0 44 44 0 1 0 88 0z"
    ]
};
var $5c8203742f0e3062$export$a5fd2acfcb5247c6 = {
    prefix: "fas",
    iconName: "right-to-bracket",
    icon: [
        512,
        512,
        [
            "sign-in-alt"
        ],
        "f2f6",
        "M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM352 416l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$e6709746115bd2ea = $5c8203742f0e3062$export$a5fd2acfcb5247c6;
var $5c8203742f0e3062$export$f89d028573ffc0a6 = {
    prefix: "fas",
    iconName: "venus",
    icon: [
        384,
        512,
        [
            9792
        ],
        "f221",
        "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V384H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V349.1z"
    ]
};
var $5c8203742f0e3062$export$2c31ca0d9bee400f = {
    prefix: "fas",
    iconName: "passport",
    icon: [
        448,
        512,
        [],
        "f5ab",
        "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM183 278.8c-27.9-13.2-48.4-39.4-53.7-70.8h39.1c1.6 30.4 7.7 53.8 14.6 70.8zm41.3 9.2l-.3 0-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5zm40.7-9.2c6.8-17.1 12.9-40.4 14.6-70.8h39.1c-5.3 31.4-25.8 57.6-53.7 70.8zM279.6 176c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8H279.6zM223.7 96l.3 0 .3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5H200.5c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5zM183 105.2c-6.8 17.1-12.9 40.4-14.6 70.8H129.3c5.3-31.4 25.8-57.6 53.7-70.8zM352 192A128 128 0 1 0 96 192a128 128 0 1 0 256 0zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
    ]
};
var $5c8203742f0e3062$export$a6d8e50dcd4b4294 = {
    prefix: "fas",
    iconName: "heart-pulse",
    icon: [
        512,
        512,
        [
            "heartbeat"
        ],
        "f21e",
        "M228.3 469.1L47.6 300.4c-4.2-3.9-8.2-8.1-11.9-12.4h87c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3L320 253.7l1.7 3.4c9.5 19 28.9 31 50.1 31H476.3c-3.7 4.3-7.7 8.5-11.9 12.4L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9zM503.7 240h-132c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8L205.9 158.2c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9H16c-2.6 0-5 .4-7.3 1.1C3 225.2 0 208.2 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1v5.8c0 16.9-2.8 33.5-8.3 49.1z"
    ]
};
var $5c8203742f0e3062$export$ca880e19206e80aa = $5c8203742f0e3062$export$a6d8e50dcd4b4294;
var $5c8203742f0e3062$export$7754cc6d5559ff38 = {
    prefix: "fas",
    iconName: "people-carry-box",
    icon: [
        640,
        512,
        [
            "people-carry"
        ],
        "f4ce",
        "M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm64 193.7v65.1l51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3l-14.3-85.9L66.8 320C54.8 308 48 291.7 48 274.7V186.6c0-32.4 26.2-58.6 58.6-58.6c24.1 0 46.5 12 59.9 32l47.4 71.1 10.1 5V160c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32v76.2l10.1-5L473.5 160c13.3-20 35.8-32 59.9-32c32.4 0 58.6 26.2 58.6 58.6v88.1c0 17-6.7 33.3-18.7 45.3l-79.4 79.4-14.3 85.9c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l15.2-90.9c1.6-9.9 6.3-19 13.4-26.1l51-51V241.7l-19 28.5c-4.6 7-11 12.6-18.5 16.3l-59.6 29.8c-2.4 1.3-4.9 2.2-7.6 2.8c-2.6 .6-5.3 .9-7.9 .8H256.7c-2.5 .1-5-.2-7.5-.7c-2.9-.6-5.6-1.6-8.1-3l-59.5-29.8c-7.5-3.7-13.8-9.4-18.5-16.3l-19-28.5zM2.3 468.1L50.1 348.6l49.2 49.2-37.6 94c-6.6 16.4-25.2 24.4-41.6 17.8S-4.3 484.5 2.3 468.1zM512 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm77.9 348.6l47.8 119.5c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-37.6-94 49.2-49.2z"
    ]
};
var $5c8203742f0e3062$export$35fbd4ff1265acd5 = $5c8203742f0e3062$export$7754cc6d5559ff38;
var $5c8203742f0e3062$export$15d012277c3ecf9a = {
    prefix: "fas",
    iconName: "temperature-high",
    icon: [
        512,
        512,
        [],
        "f769",
        "M416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM96 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5V112zM144 0C82.1 0 32 50.2 32 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"
    ]
};
var $5c8203742f0e3062$export$4a7bb4be15f35178 = {
    prefix: "fas",
    iconName: "microchip",
    icon: [
        512,
        512,
        [],
        "f2db",
        "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V176h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H176V24zM160 128H352c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm192 32H160V352H352V160z"
    ]
};
var $5c8203742f0e3062$export$dc1083dcd1d7b9d6 = {
    prefix: "fas",
    iconName: "crown",
    icon: [
        576,
        512,
        [
            128081
        ],
        "f521",
        "M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z"
    ]
};
var $5c8203742f0e3062$export$43d1fa6671908715 = {
    prefix: "fas",
    iconName: "weight-hanging",
    icon: [
        512,
        512,
        [],
        "f5cd",
        "M224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm122.5 32c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32H120c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512H464c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128H346.5z"
    ]
};
var $5c8203742f0e3062$export$f4595f012786d346 = {
    prefix: "fas",
    iconName: "xmarks-lines",
    icon: [
        640,
        512,
        [],
        "e59a",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM7 167c-9.4 9.4-9.4 24.6 0 33.9l55 55L7 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L41 167c-9.4-9.4-24.6-9.4-33.9 0zM265 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55zM455 167c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0z"
    ]
};
var $5c8203742f0e3062$export$a20cb90865b6beb8 = {
    prefix: "fas",
    iconName: "file-prescription",
    icon: [
        384,
        512,
        [],
        "f572",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM104 196h72c33.1 0 60 26.9 60 60c0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3L270 379.7l31.7 29.7c8.1 7.6 8.5 20.2 .9 28.3s-20.2 8.5-28.3 .9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6H124v44c0 11-9 20-20 20s-20-9-20-20V296 216c0-11 9-20 20-20zm72 80c11 0 20-9 20-20s-9-20-20-20H124v40h52z"
    ]
};
var $5c8203742f0e3062$export$e521c542d18b85c3 = {
    prefix: "fas",
    iconName: "weight-scale",
    icon: [
        512,
        512,
        [
            "weight"
        ],
        "f496",
        "M128 176a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H391.8zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40c0 22.1 17.9 40 40 40s40-17.9 40-40z"
    ]
};
var $5c8203742f0e3062$export$cf3bafa68a60bae4 = $5c8203742f0e3062$export$e521c542d18b85c3;
var $5c8203742f0e3062$export$3d626cfc365a7e36 = {
    prefix: "fas",
    iconName: "user-group",
    icon: [
        640,
        512,
        [
            128101,
            "user-friends"
        ],
        "f500",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32v-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2h61.4C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"
    ]
};
var $5c8203742f0e3062$export$46073bec205635d9 = $5c8203742f0e3062$export$3d626cfc365a7e36;
var $5c8203742f0e3062$export$fb00fdd8857804c7 = {
    prefix: "fas",
    iconName: "arrow-up-a-z",
    icon: [
        576,
        512,
        [
            "sort-alpha-up"
        ],
        "f15e",
        "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 320c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zM416 32c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 38.8 428.1 32 416 32zM395.8 176L416 135.6 436.2 176H395.8z"
    ]
};
var $5c8203742f0e3062$export$3c4115b156be730d = $5c8203742f0e3062$export$fb00fdd8857804c7;
var $5c8203742f0e3062$export$861b1f13085cf122 = {
    prefix: "fas",
    iconName: "chess-knight",
    icon: [
        448,
        512,
        [
            9822
        ],
        "f441",
        "M96 48L82.7 61.3C70.7 73.3 64 89.5 64 106.5V238.9c0 10.7 5.3 20.7 14.2 26.6l10.6 7c14.3 9.6 32.7 10.7 48.1 3l3.2-1.6c2.6-1.3 5-2.8 7.3-4.5l49.4-37c6.6-5 15.7-5 22.3 0c10.2 7.7 9.9 23.1-.7 30.3L90.4 350C73.9 361.3 64 380 64 400H384l28.9-159c2.1-11.3 3.1-22.8 3.1-34.3V192C416 86 330 0 224 0H83.8C72.9 0 64 8.9 64 19.8c0 7.5 4.2 14.3 10.9 17.7L96 48zm24 68a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H409.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L384 432H64L22.6 473.4z"
    ]
};
var $5c8203742f0e3062$export$67ca89c1ca38d559 = {
    prefix: "fas",
    iconName: "face-laugh-squint",
    icon: [
        512,
        512,
        [
            "laugh-squint"
        ],
        "f59b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zm36.7-199.4l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 125.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $5c8203742f0e3062$export$b206e700cf7084e1 = $5c8203742f0e3062$export$67ca89c1ca38d559;
var $5c8203742f0e3062$export$76a9413fbe130a53 = {
    prefix: "fas",
    iconName: "wheelchair",
    icon: [
        512,
        512,
        [],
        "f193",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM120.5 247.2c12.4-4.7 18.7-18.5 14-30.9s-18.5-18.7-30.9-14C43.1 225.1 0 283.5 0 352c0 88.4 71.6 160 160 160c61.2 0 114.3-34.3 141.2-84.7c6.2-11.7 1.8-26.2-9.9-32.5s-26.2-1.8-32.5 9.9C240 440 202.8 464 160 464C98.1 464 48 413.9 48 352c0-47.9 30.1-88.8 72.5-104.8zM259.8 176l-1.9-9.7c-4.5-22.3-24-38.3-46.8-38.3c-30.1 0-52.7 27.5-46.8 57l23.1 115.5c6 29.9 32.2 51.4 62.8 51.4h5.1c.4 0 .8 0 1.3 0h94.1c6.7 0 12.6 4.1 15 10.4L402 459.2c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9H282.2l-9.6-48H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H259.8z"
    ]
};
var $5c8203742f0e3062$export$a29c8ea43e92771d = {
    prefix: "fas",
    iconName: "circle-arrow-up",
    icon: [
        512,
        512,
        [
            "arrow-circle-up"
        ],
        "f0aa",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM385 231c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V193.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 119c9.4-9.4 24.6-9.4 33.9 0L385 231z"
    ]
};
var $5c8203742f0e3062$export$a2f6f3baa50af0b1 = $5c8203742f0e3062$export$a29c8ea43e92771d;
var $5c8203742f0e3062$export$5cffc34afa81e517 = {
    prefix: "fas",
    iconName: "toggle-on",
    icon: [
        576,
        512,
        [],
        "f205",
        "M192 64C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192s-86-192-192-192H192zm192 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $5c8203742f0e3062$export$6af1cc5998ca52bc = {
    prefix: "fas",
    iconName: "person-walking",
    icon: [
        320,
        512,
        [
            128694,
            "walking"
        ],
        "f554",
        "M160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM126.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L281 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L247 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L68.7 398z"
    ]
};
var $5c8203742f0e3062$export$4886811b7174ec35 = $5c8203742f0e3062$export$6af1cc5998ca52bc;
var $5c8203742f0e3062$export$be32b10ce70a09df = {
    prefix: "fas",
    iconName: "l",
    icon: [
        320,
        512,
        [
            108
        ],
        "4c",
        "M64 32c17.7 0 32 14.3 32 32V416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$7b24b34ef6cc130c = {
    prefix: "fas",
    iconName: "fire",
    icon: [
        448,
        512,
        [
            128293
        ],
        "f06d",
        "M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z"
    ]
};
var $5c8203742f0e3062$export$580ae0d0bbd809fb = {
    prefix: "fas",
    iconName: "bed-pulse",
    icon: [
        640,
        512,
        [
            "procedures"
        ],
        "f487",
        "M483.2 9.6L524 64h92c13.3 0 24 10.7 24 24s-10.7 24-24 24H512c-7.6 0-14.7-3.6-19.2-9.6L468.7 70.3l-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L339.2 112H216c-13.3 0-24-10.7-24-24s10.7-24 24-24H352c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5C445.9 6.2 453.2 1 461.6 .1s16.6 2.7 21.6 9.5zM320 160h12.7l20.7 31.1c11.2 16.8 30.6 26.3 50.7 24.8s37.9-13.7 46.5-32L461.9 160H544c53 0 96 43 96 96V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V352H288V192c0-17.7 14.3-32 32-32zm-144 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var $5c8203742f0e3062$export$5f9e1870e1866dde = $5c8203742f0e3062$export$580ae0d0bbd809fb;
var $5c8203742f0e3062$export$76d92e7f30d064c5 = {
    prefix: "fas",
    iconName: "shuttle-space",
    icon: [
        640,
        512,
        [
            "space-shuttle"
        ],
        "f197",
        "M130 480c40.6 0 80.4-11 115.2-31.9L352 384l-224 0 0 96h2zM352 128L245.2 63.9C210.4 43 170.6 32 130 32h-2v96l224 0zM96 128l0-96H80C53.5 32 32 53.5 32 80v48h8c-22.1 0-40 17.9-40 40v16V328v16c0 22.1 17.9 40 40 40H32v48c0 26.5 21.5 48 48 48H96l0-96h8c26.2 0 49.4-12.6 64-32H456c69.3 0 135-22.7 179.2-81.6c6.4-8.5 6.4-20.3 0-28.8C591 182.7 525.3 160 456 160H168c-14.6-19.4-37.8-32-64-32l-8 0zM512 243.6v24.9c0 19.6-15.9 35.6-35.6 35.6c-2.5 0-4.4-2-4.4-4.4V212.4c0-2.5 2-4.4 4.4-4.4c19.6 0 35.6 15.9 35.6 35.6z"
    ]
};
var $5c8203742f0e3062$export$4d1c12ba2b4ca565 = $5c8203742f0e3062$export$76d92e7f30d064c5;
var $5c8203742f0e3062$export$2f203616c892d415 = {
    prefix: "fas",
    iconName: "face-laugh",
    icon: [
        512,
        512,
        [
            "laugh"
        ],
        "f599",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$6c74e314e801a4fe = $5c8203742f0e3062$export$2f203616c892d415;
var $5c8203742f0e3062$export$ff7e93418af88b78 = {
    prefix: "fas",
    iconName: "folder-open",
    icon: [
        576,
        512,
        [
            128194,
            128449,
            61717
        ],
        "f07c",
        "M88.7 223.8L0 375.8V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H416c35.3 0 64 28.7 64 64v32H144c-22.8 0-43.8 12.1-55.3 31.8zm27.6 16.1C122.1 230 132.6 224 144 224H544c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-112 192C453.9 474 443.4 480 432 480H32c-11.5 0-22-6.1-27.7-16.1s-5.7-22.2 .1-32.1l112-192z"
    ]
};
var $5c8203742f0e3062$export$2a155a6e20f64134 = {
    prefix: "fas",
    iconName: "heart-circle-plus",
    icon: [
        576,
        512,
        [],
        "e500",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $5c8203742f0e3062$export$f54081bdbf6d4eb5 = {
    prefix: "fas",
    iconName: "code-fork",
    icon: [
        448,
        512,
        [],
        "e13b",
        "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3V192c0 17.7 14.3 32 32 32H304c17.7 0 32-14.3 32-32V153.3C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V192c0 53-43 96-96 96H256v70.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V288H144c-53 0-96-43-96-96V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $5c8203742f0e3062$export$a9947c2888b3c8fd = {
    prefix: "fas",
    iconName: "city",
    icon: [
        640,
        512,
        [
            127961
        ],
        "f64f",
        "M480 48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48V96H224V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V96H112V24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144v96V464c0 26.5 21.5 48 48 48H304h32 96H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H480V48zm96 320v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM240 416H208c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM128 400c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM560 256c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32zM256 176v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM112 160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32zM256 304c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM112 320H80c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm304-48v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM400 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zm16 112v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
    ]
};
var $5c8203742f0e3062$export$417391ae30b5922e = {
    prefix: "fas",
    iconName: "microphone-lines",
    icon: [
        384,
        512,
        [
            127897,
            "microphone-alt"
        ],
        "f3c9",
        "M96 96V256c0 53 43 96 96 96s96-43 96-96H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V192H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96S96 43 96 96zM320 240v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24z"
    ]
};
var $5c8203742f0e3062$export$f08ef94fea14f5ac = $5c8203742f0e3062$export$417391ae30b5922e;
var $5c8203742f0e3062$export$4894bf28f771e1f3 = {
    prefix: "fas",
    iconName: "pepper-hot",
    icon: [
        512,
        512,
        [
            127798
        ],
        "f816",
        "M428.3 3c11.6-6.4 26.2-2.3 32.6 9.3l4.8 8.7c19.3 34.7 19.8 75.7 3.4 110C495.8 159.6 512 197.9 512 240c0 18.5-3.1 36.3-8.9 52.8c-6.1 17.3-28.5 16.3-36.8-.1l-11.7-23.4c-4.1-8.1-12.4-13.3-21.5-13.3H360c-13.3 0-24-10.7-24-24V152c0-13.3-10.7-24-24-24l-17.1 0c-21.3 0-30-23.9-10.8-32.9C304.7 85.4 327.7 80 352 80c28.3 0 54.8 7.3 77.8 20.2c5.5-18.2 3.7-38.4-6-55.8L419 35.7c-6.4-11.6-2.3-26.2 9.3-32.6zM171.2 345.5L264 160l40 0v80c0 26.5 21.5 48 48 48h76.2l23.9 47.8C372.3 443.9 244.3 512 103.2 512H44.4C19.9 512 0 492.1 0 467.6c0-20.8 14.5-38.8 34.8-43.3l49.8-11.1c37.6-8.4 69.5-33.2 86.7-67.7z"
    ]
};
var $5c8203742f0e3062$export$db1382cd406cc506 = {
    prefix: "fas",
    iconName: "unlock",
    icon: [
        448,
        512,
        [
            128275
        ],
        "f09c",
        "M144 144c0-44.2 35.8-80 80-80c31.9 0 59.4 18.6 72.3 45.7c7.6 16 26.7 22.8 42.6 15.2s22.8-26.7 15.2-42.6C331 33.7 281.5 0 224 0C144.5 0 80 64.5 80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H144V144z"
    ]
};
var $5c8203742f0e3062$export$dec10d4c2c113312 = {
    prefix: "fas",
    iconName: "colon-sign",
    icon: [
        384,
        512,
        [],
        "e140",
        "M255 39.8c4.3-17.1-6.1-34.5-23.3-38.8S197.2 7.1 193 24.2L181.9 68.6C96.1 87.8 32 164.4 32 256c0 58.1 25.8 110.2 66.7 145.4L81 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l13-52.1c9 3.4 18.4 6.2 28 8.2L177 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l10.4-41.4c33.4-4.4 64.1-17.4 89.8-36.7c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-10.2 7.7-21.7 13.9-34 18.3L321 160c9.4-.3 18.5-4.7 24.6-12.8c10.6-14.1 7.8-34.2-6.4-44.8c-1.1-.8-2.2-1.6-3.3-2.4L351 39.8c4.3-17.1-6.1-34.5-23.3-38.8S293.2 7.1 289 24.2L277.2 71.5c-9.3-2.7-18.8-4.6-28.6-5.9L255 39.8zM163.2 143.3L117.3 326.8C103.9 306.5 96 282.2 96 256c0-48.7 27.2-91 67.2-112.7zm8.6 229.5l61.1-244.6c9.9 .7 19.5 2.5 28.7 5.3l-62 248.1c-9.7-1.9-19-4.8-27.8-8.8z"
    ]
};
var $5c8203742f0e3062$export$23b086400a31acfe = {
    prefix: "fas",
    iconName: "headset",
    icon: [
        512,
        512,
        [],
        "f590",
        "M256 48C141.1 48 48 141.1 48 256v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V256C0 114.6 114.6 0 256 0S512 114.6 512 256V400.1c0 48.6-39.4 88-88.1 88L313.6 488c-8.3 14.3-23.8 24-41.6 24H240c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c17.8 0 33.3 9.7 41.6 24l110.4 .1c22.1 0 40-17.9 40-40V256c0-114.9-93.1-208-208-208zM144 208h16c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V272c0-35.3 28.7-64 64-64zm224 0c35.3 0 64 28.7 64 64v48c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32h16z"
    ]
};
var $5c8203742f0e3062$export$4ab2f33219630bad = {
    prefix: "fas",
    iconName: "store-slash",
    icon: [
        640,
        512,
        [],
        "e071",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V384 252.6c-4 1-8 1.8-12.3 2.3l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V350.9L301.2 210.7c7-4.4 13.3-9.7 18.8-15.7c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L522.3 13.1C517.2 5 508.1 0 498.4 0H141.6c-9.7 0-18.8 5-23.9 13.1l-22.7 36L38.8 5.1zM514.9 501.7L365.5 384H160V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H480c12.9 0 24.8-3.8 34.9-10.3zM155.3 218.4L48.9 134.5c-6.1 40.6 19.5 82.8 63.3 88.7c4 .5 8.1 .8 12.1 .8c11 0 21.4-2 31-5.6z"
    ]
};
var $5c8203742f0e3062$export$2ffc88a4d31e8ffc = {
    prefix: "fas",
    iconName: "road-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e566",
        "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
    ]
};
var $5c8203742f0e3062$export$d6e17c0df8ed1bf7 = {
    prefix: "fas",
    iconName: "user-minus",
    icon: [
        640,
        512,
        [],
        "f503",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM472 200H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $5c8203742f0e3062$export$efc6d53e0dedceee = {
    prefix: "fas",
    iconName: "mars-stroke-up",
    icon: [
        320,
        512,
        [
            9896,
            "mars-stroke-v"
        ],
        "f22a",
        "M148.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H184v24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H184v24c0 .6 0 1.2-.1 1.8c77 11.6 136.1 78 136.1 158.2c0 88.4-71.6 160-160 160S0 440.4 0 352c0-80.2 59.1-146.7 136.1-158.2c0-.6-.1-1.2-.1-1.8V168H104c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V96H96c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zM256 352A96 96 0 1 0 64 352a96 96 0 1 0 192 0z"
    ]
};
var $5c8203742f0e3062$export$ed7aa1c25104f333 = $5c8203742f0e3062$export$efc6d53e0dedceee;
var $5c8203742f0e3062$export$7df1926e9eef8cc3 = {
    prefix: "fas",
    iconName: "champagne-glasses",
    icon: [
        640,
        512,
        [
            129346,
            "glass-cheers"
        ],
        "f79f",
        "M155.6 17.3C163 3 179.9-3.6 195 1.9L320 47.5l125-45.6c15.1-5.5 32 1.1 39.4 15.4l78.8 152.9c28.8 55.8 10.3 122.3-38.5 156.6L556.1 413l41-15c16.6-6 35 2.5 41 19.1s-2.5 35-19.1 41l-71.1 25.9L476.8 510c-16.6 6.1-35-2.5-41-19.1s2.5-35 19.1-41l41-15-31.3-86.2c-59.4 5.2-116.2-34-130-95.2L320 188.8l-14.6 64.7c-13.8 61.3-70.6 100.4-130 95.2l-31.3 86.2 41 15c16.6 6 25.2 24.4 19.1 41s-24.4 25.2-41 19.1L92.2 484.1 21.1 458.2c-16.6-6.1-25.2-24.4-19.1-41s24.4-25.2 41-19.1l41 15 31.3-86.2C66.5 292.5 48.1 226 76.9 170.2L155.6 17.3zm44 54.4l-27.2 52.8L261.6 157l13.1-57.9L199.6 71.7zm240.9 0L365.4 99.1 378.5 157l89.2-32.5L440.5 71.7z"
    ]
};
var $5c8203742f0e3062$export$20007d7d74cb98fe = $5c8203742f0e3062$export$7df1926e9eef8cc3;
var $5c8203742f0e3062$export$97d84347d71ba297 = {
    prefix: "fas",
    iconName: "clipboard",
    icon: [
        384,
        512,
        [
            128203
        ],
        "f328",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$8403e4b31e8aa805 = {
    prefix: "fas",
    iconName: "house-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e50a",
        "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$929df388c07f293d = {
    prefix: "fas",
    iconName: "file-arrow-up",
    icon: [
        384,
        512,
        [
            "file-upload"
        ],
        "f574",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24V305.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V408z"
    ]
};
var $5c8203742f0e3062$export$dd55ded1264643d2 = $5c8203742f0e3062$export$929df388c07f293d;
var $5c8203742f0e3062$export$1642419fe3db2857 = {
    prefix: "fas",
    iconName: "wifi",
    icon: [
        640,
        512,
        [
            "wifi-3",
            "wifi-strong"
        ],
        "f1eb",
        "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $5c8203742f0e3062$export$2349bb04a04f4b2d = $5c8203742f0e3062$export$1642419fe3db2857;
var $5c8203742f0e3062$export$4b3167c852f4c4aa = $5c8203742f0e3062$export$1642419fe3db2857;
var $5c8203742f0e3062$export$1ea66a88b8f620c9 = {
    prefix: "fas",
    iconName: "bath",
    icon: [
        512,
        512,
        [
            128705,
            "bathtub"
        ],
        "f2cd",
        "M96 77.3c0-7.3 5.9-13.3 13.3-13.3c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9C130 91.8 128 101.7 128 112c0 19.9 7.2 38 19.2 52c-5.3 9.2-4 21.1 3.8 29c9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9c-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5L163.9 22.6C149.4 8.1 129.7 0 109.3 0C66.6 0 32 34.6 32 77.3V256c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H96V77.3zM32 352v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V464H384v16c0 17.7 14.3 32 32 32s32-14.3 32-32V439.6c19.6-17.6 32-43.1 32-71.6V352H32z"
    ]
};
var $5c8203742f0e3062$export$40ae013b5e6269d8 = $5c8203742f0e3062$export$1ea66a88b8f620c9;
var $5c8203742f0e3062$export$22346afd6a3cddf8 = {
    prefix: "fas",
    iconName: "underline",
    icon: [
        448,
        512,
        [],
        "f0cd",
        "M16 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H128V224c0 53 43 96 96 96s96-43 96-96V96H304c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V96H48C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $5c8203742f0e3062$export$3842882ea09b25af = {
    prefix: "fas",
    iconName: "user-pen",
    icon: [
        640,
        512,
        [
            "user-edit"
        ],
        "f4ff",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H322.8c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1H178.3zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"
    ]
};
var $5c8203742f0e3062$export$a68a6960fc8eef82 = $5c8203742f0e3062$export$3842882ea09b25af;
var $5c8203742f0e3062$export$afa7b53ac8ebcb5d = {
    prefix: "fas",
    iconName: "signature",
    icon: [
        640,
        512,
        [],
        "f5b7",
        "M192 128c0-17.7 14.3-32 32-32s32 14.3 32 32v7.8c0 27.7-2.4 55.3-7.1 82.5l-84.4 25.3c-40.6 12.2-68.4 49.6-68.4 92v71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96s-96 43-96 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm-9.2 177l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5V335.6c0-14.1 9.3-26.6 22.8-30.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24H64.3c-.2-2.8-.3-5.6-.3-8.5V368H24zm592 48c13.3 0 24-10.7 24-24s-10.7-24-24-24H305.9c-6.7 16.3-14.2 32.3-22.3 48H616z"
    ]
};
var $5c8203742f0e3062$export$195780ddabd8e0c6 = {
    prefix: "fas",
    iconName: "stroopwafel",
    icon: [
        512,
        512,
        [],
        "f551",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM312.6 63.7c-6.2-6.2-16.4-6.2-22.6 0L256 97.6 222.1 63.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l33.9 33.9-45.3 45.3-56.6-56.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6-45.3 45.3L86.3 199.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L97.6 256 63.7 289.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9 45.3 45.3-56.6 56.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6 45.3 45.3-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 414.4l33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-33.9-33.9 45.3-45.3 56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56.6-56.6 45.3-45.3 33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L414.4 256l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9-45.3-45.3 56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-56.6 56.6-45.3-45.3 33.9-33.9c6.2-6.2 6.2-16.4 0-22.6zM142.9 256l45.3-45.3L233.4 256l-45.3 45.3L142.9 256zm67.9 67.9L256 278.6l45.3 45.3L256 369.1l-45.3-45.3zM278.6 256l45.3-45.3L369.1 256l-45.3 45.3L278.6 256zm22.6-67.9L256 233.4l-45.3-45.3L256 142.9l45.3 45.3z"
    ]
};
var $5c8203742f0e3062$export$7e0c7fd2a2e88823 = {
    prefix: "fas",
    iconName: "bold",
    icon: [
        384,
        512,
        [],
        "f032",
        "M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z"
    ]
};
var $5c8203742f0e3062$export$217195c80db39097 = {
    prefix: "fas",
    iconName: "anchor-lock",
    icon: [
        640,
        512,
        [],
        "e4ad",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8 0 15.9-.6 23.6-1.7c-4.8-9-7.6-19.3-7.6-30.3V446.7c-5.2 .9-10.5 1.3-16 1.3H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $5c8203742f0e3062$export$374e1dce366a2175 = {
    prefix: "fas",
    iconName: "building-ngo",
    icon: [
        384,
        512,
        [],
        "e4d7",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM168 64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H184v64h16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 13.3-10.7 24-24 24H176c-13.3 0-24-10.7-24-24V80c0-8.8 7.2-16 16-16zM304 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V112zM61.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 132.8V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4z"
    ]
};
var $5c8203742f0e3062$export$1ff755b523ab2851 = {
    prefix: "fas",
    iconName: "manat-sign",
    icon: [
        384,
        512,
        [],
        "e1d5",
        "M192 32c-17.7 0-32 14.3-32 32V98.7C69.2 113.9 0 192.9 0 288V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-59.6 40.8-109.8 96-124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V164c55.2 14.2 96 64.3 96 124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-95.1-69.2-174.1-160-189.3V64c0-17.7-14.3-32-32-32z"
    ]
};
var $5c8203742f0e3062$export$6a15ccae09bbaf93 = {
    prefix: "fas",
    iconName: "not-equal",
    icon: [
        448,
        512,
        [],
        "f53e",
        "M369.8 37.4c14.7 9.8 18.7 29.7 8.9 44.4L337.1 144H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H294.5l-64 96H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H187.8l-65.2 97.7c-9.8 14.7-29.7 18.7-44.4 8.9s-18.7-29.7-8.9-44.4L110.9 368H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H153.5l64-96H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H260.2l65.2-97.7c9.8-14.7 29.7-18.7 44.4-8.9z"
    ]
};
var $5c8203742f0e3062$export$cf897c3e0abd59e4 = {
    prefix: "fas",
    iconName: "border-top-left",
    icon: [
        448,
        512,
        [
            "border-style"
        ],
        "f853",
        "M0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-336c0-8.8 7.2-16 16-16l336 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32C35.8 32 0 67.8 0 112L0 448zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$c2867ca78120d644 = $5c8203742f0e3062$export$cf897c3e0abd59e4;
var $5c8203742f0e3062$export$757f50b8af780c19 = {
    prefix: "fas",
    iconName: "map-location-dot",
    icon: [
        576,
        512,
        [
            "map-marked-alt"
        ],
        "f5a0",
        "M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152V422.8c0 9.8-6 18.6-15.1 22.3L416 503V200.4zM137.6 138.3c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6V451.8L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77V504.3L192 449.4V255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $5c8203742f0e3062$export$a977d47c74d8e86c = $5c8203742f0e3062$export$757f50b8af780c19;
var $5c8203742f0e3062$export$859f204e59641ca4 = {
    prefix: "fas",
    iconName: "jedi",
    icon: [
        576,
        512,
        [],
        "f669",
        "M246 315.7l-21.2-31.9c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1l29.5 19.7c2.1 1.4 4.9 0 5-2.6L279.7 8c.1-4.5 3.8-8 8.3-8s8.1 3.5 8.3 8l9.4 281.9c.1 2.5 2.9 3.9 5 2.6l29.5-19.7c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1L330 315.7c-1.3 1.9-.2 4.5 2 4.9l37.6 7.5c3.7 .7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8L332 351.4c-2.2 .4-3.3 3-2 4.9l21.2 31.9c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1l-26.3-17.6c-2.2-1.4-5.1 .2-5 2.8l2.1 61.5C370.6 435.2 416 382.9 416 320c0-37-15.7-70.4-40.8-93.7c-7-6.5-6.5-18.6 1-24.4C410.1 175.5 432 134.3 432 88c0-16.8-2.9-33-8.2-48c-4.6-13 10.2-30 21.4-22c53.5 38 92.7 94.8 107.8 160.7c.5 2.1-.2 4.3-1.7 5.9l-28.4 28.4c-4 4-1.2 10.9 4.5 10.9h26c3.4 0 6.2 2.6 6.3 6c.1 3.3 .2 6.6 .2 10c0 17.5-1.7 34.7-4.8 51.3c-.2 1.2-.9 2.4-1.7 3.3l-46.5 46.5c-4 4-1.2 10.9 4.5 10.9H526c4.6 0 7.7 4.8 5.7 9C487.2 450.5 394.8 512 288 512S88.8 450.5 44.3 361c-2.1-4.2 1-9 5.7-9H64.5c5.7 0 8.6-6.9 4.5-10.9L22.6 294.6c-.9-.9-1.5-2-1.7-3.3C17.7 274.7 16 257.5 16 240c0-3.3 .1-6.7 .2-10c.1-3.4 2.9-6 6.3-6h26c5.7 0 8.6-6.9 4.5-10.9L24.6 184.6c-1.5-1.5-2.2-3.8-1.7-5.9C38.1 112.8 77.3 56 130.8 18c11.3-8 26 8.9 21.4 22c-5.3 15-8.2 31.2-8.2 48c0 46.3 21.9 87.5 55.8 113.9c7.5 5.8 8 17.9 1 24.4C175.7 249.6 160 283 160 320c0 62.9 45.4 115.2 105.1 126l2.1-61.5c.1-2.6-2.8-4.2-5-2.8l-26.3 17.6c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1L246 356.3c1.3-1.9 .2-4.5-2-4.9l-37.6-7.5c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l37.6-7.5c2.2-.4 3.3-3 2-4.9z"
    ]
};
var $5c8203742f0e3062$export$91d747e5aabe6fe8 = {
    prefix: "fas",
    iconName: "square-poll-vertical",
    icon: [
        448,
        512,
        [
            "poll"
        ],
        "f681",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 192c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm64-64c0-17.7 14.3-32 32-32s32 14.3 32 32V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zM320 288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$bc8ca14ab51f93db = $5c8203742f0e3062$export$91d747e5aabe6fe8;
var $5c8203742f0e3062$export$47a822c30184e8af = {
    prefix: "fas",
    iconName: "mug-hot",
    icon: [
        512,
        512,
        [
            9749
        ],
        "f7b6",
        "M88 0C74.7 0 64 10.7 64 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C120.5 112.3 128 119.9 128 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24c0-13.3-10.7-24-24-24zM32 192c-17.7 0-32 14.3-32 32V416c0 53 43 96 96 96H288c53 0 96-43 96-96h16c61.9 0 112-50.1 112-112s-50.1-112-112-112H352 32zm352 64h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H384V256zM224 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C232.5 112.3 240 119.9 240 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24z"
    ]
};
var $5c8203742f0e3062$export$a44d0c11093d9c1e = {
    prefix: "fas",
    iconName: "car-battery",
    icon: [
        512,
        512,
        [
            "battery-car"
        ],
        "f5df",
        "M80 96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32l96 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h16c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64l16 0zm304 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V256h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V192zM80 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16z"
    ]
};
var $5c8203742f0e3062$export$9133165ca669dd4b = $5c8203742f0e3062$export$a44d0c11093d9c1e;
var $5c8203742f0e3062$export$b2727de8ccdbb5ec = {
    prefix: "fas",
    iconName: "gift",
    icon: [
        512,
        512,
        [
            127873
        ],
        "f06b",
        "M190.5 68.8L225.3 128H224 152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H438.4c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0H152C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40H288h-1.3l34.8-59.2C329.1 55.9 342.9 48 357.8 48H360c22.1 0 40 17.9 40 40zM32 288V464c0 26.5 21.5 48 48 48H224V288H32zM288 512H432c26.5 0 48-21.5 48-48V288H288V512z"
    ]
};
var $5c8203742f0e3062$export$4d85df590065572f = {
    prefix: "fas",
    iconName: "dice-two",
    icon: [
        448,
        512,
        [
            9857
        ],
        "f528",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM352 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$7b8ce73615739d30 = {
    prefix: "fas",
    iconName: "chess-queen",
    icon: [
        512,
        512,
        [
            9819
        ],
        "f445",
        "M256 0a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM134.1 143.8c3.3-13 15-23.8 30.2-23.8c12.3 0 22.6 7.2 27.7 17c12 23.2 36.2 39 64 39s52-15.8 64-39c5.1-9.8 15.4-17 27.7-17c15.3 0 27 10.8 30.2 23.8c7 27.8 32.2 48.3 62.1 48.3c10.8 0 21-2.7 29.8-7.4c8.4-4.4 18.9-4.5 27.6 .9c13 8 17.1 25 9.2 38L399.7 400H384 343.6 168.4 128 112.3L5.4 223.6c-7.9-13-3.8-30 9.2-38c8.7-5.3 19.2-5.3 27.6-.9c8.9 4.7 19 7.4 29.8 7.4c29.9 0 55.1-20.5 62.1-48.3zM256 224l0 0 0 0h0zM112 432H400l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H86.6C74.1 512 64 501.9 64 489.4c0-6 2.4-11.8 6.6-16L112 432z"
    ]
};
var $5c8203742f0e3062$export$58d7d709c0a8ca5f = {
    prefix: "fas",
    iconName: "glasses",
    icon: [
        576,
        512,
        [],
        "f530",
        "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57 260.3c20.5-6.2 48.3-12.3 78.7-12.3c32.3 0 61.8 6.9 82.8 13.5c10.6 3.3 19.3 6.7 25.4 9.2c3.1 1.3 5.5 2.4 7.3 3.2c.9 .4 1.6 .7 2.1 1l.6 .3 .2 .1 .1 0 0 0 0 0s0 0-6.3 12.7h0l6.3-12.7c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.3 7.7-9.8 13.5-12.7l6.3 12.7h0c-6.3-12.7-6.3-12.7-6.3-12.7l0 0 0 0 .1 0 .2-.1 .6-.3c.5-.2 1.2-.6 2.1-1c1.8-.8 4.2-1.9 7.3-3.2c6.1-2.6 14.8-5.9 25.4-9.2c21-6.6 50.4-13.5 82.8-13.5c30.4 0 58.2 6.1 78.7 12.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.1c.3 1.9 .5 3.8 .5 5.7v6.7V352v16c0 61.9-50.1 112-112 112H419.7c-59.4 0-108.5-46.4-111.8-105.8L306.6 352H269.4l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368V352 310.7 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM64 325.4V368c0 26.5 21.5 48 48 48h44.3c25.5 0 46.5-19.9 47.9-45.3l2.5-45.6c-2.3-.8-4.9-1.7-7.5-2.5c-17.2-5.4-39.9-10.5-63.6-10.5c-23.7 0-46.2 5.1-63.2 10.5c-3.1 1-5.9 1.9-8.5 2.9zM512 368V325.4c-2.6-.9-5.5-1.9-8.5-2.9c-17-5.4-39.5-10.5-63.2-10.5c-23.7 0-46.4 5.1-63.6 10.5c-2.7 .8-5.2 1.7-7.5 2.5l2.5 45.6c1.4 25.4 22.5 45.3 47.9 45.3H464c26.5 0 48-21.5 48-48z"
    ]
};
var $5c8203742f0e3062$export$bd301515df6246af = {
    prefix: "fas",
    iconName: "chess-board",
    icon: [
        448,
        512,
        [],
        "f43c",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 64v64h64V96h64v64h64V96h64v64H320v64h64v64H320v64h64v64H320V352H256v64H192V352H128v64H64V352h64V288H64V224h64V160H64V96h64zm64 128h64V160H192v64zm0 64V224H128v64h64zm64 0H192v64h64V288zm0 0h64V224H256v64z"
    ]
};
var $5c8203742f0e3062$export$5559de5f969b9590 = {
    prefix: "fas",
    iconName: "building-circle-check",
    icon: [
        640,
        512,
        [],
        "e4d2",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $5c8203742f0e3062$export$c9dc1583b207b7ff = {
    prefix: "fas",
    iconName: "person-chalkboard",
    icon: [
        640,
        512,
        [],
        "e53d",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V192h56 64 16c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64H576V256H384V224H320v48c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80H243.1 177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $5c8203742f0e3062$export$321e84e6a900c2d6 = {
    prefix: "fas",
    iconName: "mars-stroke-right",
    icon: [
        640,
        512,
        [
            9897,
            "mars-stroke-h"
        ],
        "f22b",
        "M208 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm174.4-88C370.7 365.8 297.1 432 208 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c89.1 0 162.7 66.2 174.4 152H416V176c0-13.3 10.7-24 24-24s24 10.7 24 24v56h32V176c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V280H464v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H382.4z"
    ]
};
var $5c8203742f0e3062$export$5cb0daeafbcdabe3 = $5c8203742f0e3062$export$321e84e6a900c2d6;
var $5c8203742f0e3062$export$be38a892fe9b4098 = {
    prefix: "fas",
    iconName: "hand-back-fist",
    icon: [
        448,
        512,
        [
            "hand-rock"
        ],
        "f255",
        "M144 0C117.5 0 96 21.5 96 48V96v28.5V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V149.3l-9 7.5C40.4 169 32 187 32 206V244c0 38 16.9 74 46.1 98.3L128 384v96c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V374.7c46.9-19 80-65 80-118.7V176 160 144c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 83.5 329.3 64 304 64c-12.4 0-23.6 4.7-32.1 12.3C270 51.5 249.3 32 224 32c-12.4 0-23.6 4.7-32.1 12.3C190 19.5 169.3 0 144 0z"
    ]
};
var $5c8203742f0e3062$export$97a81eba394c8c44 = $5c8203742f0e3062$export$be38a892fe9b4098;
var $5c8203742f0e3062$export$66068918abb14406 = {
    prefix: "fas",
    iconName: "square-caret-up",
    icon: [
        448,
        512,
        [
            "caret-square-up"
        ],
        "f151",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 160c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4H120c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
    ]
};
var $5c8203742f0e3062$export$307ae80b26533ce5 = $5c8203742f0e3062$export$66068918abb14406;
var $5c8203742f0e3062$export$b416056e795d2eac = {
    prefix: "fas",
    iconName: "cloud-showers-water",
    icon: [
        576,
        512,
        [],
        "e4e4",
        "M224 0c38.6 0 71.9 22.8 87.2 55.7C325.7 41.1 345.8 32 368 32c38.7 0 71 27.5 78.4 64H448c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64c0-53 43-96 96-96zM140.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm327.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM252.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm103.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $5c8203742f0e3062$export$b532f5d25de97633 = {
    prefix: "fas",
    iconName: "chart-bar",
    icon: [
        512,
        512,
        [
            "bar-chart"
        ],
        "f080",
        "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 64H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$2d5f754a5e5738b = $5c8203742f0e3062$export$b532f5d25de97633;
var $5c8203742f0e3062$export$2f78563e14e49916 = {
    prefix: "fas",
    iconName: "hands-bubbles",
    icon: [
        576,
        512,
        [
            "hands-wash"
        ],
        "e05e",
        "M416 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 464a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM32 160l.1 72.6c.1 52.2 24 101 64 133.1c-.1-1.9-.1-3.8-.1-5.7v-8c0-71.8 37-138.6 97.9-176.7l60.2-37.6c8.6-5.4 17.9-8.4 27.3-9.4l45.9-79.5c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8l-78 135.1c-3.3 5.7-10.7 7.7-16.4 4.4s-7.7-10.7-4.4-16.4l62-107.4c6.6-11.5 2.7-26.2-8.8-32.8S214 5 207.4 16.5l-68 117.8 0 0 0 0-43.3 75L96 160c0-17.7-14.4-32-32-32s-32 14.4-32 32zM332.1 88.5L307.5 131c13.9 4.5 26.4 13.7 34.7 27c.9 1.5 1.8 2.9 2.5 4.4l28.9-50c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zm46.4 63.7l-26.8 46.4c-.6 6-2.1 11.8-4.3 17.4H352h13.3l0 0H397l23-39.8c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zM315.1 175c-9.4-15-29.1-19.5-44.1-10.2l-60.2 37.6C159.3 234.7 128 291.2 128 352v8c0 8.9 .8 17.6 2.2 26.1c35.4 8.2 61.8 40 61.8 77.9c0 6.3-.7 12.5-2.1 18.4C215.1 501 246.3 512 280 512H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H352l0 0 0 0H258.8L305 219.1c15-9.4 19.5-29.1 10.2-44.1z"
    ]
};
var $5c8203742f0e3062$export$996b5dea53b124e3 = $5c8203742f0e3062$export$2f78563e14e49916;
var $5c8203742f0e3062$export$b2c723344cff0d8 = {
    prefix: "fas",
    iconName: "less-than-equal",
    icon: [
        448,
        512,
        [],
        "f537",
        "M395.9 93.7c16.4-6.6 24.4-25.2 17.8-41.6s-25.2-24.4-41.6-17.8l-320 128C40 167.1 32 178.9 32 192s8 24.9 20.1 29.7l320 128c16.4 6.6 35-1.4 41.6-17.8s-1.4-35-17.8-41.6L150.2 192 395.9 93.7zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $5c8203742f0e3062$export$17cde74bf6f1ee89 = {
    prefix: "fas",
    iconName: "train",
    icon: [
        448,
        512,
        [
            128646
        ],
        "f238",
        "M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zM224 288a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $5c8203742f0e3062$export$23a892b1a4b994bd = {
    prefix: "fas",
    iconName: "eye-low-vision",
    icon: [
        640,
        512,
        [
            "low-vision"
        ],
        "f2a8",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223 149.5c48.6-44.3 123-50.8 179.3-11.7c60.8 42.4 78.9 123.2 44.2 186.9L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3L223 149.5zm-139.9 12c-11 14.4-20.5 28.7-28.4 42.2l339 265.7c18.7-5.5 36.2-13 52.6-21.8L83.1 161.5zm-50 86.3c-1.8 6.8-1.3 14 1.4 20.5c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c3.1 0 6.1-.1 9.2-.2L33.1 247.8z"
    ]
};
var $5c8203742f0e3062$export$7a65d2aa54cb4e93 = $5c8203742f0e3062$export$23a892b1a4b994bd;
var $5c8203742f0e3062$export$bfa312207b788ed9 = {
    prefix: "fas",
    iconName: "crow",
    icon: [
        640,
        512,
        [],
        "f520",
        "M456 0c-48.6 0-88 39.4-88 88v29.2L12.5 390.6c-14 10.8-16.6 30.9-5.9 44.9s30.9 16.6 44.9 5.9L126.1 384H259.2l46.6 113.1c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3L311.1 384H352c1.1 0 2.1 0 3.2 0l46.6 113.2c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3l-42-102C484.9 354.1 544 280 544 192V128v-8l80.5-20.1c8.6-2.1 13.8-10.8 11.6-19.4C629 52 603.4 32 574 32H523.9C507.7 12.5 483.3 0 456 0zm0 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $5c8203742f0e3062$export$e363e74e36cce80c = {
    prefix: "fas",
    iconName: "sailboat",
    icon: [
        576,
        512,
        [],
        "e445",
        "M256 16c0-7 4.5-13.2 11.2-15.3s13.9 .4 17.9 6.1l224 320c3.4 4.9 3.8 11.3 1.1 16.6s-8.2 8.6-14.2 8.6H272c-8.8 0-16-7.2-16-16V16zM212.1 96.5c7 1.9 11.9 8.2 11.9 15.5V336c0 8.8-7.2 16-16 16H80c-5.7 0-11-3-13.8-8s-2.9-11-.1-16l128-224c3.6-6.3 11-9.4 18-7.5zM5.7 404.3C2.8 394.1 10.5 384 21.1 384H554.9c10.6 0 18.3 10.1 15.4 20.3l-4 14.3C550.7 473.9 500.4 512 443 512H133C75.6 512 25.3 473.9 9.7 418.7l-4-14.3z"
    ]
};
var $5c8203742f0e3062$export$eccfff9bfd585652 = {
    prefix: "fas",
    iconName: "window-restore",
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M432 64H208c-8.8 0-16 7.2-16 16V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V320h16c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM0 192c0-35.3 28.7-64 64-64H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm64 32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z"
    ]
};
var $5c8203742f0e3062$export$eaf727acca5a35e4 = {
    prefix: "fas",
    iconName: "square-plus",
    icon: [
        448,
        512,
        [
            61846,
            "plus-square"
        ],
        "f0fe",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $5c8203742f0e3062$export$b6359eebfe900c35 = $5c8203742f0e3062$export$eaf727acca5a35e4;
var $5c8203742f0e3062$export$75825a4c2b3375e = {
    prefix: "fas",
    iconName: "torii-gate",
    icon: [
        512,
        512,
        [
            9961
        ],
        "f6a1",
        "M0 80c0 26.5 21.5 48 48 48H64v64h64V128h96v64h64V128h96v64h64V128h16c26.5 0 48-21.5 48-48V13.4C512 6 506 0 498.6 0c-1.7 0-3.4 .3-5 1l-49 19.6C425.7 28.1 405.5 32 385.2 32H126.8c-20.4 0-40.5-3.9-59.4-11.4L18.4 1c-1.6-.6-3.3-1-5-1C6 0 0 6 0 13.4V80zM64 288V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288H384V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64z"
    ]
};
var $5c8203742f0e3062$export$fe2358263efac504 = {
    prefix: "fas",
    iconName: "frog",
    icon: [
        576,
        512,
        [],
        "f52e",
        "M368 32c41.7 0 75.9 31.8 79.7 72.5l85.6 26.3c25.4 7.8 42.8 31.3 42.8 57.9c0 21.8-11.7 41.9-30.7 52.7L400.8 323.5 493.3 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-8.5 0-16.6-3.4-22.6-9.4L346.9 360.2c11.7-36 3.2-77.1-25.4-105.7c-40.6-40.6-106.3-40.6-146.9-.1L101 324.4c-6.4 6.1-6.7 16.2-.6 22.6s16.2 6.6 22.6 .6l73.8-70.2 .1-.1 .1-.1c3.5-3.5 7.3-6.6 11.3-9.2c27.9-18.5 65.9-15.4 90.5 9.2c24.7 24.7 27.7 62.9 9 90.9c-2.6 3.8-5.6 7.5-9 10.9L261.8 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64C0 249.6 127 112.9 289.3 97.5C296.2 60.2 328.8 32 368 32zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $5c8203742f0e3062$export$2124c7628e573b84 = {
    prefix: "fas",
    iconName: "bucket",
    icon: [
        448,
        512,
        [],
        "e4cf",
        "M96 152v8H48v-8C48 68.1 116.1 0 200 0h48c83.9 0 152 68.1 152 152v8H352v-8c0-57.4-46.6-104-104-104H200C142.6 48 96 94.6 96 152zM0 224c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32h-5.1L388.5 469c-2.6 24.4-23.2 43-47.7 43H107.2c-24.6 0-45.2-18.5-47.7-43L37.1 256H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $5c8203742f0e3062$export$7e9f0928967e03b = {
    prefix: "fas",
    iconName: "image",
    icon: [
        512,
        512,
        [],
        "f03e",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $5c8203742f0e3062$export$eed3c491effe6d12 = {
    prefix: "fas",
    iconName: "microphone",
    icon: [
        384,
        512,
        [],
        "f130",
        "M192 0C139 0 96 43 96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z"
    ]
};
var $5c8203742f0e3062$export$1da3b2e53dcafa2d = {
    prefix: "fas",
    iconName: "cow",
    icon: [
        640,
        512,
        [
            128004
        ],
        "f6c8",
        "M96 224v32V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V327.8c9.9 6.6 20.6 12 32 16.1V368c0 8.8 7.2 16 16 16s16-7.2 16-16V351.1c5.3 .6 10.6 .9 16 .9s10.7-.3 16-.9V368c0 8.8 7.2 16 16 16s16-7.2 16-16V343.8c11.4-4 22.1-9.4 32-16.1V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256l32 32v49.5c0 9.5 2.8 18.7 8.1 26.6L530 427c8.8 13.1 23.5 21 39.3 21c22.5 0 41.9-15.9 46.3-38l20.3-101.6c2.6-13-.3-26.5-8-37.3l-3.9-5.5V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v14.4l-52.9-74.1C496 86.5 452.4 64 405.9 64H272 256 192 144C77.7 64 24 117.7 24 184v54C9.4 249.8 0 267.8 0 288v17.6c0 8 6.4 14.4 14.4 14.4C46.2 320 72 294.2 72 262.4V256 224 184c0-24.3 12.1-45.8 30.5-58.9C98.3 135.9 96 147.7 96 160v64zM560 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM166.6 166.6c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6H361.4c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16l-23.4 23.4C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9l-23.4-23.4z"
    ]
};
var $5c8203742f0e3062$export$7de776bdab4e536d = {
    prefix: "fas",
    iconName: "caret-up",
    icon: [
        320,
        512,
        [],
        "f0d8",
        "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
    ]
};
var $5c8203742f0e3062$export$7484ff654cd6474f = {
    prefix: "fas",
    iconName: "screwdriver",
    icon: [
        512,
        512,
        [
            129691
        ],
        "f54a",
        "M465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19v54.1l-85.6 85.6c6.7 4.2 13 9.3 18.8 15.1s10.9 12.2 15.1 18.8L353.9 192H408c7.5 0 14.5-3.5 19-9.4l80-104c7.4-9.6 6.5-23.1-2.1-31.6L465 7zM121.4 281.4l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3s-79.1-30.2-109.3 0z"
    ]
};
var $5c8203742f0e3062$export$5e30548b7f8eeb95 = {
    prefix: "fas",
    iconName: "folder-closed",
    icon: [
        512,
        512,
        [],
        "e185",
        "M448 480H64c-35.3 0-64-28.7-64-64V192H512V416c0 35.3-28.7 64-64 64zm64-320H0V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64z"
    ]
};
var $5c8203742f0e3062$export$197b9567e88a0b1d = {
    prefix: "fas",
    iconName: "house-tsunami",
    icon: [
        576,
        512,
        [],
        "e515",
        "M80.8 136.5C104.9 93.8 152.6 64 209 64c16.9 0 33.1 2.7 48.2 7.7c16.8 5.5 34.9-3.6 40.4-20.4s-3.6-34.9-20.4-40.4C255.8 3.8 232.8 0 209 0C95.2 0 0 88 0 200c0 91.6 53.5 172.1 142.2 194.1c13.4 3.8 27.5 5.9 42.2 5.9c.7 0 1.4 0 2.1-.1c1.8 0 3.7 .1 5.5 .1l0 0c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0c-22.4 15.5-49.9 26.1-77.4 26.1c0 0-.1 0-.1 0c-12.4 0-24-1.5-34.9-4.3C121.6 320.2 96 287 96 248c0-48.5 39.5-88 88.4-88c13.5 0 26.1 3 37.5 8.3c16 7.5 35.1 .6 42.5-15.5s.6-35.1-15.5-42.5C229.3 101.1 207.4 96 184.4 96c-40 0-76.4 15.4-103.6 40.5zm252-18.1c-8.1 6-12.8 15.5-12.8 25.6V265c1.6 1 3.3 2 4.8 3.1c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c5.8 1.4 11.2 3.4 16.2 6.2c.7-2.7 1.1-5.5 1.1-8.4l-.4-144c0-10-4.7-19.4-12.7-25.5l-95.5-72c-11.4-8.6-27.1-8.6-38.5 0l-96 72zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"
    ]
};
var $5c8203742f0e3062$export$5498258519fc5b72 = {
    prefix: "fas",
    iconName: "square-nfi",
    icon: [
        448,
        512,
        [],
        "e576",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm75.7 64.6C68.8 162.5 64 168.8 64 176V336c0 8.8 7.2 16 16 16s16-7.2 16-16V233.8l66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V278.2L93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2zM224 176v64 96c0 8.8 7.2 16 16 16s16-7.2 16-16V256h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V192h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176z"
    ]
};
var $5c8203742f0e3062$export$cbe485a104805f4f = {
    prefix: "fas",
    iconName: "arrow-up-from-ground-water",
    icon: [
        576,
        512,
        [],
        "e4b5",
        "M288 352c17.7 0 32-14.3 32-32V109.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V320c0 17.7 14.3 32 32 32zm-18.5 69.9C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM192 192H48c-26.5 0-48 21.5-48 48V425c5.3-3.1 11.2-5.4 17.5-6.9c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.1 20.3V192zm384 48c0-26.5-21.5-48-48-48H384V416.5h0c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c6.3 1.5 12.1 3.8 17.5 6.9V240z"
    ]
};
var $5c8203742f0e3062$export$98401bb29cff68e0 = {
    prefix: "fas",
    iconName: "martini-glass",
    icon: [
        512,
        512,
        [
            127864,
            "glass-martini-alt"
        ],
        "f57b",
        "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM173.3 128l-64-64H402.7l-64 64H173.3z"
    ]
};
var $5c8203742f0e3062$export$2258439b8f4e7acb = $5c8203742f0e3062$export$98401bb29cff68e0;
var $5c8203742f0e3062$export$7adaa412bd8eb08f = {
    prefix: "fas",
    iconName: "rotate-left",
    icon: [
        512,
        512,
        [
            "rotate-back",
            "rotate-backward",
            "undo-alt"
        ],
        "f2ea",
        "M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"
    ]
};
var $5c8203742f0e3062$export$9706706f1bc7b12 = $5c8203742f0e3062$export$7adaa412bd8eb08f;
var $5c8203742f0e3062$export$4ceb0b05fed961a9 = $5c8203742f0e3062$export$7adaa412bd8eb08f;
var $5c8203742f0e3062$export$c8197b992c46c4a6 = $5c8203742f0e3062$export$7adaa412bd8eb08f;
var $5c8203742f0e3062$export$ccaa019a3fd4563f = {
    prefix: "fas",
    iconName: "table-columns",
    icon: [
        512,
        512,
        [
            "columns"
        ],
        "f0db",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 64V416H224V160H64zm384 0H288V416H448V160z"
    ]
};
var $5c8203742f0e3062$export$bb861166644ac28a = $5c8203742f0e3062$export$ccaa019a3fd4563f;
var $5c8203742f0e3062$export$4fbda8f64648f3b5 = {
    prefix: "fas",
    iconName: "lemon",
    icon: [
        448,
        512,
        [
            127819
        ],
        "f094",
        "M448 96c0-35.3-28.7-64-64-64c-6.6 0-13 1-19 2.9c-22.5 7-48.1 14.9-71 9c-75.2-19.1-156.4 11-213.7 68.3S-7.2 250.8 11.9 326c5.8 22.9-2 48.4-9 71C1 403 0 409.4 0 416c0 35.3 28.7 64 64 64c6.6 0 13-1 19.1-2.9c22.5-7 48.1-14.9 71-9c75.2 19.1 156.4-11 213.7-68.3s87.5-138.5 68.3-213.7c-5.8-22.9 2-48.4 9-71c1.9-6 2.9-12.4 2.9-19.1zM212.5 127.4c-54.6 16-101.1 62.5-117.1 117.1C92.9 253 84 257.8 75.5 255.4S62.2 244 64.6 235.5c19.1-65.1 73.7-119.8 138.9-138.9c8.5-2.5 17.4 2.4 19.9 10.9s-2.4 17.4-10.9 19.9z"
    ]
};
var $5c8203742f0e3062$export$280300af4baa1a3e = {
    prefix: "fas",
    iconName: "head-side-mask",
    icon: [
        576,
        512,
        [],
        "e063",
        "M32 224.2c0-22.2 3.2-43.6 9.2-63.9L262.2 321c-4 9.5-6.2 20-6.2 31V512H128c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C48.6 322.4 32 274.1 32 224.2zm248.3 70.4L53 129.3C88.7 53 166.2 0 256 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c5.4 6.7 8.6 14.8 9.4 23.2H336c-21.7 0-41.3 8.6-55.7 22.6zM336 304H534l0 0h10l-19.7 64H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H514.5l-9.8 32H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H494.8l-.9 2.8c-8.3 26.9-33.1 45.2-61.2 45.2H288V352c0-14 6-26.7 15.6-35.4c0 0 0 0 0 0c8.5-7.8 19.9-12.6 32.4-12.6zm48-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$b4c63e9bfc7906f1 = {
    prefix: "fas",
    iconName: "handshake",
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123zM16 128c-8.8 0-16 7.2-16 16V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V128H16zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H544zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var $5c8203742f0e3062$export$31ee86ac717db552 = {
    prefix: "fas",
    iconName: "gem",
    icon: [
        512,
        512,
        [
            128142
        ],
        "f3a5",
        "M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z"
    ]
};
var $5c8203742f0e3062$export$5879d0bca1aa497b = {
    prefix: "fas",
    iconName: "dolly",
    icon: [
        576,
        512,
        [
            "dolly-box"
        ],
        "f472",
        "M0 32C0 14.3 14.3 0 32 0h72.9c27.5 0 52 17.6 60.7 43.8L257.7 320c30.1 .5 56.8 14.9 74 37l202.1-67.4c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L352 417.7c-.9 52.2-43.5 94.3-96 94.3c-53 0-96-43-96-96c0-30.8 14.5-58.2 37-75.8L104.9 64H32C14.3 64 0 49.7 0 32zM244.8 134.5c-5.5-16.8 3.7-34.9 20.5-40.3L311 79.4l19.8 60.9 60.9-19.8L371.8 59.6l45.7-14.8c16.8-5.5 34.9 3.7 40.3 20.5l49.4 152.2c5.5 16.8-3.7 34.9-20.5 40.3L334.5 307.2c-16.8 5.5-34.9-3.7-40.3-20.5L244.8 134.5z"
    ]
};
var $5c8203742f0e3062$export$461bbb9e92cc531b = $5c8203742f0e3062$export$5879d0bca1aa497b;
var $5c8203742f0e3062$export$c4ab83701fc591a5 = {
    prefix: "fas",
    iconName: "smoking",
    icon: [
        640,
        512,
        [
            128684
        ],
        "f48d",
        "M448 32V43c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v11c0 17.7-14.3 32-32 32s-32-14.3-32-32V245c0-12.7-5.1-24.9-14.1-33.9l-21-21C405.9 151.1 384 98.1 384 43V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM576 256V245c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V32c0-17.7 14.3-32 32-32s32 14.3 32 32V43c0 12.7 5.1 24.9 14.1 33.9l21 21c39 39 60.9 91.9 60.9 147.1v11c0 17.7-14.3 32-32 32s-32-14.3-32-32zM0 416c0-35.3 28.7-64 64-64H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V416zm224 0v32H384V416H224zm288-64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$e0601b1f239fec74 = {
    prefix: "fas",
    iconName: "minimize",
    icon: [
        512,
        512,
        [
            "compress-arrows-alt"
        ],
        "f78c",
        "M456 224H312c-13.3 0-24-10.7-24-24V56c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l40 40L442.3 5.7C446 2 450.9 0 456 0s10 2 13.7 5.7l36.7 36.7C510 46 512 50.9 512 56s-2 10-5.7 13.7L433 143l40 40c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8zm0 64c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-40 40 73.4 73.4c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C466 510 461.1 512 456 512s-10-2-13.7-5.7L369 433l-40 40c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V312c0-13.3 10.7-24 24-24H456zm-256 0c13.3 0 24 10.7 24 24V456c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-40-40L69.7 506.3C66 510 61.1 512 56 512s-10-2-13.7-5.7L5.7 469.7C2 466 0 461.1 0 456s2-10 5.7-13.7L79 369 39 329c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8H200zM56 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l40-40L5.7 69.7C2 66 0 61.1 0 56s2-10 5.7-13.7L42.3 5.7C46 2 50.9 0 56 0s10 2 13.7 5.7L143 79l40-40c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2V200c0 13.3-10.7 24-24 24H56z"
    ]
};
var $5c8203742f0e3062$export$39205db0ea980efd = $5c8203742f0e3062$export$e0601b1f239fec74;
var $5c8203742f0e3062$export$6f9b0bfc012deb25 = {
    prefix: "fas",
    iconName: "monument",
    icon: [
        384,
        512,
        [],
        "f5a6",
        "M180.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c2.5 2.5 4.1 5.8 4.6 9.3l40.2 322H55.9L96.1 94c.4-3.5 2-6.8 4.6-9.3l80-80zM152 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zM32 448H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$695fae58f55c3a87 = {
    prefix: "fas",
    iconName: "snowplow",
    icon: [
        640,
        512,
        [],
        "f7d2",
        "M298.9 64l68.6 160H256l-64-64V64H298.9zM445.1 242.7l-87.4-204C347.6 15.3 324.5 0 298.9 0H176c-26.5 0-48 21.5-48 48V160H96c-17.7 0-32 14.3-32 32V298.8C26.2 316.8 0 355.3 0 400c0 61.9 50.1 112 112 112H368c61.9 0 112-50.1 112-112c0-17.2-3.9-33.5-10.8-48H512v50.7c0 17 6.7 33.3 18.7 45.3l54.6 54.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L576 402.7V320 235.2L633 164c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-57 71.2c-9.1 11.3-14 25.4-14 40V288H448V256.7c.1-2.4-.2-4.8-.6-7.1s-1.2-4.7-2.2-6.8zM368 352c26.5 0 48 21.5 48 48s-21.5 48-48 48H112c-26.5 0-48-21.5-48-48s21.5-48 48-48H368zM144 400a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM200 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $5c8203742f0e3062$export$48b60f1720e09944 = {
    prefix: "fas",
    iconName: "angles-right",
    icon: [
        512,
        512,
        [
            187,
            "angle-double-right"
        ],
        "f101",
        "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
    ]
};
var $5c8203742f0e3062$export$792931403404faf0 = $5c8203742f0e3062$export$48b60f1720e09944;
var $5c8203742f0e3062$export$8ec2f752344b69bd = {
    prefix: "fas",
    iconName: "cannabis",
    icon: [
        512,
        512,
        [],
        "f55f",
        "M256 0c5.3 0 10.3 2.7 13.3 7.1c15.8 23.5 36.7 63.7 49.2 109c7.2 26.4 11.8 55.2 10.4 84c11.5-8.8 23.7-16.7 35.8-23.6c41-23.3 84.4-36.9 112.2-42.5c5.2-1 10.7 .6 14.4 4.4s5.4 9.2 4.4 14.5c-5.6 27.7-19.3 70.9-42.7 111.7c-9.1 15.9-19.9 31.7-32.4 46.3c27.8 6.6 52.4 17.3 67.2 25.5c5.1 2.8 8.2 8.2 8.2 14s-3.2 11.2-8.2 14c-15.2 8.4-40.9 19.5-69.8 26.1c-20.2 4.6-42.9 7.2-65.2 4.6l8.3 33.1c1.5 6.1-.6 12.4-5.5 16.4s-11.6 4.6-17.2 1.9L280 417.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V417.2l-58.5 29.1c-5.6 2.8-12.3 2.1-17.2-1.9s-7-10.3-5.5-16.4l8.3-33.1c-22.2 2.6-45 0-65.2-4.6c-28.9-6.6-54.6-17.6-69.8-26.1c-5.1-2.8-8.2-8.2-8.2-14s3.2-11.2 8.2-14c14.8-8.2 39.4-18.8 67.2-25.5C78.9 296.3 68.1 280.5 59 264.6c-23.4-40.8-37.1-84-42.7-111.7c-1.1-5.2 .6-10.7 4.4-14.5s9.2-5.4 14.4-4.4c27.9 5.5 71.2 19.2 112.2 42.5c12.1 6.9 24.3 14.7 35.8 23.6c-1.4-28.7 3.1-57.6 10.4-84c12.5-45.3 33.4-85.5 49.2-109c3-4.4 8-7.1 13.3-7.1z"
    ]
};
var $5c8203742f0e3062$export$86c4e45dc3302d15 = {
    prefix: "fas",
    iconName: "circle-play",
    icon: [
        512,
        512,
        [
            61469,
            "play-circle"
        ],
        "f144",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"
    ]
};
var $5c8203742f0e3062$export$cf04333781061c5e = $5c8203742f0e3062$export$86c4e45dc3302d15;
var $5c8203742f0e3062$export$bed2b0ed4ae45e0d = {
    prefix: "fas",
    iconName: "tablets",
    icon: [
        640,
        512,
        [],
        "f490",
        "M614.3 247c16.3-25 25.7-54.9 25.7-87C640 71.6 568.4 0 480 0c-32.1 0-61.9 9.4-87 25.7c-7.9 5.2-8.5 16.2-1.8 22.9L591.4 248.8c6.7 6.7 17.8 6.2 22.9-1.8zM567 294.3c7.9-5.2 8.5-16.2 1.8-22.9L368.6 71.2c-6.7-6.7-17.8-6.2-22.9 1.8c-16.3 25-25.7 54.9-25.7 87c0 88.4 71.6 160 160 160c32.1 0 61.9-9.4 87-25.7zM301.5 368H18.5c-9.5 0-16.9 8.2-15 17.5C18.9 457.8 83.1 512 160 512s141.1-54.2 156.5-126.5c2-9.3-5.5-17.5-15-17.5zm0-32c9.5 0 16.9-8.2 15-17.5C301.1 246.2 236.9 192 160 192S18.9 246.2 3.5 318.5c-2 9.3 5.5 17.5 15 17.5H301.5z"
    ]
};
var $5c8203742f0e3062$export$6bad2c9f317b52e5 = {
    prefix: "fas",
    iconName: "ethernet",
    icon: [
        512,
        512,
        [],
        "f796",
        "M0 224V416c0 17.7 14.3 32 32 32H96V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H448V160c0-17.7-14.3-32-32-32H384V96c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v32H96c-17.7 0-32 14.3-32 32v32H32c-17.7 0-32 14.3-32 32z"
    ]
};
var $5c8203742f0e3062$export$902a3969bb113dff = {
    prefix: "fas",
    iconName: "euro-sign",
    icon: [
        320,
        512,
        [
            8364,
            "eur",
            "euro"
        ],
        "f153",
        "M48.1 240c-.1 2.7-.1 5.3-.1 8v16c0 2.7 0 5.3 .1 8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H60.3C89.9 419.9 170 480 264 480h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264c-57.9 0-108.2-32.4-133.9-80H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112.2c-.1-2.6-.2-5.3-.2-8V248c0-2.7 .1-5.4 .2-8H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H130.1c25.7-47.6 76-80 133.9-80h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264C170 32 89.9 92.1 60.3 176H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48.1z"
    ]
};
var $5c8203742f0e3062$export$4b859160cfeb12ff = $5c8203742f0e3062$export$902a3969bb113dff;
var $5c8203742f0e3062$export$bdabbefede2d3a2 = $5c8203742f0e3062$export$902a3969bb113dff;
var $5c8203742f0e3062$export$a339864ee3df7e9a = {
    prefix: "fas",
    iconName: "chair",
    icon: [
        448,
        512,
        [
            129681
        ],
        "f6c0",
        "M248 48V256h48V58.7c23.9 13.8 40 39.7 40 69.3V256h48V128C384 57.3 326.7 0 256 0H192C121.3 0 64 57.3 64 128V256h48V128c0-29.6 16.1-55.5 40-69.3V256h48V48h48zM48 288c-12.1 0-23.2 6.8-28.6 17.7l-16 32c-5 9.9-4.4 21.7 1.4 31.1S20.9 384 32 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32V384H352v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-16-32C423.2 294.8 412.1 288 400 288H48z"
    ]
};
var $5c8203742f0e3062$export$c2e9877668862374 = {
    prefix: "fas",
    iconName: "circle-check",
    icon: [
        512,
        512,
        [
            61533,
            "check-circle"
        ],
        "f058",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $5c8203742f0e3062$export$be9e388158c74f29 = $5c8203742f0e3062$export$c2e9877668862374;
var $5c8203742f0e3062$export$229de76dfef2687f = {
    prefix: "fas",
    iconName: "circle-stop",
    icon: [
        512,
        512,
        [
            62094,
            "stop-circle"
        ],
        "f28d",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$47af2aad60ab3e7c = $5c8203742f0e3062$export$229de76dfef2687f;
var $5c8203742f0e3062$export$aaaddd2cf7e20f64 = {
    prefix: "fas",
    iconName: "compass-drafting",
    icon: [
        512,
        512,
        [
            "drafting-compass"
        ],
        "f568",
        "M352 96c0 14.3-3.1 27.9-8.8 40.2L396 227.4c-23.7 25.3-54.2 44.1-88.5 53.6L256 192h0 0l-68 117.5c21.5 6.8 44.3 10.5 68.1 10.5c70.7 0 133.8-32.7 174.9-84c11.1-13.8 31.2-16 45-5s16 31.2 5 45C428.1 341.8 347 384 256 384c-35.4 0-69.4-6.4-100.7-18.1L98.7 463.7C94 471.8 87 478.4 78.6 482.6L23.2 510.3c-5 2.5-10.9 2.2-15.6-.7S0 501.5 0 496V440.6c0-8.4 2.2-16.7 6.5-24.1l60-103.7C53.7 301.6 41.8 289.3 31.2 276c-11.1-13.8-8.8-33.9 5-45s33.9-8.8 45 5c5.7 7.1 11.8 13.8 18.2 20.1l69.4-119.9c-5.6-12.2-8.8-25.8-8.8-40.2c0-53 43-96 96-96s96 43 96 96zm21 297.9c32.6-12.8 62.5-30.8 88.9-52.9l43.7 75.5c4.2 7.3 6.5 15.6 6.5 24.1V496c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7l-55.4-27.7c-8.4-4.2-15.4-10.8-20.1-18.9L373 393.9zM256 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$c8c2b127d13b9d79 = $5c8203742f0e3062$export$aaaddd2cf7e20f64;
var $5c8203742f0e3062$export$2eff9f6cbe00a643 = {
    prefix: "fas",
    iconName: "plate-wheat",
    icon: [
        512,
        512,
        [],
        "e55a",
        "M176 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM56 64h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM24 136H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 48c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48zM400 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zm80 160v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 176c8.8 0 16 7.2 16 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80zm-96 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM3.5 347.6C1.6 332.9 13 320 27.8 320H484.2c14.8 0 26.2 12.9 24.4 27.6C502.3 397.8 464.2 437 416 446v2c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-2c-48.2-9-86.3-48.2-92.5-98.4z"
    ]
};
var $5c8203742f0e3062$export$78792ed87d92a3ad = {
    prefix: "fas",
    iconName: "icicles",
    icon: [
        512,
        512,
        [],
        "f7ad",
        "M75.8 304.8L1 35.7c-.7-2.5-1-5-1-7.5C0 12.6 12.6 0 28.2 0H482.4C498.8 0 512 13.2 512 29.6c0 1.6-.1 3.3-.4 4.9L434.6 496.1c-1.5 9.2-9.5 15.9-18.8 15.9c-9.2 0-17.1-6.6-18.7-15.6L336 160 307.2 303.9c-1.9 9.3-10.1 16.1-19.6 16.1c-9.2 0-17.2-6.2-19.4-15.1L240 192 210.6 368.2c-1.5 9.1-9.4 15.8-18.6 15.8s-17.1-6.7-18.6-15.8L144 192 115.9 304.3c-2.3 9.2-10.6 15.7-20.1 15.7c-9.3 0-17.5-6.2-20-15.2z"
    ]
};
var $5c8203742f0e3062$export$d359c2cc7640953c = {
    prefix: "fas",
    iconName: "person-shelter",
    icon: [
        512,
        512,
        [],
        "e54f",
        "M271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128C6.2 137.9 0 148.5 0 160V480c0 17.7 14.3 32 32 32s32-14.3 32-32V178.6L256 68.9 448 178.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-11.5-6.2-22.1-16.1-27.8l-224-128zM256 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-8 280V400h16v88c0 13.3 10.7 24 24 24s24-10.7 24-24V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H246.2c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L200 313.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $5c8203742f0e3062$export$771cf879fba0cf93 = {
    prefix: "fas",
    iconName: "neuter",
    icon: [
        384,
        512,
        [
            9906
        ],
        "f22c",
        "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32V349.1z"
    ]
};
var $5c8203742f0e3062$export$a75288855ea05282 = {
    prefix: "fas",
    iconName: "id-badge",
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$e6789173649caa25 = {
    prefix: "fas",
    iconName: "marker",
    icon: [
        512,
        512,
        [],
        "f5a1",
        "M481 31C445.1-4.8 386.9-4.8 351 31l-15 15L322.9 33C294.8 4.9 249.2 4.9 221.1 33L135 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L255 66.9c9.4-9.4 24.6-9.4 33.9 0L302.1 80 186.3 195.7 316.3 325.7 481 161c35.9-35.9 35.9-94.1 0-129.9zM293.7 348.3L163.7 218.3 99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l64.2-64.2z"
    ]
};
var $5c8203742f0e3062$export$3f2d51c0547bf984 = {
    prefix: "fas",
    iconName: "face-laugh-beam",
    icon: [
        512,
        512,
        [
            128513,
            "laugh-beam"
        ],
        "f59a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM217.6 212.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $5c8203742f0e3062$export$a88d1f4073ea9369 = $5c8203742f0e3062$export$3f2d51c0547bf984;
var $5c8203742f0e3062$export$2a66e6044c1f7036 = {
    prefix: "fas",
    iconName: "helicopter-symbol",
    icon: [
        512,
        512,
        [],
        "e502",
        "M445.3 224H510C495.6 108.2 403.8 16.4 288 2V66.7C368.4 80.1 431.9 143.6 445.3 224zM510 288H445.3C431.9 368.4 368.4 431.9 288 445.4V510c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510V445.4C143.6 431.9 80.1 368.4 66.7 288H2zm0-64H66.7C80.1 143.6 143.6 80.1 224 66.7V2C108.2 16.4 16.4 108.2 2 224zm206-64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V288h96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H208V160z"
    ]
};
var $5c8203742f0e3062$export$e119aada7f690d05 = {
    prefix: "fas",
    iconName: "universal-access",
    icon: [
        512,
        512,
        [],
        "f29a",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm161.5-86.1c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l11.9 5.1c17.3 7.4 35.2 12.9 53.6 16.3v50.1c0 4.3-.7 8.6-2.1 12.6l-28.7 86.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l24.4-73.2c1.3-3.8 4.8-6.4 8.8-6.4s7.6 2.6 8.8 6.4l24.4 73.2c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-28.7-86.1c-1.4-4.1-2.1-8.3-2.1-12.6V235.5c18.4-3.5 36.3-8.9 53.6-16.3l11.9-5.1c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L338.7 175c-26.1 11.2-54.2 17-82.7 17s-56.5-5.8-82.7-17l-11.9-5.1zM256 160a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $5c8203742f0e3062$export$7b69b3617b84259b = {
    prefix: "fas",
    iconName: "circle-chevron-up",
    icon: [
        512,
        512,
        [
            "chevron-circle-up"
        ],
        "f139",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167c9.4-9.4 24.6-9.4 33.9 0L377 271z"
    ]
};
var $5c8203742f0e3062$export$b786cf5db03f2c36 = $5c8203742f0e3062$export$7b69b3617b84259b;
var $5c8203742f0e3062$export$d317bc452442782d = {
    prefix: "fas",
    iconName: "lari-sign",
    icon: [
        384,
        512,
        [],
        "e1c8",
        "M144 32c17.7 0 32 14.3 32 32V96.7c5.3-.4 10.6-.7 16-.7s10.7 .2 16 .7V64c0-17.7 14.3-32 32-32s32 14.3 32 32v49.4c54.9 25.2 95.8 75.5 108.2 136.2c3.5 17.3-7.7 34.2-25 37.7s-34.2-7.7-37.7-25c-6.1-29.9-22.5-55.9-45.4-74.3V256c0 17.7-14.3 32-32 32s-32-14.3-32-32V161c-5.2-.7-10.6-1-16-1s-10.8 .3-16 1v95c0 17.7-14.3 32-32 32s-32-14.3-32-32V188.1C82.7 211.5 64 247.6 64 288c0 70.7 57.3 128 128 128H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H192 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48.9C18.5 382 0 337.2 0 288c0-77.5 45.9-144.3 112-174.6V64c0-17.7 14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$bae30a76735500e1 = {
    prefix: "fas",
    iconName: "volcano",
    icon: [
        512,
        512,
        [
            127755
        ],
        "f770",
        "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31C322 21.6 336.3 16 352 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.7 0-28.3-5-39.1-13.3l-32 48C275.3 187 266 192 256 192s-19.3-5-24.9-13.3l-32-48C188.3 139 174.7 144 160 144zM144 352l48.4-24.2c10.2-5.1 21.6-7.8 33-7.8c19.6 0 38.4 7.8 52.2 21.6l32.5 32.5c6.3 6.3 14.9 9.9 23.8 9.9c11.3 0 21.8-5.6 28-15l9.7-14.6-58.9-66.3c-9.1-10.2-22.2-16.1-35.9-16.1H235.1c-13.7 0-26.8 5.9-35.9 16.1l-59.9 67.4L144 352zm19.4-95.8c18.2-20.5 44.3-32.2 71.8-32.2h41.8c27.4 0 53.5 11.7 71.8 32.2l150.2 169c8.5 9.5 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2H52.2C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l150.2-169z"
    ]
};
var $5c8203742f0e3062$export$a1d09c95bee8043b = {
    prefix: "fas",
    iconName: "person-walking-dashed-line-arrow-right",
    icon: [
        640,
        512,
        [],
        "e553",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80zM392 0c-13.3 0-24 10.7-24 24V72c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zm24 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM392 320c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V344c0-13.3-10.7-24-24-24zm24 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V440z"
    ]
};
var $5c8203742f0e3062$export$170c56774c8e7961 = {
    prefix: "fas",
    iconName: "sterling-sign",
    icon: [
        320,
        512,
        [
            163,
            "gbp",
            "pound-sign"
        ],
        "f154",
        "M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v44.5c0 17.4-4.7 34.5-13.7 49.4L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1C104.1 390 112 361.5 112 332.5V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V160.4z"
    ]
};
var $5c8203742f0e3062$export$3d9479ec1d1ae83e = $5c8203742f0e3062$export$170c56774c8e7961;
var $5c8203742f0e3062$export$9ce041dfec8319b = $5c8203742f0e3062$export$170c56774c8e7961;
var $5c8203742f0e3062$export$ee194b18f5c6f6b6 = {
    prefix: "fas",
    iconName: "viruses",
    icon: [
        640,
        512,
        [],
        "e076",
        "M192 0c13.3 0 24 10.7 24 24V37.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5C293 124.9 310.9 168 346.5 168H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H346.5c-35.6 0-53.5 43.1-28.3 68.3l9.5 9.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5C259.1 293 216 310.9 216 346.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V346.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H37.5c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l9.5 9.5C124.9 91 168 73.1 168 37.5V24c0-13.3 10.7-24 24-24zm48 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 80c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $5c8203742f0e3062$export$8aaca358568da0e0 = {
    prefix: "fas",
    iconName: "square-person-confined",
    icon: [
        448,
        512,
        [],
        "e577",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm80 104c0-30.9 25.1-56 56-56s56 25.1 56 56V350.1c0 36.4-29.5 65.9-65.9 65.9c-17.5 0-34.3-6.9-46.6-19.3L184.8 342l-28.1 56.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l48-96c4.6-9.2 13.3-15.6 23.5-17.3s20.5 1.7 27.8 9L240 306.7V248z"
    ]
};
var $5c8203742f0e3062$export$48c51dda34e9f04c = {
    prefix: "fas",
    iconName: "user-tie",
    icon: [
        448,
        512,
        [],
        "f508",
        "M96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm94.5 200.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7H162.5c0 0 0 0 .1 0H168 280h5.5c0 0 0 0 .1 0H417.3c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2H224 204.3c-12.4 0-20.1 13.6-13.7 24.2z"
    ]
};
var $5c8203742f0e3062$export$5977e8de7e65b20 = {
    prefix: "fas",
    iconName: "arrow-down-long",
    icon: [
        384,
        512,
        [
            "long-arrow-down"
        ],
        "f175",
        "M169.4 502.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7 224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 370.7L86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z"
    ]
};
var $5c8203742f0e3062$export$52ecf90b62f3f030 = $5c8203742f0e3062$export$5977e8de7e65b20;
var $5c8203742f0e3062$export$8a4f323f00a91606 = {
    prefix: "fas",
    iconName: "tent-arrow-down-to-line",
    icon: [
        640,
        512,
        [],
        "e57e",
        "M241.8 111.9c8.9 9.9 8.1 25-1.8 33.9l-80 72c-9.1 8.2-23 8.2-32.1 0l-80-72c-9.9-8.9-10.7-24-1.8-33.9s24-10.7 33.9-1.8l39.9 36L120 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 122.1 39.9-36c9.9-8.9 25-8.1 33.9 1.8zm122.8 22.6c11.5-8.7 27.3-8.7 38.8 0l168 128c6.6 5 11 12.5 12.3 20.7l24 160 .7 4.7c17.5 .2 31.6 14.4 31.6 32c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H159.6l.7-4.7 24-160c1.2-8.2 5.6-15.7 12.3-20.7l168-128zM384 448h80L402.7 325.5c-1.7-3.4-5.1-5.5-8.8-5.5c-5.5 0-9.9 4.4-9.9 9.9V448z"
    ]
};
var $5c8203742f0e3062$export$a881f37164b11fbf = {
    prefix: "fas",
    iconName: "certificate",
    icon: [
        512,
        512,
        [],
        "f0a3",
        "M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z"
    ]
};
var $5c8203742f0e3062$export$ca6fd367f31ecbc5 = {
    prefix: "fas",
    iconName: "reply-all",
    icon: [
        576,
        512,
        [
            "mail-reply-all"
        ],
        "f122",
        "M209.4 39.5c-9.1-9.6-24.3-10-33.9-.9L33.8 173.2c-19.9 18.9-19.9 50.7 0 69.6L175.5 377.4c9.6 9.1 24.8 8.7 33.9-.9s8.7-24.8-.9-33.9L66.8 208 208.5 73.4c9.6-9.1 10-24.3 .9-33.9zM352 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V288h32c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C494.5 467.9 576 417.3 576 304c0-97.2-78.8-176-176-176H352V64z"
    ]
};
var $5c8203742f0e3062$export$8274334f3a2c1841 = $5c8203742f0e3062$export$ca6fd367f31ecbc5;
var $5c8203742f0e3062$export$60710f3921019268 = {
    prefix: "fas",
    iconName: "suitcase",
    icon: [
        512,
        512,
        [
            129523
        ],
        "f0f2",
        "M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96v32V480H128V128 96zM64 96H96V480H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zM448 480H416V96h32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64z"
    ]
};
var $5c8203742f0e3062$export$f3854553fe688388 = {
    prefix: "fas",
    iconName: "person-skating",
    icon: [
        448,
        512,
        [
            "skating"
        ],
        "f7c5",
        "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 128c0-17.7 14.3-32 32-32H319.4c43.6 0 64.6 53.4 32.8 83.1l-74.4 69.4 60.2 60.2c9 9 14.1 21.2 14.1 33.9V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V349.3l-77.9-77.8c-26.6-26.6-24.6-70.3 4.3-94.4l20.4-17H160c-17.7 0-32-14.3-32-32zM81.4 353.4l86.9-86.9c4.6 10 11 19.3 19.3 27.5l21.8 21.8-82.7 82.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm322.5 95.1c8.6 2.1 13.8 10.8 11.6 19.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h88.8c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6zM135.2 478.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"
    ]
};
var $5c8203742f0e3062$export$21bd1d54bd4f2c5a = $5c8203742f0e3062$export$f3854553fe688388;
var $5c8203742f0e3062$export$3300e4b4d1d1936f = {
    prefix: "fas",
    iconName: "filter-circle-dollar",
    icon: [
        576,
        512,
        [
            "funnel-dollar"
        ],
        "f662",
        "M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z"
    ]
};
var $5c8203742f0e3062$export$cebe38ad8f0a143d = $5c8203742f0e3062$export$3300e4b4d1d1936f;
var $5c8203742f0e3062$export$41dbdadc07a89b05 = {
    prefix: "fas",
    iconName: "camera-retro",
    icon: [
        512,
        512,
        [
            128247
        ],
        "f083",
        "M220.6 121.2L271.1 96 448 96v96H333.2c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24H64V128H192c9.9 0 19.7-2.3 28.6-6.8zM0 128V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H271.1c-9.9 0-19.7 2.3-28.6 6.8L192 64H160V48c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16l0 16C28.7 64 0 92.7 0 128zM168 304a88 88 0 1 1 176 0 88 88 0 1 1 -176 0z"
    ]
};
var $5c8203742f0e3062$export$a30c52cde32bec7e = {
    prefix: "fas",
    iconName: "circle-arrow-down",
    icon: [
        512,
        512,
        [
            "arrow-circle-down"
        ],
        "f0ab",
        "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM127 281c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l71 71L232 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1 71-71c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 393c-9.4 9.4-24.6 9.4-33.9 0L127 281z"
    ]
};
var $5c8203742f0e3062$export$6cfa36bbb3a057 = $5c8203742f0e3062$export$a30c52cde32bec7e;
var $5c8203742f0e3062$export$d796c05153b1255c = {
    prefix: "fas",
    iconName: "file-import",
    icon: [
        512,
        512,
        [
            "arrow-right-to-file"
        ],
        "f56f",
        "M128 64c0-35.3 28.7-64 64-64H352V128c0 17.7 14.3 32 32 32H512V448c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V336H302.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H128V64zm0 224v48H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H128zM512 128H384V0L512 128z"
    ]
};
var $5c8203742f0e3062$export$32f14beaf6294476 = $5c8203742f0e3062$export$d796c05153b1255c;
var $5c8203742f0e3062$export$38150b61dfd06fff = {
    prefix: "fas",
    iconName: "square-arrow-up-right",
    icon: [
        448,
        512,
        [
            "external-link-square"
        ],
        "f14c",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.1L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V328c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24H160z"
    ]
};
var $5c8203742f0e3062$export$e04d83fed5ebcebf = $5c8203742f0e3062$export$38150b61dfd06fff;
var $5c8203742f0e3062$export$9010ed816a8b9c97 = {
    prefix: "fas",
    iconName: "box-open",
    icon: [
        640,
        512,
        [],
        "f49e",
        "M58.9 42.1c3-6.1 9.6-9.6 16.3-8.7L320 64 564.8 33.4c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1L439.6 217.3c-13.9 4-28.8-1.9-36.2-14.3L320 64 236.6 203c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 170.6c-19.3-5.5-28.8-27.2-19.8-45.1L58.9 42.1zM321.1 128l54.9 91.4c14.9 24.8 44.6 36.6 72.5 28.6L576 211.6v167c0 22-15 41.2-36.4 46.6l-204.1 51c-10.2 2.6-20.9 2.6-31 0l-204.1-51C79 419.7 64 400.5 64 378.5v-167L191.6 248c27.8 8 57.6-3.8 72.5-28.6L318.9 128h2.2z"
    ]
};
var $5c8203742f0e3062$export$7c265716d4399676 = {
    prefix: "fas",
    iconName: "scroll",
    icon: [
        576,
        512,
        [
            128220
        ],
        "f70e",
        "M0 80v48c0 17.7 14.3 32 32 32H48 96V80c0-26.5-21.5-48-48-48S0 53.5 0 80zM112 32c10 13.4 16 30 16 48V384c0 35.3 28.7 64 64 64s64-28.7 64-64v-5.3c0-32.4 26.3-58.7 58.7-58.7H480V128c0-53-43-96-96-96H112zM464 480c61.9 0 112-50.1 112-112c0-8.8-7.2-16-16-16H314.7c-14.7 0-26.7 11.9-26.7 26.7V384c0 53-43 96-96 96H368h96z"
    ]
};
var $5c8203742f0e3062$export$f9a38ef7b046ab51 = {
    prefix: "fas",
    iconName: "spa",
    icon: [
        576,
        512,
        [],
        "f5bb",
        "M183.1 235.3c33.7 20.7 62.9 48.1 85.8 80.5c7 9.9 13.4 20.3 19.1 31c5.7-10.8 12.1-21.1 19.1-31c22.9-32.4 52.1-59.8 85.8-80.5C437.6 207.8 490.1 192 546 192h9.9c11.1 0 20.1 9 20.1 20.1C576 360.1 456.1 480 308.1 480H288 267.9C119.9 480 0 360.1 0 212.1C0 201 9 192 20.1 192H30c55.9 0 108.4 15.8 153.1 43.3zM301.5 37.6c15.7 16.9 61.1 71.8 84.4 164.6c-38 21.6-71.4 50.8-97.9 85.6c-26.5-34.8-59.9-63.9-97.9-85.6c23.2-92.8 68.6-147.7 84.4-164.6C278 33.9 282.9 32 288 32s10 1.9 13.5 5.6z"
    ]
};
var $5c8203742f0e3062$export$db853fbb474326cc = {
    prefix: "fas",
    iconName: "location-pin-lock",
    icon: [
        512,
        512,
        [],
        "e51f",
        "M215.7 499.2c11-13.8 25.1-31.7 40.3-52.3V352c0-23.7 12.9-44.4 32-55.4V272c0-55.6 40.5-101.7 93.6-110.5C367 70 287.7 0 192 0C86 0 0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c17.7 0 32 14.3 32 32v48H368V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $5c8203742f0e3062$export$da79f048408b1722 = {
    prefix: "fas",
    iconName: "pause",
    icon: [
        320,
        512,
        [
            9208
        ],
        "f04c",
        "M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z"
    ]
};
var $5c8203742f0e3062$export$50d11c98c99e3b2d = {
    prefix: "fas",
    iconName: "hill-avalanche",
    icon: [
        576,
        512,
        [],
        "e507",
        "M439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8c34.4-34.4 34.4-90.1 0-124.4c-27.8-27.8-69.5-33.1-102.6-16c-11.8 6.1-16.4 20.6-10.3 32.3s20.6 16.4 32.3 10.3c15.1-7.8 34-5.3 46.6 7.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C401.2 261.3 416 236.4 416 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C216.3 46.6 197.9 32 176 32c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6L439.7 401.9zM480 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80H396.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87z"
    ]
};
var $5c8203742f0e3062$export$ac389bf5cc37feb5 = {
    prefix: "fas",
    iconName: "temperature-empty",
    icon: [
        320,
        512,
        [
            "temperature-0",
            "thermometer-0",
            "thermometer-empty"
        ],
        "f2cb",
        "M112 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C233.8 332.6 240 349.5 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM160 0C98.1 0 48 50.2 48 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C27.2 304.2 16 334.8 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C272 50.2 221.9 0 160 0zm0 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $5c8203742f0e3062$export$e99b7d2ccc282383 = $5c8203742f0e3062$export$ac389bf5cc37feb5;
var $5c8203742f0e3062$export$4c13a186ecce3b80 = $5c8203742f0e3062$export$ac389bf5cc37feb5;
var $5c8203742f0e3062$export$81a2f8298cf523f9 = $5c8203742f0e3062$export$ac389bf5cc37feb5;
var $5c8203742f0e3062$export$d59078f6e80b4a67 = {
    prefix: "fas",
    iconName: "bomb",
    icon: [
        512,
        512,
        [
            128163
        ],
        "f1e2",
        "M459.1 52.4L442.6 6.5C440.7 2.6 436.5 0 432.1 0s-8.5 2.6-10.4 6.5L405.2 52.4l-46 16.8c-4.3 1.6-7.3 5.9-7.2 10.4c0 4.5 3 8.7 7.2 10.2l45.7 16.8 16.8 45.8c1.5 4.4 5.8 7.5 10.4 7.5s8.9-3.1 10.4-7.5l16.5-45.8 45.7-16.8c4.2-1.5 7.2-5.7 7.2-10.2c0-4.6-3-8.9-7.2-10.4L459.1 52.4zm-132.4 53c-12.5-12.5-32.8-12.5-45.3 0l-2.9 2.9C256.5 100.3 232.7 96 208 96C93.1 96 0 189.1 0 304S93.1 512 208 512s208-93.1 208-208c0-24.7-4.3-48.5-12.2-70.5l2.9-2.9c12.5-12.5 12.5-32.8 0-45.3l-80-80zM200 192c-57.4 0-104 46.6-104 104v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-75.1 60.9-136 136-136h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8z"
    ]
};
var $5c8203742f0e3062$export$5f519e9ac15ab8c3 = {
    prefix: "fas",
    iconName: "registered",
    icon: [
        512,
        512,
        [
            174
        ],
        "f25d",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152c0-13.3 10.7-24 24-24h88c44.2 0 80 35.8 80 80c0 28-14.4 52.7-36.3 67l34.1 75.1c5.5 12.1 .1 26.3-11.9 31.8s-26.3 .1-31.8-11.9L268.9 288H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152zm48 88h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H208v64z"
    ]
};
var $5c8203742f0e3062$export$6ea408c7266ed557 = {
    prefix: "fas",
    iconName: "address-card",
    icon: [
        576,
        512,
        [
            62140,
            "contact-card",
            "vcard"
        ],
        "f2bb",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 256h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-32H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$4ac51eb0b298b190 = $5c8203742f0e3062$export$6ea408c7266ed557;
var $5c8203742f0e3062$export$91228257deb1bf18 = $5c8203742f0e3062$export$6ea408c7266ed557;
var $5c8203742f0e3062$export$f4d7840209109993 = {
    prefix: "fas",
    iconName: "scale-unbalanced-flip",
    icon: [
        640,
        512,
        [
            "balance-scale-right"
        ],
        "f516",
        "M117.9 62.4c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l113 37.7C265 15.8 290.7 0 320 0c44.2 0 80 35.8 80 80c0 3-.2 5.9-.5 8.8l122.6 40.9c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2L366.4 145.2c-4.5 3.2-9.3 5.9-14.4 8.2V480c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-21-9.2-37.2-27-44.2-49l-125.9-42zM200.4 288L128 163.8 55.6 288H200.4zM128 384C65.1 384 12.8 350 2 305.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C243.2 350 190.9 384 128 384zm382.8-92.2L438.4 416H583.3L510.8 291.8zm126 141.3C626 478 573.7 512 510.8 512s-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1z"
    ]
};
var $5c8203742f0e3062$export$2238e05f8920005a = $5c8203742f0e3062$export$f4d7840209109993;
var $5c8203742f0e3062$export$34c1e678c32ed646 = {
    prefix: "fas",
    iconName: "subscript",
    icon: [
        512,
        512,
        [],
        "f12c",
        "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32zM480 320c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 361.5 404.3 368 416 368v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V320z"
    ]
};
var $5c8203742f0e3062$export$99749ac517cbef07 = {
    prefix: "fas",
    iconName: "diamond-turn-right",
    icon: [
        512,
        512,
        [
            "directions"
        ],
        "f5eb",
        "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm87.6 137c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v56H224c-35.3 0-64 28.7-64 64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V280c0-8.8 7.2-16 16-16h64v56c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"
    ]
};
var $5c8203742f0e3062$export$6a6973de44442fe5 = $5c8203742f0e3062$export$99749ac517cbef07;
var $5c8203742f0e3062$export$ea2986b45ba5d2cf = {
    prefix: "fas",
    iconName: "burst",
    icon: [
        512,
        512,
        [],
        "e4dc",
        "M37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l112 163.3L16.6 233.2C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l103.1 33.4L66.8 412.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3l100.6-52.9 33.4 103.1c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l33.4-103.1 100.6 52.9c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L392.3 312.2l103.1-33.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8L388.9 198.7l25.7-70.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-70.4 25.7L278.8 16.6C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-32.3 99.6L37.6 4.2z"
    ]
};
var $5c8203742f0e3062$export$6486d62e77b910 = {
    prefix: "fas",
    iconName: "house-laptop",
    icon: [
        640,
        512,
        [
            "laptop-house"
        ],
        "e066",
        "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0l208 192c6.7 6.2 10.3 14.8 10.3 23.5H336c-19.1 0-36.3 8.4-48 21.7V208c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64V416H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM352 304V448H544V304H352zm-48-16c0-17.7 14.3-32 32-32H560c17.7 0 32 14.3 32 32V448h32c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48H544 352 304c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16h32V288z"
    ]
};
var $5c8203742f0e3062$export$efd983de5e4d6ad3 = $5c8203742f0e3062$export$6486d62e77b910;
var $5c8203742f0e3062$export$5352cbdc070ce8d = {
    prefix: "fas",
    iconName: "face-tired",
    icon: [
        512,
        512,
        [
            128555,
            "tired"
        ],
        "f5c8",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.7 328.7c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3h-3.2c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4zm-31.2-182l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $5c8203742f0e3062$export$3d016d62cda18371 = $5c8203742f0e3062$export$5352cbdc070ce8d;
var $5c8203742f0e3062$export$a822dad6e586ee9e = {
    prefix: "fas",
    iconName: "money-bills",
    icon: [
        640,
        512,
        [],
        "e1f3",
        "M96 96V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm64 160c35.3 0 64 28.7 64 64H160V256zM224 96c0 35.3-28.7 64-64 64V96h64zM576 256v64H512c0-35.3 28.7-64 64-64zM512 96h64v64c-35.3 0-64-28.7-64-64zM288 208a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V360c0 66.3 53.7 120 120 120H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"
    ]
};
var $5c8203742f0e3062$export$aa11b8edb09fed14 = {
    prefix: "fas",
    iconName: "smog",
    icon: [
        640,
        512,
        [],
        "f75f",
        "M32 144c0 79.5 64.5 144 144 144H299.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.6 0-62.4 12.2-85.1 32.3C242.1 12.1 210.5 0 176 0C96.5 0 32 64.5 32 144zM616 368H280c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-64 96H440c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-192 0H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24zM224 392c0-13.3-10.7-24-24-24H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H200c13.3 0 24-10.7 24-24z"
    ]
};
var $5c8203742f0e3062$export$e94134641c0e2 = {
    prefix: "fas",
    iconName: "crutch",
    icon: [
        512,
        512,
        [],
        "f7f7",
        "M297.4 9.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0zm-96 144l-34.8 34.8c-12.9 12.9-21.9 29.2-25.8 47.1L116.8 342.9c-1.3 5.9-4.3 11.4-8.6 15.7L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l98.8-98.8c4.3-4.3 9.7-7.3 15.7-8.6l107.6-23.9c17.8-4 34.1-12.9 47.1-25.8l34.7-34.7c0 0 .1-.1 .1-.1s.1-.1 .1-.1l74.6-74.6-45.3-45.3L336 242.7 269.3 176l52.1-52.1L276.1 78.6l-74.7 74.7zM224 221.3L290.7 288l-12.2 12.2c-4.3 4.3-9.7 7.3-15.7 8.6l-76.7 17 17-76.7c1.3-5.9 4.3-11.4 8.6-15.7L224 221.3z"
    ]
};
var $5c8203742f0e3062$export$aa4baaed1c60f58d = {
    prefix: "fas",
    iconName: "font-awesome",
    icon: [
        512,
        512,
        [
            62501,
            62694,
            "font-awesome-flag",
            "font-awesome-logo-full"
        ],
        "f2b4",
        "M91.7 96C106.3 86.8 116 70.5 116 52C116 23.3 92.7 0 64 0S12 23.3 12 52c0 16.7 7.8 31.5 20 41l0 3 0 352 0 64 64 0 0-64 373.6 0c14.6 0 26.4-11.8 26.4-26.4c0-3.7-.8-7.3-2.3-10.7L432 272l61.7-138.9c1.5-3.4 2.3-7 2.3-10.7c0-14.6-11.8-26.4-26.4-26.4L91.7 96z"
    ]
};
var $5c8203742f0e3062$export$102c25fde54d4843 = $5c8203742f0e3062$export$aa4baaed1c60f58d;
var $5c8203742f0e3062$export$6e20d421a2e0f320 = $5c8203742f0e3062$export$aa4baaed1c60f58d;
var $5c8203742f0e3062$export$3507214fff1cc655 = {
    prefix: "fas",
    iconName: "cloud-arrow-up",
    icon: [
        640,
        512,
        [
            62338,
            "cloud-upload",
            "cloud-upload-alt"
        ],
        "f0ee",
        "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"
    ]
};
var $5c8203742f0e3062$export$a48720e6366f5d9a = $5c8203742f0e3062$export$3507214fff1cc655;
var $5c8203742f0e3062$export$e73b3e819b9d14a5 = $5c8203742f0e3062$export$3507214fff1cc655;
var $5c8203742f0e3062$export$5c390baea5db4f77 = {
    prefix: "fas",
    iconName: "palette",
    icon: [
        512,
        512,
        [
            127912
        ],
        "f53f",
        "M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3H344c-26.5 0-48 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$db9f783f15682c4a = {
    prefix: "fas",
    iconName: "arrows-turn-right",
    icon: [
        448,
        512,
        [],
        "e4c0",
        "M297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L338.7 160H128c-35.3 0-64 28.7-64 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V224C0 153.3 57.3 96 128 96H338.7L297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm-96 256c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416H96c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96H242.7l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var $5c8203742f0e3062$export$c8370e53051a657 = {
    prefix: "fas",
    iconName: "vest",
    icon: [
        448,
        512,
        [],
        "e085",
        "M207.1 237.4L151.2 69.7C168.6 79.7 192.6 88 224 88s55.4-8.3 72.8-18.3L226.5 280.6c-1.6 4.9-2.5 10-2.5 15.2V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V270.5c0-9.5-2.8-18.7-8.1-26.6l-47.9-71.8c-5.3-7.9-8.1-17.1-8.1-26.6V128 54.3 48c0-26.5-21.5-48-48-48h-4.5c-.2 0-.4 0-.6 0c-.4 0-.8 0-1.2 0C311 0 295.7 9.7 285.7 18.8C276.4 27.2 257.2 40 224 40s-52.4-12.8-61.7-21.2C152.3 9.7 137 0 118.3 0c-.4 0-.8 0-1.2 0c-.2 0-.4 0-.6 0H112C85.5 0 64 21.5 64 48v6.3V128v17.5c0 9.5-2.8 18.7-8.1 26.6L8.1 243.9C2.8 251.8 0 261.1 0 270.5V464c0 26.5 21.5 48 48 48H176c9.9 0 19-3 26.7-8.1C195.9 492.2 192 478.5 192 464V295.8c0-8.6 1.4-17.1 4.1-25.3l11-33.1zM347.3 356.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-294.6 48l48-48c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"
    ]
};
var $5c8203742f0e3062$export$fd312949b97346ae = {
    prefix: "fas",
    iconName: "ferry",
    icon: [
        576,
        512,
        [],
        "e4ea",
        "M224 0H352c17.7 0 32 14.3 32 32h75.1c20.6 0 31.6 24.3 18.1 39.8L456 96H120L98.8 71.8C85.3 56.3 96.3 32 116.9 32H192c0-17.7 14.3-32 32-32zM96 128H480c17.7 0 32 14.3 32 32V283.5c0 13.3-4.2 26.3-11.9 37.2l-51.4 71.9c-1.9 1.1-3.7 2.2-5.5 3.5c-15.5 10.7-34 18-51 19.9H375.6c-17.1-1.8-35-9-50.8-19.9c-22.1-15.5-51.6-15.5-73.7 0c-14.8 10.2-32.5 18-50.6 19.9H183.9c-17-1.8-35.6-9.2-51-19.9c-1.8-1.3-3.7-2.4-5.6-3.5L75.9 320.7C68.2 309.8 64 296.8 64 283.5V160c0-17.7 14.3-32 32-32zm32 64v96H448V192H128zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.3-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $5c8203742f0e3062$export$cfb044c7d35060bb = {
    prefix: "fas",
    iconName: "arrows-down-to-people",
    icon: [
        640,
        512,
        [],
        "e4b9",
        "M144 0c-13.3 0-24 10.7-24 24V142.1L97 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24zM360 200a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM184 296a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm312 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 345.5V400c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V345.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 468.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5zM415 153l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V142.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
    ]
};
var $5c8203742f0e3062$export$d7b60b8dbd03cfe4 = {
    prefix: "fas",
    iconName: "seedling",
    icon: [
        512,
        512,
        [
            127793,
            "sprout"
        ],
        "f4d8",
        "M512 32c0 113.6-84.6 207.5-194.2 222c-7.1-53.4-30.6-101.6-65.3-139.3C290.8 46.3 364 0 448 0h32c17.7 0 32 14.3 32 32zM0 96C0 78.3 14.3 64 32 64H64c123.7 0 224 100.3 224 224v32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320C100.3 320 0 219.7 0 96z"
    ]
};
var $5c8203742f0e3062$export$9f3035e3a8c62323 = $5c8203742f0e3062$export$d7b60b8dbd03cfe4;
var $5c8203742f0e3062$export$47d93e9001818ee7 = {
    prefix: "fas",
    iconName: "left-right",
    icon: [
        512,
        512,
        [
            8596,
            "arrows-alt-h"
        ],
        "f337",
        "M504.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 56-192 0 0-56c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104C2.8 243 0 249.3 0 256s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-56 192 0 0 56c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z"
    ]
};
var $5c8203742f0e3062$export$7937ea574fb1389 = $5c8203742f0e3062$export$47d93e9001818ee7;
var $5c8203742f0e3062$export$e81e7f3390fe84fe = {
    prefix: "fas",
    iconName: "boxes-packing",
    icon: [
        640,
        512,
        [],
        "e4c7",
        "M256 48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H381.3c1.8-5 2.7-10.4 2.7-16V253.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H256V48zM571.3 347.3c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 310.6V432c0 8.8 7.2 16 16 16s16-7.2 16-16V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0zM0 176c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V176zm352 80V480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256H352zM144 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"
    ]
};
var $5c8203742f0e3062$export$827fbb87bdbe1028 = {
    prefix: "fas",
    iconName: "circle-arrow-left",
    icon: [
        512,
        512,
        [
            "arrow-circle-left"
        ],
        "f0a8",
        "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM231 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L376 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L119 273c-9.4-9.4-9.4-24.6 0-33.9L231 127z"
    ]
};
var $5c8203742f0e3062$export$728262abb9f58d0a = $5c8203742f0e3062$export$827fbb87bdbe1028;
var $5c8203742f0e3062$export$88a8383ecdd39a54 = {
    prefix: "fas",
    iconName: "group-arrows-rotate",
    icon: [
        512,
        512,
        [],
        "e4f6",
        "M201.1 71.9c16.9-5 26.6-22.9 21.5-39.8s-22.9-26.6-39.8-21.5c-21.5 6.4-41.8 15.5-60.6 27C114.3 34 105.4 32 96 32C60.7 32 32 60.7 32 96c0 9.4 2 18.3 5.6 26.3c-11.5 18.7-20.6 39-27 60.6c-5 16.9 4.6 34.8 21.5 39.8s34.8-4.6 39.8-21.5c4.3-14.6 10.4-28.5 17.9-41.4c2 .2 4.1 .3 6.1 .3c35.3 0 64-28.7 64-64c0-2.1-.1-4.1-.3-6.1c12.9-7.5 26.8-13.6 41.4-17.9zm128-61.3c-16.9-5-34.8 4.6-39.8 21.5s4.6 34.8 21.5 39.8c14.6 4.3 28.5 10.4 41.4 17.9c-.2 2-.3 4.1-.3 6.1c0 35.3 28.7 64 64 64c2.1 0 4.1-.1 6.2-.3c7.5 12.9 13.6 26.8 17.9 41.4c5 16.9 22.9 26.6 39.8 21.5s26.6-22.9 21.5-39.8c-6.4-21.5-15.5-41.8-27-60.6c3.6-8 5.6-16.9 5.6-26.3c0-35.3-28.7-64-64-64c-9.4 0-18.3 2-26.3 5.6c-18.7-11.5-39-20.6-60.6-27zM71.9 310.9c-5-16.9-22.9-26.6-39.8-21.5s-26.6 22.9-21.5 39.8c6.4 21.5 15.5 41.8 27 60.6C34 397.7 32 406.6 32 416c0 35.3 28.7 64 64 64c9.4 0 18.3-2 26.3-5.6c18.7 11.5 39 20.6 60.6 27c16.9 5 34.8-4.6 39.8-21.5s-4.6-34.8-21.5-39.8c-14.6-4.3-28.5-10.4-41.4-17.9c.2-2 .3-4.1 .3-6.2c0-35.3-28.7-64-64-64c-2.1 0-4.1 .1-6.2 .3c-7.5-12.9-13.6-26.8-17.9-41.4zm429.4 18.3c5-16.9-4.6-34.8-21.5-39.8s-34.8 4.6-39.8 21.5c-4.3 14.6-10.4 28.5-17.9 41.4c-2-.2-4.1-.3-6.2-.3c-35.3 0-64 28.7-64 64c0 2.1 .1 4.1 .3 6.2c-12.9 7.5-26.8 13.6-41.4 17.9c-16.9 5-26.6 22.9-21.5 39.8s22.9 26.6 39.8 21.5c21.5-6.4 41.8-15.5 60.6-27c8 3.6 16.9 5.6 26.3 5.6c35.3 0 64-28.7 64-64c0-9.4-2-18.3-5.6-26.3c11.5-18.7 20.6-39 27-60.6zM192.8 256.8c0-15.6 5.6-29.9 14.9-41.1L223 231c6.6 6.6 17.8 1.9 17.8-7.4V163.2c0-5.7-4.7-10.4-10.4-10.4H169.9c-9.3 0-13.9 11.2-7.4 17.8l11.2 11.2c-17.9 19.8-28.9 46.2-28.9 75.1c0 43.6 24.9 81.3 61.1 99.8c11.8 6 26.3 1.4 32.3-10.4s1.4-26.3-10.4-32.3c-20.8-10.6-34.9-32.2-34.9-57zm93.1-58.6c20.8 10.6 34.9 32.2 34.9 57c0 15.6-5.6 29.9-14.9 41.1L290.6 281c-6.6-6.6-17.8-1.9-17.8 7.4v60.5c0 5.7 4.7 10.4 10.4 10.4h60.5c9.3 0 13.9-11.2 7.4-17.8l-11.2-11.2c17.9-19.8 28.9-46.2 28.9-75.1c0-43.6-24.9-81.3-61.1-99.8c-11.8-6-26.3-1.4-32.3 10.4s-1.4 26.3 10.4 32.3z"
    ]
};
var $5c8203742f0e3062$export$8b89ca3201039376 = {
    prefix: "fas",
    iconName: "bowl-food",
    icon: [
        512,
        512,
        [],
        "e4c6",
        "M0 192c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0C73 91.5 105.3 64 144 64c15 0 29 4.1 40.9 11.2C198.2 49.6 225.1 32 256 32s57.8 17.6 71.1 43.2C339 68.1 353 64 368 64c38.7 0 71 27.5 78.4 64c.5 0 1.1 0 1.6 0c35.3 0 64 28.7 64 64c0 11.7-3.1 22.6-8.6 32H8.6C3.1 214.6 0 203.7 0 192zm0 91.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4z"
    ]
};
var $5c8203742f0e3062$export$14d66ba7571ae0b9 = {
    prefix: "fas",
    iconName: "candy-cane",
    icon: [
        512,
        512,
        [],
        "f786",
        "M348.8 131.5c3.7-2.3 7.9-3.5 12.2-3.5c12.7 0 23 10.3 23 23v5.6c0 9.9-5.1 19.1-13.5 24.3L30.1 393.7C.1 412.5-9 451.9 9.7 481.9s58.2 39.1 88.2 20.4L438.4 289.5c45.8-28.6 73.6-78.8 73.6-132.8V151C512 67.6 444.4 0 361 0c-28.3 0-56 8-80.1 23L254.1 39.7c-30 18.7-39.1 58.2-20.4 88.2s58.2 39.1 88.2 20.4l26.8-16.8zM298.4 49.8c9.2-5.7 19.1-10.1 29.4-13.1L348 97.5c-5.7 1.4-11.2 3.7-16.3 6.8l-12.6 7.9L298.4 49.8zm88.5 52.7l46.2-46.2c8.5 6.5 16.1 14.1 22.6 22.6l-46.2 46.2c-5.1-9.6-13-17.5-22.6-22.6zm28.9 59.3l61.6 20.5c-2.2 10.5-5.8 20.7-10.5 30.2l-62-20.7c6.2-8.8 10.1-19.1 11-30.1zm-86.1 82.5l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zm-107.2 67l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zM119.3 375.7l60.4 37.7-30.2 18.9L89.1 394.6l30.2-18.9z"
    ]
};
var $5c8203742f0e3062$export$4229d00802c33062 = {
    prefix: "fas",
    iconName: "arrow-down-wide-short",
    icon: [
        576,
        512,
        [
            "sort-amount-asc",
            "sort-amount-down"
        ],
        "f160",
        "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 480c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320z"
    ]
};
var $5c8203742f0e3062$export$ddf8b8dd5983367d = $5c8203742f0e3062$export$4229d00802c33062;
var $5c8203742f0e3062$export$4b2a02d50e417b5f = $5c8203742f0e3062$export$4229d00802c33062;
var $5c8203742f0e3062$export$cdd116afa0309c17 = {
    prefix: "fas",
    iconName: "cloud-bolt",
    icon: [
        512,
        512,
        [
            127785,
            "thunderstorm"
        ],
        "f76c",
        "M0 224c0 53 43 96 96 96h47.2L290 202.5c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L333.7 320H352h64c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm330.1 3.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L177.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H281.9l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"
    ]
};
var $5c8203742f0e3062$export$bbf9e3d433f8f6de = $5c8203742f0e3062$export$cdd116afa0309c17;
var $5c8203742f0e3062$export$ec658c0f040c3e1a = {
    prefix: "fas",
    iconName: "text-slash",
    icon: [
        640,
        512,
        [
            "remove-format"
        ],
        "f87d",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L355.7 253.5 400.2 96H503L497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1C577.6 61.3 554.7 32 523.5 32H376.1h-.3H204.5c-22 0-41.2 15-46.6 36.4l-6.3 25.2L38.8 5.1zm168 131.7c.1-.3 .2-.7 .3-1L217 96H333.7L301.3 210.8l-94.5-74.1zM327.3 353.9L272.9 311 243.3 416H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H309.8l17.6-62.1z"
    ]
};
var $5c8203742f0e3062$export$d91179f327329532 = $5c8203742f0e3062$export$ec658c0f040c3e1a;
var $5c8203742f0e3062$export$6143da800b0e6626 = {
    prefix: "fas",
    iconName: "face-smile-wink",
    icon: [
        512,
        512,
        [
            128521,
            "smile-wink"
        ],
        "f4da",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
    ]
};
var $5c8203742f0e3062$export$f5dbb37f6801ee3f = $5c8203742f0e3062$export$6143da800b0e6626;
var $5c8203742f0e3062$export$f0858dff6e769cf6 = {
    prefix: "fas",
    iconName: "file-word",
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM111 257.1l26.8 89.2 31.6-90.3c3.4-9.6 12.5-16.1 22.7-16.1s19.3 6.4 22.7 16.1l31.6 90.3L273 257.1c3.8-12.7 17.2-19.9 29.9-16.1s19.9 17.2 16.1 29.9l-48 160c-3 10-12 16.9-22.4 17.1s-19.8-6.2-23.2-16.1L192 336.6l-33.3 95.3c-3.4 9.8-12.8 16.3-23.2 16.1s-19.5-7.1-22.4-17.1l-48-160c-3.8-12.7 3.4-26.1 16.1-29.9s26.1 3.4 29.9 16.1z"
    ]
};
var $5c8203742f0e3062$export$c341daeecdea449a = {
    prefix: "fas",
    iconName: "file-powerpoint",
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM136 240h68c42 0 76 34 76 76s-34 76-76 76H160v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V368 264c0-13.3 10.7-24 24-24zm68 104c15.5 0 28-12.5 28-28s-12.5-28-28-28H160v56h44z"
    ]
};
var $5c8203742f0e3062$export$672e2f590b189583 = {
    prefix: "fas",
    iconName: "arrows-left-right",
    icon: [
        512,
        512,
        [
            "arrows-h"
        ],
        "f07e",
        "M406.6 374.6l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224l-293.5 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288l293.5 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
    ]
};
var $5c8203742f0e3062$export$de517642cdb40354 = $5c8203742f0e3062$export$672e2f590b189583;
var $5c8203742f0e3062$export$aa54b16c409e882f = {
    prefix: "fas",
    iconName: "house-lock",
    icon: [
        640,
        512,
        [],
        "e510",
        "M384 480c0 11.7 3.1 22.6 8.6 32H392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L490.7 166.3C447.2 181.7 416 223.2 416 272v24.6c-19.1 11.1-32 31.7-32 55.4V480zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $5c8203742f0e3062$export$542a9676c5286e01 = {
    prefix: "fas",
    iconName: "cloud-arrow-down",
    icon: [
        640,
        512,
        [
            62337,
            "cloud-download",
            "cloud-download-alt"
        ],
        "f0ed",
        "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
    ]
};
var $5c8203742f0e3062$export$b318977f29260464 = $5c8203742f0e3062$export$542a9676c5286e01;
var $5c8203742f0e3062$export$351357a14c41f824 = $5c8203742f0e3062$export$542a9676c5286e01;
var $5c8203742f0e3062$export$f2819bf60df55912 = {
    prefix: "fas",
    iconName: "children",
    icon: [
        640,
        512,
        [],
        "e4e1",
        "M160 0a64 64 0 1 1 0 128A64 64 0 1 1 160 0zM88 480V400H70.2c-10.9 0-18.6-10.7-15.2-21.1l31.1-93.4L57.5 323.3c-10.7 14.1-30.8 16.8-44.8 6.2s-16.8-30.7-6.2-44.8L65.4 207c22.4-29.6 57.5-47 94.6-47s72.2 17.4 94.6 47l58.9 77.7c10.7 14.1 7.9 34.2-6.2 44.8s-34.2 7.9-44.8-6.2l-28.6-37.8L265 378.9c3.5 10.4-4.3 21.1-15.2 21.1H232v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V400H152v80c0 17.7-14.3 32-32 32s-32-14.3-32-32zM480 0a64 64 0 1 1 0 128A64 64 0 1 1 480 0zm-8 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V300.5L395.1 321c-9.4 15-29.2 19.4-44.1 10s-19.4-29.2-10-44.1l51.7-82.1c17.6-27.9 48.3-44.9 81.2-44.9h12.3c33 0 63.7 16.9 81.2 44.9L619.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L552 300.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H472z"
    ]
};
var $5c8203742f0e3062$export$49a36efd66df775 = {
    prefix: "fas",
    iconName: "chalkboard",
    icon: [
        576,
        512,
        [
            "blackboard"
        ],
        "f51b",
        "M96 32C60.7 32 32 60.7 32 96V384H96V96l384 0V384h64V96c0-35.3-28.7-64-64-64H96zM224 384v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H416V384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"
    ]
};
var $5c8203742f0e3062$export$f497e01bf522fd9c = $5c8203742f0e3062$export$49a36efd66df775;
var $5c8203742f0e3062$export$ae7fc6b7f0534be9 = {
    prefix: "fas",
    iconName: "user-large-slash",
    icon: [
        640,
        512,
        [
            "user-alt-slash"
        ],
        "f4fa",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L381.9 274c48.5-23.2 82.1-72.7 82.1-130C464 64.5 399.5 0 320 0C250.4 0 192.4 49.3 178.9 114.9L38.8 5.1zM545.5 512H528L284.3 320h-59C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7H545.3l.3 0z"
    ]
};
var $5c8203742f0e3062$export$46185fab4772ada6 = $5c8203742f0e3062$export$ae7fc6b7f0534be9;
var $5c8203742f0e3062$export$c6c3bd5f7d9b8bf2 = {
    prefix: "fas",
    iconName: "envelope-open",
    icon: [
        512,
        512,
        [
            62135
        ],
        "f2b6",
        "M64 208.1L256 65.9 448 208.1v47.4L289.5 373c-9.7 7.2-21.4 11-33.5 11s-23.8-3.9-33.5-11L64 255.5V208.1zM256 0c-12.1 0-23.8 3.9-33.5 11L25.9 156.7C9.6 168.8 0 187.8 0 208.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V208.1c0-20.3-9.6-39.4-25.9-51.4L289.5 11C279.8 3.9 268.1 0 256 0z"
    ]
};
var $5c8203742f0e3062$export$e99ae494101c5e91 = {
    prefix: "fas",
    iconName: "handshake-simple-slash",
    icon: [
        640,
        512,
        [
            "handshake-alt-slash"
        ],
        "e05f",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM413.6 421.9L41.2 128.5C17.9 131.8 0 151.8 0 176V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6z"
    ]
};
var $5c8203742f0e3062$export$ca302f956ae9f1bf = $5c8203742f0e3062$export$e99ae494101c5e91;
var $5c8203742f0e3062$export$f042d3e458efa721 = {
    prefix: "fas",
    iconName: "mattress-pillow",
    icon: [
        640,
        512,
        [],
        "e525",
        "M256 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H256V64zm32 384H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H288V448zM64 160c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160z"
    ]
};
var $5c8203742f0e3062$export$b731a51acb74b00c = {
    prefix: "fas",
    iconName: "guarani-sign",
    icon: [
        384,
        512,
        [],
        "e19a",
        "M192 0c-17.7 0-32 14.3-32 32V66.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c90.8-15.2 160-94.2 160-189.3c0-17.7-14.3-32-32-32H224V132c22.1 5.7 41.8 17.1 57.6 32.6c12.6 12.4 32.9 12.2 45.3-.4s12.2-32.9-.5-45.3C299 92 263.5 73.3 224 66.7V32c0-17.7-14.3-32-32-32zM160 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124zM224 380V288h92c-11.6 45-47 80.4-92 92z"
    ]
};
var $5c8203742f0e3062$export$2fd091cb98dc8ab8 = {
    prefix: "fas",
    iconName: "arrows-rotate",
    icon: [
        512,
        512,
        [
            128472,
            "refresh",
            "sync"
        ],
        "f021",
        "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H352c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V432c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"
    ]
};
var $5c8203742f0e3062$export$fd4359e93d7b3d14 = $5c8203742f0e3062$export$2fd091cb98dc8ab8;
var $5c8203742f0e3062$export$ff87319002e3dae9 = $5c8203742f0e3062$export$2fd091cb98dc8ab8;
var $5c8203742f0e3062$export$d75fb6743634a0a = {
    prefix: "fas",
    iconName: "fire-extinguisher",
    icon: [
        512,
        512,
        [
            129519
        ],
        "f134",
        "M500.3 7.3C507.7 13.3 512 22.4 512 32v96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32C301.5 124.9 292 115.7 289 104H224v34.8c37.8 18 64 56.5 64 101.2V384H64V240c0-44.7 26.2-83.2 64-101.2V110c-36.2 11.1-66 36.9-82.3 70.5c-5.8 11.9-20.2 16.9-32.1 11.1S-3.3 171.4 2.5 159.5C26.7 109.8 72.7 72.6 128 60.4V32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V56h65c3-11.7 12.5-20.9 24.7-23.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM288 416v32c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V416H288zM176 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $5c8203742f0e3062$export$64dd1b27affb6572 = {
    prefix: "fas",
    iconName: "cruzeiro-sign",
    icon: [
        448,
        512,
        [],
        "e152",
        "M96 256c0-88.4 71.6-160 160-160c41 0 78.3 15.4 106.7 40.7c13.2 11.8 33.4 10.7 45.2-2.5s10.7-33.4-2.5-45.2c-39.6-35.5-92-57-149.3-57C132.3 32 32 132.3 32 256s100.3 224 224 224c57.4 0 109.7-21.6 149.3-57c13.2-11.8 14.3-32 2.5-45.2s-32-14.3-45.2-2.5C334.3 400.6 297 416 256 416V320v-8.7c0-12.8 10.4-23.3 23.3-23.3c4.6 0 9.1 1.4 12.9 3.9l10.1 6.7c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4l-10.1-6.7c-14.3-9.6-31.2-14.7-48.4-14.7c-12.4 0-24.2 2.6-34.9 7.3c-5.5-4.5-12.6-7.3-20.3-7.3c-17.7 0-32 14.3-32 32v55.3V320v82.7C135.5 378 96 321.6 96 256z"
    ]
};
var $5c8203742f0e3062$export$7bf8dfe2e6661a54 = {
    prefix: "fas",
    iconName: "greater-than-equal",
    icon: [
        448,
        512,
        [],
        "f532",
        "M52.1 93.7C35.7 87.1 27.7 68.5 34.3 52.1s25.2-24.4 41.6-17.8l320 128C408 167.1 416 178.9 416 192s-8 24.9-20.1 29.7l-320 128c-16.4 6.6-35-1.4-41.6-17.8s1.4-35 17.8-41.6L297.8 192 52.1 93.7zM416 416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416z"
    ]
};
var $5c8203742f0e3062$export$36e034ccc72554a9 = {
    prefix: "fas",
    iconName: "shield-halved",
    icon: [
        512,
        512,
        [
            "shield-alt"
        ],
        "f3ed",
        "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8V444.8C394 378 431.1 230.1 432 141.4L256 66.8l0 0z"
    ]
};
var $5c8203742f0e3062$export$d6508d18a824f291 = $5c8203742f0e3062$export$36e034ccc72554a9;
var $5c8203742f0e3062$export$7fb8daedae341012 = {
    prefix: "fas",
    iconName: "book-atlas",
    icon: [
        448,
        512,
        [
            "atlas"
        ],
        "f558",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM247.4 283.8c-3.7 3.7-6.2 4.2-7.4 4.2s-3.7-.5-7.4-4.2c-3.8-3.7-8-10-11.8-18.9c-6.2-14.5-10.8-34.3-12.2-56.9h63c-1.5 22.6-6 42.4-12.2 56.9c-3.8 8.9-8 15.2-11.8 18.9zm42.7-9.9c7.3-18.3 12-41.1 13.4-65.9h31.1c-4.7 27.9-21.4 51.7-44.5 65.9zm0-163.8c23.2 14.2 39.9 38 44.5 65.9H303.5c-1.4-24.7-6.1-47.5-13.4-65.9zM368 192a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM145.3 208h31.1c1.4 24.7 6.1 47.5 13.4 65.9c-23.2-14.2-39.9-38-44.5-65.9zm31.1-32H145.3c4.7-27.9 21.4-51.7 44.5-65.9c-7.3 18.3-12 41.1-13.4 65.9zm56.1-75.8c3.7-3.7 6.2-4.2 7.4-4.2s3.7 .5 7.4 4.2c3.8 3.7 8 10 11.8 18.9c6.2 14.5 10.8 34.3 12.2 56.9h-63c1.5-22.6 6-42.4 12.2-56.9c3.8-8.9 8-15.2 11.8-18.9z"
    ]
};
var $5c8203742f0e3062$export$380a9050e42fe5d7 = $5c8203742f0e3062$export$7fb8daedae341012;
var $5c8203742f0e3062$export$37c67e0b3dc6bd1b = {
    prefix: "fas",
    iconName: "virus",
    icon: [
        512,
        512,
        [],
        "e074",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H43.5c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H468.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5V32zM176 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $5c8203742f0e3062$export$74d890536dbd21b7 = {
    prefix: "fas",
    iconName: "envelope-circle-check",
    icon: [
        640,
        512,
        [],
        "e4e8",
        "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0l57.4-43c23.9-59.8 79.7-103.3 146.3-109.8l13.9-10.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176V384c0 35.3 28.7 64 64 64H360.2C335.1 417.6 320 378.5 320 336c0-5.6 .3-11.1 .8-16.6l-26.4 19.8zM640 336a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 353.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $5c8203742f0e3062$export$a137712e11e257dd = {
    prefix: "fas",
    iconName: "layer-group",
    icon: [
        576,
        512,
        [],
        "f5fd",
        "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z"
    ]
};
var $5c8203742f0e3062$export$ab3a06d4b53c0fc0 = {
    prefix: "fas",
    iconName: "arrows-to-dot",
    icon: [
        512,
        512,
        [],
        "e4be",
        "M256 0c17.7 0 32 14.3 32 32V64h32c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8h32V32c0-17.7 14.3-32 32-32zM169.4 393.4l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H288v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H192c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9zM32 224H64V192c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$d56753dd2eb5c323 = {
    prefix: "fas",
    iconName: "archway",
    icon: [
        512,
        512,
        [],
        "f557",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H96h64V352c0-53 43-96 96-96s96 43 96 96V480h64 64c17.7 0 32-14.3 32-32s-14.3-32-32-32V128H32V416z"
    ]
};
var $5c8203742f0e3062$export$5e4b6785eedecc1a = {
    prefix: "fas",
    iconName: "heart-circle-check",
    icon: [
        576,
        512,
        [],
        "e4fd",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $5c8203742f0e3062$export$e824540f5a6a8a57 = {
    prefix: "fas",
    iconName: "house-chimney-crack",
    icon: [
        576,
        512,
        [
            "house-damage"
        ],
        "f6f1",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H326.4L288 448l80.8-67.3c7.8-6.5 7.6-18.6-.4-24.9L250.6 263.2c-14.6-11.5-33.8 7-22.8 22L288 368l-85.5 71.2c-6.1 5-7.5 13.8-3.5 20.5L230.4 512H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24z"
    ]
};
var $5c8203742f0e3062$export$8d7e943005ce0b49 = $5c8203742f0e3062$export$e824540f5a6a8a57;
var $5c8203742f0e3062$export$7a4a0e4caa1e4e6f = {
    prefix: "fas",
    iconName: "file-zipper",
    icon: [
        384,
        512,
        [
            "file-archive"
        ],
        "f1c6",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm-6.3 71.8c3.7-14 16.4-23.8 30.9-23.8h14.8c14.5 0 27.2 9.7 30.9 23.8l23.5 88.2c1.4 5.4 2.1 10.9 2.1 16.4c0 35.2-28.8 63.7-64 63.7s-64-28.5-64-63.7c0-5.5 .7-11.1 2.1-16.4l23.5-88.2zM112 336c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
    ]
};
var $5c8203742f0e3062$export$bf2047a9946b5c3f = $5c8203742f0e3062$export$7a4a0e4caa1e4e6f;
var $5c8203742f0e3062$export$90b4406457aae8cc = {
    prefix: "fas",
    iconName: "square",
    icon: [
        448,
        512,
        [
            9632,
            9723,
            9724,
            61590
        ],
        "f0c8",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
    ]
};
var $5c8203742f0e3062$export$a8a0de30198815a3 = {
    prefix: "fas",
    iconName: "martini-glass-empty",
    icon: [
        512,
        512,
        [
            "glass-martini"
        ],
        "f000",
        "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM256 210.7L109.3 64H402.7L256 210.7z"
    ]
};
var $5c8203742f0e3062$export$e96f280e39af4a91 = $5c8203742f0e3062$export$a8a0de30198815a3;
var $5c8203742f0e3062$export$ce96e32767a7dd51 = {
    prefix: "fas",
    iconName: "couch",
    icon: [
        640,
        512,
        [],
        "f4b8",
        "M64 160C64 89.3 121.3 32 192 32H448c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128V272c0-38.7-27.5-71-64-78.4V160zM544 272c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48V448c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3v48 32h32H512h32V320 272z"
    ]
};
var $5c8203742f0e3062$export$66c557f70914132c = {
    prefix: "fas",
    iconName: "cedi-sign",
    icon: [
        384,
        512,
        [],
        "e0df",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V66.7C101.2 81.9 32 160.9 32 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c30.9-5.2 59.2-17.7 83.2-35.8c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-13.2 9.9-28.3 17.3-44.8 21.6V132c16.4 4.2 31.6 11.6 44.8 21.6c14.1 10.6 34.2 7.8 44.8-6.4s7.8-34.2-6.4-44.8c-24-18-52.4-30.6-83.2-35.8V32zM192 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124z"
    ]
};
var $5c8203742f0e3062$export$16e344bae4d495ed = {
    prefix: "fas",
    iconName: "italic",
    icon: [
        384,
        512,
        [],
        "f033",
        "M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z"
    ]
};
var $5c8203742f0e3062$export$257af4c5fc557105 = {
    prefix: "fas",
    iconName: "table-cells-column-lock",
    icon: [
        640,
        512,
        [],
        "e678",
        "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 56 0 0 8.6c-19.1 11.1-32 31.7-32 55.4l-24 0 0 64 24 0 0 64L64 480c-35.3 0-64-28.7-64-64L0 96zm208 0l0 64 88 0 0-64-88 0zm240 0l-88 0 0 64 88 0 0-64zM208 224l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"
    ]
};
var $5c8203742f0e3062$export$16a3f12c6ae9650 = {
    prefix: "fas",
    iconName: "church",
    icon: [
        640,
        512,
        [
            9962
        ],
        "f51d",
        "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V48H264c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v46.4L183.3 210c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V251.2c0-16.9-8.8-32.5-23.3-41.2L344 142.4V96h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V24zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"
    ]
};
var $5c8203742f0e3062$export$d477129b070e5ac4 = {
    prefix: "fas",
    iconName: "comments-dollar",
    icon: [
        640,
        512,
        [],
        "f653",
        "M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9l0 0 0 0 .2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2 0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM228 72c0-11-9-20-20-20s-20 9-20 20V86c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V280c0 11 9 20 20 20s20-9 20-20V266.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V72z"
    ]
};
var $5c8203742f0e3062$export$a1672d808fbed0bd = {
    prefix: "fas",
    iconName: "democrat",
    icon: [
        640,
        512,
        [],
        "f747",
        "M64 32c0-8.9 3.8-20.9 6.2-27.3C71.2 1.8 74 0 77 0c1.9 0 3.8 .7 5.2 2.1L128 45.7 173.8 2.1C175.2 .7 177.1 0 179 0c3 0 5.8 1.8 6.8 4.7c2.4 6.5 6.2 18.4 6.2 27.3c0 26.5-21.9 42-29.5 46.6l76.2 72.6c6 5.7 13.9 8.8 22.1 8.8H480l32 0c40.3 0 78.2 19 102.4 51.2l19.2 25.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4l-19.2-25.6c-5.3-7-11.8-12.8-19.2-17V320H192l-40.4-94.3c-3.9-9.2-15.3-12.6-23.6-7l-42.1 28c-9.1 6.1-19.7 9.3-30.7 9.3h-2C23.9 256 0 232.1 0 202.7c0-12.1 4.1-23.8 11.7-33.3L87.6 74.6C78.1 67.4 64 53.2 64 32zM448 352h96v64 64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V416H288v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416 352h96H448zM260.9 210.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.3-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5zM368.1 208c-2 0-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5c-.9-1.8-2.8-2.9-4.8-2.9zm116.8 2.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5z"
    ]
};
var $5c8203742f0e3062$export$3481c1aa28972f9b = {
    prefix: "fas",
    iconName: "z",
    icon: [
        384,
        512,
        [
            122
        ],
        "5a",
        "M0 64C0 46.3 14.3 32 32 32H352c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L283.7 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var $5c8203742f0e3062$export$5ebd3cd0630e3ae7 = {
    prefix: "fas",
    iconName: "person-skiing",
    icon: [
        512,
        512,
        [
            9975,
            "skiing"
        ],
        "f7c9",
        "M380.7 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L232.7 361.3l46.2-69.2-75.1-75.1c-14.6-14.6-20.4-33.9-18.4-52.1l108.8 52 39.3 39.3c16.2 16.2 18.7 41.5 6 60.6L289.8 391l128.7 66.8c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 301.3C1.2 295.2-3.4 280.7 2.7 268.9zM118.9 65.6L137 74.2l8.7-17.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-8.5 16.9 54.7 26.2c1.5-.7 3.1-1.4 4.7-2.1l83.4-33.4c34.2-13.7 72.8 4.2 84.5 39.2l17.1 51.2 52.1 26.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-58.1-29c-11.4-5.7-20-15.7-24.1-27.8l-5.8-17.3-27.3 12.1-6.8 3-6.7-3.2L151.5 116.7l-9.2 18.4c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.3-13.4-7.5-21.3s13.4-11.3 21.3-7.5z"
    ]
};
var $5c8203742f0e3062$export$eae1acab6fb96708 = $5c8203742f0e3062$export$5ebd3cd0630e3ae7;
var $5c8203742f0e3062$export$b81a894d5bc3eb17 = {
    prefix: "fas",
    iconName: "road-lock",
    icon: [
        640,
        512,
        [],
        "e567",
        "M288 32H213.2c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2C32 455.5 56.5 480 86.6 480H288V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64h32V352c0-23.7 12.9-44.4 32-55.4V272c0-58.3 44.6-106.2 101.5-111.5L487.1 74.6C478 49.1 453.9 32 426.8 32H352V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zm176 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $5c8203742f0e3062$export$406fe05808a3753e = {
    prefix: "fas",
    iconName: "a",
    icon: [
        384,
        512,
        [
            97
        ],
        "41",
        "M221.5 51.7C216.6 39.8 204.9 32 192 32s-24.6 7.8-29.5 19.7l-120 288-40 96c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L93.3 384H290.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-40-96-120-288zM264 320H120l72-172.8L264 320z"
    ]
};
var $5c8203742f0e3062$export$4520eb1840c4e110 = {
    prefix: "fas",
    iconName: "temperature-arrow-down",
    icon: [
        576,
        512,
        [
            "temperature-down"
        ],
        "e03f",
        "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM176 0C114.1 0 64 50.1 64 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zm336-64H480V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352H384c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8z"
    ]
};
var $5c8203742f0e3062$export$f0b2aca3866f00f6 = $5c8203742f0e3062$export$4520eb1840c4e110;
var $5c8203742f0e3062$export$2a9d3e120019c92d = {
    prefix: "fas",
    iconName: "feather-pointed",
    icon: [
        512,
        512,
        [
            "feather-alt"
        ],
        "f56b",
        "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.8-74.8c7.4 4.6 15.3 8.2 23.8 10.5C200.3 452.8 270 454.5 338 409.4c12.2-8.1 5.8-25.4-8.8-25.4l-16.1 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l97.7-29.3c3.4-1 6.4-3.1 8.4-6.1c4.4-6.4 8.6-12.9 12.6-19.6c6.2-10.3-1.5-23-13.5-23l-38.6 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l80.9-24.3c4.6-1.4 8.4-4.8 10.2-9.3C494.5 163 507.8 86.1 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4c2.1 7.9 12 9.6 17.8 3.8L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"
    ]
};
var $5c8203742f0e3062$export$68cf766c786bcd78 = $5c8203742f0e3062$export$2a9d3e120019c92d;
var $5c8203742f0e3062$export$bcb419f1cd5beac3 = {
    prefix: "fas",
    iconName: "p",
    icon: [
        320,
        512,
        [
            112
        ],
        "50",
        "M0 96C0 60.7 28.7 32 64 32h96c88.4 0 160 71.6 160 160s-71.6 160-160 160H64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V320 96zM64 288h96c53 0 96-43 96-96s-43-96-96-96H64V288z"
    ]
};
var $5c8203742f0e3062$export$bab8f3647c394f48 = {
    prefix: "fas",
    iconName: "snowflake",
    icon: [
        448,
        512,
        [
            10052,
            10054
        ],
        "f2dc",
        "M224 0c17.7 0 32 14.3 32 32V62.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L287.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L256 311.7v70.3l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V449.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49V311.7l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L160.5 256 99.6 220.5 31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8L15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L192 200.3V129.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$d91b374112d4f8c1 = {
    prefix: "fas",
    iconName: "newspaper",
    icon: [
        512,
        512,
        [
            128240
        ],
        "f1ea",
        "M96 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H80c-44.2 0-80-35.8-80-80V128c0-17.7 14.3-32 32-32s32 14.3 32 32V400c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 24v80c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
    ]
};
var $5c8203742f0e3062$export$d0ccaddca9e06d1e = {
    prefix: "fas",
    iconName: "rectangle-ad",
    icon: [
        576,
        512,
        [
            "ad"
        ],
        "f641",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM229.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L253.2 328H162.8l-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM208 237.7L186.8 280h42.3L208 237.7zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24-43.9V184c0-13.3 10.7-24 24-24s24 10.7 24 24v96 48c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-9.4 4.5-19.9 7-31 7c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z"
    ]
};
var $5c8203742f0e3062$export$7af266c3465b1ff2 = $5c8203742f0e3062$export$d0ccaddca9e06d1e;
var $5c8203742f0e3062$export$2f1e22e081a1ad05 = {
    prefix: "fas",
    iconName: "circle-arrow-right",
    icon: [
        512,
        512,
        [
            "arrow-circle-right"
        ],
        "f0a9",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
    ]
};
var $5c8203742f0e3062$export$7d3d828103aa3be7 = $5c8203742f0e3062$export$2f1e22e081a1ad05;
var $5c8203742f0e3062$export$fb5ab619c34ea613 = {
    prefix: "fas",
    iconName: "filter-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e17b",
        "M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
var $5c8203742f0e3062$export$4982360d3b844c19 = {
    prefix: "fas",
    iconName: "locust",
    icon: [
        576,
        512,
        [],
        "e520",
        "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c98.7 0 180.6 71.4 197 165.4c-9-3.5-18.8-5.4-29-5.4H431.8l-41.8-97.5c-3.4-7.9-10.8-13.4-19.3-14.4s-17 2.7-22.1 9.6l-40.9 55.5-21.7-50.7c-3.3-7.8-10.5-13.2-18.9-14.3s-16.7 2.3-22 8.9l-240 304c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l79.4-100.5 43 16.4-40.5 55c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1L215.1 400h74.5l-29.3 42.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1L348 400h80.4l38.8 67.9c6.6 11.5 21.2 15.5 32.7 8.9s15.5-21.2 8.9-32.7L483.6 400H496c44.1 0 79.8-35.7 80-79.7c0-.1 0-.2 0-.3V280C576 143 465 32 328 32H312zm50.5 168l17.1 40H333l29.5-40zm-87.7 38.1l-1.4 1.9H225.1l32.7-41.5 16.9 39.5zM88.8 240C57.4 240 32 265.4 32 296.8c0 15.5 6.3 30 16.9 40.4L126.7 240H88.8zM496 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $5c8203742f0e3062$export$4941c5969d5399b = {
    prefix: "fas",
    iconName: "sort",
    icon: [
        320,
        512,
        [
            "unsorted"
        ],
        "f0dc",
        "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"
    ]
};
var $5c8203742f0e3062$export$418597748f0fe52d = $5c8203742f0e3062$export$4941c5969d5399b;
var $5c8203742f0e3062$export$3db8f67cd0fc963b = {
    prefix: "fas",
    iconName: "list-ol",
    icon: [
        512,
        512,
        [
            "list-1-2",
            "list-numeric"
        ],
        "f0cb",
        "M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$7e3d894cd55296b = $5c8203742f0e3062$export$3db8f67cd0fc963b;
var $5c8203742f0e3062$export$cf51408faadac277 = $5c8203742f0e3062$export$3db8f67cd0fc963b;
var $5c8203742f0e3062$export$523180e731928397 = {
    prefix: "fas",
    iconName: "person-dress-burst",
    icon: [
        640,
        512,
        [],
        "e544",
        "M528 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM390.2 384H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h17.8c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3H474.2c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"
    ]
};
var $5c8203742f0e3062$export$eeb59dd1825c6a65 = {
    prefix: "fas",
    iconName: "money-check-dollar",
    icon: [
        576,
        512,
        [
            "money-check-alt"
        ],
        "f53d",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM272 192H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 304c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zM164 152v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V360c0 11-9 20-20 20s-20-9-20-20V345.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V152c0-11 9-20 20-20s20 9 20 20z"
    ]
};
var $5c8203742f0e3062$export$8c6ccc9745897cb2 = $5c8203742f0e3062$export$eeb59dd1825c6a65;
var $5c8203742f0e3062$export$567d5631a7b0599f = {
    prefix: "fas",
    iconName: "vector-square",
    icon: [
        448,
        512,
        [],
        "f5cb",
        "M368 80h32v32H368V80zM352 32c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32V160c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H352zM96 160c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32V160zM48 400H80v32H48V400zm320 32V400h32v32H368zM48 112V80H80v32H48z"
    ]
};
var $5c8203742f0e3062$export$d78e8b0681279167 = {
    prefix: "fas",
    iconName: "bread-slice",
    icon: [
        512,
        512,
        [],
        "f7ec",
        "M256 32C192 32 0 64 0 192c0 35.3 28.7 64 64 64V432c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32z"
    ]
};
var $5c8203742f0e3062$export$8a7bee49fdf8c954 = {
    prefix: "fas",
    iconName: "language",
    icon: [
        640,
        512,
        [],
        "f1ab",
        "M0 128C0 92.7 28.7 64 64 64H256h48 16H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H320 304 256 64c-35.3 0-64-28.7-64-64V128zm320 0V384H576V128H320zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276H141l19-42.8zM448 164c11 0 20 9 20 20v4h44 16c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45H448 376c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20z"
    ]
};
var $5c8203742f0e3062$export$611ae61f02de0aa = {
    prefix: "fas",
    iconName: "face-kiss-wink-heart",
    icon: [
        512,
        512,
        [
            128536,
            "kiss-wink-heart"
        ],
        "f598",
        "M498 339.7c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-22.9-89.3c-10-39 11.8-80.9 51.8-92.1c37.2-10.4 73.8 10.1 87.5 44c12.7-1.6 25.1 .4 36.2 5zM296 332c0 6.9-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C258.7 443.1 241.4 448 224 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.6-.4-.3-.2-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm194.8 57.6c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"
    ]
};
var $5c8203742f0e3062$export$ebba617701dfb917 = $5c8203742f0e3062$export$611ae61f02de0aa;
var $5c8203742f0e3062$export$f253a38d7142e29f = {
    prefix: "fas",
    iconName: "filter",
    icon: [
        512,
        512,
        [],
        "f0b0",
        "M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"
    ]
};
var $5c8203742f0e3062$export$d96973f90e8f6e47 = {
    prefix: "fas",
    iconName: "question",
    icon: [
        320,
        512,
        [
            10067,
            10068,
            61736
        ],
        "3f",
        "M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74V320c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $5c8203742f0e3062$export$d0de575ac166712b = {
    prefix: "fas",
    iconName: "file-signature",
    icon: [
        576,
        512,
        [],
        "f573",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V428.7c-2.7 1.1-5.4 2-8.2 2.7l-60.1 15c-3 .7-6 1.2-9 1.4c-.9 .1-1.8 .2-2.7 .2H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 381l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.8 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8h8.9c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7L384 203.6V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM549.8 139.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM311.9 321c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 262.7l-71-71L311.9 321z"
    ]
};
var $5c8203742f0e3062$export$cd7b22f4e6e3834b = {
    prefix: "fas",
    iconName: "up-down-left-right",
    icon: [
        512,
        512,
        [
            "arrows-alt"
        ],
        "f0b2",
        "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v96H128V192c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V288h96v96H192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H288V288h96v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H288V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
    ]
};
var $5c8203742f0e3062$export$3cdabfff52cfc73a = $5c8203742f0e3062$export$cd7b22f4e6e3834b;
var $5c8203742f0e3062$export$1ddbaebce033a0d = {
    prefix: "fas",
    iconName: "house-chimney-user",
    icon: [
        576,
        512,
        [],
        "e065",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM288 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 400c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16z"
    ]
};
var $5c8203742f0e3062$export$97e5ef3e80a0fbef = {
    prefix: "fas",
    iconName: "hand-holding-heart",
    icon: [
        576,
        512,
        [],
        "f4be",
        "M163.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $5c8203742f0e3062$export$7ee0dbd1e92e2859 = {
    prefix: "fas",
    iconName: "puzzle-piece",
    icon: [
        512,
        512,
        [
            129513
        ],
        "f12e",
        "M192 104.8c0-9.2-5.8-17.3-13.2-22.8C167.2 73.3 160 61.3 160 48c0-26.5 28.7-48 64-48s64 21.5 64 48c0 13.3-7.2 25.3-18.8 34c-7.4 5.5-13.2 13.6-13.2 22.8c0 12.8 10.4 23.2 23.2 23.2H336c26.5 0 48 21.5 48 48v56.8c0 12.8 10.4 23.2 23.2 23.2c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2c-12.8 0-23.2 10.4-23.2 23.2V464c0 26.5-21.5 48-48 48H279.2c-12.8 0-23.2-10.4-23.2-23.2c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8c0 12.8-10.4 23.2-23.2 23.2H48c-26.5 0-48-21.5-48-48V343.2C0 330.4 10.4 320 23.2 320c9.2 0 17.3 5.8 22.8 13.2C54.7 344.8 66.7 352 80 352c26.5 0 48-28.7 48-64s-21.5-64-48-64c-13.3 0-25.3 7.2-34 18.8C40.5 250.2 32.4 256 23.2 256C10.4 256 0 245.6 0 232.8V176c0-26.5 21.5-48 48-48H168.8c12.8 0 23.2-10.4 23.2-23.2z"
    ]
};
var $5c8203742f0e3062$export$be069f641c85d0b3 = {
    prefix: "fas",
    iconName: "money-check",
    icon: [
        576,
        512,
        [],
        "f53c",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm48 160H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 336c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zM376 160h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24z"
    ]
};
var $5c8203742f0e3062$export$3e4892d8bf919edd = {
    prefix: "fas",
    iconName: "star-half-stroke",
    icon: [
        576,
        512,
        [
            "star-half-alt"
        ],
        "f5c0",
        "M288 376.4l.1-.1 26.4 14.1 85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6L288.1 86.9l-.1 .3V376.4zm175.1 98.3c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L288.1 439.8 159.8 508.3C149 514 135.9 513.1 126 506s-14.9-19.3-12.9-31.3L137.8 329 33.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L195 150.3 259.4 18c5.4-11 16.5-18 28.8-18s23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L438.5 329l24.6 145.7z"
    ]
};
var $5c8203742f0e3062$export$c13575f42532efb3 = $5c8203742f0e3062$export$3e4892d8bf919edd;
var $5c8203742f0e3062$export$eba095993e51cc97 = {
    prefix: "fas",
    iconName: "code",
    icon: [
        640,
        512,
        [],
        "f121",
        "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"
    ]
};
var $5c8203742f0e3062$export$f1304dd34ea2afbd = {
    prefix: "fas",
    iconName: "whiskey-glass",
    icon: [
        512,
        512,
        [
            129347,
            "glass-whiskey"
        ],
        "f7a0",
        "M32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zM87.7 224L69 96H443L424.3 224H87.7z"
    ]
};
var $5c8203742f0e3062$export$fdec0f5f1a169419 = $5c8203742f0e3062$export$f1304dd34ea2afbd;
var $5c8203742f0e3062$export$c49f030b19083ebe = {
    prefix: "fas",
    iconName: "building-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e4d3",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$6a1e4cdbb8ca10c5 = {
    prefix: "fas",
    iconName: "magnifying-glass-chart",
    icon: [
        512,
        512,
        [],
        "e522",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zm-312 8v64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96V280c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $5c8203742f0e3062$export$5ad84e891223f2c3 = {
    prefix: "fas",
    iconName: "arrow-up-right-from-square",
    icon: [
        512,
        512,
        [
            "external-link"
        ],
        "f08e",
        "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    ]
};
var $5c8203742f0e3062$export$f4c613289034e5ef = $5c8203742f0e3062$export$5ad84e891223f2c3;
var $5c8203742f0e3062$export$b1f00c433aabac05 = {
    prefix: "fas",
    iconName: "cubes-stacked",
    icon: [
        448,
        512,
        [],
        "e4e6",
        "M192 64v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32zM82.7 207c-15.3 8.8-20.5 28.4-11.7 43.7l32 55.4c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-32-55.4c-8.8-15.3-28.4-20.5-43.7-11.7L82.7 207zM288 192c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H288zm64 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H352zM160 384v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zM32 352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H32z"
    ]
};
var $5c8203742f0e3062$export$51790ddd26e431bc = {
    prefix: "fas",
    iconName: "won-sign",
    icon: [
        512,
        512,
        [
            8361,
            "krw",
            "won"
        ],
        "f159",
        "M62.4 53.9C56.8 37.1 38.6 28.1 21.9 33.6S-3.9 57.4 1.6 74.1L51.6 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H72.9l56.7 170.1c4.5 13.5 17.4 22.4 31.6 21.9s26.4-10.4 29.8-24.2L233 288h46L321 455.8c3.4 13.8 15.6 23.7 29.8 24.2s27.1-8.4 31.6-21.9L439.1 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l50-149.9c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2L392.9 224H329L287 56.2C283.5 42 270.7 32 256 32s-27.5 10-31 24.2L183 224h-64L62.4 53.9zm78 234.1H167l-11.4 45.6L140.4 288zM249 224l7-28.1 7 28.1H249zm96 64h26.6l-15.2 45.6L345 288z"
    ]
};
var $5c8203742f0e3062$export$2f65e07a45b95b50 = $5c8203742f0e3062$export$51790ddd26e431bc;
var $5c8203742f0e3062$export$5a1fd3ed9564d7fa = $5c8203742f0e3062$export$51790ddd26e431bc;
var $5c8203742f0e3062$export$1df4e031b8ee4f84 = {
    prefix: "fas",
    iconName: "virus-covid",
    icon: [
        512,
        512,
        [],
        "e4a8",
        "M192 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V81.6c30.7 4.2 58.8 16.3 82.3 34.1L386.1 92 374.8 80.6c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L420 125.9l-23.8 23.8c17.9 23.5 29.9 51.7 34.1 82.3H464V216c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H430.4c-4.2 30.7-16.3 58.8-34.1 82.3L420 386.1l11.3-11.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L386.1 420l-23.8-23.8c-23.5 17.9-51.7 29.9-82.3 34.1V464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V430.4c-30.7-4.2-58.8-16.3-82.3-34.1L125.9 420l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L46.7 408.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L92 386.1l23.8-23.8C97.9 338.8 85.8 310.7 81.6 280H48v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24s24 10.7 24 24v16H81.6c4.2-30.7 16.3-58.8 34.1-82.3L92 125.9 80.6 137.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L125.9 92l23.8 23.8c23.5-17.9 51.7-29.9 82.3-34.1V48H216c-13.3 0-24-10.7-24-24zm48 200a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm64 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $5c8203742f0e3062$export$299c200ad3db97b4 = {
    prefix: "fas",
    iconName: "austral-sign",
    icon: [
        448,
        512,
        [],
        "e0a9",
        "M253.5 51.7C248.6 39.8 236.9 32 224 32s-24.6 7.8-29.5 19.7L122.7 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96L82.7 320H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H56L34.5 435.7c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L125.3 384H322.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8L392 384h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H365.3L352 288h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H325.3L253.5 51.7zM256 224H192l32-76.8L256 224zm-90.7 64H282.7L296 320H152l13.3-32z"
    ]
};
var $5c8203742f0e3062$export$a2f384a559654618 = {
    prefix: "fas",
    iconName: "f",
    icon: [
        320,
        512,
        [
            102
        ],
        "46",
        "M64 32C28.7 32 0 60.7 0 96V256 448c0 17.7 14.3 32 32 32s32-14.3 32-32V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"
    ]
};
var $5c8203742f0e3062$export$7c497bae2754a087 = {
    prefix: "fas",
    iconName: "leaf",
    icon: [
        512,
        512,
        [],
        "f06c",
        "M272 96c-78.6 0-145.1 51.5-167.7 122.5c33.6-17 71.5-26.5 111.7-26.5h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 216s0 0 0 0c-16.6 0-32.7 1.9-48.3 5.4c-25.9 5.9-49.9 16.4-71.4 30.7c0 0 0 0 0 0C38.3 298.8 0 364.9 0 440v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-42.6-7.5-83.1-21.1-119.6c-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96L272 96z"
    ]
};
var $5c8203742f0e3062$export$f224567a4851a5e9 = {
    prefix: "fas",
    iconName: "road",
    icon: [
        576,
        512,
        [
            128739
        ],
        "f018",
        "M256 32H181.2c-27.1 0-51.3 17.1-60.3 42.6L3.1 407.2C1.1 413 0 419.2 0 425.4C0 455.5 24.5 480 54.6 480H256V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64H521.4c30.2 0 54.6-24.5 54.6-54.6c0-6.2-1.1-12.4-3.1-18.2L455.1 74.6C446 49.1 421.9 32 394.8 32H320V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $5c8203742f0e3062$export$9958afcdfece1b58 = {
    prefix: "fas",
    iconName: "taxi",
    icon: [
        512,
        512,
        [
            128662,
            "cab"
        ],
        "f1ba",
        "M192 0c-17.7 0-32 14.3-32 32V64c0 .1 0 .1 0 .2c-38.6 2.2-72.3 27.3-85.2 64.1L39.6 228.8C16.4 238.4 0 261.3 0 288V432v48c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V432H416v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V432 288c0-26.7-16.4-49.6-39.6-59.2L437.2 128.3c-12.9-36.8-46.6-62-85.2-64.1c0-.1 0-.1 0-.2V32c0-17.7-14.3-32-32-32H192zM165.4 128H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 224H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zM96 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $5c8203742f0e3062$export$7bf12d9380f0971b = $5c8203742f0e3062$export$9958afcdfece1b58;
var $5c8203742f0e3062$export$55686b1eb7d00307 = {
    prefix: "fas",
    iconName: "person-circle-plus",
    icon: [
        576,
        512,
        [],
        "e541",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"
    ]
};
var $5c8203742f0e3062$export$1de7b9cf7d1b153b = {
    prefix: "fas",
    iconName: "chart-pie",
    icon: [
        576,
        512,
        [
            "pie-chart"
        ],
        "f200",
        "M304 240V16.6c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16H304zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4V288L412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288H558.4z"
    ]
};
var $5c8203742f0e3062$export$7877286cd337de81 = $5c8203742f0e3062$export$1de7b9cf7d1b153b;
var $5c8203742f0e3062$export$b16dcd08f3da1ba2 = {
    prefix: "fas",
    iconName: "bolt-lightning",
    icon: [
        384,
        512,
        [],
        "e0b7",
        "M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $5c8203742f0e3062$export$2bad98c38bea5994 = {
    prefix: "fas",
    iconName: "sack-xmark",
    icon: [
        512,
        512,
        [],
        "e56a",
        "M192 96H320l47.4-71.1C374.5 14.2 366.9 0 354.1 0H157.9c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32H192c-3.8 2.5-8.1 5.3-13 8.4l0 0 0 0C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96H416c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4zM289.9 336l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47z"
    ]
};
var $5c8203742f0e3062$export$77cb1a465c4fe84 = {
    prefix: "fas",
    iconName: "file-excel",
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"
    ]
};
var $5c8203742f0e3062$export$70fde3f3fdaa6a6a = {
    prefix: "fas",
    iconName: "file-contract",
    icon: [
        384,
        512,
        [],
        "f56c",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349l-9.8 32.8z"
    ]
};
var $5c8203742f0e3062$export$e7af4f0123222b6f = {
    prefix: "fas",
    iconName: "fish-fins",
    icon: [
        576,
        512,
        [],
        "e4f2",
        "M275.2 38.4c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5c-15.3 11.5-29 23.9-40.7 36.3L48.1 132.4c-12.5-7.3-28.4-5.3-38.6 4.9S-3 163.3 4.2 175.9L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.6 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3c15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8c39.2-29.4 67.2-64.7 81.6-89.5c5.8-9.9 5.8-22.2 0-32.1c-14.4-24.8-42.5-60.1-81.6-89.5c-35.8-26.8-82.3-49.8-137.2-53.8L275.2 38.4zM384 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $5c8203742f0e3062$export$592422b29ab0a914 = {
    prefix: "fas",
    iconName: "building-flag",
    icon: [
        640,
        512,
        [],
        "e4d5",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM448 0c-17.7 0-32 14.3-32 32V512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H480c0-17.7-14.3-32-32-32z"
    ]
};
var $5c8203742f0e3062$export$3de52eeb00462407 = {
    prefix: "fas",
    iconName: "face-grin-beam",
    icon: [
        512,
        512,
        [
            128516,
            "grin-beam"
        ],
        "f582",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-170.5-84l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $5c8203742f0e3062$export$734da5249381ec7e = $5c8203742f0e3062$export$3de52eeb00462407;
var $5c8203742f0e3062$export$887f6345573abcac = {
    prefix: "fas",
    iconName: "object-ungroup",
    icon: [
        640,
        512,
        [],
        "f248",
        "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H328.6C339.6 12.9 360.3 0 384 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V232.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4V232.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4H119.4zm192 384c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V352h64v40.6c9.7 5.6 17.8 13.7 23.4 23.4H520.6c5.6-9.7 13.7-17.8 23.4-23.4V279.4c-9.7-5.6-17.8-13.7-23.4-23.4h-46c-5.4-15.4-14.6-28.9-26.5-39.6V192h72.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H311.4z"
    ]
};
var $5c8203742f0e3062$export$bb45b6b87d1adf27 = {
    prefix: "fas",
    iconName: "poop",
    icon: [
        512,
        512,
        [],
        "f619",
        "M254.4 6.6c3.5-4.3 9-6.5 14.5-5.7C315.8 7.2 352 47.4 352 96c0 11.2-1.9 22-5.5 32H352c35.3 0 64 28.7 64 64c0 19.1-8.4 36.3-21.7 48H408c39.8 0 72 32.2 72 72c0 23.2-11 43.8-28 57c34.1 5.7 60 35.3 60 71c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72c0-35.7 25.9-65.3 60-71c-17-13.2-28-33.8-28-57c0-39.8 32.2-72 72-72h13.7C104.4 228.3 96 211.1 96 192c0-35.3 28.7-64 64-64h16.2c44.1-.1 79.8-35.9 79.8-80c0-9.2-1.5-17.9-4.3-26.1c-1.8-5.2-.8-11.1 2.8-15.4z"
    ]
};
var $5c8203742f0e3062$export$c0b7617de95c0c05 = {
    prefix: "fas",
    iconName: "location-pin",
    icon: [
        384,
        512,
        [
            "map-marker"
        ],
        "f041",
        "M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z"
    ]
};
var $5c8203742f0e3062$export$10d360e4f1a554dd = $5c8203742f0e3062$export$c0b7617de95c0c05;
var $5c8203742f0e3062$export$ab1408bfbe914cc9 = {
    prefix: "fas",
    iconName: "kaaba",
    icon: [
        576,
        512,
        [
            128331
        ],
        "f66b",
        "M60 120l228 71.2L516 120 288 48.8 60 120zM278.5 1.5c6.2-1.9 12.9-1.9 19.1 0l256 80C566.9 85.6 576 98 576 112v16 0 21.2L292.8 237.7c-3.1 1-6.4 1-9.5 0L0 149.2V128 112C0 98 9.1 85.6 22.5 81.5l256-80zm23.9 266.8L576 182.8v46.5l-52.8 16.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5L576 262.8V400c0 14-9.1 26.4-22.5 30.5l-256 80c-6.2 1.9-12.9 1.9-19.1 0l-256-80C9.1 426.4 0 414 0 400V262.8l43.2 13.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L0 229.2V182.8l273.7 85.5c9.3 2.9 19.3 2.9 28.6 0zm-185.5-2.6c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"
    ]
};
var $5c8203742f0e3062$export$c8cc083ccc72b17 = {
    prefix: "fas",
    iconName: "toilet-paper",
    icon: [
        640,
        512,
        [
            129531
        ],
        "f71e",
        "M444.2 0C397.2 49.6 384 126.5 384 192c0 158.8-27.3 247-42.7 283.9c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3 .4-32.2c9.8-17.7 15.4-38.2 20.5-57.7C52.3 362.8 64 293.5 64 192C64 86 107 0 160 0H444.2zM512 384c-53 0-96-86-96-192S459 0 512 0s96 86 96 192s-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zM144 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $5c8203742f0e3062$export$aacaf42fba617981 = {
    prefix: "fas",
    iconName: "helmet-safety",
    icon: [
        576,
        512,
        [
            "hard-hat",
            "hat-hard"
        ],
        "f807",
        "M256 32c-17.7 0-32 14.3-32 32v2.3 99.6c0 5.6-4.5 10.1-10.1 10.1c-3.6 0-7-1.9-8.8-5.1L157.1 87C83 123.5 32 199.8 32 288v64H544l0-66.4c-.9-87.2-51.7-162.4-125.1-198.6l-48 83.9c-1.8 3.2-5.2 5.1-8.8 5.1c-5.6 0-10.1-4.5-10.1-10.1V66.3 64c0-17.7-14.3-32-32-32H256zM16.6 384C7.4 384 0 391.4 0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9c0-9.2-7.4-16.6-16.6-16.6H16.6z"
    ]
};
var $5c8203742f0e3062$export$7b72177558a98b6f = $5c8203742f0e3062$export$aacaf42fba617981;
var $5c8203742f0e3062$export$c0e235dbf1644a2f = $5c8203742f0e3062$export$aacaf42fba617981;
var $5c8203742f0e3062$export$8484041d5b209494 = {
    prefix: "fas",
    iconName: "eject",
    icon: [
        448,
        512,
        [
            9167
        ],
        "f052",
        "M224 32c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 320 400 320H48c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192C197.7 37.6 210.5 32 224 32zM0 432c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48s-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z"
    ]
};
var $5c8203742f0e3062$export$1fec48c8bdd69c1d = {
    prefix: "fas",
    iconName: "circle-right",
    icon: [
        512,
        512,
        [
            61838,
            "arrow-alt-circle-right"
        ],
        "f35a",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 135.1l99.9 107.1c3.5 3.8 5.5 8.7 5.5 13.8s-2 10.1-5.5 13.8L294.6 376.9c-4.2 4.5-10.1 7.1-16.3 7.1C266 384 256 374 256 361.7l0-57.7-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-57.7c0-12.3 10-22.3 22.3-22.3c6.2 0 12.1 2.6 16.3 7.1z"
    ]
};
var $5c8203742f0e3062$export$88962ffdad8b856d = $5c8203742f0e3062$export$1fec48c8bdd69c1d;
var $5c8203742f0e3062$export$9cbf8612c6cadc74 = {
    prefix: "fas",
    iconName: "plane-circle-check",
    icon: [
        640,
        512,
        [],
        "e555",
        "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $5c8203742f0e3062$export$a6d72a9a068392b5 = {
    prefix: "fas",
    iconName: "face-rolling-eyes",
    icon: [
        512,
        512,
        [
            128580,
            "meh-rolling-eyes"
        ],
        "f5a5",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 368H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zm32-144c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C208.5 175.6 224 198 224 224zm128 64c-35.3 0-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C400.5 175.6 416 198 416 224c0 35.3-28.7 64-64 64z"
    ]
};
var $5c8203742f0e3062$export$fdc62a1bea767cc2 = $5c8203742f0e3062$export$a6d72a9a068392b5;
var $5c8203742f0e3062$export$40cdac24aa94a57a = {
    prefix: "fas",
    iconName: "object-group",
    icon: [
        576,
        512,
        [],
        "f247",
        "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H456.6C467.6 12.9 488.3 0 512 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM456.6 96H119.4c-5.6 9.7-13.7 17.8-23.4 23.4V392.6c9.7 5.6 17.8 13.7 23.4 23.4H456.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4zM128 160c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160zM256 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V320z"
    ]
};
var $5c8203742f0e3062$export$e022f62a119e1d93 = {
    prefix: "fas",
    iconName: "chart-line",
    icon: [
        512,
        512,
        [
            "line-chart"
        ],
        "f201",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"
    ]
};
var $5c8203742f0e3062$export$f729617a20de475b = $5c8203742f0e3062$export$e022f62a119e1d93;
var $5c8203742f0e3062$export$122c8413a0dc5ff6 = {
    prefix: "fas",
    iconName: "mask-ventilator",
    icon: [
        640,
        512,
        [],
        "e524",
        "M159.1 176C139.4 219.2 128 264.7 128 300.8c0 15.9 2.2 31.4 6.3 46l-31.8-7.9C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H159.1zm26-48H56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l71.3 17.8c22.7 30.5 55.4 54.1 93.8 66.6V393.3c-19.7-16.4-32-40.3-32-66.9c0-49.5 43-134.4 96-134.4c52.5 0 96 84.9 96 134.4c0 26.7-12.4 50.4-32 66.8v76.6c38-12.6 70.6-36 93.5-66.4l71.6-17.9C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H454.5C419.7 73.8 372.1 32 320 32c-52.6 0-100.2 41.8-134.9 96zm295.6 48H584c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9l-31.8 8c4.2-14.7 6.4-30.1 6.4-46.1c0-36.1-11.6-81.6-31.3-124.8zM288 320V512h64V320c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $5c8203742f0e3062$export$b4da69a0247f3620 = {
    prefix: "fas",
    iconName: "arrow-right",
    icon: [
        448,
        512,
        [
            8594
        ],
        "f061",
        "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
    ]
};
var $5c8203742f0e3062$export$905f45f8ffd6b8e5 = {
    prefix: "fas",
    iconName: "signs-post",
    icon: [
        512,
        512,
        [
            "map-signs"
        ],
        "f277",
        "M224 32H64C46.3 32 32 46.3 32 64v64c0 17.7 14.3 32 32 32H441.4c4.2 0 8.3-1.7 11.3-4.7l48-48c6.2-6.2 6.2-16.4 0-22.6l-48-48c-3-3-7.1-4.7-11.3-4.7H288c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 256c0-17.7-14.3-32-32-32H288V192H224v32H70.6c-4.2 0-8.3 1.7-11.3 4.7l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c3 3 7.1 4.7 11.3 4.7H448c17.7 0 32-14.3 32-32V256zM288 480V384H224v96c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $5c8203742f0e3062$export$743f4b1071b3333a = $5c8203742f0e3062$export$905f45f8ffd6b8e5;
var $5c8203742f0e3062$export$6357093f67788b33 = {
    prefix: "fas",
    iconName: "cash-register",
    icon: [
        512,
        512,
        [],
        "f788",
        "M64 0C46.3 0 32 14.3 32 32V96c0 17.7 14.3 32 32 32h80v32H87c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1C.4 368.8 0 373.6 0 378.4V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V378.4c0-4.8-.4-9.6-1.1-14.4L488.2 214.4C483.5 183.1 456.6 160 425 160H208V128h80c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H64zM96 48H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 432c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm48-168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM160 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM424 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM352 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"
    ]
};
var $5c8203742f0e3062$export$c8f8a597ffd676c0 = {
    prefix: "fas",
    iconName: "person-circle-question",
    icon: [
        576,
        512,
        [],
        "e542",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"
    ]
};
var $5c8203742f0e3062$export$d762b7b66d5875e1 = {
    prefix: "fas",
    iconName: "h",
    icon: [
        384,
        512,
        [
            104
        ],
        "48",
        "M320 256l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192L64 192 64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 256 0z"
    ]
};
var $5c8203742f0e3062$export$2305b1a41b3f914 = {
    prefix: "fas",
    iconName: "tarp",
    icon: [
        576,
        512,
        [],
        "e57b",
        "M576 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64l352 0 0-128c0-17.7 14.3-32 32-32H576V128zM448 448L576 320H448l0 128zM96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$158a12f36bbecf9 = {
    prefix: "fas",
    iconName: "screwdriver-wrench",
    icon: [
        512,
        512,
        [
            "tools"
        ],
        "f7d9",
        "M78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4h54.1l109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3l-109-109V104c0-7.5-3.5-14.5-9.4-19L78.6 5zM19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L233.7 374.3c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1zM512 144c0-10.5-1.1-20.7-3.2-30.5c-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7H352c-8.8 0-16-7.2-16-16V102.6c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0C288.5 0 224 64.5 224 144l0 .8 85.3 85.3c36-9.1 75.8 .5 104 28.7L429 274.5c49-23 83-72.8 83-130.5zM56 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $5c8203742f0e3062$export$646e4e7a8c6172aa = $5c8203742f0e3062$export$158a12f36bbecf9;
var $5c8203742f0e3062$export$9adae865350879af = {
    prefix: "fas",
    iconName: "arrows-to-eye",
    icon: [
        640,
        512,
        [],
        "e4bf",
        "M15 15C24.4 5.7 39.6 5.7 49 15l63 63V40c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H78.1L15 49C5.7 39.6 5.7 24.4 15 15zM133.5 243.9C158.6 193.6 222.7 112 320 112s161.4 81.6 186.5 131.9c3.8 7.6 3.8 16.5 0 24.2C481.4 318.4 417.3 400 320 400s-161.4-81.6-186.5-131.9c-3.8-7.6-3.8-16.5 0-24.2zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM591 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-63 63H600c13.3 0 24 10.7 24 24s-10.7 24-24 24H504c-13.3 0-24-10.7-24-24V40c0-13.3 10.7-24 24-24s24 10.7 24 24V78.1l63-63zM15 497c-9.4-9.4-9.4-24.6 0-33.9l63-63H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V433.9L49 497c-9.4 9.4-24.6 9.4-33.9 0zm576 0l-63-63V472c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H561.9l63 63c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
    ]
};
var $5c8203742f0e3062$export$4f3b3144ce966486 = {
    prefix: "fas",
    iconName: "plug-circle-bolt",
    icon: [
        576,
        512,
        [],
        "e55b",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
    ]
};
var $5c8203742f0e3062$export$e4b51a47a2f8b9db = {
    prefix: "fas",
    iconName: "heart",
    icon: [
        512,
        512,
        [
            128153,
            128154,
            128155,
            128156,
            128420,
            129293,
            129294,
            129505,
            9829,
            10084,
            61578
        ],
        "f004",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"
    ]
};
var $5c8203742f0e3062$export$808b88e8735e31e8 = {
    prefix: "fas",
    iconName: "mars-and-venus",
    icon: [
        512,
        512,
        [
            9893
        ],
        "f224",
        "M337.8 14.8C341.5 5.8 350.3 0 360 0H472c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-24.7 24.7C407 163.3 416 192.6 416 224c0 80.2-59 146.6-136 158.2V408h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V456H208c-13.3 0-24-10.7-24-24s10.7-24 24-24h24V382.2C155 370.6 96 304.2 96 224c0-88.4 71.6-160 160-160c39.6 0 75.9 14.4 103.8 38.2L382.1 80 343 41c-6.9-6.9-8.9-17.2-5.2-26.2zM448 48l0 0h0v0zM352 224a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"
    ]
};
var $5c8203742f0e3062$export$9a513ee921e8e885 = {
    prefix: "fas",
    iconName: "house-user",
    icon: [
        576,
        512,
        [
            "home-user"
        ],
        "e1b0",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24zM352 224a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 96c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H256z"
    ]
};
var $5c8203742f0e3062$export$e732fa55ae5bbdf0 = $5c8203742f0e3062$export$9a513ee921e8e885;
var $5c8203742f0e3062$export$25e9b29b3f2230b5 = {
    prefix: "fas",
    iconName: "dumpster-fire",
    icon: [
        640,
        512,
        [],
        "f794",
        "M49.7 32l90.8 0L114.9 160l-94 0C9.3 160 0 150.7 0 139.1c0-2.1 .3-4.1 .9-6.1L26.8 48.9C29.9 38.9 39.2 32 49.7 32zM272 160l-124.5 0L173.1 32 272 32l0 128zm32 0l0-128 98.9 0 14.4 72.1c-1.7 1.1-3.3 2.4-4.8 3.8c-18.4 16.4-35.4 34-50.5 52.1l-58 0zm209.9-23.7c-1.7 1.6-3.4 3.2-5 4.8C498 129.6 486.7 118.6 475 108c-7.6-6.9-17-10.8-26.6-11.8L435.5 32l90.8 0c10.5 0 19.8 6.9 22.9 16.9L575.1 133c.2 .7 .4 1.4 .5 2.1c-17.8-15-44.3-14.6-61.7 1.2zM325.2 210.7C304.3 244.5 288 282.9 288 318.1c0 49.3 18.6 95.2 49.6 129.9L128 448c0 17.7-14.3 32-32 32s-32-14.3-32-32L44 288l-12 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l4 0-4-32 305.5 0c-4.4 6.2-8.5 12.5-12.3 18.7zm180.6-34.5L518 162.5c5.4-6.1 13.3-8.8 20.9-8.9c7.2 0 14.3 2.6 19.9 7.8c19.7 18.3 39.8 43.2 55 70.6C629 259.2 640 290.2 640 320.2C640 408.8 568.7 480 480 480c-89.6 0-160-71.3-160-159.8c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2c5.7-5.2 13.1-7.7 20.3-7.5c14.1 .3 23.8 11.4 32.7 21.6c0 0 0 0 0 0c2 2.3 4 4.6 6 6.7l19 19.9zM544 368.2c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C453 295.1 416 331.6 416 368.2c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $5c8203742f0e3062$export$baa3c215534dbf2a = {
    prefix: "fas",
    iconName: "house-crack",
    icon: [
        576,
        512,
        [],
        "e3b1",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H230.4l-31.3-52.2c-4.1-6.8-2.6-15.5 3.5-20.5L288 368l-60.2-82.8c-10.9-15 8.2-33.5 22.8-22l117.9 92.6c8 6.3 8.2 18.4 .4 24.9L288 448l38.4 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32z"
    ]
};
var $5c8203742f0e3062$export$c6e76550bdc0255d = {
    prefix: "fas",
    iconName: "martini-glass-citrus",
    icon: [
        576,
        512,
        [
            "cocktail"
        ],
        "f561",
        "M432 240c53 0 96-43 96-96s-43-96-96-96c-35.5 0-66.6 19.3-83.2 48H296.2C316 40.1 369.3 0 432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-27.7 0-53.5-7.8-75.5-21.3l35.4-35.4c12.2 5.6 25.8 8.7 40.1 8.7zM1.8 142.8C5.5 133.8 14.3 128 24 128H392c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-177 177V464h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H208 120c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V345.9L7 169c-6.9-6.9-8.9-17.2-5.2-26.2z"
    ]
};
var $5c8203742f0e3062$export$4be708f1e41d387b = $5c8203742f0e3062$export$c6e76550bdc0255d;
var $5c8203742f0e3062$export$c938968e28178994 = {
    prefix: "fas",
    iconName: "face-surprise",
    icon: [
        512,
        512,
        [
            128558,
            "surprise"
        ],
        "f5c2",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $5c8203742f0e3062$export$46647c72213f53ba = $5c8203742f0e3062$export$c938968e28178994;
var $5c8203742f0e3062$export$3ee278c67519eeeb = {
    prefix: "fas",
    iconName: "bottle-water",
    icon: [
        320,
        512,
        [],
        "e4c5",
        "M120 0l80 0c13.3 0 24 10.7 24 24l0 40L96 64l0-40c0-13.3 10.7-24 24-24zM32 167.5c0-19.5 10-37.6 26.6-47.9l15.8-9.9C88.7 100.7 105.2 96 122.1 96l75.8 0c16.9 0 33.4 4.7 47.7 13.7l15.8 9.9C278 129.9 288 148 288 167.5c0 17-7.5 32.3-19.4 42.6C280.6 221.7 288 238 288 256c0 19.1-8.4 36.3-21.7 48c13.3 11.7 21.7 28.9 21.7 48s-8.4 36.3-21.7 48c13.3 11.7 21.7 28.9 21.7 48c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64c0-19.1 8.4-36.3 21.7-48C40.4 388.3 32 371.1 32 352s8.4-36.3 21.7-48C40.4 292.3 32 275.1 32 256c0-18 7.4-34.3 19.4-45.9C39.5 199.7 32 184.5 32 167.5zM96 240c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0z"
    ]
};
var $5c8203742f0e3062$export$fbeef2513e05ad08 = {
    prefix: "fas",
    iconName: "circle-pause",
    icon: [
        512,
        512,
        [
            62092,
            "pause-circle"
        ],
        "f28b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 192V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $5c8203742f0e3062$export$d8cf08a0362da8db = $5c8203742f0e3062$export$fbeef2513e05ad08;
var $5c8203742f0e3062$export$7a494edbf9b65575 = {
    prefix: "fas",
    iconName: "toilet-paper-slash",
    icon: [
        640,
        512,
        [],
        "e072",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-109.7-86C569.9 374 608 291.9 608 192C608 86 565 0 512 0s-96 86-96 192c0 49.1 9.2 93.9 24.4 127.9l-59-46.2c1.6-24.8 2.6-52 2.6-81.6c0-65.5 13.2-142.4 60.2-192H160c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM367.3 385.4L66.5 148.4C64.9 162.4 64 177 64 192c0 101.5-11.7 170.8-23 213.9c-5.1 19.4-10.7 39.9-20.5 57.7c-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512H285.9c22.3 0 45.4-12.1 55.4-36.1c7.4-17.7 17.5-47.2 26-90.6zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z"
    ]
};
var $5c8203742f0e3062$export$12de8220d30453a3 = {
    prefix: "fas",
    iconName: "apple-whole",
    icon: [
        448,
        512,
        [
            127822,
            127823,
            "apple-alt"
        ],
        "f5d1",
        "M224 112c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16V32c0 44.2-35.8 80-80 80H224zM0 288c0-76.3 35.7-160 112-160c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c76.3 0 112 83.7 112 160c0 128-80 224-160 224c-16.5 0-38.1-6.6-51.5-11.3c-8.1-2.8-16.9-2.8-25 0c-13.4 4.7-35 11.3-51.5 11.3C80 512 0 416 0 288z"
    ]
};
var $5c8203742f0e3062$export$bcdd94f3977a0884 = $5c8203742f0e3062$export$12de8220d30453a3;
var $5c8203742f0e3062$export$64c1570509eaf40d = {
    prefix: "fas",
    iconName: "kitchen-set",
    icon: [
        576,
        512,
        [],
        "e51a",
        "M240 144A96 96 0 1 0 48 144a96 96 0 1 0 192 0zm44.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112h71.8c8.8-9.8 21.6-16 35.8-16H496c26.5 0 48 21.5 48 48s-21.5 48-48 48H392c-14.2 0-27-6.2-35.8-16H284.4zM144 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c13.3 0 24 10.7 24 24v8h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h96v-8c0-13.3 10.7-24 24-24zM288 464V352H512V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48zM48 320h80 16 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v32h16zM24 464H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $5c8203742f0e3062$export$eb4c616de6eef46f = {
    prefix: "fas",
    iconName: "r",
    icon: [
        320,
        512,
        [
            114
        ],
        "52",
        "M64 32C28.7 32 0 60.7 0 96V288 448c0 17.7 14.3 32 32 32s32-14.3 32-32V320h95.3L261.8 466.4c10.1 14.5 30.1 18 44.6 7.9s18-30.1 7.9-44.6L230.1 309.5C282.8 288.1 320 236.4 320 176c0-79.5-64.5-144-144-144H64zM176 256H64V96H176c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $5c8203742f0e3062$export$f9d1c19925fd7fa8 = {
    prefix: "fas",
    iconName: "temperature-quarter",
    icon: [
        320,
        512,
        [
            "temperature-1",
            "thermometer-1",
            "thermometer-quarter"
        ],
        "f2ca",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $5c8203742f0e3062$export$d4f1cd380bde2129 = $5c8203742f0e3062$export$f9d1c19925fd7fa8;
var $5c8203742f0e3062$export$3f77fbe2dabe285b = $5c8203742f0e3062$export$f9d1c19925fd7fa8;
var $5c8203742f0e3062$export$ed05754fcbec6e46 = $5c8203742f0e3062$export$f9d1c19925fd7fa8;
var $5c8203742f0e3062$export$973ae4f1e4d2ce78 = {
    prefix: "fas",
    iconName: "cube",
    icon: [
        512,
        512,
        [],
        "f1b2",
        "M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6C495 83.4 512 107.5 512 134.6V377.4c0 27-17 51.2-42.5 60.3l-192 68.6c-13.9 5-29.1 5-43.1 0l-192-68.6C17 428.6 0 404.5 0 377.4V134.6c0-27 17-51.2 42.5-60.3l192-68.6zM256 66L82.3 128 256 190l173.7-62L256 66zm32 368.6l160-57.1v-188L288 246.6v188z"
    ]
};
var $5c8203742f0e3062$export$441bfc8058328ce8 = {
    prefix: "fas",
    iconName: "bitcoin-sign",
    icon: [
        320,
        512,
        [],
        "e0b4",
        "M48 32C48 14.3 62.3 0 80 0s32 14.3 32 32V64h32V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64c0 1.5-.1 3.1-.3 4.5C254.1 82.2 288 125.1 288 176c0 24.2-7.7 46.6-20.7 64.9c31.7 19.8 52.7 55 52.7 95.1c0 61.9-50.1 112-112 112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H41.7C18.7 448 0 429.3 0 406.3V288 265.7 224 101.6C0 80.8 16.8 64 37.6 64H48V32zM64 224H176c26.5 0 48-21.5 48-48s-21.5-48-48-48H64v96zm112 64H64v96H208c26.5 0 48-21.5 48-48s-21.5-48-48-48H176z"
    ]
};
var $5c8203742f0e3062$export$2a5c6f182c0cbcb = {
    prefix: "fas",
    iconName: "shield-dog",
    icon: [
        512,
        512,
        [],
        "e573",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160.9 286.2c4.8 1.2 9.9 1.8 15.1 1.8c35.3 0 64-28.7 64-64V160h44.2c12.1 0 23.2 6.8 28.6 17.7L320 192h64c8.8 0 16 7.2 16 16v32c0 44.2-35.8 80-80 80H272v50.7c0 7.3-5.9 13.3-13.3 13.3c-1.8 0-3.6-.4-5.2-1.1l-98.7-42.3c-6.6-2.8-10.8-9.3-10.8-16.4c0-2.8 .6-5.5 1.9-8l15-30zM160 160h40 8v32 32c0 17.7-14.3 32-32 32s-32-14.3-32-32V176c0-8.8 7.2-16 16-16zm128 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $5c8203742f0e3062$export$b9c649c5e37017f3 = {
    prefix: "fas",
    iconName: "solar-panel",
    icon: [
        640,
        512,
        [],
        "f5ba",
        "M122.2 0C91.7 0 65.5 21.5 59.5 51.4L8.3 307.4C.4 347 30.6 384 71 384H288v64H224c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H569c40.4 0 70.7-36.9 62.8-76.6l-51.2-256C574.5 21.5 548.3 0 517.8 0H122.2zM260.9 64H379.1l10.4 104h-139L260.9 64zM202.3 168H101.4L122.2 64h90.4L202.3 168zM91.8 216H197.5L187.1 320H71L91.8 216zm153.9 0H394.3l10.4 104-169.4 0 10.4-104zm196.8 0H548.2L569 320h-116L442.5 216zm96-48H437.7L427.3 64h90.4l31.4-6.3L517.8 64l20.8 104z"
    ]
};
var $5c8203742f0e3062$export$84b5acad4436d02a = {
    prefix: "fas",
    iconName: "lock-open",
    icon: [
        576,
        512,
        [],
        "f3c1",
        "M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32V144C576 64.5 511.5 0 432 0S288 64.5 288 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V144z"
    ]
};
var $5c8203742f0e3062$export$c7a833ce065e0ea4 = {
    prefix: "fas",
    iconName: "elevator",
    icon: [
        512,
        512,
        [],
        "e16d",
        "M132.7 4.7l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H208c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H64zm96 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 400c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V400zm192 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V400zm32-128a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM356.7 91.3c6.2 6.2 16.4 6.2 22.6 0l64-64c4.6-4.6 5.9-11.5 3.5-17.4S438.5 0 432 0H304c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l64 64z"
    ]
};
var $5c8203742f0e3062$export$1b71392d9effbe = {
    prefix: "fas",
    iconName: "money-bill-transfer",
    icon: [
        640,
        512,
        [],
        "e528",
        "M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L384 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l174.1 0L535 41zM105 377l-23 23L256 400c13.3 0 24 10.7 24 24s-10.7 24-24 24L81.9 448l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64H337.9c-3.7 7.2-5.9 15.3-5.9 24c0 28.7 23.3 52 52 52l117.4 0c-4 17 .6 35.5 13.8 48.8c20.3 20.3 53.2 20.3 73.5 0L608 169.5V384c0 35.3-28.7 64-64 64H302.1c3.7-7.2 5.9-15.3 5.9-24c0-28.7-23.3-52-52-52l-117.4 0c4-17-.6-35.5-13.8-48.8c-20.3-20.3-53.2-20.3-73.5 0L32 342.5V128c0-35.3 28.7-64 64-64zm64 64H96v64c35.3 0 64-28.7 64-64zM544 320c-35.3 0-64 28.7-64 64h64V320zM320 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
    ]
};
var $5c8203742f0e3062$export$18ab80cba7d5044f = {
    prefix: "fas",
    iconName: "money-bill-trend-up",
    icon: [
        512,
        512,
        [],
        "e529",
        "M470.7 9.4c3 3.1 5.3 6.6 6.9 10.3s2.4 7.8 2.4 12.2l0 .1v0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3L310.6 214.6c-11.8 11.8-30.8 12.6-43.5 1.7L176 138.1 84.8 216.3c-13.4 11.5-33.6 9.9-45.1-3.5s-9.9-33.6 3.5-45.1l112-96c12-10.3 29.7-10.3 41.7 0l89.5 76.7L370.7 64H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0c8.8 0 16.8 3.6 22.6 9.3l.1 .1zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $5c8203742f0e3062$export$30d3e64480aa266b = {
    prefix: "fas",
    iconName: "house-flood-water-circle-arrow-right",
    icon: [
        640,
        512,
        [],
        "e50f",
        "M288 144A144 144 0 1 0 0 144a144 144 0 1 0 288 0zM140.7 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 160H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4L140.7 99.3c-6.2-6.2-6.2-16.4 0-22.6zM320 144c0 57.3-27.4 108.2-69.8 140.3c11.8-3.6 23-9.4 33-16.2c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.4 78.1 3.4c2.1 1.7 4.2 3.3 6.5 4.9l-.3-84.4H576c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128C407.6-2 392.4-2 381.2 6.1L301 64.4c12.1 23.9 19 50.9 19 79.6zm18.5 165.9c-11.1-7.9-25.9-7.9-37 0C279 325.4 251.5 336 224 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 389.7 191 400 224 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C471.4 325.2 442.9 336 416 336c-27.5 0-55-10.6-77.5-26.1zm0 112c-11.1-7.9-25.9-7.9-37 0C279 437.4 251.5 448 224 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 501.7 191 512 224 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C471.4 437.2 442.9 448 416 448c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
var $5c8203742f0e3062$export$287bdd70ab874659 = {
    prefix: "fas",
    iconName: "square-poll-horizontal",
    icon: [
        448,
        512,
        [
            "poll-h"
        ],
        "f682",
        "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM256 160c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32zm64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0zM192 352c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32z"
    ]
};
var $5c8203742f0e3062$export$456a238f0144d430 = $5c8203742f0e3062$export$287bdd70ab874659;
var $5c8203742f0e3062$export$4280b2387fbdad12 = {
    prefix: "fas",
    iconName: "circle",
    icon: [
        512,
        512,
        [
            128308,
            128309,
            128992,
            128993,
            128994,
            128995,
            128996,
            9679,
            9898,
            9899,
            11044,
            61708,
            61915
        ],
        "f111",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"
    ]
};
var $5c8203742f0e3062$export$662cbc6ed5a3c5e8 = {
    prefix: "fas",
    iconName: "backward-fast",
    icon: [
        512,
        512,
        [
            9198,
            "fast-backward"
        ],
        "f049",
        "M493.6 445c-11.2 5.3-24.5 3.6-34.1-4.4L288 297.7V416c0 12.4-7.2 23.7-18.4 29s-24.5 3.6-34.1-4.4L64 297.7V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V214.3L235.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S288 83.6 288 96V214.3L459.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S512 83.6 512 96V416c0 12.4-7.2 23.7-18.4 29z"
    ]
};
var $5c8203742f0e3062$export$e6246a3279a379b8 = $5c8203742f0e3062$export$662cbc6ed5a3c5e8;
var $5c8203742f0e3062$export$a65c441f12cb6bd = {
    prefix: "fas",
    iconName: "recycle",
    icon: [
        512,
        512,
        [
            9842,
            9850,
            9851
        ],
        "f1b8",
        "M174.7 45.1C192.2 17 223 0 256 0s63.8 17 81.3 45.1l38.6 61.7 27-15.6c8.4-4.9 18.9-4.2 26.6 1.7s11.1 15.9 8.6 25.3l-23.4 87.4c-3.4 12.8-16.6 20.4-29.4 17l-87.4-23.4c-9.4-2.5-16.3-10.4-17.6-20s3.4-19.1 11.8-23.9l28.4-16.4L283 79c-5.8-9.3-16-15-27-15s-21.2 5.7-27 15l-17.5 28c-9.2 14.8-28.6 19.5-43.6 10.5c-15.3-9.2-20.2-29.2-10.7-44.4l17.5-28zM429.5 251.9c15-9 34.4-4.3 43.6 10.5l24.4 39.1c9.4 15.1 14.4 32.4 14.6 50.2c.3 53.1-42.7 96.4-95.8 96.4L320 448v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2v32l96.2 0c17.6 0 31.9-14.4 31.8-32c0-5.9-1.7-11.7-4.8-16.7l-24.4-39.1c-9.5-15.2-4.7-35.2 10.7-44.4zm-364.6-31L36 204.2c-8.4-4.9-13.1-14.3-11.8-23.9s8.2-17.5 17.6-20l87.4-23.4c12.8-3.4 26 4.2 29.4 17L182 241.2c2.5 9.4-.9 19.3-8.6 25.3s-18.2 6.6-26.6 1.7l-26.5-15.3L68.8 335.3c-3.1 5-4.8 10.8-4.8 16.7c-.1 17.6 14.2 32 31.8 32l32.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32.2 0C42.7 448-.3 404.8 0 351.6c.1-17.8 5.1-35.1 14.6-50.2l50.3-80.5z"
    ]
};
var $5c8203742f0e3062$export$94363e983c225a04 = {
    prefix: "fas",
    iconName: "user-astronaut",
    icon: [
        448,
        512,
        [],
        "f4fb",
        "M370.7 96.1C346.1 39.5 289.7 0 224 0S101.9 39.5 77.3 96.1C60.9 97.5 48 111.2 48 128v64c0 16.8 12.9 30.5 29.3 31.9C101.9 280.5 158.3 320 224 320s122.1-39.5 146.7-96.1c16.4-1.4 29.3-15.1 29.3-31.9V128c0-16.8-12.9-30.5-29.3-31.9zM336 144v16c0 53-43 96-96 96H208c-53 0-96-43-96-96V144c0-26.5 21.5-48 48-48H288c26.5 0 48 21.5 48 48zM189.3 162.7l-6-21.2c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3 .9-5.5 3.9-5.5 7.3s2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3l-21.2-6zM112.7 316.5C46.7 342.6 0 407 0 482.3C0 498.7 13.3 512 29.7 512H128V448c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64l98.3 0c16.4 0 29.7-13.3 29.7-29.7c0-75.3-46.7-139.7-112.7-165.8C303.9 338.8 265.5 352 224 352s-79.9-13.2-111.3-35.5zM176 448c-8.8 0-16 7.2-16 16v48h32V464c0-8.8-7.2-16-16-16zm96 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $5c8203742f0e3062$export$cfee4df0d5df6d21 = {
    prefix: "fas",
    iconName: "plane-slash",
    icon: [
        640,
        512,
        [],
        "e069",
        "M440.6 320h73.8c34.2 0 93.7-28 93.7-64c0-35-59.5-64-93.7-64l-116.6 0L297.2 16.1C291.5 6.2 280.9 0 269.4 0H213.2c-10.6 0-18.3 10.2-15.4 20.4l40.3 140.9L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320zm-78.1 61.6L41.5 128.7C36 130.6 32 135.9 32 142c0 1.3 .2 2.6 .5 3.9L64 256 32.5 366.1c-.4 1.3-.5 2.6-.5 3.9c0 7.8 6.3 14 14 14H88c5 0 9.8-2.4 12.8-6.4L144 320H246.9l-49 171.6c-2.9 10.2 4.8 20.4 15.4 20.4l56.2 0c11.5 0 22.1-6.2 27.8-16.1l65.3-114.3z"
    ]
};
var $5c8203742f0e3062$export$9c9b2fbddd59047d = {
    prefix: "fas",
    iconName: "trademark",
    icon: [
        640,
        512,
        [
            8482
        ],
        "f25c",
        "M345.6 108.8c-8.3-11-22.7-15.5-35.7-11.2S288 114.2 288 128V384c0 17.7 14.3 32 32 32s32-14.3 32-32V224l86.4 115.2c6 8.1 15.5 12.8 25.6 12.8s19.6-4.7 25.6-12.8L576 224V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-13.8-8.8-26-21.9-30.4s-27.5 .1-35.7 11.2L464 266.7 345.6 108.8zM0 128c0 17.7 14.3 32 32 32H96V384c0 17.7 14.3 32 32 32s32-14.3 32-32V160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 96 0 110.3 0 128z"
    ]
};
var $5c8203742f0e3062$export$44dee69e3a29b0e = {
    prefix: "fas",
    iconName: "basketball",
    icon: [
        512,
        512,
        [
            127936,
            "basketball-ball"
        ],
        "f434",
        "M86.6 64l85.2 85.2C194.5 121.7 208 86.4 208 48c0-14.7-2-28.9-5.7-42.4C158.6 15 119 35.5 86.6 64zM64 86.6C35.5 119 15 158.6 5.6 202.3C19.1 206 33.3 208 48 208c38.4 0 73.7-13.5 101.3-36.1L64 86.6zM256 0c-7.3 0-14.6 .3-21.8 .9C238 16 240 31.8 240 48c0 47.3-17.1 90.5-45.4 124L256 233.4 425.4 64C380.2 24.2 320.9 0 256 0zM48 240c-16.2 0-32-2-47.1-5.8C.3 241.4 0 248.7 0 256c0 64.9 24.2 124.2 64 169.4L233.4 256 172 194.6C138.5 222.9 95.3 240 48 240zm463.1 37.8c.6-7.2 .9-14.5 .9-21.8c0-64.9-24.2-124.2-64-169.4L278.6 256 340 317.4c33.4-28.3 76.7-45.4 124-45.4c16.2 0 32 2 47.1 5.8zm-4.7 31.9C492.9 306 478.7 304 464 304c-38.4 0-73.7 13.5-101.3 36.1L448 425.4c28.5-32.3 49.1-71.9 58.4-115.7zM340.1 362.7C317.5 390.3 304 425.6 304 464c0 14.7 2 28.9 5.7 42.4C353.4 497 393 476.5 425.4 448l-85.2-85.2zM317.4 340L256 278.6 86.6 448c45.1 39.8 104.4 64 169.4 64c7.3 0 14.6-.3 21.8-.9C274 496 272 480.2 272 464c0-47.3 17.1-90.5 45.4-124z"
    ]
};
var $5c8203742f0e3062$export$36550ab8ffcc5b28 = $5c8203742f0e3062$export$44dee69e3a29b0e;
var $5c8203742f0e3062$export$219ccae0e4da3c92 = {
    prefix: "fas",
    iconName: "satellite-dish",
    icon: [
        512,
        512,
        [
            128225
        ],
        "f7c0",
        "M192 32c0-17.7 14.3-32 32-32C383.1 0 512 128.9 512 288c0 17.7-14.3 32-32 32s-32-14.3-32-32C448 164.3 347.7 64 224 64c-17.7 0-32-14.3-32-32zM60.6 220.6L164.7 324.7l28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4L291.4 451.4c14.5 14.5 11.8 38.8-7.3 46.3C260.5 506.9 234.9 512 208 512C93.1 512 0 418.9 0 304c0-26.9 5.1-52.5 14.4-76.1c7.5-19 31.8-21.8 46.3-7.3zM224 96c106 0 192 86 192 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7-57.3-128-128-128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$72ea8a5e4e86cd69 = {
    prefix: "fas",
    iconName: "circle-up",
    icon: [
        512,
        512,
        [
            61467,
            "arrow-alt-circle-up"
        ],
        "f35b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 217.4l107.1-99.9c3.8-3.5 8.7-5.5 13.8-5.5s10.1 2 13.8 5.5l107.1 99.9c4.5 4.2 7.1 10.1 7.1 16.3c0 12.3-10 22.3-22.3 22.3H304v96c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V256H150.3C138 256 128 246 128 233.7c0-6.2 2.6-12.1 7.1-16.3z"
    ]
};
var $5c8203742f0e3062$export$3747a8ef0995eadf = $5c8203742f0e3062$export$72ea8a5e4e86cd69;
var $5c8203742f0e3062$export$da39ed20699ee2d7 = {
    prefix: "fas",
    iconName: "mobile-screen-button",
    icon: [
        384,
        512,
        [
            "mobile-alt"
        ],
        "f3cd",
        "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM224 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM304 64H80V384H304V64z"
    ]
};
var $5c8203742f0e3062$export$e9599bc6cd92234d = $5c8203742f0e3062$export$da39ed20699ee2d7;
var $5c8203742f0e3062$export$39461921e738be65 = {
    prefix: "fas",
    iconName: "volume-high",
    icon: [
        640,
        512,
        [
            128266,
            "volume-up"
        ],
        "f028",
        "M533.6 32.5C598.5 85.2 640 165.8 640 256s-41.5 170.7-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"
    ]
};
var $5c8203742f0e3062$export$5940d3e475d90cc4 = $5c8203742f0e3062$export$39461921e738be65;
var $5c8203742f0e3062$export$9c0b63b698611d06 = {
    prefix: "fas",
    iconName: "users-rays",
    icon: [
        640,
        512,
        [],
        "e593",
        "M41 7C31.6-2.3 16.4-2.3 7 7S-2.3 31.6 7 41l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7zM599 7L527 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM7 505c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9zm592 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM212.1 336c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-.5-1.4-1-2.7-1.6-4c-9.4-22.3-29.8-38.9-54.3-43c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-.8 .1-1.7 .3-2.5 .5c-24.9 5.1-45.1 23-53.4 46.5zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $5c8203742f0e3062$export$79204db8777905c8 = {
    prefix: "fas",
    iconName: "wallet",
    icon: [
        512,
        512,
        [],
        "f555",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H448c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM416 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$7babcb2c90eb609a = {
    prefix: "fas",
    iconName: "clipboard-check",
    icon: [
        384,
        512,
        [],
        "f46c",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM305 273L177 401c-9.4 9.4-24.6 9.4-33.9 0L79 337c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 239c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $5c8203742f0e3062$export$b8d24c57c9e64933 = {
    prefix: "fas",
    iconName: "file-audio",
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zm2 226.3c37.1 22.4 62 63.1 62 109.7s-24.9 87.3-62 109.7c-7.6 4.6-17.4 2.1-22-5.4s-2.1-17.4 5.4-22C269.4 401.5 288 370.9 288 336s-18.6-65.5-46.5-82.3c-7.6-4.6-10-14.4-5.4-22s14.4-10 22-5.4zm-91.9 30.9c6 2.5 9.9 8.3 9.9 14.8V400c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L113.4 376H80c-8.8 0-16-7.2-16-16V312c0-8.8 7.2-16 16-16h33.4l35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5zm51 34.9c6.6-5.9 16.7-5.3 22.6 1.3C249.8 304.6 256 319.6 256 336s-6.2 31.4-16.3 42.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c5.1-5.7 8.1-13.1 8.1-21.3s-3.1-15.7-8.1-21.3c-5.9-6.6-5.3-16.7 1.3-22.6z"
    ]
};
var $5c8203742f0e3062$export$128a6cab12423493 = {
    prefix: "fas",
    iconName: "burger",
    icon: [
        512,
        512,
        [
            "hamburger"
        ],
        "f805",
        "M61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1H61.1zM144 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm240 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM272 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM16 304c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48s-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zm16 96c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16v16c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V400z"
    ]
};
var $5c8203742f0e3062$export$bab3bb9f4f59363 = $5c8203742f0e3062$export$128a6cab12423493;
var $5c8203742f0e3062$export$3c6c0c8185296ac5 = {
    prefix: "fas",
    iconName: "wrench",
    icon: [
        512,
        512,
        [
            128295
        ],
        "f0ad",
        "M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7H336c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $5c8203742f0e3062$export$f5bfd1271b8b71d1 = {
    prefix: "fas",
    iconName: "bugs",
    icon: [
        576,
        512,
        [],
        "e4d0",
        "M164.5 107.4l33.4-73.5c5.5-12.1 .1-26.3-11.9-31.8s-26.3-.1-31.8 11.9L128 71.7 101.9 14.1C96.4 2 82.1-3.3 70.1 2.1S52.7 21.9 58.1 33.9l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6h-17l-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8S-2.1 111.7 .5 124.7l8 40C10.7 175.9 20.6 184 32 184H64v23.3l-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6C82.7 274.6 103.8 288 128 288s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9L192 207.3V184h32c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8L204.3 136h-17c-4.7-11.6-12.7-21.5-22.9-28.6zM496 286.5l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.1-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6L432.8 250c-12.3 1-24.2 5.6-34.1 13.3L384 254.8l6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15l-13.1 38.6c-3.7 10.8 .8 22.8 10.7 28.5l27.7 16L359 322.7 321.5 312c-9.4-2.7-19.5 .6-25.5 8.3l-34.9 44.5c-8.2 10.4-6.4 25.5 4.1 33.7s25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3L503.5 440c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9L566.2 347c8.7-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2z"
    ]
};
var $5c8203742f0e3062$export$8bf9e3f7f57d486a = {
    prefix: "fas",
    iconName: "rupee-sign",
    icon: [
        448,
        512,
        [
            8360,
            "rupee"
        ],
        "f156",
        "M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256.5 16.4c-.9 6 0 8.7 .4 9.8c.4 1.1 1.4 2.6 4.2 4.9c7.2 5.7 18.7 10 37.9 16.8l1.3 .5c16 5.6 38.7 13.6 55.7 28.1c9.5 8.1 17.9 18.6 23.1 32.3c5.1 13.7 6.1 28.5 3.8 44c-4.2 28.1-20.5 49.3-43.8 60.9c-22.1 11-48.1 12.5-73.2 8l-.2 0 0 0c-9.3-1.8-20.5-5.7-29.3-9c-6-2.3-12.6-4.9-17.7-6.9l0 0c-2.5-1-4.6-1.8-6.3-2.5c-16.5-6.4-24.6-25-18.2-41.4s24.9-24.6 41.4-18.2c2.6 1 5.2 2 7.9 3.1l0 0c4.8 1.9 9.8 3.9 15.4 6c8.8 3.3 15.3 5.4 18.7 6c15.7 2.8 26.7 .8 32.9-2.3c5-2.5 8-6 9.1-13c1-6.9 .2-10.5-.5-12.3c-.6-1.7-1.8-3.6-4.5-5.9c-6.9-5.8-18.2-10.4-36.9-17l-3-1.1c-15.5-5.4-37-13-53.3-25.9c-9.5-7.5-18.3-17.6-23.7-31c-5.5-13.4-6.6-28-4.4-43.2c8.4-57.1 67-78 116.9-68.9c6.9 1.3 27.3 5.8 35.4 8.4c16.9 5.2 26.3 23.2 21.1 40.1s-23.2 26.3-40.1 21.1c-4.7-1.4-22.3-5.5-27.9-6.5c-14.6-2.7-25.8-.4-32.6 3.2c-6.3 3.3-8.9 7.6-9.5 12z"
    ]
};
var $5c8203742f0e3062$export$9da25a46cfcb6fa4 = $5c8203742f0e3062$export$8bf9e3f7f57d486a;
var $5c8203742f0e3062$export$6440b286d3cbac9b = {
    prefix: "fas",
    iconName: "file-image",
    icon: [
        384,
        512,
        [
            128443
        ],
        "f1c5",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm152 32c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5s-8.2 8.6-14.2 8.6H216 176 128 80c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l48-80c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l12.8 21.4 48.3-70.2c3-4.3 7.9-6.9 13.2-6.9z"
    ]
};
var $5c8203742f0e3062$export$d7cf0978afd90002 = {
    prefix: "fas",
    iconName: "circle-question",
    icon: [
        512,
        512,
        [
            62108,
            "question-circle"
        ],
        "f059",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $5c8203742f0e3062$export$5ba67d7f2265c1a5 = $5c8203742f0e3062$export$d7cf0978afd90002;
var $5c8203742f0e3062$export$6ccbeeccfea6dc8a = {
    prefix: "fas",
    iconName: "plane-departure",
    icon: [
        640,
        512,
        [
            128747
        ],
        "f5b0",
        "M381 114.9L186.1 41.8c-16.7-6.2-35.2-5.3-51.1 2.7L89.1 67.4C78 73 77.2 88.5 87.6 95.2l146.9 94.5L136 240 77.8 214.1c-8.7-3.9-18.8-3.7-27.3 .6L18.3 230.8c-9.3 4.7-11.8 16.8-5 24.7l73.1 85.3c6.1 7.1 15 11.2 24.3 11.2H248.4c5 0 9.9-1.2 14.3-3.4L535.6 212.2c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48H542.8c-20.2 0-40.2 4.8-58.2 14L381 114.9zM0 480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"
    ]
};
var $5c8203742f0e3062$export$2cef3f81ad90fb76 = {
    prefix: "fas",
    iconName: "handshake-slash",
    icon: [
        640,
        512,
        [],
        "e060",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM413.6 421.9L128 196.8V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6zM96 171.6L40.6 128H16c-8.8 0-16 7.2-16 16V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V171.6zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H544zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var $5c8203742f0e3062$export$3d177ecdf7fc50ec = {
    prefix: "fas",
    iconName: "book-bookmark",
    icon: [
        448,
        512,
        [],
        "e0bb",
        "M0 96C0 43 43 0 96 0h96V190.7c0 13.4 15.5 20.9 26 12.5L272 160l54 43.2c10.5 8.4 26 .9 26-12.5V0h32 32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32z"
    ]
};
var $5c8203742f0e3062$export$aa054a78ab078db3 = {
    prefix: "fas",
    iconName: "code-branch",
    icon: [
        448,
        512,
        [],
        "f126",
        "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3v87.8c18.8-10.9 40.7-17.1 64-17.1h96c35.3 0 64-28.7 64-64v-6.7C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V160c0 70.7-57.3 128-128 128H176c-35.3 0-64 28.7-64 64v6.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V352 153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm232 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM80 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $5c8203742f0e3062$export$37672611144b857b = {
    prefix: "fas",
    iconName: "hat-cowboy",
    icon: [
        640,
        512,
        [],
        "f8c0",
        "M320 64c14.4 0 22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c49.3 0 84.4 152.2 97.9 221.9C447.8 272.1 390.9 288 320 288s-127.8-15.9-169.9-34.1C163.6 184.2 198.7 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64zM111.1 270.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7c7.9-7.9 20.2-9.2 29.6-3.3c9.5 5.9 13.5 17.9 9.9 28.5c-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2C39.8 320.4 14.9 285.8 1.4 248.1c-3.6-10.6 .4-22.6 9.9-28.5c9.5-5.9 21.7-4.5 29.6 3.3c20.4 19.4 45.3 34.8 70.1 47.7z"
    ]
};
var $5c8203742f0e3062$export$f402c7c97f3383f0 = {
    prefix: "fas",
    iconName: "bridge",
    icon: [
        576,
        512,
        [],
        "e4c8",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H72v64H0V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96s96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96V160H504V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM456 96v64H376V96h80zM328 96v64H248V96h80zM200 96v64H120V96h80z"
    ]
};
var $5c8203742f0e3062$export$d86c56ab43eb0deb = {
    prefix: "fas",
    iconName: "phone-flip",
    icon: [
        512,
        512,
        [
            128381,
            "phone-alt"
        ],
        "f879",
        "M347.1 24.6c7.7-18.6 28-28.5 47.4-23.2l88 24C499.9 30.2 512 46 512 64c0 247.4-200.6 448-448 448c-18 0-33.8-12.1-38.6-29.5l-24-88c-5.3-19.4 4.6-39.7 23.2-47.4l96-40c16.3-6.8 35.2-2.1 46.3 11.6L207.3 368c70.4-33.3 127.4-90.3 160.7-160.7L318.7 167c-13.7-11.2-18.4-30-11.6-46.3l40-96z"
    ]
};
var $5c8203742f0e3062$export$a07a9b305deebf32 = $5c8203742f0e3062$export$d86c56ab43eb0deb;
var $5c8203742f0e3062$export$4a5a13c01d46357c = {
    prefix: "fas",
    iconName: "truck-front",
    icon: [
        512,
        512,
        [],
        "e2b7",
        "M0 80C0 35.8 35.8 0 80 0H432c44.2 0 80 35.8 80 80V368c0 26.2-12.6 49.4-32 64v48c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V432C12.6 417.4 0 394.2 0 368V80zm129.9 72.2L112 224H400l-17.9-71.8C378.5 138 365.7 128 351 128H161c-14.7 0-27.5 10-31 24.2zM128 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$ab927dada03be4b3 = {
    prefix: "fas",
    iconName: "cat",
    icon: [
        576,
        512,
        [
            128008
        ],
        "f6be",
        "M320 192h17.1c22.1 38.3 63.5 64 110.9 64c11 0 21.8-1.4 32-4v4 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V339.2L280 448h56c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-53 0-96-43-96-96V192.5c0-16.1-12-29.8-28-31.8l-7.9-1c-17.5-2.2-30-18.2-27.8-35.7s18.2-30 35.7-27.8l7.9 1c48 6 84.1 46.8 84.1 95.3v85.3c34.4-51.7 93.2-85.8 160-85.8zm160 26.5v0c-10 3.5-20.8 5.5-32 5.5c-28.4 0-54-12.4-71.6-32h0c-3.7-4.1-7-8.5-9.9-13.2C357.3 164 352 146.6 352 128v0V32 12 10.7C352 4.8 356.7 .1 362.6 0h.2c3.3 0 6.4 1.6 8.4 4.2l0 .1L384 21.3l27.2 36.3L416 64h64l4.8-6.4L512 21.3 524.8 4.3l0-.1c2-2.6 5.1-4.2 8.4-4.2h.2C539.3 .1 544 4.8 544 10.7V12 32v96c0 17.3-4.6 33.6-12.6 47.6c-11.3 19.8-29.6 35.2-51.4 42.9zM432 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $5c8203742f0e3062$export$61add9eca991b5ec = {
    prefix: "fas",
    iconName: "anchor-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e4ab",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$f4419f7b2e53b340 = {
    prefix: "fas",
    iconName: "truck-field",
    icon: [
        640,
        512,
        [],
        "e58d",
        "M32 96c0-35.3 28.7-64 64-64H320c23.7 0 44.4 12.9 55.4 32h51.8c25.3 0 48.2 14.9 58.5 38l52.8 118.8c.5 1.1 .9 2.1 1.3 3.2H544c35.3 0 64 28.7 64 64v32c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V288c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32V96zM384 224h85.9l-42.7-96H384v96zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $5c8203742f0e3062$export$806c0a45a7ecd6e8 = {
    prefix: "fas",
    iconName: "route",
    icon: [
        512,
        512,
        [],
        "f4d7",
        "M512 96c0 50.2-59.1 125.1-84.6 155c-3.8 4.4-9.4 6.1-14.5 5H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c53 0 96 43 96 96s-43 96-96 96H139.6c8.7-9.9 19.3-22.6 30-36.8c6.3-8.4 12.8-17.6 19-27.2H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-53 0-96-43-96-96s43-96 96-96h39.8c-21-31.5-39.8-67.7-39.8-96c0-53 43-96 96-96s96 43 96 96zM117.1 489.1c-3.8 4.3-7.2 8.1-10.1 11.3l-1.8 2-.2-.2c-6 4.6-14.6 4-20-1.8C59.8 473 0 402.5 0 352c0-53 43-96 96-96s96 43 96 96c0 30-21.1 67-43.5 97.9c-10.7 14.7-21.7 28-30.8 38.5l-.6 .7zM128 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$d4aa151a4554b74e = {
    prefix: "fas",
    iconName: "clipboard-question",
    icon: [
        384,
        512,
        [],
        "e4e3",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM105.8 229.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 328.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V314.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H158.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $5c8203742f0e3062$export$5dd22dcb6e3ed369 = {
    prefix: "fas",
    iconName: "panorama",
    icon: [
        640,
        512,
        [],
        "e209",
        "M45.6 32C20.4 32 0 52.4 0 77.6V434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6V77.6C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32zM96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm272 0c7.9 0 15.4 3.9 19.8 10.5L512.3 353c5.4 8 5.6 18.4 .4 26.5s-14.7 12.3-24.2 10.7C442.7 382.4 385.2 376 320 376c-65.6 0-123.4 6.5-169.3 14.4c-9.8 1.7-19.7-2.9-24.7-11.5s-4.3-19.4 1.9-27.2L197.3 265c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l26.4 33.1 87-127.6c4.5-6.6 11.9-10.5 19.8-10.5z"
    ]
};
var $5c8203742f0e3062$export$101422b773924276 = {
    prefix: "fas",
    iconName: "comment-medical",
    icon: [
        512,
        512,
        [],
        "f7f5",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM224 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V272H176c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"
    ]
};
var $5c8203742f0e3062$export$c88ac21fe7c88ae6 = {
    prefix: "fas",
    iconName: "teeth-open",
    icon: [
        576,
        512,
        [],
        "f62f",
        "M96 32C43 32 0 75 0 128v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-53-43-96-96-96H96zM224 96c26.5 0 48 21.5 48 48v56c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V144c0-26.5 21.5-48 48-48zm80 48c0-26.5 21.5-48 48-48s48 21.5 48 48v56c0 13.3-10.7 24-24 24H328c-13.3 0-24-10.7-24-24V144zM96 128c26.5 0 48 21.5 48 48v24c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V176c0-26.5 21.5-48 48-48zm336 48c0-26.5 21.5-48 48-48s48 21.5 48 48v24c0 13.3-10.7 24-24 24H456c-13.3 0-24-10.7-24-24V176zM96 480H480c53 0 96-43 96-96V352c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v32c0 53 43 96 96 96zm0-64c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48zm176 48c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48z"
    ]
};
var $5c8203742f0e3062$export$4b89fabf50a10951 = {
    prefix: "fas",
    iconName: "file-circle-minus",
    icon: [
        576,
        512,
        [],
        "e4ed",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"
    ]
};
var $5c8203742f0e3062$export$d55778e3ab6c933f = {
    prefix: "fas",
    iconName: "tags",
    icon: [
        512,
        512,
        [],
        "f02c",
        "M345 39.1L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM0 229.5V80C0 53.5 21.5 32 48 32H197.5c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $5c8203742f0e3062$export$e06d6607d3577d6e = {
    prefix: "fas",
    iconName: "wine-glass",
    icon: [
        320,
        512,
        [
            127863
        ],
        "f4e3",
        "M32.1 29.3C33.5 12.8 47.4 0 64 0H256c16.6 0 30.5 12.8 31.9 29.3l14 168.4c6 72-42.5 135.2-109.9 150.6V448h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H160 80c-17.7 0-32-14.3-32-32s14.3-32 32-32h48V348.4C60.6 333 12.1 269.8 18.1 197.8l14-168.4zm56 98.7H231.9l-5.3-64H93.4l-5.3 64z"
    ]
};
var $5c8203742f0e3062$export$dc9cc4280bee320d = {
    prefix: "fas",
    iconName: "forward-fast",
    icon: [
        512,
        512,
        [
            9197,
            "fast-forward"
        ],
        "f050",
        "M18.4 445c11.2 5.3 24.5 3.6 34.1-4.4L224 297.7V416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4L448 297.7V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32V214.3L276.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S224 83.6 224 96V214.3L52.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S0 83.6 0 96V416c0 12.4 7.2 23.7 18.4 29z"
    ]
};
var $5c8203742f0e3062$export$61a8cdc53c2e078d = $5c8203742f0e3062$export$dc9cc4280bee320d;
var $5c8203742f0e3062$export$38c072b870a9e4ab = {
    prefix: "fas",
    iconName: "face-meh-blank",
    icon: [
        512,
        512,
        [
            128566,
            "meh-blank"
        ],
        "f5a4",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.4-48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$e945435725f71e88 = $5c8203742f0e3062$export$38c072b870a9e4ab;
var $5c8203742f0e3062$export$f2cfa036d76f69ab = {
    prefix: "fas",
    iconName: "square-parking",
    icon: [
        448,
        512,
        [
            127359,
            "parking"
        ],
        "f540",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM192 256h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H192v64zm48 64H192v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 168c0-22.1 17.9-40 40-40h72c53 0 96 43 96 96s-43 96-96 96z"
    ]
};
var $5c8203742f0e3062$export$fda29c8f99573a4e = $5c8203742f0e3062$export$f2cfa036d76f69ab;
var $5c8203742f0e3062$export$58845db8e7e9a199 = {
    prefix: "fas",
    iconName: "house-signal",
    icon: [
        576,
        512,
        [],
        "e012",
        "M357.7 8.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.4 8.6-12.7 22-8.5 34c87.1 25.3 155.6 94.2 180.3 181.6H464c26.5 0 48-21.5 48-48V256h32c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM288 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V208zM24 256c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184c0 13.3 10.7 24 24 24s24-10.7 24-24c0-128.1-103.9-232-232-232zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM0 376c0 13.3 10.7 24 24 24c48.6 0 88 39.4 88 88c0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136c-13.3 0-24 10.7-24 24z"
    ]
};
var $5c8203742f0e3062$export$ee3a02da18715b2 = {
    prefix: "fas",
    iconName: "bars-progress",
    icon: [
        512,
        512,
        [
            "tasks-alt"
        ],
        "f828",
        "M448 160H320V128H448v32zM48 64C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zM448 352v32H192V352H448zM48 288c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48z"
    ]
};
var $5c8203742f0e3062$export$bbc0784fc1578f7f = $5c8203742f0e3062$export$ee3a02da18715b2;
var $5c8203742f0e3062$export$7a255960242435f6 = {
    prefix: "fas",
    iconName: "faucet-drip",
    icon: [
        512,
        512,
        [
            128688
        ],
        "e006",
        "M224 0c17.7 0 32 14.3 32 32V44l96-12c17.7 0 32 14.3 32 32s-14.3 32-32 32L256 84l-31-3.9-1-.1-1 .1L192 84 96 96C78.3 96 64 81.7 64 64s14.3-32 32-32l96 12V32c0-17.7 14.3-32 32-32zM0 224c0-17.7 14.3-32 32-32h96l22.6-22.6c6-6 14.1-9.4 22.6-9.4H192V116.2l32-4 32 4V160h18.7c8.5 0 16.6 3.4 22.6 9.4L320 192h32c88.4 0 160 71.6 160 160c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32s-14.3-32-32-32H315.9c-20.2 29-53.9 48-91.9 48s-71.7-19-91.9-48H32c-17.7 0-32-14.3-32-32V224zM436.8 423.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4z"
    ]
};
var $5c8203742f0e3062$export$df587aaf7765e1ce = {
    prefix: "fas",
    iconName: "cart-flatbed",
    icon: [
        640,
        512,
        [
            "dolly-flatbed"
        ],
        "f474",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64H48c8.8 0 16 7.2 16 16V368c0 44.2 35.8 80 80 80h18.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H450.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-8.8 0-16-7.2-16-16V80C128 35.8 92.2 0 48 0H32zM192 80V272c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H464V176c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L400 163.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V32H240c-26.5 0-48 21.5-48 48z"
    ]
};
var $5c8203742f0e3062$export$f7c6efb60c53b285 = $5c8203742f0e3062$export$df587aaf7765e1ce;
var $5c8203742f0e3062$export$130df7ed74437774 = {
    prefix: "fas",
    iconName: "ban-smoking",
    icon: [
        512,
        512,
        [
            128685,
            "smoking-ban"
        ],
        "f54d",
        "M99.5 144.8L178.7 224l96 96 92.5 92.5C335.9 434.9 297.5 448 256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2zM333.3 288l-32-32H384v32H333.3zm32 32H400c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H269.3L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2L365.3 320zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H304c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM229.5 320l-96-96H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H229.5z"
    ]
};
var $5c8203742f0e3062$export$e50452a49dec29f = $5c8203742f0e3062$export$130df7ed74437774;
var $5c8203742f0e3062$export$5e63e8b85b5f119c = {
    prefix: "fas",
    iconName: "terminal",
    icon: [
        576,
        512,
        [],
        "f120",
        "M9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6zM256 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$c93d62849efbdd11 = {
    prefix: "fas",
    iconName: "mobile-button",
    icon: [
        384,
        512,
        [],
        "f10b",
        "M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zM192 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$86c50f517be57a40 = {
    prefix: "fas",
    iconName: "house-medical-flag",
    icon: [
        640,
        512,
        [],
        "e514",
        "M480 0c17.7 0 32 14.3 32 32H624c8.8 0 16 7.2 16 16V176c0 8.8-7.2 16-16 16H512V512H448V192 32c0-17.7 14.3-32 32-32zM276.8 39.7L416 159V512h1l-.2 0H96c-17.7 0-32-14.3-32-32V288H32c-13.4 0-25.4-8.3-30-20.9s-1-26.7 9.2-35.4l224-192c12-10.3 29.7-10.3 41.7 0zM224 208v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H288V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"
    ]
};
var $5c8203742f0e3062$export$1d307c13b511e8e1 = {
    prefix: "fas",
    iconName: "basket-shopping",
    icon: [
        576,
        512,
        [
            "shopping-basket"
        ],
        "f291",
        "M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512H430c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H458.4L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192H171.7L253.3 35.1zM192 304v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $5c8203742f0e3062$export$ca6d443595a6578f = $5c8203742f0e3062$export$1d307c13b511e8e1;
var $5c8203742f0e3062$export$b88ed5e1e0eac4c6 = {
    prefix: "fas",
    iconName: "tape",
    icon: [
        576,
        512,
        [],
        "f4db",
        "M380.8 416c41.5-40.7 67.2-97.3 67.2-160C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H380.8zM224 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm64 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $5c8203742f0e3062$export$d3724faf0c559353 = {
    prefix: "fas",
    iconName: "bus-simple",
    icon: [
        448,
        512,
        [
            "bus-alt"
        ],
        "f55e",
        "M224 0C348.8 0 448 35.2 448 80V96 416c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32V96 80C0 35.2 99.2 0 224 0zM64 128V256c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$40616edfab6d332a = $5c8203742f0e3062$export$d3724faf0c559353;
var $5c8203742f0e3062$export$b8c3e79e8c99c95b = {
    prefix: "fas",
    iconName: "eye",
    icon: [
        576,
        512,
        [
            128065
        ],
        "f06e",
        "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"
    ]
};
var $5c8203742f0e3062$export$e8ea88c55e55be7c = {
    prefix: "fas",
    iconName: "face-sad-cry",
    icon: [
        512,
        512,
        [
            128557,
            "sad-cry"
        ],
        "f5b3",
        "M352 493.4c-29.6 12-62.1 18.6-96 18.6s-66.4-6.6-96-18.6V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V477.8C51.5 433.5 0 350.8 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 94.8-51.5 177.5-128 221.8V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V493.4zM195.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm121.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM208 336v32c0 26.5 21.5 48 48 48s48-21.5 48-48V336c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
    ]
};
var $5c8203742f0e3062$export$8e924e6bd422cef9 = $5c8203742f0e3062$export$e8ea88c55e55be7c;
var $5c8203742f0e3062$export$b6b464c98c009494 = {
    prefix: "fas",
    iconName: "audio-description",
    icon: [
        576,
        512,
        [],
        "f29e",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM213.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9H150.9l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zm-.4 106.6L192 237.7l-21.1 42.2h42.2zM304 184c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96s-43 96-96 96H328c-13.3 0-24-10.7-24-24V184zm48 24v96h32c26.5 0 48-21.5 48-48s-21.5-48-48-48H352z"
    ]
};
var $5c8203742f0e3062$export$41b1e14a6b0fe11b = {
    prefix: "fas",
    iconName: "person-military-to-person",
    icon: [
        512,
        512,
        [],
        "e54c",
        "M71 12.5c-8.6 1-15 8.2-15 16.8c0 9.3 7.5 16.8 16.7 16.9H184.1c8.8-.1 15.9-7.2 15.9-16V16c0-9.5-8.3-17-17.8-15.9L71 12.5zM189.5 78.1H66.5C64.9 83.8 64 89.8 64 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.2-.9-12.2-2.5-17.9zM32 256v32c0 17.7 14.3 32 32 32H192c1.8 0 3.5-.1 5.2-.4L53 208.6C40.1 220.3 32 237.2 32 256zm190.2 42.5c1.1-3.3 1.8-6.8 1.8-10.5V256c0-35.3-28.7-64-64-64H96c-3.7 0-7.4 .3-10.9 .9L222.2 298.5zM384 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H352zM215.8 450.1c5.2-4.6 8.2-11.1 8.2-18.1s-3-13.5-8.2-18.1l-64-56c-7.1-6.2-17.1-7.7-25.7-3.8S112 366.6 112 376v32l-88 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0v32c0 9.4 5.5 18 14.1 21.9s18.6 2.4 25.7-3.8l64-56zM288 431.9c0 6.9 2.9 13.5 8.1 18.1l64 56.4c7.1 6.2 17.1 7.8 25.7 3.9s14.1-12.4 14.1-21.9l0-32.4 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-32c0-9.4-5.5-18-14.1-21.9s-18.6-2.4-25.7 3.8l-64 56c-5.2 4.5-8.2 11.1-8.2 18z"
    ]
};
var $5c8203742f0e3062$export$348a01df65a66c99 = {
    prefix: "fas",
    iconName: "file-shield",
    icon: [
        576,
        512,
        [],
        "e4f0",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v47l-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52c0 56.6 18.9 148 94.2 208.3c-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm39.1 97.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"
    ]
};
var $5c8203742f0e3062$export$3924ab4d3ef9b5ef = {
    prefix: "fas",
    iconName: "user-slash",
    icon: [
        640,
        512,
        [],
        "f506",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2L38.8 5.1zM264.3 304.3C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7H514.3c3.9 0 7.6-.7 11-2.1l-261-205.6z"
    ]
};
var $5c8203742f0e3062$export$8f4567331fb0d3bc = {
    prefix: "fas",
    iconName: "pen",
    icon: [
        512,
        512,
        [
            128394
        ],
        "f304",
        "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"
    ]
};
var $5c8203742f0e3062$export$5b2f0f631f559d51 = {
    prefix: "fas",
    iconName: "tower-observation",
    icon: [
        512,
        512,
        [],
        "e586",
        "M241.7 3.4c9-4.5 19.6-4.5 28.6 0l160 80c15.8 7.9 22.2 27.1 14.3 42.9C439 137.5 427.7 144 416 144v80c0 17.7-14.3 32-32 32h-4.9l32 192H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H384.5c-.4 0-.8 0-1.1 0H128.6c-.4 0-.8 0-1.1 0H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l32-192H128c-17.7 0-32-14.3-32-32V144c-11.7 0-23-6.5-28.6-17.7c-7.9-15.8-1.5-35 14.3-42.9l160-80zM314.5 448L256 399.2 197.5 448h117zM197.8 256l-4.7 28.3L256 336.8l62.9-52.5L314.2 256H197.8zm-13.9 83.2l-11.2 67L218.5 368l-34.6-28.8zM293.5 368l45.8 38.1-11.2-67L293.5 368zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"
    ]
};
var $5c8203742f0e3062$export$143d0ca7d2200f20 = {
    prefix: "fas",
    iconName: "file-code",
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM153 289l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 337c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM265 255l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var $5c8203742f0e3062$export$79046b073b6c584d = {
    prefix: "fas",
    iconName: "signal",
    icon: [
        640,
        512,
        [
            128246,
            "signal-5",
            "signal-perfect"
        ],
        "f012",
        "M576 0c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM448 96c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM352 224V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zM192 288c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zM96 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $5c8203742f0e3062$export$3417071118065933 = $5c8203742f0e3062$export$79046b073b6c584d;
var $5c8203742f0e3062$export$1aea50ab3e99cc95 = $5c8203742f0e3062$export$79046b073b6c584d;
var $5c8203742f0e3062$export$ce69441578ff2fdb = {
    prefix: "fas",
    iconName: "bus",
    icon: [
        576,
        512,
        [
            128653
        ],
        "f207",
        "M288 0C422.4 0 512 35.2 512 80V96l0 32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32l0 160c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H192v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32l0-160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h0V96h0V80C64 35.2 153.6 0 288 0zM128 160v96c0 17.7 14.3 32 32 32H272V128H160c-17.7 0-32 14.3-32 32zM304 288H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H304V288zM144 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 80c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16z"
    ]
};
var $5c8203742f0e3062$export$742f89ae2f8d6b20 = {
    prefix: "fas",
    iconName: "heart-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e501",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $5c8203742f0e3062$export$af554427144a7e5c = {
    prefix: "fas",
    iconName: "house-chimney",
    icon: [
        576,
        512,
        [
            63499,
            "home-lg"
        ],
        "e3af",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64 24c0 22.1 17.9 40 40 40h24 32.5c1.4 0 2.8 0 4.2-.1c1.1 .1 2.2 .1 3.3 .1h16c22.1 0 40-17.9 40-40V455.8c.3-2.6 .5-5.3 .5-8.1l-.7-160.2h32z"
    ]
};
var $5c8203742f0e3062$export$dbab81727ec94698 = $5c8203742f0e3062$export$af554427144a7e5c;
var $5c8203742f0e3062$export$703cd98be31ec905 = {
    prefix: "fas",
    iconName: "window-maximize",
    icon: [
        512,
        512,
        [
            128470
        ],
        "f2d0",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$e5f78e87efbb0248 = {
    prefix: "fas",
    iconName: "face-frown",
    icon: [
        512,
        512,
        [
            9785,
            "frown"
        ],
        "f119",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.3 388.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$43b7108508aecc5f = $5c8203742f0e3062$export$e5f78e87efbb0248;
var $5c8203742f0e3062$export$8767bafb19515ee4 = {
    prefix: "fas",
    iconName: "prescription",
    icon: [
        448,
        512,
        [],
        "f5b1",
        "M32 0C14.3 0 0 14.3 0 32V192v96c0 17.7 14.3 32 32 32s32-14.3 32-32V224h50.7l128 128L137.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 397.3 393.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L333.3 352 438.6 246.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 306.7l-85.8-85.8C251.4 209.1 288 164.8 288 112C288 50.1 237.9 0 176 0H32zM176 160H64V64H176c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $5c8203742f0e3062$export$78edc9b98453b6f7 = {
    prefix: "fas",
    iconName: "shop",
    icon: [
        640,
        512,
        [
            "store-alt"
        ],
        "f54f",
        "M36.8 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM64 224V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 224H320V384H128V224H64zm448 0V480c0 17.7 14.3 32 32 32s32-14.3 32-32V224H512z"
    ]
};
var $5c8203742f0e3062$export$1f1871dab9cec9d8 = $5c8203742f0e3062$export$78edc9b98453b6f7;
var $5c8203742f0e3062$export$f62f2879ccaea13f = {
    prefix: "fas",
    iconName: "floppy-disk",
    icon: [
        448,
        512,
        [
            128190,
            128426,
            "save"
        ],
        "f0c7",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $5c8203742f0e3062$export$1aaa83ff70706e1e = $5c8203742f0e3062$export$f62f2879ccaea13f;
var $5c8203742f0e3062$export$ee4b92e89fe0dfaf = {
    prefix: "fas",
    iconName: "vihara",
    icon: [
        640,
        512,
        [],
        "f6a7",
        "M281 22L305.8 4.7c1.3-.9 2.7-1.8 4.1-2.4C313.1 .7 316.6 0 320 0s6.9 .7 10.1 2.2c1.4 .7 2.8 1.5 4.1 2.4L359 22C393 45.8 430.8 63.5 470.8 74.4l23 6.3c1.8 .5 3.6 1.1 5.2 2c3.2 1.7 5.9 4 8.1 6.8c3.8 4.9 5.6 11.3 4.7 17.8c-.4 2.8-1.2 5.4-2.5 7.8c-1.7 3.2-4 5.9-6.8 8.1c-4.3 3.2-9.6 5.1-15.1 4.9H480v56.1l6.4 5.1 5.2 4.1c21.1 16.7 45 29.6 70.5 38.1l28.9 9.6c1.6 .5 3.2 1.2 4.6 2c3.1 1.7 5.8 4.1 7.8 6.9s3.5 6.1 4.1 9.6c.5 2.7 .6 5.5 .1 8.3s-1.4 5.4-2.7 7.8c-1.7 3.1-4.1 5.8-6.9 7.8s-6.1 3.5-9.6 4.1c-1.6 .3-3.3 .4-5 .4H544v65.9c20.5 22.8 47.4 39.2 77.4 46.7C632 403 640 412.6 640 424c0 13.3-10.7 24-24 24H576v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H24c-13.3 0-24-10.7-24-24c0-11.4 8-21 18.6-23.4c30-7.6 56.9-23.9 77.4-46.7V288H56.6c-1.7 0-3.4-.1-5-.4c-3.5-.7-6.8-2.1-9.6-4.1s-5.2-4.7-7-7.8c-1.3-2.4-2.3-5-2.7-7.8s-.4-5.6 .1-8.3c.7-3.5 2.1-6.8 4.1-9.6s4.7-5.2 7.8-6.9c1.4-.8 3-1.5 4.6-2l28.9-9.6c25.5-8.5 49.4-21.4 70.5-38.1l5.2-4.1 6.4-5.1V176 128h-7.5c-5.5 .1-10.8-1.7-15.1-4.9c-2.8-2.1-5.1-4.8-6.8-8.1c-1.2-2.4-2.1-5-2.5-7.8c-.9-6.5 .9-12.8 4.7-17.8c2.1-2.8 4.8-5.1 8.1-6.8c1.6-.8 3.4-1.5 5.2-2l23-6.3C209.2 63.5 247 45.8 281 22zM416 128H320 224v64h72 48 72V128zM160 288v64H296h24 24H480V288H344 320h0H296 160z"
    ]
};
var $5c8203742f0e3062$export$4d10bcc8d068f454 = {
    prefix: "fas",
    iconName: "scale-unbalanced",
    icon: [
        640,
        512,
        [
            "balance-scale-left"
        ],
        "f515",
        "M522.1 62.4c16.8-5.6 25.8-23.7 20.2-40.5S518.6-3.9 501.9 1.6l-113 37.7C375 15.8 349.3 0 320 0c-44.2 0-80 35.8-80 80c0 3 .2 5.9 .5 8.8L117.9 129.6c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2V480c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V153.3c21-9.2 37.2-27 44.2-49l125.9-42zM439.6 288L512 163.8 584.4 288H439.6zM512 384c62.9 0 115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L536.1 109.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L392.7 273.1c-5.7 9.8-9.3 21.1-6.7 32.1C396.8 350 449.1 384 512 384zM129.2 291.8L201.6 416H56.7l72.4-124.2zM3.2 433.1C14 478 66.3 512 129.2 512s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L153.2 237.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L9.9 401.1c-5.7 9.8-9.3 21.1-6.7 32.1z"
    ]
};
var $5c8203742f0e3062$export$786cb0c775487f19 = $5c8203742f0e3062$export$4d10bcc8d068f454;
var $5c8203742f0e3062$export$f9dd5b1410e95035 = {
    prefix: "fas",
    iconName: "sort-up",
    icon: [
        320,
        512,
        [
            "sort-asc"
        ],
        "f0de",
        "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
    ]
};
var $5c8203742f0e3062$export$e4c8c924b1cc43a7 = $5c8203742f0e3062$export$f9dd5b1410e95035;
var $5c8203742f0e3062$export$63ffcb3d4e94cb92 = {
    prefix: "fas",
    iconName: "comment-dots",
    icon: [
        512,
        512,
        [
            128172,
            62075,
            "commenting"
        ],
        "f4ad",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $5c8203742f0e3062$export$49ee382a2425e89c = $5c8203742f0e3062$export$63ffcb3d4e94cb92;
var $5c8203742f0e3062$export$77a38850ff8b0407 = {
    prefix: "fas",
    iconName: "plant-wilt",
    icon: [
        512,
        512,
        [],
        "e5aa",
        "M288 120c0-30.9 25.1-56 56-56s56 25.1 56 56v13c-29.3 10-48 34.5-48 70.1c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V120C464 53.7 410.3 0 344 0S224 53.7 224 120v21.8C207.3 133 188.2 128 168 128c-66.3 0-120 53.7-120 120v13c-29.3 10-48 34.5-48 70.1C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V248c0-30.9 25.1-56 56-56s56 25.1 56 56v32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V280 248 120z"
    ]
};
var $5c8203742f0e3062$export$f214f827e0023247 = {
    prefix: "fas",
    iconName: "diamond",
    icon: [
        512,
        512,
        [
            9830
        ],
        "f219",
        "M284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"
    ]
};
var $5c8203742f0e3062$export$5d53da7627754bc6 = {
    prefix: "fas",
    iconName: "face-grin-squint",
    icon: [
        512,
        512,
        [
            128518,
            "grin-squint"
        ],
        "f585",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM133.5 146.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $5c8203742f0e3062$export$243ae757907b1580 = $5c8203742f0e3062$export$5d53da7627754bc6;
var $5c8203742f0e3062$export$61a67f5f8ab39be = {
    prefix: "fas",
    iconName: "hand-holding-dollar",
    icon: [
        576,
        512,
        [
            "hand-holding-usd"
        ],
        "f4c0",
        "M312 24V34.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V220.6c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $5c8203742f0e3062$export$47d27bc305b59690 = $5c8203742f0e3062$export$61a67f5f8ab39be;
var $5c8203742f0e3062$export$b0babe4230e35ebe = {
    prefix: "fas",
    iconName: "bacterium",
    icon: [
        512,
        512,
        [],
        "e05a",
        "M423.1 30.6c3.6-12.7-3.7-26-16.5-29.7s-26 3.7-29.7 16.5l-4.2 14.7c-9.8-.4-19.9 .5-29.9 2.8c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8L196 82.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7c-9.4 15.7-17 31-23.2 45.3l-9.9-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.6 4.6c-.3 1.1-.6 2.1-.9 3.1c-3.5 12.5-5.7 23.2-7.1 31.3c-.7 4.1-1.2 7.5-1.6 10.3c-.2 1.4-.3 2.6-.4 3.6l-.1 1.4-.1 .6 0 .3 0 .1c0 0 0 .1 39.2 3.7l0 0-39.2-3.6c-.5 5-.6 10-.4 14.9l-14.7 4.2C4.7 380.6-2.7 393.8 .9 406.6s16.9 20.1 29.7 16.5l13.8-3.9c10.6 20.7 27.6 37.8 48.5 48.5l-3.9 13.7c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L215 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3l.1-.8c.3-1.7 1-5.1 2.3-9.8l.2-.8 12.6 5.4c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7L371 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L439 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7s-16.9-20.1-29.7-16.5l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8zM92.1 363.3l0 0L144 368l-51.9-4.7zM112 320a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM240 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $5c8203742f0e3062$export$d97ff927c450c87f = {
    prefix: "fas",
    iconName: "hand-pointer",
    icon: [
        448,
        512,
        [],
        "f25a",
        "M128 40c0-22.1 17.9-40 40-40s40 17.9 40 40V188.2c8.5-7.6 19.7-12.2 32-12.2c20.6 0 38.2 13 45 31.2c8.8-9.3 21.2-15.2 35-15.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c26.5 0 48 21.5 48 48v48 16 48c0 70.7-57.3 128-128 128l-16 0H240l-.1 0h-5.2c-5 0-9.9-.3-14.7-1c-55.3-5.6-106.2-34-140-79L8 336c-13.3-17.7-9.7-42.7 8-56s42.7-9.7 56 8l56 74.7V40zM240 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"
    ]
};
var $5c8203742f0e3062$export$48d1206500db2e9d = {
    prefix: "fas",
    iconName: "drum-steelpan",
    icon: [
        576,
        512,
        [],
        "f56a",
        "M288 32c159.1 0 288 48 288 128V352c0 80-128.9 128-288 128S0 432 0 352V160C0 80 128.9 32 288 32zM528 160c0-9.9-8-29.9-55-49.8c-18.6-7.9-40.9-14.4-66-19.4l-27.8 43.6c-7.3 11.5-11.2 24.8-11.2 38.4c0 17.5 6.4 34.4 18.1 47.5l9.8 11c29.8-5.2 55.9-12.5 77.2-21.5c47.1-19.9 55-39.9 55-49.8zM349.2 237.3c-8-26.2-32.4-45.3-61.2-45.3s-53.3 19.1-61.2 45.3c19.4 1.7 39.9 2.7 61.2 2.7s41.8-.9 61.2-2.7zM169 90.8c-25.2 5-47.4 11.6-66 19.4C56 130.1 48 150.1 48 160s8 29.9 55 49.8c21.3 9 47.4 16.3 77.2 21.5l9.8-11c11.6-13.1 18.1-30 18.1-47.5c0-13.6-3.9-26.9-11.2-38.4L169 90.8zm56.3-8C224.5 87 224 91.5 224 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-4.5-.5-9-1.4-13.2C330.8 81 309.8 80 288 80s-42.8 1-62.6 2.8z"
    ]
};
var $5c8203742f0e3062$export$c578e919f2c5c135 = {
    prefix: "fas",
    iconName: "hand-scissors",
    icon: [
        512,
        512,
        [],
        "f257",
        "M40 208c-22.1 0-40 17.9-40 40s17.9 40 40 40l180.2 0c-7.6 8.5-12.2 19.7-12.2 32c0 25.3 19.5 46 44.3 47.9c-7.7 8.5-12.3 19.8-12.3 32.1c0 26.5 21.5 48 48 48l32 0 64 0c70.7 0 128-57.3 128-128l0-113.1c0-40.2-16-78.8-44.4-107.3C444.8 76.8 413.9 64 381.7 64L336 64c-21.3 0-39.3 13.9-45.6 33.1l74.5 23.7c8.4 2.7 13.1 11.7 10.4 20.1s-11.7 13.1-20.1 10.4L288 129.9l0 .1L84 65.8C62.9 59.2 40.5 70.9 33.8 92s5.1 43.5 26.2 50.2L269.5 208 40 208z"
    ]
};
var $5c8203742f0e3062$export$a96374faedb12593 = {
    prefix: "fas",
    iconName: "hands-praying",
    icon: [
        640,
        512,
        [
            "praying-hands"
        ],
        "f684",
        "M351.2 4.8c3.2-2 6.6-3.3 10-4.1c4.7-1 9.6-.9 14.1 .1c7.7 1.8 14.8 6.5 19.4 13.6L514.6 194.2c8.8 13.1 13.4 28.6 13.4 44.4v73.5c0 6.9 4.4 13 10.9 15.2l79.2 26.4C631.2 358 640 370.2 640 384v96c0 9.9-4.6 19.3-12.5 25.4s-18.1 8.1-27.7 5.5L431 465.9c-56-14.9-95-65.7-95-123.7V224c0-17.7 14.3-32 32-32s32 14.3 32 32v80c0 8.8 7.2 16 16 16s16-7.2 16-16V219.1c0-7-1.8-13.8-5.3-19.8L340.3 48.1c-1.7-3-2.9-6.1-3.6-9.3c-1-4.7-1-9.6 .1-14.1c1.9-8 6.8-15.2 14.3-19.9zm-62.4 0c7.5 4.6 12.4 11.9 14.3 19.9c1.1 4.6 1.2 9.4 .1 14.1c-.7 3.2-1.9 6.3-3.6 9.3L213.3 199.3c-3.5 6-5.3 12.9-5.3 19.8V304c0 8.8 7.2 16 16 16s16-7.2 16-16V224c0-17.7 14.3-32 32-32s32 14.3 32 32V342.3c0 58-39 108.7-95 123.7l-168.7 45c-9.6 2.6-19.9 .5-27.7-5.5S0 490 0 480V384c0-13.8 8.8-26 21.9-30.4l79.2-26.4c6.5-2.2 10.9-8.3 10.9-15.2V238.5c0-15.8 4.7-31.2 13.4-44.4L245.2 14.5c4.6-7.1 11.7-11.8 19.4-13.6c4.6-1.1 9.4-1.2 14.1-.1c3.5 .8 6.9 2.1 10 4.1z"
    ]
};
var $5c8203742f0e3062$export$95e08e91b0929943 = $5c8203742f0e3062$export$a96374faedb12593;
var $5c8203742f0e3062$export$9c58ddc4b3356f98 = {
    prefix: "fas",
    iconName: "arrow-rotate-right",
    icon: [
        512,
        512,
        [
            8635,
            "arrow-right-rotate",
            "arrow-rotate-forward",
            "redo"
        ],
        "f01e",
        "M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"
    ]
};
var $5c8203742f0e3062$export$ffa1245982c1b28b = $5c8203742f0e3062$export$9c58ddc4b3356f98;
var $5c8203742f0e3062$export$89c59b5f47067f4c = $5c8203742f0e3062$export$9c58ddc4b3356f98;
var $5c8203742f0e3062$export$3d9f98aa1c24c776 = $5c8203742f0e3062$export$9c58ddc4b3356f98;
var $5c8203742f0e3062$export$ae3a453550dec95 = {
    prefix: "fas",
    iconName: "biohazard",
    icon: [
        576,
        512,
        [
            9763
        ],
        "f780",
        "M173.2 0c-1.8 0-3.5 .7-4.8 2C138.5 32.3 120 74 120 120c0 26.2 6 50.9 16.6 73c-22 2.4-43.8 9.1-64.2 20.5C37.9 232.8 13.3 262.4 .4 296c-.7 1.7-.5 3.7 .5 5.2c2.2 3.7 7.4 4.3 10.6 1.3C64.2 254.3 158 245.1 205 324s-8.1 153.1-77.6 173.2c-4.2 1.2-6.3 5.9-4.1 9.6c1 1.6 2.6 2.7 4.5 3c36.5 5.9 75.2 .1 109.7-19.2c20.4-11.4 37.4-26.5 50.5-43.8c13.1 17.3 30.1 32.4 50.5 43.8c34.5 19.3 73.3 25.2 109.7 19.2c1.9-.3 3.5-1.4 4.5-3c2.2-3.7 .1-8.4-4.1-9.6C379.1 477.1 324 403 371 324s140.7-69.8 193.5-21.4c3.2 2.9 8.4 2.3 10.6-1.3c1-1.6 1.1-3.5 .5-5.2c-12.9-33.6-37.5-63.2-72.1-82.5c-20.4-11.4-42.2-18.1-64.2-20.5C450 170.9 456 146.2 456 120c0-46-18.5-87.7-48.4-118c-1.3-1.3-3-2-4.8-2c-5 0-8.4 5.2-6.7 9.9C421.7 80.5 385.6 176 288 176S154.3 80.5 179.9 9.9c1.7-4.7-1.6-9.9-6.7-9.9zM240 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM181.7 417.6c6.3-11.8 9.8-25.1 8.6-39.8c-19.5-18-34-41.4-41.2-67.8c-12.5-8.1-26.2-11.8-40-12.4c-9-.4-18.1 .6-27.1 2.7c7.8 57.1 38.7 106.8 82.9 139.4c6.8-6.7 12.6-14.1 16.8-22.1zM288 64c-28.8 0-56.3 5.9-81.2 16.5c2 8.3 5 16.2 9 23.5c6.8 12.4 16.7 23.1 30.1 30.3c13.3-4.1 27.5-6.3 42.2-6.3s28.8 2.2 42.2 6.3c13.4-7.2 23.3-17.9 30.1-30.3c4-7.3 7-15.2 9-23.5C344.3 69.9 316.8 64 288 64zM426.9 310c-7.2 26.4-21.7 49.7-41.2 67.8c-1.2 14.7 2.2 28.1 8.6 39.8c4.3 8 10 15.4 16.8 22.1c44.3-32.6 75.2-82.3 82.9-139.4c-9-2.2-18.1-3.1-27.1-2.7c-13.8 .6-27.5 4.4-40 12.4z"
    ]
};
var $5c8203742f0e3062$export$14e1096ad1719098 = {
    prefix: "fas",
    iconName: "location-crosshairs",
    icon: [
        512,
        512,
        [
            "location"
        ],
        "f601",
        "M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm128-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var $5c8203742f0e3062$export$45e012c32174eb5d = $5c8203742f0e3062$export$14e1096ad1719098;
var $5c8203742f0e3062$export$2f8a28204bb4b86f = {
    prefix: "fas",
    iconName: "mars-double",
    icon: [
        640,
        512,
        [
            9891
        ],
        "f227",
        "M312 32c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L275.8 159c-28.4-19.5-62.7-31-99.8-31C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L407 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312zm88 48h0v0l0 0zM64 304a112 112 0 1 1 224 0A112 112 0 1 1 64 304zM368 480c97.2 0 176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L599 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H504c-9.7 0-18.5 5.8-22.2 14.8c-1.2 2.9-1.8 6-1.8 9l0 .2v.2c0 6.2 2.5 12.2 7 16.8l33.4 33.4L480 146.7V168c0 22.6-13.6 43.1-34.6 51.7c-.8 .3-1.7 .7-2.5 1C465.7 241.2 480 270.9 480 304c0 61.9-50.1 112-112 112c-5.4 0-10.8-.4-16-1.1c-12.9 20.4-29.1 38.3-48.1 53.1c19.8 7.8 41.4 12 64 12z"
    ]
};
var $5c8203742f0e3062$export$f31a37ecbfd4e707 = {
    prefix: "fas",
    iconName: "child-dress",
    icon: [
        320,
        512,
        [],
        "e59c",
        "M224 64A64 64 0 1 0 96 64a64 64 0 1 0 128 0zM88 400v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h16v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h17.8c10.9 0 18.6-10.7 15.2-21.1l-31.1-93.4 28.6 37.8c10.7 14.1 30.8 16.8 44.8 6.2s16.8-30.7 6.2-44.8L254.6 207c-22.4-29.6-57.5-47-94.6-47s-72.2 17.4-94.6 47L6.5 284.7c-10.7 14.1-7.9 34.2 6.2 44.8s34.2 7.9 44.8-6.2l28.7-37.8L55 378.9C51.6 389.3 59.3 400 70.2 400H88z"
    ]
};
var $5c8203742f0e3062$export$6ea1decf8bb3513d = {
    prefix: "fas",
    iconName: "users-between-lines",
    icon: [
        640,
        512,
        [],
        "e591",
        "M0 24C0 10.7 10.7 0 24 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24zM0 488c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM83.2 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 320c0-35.3 28.7-64 64-64h96c12.2 0 23.7 3.4 33.4 9.4c-37.2 15.1-65.6 47.2-75.8 86.6H64c-17.7 0-32-14.3-32-32zm461.6 32c-10.3-40.1-39.6-72.6-77.7-87.4c9.4-5.5 20.4-8.6 32.1-8.6h96c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H493.6zM391.2 290.4c32.1 7.4 58.1 30.9 68.9 61.6c3.5 10 5.5 20.8 5.5 32c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32c0-11.2 1.9-22 5.5-32c10.5-29.7 35.3-52.8 66.1-60.9c7.8-2.1 16-3.1 24.5-3.1h96c7.4 0 14.7 .8 21.6 2.4zm44-130.4a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM321.6 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var $5c8203742f0e3062$export$895159d10626af74 = {
    prefix: "fas",
    iconName: "lungs-virus",
    icon: [
        640,
        512,
        [],
        "e067",
        "M320 0c17.7 0 32 14.3 32 32V156.2c-8.5-7.6-19.7-12.2-32-12.2s-23.5 4.6-32 12.2V32c0-17.7 14.3-32 32-32zM444.5 195.5c-16.4-16.4-41.8-18.5-60.5-6.1V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9c14 1.5 28.5-3 39.2-13.8l-22.6-22.6 22.6 22.6c18.7-18.7 18.7-49.1 0-67.9c-1.1-1.1-1.4-2-1.5-2.5c-.1-.8-.1-1.8 .4-2.9s1.2-1.9 1.8-2.3c.5-.3 1.3-.8 2.9-.8c26.5 0 48-21.5 48-48s-21.5-48-48-48c-1.6 0-2.4-.4-2.9-.8c-.6-.4-1.3-1.2-1.8-2.3s-.5-2.2-.4-2.9c.1-.6 .4-1.4 1.5-2.5c18.7-18.7 18.7-49.1 0-67.9zM421.8 421.8c-6.2 6.2-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6zM183.3 491.2l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v24.1c-18.6-12.4-44-10.3-60.5 6.1c-18.7 18.7-18.7 49.1 0 67.9c1.1 1.1 1.4 2 1.5 2.5c.1 .8 .1 1.8-.4 2.9s-1.2 1.9-1.8 2.3c-.5 .3-1.3 .8-2.9 .8c-26.5 0-48 21.5-48 48s21.5 48 48 48c1.6 0 2.4 .4 2.9 .8c.6 .4 1.3 1.2 1.8 2.3s.5 2.2 .4 2.9c-.1 .6-.4 1.4-1.5 2.5c-18.7 18.7-18.7 49.1 0 67.9c10.7 10.7 25.3 15.3 39.2 13.8c-12.8 15.9-30.6 27.7-51.5 32.9zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $5c8203742f0e3062$export$8ac6d81a3d5b40a1 = {
    prefix: "fas",
    iconName: "face-grin-tears",
    icon: [
        640,
        512,
        [
            128514,
            "grin-tears"
        ],
        "f588",
        "M548.6 371.4C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c3.6-8.8 6.5-18.4 8.8-27.5c4.6-18.2 7.7-37 9.3-48.2c3.9-26.5-18.8-49.2-45.2-45.4c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-26.5-3.9-49.2 18.8-45.2 45.4c1.6 11.3 4.6 30 9.3 48.2c2.3 9.1 5.2 18.8 8.8 27.5c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3zM107 254.1c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9zm454.5 87.1c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zm-90.1-9.7c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM281.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0z"
    ]
};
var $5c8203742f0e3062$export$b2f7512221512b5b = $5c8203742f0e3062$export$8ac6d81a3d5b40a1;
var $5c8203742f0e3062$export$ddab067855cf34cb = {
    prefix: "fas",
    iconName: "phone",
    icon: [
        512,
        512,
        [
            128222,
            128379
        ],
        "f095",
        "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"
    ]
};
var $5c8203742f0e3062$export$3c70ffe5660af060 = {
    prefix: "fas",
    iconName: "calendar-xmark",
    icon: [
        448,
        512,
        [
            "calendar-times"
        ],
        "f273",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM305 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"
    ]
};
var $5c8203742f0e3062$export$99b20d7352fbcf08 = $5c8203742f0e3062$export$3c70ffe5660af060;
var $5c8203742f0e3062$export$84a2f9476730c40e = {
    prefix: "fas",
    iconName: "child-reaching",
    icon: [
        384,
        512,
        [],
        "e59d",
        "M256 64A64 64 0 1 0 128 64a64 64 0 1 0 128 0zM152.9 169.3c-23.7-8.4-44.5-24.3-58.8-45.8L74.6 94.2C64.8 79.5 45 75.6 30.2 85.4s-18.7 29.7-8.9 44.4L40.9 159c18.1 27.1 42.8 48.4 71.1 62.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384h32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V221.6c29.1-14.2 54.4-36.2 72.7-64.2l18.2-27.9c9.6-14.8 5.4-34.6-9.4-44.3s-34.6-5.5-44.3 9.4L291 122.4c-21.8 33.4-58.9 53.6-98.8 53.6c-12.6 0-24.9-2-36.6-5.8c-.9-.3-1.8-.7-2.7-.9z"
    ]
};
var $5c8203742f0e3062$export$5b64b916710da7c7 = {
    prefix: "fas",
    iconName: "head-side-virus",
    icon: [
        512,
        512,
        [],
        "e064",
        "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM224 64c-8.8 0-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80c0-8.8-7.2-16-16-16zm-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var $5c8203742f0e3062$export$f504a6909b677146 = {
    prefix: "fas",
    iconName: "user-gear",
    icon: [
        640,
        512,
        [
            "user-cog"
        ],
        "f4fe",
        "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304h91.4c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7v.9c0 9.2 2.7 18.5 7.9 26.3H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v17.7c0 7.8 4.8 14.8 11.6 18.7c6.8 3.9 15.1 4.5 21.8 .6l13.8-7.9c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-14.4 8.3c-6.5 3.7-10 10.9-10 18.4s3.5 14.7 10 18.4l14.4 8.3c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-13.8-7.9c-6.7-3.9-15.1-3.3-21.8 .6c-6.8 3.9-11.6 10.9-11.6 18.7v17.7c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8V467.8c0-7.9-4.9-14.9-11.7-18.9c-6.8-3.9-15.2-4.5-22-.6l-13.5 7.8c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l14-8.1c6.5-3.8 10.1-11.1 10.1-18.6s-3.5-14.8-10.1-18.6l-14-8.1c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l13.6 7.8c6.8 3.9 15.2 3.3 22-.6c6.9-3.9 11.7-11 11.7-18.9V218.2zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"
    ]
};
var $5c8203742f0e3062$export$474108c2b86e730e = $5c8203742f0e3062$export$f504a6909b677146;
var $5c8203742f0e3062$export$bbbff45e04f4abab = {
    prefix: "fas",
    iconName: "arrow-up-1-9",
    icon: [
        576,
        512,
        [
            "sort-numeric-up"
        ],
        "f163",
        "M450.7 38c8.3 6 13.3 15.7 13.3 26v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V108.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zM160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM445.7 364.9A32 32 0 1 0 418.3 307a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 408.4 344 375.2 344 336c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 467c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
    ]
};
var $5c8203742f0e3062$export$d213a3ba3cabed48 = $5c8203742f0e3062$export$bbbff45e04f4abab;
var $5c8203742f0e3062$export$2c79e1a422528bba = {
    prefix: "fas",
    iconName: "door-closed",
    icon: [
        576,
        512,
        [
            128682
        ],
        "f52a",
        "M96 64c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V448h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 144 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96V64zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$bea811bbf570f05a = {
    prefix: "fas",
    iconName: "shield-virus",
    icon: [
        512,
        512,
        [],
        "e06c",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 112c8.8 0 16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C334.5 200.1 351 240 384 240c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C311.9 334.5 272 351 272 384c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C177.5 311.9 161 272 128 272c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C200.1 177.5 240 161 240 128c0-8.8 7.2-16 16-16zM232 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $5c8203742f0e3062$export$3397c7b4679acccc = {
    prefix: "fas",
    iconName: "dice-six",
    icon: [
        448,
        512,
        [
            9861
        ],
        "f526",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$f3858ce1b3218e2 = {
    prefix: "fas",
    iconName: "mosquito-net",
    icon: [
        640,
        512,
        [],
        "e52c",
        "M168.8 462.3c-7.9-4-11.1-13.6-7.2-21.5L192 380.2l0-44.2c0-4.2 1.7-8.3 4.7-11.3L256 265.4V242.2L139.2 344C87.8 395.3 0 358.9 0 286.3c0-41.1 30.6-75.8 71.4-80.9l159.9-23.9-49.6-41.3c-5.1-4.2-7-11.1-4.9-17.4l13.9-41.7-29-58.1c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l32 64c1.9 3.8 2.2 8.2 .9 12.2l-12.5 37.6L256 160.5V137.9c0-14.9 10.1-27.3 23.8-31V63.7c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2V107c13.7 3.6 23.8 16.1 23.8 31v22.6l45.4-37.8L352.8 85.1c-1.3-4-1-8.4 .9-12.2l32-64c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-29 58.1 13.9 41.7c2.1 6.2 .1 13.1-4.9 17.4l-49.6 41.3 159.9 23.9c22.5 2.8 41.8 14.6 54.7 31.4c-2.7 2.6-5.2 5.4-7.3 8.6c-8.6-12.9-23.3-21.5-40-21.5s-31.4 8.5-40 21.5c-8.6-12.9-23.3-21.5-40-21.5c-21.7 0-40 14.3-45.9 34.1c-10.7 3.2-19.8 10.1-25.9 19.2l-40.2-35v23.1l32.4 32.4c-.3 2-.4 4.1-.4 6.2c0 16.7 8.5 31.4 21.5 40c-4 2.6-7.5 5.9-10.6 9.5L320 310.6v50c0 17.7-14.3 32-32 32s-32-14.3-32-32v-50l-32 32 0 41.4c0 2.5-.6 4.9-1.7 7.2l-32 64c-4 7.9-13.6 11.1-21.5 7.2zM512 256c8.8 0 16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H528v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H448v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V400H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V320H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16zm16 112h48V320H528v48zm0 80h48V400H528v48zM448 320v48h48V320H448zm0 80v48h48V400H448z"
    ]
};
var $5c8203742f0e3062$export$154e99cb34841765 = {
    prefix: "fas",
    iconName: "bridge-water",
    icon: [
        576,
        512,
        [],
        "e4ce",
        "M0 96C0 78.3 14.3 64 32 64H544c17.7 0 32 14.3 32 32v35.6c0 15.7-12.7 28.4-28.4 28.4c-37.3 0-67.6 30.2-67.6 67.6V352.5c-12.9 0-25.8 3.9-36.8 11.7c-18 12.4-40.1 20.3-59.2 20.3h0l0-.5V256c0-53-43-96-96-96s-96 43-96 96V384l0 .5c-19 0-41.2-7.9-59.1-20.3c-11.1-7.8-24-11.7-36.9-11.7V227.6C96 190.2 65.8 160 28.4 160C12.7 160 0 147.3 0 131.6V96zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $5c8203742f0e3062$export$2337c975289bdd84 = {
    prefix: "fas",
    iconName: "person-booth",
    icon: [
        576,
        512,
        [],
        "f756",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64V32zm320 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM224 512c17.7 0 32-14.3 32-32V320H192V480c0 17.7 14.3 32 32 32zM320 0c-9.3 0-18.1 4-24.2 11s-8.8 16.3-7.5 25.5l31.2 218.6L288.6 409.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1l.7-3.6c1.3 16.4 15.1 29.4 31.9 29.4c17.7 0 32-14.3 32-32c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM112 80A48 48 0 1 0 16 80a48 48 0 1 0 96 0zm0 261.3V269.3l4.7 4.7c9 9 21.2 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H157.3l-41.6-41.6c-14.3-14.3-33.8-22.4-54-22.4C27.6 160 0 187.6 0 221.6v55.7l0 .9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384l32 42.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V421.3c0-10.4-3.4-20.5-9.6-28.8L112 341.3z"
    ]
};
var $5c8203742f0e3062$export$d8724cf433389700 = {
    prefix: "fas",
    iconName: "text-width",
    icon: [
        448,
        512,
        [],
        "f035",
        "M64 128V96H192l0 128H176c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H256l0-128H384v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H224 48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V416H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H128V320c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64z"
    ]
};
var $5c8203742f0e3062$export$7daa48199dcb2ad1 = {
    prefix: "fas",
    iconName: "hat-wizard",
    icon: [
        512,
        512,
        [],
        "f6e8",
        "M64 416L168.6 180.7c15.3-34.4 40.3-63.5 72-83.7l146.9-94c3-1.9 6.5-2.9 10-2.9C407.7 0 416 8.3 416 18.6v1.6c0 2.6-.5 5.1-1.4 7.5L354.8 176.9c-1.9 4.7-2.8 9.7-2.8 14.7c0 5.5 1.2 11 3.4 16.1L448 416H240.9l11.8-35.4 40.4-13.5c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-40.4-13.5-13.5-40.4C237 276.4 230.9 272 224 272s-13 4.4-15.2 10.9l-13.5 40.4-40.4 13.5C148.4 339 144 345.1 144 352s4.4 13 10.9 15.2l40.4 13.5L207.1 416H64zM279.6 141.5c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5l-6.7 20.2-20.2 6.7c-3.3 1.1-5.5 4.1-5.5 7.6s2.2 6.5 5.5 7.6l20.2 6.7 6.7 20.2c1.1 3.3 4.1 5.5 7.6 5.5s6.5-2.2 7.6-5.5l6.7-20.2 20.2-6.7c3.3-1.1 5.5-4.1 5.5-7.6s-2.2-6.5-5.5-7.6l-20.2-6.7-6.7-20.2zM32 448H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$8bdfe14ac72a8b17 = {
    prefix: "fas",
    iconName: "pen-fancy",
    icon: [
        512,
        512,
        [
            128395,
            10002
        ],
        "f5ac",
        "M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79c0 22.8-9.9 44.6-27.1 59.6L277.7 319l-10.3-10.3-64-64L193 234.3 373.5 27.1zM170.3 256.9l10.4 10.4 64 64 10.4 10.4-19.2 83.4c-3.9 17.1-16.9 30.7-33.8 35.4L24.4 510.3l95.4-95.4c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L1.7 487.6 51.5 310c4.7-16.9 18.3-29.9 35.4-33.8l83.4-19.2z"
    ]
};
var $5c8203742f0e3062$export$f4d483fca19a4604 = {
    prefix: "fas",
    iconName: "person-digging",
    icon: [
        576,
        512,
        [
            "digging"
        ],
        "f85e",
        "M208 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM9.8 214.8c5.1-12.2 19.1-18 31.4-12.9L60.7 210l22.9-38.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l34.6 103.7 79.3 33.1 34.2-45.6c6.4-8.5 16.6-13.3 27.2-12.8s20.3 6.4 25.8 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2H288c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7h32l22.5-30L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4zm82.8 91.8l112 48c11.8 5 19.4 16.6 19.4 29.4v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V405.1l-60.6-26-37 111c-5.6 16.8-23.7 25.8-40.5 20.2S-3.9 486.6 1.6 469.9l48-144 11-33 32 13.7z"
    ]
};
var $5c8203742f0e3062$export$7bd93e3343bd5671 = $5c8203742f0e3062$export$f4d483fca19a4604;
var $5c8203742f0e3062$export$ed8c149a0ea54bb4 = {
    prefix: "fas",
    iconName: "trash",
    icon: [
        448,
        512,
        [],
        "f1f8",
        "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"
    ]
};
var $5c8203742f0e3062$export$f3a0a4e6723a86d4 = {
    prefix: "fas",
    iconName: "gauge-simple",
    icon: [
        512,
        512,
        [
            "gauge-simple-med",
            "tachometer-average"
        ],
        "f629",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $5c8203742f0e3062$export$ba8c12ff7cfa2521 = $5c8203742f0e3062$export$f3a0a4e6723a86d4;
var $5c8203742f0e3062$export$94fcfd6f6335431b = $5c8203742f0e3062$export$f3a0a4e6723a86d4;
var $5c8203742f0e3062$export$6feb44fec53ba30d = {
    prefix: "fas",
    iconName: "book-medical",
    icon: [
        448,
        512,
        [],
        "f7e6",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM208 112v48H160c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h48c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16z"
    ]
};
var $5c8203742f0e3062$export$dd0ede1713d2d2f9 = {
    prefix: "fas",
    iconName: "poo",
    icon: [
        512,
        512,
        [
            128169
        ],
        "f2fe",
        "M268.9 .9c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.4c2.8 8.2 4.3 16.9 4.3 26.1c0 44.1-35.7 79.9-79.8 80H160c-35.3 0-64 28.7-64 64c0 19.1 8.4 36.3 21.7 48H104c-39.8 0-72 32.2-72 72c0 23.2 11 43.8 28 57c-34.1 5.7-60 35.3-60 71c0 39.8 32.2 72 72 72H440c39.8 0 72-32.2 72-72c0-35.7-25.9-65.3-60-71c17-13.2 28-33.8 28-57c0-39.8-32.2-72-72-72H394.3c13.3-11.7 21.7-28.9 21.7-48c0-35.3-28.7-64-64-64h-5.5c3.5-10 5.5-20.8 5.5-32c0-48.6-36.2-88.8-83.1-95.1zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm64 108.3c0 2.4-.7 4.8-2.2 6.7c-8.2 10.5-39.5 45-93.8 45s-85.6-34.6-93.8-45c-1.5-1.9-2.2-4.3-2.2-6.7c0-6.8 5.5-12.3 12.3-12.3H339.7c6.8 0 12.3 5.5 12.3 12.3z"
    ]
};
var $5c8203742f0e3062$export$54e3a80c9875b74c = {
    prefix: "fas",
    iconName: "quote-right",
    icon: [
        448,
        512,
        [
            8221,
            "quote-right-alt"
        ],
        "f10e",
        "M448 296c0 66.3-53.7 120-120 120h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H320c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72zm-256 0c0 66.3-53.7 120-120 120H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72z"
    ]
};
var $5c8203742f0e3062$export$dd692f2e88bd4b1a = $5c8203742f0e3062$export$54e3a80c9875b74c;
var $5c8203742f0e3062$export$312f2c01c6fedca8 = {
    prefix: "fas",
    iconName: "shirt",
    icon: [
        640,
        512,
        [
            128085,
            "t-shirt",
            "tshirt"
        ],
        "f553",
        "M211.8 0c7.8 0 14.3 5.7 16.7 13.2C240.8 51.9 277.1 80 320 80s79.2-28.1 91.5-66.8C413.9 5.7 420.4 0 428.2 0h12.6c22.5 0 44.2 7.9 61.5 22.3L628.5 127.4c6.6 5.5 10.7 13.5 11.4 22.1s-2.1 17.1-7.8 23.6l-56 64c-11.4 13.1-31.2 14.6-44.6 3.5L480 197.7V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V197.7l-51.5 42.9c-13.3 11.1-33.1 9.6-44.6-3.5l-56-64c-5.7-6.5-8.5-15-7.8-23.6s4.8-16.6 11.4-22.1L137.7 22.3C155 7.9 176.7 0 199.2 0h12.6z"
    ]
};
var $5c8203742f0e3062$export$144e5f8bc4d705a6 = $5c8203742f0e3062$export$312f2c01c6fedca8;
var $5c8203742f0e3062$export$36edce3ba87c2b17 = $5c8203742f0e3062$export$312f2c01c6fedca8;
var $5c8203742f0e3062$export$30523a9441a31e97 = {
    prefix: "fas",
    iconName: "cubes",
    icon: [
        576,
        512,
        [],
        "f1b3",
        "M290.8 48.6l78.4 29.7L288 109.5 206.8 78.3l78.4-29.7c1.8-.7 3.8-.7 5.7 0zM136 92.5V204.7c-1.3 .4-2.6 .8-3.9 1.3l-96 36.4C14.4 250.6 0 271.5 0 294.7V413.9c0 22.2 13.1 42.3 33.5 51.3l96 42.2c14.4 6.3 30.7 6.3 45.1 0L288 457.5l113.5 49.9c14.4 6.3 30.7 6.3 45.1 0l96-42.2c20.3-8.9 33.5-29.1 33.5-51.3V294.7c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-1.3-.5-2.6-.9-3.9-1.3V92.5c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-12.8-4.8-26.9-4.8-39.7 0l-96 36.4C150.4 48.4 136 69.3 136 92.5zM392 210.6l-82.4 31.2V152.6L392 121v89.6zM154.8 250.9l78.4 29.7L152 311.7 70.8 280.6l78.4-29.7c1.8-.7 3.8-.7 5.7 0zm18.8 204.4V354.8L256 323.2v95.9l-82.4 36.2zM421.2 250.9c1.8-.7 3.8-.7 5.7 0l78.4 29.7L424 311.7l-81.2-31.1 78.4-29.7zM523.2 421.2l-77.6 34.1V354.8L528 323.2v90.7c0 3.2-1.9 6-4.8 7.3z"
    ]
};
var $5c8203742f0e3062$export$89fa217ec5503ac9 = {
    prefix: "fas",
    iconName: "divide",
    icon: [
        448,
        512,
        [
            10135,
            247
        ],
        "f529",
        "M272 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 320a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 288c17.7 0 32-14.3 32-32s-14.3-32-32-32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H400z"
    ]
};
var $5c8203742f0e3062$export$c04e864469c1d117 = {
    prefix: "fas",
    iconName: "tenge-sign",
    icon: [
        384,
        512,
        [
            8376,
            "tenge"
        ],
        "f7d7",
        "M0 64C0 46.3 14.3 32 32 32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM0 192c0-17.7 14.3-32 32-32H192 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V224H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $5c8203742f0e3062$export$af6ebee83047b793 = $5c8203742f0e3062$export$c04e864469c1d117;
var $5c8203742f0e3062$export$ad02dd8ca5816958 = {
    prefix: "fas",
    iconName: "headphones",
    icon: [
        512,
        512,
        [
            127911
        ],
        "f025",
        "M256 80C149.9 80 62.4 159.4 49.6 262c9.4-3.8 19.6-6 30.4-6c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48c-44.2 0-80-35.8-80-80V384 336 288C0 146.6 114.6 32 256 32s256 114.6 256 256v48 48 16c0 44.2-35.8 80-80 80c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48c10.8 0 21 2.1 30.4 6C449.6 159.4 362.1 80 256 80z"
    ]
};
var $5c8203742f0e3062$export$96891bbcda1dbb7b = {
    prefix: "fas",
    iconName: "hands-holding",
    icon: [
        640,
        512,
        [],
        "f4c2",
        "M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v56 64V325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48V385.1c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3 0 0-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3V224 144 104zm480 0v40 80 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2 0 0-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V224 160 104c0-22.1-17.9-40-40-40s-40 17.9-40 40z"
    ]
};
var $5c8203742f0e3062$export$765c446e974b5e59 = {
    prefix: "fas",
    iconName: "hands-clapping",
    icon: [
        512,
        512,
        [],
        "e1a8",
        "M336 16V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm-98.7 7.1l32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4zM135 119c9.4-9.4 24.6-9.4 33.9 0L292.7 242.7c10.1 10.1 27.3 2.9 27.3-11.3V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4c-64 38.4-145.8 28.3-198.5-24.4L7 361c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l53 53c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L23 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l93 93c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L55 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l117 117c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9zM433.1 484.9c-24.2 14.5-50.9 22.1-77.7 23.1c48.1-39.6 76.6-99 76.6-162.4l0-98.1c8.2-.1 16-6.4 16-16V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4zM424.9 18.7c7.4 4.9 9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48c4.9-7.4 14.8-9.3 22.2-4.4z"
    ]
};
var $5c8203742f0e3062$export$929518bb4b66a588 = {
    prefix: "fas",
    iconName: "republican",
    icon: [
        640,
        512,
        [],
        "f75e",
        "M0 192C0 103.6 71.6 32 160 32H384c88.4 0 160 71.6 160 160v64H0V192zm415.9-64c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L466 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm-138.3 3.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L322 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6zM127.9 128c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L178 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm.1 160H320h96 32 64 32v32 80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80s-80-35.8-80-80V352H448v32 64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V384H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V384 288H128z"
    ]
};
var $5c8203742f0e3062$export$b7fac681e7d09400 = {
    prefix: "fas",
    iconName: "arrow-left",
    icon: [
        448,
        512,
        [
            8592
        ],
        "f060",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    ]
};
var $5c8203742f0e3062$export$16c9e0374c346c6e = {
    prefix: "fas",
    iconName: "person-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e543",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
var $5c8203742f0e3062$export$8e90575265a56cfc = {
    prefix: "fas",
    iconName: "ruler",
    icon: [
        512,
        512,
        [
            128207
        ],
        "f545",
        "M177.9 494.1c-18.7 18.7-49.1 18.7-67.9 0L17.9 401.9c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 50.7-50.7c18.7-18.7 49.1-18.7 67.9 0l92.1 92.1c18.7 18.7 18.7 49.1 0 67.9L177.9 494.1z"
    ]
};
var $5c8203742f0e3062$export$e490f662af4d1c78 = {
    prefix: "fas",
    iconName: "align-left",
    icon: [
        448,
        512,
        [],
        "f036",
        "M288 64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32H256c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $5c8203742f0e3062$export$64bfd48ed353c031 = {
    prefix: "fas",
    iconName: "dice-d6",
    icon: [
        448,
        512,
        [],
        "f6d1",
        "M201 10.3c14.3-7.8 31.6-7.8 46 0L422.3 106c5.1 2.8 8.3 8.2 8.3 14s-3.2 11.2-8.3 14L231.7 238c-4.8 2.6-10.5 2.6-15.3 0L25.7 134c-5.1-2.8-8.3-8.2-8.3-14s3.2-11.2 8.3-14L201 10.3zM23.7 170l176 96c5.1 2.8 8.3 8.2 8.3 14V496c0 5.6-3 10.9-7.8 13.8s-10.9 3-15.8 .3L25 423.1C9.6 414.7 0 398.6 0 381V184c0-5.6 3-10.9 7.8-13.8s10.9-3 15.8-.3zm400.7 0c5-2.7 11-2.6 15.8 .3s7.8 8.1 7.8 13.8V381c0 17.6-9.6 33.7-25 42.1L263.7 510c-5 2.7-11 2.6-15.8-.3s-7.8-8.1-7.8-13.8V280c0-5.9 3.2-11.2 8.3-14l176-96z"
    ]
};
var $5c8203742f0e3062$export$5fbcef35138741a5 = {
    prefix: "fas",
    iconName: "restroom",
    icon: [
        640,
        512,
        [],
        "f7bd",
        "M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V325.2c-8.1 9.2-21.1 13.2-33.5 9.4c-16.9-5.3-26.3-23.2-21-40.1l30.9-99.1C44.9 155.3 82 128 124 128h8c42 0 79.1 27.3 91.6 67.4l30.9 99.1c5.3 16.9-4.1 34.8-21 40.1c-12.4 3.9-25.4-.2-33.5-9.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H120zM320 0c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zM464 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM440 480V384H422.2c-10.9 0-18.6-10.7-15.2-21.1l9-26.9c-3.2 0-6.4-.5-9.5-1.5c-16.9-5.3-26.3-23.2-21-40.1l29.7-95.2C428.4 156.9 467.6 128 512 128s83.6 28.9 96.8 71.2l29.7 95.2c5.3 16.9-4.1 34.8-21 40.1c-3.2 1-6.4 1.5-9.5 1.5l9 26.9c3.5 10.4-4.3 21.1-15.2 21.1H584v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H504v96c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
    ]
};
var $5c8203742f0e3062$export$bbf24078bd1f73e6 = {
    prefix: "fas",
    iconName: "j",
    icon: [
        320,
        512,
        [
            106
        ],
        "4a",
        "M288 32c17.7 0 32 14.3 32 32V320c0 88.4-71.6 160-160 160S0 408.4 0 320V288c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 53 43 96 96 96s96-43 96-96V64c0-17.7 14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$72b785dcfe44c69b = {
    prefix: "fas",
    iconName: "users-viewfinder",
    icon: [
        640,
        512,
        [],
        "e595",
        "M48 48h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H32C14.3 0 0 14.3 0 32V136c0 13.3 10.7 24 24 24s24-10.7 24-24V48zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM504 48h88v88c0 13.3 10.7 24 24 24s24-10.7 24-24V32c0-17.7-14.3-32-32-32H504c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464V376c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 17.7 14.3 32 32 32H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H48zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H608c17.7 0 32-14.3 32-32V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v88H504z"
    ]
};
var $5c8203742f0e3062$export$b44eb38345c6a964 = {
    prefix: "fas",
    iconName: "file-video",
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V288zM300.9 397.9L256 368V304l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z"
    ]
};
var $5c8203742f0e3062$export$c1a3ba061b4f60c4 = {
    prefix: "fas",
    iconName: "up-right-from-square",
    icon: [
        512,
        512,
        [
            "external-link-alt"
        ],
        "f35d",
        "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    ]
};
var $5c8203742f0e3062$export$d7f107e456ab0306 = $5c8203742f0e3062$export$c1a3ba061b4f60c4;
var $5c8203742f0e3062$export$c517dffc18db483f = {
    prefix: "fas",
    iconName: "table-cells",
    icon: [
        512,
        512,
        [
            "th"
        ],
        "f00a",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 64v64H64V96h88zm56 0h88v64H208V96zm240 0v64H360V96h88zM64 224h88v64H64V224zm232 0v64H208V224h88zm64 0h88v64H360V224zM152 352v64H64V352h88zm56 0h88v64H208V352zm240 0v64H360V352h88z"
    ]
};
var $5c8203742f0e3062$export$4d383c83efc0c819 = $5c8203742f0e3062$export$c517dffc18db483f;
var $5c8203742f0e3062$export$38611f1c776aba73 = {
    prefix: "fas",
    iconName: "file-pdf",
    icon: [
        512,
        512,
        [],
        "f1c1",
        "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"
    ]
};
var $5c8203742f0e3062$export$df8194b081d34b27 = {
    prefix: "fas",
    iconName: "book-bible",
    icon: [
        448,
        512,
        [
            "bible"
        ],
        "f647",
        "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zM208 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272V304c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V192H160c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h48V80z"
    ]
};
var $5c8203742f0e3062$export$2eac809b0670d139 = $5c8203742f0e3062$export$df8194b081d34b27;
var $5c8203742f0e3062$export$9db87eabf605857e = {
    prefix: "fas",
    iconName: "o",
    icon: [
        448,
        512,
        [
            111
        ],
        "4f",
        "M224 96a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z"
    ]
};
var $5c8203742f0e3062$export$25ea11267429d202 = {
    prefix: "fas",
    iconName: "suitcase-medical",
    icon: [
        512,
        512,
        [
            "medkit"
        ],
        "f0fa",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96v32V480H384V128 96 56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM96 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H96V96zM416 480h32c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H416V480zM224 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
    ]
};
var $5c8203742f0e3062$export$e75f02bae5b7d34b = $5c8203742f0e3062$export$25ea11267429d202;
var $5c8203742f0e3062$export$597826232327559b = {
    prefix: "fas",
    iconName: "user-secret",
    icon: [
        448,
        512,
        [
            128373
        ],
        "f21b",
        "M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 14.3 25 27.1 64.6 35.9c-.4 4-.6 8-.6 12.1c0 17 3.3 33.2 9.3 48H45.4C38 224 32 230 32 237.4c0 1.7 .3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-58.5-28.2-110.4-71.7-143L415 242.4c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4H342.7c6-14.8 9.3-31 9.3-48c0-4.1-.2-8.1-.6-12.1C391 155.1 416 142.3 416 128c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1zm56 208H267.6c-16.5 0-31.1-10.6-36.3-26.2c-2.3-7-12.2-7-14.5 0c-5.2 15.6-19.9 26.2-36.3 26.2H168c-22.1 0-40-17.9-40-40V169.6c28.2 4.1 61 6.4 96 6.4s67.8-2.3 96-6.4V184c0 22.1-17.9 40-40 40zm-88 96l16 32L176 480 128 288l64 32zm128-32L272 480 240 352l16-32 64-32z"
    ]
};
var $5c8203742f0e3062$export$743cce3ca4eb1d7d = {
    prefix: "fas",
    iconName: "otter",
    icon: [
        640,
        512,
        [
            129446
        ],
        "f700",
        "M181.5 197.1l12.9 6.4c5.9 3 12.4 4.5 19.1 4.5c23.5 0 42.6-19.1 42.6-42.6V144c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v21.4c0 23.5 19.1 42.6 42.6 42.6c6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2L135.1 185c-4.5-3-7.1-8-7.1-13.3V168c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2zm-8.6 49.4L160 240l-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6c-3.6 0-7.1-.2-10.6-.6v.6c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V336 320c0-23.7 12.9-44.4 32-55.4c9.4-5.4 20.3-8.6 32-8.6V240c0-26.5 21.5-48 48-48c8.8 0 16 7.2 16 16v32 16 48c0 8.8 7.2 16 16 16s16-7.2 16-16V204.3c0-48.2-30.8-91-76.6-106.3l-8.5-2.8c-8-2.7-12.6-11.1-10.4-19.3s10.3-13.2 18.6-11.6l19.9 4C576 86.1 640 164.2 640 254.9l0 1.1h0c0 123.7-100.3 224-224 224h-1.1H256h-.6C132 480 32 380 32 256.6V256 216.8c-10.1-14.6-16-32.3-16-51.4V144l0-1.4C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24h2.8C44.8 58.2 83.3 32 128 32h64c44.7 0 83.2 26.2 101.2 64H296c13.3 0 24 10.7 24 24c0 10.5-6.7 19.3-16 22.6l0 1.4v21.4c0 1.4 0 2.8-.1 4.3c12-6.2 25.7-9.6 40.1-9.6h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-13.3 0-24 10.7-24 24v8h56.4c-15.2 17-24.4 39.4-24.4 64H320c-42.3 0-78.2-27.4-91-65.3c-5.1 .9-10.3 1.3-15.6 1.3c-14.1 0-27.9-3.3-40.5-9.6zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var $5c8203742f0e3062$export$27f7383b96c3f4b4 = {
    prefix: "fas",
    iconName: "person-dress",
    icon: [
        320,
        512,
        [
            "female"
        ],
        "f182",
        "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM88 384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2c20.3-33.7 56.7-54.3 96-54.3h11.6c39.3 0 75.7 20.6 96 54.3l53.6 89.2c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9l-33.9-56.3L265 362.9c3.5 10.4-4.3 21.1-15.2 21.1H232v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H152v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"
    ]
};
var $5c8203742f0e3062$export$70e8e75e61dd7169 = $5c8203742f0e3062$export$27f7383b96c3f4b4;
var $5c8203742f0e3062$export$7a088030853df12c = {
    prefix: "fas",
    iconName: "comment-dollar",
    icon: [
        512,
        512,
        [],
        "f651",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm20-312v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V344c0 11-9 20-20 20s-20-9-20-20V329.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V136c0-11 9-20 20-20s20 9 20 20z"
    ]
};
var $5c8203742f0e3062$export$694b7e88782dec12 = {
    prefix: "fas",
    iconName: "business-time",
    icon: [
        640,
        512,
        [
            "briefcase-clock"
        ],
        "f64a",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 352h8.2c32.3-39.1 81.1-64 135.8-64c5.4 0 10.7 .2 16 .7V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM320 352H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H360.2C335.1 449.6 320 410.5 320 368c0-5.4 .2-10.7 .7-16l-.7 0zm320 16a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$8b00ae94743552ce = $5c8203742f0e3062$export$694b7e88782dec12;
var $5c8203742f0e3062$export$d2bcaf492dfb3817 = {
    prefix: "fas",
    iconName: "table-cells-large",
    icon: [
        512,
        512,
        [
            "th-large"
        ],
        "f009",
        "M448 96V224H288V96H448zm0 192V416H288V288H448zM224 224H64V96H224V224zM64 288H224V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $5c8203742f0e3062$export$69782f333e90cdc6 = $5c8203742f0e3062$export$d2bcaf492dfb3817;
var $5c8203742f0e3062$export$24c764717169f536 = {
    prefix: "fas",
    iconName: "book-tanakh",
    icon: [
        448,
        512,
        [
            "tanakh"
        ],
        "f827",
        "M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM138.7 208l13.9 24H124.9l13.9-24zm-13.9-24L97.1 232c-6.2 10.7 1.5 24 13.9 24h55.4l27.7 48c6.2 10.7 21.6 10.7 27.7 0l27.7-48H305c12.3 0 20-13.3 13.9-24l-27.7-48 27.7-48c6.2-10.7-1.5-24-13.9-24H249.6L221.9 64c-6.2-10.7-21.6-10.7-27.7 0l-27.7 48H111c-12.3 0-20 13.3-13.9 24l27.7 48zm27.7 0l27.7-48h55.4l27.7 48-27.7 48H180.3l-27.7-48zm0-48l-13.9 24-13.9-24h27.7zm41.6-24L208 88l13.9 24H194.1zm69.3 24h27.7l-13.9 24-13.9-24zm13.9 72l13.9 24H263.4l13.9-24zm-55.4 48L208 280l-13.9-24h27.7z"
    ]
};
var $5c8203742f0e3062$export$7fd4a58929315448 = $5c8203742f0e3062$export$24c764717169f536;
var $5c8203742f0e3062$export$c377f240bb8b5d74 = {
    prefix: "fas",
    iconName: "phone-volume",
    icon: [
        512,
        512,
        [
            "volume-control-phone"
        ],
        "f2a0",
        "M280 0C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z"
    ]
};
var $5c8203742f0e3062$export$5358d004fa3d3be2 = $5c8203742f0e3062$export$c377f240bb8b5d74;
var $5c8203742f0e3062$export$ab6f71fd6878da90 = {
    prefix: "fas",
    iconName: "hat-cowboy-side",
    icon: [
        640,
        512,
        [],
        "f8c1",
        "M152.7 135.9l-10.4 57.2c6.8-.7 13.6-1.1 20.5-1.1h10.7c39.4 0 77.8 12.1 110.1 34.7L562.4 421.8l35.1 24.6c24.4-6 42.5-28.1 42.5-54.4c0-75.8-94.7-126.6-134.6-144.7L474 83.9C468.2 53.8 441.8 32 411.1 32h-2.7c-5.6 0-11.1 .7-16.5 2.2L199.2 85.5c-23.9 6.4-42 26-46.5 50.4zM0 384c0 35.3 28.7 64 64 64H544L265.3 252.9c-26.9-18.8-58.9-28.9-91.8-28.9H162.9c-60.6 0-116 34.2-143.1 88.4L13.5 325C4.6 342.7 0 362.3 0 382.2V384z"
    ]
};
var $5c8203742f0e3062$export$1204f2d171424659 = {
    prefix: "fas",
    iconName: "clipboard-user",
    icon: [
        384,
        512,
        [],
        "f7f3",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"
    ]
};
var $5c8203742f0e3062$export$60b41e3581d1739a = {
    prefix: "fas",
    iconName: "child",
    icon: [
        320,
        512,
        [],
        "f1ae",
        "M96 64a64 64 0 1 1 128 0A64 64 0 1 1 96 64zm48 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V287.8L59.1 321c-9.4 15-29.2 19.4-44.1 10S-4.5 301.9 4.9 287l39.9-63.3C69.7 184 113.2 160 160 160s90.3 24 115.2 63.6L315.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L240 287.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H144z"
    ]
};
var $5c8203742f0e3062$export$f0f37dbc60110b10 = {
    prefix: "fas",
    iconName: "lira-sign",
    icon: [
        320,
        512,
        [
            8356
        ],
        "f195",
        "M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H46c-2.2 10.5-6.1 20.6-11.7 29.9L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1c11.6-19.3 18.9-40.7 21.6-62.9H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V256H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V160.4z"
    ]
};
var $5c8203742f0e3062$export$da3f1730d013e224 = {
    prefix: "fas",
    iconName: "satellite",
    icon: [
        512,
        512,
        [
            128752
        ],
        "f7bf",
        "M233 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9l89.4 89.4-15.5 15.5C152.3 230.4 124.9 224 96 224c-31.7 0-61.5 7.7-87.8 21.2c-9 4.7-10.3 16.7-3.1 23.8L112.7 376.7 96.3 393.1c-2.6-.7-5.4-1.1-8.3-1.1c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3l16.4-16.4L242.9 506.9c7.2 7.2 19.2 5.9 23.8-3.1C280.3 477.5 288 447.7 288 416c0-28.9-6.4-56.3-17.8-80.9l15.5-15.5L375 409c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9l-89.4-89.4 55-55c12.5-12.5 12.5-32.8 0-45.3l-48-48c-12.5-12.5-32.8-12.5-45.3 0l-55 55L233 7zm159 351l-72.4-72.4 62.1-62.1L454.1 296 392 358.1zM226.3 192.4L153.9 120 216 57.9l72.4 72.4-62.1 62.1z"
    ]
};
var $5c8203742f0e3062$export$1125ac57be52258c = {
    prefix: "fas",
    iconName: "plane-lock",
    icon: [
        640,
        512,
        [],
        "e558",
        "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7v84.6l101.8 58.2C418 247.6 416 259.6 416 272v24.6c-17.9 10.4-30.3 29.1-31.8 50.9L320 329.1V400l57.6 43.2c4 3 6.4 7.8 6.4 12.8v24 18c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400l0-70.9-171.6 49C10.2 381.1 0 373.4 0 362.8V297.3c0-5.7 3.1-11 8.1-13.9L192 178.3V93.7zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $5c8203742f0e3062$export$cb61f447f29887e = {
    prefix: "fas",
    iconName: "tag",
    icon: [
        448,
        512,
        [
            127991
        ],
        "f02b",
        "M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$805cd88398a70581 = {
    prefix: "fas",
    iconName: "comment",
    icon: [
        512,
        512,
        [
            128489,
            61669
        ],
        "f075",
        "M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4l0 0 0 0 0 0 0 0 .3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z"
    ]
};
var $5c8203742f0e3062$export$e4019fe302a972e1 = {
    prefix: "fas",
    iconName: "cake-candles",
    icon: [
        448,
        512,
        [
            127874,
            "birthday-cake",
            "cake"
        ],
        "f1fd",
        "M86.4 5.5L61.8 47.6C58 54.1 56 61.6 56 69.2V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L105.6 5.5C103.6 2.1 100 0 96 0s-7.6 2.1-9.6 5.5zm128 0L189.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L233.6 5.5C231.6 2.1 228 0 224 0s-7.6 2.1-9.6 5.5zM317.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L361.6 5.5C359.6 2.1 356 0 352 0s-7.6 2.1-9.6 5.5L317.8 47.6zM128 176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c-35.3 0-64 28.7-64 64v71c8.3 5.2 18.1 9 28.8 9c13.5 0 27.2-6.1 38.4-13.4c5.4-3.5 9.9-7.1 13-9.7c1.5-1.3 2.7-2.4 3.5-3.1c.4-.4 .7-.6 .8-.8l.1-.1 0 0 0 0s0 0 0 0s0 0 0 0c3.1-3.2 7.4-4.9 11.9-4.8s8.6 2.1 11.6 5.4l0 0 0 0 .1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c3-3.5 7.4-5.4 12-5.4s9 2 12 5.4l.1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c2.9-3.4 7.1-5.3 11.6-5.4s8.7 1.6 11.9 4.8l0 0 0 0 0 0 .1 .1c.2 .2 .4 .4 .8 .8c.8 .7 1.9 1.8 3.5 3.1c3.1 2.6 7.5 6.2 13 9.7c11.2 7.3 24.9 13.4 38.4 13.4c10.7 0 20.5-3.9 28.8-9V288c0-35.3-28.7-64-64-64V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H256V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H128V176zM448 394.6c-8.5 3.3-18.2 5.4-28.8 5.4c-22.5 0-42.4-9.9-55.8-18.6c-4.1-2.7-7.8-5.4-10.9-7.8c-2.8 2.4-6.1 5-9.8 7.5C329.8 390 310.6 400 288 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2c-2.7 2.3-5.9 4.7-9.4 7.2C201.8 390 182.6 400 160 400s-41.8-10-54.6-18.9c-3.7-2.6-7-5.2-9.8-7.5c-3.1 2.4-6.8 5.1-10.9 7.8C71.2 390.1 51.3 400 28.8 400c-10.6 0-20.3-2.2-28.8-5.4V480c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V394.6z"
    ]
};
var $5c8203742f0e3062$export$bdcf98f725a7241a = $5c8203742f0e3062$export$e4019fe302a972e1;
var $5c8203742f0e3062$export$707bc1c80c0177c1 = $5c8203742f0e3062$export$e4019fe302a972e1;
var $5c8203742f0e3062$export$6f095630677adc = {
    prefix: "fas",
    iconName: "envelope",
    icon: [
        512,
        512,
        [
            128386,
            9993,
            61443
        ],
        "f0e0",
        "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"
    ]
};
var $5c8203742f0e3062$export$152ef92a4f9d80a7 = {
    prefix: "fas",
    iconName: "angles-up",
    icon: [
        448,
        512,
        [
            "angle-double-up"
        ],
        "f102",
        "M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 361.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zm160 352l-160-160c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 301.3 361.4 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
    ]
};
var $5c8203742f0e3062$export$9bb51e1a2c07db7c = $5c8203742f0e3062$export$152ef92a4f9d80a7;
var $5c8203742f0e3062$export$4b24ca1552f410af = {
    prefix: "fas",
    iconName: "paperclip",
    icon: [
        448,
        512,
        [
            128206
        ],
        "f0c6",
        "M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z"
    ]
};
var $5c8203742f0e3062$export$e201217e5046cd15 = {
    prefix: "fas",
    iconName: "arrow-right-to-city",
    icon: [
        640,
        512,
        [],
        "e4b3",
        "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM166.6 153.4l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L146.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H146.7l-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"
    ]
};
var $5c8203742f0e3062$export$838459d11f3971df = {
    prefix: "fas",
    iconName: "ribbon",
    icon: [
        448,
        512,
        [
            127895
        ],
        "f4d6",
        "M333.2 322.8l0 0-133.9-146 0 0L146 118.6c7.8-5.1 37-22.6 78-22.6s70.2 17.4 78 22.6L245.7 180l85.6 93.4 27.4-29.8c16.3-17.7 25.3-40.9 25.3-65V149.1c0-19-5.6-37.5-16.1-53.3L327.8 35.6C312.9 13.4 287.9 0 261.2 0h-76c-25.8 0-50.1 12.5-65.1 33.5L81.9 87C70.3 103.2 64 122.8 64 142.8V164c0 23.2 8.4 45.6 23.6 63.1l56 64.2 0 0 83.3 95.6 0 0 91.8 105.3c10 11.5 26.8 14.3 40 6.8l54.5-31.1c17.8-10.2 21.6-34.3 7.7-49.4l-87.7-95.7zM205.2 410.6l-83.3-95.6L27.1 418.5c-13.9 15.1-10.1 39.2 7.7 49.4l55.1 31.5c13 7.4 29.3 4.9 39.4-6.1l75.9-82.6z"
    ]
};
var $5c8203742f0e3062$export$ba9b387e84727819 = {
    prefix: "fas",
    iconName: "lungs",
    icon: [
        640,
        512,
        [
            129729
        ],
        "f604",
        "M320 0c17.7 0 32 14.3 32 32V164.1c0 16.4 8.4 31.7 22.2 40.5l9.8 6.2V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2C414 480.5 384 442.1 384 398V325l90.5 57.6c7.5 4.7 17.3 2.5 22.1-4.9s2.5-17.3-4.9-22.1L384 287.1v-.4l-44.1-28.1c-7.3-4.6-13.9-10.1-19.9-16.1c-5.9 6-12.6 11.5-19.9 16.1L256 286.7 161.2 347l-13.5 8.6c0 0 0 0-.1 0c-7.4 4.8-9.6 14.6-4.8 22.1c4.7 7.5 14.6 9.7 22.1 4.9l91.1-58V398c0 44.1-30 82.5-72.7 93.1l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v45.5l9.8-6.2c13.8-8.8 22.2-24.1 22.2-40.5V32c0-17.7 14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$25218e5886296cb9 = {
    prefix: "fas",
    iconName: "arrow-up-9-1",
    icon: [
        576,
        512,
        [
            "sort-numeric-up-alt"
        ],
        "f887",
        "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM450.7 294c8.3 6 13.3 15.7 13.3 26v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V364.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zm-5-145.1A32 32 0 1 0 418.3 91a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 192.4 344 159.2 344 120c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 251c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
    ]
};
var $5c8203742f0e3062$export$d41859f1bbb9e086 = $5c8203742f0e3062$export$25218e5886296cb9;
var $5c8203742f0e3062$export$4a157bd81dcd8d80 = {
    prefix: "fas",
    iconName: "litecoin-sign",
    icon: [
        384,
        512,
        [],
        "e1d3",
        "M128 64c0-17.7-14.3-32-32-32S64 46.3 64 64V213.6L23.2 225.2c-17 4.9-26.8 22.6-22 39.6s22.6 26.8 39.6 22L64 280.1V448c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V261.9l136.8-39.1c17-4.9 26.8-22.6 22-39.6s-22.6-26.8-39.6-22L128 195.3V64z"
    ]
};
var $5c8203742f0e3062$export$2b488402ec335d97 = {
    prefix: "fas",
    iconName: "border-none",
    icon: [
        448,
        512,
        [],
        "f850",
        "M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
    ]
};
var $5c8203742f0e3062$export$de462dd5a18e80d4 = {
    prefix: "fas",
    iconName: "circle-nodes",
    icon: [
        512,
        512,
        [],
        "e4e2",
        "M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80c-43.4 0-78.7 34.5-80 77.5L136.2 151.1C121.7 136.8 101.9 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6L259.7 407.8c-2.4 7.6-3.7 15.8-3.7 24.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7zM156.3 232.2c2.2-6.9 3.5-14.2 3.7-21.7l183.8-73.5c3.6 3.5 7.4 6.7 11.6 9.5L317.6 354.1c-5.5 1.3-10.8 3.1-15.8 5.5L156.3 232.2z"
    ]
};
var $5c8203742f0e3062$export$ca9e3368f1d9500a = {
    prefix: "fas",
    iconName: "parachute-box",
    icon: [
        512,
        512,
        [],
        "f4cd",
        "M383.5 192c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16H240V320H208c-7 0-13.7 1.5-19.7 4.2L68.2 192H96.5c-.3-5.3-.5-10.6-.5-16c0-64 22.2-121.2 57.1-159.3C62 49.3 18.6 122.6 4.2 173.6C1.5 183.1 9 192 18.9 192h6L165.2 346.3c-3.3 6.5-5.2 13.9-5.2 21.7v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V368c0-7.8-1.9-15.2-5.2-21.7L487.1 192h6c9.9 0 17.4-8.9 14.7-18.4C493.4 122.6 450 49.3 358.9 16.7C393.8 54.8 416 112.1 416 176c0 5.4-.2 10.7-.5 16h28.3L323.7 324.2c-6-2.7-12.7-4.2-19.7-4.2H272V192H383.5z"
    ]
};
var $5c8203742f0e3062$export$318208bc30aeebcc = {
    prefix: "fas",
    iconName: "indent",
    icon: [
        448,
        512,
        [],
        "f03c",
        "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM127.8 268.6L25.8 347.9C15.3 356.1 0 348.6 0 335.3V176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3c8.2 6.4 8.2 18.9 0 25.3z"
    ]
};
var $5c8203742f0e3062$export$40cb0a4a3a74dc03 = {
    prefix: "fas",
    iconName: "truck-field-un",
    icon: [
        640,
        512,
        [],
        "e58e",
        "M96 32C60.7 32 32 60.7 32 96v32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288c0-35.3-28.7-64-64-64h-4.2c-.4-1.1-.9-2.1-1.3-3.2L485.7 102c-10.3-23.1-33.2-38-58.5-38H375.4C364.4 44.9 343.7 32 320 32H96zm288 96h43.2l42.7 96H384V128zM112 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM253.3 135.1l34.7 52V144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $5c8203742f0e3062$export$b9098a890f61e022 = {
    prefix: "fas",
    iconName: "hourglass",
    icon: [
        384,
        512,
        [
            9203,
            62032,
            "hourglass-empty"
        ],
        "f254",
        "M0 32C0 14.3 14.3 0 32 0H64 320h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V75c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1v11c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V437c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1C48.9 158.1 32 117.4 32 75V64C14.3 64 0 49.7 0 32zM96 64V75c0 25.5 10.1 49.9 28.1 67.9L192 210.7l67.9-67.9c18-18 28.1-42.4 28.1-67.9V64H96zm0 384H288V437c0-25.5-10.1-49.9-28.1-67.9L192 301.3l-67.9 67.9c-18 18-28.1 42.4-28.1 67.9v11z"
    ]
};
var $5c8203742f0e3062$export$a2f8176a0161e891 = $5c8203742f0e3062$export$b9098a890f61e022;
var $5c8203742f0e3062$export$64f9eb99c9749cce = {
    prefix: "fas",
    iconName: "mountain",
    icon: [
        512,
        512,
        [
            127956
        ],
        "f6fc",
        "M256 32c12.5 0 24.1 6.4 30.8 17L503.4 394.4c5.6 8.9 8.6 19.2 8.6 29.7c0 30.9-25 55.9-55.9 55.9H55.9C25 480 0 455 0 424.1c0-10.5 3-20.8 8.6-29.7L225.2 49c6.6-10.6 18.3-17 30.8-17zm65 192L256 120.4 176.9 246.5l18.3 24.4c6.4 8.5 19.2 8.5 25.6 0l25.6-34.1c6-8.1 15.5-12.8 25.6-12.8h49z"
    ]
};
var $5c8203742f0e3062$export$9884bf227eeb829 = {
    prefix: "fas",
    iconName: "user-doctor",
    icon: [
        448,
        512,
        [
            "user-md"
        ],
        "f0f0",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16V424c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V424c0-29.8 20.4-54.9 48-62V304.9c-6-.6-12.1-.9-18.3-.9H178.3c-6.2 0-12.3 .3-18.3 .9v65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V311.2zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $5c8203742f0e3062$export$ab0d33a2c03f1794 = $5c8203742f0e3062$export$9884bf227eeb829;
var $5c8203742f0e3062$export$317f99f46b39906e = {
    prefix: "fas",
    iconName: "circle-info",
    icon: [
        512,
        512,
        [
            "info-circle"
        ],
        "f05a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$aa9288aeadf882fa = $5c8203742f0e3062$export$317f99f46b39906e;
var $5c8203742f0e3062$export$5d120e8b87ad33f4 = {
    prefix: "fas",
    iconName: "cloud-meatball",
    icon: [
        512,
        512,
        [],
        "f73b",
        "M0 224c0 53 43 96 96 96h44.7c9.5-23.5 32.5-40 59.3-40c2 0 3.9 .1 5.8 .3C217.6 265.5 235.7 256 256 256s38.4 9.5 50.2 24.3c1.9-.2 3.9-.3 5.8-.3c26.9 0 49.9 16.5 59.3 40H416c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 1 .1 2.1 .1 3.1c-.7-.8-1.4-1.6-2.1-2.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3c.7 .7 1.5 1.4 2.3 2.1c-1-.1-2.1-.1-3.1-.1c-17.7 0-32 14.3-32 32s14.3 32 32 32c1 0 2.1-.1 3.1-.1c-.8 .7-1.6 1.3-2.3 2.1c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0c.7-.7 1.4-1.5 2.1-2.3c-.1 1-.1 2.1-.1 3.1c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1-.1-2.1-.1-3.1c.7 .8 1.3 1.6 2.1 2.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3c-.7-.7-1.5-1.4-2.3-2.1c1 .1 2.1 .1 3.1 .1c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1 0-2.1 .1-3.1 .1c.8-.7 1.6-1.3 2.3-2.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-.7 .7-1.4 1.5-2.1 2.3c.1-1 .1-2.1 .1-3.1zM48 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm416 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $5c8203742f0e3062$export$84ffbd7161ca2008 = {
    prefix: "fas",
    iconName: "camera",
    icon: [
        512,
        512,
        [
            62258,
            "camera-alt"
        ],
        "f030",
        "M149.1 64.8L138.7 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H373.3L362.9 64.8C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $5c8203742f0e3062$export$8872b5664e88e793 = $5c8203742f0e3062$export$84ffbd7161ca2008;
var $5c8203742f0e3062$export$f9409a7b020dbec4 = {
    prefix: "fas",
    iconName: "square-virus",
    icon: [
        448,
        512,
        [],
        "e578",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM223.8 93.7c13.3 0 24 10.7 24 24c0 29.3 35.4 43.9 56.1 23.2c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1c-13.3 0-24-10.7-24-24s10.7-24 24-24c29.3 0 43.9-35.4 23.2-56.1c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2c0-13.3 10.7-24 24-24zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $5c8203742f0e3062$export$1439f0d6365138da = {
    prefix: "fas",
    iconName: "meteor",
    icon: [
        512,
        512,
        [
            9732
        ],
        "f753",
        "M493.7 .9L299.4 75.6l2.3-29.3c1-12.8-12.8-21.5-24-15.1L101.3 133.4C38.6 169.7 0 236.6 0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L480.8 234.3c6.5-11.1-2.2-25-15.1-24l-29.3 2.3L511.1 18.3c.6-1.5 .9-3.2 .9-4.8C512 6 506 0 498.5 0c-1.7 0-3.3 .3-4.8 .9zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $5c8203742f0e3062$export$d901d50df5cf8d91 = {
    prefix: "fas",
    iconName: "car-on",
    icon: [
        512,
        512,
        [],
        "e4dd",
        "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM185.8 224H326.2c6.8 0 12.8 4.3 15.1 10.6L360.3 288H151.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9L82.2 292.4C62.1 300.9 48 320.8 48 344v40 64 32c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V448H384v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 384 344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C390.1 181.3 360 160 326.2 160H185.8c-33.8 0-64 21.3-75.3 53.1zM128 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM39 39c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L73 39c-9.4-9.4-24.6-9.4-33.9 0zm400 0L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"
    ]
};
var $5c8203742f0e3062$export$26a8fd1143d2d6c0 = {
    prefix: "fas",
    iconName: "sleigh",
    icon: [
        640,
        512,
        [],
        "f7cc",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V256c0 53 43 96 96 96v32h64V352H384v32h64V352c53 0 96-43 96-96V160c17.7 0 32-14.3 32-32s-14.3-32-32-32H512 480c-17.7 0-32 14.3-32 32v41.3c0 30.2-24.5 54.7-54.7 54.7c-75.5 0-145.6-38.9-185.6-102.9l-4.3-6.9C174.2 67.6 125 37.6 70.7 32.7c-2.2-.5-4.4-.7-6.7-.7H55 32zM640 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v8c0 13.3-10.7 24-24 24H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H552c48.6 0 88-39.4 88-88v-8z"
    ]
};
var $5c8203742f0e3062$export$9a40d582bd4628fb = {
    prefix: "fas",
    iconName: "arrow-down-1-9",
    icon: [
        576,
        512,
        [
            "sort-numeric-asc",
            "sort-numeric-down"
        ],
        "f162",
        "M450.7 38c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V64c0-10.3-4.9-19.9-13.3-26zM160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM418.3 307a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 307zM405.1 419.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
    ]
};
var $5c8203742f0e3062$export$a4fb1aa2cdfb18d7 = $5c8203742f0e3062$export$9a40d582bd4628fb;
var $5c8203742f0e3062$export$835db7eb35b3c29b = $5c8203742f0e3062$export$9a40d582bd4628fb;
var $5c8203742f0e3062$export$b9c3f9a906f96b82 = {
    prefix: "fas",
    iconName: "hand-holding-droplet",
    icon: [
        576,
        512,
        [
            "hand-holding-water"
        ],
        "f4c1",
        "M275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3V160c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3L275.5 6.6zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $5c8203742f0e3062$export$4265371b99d38b95 = $5c8203742f0e3062$export$b9c3f9a906f96b82;
var $5c8203742f0e3062$export$efaeddad0a6e901b = {
    prefix: "fas",
    iconName: "water",
    icon: [
        576,
        512,
        [],
        "f773",
        "M269.5 69.9c11.1-7.9 25.9-7.9 37 0C329 85.4 356.5 96 384 96c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 149.7 417 160 384 160c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4C42.8 92.6 61 83.5 75.3 71.6c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 85.2 165.1 96 192 96c27.5 0 55-10.6 77.5-26.1zm37 288C329 373.4 356.5 384 384 384c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 437.7 417 448 384 448c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 373.2 165.1 384 192 384c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0zm0-144C329 229.4 356.5 240 384 240c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 293.7 417 304 384 304c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 229.2 165.1 240 192 240c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $5c8203742f0e3062$export$5655108e1162ba45 = {
    prefix: "fas",
    iconName: "calendar-check",
    icon: [
        448,
        512,
        [],
        "f274",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z"
    ]
};
var $5c8203742f0e3062$export$983e9c27cac7ed1c = {
    prefix: "fas",
    iconName: "braille",
    icon: [
        640,
        512,
        [],
        "f2a1",
        "M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zM224 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM80 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM352 96a64 64 0 1 1 128 0A64 64 0 1 1 352 96zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0A64 64 0 1 1 512 96zm64 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM416 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
var $5c8203742f0e3062$export$99cfe064ff0b71c9 = {
    prefix: "fas",
    iconName: "prescription-bottle-medical",
    icon: [
        384,
        512,
        [
            "prescription-bottle-alt"
        ],
        "f486",
        "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zM160 240v48H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V352h48c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
    ]
};
var $5c8203742f0e3062$export$65d1c884b8581d1a = $5c8203742f0e3062$export$99cfe064ff0b71c9;
var $5c8203742f0e3062$export$2bebc54c51db6505 = {
    prefix: "fas",
    iconName: "landmark",
    icon: [
        512,
        512,
        [
            127963
        ],
        "f66f",
        "M240.1 4.2c9.8-5.6 21.9-5.6 31.8 0l171.8 98.1L448 104l0 .9 47.9 27.4c12.6 7.2 18.8 22 15.1 36s-16.4 23.8-30.9 23.8H32c-14.5 0-27.2-9.8-30.9-23.8s2.5-28.8 15.1-36L64 104.9V104l4.4-1.6L240.1 4.2zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"
    ]
};
var $5c8203742f0e3062$export$d7895f386f8bd8b8 = {
    prefix: "fas",
    iconName: "truck",
    icon: [
        640,
        512,
        [
            128666,
            9951
        ],
        "f0d1",
        "M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $5c8203742f0e3062$export$721c101130c40043 = {
    prefix: "fas",
    iconName: "crosshairs",
    icon: [
        512,
        512,
        [],
        "f05b",
        "M256 0c17.7 0 32 14.3 32 32V42.4c93.7 13.9 167.7 88 181.6 181.6H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H469.6c-13.9 93.7-88 167.7-181.6 181.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V469.6C130.3 455.7 56.3 381.7 42.4 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H42.4C56.3 130.3 130.3 56.3 224 42.4V32c0-17.7 14.3-32 32-32zM107.4 288c12.5 58.3 58.4 104.1 116.6 116.6V384c0-17.7 14.3-32 32-32s32 14.3 32 32v20.6c58.3-12.5 104.1-58.4 116.6-116.6H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h20.6C392.1 165.7 346.3 119.9 288 107.4V128c0 17.7-14.3 32-32 32s-32-14.3-32-32V107.4C165.7 119.9 119.9 165.7 107.4 224H128c17.7 0 32 14.3 32 32s-14.3 32-32 32H107.4zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$c48422e9da776c1b = {
    prefix: "fas",
    iconName: "person-cane",
    icon: [
        448,
        512,
        [],
        "e53c",
        "M272 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-8 187.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3zM352 376c0-4.4 3.6-8 8-8s8 3.6 8 8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V376c0-30.9-25.1-56-56-56s-56 25.1-56 56v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8z"
    ]
};
var $5c8203742f0e3062$export$e5075400db564e24 = {
    prefix: "fas",
    iconName: "tent",
    icon: [
        576,
        512,
        [],
        "e57d",
        "M269.4 6C280.5-2 295.5-2 306.6 6l224 160c7.4 5.3 12.2 13.5 13.2 22.5l32 288c1 9-1.9 18.1-8 24.9s-14.7 10.7-23.8 10.7H464 435.8c-12.1 0-23.2-6.8-28.6-17.7L306.7 293.5c-1.7-3.4-5.1-5.5-8.8-5.5c-5.5 0-9.9 4.4-9.9 9.9V480c0 17.7-14.3 32-32 32H240 32c-9.1 0-17.8-3.9-23.8-10.7s-9-15.8-8-24.9l32-288c1-9 5.8-17.2 13.2-22.5L269.4 6z"
    ]
};
var $5c8203742f0e3062$export$750a64470c2e0f3f = {
    prefix: "fas",
    iconName: "vest-patches",
    icon: [
        448,
        512,
        [],
        "e086",
        "M151.2 69.7l55.9 167.7-11 33.1c-2.7 8.2-4.1 16.7-4.1 25.3V464c0 14.5 3.9 28.2 10.7 39.9C195 509 185.9 512 176 512H48c-26.5 0-48-21.5-48-48V270.5c0-9.5 2.8-18.7 8.1-26.6l47.9-71.8c5.3-7.9 8.1-17.1 8.1-26.6V128 54.3 48C64 21.5 85.5 0 112 0h4.5c.2 0 .4 0 .6 0c.4 0 .8 0 1.2 0c18.8 0 34.1 9.7 44.1 18.8C171.6 27.2 190.8 40 224 40s52.4-12.8 61.7-21.2C295.7 9.7 311 0 329.7 0c.4 0 .8 0 1.2 0c.2 0 .4 0 .6 0H336c26.5 0 48 21.5 48 48v6.3V128v17.5c0 9.5 2.8 18.7 8.1 26.6l47.9 71.8c5.3 7.9 8.1 17.1 8.1 26.6V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V295.8c0-5.2 .8-10.3 2.5-15.2L296.8 69.7C279.4 79.7 255.4 88 224 88s-55.4-8.3-72.8-18.3zM96 456a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM63.5 255.5c-4.7 4.7-4.7 12.3 0 17L79 288 63.5 303.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L96 305l15.5 15.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L113 288l15.5-15.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L96 271 80.5 255.5c-4.7-4.7-12.3-4.7-17 0zM304 280v8 32c0 8.8 7.2 16 16 16h32 8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $5c8203742f0e3062$export$f178c8c2ad3cc861 = {
    prefix: "fas",
    iconName: "check-double",
    icon: [
        448,
        512,
        [],
        "f560",
        "M342.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 178.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l160-160zm96 128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7 54.6 297.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l256-256z"
    ]
};
var $5c8203742f0e3062$export$43b642fac7053978 = {
    prefix: "fas",
    iconName: "arrow-down-a-z",
    icon: [
        576,
        512,
        [
            "sort-alpha-asc",
            "sort-alpha-down"
        ],
        "f15d",
        "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 320c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 416H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 352H352c-17.7 0-32-14.3-32-32zM416 32c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 224H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128C392.8 38.8 403.9 32 416 32zM395.8 176h40.4L416 135.6 395.8 176z"
    ]
};
var $5c8203742f0e3062$export$cb87697f2fa77cfc = $5c8203742f0e3062$export$43b642fac7053978;
var $5c8203742f0e3062$export$7658045270aafde3 = $5c8203742f0e3062$export$43b642fac7053978;
var $5c8203742f0e3062$export$6a4ef2ef77625063 = {
    prefix: "fas",
    iconName: "money-bill-wheat",
    icon: [
        512,
        512,
        [],
        "e52a",
        "M176 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zM56 16h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56C42.7 64 32 53.3 32 40s10.7-24 24-24zM24 88H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24S10.7 88 24 88zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 16c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80zM400 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zm80 144c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 128c8.8 0 16 7.2 16 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-96 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $5c8203742f0e3062$export$b3e64f5f68c6623f = {
    prefix: "fas",
    iconName: "cookie",
    icon: [
        512,
        512,
        [
            127850
        ],
        "f563",
        "M247.2 17c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9l-14.6-82.8c-3.9-22.1-14.6-42.3-30.7-57.9L388.9 57.5c-16.1-15.6-36.6-25.6-58.7-28.7L247.2 17zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$89b706873769c180 = {
    prefix: "fas",
    iconName: "arrow-rotate-left",
    icon: [
        512,
        512,
        [
            8634,
            "arrow-left-rotate",
            "arrow-rotate-back",
            "arrow-rotate-backward",
            "undo"
        ],
        "f0e2",
        "M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"
    ]
};
var $5c8203742f0e3062$export$1aea864c3e1d79b = $5c8203742f0e3062$export$89b706873769c180;
var $5c8203742f0e3062$export$a34701878babe5fc = $5c8203742f0e3062$export$89b706873769c180;
var $5c8203742f0e3062$export$fce381d12e4535cd = $5c8203742f0e3062$export$89b706873769c180;
var $5c8203742f0e3062$export$a5e5ba60b1dfe2b2 = $5c8203742f0e3062$export$89b706873769c180;
var $5c8203742f0e3062$export$4cb736b866cbb7ec = {
    prefix: "fas",
    iconName: "hard-drive",
    icon: [
        512,
        512,
        [
            128436,
            "hdd"
        ],
        "f0a0",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V280.4c-17-15.2-39.4-24.4-64-24.4H64c-24.6 0-47 9.2-64 24.4V96zM64 288H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64zM320 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $5c8203742f0e3062$export$62551e9c5ba7093f = $5c8203742f0e3062$export$4cb736b866cbb7ec;
var $5c8203742f0e3062$export$8ff56f5ebb8416a0 = {
    prefix: "fas",
    iconName: "face-grin-squint-tears",
    icon: [
        512,
        512,
        [
            129315,
            "grin-squint-tears"
        ],
        "f586",
        "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-6.8 6.8-21.4 12.4-37.4 16.7c-16.3 4.4-34.1 7.5-46.3 9.3c-1.6 .2-3.1 .5-4.6 .6c-5.6 .9-10.3-3.9-9.5-9.5c1.6-11.2 4.6-29.6 9-47c.3-1.3 .7-2.6 1-3.9c4.3-15.9 9.8-30.5 16.7-37.4zm-44.7 19c-1.5 4.8-2.9 9.6-4.1 14.3c-4.8 18.9-8 38.5-9.7 50.3c-4 26.8 18.9 49.7 45.7 45.8c11.9-1.6 31.5-4.8 50.4-9.7c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c4.8-18.9 8-38.5 9.7-50.3c4-26.8-18.9-49.7-45.7-45.8c-11.9 1.6-31.5 4.8-50.4 9.7c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75C158.2-8.3 284.5-22.2 382.2 33.2zM51.5 410.1c18.5-5 38.8-8.3 50.9-10c5.6-.9 10.3 3.9 9.5 9.5c-1.7 12.1-5 32.4-10 50.9C97.6 476.4 92 491 85.2 497.8C66 517 34.5 516.6 14.9 497.1s-20-51-.7-70.3c6.8-6.8 21.4-12.4 37.4-16.7zM416.4 202.3c-4.8-11.9-20.9-10.9-26.9 .4c-19.4 36.7-46.3 73.2-79.8 106.7s-70 60.3-106.7 79.8c-11.3 6-12.3 22.1-.4 26.9c59.4 24.1 129.9 12.2 177.9-35.8s59.9-118.5 35.8-177.9zM87.1 285.1c2 2 4.6 3.2 7.3 3.4l56.1 5.1 5.1 56.1c.3 2.8 1.5 5.4 3.4 7.3c6.3 6.3 17.2 3.6 19.8-4.9l29.7-97.4c3.5-11.6-7.3-22.5-19-19L92 265.3c-8.6 2.6-11.3 13.4-4.9 19.8zM265.3 92l-29.7 97.4c-3.5 11.6 7.3 22.5 19 19l97.4-29.7c8.6-2.6 11.3-13.4 4.9-19.8c-2-2-4.6-3.2-7.3-3.4l-56.1-5.1-5.1-56.1c-.3-2.8-1.5-5.4-3.4-7.3c-6.3-6.3-17.2-3.6-19.8 4.9z"
    ]
};
var $5c8203742f0e3062$export$542206d6a85f3b42 = $5c8203742f0e3062$export$8ff56f5ebb8416a0;
var $5c8203742f0e3062$export$56700074cf37be5c = {
    prefix: "fas",
    iconName: "dumbbell",
    icon: [
        640,
        512,
        [],
        "f44b",
        "M96 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V224v64V448c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V384H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H96V64zm448 0v64h32c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32H544v64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V288 224 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32zM416 224v64H224V224H416z"
    ]
};
var $5c8203742f0e3062$export$1f7600fa9fdb3978 = {
    prefix: "fas",
    iconName: "rectangle-list",
    icon: [
        576,
        512,
        [
            "list-alt"
        ],
        "f022",
        "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224z"
    ]
};
var $5c8203742f0e3062$export$c6327a203ffc65a3 = $5c8203742f0e3062$export$1f7600fa9fdb3978;
var $5c8203742f0e3062$export$1585b7c3c7109751 = {
    prefix: "fas",
    iconName: "tarp-droplet",
    icon: [
        576,
        512,
        [],
        "e57c",
        "M288 160c-35.3 0-64-26.9-64-60c0-24 33.7-70.1 52.2-93.5c6.1-7.7 17.5-7.7 23.6 0C318.3 29.9 352 76 352 100c0 33.1-28.7 60-64 60zM64 128H197.5c13.2 37.3 48.7 64 90.5 64s77.4-26.7 90.5-64H512c35.3 0 64 28.7 64 64V352H448c-17.7 0-32 14.3-32 32l0 128L64 512c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zM448 512l0-128H576L448 512zM96 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$5d08d08f88a96aac = {
    prefix: "fas",
    iconName: "house-medical-circle-check",
    icon: [
        640,
        512,
        [],
        "e511",
        "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm32 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $5c8203742f0e3062$export$c8cd1786449517d3 = {
    prefix: "fas",
    iconName: "person-skiing-nordic",
    icon: [
        576,
        512,
        [
            "skiing-nordic"
        ],
        "f7ca",
        "M336 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM227.2 160c1.9 0 3.8 .1 5.6 .3L201.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9L291.3 464H202.8l41.1-88.1-32.4-20.3c-7.8-4.9-14.7-10.7-20.6-17.3L132.2 464H99.7l54.2-257.6c4.6-1.5 9-4.1 12.7-7.8l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5zM121.4 198.6c.4 .4 .8 .8 1.3 1.2L67 464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H159.3c.4 0 .9 0 1.3 0H319.3c.5 0 1 0 1.4 0H504c39.8 0 72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24H434.6l27.6-179.3c10.5-5.2 17.8-16.1 17.8-28.7c0-17.7-14.3-32-32-32H426.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c-12.5 12.5-12.5 32.8 0 45.3zm308 89.4L402.3 464H357.8l21.6-75.6c5.9-20.6-2.6-42.6-20.7-53.9L302 299l30.9-82.4 5.1 12.3C353 264.7 387.9 288 426.7 288h2.7z"
    ]
};
var $5c8203742f0e3062$export$6ea48260d7d09b1b = $5c8203742f0e3062$export$c8cd1786449517d3;
var $5c8203742f0e3062$export$16768a660ae3ca9d = {
    prefix: "fas",
    iconName: "calendar-plus",
    icon: [
        448,
        512,
        [],
        "f271",
        "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM224 248c13.3 0 24 10.7 24 24v56h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V376H144c-13.3 0-24-10.7-24-24s10.7-24 24-24h56V272c0-13.3 10.7-24 24-24z"
    ]
};
var $5c8203742f0e3062$export$9b2dbe133273f284 = {
    prefix: "fas",
    iconName: "plane-arrival",
    icon: [
        640,
        512,
        [
            128748
        ],
        "f5af",
        "M.3 166.9L0 68C0 57.7 9.5 50.1 19.5 52.3l35.6 7.9c10.6 2.3 19.2 9.9 23 20L96 128l127.3 37.6L181.8 20.4C178.9 10.2 186.6 0 197.2 0h40.1c11.6 0 22.2 6.2 27.9 16.3l109 193.8 107.2 31.7c15.9 4.7 30.8 12.5 43.7 22.8l34.4 27.6c24 19.2 18.1 57.3-10.7 68.2c-41.2 15.6-86.2 18.1-128.8 7L121.7 289.8c-11.1-2.9-21.2-8.7-29.3-16.9L9.5 189.4c-5.9-6-9.3-14.1-9.3-22.5zM32 448H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm96-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$5ae86b9da9cca3bd = {
    prefix: "fas",
    iconName: "circle-left",
    icon: [
        512,
        512,
        [
            61840,
            "arrow-alt-circle-left"
        ],
        "f359",
        "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9L117.5 269.8c-3.5-3.8-5.5-8.7-5.5-13.8s2-10.1 5.5-13.8l99.9-107.1c4.2-4.5 10.1-7.1 16.3-7.1c12.3 0 22.3 10 22.3 22.3l0 57.7 96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-96 0 0 57.7c0 12.3-10 22.3-22.3 22.3c-6.2 0-12.1-2.6-16.3-7.1z"
    ]
};
var $5c8203742f0e3062$export$5460a5b11a24996f = $5c8203742f0e3062$export$5ae86b9da9cca3bd;
var $5c8203742f0e3062$export$cda326cc3bce41c = {
    prefix: "fas",
    iconName: "train-subway",
    icon: [
        448,
        512,
        [
            "subway"
        ],
        "f239",
        "M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 128c0-17.7 14.3-32 32-32h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM272 96h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H272c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM64 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$4cabc8a12d4e2f9 = $5c8203742f0e3062$export$cda326cc3bce41c;
var $5c8203742f0e3062$export$dce43b02b3fe0c18 = {
    prefix: "fas",
    iconName: "chart-gantt",
    icon: [
        512,
        512,
        [],
        "e0e4",
        "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm96 64H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$1d2b135cc5a2c852 = {
    prefix: "fas",
    iconName: "indian-rupee-sign",
    icon: [
        320,
        512,
        [
            "indian-rupee",
            "inr"
        ],
        "e1bc",
        "M0 64C0 46.3 14.3 32 32 32H96h16H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H231.8c9.6 14.4 16.7 30.6 20.7 48H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H252.4c-13.2 58.3-61.9 103.2-122.2 110.9L274.6 422c14.4 10.3 17.7 30.3 7.4 44.6s-30.3 17.7-44.6 7.4L13.4 314C2.1 306-2.7 291.5 1.5 278.2S18.1 256 32 256h80c32.8 0 61-19.7 73.3-48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H185.3C173 115.7 144.8 96 112 96H96 32C14.3 96 0 81.7 0 64z"
    ]
};
var $5c8203742f0e3062$export$be886a4def17c565 = $5c8203742f0e3062$export$1d2b135cc5a2c852;
var $5c8203742f0e3062$export$12c6d8b3e052490b = $5c8203742f0e3062$export$1d2b135cc5a2c852;
var $5c8203742f0e3062$export$c3605731beb92daf = {
    prefix: "fas",
    iconName: "crop-simple",
    icon: [
        512,
        512,
        [
            "crop-alt"
        ],
        "f565",
        "M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H128V32zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-256c0-35.3-28.7-64-64-64L160 64v64l224 0 0 352z"
    ]
};
var $5c8203742f0e3062$export$d932915fde4f1010 = $5c8203742f0e3062$export$c3605731beb92daf;
var $5c8203742f0e3062$export$a312c7d58dd44a75 = {
    prefix: "fas",
    iconName: "money-bill-1",
    icon: [
        576,
        512,
        [
            "money-bill-alt"
        ],
        "f3d1",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm76-48c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"
    ]
};
var $5c8203742f0e3062$export$a35d573395884c3d = $5c8203742f0e3062$export$a312c7d58dd44a75;
var $5c8203742f0e3062$export$1db7e2ee10d36035 = {
    prefix: "fas",
    iconName: "left-long",
    icon: [
        512,
        512,
        [
            "long-arrow-alt-left"
        ],
        "f30a",
        "M177.5 414c-8.8 3.8-19 2-26-4.6l-144-136C2.7 268.9 0 262.6 0 256s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 72 288 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-288 0 0 72c0 9.6-5.7 18.2-14.5 22z"
    ]
};
var $5c8203742f0e3062$export$a8b3226b2bf323d = $5c8203742f0e3062$export$1db7e2ee10d36035;
var $5c8203742f0e3062$export$c062100d54a2da00 = {
    prefix: "fas",
    iconName: "dna",
    icon: [
        448,
        512,
        [
            129516
        ],
        "f471",
        "M416 0c17.7 0 32 14.3 32 32c0 59.8-30.3 107.5-69.4 146.6c-28 28-62.5 53.5-97.3 77.4l-2.5 1.7c-11.9 8.1-23.8 16.1-35.5 23.9l0 0 0 0 0 0-1.6 1c-6 4-11.9 7.9-17.8 11.9c-20.9 14-40.8 27.7-59.3 41.5H283.3c-9.8-7.4-20.1-14.7-30.7-22.1l7-4.7 3-2c15.1-10.1 30.9-20.6 46.7-31.6c25 18.1 48.9 37.3 69.4 57.7C417.7 372.5 448 420.2 448 480c0 17.7-14.3 32-32 32s-32-14.3-32-32H64c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-59.8 30.3-107.5 69.4-146.6c28-28 62.5-53.5 97.3-77.4c-34.8-23.9-69.3-49.3-97.3-77.4C30.3 139.5 0 91.8 0 32C0 14.3 14.3 0 32 0S64 14.3 64 32H384c0-17.7 14.3-32 32-32zM338.6 384H109.4c-10.1 10.6-18.6 21.3-25.5 32H364.1c-6.8-10.7-15.3-21.4-25.5-32zM109.4 128H338.6c10.1-10.7 18.6-21.3 25.5-32H83.9c6.8 10.7 15.3 21.3 25.5 32zm55.4 48c18.4 13.8 38.4 27.5 59.3 41.5c20.9-14 40.8-27.7 59.3-41.5H164.7z"
    ]
};
var $5c8203742f0e3062$export$c4ff5306c5470939 = {
    prefix: "fas",
    iconName: "virus-slash",
    icon: [
        640,
        512,
        [],
        "e075",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-154.3-121c-2-30.1 20.8-60.1 56-60.1H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H532.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L184.2 75c-12.5-12.5-32.8-12.5-45.3 0c-1.6 1.6-3.1 3.4-4.3 5.3L38.8 5.1zm225.8 177c6.9-3.9 14.9-6.1 23.4-6.1c26.5 0 48 21.5 48 48c0 4.4-.6 8.7-1.7 12.7l-69.7-54.6zM402 412.7L144.7 210c-9.5 8.5-22.2 14-37.2 14H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-31.2 23.6-52.7 50-55.7z"
    ]
};
var $5c8203742f0e3062$export$fee0376c250cdef = {
    prefix: "fas",
    iconName: "minus",
    icon: [
        448,
        512,
        [
            8211,
            8722,
            10134,
            "subtract"
        ],
        "f068",
        "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"
    ]
};
var $5c8203742f0e3062$export$f8cb2531ef1fc4a2 = $5c8203742f0e3062$export$fee0376c250cdef;
var $5c8203742f0e3062$export$442fddbbd741c590 = {
    prefix: "fas",
    iconName: "chess",
    icon: [
        512,
        512,
        [],
        "f439",
        "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V96H60.2C49.1 96 40 105.1 40 116.2c0 2.5 .5 4.9 1.3 7.3L73.8 208H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h4L60 384H196L180 256h4c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.8l32.5-84.5c.9-2.3 1.3-4.8 1.3-7.3c0-11.2-9.1-20.2-20.2-20.2H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V16zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416H48zm288 0l-43.2 57.6c-3.1 4.2-4.8 9.2-4.8 14.4c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L464 416H336zM304 208v51.9c0 7.8 2.8 15.3 8 21.1L339.2 312 337 384H462.5l-3.3-72 28.3-30.8c5.4-5.9 8.5-13.6 8.5-21.7V208c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16v16H424V208c0-8.8-7.2-16-16-16H392c-8.8 0-16 7.2-16 16v16H352V208c0-8.8-7.2-16-16-16H320c-8.8 0-16 7.2-16 16zm80 96c0-8.8 7.2-16 16-16s16 7.2 16 16v32H384V304z"
    ]
};
var $5c8203742f0e3062$export$6e5225f0e6c0bacd = {
    prefix: "fas",
    iconName: "arrow-left-long",
    icon: [
        512,
        512,
        [
            "long-arrow-left"
        ],
        "f177",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"
    ]
};
var $5c8203742f0e3062$export$80896efc906118b4 = $5c8203742f0e3062$export$6e5225f0e6c0bacd;
var $5c8203742f0e3062$export$2bd45e99b9afa947 = {
    prefix: "fas",
    iconName: "plug-circle-check",
    icon: [
        576,
        512,
        [],
        "e55c",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $5c8203742f0e3062$export$6aab6c3359c2554c = {
    prefix: "fas",
    iconName: "street-view",
    icon: [
        512,
        512,
        [],
        "f21d",
        "M320 64A64 64 0 1 0 192 64a64 64 0 1 0 128 0zm-96 96c-35.3 0-64 28.7-64 64v48c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h38.7c16.3 0 30-12.3 31.8-28.5L318.2 304H320c17.7 0 32-14.3 32-32V224c0-35.3-28.7-64-64-64H224zM132.3 394.2c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8c-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45c14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4c13.7-8.9 29.1-23.6 29.1-45c0-13.5-6.4-24.5-14-32.6c-7.5-7.9-17.3-14.3-27.8-19.6c-21-10.6-49.5-18.9-82-24.8c-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5c3.2 1.6 5.8 3.1 7.9 4.5c3.6 2.4 3.6 7.2 0 9.6c-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3c-3.6-2.4-3.6-7.2 0-9.6c2.1-1.4 4.8-2.9 7.9-4.5c15.3-7.7 38.8-14.9 69-20.5z"
    ]
};
var $5c8203742f0e3062$export$acef3e5c2029d285 = {
    prefix: "fas",
    iconName: "franc-sign",
    icon: [
        320,
        512,
        [],
        "e18f",
        "M80 32C62.3 32 48 46.3 48 64V224v96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V256H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    ]
};
var $5c8203742f0e3062$export$d94ba52e980ea0f1 = {
    prefix: "fas",
    iconName: "volume-off",
    icon: [
        320,
        512,
        [],
        "f026",
        "M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h67.8L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448V64z"
    ]
};
var $5c8203742f0e3062$export$bc43eb4655c78f49 = {
    prefix: "fas",
    iconName: "hands-asl-interpreting",
    icon: [
        640,
        512,
        [
            "american-sign-language-interpreting",
            "asl-interpreting",
            "hands-american-sign-language-interpreting"
        ],
        "f2a3",
        "M156.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L13.5 189.4C4.6 207.2 0 226.8 0 246.7V256c0 70.7 57.3 128 128 128h72 8v-.3c35.2-2.7 65.4-22.8 82.1-51.7c8.8-15.3 3.6-34.9-11.7-43.7s-34.9-3.6-43.7 11.7c-7 12-19.9 20-34.7 20c-22.1 0-40-17.9-40-40s17.9-40 40-40c14.8 0 27.7 8 34.7 20c8.8 15.3 28.4 20.5 43.7 11.7s20.5-28.4 11.7-43.7c-12.8-22.1-33.6-39.1-58.4-47.1l80.8-22c17-4.6 27.1-22.2 22.5-39.3s-22.2-27.1-39.3-22.5L194.9 124.6l81.6-68c13.6-11.3 15.4-31.5 4.1-45.1S249.1-3.9 235.5 7.4L133.6 92.3l23-46zM483.4 465.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l85.9-171.7c8.9-17.8 13.5-37.4 13.5-57.2V256c0-70.7-57.3-128-128-128H440h-8v.3c-35.2 2.7-65.4 22.8-82.1 51.7c-8.9 15.3-3.6 34.9 11.7 43.7s34.9 3.6 43.7-11.7c7-12 19.9-20 34.7-20c22.1 0 40 17.9 40 40s-17.9 40-40 40c-14.8 0-27.7-8-34.7-20c-8.9-15.3-28.4-20.5-43.7-11.7s-20.5 28.4-11.7 43.7c12.8 22.1 33.6 39.1 58.4 47.1l-80.8 22c-17.1 4.7-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5l100.7-27.5-81.6 68c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1l101.9-84.9-23 46z"
    ]
};
var $5c8203742f0e3062$export$23a7517099ab1b86 = $5c8203742f0e3062$export$bc43eb4655c78f49;
var $5c8203742f0e3062$export$beb51abfb05a4eca = $5c8203742f0e3062$export$bc43eb4655c78f49;
var $5c8203742f0e3062$export$82846008645b0301 = $5c8203742f0e3062$export$bc43eb4655c78f49;
var $5c8203742f0e3062$export$ec05accb7226d001 = {
    prefix: "fas",
    iconName: "gear",
    icon: [
        512,
        512,
        [
            9881,
            "cog"
        ],
        "f013",
        "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
    ]
};
var $5c8203742f0e3062$export$d6298bbfd1912a78 = $5c8203742f0e3062$export$ec05accb7226d001;
var $5c8203742f0e3062$export$1d6c5a49025d720b = {
    prefix: "fas",
    iconName: "droplet-slash",
    icon: [
        640,
        512,
        [
            "tint-slash"
        ],
        "f5c7",
        "M320 512c53.2 0 101.4-21.6 136.1-56.6l-298.3-235C140 257.1 128 292.3 128 320c0 106 86 192 192 192zM505.2 370.7c4.4-16.1 6.8-33.1 6.8-50.7c0-91.2-130.2-262.3-166.6-308.3C339.4 4.2 330.5 0 320.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C277.8 33 240.7 81.3 205.8 136L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L505.2 370.7zM224 336c0 44.2 35.8 80 80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $5c8203742f0e3062$export$5d6f0943039b898f = $5c8203742f0e3062$export$1d6c5a49025d720b;
var $5c8203742f0e3062$export$4999586d7e1087fb = {
    prefix: "fas",
    iconName: "mosque",
    icon: [
        640,
        512,
        [
            128332
        ],
        "f678",
        "M400 0c5 0 9.8 2.4 12.8 6.4c34.7 46.3 78.1 74.9 133.5 111.5l0 0 0 0c5.2 3.4 10.5 7 16 10.6c28.9 19.2 45.7 51.7 45.7 86.1c0 28.6-11.3 54.5-29.8 73.4H221.8c-18.4-19-29.8-44.9-29.8-73.4c0-34.4 16.7-66.9 45.7-86.1c5.4-3.6 10.8-7.1 16-10.6l0 0 0 0C309.1 81.3 352.5 52.7 387.2 6.4c3-4 7.8-6.4 12.8-6.4zM288 512V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H192c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H560V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H448V454c0-19-8.4-37-23-49.2L400 384l-25 20.8C360.4 417 352 435 352 454v58H288zM70.4 5.2c5.7-4.3 13.5-4.3 19.2 0l16 12C139.8 42.9 160 83.2 160 126v2H0v-2C0 83.2 20.2 42.9 54.4 17.2l16-12zM0 160H160V296.6c-19.1 11.1-32 31.7-32 55.4V480c0 9.6 2.1 18.6 5.8 26.8c-6.6 3.4-14 5.2-21.8 5.2H48c-26.5 0-48-21.5-48-48V176 160z"
    ]
};
var $5c8203742f0e3062$export$67c7a1518d0715ff = {
    prefix: "fas",
    iconName: "mosquito",
    icon: [
        640,
        512,
        [],
        "e52b",
        "M463.7 505.9c9.8-8.9 10.7-24.3 2.1-34.3l-42.1-49 0-54.7c0-5.5-1.8-10.8-5.1-15.1L352 266.3l0-.3L485.4 387.8C542.4 447.6 640 405.2 640 320.6c0-47.9-34-88.3-79.4-94.2l-153-23.9 40.8-40.9c7.8-7.8 9.4-20.1 3.9-29.8L428.5 90.1l38.2-50.9c8-10.6 6.1-25.9-4.3-34.1s-25.2-6.3-33.2 4.4l-48 63.9c-5.9 7.9-6.6 18.6-1.7 27.2L402.2 140 352 190.3l0-38.2c0-14.9-10.2-27.4-24-31l0-57.2c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 57.2c-13.8 3.6-24 16.1-24 31l0 38.1L237.8 140l22.6-39.5c4.9-8.6 4.2-19.3-1.7-27.2l-48-63.9c-8-10.6-22.8-12.6-33.2-4.4s-12.2 23.5-4.3 34.1l38.2 50.9-23.9 41.7c-5.5 9.7-3.9 22 3.9 29.8l40.8 40.9-153 23.9C34 232.3 0 272.7 0 320.6c0 84.6 97.6 127 154.6 67.1L288 266l0 .3-66.5 86.4c-3.3 4.3-5.1 9.6-5.1 15.1l0 54.7-42.1 49c-8.6 10.1-7.7 25.5 2.1 34.3s24.7 7.9 33.4-2.1l48-55.9c3.8-4.4 5.9-10.2 5.9-16.1l0-55.4L288 344.7l0 63.1c0 17.7 14.3 32 32 32s32-14.3 32-32l0-63.1 24.3 31.6 0 55.4c0 5.9 2.1 11.7 5.9 16.1l48 55.9c8.6 10.1 23.6 11 33.4 2.1z"
    ]
};
var $5c8203742f0e3062$export$f823fee3712b2601 = {
    prefix: "fas",
    iconName: "star-of-david",
    icon: [
        512,
        512,
        [
            10017
        ],
        "f69a",
        "M404.2 309.5L383.1 344h42.3l-21.1-34.5zM371.4 256l-54-88H194.6l-54 88 54 88H317.4l54-88zm65.7 0l53.4 87c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4H348.7l-56.2 91.5C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400H53.4C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112H163.3l56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112H458.6c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87zm-54-88l21.1 34.5L425.4 168H383.1zM283 112L256 68l-27 44h54zM128.9 168H86.6l21.1 34.5L128.9 168zM107.8 309.5L86.6 344h42.3l-21.1-34.5zM229 400l27 44 27-44H229z"
    ]
};
var $5c8203742f0e3062$export$842b988dae95ccb8 = {
    prefix: "fas",
    iconName: "person-military-rifle",
    icon: [
        512,
        512,
        [],
        "e54b",
        "M160 39c0-13 10-23.8 22.9-24.9L334.7 1.4C344 .7 352 8 352 17.4V48c0 8.8-7.2 16-16 16H185c-13.8 0-25-11.2-25-25zm17.6 57H334.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16zm228 364.3L352 369.7V480c0 1.3-.1 2.5-.2 3.8L177.5 234.9c16.6-7.1 34.6-10.9 53.3-10.9h50.4c15.9 0 31.3 2.8 45.8 7.9L421.9 67.7c-7.7-4.4-10.3-14.2-5.9-21.9s14.2-10.3 21.9-5.9l13.9 8 13.9 8c7.7 4.4 10.3 14.2 5.9 21.9L416 173.9l1.6 .9c15.3 8.8 20.6 28.4 11.7 43.7L392.6 282c2 2.8 3.9 5.8 5.7 8.8l76.1 128.8c11.2 19 4.9 43.5-14.1 54.8s-43.5 4.9-54.8-14.1zM320 512H192c-17.7 0-32-14.3-32-32V369.7l-53.6 90.6c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8l76.1-128.8c9.4-15.8 21.7-29.3 36-40L331.1 510c-3.5 1.3-7.2 2-11.1 2zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $5c8203742f0e3062$export$c790b41dc166ae13 = {
    prefix: "fas",
    iconName: "cart-shopping",
    icon: [
        576,
        512,
        [
            128722,
            "shopping-cart"
        ],
        "f07a",
        "M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $5c8203742f0e3062$export$51da406e5aa1388c = $5c8203742f0e3062$export$c790b41dc166ae13;
var $5c8203742f0e3062$export$507e8edd7676b2e9 = {
    prefix: "fas",
    iconName: "vials",
    icon: [
        512,
        512,
        [],
        "f493",
        "M0 64C0 46.3 14.3 32 32 32H88h48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96C14.3 96 0 81.7 0 64zM136 96H88V256h48V96zM288 64c0-17.7 14.3-32 32-32h56 48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96c-17.7 0-32-14.3-32-32zM424 96H376V256h48V96z"
    ]
};
var $5c8203742f0e3062$export$f193138a7d21971c = {
    prefix: "fas",
    iconName: "plug-circle-plus",
    icon: [
        576,
        512,
        [],
        "e55f",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $5c8203742f0e3062$export$c5a9302c8c13c79a = {
    prefix: "fas",
    iconName: "place-of-worship",
    icon: [
        640,
        512,
        [],
        "f67f",
        "M224 109.3V217.6L183.3 242c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V283.2c0-16.9-8.8-32.5-23.3-41.2L416 217.6V109.3c0-8.5-3.4-16.6-9.4-22.6L331.3 11.3c-6.2-6.2-16.4-6.2-22.6 0L233.4 86.6c-6 6-9.4 14.1-9.4 22.6zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"
    ]
};
var $5c8203742f0e3062$export$cacbd95c283996ec = {
    prefix: "fas",
    iconName: "grip-vertical",
    icon: [
        320,
        512,
        [],
        "f58e",
        "M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"
    ]
};
var $5c8203742f0e3062$export$2d3ccb9b2099f3fe = {
    prefix: "fas",
    iconName: "arrow-turn-up",
    icon: [
        384,
        512,
        [
            "level-up"
        ],
        "f148",
        "M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z"
    ]
};
var $5c8203742f0e3062$export$c227d3ba1de97ceb = $5c8203742f0e3062$export$2d3ccb9b2099f3fe;
var $5c8203742f0e3062$export$4f39e8dbaf09ea8b = {
    prefix: "fas",
    iconName: "u",
    icon: [
        384,
        512,
        [
            117
        ],
        "55",
        "M32 32c17.7 0 32 14.3 32 32V288c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 106-86 192-192 192S0 394 0 288V64C0 46.3 14.3 32 32 32z"
    ]
};
var $5c8203742f0e3062$export$60b44cfa7af18422 = {
    prefix: "fas",
    iconName: "square-root-variable",
    icon: [
        576,
        512,
        [
            "square-root-alt"
        ],
        "f698",
        "M282.6 78.1c8-27.3 33-46.1 61.4-46.1H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H344L238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H77.6c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8L282.6 78.1zM393.4 233.4c12.5-12.5 32.8-12.5 45.3 0L480 274.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 320l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 365.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 320l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var $5c8203742f0e3062$export$28e4b96627e00057 = $5c8203742f0e3062$export$60b44cfa7af18422;
var $5c8203742f0e3062$export$95b9968e7fceb821 = {
    prefix: "fas",
    iconName: "clock",
    icon: [
        512,
        512,
        [
            128339,
            "clock-four"
        ],
        "f017",
        "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $5c8203742f0e3062$export$9a575facf1cab48f = $5c8203742f0e3062$export$95b9968e7fceb821;
var $5c8203742f0e3062$export$5d2b6a700940df16 = {
    prefix: "fas",
    iconName: "backward-step",
    icon: [
        320,
        512,
        [
            "step-backward"
        ],
        "f048",
        "M267.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160L64 241V96c0-17.7-14.3-32-32-32S0 78.3 0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V271l11.5 9.6 192 160z"
    ]
};
var $5c8203742f0e3062$export$2884e379aed297d4 = $5c8203742f0e3062$export$5d2b6a700940df16;
var $5c8203742f0e3062$export$d7ff2047dbc34562 = {
    prefix: "fas",
    iconName: "pallet",
    icon: [
        640,
        512,
        [],
        "f482",
        "M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 320 544h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H576V384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H544 320 96 32zm96 64H288v64H128V384zm224 0H512v64H352V384z"
    ]
};
var $5c8203742f0e3062$export$a0856b225f3b0614 = {
    prefix: "fas",
    iconName: "faucet",
    icon: [
        512,
        512,
        [],
        "e005",
        "M192 96v12L96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l96-12 31-3.9 1-.1 1 .1 31 3.9 96 12c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 12V96c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 256c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H132.1c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48H352c17.7 0 32 14.3 32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32c0-88.4-71.6-160-160-160H320l-22.6-22.6c-6-6-14.1-9.4-22.6-9.4H256V180.2l-32-4-32 4V224H173.3c-8.5 0-16.6 3.4-22.6 9.4L128 256H32z"
    ]
};
var $5c8203742f0e3062$export$59669f486ab41d86 = {
    prefix: "fas",
    iconName: "baseball-bat-ball",
    icon: [
        512,
        512,
        [],
        "f432",
        "M424 0c-12.4 0-24.2 4.9-33 13.7L233.5 171.2c-10.5 10.5-19.8 22.1-27.7 34.6L132.7 321.6c-7.3 11.5-15.8 22.2-25.5 31.9L69.9 390.7l51.3 51.3 37.3-37.3c9.6-9.6 20.3-18.2 31.9-25.5l115.8-73.1c12.5-7.9 24.1-17.2 34.6-27.7L498.3 121c8.7-8.7 13.7-20.6 13.7-33s-4.9-24.2-13.7-33L457 13.7C448.2 4.9 436.4 0 424 0zm88 432a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM15 399c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L49 399c-9.4-9.4-24.6-9.4-33.9 0z"
    ]
};
var $5c8203742f0e3062$export$cb39585371b75720 = {
    prefix: "fas",
    iconName: "s",
    icon: [
        320,
        512,
        [
            115
        ],
        "53",
        "M99.1 105.4C79 114 68.2 127.2 65.2 144.8c-2.4 14.1-.7 23.2 2 29.4c2.8 6.3 7.9 12.4 16.7 18.6c19.2 13.4 48.3 22.1 84.9 32.5c1 .3 1.9 .6 2.9 .8c32.7 9.3 72 20.6 100.9 40.7c15.7 10.9 29.9 25.5 38.6 45.1c8.8 19.8 10.8 42 6.6 66.3c-7.3 42.5-35.3 71.7-71.8 87.3c-35.4 15.2-79.1 17.9-123.7 10.9l-.2 0 0 0c-24-3.9-62.7-17.1-87.6-25.6c-4.8-1.7-9.2-3.1-12.8-4.3C5.1 440.8-3.9 422.7 1.6 405.9s23.7-25.8 40.5-20.3c4.9 1.6 10.2 3.4 15.9 5.4c25.4 8.6 56.4 19.2 74.4 22.1c36.8 5.7 67.5 2.5 88.5-6.5c20.1-8.6 30.8-21.8 33.9-39.4c2.4-14.1 .7-23.2-2-29.4c-2.8-6.3-7.9-12.4-16.7-18.6c-19.2-13.4-48.3-22.1-84.9-32.5c-1-.3-1.9-.6-2.9-.8c-32.7-9.3-72-20.6-100.9-40.7c-15.7-10.9-29.9-25.5-38.6-45.1c-8.8-19.8-10.8-42-6.6-66.3l31.5 5.5L2.1 133.9C9.4 91.4 37.4 62.2 73.9 46.6c35.4-15.2 79.1-17.9 123.7-10.9c13 2 52.4 9.6 66.6 13.4c17.1 4.5 27.2 22.1 22.7 39.2s-22.1 27.2-39.2 22.7c-11.2-3-48.1-10.2-60.1-12l4.9-31.5-4.9 31.5c-36.9-5.8-67.5-2.5-88.6 6.5z"
    ]
};
var $5c8203742f0e3062$export$5e239d90ef904a84 = {
    prefix: "fas",
    iconName: "timeline",
    icon: [
        640,
        512,
        [],
        "e29c",
        "M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 97.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288v54.7c-28.3 12.3-48 40.5-48 73.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V288H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V169.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3V224H160V169.3zM488 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM320 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $5c8203742f0e3062$export$fb61df5d98785fa8 = {
    prefix: "fas",
    iconName: "keyboard",
    icon: [
        576,
        512,
        [
            9000
        ],
        "f11c",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM160 336c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336zM272 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM256 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM368 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM352 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V240zM464 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM448 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$f9395ef707603e40 = {
    prefix: "fas",
    iconName: "caret-down",
    icon: [
        320,
        512,
        [],
        "f0d7",
        "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
    ]
};
var $5c8203742f0e3062$export$9c73560282dceccd = {
    prefix: "fas",
    iconName: "house-chimney-medical",
    icon: [
        576,
        512,
        [
            "clinic-medical"
        ],
        "f7f2",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM272 192c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H320V208c0-8.8-7.2-16-16-16H272z"
    ]
};
var $5c8203742f0e3062$export$20d8a680febc7434 = $5c8203742f0e3062$export$9c73560282dceccd;
var $5c8203742f0e3062$export$7ed2bad15ae6237f = {
    prefix: "fas",
    iconName: "temperature-three-quarters",
    icon: [
        320,
        512,
        [
            "temperature-3",
            "thermometer-3",
            "thermometer-three-quarters"
        ],
        "f2c8",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V144c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $5c8203742f0e3062$export$89def3268ed9b4bc = $5c8203742f0e3062$export$7ed2bad15ae6237f;
var $5c8203742f0e3062$export$2f653125f4e6463 = $5c8203742f0e3062$export$7ed2bad15ae6237f;
var $5c8203742f0e3062$export$6c632d1dc30d4a77 = $5c8203742f0e3062$export$7ed2bad15ae6237f;
var $5c8203742f0e3062$export$8867e7da34bb8bf4 = {
    prefix: "fas",
    iconName: "mobile-screen",
    icon: [
        384,
        512,
        [
            "mobile-android-alt"
        ],
        "f3cf",
        "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM144 448c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM304 64H80V384H304V64z"
    ]
};
var $5c8203742f0e3062$export$cb39d7b468ba5838 = $5c8203742f0e3062$export$8867e7da34bb8bf4;
var $5c8203742f0e3062$export$a5f2976a01fdc970 = {
    prefix: "fas",
    iconName: "plane-up",
    icon: [
        512,
        512,
        [],
        "e22d",
        "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7l0 66.3L497.8 278.5c8.9 5.9 14.2 15.9 14.2 26.6v56.7c0 10.9-10.7 18.6-21.1 15.2L320 320v80l57.6 43.2c4 3 6.4 7.8 6.4 12.8v42c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400V320L21.1 377C10.7 380.4 0 372.7 0 361.8V305.1c0-10.7 5.3-20.7 14.2-26.6L192 160V93.7z"
    ]
};
var $5c8203742f0e3062$export$46d49a6734c4872a = {
    prefix: "fas",
    iconName: "piggy-bank",
    icon: [
        576,
        512,
        [],
        "f4d3",
        "M400 96l0 .7c-5.3-.4-10.6-.7-16-.7H256c-16.5 0-32.5 2.1-47.8 6c-.1-2-.2-4-.2-6c0-53 43-96 96-96s96 43 96 96zm-16 32c3.5 0 7 .1 10.4 .3c4.2 .3 8.4 .7 12.6 1.3C424.6 109.1 450.8 96 480 96h11.5c10.4 0 18 9.8 15.5 19.9l-13.8 55.2c15.8 14.8 28.7 32.8 37.5 52.9H544c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H512c-9.1 12.1-19.9 22.9-32 32v64c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H256v32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V416c-34.9-26.2-58.7-66.3-63.2-112H68c-37.6 0-68-30.4-68-68s30.4-68 68-68h4c13.3 0 24 10.7 24 24s-10.7 24-24 24H68c-11 0-20 9-20 20s9 20 20 20H99.2c12.1-59.8 57.7-107.5 116.3-122.8c12.9-3.4 26.5-5.2 40.5-5.2H384zm64 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $5c8203742f0e3062$export$e6dadc1155c4ee48 = {
    prefix: "fas",
    iconName: "battery-half",
    icon: [
        576,
        512,
        [
            "battery-3"
        ],
        "f242",
        "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm208 96H96V320H288V192z"
    ]
};
var $5c8203742f0e3062$export$f9138caac2aedaed = $5c8203742f0e3062$export$e6dadc1155c4ee48;
var $5c8203742f0e3062$export$28f06bbf9c17c3af = {
    prefix: "fas",
    iconName: "mountain-city",
    icon: [
        640,
        512,
        [],
        "e52e",
        "M336 0c-26.5 0-48 21.5-48 48v92.1l71.4 118.4c2.5-1.6 5.4-2.5 8.6-2.5h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-3.5l73.8 122.4c12.4 20.6 12.9 46.3 1.2 67.3c-.4 .8-.9 1.6-1.4 2.3H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H568V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H480V48c0-26.5-21.5-48-48-48H336zm32 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM352 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176zm160 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zM224 188.9L283.8 288H223l-48 64-24.6-41.2L224 188.9zm29.4-44.2C247.1 134.3 236 128 224 128s-23.1 6.3-29.4 16.7L5.1 458.9c-6.5 10.8-6.7 24.3-.7 35.3S22 512 34.5 512H413.5c12.5 0 24-6.8 30.1-17.8s5.8-24.5-.7-35.3L253.4 144.7z"
    ]
};
var $5c8203742f0e3062$export$bc5da164799a0e = {
    prefix: "fas",
    iconName: "coins",
    icon: [
        512,
        512,
        [],
        "f51e",
        "M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2l0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5V176c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336V300.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4V304v5.7V336zm32 0V304 278.1c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5V272c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5V432c0 44.2-86 80-192 80S0 476.2 0 432V396.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"
    ]
};
var $5c8203742f0e3062$export$8d41d1f1ba3f9217 = {
    prefix: "fas",
    iconName: "khanda",
    icon: [
        512,
        512,
        [
            9772
        ],
        "f66d",
        "M245.8 3.7c5.9-4.9 14.6-4.9 20.5 0l48 40c5.9 4.9 7.5 13.2 3.8 19.9l0 0 0 0 0 0 0 0-.1 .1-.3 .6c-.3 .5-.7 1.3-1.2 2.3c-1 2-2.6 5-4.4 8.6c-.5 .9-.9 1.9-1.4 2.9C344.9 97.4 368 134 368 176s-23.1 78.6-57.3 97.8c.5 1 1 2 1.4 2.9c1.8 3.7 3.3 6.6 4.4 8.6c.5 1 .9 1.8 1.2 2.3l.3 .6 .1 .1 0 0 0 0c3.6 6.7 2 15-3.8 19.9L272 343.5v19.8l35.6-24.5 41.1-28.2c42.8-29.4 68.4-78 68.4-130c0-31.1-9.2-61.6-26.5-87.5l-2.8-4.2c-4-6-3.5-14 1.3-19.5s12.7-7 19.2-3.7L401.1 80c7.2-14.3 7.2-14.3 7.2-14.3l0 0 0 0 .1 0 .3 .2 1 .5c.8 .4 2 1.1 3.5 1.9c2.9 1.7 7 4.1 11.8 7.3c9.6 6.4 22.5 16.1 35.4 29c25.7 25.7 52.7 65.6 52.7 119.3c0 53.1-26.4 100.5-51.2 133.6c-12.6 16.7-25.1 30.3-34.5 39.7c-4.7 4.7-8.7 8.4-11.5 10.9c-1.4 1.3-2.5 2.2-3.3 2.9l-.9 .8-.3 .2-.1 .1 0 0 0 0s0 0-10.2-12.3l10.2 12.3c-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4v28.9c9.6 5.5 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7V424.1l-40.3 27.7C197.8 463.3 187.9 472 176 472c-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4 .3 6.5 .9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6L112 400c-10.2 12.3-10.2 12.3-10.3 12.3l0 0 0 0-.1-.1-.3-.2-.9-.8c-.8-.7-1.9-1.7-3.3-2.9c-2.8-2.5-6.7-6.2-11.5-10.9c-9.4-9.4-21.9-23-34.5-39.7C26.4 324.5 0 277.1 0 224c0-53.7 26.9-93.6 52.7-119.3c12.9-12.9 25.8-22.6 35.4-29C93 72.5 97 70 99.9 68.4c1.5-.8 2.6-1.5 3.5-1.9l1-.5 .3-.2 .1 0 0 0 0 0s0 0 7.2 14.3l-7.2-14.3c6.5-3.2 14.3-1.7 19.2 3.7s5.3 13.4 1.3 19.5l-2.8 4.2C105.2 119 96 149.5 96 180.6c0 51.9 25.6 100.6 68.4 130l41.1 28.2L240 362.6V343.5l-42.2-35.2c-5.9-4.9-7.5-13.2-3.8-19.9l0 0 0 0 0 0 .1-.1 .3-.6c.3-.5 .7-1.3 1.2-2.3c1-2 2.6-5 4.4-8.6c.5-.9 .9-1.9 1.4-2.9C167.1 254.6 144 218 144 176s23.1-78.6 57.3-97.8c-.5-1-1-2-1.4-2.9c-1.8-3.7-3.3-6.6-4.4-8.6c-.5-1-.9-1.8-1.2-2.3l-.3-.6-.1-.1 0 0 0 0 0 0c-3.6-6.7-2-15 3.8-19.9l48-40zM220.2 122.9c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1C227 210.2 232 190.9 232 176s-5-34.2-11.8-53.1zm71.5 106.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1C285 141.8 280 161.1 280 176s5 34.2 11.8 53.1z"
    ]
};
var $5c8203742f0e3062$export$ea6970ed5a15feb6 = {
    prefix: "fas",
    iconName: "sliders",
    icon: [
        512,
        512,
        [
            "sliders-h"
        ],
        "f1de",
        "M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z"
    ]
};
var $5c8203742f0e3062$export$94d4dcb523f95563 = $5c8203742f0e3062$export$ea6970ed5a15feb6;
var $5c8203742f0e3062$export$54d16fa2e445d3fe = {
    prefix: "fas",
    iconName: "folder-tree",
    icon: [
        576,
        512,
        [],
        "f802",
        "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v96V384c0 35.3 28.7 64 64 64H256V384H64V160H256V96H64V32zM288 192c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4L409.4 9.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V192zm0 288c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V480z"
    ]
};
var $5c8203742f0e3062$export$882cabd11f4943b8 = {
    prefix: "fas",
    iconName: "network-wired",
    icon: [
        640,
        512,
        [],
        "f6ff",
        "M256 64H384v64H256V64zM240 0c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96v32H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H192V288H448v32H400c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H512V288h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V192h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H240zM96 448V384H224v64H96zm320-64H544v64H416V384z"
    ]
};
var $5c8203742f0e3062$export$184725965b3402dc = {
    prefix: "fas",
    iconName: "map-pin",
    icon: [
        320,
        512,
        [
            128205
        ],
        "f276",
        "M16 144a144 144 0 1 1 288 0A144 144 0 1 1 16 144zM160 80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64zM128 480V317.1c10.4 1.9 21.1 2.9 32 2.9s21.6-1 32-2.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
    ]
};
var $5c8203742f0e3062$export$38d20d399463edf9 = {
    prefix: "fas",
    iconName: "hamsa",
    icon: [
        512,
        512,
        [],
        "f665",
        "M34.6 288H80c8.8 0 16-7.2 16-16V72c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V40c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V72c0-22.1 17.9-40 40-40s40 17.9 40 40V272c0 8.8 7.2 16 16 16h45.4c19.1 0 34.6 15.5 34.6 34.6c0 8.6-3.2 16.9-9 23.3L416.6 441c-41.1 45.2-99.4 71-160.6 71s-119.4-25.8-160.6-71L9 345.9c-5.8-6.4-9-14.7-9-23.3C0 303.5 15.5 288 34.6 288zM256 288c-38.4 0-76.8 35.8-90.6 50.2c-3.6 3.7-5.4 8.7-5.4 13.8s1.8 10.1 5.4 13.8C179.2 380.2 217.6 416 256 416s76.8-35.8 90.6-50.2c3.6-3.7 5.4-8.7 5.4-13.8s-1.8-10.1-5.4-13.8C332.8 323.8 294.4 288 256 288zm0 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$875b6c94a4b00ea8 = {
    prefix: "fas",
    iconName: "cent-sign",
    icon: [
        384,
        512,
        [],
        "e3f5",
        "M224 0c17.7 0 32 14.3 32 32V66.7c30.9 5.2 59.2 17.7 83.2 35.8c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6c14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8c-24 18-52.4 30.6-83.2 35.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C101.2 430.1 32 351.1 32 256s69.2-174.1 160-189.3V32c0-17.7 14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$f9b579ba06048af = {
    prefix: "fas",
    iconName: "flask",
    icon: [
        448,
        512,
        [],
        "f0c3",
        "M288 0H160 128C110.3 0 96 14.3 96 32s14.3 32 32 32V196.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6C0 480.9 31.1 512 69.4 512H378.6c38.3 0 69.4-31.1 69.4-69.4c0-12.8-3.6-25.4-10.3-36.4L329.5 230.4c-6.2-10.1-9.5-21.7-9.5-33.5V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288zM192 196.8V64h64V196.8c0 23.7 6.6 46.9 19 67.1L309.5 320h-171L173 263.9c12.4-20.2 19-43.4 19-67.1z"
    ]
};
var $5c8203742f0e3062$export$e7b4c26b5857fe9c = {
    prefix: "fas",
    iconName: "person-pregnant",
    icon: [
        384,
        512,
        [],
        "e31e",
        "M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 383c-13.8-3.6-24-16.1-24-31V296.9l-4.6 7.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c15-24.9 40.3-41.5 68.7-45.6c4.1-.6 8.2-1 12.5-1h1.1 12.5H192c1.4 0 2.8 .1 4.1 .3c35.7 2.9 65.4 29.3 72.1 65l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3v32c0 17.7-14.3 32-32 32H304 264v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384h-8-8v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V383z"
    ]
};
var $5c8203742f0e3062$export$76cc39f249b6864e = {
    prefix: "fas",
    iconName: "wand-sparkles",
    icon: [
        512,
        512,
        [],
        "f72b",
        "M464 6.1c9.5-8.5 24-8.1 33 .9l8 8c9 9 9.4 23.5 .9 33l-85.8 95.9c-2.6 2.9-4.1 6.7-4.1 10.7V176c0 8.8-7.2 16-16 16H384.2c-4.6 0-8.9 1.9-11.9 5.3L100.7 500.9C94.3 508 85.3 512 75.8 512c-8.8 0-17.3-3.5-23.5-9.8L9.7 459.7C3.5 453.4 0 445 0 436.2c0-9.5 4-18.5 11.1-24.8l111.6-99.8c3.4-3 5.3-7.4 5.3-11.9V272c0-8.8 7.2-16 16-16h34.6c3.9 0 7.7-1.5 10.7-4.1L464 6.1zM432 288c3.6 0 6.7 2.4 7.7 5.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8zM87.7 69.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8L87.7 218.2c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8L57.5 166.5 5.8 151.7c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8L72.3 69.8c1-3.4 4.1-5.8 7.7-5.8s6.7 2.4 7.7 5.8zM208 0c3.7 0 6.9 2.5 7.8 6.1l6.8 27.3 27.3 6.8c3.6 .9 6.1 4.1 6.1 7.8s-2.5 6.9-6.1 7.8l-27.3 6.8-6.8 27.3c-.9 3.6-4.1 6.1-7.8 6.1s-6.9-2.5-7.8-6.1l-6.8-27.3-27.3-6.8c-3.6-.9-6.1-4.1-6.1-7.8s2.5-6.9 6.1-7.8l27.3-6.8 6.8-27.3c.9-3.6 4.1-6.1 7.8-6.1z"
    ]
};
var $5c8203742f0e3062$export$7480721bf113be3e = {
    prefix: "fas",
    iconName: "ellipsis-vertical",
    icon: [
        128,
        512,
        [
            "ellipsis-v"
        ],
        "f142",
        "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"
    ]
};
var $5c8203742f0e3062$export$e58494c7fcb5380 = $5c8203742f0e3062$export$7480721bf113be3e;
var $5c8203742f0e3062$export$3604f15924cf0b98 = {
    prefix: "fas",
    iconName: "ticket",
    icon: [
        576,
        512,
        [
            127903
        ],
        "f145",
        "M64 64C28.7 64 0 92.7 0 128v64c0 8.8 7.4 15.7 15.7 18.6C34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V320c0-8.8-7.4-15.7-15.7-18.6C541.5 294.9 528 277 528 256s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6V128c0-35.3-28.7-64-64-64H64zm64 112l0 160c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM96 160c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160z"
    ]
};
var $5c8203742f0e3062$export$a1cca9928dcf9798 = {
    prefix: "fas",
    iconName: "power-off",
    icon: [
        512,
        512,
        [
            9211
        ],
        "f011",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V256c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM143.5 120.6c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6c-13.6-11.3-33.8-9.4-45.1 4.1s-9.4 33.8 4.1 45.1c38.9 32.3 63.5 81 63.5 135.4c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-54.4 24.7-103.1 63.5-135.4z"
    ]
};
var $5c8203742f0e3062$export$b356b1dbe7d7f736 = {
    prefix: "fas",
    iconName: "right-long",
    icon: [
        512,
        512,
        [
            "long-arrow-alt-right"
        ],
        "f30b",
        "M334.5 414c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22l0 72L32 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l288 0 0 72c0 9.6 5.7 18.2 14.5 22z"
    ]
};
var $5c8203742f0e3062$export$533e1f578f74c066 = $5c8203742f0e3062$export$b356b1dbe7d7f736;
var $5c8203742f0e3062$export$19357abad396e723 = {
    prefix: "fas",
    iconName: "flag-usa",
    icon: [
        448,
        512,
        [],
        "f74d",
        "M32 0C49.7 0 64 14.3 64 32V48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1v36.1l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9v32.2c17.4 2.1 34.4 6.7 50.6 13.9l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 136.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 203.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 232.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 299.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 328.3v33.5c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 400v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V416 345.5 312.8 249.5 216.8 153.5 120.8 64 32C0 14.3 14.3 0 32 0zm80 96A16 16 0 1 0 80 96a16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $5c8203742f0e3062$export$e1046cf83da9b7ef = {
    prefix: "fas",
    iconName: "laptop-file",
    icon: [
        640,
        512,
        [],
        "e51d",
        "M128 0C92.7 0 64 28.7 64 64V288H19.2C8.6 288 0 296.6 0 307.2C0 349.6 34.4 384 76.8 384H320V288H128V64H448V96h64V64c0-35.3-28.7-64-64-64H128zM512 128H400c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V256H544c-17.7 0-32-14.3-32-32V128zm32 0v96h96l-96-96z"
    ]
};
var $5c8203742f0e3062$export$7c85aba0f9624b29 = {
    prefix: "fas",
    iconName: "tty",
    icon: [
        512,
        512,
        [
            "teletype"
        ],
        "f1e4",
        "M38.3 241.3L15.1 200.6c-9.2-16.2-8.4-36.5 4.5-50C61.4 106.8 144.7 48 256 48s194.6 58.8 236.4 102.6c12.9 13.5 13.7 33.8 4.5 50l-23.1 40.7c-7.5 13.2-23.3 19.3-37.8 14.6l-81.1-26.6c-13.1-4.3-22-16.6-22-30.4V144c-49.6-18.1-104-18.1-153.6 0v54.8c0 13.8-8.9 26.1-22 30.4L76.1 255.8c-14.5 4.7-30.3-1.4-37.8-14.6zM32 336c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V336zm0 96c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V432zM144 320h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V336zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V336zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16zM128 432c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V432z"
    ]
};
var $5c8203742f0e3062$export$14bcd5c43dc736f9 = $5c8203742f0e3062$export$7c85aba0f9624b29;
var $5c8203742f0e3062$export$2faddf1690e14e11 = {
    prefix: "fas",
    iconName: "diagram-next",
    icon: [
        512,
        512,
        [],
        "e476",
        "M512 160c0 35.3-28.7 64-64 64H280v64h46.1c21.4 0 32.1 25.9 17 41L273 399c-9.4 9.4-24.6 9.4-33.9 0L169 329c-15.1-15.1-4.4-41 17-41H232V224H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64zM448 416V352H365.3l.4-.4c18.4-18.4 20.4-43.7 11-63.6l71.3 0c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64l71.3 0c-9.4 19.9-7.4 45.2 11 63.6l.4 .4H64v64H210.7l5.7 5.7c21.9 21.9 57.3 21.9 79.2 0l5.7-5.7H448z"
    ]
};
var $5c8203742f0e3062$export$b16df914812cedbe = {
    prefix: "fas",
    iconName: "person-rifle",
    icon: [
        576,
        512,
        [],
        "e54e",
        "M265.2 192c25.4 0 49.8 7.1 70.8 19.9V512H144V337.7L90.4 428.3c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8L97.7 258.8c24.5-41.4 69-66.8 117.1-66.8h50.4zM160 80a80 80 0 1 1 160 0A80 80 0 1 1 160 80zM448 0c8.8 0 16 7.2 16 16V132.3c9.6 5.5 16 15.9 16 27.7V269.3l16-5.3V208c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v84.5c0 6.9-4.4 13-10.9 15.2L480 325.3V352h48c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H484l23 92.1c2.5 10.1-5.1 19.9-15.5 19.9H432c-8.8 0-16-7.2-16-16V400H400c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32V160c0-11.8 6.4-22.2 16-27.7V32c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 16z"
    ]
};
var $5c8203742f0e3062$export$bc50edea6e121df5 = {
    prefix: "fas",
    iconName: "house-medical-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e512",
        "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $5c8203742f0e3062$export$8e047801a8603af7 = {
    prefix: "fas",
    iconName: "closed-captioning",
    icon: [
        576,
        512,
        [],
        "f20a",
        "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"
    ]
};
var $5c8203742f0e3062$export$baf9f153991b2ea = {
    prefix: "fas",
    iconName: "person-hiking",
    icon: [
        384,
        512,
        [
            "hiking"
        ],
        "f6ec",
        "M192 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm51.3 182.7L224.2 307l49.7 49.7c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3l-73.9-73.9c-15.8-15.8-22.2-38.6-16.9-60.3l20.4-84c8.3-34.1 42.7-54.9 76.7-46.4c19 4.8 35.6 16.4 46.4 32.7L305.1 208H336V184c0-13.3 10.7-24 24-24s24 10.7 24 24v55.8c0 .1 0 .2 0 .2s0 .2 0 .2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V272H296.6c-16 0-31-8-39.9-21.4l-13.3-20zM81.1 471.9L117.3 334c3 4.2 6.4 8.2 10.1 11.9l41.9 41.9L142.9 488.1c-4.5 17.1-22 27.3-39.1 22.8s-27.3-22-22.8-39.1zm55.5-346L101.4 266.5c-3 12.1-14.9 19.9-27.2 17.9l-47.9-8c-14-2.3-22.9-16.3-19.2-30L31.9 155c9.5-34.8 41.1-59 77.2-59h4.2c15.6 0 27.1 14.7 23.3 29.8z"
    ]
};
var $5c8203742f0e3062$export$b2ab0105a901499e = $5c8203742f0e3062$export$baf9f153991b2ea;
var $5c8203742f0e3062$export$6a6f9cba7a1e5fe4 = {
    prefix: "fas",
    iconName: "venus-double",
    icon: [
        640,
        512,
        [
            9890
        ],
        "f226",
        "M192 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM368 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H224v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C78.1 334.1 16 262.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c14.6-15.6 26.8-33.4 36-53c18.8 14.4 42.4 23 68 23c61.9 0 112-50.1 112-112s-50.1-112-112-112c-25.6 0-49.1 8.6-68 23c-9.3-19.5-21.5-37.4-36-53C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H480v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1c-26.6-4.9-51.1-15.7-72-31.1z"
    ]
};
var $5c8203742f0e3062$export$74f06b41ed2ca28a = {
    prefix: "fas",
    iconName: "images",
    icon: [
        576,
        512,
        [],
        "f302",
        "M160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320H328 280 200c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
    ]
};
var $5c8203742f0e3062$export$693bd40950ed2c3a = {
    prefix: "fas",
    iconName: "calculator",
    icon: [
        384,
        512,
        [
            128425
        ],
        "f1ec",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 64H288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM64 416c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
    ]
};
var $5c8203742f0e3062$export$dace56f632fecf6f = {
    prefix: "fas",
    iconName: "people-pulling",
    icon: [
        576,
        512,
        [],
        "e535",
        "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM64 128c-35.3 0-64 28.7-64 64V320c0 17.7 14.3 32 32 32c9.8 0 18.5-4.4 24.4-11.2L80.4 485.3c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8L123.1 352h15.7l30 134.9c3.8 17.3 20.9 28.1 38.2 24.3s28.1-20.9 24.3-38.2l-57.3-258 116.3 53.8c.5 .3 1.1 .5 1.6 .7c8.6 3.6 18 3.1 25.9-.7c3.4-1.6 6.6-3.9 9.3-6.7c3.1-3.2 5.5-7 7.1-11.4c.1-.3 .2-.7 .3-1l2.5-7.5c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L537 232.7l-15.3-36.8C504.5 154.8 464.3 128 419.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-24.4 10.9-44.6 29-58.1 51.6L157.3 136.9C144.7 131 130.9 128 117 128H64zM464 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM349.7 335.6l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L372.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6z"
    ]
};
var $5c8203742f0e3062$export$328a9baf0f9e3405 = {
    prefix: "fas",
    iconName: "n",
    icon: [
        384,
        512,
        [
            110
        ],
        "4e",
        "M21.1 33.9c12.7-4.6 26.9-.7 35.5 9.6L320 359.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 13.5-8.4 25.5-21.1 30.1s-26.9 .7-35.5-9.6L64 152.4V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 50.5 8.4 38.5 21.1 33.9z"
    ]
};
var $5c8203742f0e3062$export$85cb04eaefaf2d8b = {
    prefix: "fas",
    iconName: "cable-car",
    icon: [
        512,
        512,
        [
            128673,
            57551,
            "tram"
        ],
        "f7da",
        "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 56a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 288c0-35.3 28.7-64 64-64H232V157.5l-203.1 42c-13 2.7-25.7-5.7-28.4-18.6s5.7-25.7 18.6-28.4l232-48 232-48c13-2.7 25.7 5.7 28.4 18.6s-5.7 25.7-18.6 28.4L280 147.5V224H416c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V288zm64 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H96zm112 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H352z"
    ]
};
var $5c8203742f0e3062$export$a7a36674c079f293 = $5c8203742f0e3062$export$85cb04eaefaf2d8b;
var $5c8203742f0e3062$export$a6c308ee087b4ded = {
    prefix: "fas",
    iconName: "cloud-rain",
    icon: [
        512,
        512,
        [
            127783,
            9926
        ],
        "f73d",
        "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zm-6.8 52c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L89.2 372zm160 0c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L249.2 372zm124.9 64.6L409.2 372c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3z"
    ]
};
var $5c8203742f0e3062$export$c4c015418a1f24df = {
    prefix: "fas",
    iconName: "building-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e4d4",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $5c8203742f0e3062$export$6c645741140616af = {
    prefix: "fas",
    iconName: "ship",
    icon: [
        576,
        512,
        [
            128674
        ],
        "f21a",
        "M192 32c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V64h48c26.5 0 48 21.5 48 48V240l44.4 14.8c23.1 7.7 29.5 37.5 11.5 53.9l-101 92.6c-16.2 9.4-34.7 15.1-50.9 15.1c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-16.2 0-34.7-5.7-50.9-15.1l-101-92.6c-18-16.5-11.6-46.2 11.5-53.9L96 240V112c0-26.5 21.5-48 48-48h48V32zM160 218.7l107.8-35.9c13.1-4.4 27.3-4.4 40.5 0L416 218.7V128H160v90.7zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $5c8203742f0e3062$export$8f2463c7b2fc6ae4 = {
    prefix: "fas",
    iconName: "arrows-down-to-line",
    icon: [
        576,
        512,
        [],
        "e4b8",
        "M544 416L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32zm22.6-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L480 274.7 480 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96zm-320-45.3c-12.5-12.5-32.8-12.5-45.3 0L160 274.7 160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7L54.6 233.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3z"
    ]
};
var $5c8203742f0e3062$export$8f734e51d72ca13a = {
    prefix: "fas",
    iconName: "download",
    icon: [
        512,
        512,
        [],
        "f019",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $5c8203742f0e3062$export$92292137ef3cf4c8 = {
    prefix: "fas",
    iconName: "face-grin",
    icon: [
        512,
        512,
        [
            128512,
            "grin"
        ],
        "f580",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$37e1f10b6de76621 = $5c8203742f0e3062$export$92292137ef3cf4c8;
var $5c8203742f0e3062$export$bbcc9e0b6022772b = {
    prefix: "fas",
    iconName: "delete-left",
    icon: [
        576,
        512,
        [
            9003,
            "backspace"
        ],
        "f55a",
        "M576 128c0-35.3-28.7-64-64-64H205.3c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7H512c35.3 0 64-28.7 64-64V128zM271 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $5c8203742f0e3062$export$e43e3f67102fc526 = $5c8203742f0e3062$export$bbcc9e0b6022772b;
var $5c8203742f0e3062$export$1bc3e0ad56dc9eb0 = {
    prefix: "fas",
    iconName: "eye-dropper",
    icon: [
        512,
        512,
        [
            "eye-dropper-empty",
            "eyedropper"
        ],
        "f1fb",
        "M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4L309.4 335.9l-45.3-45.3L143.4 411.3c-3 3-7.1 4.7-11.3 4.7H96V379.9c0-4.2 1.7-8.3 4.7-11.3L221.4 247.9l-45.3-45.3L55.4 323.3z"
    ]
};
var $5c8203742f0e3062$export$ef304e9b7524c1f9 = $5c8203742f0e3062$export$1bc3e0ad56dc9eb0;
var $5c8203742f0e3062$export$91549a375c0b6d25 = $5c8203742f0e3062$export$1bc3e0ad56dc9eb0;
var $5c8203742f0e3062$export$8547e9f3a2ddab5b = {
    prefix: "fas",
    iconName: "file-circle-check",
    icon: [
        576,
        512,
        [],
        "e5a0",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $5c8203742f0e3062$export$a8710cdb23198d53 = {
    prefix: "fas",
    iconName: "forward",
    icon: [
        512,
        512,
        [
            9193
        ],
        "f04e",
        "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3V256v41.7L52.5 440.6zM256 352V256 128 96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29V352z"
    ]
};
var $5c8203742f0e3062$export$59edacfad04cd121 = {
    prefix: "fas",
    iconName: "mobile",
    icon: [
        384,
        512,
        [
            128241,
            "mobile-android",
            "mobile-phone"
        ],
        "f3ce",
        "M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zm80 432h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$82f602311a698c32 = $5c8203742f0e3062$export$59edacfad04cd121;
var $5c8203742f0e3062$export$475a9be8da747e57 = $5c8203742f0e3062$export$59edacfad04cd121;
var $5c8203742f0e3062$export$dc130582748497c6 = {
    prefix: "fas",
    iconName: "face-meh",
    icon: [
        512,
        512,
        [
            128528,
            "meh"
        ],
        "f11a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 336H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$6d2db489aaeeecd2 = $5c8203742f0e3062$export$dc130582748497c6;
var $5c8203742f0e3062$export$70e29dd05344623e = {
    prefix: "fas",
    iconName: "align-center",
    icon: [
        448,
        512,
        [],
        "f037",
        "M352 64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM352 320c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32z"
    ]
};
var $5c8203742f0e3062$export$a57d448e8969ce8a = {
    prefix: "fas",
    iconName: "book-skull",
    icon: [
        448,
        512,
        [
            "book-dead"
        ],
        "f6b7",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM320 112c0-35.3-35.8-64-80-64s-80 28.7-80 64c0 20.9 12.6 39.5 32 51.2V176c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V163.2c19.4-11.7 32-30.3 32-51.2zM208 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM134.3 209.3c-8.1-3.5-17.5 .3-21 8.4s.3 17.5 8.4 21L199.4 272l-77.7 33.3c-8.1 3.5-11.9 12.9-8.4 21s12.9 11.9 21 8.4L240 289.4l105.7 45.3c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21L280.6 272l77.7-33.3c8.1-3.5 11.9-12.9 8.4-21s-12.9-11.9-21-8.4L240 254.6 134.3 209.3z"
    ]
};
var $5c8203742f0e3062$export$b98a3f8c3941a74a = $5c8203742f0e3062$export$a57d448e8969ce8a;
var $5c8203742f0e3062$export$782ac893fc22249b = {
    prefix: "fas",
    iconName: "id-card",
    icon: [
        576,
        512,
        [
            62147,
            "drivers-license"
        ],
        "f2c2",
        "M0 96l576 0c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm0 32V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128H0zM64 405.3c0-29.5 23.9-53.3 53.3-53.3H234.7c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7H74.7c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16z"
    ]
};
var $5c8203742f0e3062$export$8359c70e609eff64 = $5c8203742f0e3062$export$782ac893fc22249b;
var $5c8203742f0e3062$export$e21cfc4f23776bff = {
    prefix: "fas",
    iconName: "outdent",
    icon: [
        448,
        512,
        [
            "dedent"
        ],
        "f03b",
        "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM.2 268.6c-8.2-6.4-8.2-18.9 0-25.3l101.9-79.3c10.5-8.2 25.8-.7 25.8 12.6V335.3c0 13.3-15.3 20.8-25.8 12.6L.2 268.6z"
    ]
};
var $5c8203742f0e3062$export$cbffb369d9299db7 = $5c8203742f0e3062$export$e21cfc4f23776bff;
var $5c8203742f0e3062$export$3772719b170306e2 = {
    prefix: "fas",
    iconName: "heart-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e4fe",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$dcadc0d67468dfa8 = {
    prefix: "fas",
    iconName: "house",
    icon: [
        576,
        512,
        [
            127968,
            63498,
            63500,
            "home",
            "home-alt",
            "home-lg-alt"
        ],
        "f015",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
    ]
};
var $5c8203742f0e3062$export$48f10d71ec526479 = $5c8203742f0e3062$export$dcadc0d67468dfa8;
var $5c8203742f0e3062$export$279659c4b23dbedb = $5c8203742f0e3062$export$dcadc0d67468dfa8;
var $5c8203742f0e3062$export$20d6d52d45f53262 = $5c8203742f0e3062$export$dcadc0d67468dfa8;
var $5c8203742f0e3062$export$39be5cb4aed5a521 = {
    prefix: "fas",
    iconName: "calendar-week",
    icon: [
        448,
        512,
        [],
        "f784",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"
    ]
};
var $5c8203742f0e3062$export$ba2fa38f7bcc6930 = {
    prefix: "fas",
    iconName: "laptop-medical",
    icon: [
        640,
        512,
        [],
        "f812",
        "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM288 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H352v48c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V272H240c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"
    ]
};
var $5c8203742f0e3062$export$fa30fcd1e0d0d8 = {
    prefix: "fas",
    iconName: "b",
    icon: [
        320,
        512,
        [
            98
        ],
        "42",
        "M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64H192c70.7 0 128-57.3 128-128c0-46.5-24.8-87.3-62-109.7c18.7-22.3 30-51 30-82.3c0-70.7-57.3-128-128-128H64zm96 192H64V96h96c35.3 0 64 28.7 64 64s-28.7 64-64 64zM64 288h96 32c35.3 0 64 28.7 64 64s-28.7 64-64 64H64V288z"
    ]
};
var $5c8203742f0e3062$export$56cbcd962389b090 = {
    prefix: "fas",
    iconName: "file-medical",
    icon: [
        384,
        512,
        [],
        "f477",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM160 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H224v48c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V352H112c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h48V240z"
    ]
};
var $5c8203742f0e3062$export$d91800b7be5303b0 = {
    prefix: "fas",
    iconName: "dice-one",
    icon: [
        448,
        512,
        [
            9856
        ],
        "f525",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$d9933d91e1314d02 = {
    prefix: "fas",
    iconName: "kiwi-bird",
    icon: [
        576,
        512,
        [],
        "f535",
        "M291.2 388.4c31.2-18.8 64.7-36.4 101.1-36.4H448c4.6 0 9.1-.2 13.6-.7l85.3 121.9c4 5.7 11.3 8.2 17.9 6.1s11.2-8.3 11.2-15.3V224c0-70.7-57.3-128-128-128H392.3c-36.4 0-69.9-17.6-101.1-36.4C262.3 42.1 228.3 32 192 32C86 32 0 118 0 224c0 71.1 38.6 133.1 96 166.3V456c0 13.3 10.7 24 24 24s24-10.7 24-24V410c15.3 3.9 31.4 6 48 6c5.4 0 10.7-.2 16-.7V456c0 13.3 10.7 24 24 24s24-10.7 24-24V405.1c12.4-4.4 24.2-10 35.2-16.7zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $5c8203742f0e3062$export$56b6d3d7d0e67a1c = {
    prefix: "fas",
    iconName: "arrow-right-arrow-left",
    icon: [
        448,
        512,
        [
            8644,
            "exchange"
        ],
        "f0ec",
        "M438.6 150.6c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96 32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l306.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96zm-333.3 352c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 416 416 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96z"
    ]
};
var $5c8203742f0e3062$export$1aab915ca61b734a = $5c8203742f0e3062$export$56b6d3d7d0e67a1c;
var $5c8203742f0e3062$export$7f465bf410c6eff7 = {
    prefix: "fas",
    iconName: "rotate-right",
    icon: [
        512,
        512,
        [
            "redo-alt",
            "rotate-forward"
        ],
        "f2f9",
        "M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"
    ]
};
var $5c8203742f0e3062$export$50c037520c6cfdc1 = $5c8203742f0e3062$export$7f465bf410c6eff7;
var $5c8203742f0e3062$export$2507849a0fdd7f64 = $5c8203742f0e3062$export$7f465bf410c6eff7;
var $5c8203742f0e3062$export$750d52edc1dafc7 = {
    prefix: "fas",
    iconName: "utensils",
    icon: [
        448,
        512,
        [
            127860,
            61685,
            "cutlery"
        ],
        "f2e7",
        "M416 0C400 0 288 32 288 176V288c0 35.3 28.7 64 64 64h32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352 240 32c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7 .1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V255.6c44.9-4.1 80-41.8 80-87.7c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16V150.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8V16zm48.3 152l-.3 0-.3 0 .3-.7 .3 .7z"
    ]
};
var $5c8203742f0e3062$export$7034e54a8036c5c8 = $5c8203742f0e3062$export$750d52edc1dafc7;
var $5c8203742f0e3062$export$63f4908401ded049 = {
    prefix: "fas",
    iconName: "arrow-up-wide-short",
    icon: [
        576,
        512,
        [
            "sort-amount-up"
        ],
        "f161",
        "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 480h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $5c8203742f0e3062$export$28ef3e933e4b5364 = $5c8203742f0e3062$export$63f4908401ded049;
var $5c8203742f0e3062$export$9b53510cf4010e4d = {
    prefix: "fas",
    iconName: "mill-sign",
    icon: [
        384,
        512,
        [],
        "e1ed",
        "M302.1 42.8c5.9-16.6-2.7-35-19.4-40.9s-35 2.7-40.9 19.4L208 116.1c-5.7 4-11.1 8.5-16 13.5C171.7 108.9 143.3 96 112 96c-19.5 0-37.8 5-53.7 13.7C52.5 101.4 42.9 96 32 96C14.3 96 0 110.3 0 128v80V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-26.5 21.5-48 48-48s48 21.5 48 48v42.5L81.9 469.2c-5.9 16.6 2.7 35 19.4 40.9s35-2.7 40.9-19.4l21.4-60C168.9 441 179.6 448 192 448c17.7 0 32-14.3 32-32V261.5l35.7-100c3.9-1 8.1-1.6 12.3-1.6c26.5 0 48 21.5 48 48V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-58.2-44.3-106-101.1-111.5l19.2-53.8z"
    ]
};
var $5c8203742f0e3062$export$86079bc65a716451 = {
    prefix: "fas",
    iconName: "bowl-rice",
    icon: [
        512,
        512,
        [],
        "e2eb",
        "M176 56c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24zm24 48h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24zM56 176H72c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 283.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4zM224 200c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zm-96 0c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H104c-13.3 0-24-10.7-24-24s10.7-24 24-24zm216 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H392c-13.3 0-24-10.7-24-24s10.7-24 24-24zM296 32h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $5c8203742f0e3062$export$138b45e2afb1dfa4 = {
    prefix: "fas",
    iconName: "skull",
    icon: [
        512,
        512,
        [
            128128
        ],
        "f54c",
        "M416 398.9c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224c0 70.7 37.5 133.8 96 174.9c0 .4 0 .7 0 1.1v64c0 26.5 21.5 48 48 48h48V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c26.5 0 48-21.5 48-48V400c0-.4 0-.7 0-1.1zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $5c8203742f0e3062$export$fd06ff4ce9799eb0 = {
    prefix: "fas",
    iconName: "tower-broadcast",
    icon: [
        576,
        512,
        [
            "broadcast-tower"
        ],
        "f519",
        "M80.3 44C69.8 69.9 64 98.2 64 128s5.8 58.1 16.3 84c6.6 16.4-1.3 35-17.7 41.7s-35-1.3-41.7-17.7C7.4 202.6 0 166.1 0 128S7.4 53.4 20.9 20C27.6 3.6 46.2-4.3 62.6 2.3S86.9 27.6 80.3 44zM555.1 20C568.6 53.4 576 89.9 576 128s-7.4 74.6-20.9 108c-6.6 16.4-25.3 24.3-41.7 17.7S489.1 228.4 495.7 212c10.5-25.9 16.3-54.2 16.3-84s-5.8-58.1-16.3-84C489.1 27.6 497 9 513.4 2.3s35 1.3 41.7 17.7zM352 128c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64zM170.6 76.8C163.8 92.4 160 109.7 160 128s3.8 35.6 10.6 51.2c7.1 16.2-.3 35.1-16.5 42.1s-35.1-.3-42.1-16.5c-10.3-23.6-16-49.6-16-76.8s5.7-53.2 16-76.8c7.1-16.2 25.9-23.6 42.1-16.5s23.6 25.9 16.5 42.1zM464 51.2c10.3 23.6 16 49.6 16 76.8s-5.7 53.2-16 76.8c-7.1 16.2-25.9 23.6-42.1 16.5s-23.6-25.9-16.5-42.1c6.8-15.6 10.6-32.9 10.6-51.2s-3.8-35.6-10.6-51.2c-7.1-16.2 .3-35.1 16.5-42.1s35.1 .3 42.1 16.5z"
    ]
};
var $5c8203742f0e3062$export$f68b38d51f5c0ed = $5c8203742f0e3062$export$fd06ff4ce9799eb0;
var $5c8203742f0e3062$export$f846b848b3ba3064 = {
    prefix: "fas",
    iconName: "truck-pickup",
    icon: [
        640,
        512,
        [
            128763
        ],
        "f63c",
        "M368.6 96l76.8 96H288V96h80.6zM224 80V192H64c-17.7 0-32 14.3-32 32v64c-17.7 0-32 14.3-32 32s14.3 32 32 32H65.1c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16h66.3c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32V224c0-17.7-14.3-32-32-32H527.4L418.6 56c-12.1-15.2-30.5-24-50-24H272c-26.5 0-48 21.5-48 48zm0 288a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm288 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"
    ]
};
var $5c8203742f0e3062$export$5608156cc81126e7 = {
    prefix: "fas",
    iconName: "up-long",
    icon: [
        320,
        512,
        [
            "long-arrow-alt-up"
        ],
        "f30c",
        "M318 177.5c3.8-8.8 2-19-4.6-26l-136-144C172.9 2.7 166.6 0 160 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26S14.4 192 24 192H96l0 288c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32l0-288h72c9.6 0 18.2-5.7 22-14.5z"
    ]
};
var $5c8203742f0e3062$export$43c8f2a46326c55f = $5c8203742f0e3062$export$5608156cc81126e7;
var $5c8203742f0e3062$export$51577929c676143b = {
    prefix: "fas",
    iconName: "stop",
    icon: [
        384,
        512,
        [
            9209
        ],
        "f04d",
        "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
    ]
};
var $5c8203742f0e3062$export$e151fe5abf6db993 = {
    prefix: "fas",
    iconName: "code-merge",
    icon: [
        448,
        512,
        [],
        "f387",
        "M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32.4 97.2c28-12.4 47.6-40.5 47.6-73.2c0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3V358.7C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V272c26.7 20.1 60 32 96 32h86.7c12.3 28.3 40.5 48 73.3 48c44.2 0 80-35.8 80-80s-35.8-80-80-80c-32.8 0-61 19.7-73.3 48H208c-49.9 0-91-38.1-95.6-86.8zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM344 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $5c8203742f0e3062$export$a9578350255b2b79 = {
    prefix: "fas",
    iconName: "upload",
    icon: [
        512,
        512,
        [],
        "f093",
        "M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $5c8203742f0e3062$export$4cf54a379be7e59a = {
    prefix: "fas",
    iconName: "hurricane",
    icon: [
        384,
        512,
        [],
        "f751",
        "M0 208C0 104.4 75.7 18.5 174.9 2.6C184 1.2 192 8.6 192 17.9V81.2c0 8.4 6.5 15.3 14.7 16.5C307 112.5 384 199 384 303.4c0 103.6-75.7 189.5-174.9 205.4c-9.2 1.5-17.1-5.9-17.1-15.2V430.2c0-8.4-6.5-15.3-14.7-16.5C77 398.9 0 312.4 0 208zm288 48A96 96 0 1 0 96 256a96 96 0 1 0 192 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$ac54ffffdb218383 = {
    prefix: "fas",
    iconName: "mound",
    icon: [
        576,
        512,
        [],
        "e52d",
        "M144.1 179.2C173.8 127.7 228.6 96 288 96s114.2 31.7 143.9 83.2L540.4 368c12.3 21.3-3.1 48-27.7 48H63.3c-24.6 0-40-26.6-27.7-48L144.1 179.2z"
    ]
};
var $5c8203742f0e3062$export$a3a5de5f6e2513ba = {
    prefix: "fas",
    iconName: "toilet-portable",
    icon: [
        320,
        512,
        [],
        "e583",
        "M0 32V64H320V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zM24 96H0v24V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H272v8c0 13.3 10.7 24 24 24s24-10.7 24-24V120 96H296 24zM256 240v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $5c8203742f0e3062$export$84021631df0f831b = {
    prefix: "fas",
    iconName: "compact-disc",
    icon: [
        512,
        512,
        [
            128191,
            128192,
            128440
        ],
        "f51f",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96-32a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM96 240c0-35 17.5-71.1 45.2-98.8S205 96 240 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-45.4 0-89.2 22.3-121.5 54.5S64 194.6 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $5c8203742f0e3062$export$148bcede94488555 = {
    prefix: "fas",
    iconName: "file-arrow-down",
    icon: [
        384,
        512,
        [
            "file-download"
        ],
        "f56d",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 232V334.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V232c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $5c8203742f0e3062$export$1013b9966d758343 = $5c8203742f0e3062$export$148bcede94488555;
var $5c8203742f0e3062$export$afb5d0eee7c1bdb = {
    prefix: "fas",
    iconName: "caravan",
    icon: [
        640,
        512,
        [],
        "f8ff",
        "M0 112C0 67.8 35.8 32 80 32H416c88.4 0 160 71.6 160 160V352h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0H288c0 53-43 96-96 96s-96-43-96-96H80c-44.2 0-80-35.8-80-80V112zM320 352H448V256H416c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V160c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32V352zM96 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96zm96 336a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $5c8203742f0e3062$export$1639f087457d4f58 = {
    prefix: "fas",
    iconName: "shield-cat",
    icon: [
        512,
        512,
        [],
        "e572",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160 154.4c0-5.8 4.7-10.4 10.4-10.4h.2c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4h48c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3h.2c5.8 0 10.4 4.7 10.4 10.4V272c0 53-43 96-96 96s-96-43-96-96V154.4zM216 288a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $5c8203742f0e3062$export$6869964aa308dd31 = {
    prefix: "fas",
    iconName: "bolt",
    icon: [
        448,
        512,
        [
            9889,
            "zap"
        ],
        "f0e7",
        "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"
    ]
};
var $5c8203742f0e3062$export$d62abb82664f55ca = $5c8203742f0e3062$export$6869964aa308dd31;
var $5c8203742f0e3062$export$b80f542550a05ea7 = {
    prefix: "fas",
    iconName: "glass-water",
    icon: [
        384,
        512,
        [],
        "e4f4",
        "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM73 156.5L66.4 64H317.6L311 156.5l-24.2 12.1c-19.4 9.7-42.2 9.7-61.6 0c-20.9-10.4-45.5-10.4-66.4 0c-19.4 9.7-42.2 9.7-61.6 0L73 156.5z"
    ]
};
var $5c8203742f0e3062$export$b69c6757012a2267 = {
    prefix: "fas",
    iconName: "oil-well",
    icon: [
        576,
        512,
        [],
        "e532",
        "M528.3 61.3c-11.4-42.7-55.3-68-98-56.6L414.9 8.8C397.8 13.4 387.7 31 392.3 48l24.5 91.4L308.5 167.5l-6.3-18.1C297.7 136.6 285.6 128 272 128s-25.7 8.6-30.2 21.4l-13.6 39L96 222.6V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H406.7L340 257.5l-62.2 16.1L305.3 352H238.7L265 277l-74.6 19.3L137.3 448H96V288.8l337.4-87.5 25.2 94c4.6 17.1 22.1 27.2 39.2 22.6l15.5-4.1c42.7-11.4 68-55.3 56.6-98L528.3 61.3zM205.1 448l11.2-32H327.7l11.2 32H205.1z"
    ]
};
var $5c8203742f0e3062$export$4689a147513594a7 = {
    prefix: "fas",
    iconName: "vault",
    icon: [
        576,
        512,
        [],
        "e2c5",
        "M64 0C28.7 0 0 28.7 0 64V416c0 35.3 28.7 64 64 64H80l16 32h64l16-32H400l16 32h64l16-32h16c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 320a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-240a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM480 221.3V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V221.3c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3z"
    ]
};
var $5c8203742f0e3062$export$a9f5c0b9c1e77a6f = {
    prefix: "fas",
    iconName: "mars",
    icon: [
        448,
        512,
        [
            9794
        ],
        "f222",
        "M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8H424c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80l0 0h0v0zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"
    ]
};
var $5c8203742f0e3062$export$505476859b9691c0 = {
    prefix: "fas",
    iconName: "toilet",
    icon: [
        448,
        512,
        [
            128701
        ],
        "f7d8",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h8V196.9c-1.9 1.4-3.8 2.9-5.6 4.4C10.9 214.5 0 232.9 0 256c0 46.9 14.3 84.1 37 112.5c14.2 17.7 31.1 31.3 48.5 41.8L65.6 469.9c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H352c10.3 0 19.9-4.9 26-13.3s7.7-19.1 4.4-28.8l-19.8-59.5c17.4-10.5 34.3-24.1 48.5-41.8c22.7-28.4 37-65.5 37-112.5c0-23.1-10.9-41.5-26.4-54.6c-1.8-1.5-3.7-3-5.6-4.4V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM384 256.3c0 1-.3 2.6-3.8 5.6c-4.8 4.1-14 9-29.3 13.4C320.5 284 276.1 288 224 288s-96.5-4-126.9-12.8c-15.3-4.4-24.5-9.3-29.3-13.4c-3.5-3-3.8-4.6-3.8-5.6l0-.3 0-.1c0-1 0-2.5 3.8-5.8c4.8-4.1 14-9 29.3-13.4C127.5 228 171.9 224 224 224s96.5 4 126.9 12.8c15.3 4.4 24.5 9.3 29.3 13.4c3.8 3.2 3.8 4.8 3.8 5.8l0 .1 0 .3zM328.2 384l-.2 .5 0-.5h.2zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$94ef668f5108e431 = {
    prefix: "fas",
    iconName: "plane-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e557",
        "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $5c8203742f0e3062$export$30f1437f5a4e991d = {
    prefix: "fas",
    iconName: "yen-sign",
    icon: [
        320,
        512,
        [
            165,
            "cny",
            "jpy",
            "rmb",
            "yen"
        ],
        "f157",
        "M58.6 46.2C48.8 31.5 29 27.6 14.3 37.4S-4.4 67 5.4 81.7L100.2 224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V288h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H219.8L314.6 81.7c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9L160 198.3 58.6 46.2z"
    ]
};
var $5c8203742f0e3062$export$268a23eee8f089a2 = $5c8203742f0e3062$export$30f1437f5a4e991d;
var $5c8203742f0e3062$export$5460a9192eb79bf5 = $5c8203742f0e3062$export$30f1437f5a4e991d;
var $5c8203742f0e3062$export$e2a8016afc962883 = $5c8203742f0e3062$export$30f1437f5a4e991d;
var $5c8203742f0e3062$export$cf914b1afb9455a2 = $5c8203742f0e3062$export$30f1437f5a4e991d;
var $5c8203742f0e3062$export$1ae0a94c8ba4131a = {
    prefix: "fas",
    iconName: "ruble-sign",
    icon: [
        384,
        512,
        [
            8381,
            "rouble",
            "rub",
            "ruble"
        ],
        "f158",
        "M96 32C78.3 32 64 46.3 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V416H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V320H240c79.5 0 144-64.5 144-144s-64.5-144-144-144H96zM240 256H128V96H240c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $5c8203742f0e3062$export$c5dc3d98c4d8f2a5 = $5c8203742f0e3062$export$1ae0a94c8ba4131a;
var $5c8203742f0e3062$export$9c4d936240e1f0b1 = $5c8203742f0e3062$export$1ae0a94c8ba4131a;
var $5c8203742f0e3062$export$6c0cf65134387046 = $5c8203742f0e3062$export$1ae0a94c8ba4131a;
var $5c8203742f0e3062$export$2fa35dcbc038dbe9 = {
    prefix: "fas",
    iconName: "sun",
    icon: [
        512,
        512,
        [
            9728
        ],
        "f185",
        "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
    ]
};
var $5c8203742f0e3062$export$790dd5b32282b6fb = {
    prefix: "fas",
    iconName: "guitar",
    icon: [
        512,
        512,
        [],
        "f7a6",
        "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41-77.5 77.6c-45.1-29.4-99.3-30.2-131 1.6c-11 11-18 24.6-21.4 39.6c-3.7 16.6-19.1 30.7-36.1 31.6c-25.6 1.3-49.3 10.7-67.3 28.6C-16 328.4-7.6 409.4 47.5 464.5s136.1 63.5 180.9 18.7c17.9-17.9 27.4-41.7 28.6-67.3c.9-17 15-32.3 31.6-36.1c15-3.4 28.6-10.5 39.6-21.4c31.8-31.8 31-85.9 1.6-131l77.6-77.6 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM208 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $5c8203742f0e3062$export$600a1b26b33c3d47 = {
    prefix: "fas",
    iconName: "face-laugh-wink",
    icon: [
        512,
        512,
        [
            "laugh-wink"
        ],
        "f59c",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
    ]
};
var $5c8203742f0e3062$export$77ac40095f39933e = $5c8203742f0e3062$export$600a1b26b33c3d47;
var $5c8203742f0e3062$export$5bcca85203ebd1e8 = {
    prefix: "fas",
    iconName: "horse-head",
    icon: [
        640,
        512,
        [],
        "f7ab",
        "M64 464V316.9c0-108.4 68.3-205.1 170.5-241.3L404.2 15.5C425.6 7.9 448 23.8 448 46.4c0 11-5.5 21.2-14.6 27.3L400 96c48.1 0 91.2 29.8 108.1 74.9l48.6 129.5c11.8 31.4 4.1 66.8-19.6 90.5c-16 16-37.8 25.1-60.5 25.1h-3.4c-26.1 0-50.9-11.6-67.6-31.7l-32.3-38.7c-11.7 4.1-24.2 6.4-37.3 6.4l-.1 0 0 0c-6.3 0-12.5-.5-18.6-1.5c-3.6-.6-7.2-1.4-10.7-2.3l0 0c-28.9-7.8-53.1-26.8-67.8-52.2c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c24 41.5 68.3 70 119.3 71.9l47.2 70.8c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8H112c-26.5 0-48-21.5-48-48zM392 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $5c8203742f0e3062$export$cd79eeea6201e9d4 = {
    prefix: "fas",
    iconName: "bore-hole",
    icon: [
        512,
        512,
        [],
        "e4c3",
        "M256 0c-17.7 0-32 14.3-32 32V296.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V32c0-17.7-14.3-32-32-32zM48 128c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H384c-17.7 0-32 14.3-32 32V352c0 53-43 96-96 96s-96-43-96-96V160c0-17.7-14.3-32-32-32H48z"
    ]
};
var $5c8203742f0e3062$export$5548c3eb51060fa8 = {
    prefix: "fas",
    iconName: "industry",
    icon: [
        576,
        512,
        [],
        "f275",
        "M64 32C46.3 32 32 46.3 32 64V304v48 80c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V304 152.2c0-18.2-19.4-29.7-35.4-21.1L352 215.4V152.2c0-18.2-19.4-29.7-35.4-21.1L160 215.4V64c0-17.7-14.3-32-32-32H64z"
    ]
};
var $5c8203742f0e3062$export$531badb89cf01312 = {
    prefix: "fas",
    iconName: "circle-down",
    icon: [
        512,
        512,
        [
            61466,
            "arrow-alt-circle-down"
        ],
        "f358",
        "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6L269.8 394.5c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5L135.1 294.6c-4.5-4.2-7.1-10.1-7.1-16.3c0-12.3 10-22.3 22.3-22.3l57.7 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 57.7 0c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.1 16.3z"
    ]
};
var $5c8203742f0e3062$export$ff3afbc8c0bc5d59 = $5c8203742f0e3062$export$531badb89cf01312;
var $5c8203742f0e3062$export$b9d8fdf63999a76d = {
    prefix: "fas",
    iconName: "arrows-turn-to-dots",
    icon: [
        512,
        512,
        [],
        "e4c1",
        "M249.4 25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 96 416 96c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7-14.3-32-32-32l-146.7 0 25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zm13.3 256l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416 96 416c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96l146.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM384 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192A64 64 0 1 1 64 64a64 64 0 1 1 0 128z"
    ]
};
var $5c8203742f0e3062$export$6248ec7440b2ffcb = {
    prefix: "fas",
    iconName: "florin-sign",
    icon: [
        384,
        512,
        [],
        "e184",
        "M314.7 32c-38.8 0-73.7 23.3-88.6 59.1L170.7 224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h80L98.9 396.3c-5 11.9-16.6 19.7-29.5 19.7H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H69.3c38.8 0 73.7-23.3 88.6-59.1L213.3 288H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H240l45.1-108.3c5-11.9 16.6-19.7 29.5-19.7H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H314.7z"
    ]
};
var $5c8203742f0e3062$export$a51c464b699200ae = {
    prefix: "fas",
    iconName: "arrow-down-short-wide",
    icon: [
        576,
        512,
        [
            "sort-amount-desc",
            "sort-amount-down-alt"
        ],
        "f884",
        "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$93835bc31892b5c3 = $5c8203742f0e3062$export$a51c464b699200ae;
var $5c8203742f0e3062$export$e7d80d8c226cb77 = $5c8203742f0e3062$export$a51c464b699200ae;
var $5c8203742f0e3062$export$7f24f1bf98af5411 = {
    prefix: "fas",
    iconName: "less-than",
    icon: [
        384,
        512,
        [
            62774
        ],
        "3c",
        "M380.6 81.7c7.9 15.8 1.5 35-14.3 42.9L103.6 256 366.3 387.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-320-160C6.8 279.2 0 268.1 0 256s6.8-23.2 17.7-28.6l320-160c15.8-7.9 35-1.5 42.9 14.3z"
    ]
};
var $5c8203742f0e3062$export$4b5be0142d10f342 = {
    prefix: "fas",
    iconName: "angle-down",
    icon: [
        448,
        512,
        [
            8964
        ],
        "f107",
        "M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ]
};
var $5c8203742f0e3062$export$ec5cfe409de2ed37 = {
    prefix: "fas",
    iconName: "car-tunnel",
    icon: [
        512,
        512,
        [],
        "e4de",
        "M256 0C114.6 0 0 114.6 0 256V448c0 35.3 28.7 64 64 64h42.8c-6.6-5.9-10.8-14.4-10.8-24V376c0-20.8 11.3-38.9 28.1-48.6l21-64.7c7.5-23.1 29-38.7 53.3-38.7H313.6c24.3 0 45.8 15.6 53.3 38.7l21 64.7c16.8 9.7 28.2 27.8 28.2 48.6V488c0 9.6-4.2 18.1-10.8 24H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zM362.8 512c-6.6-5.9-10.8-14.4-10.8-24V448H160v40c0 9.6-4.2 18.1-10.8 24H362.8zM190.8 277.5L177 320H335l-13.8-42.5c-1.1-3.3-4.1-5.5-7.6-5.5H198.4c-3.5 0-6.5 2.2-7.6 5.5zM168 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm200-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $5c8203742f0e3062$export$3cd04b7c1624f598 = {
    prefix: "fas",
    iconName: "head-side-cough",
    icon: [
        640,
        512,
        [],
        "e061",
        "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v0 32L339.2 365.6c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9L448 416v16c0 26.5-21.5 48-48 48H320v8c0 13.3-10.7 24-24 24H256v0H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm352-.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM592 480a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 312a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $5c8203742f0e3062$export$1412f35381064d7d = {
    prefix: "fas",
    iconName: "grip-lines",
    icon: [
        448,
        512,
        [],
        "f7a4",
        "M32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 288zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160z"
    ]
};
var $5c8203742f0e3062$export$aba24ca305bbe8c1 = {
    prefix: "fas",
    iconName: "thumbs-down",
    icon: [
        512,
        512,
        [
            128078,
            61576
        ],
        "f165",
        "M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2H464c26.5 0 48-21.5 48-48c0-18.5-10.5-34.6-25.9-42.6C497 236.6 504 223.1 504 208c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48H294.5c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7V192v48 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 384H96c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H32C14.3 96 0 110.3 0 128V352c0 17.7 14.3 32 32 32z"
    ]
};
var $5c8203742f0e3062$export$d9b89b5872b67a4f = {
    prefix: "fas",
    iconName: "user-lock",
    icon: [
        640,
        512,
        [],
        "f502",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H392.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7H178.3zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $5c8203742f0e3062$export$becbc35d3541bcc = {
    prefix: "fas",
    iconName: "arrow-right-long",
    icon: [
        512,
        512,
        [
            "long-arrow-right"
        ],
        "f178",
        "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
    ]
};
var $5c8203742f0e3062$export$7ec6527cf8651899 = $5c8203742f0e3062$export$becbc35d3541bcc;
var $5c8203742f0e3062$export$f6773af4219eebd = {
    prefix: "fas",
    iconName: "anchor-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e4ac",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $5c8203742f0e3062$export$37fe3659ba7b6b54 = {
    prefix: "fas",
    iconName: "ellipsis",
    icon: [
        448,
        512,
        [
            "ellipsis-h"
        ],
        "f141",
        "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
    ]
};
var $5c8203742f0e3062$export$c9f2fedd4489a2ee = $5c8203742f0e3062$export$37fe3659ba7b6b54;
var $5c8203742f0e3062$export$3db75d5ac9e98468 = {
    prefix: "fas",
    iconName: "chess-pawn",
    icon: [
        320,
        512,
        [
            9823
        ],
        "f443",
        "M215.5 224c29.2-18.4 48.5-50.9 48.5-88c0-57.4-46.6-104-104-104S56 78.6 56 136c0 37.1 19.4 69.6 48.5 88H96c-17.7 0-32 14.3-32 32c0 16.5 12.5 30 28.5 31.8L80 400H240L227.5 287.8c16-1.8 28.5-15.3 28.5-31.8c0-17.7-14.3-32-32-32h-8.5zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H281.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L256 432H64L22.6 473.4z"
    ]
};
var $5c8203742f0e3062$export$f04e7a0f1033a0cd = {
    prefix: "fas",
    iconName: "kit-medical",
    icon: [
        576,
        512,
        [
            "first-aid"
        ],
        "f479",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H96V32H64zm64 0V480H448V32H128zM512 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H480V480h32zM256 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V288H208c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h48V176z"
    ]
};
var $5c8203742f0e3062$export$5b01ccb2da4c4387 = $5c8203742f0e3062$export$f04e7a0f1033a0cd;
var $5c8203742f0e3062$export$a77a2f6da72f89e3 = {
    prefix: "fas",
    iconName: "person-through-window",
    icon: [
        640,
        512,
        [],
        "e5a9",
        "M64 64l224 0 0 9.8c0 39-23.7 74-59.9 88.4C167.6 186.5 128 245 128 310.2l0 73.8s0 0 0 0H64V64zm288 0l224 0V384H508.3l-3.7-4.5-75.2-90.2c-9.1-10.9-22.6-17.3-36.9-17.3l-71.1 0-41-63.1c-.3-.5-.6-1-1-1.4c44.7-29 72.5-79 72.5-133.6l0-9.8zm73 320H379.2l42.7 64H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V400c0 26.5 21.5 48 48 48H308.2l33.2 49.8c9.8 14.7 29.7 18.7 44.4 8.9s18.7-29.7 8.9-44.4L310.5 336l74.6 0 40 48zm-159.5 0H192s0 0 0 0l0-73.8c0-10.2 1.6-20.1 4.7-29.5L265.5 384zM192 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $5c8203742f0e3062$export$b34d64c205c732a9 = {
    prefix: "fas",
    iconName: "toolbox",
    icon: [
        512,
        512,
        [
            129520
        ],
        "f552",
        "M176 88l0 40 160 0 0-40c0-4.4-3.6-8-8-8L184 80c-4.4 0-8 3.6-8 8zm-48 40l0-40c0-30.9 25.1-56 56-56l144 0c30.9 0 56 25.1 56 56l0 40 28.1 0c12.7 0 24.9 5.1 33.9 14.1l51.9 51.9c9 9 14.1 21.2 14.1 33.9l0 92.1-128 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-128 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L0 320l0-92.1c0-12.7 5.1-24.9 14.1-33.9l51.9-51.9c9-9 21.2-14.1 33.9-14.1l28.1 0zM0 416l0-64 128 0c0 17.7 14.3 32 32 32s32-14.3 32-32l128 0c0 17.7 14.3 32 32 32s32-14.3 32-32l128 0 0 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64z"
    ]
};
var $5c8203742f0e3062$export$3aa81d0e606b08b6 = {
    prefix: "fas",
    iconName: "hands-holding-circle",
    icon: [
        640,
        512,
        [],
        "e4fb",
        "M320 0a128 128 0 1 1 0 256A128 128 0 1 1 320 0zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"
    ]
};
var $5c8203742f0e3062$export$a18cfac400116d9f = {
    prefix: "fas",
    iconName: "bug",
    icon: [
        512,
        512,
        [],
        "f188",
        "M256 0c53 0 96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96c0-53 43-96 96-96zM41.4 105.4c12.5-12.5 32.8-12.5 45.3 0l64 64c.7 .7 1.3 1.4 1.9 2.1c14.2-7.3 30.4-11.4 47.5-11.4H312c17.1 0 33.2 4.1 47.5 11.4c.6-.7 1.2-1.4 1.9-2.1l64-64c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-.7 .7-1.4 1.3-2.1 1.9c6.2 12 10.1 25.3 11.1 39.5H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c0 24.6-5.5 47.8-15.4 68.6c2.2 1.3 4.2 2.9 6 4.8l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-63.1-63.1c-24.5 21.8-55.8 36.2-90.3 39.6V240c0-8.8-7.2-16-16-16s-16 7.2-16 16V479.2c-34.5-3.4-65.8-17.8-90.3-39.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64c1.9-1.9 3.9-3.4 6-4.8C101.5 367.8 96 344.6 96 320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96.3c1.1-14.1 5-27.5 11.1-39.5c-.7-.6-1.4-1.2-2.1-1.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var $5c8203742f0e3062$export$3e7437bf6535bef0 = {
    prefix: "fas",
    iconName: "credit-card",
    icon: [
        576,
        512,
        [
            128179,
            62083,
            "credit-card-alt"
        ],
        "f09d",
        "M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
    ]
};
var $5c8203742f0e3062$export$5fffe8e3c36964a2 = $5c8203742f0e3062$export$3e7437bf6535bef0;
var $5c8203742f0e3062$export$9eefe7fcdf123b76 = {
    prefix: "fas",
    iconName: "car",
    icon: [
        512,
        512,
        [
            128664,
            "automobile"
        ],
        "f1b9",
        "M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400v48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$240a6c53cf7ac525 = $5c8203742f0e3062$export$9eefe7fcdf123b76;
var $5c8203742f0e3062$export$6638511b28df3be5 = {
    prefix: "fas",
    iconName: "hand-holding-hand",
    icon: [
        576,
        512,
        [],
        "e4f7",
        "M7.8 207.7c-13.1-17.8-9.3-42.8 8.5-55.9L142.9 58.5C166.2 41.3 194.5 32 223.5 32H384 544c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H507.2l-44.9 36c-22.7 18.2-50.9 28-80 28H304 288 224c-17.7 0-32-14.3-32-32s14.3-32 32-32h64 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H183.4L63.7 216.2c-17.8 13.1-42.8 9.3-55.9-8.5zM382.4 160l0 0 .9 0c-.3 0-.6 0-.9 0zM568.2 304.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 453.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 352l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $5c8203742f0e3062$export$cb6e40528b98a5b = {
    prefix: "fas",
    iconName: "book-open-reader",
    icon: [
        512,
        512,
        [
            "book-reader"
        ],
        "f5da",
        "M160 96a96 96 0 1 1 192 0A96 96 0 1 1 160 96zm80 152V512l-48.4-24.2c-20.9-10.4-43.5-17-66.8-19.3l-96-9.6C12.5 457.2 0 443.5 0 427V224c0-17.7 14.3-32 32-32H62.3c63.6 0 125.6 19.6 177.7 56zm32 264V248c52.1-36.4 114.1-56 177.7-56H480c17.7 0 32 14.3 32 32V427c0 16.4-12.5 30.2-28.8 31.8l-96 9.6c-23.2 2.3-45.9 8.9-66.8 19.3L272 512z"
    ]
};
var $5c8203742f0e3062$export$cee14fe33262fa7d = $5c8203742f0e3062$export$cb6e40528b98a5b;
var $5c8203742f0e3062$export$af9eaee7db3ba7a9 = {
    prefix: "fas",
    iconName: "mountain-sun",
    icon: [
        640,
        512,
        [],
        "e52f",
        "M560 160A80 80 0 1 0 560 0a80 80 0 1 0 0 160zM55.9 512H381.1h75H578.9c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 196.1 487.8 192 480 192s-15 4.1-19.1 10.7l-48.2 79L286.8 81c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 426.4C3 435.3 0 445.6 0 456.1C0 487 25 512 55.9 512z"
    ]
};
var $5c8203742f0e3062$export$a63cecc8a4166c49 = {
    prefix: "fas",
    iconName: "arrows-left-right-to-line",
    icon: [
        640,
        512,
        [],
        "e4ba",
        "M32 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64zm214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224l229.5 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288l-229.5 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM640 96V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $5c8203742f0e3062$export$b06003a02c9055bd = {
    prefix: "fas",
    iconName: "dice-d20",
    icon: [
        512,
        512,
        [],
        "f6cf",
        "M48.7 125.8l53.2 31.9c7.8 4.7 17.8 2 22.2-5.9L201.6 12.1c3-5.4-.9-12.1-7.1-12.1c-1.6 0-3.2 .5-4.6 1.4L47.9 98.8c-9.6 6.6-9.2 20.9 .8 26.9zM16 171.7V295.3c0 8 10.4 11 14.7 4.4l60-92c5-7.6 2.6-17.8-5.2-22.5L40.2 158C29.6 151.6 16 159.3 16 171.7zM310.4 12.1l77.6 139.6c4.4 7.9 14.5 10.6 22.2 5.9l53.2-31.9c10-6 10.4-20.3 .8-26.9L322.1 1.4c-1.4-.9-3-1.4-4.6-1.4c-6.2 0-10.1 6.7-7.1 12.1zM496 171.7c0-12.4-13.6-20.1-24.2-13.7l-45.3 27.2c-7.8 4.7-10.1 14.9-5.2 22.5l60 92c4.3 6.7 14.7 3.6 14.7-4.4V171.7zm-49.3 246L286.1 436.6c-8.1 .9-14.1 7.8-14.1 15.9v52.8c0 3.7 3 6.8 6.8 6.8c.8 0 1.6-.1 2.4-.4l172.7-64c6.1-2.2 10.1-8 10.1-14.5c0-9.3-8.1-16.5-17.3-15.4zM233.2 512c3.7 0 6.8-3 6.8-6.8V452.6c0-8.1-6.1-14.9-14.1-15.9l-160.6-19c-9.2-1.1-17.3 6.1-17.3 15.4c0 6.5 4 12.3 10.1 14.5l172.7 64c.8 .3 1.6 .4 2.4 .4zM41.7 382.9l170.9 20.2c7.8 .9 13.4-7.5 9.5-14.3l-85.7-150c-5.9-10.4-20.7-10.8-27.3-.8L30.2 358.2c-6.5 9.9-.3 23.3 11.5 24.7zm439.6-24.8L402.9 238.1c-6.5-10-21.4-9.6-27.3 .8L290.2 388.5c-3.9 6.8 1.6 15.2 9.5 14.3l170.1-20c11.8-1.4 18-14.7 11.5-24.6zm-216.9 11l78.4-137.2c6.1-10.7-1.6-23.9-13.9-23.9H183.1c-12.3 0-20 13.3-13.9 23.9l78.4 137.2c3.7 6.4 13 6.4 16.7 0zM174.4 176H337.6c12.2 0 19.9-13.1 14-23.8l-80-144c-2.8-5.1-8.2-8.2-14-8.2h-3.2c-5.8 0-11.2 3.2-14 8.2l-80 144c-5.9 10.7 1.8 23.8 14 23.8z"
    ]
};
var $5c8203742f0e3062$export$41ce20639e8fef2b = {
    prefix: "fas",
    iconName: "truck-droplet",
    icon: [
        640,
        512,
        [],
        "e58c",
        "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 272c39.8 0 72-29.6 72-66c0-27-39.4-82.9-59.9-110.3c-6.1-8.2-18.1-8.2-24.2 0C175.4 123 136 179 136 206c0 36.5 32.2 66 72 66z"
    ]
};
var $5c8203742f0e3062$export$e4686afbe882e24a = {
    prefix: "fas",
    iconName: "file-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e5a1",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
var $5c8203742f0e3062$export$d7a5da41ce01461d = {
    prefix: "fas",
    iconName: "temperature-arrow-up",
    icon: [
        576,
        512,
        [
            "temperature-up"
        ],
        "e040",
        "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM176 0C114.1 0 64 50.1 64 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM480 160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V160z"
    ]
};
var $5c8203742f0e3062$export$872345a0157330a3 = $5c8203742f0e3062$export$d7a5da41ce01461d;
var $5c8203742f0e3062$export$b48a5be96314835a = {
    prefix: "fas",
    iconName: "medal",
    icon: [
        512,
        512,
        [
            127941
        ],
        "f5a2",
        "M4.1 38.2C1.4 34.2 0 29.4 0 24.6C0 11 11 0 24.6 0H133.9c11.2 0 21.7 5.9 27.4 15.5l68.5 114.1c-48.2 6.1-91.3 28.6-123.4 61.9L4.1 38.2zm503.7 0L405.6 191.5c-32.1-33.3-75.2-55.8-123.4-61.9L350.7 15.5C356.5 5.9 366.9 0 378.1 0H487.4C501 0 512 11 512 24.6c0 4.8-1.4 9.6-4.1 13.6zM80 336a176 176 0 1 1 352 0A176 176 0 1 1 80 336zm184.4-94.9c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1L168 298.9c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z"
    ]
};
var $5c8203742f0e3062$export$f24e0fce77994d4d = {
    prefix: "fas",
    iconName: "bed",
    icon: [
        640,
        512,
        [
            128716
        ],
        "f236",
        "M32 32c17.7 0 32 14.3 32 32V320H288V160c0-17.7 14.3-32 32-32H544c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32zm144 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var $5c8203742f0e3062$export$51e3c5be06a49e32 = {
    prefix: "fas",
    iconName: "square-h",
    icon: [
        448,
        512,
        [
            "h-square"
        ],
        "f0fd",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM336 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H160l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H288V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $5c8203742f0e3062$export$f08bbcf8f59eafc2 = $5c8203742f0e3062$export$51e3c5be06a49e32;
var $5c8203742f0e3062$export$5c0b4709125e92f8 = {
    prefix: "fas",
    iconName: "podcast",
    icon: [
        448,
        512,
        [],
        "f2ce",
        "M319.4 372c48.5-31.3 80.6-85.9 80.6-148c0-97.2-78.8-176-176-176S48 126.8 48 224c0 62.1 32.1 116.6 80.6 148c1.2 17.3 4 38 7.2 57.1l.2 1C56 395.8 0 316.5 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 92.5-56 171.9-136 206.1l.2-1.1c3.1-19.2 6-39.8 7.2-57zm-2.3-38.1c-1.6-5.7-3.9-11.1-7-16.2c-5.8-9.7-13.5-17-21.9-22.4c19.5-17.6 31.8-43 31.8-71.3c0-53-43-96-96-96s-96 43-96 96c0 28.3 12.3 53.8 31.8 71.3c-8.4 5.4-16.1 12.7-21.9 22.4c-3.1 5.1-5.4 10.5-7 16.2C99.8 307.5 80 268 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 44-19.8 83.5-50.9 109.9zM224 312c32.9 0 64 8.6 64 43.8c0 33-12.9 104.1-20.6 132.9c-5.1 19-24.5 23.4-43.4 23.4s-38.2-4.4-43.4-23.4c-7.8-28.5-20.6-99.7-20.6-132.8c0-35.1 31.1-43.8 64-43.8zm0-144a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
    ]
};
var $5c8203742f0e3062$export$bf4d97a79734997f = {
    prefix: "fas",
    iconName: "temperature-full",
    icon: [
        320,
        512,
        [
            "temperature-4",
            "thermometer-4",
            "thermometer-full"
        ],
        "f2c7",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $5c8203742f0e3062$export$db946f8dc50a57ca = $5c8203742f0e3062$export$bf4d97a79734997f;
var $5c8203742f0e3062$export$92b2e2293472dd50 = $5c8203742f0e3062$export$bf4d97a79734997f;
var $5c8203742f0e3062$export$74e07083cef79a6f = $5c8203742f0e3062$export$bf4d97a79734997f;
var $5c8203742f0e3062$export$9b6162797ab1b255 = {
    prefix: "fas",
    iconName: "bell",
    icon: [
        448,
        512,
        [
            128276,
            61602
        ],
        "f0f3",
        "M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
    ]
};
var $5c8203742f0e3062$export$4fa56a54e822dd25 = {
    prefix: "fas",
    iconName: "superscript",
    icon: [
        512,
        512,
        [],
        "f12b",
        "M480 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 73.5 404.3 80 416 80v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V32zM32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32z"
    ]
};
var $5c8203742f0e3062$export$12ef959394d63192 = {
    prefix: "fas",
    iconName: "plug-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e560",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $5c8203742f0e3062$export$aa3c4c1c5a47bf98 = {
    prefix: "fas",
    iconName: "star-of-life",
    icon: [
        512,
        512,
        [],
        "f621",
        "M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V172.9l122-70.4c15.3-8.8 34.9-3.6 43.7 11.7l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7L352 256l122 70.4c15.3 8.8 20.5 28.4 11.7 43.7l-16 27.7c-8.8 15.3-28.4 20.6-43.7 11.7L304 339.1V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V339.1L86 409.6c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7c-8.8-15.3-3.6-34.9 11.7-43.7L160 256 38 185.6c-15.3-8.8-20.5-28.4-11.7-43.7l16-27.7C51.1 98.8 70.7 93.6 86 102.4l122 70.4V32z"
    ]
};
var $5c8203742f0e3062$export$4c60a3aade08b6c2 = {
    prefix: "fas",
    iconName: "phone-slash",
    icon: [
        640,
        512,
        [],
        "f3dd",
        "M601.2 5.1c10.4-8.2 25.5-6.3 33.7 4.1s6.3 25.5-4.1 33.7l-592 464c-10.4 8.2-25.5 6.3-33.7-4.1s-6.3-25.5 4.1-33.7l155.6-122C101.8 270 64 171.4 64 64c0-18 12.1-33.8 29.5-38.6l88-24c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L208 207.3c12 25.5 27.2 49.2 45 70.7L601.2 5.1zM234.3 415.6l91.3-72c13.7 9.1 28 17.3 43 24.3L409 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C545.8 499.9 530 512 512 512c-104.9 0-201.3-36-277.7-96.4z"
    ]
};
var $5c8203742f0e3062$export$d1de8d1b815d6a5 = {
    prefix: "fas",
    iconName: "paint-roller",
    icon: [
        512,
        512,
        [],
        "f5aa",
        "M0 64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 352c0-17.7 14.3-32 32-32V304c0-44.2 35.8-80 80-80H416c17.7 0 32-14.3 32-32V160 69.5c37.3 13.2 64 48.7 64 90.5v32c0 53-43 96-96 96H272c-8.8 0-16 7.2-16 16v16c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V352z"
    ]
};
var $5c8203742f0e3062$export$503f458ca5cf64c2 = {
    prefix: "fas",
    iconName: "handshake-angle",
    icon: [
        640,
        512,
        [
            "hands-helping"
        ],
        "f4c4",
        "M544 248v3.3l69.7-69.7c21.9-21.9 21.9-57.3 0-79.2L535.6 24.4c-21.9-21.9-57.3-21.9-79.2 0L416.3 64.5c-2.7-.3-5.5-.5-8.3-.5H296c-37.1 0-67.6 28-71.6 64H224V248c0 22.1 17.9 40 40 40s40-17.9 40-40V176c0 0 0-.1 0-.1V160l16 0 136 0c0 0 0 0 .1 0H464c44.2 0 80 35.8 80 80v8zM336 192v56c0 39.8-32.2 72-72 72s-72-32.2-72-72V129.4c-35.9 6.2-65.8 32.3-76 68.2L99.5 255.2 26.3 328.4c-21.9 21.9-21.9 57.3 0 79.2l78.1 78.1c21.9 21.9 57.3 21.9 79.2 0l37.7-37.7c.9 0 1.8 .1 2.7 .1H384c26.5 0 48-21.5 48-48c0-5.6-1-11-2.7-16H432c26.5 0 48-21.5 48-48c0-12.8-5-24.4-13.2-33c25.7-5 45.1-27.6 45.2-54.8v-.4c-.1-30.8-25.1-55.8-56-55.8c0 0 0 0 0 0l-120 0z"
    ]
};
var $5c8203742f0e3062$export$287dbb1632da0d44 = $5c8203742f0e3062$export$503f458ca5cf64c2;
var $5c8203742f0e3062$export$90a475e93ff4bb8a = {
    prefix: "fas",
    iconName: "location-dot",
    icon: [
        384,
        512,
        [
            "map-marker-alt"
        ],
        "f3c5",
        "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $5c8203742f0e3062$export$4be92fa780613f93 = $5c8203742f0e3062$export$90a475e93ff4bb8a;
var $5c8203742f0e3062$export$cad54bead856a678 = {
    prefix: "fas",
    iconName: "file",
    icon: [
        384,
        512,
        [
            128196,
            128459,
            61462
        ],
        "f15b",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128z"
    ]
};
var $5c8203742f0e3062$export$da07b6bc24a496ca = {
    prefix: "fas",
    iconName: "greater-than",
    icon: [
        384,
        512,
        [
            62769
        ],
        "3e",
        "M3.4 81.7c-7.9 15.8-1.5 35 14.3 42.9L280.5 256 17.7 387.4C1.9 395.3-4.5 414.5 3.4 430.3s27.1 22.2 42.9 14.3l320-160c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-320-160c-15.8-7.9-35-1.5-42.9 14.3z"
    ]
};
var $5c8203742f0e3062$export$3fb4da6af843d39f = {
    prefix: "fas",
    iconName: "person-swimming",
    icon: [
        576,
        512,
        [
            127946,
            "swimmer"
        ],
        "f5c4",
        "M309.5 178.4L447.9 297.1c-1.6 .9-3.2 2-4.8 3c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-10.1 0-21.1-2.2-31.9-6.2C163.1 193.2 262.2 96 384 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-26.9 0-52.3 6.6-74.5 18.4zM160 160A64 64 0 1 1 32 160a64 64 0 1 1 128 0zM306.5 325.9C329 341.4 356.5 352 384 352c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 405.7 417 416 384 416c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 341.2 165.1 352 192 352c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $5c8203742f0e3062$export$67daf2e2f88c1365 = $5c8203742f0e3062$export$3fb4da6af843d39f;
var $5c8203742f0e3062$export$9686eff8d817f770 = {
    prefix: "fas",
    iconName: "arrow-down",
    icon: [
        384,
        512,
        [
            8595
        ],
        "f063",
        "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ]
};
var $5c8203742f0e3062$export$cc1b6e60cb98fb90 = {
    prefix: "fas",
    iconName: "droplet",
    icon: [
        384,
        512,
        [
            128167,
            "tint"
        ],
        "f043",
        "M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"
    ]
};
var $5c8203742f0e3062$export$60dd975bd5938c15 = $5c8203742f0e3062$export$cc1b6e60cb98fb90;
var $5c8203742f0e3062$export$e7fc4fe34e767f28 = {
    prefix: "fas",
    iconName: "eraser",
    icon: [
        576,
        512,
        [],
        "f12d",
        "M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7H288h9.4H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H387.9L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416H288l-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z"
    ]
};
var $5c8203742f0e3062$export$9c4218a898614082 = {
    prefix: "fas",
    iconName: "earth-americas",
    icon: [
        512,
        512,
        [
            127758,
            "earth",
            "earth-america",
            "globe-americas"
        ],
        "f57d",
        "M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var $5c8203742f0e3062$export$c2118d3775773870 = $5c8203742f0e3062$export$9c4218a898614082;
var $5c8203742f0e3062$export$8b0f3a26397cf632 = $5c8203742f0e3062$export$9c4218a898614082;
var $5c8203742f0e3062$export$e96bcc7bde9498db = $5c8203742f0e3062$export$9c4218a898614082;
var $5c8203742f0e3062$export$ae02241644924482 = {
    prefix: "fas",
    iconName: "person-burst",
    icon: [
        640,
        512,
        [],
        "e53b",
        "M480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H465.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L408 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.3-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"
    ]
};
var $5c8203742f0e3062$export$a1ab1e69a300089f = {
    prefix: "fas",
    iconName: "dove",
    icon: [
        512,
        512,
        [
            128330
        ],
        "f4ba",
        "M160.8 96.5c14 17 31 30.9 49.5 42.2c25.9 15.8 53.7 25.9 77.7 31.6V138.8C265.8 108.5 250 71.5 248.6 28c-.4-11.3-7.5-21.5-18.4-24.4c-7.6-2-15.8-.2-21 5.8c-13.3 15.4-32.7 44.6-48.4 87.2zM320 144v30.6l0 0v1.3l0 0 0 32.1c-60.8-5.1-185-43.8-219.3-157.2C97.4 40 87.9 32 76.6 32c-7.9 0-15.3 3.9-18.8 11C46.8 65.9 32 112.1 32 176c0 116.9 80.1 180.5 118.4 202.8L11.8 416.6C6.7 418 2.6 421.8 .9 426.8s-.8 10.6 2.3 14.8C21.7 466.2 77.3 512 160 512c3.6 0 7.2-1.2 10-3.5L245.6 448H320c88.4 0 160-71.6 160-160V128l29.9-44.9c1.3-2 2.1-4.4 2.1-6.8c0-6.8-5.5-12.3-12.3-12.3H400c-44.2 0-80 35.8-80 80zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $5c8203742f0e3062$export$1344b64f6e922e12 = {
    prefix: "fas",
    iconName: "battery-empty",
    icon: [
        576,
        512,
        [
            "battery-0"
        ],
        "f244",
        "M80 160c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zM0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176z"
    ]
};
var $5c8203742f0e3062$export$de8d0338927394c1 = $5c8203742f0e3062$export$1344b64f6e922e12;
var $5c8203742f0e3062$export$8d36a54dbf1e6bce = {
    prefix: "fas",
    iconName: "socks",
    icon: [
        512,
        512,
        [
            129510
        ],
        "f696",
        "M175.2 476.6c-9.7-18-15.2-38.7-15.2-60.6c0-40.3 19-78.2 51.2-102.4l64-48c8.1-6 12.8-15.5 12.8-25.6V96H128V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l21.6-16.2zM128 64H288V48c0-14.5 3.9-28.2 10.7-39.9C291 3 281.9 0 272 0H176c-26.5 0-48 21.5-48 48V64zM320 96V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l115.2-86.4C493 382.2 512 344.3 512 304V96H320zM512 64V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48V64H512z"
    ]
};
var $5c8203742f0e3062$export$366b69cbdce46334 = {
    prefix: "fas",
    iconName: "inbox",
    icon: [
        512,
        512,
        [],
        "f01c",
        "M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V323.9c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32H121zm0 64H391l48 192H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73L121 96z"
    ]
};
var $5c8203742f0e3062$export$a6f4f4a005d91fbd = {
    prefix: "fas",
    iconName: "section",
    icon: [
        256,
        512,
        [],
        "e447",
        "M64.9 96C67.1 84.4 73.7 76.2 86 70.6c13.8-6.2 34.8-8.9 61.2-4.5c8.8 1.4 36.1 7.1 44.1 9.3c17 4.8 34.7-5.1 39.5-22.2s-5.1-34.7-22.2-39.5c-11.1-3.1-41-9.2-50.9-10.8C123-2.7 88.3-.6 59.7 12.3C29.9 25.8 7.5 50.9 1.6 86.5c-.1 .5-.2 1.1-.2 1.6c-2.2 19.7 .3 37.9 8.1 54.1c7.7 16.1 19.4 28 32 36.9c.6 .5 1.3 .9 2 1.4C22.3 194.2 6.5 215.1 1.7 243c-.1 .6-.2 1.1-.2 1.7c-2.3 19.3 .4 37.1 8.4 53c7.9 15.6 19.8 27 32.3 35.5c22.4 15.2 51.9 24 75.4 31l0 0 3.7 1.1c27.2 8.2 46.9 14.6 59.4 23.8c5.5 4 8.2 7.6 9.5 10.9c1.3 3.2 2.6 8.6 .9 18.1c-1.7 10.1-7.7 18-20.7 23.5c-14 6-35.4 8.5-62 4.4c-12.8-2.1-35.1-9.7-54.1-16.2l0 0c-4.3-1.5-8.5-2.9-12.3-4.2C25.3 420 7.2 429.1 1.6 445.8s3.5 34.9 20.3 40.5c2.6 .8 5.7 1.9 9.2 3.1c18.6 6.3 48.5 16.6 67.3 19.6l0 0 .2 0c34.5 5.4 68.8 3.4 97.2-8.7c29.4-12.6 52.5-36.5 58.5-71.5c3.3-19.3 1.9-37.4-5-53.9c-6.3-15-16.4-26.4-27.6-35.2c16.5-13.9 28.5-33.2 32.6-58.2c3.2-19.8 1.9-38.3-4.8-55.1c-6.7-16.8-17.8-29.4-30.2-39c-22.8-17.6-53.6-27.4-77.7-35l-1.4-.5c-27.4-8.7-47.8-15.3-61.5-25c-6.1-4.4-9.5-8.5-11.4-12.4c-1.8-3.7-3.2-9.3-2.3-18.5zm76.7 208.5c-.2-.1-.4-.1-.6-.2l-1.4-.4c-27.4-8.2-47.9-14.5-61.7-23.8c-6.2-4.2-9.3-7.9-11-11.3c-1.5-3-2.9-7.7-2.1-15.7c1.9-9.7 7.9-17.3 20.5-22.7c14-6 35.4-8.5 62.1-4.3l16.4 2.6c6.3 2.9 11.7 6 16.2 9.5c5.5 4.2 8.4 8.2 10 12.2c1.6 4 2.8 10.4 1.1 20.9c-2.4 14.7-12.8 26.4-37.1 31l-12.4 2.3z"
    ]
};
var $5c8203742f0e3062$export$d262c1f5912046e6 = {
    prefix: "fas",
    iconName: "gauge-high",
    icon: [
        512,
        512,
        [
            62461,
            "tachometer-alt",
            "tachometer-alt-fast"
        ],
        "f625",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64c0-17.4-6.9-33.1-18.1-44.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L257.9 288c-.6 0-1.3 0-1.9 0c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $5c8203742f0e3062$export$38dd17b9f064c10f = $5c8203742f0e3062$export$d262c1f5912046e6;
var $5c8203742f0e3062$export$e99d8b85f35b8ca5 = $5c8203742f0e3062$export$d262c1f5912046e6;
var $5c8203742f0e3062$export$f5c53ce8ec380d11 = {
    prefix: "fas",
    iconName: "envelope-open-text",
    icon: [
        512,
        512,
        [],
        "f658",
        "M215.4 96H144 107.8 96v8.8V144v40.4 89L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L339.4 48H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4v-89V144 104.8 96H404.2 368 296.6 215.4zM0 448V242.1L217.6 403.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448v0c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v0zM176 160H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$7a76c9d35b42d691 = {
    prefix: "fas",
    iconName: "hospital",
    icon: [
        640,
        512,
        [
            127973,
            62589,
            "hospital-alt",
            "hospital-wide"
        ],
        "f0f8",
        "M192 48c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48V512H368V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H192V48zM48 96H160V512H48c-26.5 0-48-21.5-48-48V320H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V224H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V144c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v48H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80V464c0 26.5-21.5 48-48 48H480V96H592zM312 64c-8.8 0-16 7.2-16 16v24H272c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V152h24c8.8 0 16-7.2 16-16V120c0-8.8-7.2-16-16-16H344V80c0-8.8-7.2-16-16-16H312z"
    ]
};
var $5c8203742f0e3062$export$cea7736417b94a3b = $5c8203742f0e3062$export$7a76c9d35b42d691;
var $5c8203742f0e3062$export$69c8cc0360f017e8 = $5c8203742f0e3062$export$7a76c9d35b42d691;
var $5c8203742f0e3062$export$770be8b3d5776043 = {
    prefix: "fas",
    iconName: "wine-bottle",
    icon: [
        512,
        512,
        [],
        "f72f",
        "M393.4 9.4c12.5-12.5 32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3c-11.8 11.8-30.7 12.5-43.2 1.9l-9.5 9.5-48.8 48.8c-9.2 9.2-11.5 22.9-8.6 35.6c9.4 40.9-1.9 85.6-33.8 117.5L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5L180.2 153.3c31.9-31.9 76.6-43.1 117.5-33.8c12.6 2.9 26.4 .5 35.5-8.6l48.8-48.8 9.5-9.5c-10.6-12.6-10-31.4 1.9-43.2zM99.3 347.3l65.4 65.4c6.2 6.2 16.4 6.2 22.6 0l97.4-97.4c6.2-6.2 6.2-16.4 0-22.6l-65.4-65.4c-6.2-6.2-16.4-6.2-22.6 0L99.3 324.7c-6.2 6.2-6.2 16.4 0 22.6z"
    ]
};
var $5c8203742f0e3062$export$5d65c40a109eb09c = {
    prefix: "fas",
    iconName: "chess-rook",
    icon: [
        448,
        512,
        [
            9820
        ],
        "f447",
        "M32 192V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V192c0 10.1-4.7 19.6-12.8 25.6L352 256l16 144H80L96 256 44.8 217.6C36.7 211.6 32 202.1 32 192zm176 96h32c8.8 0 16-7.2 16-16V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 8.8 7.2 16 16 16zM22.6 473.4L64 432H384l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H38.6C26.1 512 16 501.9 16 489.4c0-6 2.4-11.8 6.6-16z"
    ]
};
var $5c8203742f0e3062$export$2f8a7938c06a2142 = {
    prefix: "fas",
    iconName: "bars-staggered",
    icon: [
        512,
        512,
        [
            "reorder",
            "stream"
        ],
        "f550",
        "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $5c8203742f0e3062$export$75d2bb378a2fc102 = $5c8203742f0e3062$export$2f8a7938c06a2142;
var $5c8203742f0e3062$export$ed81ab40fc4e904 = $5c8203742f0e3062$export$2f8a7938c06a2142;
var $5c8203742f0e3062$export$45cbd92c28deb2c7 = {
    prefix: "fas",
    iconName: "dharmachakra",
    icon: [
        512,
        512,
        [
            9784
        ],
        "f655",
        "M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.5 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.5-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$9fae219b4d3ce0be = {
    prefix: "fas",
    iconName: "hotdog",
    icon: [
        512,
        512,
        [
            127789
        ],
        "f80f",
        "M488.6 23.4c31.2 31.2 31.2 81.9 0 113.1l-352 352c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1l352-352c31.2-31.2 81.9-31.2 113.1 0zM443.3 92.7c-6.2-6.2-16.4-6.2-22.6 0c-12.5 12.5-23.8 15.1-37.5 17.6l-2.5 .4c-13.8 2.5-31.6 5.6-48 22c-16.7 16.7-20.9 36-24.1 50.9l0 0v0l-.2 1c-3.4 15.6-6 26.4-15.7 36.1s-20.5 12.3-36.1 15.7l-1 .2c-14.9 3.2-34.2 7.4-50.9 24.1s-20.9 36-24.1 50.9l-.2 1c-3.4 15.6-6 26.4-15.7 36.1c-9.2 9.2-18 10.8-32.7 13.4l0 0-.9 .2c-15.6 2.8-34.9 6.9-54.4 26.4c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c12.5-12.5 23.8-15.1 37.5-17.6l2.5-.4c13.8-2.5 31.6-5.6 48-22c16.7-16.7 20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1s20.5-12.3 36.1-15.7l1-.2c14.9-3.2 34.2-7.4 50.9-24.1s20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1c9.2-9.2 18-10.8 32.7-13.4l.9-.2c15.6-2.8 34.9-6.9 54.4-26.4c6.2-6.2 6.2-16.4 0-22.6zM191.2 479.2l288-288L495 207c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L289 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17l-15.8-15.8zM17 305C6.1 294.1 0 279.4 0 264s6.1-30.1 17-41L223 17C233.9 6.1 248.6 0 264 0s30.1 6.1 41 17l15.8 15.8-288 288L17 305z"
    ]
};
var $5c8203742f0e3062$export$2ffee5b2bc935c1f = {
    prefix: "fas",
    iconName: "person-walking-with-cane",
    icon: [
        512,
        512,
        [
            "blind"
        ],
        "f29d",
        "M176 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8.4 32c-36.4 0-69.6 20.5-85.9 53.1L35.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L128 231.6v43.2c0 17 6.7 33.3 18.7 45.3L224 397.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V390.6c0-12.7-5.1-24.9-14.1-33.9L224 306.7V213.3l70.4 93.9c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8L268.8 166.4C250.7 142.2 222.2 128 192 128H167.6zM128.3 346.8L97 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l22-88.2-52.8-52.8zM450.8 505.1c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L358.9 316.1c-2.8 3.8-6.1 7.3-10.1 10.3c-5 3.8-10.5 6.4-16.2 7.9L450.8 505.1z"
    ]
};
var $5c8203742f0e3062$export$923de21def6ea9b6 = $5c8203742f0e3062$export$2ffee5b2bc935c1f;
var $5c8203742f0e3062$export$5b9205e1042594b7 = {
    prefix: "fas",
    iconName: "drum",
    icon: [
        512,
        512,
        [
            129345
        ],
        "f569",
        "M501.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2s-22.1-14.2-33.2-6.9L370.2 104.5C335.8 98.7 297 96 256 96C114.6 96 0 128 0 208V368c0 31.3 27.4 58.8 72 78.7V344c0-13.3 10.7-24 24-24s24 10.7 24 24V463.4c33 8.9 71.1 14.5 112 16.1V376c0-13.3 10.7-24 24-24s24 10.7 24 24V479.5c40.9-1.6 79-7.2 112-16.1V344c0-13.3 10.7-24 24-24s24 10.7 24 24V446.7c44.6-19.9 72-47.4 72-78.7V208c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zM307.4 145.6l-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l111.1-72.8c14.7 3.2 27.9 7 39.4 11.5C458.4 181.8 464 197.4 464 208c0 .8-2.7 17.2-46 35.9C379.1 260.7 322 272 256 272s-123.1-11.3-162-28.1C50.7 225.2 48 208.8 48 208c0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1 .5 51.4 1.6z"
    ]
};
var $5c8203742f0e3062$export$dd52741c60cc638f = {
    prefix: "fas",
    iconName: "ice-cream",
    icon: [
        448,
        512,
        [
            127848
        ],
        "f810",
        "M367.1 160c.6-5.3 .9-10.6 .9-16C368 64.5 303.5 0 224 0S80 64.5 80 144c0 5.4 .3 10.7 .9 16H80c-26.5 0-48 21.5-48 48s21.5 48 48 48h53.5 181H368c26.5 0 48-21.5 48-48s-21.5-48-48-48h-.9zM96 288L200.8 497.7c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3L352 288H96z"
    ]
};
var $5c8203742f0e3062$export$2a376a9d0d8fee96 = {
    prefix: "fas",
    iconName: "heart-circle-bolt",
    icon: [
        576,
        512,
        [],
        "e4fc",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
    ]
};
var $5c8203742f0e3062$export$b5698497901d7197 = {
    prefix: "fas",
    iconName: "fax",
    icon: [
        512,
        512,
        [
            128224,
            128439
        ],
        "f1ac",
        "M128 64v96h64V64H386.7L416 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L432 18.7C420 6.7 403.7 0 386.7 0H192c-35.3 0-64 28.7-64 64zM0 160V480c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm480 32H128V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM256 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $5c8203742f0e3062$export$dec46f8df1860e0 = {
    prefix: "fas",
    iconName: "paragraph",
    icon: [
        448,
        512,
        [
            182
        ],
        "f1dd",
        "M192 32h64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352H288V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H192c-88.4 0-160-71.6-160-160s71.6-160 160-160z"
    ]
};
var $5c8203742f0e3062$export$6999832247e52c2b = {
    prefix: "fas",
    iconName: "check-to-slot",
    icon: [
        576,
        512,
        [
            "vote-yea"
        ],
        "f772",
        "M96 80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48V384H96V80zm313 47c-9.4-9.4-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L409 161c9.4-9.4 9.4-24.6 0-33.9zM0 336c0-26.5 21.5-48 48-48H64V416H512V288h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336z"
    ]
};
var $5c8203742f0e3062$export$e87bb3db1608b850 = $5c8203742f0e3062$export$6999832247e52c2b;
var $5c8203742f0e3062$export$228008b5e11032fa = {
    prefix: "fas",
    iconName: "star-half",
    icon: [
        576,
        512,
        [
            61731
        ],
        "f089",
        "M288 0c-12.2 .1-23.3 7-28.6 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3L288 439.8V0zM429.9 512c1.1 .1 2.1 .1 3.2 0h-3.2z"
    ]
};
var $5c8203742f0e3062$export$2088efcf62cf3b1 = {
    prefix: "fas",
    iconName: "boxes-stacked",
    icon: [
        576,
        512,
        [
            62625,
            "boxes",
            "boxes-alt"
        ],
        "f468",
        "M248 0H208c-26.5 0-48 21.5-48 48V160c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V48c0-26.5-21.5-48-48-48H328V80c0 8.8-7.2 16-16 16H264c-8.8 0-16-7.2-16-16V0zM64 256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H184v80c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V256H64zM352 512H512c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H472v80c0 8.8-7.2 16-16 16H408c-8.8 0-16-7.2-16-16V256H352c-15 0-28.8 5.1-39.7 13.8c4.9 10.4 7.7 22 7.7 34.2V464c0 12.2-2.8 23.8-7.7 34.2C323.2 506.9 337 512 352 512z"
    ]
};
var $5c8203742f0e3062$export$2007320dd6cde6db = $5c8203742f0e3062$export$2088efcf62cf3b1;
var $5c8203742f0e3062$export$e6ef1d896ed63b3e = $5c8203742f0e3062$export$2088efcf62cf3b1;
var $5c8203742f0e3062$export$88bc01ff8dbecc55 = {
    prefix: "fas",
    iconName: "link",
    icon: [
        640,
        512,
        [
            128279,
            "chain"
        ],
        "f0c1",
        "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
    ]
};
var $5c8203742f0e3062$export$b5d071e02a25554f = $5c8203742f0e3062$export$88bc01ff8dbecc55;
var $5c8203742f0e3062$export$837bc776b490934d = {
    prefix: "fas",
    iconName: "ear-listen",
    icon: [
        512,
        512,
        [
            "assistive-listening-systems"
        ],
        "f2a2",
        "M398.3 3.4c-15.8-7.9-35-1.5-42.9 14.3c-7.9 15.8-1.5 34.9 14.2 42.9l.4 .2c.4 .2 1.1 .6 2.1 1.2c2 1.2 5 3 8.7 5.6c7.5 5.2 17.6 13.2 27.7 24.2C428.5 113.4 448 146 448 192c0 17.7 14.3 32 32 32s32-14.3 32-32c0-66-28.5-113.4-56.5-143.7C441.6 33.2 427.7 22.2 417.3 15c-5.3-3.7-9.7-6.4-13-8.3c-1.6-1-3-1.7-4-2.2c-.5-.3-.9-.5-1.2-.7l-.4-.2-.2-.1-.1 0 0 0c0 0 0 0-14.3 28.6L398.3 3.4zM128.7 227.5c6.2-56 53.7-99.5 111.3-99.5c61.9 0 112 50.1 112 112c0 29.3-11.2 55.9-29.6 75.9c-17 18.4-34.4 45.1-34.4 78V400c0 26.5-21.5 48-48 48c-17.7 0-32 14.3-32 32s14.3 32 32 32c61.9 0 112-50.1 112-112v-6.1c0-9.8 5.4-21.7 17.4-34.7C398.3 327.9 416 286 416 240c0-97.2-78.8-176-176-176C149.4 64 74.8 132.5 65.1 220.5c-1.9 17.6 10.7 33.4 28.3 35.3s33.4-10.7 35.3-28.3zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM192 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM208 240c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 13.3 10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $5c8203742f0e3062$export$8eeef3dc0035b165 = $5c8203742f0e3062$export$837bc776b490934d;
var $5c8203742f0e3062$export$ad95e4f80f98ebe0 = {
    prefix: "fas",
    iconName: "tree-city",
    icon: [
        640,
        512,
        [],
        "e587",
        "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM224 160c0 6-1 11-2 16c20 14 34 38 34 64c0 45-36 80-80 80H160V480c0 18-15 32-32 32c-18 0-32-14-32-32V320H80c-45 0-80-35-80-80c0-26 13-50 33-64c-1-5-1-10-1-16c0-53 42-96 96-96c53 0 96 43 96 96z"
    ]
};
var $5c8203742f0e3062$export$436587205947bca5 = {
    prefix: "fas",
    iconName: "play",
    icon: [
        384,
        512,
        [
            9654
        ],
        "f04b",
        "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"
    ]
};
var $5c8203742f0e3062$export$a5dc297d3f60936 = {
    prefix: "fas",
    iconName: "font",
    icon: [
        448,
        512,
        [],
        "f031",
        "M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1.8l18-48H303.8l18 48H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H390.2L254 52.8zM279.8 304H168.2L224 155.1 279.8 304z"
    ]
};
var $5c8203742f0e3062$export$2c0ab34218da6651 = {
    prefix: "fas",
    iconName: "table-cells-row-lock",
    icon: [
        640,
        512,
        [],
        "e67a",
        "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 56 0 0 8.6c-19.1 11.1-32 31.7-32 55.4l-24 0 0 64 24 0 0 64L64 480c-35.3 0-64-28.7-64-64L0 96zM64 224l0 64 88 0 0-64-88 0zm232 0l-88 0 0 64 88 0 0-64zM152 352l-88 0 0 64 88 0 0-64zm56 0l0 64 88 0 0-64-88 0zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"
    ]
};
var $5c8203742f0e3062$export$fe44d4c71644ea0 = {
    prefix: "fas",
    iconName: "rupiah-sign",
    icon: [
        512,
        512,
        [],
        "e23d",
        "M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256-96h80c61.9 0 112 50.1 112 112s-50.1 112-112 112H352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352 192c0-17.7 14.3-32 32-32zm80 160c26.5 0 48-21.5 48-48s-21.5-48-48-48H352v96h48z"
    ]
};
var $5c8203742f0e3062$export$34c8b97060c09ff = {
    prefix: "fas",
    iconName: "magnifying-glass",
    icon: [
        512,
        512,
        [
            128269,
            "search"
        ],
        "f002",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
    ]
};
var $5c8203742f0e3062$export$871a78837687ffe8 = $5c8203742f0e3062$export$34c8b97060c09ff;
var $5c8203742f0e3062$export$eabe53838d45ac6a = {
    prefix: "fas",
    iconName: "table-tennis-paddle-ball",
    icon: [
        640,
        512,
        [
            127955,
            "ping-pong-paddle-ball",
            "table-tennis"
        ],
        "f45d",
        "M480 288c-50.1 0-93.6 28.8-114.6 70.8L132.9 126.3l.6-.6 60.1-60.1c87.5-87.5 229.3-87.5 316.8 0c67.1 67.1 82.7 166.3 46.8 248.3C535.8 297.6 509 288 480 288zM113.3 151.9L354.1 392.7c-1.4 7.5-2.1 15.3-2.1 23.3c0 23.2 6.2 44.9 16.9 63.7c-3 .2-6.1 .3-9.2 .3H357c-33.9 0-66.5-13.5-90.5-37.5l-9.8-9.8c-13.1-13.1-34.6-12.4-46.8 1.7L152.2 501c-5.8 6.7-14.2 10.7-23 11s-17.5-3.1-23.8-9.4l-32-32c-6.3-6.3-9.7-14.9-9.4-23.8s4.3-17.2 11-23l66.6-57.7c14-12.2 14.8-33.7 1.7-46.8l-9.8-9.8c-24-24-37.5-56.6-37.5-90.5v-2.7c0-22.8 6.1-44.9 17.3-64.3zM480 320a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $5c8203742f0e3062$export$ebb246c621751737 = $5c8203742f0e3062$export$eabe53838d45ac6a;
var $5c8203742f0e3062$export$f378fbb4e0ef7edf = $5c8203742f0e3062$export$eabe53838d45ac6a;
var $5c8203742f0e3062$export$cdcec8ca7ec0d381 = {
    prefix: "fas",
    iconName: "person-dots-from-line",
    icon: [
        576,
        512,
        [
            "diagnoses"
        ],
        "f470",
        "M288 176A88 88 0 1 0 288 0a88 88 0 1 0 0 176zM78.7 372.9c15-12.5 50-34.4 97.3-50.1V432H400V322.7c47.3 15.8 82.3 37.7 97.3 50.1c20.4 17 50.6 14.2 67.6-6.1s14.2-50.6-6.1-67.6c-12-10-30.1-22.5-53.2-35C497.2 278.4 481.7 288 464 288c-26.5 0-48-21.5-48-48c0-4.3 .6-8.4 1.6-12.4C379.1 215.9 335.3 208 288 208c-60.2 0-114.9 12.9-160 29.9c0 .7 0 1.4 0 2.1c0 26.5-21.5 48-48 48c-11.8 0-22.7-4.3-31-11.4c-13.1 8.1-23.7 15.9-31.7 22.5c-20.4 17-23.1 47.2-6.1 67.6s47.2 23.1 67.6 6.1zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM224 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $5c8203742f0e3062$export$68bad2b52a90d1fa = $5c8203742f0e3062$export$cdcec8ca7ec0d381;
var $5c8203742f0e3062$export$60430351cdb4ba89 = {
    prefix: "fas",
    iconName: "trash-can-arrow-up",
    icon: [
        448,
        512,
        [
            "trash-restore-alt"
        ],
        "f82a",
        "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
    ]
};
var $5c8203742f0e3062$export$d075b19b21cb9856 = $5c8203742f0e3062$export$60430351cdb4ba89;
var $5c8203742f0e3062$export$58b7558ca9822358 = {
    prefix: "fas",
    iconName: "naira-sign",
    icon: [
        448,
        512,
        [],
        "e1f6",
        "M122.6 46.3c-7.8-11.7-22.4-17-35.9-12.9S64 49.9 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H228.2l97.2 145.8c7.8 11.7 22.4 17 35.9 12.9s22.7-16.5 22.7-30.6V320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V256H262.5L122.6 46.3zM305.1 320H320v22.3L305.1 320zM185.5 256H128V169.7L185.5 256z"
    ]
};
var $5c8203742f0e3062$export$9206260ff0c0c616 = {
    prefix: "fas",
    iconName: "cart-arrow-down",
    icon: [
        576,
        512,
        [],
        "f218",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32H360V134.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V32H120.1C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $5c8203742f0e3062$export$8a322f740d64e9fc = {
    prefix: "fas",
    iconName: "walkie-talkie",
    icon: [
        384,
        512,
        [],
        "f8ef",
        "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144V300.1c0 12.7 5.1 24.9 14.1 33.9l3.9 3.9c9 9 14.1 21.2 14.1 33.9V464c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V371.9c0-12.7 5.1-24.9 14.1-33.9l3.9-3.9c9-9 14.1-21.2 14.1-33.9V144c0-26.5-21.5-48-48-48H320c0-17.7-14.3-32-32-32s-32 14.3-32 32H224c0-17.7-14.3-32-32-32s-32 14.3-32 32H112V24zm0 136H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$27f34878d8ed7a76 = {
    prefix: "fas",
    iconName: "file-pen",
    icon: [
        576,
        512,
        [
            128221,
            "file-edit"
        ],
        "f31c",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V299.6l-94.7 94.7c-8.2 8.2-14 18.5-16.8 29.7l-15 60.1c-2.3 9.4-1.8 19 1.4 27.8H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
    ]
};
var $5c8203742f0e3062$export$e343e19f1757c5ae = $5c8203742f0e3062$export$27f34878d8ed7a76;
var $5c8203742f0e3062$export$32b0cd6133c2742 = {
    prefix: "fas",
    iconName: "receipt",
    icon: [
        384,
        512,
        [
            129534
        ],
        "f543",
        "M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.3-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8V488c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488V24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"
    ]
};
var $5c8203742f0e3062$export$3643b719db23d46e = {
    prefix: "fas",
    iconName: "square-pen",
    icon: [
        448,
        512,
        [
            "pen-square",
            "pencil-square"
        ],
        "f14b",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM325.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
    ]
};
var $5c8203742f0e3062$export$fbb231ccb3d960bc = $5c8203742f0e3062$export$3643b719db23d46e;
var $5c8203742f0e3062$export$35d253ecd249e771 = $5c8203742f0e3062$export$3643b719db23d46e;
var $5c8203742f0e3062$export$957e62a9b80ff4e3 = {
    prefix: "fas",
    iconName: "suitcase-rolling",
    icon: [
        384,
        512,
        [],
        "f5c1",
        "M144 56c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v72H144V56zm176 72H288V56c0-30.9-25.1-56-56-56H152C121.1 0 96 25.1 96 56v72H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64c0 17.7 14.3 32 32 32s32-14.3 32-32H256c0 17.7 14.3 32 32 32s32-14.3 32-32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64zM112 224H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$38c8c32017dd9cc = {
    prefix: "fas",
    iconName: "person-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e53f",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $5c8203742f0e3062$export$8db9bc521720fccd = {
    prefix: "fas",
    iconName: "chevron-down",
    icon: [
        512,
        512,
        [],
        "f078",
        "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
    ]
};
var $5c8203742f0e3062$export$9338fc4614cfc0cf = {
    prefix: "fas",
    iconName: "battery-full",
    icon: [
        576,
        512,
        [
            128267,
            "battery",
            "battery-5"
        ],
        "f240",
        "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm368 96H96V320H448V192z"
    ]
};
var $5c8203742f0e3062$export$214720d39635cea8 = $5c8203742f0e3062$export$9338fc4614cfc0cf;
var $5c8203742f0e3062$export$e426617482c711a7 = $5c8203742f0e3062$export$9338fc4614cfc0cf;
var $5c8203742f0e3062$export$8717352b90217272 = {
    prefix: "fas",
    iconName: "skull-crossbones",
    icon: [
        448,
        512,
        [
            128369,
            9760
        ],
        "f714",
        "M368 128c0 44.4-25.4 83.5-64 106.4V256c0 17.7-14.3 32-32 32H176c-17.7 0-32-14.3-32-32V234.4c-38.6-23-64-62.1-64-106.4C80 57.3 144.5 0 224 0s144 57.3 144 128zM168 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM3.4 273.7c7.9-15.8 27.1-22.2 42.9-14.3L224 348.2l177.7-88.8c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L295.6 384l134.8 67.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L224 419.8 46.3 508.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9L152.4 384 17.7 316.6C1.9 308.7-4.5 289.5 3.4 273.7z"
    ]
};
var $5c8203742f0e3062$export$ca4c5b4dcff58860 = {
    prefix: "fas",
    iconName: "code-compare",
    icon: [
        512,
        512,
        [],
        "e13a",
        "M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1s14.2 12.4 14.2 21.9v40h16c35.3 0 64-28.7 64-64V153.3C371.7 141 352 112.8 352 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V320c0 70.7-57.3 128-128 128H320v40zM456 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 24c0-9.5 5.6-18.1 14.2-21.9s18.8-2.3 25.8 4.1l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1s-14.2-12.4-14.2-21.9V128H176c-35.3 0-64 28.7-64 64V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-70.7 57.3-128 128-128h16V24zM56 432a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"
    ]
};
var $5c8203742f0e3062$export$f8a219cf4f516384 = {
    prefix: "fas",
    iconName: "list-ul",
    icon: [
        512,
        512,
        [
            "list-dots"
        ],
        "f0ca",
        "M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $5c8203742f0e3062$export$e6f4ba30d84fa6ea = $5c8203742f0e3062$export$f8a219cf4f516384;
var $5c8203742f0e3062$export$8845cce2a763ee07 = {
    prefix: "fas",
    iconName: "school-lock",
    icon: [
        640,
        512,
        [],
        "e56f",
        "M302.2 5.4c10.7-7.2 24.8-7.2 35.5 0L473.7 96H592c26.5 0 48 21.5 48 48V272c0-61.9-50.1-112-112-112s-112 50.1-112 112v24.6c-19.1 11.1-32 31.7-32 55.4H320.3l-.3 0c-35.3 0-64 28.7-64 64v96h64v0H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48H166.3L302.2 5.4zM80 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm0 128v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm240-72a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm16-120v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 96c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $5c8203742f0e3062$export$f4b64c3a138c1b59 = {
    prefix: "fas",
    iconName: "tower-cell",
    icon: [
        576,
        512,
        [],
        "e585",
        "M62.6 2.3C46.2-4.3 27.6 3.6 20.9 20C7.4 53.4 0 89.9 0 128s7.4 74.6 20.9 108c6.6 16.4 25.3 24.3 41.7 17.7S86.9 228.4 80.3 212C69.8 186.1 64 157.8 64 128s5.8-58.1 16.3-84C86.9 27.6 79 9 62.6 2.3zm450.8 0C497 9 489.1 27.6 495.7 44C506.2 69.9 512 98.2 512 128s-5.8 58.1-16.3 84c-6.6 16.4 1.3 35 17.7 41.7s35-1.3 41.7-17.7c13.5-33.4 20.9-69.9 20.9-108s-7.4-74.6-20.9-108C548.4 3.6 529.8-4.3 513.4 2.3zM340.1 165.2c7.5-10.5 11.9-23.3 11.9-37.2c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.9 4.4 26.7 11.9 37.2L98.9 466.8c-7.3 16.1-.2 35.1 15.9 42.4s35.1 .2 42.4-15.9L177.7 448H398.3l20.6 45.2c7.3 16.1 26.3 23.2 42.4 15.9s23.2-26.3 15.9-42.4L340.1 165.2zM369.2 384H206.8l14.5-32H354.7l14.5 32zM288 205.3L325.6 288H250.4L288 205.3zM163.3 73.6c5.3-12.1-.2-26.3-12.4-31.6s-26.3 .2-31.6 12.4C109.5 77 104 101.9 104 128s5.5 51 15.3 73.6c5.3 12.1 19.5 17.7 31.6 12.4s17.7-19.5 12.4-31.6C156 165.8 152 147.4 152 128s4-37.8 11.3-54.4zM456.7 54.4c-5.3-12.1-19.5-17.7-31.6-12.4s-17.7 19.5-12.4 31.6C420 90.2 424 108.6 424 128s-4 37.8-11.3 54.4c-5.3 12.1 .2 26.3 12.4 31.6s26.3-.2 31.6-12.4C466.5 179 472 154.1 472 128s-5.5-51-15.3-73.6z"
    ]
};
var $5c8203742f0e3062$export$e88ba08d4f4d65b6 = {
    prefix: "fas",
    iconName: "down-long",
    icon: [
        320,
        512,
        [
            "long-arrow-alt-down"
        ],
        "f309",
        "M2 334.5c-3.8 8.8-2 19 4.6 26l136 144c4.5 4.8 10.8 7.5 17.4 7.5s12.9-2.7 17.4-7.5l136-144c6.6-7 8.4-17.2 4.6-26s-12.5-14.5-22-14.5l-72 0 0-288c0-17.7-14.3-32-32-32L128 0C110.3 0 96 14.3 96 32l0 288-72 0c-9.6 0-18.2 5.7-22 14.5z"
    ]
};
var $5c8203742f0e3062$export$8b92530ca6418c2f = $5c8203742f0e3062$export$e88ba08d4f4d65b6;
var $5c8203742f0e3062$export$e6fd420a918b43b5 = {
    prefix: "fas",
    iconName: "ranking-star",
    icon: [
        640,
        512,
        [],
        "e561",
        "M353.8 54.1L330.2 6.3c-3.9-8.3-16.1-8.6-20.4 0L286.2 54.1l-52.3 7.5c-9.3 1.4-13.3 12.9-6.4 19.8l38 37-9 52.1c-1.4 9.3 8.2 16.5 16.8 12.2l46.9-24.8 46.6 24.4c8.6 4.3 18.3-2.9 16.8-12.2l-9-52.1 38-36.6c6.8-6.8 2.9-18.3-6.4-19.8l-52.3-7.5zM256 256c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H256zM32 320c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zm416 96v64c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H480c-17.7 0-32 14.3-32 32z"
    ]
};
var $5c8203742f0e3062$export$d5713874f8fefe1b = {
    prefix: "fas",
    iconName: "chess-king",
    icon: [
        448,
        512,
        [
            9818
        ],
        "f43f",
        "M224 0c17.7 0 32 14.3 32 32V48h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H256v48H408c22.1 0 40 17.9 40 40c0 5.3-1 10.5-3.1 15.4L368 400H80L3.1 215.4C1 210.5 0 205.3 0 200c0-22.1 17.9-40 40-40H192V112H176c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V32c0-17.7 14.3-32 32-32zM38.6 473.4L80 432H368l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H54.6C42.1 512 32 501.9 32 489.4c0-6 2.4-11.8 6.6-16z"
    ]
};
var $5c8203742f0e3062$export$dcd74f2821882a49 = {
    prefix: "fas",
    iconName: "person-harassing",
    icon: [
        576,
        512,
        [],
        "e549",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM59.4 304.5L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9zM480 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM464 344v58.7l-41.4-41.4c-7.3-7.3-17.6-10.6-27.8-9s-18.9 8.1-23.5 17.3l-48 96c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L408.8 438l54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9V344c0-30.9-25.1-56-56-56s-56 25.1-56 56zM288 48c0 8.8 7.2 16 16 16h56c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm-.8 49.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-48-24z"
    ]
};
var $5c8203742f0e3062$export$9d355b4e79216962 = {
    prefix: "fas",
    iconName: "brazilian-real-sign",
    icon: [
        512,
        512,
        [],
        "e46c",
        "M400 0c17.7 0 32 14.3 32 32V50.2c12.5 2.3 24.7 6.4 36.2 12.1l10.1 5.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-10.2-5.1c-9.9-5-20.9-7.5-32-7.5h-1.7c-29.8 0-53.9 24.1-53.9 53.9c0 22 13.4 41.8 33.9 50l52 20.8c44.7 17.9 74.1 61.2 74.1 109.4v3.4c0 51.2-33.6 94.6-80 109.2V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V460.6c-15-3.5-29.4-9.7-42.3-18.3l-23.4-15.6c-14.7-9.8-18.7-29.7-8.9-44.4s29.7-18.7 44.4-8.9L361.2 389c10.8 7.2 23.4 11 36.3 11c27.9 0 50.5-22.6 50.5-50.5v-3.4c0-22-13.4-41.8-33.9-50l-52-20.8C317.3 257.4 288 214.1 288 165.9C288 114 321.5 70 368 54.2V32c0-17.7 14.3-32 32-32zM0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256z"
    ]
};
var $5c8203742f0e3062$export$8a56136f40511e5d = {
    prefix: "fas",
    iconName: "landmark-dome",
    icon: [
        512,
        512,
        [
            "landmark-alt"
        ],
        "f752",
        "M248 0h16c13.3 0 24 10.7 24 24V34.7C368.4 48.1 431.9 111.6 445.3 192H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h2.7C80.1 111.6 143.6 48.1 224 34.7V24c0-13.3 10.7-24 24-24zM64 288h64V416h40V288h64V416h48V288h64V416h40V288h64V420.3c.6 .3 1.2 .7 1.7 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V288z"
    ]
};
var $5c8203742f0e3062$export$8b9c180efffc50ab = $5c8203742f0e3062$export$8a56136f40511e5d;
var $5c8203742f0e3062$export$8e144ed4d52eef49 = {
    prefix: "fas",
    iconName: "arrow-up",
    icon: [
        384,
        512,
        [
            8593
        ],
        "f062",
        "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"
    ]
};
var $5c8203742f0e3062$export$e0cfed4ba2fe562c = {
    prefix: "fas",
    iconName: "tv",
    icon: [
        640,
        512,
        [
            63717,
            "television",
            "tv-alt"
        ],
        "f26c",
        "M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$9803b0176917be28 = $5c8203742f0e3062$export$e0cfed4ba2fe562c;
var $5c8203742f0e3062$export$6aa64ad5a1974ad7 = $5c8203742f0e3062$export$e0cfed4ba2fe562c;
var $5c8203742f0e3062$export$ac094c06f566cca3 = {
    prefix: "fas",
    iconName: "shrimp",
    icon: [
        512,
        512,
        [
            129424
        ],
        "e448",
        "M64 32C28.7 32 0 60.7 0 96s28.7 64 64 64h1c3.7 88.9 77 160 167 160h56V128H264 88.8 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zM224 456c0 13.3 10.7 24 24 24h72V407.8l-64.1-22.4c-12.5-4.4-26.2 2.2-30.6 14.7s2.2 26.2 14.7 30.6l4.5 1.6C233 433.9 224 443.9 224 456zm128 23.3c36.4-3.3 69.5-17.6 96.1-39.6l-86.5-34.6c-3 1.8-6.2 3.2-9.6 4.3v69.9zM472.6 415c24.6-30.3 39.4-68.9 39.4-111c0-12.3-1.3-24.3-3.7-35.9L382.8 355.1c.8 3.4 1.2 7 1.2 10.6c0 4.6-.7 9-1.9 13.1L472.6 415zM336 128H320V320h18.3c9.9 0 19.1 3.2 26.6 8.5l133.5-92.4C471.8 172.6 409.1 128 336 128zM168 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $5c8203742f0e3062$export$350a84fd0f833f4d = {
    prefix: "fas",
    iconName: "list-check",
    icon: [
        512,
        512,
        [
            "tasks"
        ],
        "f0ae",
        "M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $5c8203742f0e3062$export$2f6d5b2fec286d63 = $5c8203742f0e3062$export$350a84fd0f833f4d;
var $5c8203742f0e3062$export$3fe50bd8062cd141 = {
    prefix: "fas",
    iconName: "jug-detergent",
    icon: [
        384,
        512,
        [],
        "e519",
        "M96 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V48h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H88C74.7 96 64 85.3 64 72s10.7-24 24-24h8V24zM0 256c0-70.7 57.3-128 128-128H256c70.7 0 128 57.3 128 128V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zm256 0v96c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $5c8203742f0e3062$export$9a5c11a5e3d7f1e7 = {
    prefix: "fas",
    iconName: "circle-user",
    icon: [
        512,
        512,
        [
            62142,
            "user-circle"
        ],
        "f2bd",
        "M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"
    ]
};
var $5c8203742f0e3062$export$be7d974e9e0dba1a = $5c8203742f0e3062$export$9a5c11a5e3d7f1e7;
var $5c8203742f0e3062$export$d1886bc596424e6c = {
    prefix: "fas",
    iconName: "user-shield",
    icon: [
        640,
        512,
        [],
        "f505",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c1.8 0 3.5-.2 5.3-.5c-76.3-55.1-99.8-141-103.1-200.2c-16.1-4.8-33.1-7.3-50.7-7.3H178.3zm308.8-78.3l-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM591.4 312c-3.9 50.7-27.2 116.7-95.4 149.7V273.8L591.4 312z"
    ]
};
var $5c8203742f0e3062$export$cc58cb0f2257a6a9 = {
    prefix: "fas",
    iconName: "wind",
    icon: [
        512,
        512,
        [],
        "f72e",
        "M288 32c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c53 0 96-43 96-96s-43-96-96-96H320c-17.7 0-32 14.3-32 32zm64 352c0 17.7 14.3 32 32 32h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32 14.3-32 32zM128 512h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $5c8203742f0e3062$export$6d2be7c5d395dd16 = {
    prefix: "fas",
    iconName: "car-burst",
    icon: [
        640,
        512,
        [
            "car-crash"
        ],
        "f5e1",
        "M176 8c-6.6 0-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l35.3-32.5 9.5-35.4 10.4-38.6c8-29.9 30.5-52.1 57.9-60.9l41-59.2c11.3-16.3 26.4-28.9 43.5-37.2c-.4-.6-.8-1.2-1.3-1.8c-4.1-5.1-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74C188.4 12 182.6 8 176 8zM367.7 161.5l135.6 36.3c6.5 1.8 11.3 7.4 11.8 14.2l4.6 56.5-201.5-54 32.2-46.6c3.8-5.6 10.8-8.1 17.3-6.4zm-69.9-30l-47.9 69.3c-21.6 3-40.3 18.6-46.3 41l-10.4 38.6-16.6 61.8-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9 247.3 66.3-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9L595 388l10.4-38.6c6-22.4-2.5-45.2-19.6-58.7l-6.8-84c-2.7-33.7-26.4-62-59-70.8L384.2 99.7c-32.7-8.8-67.3 4-86.5 31.8zm-17 131a24 24 0 1 1 -12.4 46.4 24 24 0 1 1 12.4-46.4zm217.9 83.2A24 24 0 1 1 545 358.1a24 24 0 1 1 -46.4-12.4z"
    ]
};
var $5c8203742f0e3062$export$8ff55566398404cd = $5c8203742f0e3062$export$6d2be7c5d395dd16;
var $5c8203742f0e3062$export$b8c4c058fe7d193c = {
    prefix: "fas",
    iconName: "y",
    icon: [
        384,
        512,
        [
            121
        ],
        "59",
        "M58 45.4C47.8 31 27.8 27.7 13.4 38S-4.3 68.2 6 82.6L160 298.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V298.3L378 82.6c10.3-14.4 6.9-34.4-7.4-44.6S336.2 31 326 45.4L192 232.9 58 45.4z"
    ]
};
var $5c8203742f0e3062$export$22c642403aeeaeaf = {
    prefix: "fas",
    iconName: "person-snowboarding",
    icon: [
        512,
        512,
        [
            127938,
            "snowboarding"
        ],
        "f7ce",
        "M209.7 3.4c15.8-7.9 35-1.5 42.9 14.3l25 50 42.4 8.5c19.5 3.9 37.8 12.3 53.5 24.5l126.1 98.1c14 10.9 16.5 31 5.6 44.9s-31 16.5-44.9 5.6l-72.1-56.1-71.5 31.8 33.1 27.6c23.2 19.3 33.5 50 26.7 79.4l-17.4 75.2c-2.2 9.4-8.2 16.8-16.1 21l86.5 33.1c4.6 1.8 9.4 2.6 14.3 2.6H472c13.3 0 24 10.7 24 24s-10.7 24-24 24H443.8c-10.8 0-21.4-2-31.5-5.8L60.1 371.3c-11.5-4.4-22-11.2-30.8-20L7 329c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.4 22.4c4 4 8.7 7.1 14 9.1l22.4 8.6c-.8-1.6-1.5-3.2-2.1-4.9c-5.6-16.8 3.5-34.9 20.2-40.5L192 264.9l0-53.2c0-24.2 13.7-46.4 35.4-57.2l45.2-22.6-7.5-1.5c-19.4-3.9-35.9-16.5-44.7-34.1l-25-50c-7.9-15.8-1.5-35 14.3-42.9zM139 350.1l159 60.9c-2.1-5.6-2.6-11.9-1.1-18.2l17.4-75.2c1.4-5.9-.7-12-5.3-15.9l-52.8-44 0 18.8c0 20.7-13.2 39-32.8 45.5L139 350.1zM432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $5c8203742f0e3062$export$72683772d587302a = $5c8203742f0e3062$export$22c642403aeeaeaf;
var $5c8203742f0e3062$export$27de16299ddd171 = {
    prefix: "fas",
    iconName: "truck-fast",
    icon: [
        640,
        512,
        [
            "shipping-fast"
        ],
        "f48b",
        "M112 0C85.5 0 64 21.5 64 48V96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 272c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 240c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 208c8.8 0 16 7.2 16 16s-7.2 16-16 16H64V416c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H112zM544 237.3V256H416V160h50.7L544 237.3zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var $5c8203742f0e3062$export$5e419f47aaeb3c05 = $5c8203742f0e3062$export$27de16299ddd171;
var $5c8203742f0e3062$export$24228a855c5f6812 = {
    prefix: "fas",
    iconName: "fish",
    icon: [
        576,
        512,
        [
            128031
        ],
        "f578",
        "M180.5 141.5C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9S-3 348.7 4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1zM448 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $5c8203742f0e3062$export$10f5839059d22f7e = {
    prefix: "fas",
    iconName: "user-graduate",
    icon: [
        448,
        512,
        [],
        "f501",
        "M219.3 .5c3.1-.6 6.3-.6 9.4 0l200 40C439.9 42.7 448 52.6 448 64s-8.1 21.3-19.3 23.5L352 102.9V160c0 70.7-57.3 128-128 128s-128-57.3-128-128V102.9L48 93.3v65.1l15.7 78.4c.9 4.7-.3 9.6-3.3 13.3s-7.6 5.9-12.4 5.9H16c-4.8 0-9.3-2.1-12.4-5.9s-4.3-8.6-3.3-13.3L16 158.4V86.6C6.5 83.3 0 74.3 0 64C0 52.6 8.1 42.7 19.3 40.5l200-40zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6z"
    ]
};
var $5c8203742f0e3062$export$625fb3848216f28c = {
    prefix: "fas",
    iconName: "circle-half-stroke",
    icon: [
        512,
        512,
        [
            9680,
            "adjust"
        ],
        "f042",
        "M448 256c0-106-86-192-192-192V448c106 0 192-86 192-192zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var $5c8203742f0e3062$export$cfa06e4b68edca2d = $5c8203742f0e3062$export$625fb3848216f28c;
var $5c8203742f0e3062$export$add3b381ced12554 = {
    prefix: "fas",
    iconName: "clapperboard",
    icon: [
        512,
        512,
        [],
        "e131",
        "M448 32H361.9l-1 1-127 127h92.1l1-1L453.8 32.3c-1.9-.2-3.8-.3-5.8-.3zm64 128V96c0-15.1-5.3-29.1-14-40l-104 104H512zM294.1 32H201.9l-1 1L73.9 160h92.1l1-1 127-127zM64 32C28.7 32 0 60.7 0 96v64H6.1l1-1 127-127H64zM512 192H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192z"
    ]
};
var $5c8203742f0e3062$export$55c8e3afd9f6c0b4 = {
    prefix: "fas",
    iconName: "circle-radiation",
    icon: [
        512,
        512,
        [
            9762,
            "radiation-alt"
        ],
        "f7ba",
        "M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9c-25.6 22.6-43.9 53.3-50.9 88.1C95.7 241.5 110.3 256 128 256l72 0zm28 48.5l-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8c16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l72 0c17.7 0 32.3-14.5 28.8-31.8c-7-34.8-25.3-65.5-50.9-88.1c-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5zm-56 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$2f048fa82bbddf6f = $5c8203742f0e3062$export$55c8e3afd9f6c0b4;
var $5c8203742f0e3062$export$dc3654cf8a596fbf = {
    prefix: "fas",
    iconName: "baseball",
    icon: [
        512,
        512,
        [
            129358,
            9918,
            "baseball-ball"
        ],
        "f433",
        "M62.7 223.4c-4.8 .4-9.7 .6-14.7 .6c-15.6 0-30.8-2-45.2-5.9C19.2 107.1 107.1 19.2 218.1 2.8C222 17.2 224 32.4 224 48c0 4.9-.2 9.8-.6 14.7c-.7 8.8 5.8 16.5 14.6 17.3s16.5-5.8 17.3-14.6c.5-5.7 .7-11.5 .7-17.3c0-16.5-1.9-32.6-5.6-47.9c1.8 0 3.7-.1 5.6-.1C397.4 0 512 114.6 512 256c0 1.9 0 3.7-.1 5.6c-15.4-3.6-31.4-5.6-47.9-5.6c-5.8 0-11.6 .2-17.3 .7c-8.8 .7-15.4 8.5-14.6 17.3s8.5 15.4 17.3 14.6c4.8-.4 9.7-.6 14.7-.6c15.6 0 30.8 2 45.2 5.9C492.8 404.9 404.9 492.8 293.9 509.2C290 494.8 288 479.6 288 464c0-4.9 .2-9.8 .6-14.7c.7-8.8-5.8-16.5-14.6-17.3s-16.5 5.8-17.3 14.6c-.5 5.7-.7 11.5-.7 17.3c0 16.5 1.9 32.6 5.6 47.9c-1.8 0-3.7 .1-5.6 .1C114.6 512 0 397.4 0 256c0-1.9 0-3.7 .1-5.6C15.4 254.1 31.5 256 48 256c5.8 0 11.6-.2 17.3-.7c8.8-.7 15.4-8.5 14.6-17.3s-8.5-15.4-17.3-14.6zM121.3 208c-8 3.7-11.6 13.2-7.9 21.2s13.2 11.6 21.2 7.9c45.2-20.8 81.7-57.2 102.5-102.5c3.7-8 .2-17.5-7.9-21.2s-17.5-.2-21.2 7.9c-17.6 38.3-48.5 69.2-86.7 86.7zm277.2 74.7c-3.7-8-13.2-11.6-21.2-7.9c-45.2 20.8-81.7 57.2-102.5 102.5c-3.7 8-.2 17.5 7.9 21.2s17.5 .2 21.2-7.9c17.6-38.3 48.5-69.2 86.7-86.7c8-3.7 11.6-13.2 7.9-21.2z"
    ]
};
var $5c8203742f0e3062$export$63a3f8ceae07c7f3 = $5c8203742f0e3062$export$dc3654cf8a596fbf;
var $5c8203742f0e3062$export$b024a52a4ccf5e69 = {
    prefix: "fas",
    iconName: "jet-fighter-up",
    icon: [
        512,
        512,
        [],
        "e518",
        "M270.7 9.7C268.2 3.8 262.4 0 256 0s-12.2 3.8-14.7 9.7L197.2 112.6c-3.4 8-5.2 16.5-5.2 25.2v77l-144 84V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v56 32 24c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H192v32.7L133.5 468c-3.5 3-5.5 7.4-5.5 12v16c0 8.8 7.2 16 16 16h96V448c0-8.8 7.2-16 16-16s16 7.2 16 16v64h96c8.8 0 16-7.2 16-16V480c0-4.6-2-9-5.5-12L320 416.7V384H464v8c0 13.3 10.7 24 24 24s24-10.7 24-24V368 336 280c0-13.3-10.7-24-24-24s-24 10.7-24 24v18.8l-144-84v-77c0-8.7-1.8-17.2-5.2-25.2L270.7 9.7z"
    ]
};
var $5c8203742f0e3062$export$59c351869dc27435 = {
    prefix: "fas",
    iconName: "diagram-project",
    icon: [
        576,
        512,
        [
            "project-diagram"
        ],
        "f542",
        "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48V96H384V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V160H192v16c0 1.7-.1 3.4-.3 5L272 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V336c0-1.7 .1-3.4 .3-5L144 224H48c-26.5 0-48-21.5-48-48V80z"
    ]
};
var $5c8203742f0e3062$export$30bf9f5b96509df1 = $5c8203742f0e3062$export$59c351869dc27435;
var $5c8203742f0e3062$export$e9bd786d30cb716c = {
    prefix: "fas",
    iconName: "copy",
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M208 0H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z"
    ]
};
var $5c8203742f0e3062$export$28cc565c11db6f2e = {
    prefix: "fas",
    iconName: "volume-xmark",
    icon: [
        576,
        512,
        [
            "volume-mute",
            "volume-times"
        ],
        "f6a9",
        "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var $5c8203742f0e3062$export$aa8decd057dfd29b = $5c8203742f0e3062$export$28cc565c11db6f2e;
var $5c8203742f0e3062$export$a1c7b36ba71dbeca = $5c8203742f0e3062$export$28cc565c11db6f2e;
var $5c8203742f0e3062$export$72e2d874a963de0c = {
    prefix: "fas",
    iconName: "hand-sparkles",
    icon: [
        640,
        512,
        [],
        "e05d",
        "M320 0c17.7 0 32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7 14.3-32 32-32s32 14.3 32 32V323.1c-11.9 4.8-21.3 14.9-25 27.8l-8.9 31.2L478.9 391C460.6 396.3 448 413 448 432c0 18.9 12.5 35.6 30.6 40.9C448.4 497.4 409.9 512 368 512H348.8c-59.6 0-116.9-22.9-160-64L76.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-17.7 14.3-32 32-32zm-7.3 326.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L288 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L288 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L320 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L320 352l-7.3-25.4zM104 120l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L104 168 90.2 216.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 168 7.7 154.2C3.1 152.9 0 148.7 0 144s3.1-8.9 7.7-10.2L56 120 69.8 71.7C71.1 67.1 75.3 64 80 64s8.9 3.1 10.2 7.7L104 120zM584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7L584 408z"
    ]
};
var $5c8203742f0e3062$export$eb83fb404127db75 = {
    prefix: "fas",
    iconName: "grip",
    icon: [
        448,
        512,
        [
            "grip-horizontal"
        ],
        "f58d",
        "M128 136c0-22.1-17.9-40-40-40L40 96C17.9 96 0 113.9 0 136l0 48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40l0-48zm0 192c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM288 328c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM448 328c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328z"
    ]
};
var $5c8203742f0e3062$export$4a45308d6c8decc1 = $5c8203742f0e3062$export$eb83fb404127db75;
var $5c8203742f0e3062$export$928280bdd54fa173 = {
    prefix: "fas",
    iconName: "share-from-square",
    icon: [
        576,
        512,
        [
            61509,
            "share-square"
        ],
        "f14d",
        "M352 224H305.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144h80V34.7C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9L548.1 133.3c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2H384c-17.7 0-32-14.3-32-32V224zM80 96c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V384c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112C0 67.8 35.8 32 80 32h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H80z"
    ]
};
var $5c8203742f0e3062$export$ae9e1434571f373c = $5c8203742f0e3062$export$928280bdd54fa173;
var $5c8203742f0e3062$export$f7367a7301f2dc0f = {
    prefix: "fas",
    iconName: "child-combatant",
    icon: [
        576,
        512,
        [
            "child-rifle"
        ],
        "e4e0",
        "M176 128A64 64 0 1 0 176 0a64 64 0 1 0 0 128zm-8 352V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V300.5L260.9 321c9.4 15 29.2 19.4 44.1 10s19.4-29.2 10-44.1l-51.7-82.1c-17.6-27.9-48.3-44.9-81.2-44.9H169.8c-33 0-63.7 16.9-81.2 44.9L36.9 287c-9.4 15-4.9 34.7 10 44.1s34.7 4.9 44.1-10L104 300.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM448 0H432 416c-8.8 0-16 7.2-16 16s7.2 16 16 16V132.3c-9.6 5.5-16 15.9-16 27.7v32c-17.7 0-32 14.3-32 32V368c0 17.7 14.3 32 32 32h16v96c0 8.8 7.2 16 16 16h59.5c10.4 0 18-9.8 15.5-19.9L484 400h44c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H480V325.3l53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2V208c0-8.8-7.2-16-16-16H512c-8.8 0-16 7.2-16 16v56l-16 5.3V160c0-11.8-6.4-22.2-16-27.7V16c0-8.8-7.2-16-16-16z"
    ]
};
var $5c8203742f0e3062$export$9b027cdb5db3ae5c = $5c8203742f0e3062$export$f7367a7301f2dc0f;
var $5c8203742f0e3062$export$e18f576a7b31ba46 = {
    prefix: "fas",
    iconName: "gun",
    icon: [
        576,
        512,
        [],
        "e19b",
        "M528 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H32C14.3 64 0 78.3 0 96V208c0 17.7 14.3 32 32 32H42c20.8 0 36.1 19.6 31 39.8L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480h96c14.7 0 27.5-10 31-24.2L217 352H321.4c23.7 0 44.8-14.9 52.7-37.2L400.9 240H432c8.5 0 16.6-3.4 22.6-9.4L477.3 208H544c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H528V56zM321.4 304H229l16-64h105l-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3zM80 128H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$318ed022991eef56 = {
    prefix: "fas",
    iconName: "square-phone",
    icon: [
        448,
        512,
        [
            "phone-square"
        ],
        "f098",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.7 96.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384C196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3l44-12z"
    ]
};
var $5c8203742f0e3062$export$8ba22605a641ebdf = $5c8203742f0e3062$export$318ed022991eef56;
var $5c8203742f0e3062$export$a105e7b44ca0eb9e = {
    prefix: "fas",
    iconName: "plus",
    icon: [
        448,
        512,
        [
            10133,
            61543,
            "add"
        ],
        "2b",
        "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"
    ]
};
var $5c8203742f0e3062$export$9e8f9a9d4ad32c0f = $5c8203742f0e3062$export$a105e7b44ca0eb9e;
var $5c8203742f0e3062$export$1fe4a9976a241685 = {
    prefix: "fas",
    iconName: "expand",
    icon: [
        448,
        512,
        [],
        "f065",
        "M32 32C14.3 32 0 46.3 0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V352zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H320zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V352z"
    ]
};
var $5c8203742f0e3062$export$9835883ce9d0fe78 = {
    prefix: "fas",
    iconName: "computer",
    icon: [
        640,
        512,
        [],
        "e4e5",
        "M384 96V320H64L64 96H384zM64 32C28.7 32 0 60.7 0 96V320c0 35.3 28.7 64 64 64H181.3l-10.7 32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H277.3l-10.7-32H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm464 0c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H528zm16 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$e6e44779b2fa1a5c = {
    prefix: "fas",
    iconName: "xmark",
    icon: [
        384,
        512,
        [
            128473,
            10005,
            10006,
            10060,
            215,
            "close",
            "multiply",
            "remove",
            "times"
        ],
        "f00d",
        "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
    ]
};
var $5c8203742f0e3062$export$23c717133fd81476 = $5c8203742f0e3062$export$e6e44779b2fa1a5c;
var $5c8203742f0e3062$export$4ed4ff13d4dbc862 = $5c8203742f0e3062$export$e6e44779b2fa1a5c;
var $5c8203742f0e3062$export$34810740c1bd6c54 = $5c8203742f0e3062$export$e6e44779b2fa1a5c;
var $5c8203742f0e3062$export$174bd7f477b115b4 = $5c8203742f0e3062$export$e6e44779b2fa1a5c;
var $5c8203742f0e3062$export$ff9a43e3a9cb653c = {
    prefix: "fas",
    iconName: "arrows-up-down-left-right",
    icon: [
        512,
        512,
        [
            "arrows"
        ],
        "f047",
        "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4V224H109.3l9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4H224V402.7l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4V288H402.7l-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4H288V109.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64z"
    ]
};
var $5c8203742f0e3062$export$d5ae09a305d70340 = $5c8203742f0e3062$export$ff9a43e3a9cb653c;
var $5c8203742f0e3062$export$fd7622d4b8d3674b = {
    prefix: "fas",
    iconName: "chalkboard-user",
    icon: [
        640,
        512,
        [
            "chalkboard-teacher"
        ],
        "f51c",
        "M160 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H384V320c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32h64V64L224 64v49.1C205.2 102.2 183.3 96 160 96V64zm0 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 352h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z"
    ]
};
var $5c8203742f0e3062$export$443fcf69b0155291 = $5c8203742f0e3062$export$fd7622d4b8d3674b;
var $5c8203742f0e3062$export$c8f99b9b5ea83555 = {
    prefix: "fas",
    iconName: "peso-sign",
    icon: [
        384,
        512,
        [],
        "e222",
        "M64 32C46.3 32 32 46.3 32 64v64c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c68.4 0 127.7-39 156.8-96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.7c.5-5.3 .7-10.6 .7-16s-.2-10.7-.7-16h.7c17.7 0 32-14.3 32-32s-14.3-32-32-32H332.8C303.7 71 244.4 32 176 32H64zm190.4 96H96V96h80c30.5 0 58.2 12.2 78.4 32zM96 192H286.9c.7 5.2 1.1 10.6 1.1 16s-.4 10.8-1.1 16H96V192zm158.4 96c-20.2 19.8-47.9 32-78.4 32H96V288H254.4z"
    ]
};
var $5c8203742f0e3062$export$18ba6a500873dba9 = {
    prefix: "fas",
    iconName: "building-shield",
    icon: [
        576,
        512,
        [],
        "e4d8",
        "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V207l-42.4 17H304 272c-8.8 0-16 7.2-16 16v32 24.2V304c0 .9 .1 1.7 .2 2.6c2.3 58.1 24.1 144.8 98.7 201.5c-5.8 2.5-12.2 3.9-18.9 3.9H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zM423.1 225.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"
    ]
};
var $5c8203742f0e3062$export$8afab767536f59ad = {
    prefix: "fas",
    iconName: "baby",
    icon: [
        448,
        512,
        [],
        "f77c",
        "M152 88a72 72 0 1 1 144 0A72 72 0 1 1 152 88zM39.7 144.5c13-17.9 38-21.8 55.9-8.8L131.8 162c26.8 19.5 59.1 30 92.2 30s65.4-10.5 92.2-30l36.2-26.4c17.9-13 42.9-9 55.9 8.8s9 42.9-8.8 55.9l-36.2 26.4c-13.6 9.9-28.1 18.2-43.3 25V288H128V251.7c-15.2-6.7-29.7-15.1-43.3-25L48.5 200.3c-17.9-13-21.8-38-8.8-55.9zm89.8 184.8l60.6 53-26 37.2 24.3 24.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-48-48C70 438.6 68.1 417 79.2 401.1l50.2-71.8zm128.5 53l60.6-53 50.2 71.8c11.1 15.9 9.2 37.5-4.5 51.2l-48 48c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6L284 419.4l-26-37.2z"
    ]
};
var $5c8203742f0e3062$export$d7e538fddb81da68 = {
    prefix: "fas",
    iconName: "users-line",
    icon: [
        640,
        512,
        [],
        "e592",
        "M211.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM32 256c0 17.7 14.3 32 32 32h85.6c10.1-39.4 38.6-71.5 75.8-86.6c-9.7-6-21.2-9.4-33.4-9.4H96c-35.3 0-64 28.7-64 64zm461.6 32H576c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H448c-11.7 0-22.7 3.1-32.1 8.6c38.1 14.8 67.4 47.3 77.7 87.4zM391.2 226.4c-6.9-1.6-14.2-2.4-21.6-2.4h-96c-8.5 0-16.7 1.1-24.5 3.1c-30.8 8.1-55.6 31.1-66.1 60.9c-3.5 10-5.5 20.8-5.5 32c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32c0-11.2-1.9-22-5.5-32c-10.8-30.7-36.8-54.2-68.9-61.6zM563.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM321.6 192a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $5c8203742f0e3062$export$932a67a1b1a7a724 = {
    prefix: "fas",
    iconName: "quote-left",
    icon: [
        448,
        512,
        [
            8220,
            "quote-left-alt"
        ],
        "f10d",
        "M0 216C0 149.7 53.7 96 120 96h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320 288 216zm256 0c0-66.3 53.7-120 120-120h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H320c-35.3 0-64-28.7-64-64V320 288 216z"
    ]
};
var $5c8203742f0e3062$export$95bb9ad3aa35c741 = $5c8203742f0e3062$export$932a67a1b1a7a724;
var $5c8203742f0e3062$export$e87e41787bbedc98 = {
    prefix: "fas",
    iconName: "tractor",
    icon: [
        640,
        512,
        [
            128668
        ],
        "f722",
        "M96 64c0-35.3 28.7-64 64-64H266.3c26.2 0 49.7 15.9 59.4 40.2L373.7 160H480V126.2c0-24.8 5.8-49.3 16.9-71.6l2.5-5c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.5 5c-6.7 13.3-10.1 28-10.1 42.9V160h56c22.1 0 40 17.9 40 40v45.4c0 16.5-8.5 31.9-22.6 40.7l-43.3 27.1c-14.2-5.9-29.8-9.2-46.1-9.2c-39.3 0-74.1 18.9-96 48H352c0 17.7-14.3 32-32 32h-8.2c-1.7 4.8-3.7 9.5-5.8 14.1l5.8 5.8c12.5 12.5 12.5 32.8 0 45.3l-22.6 22.6c-12.5 12.5-32.8 12.5-45.3 0l-5.8-5.8c-4.6 2.2-9.3 4.1-14.1 5.8V480c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32v-8.2c-4.8-1.7-9.5-3.7-14.1-5.8l-5.8 5.8c-12.5 12.5-32.8 12.5-45.3 0L40.2 449.1c-12.5-12.5-12.5-32.8 0-45.3l5.8-5.8c-2.2-4.6-4.1-9.3-5.8-14.1H32c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h8.2c1.7-4.8 3.7-9.5 5.8-14.1l-5.8-5.8c-12.5-12.5-12.5-32.8 0-45.3l22.6-22.6c9-9 21.9-11.5 33.1-7.6V192 160 64zm170.3 0H160v96h32H304.7L266.3 64zM176 256a80 80 0 1 0 0 160 80 80 0 1 0 0-160zM528 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 64c-48.6 0-88-39.4-88-88c0-29.8 14.8-56.1 37.4-72c14.3-10.1 31.8-16 50.6-16c2.7 0 5.3 .1 7.9 .3c44.9 4 80.1 41.7 80.1 87.7c0 48.6-39.4 88-88 88z"
    ]
};
var $5c8203742f0e3062$export$940cea0f5451895c = {
    prefix: "fas",
    iconName: "trash-arrow-up",
    icon: [
        448,
        512,
        [
            "trash-restore"
        ],
        "f829",
        "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416L394.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
    ]
};
var $5c8203742f0e3062$export$d32f45a64ed40e8d = $5c8203742f0e3062$export$940cea0f5451895c;
var $5c8203742f0e3062$export$fc9f7bd981c34c45 = {
    prefix: "fas",
    iconName: "arrow-down-up-lock",
    icon: [
        640,
        512,
        [],
        "e4b0",
        "M150.6 502.6l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7V288H416V272c0-17.2 3.9-33.5 10.8-48H352V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-6-6-14.1-9.4-22.6-9.4s-16.6 3.4-22.6 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 109.3V224l-128 0H96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32H96V402.7L54.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0zM160 192V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64zM288 320V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H288zm240-80c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $5c8203742f0e3062$export$4d384ffc907ddaff = {
    prefix: "fas",
    iconName: "lines-leaning",
    icon: [
        384,
        512,
        [],
        "e51e",
        "M190.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2l-128 384c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l128-384zm70.9-41.7c-17.4-2.9-33.9 8.9-36.8 26.3l-64 384c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3l64-384c2.9-17.4-8.9-33.9-26.3-36.8zM352 32c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32z"
    ]
};
var $5c8203742f0e3062$export$613f406c1b5802a8 = {
    prefix: "fas",
    iconName: "ruler-combined",
    icon: [
        512,
        512,
        [],
        "f546",
        "M.2 468.9C2.7 493.1 23.1 512 48 512l96 0 320 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 368l0 96c0 1.7 .1 3.3 .2 4.9z"
    ]
};
var $5c8203742f0e3062$export$da61665fff8aebfe = {
    prefix: "fas",
    iconName: "copyright",
    icon: [
        512,
        512,
        [
            169
        ],
        "f1f9",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c31.2 31.2 81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z"
    ]
};
var $5c8203742f0e3062$export$a7c5f5e4805fdab = {
    prefix: "fas",
    iconName: "equals",
    icon: [
        448,
        512,
        [
            62764
        ],
        "3d",
        "M48 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48zm0 192c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48z"
    ]
};
var $5c8203742f0e3062$export$db34f7a6de38784f = {
    prefix: "fas",
    iconName: "blender",
    icon: [
        512,
        512,
        [],
        "f517",
        "M0 64C0 28.7 28.7 0 64 0h64 32H470.1c21.1 0 36.4 20.1 30.9 40.4L494.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H485.8l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H459.6l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L416 352H160l-8.7-96H64c-35.3 0-64-28.7-64-64V64zM145.5 192L133.8 64H64V192h81.5zM144 384H432c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$b4619aeaf0b9d18e = {
    prefix: "fas",
    iconName: "teeth",
    icon: [
        576,
        512,
        [],
        "f62e",
        "M0 128C0 75 43 32 96 32H480c53 0 96 43 96 96V384c0 53-43 96-96 96H96c-53 0-96-43-96-96V128zm176 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48s-48 21.5-48 48zm176-48c-26.5 0-48 21.5-48 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48zM48 208v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zM96 384c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-48c0 26.5 21.5 48 48 48s48-21.5 48-48V312c0-13.3-10.7-24-24-24H200c-13.3 0-24 10.7-24 24v24zm176 48c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-176v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48 176c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H456c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48z"
    ]
};
var $5c8203742f0e3062$export$3570be7b68efb8db = {
    prefix: "fas",
    iconName: "shekel-sign",
    icon: [
        448,
        512,
        [
            8362,
            "ils",
            "shekel",
            "sheqel",
            "sheqel-sign"
        ],
        "f20b",
        "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H192c35.3 0 64 28.7 64 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-70.7-57.3-128-128-128H32zM320 480c70.7 0 128-57.3 128-128V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 35.3-28.7 64-64 64H192V192c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32H320z"
    ]
};
var $5c8203742f0e3062$export$ecadeff45b05a451 = $5c8203742f0e3062$export$3570be7b68efb8db;
var $5c8203742f0e3062$export$27e0e10e74d98736 = $5c8203742f0e3062$export$3570be7b68efb8db;
var $5c8203742f0e3062$export$28b3b26a80030d4e = $5c8203742f0e3062$export$3570be7b68efb8db;
var $5c8203742f0e3062$export$d84993fb5e8c6edd = $5c8203742f0e3062$export$3570be7b68efb8db;
var $5c8203742f0e3062$export$fc82fb79180cd17c = {
    prefix: "fas",
    iconName: "map",
    icon: [
        576,
        512,
        [
            128506,
            62072
        ],
        "f279",
        "M384 476.1L192 421.2V35.9L384 90.8V476.1zm32-1.2V88.4L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3V394.6c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2V423.6L32.9 474.5C17.1 480.8 0 469.2 0 452.2V117.4c0-9.8 6-18.6 15.1-22.3z"
    ]
};
var $5c8203742f0e3062$export$b24d84ed5657d89a = {
    prefix: "fas",
    iconName: "rocket",
    icon: [
        512,
        512,
        [],
        "f135",
        "M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2v82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9V380.8c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $5c8203742f0e3062$export$ed36ad335b36be22 = {
    prefix: "fas",
    iconName: "photo-film",
    icon: [
        640,
        512,
        [
            "photo-video"
        ],
        "f87c",
        "M256 0H576c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64zM476 106.7C471.5 100 464 96 456 96s-15.5 4-20 10.7l-56 84L362.7 169c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H552c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144zM336 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 128h96V384v32c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V384H512v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm8 64c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V312c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H72zm336 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H424c-8.8 0-16 7.2-16 16z"
    ]
};
var $5c8203742f0e3062$export$739f6a6a12dfb6ed = $5c8203742f0e3062$export$ed36ad335b36be22;
var $5c8203742f0e3062$export$758f1fb3784e4080 = {
    prefix: "fas",
    iconName: "folder-minus",
    icon: [
        512,
        512,
        [],
        "f65d",
        "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
    ]
};
var $5c8203742f0e3062$export$de59c2657a8ace67 = {
    prefix: "fas",
    iconName: "store",
    icon: [
        576,
        512,
        [],
        "f54e",
        "M547.6 103.8L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4zM499.7 254.9l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V384H128V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384 252.6c-4 1-8 1.8-12.3 2.3z"
    ]
};
var $5c8203742f0e3062$export$cf36928a9c52e98a = {
    prefix: "fas",
    iconName: "arrow-trend-up",
    icon: [
        576,
        512,
        [],
        "e098",
        "M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V205.3L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160H384z"
    ]
};
var $5c8203742f0e3062$export$2a44d62160972254 = {
    prefix: "fas",
    iconName: "plug-circle-minus",
    icon: [
        576,
        512,
        [],
        "e55e",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"
    ]
};
var $5c8203742f0e3062$export$5c1f29f4c7cad367 = {
    prefix: "fas",
    iconName: "sign-hanging",
    icon: [
        512,
        512,
        [
            "sign"
        ],
        "f4d9",
        "M96 0c17.7 0 32 14.3 32 32V64l352 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-352 0V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128H32C14.3 128 0 113.7 0 96S14.3 64 32 64H64V32C64 14.3 78.3 0 96 0zm96 160H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$d21d0d6c8e9e8bf9 = $5c8203742f0e3062$export$5c1f29f4c7cad367;
var $5c8203742f0e3062$export$a527a6267c55a54c = {
    prefix: "fas",
    iconName: "bezier-curve",
    icon: [
        640,
        512,
        [],
        "f55b",
        "M296 136V88h48v48H296zM288 32c-26.5 0-48 21.5-48 48v4H121.6C111.2 62.7 89.3 48 64 48C28.7 48 0 76.7 0 112s28.7 64 64 64c25.3 0 47.2-14.7 57.6-36h66.9c-58.9 39.6-98.9 105-104 180H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-3.3c5.9-67 48.5-123.4 107.5-149.1c8.6 12.7 23.2 21.1 39.8 21.1h64c16.6 0 31.1-8.4 39.8-21.1c59 25.7 101.6 82.1 107.5 149.1H496c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-4.5c-5-75-45.1-140.4-104-180h66.9c10.4 21.3 32.3 36 57.6 36c35.3 0 64-28.7 64-64s-28.7-64-64-64c-25.3 0-47.2 14.7-57.6 36H400V80c0-26.5-21.5-48-48-48H288zM88 376h48v48H88V376zm416 48V376h48v48H504z"
    ]
};
var $5c8203742f0e3062$export$6b31a1e5968b2378 = {
    prefix: "fas",
    iconName: "bell-slash",
    icon: [
        640,
        512,
        [
            128277,
            61943
        ],
        "f1f6",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-90.2-70.7c.2-.4 .4-.9 .6-1.3c5.2-11.5 3.1-25-5.3-34.4l-7.4-8.3C497.3 319.2 480 273.9 480 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V51.2c-42.6 8.6-79 34.2-102 69.3L38.8 5.1zM406.2 416L160 222.1v4.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S115.4 416 128 416H406.2zm-40.9 77.3c12-12 18.7-28.3 18.7-45.3H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
    ]
};
var $5c8203742f0e3062$export$1c92b67c45a4b4fc = {
    prefix: "fas",
    iconName: "tablet",
    icon: [
        448,
        512,
        [
            "tablet-android"
        ],
        "f3fb",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM176 432h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$5eddbb7c71278268 = $5c8203742f0e3062$export$1c92b67c45a4b4fc;
var $5c8203742f0e3062$export$9b263780a7312c8c = {
    prefix: "fas",
    iconName: "school-flag",
    icon: [
        576,
        512,
        [],
        "e56e",
        "M288 0H400c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H320.7l89.6 64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H336V400c0-26.5-21.5-48-48-48s-48 21.5-48 48V512H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64H165.7L256 95.5V32c0-17.7 14.3-32 32-32zm48 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm368 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16zM80 352c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H80zm384 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H464z"
    ]
};
var $5c8203742f0e3062$export$d3c2bcfd3b861e4a = {
    prefix: "fas",
    iconName: "fill",
    icon: [
        512,
        512,
        [],
        "f575",
        "M86.6 9.4C74.1-3.1 53.9-3.1 41.4 9.4s-12.5 32.8 0 45.3L122.7 136 30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0L168 90.7 86.6 9.4zM168 181.3l49.4 49.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L213.3 136l53.1-53.1c3.1-3.1 8.2-3.1 11.3 0L429.1 234.3c3.1 3.1 3.1 8.2 0 11.3L386.7 288H67.5c1.4-5.4 4.2-10.4 8.4-14.6L168 181.3z"
    ]
};
var $5c8203742f0e3062$export$887340269e6d6cac = {
    prefix: "fas",
    iconName: "angle-up",
    icon: [
        448,
        512,
        [
            8963
        ],
        "f106",
        "M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"
    ]
};
var $5c8203742f0e3062$export$482976e9a4ab10f3 = {
    prefix: "fas",
    iconName: "drumstick-bite",
    icon: [
        512,
        512,
        [],
        "f6d7",
        "M160 265.2c0 8.5-3.4 16.6-9.4 22.6l-26.8 26.8c-12.3 12.3-32.5 11.4-49.4 7.2C69.8 320.6 65 320 60 320c-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-5-.6-9.8-1.8-14.5c-4.2-16.9-5.2-37.1 7.2-49.4l26.8-26.8c6-6 14.1-9.4 22.6-9.4H336c6.3 0 12.4-.3 18.5-1c11.9-1.2 16.4-15.5 10.8-26c-8.5-15.8-13.3-33.8-13.3-53c0-61.9 50.1-112 112-112c8 0 15.7 .8 23.2 2.4c11.7 2.5 24.1-5.9 22-17.6C494.5 62.5 422.5 0 336 0C238.8 0 160 78.8 160 176v89.2z"
    ]
};
var $5c8203742f0e3062$export$273296afacf93991 = {
    prefix: "fas",
    iconName: "holly-berry",
    icon: [
        512,
        512,
        [],
        "f7aa",
        "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM276.8 383.8c1 .1 2.1 .2 3.2 .2c39.8 0 72 32.2 72 72v22.7c0 16.4 16 27.9 31.6 22.8l12.8-4.3c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5L495.6 452c-5-18.3-4.4-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6c-34.6 0-62.7-28.1-62.7-62.7v-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-29.6-8.1c-2.9-.8-5.9-1-8.7-.7c4.2 9.7 5.8 20.8 3.7 32.3L275 298.7c-1.5 8.4-1.4 17 .5 25.3l5.3 23.9c2.8 12.7 1.1 25.2-4 35.9zM127.6 234.5c-15.5-5.2-31.6 6.4-31.6 22.8v32C96 323.9 67.9 352 33.3 352c-16.4 0-27.9 16-22.8 31.6l4.3 12.8c6 18 6.5 37.3 1.5 55.6l-5.3 19.4C6.2 489.4 22.6 505.8 40.5 501L60 495.6c18.3-5 37.6-4.5 55.6 1.5l12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8v-32c0-34.6 28.1-62.7 62.7-62.7c16.4 0 27.9-16 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5L196 240.4c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3zM384 144a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $5c8203742f0e3062$export$75702e3e3dd44a44 = {
    prefix: "fas",
    iconName: "chevron-left",
    icon: [
        320,
        512,
        [
            9001
        ],
        "f053",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
    ]
};
var $5c8203742f0e3062$export$7fc18cf2d526c341 = {
    prefix: "fas",
    iconName: "bacteria",
    icon: [
        640,
        512,
        [],
        "e059",
        "M304.9 .7c-9.6-2.7-19.5 2.8-22.3 12.4l-4.3 15.2c-8.3-.6-16.8 0-25.2 1.9c-7.3 1.7-14.3 3.5-21.1 5.5l-5.5-12.7c-3.9-9.1-14.5-13.4-23.6-9.5s-13.4 14.5-9.5 23.6l4.4 10.4c-16.6 6.7-31.7 14.4-45.4 22.8L147 62c-5.5-8.3-16.7-10.5-25-5s-10.5 16.7-5 25l6 9c-13.7 11-25.5 22.8-35.8 34.9l-10-8c-7.8-6.2-19.1-5-25.3 2.8s-5 19.1 2.8 25.3L65.9 155c-1.8 2.8-3.5 5.7-5.1 8.5c-6.6 11.4-11.8 22.6-16 33l-8-3.2c-9.2-3.7-19.7 .8-23.4 10s.8 19.7 10 23.4l10.4 4.2c-.2 .8-.4 1.5-.5 2.3c-2.2 9.3-3.4 17.3-4.1 23.4c-.4 3.1-.6 5.7-.8 7.8c-.1 1.1-.1 2-.2 2.8l-.1 1.1 0 .5 0 .2 0 .1c0 0 0 .1 29.1 1l-.1 0L28 269.3c-.1 3.1 0 6.1 .2 9.1l-15.2 4.3C3.5 285.4-2 295.4 .7 304.9s12.7 15.1 22.3 12.4l15.6-4.5c7.6 13.6 18.9 25 32.6 32.6L66.7 361c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.3-12.4l4.3-15.2c1.2 .1 2.4 .2 3.6 .2c15.6 .5 30.3-3.3 43-10.2l9 9c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-7.2-7.2c9.3-12.6 15.2-27.8 16.3-44.5l7.1 3c9.1 3.9 19.7-.3 23.6-9.5s-.3-19.7-9.5-23.6l-8.6-3.7c6.4-9.9 17.3-22.4 36.9-33.3l1.3 4.4c2.7 9.6 12.7 15.1 22.3 12.4s15.1-12.7 12.4-22.3l-2.3-8.1c3.8-1.1 7.7-2.1 11.9-3.1c11.6-2.7 22.1-7.7 31.1-14.4l7.2 7.2c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-9-9c7.6-13.9 11.3-30.1 10.1-46.6l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3S370.6 64 361 66.7l-15.6 4.5c-7.7-13.9-19.1-25.1-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3zM112 272l-48-1.5 0 0c11.7 .4 27.3 .9 48 1.6zm16-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM322.7 489c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.2-12.4l4.3-15.2c8.3 .6 16.8 0 25.2-1.9c7.3-1.7 14.3-3.5 21.1-5.5l5.5 12.7c3.9 9.1 14.5 13.4 23.6 9.5s13.4-14.5 9.5-23.6l-4.4-10.4c16.6-6.7 31.7-14.4 45.4-22.8L493 450c5.5 8.3 16.7 10.5 25 5s10.5-16.7 5-25l-6-9c13.7-11 25.5-22.8 35.8-34.9l10 8c7.8 6.2 19.1 5 25.3-2.8s5-19.1-2.8-25.3L574.1 357c1.8-2.8 3.5-5.7 5.1-8.5c6.6-11.4 11.8-22.6 16-33l8 3.2c9.2 3.7 19.7-.8 23.4-10s-.8-19.7-10-23.4l-10.4-4.2c.2-.8 .4-1.5 .5-2.3c2.2-9.3 3.4-17.3 4.1-23.4c.4-3.1 .6-5.7 .8-7.8c.1-1.1 .1-2 .2-2.8l.1-1.1 0-.5 0-.2 0-.1c0 0 0-.1-29.1-1l.1 0 29.1 .9c.1-3.1 0-6.1-.2-9.1l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3s-12.7-15.1-22.3-12.4l-15.6 4.5c-7.6-13.6-18.9-25-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3s-19.5 2.8-22.3 12.4l-4.3 15.2c-1.2-.1-2.4-.2-3.6-.2c-15.6-.5-30.3 3.3-43 10.2l-9-9c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l7.2 7.2c-9.3 12.6-15.2 27.8-16.3 44.5l-7.1-3c-9.1-3.9-19.7 .3-23.6 9.5s.3 19.7 9.5 23.6l8.6 3.7c-6.4 9.9-17.3 22.4-36.9 33.3l-1.3-4.4c-2.7-9.6-12.7-15.1-22.3-12.4s-15.1 12.7-12.4 22.3l2.3 8.1c-3.8 1.1-7.7 2.1-11.9 3.1c-11.6 2.7-22.1 7.7-31.1 14.4l-7.2-7.2c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l9 9c-7.6 13.9-11.3 30.1-10.1 46.6l-15.2 4.3c-9.6 2.7-15.1 12.7-12.4 22.2s12.7 15.1 22.3 12.4l15.6-4.5c7.7 13.9 19.1 25.1 32.6 32.6L322.7 489zM576 241.5l0 0c-11.7-.4-27.3-.9-48-1.6l48 1.5zM448 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"
    ]
};
var $5c8203742f0e3062$export$54608d0a883fea4d = {
    prefix: "fas",
    iconName: "hand-lizard",
    icon: [
        512,
        512,
        [],
        "f258",
        "M0 112C0 85.5 21.5 64 48 64H160h80 46.5c36.8 0 71.2 18 92.1 48.2l113.5 164c13 18.7 19.9 41 19.9 63.8v12 16 48c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V402.2L273.9 352H240 160 112c-26.5 0-48-21.5-48-48s21.5-48 48-48h48 80c26.5 0 48-21.5 48-48s-21.5-48-48-48H160 48c-26.5 0-48-21.5-48-48z"
    ]
};
var $5c8203742f0e3062$export$3db5bca65a1be8dc = {
    prefix: "fas",
    iconName: "notdef",
    icon: [
        384,
        512,
        [],
        "e1fe",
        "M64 390.3L153.5 256 64 121.7V390.3zM102.5 448H281.5L192 313.7 102.5 448zm128-192L320 390.3V121.7L230.5 256zM281.5 64H102.5L192 198.3 281.5 64zM0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"
    ]
};
var $5c8203742f0e3062$export$c7675a37487adc45 = {
    prefix: "fas",
    iconName: "disease",
    icon: [
        512,
        512,
        [],
        "f7fa",
        "M236.4 61.4L227 75.5c-21.3 32-59.4 48.5-97.3 42.1l-59.6-9.9C33.4 101.6 0 129.9 .1 167.1c0 15.9 6.4 31.2 17.6 42.5l29.2 29.2c11 11 17.2 25.9 17.2 41.5c0 15.8-6.4 30.9-17.7 42L33.3 335.1C22.2 345.9 16 360.7 16 376.2c0 36.8 34.1 64.2 70.1 56.2l62.3-13.8c7.7-1.7 15.7-2.6 23.6-2.6h10c27.2 0 53.7 9.3 75 26.3L287.8 467c10.5 8.4 23.6 13 37 13c32.7 0 59.3-26.5 59.3-59.3l0-25.2c0-34.9 21.4-66.2 53.9-78.8l36.9-14.3c22.4-8.7 37.2-30.3 37.2-54.3c0-28.1-20.1-52.3-47.8-57.3l-28-5.1c-36.5-6.7-65.4-34.5-73.6-70.7l-7.1-31.5C348.9 53.4 322.1 32 291.3 32c-22 0-42.6 11-54.9 29.4zM160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$5000f52ca9819bf5 = {
    prefix: "fas",
    iconName: "briefcase-medical",
    icon: [
        512,
        512,
        [],
        "f469",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm96 152c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
    ]
};
var $5c8203742f0e3062$export$c093cc22e88981c2 = {
    prefix: "fas",
    iconName: "genderless",
    icon: [
        384,
        512,
        [],
        "f22d",
        "M192 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 288a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"
    ]
};
var $5c8203742f0e3062$export$930de8c26eb20490 = {
    prefix: "fas",
    iconName: "chevron-right",
    icon: [
        320,
        512,
        [
            9002
        ],
        "f054",
        "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
    ]
};
var $5c8203742f0e3062$export$cebc76f79478e40e = {
    prefix: "fas",
    iconName: "retweet",
    icon: [
        576,
        512,
        [],
        "f079",
        "M272 416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32-14.3-32-32V192h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 128c0 53 43 96 96 96H272zM304 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0c17.7 0 32 14.3 32 32l0 128H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0V192c0-53-43-96-96-96L304 96z"
    ]
};
var $5c8203742f0e3062$export$ff2b8d5628da5f14 = {
    prefix: "fas",
    iconName: "car-rear",
    icon: [
        512,
        512,
        [
            "car-alt"
        ],
        "f5de",
        "M165.4 96H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 192H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zm-90.6 .3L39.6 196.8C16.4 206.4 0 229.3 0 256v80c0 23.7 12.9 44.4 32 55.4V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V400H384v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V391.4c19.1-11.1 32-31.7 32-55.4V256c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32H165.4c-40.8 0-77.1 25.8-90.6 64.3zM208 272h96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V288c0-8.8 7.2-16 16-16zM48 280c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24zm360-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H408c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $5c8203742f0e3062$export$7937ed2462a665c0 = $5c8203742f0e3062$export$ff2b8d5628da5f14;
var $5c8203742f0e3062$export$821aeede187f23c9 = {
    prefix: "fas",
    iconName: "pump-soap",
    icon: [
        448,
        512,
        [],
        "e06b",
        "M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM256 360c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-32.5 37-80.9 50.9-97.9c3.2-3.9 8.1-6.1 13.1-6.1s9.9 2.2 13.1 6.1C219 279.1 256 327.5 256 360z"
    ]
};
var $5c8203742f0e3062$export$a714fc79f58cc9ef = {
    prefix: "fas",
    iconName: "video-slash",
    icon: [
        640,
        512,
        [],
        "f4e2",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.4-67.7 13.8 9.2c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2V128c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L448 174.9V192 320v5.8l-32-25.1V128c0-35.3-28.7-64-64-64H113.9L38.8 5.1zM407 416.7L32.3 121.5c-.2 2.1-.3 4.3-.3 6.5V384c0 35.3 28.7 64 64 64H352c23.4 0 43.9-12.6 55-31.3z"
    ]
};
var $5c8203742f0e3062$export$acec92052ac2183 = {
    prefix: "fas",
    iconName: "battery-quarter",
    icon: [
        576,
        512,
        [
            "battery-2"
        ],
        "f243",
        "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm112 96H96V320h96V192z"
    ]
};
var $5c8203742f0e3062$export$23ca8a94c555576 = $5c8203742f0e3062$export$acec92052ac2183;
var $5c8203742f0e3062$export$11b26516cae2104f = {
    prefix: "fas",
    iconName: "radio",
    icon: [
        512,
        512,
        [
            128251
        ],
        "f8d7",
        "M494.8 47c12.7-3.7 20-17.1 16.3-29.8S494-2.8 481.2 1L51.7 126.9c-9.4 2.7-17.9 7.3-25.1 13.2C10.5 151.7 0 170.6 0 192v4V304 448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H218.5L494.8 47zM368 240a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM80 256c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zM64 320c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 64c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"
    ]
};
var $5c8203742f0e3062$export$3b3ab4d86bad7d26 = {
    prefix: "fas",
    iconName: "baby-carriage",
    icon: [
        512,
        512,
        [
            "carriage-baby"
        ],
        "f77d",
        "M256 192H.1C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8L256 192zm128-32c0-35.3 28.7-64 64-64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0v64c0 25.2-5.8 50.2-17 73.5s-27.8 44.5-48.6 62.3s-45.5 32-72.7 41.6S253.4 416 224 416s-58.5-5-85.7-14.6s-51.9-23.8-72.7-41.6s-37.3-39-48.6-62.3S0 249.2 0 224l224 0 160 0V160zM80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var $5c8203742f0e3062$export$9f117d92ccd36cf1 = $5c8203742f0e3062$export$3b3ab4d86bad7d26;
var $5c8203742f0e3062$export$bf0b19daceaec9c2 = {
    prefix: "fas",
    iconName: "traffic-light",
    icon: [
        320,
        512,
        [
            128678
        ],
        "f637",
        "M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"
    ]
};
var $5c8203742f0e3062$export$f576739e9b18ea4f = {
    prefix: "fas",
    iconName: "thermometer",
    icon: [
        512,
        512,
        [],
        "f491",
        "M96 382.1V293.3c0-14.9 5.9-29.1 16.4-39.6l27.3-27.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 45.5-45.5C355.2 10.9 381.4 0 408.8 0C465.8 0 512 46.2 512 103.2c0 27.4-10.9 53.6-30.2 73L258.3 399.6c-10.5 10.5-24.7 16.4-39.6 16.4H129.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l89-89z"
    ]
};
var $5c8203742f0e3062$export$248171cb6dad4307 = {
    prefix: "fas",
    iconName: "vr-cardboard",
    icon: [
        640,
        512,
        [],
        "f729",
        "M576 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H184.4c24.2 0 46.4-13.7 57.2-35.4l32-64c8.8-17.5 26.7-28.6 46.3-28.6s37.5 11.1 46.3 28.6l32 64c10.8 21.7 33 35.4 57.2 35.4H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM96 240a64 64 0 1 1 128 0A64 64 0 1 1 96 240zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $5c8203742f0e3062$export$bd40d3a3a16fb147 = {
    prefix: "fas",
    iconName: "hand-middle-finger",
    icon: [
        448,
        512,
        [
            128405
        ],
        "f806",
        "M232 0c-22.1 0-40 17.9-40 40V204.2c-8.5-7.6-19.7-12.2-32-12.2c-26.5 0-48 21.5-48 48v7 73c0 8.8-7.2 16-16 16s-16-7.2-16-16V264.3c-2 1.4-3.9 3-5.8 4.5L55 284.8C40.4 297 32 315 32 334V372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1H304c70.7 0 128-57.3 128-128V320 288c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 227.5 329.3 208 304 208c-12.3 0-23.5 4.6-32 12.2V40c0-22.1-17.9-40-40-40z"
    ]
};
var $5c8203742f0e3062$export$89a1764fbb7ad2cb = {
    prefix: "fas",
    iconName: "percent",
    icon: [
        384,
        512,
        [
            62101,
            62785,
            "percentage"
        ],
        "25",
        "M374.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-320 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l320-320zM128 128A64 64 0 1 0 0 128a64 64 0 1 0 128 0zM384 384a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $5c8203742f0e3062$export$89333857fc063a2e = $5c8203742f0e3062$export$89a1764fbb7ad2cb;
var $5c8203742f0e3062$export$a06617a1a4ccea67 = {
    prefix: "fas",
    iconName: "truck-moving",
    icon: [
        640,
        512,
        [],
        "f4df",
        "M64 32C28.7 32 0 60.7 0 96V304v80 16c0 44.2 35.8 80 80 80c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c44.2 0 80-35.8 80-80c0-5.5-.6-10.8-1.6-16H416h33.6c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H608c17.7 0 32-14.3 32-32V288 272 261.7c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5H480V96c0-35.3-28.7-64-64-64H64zM585 256H480V192h48.8c2.4 0 4.7 1.1 6.2 2.9L585 256zM528 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM176 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$b7ae54b4078b2060 = {
    prefix: "fas",
    iconName: "glass-water-droplet",
    icon: [
        384,
        512,
        [],
        "e4f5",
        "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM83 297.5L66.4 64H317.6L301 297.5 288 304c-20.1 10.1-43.9 10.1-64 0s-43.9-10.1-64 0s-43.9 10.1-64 0l-13-6.5zM256 196c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C161.7 125.9 128 172 128 196c0 33.1 28.7 60 64 60s64-26.9 64-60z"
    ]
};
var $5c8203742f0e3062$export$e9d85839f7751f01 = {
    prefix: "fas",
    iconName: "display",
    icon: [
        576,
        512,
        [],
        "e163",
        "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V352H64V64H512z"
    ]
};
var $5c8203742f0e3062$export$b5023c446f10324 = {
    prefix: "fas",
    iconName: "face-smile",
    icon: [
        512,
        512,
        [
            128578,
            "smile"
        ],
        "f118",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$c632b2334f0913bc = $5c8203742f0e3062$export$b5023c446f10324;
var $5c8203742f0e3062$export$b6314cdc01bb5c43 = {
    prefix: "fas",
    iconName: "thumbtack",
    icon: [
        384,
        512,
        [
            128204,
            128392,
            "thumb-tack"
        ],
        "f08d",
        "M32 32C32 14.3 46.3 0 64 0H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H290.5l11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3H32c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64H64C46.3 64 32 49.7 32 32zM160 384h64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"
    ]
};
var $5c8203742f0e3062$export$b63d0c7b519a9aae = $5c8203742f0e3062$export$b6314cdc01bb5c43;
var $5c8203742f0e3062$export$29c432d69ccf85a5 = {
    prefix: "fas",
    iconName: "trophy",
    icon: [
        576,
        512,
        [
            127942
        ],
        "f091",
        "M400 0H176c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8H24C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H357.9C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24H446.4c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112h84.4c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6h84.4c-5.1 66.3-31.1 111.2-63 142.3z"
    ]
};
var $5c8203742f0e3062$export$8ecd436ef91fc02e = {
    prefix: "fas",
    iconName: "person-praying",
    icon: [
        448,
        512,
        [
            128720,
            "pray"
        ],
        "f683",
        "M352 64A64 64 0 1 0 224 64a64 64 0 1 0 128 0zM232.7 264l22.9 31.5c6.5 8.9 16.3 14.7 27.2 16.1s21.9-1.7 30.4-8.7l88-72c17.1-14 19.6-39.2 5.6-56.3s-39.2-19.6-56.3-5.6l-55.2 45.2-26.2-36C253.6 156.7 228.6 144 202 144c-30.9 0-59.2 17.1-73.6 44.4L79.8 280.9c-20.2 38.5-9.4 85.9 25.6 111.8L158.6 432H72c-22.1 0-40 17.9-40 40s17.9 40 40 40H280c17.3 0 32.6-11.1 38-27.5s-.3-34.4-14.2-44.7L187.7 354l45-90z"
    ]
};
var $5c8203742f0e3062$export$3b32c982141cad51 = $5c8203742f0e3062$export$8ecd436ef91fc02e;
var $5c8203742f0e3062$export$6310f315e1ebbca5 = {
    prefix: "fas",
    iconName: "hammer",
    icon: [
        576,
        512,
        [
            128296
        ],
        "f6e3",
        "M413.5 237.5c-28.2 4.8-58.2-3.6-80-25.4l-38.1-38.1C280.4 159 272 138.8 272 117.6V105.5L192.3 62c-5.3-2.9-8.6-8.6-8.3-14.7s3.9-11.5 9.5-14l47.2-21C259.1 4.2 279 0 299.2 0h18.1c36.7 0 72 14 98.7 39.1l44.6 42c24.2 22.8 33.2 55.7 26.6 86L503 183l8-8c9.4-9.4 24.6-9.4 33.9 0l24 24c9.4 9.4 9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-24-24c-9.4-9.4-9.4-24.6 0-33.9l8-8-17.5-17.5zM27.4 377.1L260.9 182.6c3.5 4.9 7.5 9.6 11.8 14l38.1 38.1c6 6 12.4 11.2 19.2 15.7L134.9 484.6c-14.5 17.4-36 27.4-58.6 27.4C34.1 512 0 477.8 0 435.7c0-22.6 10.1-44.1 27.4-58.6z"
    ]
};
var $5c8203742f0e3062$export$e49e3cfceea441cc = {
    prefix: "fas",
    iconName: "hand-peace",
    icon: [
        512,
        512,
        [
            9996
        ],
        "f25b",
        "M224 0c17.7 0 32 14.3 32 32V240H192V32c0-17.7 14.3-32 32-32zm96 160c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zM93.3 51.2L175.9 240H106.1L34.7 76.8C27.6 60.6 35 41.8 51.2 34.7s35.1 .3 42.1 16.5zm27 221.3l-.2-.5h69.9H216c22.1 0 40 17.9 40 40s-17.9 40-40 40H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H226.3c-42.4 0-83.1-16.9-113.1-46.9l-11.6-11.6C77.5 429.5 64 396.9 64 363V336c0-32.7 24.6-59.7 56.3-63.5z"
    ]
};
var $5c8203742f0e3062$export$decde496a29c5b23 = {
    prefix: "fas",
    iconName: "rotate",
    icon: [
        512,
        512,
        [
            128260,
            "sync-alt"
        ],
        "f2f1",
        "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"
    ]
};
var $5c8203742f0e3062$export$2ff2056be8c281e4 = $5c8203742f0e3062$export$decde496a29c5b23;
var $5c8203742f0e3062$export$1025ad641edb49c2 = {
    prefix: "fas",
    iconName: "spinner",
    icon: [
        512,
        512,
        [],
        "f110",
        "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
    ]
};
var $5c8203742f0e3062$export$30a5bb4ad3fa716c = {
    prefix: "fas",
    iconName: "robot",
    icon: [
        640,
        512,
        [
            129302
        ],
        "f544",
        "M320 0c17.7 0 32 14.3 32 32V96H472c39.8 0 72 32.2 72 72V440c0 39.8-32.2 72-72 72H168c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72H288V32c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H400zM264 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm152 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM48 224H64V416H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V224h16z"
    ]
};
var $5c8203742f0e3062$export$8614cb1326eacd7a = {
    prefix: "fas",
    iconName: "peace",
    icon: [
        512,
        512,
        [
            9774
        ],
        "f67c",
        "M224 445.3V323.5l-94.3 77.1c26.1 22.8 58.5 38.7 94.3 44.7zM89.2 351.1L224 240.8V66.7C133.2 81.9 64 160.9 64 256c0 34.6 9.2 67.1 25.2 95.1zm293.1 49.5L288 323.5V445.3c35.7-6 68.1-21.9 94.3-44.7zm40.6-49.5c16-28 25.2-60.5 25.2-95.1c0-95.1-69.2-174.1-160-189.3V240.8L422.8 351.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var $5c8203742f0e3062$export$4aac79b9ae3cfdb8 = {
    prefix: "fas",
    iconName: "gears",
    icon: [
        640,
        512,
        [
            "cogs"
        ],
        "f085",
        "M308.5 135.3c7.1-6.3 9.9-16.2 6.2-25c-2.3-5.3-4.8-10.5-7.6-15.5L304 89.4c-3-5-6.3-9.9-9.8-14.6c-5.7-7.6-15.7-10.1-24.7-7.1l-28.2 9.3c-10.7-8.8-23-16-36.2-20.9L199 27.1c-1.9-9.3-9.1-16.7-18.5-17.8C173.9 8.4 167.2 8 160.4 8h-.7c-6.8 0-13.5 .4-20.1 1.2c-9.4 1.1-16.6 8.6-18.5 17.8L115 56.1c-13.3 5-25.5 12.1-36.2 20.9L50.5 67.8c-9-3-19-.5-24.7 7.1c-3.5 4.7-6.8 9.6-9.9 14.6l-3 5.3c-2.8 5-5.3 10.2-7.6 15.6c-3.7 8.7-.9 18.6 6.2 25l22.2 19.8C32.6 161.9 32 168.9 32 176s.6 14.1 1.7 20.9L11.5 216.7c-7.1 6.3-9.9 16.2-6.2 25c2.3 5.3 4.8 10.5 7.6 15.6l3 5.2c3 5.1 6.3 9.9 9.9 14.6c5.7 7.6 15.7 10.1 24.7 7.1l28.2-9.3c10.7 8.8 23 16 36.2 20.9l6.1 29.1c1.9 9.3 9.1 16.7 18.5 17.8c6.7 .8 13.5 1.2 20.4 1.2s13.7-.4 20.4-1.2c9.4-1.1 16.6-8.6 18.5-17.8l6.1-29.1c13.3-5 25.5-12.1 36.2-20.9l28.2 9.3c9 3 19 .5 24.7-7.1c3.5-4.7 6.8-9.5 9.8-14.6l3.1-5.4c2.8-5 5.3-10.2 7.6-15.5c3.7-8.7 .9-18.6-6.2-25l-22.2-19.8c1.1-6.8 1.7-13.8 1.7-20.9s-.6-14.1-1.7-20.9l22.2-19.8zM112 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM504.7 500.5c6.3 7.1 16.2 9.9 25 6.2c5.3-2.3 10.5-4.8 15.5-7.6l5.4-3.1c5-3 9.9-6.3 14.6-9.8c7.6-5.7 10.1-15.7 7.1-24.7l-9.3-28.2c8.8-10.7 16-23 20.9-36.2l29.1-6.1c9.3-1.9 16.7-9.1 17.8-18.5c.8-6.7 1.2-13.5 1.2-20.4s-.4-13.7-1.2-20.4c-1.1-9.4-8.6-16.6-17.8-18.5L583.9 307c-5-13.3-12.1-25.5-20.9-36.2l9.3-28.2c3-9 .5-19-7.1-24.7c-4.7-3.5-9.6-6.8-14.6-9.9l-5.3-3c-5-2.8-10.2-5.3-15.6-7.6c-8.7-3.7-18.6-.9-25 6.2l-19.8 22.2c-6.8-1.1-13.8-1.7-20.9-1.7s-14.1 .6-20.9 1.7l-19.8-22.2c-6.3-7.1-16.2-9.9-25-6.2c-5.3 2.3-10.5 4.8-15.6 7.6l-5.2 3c-5.1 3-9.9 6.3-14.6 9.9c-7.6 5.7-10.1 15.7-7.1 24.7l9.3 28.2c-8.8 10.7-16 23-20.9 36.2L315.1 313c-9.3 1.9-16.7 9.1-17.8 18.5c-.8 6.7-1.2 13.5-1.2 20.4s.4 13.7 1.2 20.4c1.1 9.4 8.6 16.6 17.8 18.5l29.1 6.1c5 13.3 12.1 25.5 20.9 36.2l-9.3 28.2c-3 9-.5 19 7.1 24.7c4.7 3.5 9.5 6.8 14.6 9.8l5.4 3.1c5 2.8 10.2 5.3 15.5 7.6c8.7 3.7 18.6 .9 25-6.2l19.8-22.2c6.8 1.1 13.8 1.7 20.9 1.7s14.1-.6 20.9-1.7l19.8 22.2zM464 304a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $5c8203742f0e3062$export$af1575770afc9559 = $5c8203742f0e3062$export$4aac79b9ae3cfdb8;
var $5c8203742f0e3062$export$e3a174a50618c208 = {
    prefix: "fas",
    iconName: "warehouse",
    icon: [
        640,
        512,
        [],
        "f494",
        "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24H568c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32V488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm488 24l-336 0c-13.3 0-24-10.7-24-24V432H512l0 56c0 13.3-10.7 24-24 24zM128 400V336H512v64H128zm0-96V224H512l0 80H128z"
    ]
};
var $5c8203742f0e3062$export$bc804c6ab898f610 = {
    prefix: "fas",
    iconName: "arrow-up-right-dots",
    icon: [
        576,
        512,
        [],
        "e4b7",
        "M160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V160c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H160zM576 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM448 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm128 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM576 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $5c8203742f0e3062$export$d6f21e17ea797702 = {
    prefix: "fas",
    iconName: "splotch",
    icon: [
        512,
        512,
        [],
        "f5bc",
        "M208.5 62.3l28.1-36.9C248.8 9.4 267.8 0 288 0c28.5 0 53.6 18.7 61.8 46l17.8 59.4c10.3 34.4 36.1 62 69.8 74.6l39.8 14.9c20.9 7.9 34.8 27.9 34.8 50.2c0 16.9-7.9 32.8-21.5 42.9l-67.3 50.5c-24.3 18.2-37.2 47.9-33.8 78.1l2.5 22.7c4.3 38.7-26 72.6-65 72.6c-14.8 0-29.3-5.1-40.8-14.3l-55.4-44.3c-4.5-3.6-9.3-6.7-14.5-9.2c-15.8-7.9-33.7-10.4-51-7.3L82.4 451.9C47.8 458.2 16 431.6 16 396.5c0-13.2 4.7-26 13.1-36.2l11.2-13.4c14.6-17.4 22.6-39.4 22.6-62.1c0-18.8-5.5-37.2-15.8-53L8.8 173.5C3.1 164.7 0 154.4 0 143.9c0-33.4 30.1-58.8 63-53.2l51.3 8.7c35.9 6.1 72.2-8.2 94.2-37.1z"
    ]
};
var $5c8203742f0e3062$export$fbb22081b65e4f33 = {
    prefix: "fas",
    iconName: "face-grin-hearts",
    icon: [
        512,
        512,
        [
            128525,
            "grin-hearts"
        ],
        "f584",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM199.3 129.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm154.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"
    ]
};
var $5c8203742f0e3062$export$c56cf0e0c3bc5ed2 = $5c8203742f0e3062$export$fbb22081b65e4f33;
var $5c8203742f0e3062$export$2df6451abf70a6ff = {
    prefix: "fas",
    iconName: "dice-four",
    icon: [
        448,
        512,
        [
            9859
        ],
        "f524",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$3bee83bf278fddbe = {
    prefix: "fas",
    iconName: "sim-card",
    icon: [
        384,
        512,
        [],
        "f7c4",
        "M64 0H242.7c17 0 33.3 6.7 45.3 18.7L365.3 96c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM96 192c-17.7 0-32 14.3-32 32v32h64V192H96zM64 352h80 96 80V288H240 144 64v64zM320 224c0-17.7-14.3-32-32-32H256v64h64V224zM160 192v64h64V192H160zM288 448c17.7 0 32-14.3 32-32V384H256v64h32zM160 384v64h64V384H160zM64 416c0 17.7 14.3 32 32 32h32V384H64v32z"
    ]
};
var $5c8203742f0e3062$export$7e3f1701aa95ef01 = {
    prefix: "fas",
    iconName: "transgender",
    icon: [
        512,
        512,
        [
            9895,
            "transgender-alt"
        ],
        "f225",
        "M112 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-31 31L112 78.1l7-7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7 15.2 15.2C187.7 107.6 220.5 96 256 96s68.3 11.6 94.9 31.2l68.8-68.8-31-31c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h96c8.8 0 16 7.2 16 16v96c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-31-31-68.8 68.8C404.4 187.7 416 220.5 416 256c0 80.2-59 146.6-136 158.2V432h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V414.2C155 402.6 96 336.2 96 256c0-35.5 11.6-68.3 31.2-94.9L112 145.9l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l7-7L58.3 92.3l-31 31c-4.6 4.6-11.5 5.9-17.4 3.5S0 118.5 0 112V16C0 7.2 7.2 0 16 0h96zM352 256a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"
    ]
};
var $5c8203742f0e3062$export$9c36cf9334c052f = $5c8203742f0e3062$export$7e3f1701aa95ef01;
var $5c8203742f0e3062$export$e134ecd00b622a47 = {
    prefix: "fas",
    iconName: "mercury",
    icon: [
        384,
        512,
        [
            9791
        ],
        "f223",
        "M72.1 7C85.8-4 106-1.8 117 12c17.6 22 44.7 36 75 36s57.3-14 75-36c11.1-13.8 31.2-16 45-5s16 31.2 5 45c-7.8 9.7-16.6 18.4-26.4 26.1C337.3 109.7 368 163.3 368 224c0 89.1-66.2 162.7-152 174.4V424h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V472H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V398.4C82.2 386.7 16 313.1 16 224c0-60.7 30.7-114.3 77.5-145.9C83.7 70.5 74.9 61.7 67.1 52c-11.1-13.8-8.8-33.9 5-45zM80 224a112 112 0 1 0 224 0A112 112 0 1 0 80 224z"
    ]
};
var $5c8203742f0e3062$export$fd4d6cfd52703f50 = {
    prefix: "fas",
    iconName: "arrow-turn-down",
    icon: [
        384,
        512,
        [
            "level-down"
        ],
        "f149",
        "M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z"
    ]
};
var $5c8203742f0e3062$export$3794c07e7a666c94 = $5c8203742f0e3062$export$fd4d6cfd52703f50;
var $5c8203742f0e3062$export$a75569baaf4a6c3a = {
    prefix: "fas",
    iconName: "person-falling-burst",
    icon: [
        640,
        512,
        [],
        "e547",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 9.8c0 39-23.7 74-59.9 88.4C71.6 154.5 32 213 32 278.2V352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-73.8c0-10 1.6-19.8 4.5-29L261.1 497.4c9.6 14.8 29.4 19.1 44.3 9.5s19.1-29.4 9.5-44.3L222.6 320H224l80 0 38.4 51.2c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-43.2-57.6C341.3 263.1 327.1 256 312 256l-71.5 0-56.8-80.2-.2-.3c44.7-29 72.5-79 72.5-133.6l0-9.8zM96 80A48 48 0 1 0 0 80a48 48 0 1 0 96 0zM464 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 78.7-12.2c6.5-1 11.7-5.9 13.1-12.2s-1.1-13-6.5-16.7l-65.6-45.1L603 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L508.3 92.1l-29.4-74C476.4 12 470.6 8 464 8s-12.4 4-14.9 10.1l-29.4 74L343.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1-65.6 45.1c-5.4 3.7-8 10.3-6.5 16.7c.1 .3 .1 .6 .2 .8l19.4 0c20.1 0 39.2 7.5 53.8 20.8l18.4 2.9L383 265.3l36.2 48.3c2.1 2.8 3.9 5.7 5.5 8.6L464 286.1z"
    ]
};
var $5c8203742f0e3062$export$f8db2747dadd48f7 = {
    prefix: "fas",
    iconName: "award",
    icon: [
        384,
        512,
        [],
        "f559",
        "M173.8 5.5c11-7.3 25.4-7.3 36.4 0L228 17.2c6 3.9 13 5.8 20.1 5.4l21.3-1.3c13.2-.8 25.6 6.4 31.5 18.2l9.6 19.1c3.2 6.4 8.4 11.5 14.7 14.7L344.5 83c11.8 5.9 19 18.3 18.2 31.5l-1.3 21.3c-.4 7.1 1.5 14.2 5.4 20.1l11.8 17.8c7.3 11 7.3 25.4 0 36.4L366.8 228c-3.9 6-5.8 13-5.4 20.1l1.3 21.3c.8 13.2-6.4 25.6-18.2 31.5l-19.1 9.6c-6.4 3.2-11.5 8.4-14.7 14.7L301 344.5c-5.9 11.8-18.3 19-31.5 18.2l-21.3-1.3c-7.1-.4-14.2 1.5-20.1 5.4l-17.8 11.8c-11 7.3-25.4 7.3-36.4 0L156 366.8c-6-3.9-13-5.8-20.1-5.4l-21.3 1.3c-13.2 .8-25.6-6.4-31.5-18.2l-9.6-19.1c-3.2-6.4-8.4-11.5-14.7-14.7L39.5 301c-11.8-5.9-19-18.3-18.2-31.5l1.3-21.3c.4-7.1-1.5-14.2-5.4-20.1L5.5 210.2c-7.3-11-7.3-25.4 0-36.4L17.2 156c3.9-6 5.8-13 5.4-20.1l-1.3-21.3c-.8-13.2 6.4-25.6 18.2-31.5l19.1-9.6C65 70.2 70.2 65 73.4 58.6L83 39.5c5.9-11.8 18.3-19 31.5-18.2l21.3 1.3c7.1 .4 14.2-1.5 20.1-5.4L173.8 5.5zM272 192a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM1.3 441.8L44.4 339.3c.2 .1 .3 .2 .4 .4l9.6 19.1c11.7 23.2 36 37.3 62 35.8l21.3-1.3c.2 0 .5 0 .7 .2l17.8 11.8c5.1 3.3 10.5 5.9 16.1 7.7l-37.6 89.3c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L211.7 413c5.6-1.8 11-4.3 16.1-7.7l17.8-11.8c.2-.1 .4-.2 .7-.2l21.3 1.3c26 1.5 50.3-12.6 62-35.8l9.6-19.1c.1-.2 .2-.3 .4-.4l43.2 102.5c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"
    ]
};
var $5c8203742f0e3062$export$68ddda3b30ba09f0 = {
    prefix: "fas",
    iconName: "ticket-simple",
    icon: [
        576,
        512,
        [
            "ticket-alt"
        ],
        "f3ff",
        "M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v64c0 8.8-7.4 15.7-15.7 18.6C541.5 217.1 528 235 528 256s13.5 38.9 32.3 45.4c8.3 2.9 15.7 9.8 15.7 18.6v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320c0-8.8 7.4-15.7 15.7-18.6C34.5 294.9 48 277 48 256s-13.5-38.9-32.3-45.4C7.4 207.7 0 200.8 0 192V128z"
    ]
};
var $5c8203742f0e3062$export$75e38ba471fd89c4 = $5c8203742f0e3062$export$68ddda3b30ba09f0;
var $5c8203742f0e3062$export$f26673f8b10c3d46 = {
    prefix: "fas",
    iconName: "building",
    icon: [
        384,
        512,
        [
            127970,
            61687
        ],
        "f1ad",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$2ebd565813951f81 = {
    prefix: "fas",
    iconName: "angles-left",
    icon: [
        512,
        512,
        [
            171,
            "angle-double-left"
        ],
        "f100",
        "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"
    ]
};
var $5c8203742f0e3062$export$21b0833b3cf929a7 = $5c8203742f0e3062$export$2ebd565813951f81;
var $5c8203742f0e3062$export$fc19ca0fe15e73bc = {
    prefix: "fas",
    iconName: "qrcode",
    icon: [
        448,
        512,
        [],
        "f029",
        "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM64 96v64h64V96H64zM0 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336zm64 16v64h64V352H64zM304 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm80 64H320v64h64V96zM256 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V304zM368 480a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"
    ]
};
var $5c8203742f0e3062$export$29be1665d1b36a3b = {
    prefix: "fas",
    iconName: "clock-rotate-left",
    icon: [
        512,
        512,
        [
            "history"
        ],
        "f1da",
        "M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"
    ]
};
var $5c8203742f0e3062$export$76d1986559ca7b7a = $5c8203742f0e3062$export$29be1665d1b36a3b;
var $5c8203742f0e3062$export$2ff38f330c834084 = {
    prefix: "fas",
    iconName: "face-grin-beam-sweat",
    icon: [
        512,
        512,
        [
            128517,
            "grin-beam-sweat"
        ],
        "f583",
        "M476.8 126.3c-4.1 1.1-8.4 1.7-12.8 1.7c-26.5 0-48-21-48-47c0-5 1.8-11.3 4.6-18.1c.3-.7 .6-1.4 .9-2.1c9-20.2 26.5-44.9 36-57.5c3.2-4.4 9.6-4.4 12.8 0C483.4 20.6 512 61 512 81c0 21.7-14.9 39.8-35.2 45.3zM256 0c51.4 0 99.3 15.2 139.4 41.2c-1.5 3.1-3 6.2-4.3 9.3c-3.4 8-7.1 19-7.1 30.5c0 44.3 36.6 79 80 79c9.6 0 18.8-1.7 27.4-4.8c13.3 30.9 20.6 65 20.6 100.8c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0zM388.1 312.8c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5c5-11.8-7-22.5-19.3-18.7zm-170.5-84l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"
    ]
};
var $5c8203742f0e3062$export$14d0ccc54c5b6826 = $5c8203742f0e3062$export$2ff38f330c834084;
var $5c8203742f0e3062$export$364f19abcfac1b0a = {
    prefix: "fas",
    iconName: "file-export",
    icon: [
        576,
        512,
        [
            "arrow-right-from-file"
        ],
        "f56e",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V288H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM384 336V288H494.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H384zm0-208H256V0L384 128z"
    ]
};
var $5c8203742f0e3062$export$b9c76255b38e1df1 = $5c8203742f0e3062$export$364f19abcfac1b0a;
var $5c8203742f0e3062$export$8241bd5b9163ca12 = {
    prefix: "fas",
    iconName: "shield",
    icon: [
        512,
        512,
        [
            128737,
            "shield-blank"
        ],
        "f132",
        "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z"
    ]
};
var $5c8203742f0e3062$export$64f54da8fbaba8ee = $5c8203742f0e3062$export$8241bd5b9163ca12;
var $5c8203742f0e3062$export$be9d5060a4bc3b4b = {
    prefix: "fas",
    iconName: "arrow-up-short-wide",
    icon: [
        576,
        512,
        [
            "sort-amount-up-alt"
        ],
        "f885",
        "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"
    ]
};
var $5c8203742f0e3062$export$6e87844b0f151b6a = $5c8203742f0e3062$export$be9d5060a4bc3b4b;
var $5c8203742f0e3062$export$2d077da983246a68 = {
    prefix: "fas",
    iconName: "house-medical",
    icon: [
        576,
        512,
        [],
        "e3b2",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
    ]
};
var $5c8203742f0e3062$export$14c9f1d85e53ae99 = {
    prefix: "fas",
    iconName: "golf-ball-tee",
    icon: [
        384,
        512,
        [
            "golf-ball"
        ],
        "f450",
        "M384 192c0 66.8-34.1 125.6-85.8 160H85.8C34.1 317.6 0 258.8 0 192C0 86 86 0 192 0S384 86 384 192zM242.1 256.6c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zm-52.3-49.3c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4c0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zM96 416c0-17.7 14.3-32 32-32h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H240c-8.8 0-16 7.2-16 16v16c0 17.7-14.3 32-32 32s-32-14.3-32-32V464c0-8.8-7.2-16-16-16H128c-17.7 0-32-14.3-32-32z"
    ]
};
var $5c8203742f0e3062$export$2251487a9a33c682 = $5c8203742f0e3062$export$14c9f1d85e53ae99;
var $5c8203742f0e3062$export$f2b13ad44c03c40f = {
    prefix: "fas",
    iconName: "circle-chevron-left",
    icon: [
        512,
        512,
        [
            "chevron-circle-left"
        ],
        "f137",
        "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135z"
    ]
};
var $5c8203742f0e3062$export$4a42c8c2451a33fd = $5c8203742f0e3062$export$f2b13ad44c03c40f;
var $5c8203742f0e3062$export$792391babe46862d = {
    prefix: "fas",
    iconName: "house-chimney-window",
    icon: [
        576,
        512,
        [],
        "e00d",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM248 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H248z"
    ]
};
var $5c8203742f0e3062$export$a82594dcc75a49f5 = {
    prefix: "fas",
    iconName: "pen-nib",
    icon: [
        512,
        512,
        [
            10001
        ],
        "f5ad",
        "M368.4 18.3L312.7 74.1 437.9 199.3l55.7-55.7c21.9-21.9 21.9-57.3 0-79.2L447.6 18.3c-21.9-21.9-57.3-21.9-79.2 0zM288 94.6l-9.2 2.8L134.7 140.6c-19.9 6-35.7 21.2-42.3 41L3.8 445.8c-3.8 11.3-1 23.9 7.3 32.4L164.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L33.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c19.7-6.6 35-22.4 41-42.3l43.2-144.1 2.8-9.2L288 94.6z"
    ]
};
var $5c8203742f0e3062$export$89af87b7d6c15adf = {
    prefix: "fas",
    iconName: "tent-arrow-turn-left",
    icon: [
        576,
        512,
        [],
        "e580",
        "M120.1 41.8c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120 456 120c39.8 0 72 32.2 72 72v40c0 13.3 10.7 24 24 24s24-10.7 24-24V192c0-66.3-53.7-120-120-120L86.5 72l33.5-30.2zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H240h16c17.7 0 32-14.3 32-32V361.9c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7H464h16c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $5c8203742f0e3062$export$c93b950e845a4ee7 = {
    prefix: "fas",
    iconName: "tents",
    icon: [
        640,
        512,
        [],
        "e582",
        "M396.6 6.5L235.8 129.1c9.6 1.8 18.9 5.8 27 12l168 128c13.2 10.1 22 24.9 24.5 41.4l6.2 41.5H608c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128c-11.5-8.7-27.3-8.7-38.8 0zm-153.2 160c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S22.7 512 32 512H176h16c17.7 0 32-14.3 32-32V361.9c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7H400h16c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $5c8203742f0e3062$export$8282f5f5dcf6b009 = {
    prefix: "fas",
    iconName: "wand-magic",
    icon: [
        512,
        512,
        [
            "magic"
        ],
        "f0d0",
        "M14.1 463.3c-18.7-18.7-18.7-49.1 0-67.9L395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0L14.1 463.3zM347.6 187.6l105-105L429.4 59.3l-105 105 23.3 23.3z"
    ]
};
var $5c8203742f0e3062$export$e58f9b502d4dd52d = $5c8203742f0e3062$export$8282f5f5dcf6b009;
var $5c8203742f0e3062$export$c6406747800cf702 = {
    prefix: "fas",
    iconName: "dog",
    icon: [
        576,
        512,
        [
            128021
        ],
        "f6d3",
        "M309.6 158.5L332.7 19.8C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32h52.1c12.7 0 24.9 5.1 33.9 14.1L496 64h56c13.3 0 24 10.7 24 24v24c0 44.2-35.8 80-80 80H464 448 426.7l-5.1 30.5-112-64zM416 256.1L416 480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V364.8c-24 12.3-51.2 19.2-80 19.2s-56-6.9-80-19.2V480c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V249.8c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192h30 16H303.8L416 256.1zM464 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $5c8203742f0e3062$export$28e93ec9f5e2ddf3 = {
    prefix: "fas",
    iconName: "carrot",
    icon: [
        512,
        512,
        [
            129365
        ],
        "f787",
        "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6zM244.6 136c-40 0-77.1 18.1-101.7 48.2l60.5 60.5c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-55.3-55.3 0 .1L2.2 477.9C-2 487-.1 497.8 7 505s17.9 9 27.1 4.8l134.7-62.4-52.1-52.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L199.7 433l100.2-46.4c46.4-21.5 76.2-68 76.2-119.2C376 194.8 317.2 136 244.6 136z"
    ]
};
var $5c8203742f0e3062$export$c4c2f69a53bab720 = {
    prefix: "fas",
    iconName: "moon",
    icon: [
        384,
        512,
        [
            127769,
            9214
        ],
        "f186",
        "M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"
    ]
};
var $5c8203742f0e3062$export$b86d7336e68a3f57 = {
    prefix: "fas",
    iconName: "wine-glass-empty",
    icon: [
        320,
        512,
        [
            "wine-glass-alt"
        ],
        "f5ce",
        "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h80 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V348.4c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0H64zM81.9 203.1L93.4 64H226.6l11.6 139.1C242 248.8 205.9 288 160 288s-82-39.2-78.1-84.9z"
    ]
};
var $5c8203742f0e3062$export$b8ff3fe2b78aef2f = $5c8203742f0e3062$export$b86d7336e68a3f57;
var $5c8203742f0e3062$export$549b99473b7201e6 = {
    prefix: "fas",
    iconName: "cheese",
    icon: [
        512,
        512,
        [],
        "f7ef",
        "M512 240.2V256H0c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7C418.8 32 512 125.2 512 240.2zm0 47.8V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288H512z"
    ]
};
var $5c8203742f0e3062$export$6ec1acbf3f610b8f = {
    prefix: "fas",
    iconName: "yin-yang",
    icon: [
        512,
        512,
        [
            9775
        ],
        "f6ad",
        "M256 64c53 0 96 43 96 96s-43 96-96 96s-96 43-96 96s43 96 96 96C150 448 64 362 64 256S150 64 256 64zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $5c8203742f0e3062$export$fcb0647a5340b5b8 = {
    prefix: "fas",
    iconName: "music",
    icon: [
        512,
        512,
        [
            127925
        ],
        "f001",
        "M499.1 6.3c8.1 6 12.9 15.6 12.9 25.7v72V368c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V147L192 223.8V432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V200 128c0-14.1 9.3-26.6 22.8-30.7l320-96c9.7-2.9 20.2-1.1 28.3 5z"
    ]
};
var $5c8203742f0e3062$export$d5d870c10bc9f1ce = {
    prefix: "fas",
    iconName: "code-commit",
    icon: [
        640,
        512,
        [],
        "f386",
        "M320 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm156.8-48C462 361 397.4 416 320 416s-142-55-156.8-128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H163.2C178 151 242.6 96 320 96s142 55 156.8 128H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H476.8z"
    ]
};
var $5c8203742f0e3062$export$9e9af12b90a1abd2 = {
    prefix: "fas",
    iconName: "temperature-low",
    icon: [
        512,
        512,
        [],
        "f76b",
        "M448 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 96a96 96 0 1 1 192 0A96 96 0 1 1 320 96zM144 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C70.2 332.6 64 349.5 64 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM32 112C32 50.2 82.1 0 144 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S0 447.5 0 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM192 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $5c8203742f0e3062$export$cf152282d5de300d = {
    prefix: "fas",
    iconName: "person-biking",
    icon: [
        640,
        512,
        [
            128692,
            "biking"
        ],
        "f84a",
        "M400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm27.2 64l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1V416c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H427.2zM56 384a72 72 0 1 1 144 0A72 72 0 1 1 56 384zm200 0A128 128 0 1 0 0 384a128 128 0 1 0 256 0zm184 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm200 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
    ]
};
var $5c8203742f0e3062$export$a5bcf835dbf9c0b = $5c8203742f0e3062$export$cf152282d5de300d;
var $5c8203742f0e3062$export$2a533051418ff4ca = {
    prefix: "fas",
    iconName: "broom",
    icon: [
        576,
        512,
        [
            129529
        ],
        "f51a",
        "M566.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192-34.7-34.7c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6v29.1L364.3 320h29.1c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-34.7-34.7 192-192zM341.1 353.4L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3l-8 8C76.5 307.5 64 337.7 64 369.2c0 6.8 7.1 11.2 13.2 8.2l51.1-25.5c5-2.5 9.5 4.1 5.4 7.9L7.3 473.4C2.7 477.6 0 483.6 0 489.9C0 502.1 9.9 512 22.1 512l173.3 0c38.8 0 75.9-15.4 103.4-42.8c30.6-30.6 45.9-73.1 42.3-115.8z"
    ]
};
var $5c8203742f0e3062$export$7b96388ca2be471b = {
    prefix: "fas",
    iconName: "shield-heart",
    icon: [
        512,
        512,
        [],
        "e574",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM144 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"
    ]
};
var $5c8203742f0e3062$export$31f89d8ac1d14ed6 = {
    prefix: "fas",
    iconName: "gopuram",
    icon: [
        512,
        512,
        [],
        "f664",
        "M120 0c13.3 0 24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h48V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8V64v64c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H416V352H384V224H352V128H320v96h32V352h32V512H304V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H128V352h32V224h32V128H160v96H128V352H96V512H32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32V256c0-17.7 14.3-32 32-32V160c0-17.7 14.3-32 32-32V64 32 24c0-13.3 10.7-24 24-24zM256 272c-17.7 0-32 14.3-32 32v48h64V304c0-17.7-14.3-32-32-32zm-32-80v32h64V192c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $5c8203742f0e3062$export$bd931e906edf2f47 = {
    prefix: "fas",
    iconName: "earth-oceania",
    icon: [
        512,
        512,
        [
            "globe-oceania"
        ],
        "e47b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208.6 357.3l-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1c7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4c4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2L311 299.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26L299 367.2c-8.3 10.6-21 16.8-34.4 16.8c-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8L296 164.7c10.1 10.1 2.9 27.3-11.3 27.3H254.8c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9zM248 432c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H264c-8.8 0-16-7.2-16-16zM431.2 298.9l8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1zm-19.9 80.4l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $5c8203742f0e3062$export$8ac3f5271448657d = $5c8203742f0e3062$export$bd931e906edf2f47;
var $5c8203742f0e3062$export$5a17e58bb7afb1d7 = {
    prefix: "fas",
    iconName: "square-xmark",
    icon: [
        448,
        512,
        [
            10062,
            "times-square",
            "xmark-square"
        ],
        "f2d3",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm79 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $5c8203742f0e3062$export$c0248ac97142ea2a = $5c8203742f0e3062$export$5a17e58bb7afb1d7;
var $5c8203742f0e3062$export$9a364781d6b7602b = $5c8203742f0e3062$export$5a17e58bb7afb1d7;
var $5c8203742f0e3062$export$c92c903bade56844 = {
    prefix: "fas",
    iconName: "hashtag",
    icon: [
        448,
        512,
        [
            62098
        ],
        "23",
        "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H347.1L325.8 320H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H315.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7H155.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320h95.1l21.3-128H187.1z"
    ]
};
var $5c8203742f0e3062$export$95457ede07b81517 = {
    prefix: "fas",
    iconName: "up-right-and-down-left-from-center",
    icon: [
        512,
        512,
        [
            "expand-alt"
        ],
        "f424",
        "M344 0H488c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512H24c-13.3 0-24-10.7-24-24V344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"
    ]
};
var $5c8203742f0e3062$export$bcb8d86a3a1d6eb6 = $5c8203742f0e3062$export$95457ede07b81517;
var $5c8203742f0e3062$export$2599126c3a57f727 = {
    prefix: "fas",
    iconName: "oil-can",
    icon: [
        640,
        512,
        [],
        "f613",
        "M320 128c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32H144 96 48c-26.5 0-48 21.5-48 48v64.8c0 19 11.2 36.2 28.5 43.9l67.5 30V368c0 26.5 21.5 48 48 48H403.1c18.4 0 35.8-7.9 48-21.7L633.5 187.7c12.3-13.9-.3-35.4-18.4-31.5L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8H288V128h32zM96 208v86.1L48 272.8V208H96z"
    ]
};
var $5c8203742f0e3062$export$6e625d2e7790c860 = {
    prefix: "fas",
    iconName: "t",
    icon: [
        384,
        512,
        [
            116
        ],
        "54",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H160V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H192 32z"
    ]
};
var $5c8203742f0e3062$export$d4c909619093de2d = {
    prefix: "fas",
    iconName: "hippo",
    icon: [
        640,
        512,
        [
            129435
        ],
        "f6ed",
        "M407 47c9.4-9.4 24.6-9.4 33.9 0l17.2 17.2c1.9-.1 3.9-.2 5.8-.2h32c11.2 0 21.9 2.3 31.6 6.5L543 55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L564 101.9c7.6 12.2 12 26.7 12 42.1c0 10.2 7.4 18.8 16.7 23c27.9 12.5 47.3 40.5 47.3 73c0 26.2-12.6 49.4-32 64v32c0 8.8-7.2 16-16 16H560c-8.8 0-16-7.2-16-16V320H480v16c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V318.4c-11.8-2.4-22.7-7.4-32-14.4c-1.5-1.1-2.9-2.3-4.3-3.5c-17-14.7-27.7-36.4-27.7-60.5c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 44.7 26.2 83.2 64 101.2V352c0 17.7 14.3 32 32 32h32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V372c-19.8 7.7-41.4 12-64 12s-44.2-4.3-64-12v76c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V329.1L45.9 369.7c-5.4 12.1-19.6 17.6-31.7 12.2S-3.3 362.4 2.1 350.3L24 300.9c5.3-11.9 8-24.7 8-37.7C32 155.7 117.2 68 223.8 64.1l.2-.1h7.2H256h32c41.7 0 83.4 12.1 117.2 25.7c1.7-1.8 3.5-3.6 5.3-5.2L407 81c-9.4-9.4-9.4-24.6 0-33.9zm73 185a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM480 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $5c8203742f0e3062$export$d01ddcc9efe7b149 = {
    prefix: "fas",
    iconName: "chart-column",
    icon: [
        512,
        512,
        [],
        "e0e3",
        "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm128-64V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM480 96V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $5c8203742f0e3062$export$a590003279d671b8 = {
    prefix: "fas",
    iconName: "infinity",
    icon: [
        640,
        512,
        [
            8734,
            9854
        ],
        "f534",
        "M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5L320 210.7l72.2-72.2C419.5 111.3 456.4 96 494.9 96C575 96 640 161 640 241.1v29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2C220.5 400.7 183.6 416 145.1 416C65 416 0 351 0 270.9V241.1zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8C100.3 160 64 196.3 64 241.1v29.7c0 44.8 36.3 81.1 81.1 81.1c21.5 0 42.2-8.5 57.4-23.8L274.7 256zm90.5 0l72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8c44.8 0 81.1-36.3 81.1-81.1V241.1c0-44.8-36.3-81.1-81.1-81.1c-21.5 0-42.2 8.5-57.4 23.8L365.3 256z"
    ]
};
var $5c8203742f0e3062$export$2db4f9712313eafa = {
    prefix: "fas",
    iconName: "vial-circle-check",
    icon: [
        512,
        512,
        [],
        "e596",
        "M0 64C0 46.3 14.3 32 32 32H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V266.8c-20.2 28.6-32 63.5-32 101.2c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96V96C14.3 96 0 81.7 0 64zM96 96v96h64V96H96zM224 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L352 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $5c8203742f0e3062$export$f9a5161975928326 = {
    prefix: "fas",
    iconName: "person-arrow-down-to-line",
    icon: [
        640,
        512,
        [],
        "e538",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM464 64V306.7l-25.4-25.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L528 306.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $5c8203742f0e3062$export$4f1ce88b2b4cd5cd = {
    prefix: "fas",
    iconName: "voicemail",
    icon: [
        640,
        512,
        [],
        "f897",
        "M144 320a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm119.8 0c15.3-22.9 24.2-50.4 24.2-80c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144H496c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 29.6 8.9 57.1 24.2 80H263.8zM496 160a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var $5c8203742f0e3062$export$55145a3dae4f984a = {
    prefix: "fas",
    iconName: "fan",
    icon: [
        512,
        512,
        [],
        "f863",
        "M258.6 0c-1.7 0-3.4 .1-5.1 .5C168 17 115.6 102.3 130.5 189.3c2.9 17 8.4 32.9 15.9 47.4L32 224H29.4C13.2 224 0 237.2 0 253.4c0 1.7 .1 3.4 .5 5.1C17 344 102.3 396.4 189.3 381.5c17-2.9 32.9-8.4 47.4-15.9L224 480v2.6c0 16.2 13.2 29.4 29.4 29.4c1.7 0 3.4-.1 5.1-.5C344 495 396.4 409.7 381.5 322.7c-2.9-17-8.4-32.9-15.9-47.4L480 288h2.6c16.2 0 29.4-13.2 29.4-29.4c0-1.7-.1-3.4-.5-5.1C495 168 409.7 115.6 322.7 130.5c-17 2.9-32.9 8.4-47.4 15.9L288 32V29.4C288 13.2 274.8 0 258.6 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$1ae0a37b36ace746 = {
    prefix: "fas",
    iconName: "person-walking-luggage",
    icon: [
        576,
        512,
        [],
        "e554",
        "M432 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM347.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L505 232.7l-15.3-36.8C472.5 154.8 432.3 128 387.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L340.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM256 274.1c-7.7-4.4-17.4-1.8-21.9 5.9l-32 55.4L147.7 304c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l64-110.9c1.5-2.6 2.6-5.2 3.3-8L261.9 296c4.4-7.7 1.8-17.4-5.9-21.9z"
    ]
};
var $5c8203742f0e3062$export$e36c32dd5cba9b90 = {
    prefix: "fas",
    iconName: "up-down",
    icon: [
        256,
        512,
        [
            8597,
            11021,
            "arrows-alt-v"
        ],
        "f338",
        "M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160H80V352H24c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4H176V160h56c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"
    ]
};
var $5c8203742f0e3062$export$138cb56a3f8f7040 = $5c8203742f0e3062$export$e36c32dd5cba9b90;
var $5c8203742f0e3062$export$301c3fab0c4545bd = {
    prefix: "fas",
    iconName: "cloud-moon-rain",
    icon: [
        576,
        512,
        [],
        "f73c",
        "M481.2 0C417 0 363.5 46.5 353.7 107.6c35.4 17.6 60.2 53.3 62.1 95.1c23.2 11 42 29.7 53.1 52.7c4 .4 8.1 .6 12.3 .6c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5zM367.9 383.9c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.3 114.6 210.8 96 176 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96H367.9zM85.4 420.1c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3z"
    ]
};
var $5c8203742f0e3062$export$34f5c36a3e80efa2 = {
    prefix: "fas",
    iconName: "calendar",
    icon: [
        448,
        512,
        [
            128197,
            128198
        ],
        "f133",
        "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
    ]
};
var $5c8203742f0e3062$export$3a48b9820e92f5ab = {
    prefix: "fas",
    iconName: "trailer",
    icon: [
        640,
        512,
        [],
        "e041",
        "M48 32C21.5 32 0 53.5 0 80V336c0 26.5 21.5 48 48 48H65.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96H488h8H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V80c0-26.5-21.5-48-48-48H48zM80 96c8.8 0 16 7.2 16 16l0 131.2c-11.4 5.9-22.2 12.9-32 21V112c0-8.8 7.2-16 16-16zm96 128c-5.4 0-10.7 .2-16 .7L160 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112.7c-5.3-.5-10.6-.7-16-.7zm80 19.2L256 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 152.2c-9.8-8.1-20.6-15.2-32-21zM368 96c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16zm112 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$6d636565b3ec36b4 = {
    prefix: "fas",
    iconName: "bahai",
    icon: [
        576,
        512,
        [
            "haykal"
        ],
        "f666",
        "M288 0c14.5 0 27.2 9.7 30.9 23.8l23.9 89.6 75.9-53.3c11.9-8.3 27.8-7.6 39 1.7s14.6 24.9 8.4 38.1l-39.3 84 92.4 8c14.4 1.2 26.2 12 28.8 26.3s-4.9 28.5-18 34.6l-84.1 39.1 65.7 65.5c10.3 10.2 12.4 26.1 5.1 38.7s-22 18.7-36 14.9L391 386.8l8.2 92.4c1.3 14.4-7.3 27.9-20.9 32.9s-28.9 .1-37.2-11.7l-53.1-76-53.1 76c-8.3 11.9-23.6 16.7-37.2 11.7s-22.2-18.5-20.9-32.9l8.2-92.4L95.4 410.9c-14 3.8-28.8-2.3-36-14.9s-5.2-28.4 5.1-38.7l65.7-65.5L46 252.7c-13.1-6.1-20.5-20.3-18-34.6s14.3-25.1 28.8-26.3l92.4-8-39.3-84c-6.1-13.1-2.7-28.8 8.4-38.1s27.1-10 39-1.7l75.9 53.3 23.9-89.6C260.8 9.7 273.5 0 288 0zm0 156.2l-4.8 18c-2.7 10.1-10.2 18.2-20 21.8s-20.8 2.1-29.3-3.9l-15.2-10.7 7.9 16.8c4.4 9.5 4 20.5-1.3 29.6s-14.5 15-25 15.9l-18.5 1.6 16.8 7.8c9.5 4.4 16.2 13.2 18 23.5s-1.5 20.8-8.9 28.2l-13.2 13.1 17.9-4.8c10.1-2.7 20.9-.3 28.9 6.4s12.2 16.9 11.3 27.3l-1.6 18.5 10.6-15.2c6-8.6 15.8-13.7 26.2-13.7s20.2 5.1 26.2 13.7l10.6 15.2-1.6-18.5c-.9-10.4 3.3-20.6 11.3-27.3s18.8-9.1 28.9-6.4l17.9 4.8-13.2-13.1c-7.4-7.4-10.7-17.9-8.9-28.2s8.5-19.1 18-23.5l16.8-7.8-18.5-1.6c-10.4-.9-19.7-6.8-25-15.9s-5.7-20.1-1.3-29.6l7.9-16.8-15.2 10.7c-8.6 6-19.5 7.5-29.3 3.9s-17.3-11.7-20-21.8l-4.8-18z"
    ]
};
var $5c8203742f0e3062$export$5c15e34e0e43f15c = $5c8203742f0e3062$export$6d636565b3ec36b4;
var $5c8203742f0e3062$export$303efb6031da122 = {
    prefix: "fas",
    iconName: "sd-card",
    icon: [
        384,
        512,
        [],
        "f7c2",
        "M320 0H141.3C124.3 0 108 6.7 96 18.7L18.7 96C6.7 108 0 124.3 0 141.3V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 88v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $5c8203742f0e3062$export$ae1875ba975aa0e9 = {
    prefix: "fas",
    iconName: "dragon",
    icon: [
        640,
        512,
        [
            128009
        ],
        "f6d5",
        "M352 124.5l-51.9-13c-6.5-1.6-11.3-7.1-12-13.8s2.8-13.1 8.7-16.1l40.8-20.4L294.4 28.8c-5.5-4.1-7.8-11.3-5.6-17.9S297.1 0 304 0H416h32 16c30.2 0 58.7 14.2 76.8 38.4l57.6 76.8c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48H538.5c-17 0-33.3-6.7-45.3-18.7L480 160H448v21.5c0 24.8 12.8 47.9 33.8 61.1l106.6 66.6c32.1 20.1 51.6 55.2 51.6 93.1C640 462.9 590.9 512 530.2 512H496 432 32.3c-3.3 0-6.6-.4-9.6-1.4C13.5 507.8 6 501 2.4 492.1C1 488.7 .2 485.2 0 481.4c-.2-3.7 .3-7.3 1.3-10.7c2.8-9.2 9.6-16.7 18.6-20.4c3-1.2 6.2-2 9.5-2.2L433.3 412c8.3-.7 14.7-7.7 14.7-16.1c0-4.3-1.7-8.4-4.7-11.4l-44.4-44.4c-30-30-46.9-70.7-46.9-113.1V181.5v-57zM512 72.3c0-.1 0-.2 0-.3s0-.2 0-.3v.6zm-1.3 7.4L464.3 68.1c-.2 1.3-.3 2.6-.3 3.9c0 13.3 10.7 24 24 24c10.6 0 19.5-6.8 22.7-16.3zM130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1l130.6 87V227c0 32.8 8.4 64.8 24 93H112c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7L171 232.3 18.4 255.8c-7 1.1-13.9-2.6-16.9-9s-1.5-14.1 3.8-18.8L130.9 116.5z"
    ]
};
var $5c8203742f0e3062$export$cdbdd2118099ae07 = {
    prefix: "fas",
    iconName: "shoe-prints",
    icon: [
        640,
        512,
        [],
        "f54b",
        "M416 0C352.3 0 256 32 256 32V160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0zM128 96c0 35.3 28.7 64 64 64h32V32H192c-35.3 0-64 28.7-64 64zM288 512c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32V480s96.3 32 160 32zM0 416c0 35.3 28.7 64 64 64H96V352H64c-35.3 0-64 28.7-64 64z"
    ]
};
var $5c8203742f0e3062$export$eeda28b8ca4cb18e = {
    prefix: "fas",
    iconName: "circle-plus",
    icon: [
        512,
        512,
        [
            "plus-circle"
        ],
        "f055",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $5c8203742f0e3062$export$d9cc3a81499af48c = $5c8203742f0e3062$export$eeda28b8ca4cb18e;
var $5c8203742f0e3062$export$4272e56f2429da88 = {
    prefix: "fas",
    iconName: "face-grin-tongue-wink",
    icon: [
        512,
        512,
        [
            128540,
            "grin-tongue-wink"
        ],
        "f58b",
        "M174.5 498.8C73.1 464.7 0 368.9 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 112.9-73.1 208.7-174.5 242.8C346.7 484 352 466.6 352 448V401.1c24.3-17.5 43.6-41.6 55.4-69.6c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c11.7 27.8 30.8 51.7 54.8 69.2V448c0 18.6 5.3 36 14.5 50.8zm20.7-265.2c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM336 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM320 402.6V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V402.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6zM336 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $5c8203742f0e3062$export$58099903d50aefb3 = $5c8203742f0e3062$export$4272e56f2429da88;
var $5c8203742f0e3062$export$e6094d25274088ab = {
    prefix: "fas",
    iconName: "hand-holding",
    icon: [
        576,
        512,
        [],
        "f4bd",
        "M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .2 .5 .5 0 1 1 .9-.2z"
    ]
};
var $5c8203742f0e3062$export$d893dd9509763a17 = {
    prefix: "fas",
    iconName: "plug-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e55d",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$22965c7f4d903953 = {
    prefix: "fas",
    iconName: "link-slash",
    icon: [
        640,
        512,
        [
            "chain-broken",
            "chain-slash",
            "unlink"
        ],
        "f127",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25C430.9 239.6 420.1 175.1 377 132c-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3c20 20 27.5 48.3 21.7 74.5L239 162zM116.6 187.9L60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l61.8-61.8-50.6-39.9zM220.9 270c-2.1 39.8 12.2 80.1 42.2 110c38.9 38.9 94.4 51 143.6 36.3L220.9 270z"
    ]
};
var $5c8203742f0e3062$export$382551e04f32620a = $5c8203742f0e3062$export$22965c7f4d903953;
var $5c8203742f0e3062$export$12f09d657be59586 = $5c8203742f0e3062$export$22965c7f4d903953;
var $5c8203742f0e3062$export$2f546f7d8ba01e18 = $5c8203742f0e3062$export$22965c7f4d903953;
var $5c8203742f0e3062$export$76c1aa4bf9a39458 = {
    prefix: "fas",
    iconName: "clone",
    icon: [
        512,
        512,
        [],
        "f24d",
        "M288 448H64V224h64V160H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V384H288v64zm-64-96H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64V288c0 35.3 28.7 64 64 64z"
    ]
};
var $5c8203742f0e3062$export$5a200e8504b7367a = {
    prefix: "fas",
    iconName: "person-walking-arrow-loop-left",
    icon: [
        640,
        512,
        [],
        "e551",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zm347.7 119c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L461.3 384H480c88.4 0 160-71.6 160-160s-71.6-160-160-160L352 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c53 0 96 43 96 96s-43 96-96 96H461.3l25.4-25.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3l80 80z"
    ]
};
var $5c8203742f0e3062$export$a0a53d8e3c68e9f1 = {
    prefix: "fas",
    iconName: "arrow-up-z-a",
    icon: [
        576,
        512,
        [
            "sort-alpha-up-alt"
        ],
        "f882",
        "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 64c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zm96 192c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 262.8 428.1 256 416 256zM395.8 400L416 359.6 436.2 400H395.8z"
    ]
};
var $5c8203742f0e3062$export$95ef20828693fb0f = $5c8203742f0e3062$export$a0a53d8e3c68e9f1;
var $5c8203742f0e3062$export$769724fc1434d618 = {
    prefix: "fas",
    iconName: "fire-flame-curved",
    icon: [
        384,
        512,
        [
            "fire-alt"
        ],
        "f7e4",
        "M153.6 29.9l16-21.3C173.6 3.2 180 0 186.7 0C198.4 0 208 9.6 208 21.3V43.5c0 13.1 5.4 25.7 14.9 34.7L307.6 159C356.4 205.6 384 270.2 384 337.7C384 434 306 512 209.7 512H192C86 512 0 426 0 320v-3.8c0-48.8 19.4-95.6 53.9-130.1l3.5-3.5c4.2-4.2 10-6.6 16-6.6C85.9 176 96 186.1 96 198.6V288c0 35.3 28.7 64 64 64s64-28.7 64-64v-3.9c0-18-7.2-35.3-19.9-48l-38.6-38.6c-24-24-37.5-56.7-37.5-90.7c0-27.7 9-54.8 25.6-76.9z"
    ]
};
var $5c8203742f0e3062$export$70dc26b4926d0b1b = $5c8203742f0e3062$export$769724fc1434d618;
var $5c8203742f0e3062$export$6d274258ba4b0089 = {
    prefix: "fas",
    iconName: "tornado",
    icon: [
        448,
        512,
        [
            127786
        ],
        "f76f",
        "M0 32V45.6C0 62.7 1.7 79.6 5 96H357.8c3.2-6.9 7.5-13.3 13-18.8l38.6-38.6c4.2-4.2 6.6-10 6.6-16C416 10.1 405.9 0 393.4 0H32C14.3 0 0 14.3 0 32zm352.2 96H13.6c12.2 35.9 32.3 68.7 58.8 96H412l-47.2-62.9c-7.3-9.7-11.6-21.2-12.6-33.1zm-226 138.2l116.4 68.5c8.2 4.8 15.8 10.7 22.5 17.3H445c2-9.8 3-19.9 3-30.1c0-23-5.3-45.5-15.3-65.9H110.2c5.2 3.6 10.5 7 16 10.2zM288 384c10.3 21.4 13.8 45.5 9.9 69l-5.9 35.7c-2 12.2 7.4 23.4 19.8 23.4c5.3 0 10.4-2.1 14.2-5.9l78.2-78.2c12.8-12.8 23.1-27.7 30.4-43.9H288z"
    ]
};
var $5c8203742f0e3062$export$430d63b54b1d4009 = {
    prefix: "fas",
    iconName: "file-circle-plus",
    icon: [
        576,
        512,
        [
            58606
        ],
        "e494",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"
    ]
};
var $5c8203742f0e3062$export$ad3212bc3fa1595b = {
    prefix: "fas",
    iconName: "book-quran",
    icon: [
        448,
        512,
        [
            "quran"
        ],
        "f687",
        "M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM274.1 150.2l-8.9 21.4-23.1 1.9c-5.7 .5-8 7.5-3.7 11.2L256 199.8l-5.4 22.6c-1.3 5.5 4.7 9.9 9.6 6.9L280 217.2l19.8 12.1c4.9 3 10.9-1.4 9.6-6.9L304 199.8l17.6-15.1c4.3-3.7 2-10.8-3.7-11.2l-23.1-1.9-8.9-21.4c-2.2-5.3-9.6-5.3-11.8 0zM96 192c0 70.7 57.3 128 128 128c25.6 0 49.5-7.5 69.5-20.5c3.2-2.1 4.5-6.2 3.1-9.7s-5.2-5.6-9-4.8c-6.1 1.2-12.5 1.9-19 1.9c-52.4 0-94.9-42.5-94.9-94.9s42.5-94.9 94.9-94.9c6.5 0 12.8 .7 19 1.9c3.8 .8 7.5-1.3 9-4.8s.2-7.6-3.1-9.7C273.5 71.5 249.6 64 224 64C153.3 64 96 121.3 96 192z"
    ]
};
var $5c8203742f0e3062$export$46f29ea84ed4c5f1 = $5c8203742f0e3062$export$ad3212bc3fa1595b;
var $5c8203742f0e3062$export$12a35719f889cd1 = {
    prefix: "fas",
    iconName: "anchor",
    icon: [
        576,
        512,
        [
            9875
        ],
        "f13d",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c88.4 0 160-71.6 160-160v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56-56c-9.4-9.4-24.6-9.4-33.9 0l-56 56c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 53-43 96-96 96H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1z"
    ]
};
var $5c8203742f0e3062$export$93a5eb721c9c0d25 = {
    prefix: "fas",
    iconName: "border-all",
    icon: [
        448,
        512,
        [],
        "f84c",
        "M384 96V224H256V96H384zm0 192V416H256V288H384zM192 224H64V96H192V224zM64 288H192V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $5c8203742f0e3062$export$67a047c738fb34da = {
    prefix: "fas",
    iconName: "face-angry",
    icon: [
        512,
        512,
        [
            128544,
            "angry"
        ],
        "f556",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM338.7 395.9c6.6-5.9 7.1-16 1.2-22.6C323.8 355.4 295.7 336 256 336s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $5c8203742f0e3062$export$3c96c08e234498c5 = $5c8203742f0e3062$export$67a047c738fb34da;
var $5c8203742f0e3062$export$317dde8664f7de71 = {
    prefix: "fas",
    iconName: "cookie-bite",
    icon: [
        512,
        512,
        [],
        "f564",
        "M257.5 27.6c-.8-5.4-4.9-9.8-10.3-10.6v0c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9v0c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$d2caed5e37174c23 = {
    prefix: "fas",
    iconName: "arrow-trend-down",
    icon: [
        576,
        512,
        [],
        "e097",
        "M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352H384z"
    ]
};
var $5c8203742f0e3062$export$7329a1ca27b90c5b = {
    prefix: "fas",
    iconName: "rss",
    icon: [
        448,
        512,
        [
            "feed"
        ],
        "f09e",
        "M0 64C0 46.3 14.3 32 32 32c229.8 0 416 186.2 416 416c0 17.7-14.3 32-32 32s-32-14.3-32-32C384 253.6 226.4 96 32 96C14.3 96 0 81.7 0 64zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zM32 160c159.1 0 288 128.9 288 288c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$67ad3d0233cd7b33 = $5c8203742f0e3062$export$7329a1ca27b90c5b;
var $5c8203742f0e3062$export$df9bd3777d1154d2 = {
    prefix: "fas",
    iconName: "draw-polygon",
    icon: [
        448,
        512,
        [],
        "f5ee",
        "M96 151.4V360.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c0-.1 .1-.2 .1-.3l-4.5-7.9-32-56 0 0c-1.4 .1-2.8 .1-4.2 .1c-35.3 0-64-28.7-64-64s28.7-64 64-64c1.4 0 2.8 0 4.2 .1l0 0 32-56 4.5-7.9-.1-.3H119.4c-5.6 9.7-13.7 17.8-23.4 23.4zM384.3 352c35.2 .2 63.7 28.7 63.7 64c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V151.4C12.9 140.4 0 119.7 0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32H328.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 35.3-28.5 63.8-63.7 64l-4.5 7.9-32 56-2.3 4c4.2 8.5 6.5 18 6.5 28.1s-2.3 19.6-6.5 28.1l2.3 4 32 56 4.5 7.9z"
    ]
};
var $5c8203742f0e3062$export$33fb4280dc20f0dd = {
    prefix: "fas",
    iconName: "scale-balanced",
    icon: [
        640,
        512,
        [
            9878,
            "balance-scale"
        ],
        "f24e",
        "M384 32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H398.4c-5.2 25.8-22.9 47.1-46.4 57.3V448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-23.5-10.3-41.2-31.6-46.4-57.3H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm55.6 288H584.4L512 195.8 439.6 320zM512 416c-62.9 0-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C627.2 382 574.9 416 512 416zM126.8 195.8L54.4 320H199.3L126.8 195.8zM.9 337.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C242 382 189.7 416 126.8 416S11.7 382 .9 337.1z"
    ]
};
var $5c8203742f0e3062$export$fec323dcfd81d750 = $5c8203742f0e3062$export$33fb4280dc20f0dd;
var $5c8203742f0e3062$export$cc4351eb13da27d8 = {
    prefix: "fas",
    iconName: "gauge-simple-high",
    icon: [
        512,
        512,
        [
            61668,
            "tachometer",
            "tachometer-fast"
        ],
        "f62a",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-15.9-5.8-30.4-15.3-41.6l76.6-147.4c6.1-11.8 1.5-26.3-10.2-32.4s-26.2-1.5-32.4 10.2L262.1 288.3c-2-.2-4-.3-6.1-.3c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $5c8203742f0e3062$export$362d0f652c3fbca2 = $5c8203742f0e3062$export$cc4351eb13da27d8;
var $5c8203742f0e3062$export$375b6a8680f980ed = $5c8203742f0e3062$export$cc4351eb13da27d8;
var $5c8203742f0e3062$export$f7f7c15f18cc19a1 = {
    prefix: "fas",
    iconName: "shower",
    icon: [
        512,
        512,
        [
            128703
        ],
        "f2cc",
        "M64 131.9C64 112.1 80.1 96 99.9 96c9.5 0 18.6 3.8 25.4 10.5l16.2 16.2c-21 38.9-17.4 87.5 10.9 123L151 247c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-1.3 1.3c-35.5-28.3-84.2-31.9-123-10.9L170.5 61.3C151.8 42.5 126.4 32 99.9 32C44.7 32 0 76.7 0 131.9V448c0 17.7 14.3 32 32 32s32-14.3 32-32V131.9zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$6e6ddc253102e596 = {
    prefix: "fas",
    iconName: "desktop",
    icon: [
        576,
        512,
        [
            128421,
            61704,
            "desktop-alt"
        ],
        "f390",
        "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V288H64V64H512z"
    ]
};
var $5c8203742f0e3062$export$ff09a62b9e0fa899 = $5c8203742f0e3062$export$6e6ddc253102e596;
var $5c8203742f0e3062$export$bd6a7788954842b5 = {
    prefix: "fas",
    iconName: "m",
    icon: [
        448,
        512,
        [
            109
        ],
        "4d",
        "M22.7 33.4c13.5-4.1 28.1 1.1 35.9 12.9L224 294.3 389.4 46.2c7.8-11.7 22.4-17 35.9-12.9S448 49.9 448 64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V169.7L250.6 369.8c-5.9 8.9-15.9 14.2-26.6 14.2s-20.7-5.3-26.6-14.2L64 169.7V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 49.9 9.2 37.5 22.7 33.4z"
    ]
};
var $5c8203742f0e3062$export$6e989c3c7050dbb = {
    prefix: "fas",
    iconName: "table-list",
    icon: [
        512,
        512,
        [
            "th-list"
        ],
        "f00b",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 0v64h64V96H64zm384 0H192v64H448V96zM64 224v64h64V224H64zm384 0H192v64H448V224zM64 352v64h64V352H64zm384 0H192v64H448V352z"
    ]
};
var $5c8203742f0e3062$export$daf2614a457122c0 = $5c8203742f0e3062$export$6e989c3c7050dbb;
var $5c8203742f0e3062$export$435fe17e9d6170d6 = {
    prefix: "fas",
    iconName: "comment-sms",
    icon: [
        512,
        512,
        [
            "sms"
        ],
        "f7cd",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM96 212.8c0-20.3 16.5-36.8 36.8-36.8H152c8.8 0 16 7.2 16 16s-7.2 16-16 16H132.8c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.3 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h27.2c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6C102.2 236.7 96 225.2 96 212.8zM372.8 176H392c8.8 0 16 7.2 16 16s-7.2 16-16 16H372.8c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.2 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8H352c-8.8 0-16-7.2-16-16s7.2-16 16-16h27.2c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6c-10.2-6.8-16.4-18.3-16.4-30.7c0-20.3 16.5-36.8 36.8-36.8zm-152 6.4L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V240l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-6.9 4.4-13 10.9-15.2s13.7 .1 17.9 5.6z"
    ]
};
var $5c8203742f0e3062$export$9dbcc3443daa7323 = $5c8203742f0e3062$export$435fe17e9d6170d6;
var $5c8203742f0e3062$export$c9d7ef726d1a8742 = {
    prefix: "fas",
    iconName: "book",
    icon: [
        448,
        512,
        [
            128212
        ],
        "f02d",
        "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$4c17261776a709f2 = {
    prefix: "fas",
    iconName: "user-plus",
    icon: [
        640,
        512,
        [],
        "f234",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $5c8203742f0e3062$export$62b2c752fccc6a9c = {
    prefix: "fas",
    iconName: "check",
    icon: [
        448,
        512,
        [
            10003,
            10004
        ],
        "f00c",
        "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
    ]
};
var $5c8203742f0e3062$export$cfb37069d38f379e = {
    prefix: "fas",
    iconName: "battery-three-quarters",
    icon: [
        576,
        512,
        [
            "battery-4"
        ],
        "f241",
        "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm272 96H96V320H352V192z"
    ]
};
var $5c8203742f0e3062$export$35ffefed200d123c = $5c8203742f0e3062$export$cfb37069d38f379e;
var $5c8203742f0e3062$export$c9382fa3394ef53a = {
    prefix: "fas",
    iconName: "house-circle-check",
    icon: [
        640,
        512,
        [],
        "e509",
        "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $5c8203742f0e3062$export$3cbcd1b7e35945d2 = {
    prefix: "fas",
    iconName: "angle-left",
    icon: [
        320,
        512,
        [
            8249
        ],
        "f104",
        "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    ]
};
var $5c8203742f0e3062$export$ff7f40159cadb0ac = {
    prefix: "fas",
    iconName: "diagram-successor",
    icon: [
        512,
        512,
        [],
        "e47a",
        "M512 416l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zM64 160l0-64 144 0 16 0 0 64L64 160zm224 0l0-64 80 0c8.8 0 16 7.2 16 16l0 16-38.1 0c-21.4 0-32.1 25.9-17 41L399 239c9.4 9.4 24.6 9.4 33.9 0L503 169c15.1-15.1 4.4-41-17-41L448 128l0-16c0-44.2-35.8-80-80-80L224 32l-16 0L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64z"
    ]
};
var $5c8203742f0e3062$export$d69fa2b7839ce76 = {
    prefix: "fas",
    iconName: "truck-arrow-right",
    icon: [
        640,
        512,
        [],
        "e58b",
        "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM257 95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H262.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9L257 95z"
    ]
};
var $5c8203742f0e3062$export$7df274119d2469d1 = {
    prefix: "fas",
    iconName: "arrows-split-up-and-left",
    icon: [
        512,
        512,
        [],
        "e4bc",
        "M246.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 109.3V384c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c-70.7 0-128-57.3-128-128c0-35.3-28.7-64-64-64H109.3l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256H224c23.3 0 45.2 6.2 64 17.1V109.3l-41.4 41.4z"
    ]
};
var $5c8203742f0e3062$export$ca492f58fe30a42f = {
    prefix: "fas",
    iconName: "hand-fist",
    icon: [
        448,
        512,
        [
            9994,
            "fist-raised"
        ],
        "f6de",
        "M192 0c17.7 0 32 14.3 32 32V144H160V32c0-17.7 14.3-32 32-32zM64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v80H64V64zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V64zm96 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V128zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V256c0 52.3-25.1 98.8-64 128v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V401.6c-17.3-7.9-33.2-18.8-46.9-32.5L69.5 357.5C45.5 333.5 32 300.9 32 267V240c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"
    ]
};
var $5c8203742f0e3062$export$fa0323a4d7489a8d = $5c8203742f0e3062$export$ca492f58fe30a42f;
var $5c8203742f0e3062$export$482eb125aaf0fbc2 = {
    prefix: "fas",
    iconName: "cloud-moon",
    icon: [
        640,
        512,
        [],
        "f6c3",
        "M495.8 0c5.5 0 10.9 .2 16.3 .7c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8c0 81 65.5 146.6 146.2 146.6c8.6 0 17-.7 25.1-2.1c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4c-9.3 0-18.4-.7-27.4-1.9c-11.2-22.6-29.8-40.9-52.6-51.7c-2.7-58.5-50.3-105.3-109.2-106.7c-1.7-10.4-2.6-21-2.6-31.8C304 86.1 389.8 0 495.8 0zM447.9 431.9c0 44.2-35.8 80-80 80H96c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
var $5c8203742f0e3062$export$8da450d063b0eb37 = {
    prefix: "fas",
    iconName: "briefcase",
    icon: [
        512,
        512,
        [
            128188
        ],
        "f0b1",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z"
    ]
};
var $5c8203742f0e3062$export$e94ab3a30cf4aca5 = {
    prefix: "fas",
    iconName: "person-falling",
    icon: [
        512,
        512,
        [],
        "e546",
        "M288 0c17.7 0 32 14.3 32 32l0 9.8c0 54.6-27.9 104.6-72.5 133.6l.2 .3L304.5 256l87.5 0c15.1 0 29.3 7.1 38.4 19.2l43.2 57.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L384 320l-96 0h-1.4l92.3 142.6c9.6 14.8 5.4 34.6-9.5 44.3s-34.6 5.4-44.3-9.5L164.5 249.2c-2.9 9.2-4.5 19-4.5 29l0 73.8c0 17.7-14.3 32-32 32s-32-14.3-32-32V278.2c0-65.1 39.6-123.7 100.1-147.9C232.3 115.8 256 80.8 256 41.8l0-9.8c0-17.7 14.3-32 32-32zM112 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $5c8203742f0e3062$export$c23fd8b91a7ed48 = {
    prefix: "fas",
    iconName: "image-portrait",
    icon: [
        384,
        512,
        [
            "portrait"
        ],
        "f3e0",
        "M384 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64l0-384zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 356.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H107.4C92.3 384 80 371.7 80 356.6z"
    ]
};
var $5c8203742f0e3062$export$e3d25f819c7ee7d7 = $5c8203742f0e3062$export$c23fd8b91a7ed48;
var $5c8203742f0e3062$export$9eec597148166b36 = {
    prefix: "fas",
    iconName: "user-tag",
    icon: [
        640,
        512,
        [],
        "f507",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c10 0 18.8-4.9 24.2-12.5l-99.2-99.2c-14.9-14.9-23.3-35.1-23.3-56.1v-33c-15.9-4.7-32.8-7.2-50.3-7.2H178.3zM384 224c-17.7 0-32 14.3-32 32v82.7c0 17 6.7 33.3 18.7 45.3L478.1 491.3c18.7 18.7 49.1 18.7 67.9 0l73.4-73.4c18.7-18.7 18.7-49.1 0-67.9L512 242.7c-12-12-28.3-18.7-45.3-18.7H384zm24 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $5c8203742f0e3062$export$7cee7480f25f5289 = {
    prefix: "fas",
    iconName: "rug",
    icon: [
        640,
        512,
        [],
        "e569",
        "M24 64H56 80V88v88 80 80 88 24H56 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V360H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V200H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V112H24C10.7 112 0 101.3 0 88S10.7 64 24 64zm88 0H528V448H112V64zM640 88c0 13.3-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H584 560V424 336 256 176 88 64h24 32c13.3 0 24 10.7 24 24z"
    ]
};
var $5c8203742f0e3062$export$7adefae4a1be1d97 = {
    prefix: "fas",
    iconName: "earth-europe",
    icon: [
        512,
        512,
        [
            "globe-europe"
        ],
        "f7a2",
        "M266.3 48.3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1v9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1h1c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24v4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H379.3c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3h11.3c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16H454c6.5-20.2 10-41.7 10-64c0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4H251.4c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3v3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3H248c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c71.3-5.8 132.5-47.6 165.2-107.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $5c8203742f0e3062$export$5318b8ede86cc96b = $5c8203742f0e3062$export$7adefae4a1be1d97;
var $5c8203742f0e3062$export$ab81ff863770d996 = {
    prefix: "fas",
    iconName: "cart-flatbed-suitcase",
    icon: [
        640,
        512,
        [
            "luggage-cart"
        ],
        "f59d",
        "M0 32C0 14.3 14.3 0 32 0H48c44.2 0 80 35.8 80 80V368c0 8.8 7.2 16 16 16H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H541.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H253.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H144c-44.2 0-80-35.8-80-80V80c0-8.8-7.2-16-16-16H32C14.3 64 0 49.7 0 32zM432 96V56c0-4.4-3.6-8-8-8H344c-4.4 0-8 3.6-8 8V96h96zM288 96V56c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56V96 320H288V96zM512 320V96h16c26.5 0 48 21.5 48 48V272c0 26.5-21.5 48-48 48H512zM240 96h16V320H240c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"
    ]
};
var $5c8203742f0e3062$export$bd1e24dd3cde8514 = $5c8203742f0e3062$export$ab81ff863770d996;
var $5c8203742f0e3062$export$3896694b3e81fba7 = {
    prefix: "fas",
    iconName: "rectangle-xmark",
    icon: [
        512,
        512,
        [
            62164,
            "rectangle-times",
            "times-rectangle",
            "window-close"
        ],
        "f410",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $5c8203742f0e3062$export$eaaf26416a51dc1 = $5c8203742f0e3062$export$3896694b3e81fba7;
var $5c8203742f0e3062$export$10147c0014152a3f = $5c8203742f0e3062$export$3896694b3e81fba7;
var $5c8203742f0e3062$export$18b7775f78a3e16 = $5c8203742f0e3062$export$3896694b3e81fba7;
var $5c8203742f0e3062$export$ffc7123046a28ee = {
    prefix: "fas",
    iconName: "baht-sign",
    icon: [
        320,
        512,
        [],
        "e0ac",
        "M144 0c-17.7 0-32 14.3-32 32V64H37.6C16.8 64 0 80.8 0 101.6V224v41.7V288 406.3c0 23 18.7 41.7 41.7 41.7H112v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c61.9 0 112-50.1 112-112c0-40.1-21.1-75.3-52.7-95.1C280.3 222.6 288 200.2 288 176c0-61.9-50.1-112-112-112V32c0-17.7-14.3-32-32-32zM112 128v96H64V128h48zm64 96V128c26.5 0 48 21.5 48 48s-21.5 48-48 48zm-64 64v96H64V288h48zm64 96V288h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H176z"
    ]
};
var $5c8203742f0e3062$export$8a3071811b2b7979 = {
    prefix: "fas",
    iconName: "book-open",
    icon: [
        576,
        512,
        [
            128214,
            128366
        ],
        "f518",
        "M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5V78.6c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C93.5 32 46.3 45.3 18.1 56.1C6.8 60.5 0 71.7 0 83.8V454.1c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5zm76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5V83.8c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-58.4 0-103.4 20-123 35.6c-3.3 2.6-5 6.8-5 11V456c0 11.4 11.7 19.3 22.4 15.5z"
    ]
};
var $5c8203742f0e3062$export$d3d49030d557a09b = {
    prefix: "fas",
    iconName: "book-journal-whills",
    icon: [
        448,
        512,
        [
            "journal-whills"
        ],
        "f66a",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zm90.4-234.4l-21.2-21.2c-3 10.1-5.1 20.6-5.1 31.6c0 .2 0 .5 .1 .8s.1 .5 .1 .8L165.2 226c2.5 2.1 3.4 5.8 2.3 8.9c-1.3 3-4.1 5.1-7.5 5.1c-1.9-.1-3.8-.8-5.2-2l-23.6-20.6C142.8 267 186.9 304 240 304s97.3-37 108.9-86.6L325.3 238c-1.4 1.2-3.3 2-5.3 2c-2.2-.1-4.4-1.1-6-2.8c-1.2-1.5-1.9-3.4-2-5.2c.1-2.2 1.1-4.4 2.8-6l37.1-32.5c0-.3 0-.5 .1-.8s.1-.5 .1-.8c0-11-2.1-21.5-5.1-31.6l-21.2 21.2c-3.1 3.1-8.1 3.1-11.3 0s-3.1-8.1 0-11.2l26.4-26.5c-8.2-17-20.5-31.7-35.9-42.6c-2.7-1.9-6.2 1.4-5 4.5c8.5 22.4 3.6 48-13 65.6c-3.2 3.4-3.6 8.9-.9 12.7c9.8 14 12.7 31.9 7.5 48.5c-5.9 19.4-22 34.1-41.9 38.3l-1.4-34.3 12.6 8.6c.6 .4 1.5 .6 2.3 .6c1.5 0 2.7-.8 3.5-2s.6-2.8-.1-4L260 225.4l18-3.6c1.8-.4 3.1-2.1 3.1-4s-1.4-3.5-3.1-3.9l-18-3.7 8.5-14.3c.8-1.2 .9-2.9 .1-4.1s-2-2-3.5-2l-.1 0c-.7 .1-1.5 .3-2.1 .7l-14.1 9.6L244 87.9c-.1-2.2-1.9-3.9-4-3.9s-3.9 1.6-4 3.9l-4.6 110.8-12-8.1c-1.5-1.1-3.6-.9-5 .4s-1.6 3.4-.8 5l8.6 14.3-18 3.7c-1.8 .4-3.1 2-3.1 3.9s1.4 3.6 3.1 4l18 3.8-8.6 14.2c-.2 .6-.5 1.4-.5 2c0 1.1 .5 2.1 1.2 3c.8 .6 1.8 1 2.8 1c.7 0 1.6-.2 2.2-.6l10.4-7.1-1.4 32.8c-19.9-4.1-36-18.9-41.9-38.3c-5.1-16.6-2.2-34.4 7.6-48.5c2.7-3.9 2.3-9.3-.9-12.7c-16.6-17.5-21.6-43.1-13.1-65.5c1.2-3.1-2.3-6.4-5-4.5c-15.3 10.9-27.6 25.6-35.8 42.6l26.4 26.5c3.1 3.1 3.1 8.1 0 11.2s-8.1 3.1-11.2 0z"
    ]
};
var $5c8203742f0e3062$export$66a0d8d45aab6631 = $5c8203742f0e3062$export$d3d49030d557a09b;
var $5c8203742f0e3062$export$74d1f89b5feb9d42 = {
    prefix: "fas",
    iconName: "handcuffs",
    icon: [
        640,
        512,
        [],
        "e4f8",
        "M240 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 80c17.7 0 32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32zm0 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm192-96c0-25.9-5.1-50.5-14.4-73.1c16.9-32.9 44.8-59.1 78.9-73.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32s32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm224 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM368 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$1cbf6e649ce86166 = {
    prefix: "fas",
    iconName: "triangle-exclamation",
    icon: [
        512,
        512,
        [
            9888,
            "exclamation-triangle",
            "warning"
        ],
        "f071",
        "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $5c8203742f0e3062$export$3d249b63b52cce7c = $5c8203742f0e3062$export$1cbf6e649ce86166;
var $5c8203742f0e3062$export$2e470a35c38b096a = $5c8203742f0e3062$export$1cbf6e649ce86166;
var $5c8203742f0e3062$export$24680dede86b1883 = {
    prefix: "fas",
    iconName: "database",
    icon: [
        448,
        512,
        [],
        "f1c0",
        "M448 80v48c0 44.2-100.3 80-224 80S0 172.2 0 128V80C0 35.8 100.3 0 224 0S448 35.8 448 80zM393.2 214.7c20.8-7.4 39.9-16.9 54.8-28.6V288c0 44.2-100.3 80-224 80S0 332.2 0 288V186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3zM0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6V432c0 44.2-100.3 80-224 80S0 476.2 0 432V346.1z"
    ]
};
var $5c8203742f0e3062$export$c08b4b0e2b0dc027 = {
    prefix: "fas",
    iconName: "share",
    icon: [
        512,
        512,
        [
            "mail-forward"
        ],
        "f064",
        "M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"
    ]
};
var $5c8203742f0e3062$export$81df7693d3f2f8da = $5c8203742f0e3062$export$c08b4b0e2b0dc027;
var $5c8203742f0e3062$export$8f534e1e0ab75bfe = {
    prefix: "fas",
    iconName: "bottle-droplet",
    icon: [
        320,
        512,
        [],
        "e4c4",
        "M96 0C82.7 0 72 10.7 72 24s10.7 24 24 24c4.4 0 8 3.6 8 8v64.9c0 12.2-7.2 23.1-17.2 30.1C53.7 174.1 32 212.5 32 256V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V256c0-43.5-21.7-81.9-54.8-105c-10-7-17.2-17.9-17.2-30.1V56c0-4.4 3.6-8 8-8c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 0 0 0H104l0 0 0 0L96 0zm64 382c-26.5 0-48-20.1-48-45c0-16.8 22.1-48.1 36.3-66.4c6-7.8 17.5-7.8 23.5 0C185.9 288.9 208 320.2 208 337c0 24.9-21.5 45-48 45z"
    ]
};
var $5c8203742f0e3062$export$140d4da0adbaf435 = {
    prefix: "fas",
    iconName: "mask-face",
    icon: [
        640,
        512,
        [],
        "e1d7",
        "M320 64c-27.2 0-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1H144 128 56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l108 27C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l108-27C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H512 496h-9.2c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64zM132.3 346.3l-29.8-7.4C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H96v48c0 45.1 13.4 87.2 36.3 122.3zm405.1-7.4l-29.8 7.4c23-35.2 36.3-77.2 36.3-122.3V176h40c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9zM192 208c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 48H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 80c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
    ]
};
var $5c8203742f0e3062$export$7ec15a32285f6c22 = {
    prefix: "fas",
    iconName: "hill-rockslide",
    icon: [
        576,
        512,
        [],
        "e508",
        "M252.4 103.8l27 48c2.8 5 8.2 8.2 13.9 8.2l53.3 0c5.8 0 11.1-3.1 13.9-8.2l27-48c2.7-4.9 2.7-10.8 0-15.7l-27-48c-2.8-5-8.2-8.2-13.9-8.2H293.4c-5.8 0-11.1 3.1-13.9 8.2l-27 48c-2.7 4.9-2.7 10.8 0 15.7zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80H396.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87zM504.2 403.6c4.9 2.7 10.8 2.7 15.7 0l48-27c5-2.8 8.2-8.2 8.2-13.9V309.4c0-5.8-3.1-11.1-8.2-13.9l-48-27c-4.9-2.7-10.8-2.7-15.7 0l-48 27c-5 2.8-8.2 8.2-8.2 13.9v53.3c0 5.8 3.1 11.1 8.2 13.9l48 27zM192 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$a082af56be9786ae = {
    prefix: "fas",
    iconName: "right-left",
    icon: [
        512,
        512,
        [
            "exchange-alt"
        ],
        "f362",
        "M32 96l320 0V32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160L32 160c-17.7 0-32-14.3-32-32s14.3-32 32-32zM480 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H160v64c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-96-96c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6l96-96c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 64H480z"
    ]
};
var $5c8203742f0e3062$export$f6c6fb20d374b128 = $5c8203742f0e3062$export$a082af56be9786ae;
var $5c8203742f0e3062$export$b5378818301da1be = {
    prefix: "fas",
    iconName: "paper-plane",
    icon: [
        512,
        512,
        [
            61913
        ],
        "f1d8",
        "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480V396.4c0-4 1.5-7.8 4.2-10.7L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"
    ]
};
var $5c8203742f0e3062$export$79753c2153535b01 = {
    prefix: "fas",
    iconName: "road-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e565",
        "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $5c8203742f0e3062$export$1156dc6acb0058bd = {
    prefix: "fas",
    iconName: "dungeon",
    icon: [
        512,
        512,
        [],
        "f6d9",
        "M336.6 156.5c1.3 1.1 2.7 2.2 3.9 3.3c9.3 8.2 23 10.5 33.4 3.6l67.6-45.1c11.4-7.6 14.2-23.2 5.1-33.4C430 66.6 410.9 50.6 389.7 37.6c-11.9-7.3-26.9-1.4-32.1 11.6l-30.5 76.2c-4.5 11.1 .2 23.6 9.5 31.2zM328 36.8c5.1-12.8-1.6-27.4-15-30.5C294.7 2.2 275.6 0 256 0s-38.7 2.2-57 6.4C185.5 9.4 178.8 24 184 36.8l30.3 75.8c4.5 11.3 16.8 17.2 29 16c4.2-.4 8.4-.6 12.7-.6s8.6 .2 12.7 .6c12.1 1.2 24.4-4.7 29-16L328 36.8zM65.5 85c-9.1 10.2-6.3 25.8 5.1 33.4l67.6 45.1c10.3 6.9 24.1 4.6 33.4-3.6c1.3-1.1 2.6-2.3 4-3.3c9.3-7.5 13.9-20.1 9.5-31.2L154.4 49.2c-5.2-12.9-20.3-18.8-32.1-11.6C101.1 50.6 82 66.6 65.5 85zm314 137.1c.9 3.3 1.7 6.6 2.3 10c2.5 13 13 23.9 26.2 23.9h80c13.3 0 24.1-10.8 22.9-24c-2.5-27.2-9.3-53.2-19.7-77.3c-5.5-12.9-21.4-16.6-33.1-8.9l-68.6 45.7c-9.8 6.5-13.2 19.2-10 30.5zM53.9 145.8c-11.6-7.8-27.6-4-33.1 8.9C10.4 178.8 3.6 204.8 1.1 232c-1.2 13.2 9.6 24 22.9 24h80c13.3 0 23.8-10.8 26.2-23.9c.6-3.4 1.4-6.7 2.3-10c3.1-11.4-.2-24-10-30.5L53.9 145.8zM104 288H24c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24zm304 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24H408zM24 416c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H24zm384 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H408zM272 192c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V192zm-64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224z"
    ]
};
var $5c8203742f0e3062$export$7370f36a39a38737 = {
    prefix: "fas",
    iconName: "align-right",
    icon: [
        448,
        512,
        [],
        "f038",
        "M448 64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $5c8203742f0e3062$export$52e3e96cd1564779 = {
    prefix: "fas",
    iconName: "money-bill-1-wave",
    icon: [
        576,
        512,
        [
            "money-bill-wave-alt"
        ],
        "f53b",
        "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM128 416H64V352c35.3 0 64 28.7 64 64zM64 224V160h64c0 35.3-28.7 64-64 64zM448 352c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM384 256c0 61.9-43 112-96 112s-96-50.1-96-112s43-112 96-112s96 50.1 96 112zM252 208c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"
    ]
};
var $5c8203742f0e3062$export$1613858e873cbb3e = $5c8203742f0e3062$export$52e3e96cd1564779;
var $5c8203742f0e3062$export$53dd2cacf674142a = {
    prefix: "fas",
    iconName: "life-ring",
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M367.2 412.5C335.9 434.9 297.5 448 256 448s-79.9-13.1-111.2-35.5l58-58c15.8 8.6 34 13.5 53.3 13.5s37.4-4.9 53.3-13.5l58 58zm90.7 .8c33.8-43.4 54-98 54-157.3s-20.2-113.9-54-157.3c9-12.5 7.9-30.1-3.4-41.3S425.8 45 413.3 54C369.9 20.2 315.3 0 256 0S142.1 20.2 98.7 54c-12.5-9-30.1-7.9-41.3 3.4S45 86.2 54 98.7C20.2 142.1 0 196.7 0 256s20.2 113.9 54 157.3c-9 12.5-7.9 30.1 3.4 41.3S86.2 467 98.7 458c43.4 33.8 98 54 157.3 54s113.9-20.2 157.3-54c12.5 9 30.1 7.9 41.3-3.4s12.4-28.8 3.4-41.3zm-45.5-46.1l-58-58c8.6-15.8 13.5-34 13.5-53.3s-4.9-37.4-13.5-53.3l58-58C434.9 176.1 448 214.5 448 256s-13.1 79.9-35.5 111.2zM367.2 99.5l-58 58c-15.8-8.6-34-13.5-53.3-13.5s-37.4 4.9-53.3 13.5l-58-58C176.1 77.1 214.5 64 256 64s79.9 13.1 111.2 35.5zM157.5 309.3l-58 58C77.1 335.9 64 297.5 64 256s13.1-79.9 35.5-111.2l58 58c-8.6 15.8-13.5 34-13.5 53.3s4.9 37.4 13.5 53.3zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var $5c8203742f0e3062$export$f9712d0cf5150f0c = {
    prefix: "fas",
    iconName: "hands",
    icon: [
        576,
        512,
        [
            "sign-language",
            "signing"
        ],
        "f2a7",
        "M544 160l-.1 72.6c-.1 52.2-24 101-64 133.1c.1-1.9 .1-3.8 .1-5.7v-8c0-71.8-37-138.6-97.9-176.7l-60.2-37.6c-8.6-5.4-17.9-8.4-27.3-9.4L248.7 48.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8l78 135.1c3.3 5.7 10.7 7.7 16.4 4.4s7.7-10.7 4.4-16.4l-62-107.4c-6.6-11.5-2.7-26.2 8.8-32.8S362 5 368.6 16.5l68 117.8 0 0 0 0 43.3 75L480 160c0-17.7 14.4-32 32-32s32 14.4 32 32zM243.9 88.5L268.5 131c-13.9 4.5-26.4 13.7-34.7 27c-.9 1.4-1.7 2.9-2.5 4.4l-28.9-50c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zm-46.4 63.7l26.8 46.4c.6 6 2.1 11.8 4.3 17.4H224 210.7l0 0H179l-23-39.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zM260.9 175c9.4-15 29.1-19.5 44.1-10.2l60.2 37.6C416.7 234.7 448 291.2 448 352v8c0 83.9-68.1 152-152 152H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h92c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H212c6.6 0 12-5.4 12-12s-5.4-12-12-12H56c-13.3 0-24-10.7-24-24s10.7-24 24-24H212c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H224l0 0 0 0h93.2L271 219.1c-15-9.4-19.5-29.1-10.2-44.1z"
    ]
};
var $5c8203742f0e3062$export$20993813350f9671 = $5c8203742f0e3062$export$f9712d0cf5150f0c;
var $5c8203742f0e3062$export$5cc0e6f5191f4f02 = $5c8203742f0e3062$export$f9712d0cf5150f0c;
var $5c8203742f0e3062$export$80968bcfef6481ca = {
    prefix: "fas",
    iconName: "calendar-day",
    icon: [
        448,
        512,
        [],
        "f783",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"
    ]
};
var $5c8203742f0e3062$export$5930e9bdfd790d77 = {
    prefix: "fas",
    iconName: "water-ladder",
    icon: [
        576,
        512,
        [
            "ladder-water",
            "swimming-pool"
        ],
        "f5c5",
        "M128 127.7C128 74.9 170.9 32 223.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V224H384V127.7C384 74.9 426.9 32 479.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V361c-1.6 1-3.3 2-4.8 3.1c-18 12.4-40.1 20.3-59.2 20.3h0V288H192v96.5c-19 0-41.2-7.9-59.1-20.3c-1.6-1.1-3.2-2.2-4.9-3.1V127.7zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $5c8203742f0e3062$export$c5ea6eeef2db2b3b = $5c8203742f0e3062$export$5930e9bdfd790d77;
var $5c8203742f0e3062$export$4dee691631c67d5c = $5c8203742f0e3062$export$5930e9bdfd790d77;
var $5c8203742f0e3062$export$64185f27d82c259f = {
    prefix: "fas",
    iconName: "arrows-up-down",
    icon: [
        320,
        512,
        [
            "arrows-v"
        ],
        "f07d",
        "M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"
    ]
};
var $5c8203742f0e3062$export$cec5f1bc9e068e48 = $5c8203742f0e3062$export$64185f27d82c259f;
var $5c8203742f0e3062$export$bd5bd2ef56b793b1 = {
    prefix: "fas",
    iconName: "face-grimace",
    icon: [
        512,
        512,
        [
            128556,
            "grimace"
        ],
        "f57f",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-112h-8V360l55.3 0c-3.8 22.7-23.6 40-47.3 40zm47.3-56L344 344V304h8c23.8 0 43.5 17.3 47.3 40zM328 344H264V304h64v40zm0 56H264V360h64v40zm-80-96v40l-64 0V304h64zm0 56v40H184V360l64 0zm-80-16H112.7c3.8-22.7 23.6-40 47.3-40h8v40zm0 56h-8c-23.8 0-43.5-17.3-47.3-40H168v40zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$3d08cd36ac1ef231 = $5c8203742f0e3062$export$bd5bd2ef56b793b1;
var $5c8203742f0e3062$export$1482162f7fe04ac = {
    prefix: "fas",
    iconName: "wheelchair-move",
    icon: [
        448,
        512,
        [
            "wheelchair-alt"
        ],
        "e2ce",
        "M320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM204.5 121.3c-5.4-2.5-11.7-1.9-16.4 1.7l-40.9 30.7c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l40.9-30.7c23.7-17.8 55.3-21 82.1-8.4l90.4 42.5c29.1 13.7 36.8 51.6 15.2 75.5L299.1 224h97.4c30.3 0 53 27.7 47.1 57.4L415.4 422.3c-3.5 17.3-20.3 28.6-37.7 25.1s-28.6-20.3-25.1-37.7L377 288H306.7c8.6 19.6 13.3 41.2 13.3 64c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c11.1 0 22 1.1 32.4 3.3l54.2-54.2-42.1-19.8zM160 448a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
    ]
};
var $5c8203742f0e3062$export$7db9460785019040 = $5c8203742f0e3062$export$1482162f7fe04ac;
var $5c8203742f0e3062$export$b5dc9dd0347bbb6 = {
    prefix: "fas",
    iconName: "turn-down",
    icon: [
        384,
        512,
        [
            10549,
            "level-down-alt"
        ],
        "f3be",
        "M350 334.5c3.8 8.8 2 19-4.6 26l-136 144c-4.5 4.8-10.8 7.5-17.4 7.5s-12.9-2.7-17.4-7.5l-136-144c-6.6-7-8.4-17.2-4.6-26s12.5-14.5 22-14.5h88l0-192c0-17.7-14.3-32-32-32H32C14.3 96 0 81.7 0 64V32C0 14.3 14.3 0 32 0l80 0c70.7 0 128 57.3 128 128l0 192h88c9.6 0 18.2 5.7 22 14.5z"
    ]
};
var $5c8203742f0e3062$export$c07eb6ff5a382cbd = $5c8203742f0e3062$export$b5dc9dd0347bbb6;
var $5c8203742f0e3062$export$3e15790fe68c095b = {
    prefix: "fas",
    iconName: "person-walking-arrow-right",
    icon: [
        640,
        512,
        [],
        "e552",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80z"
    ]
};
var $5c8203742f0e3062$export$15da4ef8c0fb20d6 = {
    prefix: "fas",
    iconName: "square-envelope",
    icon: [
        448,
        512,
        [
            "envelope-square"
        ],
        "f199",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM218 271.7L64.2 172.4C66 156.4 79.5 144 96 144H352c16.5 0 30 12.4 31.8 28.4L230 271.7c-1.8 1.2-3.9 1.8-6 1.8s-4.2-.6-6-1.8zm29.4 26.9L384 210.4V336c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V210.4l136.6 88.2c7 4.5 15.1 6.9 23.4 6.9s16.4-2.4 23.4-6.9z"
    ]
};
var $5c8203742f0e3062$export$354e159473e73552 = $5c8203742f0e3062$export$15da4ef8c0fb20d6;
var $5c8203742f0e3062$export$4ed8206e6619cc8f = {
    prefix: "fas",
    iconName: "dice",
    icon: [
        640,
        512,
        [
            127922
        ],
        "f522",
        "M274.9 34.3c-28.1-28.1-73.7-28.1-101.8 0L34.3 173.1c-28.1 28.1-28.1 73.7 0 101.8L173.1 413.7c28.1 28.1 73.7 28.1 101.8 0L413.7 274.9c28.1-28.1 28.1-73.7 0-101.8L274.9 34.3zM200 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 376a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM352 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 120a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm96 328c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H461.7c11.6 36 3.1 77-25.4 105.5L320 413.8V448zM480 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $5c8203742f0e3062$export$5ee2640fe105312d = {
    prefix: "fas",
    iconName: "bowling-ball",
    icon: [
        512,
        512,
        [],
        "f436",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$97fa4f4c1006ab1 = {
    prefix: "fas",
    iconName: "brain",
    icon: [
        512,
        512,
        [
            129504
        ],
        "f5dc",
        "M184 0c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56c-28.9 0-52.7-21.9-55.7-50.1c-5.2 1.4-10.7 2.1-16.3 2.1c-35.3 0-64-28.7-64-64c0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1C131.3 21.9 155.1 0 184 0zM328 0c28.9 0 52.6 21.9 55.7 49.9c27.8 7 48.3 32.1 48.3 62.1c0 6-.8 11.9-2.4 17.4c28.8 6.2 50.4 31.9 50.4 62.6c0 15-5.1 28.8-13.8 39.7C493.3 244.5 512 272.1 512 304c0 34.2-21.4 63.4-51.6 74.8c2.3 6.6 3.6 13.8 3.6 21.2c0 35.3-28.7 64-64 64c-5.6 0-11.1-.7-16.3-2.1c-3 28.2-26.8 50.1-55.7 50.1c-30.9 0-56-25.1-56-56V56c0-30.9 25.1-56 56-56z"
    ]
};
var $5c8203742f0e3062$export$658a137d3845bca7 = {
    prefix: "fas",
    iconName: "bandage",
    icon: [
        640,
        512,
        [
            129657,
            "band-aid"
        ],
        "f462",
        "M480 416h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H480V416zM448 96H192V416H448V96zM64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64h96V96H64zM248 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $5c8203742f0e3062$export$b14a1014df2fdf46 = $5c8203742f0e3062$export$658a137d3845bca7;
var $5c8203742f0e3062$export$23e8b4955c2d951b = {
    prefix: "fas",
    iconName: "calendar-minus",
    icon: [
        448,
        512,
        [],
        "f272",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM312 376c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-13.3 0-24 10.7-24 24s10.7 24 24 24H312z"
    ]
};
var $5c8203742f0e3062$export$30262489773a79a3 = {
    prefix: "fas",
    iconName: "circle-xmark",
    icon: [
        512,
        512,
        [
            61532,
            "times-circle",
            "xmark-circle"
        ],
        "f057",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $5c8203742f0e3062$export$ab0ec50720a747eb = $5c8203742f0e3062$export$30262489773a79a3;
var $5c8203742f0e3062$export$90ac4096df8efdee = $5c8203742f0e3062$export$30262489773a79a3;
var $5c8203742f0e3062$export$de9a67b55dbe819a = {
    prefix: "fas",
    iconName: "gifts",
    icon: [
        640,
        512,
        [],
        "f79c",
        "M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16L144.7 46.2l-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l8.3 25-27.4-20c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5L70.2 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H200.6c-5.4-9.4-8.6-20.3-8.6-32V256c0-29.9 20.5-55 48.2-62c1.8-31 17.1-58.2 40.1-76.1C271.7 104.7 256.9 96 240 96H217.8l28.3-20.6c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3L192.5 55.1 200.6 32zM363.5 185.5L393.1 224H344c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24H272c-26.5 0-48 21.5-48 48v80H416V256h32v96H640V272c0-26.5-21.5-48-48-48h-4.1c2.7-7.5 4.1-15.6 4.1-24c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72zM224 464c0 26.5 21.5 48 48 48H416V384H224v80zm224 48H592c26.5 0 48-21.5 48-48V384H448V512zm96-312c0 13.3-10.7 24-24 24H470.9l29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5c13.4 0 24.2 10.9 24.2 24z"
    ]
};
var $5c8203742f0e3062$export$c402efcf01d5ca07 = {
    prefix: "fas",
    iconName: "hotel",
    icon: [
        512,
        512,
        [
            127976
        ],
        "f594",
        "M0 32C0 14.3 14.3 0 32 0H480c17.7 0 32 14.3 32 32s-14.3 32-32 32V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H304V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64C14.3 64 0 49.7 0 32zm96 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM240 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H240zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM112 192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H112zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H368zM328 384c13.3 0 24.3-10.9 21-23.8c-10.6-41.5-48.2-72.2-93-72.2s-82.5 30.7-93 72.2c-3.3 12.8 7.8 23.8 21 23.8H328z"
    ]
};
var $5c8203742f0e3062$export$807cdd395fe012cb = {
    prefix: "fas",
    iconName: "earth-asia",
    icon: [
        512,
        512,
        [
            127759,
            "globe-asia"
        ],
        "f57e",
        "M51.7 295.1l31.7 6.3c7.9 1.6 16-.9 21.7-6.6l15.4-15.4c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7c15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9h2.3c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17-4.3c7.5-1.9 13.6-7.2 16.5-14.4l16.4-40.9C303.4 52.1 280.2 48 256 48C141.1 48 48 141.1 48 256c0 13.4 1.3 26.5 3.7 39.1zm407.7 4.6c-3-.3-6-.1-9 .8l-15.8 4.4c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.5 21.1l2.6-1c10-3.7 21.3-2.2 29.9 4.1l1.5 1.1c37.2-29.5 64.1-71.4 74.4-119.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144.5 92.1c-2.1 8.6 3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8c-8.6-2.1-17.3 3.1-19.4 11.6zm92-20c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32zM343.2 113.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l16-32c4-7.9 .7-17.5-7.2-21.5z"
    ]
};
var $5c8203742f0e3062$export$796fdfc909e603f4 = $5c8203742f0e3062$export$807cdd395fe012cb;
var $5c8203742f0e3062$export$31e6961064ddac7b = {
    prefix: "fas",
    iconName: "id-card-clip",
    icon: [
        576,
        512,
        [
            "id-card-alt"
        ],
        "f47f",
        "M256 0h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM64 64H192v48c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64zM176 437.3c0 5.9 4.8 10.7 10.7 10.7H389.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H229.3c-29.5 0-53.3 23.9-53.3 53.3zM288 352a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
    ]
};
var $5c8203742f0e3062$export$dc37ebbac31f6c6c = $5c8203742f0e3062$export$31e6961064ddac7b;
var $5c8203742f0e3062$export$f48a3ba52a0a9e56 = {
    prefix: "fas",
    iconName: "magnifying-glass-plus",
    icon: [
        512,
        512,
        [
            "search-plus"
        ],
        "f00e",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
    ]
};
var $5c8203742f0e3062$export$378f00e6b1a8185 = $5c8203742f0e3062$export$f48a3ba52a0a9e56;
var $5c8203742f0e3062$export$47e4e0d519d33497 = {
    prefix: "fas",
    iconName: "thumbs-up",
    icon: [
        512,
        512,
        [
            128077,
            61575
        ],
        "f164",
        "M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2H464c26.5 0 48 21.5 48 48c0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1c4.4 7.3 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48H294.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V320 272 247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$b00596a09aa07311 = {
    prefix: "fas",
    iconName: "user-clock",
    icon: [
        640,
        512,
        [],
        "f4fd",
        "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304h91.4c20.6 0 40.4 3.5 58.8 9.9C323 331 320 349.1 320 368c0 59.5 29.5 112.1 74.8 144H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304c0-8.8-7.2-16-16-16z"
    ]
};
var $5c8203742f0e3062$export$8846d49caaed1c0a = {
    prefix: "fas",
    iconName: "hand-dots",
    icon: [
        512,
        512,
        [
            "allergies"
        ],
        "f461",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32zM240 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM240 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $5c8203742f0e3062$export$dcae2101babbffff = $5c8203742f0e3062$export$8846d49caaed1c0a;
var $5c8203742f0e3062$export$bef39294aed2281a = {
    prefix: "fas",
    iconName: "file-invoice",
    icon: [
        384,
        512,
        [],
        "f570",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm0 32v64H288V256H96zM240 416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $5c8203742f0e3062$export$26a3f9d2784b90d8 = {
    prefix: "fas",
    iconName: "window-minimize",
    icon: [
        512,
        512,
        [
            128469
        ],
        "f2d1",
        "M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $5c8203742f0e3062$export$60048819854688c5 = {
    prefix: "fas",
    iconName: "mug-saucer",
    icon: [
        640,
        512,
        [
            "coffee"
        ],
        "f0f4",
        "M96 64c0-17.7 14.3-32 32-32H448h64c70.7 0 128 57.3 128 128s-57.3 128-128 128H480c0 53-43 96-96 96H192c-53 0-96-43-96-96V64zM480 224h32c35.3 0 64-28.7 64-64s-28.7-64-64-64H480V224zM32 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$1d24a9e457278011 = $5c8203742f0e3062$export$60048819854688c5;
var $5c8203742f0e3062$export$5824ffe6f8983c83 = {
    prefix: "fas",
    iconName: "brush",
    icon: [
        384,
        512,
        [],
        "f55d",
        "M162.4 6c-1.5-3.6-5-6-8.9-6h-19c-3.9 0-7.5 2.4-8.9 6L104.9 57.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6H48C21.5 0 0 21.5 0 48V224v22.4V256H9.6 374.4 384v-9.6V224 48c0-26.5-21.5-48-48-48H230.5c-3.9 0-7.5 2.4-8.9 6L200.9 57.7c-3.2 8-14.6 8-17.8 0L162.4 6zM0 288v32c0 35.3 28.7 64 64 64h64v64c0 35.3 28.7 64 64 64s64-28.7 64-64V384h64c35.3 0 64-28.7 64-64V288H0zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $5c8203742f0e3062$export$7b028758c03b9655 = {
    prefix: "fas",
    iconName: "mask",
    icon: [
        576,
        512,
        [],
        "f6fa",
        "M288 64C64 64 0 160 0 272S80 448 176 448h8.4c24.2 0 46.4-13.7 57.2-35.4l23.2-46.3c4.4-8.8 13.3-14.3 23.2-14.3s18.8 5.5 23.2 14.3l23.2 46.3c10.8 21.7 33 35.4 57.2 35.4H400c96 0 176-64 176-176s-64-208-288-208zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $5c8203742f0e3062$export$56d810b9ab2e30bc = {
    prefix: "fas",
    iconName: "magnifying-glass-minus",
    icon: [
        512,
        512,
        [
            "search-minus"
        ],
        "f010",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H136z"
    ]
};
var $5c8203742f0e3062$export$efca97eef6a7a17d = $5c8203742f0e3062$export$56d810b9ab2e30bc;
var $5c8203742f0e3062$export$a6ad5df9d9f29553 = {
    prefix: "fas",
    iconName: "ruler-vertical",
    icon: [
        256,
        512,
        [],
        "f548",
        "M0 48C0 21.5 21.5 0 48 0H208c26.5 0 48 21.5 48 48V96H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"
    ]
};
var $5c8203742f0e3062$export$50a28538498238f = {
    prefix: "fas",
    iconName: "user-large",
    icon: [
        512,
        512,
        [
            "user-alt"
        ],
        "f406",
        "M256 288A144 144 0 1 0 256 0a144 144 0 1 0 0 288zm-94.7 32C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7H481.3c17 0 30.7-13.8 30.7-30.7C512 392.2 439.8 320 350.7 320H161.3z"
    ]
};
var $5c8203742f0e3062$export$ae9b19c2ac726cfc = $5c8203742f0e3062$export$50a28538498238f;
var $5c8203742f0e3062$export$d401d4aeba21cdf3 = {
    prefix: "fas",
    iconName: "train-tram",
    icon: [
        448,
        512,
        [
            128650
        ],
        "e5b4",
        "M86.8 48c-12.2 0-23.6 5.5-31.2 15L42.7 79C34.5 89.3 19.4 91 9 82.7S-3 59.4 5.3 49L18 33C34.7 12.2 60 0 86.8 0H361.2c26.7 0 52 12.2 68.7 33l12.8 16c8.3 10.4 6.6 25.5-3.8 33.7s-25.5 6.6-33.7-3.7L392.5 63c-7.6-9.5-19.1-15-31.2-15H248V96h40c53 0 96 43 96 96V352c0 30.6-14.3 57.8-36.6 75.4l65.5 65.5c7.1 7.1 2.1 19.1-7.9 19.1H365.3c-8.5 0-16.6-3.4-22.6-9.4L288 448H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H43c-10 0-15-12.1-7.9-19.1l65.5-65.5C78.3 409.8 64 382.6 64 352V192c0-53 43-96 96-96h40V48H86.8zM160 160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H160zm32 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $5c8203742f0e3062$export$ab9af5aa013d2162 = {
    prefix: "fas",
    iconName: "user-nurse",
    icon: [
        448,
        512,
        [],
        "f82f",
        "M96 128V70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V128h-.3c.2 2.6 .3 5.3 .3 8v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V136c0-2.7 .1-5.4 .3-8H96zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80V160H144v16zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6zM208 48V64H192c-4.4 0-8 3.6-8 8V88c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V96h16c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8H240V48c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8z"
    ]
};
var $5c8203742f0e3062$export$1aa9423ec6b1d609 = {
    prefix: "fas",
    iconName: "syringe",
    icon: [
        512,
        512,
        [
            128137
        ],
        "f48e",
        "M441 7l32 32 32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15L417.9 128l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72L295 73c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L422.1 56 407 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM210.3 155.7l61.1-61.1c.3 .3 .6 .7 1 1l16 16 56 56 56 56 16 16c.3 .3 .6 .6 1 1l-191 191c-10.5 10.5-24.7 16.4-39.6 16.4H97.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57V325.3c0-14.9 5.9-29.1 16.4-39.6l43.3-43.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57z"
    ]
};
var $5c8203742f0e3062$export$dcaadfd9c98e42a1 = {
    prefix: "fas",
    iconName: "cloud-sun",
    icon: [
        640,
        512,
        [
            9925
        ],
        "f6c4",
        "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 84.7 14.1c5.4 .9 10 4.5 12.1 9.6s1.5 10.9-1.6 15.4l-38.5 55c-2.2-.1-4.4-.2-6.7-.2c-23.3 0-45.1 6.2-64 17.1l0-1.1c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM639.9 431.9c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
var $5c8203742f0e3062$export$df6244b0501f2112 = {
    prefix: "fas",
    iconName: "stopwatch-20",
    icon: [
        448,
        512,
        [],
        "e06f",
        "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H176zM288 204c28.7 0 52 23.3 52 52v96c0 28.7-23.3 52-52 52s-52-23.3-52-52V256c0-28.7 23.3-52 52-52zm-12 52v96c0 6.6 5.4 12 12 12s12-5.4 12-12V256c0-6.6-5.4-12-12-12s-12 5.4-12 12zM159.5 244c-5.4 0-10.2 3.5-11.9 8.6l-.6 1.7c-3.5 10.5-14.8 16.1-25.3 12.6s-16.1-14.8-12.6-25.3l.6-1.7c7.2-21.5 27.2-35.9 49.8-35.9c29 0 52.5 23.5 52.5 52.5v2.2c0 13.4-4.9 26.4-13.8 36.4l-39 43.9c-6.2 7-10 15.7-10.9 24.9H192c11 0 20 9 20 20s-9 20-20 20H128c-11 0-20-9-20-20V368.3c0-20.6 7.5-40.4 21.2-55.8l39-43.9c2.4-2.7 3.7-6.2 3.7-9.8v-2.2c0-6.9-5.6-12.5-12.5-12.5z"
    ]
};
var $5c8203742f0e3062$export$7ec6541fee081990 = {
    prefix: "fas",
    iconName: "square-full",
    icon: [
        512,
        512,
        [
            128997,
            128998,
            128999,
            129000,
            129001,
            129002,
            129003,
            11035,
            11036
        ],
        "f45c",
        "M0 0H512V512H0V0z"
    ]
};
var $5c8203742f0e3062$export$78932e9c9abea6b7 = {
    prefix: "fas",
    iconName: "magnet",
    icon: [
        448,
        512,
        [
            129522
        ],
        "f076",
        "M0 160v96C0 379.7 100.3 480 224 480s224-100.3 224-224V160H320v96c0 53-43 96-96 96s-96-43-96-96V160H0zm0-32H128V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64zm320 0H448V64c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32v64z"
    ]
};
var $5c8203742f0e3062$export$53583b459a87a01 = {
    prefix: "fas",
    iconName: "jar",
    icon: [
        320,
        512,
        [],
        "e516",
        "M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm96 64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H96z"
    ]
};
var $5c8203742f0e3062$export$4a4e034527c933f5 = {
    prefix: "fas",
    iconName: "note-sticky",
    icon: [
        448,
        512,
        [
            62026,
            "sticky-note"
        ],
        "f249",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H288V368c0-26.5 21.5-48 48-48H448V96c0-35.3-28.7-64-64-64H64zM448 352H402.7 336c-8.8 0-16 7.2-16 16v66.7V480l32-32 64-64 32-32z"
    ]
};
var $5c8203742f0e3062$export$80889adc5d98bf4a = $5c8203742f0e3062$export$4a4e034527c933f5;
var $5c8203742f0e3062$export$fc4dd5feed8df23 = {
    prefix: "fas",
    iconName: "bug-slash",
    icon: [
        640,
        512,
        [],
        "e490",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L477.4 348.9c1.7-9.4 2.6-19 2.6-28.9h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H479.7c-1.1-14.1-5-27.5-11.1-39.5c.7-.6 1.4-1.2 2.1-1.9l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-.7 .7-1.3 1.4-1.9 2.1C409.2 164.1 393.1 160 376 160H264c-8.3 0-16.3 1-24 2.8L38.8 5.1zm392 430.3L336 360.7V479.2c36.6-3.6 69.7-19.6 94.8-43.8zM166.7 227.3c-3.4 9-5.6 18.7-6.4 28.7H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c0 24.6 5.5 47.8 15.4 68.6c-2.2 1.3-4.2 2.9-6 4.8l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l63.1-63.1c24.5 21.8 55.8 36.2 90.3 39.6V335.5L166.7 227.3zM320 0c-53 0-96 43-96 96v3.6c0 15.7 12.7 28.4 28.4 28.4H387.6c15.7 0 28.4-12.7 28.4-28.4V96c0-53-43-96-96-96z"
    ]
};
var $5c8203742f0e3062$export$1a093e7861c5e48f = {
    prefix: "fas",
    iconName: "arrow-up-from-water-pump",
    icon: [
        576,
        512,
        [],
        "e4b6",
        "M112 0C85.5 0 64 21.5 64 48V256H48c-26.5 0-48 21.5-48 48v96c0 8 2 15.6 5.4 22.2c3.8-1.7 7.8-3.1 12-4.1c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c4.2 1 8.2 2.4 12 4.1C574 415.6 576 408 576 400V304c0-26.5-21.5-48-48-48H480l0-146.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 109.3 416 256H288V48c0-26.5-21.5-48-48-48H112zM306.5 421.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
var $5c8203742f0e3062$export$5902c007d5703f2d = {
    prefix: "fas",
    iconName: "bone",
    icon: [
        576,
        512,
        [
            129460
        ],
        "f5d7",
        "M153.7 144.8c6.9 16.3 20.6 31.2 38.3 31.2H384c17.7 0 31.4-14.9 38.3-31.2C434.4 116.1 462.9 96 496 96c44.2 0 80 35.8 80 80c0 30.4-17 56.9-42 70.4c-3.6 1.9-6 5.5-6 9.6s2.4 7.7 6 9.6c25 13.5 42 40 42 70.4c0 44.2-35.8 80-80 80c-33.1 0-61.6-20.1-73.7-48.8C415.4 350.9 401.7 336 384 336H192c-17.7 0-31.4 14.9-38.3 31.2C141.6 395.9 113.1 416 80 416c-44.2 0-80-35.8-80-80c0-30.4 17-56.9 42-70.4c3.6-1.9 6-5.5 6-9.6s-2.4-7.7-6-9.6C17 232.9 0 206.4 0 176c0-44.2 35.8-80 80-80c33.1 0 61.6 20.1 73.7 48.8z"
    ]
};
var $5c8203742f0e3062$export$c950c1ba7f227d5b = {
    prefix: "fas",
    iconName: "user-injured",
    icon: [
        448,
        512,
        [],
        "f728",
        "M240 80H342.7c-7.9-19.5-20.4-36.5-36.2-49.9L240 80zm37.7-68.2C261.3 4.2 243.2 0 224 0c-53.7 0-99.7 33.1-118.7 80h81.4l91-68.2zM224 256c70.7 0 128-57.3 128-128c0-5.4-.3-10.8-1-16H97c-.7 5.2-1 10.6-1 16c0 70.7 57.3 128 128 128zM124 312.4c-9.7 3.1-19.1 7-28 11.7V512H243.7L181.5 408.2 124 312.4zm33-7.2L204.3 384H272c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48h82.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3c-7.2 0-14.3 .4-21.3 1.3zM0 482.3C0 498.7 13.3 512 29.7 512H64V345.4C24.9 378.1 0 427.3 0 482.3zM320 464c0-26.5-21.5-48-48-48H223.5l57.1 95.2C303 507.2 320 487.6 320 464z"
    ]
};
var $5c8203742f0e3062$export$8a5a0dbb2a17e253 = {
    prefix: "fas",
    iconName: "face-sad-tear",
    icon: [
        512,
        512,
        [
            128546,
            "sad-tear"
        ],
        "f5b4",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm240 80c0-8.8 7.2-16 16-16c45 0 85.6 20.5 115.7 53.1c6 6.5 5.6 16.6-.9 22.6s-16.6 5.6-22.6-.9c-25-27.1-57.4-42.9-92.3-42.9c-8.8 0-16-7.2-16-16zm-80 80c-26.5 0-48-21-48-47c0-20 28.6-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C179.6 308.6 208 349 208 369c0 26-21.5 47-48 47zM367.6 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$4b5241926f692f91 = $5c8203742f0e3062$export$8a5a0dbb2a17e253;
var $5c8203742f0e3062$export$f654c69e66b466c0 = {
    prefix: "fas",
    iconName: "plane",
    icon: [
        576,
        512,
        [],
        "f072",
        "M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"
    ]
};
var $5c8203742f0e3062$export$51adfe7c9ee4f428 = {
    prefix: "fas",
    iconName: "tent-arrows-down",
    icon: [
        576,
        512,
        [],
        "e581",
        "M209.8 111.9c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36L136 24c0-13.3-10.7-24-24-24S88 10.7 88 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm352 0c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V146.1l-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H240h16c17.7 0 32-14.3 32-32V361.9c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7H464h16c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $5c8203742f0e3062$export$de6218b649cbb6a9 = {
    prefix: "fas",
    iconName: "exclamation",
    icon: [
        64,
        512,
        [
            10069,
            10071,
            61738
        ],
        "21",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM32 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $5c8203742f0e3062$export$7e05388be208e313 = {
    prefix: "fas",
    iconName: "arrows-spin",
    icon: [
        512,
        512,
        [],
        "e4bb",
        "M256 96c38.4 0 73.7 13.5 101.3 36.1l-32.6 32.6c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H448c8.8 0 16-7.2 16-16V64c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-34 34C363.4 52.6 312.1 32 256 32c-10.9 0-21.5 .8-32 2.3V99.2c10.3-2.1 21-3.2 32-3.2zM132.1 154.7l32.6 32.6c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V64c0-8.8-7.2-16-16-16H64c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l34 34C52.6 148.6 32 199.9 32 256c0 10.9 .8 21.5 2.3 32H99.2c-2.1-10.3-3.2-21-3.2-32c0-38.4 13.5-73.7 36.1-101.3zM477.7 224H412.8c2.1 10.3 3.2 21 3.2 32c0 38.4-13.5 73.7-36.1 101.3l-32.6-32.6c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8V448c0 8.8 7.2 16 16 16H448c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-34-34C459.4 363.4 480 312.1 480 256c0-10.9-.8-21.5-2.3-32zM256 416c-38.4 0-73.7-13.5-101.3-36.1l32.6-32.6c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H64c-8.8 0-16 7.2-16 16l0 112c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l34-34C148.6 459.4 199.9 480 256 480c10.9 0 21.5-.8 32-2.3V412.8c-10.3 2.1-21 3.2-32 3.2z"
    ]
};
var $5c8203742f0e3062$export$ae64371e02ee8e56 = {
    prefix: "fas",
    iconName: "print",
    icon: [
        512,
        512,
        [
            128424,
            128438,
            9113
        ],
        "f02f",
        "M128 0C92.7 0 64 28.7 64 64v96h64V64H354.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM384 352v32 64H128V384 368 352H384zm64 32h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $5c8203742f0e3062$export$b458d393151b6960 = {
    prefix: "fas",
    iconName: "turkish-lira-sign",
    icon: [
        384,
        512,
        [
            "try",
            "turkish-lira"
        ],
        "e2bb",
        "M96 32c17.7 0 32 14.3 32 32V99.3L247.2 65.2c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 165.9v29.4l119.2-34.1c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 261.9V416h63.8c68.2 0 124.4-53.5 127.8-121.6l.4-8c.9-17.7 15.9-31.2 33.6-30.4s31.2 15.9 30.4 33.6l-.4 8C378.5 399.8 294.1 480 191.8 480H96c-17.7 0-32-14.3-32-32V280.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 213.6V184.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 117.6V64c0-17.7 14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$970dda513e46c41f = $5c8203742f0e3062$export$b458d393151b6960;
var $5c8203742f0e3062$export$40e66e5966827199 = $5c8203742f0e3062$export$b458d393151b6960;
var $5c8203742f0e3062$export$fb420d3e4d8c6a18 = {
    prefix: "fas",
    iconName: "dollar-sign",
    icon: [
        320,
        512,
        [
            128178,
            61781,
            "dollar",
            "usd"
        ],
        "24",
        "M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32z"
    ]
};
var $5c8203742f0e3062$export$a4ffb0775547fcdf = $5c8203742f0e3062$export$fb420d3e4d8c6a18;
var $5c8203742f0e3062$export$72cca07d38a28589 = $5c8203742f0e3062$export$fb420d3e4d8c6a18;
var $5c8203742f0e3062$export$476af662c0c32cbc = {
    prefix: "fas",
    iconName: "x",
    icon: [
        384,
        512,
        [
            120
        ],
        "58",
        "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"
    ]
};
var $5c8203742f0e3062$export$fa4f1ead37dc1dce = {
    prefix: "fas",
    iconName: "magnifying-glass-dollar",
    icon: [
        512,
        512,
        [
            "search-dollar"
        ],
        "f688",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM228 104c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"
    ]
};
var $5c8203742f0e3062$export$65b49a6767630708 = $5c8203742f0e3062$export$fa4f1ead37dc1dce;
var $5c8203742f0e3062$export$3a18218720110fc0 = {
    prefix: "fas",
    iconName: "users-gear",
    icon: [
        640,
        512,
        [
            "users-cog"
        ],
        "f509",
        "M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H455.2c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2-2.4-4.1-.1-.2-.1-.2c-3.4-6.2-6.4-12.6-9-19.3c-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5c0-.8 0-1.5 0-2.3s0-1.5 0-2.3l-2.7-1.5zM533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5 .9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3 .6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3 .7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zm91.3 163.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1v-3.4c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 17.9l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1v3.4c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM472 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"
    ]
};
var $5c8203742f0e3062$export$5e0b06753fc69b81 = $5c8203742f0e3062$export$3a18218720110fc0;
var $5c8203742f0e3062$export$50b6dcaa9ec03439 = {
    prefix: "fas",
    iconName: "person-military-pointing",
    icon: [
        576,
        512,
        [],
        "e54a",
        "M246.9 14.1C234 15.2 224 26 224 39c0 13.8 11.2 25 25 25H400c8.8 0 16-7.2 16-16V17.4C416 8 408 .7 398.7 1.4L246.9 14.1zM240 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H241.6c-1 5.2-1.6 10.5-1.6 16zM72 224c-22.1 0-40 17.9-40 40s17.9 40 40 40H224v89.4L386.8 230.5c-13.3-4.3-27.3-6.5-41.6-6.5H240 72zm345.7 20.9L246.6 416H416V369.7l53.6 90.6c11.2 19 35.8 25.3 54.8 14.1s25.3-35.8 14.1-54.8L462.3 290.8c-11.2-18.9-26.6-34.5-44.6-45.9zM224 448v32c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V448H224z"
    ]
};
var $5c8203742f0e3062$export$a411e7e26cb63d5e = {
    prefix: "fas",
    iconName: "building-columns",
    icon: [
        512,
        512,
        [
            "bank",
            "institution",
            "museum",
            "university"
        ],
        "f19c",
        "M243.4 2.6l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24v-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8-3.4-17.2-3.4-25.2 0zM128 224H64V420.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V224H384V416H344V224H280V416H232V224H168V416H128V224zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $5c8203742f0e3062$export$6e379b829ea8b99 = $5c8203742f0e3062$export$a411e7e26cb63d5e;
var $5c8203742f0e3062$export$1dba320226a34c1f = $5c8203742f0e3062$export$a411e7e26cb63d5e;
var $5c8203742f0e3062$export$9b3953adff472ad2 = $5c8203742f0e3062$export$a411e7e26cb63d5e;
var $5c8203742f0e3062$export$f2e1460ebe1a8cb0 = $5c8203742f0e3062$export$a411e7e26cb63d5e;
var $5c8203742f0e3062$export$9ff64ffae70e08c0 = {
    prefix: "fas",
    iconName: "umbrella",
    icon: [
        576,
        512,
        [],
        "f0e9",
        "M288 0c17.7 0 32 14.3 32 32V49.7C451.8 63.4 557.7 161 573.9 285.9c2 15.6-17.3 24.4-27.8 12.7C532.1 283 504.8 272 480 272c-38.7 0-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C359 299.5 326.7 272 288 272s-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C167 299.5 134.7 272 96 272c-24.8 0-52.1 11-66.1 26.7C19.4 310.4 .1 301.5 2.1 285.9C18.3 161 124.2 63.4 256 49.7V32c0-17.7 14.3-32 32-32zm0 304c12.3 0 23.5 4.6 32 12.2V430.6c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4V316.2c8.5-7.6 19.7-12.2 32-12.2z"
    ]
};
var $5c8203742f0e3062$export$12ca996a6f686fe1 = {
    prefix: "fas",
    iconName: "trowel",
    icon: [
        512,
        512,
        [],
        "e589",
        "M343.9 213.4L245.3 312l65.4 65.4c7.9 7.9 11.1 19.4 8.4 30.3s-10.8 19.6-21.5 22.9l-256 80c-11.4 3.5-23.8 .5-32.2-7.9S-2.1 481.8 1.5 470.5l80-256c3.3-10.7 12-18.9 22.9-21.5s22.4 .5 30.3 8.4L200 266.7l98.6-98.6c-14.3-14.6-14.2-38 .3-52.5l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0s26.9 70.5 0 97.5l-95.4 95.4c-14.5 14.5-37.9 14.6-52.5 .3z"
    ]
};
var $5c8203742f0e3062$export$56c73b799aac2555 = {
    prefix: "fas",
    iconName: "d",
    icon: [
        384,
        512,
        [
            100
        ],
        "44",
        "M0 96C0 60.7 28.7 32 64 32h96c123.7 0 224 100.3 224 224s-100.3 224-224 224H64c-35.3 0-64-28.7-64-64V96zm160 0H64V416h96c88.4 0 160-71.6 160-160s-71.6-160-160-160z"
    ]
};
var $5c8203742f0e3062$export$c7e014b7e3ac3d83 = {
    prefix: "fas",
    iconName: "stapler",
    icon: [
        640,
        512,
        [],
        "e5af",
        "M640 299.3V304 432c0 26.5-21.5 48-48 48H512 448 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H448V368H96c-17.7 0-32-14.3-32-32V219.4L33.8 214C14.2 210.5 0 193.5 0 173.7c0-8.9 2.9-17.5 8.2-24.6l35.6-47.5C76.7 57.8 128.2 32 182.9 32c27 0 53.6 6.3 77.8 18.4L586.9 213.5C619.5 229.7 640 263 640 299.3zM448 304V288L128 230.9V304H448z"
    ]
};
var $5c8203742f0e3062$export$bf5896cc1ce4d55 = {
    prefix: "fas",
    iconName: "masks-theater",
    icon: [
        640,
        512,
        [
            127917,
            "theater-masks"
        ],
        "f630",
        "M74.6 373.2c41.7 36.1 108 82.5 166.1 73.7c6.1-.9 12.1-2.5 18-4.5c-9.2-12.3-17.3-24.4-24.2-35.4c-21.9-35-28.8-75.2-25.9-113.6c-20.6 4.1-39.2 13-54.7 25.4c-6.5 5.2-16.3 1.3-14.8-7c6.4-33.5 33-60.9 68.2-66.3c2.6-.4 5.3-.7 7.9-.8l19.4-131.3c2-13.8 8-32.7 25-45.9C278.2 53.2 310.5 37 363.2 32.2c-.8-.7-1.6-1.4-2.4-2.1C340.6 14.5 288.4-11.5 175.7 5.6S20.5 63 5.7 83.9C0 91.9-.8 102 .6 111.8L24.8 276.1c5.5 37.3 21.5 72.6 49.8 97.2zm87.7-219.6c4.4-3.1 10.8-2 11.8 3.3c.1 .5 .2 1.1 .3 1.6c3.2 21.8-11.6 42-33.1 45.3s-41.5-11.8-44.7-33.5c-.1-.5-.1-1.1-.2-1.6c-.6-5.4 5.2-8.4 10.3-6.7c9 3 18.8 3.9 28.7 2.4s19.1-5.3 26.8-10.8zM261.6 390c29.4 46.9 79.5 110.9 137.6 119.7s124.5-37.5 166.1-73.7c28.3-24.5 44.3-59.8 49.8-97.2l24.2-164.3c1.4-9.8 .6-19.9-5.1-27.9c-14.8-20.9-57.3-61.2-170-78.3S299.4 77.2 279.2 92.8c-7.8 6-11.5 15.4-12.9 25.2L242.1 282.3c-5.5 37.3-.4 75.8 19.6 107.7zM404.5 235.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6c-1 5.3-7.4 6.4-11.8 3.3zm136.2 15.5c-1 5.3-7.4 6.4-11.8 3.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6zM530 350.2c-19.6 44.7-66.8 72.5-116.8 64.9s-87.1-48.2-93-96.7c-1-8.3 8.9-12.1 15.2-6.7c23.9 20.8 53.6 35.3 87 40.3s66.1 .1 94.9-12.8c7.6-3.4 16 3.2 12.6 10.9z"
    ]
};
var $5c8203742f0e3062$export$3dbedc487b0159ac = $5c8203742f0e3062$export$bf5896cc1ce4d55;
var $5c8203742f0e3062$export$a6df39524c41472c = {
    prefix: "fas",
    iconName: "kip-sign",
    icon: [
        384,
        512,
        [],
        "e1c4",
        "M340.8 88.3c13.4-11.5 15-31.7 3.5-45.1s-31.7-15-45.1-3.5L128 186.4V64c0-17.7-14.3-32-32-32S64 46.3 64 64V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V325.6L299.2 472.3c13.4 11.5 33.6 9.9 45.1-3.5s9.9-33.6-3.5-45.1L182.5 288H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H182.5L340.8 88.3z"
    ]
};
var $5c8203742f0e3062$export$b276ec3dc9760d39 = {
    prefix: "fas",
    iconName: "hand-point-left",
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l208 0 0-64L32 96zM192 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm-64-64c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32zm96 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm88-96l-.6 0c5.4 9.4 8.6 20.3 8.6 32c0 13.2-4 25.4-10.8 35.6c24.9 8.7 42.8 32.5 42.8 60.4c0 11.7-3.1 22.6-8.6 32l8.6 0c88.4 0 160-71.6 160-160l0-61.7c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64l-27 0c-35.3 0-64 28.7-64 64l0 88c0 22.1 17.9 40 40 40s40-17.9 40-40l0-56c0-8.8 7.2-16 16-16s16 7.2 16 16l0 56c0 39.8-32.2 72-72 72z"
    ]
};
var $5c8203742f0e3062$export$e8485db4dab0ab30 = {
    prefix: "fas",
    iconName: "handshake-simple",
    icon: [
        640,
        512,
        [
            129309,
            "handshake-alt"
        ],
        "f4c6",
        "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48H48c-26.5 0-48 21.5-48 48V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123z"
    ]
};
var $5c8203742f0e3062$export$e9aa3c6f9f47aa1a = $5c8203742f0e3062$export$e8485db4dab0ab30;
var $5c8203742f0e3062$export$2130e629ab767ab3 = {
    prefix: "fas",
    iconName: "jet-fighter",
    icon: [
        640,
        512,
        [
            "fighter-jet"
        ],
        "f0fb",
        "M160 24c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H280L384 192H500.4c7.7 0 15.3 1.4 22.5 4.1L625 234.4c9 3.4 15 12 15 21.6s-6 18.2-15 21.6L522.9 315.9c-7.2 2.7-14.8 4.1-22.5 4.1H384L280 464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V320H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H82.7c8.5 0 16.6 3.4 22.6 9.4L160 192h32V48h-8c-13.3 0-24-10.7-24-24zM80 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"
    ]
};
var $5c8203742f0e3062$export$102b809faf56e033 = $5c8203742f0e3062$export$2130e629ab767ab3;
var $5c8203742f0e3062$export$1bdb0ec5af3fea99 = {
    prefix: "fas",
    iconName: "square-share-nodes",
    icon: [
        448,
        512,
        [
            "share-alt-square"
        ],
        "f1e1",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM384 160c0 35.3-28.7 64-64 64c-15.4 0-29.5-5.4-40.6-14.5L194.1 256l85.3 46.5c11-9.1 25.2-14.5 40.6-14.5c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-2.5 .1-4.9 .4-7.3L174.5 300c-11.7 12.3-28.2 20-46.5 20c-35.3 0-64-28.7-64-64s28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3c0-35.3 28.7-64 64-64s64 28.7 64 64z"
    ]
};
var $5c8203742f0e3062$export$3799c2d8fd7e493b = $5c8203742f0e3062$export$1bdb0ec5af3fea99;
var $5c8203742f0e3062$export$3825a842b5afc5aa = {
    prefix: "fas",
    iconName: "barcode",
    icon: [
        512,
        512,
        [],
        "f02a",
        "M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24H40c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H184zm96 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H280zM448 56V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H472c-13.3 0-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
    ]
};
var $5c8203742f0e3062$export$37bd38cf96417095 = {
    prefix: "fas",
    iconName: "plus-minus",
    icon: [
        384,
        512,
        [],
        "e43c",
        "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H160V320c0 17.7 14.3 32 32 32s32-14.3 32-32V208H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V32zM0 480c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"
    ]
};
var $5c8203742f0e3062$export$5c6bd8729527871b = {
    prefix: "fas",
    iconName: "video",
    icon: [
        576,
        512,
        [
            "video-camera"
        ],
        "f03d",
        "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"
    ]
};
var $5c8203742f0e3062$export$3a530df752193ccf = $5c8203742f0e3062$export$5c6bd8729527871b;
var $5c8203742f0e3062$export$874e305fd7920cce = {
    prefix: "fas",
    iconName: "graduation-cap",
    icon: [
        640,
        512,
        [
            127891,
            "mortar-board"
        ],
        "f19d",
        "M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9v28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5V291.9c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z"
    ]
};
var $5c8203742f0e3062$export$dd0a013bf23a9d86 = $5c8203742f0e3062$export$874e305fd7920cce;
var $5c8203742f0e3062$export$bb2a6b1b5e852300 = {
    prefix: "fas",
    iconName: "hand-holding-medical",
    icon: [
        576,
        512,
        [],
        "e05c",
        "M224 24V80H168c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h56v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176h56c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H320V24c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zM559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2l.9 0 0 0c-.3 0-.6 0-.9 0z"
    ]
};
var $5c8203742f0e3062$export$30294c81ac4031ca = {
    prefix: "fas",
    iconName: "person-circle-check",
    icon: [
        576,
        512,
        [],
        "e53e",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $5c8203742f0e3062$export$314f5cab62fc6968 = {
    prefix: "fas",
    iconName: "turn-up",
    icon: [
        384,
        512,
        [
            10548,
            "level-up-alt"
        ],
        "f3bf",
        "M350 177.5c3.8-8.8 2-19-4.6-26l-136-144C204.9 2.7 198.6 0 192 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26s12.5 14.5 22 14.5h88l0 192c0 17.7-14.3 32-32 32H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32l80 0c70.7 0 128-57.3 128-128l0-192h88c9.6 0 18.2-5.7 22-14.5z"
    ]
};
var $5c8203742f0e3062$export$d6f21a309b179c3d = $5c8203742f0e3062$export$314f5cab62fc6968;
var $5c8203742f0e3062$export$da048c47c8dcd50a = {
    fa0: $5c8203742f0e3062$export$f22454595d96c106,
    fa1: $5c8203742f0e3062$export$8398cb2addc9e182,
    fa2: $5c8203742f0e3062$export$ed1a0ff7bd680a1d,
    fa3: $5c8203742f0e3062$export$74b7ff79ce1818d6,
    fa4: $5c8203742f0e3062$export$969b2215780d58fd,
    fa5: $5c8203742f0e3062$export$3919f68a5b3825a9,
    fa6: $5c8203742f0e3062$export$580ac17b31ffb5c3,
    fa7: $5c8203742f0e3062$export$ee79cab31be16d23,
    fa8: $5c8203742f0e3062$export$45d84c4b2c560d2f,
    fa9: $5c8203742f0e3062$export$a120f1e4223629f2,
    faFillDrip: $5c8203742f0e3062$export$38320138fc0262d0,
    faArrowsToCircle: $5c8203742f0e3062$export$917a3d30f6cd766,
    faCircleChevronRight: $5c8203742f0e3062$export$a39bab13d51abfd0,
    faChevronCircleRight: $5c8203742f0e3062$export$2a5db4f6eba6f2b,
    faAt: $5c8203742f0e3062$export$c115e8063ee02632,
    faTrashCan: $5c8203742f0e3062$export$864bb8d6c21fb792,
    faTrashAlt: $5c8203742f0e3062$export$88df7ff7eb32f9dc,
    faTextHeight: $5c8203742f0e3062$export$3313bce3924ea7da,
    faUserXmark: $5c8203742f0e3062$export$e585697127cda27,
    faUserTimes: $5c8203742f0e3062$export$45b996d071667753,
    faStethoscope: $5c8203742f0e3062$export$acb2d72d28cd92d9,
    faMessage: $5c8203742f0e3062$export$6563a67224e7f879,
    faCommentAlt: $5c8203742f0e3062$export$6e96904d9af0ec4a,
    faInfo: $5c8203742f0e3062$export$d469b770895f47ac,
    faDownLeftAndUpRightToCenter: $5c8203742f0e3062$export$d56736f5800b3f0d,
    faCompressAlt: $5c8203742f0e3062$export$a05650ebe54bede,
    faExplosion: $5c8203742f0e3062$export$36b5fbeae4855055,
    faFileLines: $5c8203742f0e3062$export$ef565d07efe2b5e9,
    faFileAlt: $5c8203742f0e3062$export$243b47dca32bf0b8,
    faFileText: $5c8203742f0e3062$export$f466100bf9bf37a5,
    faWaveSquare: $5c8203742f0e3062$export$c38cf504b3bc58a2,
    faRing: $5c8203742f0e3062$export$a95486586631edc7,
    faBuildingUn: $5c8203742f0e3062$export$fbbc7601eb465ac7,
    faDiceThree: $5c8203742f0e3062$export$221059e0d5fd8958,
    faCalendarDays: $5c8203742f0e3062$export$31c6cf6f5d38dc0,
    faCalendarAlt: $5c8203742f0e3062$export$cbc139f33cff356,
    faAnchorCircleCheck: $5c8203742f0e3062$export$8bce49e6ae597af8,
    faBuildingCircleArrowRight: $5c8203742f0e3062$export$37584b1a5e175b47,
    faVolleyball: $5c8203742f0e3062$export$cc519c9529a46c5c,
    faVolleyballBall: $5c8203742f0e3062$export$a15e6fc8e68a76b0,
    faArrowsUpToLine: $5c8203742f0e3062$export$159982ce2622211e,
    faSortDown: $5c8203742f0e3062$export$58e2577a373e7d4,
    faSortDesc: $5c8203742f0e3062$export$e24f016f5f78af6a,
    faCircleMinus: $5c8203742f0e3062$export$d0163707993a8110,
    faMinusCircle: $5c8203742f0e3062$export$f3979b49bf57313c,
    faDoorOpen: $5c8203742f0e3062$export$41821b9a6fd703de,
    faRightFromBracket: $5c8203742f0e3062$export$122a80ae0f87f726,
    faSignOutAlt: $5c8203742f0e3062$export$c844d6923b7096c2,
    faAtom: $5c8203742f0e3062$export$b5bb295e8ad4ab31,
    faSoap: $5c8203742f0e3062$export$64f1c53b21f310ac,
    faIcons: $5c8203742f0e3062$export$7fe2894454d8eb8a,
    faHeartMusicCameraBolt: $5c8203742f0e3062$export$ec74c13cedb0791d,
    faMicrophoneLinesSlash: $5c8203742f0e3062$export$4be1b324ac8a71ba,
    faMicrophoneAltSlash: $5c8203742f0e3062$export$d2a53a388f30780,
    faBridgeCircleCheck: $5c8203742f0e3062$export$ea908d3d80c57d08,
    faPumpMedical: $5c8203742f0e3062$export$f1b881c73328720c,
    faFingerprint: $5c8203742f0e3062$export$614dc068d88655af,
    faHandPointRight: $5c8203742f0e3062$export$f7bc8714c970afa4,
    faMagnifyingGlassLocation: $5c8203742f0e3062$export$234a18b2b4d530a3,
    faSearchLocation: $5c8203742f0e3062$export$c33aba6c251a898a,
    faForwardStep: $5c8203742f0e3062$export$908d699be6717adc,
    faStepForward: $5c8203742f0e3062$export$b303329afce5de18,
    faFaceSmileBeam: $5c8203742f0e3062$export$e3c56ed54f074063,
    faSmileBeam: $5c8203742f0e3062$export$54ada6dc9690e0ca,
    faFlagCheckered: $5c8203742f0e3062$export$92fad97e19a9fea,
    faFootball: $5c8203742f0e3062$export$e15f65e77f717c29,
    faFootballBall: $5c8203742f0e3062$export$e8fd664711e31704,
    faSchoolCircleExclamation: $5c8203742f0e3062$export$f629fdee00932a01,
    faCrop: $5c8203742f0e3062$export$afa58590dfb6fca2,
    faAnglesDown: $5c8203742f0e3062$export$52783a541b1bb03,
    faAngleDoubleDown: $5c8203742f0e3062$export$fd504117f273ca92,
    faUsersRectangle: $5c8203742f0e3062$export$a28757068b9a3a9a,
    faPeopleRoof: $5c8203742f0e3062$export$b96e695bdcf3f3f5,
    faPeopleLine: $5c8203742f0e3062$export$d12c2d6def120efe,
    faBeerMugEmpty: $5c8203742f0e3062$export$b957c27bc5330472,
    faBeer: $5c8203742f0e3062$export$f74725691538983b,
    faDiagramPredecessor: $5c8203742f0e3062$export$1852c99deca7bee8,
    faArrowUpLong: $5c8203742f0e3062$export$92c58defe6e4c5a7,
    faLongArrowUp: $5c8203742f0e3062$export$ede1d50ec4b01670,
    faFireFlameSimple: $5c8203742f0e3062$export$9ebfff5c90672059,
    faBurn: $5c8203742f0e3062$export$80ed4535efc60402,
    faPerson: $5c8203742f0e3062$export$e6619e43cb090a16,
    faMale: $5c8203742f0e3062$export$2e21f9dba1630651,
    faLaptop: $5c8203742f0e3062$export$c2dee3bd177275a2,
    faFileCsv: $5c8203742f0e3062$export$82cea4f586f6ec9,
    faMenorah: $5c8203742f0e3062$export$232452c59d77c56e,
    faTruckPlane: $5c8203742f0e3062$export$e1d5ceed99060d76,
    faRecordVinyl: $5c8203742f0e3062$export$fe2d5012d9982673,
    faFaceGrinStars: $5c8203742f0e3062$export$1d1fbac384a76a12,
    faGrinStars: $5c8203742f0e3062$export$64347a5c8c402ef4,
    faBong: $5c8203742f0e3062$export$e74974fac77c468e,
    faSpaghettiMonsterFlying: $5c8203742f0e3062$export$3c8d5c62d76c33b8,
    faPastafarianism: $5c8203742f0e3062$export$733efdaec97447be,
    faArrowDownUpAcrossLine: $5c8203742f0e3062$export$9fe0c42ede2dd003,
    faSpoon: $5c8203742f0e3062$export$faf854a434ce6d0c,
    faUtensilSpoon: $5c8203742f0e3062$export$fb7af5d245fb9053,
    faJarWheat: $5c8203742f0e3062$export$8b503c1d76716ddd,
    faEnvelopesBulk: $5c8203742f0e3062$export$dc2cce064a1e70bb,
    faMailBulk: $5c8203742f0e3062$export$dd24f40c5337e2e1,
    faFileCircleExclamation: $5c8203742f0e3062$export$61fa9809253098e5,
    faCircleH: $5c8203742f0e3062$export$bf5674308c61894f,
    faHospitalSymbol: $5c8203742f0e3062$export$c8a3c78d99c23fed,
    faPager: $5c8203742f0e3062$export$e1611f373a10a98c,
    faAddressBook: $5c8203742f0e3062$export$853fd1561789e3bb,
    faContactBook: $5c8203742f0e3062$export$594b5a5d4d2e156b,
    faStrikethrough: $5c8203742f0e3062$export$eff51ea25b4de135,
    faK: $5c8203742f0e3062$export$3f85413cb67e7f67,
    faLandmarkFlag: $5c8203742f0e3062$export$f4d472cf47be4096,
    faPencil: $5c8203742f0e3062$export$c72de95adaca18b8,
    faPencilAlt: $5c8203742f0e3062$export$8210adc172262df,
    faBackward: $5c8203742f0e3062$export$ae65f96ea7a4078d,
    faCaretRight: $5c8203742f0e3062$export$f1011352b01c1c0,
    faComments: $5c8203742f0e3062$export$932912e74adb8939,
    faPaste: $5c8203742f0e3062$export$6f95f90dd1f6d86b,
    faFileClipboard: $5c8203742f0e3062$export$ca3229c47de163fa,
    faCodePullRequest: $5c8203742f0e3062$export$37576dfab037d8bf,
    faClipboardList: $5c8203742f0e3062$export$2c5a9d8548d8810e,
    faTruckRampBox: $5c8203742f0e3062$export$37396c36c76937bc,
    faTruckLoading: $5c8203742f0e3062$export$f00c152db7d44638,
    faUserCheck: $5c8203742f0e3062$export$76de2a120043c9f8,
    faVialVirus: $5c8203742f0e3062$export$a56b2b0a1073620c,
    faSheetPlastic: $5c8203742f0e3062$export$57f2bcd070bff91a,
    faBlog: $5c8203742f0e3062$export$890d5e011054935a,
    faUserNinja: $5c8203742f0e3062$export$a9174995732e03c5,
    faPersonArrowUpFromLine: $5c8203742f0e3062$export$5709329dd2b70bdc,
    faScrollTorah: $5c8203742f0e3062$export$4e3fe5b42a6cd494,
    faTorah: $5c8203742f0e3062$export$54d07baabd8c2acb,
    faBroomBall: $5c8203742f0e3062$export$3e1327487ce53231,
    faQuidditch: $5c8203742f0e3062$export$c00c446e6db1605f,
    faQuidditchBroomBall: $5c8203742f0e3062$export$791bfe29b97b4d42,
    faToggleOff: $5c8203742f0e3062$export$d20aaceb882ca545,
    faBoxArchive: $5c8203742f0e3062$export$2a0fcb66c3d79d00,
    faArchive: $5c8203742f0e3062$export$26b3e1c454273f34,
    faPersonDrowning: $5c8203742f0e3062$export$bac321083217fd4,
    faArrowDown91: $5c8203742f0e3062$export$6cc91ce23eb3fae1,
    faSortNumericDesc: $5c8203742f0e3062$export$99f058110e2c82a8,
    faSortNumericDownAlt: $5c8203742f0e3062$export$857385fda7a5a98e,
    faFaceGrinTongueSquint: $5c8203742f0e3062$export$8eee2c17ff89e724,
    faGrinTongueSquint: $5c8203742f0e3062$export$4edf34c3def09a31,
    faSprayCan: $5c8203742f0e3062$export$4952c502f544cf85,
    faTruckMonster: $5c8203742f0e3062$export$24b8a0147653649a,
    faW: $5c8203742f0e3062$export$c7f24bdea332f90a,
    faEarthAfrica: $5c8203742f0e3062$export$11afa141d42099d0,
    faGlobeAfrica: $5c8203742f0e3062$export$64af36f3b403a57c,
    faRainbow: $5c8203742f0e3062$export$92ab27739d3a91b2,
    faCircleNotch: $5c8203742f0e3062$export$9429fd8df55155d,
    faTabletScreenButton: $5c8203742f0e3062$export$df1e253fc358ade4,
    faTabletAlt: $5c8203742f0e3062$export$db0cac088255eacc,
    faPaw: $5c8203742f0e3062$export$7bc6e4d977673e69,
    faCloud: $5c8203742f0e3062$export$8bb3c4d5c2f50243,
    faTrowelBricks: $5c8203742f0e3062$export$b6c20c10ddbd9898,
    faFaceFlushed: $5c8203742f0e3062$export$ba5dc4287853ecbd,
    faFlushed: $5c8203742f0e3062$export$dfd2bd012685aeac,
    faHospitalUser: $5c8203742f0e3062$export$684703c93d630cc5,
    faTentArrowLeftRight: $5c8203742f0e3062$export$fa95eb7418c0e2b8,
    faGavel: $5c8203742f0e3062$export$c36fb40057e2c3aa,
    faLegal: $5c8203742f0e3062$export$59d593c2dacb3781,
    faBinoculars: $5c8203742f0e3062$export$8a910017964bb8c2,
    faMicrophoneSlash: $5c8203742f0e3062$export$843f63d64e6f7951,
    faBoxTissue: $5c8203742f0e3062$export$f2adc06617bc0c7,
    faMotorcycle: $5c8203742f0e3062$export$f26017bdca99338d,
    faBellConcierge: $5c8203742f0e3062$export$e433538b78718fb3,
    faConciergeBell: $5c8203742f0e3062$export$ad92ffbbfbc0fcf3,
    faPenRuler: $5c8203742f0e3062$export$85ba06027671d290,
    faPencilRuler: $5c8203742f0e3062$export$e3a7a1affea005f5,
    faPeopleArrows: $5c8203742f0e3062$export$804bfc5c390e1a2a,
    faPeopleArrowsLeftRight: $5c8203742f0e3062$export$da01f044c59e3598,
    faMarsAndVenusBurst: $5c8203742f0e3062$export$1dc6221efb867885,
    faSquareCaretRight: $5c8203742f0e3062$export$5b1d41cdd118ea6d,
    faCaretSquareRight: $5c8203742f0e3062$export$ae86c9de7e0f62fa,
    faScissors: $5c8203742f0e3062$export$b2a906a5928c6404,
    faCut: $5c8203742f0e3062$export$66847f2a71b260e7,
    faSunPlantWilt: $5c8203742f0e3062$export$8db7f2f70484e17e,
    faToiletsPortable: $5c8203742f0e3062$export$c00f55f36d386cb7,
    faHockeyPuck: $5c8203742f0e3062$export$a274b02dc75663dc,
    faTable: $5c8203742f0e3062$export$36583f5d3d5a971f,
    faMagnifyingGlassArrowRight: $5c8203742f0e3062$export$382d3376c7fc7fc5,
    faTachographDigital: $5c8203742f0e3062$export$73f2bf302381c86a,
    faDigitalTachograph: $5c8203742f0e3062$export$b3bf1994f0fefe98,
    faUsersSlash: $5c8203742f0e3062$export$b71a093b86e3da1f,
    faClover: $5c8203742f0e3062$export$57813571c0e10a0a,
    faReply: $5c8203742f0e3062$export$bb06d4a7bb6736fe,
    faMailReply: $5c8203742f0e3062$export$12e45ff70d2646a1,
    faStarAndCrescent: $5c8203742f0e3062$export$cafa834c96ebcb1a,
    faHouseFire: $5c8203742f0e3062$export$947ee033a6942aa8,
    faSquareMinus: $5c8203742f0e3062$export$814c9edba7b84aa4,
    faMinusSquare: $5c8203742f0e3062$export$ffe9387966b3e681,
    faHelicopter: $5c8203742f0e3062$export$612d3e1afaf45fa5,
    faCompass: $5c8203742f0e3062$export$b4d344633433e50e,
    faSquareCaretDown: $5c8203742f0e3062$export$a1ab39cd66c4e50e,
    faCaretSquareDown: $5c8203742f0e3062$export$61aea18df1c84401,
    faFileCircleQuestion: $5c8203742f0e3062$export$877d3692c1f94bda,
    faLaptopCode: $5c8203742f0e3062$export$94100f4c6ee29932,
    faSwatchbook: $5c8203742f0e3062$export$c74a20c81b957b6a,
    faPrescriptionBottle: $5c8203742f0e3062$export$214f9ce665590486,
    faBars: $5c8203742f0e3062$export$36e9cf7887265da2,
    faNavicon: $5c8203742f0e3062$export$409fa7bcaa0e4cd9,
    faPeopleGroup: $5c8203742f0e3062$export$be015e72863c3635,
    faHourglassEnd: $5c8203742f0e3062$export$52757ecc5b1e25b9,
    faHourglass3: $5c8203742f0e3062$export$1ec43c81fef8ffd6,
    faHeartCrack: $5c8203742f0e3062$export$8e521ef33062b00e,
    faHeartBroken: $5c8203742f0e3062$export$4a565395cb65b282,
    faSquareUpRight: $5c8203742f0e3062$export$a47a20ab7bde8c67,
    faExternalLinkSquareAlt: $5c8203742f0e3062$export$e4cdf2977151ee26,
    faFaceKissBeam: $5c8203742f0e3062$export$eca99665af566fe1,
    faKissBeam: $5c8203742f0e3062$export$d6ff8a73c0812e63,
    faFilm: $5c8203742f0e3062$export$c03de0cc616e77bb,
    faRulerHorizontal: $5c8203742f0e3062$export$46c6347bff3e04a,
    faPeopleRobbery: $5c8203742f0e3062$export$75ce8513e1f1c5c4,
    faLightbulb: $5c8203742f0e3062$export$1e80f89fe84a215b,
    faCaretLeft: $5c8203742f0e3062$export$85a918a11b7643c2,
    faCircleExclamation: $5c8203742f0e3062$export$59573943f9eebbd5,
    faExclamationCircle: $5c8203742f0e3062$export$220e07e14c5d7e5d,
    faSchoolCircleXmark: $5c8203742f0e3062$export$5e17b20e0f6b132b,
    faArrowRightFromBracket: $5c8203742f0e3062$export$ca14f1b4d6afb7aa,
    faSignOut: $5c8203742f0e3062$export$33e2b60243ca6d92,
    faCircleChevronDown: $5c8203742f0e3062$export$aca07924996218d8,
    faChevronCircleDown: $5c8203742f0e3062$export$9926124d75b2ecab,
    faUnlockKeyhole: $5c8203742f0e3062$export$c98fdd5082b333ec,
    faUnlockAlt: $5c8203742f0e3062$export$b19f508797f3d9c3,
    faCloudShowersHeavy: $5c8203742f0e3062$export$af51c741ee9cc090,
    faHeadphonesSimple: $5c8203742f0e3062$export$ca47801915e5a685,
    faHeadphonesAlt: $5c8203742f0e3062$export$6f0433fa527dd5be,
    faSitemap: $5c8203742f0e3062$export$b2ce5e79d0eccaf8,
    faCircleDollarToSlot: $5c8203742f0e3062$export$5f92ac3e804644e3,
    faDonate: $5c8203742f0e3062$export$40050ae52860cde7,
    faMemory: $5c8203742f0e3062$export$5f9bd9f6df021f93,
    faRoadSpikes: $5c8203742f0e3062$export$b372a24046126ad8,
    faFireBurner: $5c8203742f0e3062$export$e4e44f7b1886fef,
    faFlag: $5c8203742f0e3062$export$6591b1ea509be9da,
    faHanukiah: $5c8203742f0e3062$export$3dcd4ca3f7108a82,
    faFeather: $5c8203742f0e3062$export$5e19aea195b31816,
    faVolumeLow: $5c8203742f0e3062$export$2b1464e7557b18eb,
    faVolumeDown: $5c8203742f0e3062$export$69fdf57632b6cc29,
    faCommentSlash: $5c8203742f0e3062$export$3786a0422a3f33ea,
    faCloudSunRain: $5c8203742f0e3062$export$dd9dc9b4227dbe94,
    faCompress: $5c8203742f0e3062$export$83632d1150d3541f,
    faWheatAwn: $5c8203742f0e3062$export$79d4dac715a51fdf,
    faWheatAlt: $5c8203742f0e3062$export$deaf03a29aa05e3a,
    faAnkh: $5c8203742f0e3062$export$8736909014b15ca9,
    faHandsHoldingChild: $5c8203742f0e3062$export$bfb254bf3c0bc50b,
    faAsterisk: $5c8203742f0e3062$export$19eff32c0fd4f99f,
    faSquareCheck: $5c8203742f0e3062$export$5bb6a0c94ad2f4bb,
    faCheckSquare: $5c8203742f0e3062$export$f0c8040f596df7fe,
    faPesetaSign: $5c8203742f0e3062$export$a6f8654bcd49a39f,
    faHeading: $5c8203742f0e3062$export$4805b8d175aeb9fb,
    faHeader: $5c8203742f0e3062$export$579f9604bb10a61a,
    faGhost: $5c8203742f0e3062$export$1a989eb1919c64c1,
    faList: $5c8203742f0e3062$export$6cfc59842fedbc16,
    faListSquares: $5c8203742f0e3062$export$e3f160fc949c2b9d,
    faSquarePhoneFlip: $5c8203742f0e3062$export$b627121801cad756,
    faPhoneSquareAlt: $5c8203742f0e3062$export$a41e77f0de98bba7,
    faCartPlus: $5c8203742f0e3062$export$6675e2bf21fdb87e,
    faGamepad: $5c8203742f0e3062$export$6a66b1b639455bef,
    faCircleDot: $5c8203742f0e3062$export$aa13d9234890e8d3,
    faDotCircle: $5c8203742f0e3062$export$92bc269cb244d66a,
    faFaceDizzy: $5c8203742f0e3062$export$635e4d8cc8428961,
    faDizzy: $5c8203742f0e3062$export$89a2b10dabc487e8,
    faEgg: $5c8203742f0e3062$export$1199a8ce85311ab5,
    faHouseMedicalCircleXmark: $5c8203742f0e3062$export$bf221f0e8296233e,
    faCampground: $5c8203742f0e3062$export$295287303c0e9c7c,
    faFolderPlus: $5c8203742f0e3062$export$e18e05ffa2045d3b,
    faFutbol: $5c8203742f0e3062$export$65a345b33858a655,
    faFutbolBall: $5c8203742f0e3062$export$51a344ca0a215620,
    faSoccerBall: $5c8203742f0e3062$export$f4a29712c724ba2d,
    faPaintbrush: $5c8203742f0e3062$export$7c8b56f3f296a814,
    faPaintBrush: $5c8203742f0e3062$export$594db3339e212bc9,
    faLock: $5c8203742f0e3062$export$7aa08ad5d562578a,
    faGasPump: $5c8203742f0e3062$export$84666c793cb2a347,
    faHotTubPerson: $5c8203742f0e3062$export$6e6bd68568c17bbf,
    faHotTub: $5c8203742f0e3062$export$4842af92b516c40b,
    faMapLocation: $5c8203742f0e3062$export$9a8788ec0e4a9a0b,
    faMapMarked: $5c8203742f0e3062$export$df04458e7e32352c,
    faHouseFloodWater: $5c8203742f0e3062$export$70fd6006b4e54a5,
    faTree: $5c8203742f0e3062$export$1744430f718caf6b,
    faBridgeLock: $5c8203742f0e3062$export$cffe7d85a82d8116,
    faSackDollar: $5c8203742f0e3062$export$15854c4475080853,
    faPenToSquare: $5c8203742f0e3062$export$ba236543926e3569,
    faEdit: $5c8203742f0e3062$export$7be713e57d023733,
    faCarSide: $5c8203742f0e3062$export$6f7218565b1b8d0e,
    faShareNodes: $5c8203742f0e3062$export$cdaf45d4e50ac035,
    faShareAlt: $5c8203742f0e3062$export$f8e8bb0b3aa8c658,
    faHeartCircleMinus: $5c8203742f0e3062$export$24c21c3ca00f3625,
    faHourglassHalf: $5c8203742f0e3062$export$703272eebf5e3eea,
    faHourglass2: $5c8203742f0e3062$export$f1052bbf6bf361c0,
    faMicroscope: $5c8203742f0e3062$export$6a99139787bf9967,
    faSink: $5c8203742f0e3062$export$2a9dda2096ce792e,
    faBagShopping: $5c8203742f0e3062$export$b0137b4600e9ab12,
    faShoppingBag: $5c8203742f0e3062$export$5745f8adbc11eb01,
    faArrowDownZA: $5c8203742f0e3062$export$cf79d63ad07d943a,
    faSortAlphaDesc: $5c8203742f0e3062$export$7caf99612a55d427,
    faSortAlphaDownAlt: $5c8203742f0e3062$export$e12d23d82d5c8a89,
    faMitten: $5c8203742f0e3062$export$5030322c5fc886d7,
    faPersonRays: $5c8203742f0e3062$export$49577f913f0fe4d2,
    faUsers: $5c8203742f0e3062$export$e5a8f011aef571ac,
    faEyeSlash: $5c8203742f0e3062$export$ed3f2918429d029a,
    faFlaskVial: $5c8203742f0e3062$export$a25a266ce0c95019,
    faHand: $5c8203742f0e3062$export$f69db0b876f7d753,
    faHandPaper: $5c8203742f0e3062$export$6e6216c8b50471bb,
    faOm: $5c8203742f0e3062$export$8de8eb94230028a5,
    faWorm: $5c8203742f0e3062$export$2571e33fa6c25993,
    faHouseCircleXmark: $5c8203742f0e3062$export$423555e8708eb4c7,
    faPlug: $5c8203742f0e3062$export$cae5752c3e3b6545,
    faChevronUp: $5c8203742f0e3062$export$877e5ae47a854215,
    faHandSpock: $5c8203742f0e3062$export$2262d6b626de1120,
    faStopwatch: $5c8203742f0e3062$export$b85a7300fc7960b6,
    faFaceKiss: $5c8203742f0e3062$export$5a54c83033a0a56a,
    faKiss: $5c8203742f0e3062$export$c762a77aabf64fd0,
    faBridgeCircleXmark: $5c8203742f0e3062$export$834071278537f121,
    faFaceGrinTongue: $5c8203742f0e3062$export$95a7394c24f57943,
    faGrinTongue: $5c8203742f0e3062$export$ef222816a43a4b3a,
    faChessBishop: $5c8203742f0e3062$export$a831eedd2f59c62f,
    faFaceGrinWink: $5c8203742f0e3062$export$1dd161850c5bc64e,
    faGrinWink: $5c8203742f0e3062$export$2397fcd34eb12177,
    faEarDeaf: $5c8203742f0e3062$export$c9c5b76ec992eab4,
    faDeaf: $5c8203742f0e3062$export$4b666adf83f0de01,
    faDeafness: $5c8203742f0e3062$export$85c6a9ab2fa2631e,
    faHardOfHearing: $5c8203742f0e3062$export$ebecf90a5676e17a,
    faRoadCircleCheck: $5c8203742f0e3062$export$3f22db9ae9b6be1c,
    faDiceFive: $5c8203742f0e3062$export$d9769fb795c2db82,
    faSquareRss: $5c8203742f0e3062$export$97d1903b1e012ff7,
    faRssSquare: $5c8203742f0e3062$export$89c9b1cca2c11484,
    faLandMineOn: $5c8203742f0e3062$export$567a897fc092e403,
    faICursor: $5c8203742f0e3062$export$7fddf76ec23943d8,
    faStamp: $5c8203742f0e3062$export$722e92d2d93ffc68,
    faStairs: $5c8203742f0e3062$export$68b3af7444c89df7,
    faI: $5c8203742f0e3062$export$aee03ca0815b7c38,
    faHryvniaSign: $5c8203742f0e3062$export$22a9491150c64fef,
    faHryvnia: $5c8203742f0e3062$export$33d5f94bd6f75f59,
    faPills: $5c8203742f0e3062$export$6380e2ed6e69d350,
    faFaceGrinWide: $5c8203742f0e3062$export$bdbabf493c478cde,
    faGrinAlt: $5c8203742f0e3062$export$b4abebfe416d36ba,
    faTooth: $5c8203742f0e3062$export$3a1fa2d16f90d635,
    faV: $5c8203742f0e3062$export$6fb446f784f6b9b3,
    faBangladeshiTakaSign: $5c8203742f0e3062$export$469d376940e10d37,
    faBicycle: $5c8203742f0e3062$export$36cb1885ad7a570f,
    faStaffSnake: $5c8203742f0e3062$export$76d998742bc186eb,
    faRodAsclepius: $5c8203742f0e3062$export$f2c3e92ee37a8d89,
    faRodSnake: $5c8203742f0e3062$export$5d61dcb598296af0,
    faStaffAesculapius: $5c8203742f0e3062$export$97c8a2cdba3b7700,
    faHeadSideCoughSlash: $5c8203742f0e3062$export$b293ee8fb8e6b0c4,
    faTruckMedical: $5c8203742f0e3062$export$fb6bd43f079f72e2,
    faAmbulance: $5c8203742f0e3062$export$f5c7042778b51765,
    faWheatAwnCircleExclamation: $5c8203742f0e3062$export$e23367e54f665590,
    faSnowman: $5c8203742f0e3062$export$b23df6bafb174693,
    faMortarPestle: $5c8203742f0e3062$export$55ceb5d0c144580a,
    faRoadBarrier: $5c8203742f0e3062$export$f3e925217e396f44,
    faSchool: $5c8203742f0e3062$export$51e9b8434982947d,
    faIgloo: $5c8203742f0e3062$export$4a284575edd6f1af,
    faJoint: $5c8203742f0e3062$export$e5a289fb22ffb8cb,
    faAngleRight: $5c8203742f0e3062$export$6bce1afb61f2eb66,
    faHorse: $5c8203742f0e3062$export$5b05f097fa38352a,
    faQ: $5c8203742f0e3062$export$5a2b164552deda9f,
    faG: $5c8203742f0e3062$export$9f5c2b0db8eedeac,
    faNotesMedical: $5c8203742f0e3062$export$b2d79133c81d6697,
    faTemperatureHalf: $5c8203742f0e3062$export$a3f1d7f13c202adc,
    faTemperature2: $5c8203742f0e3062$export$8176e649df45b32c,
    faThermometer2: $5c8203742f0e3062$export$4dd764ac8d512682,
    faThermometerHalf: $5c8203742f0e3062$export$2090f040324b4449,
    faDongSign: $5c8203742f0e3062$export$18659308f17918a5,
    faCapsules: $5c8203742f0e3062$export$ba6fd4a436804a48,
    faPooStorm: $5c8203742f0e3062$export$48a38da471b097a2,
    faPooBolt: $5c8203742f0e3062$export$9a24e77f74d9cbd9,
    faFaceFrownOpen: $5c8203742f0e3062$export$c8a28356e07b9ccb,
    faFrownOpen: $5c8203742f0e3062$export$c4775e66bed5d96,
    faHandPointUp: $5c8203742f0e3062$export$cdc9f5e7e94e76da,
    faMoneyBill: $5c8203742f0e3062$export$608138a7337b5d1a,
    faBookmark: $5c8203742f0e3062$export$4ed9da5c3cca0ef1,
    faAlignJustify: $5c8203742f0e3062$export$97c42b56d462df72,
    faUmbrellaBeach: $5c8203742f0e3062$export$20932e4d438e4e4c,
    faHelmetUn: $5c8203742f0e3062$export$5e975cb293c48461,
    faBullseye: $5c8203742f0e3062$export$554720e3bf74fe90,
    faBacon: $5c8203742f0e3062$export$ab07061fe21a3a8e,
    faHandPointDown: $5c8203742f0e3062$export$f6dcbf0a940428f4,
    faArrowUpFromBracket: $5c8203742f0e3062$export$c2af1be14cd87640,
    faFolder: $5c8203742f0e3062$export$72b780186370e953,
    faFolderBlank: $5c8203742f0e3062$export$9ef114244d26da0,
    faFileWaveform: $5c8203742f0e3062$export$5e0c19cf315ac1bf,
    faFileMedicalAlt: $5c8203742f0e3062$export$ef02a0f5b39aa61f,
    faRadiation: $5c8203742f0e3062$export$4c4e509518093d6d,
    faChartSimple: $5c8203742f0e3062$export$8760a1de19ea40b9,
    faMarsStroke: $5c8203742f0e3062$export$aa05fce255a5d269,
    faVial: $5c8203742f0e3062$export$aa014b06d2d70598,
    faGauge: $5c8203742f0e3062$export$dbfb0a9f89ad94a4,
    faDashboard: $5c8203742f0e3062$export$b7ce24136743d0f1,
    faGaugeMed: $5c8203742f0e3062$export$f948a9dd257979f3,
    faTachometerAltAverage: $5c8203742f0e3062$export$6f22c345e5a92d1a,
    faWandMagicSparkles: $5c8203742f0e3062$export$5325fc72e75360b4,
    faMagicWandSparkles: $5c8203742f0e3062$export$c93286938249f0da,
    faE: $5c8203742f0e3062$export$86923e6fe1b42f5e,
    faPenClip: $5c8203742f0e3062$export$eff4bdcafd3b8d1c,
    faPenAlt: $5c8203742f0e3062$export$a3d3e92e430d3beb,
    faBridgeCircleExclamation: $5c8203742f0e3062$export$4f25939fdf728c27,
    faUser: $5c8203742f0e3062$export$f5699fa0844e0188,
    faSchoolCircleCheck: $5c8203742f0e3062$export$c8c95c2f9937bf6a,
    faDumpster: $5c8203742f0e3062$export$3b934e22d1851a3b,
    faVanShuttle: $5c8203742f0e3062$export$ecbd233b96906ee1,
    faShuttleVan: $5c8203742f0e3062$export$9d63d851db698c09,
    faBuildingUser: $5c8203742f0e3062$export$d65aef1ed7db1dae,
    faSquareCaretLeft: $5c8203742f0e3062$export$2c5163541229363,
    faCaretSquareLeft: $5c8203742f0e3062$export$d0c8ba444f1f9581,
    faHighlighter: $5c8203742f0e3062$export$73801ed54b42fabe,
    faKey: $5c8203742f0e3062$export$fa6ecc35e7315db,
    faBullhorn: $5c8203742f0e3062$export$dacae2b4ec565333,
    faGlobe: $5c8203742f0e3062$export$b1b1cdce4a19c682,
    faSynagogue: $5c8203742f0e3062$export$20d991385719b5b4,
    faPersonHalfDress: $5c8203742f0e3062$export$f3d75c19191f1688,
    faRoadBridge: $5c8203742f0e3062$export$4d6835e7175dec24,
    faLocationArrow: $5c8203742f0e3062$export$4ac9c4c370f7b157,
    faC: $5c8203742f0e3062$export$a2c1c457834fc6d8,
    faTabletButton: $5c8203742f0e3062$export$2d33c367b2b091ac,
    faBuildingLock: $5c8203742f0e3062$export$6f08294ba8a2459c,
    faPizzaSlice: $5c8203742f0e3062$export$c9f93c4667edc585,
    faMoneyBillWave: $5c8203742f0e3062$export$53e23123cc9a6796,
    faChartArea: $5c8203742f0e3062$export$2acab8312b7a999b,
    faAreaChart: $5c8203742f0e3062$export$fc2e595f0e0612cb,
    faHouseFlag: $5c8203742f0e3062$export$9a3d31c75a465b9a,
    faPersonCircleMinus: $5c8203742f0e3062$export$d7ccc6651f90f7cc,
    faBan: $5c8203742f0e3062$export$76f704d256def3c7,
    faCancel: $5c8203742f0e3062$export$6d25ef56192f6d69,
    faCameraRotate: $5c8203742f0e3062$export$e0ce7d1aba7105e7,
    faSprayCanSparkles: $5c8203742f0e3062$export$43832c90c10a7a31,
    faAirFreshener: $5c8203742f0e3062$export$a5e63e89b5ccee83,
    faStar: $5c8203742f0e3062$export$a3b0eb2cd7942125,
    faRepeat: $5c8203742f0e3062$export$cb8434288c91ae83,
    faCross: $5c8203742f0e3062$export$9d0a89fcd084abb,
    faBox: $5c8203742f0e3062$export$6e7cf270cda52323,
    faVenusMars: $5c8203742f0e3062$export$63f2d9e5f4689aa8,
    faArrowPointer: $5c8203742f0e3062$export$e4f903bc63db445,
    faMousePointer: $5c8203742f0e3062$export$2e19a69cc26b147,
    faMaximize: $5c8203742f0e3062$export$8d2b1b230601e804,
    faExpandArrowsAlt: $5c8203742f0e3062$export$6219dcd88b5fa6c2,
    faChargingStation: $5c8203742f0e3062$export$bab2cd86f8c65657,
    faShapes: $5c8203742f0e3062$export$b17d50542d1fc340,
    faTriangleCircleSquare: $5c8203742f0e3062$export$34261e5aea24fc1d,
    faShuffle: $5c8203742f0e3062$export$ee94b652453ad208,
    faRandom: $5c8203742f0e3062$export$8357bf8cc666d5f0,
    faPersonRunning: $5c8203742f0e3062$export$f48814ae62850c74,
    faRunning: $5c8203742f0e3062$export$5dfd1cb43dc9eadb,
    faMobileRetro: $5c8203742f0e3062$export$7955f08360418647,
    faGripLinesVertical: $5c8203742f0e3062$export$523960de087f5198,
    faSpider: $5c8203742f0e3062$export$6daa96b1986e2ef0,
    faHandsBound: $5c8203742f0e3062$export$740142a89118fbc0,
    faFileInvoiceDollar: $5c8203742f0e3062$export$a3dced32d48cb1ea,
    faPlaneCircleExclamation: $5c8203742f0e3062$export$f201ba865ea1b8dc,
    faXRay: $5c8203742f0e3062$export$8cf137aceaaf4de0,
    faSpellCheck: $5c8203742f0e3062$export$761e747b06ed2e1f,
    faSlash: $5c8203742f0e3062$export$f54d004dd5f1cb5e,
    faComputerMouse: $5c8203742f0e3062$export$72cf138e5ddda6eb,
    faMouse: $5c8203742f0e3062$export$198b96b894c66074,
    faArrowRightToBracket: $5c8203742f0e3062$export$a02c5909359525be,
    faSignIn: $5c8203742f0e3062$export$a55eff0ca4f9c3df,
    faShopSlash: $5c8203742f0e3062$export$b3d636689da4a3e5,
    faStoreAltSlash: $5c8203742f0e3062$export$b932a586f6ff48b4,
    faServer: $5c8203742f0e3062$export$1bf820d499b6202e,
    faVirusCovidSlash: $5c8203742f0e3062$export$61c2a6b698f55df6,
    faShopLock: $5c8203742f0e3062$export$452410c103c2403b,
    faHourglassStart: $5c8203742f0e3062$export$f0c28584caa8f4b,
    faHourglass1: $5c8203742f0e3062$export$87929336ab5c59cd,
    faBlenderPhone: $5c8203742f0e3062$export$f35a116a762ef8fc,
    faBuildingWheat: $5c8203742f0e3062$export$6c0cfe6d58faf860,
    faPersonBreastfeeding: $5c8203742f0e3062$export$9b94ed8d16d281f9,
    faRightToBracket: $5c8203742f0e3062$export$a5fd2acfcb5247c6,
    faSignInAlt: $5c8203742f0e3062$export$e6709746115bd2ea,
    faVenus: $5c8203742f0e3062$export$f89d028573ffc0a6,
    faPassport: $5c8203742f0e3062$export$2c31ca0d9bee400f,
    faHeartPulse: $5c8203742f0e3062$export$a6d8e50dcd4b4294,
    faHeartbeat: $5c8203742f0e3062$export$ca880e19206e80aa,
    faPeopleCarryBox: $5c8203742f0e3062$export$7754cc6d5559ff38,
    faPeopleCarry: $5c8203742f0e3062$export$35fbd4ff1265acd5,
    faTemperatureHigh: $5c8203742f0e3062$export$15d012277c3ecf9a,
    faMicrochip: $5c8203742f0e3062$export$4a7bb4be15f35178,
    faCrown: $5c8203742f0e3062$export$dc1083dcd1d7b9d6,
    faWeightHanging: $5c8203742f0e3062$export$43d1fa6671908715,
    faXmarksLines: $5c8203742f0e3062$export$f4595f012786d346,
    faFilePrescription: $5c8203742f0e3062$export$a20cb90865b6beb8,
    faWeightScale: $5c8203742f0e3062$export$e521c542d18b85c3,
    faWeight: $5c8203742f0e3062$export$cf3bafa68a60bae4,
    faUserGroup: $5c8203742f0e3062$export$3d626cfc365a7e36,
    faUserFriends: $5c8203742f0e3062$export$46073bec205635d9,
    faArrowUpAZ: $5c8203742f0e3062$export$fb00fdd8857804c7,
    faSortAlphaUp: $5c8203742f0e3062$export$3c4115b156be730d,
    faChessKnight: $5c8203742f0e3062$export$861b1f13085cf122,
    faFaceLaughSquint: $5c8203742f0e3062$export$67ca89c1ca38d559,
    faLaughSquint: $5c8203742f0e3062$export$b206e700cf7084e1,
    faWheelchair: $5c8203742f0e3062$export$76a9413fbe130a53,
    faCircleArrowUp: $5c8203742f0e3062$export$a29c8ea43e92771d,
    faArrowCircleUp: $5c8203742f0e3062$export$a2f6f3baa50af0b1,
    faToggleOn: $5c8203742f0e3062$export$5cffc34afa81e517,
    faPersonWalking: $5c8203742f0e3062$export$6af1cc5998ca52bc,
    faWalking: $5c8203742f0e3062$export$4886811b7174ec35,
    faL: $5c8203742f0e3062$export$be32b10ce70a09df,
    faFire: $5c8203742f0e3062$export$7b24b34ef6cc130c,
    faBedPulse: $5c8203742f0e3062$export$580ae0d0bbd809fb,
    faProcedures: $5c8203742f0e3062$export$5f9e1870e1866dde,
    faShuttleSpace: $5c8203742f0e3062$export$76d92e7f30d064c5,
    faSpaceShuttle: $5c8203742f0e3062$export$4d1c12ba2b4ca565,
    faFaceLaugh: $5c8203742f0e3062$export$2f203616c892d415,
    faLaugh: $5c8203742f0e3062$export$6c74e314e801a4fe,
    faFolderOpen: $5c8203742f0e3062$export$ff7e93418af88b78,
    faHeartCirclePlus: $5c8203742f0e3062$export$2a155a6e20f64134,
    faCodeFork: $5c8203742f0e3062$export$f54081bdbf6d4eb5,
    faCity: $5c8203742f0e3062$export$a9947c2888b3c8fd,
    faMicrophoneLines: $5c8203742f0e3062$export$417391ae30b5922e,
    faMicrophoneAlt: $5c8203742f0e3062$export$f08ef94fea14f5ac,
    faPepperHot: $5c8203742f0e3062$export$4894bf28f771e1f3,
    faUnlock: $5c8203742f0e3062$export$db1382cd406cc506,
    faColonSign: $5c8203742f0e3062$export$dec10d4c2c113312,
    faHeadset: $5c8203742f0e3062$export$23b086400a31acfe,
    faStoreSlash: $5c8203742f0e3062$export$4ab2f33219630bad,
    faRoadCircleXmark: $5c8203742f0e3062$export$2ffc88a4d31e8ffc,
    faUserMinus: $5c8203742f0e3062$export$d6e17c0df8ed1bf7,
    faMarsStrokeUp: $5c8203742f0e3062$export$efc6d53e0dedceee,
    faMarsStrokeV: $5c8203742f0e3062$export$ed7aa1c25104f333,
    faChampagneGlasses: $5c8203742f0e3062$export$7df1926e9eef8cc3,
    faGlassCheers: $5c8203742f0e3062$export$20007d7d74cb98fe,
    faClipboard: $5c8203742f0e3062$export$97d84347d71ba297,
    faHouseCircleExclamation: $5c8203742f0e3062$export$8403e4b31e8aa805,
    faFileArrowUp: $5c8203742f0e3062$export$929df388c07f293d,
    faFileUpload: $5c8203742f0e3062$export$dd55ded1264643d2,
    faWifi: $5c8203742f0e3062$export$1642419fe3db2857,
    faWifi3: $5c8203742f0e3062$export$2349bb04a04f4b2d,
    faWifiStrong: $5c8203742f0e3062$export$4b3167c852f4c4aa,
    faBath: $5c8203742f0e3062$export$1ea66a88b8f620c9,
    faBathtub: $5c8203742f0e3062$export$40ae013b5e6269d8,
    faUnderline: $5c8203742f0e3062$export$22346afd6a3cddf8,
    faUserPen: $5c8203742f0e3062$export$3842882ea09b25af,
    faUserEdit: $5c8203742f0e3062$export$a68a6960fc8eef82,
    faSignature: $5c8203742f0e3062$export$afa7b53ac8ebcb5d,
    faStroopwafel: $5c8203742f0e3062$export$195780ddabd8e0c6,
    faBold: $5c8203742f0e3062$export$7e0c7fd2a2e88823,
    faAnchorLock: $5c8203742f0e3062$export$217195c80db39097,
    faBuildingNgo: $5c8203742f0e3062$export$374e1dce366a2175,
    faManatSign: $5c8203742f0e3062$export$1ff755b523ab2851,
    faNotEqual: $5c8203742f0e3062$export$6a15ccae09bbaf93,
    faBorderTopLeft: $5c8203742f0e3062$export$cf897c3e0abd59e4,
    faBorderStyle: $5c8203742f0e3062$export$c2867ca78120d644,
    faMapLocationDot: $5c8203742f0e3062$export$757f50b8af780c19,
    faMapMarkedAlt: $5c8203742f0e3062$export$a977d47c74d8e86c,
    faJedi: $5c8203742f0e3062$export$859f204e59641ca4,
    faSquarePollVertical: $5c8203742f0e3062$export$91d747e5aabe6fe8,
    faPoll: $5c8203742f0e3062$export$bc8ca14ab51f93db,
    faMugHot: $5c8203742f0e3062$export$47a822c30184e8af,
    faCarBattery: $5c8203742f0e3062$export$a44d0c11093d9c1e,
    faBatteryCar: $5c8203742f0e3062$export$9133165ca669dd4b,
    faGift: $5c8203742f0e3062$export$b2727de8ccdbb5ec,
    faDiceTwo: $5c8203742f0e3062$export$4d85df590065572f,
    faChessQueen: $5c8203742f0e3062$export$7b8ce73615739d30,
    faGlasses: $5c8203742f0e3062$export$58d7d709c0a8ca5f,
    faChessBoard: $5c8203742f0e3062$export$bd301515df6246af,
    faBuildingCircleCheck: $5c8203742f0e3062$export$5559de5f969b9590,
    faPersonChalkboard: $5c8203742f0e3062$export$c9dc1583b207b7ff,
    faMarsStrokeRight: $5c8203742f0e3062$export$321e84e6a900c2d6,
    faMarsStrokeH: $5c8203742f0e3062$export$5cb0daeafbcdabe3,
    faHandBackFist: $5c8203742f0e3062$export$be38a892fe9b4098,
    faHandRock: $5c8203742f0e3062$export$97a81eba394c8c44,
    faSquareCaretUp: $5c8203742f0e3062$export$66068918abb14406,
    faCaretSquareUp: $5c8203742f0e3062$export$307ae80b26533ce5,
    faCloudShowersWater: $5c8203742f0e3062$export$b416056e795d2eac,
    faChartBar: $5c8203742f0e3062$export$b532f5d25de97633,
    faBarChart: $5c8203742f0e3062$export$2d5f754a5e5738b,
    faHandsBubbles: $5c8203742f0e3062$export$2f78563e14e49916,
    faHandsWash: $5c8203742f0e3062$export$996b5dea53b124e3,
    faLessThanEqual: $5c8203742f0e3062$export$b2c723344cff0d8,
    faTrain: $5c8203742f0e3062$export$17cde74bf6f1ee89,
    faEyeLowVision: $5c8203742f0e3062$export$23a892b1a4b994bd,
    faLowVision: $5c8203742f0e3062$export$7a65d2aa54cb4e93,
    faCrow: $5c8203742f0e3062$export$bfa312207b788ed9,
    faSailboat: $5c8203742f0e3062$export$e363e74e36cce80c,
    faWindowRestore: $5c8203742f0e3062$export$eccfff9bfd585652,
    faSquarePlus: $5c8203742f0e3062$export$eaf727acca5a35e4,
    faPlusSquare: $5c8203742f0e3062$export$b6359eebfe900c35,
    faToriiGate: $5c8203742f0e3062$export$75825a4c2b3375e,
    faFrog: $5c8203742f0e3062$export$fe2358263efac504,
    faBucket: $5c8203742f0e3062$export$2124c7628e573b84,
    faImage: $5c8203742f0e3062$export$7e9f0928967e03b,
    faMicrophone: $5c8203742f0e3062$export$eed3c491effe6d12,
    faCow: $5c8203742f0e3062$export$1da3b2e53dcafa2d,
    faCaretUp: $5c8203742f0e3062$export$7de776bdab4e536d,
    faScrewdriver: $5c8203742f0e3062$export$7484ff654cd6474f,
    faFolderClosed: $5c8203742f0e3062$export$5e30548b7f8eeb95,
    faHouseTsunami: $5c8203742f0e3062$export$197b9567e88a0b1d,
    faSquareNfi: $5c8203742f0e3062$export$5498258519fc5b72,
    faArrowUpFromGroundWater: $5c8203742f0e3062$export$cbe485a104805f4f,
    faMartiniGlass: $5c8203742f0e3062$export$98401bb29cff68e0,
    faGlassMartiniAlt: $5c8203742f0e3062$export$2258439b8f4e7acb,
    faRotateLeft: $5c8203742f0e3062$export$7adaa412bd8eb08f,
    faRotateBack: $5c8203742f0e3062$export$9706706f1bc7b12,
    faRotateBackward: $5c8203742f0e3062$export$4ceb0b05fed961a9,
    faUndoAlt: $5c8203742f0e3062$export$c8197b992c46c4a6,
    faTableColumns: $5c8203742f0e3062$export$ccaa019a3fd4563f,
    faColumns: $5c8203742f0e3062$export$bb861166644ac28a,
    faLemon: $5c8203742f0e3062$export$4fbda8f64648f3b5,
    faHeadSideMask: $5c8203742f0e3062$export$280300af4baa1a3e,
    faHandshake: $5c8203742f0e3062$export$b4c63e9bfc7906f1,
    faGem: $5c8203742f0e3062$export$31ee86ac717db552,
    faDolly: $5c8203742f0e3062$export$5879d0bca1aa497b,
    faDollyBox: $5c8203742f0e3062$export$461bbb9e92cc531b,
    faSmoking: $5c8203742f0e3062$export$c4ab83701fc591a5,
    faMinimize: $5c8203742f0e3062$export$e0601b1f239fec74,
    faCompressArrowsAlt: $5c8203742f0e3062$export$39205db0ea980efd,
    faMonument: $5c8203742f0e3062$export$6f9b0bfc012deb25,
    faSnowplow: $5c8203742f0e3062$export$695fae58f55c3a87,
    faAnglesRight: $5c8203742f0e3062$export$48b60f1720e09944,
    faAngleDoubleRight: $5c8203742f0e3062$export$792931403404faf0,
    faCannabis: $5c8203742f0e3062$export$8ec2f752344b69bd,
    faCirclePlay: $5c8203742f0e3062$export$86c4e45dc3302d15,
    faPlayCircle: $5c8203742f0e3062$export$cf04333781061c5e,
    faTablets: $5c8203742f0e3062$export$bed2b0ed4ae45e0d,
    faEthernet: $5c8203742f0e3062$export$6bad2c9f317b52e5,
    faEuroSign: $5c8203742f0e3062$export$902a3969bb113dff,
    faEur: $5c8203742f0e3062$export$4b859160cfeb12ff,
    faEuro: $5c8203742f0e3062$export$bdabbefede2d3a2,
    faChair: $5c8203742f0e3062$export$a339864ee3df7e9a,
    faCircleCheck: $5c8203742f0e3062$export$c2e9877668862374,
    faCheckCircle: $5c8203742f0e3062$export$be9e388158c74f29,
    faCircleStop: $5c8203742f0e3062$export$229de76dfef2687f,
    faStopCircle: $5c8203742f0e3062$export$47af2aad60ab3e7c,
    faCompassDrafting: $5c8203742f0e3062$export$aaaddd2cf7e20f64,
    faDraftingCompass: $5c8203742f0e3062$export$c8c2b127d13b9d79,
    faPlateWheat: $5c8203742f0e3062$export$2eff9f6cbe00a643,
    faIcicles: $5c8203742f0e3062$export$78792ed87d92a3ad,
    faPersonShelter: $5c8203742f0e3062$export$d359c2cc7640953c,
    faNeuter: $5c8203742f0e3062$export$771cf879fba0cf93,
    faIdBadge: $5c8203742f0e3062$export$a75288855ea05282,
    faMarker: $5c8203742f0e3062$export$e6789173649caa25,
    faFaceLaughBeam: $5c8203742f0e3062$export$3f2d51c0547bf984,
    faLaughBeam: $5c8203742f0e3062$export$a88d1f4073ea9369,
    faHelicopterSymbol: $5c8203742f0e3062$export$2a66e6044c1f7036,
    faUniversalAccess: $5c8203742f0e3062$export$e119aada7f690d05,
    faCircleChevronUp: $5c8203742f0e3062$export$7b69b3617b84259b,
    faChevronCircleUp: $5c8203742f0e3062$export$b786cf5db03f2c36,
    faLariSign: $5c8203742f0e3062$export$d317bc452442782d,
    faVolcano: $5c8203742f0e3062$export$bae30a76735500e1,
    faPersonWalkingDashedLineArrowRight: $5c8203742f0e3062$export$a1d09c95bee8043b,
    faSterlingSign: $5c8203742f0e3062$export$170c56774c8e7961,
    faGbp: $5c8203742f0e3062$export$3d9479ec1d1ae83e,
    faPoundSign: $5c8203742f0e3062$export$9ce041dfec8319b,
    faViruses: $5c8203742f0e3062$export$ee194b18f5c6f6b6,
    faSquarePersonConfined: $5c8203742f0e3062$export$8aaca358568da0e0,
    faUserTie: $5c8203742f0e3062$export$48c51dda34e9f04c,
    faArrowDownLong: $5c8203742f0e3062$export$5977e8de7e65b20,
    faLongArrowDown: $5c8203742f0e3062$export$52ecf90b62f3f030,
    faTentArrowDownToLine: $5c8203742f0e3062$export$8a4f323f00a91606,
    faCertificate: $5c8203742f0e3062$export$a881f37164b11fbf,
    faReplyAll: $5c8203742f0e3062$export$ca6fd367f31ecbc5,
    faMailReplyAll: $5c8203742f0e3062$export$8274334f3a2c1841,
    faSuitcase: $5c8203742f0e3062$export$60710f3921019268,
    faPersonSkating: $5c8203742f0e3062$export$f3854553fe688388,
    faSkating: $5c8203742f0e3062$export$21bd1d54bd4f2c5a,
    faFilterCircleDollar: $5c8203742f0e3062$export$3300e4b4d1d1936f,
    faFunnelDollar: $5c8203742f0e3062$export$cebe38ad8f0a143d,
    faCameraRetro: $5c8203742f0e3062$export$41dbdadc07a89b05,
    faCircleArrowDown: $5c8203742f0e3062$export$a30c52cde32bec7e,
    faArrowCircleDown: $5c8203742f0e3062$export$6cfa36bbb3a057,
    faFileImport: $5c8203742f0e3062$export$d796c05153b1255c,
    faArrowRightToFile: $5c8203742f0e3062$export$32f14beaf6294476,
    faSquareArrowUpRight: $5c8203742f0e3062$export$38150b61dfd06fff,
    faExternalLinkSquare: $5c8203742f0e3062$export$e04d83fed5ebcebf,
    faBoxOpen: $5c8203742f0e3062$export$9010ed816a8b9c97,
    faScroll: $5c8203742f0e3062$export$7c265716d4399676,
    faSpa: $5c8203742f0e3062$export$f9a38ef7b046ab51,
    faLocationPinLock: $5c8203742f0e3062$export$db853fbb474326cc,
    faPause: $5c8203742f0e3062$export$da79f048408b1722,
    faHillAvalanche: $5c8203742f0e3062$export$50d11c98c99e3b2d,
    faTemperatureEmpty: $5c8203742f0e3062$export$ac389bf5cc37feb5,
    faTemperature0: $5c8203742f0e3062$export$e99b7d2ccc282383,
    faThermometer0: $5c8203742f0e3062$export$4c13a186ecce3b80,
    faThermometerEmpty: $5c8203742f0e3062$export$81a2f8298cf523f9,
    faBomb: $5c8203742f0e3062$export$d59078f6e80b4a67,
    faRegistered: $5c8203742f0e3062$export$5f519e9ac15ab8c3,
    faAddressCard: $5c8203742f0e3062$export$6ea408c7266ed557,
    faContactCard: $5c8203742f0e3062$export$4ac51eb0b298b190,
    faVcard: $5c8203742f0e3062$export$91228257deb1bf18,
    faScaleUnbalancedFlip: $5c8203742f0e3062$export$f4d7840209109993,
    faBalanceScaleRight: $5c8203742f0e3062$export$2238e05f8920005a,
    faSubscript: $5c8203742f0e3062$export$34c1e678c32ed646,
    faDiamondTurnRight: $5c8203742f0e3062$export$99749ac517cbef07,
    faDirections: $5c8203742f0e3062$export$6a6973de44442fe5,
    faBurst: $5c8203742f0e3062$export$ea2986b45ba5d2cf,
    faHouseLaptop: $5c8203742f0e3062$export$6486d62e77b910,
    faLaptopHouse: $5c8203742f0e3062$export$efd983de5e4d6ad3,
    faFaceTired: $5c8203742f0e3062$export$5352cbdc070ce8d,
    faTired: $5c8203742f0e3062$export$3d016d62cda18371,
    faMoneyBills: $5c8203742f0e3062$export$a822dad6e586ee9e,
    faSmog: $5c8203742f0e3062$export$aa11b8edb09fed14,
    faCrutch: $5c8203742f0e3062$export$e94134641c0e2,
    faFontAwesome: $5c8203742f0e3062$export$aa4baaed1c60f58d,
    faFontAwesomeFlag: $5c8203742f0e3062$export$102c25fde54d4843,
    faFontAwesomeLogoFull: $5c8203742f0e3062$export$6e20d421a2e0f320,
    faCloudArrowUp: $5c8203742f0e3062$export$3507214fff1cc655,
    faCloudUpload: $5c8203742f0e3062$export$a48720e6366f5d9a,
    faCloudUploadAlt: $5c8203742f0e3062$export$e73b3e819b9d14a5,
    faPalette: $5c8203742f0e3062$export$5c390baea5db4f77,
    faArrowsTurnRight: $5c8203742f0e3062$export$db9f783f15682c4a,
    faVest: $5c8203742f0e3062$export$c8370e53051a657,
    faFerry: $5c8203742f0e3062$export$fd312949b97346ae,
    faArrowsDownToPeople: $5c8203742f0e3062$export$cfb044c7d35060bb,
    faSeedling: $5c8203742f0e3062$export$d7b60b8dbd03cfe4,
    faSprout: $5c8203742f0e3062$export$9f3035e3a8c62323,
    faLeftRight: $5c8203742f0e3062$export$47d93e9001818ee7,
    faArrowsAltH: $5c8203742f0e3062$export$7937ea574fb1389,
    faBoxesPacking: $5c8203742f0e3062$export$e81e7f3390fe84fe,
    faCircleArrowLeft: $5c8203742f0e3062$export$827fbb87bdbe1028,
    faArrowCircleLeft: $5c8203742f0e3062$export$728262abb9f58d0a,
    faGroupArrowsRotate: $5c8203742f0e3062$export$88a8383ecdd39a54,
    faBowlFood: $5c8203742f0e3062$export$8b89ca3201039376,
    faCandyCane: $5c8203742f0e3062$export$14d66ba7571ae0b9,
    faArrowDownWideShort: $5c8203742f0e3062$export$4229d00802c33062,
    faSortAmountAsc: $5c8203742f0e3062$export$ddf8b8dd5983367d,
    faSortAmountDown: $5c8203742f0e3062$export$4b2a02d50e417b5f,
    faCloudBolt: $5c8203742f0e3062$export$cdd116afa0309c17,
    faThunderstorm: $5c8203742f0e3062$export$bbf9e3d433f8f6de,
    faTextSlash: $5c8203742f0e3062$export$ec658c0f040c3e1a,
    faRemoveFormat: $5c8203742f0e3062$export$d91179f327329532,
    faFaceSmileWink: $5c8203742f0e3062$export$6143da800b0e6626,
    faSmileWink: $5c8203742f0e3062$export$f5dbb37f6801ee3f,
    faFileWord: $5c8203742f0e3062$export$f0858dff6e769cf6,
    faFilePowerpoint: $5c8203742f0e3062$export$c341daeecdea449a,
    faArrowsLeftRight: $5c8203742f0e3062$export$672e2f590b189583,
    faArrowsH: $5c8203742f0e3062$export$de517642cdb40354,
    faHouseLock: $5c8203742f0e3062$export$aa54b16c409e882f,
    faCloudArrowDown: $5c8203742f0e3062$export$542a9676c5286e01,
    faCloudDownload: $5c8203742f0e3062$export$b318977f29260464,
    faCloudDownloadAlt: $5c8203742f0e3062$export$351357a14c41f824,
    faChildren: $5c8203742f0e3062$export$f2819bf60df55912,
    faChalkboard: $5c8203742f0e3062$export$49a36efd66df775,
    faBlackboard: $5c8203742f0e3062$export$f497e01bf522fd9c,
    faUserLargeSlash: $5c8203742f0e3062$export$ae7fc6b7f0534be9,
    faUserAltSlash: $5c8203742f0e3062$export$46185fab4772ada6,
    faEnvelopeOpen: $5c8203742f0e3062$export$c6c3bd5f7d9b8bf2,
    faHandshakeSimpleSlash: $5c8203742f0e3062$export$e99ae494101c5e91,
    faHandshakeAltSlash: $5c8203742f0e3062$export$ca302f956ae9f1bf,
    faMattressPillow: $5c8203742f0e3062$export$f042d3e458efa721,
    faGuaraniSign: $5c8203742f0e3062$export$b731a51acb74b00c,
    faArrowsRotate: $5c8203742f0e3062$export$2fd091cb98dc8ab8,
    faRefresh: $5c8203742f0e3062$export$fd4359e93d7b3d14,
    faSync: $5c8203742f0e3062$export$ff87319002e3dae9,
    faFireExtinguisher: $5c8203742f0e3062$export$d75fb6743634a0a,
    faCruzeiroSign: $5c8203742f0e3062$export$64dd1b27affb6572,
    faGreaterThanEqual: $5c8203742f0e3062$export$7bf8dfe2e6661a54,
    faShieldHalved: $5c8203742f0e3062$export$36e034ccc72554a9,
    faShieldAlt: $5c8203742f0e3062$export$d6508d18a824f291,
    faBookAtlas: $5c8203742f0e3062$export$7fb8daedae341012,
    faAtlas: $5c8203742f0e3062$export$380a9050e42fe5d7,
    faVirus: $5c8203742f0e3062$export$37c67e0b3dc6bd1b,
    faEnvelopeCircleCheck: $5c8203742f0e3062$export$74d890536dbd21b7,
    faLayerGroup: $5c8203742f0e3062$export$a137712e11e257dd,
    faArrowsToDot: $5c8203742f0e3062$export$ab3a06d4b53c0fc0,
    faArchway: $5c8203742f0e3062$export$d56753dd2eb5c323,
    faHeartCircleCheck: $5c8203742f0e3062$export$5e4b6785eedecc1a,
    faHouseChimneyCrack: $5c8203742f0e3062$export$e824540f5a6a8a57,
    faHouseDamage: $5c8203742f0e3062$export$8d7e943005ce0b49,
    faFileZipper: $5c8203742f0e3062$export$7a4a0e4caa1e4e6f,
    faFileArchive: $5c8203742f0e3062$export$bf2047a9946b5c3f,
    faSquare: $5c8203742f0e3062$export$90b4406457aae8cc,
    faMartiniGlassEmpty: $5c8203742f0e3062$export$a8a0de30198815a3,
    faGlassMartini: $5c8203742f0e3062$export$e96f280e39af4a91,
    faCouch: $5c8203742f0e3062$export$ce96e32767a7dd51,
    faCediSign: $5c8203742f0e3062$export$66c557f70914132c,
    faItalic: $5c8203742f0e3062$export$16e344bae4d495ed,
    faTableCellsColumnLock: $5c8203742f0e3062$export$257af4c5fc557105,
    faChurch: $5c8203742f0e3062$export$16a3f12c6ae9650,
    faCommentsDollar: $5c8203742f0e3062$export$d477129b070e5ac4,
    faDemocrat: $5c8203742f0e3062$export$a1672d808fbed0bd,
    faZ: $5c8203742f0e3062$export$3481c1aa28972f9b,
    faPersonSkiing: $5c8203742f0e3062$export$5ebd3cd0630e3ae7,
    faSkiing: $5c8203742f0e3062$export$eae1acab6fb96708,
    faRoadLock: $5c8203742f0e3062$export$b81a894d5bc3eb17,
    faA: $5c8203742f0e3062$export$406fe05808a3753e,
    faTemperatureArrowDown: $5c8203742f0e3062$export$4520eb1840c4e110,
    faTemperatureDown: $5c8203742f0e3062$export$f0b2aca3866f00f6,
    faFeatherPointed: $5c8203742f0e3062$export$2a9d3e120019c92d,
    faFeatherAlt: $5c8203742f0e3062$export$68cf766c786bcd78,
    faP: $5c8203742f0e3062$export$bcb419f1cd5beac3,
    faSnowflake: $5c8203742f0e3062$export$bab8f3647c394f48,
    faNewspaper: $5c8203742f0e3062$export$d91b374112d4f8c1,
    faRectangleAd: $5c8203742f0e3062$export$d0ccaddca9e06d1e,
    faAd: $5c8203742f0e3062$export$7af266c3465b1ff2,
    faCircleArrowRight: $5c8203742f0e3062$export$2f1e22e081a1ad05,
    faArrowCircleRight: $5c8203742f0e3062$export$7d3d828103aa3be7,
    faFilterCircleXmark: $5c8203742f0e3062$export$fb5ab619c34ea613,
    faLocust: $5c8203742f0e3062$export$4982360d3b844c19,
    faSort: $5c8203742f0e3062$export$4941c5969d5399b,
    faUnsorted: $5c8203742f0e3062$export$418597748f0fe52d,
    faListOl: $5c8203742f0e3062$export$3db8f67cd0fc963b,
    faList12: $5c8203742f0e3062$export$7e3d894cd55296b,
    faListNumeric: $5c8203742f0e3062$export$cf51408faadac277,
    faPersonDressBurst: $5c8203742f0e3062$export$523180e731928397,
    faMoneyCheckDollar: $5c8203742f0e3062$export$eeb59dd1825c6a65,
    faMoneyCheckAlt: $5c8203742f0e3062$export$8c6ccc9745897cb2,
    faVectorSquare: $5c8203742f0e3062$export$567d5631a7b0599f,
    faBreadSlice: $5c8203742f0e3062$export$d78e8b0681279167,
    faLanguage: $5c8203742f0e3062$export$8a7bee49fdf8c954,
    faFaceKissWinkHeart: $5c8203742f0e3062$export$611ae61f02de0aa,
    faKissWinkHeart: $5c8203742f0e3062$export$ebba617701dfb917,
    faFilter: $5c8203742f0e3062$export$f253a38d7142e29f,
    faQuestion: $5c8203742f0e3062$export$d96973f90e8f6e47,
    faFileSignature: $5c8203742f0e3062$export$d0de575ac166712b,
    faUpDownLeftRight: $5c8203742f0e3062$export$cd7b22f4e6e3834b,
    faArrowsAlt: $5c8203742f0e3062$export$3cdabfff52cfc73a,
    faHouseChimneyUser: $5c8203742f0e3062$export$1ddbaebce033a0d,
    faHandHoldingHeart: $5c8203742f0e3062$export$97e5ef3e80a0fbef,
    faPuzzlePiece: $5c8203742f0e3062$export$7ee0dbd1e92e2859,
    faMoneyCheck: $5c8203742f0e3062$export$be069f641c85d0b3,
    faStarHalfStroke: $5c8203742f0e3062$export$3e4892d8bf919edd,
    faStarHalfAlt: $5c8203742f0e3062$export$c13575f42532efb3,
    faCode: $5c8203742f0e3062$export$eba095993e51cc97,
    faWhiskeyGlass: $5c8203742f0e3062$export$f1304dd34ea2afbd,
    faGlassWhiskey: $5c8203742f0e3062$export$fdec0f5f1a169419,
    faBuildingCircleExclamation: $5c8203742f0e3062$export$c49f030b19083ebe,
    faMagnifyingGlassChart: $5c8203742f0e3062$export$6a1e4cdbb8ca10c5,
    faArrowUpRightFromSquare: $5c8203742f0e3062$export$5ad84e891223f2c3,
    faExternalLink: $5c8203742f0e3062$export$f4c613289034e5ef,
    faCubesStacked: $5c8203742f0e3062$export$b1f00c433aabac05,
    faWonSign: $5c8203742f0e3062$export$51790ddd26e431bc,
    faKrw: $5c8203742f0e3062$export$2f65e07a45b95b50,
    faWon: $5c8203742f0e3062$export$5a1fd3ed9564d7fa,
    faVirusCovid: $5c8203742f0e3062$export$1df4e031b8ee4f84,
    faAustralSign: $5c8203742f0e3062$export$299c200ad3db97b4,
    faF: $5c8203742f0e3062$export$a2f384a559654618,
    faLeaf: $5c8203742f0e3062$export$7c497bae2754a087,
    faRoad: $5c8203742f0e3062$export$f224567a4851a5e9,
    faTaxi: $5c8203742f0e3062$export$9958afcdfece1b58,
    faCab: $5c8203742f0e3062$export$7bf12d9380f0971b,
    faPersonCirclePlus: $5c8203742f0e3062$export$55686b1eb7d00307,
    faChartPie: $5c8203742f0e3062$export$1de7b9cf7d1b153b,
    faPieChart: $5c8203742f0e3062$export$7877286cd337de81,
    faBoltLightning: $5c8203742f0e3062$export$b16dcd08f3da1ba2,
    faSackXmark: $5c8203742f0e3062$export$2bad98c38bea5994,
    faFileExcel: $5c8203742f0e3062$export$77cb1a465c4fe84,
    faFileContract: $5c8203742f0e3062$export$70fde3f3fdaa6a6a,
    faFishFins: $5c8203742f0e3062$export$e7af4f0123222b6f,
    faBuildingFlag: $5c8203742f0e3062$export$592422b29ab0a914,
    faFaceGrinBeam: $5c8203742f0e3062$export$3de52eeb00462407,
    faGrinBeam: $5c8203742f0e3062$export$734da5249381ec7e,
    faObjectUngroup: $5c8203742f0e3062$export$887f6345573abcac,
    faPoop: $5c8203742f0e3062$export$bb45b6b87d1adf27,
    faLocationPin: $5c8203742f0e3062$export$c0b7617de95c0c05,
    faMapMarker: $5c8203742f0e3062$export$10d360e4f1a554dd,
    faKaaba: $5c8203742f0e3062$export$ab1408bfbe914cc9,
    faToiletPaper: $5c8203742f0e3062$export$c8cc083ccc72b17,
    faHelmetSafety: $5c8203742f0e3062$export$aacaf42fba617981,
    faHardHat: $5c8203742f0e3062$export$7b72177558a98b6f,
    faHatHard: $5c8203742f0e3062$export$c0e235dbf1644a2f,
    faEject: $5c8203742f0e3062$export$8484041d5b209494,
    faCircleRight: $5c8203742f0e3062$export$1fec48c8bdd69c1d,
    faArrowAltCircleRight: $5c8203742f0e3062$export$88962ffdad8b856d,
    faPlaneCircleCheck: $5c8203742f0e3062$export$9cbf8612c6cadc74,
    faFaceRollingEyes: $5c8203742f0e3062$export$a6d72a9a068392b5,
    faMehRollingEyes: $5c8203742f0e3062$export$fdc62a1bea767cc2,
    faObjectGroup: $5c8203742f0e3062$export$40cdac24aa94a57a,
    faChartLine: $5c8203742f0e3062$export$e022f62a119e1d93,
    faLineChart: $5c8203742f0e3062$export$f729617a20de475b,
    faMaskVentilator: $5c8203742f0e3062$export$122c8413a0dc5ff6,
    faArrowRight: $5c8203742f0e3062$export$b4da69a0247f3620,
    faSignsPost: $5c8203742f0e3062$export$905f45f8ffd6b8e5,
    faMapSigns: $5c8203742f0e3062$export$743f4b1071b3333a,
    faCashRegister: $5c8203742f0e3062$export$6357093f67788b33,
    faPersonCircleQuestion: $5c8203742f0e3062$export$c8f8a597ffd676c0,
    faH: $5c8203742f0e3062$export$d762b7b66d5875e1,
    faTarp: $5c8203742f0e3062$export$2305b1a41b3f914,
    faScrewdriverWrench: $5c8203742f0e3062$export$158a12f36bbecf9,
    faTools: $5c8203742f0e3062$export$646e4e7a8c6172aa,
    faArrowsToEye: $5c8203742f0e3062$export$9adae865350879af,
    faPlugCircleBolt: $5c8203742f0e3062$export$4f3b3144ce966486,
    faHeart: $5c8203742f0e3062$export$e4b51a47a2f8b9db,
    faMarsAndVenus: $5c8203742f0e3062$export$808b88e8735e31e8,
    faHouseUser: $5c8203742f0e3062$export$9a513ee921e8e885,
    faHomeUser: $5c8203742f0e3062$export$e732fa55ae5bbdf0,
    faDumpsterFire: $5c8203742f0e3062$export$25e9b29b3f2230b5,
    faHouseCrack: $5c8203742f0e3062$export$baa3c215534dbf2a,
    faMartiniGlassCitrus: $5c8203742f0e3062$export$c6e76550bdc0255d,
    faCocktail: $5c8203742f0e3062$export$4be708f1e41d387b,
    faFaceSurprise: $5c8203742f0e3062$export$c938968e28178994,
    faSurprise: $5c8203742f0e3062$export$46647c72213f53ba,
    faBottleWater: $5c8203742f0e3062$export$3ee278c67519eeeb,
    faCirclePause: $5c8203742f0e3062$export$fbeef2513e05ad08,
    faPauseCircle: $5c8203742f0e3062$export$d8cf08a0362da8db,
    faToiletPaperSlash: $5c8203742f0e3062$export$7a494edbf9b65575,
    faAppleWhole: $5c8203742f0e3062$export$12de8220d30453a3,
    faAppleAlt: $5c8203742f0e3062$export$bcdd94f3977a0884,
    faKitchenSet: $5c8203742f0e3062$export$64c1570509eaf40d,
    faR: $5c8203742f0e3062$export$eb4c616de6eef46f,
    faTemperatureQuarter: $5c8203742f0e3062$export$f9d1c19925fd7fa8,
    faTemperature1: $5c8203742f0e3062$export$d4f1cd380bde2129,
    faThermometer1: $5c8203742f0e3062$export$3f77fbe2dabe285b,
    faThermometerQuarter: $5c8203742f0e3062$export$ed05754fcbec6e46,
    faCube: $5c8203742f0e3062$export$973ae4f1e4d2ce78,
    faBitcoinSign: $5c8203742f0e3062$export$441bfc8058328ce8,
    faShieldDog: $5c8203742f0e3062$export$2a5c6f182c0cbcb,
    faSolarPanel: $5c8203742f0e3062$export$b9c649c5e37017f3,
    faLockOpen: $5c8203742f0e3062$export$84b5acad4436d02a,
    faElevator: $5c8203742f0e3062$export$c7a833ce065e0ea4,
    faMoneyBillTransfer: $5c8203742f0e3062$export$1b71392d9effbe,
    faMoneyBillTrendUp: $5c8203742f0e3062$export$18ab80cba7d5044f,
    faHouseFloodWaterCircleArrowRight: $5c8203742f0e3062$export$30d3e64480aa266b,
    faSquarePollHorizontal: $5c8203742f0e3062$export$287bdd70ab874659,
    faPollH: $5c8203742f0e3062$export$456a238f0144d430,
    faCircle: $5c8203742f0e3062$export$4280b2387fbdad12,
    faBackwardFast: $5c8203742f0e3062$export$662cbc6ed5a3c5e8,
    faFastBackward: $5c8203742f0e3062$export$e6246a3279a379b8,
    faRecycle: $5c8203742f0e3062$export$a65c441f12cb6bd,
    faUserAstronaut: $5c8203742f0e3062$export$94363e983c225a04,
    faPlaneSlash: $5c8203742f0e3062$export$cfee4df0d5df6d21,
    faTrademark: $5c8203742f0e3062$export$9c9b2fbddd59047d,
    faBasketball: $5c8203742f0e3062$export$44dee69e3a29b0e,
    faBasketballBall: $5c8203742f0e3062$export$36550ab8ffcc5b28,
    faSatelliteDish: $5c8203742f0e3062$export$219ccae0e4da3c92,
    faCircleUp: $5c8203742f0e3062$export$72ea8a5e4e86cd69,
    faArrowAltCircleUp: $5c8203742f0e3062$export$3747a8ef0995eadf,
    faMobileScreenButton: $5c8203742f0e3062$export$da39ed20699ee2d7,
    faMobileAlt: $5c8203742f0e3062$export$e9599bc6cd92234d,
    faVolumeHigh: $5c8203742f0e3062$export$39461921e738be65,
    faVolumeUp: $5c8203742f0e3062$export$5940d3e475d90cc4,
    faUsersRays: $5c8203742f0e3062$export$9c0b63b698611d06,
    faWallet: $5c8203742f0e3062$export$79204db8777905c8,
    faClipboardCheck: $5c8203742f0e3062$export$7babcb2c90eb609a,
    faFileAudio: $5c8203742f0e3062$export$b8d24c57c9e64933,
    faBurger: $5c8203742f0e3062$export$128a6cab12423493,
    faHamburger: $5c8203742f0e3062$export$bab3bb9f4f59363,
    faWrench: $5c8203742f0e3062$export$3c6c0c8185296ac5,
    faBugs: $5c8203742f0e3062$export$f5bfd1271b8b71d1,
    faRupeeSign: $5c8203742f0e3062$export$8bf9e3f7f57d486a,
    faRupee: $5c8203742f0e3062$export$9da25a46cfcb6fa4,
    faFileImage: $5c8203742f0e3062$export$6440b286d3cbac9b,
    faCircleQuestion: $5c8203742f0e3062$export$d7cf0978afd90002,
    faQuestionCircle: $5c8203742f0e3062$export$5ba67d7f2265c1a5,
    faPlaneDeparture: $5c8203742f0e3062$export$6ccbeeccfea6dc8a,
    faHandshakeSlash: $5c8203742f0e3062$export$2cef3f81ad90fb76,
    faBookBookmark: $5c8203742f0e3062$export$3d177ecdf7fc50ec,
    faCodeBranch: $5c8203742f0e3062$export$aa054a78ab078db3,
    faHatCowboy: $5c8203742f0e3062$export$37672611144b857b,
    faBridge: $5c8203742f0e3062$export$f402c7c97f3383f0,
    faPhoneFlip: $5c8203742f0e3062$export$d86c56ab43eb0deb,
    faPhoneAlt: $5c8203742f0e3062$export$a07a9b305deebf32,
    faTruckFront: $5c8203742f0e3062$export$4a5a13c01d46357c,
    faCat: $5c8203742f0e3062$export$ab927dada03be4b3,
    faAnchorCircleExclamation: $5c8203742f0e3062$export$61add9eca991b5ec,
    faTruckField: $5c8203742f0e3062$export$f4419f7b2e53b340,
    faRoute: $5c8203742f0e3062$export$806c0a45a7ecd6e8,
    faClipboardQuestion: $5c8203742f0e3062$export$d4aa151a4554b74e,
    faPanorama: $5c8203742f0e3062$export$5dd22dcb6e3ed369,
    faCommentMedical: $5c8203742f0e3062$export$101422b773924276,
    faTeethOpen: $5c8203742f0e3062$export$c88ac21fe7c88ae6,
    faFileCircleMinus: $5c8203742f0e3062$export$4b89fabf50a10951,
    faTags: $5c8203742f0e3062$export$d55778e3ab6c933f,
    faWineGlass: $5c8203742f0e3062$export$e06d6607d3577d6e,
    faForwardFast: $5c8203742f0e3062$export$dc9cc4280bee320d,
    faFastForward: $5c8203742f0e3062$export$61a8cdc53c2e078d,
    faFaceMehBlank: $5c8203742f0e3062$export$38c072b870a9e4ab,
    faMehBlank: $5c8203742f0e3062$export$e945435725f71e88,
    faSquareParking: $5c8203742f0e3062$export$f2cfa036d76f69ab,
    faParking: $5c8203742f0e3062$export$fda29c8f99573a4e,
    faHouseSignal: $5c8203742f0e3062$export$58845db8e7e9a199,
    faBarsProgress: $5c8203742f0e3062$export$ee3a02da18715b2,
    faTasksAlt: $5c8203742f0e3062$export$bbc0784fc1578f7f,
    faFaucetDrip: $5c8203742f0e3062$export$7a255960242435f6,
    faCartFlatbed: $5c8203742f0e3062$export$df587aaf7765e1ce,
    faDollyFlatbed: $5c8203742f0e3062$export$f7c6efb60c53b285,
    faBanSmoking: $5c8203742f0e3062$export$130df7ed74437774,
    faSmokingBan: $5c8203742f0e3062$export$e50452a49dec29f,
    faTerminal: $5c8203742f0e3062$export$5e63e8b85b5f119c,
    faMobileButton: $5c8203742f0e3062$export$c93d62849efbdd11,
    faHouseMedicalFlag: $5c8203742f0e3062$export$86c50f517be57a40,
    faBasketShopping: $5c8203742f0e3062$export$1d307c13b511e8e1,
    faShoppingBasket: $5c8203742f0e3062$export$ca6d443595a6578f,
    faTape: $5c8203742f0e3062$export$b88ed5e1e0eac4c6,
    faBusSimple: $5c8203742f0e3062$export$d3724faf0c559353,
    faBusAlt: $5c8203742f0e3062$export$40616edfab6d332a,
    faEye: $5c8203742f0e3062$export$b8c3e79e8c99c95b,
    faFaceSadCry: $5c8203742f0e3062$export$e8ea88c55e55be7c,
    faSadCry: $5c8203742f0e3062$export$8e924e6bd422cef9,
    faAudioDescription: $5c8203742f0e3062$export$b6b464c98c009494,
    faPersonMilitaryToPerson: $5c8203742f0e3062$export$41b1e14a6b0fe11b,
    faFileShield: $5c8203742f0e3062$export$348a01df65a66c99,
    faUserSlash: $5c8203742f0e3062$export$3924ab4d3ef9b5ef,
    faPen: $5c8203742f0e3062$export$8f4567331fb0d3bc,
    faTowerObservation: $5c8203742f0e3062$export$5b2f0f631f559d51,
    faFileCode: $5c8203742f0e3062$export$143d0ca7d2200f20,
    faSignal: $5c8203742f0e3062$export$79046b073b6c584d,
    faSignal5: $5c8203742f0e3062$export$3417071118065933,
    faSignalPerfect: $5c8203742f0e3062$export$1aea50ab3e99cc95,
    faBus: $5c8203742f0e3062$export$ce69441578ff2fdb,
    faHeartCircleXmark: $5c8203742f0e3062$export$742f89ae2f8d6b20,
    faHouseChimney: $5c8203742f0e3062$export$af554427144a7e5c,
    faHomeLg: $5c8203742f0e3062$export$dbab81727ec94698,
    faWindowMaximize: $5c8203742f0e3062$export$703cd98be31ec905,
    faFaceFrown: $5c8203742f0e3062$export$e5f78e87efbb0248,
    faFrown: $5c8203742f0e3062$export$43b7108508aecc5f,
    faPrescription: $5c8203742f0e3062$export$8767bafb19515ee4,
    faShop: $5c8203742f0e3062$export$78edc9b98453b6f7,
    faStoreAlt: $5c8203742f0e3062$export$1f1871dab9cec9d8,
    faFloppyDisk: $5c8203742f0e3062$export$f62f2879ccaea13f,
    faSave: $5c8203742f0e3062$export$1aaa83ff70706e1e,
    faVihara: $5c8203742f0e3062$export$ee4b92e89fe0dfaf,
    faScaleUnbalanced: $5c8203742f0e3062$export$4d10bcc8d068f454,
    faBalanceScaleLeft: $5c8203742f0e3062$export$786cb0c775487f19,
    faSortUp: $5c8203742f0e3062$export$f9dd5b1410e95035,
    faSortAsc: $5c8203742f0e3062$export$e4c8c924b1cc43a7,
    faCommentDots: $5c8203742f0e3062$export$63ffcb3d4e94cb92,
    faCommenting: $5c8203742f0e3062$export$49ee382a2425e89c,
    faPlantWilt: $5c8203742f0e3062$export$77a38850ff8b0407,
    faDiamond: $5c8203742f0e3062$export$f214f827e0023247,
    faFaceGrinSquint: $5c8203742f0e3062$export$5d53da7627754bc6,
    faGrinSquint: $5c8203742f0e3062$export$243ae757907b1580,
    faHandHoldingDollar: $5c8203742f0e3062$export$61a67f5f8ab39be,
    faHandHoldingUsd: $5c8203742f0e3062$export$47d27bc305b59690,
    faBacterium: $5c8203742f0e3062$export$b0babe4230e35ebe,
    faHandPointer: $5c8203742f0e3062$export$d97ff927c450c87f,
    faDrumSteelpan: $5c8203742f0e3062$export$48d1206500db2e9d,
    faHandScissors: $5c8203742f0e3062$export$c578e919f2c5c135,
    faHandsPraying: $5c8203742f0e3062$export$a96374faedb12593,
    faPrayingHands: $5c8203742f0e3062$export$95e08e91b0929943,
    faArrowRotateRight: $5c8203742f0e3062$export$9c58ddc4b3356f98,
    faArrowRightRotate: $5c8203742f0e3062$export$ffa1245982c1b28b,
    faArrowRotateForward: $5c8203742f0e3062$export$89c59b5f47067f4c,
    faRedo: $5c8203742f0e3062$export$3d9f98aa1c24c776,
    faBiohazard: $5c8203742f0e3062$export$ae3a453550dec95,
    faLocationCrosshairs: $5c8203742f0e3062$export$14e1096ad1719098,
    faLocation: $5c8203742f0e3062$export$45e012c32174eb5d,
    faMarsDouble: $5c8203742f0e3062$export$2f8a28204bb4b86f,
    faChildDress: $5c8203742f0e3062$export$f31a37ecbfd4e707,
    faUsersBetweenLines: $5c8203742f0e3062$export$6ea1decf8bb3513d,
    faLungsVirus: $5c8203742f0e3062$export$895159d10626af74,
    faFaceGrinTears: $5c8203742f0e3062$export$8ac6d81a3d5b40a1,
    faGrinTears: $5c8203742f0e3062$export$b2f7512221512b5b,
    faPhone: $5c8203742f0e3062$export$ddab067855cf34cb,
    faCalendarXmark: $5c8203742f0e3062$export$3c70ffe5660af060,
    faCalendarTimes: $5c8203742f0e3062$export$99b20d7352fbcf08,
    faChildReaching: $5c8203742f0e3062$export$84a2f9476730c40e,
    faHeadSideVirus: $5c8203742f0e3062$export$5b64b916710da7c7,
    faUserGear: $5c8203742f0e3062$export$f504a6909b677146,
    faUserCog: $5c8203742f0e3062$export$474108c2b86e730e,
    faArrowUp19: $5c8203742f0e3062$export$bbbff45e04f4abab,
    faSortNumericUp: $5c8203742f0e3062$export$d213a3ba3cabed48,
    faDoorClosed: $5c8203742f0e3062$export$2c79e1a422528bba,
    faShieldVirus: $5c8203742f0e3062$export$bea811bbf570f05a,
    faDiceSix: $5c8203742f0e3062$export$3397c7b4679acccc,
    faMosquitoNet: $5c8203742f0e3062$export$f3858ce1b3218e2,
    faBridgeWater: $5c8203742f0e3062$export$154e99cb34841765,
    faPersonBooth: $5c8203742f0e3062$export$2337c975289bdd84,
    faTextWidth: $5c8203742f0e3062$export$d8724cf433389700,
    faHatWizard: $5c8203742f0e3062$export$7daa48199dcb2ad1,
    faPenFancy: $5c8203742f0e3062$export$8bdfe14ac72a8b17,
    faPersonDigging: $5c8203742f0e3062$export$f4d483fca19a4604,
    faDigging: $5c8203742f0e3062$export$7bd93e3343bd5671,
    faTrash: $5c8203742f0e3062$export$ed8c149a0ea54bb4,
    faGaugeSimple: $5c8203742f0e3062$export$f3a0a4e6723a86d4,
    faGaugeSimpleMed: $5c8203742f0e3062$export$ba8c12ff7cfa2521,
    faTachometerAverage: $5c8203742f0e3062$export$94fcfd6f6335431b,
    faBookMedical: $5c8203742f0e3062$export$6feb44fec53ba30d,
    faPoo: $5c8203742f0e3062$export$dd0ede1713d2d2f9,
    faQuoteRight: $5c8203742f0e3062$export$54e3a80c9875b74c,
    faQuoteRightAlt: $5c8203742f0e3062$export$dd692f2e88bd4b1a,
    faShirt: $5c8203742f0e3062$export$312f2c01c6fedca8,
    faTShirt: $5c8203742f0e3062$export$144e5f8bc4d705a6,
    faTshirt: $5c8203742f0e3062$export$36edce3ba87c2b17,
    faCubes: $5c8203742f0e3062$export$30523a9441a31e97,
    faDivide: $5c8203742f0e3062$export$89fa217ec5503ac9,
    faTengeSign: $5c8203742f0e3062$export$c04e864469c1d117,
    faTenge: $5c8203742f0e3062$export$af6ebee83047b793,
    faHeadphones: $5c8203742f0e3062$export$ad02dd8ca5816958,
    faHandsHolding: $5c8203742f0e3062$export$96891bbcda1dbb7b,
    faHandsClapping: $5c8203742f0e3062$export$765c446e974b5e59,
    faRepublican: $5c8203742f0e3062$export$929518bb4b66a588,
    faArrowLeft: $5c8203742f0e3062$export$b7fac681e7d09400,
    faPersonCircleXmark: $5c8203742f0e3062$export$16c9e0374c346c6e,
    faRuler: $5c8203742f0e3062$export$8e90575265a56cfc,
    faAlignLeft: $5c8203742f0e3062$export$e490f662af4d1c78,
    faDiceD6: $5c8203742f0e3062$export$64bfd48ed353c031,
    faRestroom: $5c8203742f0e3062$export$5fbcef35138741a5,
    faJ: $5c8203742f0e3062$export$bbf24078bd1f73e6,
    faUsersViewfinder: $5c8203742f0e3062$export$72b785dcfe44c69b,
    faFileVideo: $5c8203742f0e3062$export$b44eb38345c6a964,
    faUpRightFromSquare: $5c8203742f0e3062$export$c1a3ba061b4f60c4,
    faExternalLinkAlt: $5c8203742f0e3062$export$d7f107e456ab0306,
    faTableCells: $5c8203742f0e3062$export$c517dffc18db483f,
    faTh: $5c8203742f0e3062$export$4d383c83efc0c819,
    faFilePdf: $5c8203742f0e3062$export$38611f1c776aba73,
    faBookBible: $5c8203742f0e3062$export$df8194b081d34b27,
    faBible: $5c8203742f0e3062$export$2eac809b0670d139,
    faO: $5c8203742f0e3062$export$9db87eabf605857e,
    faSuitcaseMedical: $5c8203742f0e3062$export$25ea11267429d202,
    faMedkit: $5c8203742f0e3062$export$e75f02bae5b7d34b,
    faUserSecret: $5c8203742f0e3062$export$597826232327559b,
    faOtter: $5c8203742f0e3062$export$743cce3ca4eb1d7d,
    faPersonDress: $5c8203742f0e3062$export$27f7383b96c3f4b4,
    faFemale: $5c8203742f0e3062$export$70e8e75e61dd7169,
    faCommentDollar: $5c8203742f0e3062$export$7a088030853df12c,
    faBusinessTime: $5c8203742f0e3062$export$694b7e88782dec12,
    faBriefcaseClock: $5c8203742f0e3062$export$8b00ae94743552ce,
    faTableCellsLarge: $5c8203742f0e3062$export$d2bcaf492dfb3817,
    faThLarge: $5c8203742f0e3062$export$69782f333e90cdc6,
    faBookTanakh: $5c8203742f0e3062$export$24c764717169f536,
    faTanakh: $5c8203742f0e3062$export$7fd4a58929315448,
    faPhoneVolume: $5c8203742f0e3062$export$c377f240bb8b5d74,
    faVolumeControlPhone: $5c8203742f0e3062$export$5358d004fa3d3be2,
    faHatCowboySide: $5c8203742f0e3062$export$ab6f71fd6878da90,
    faClipboardUser: $5c8203742f0e3062$export$1204f2d171424659,
    faChild: $5c8203742f0e3062$export$60b41e3581d1739a,
    faLiraSign: $5c8203742f0e3062$export$f0f37dbc60110b10,
    faSatellite: $5c8203742f0e3062$export$da3f1730d013e224,
    faPlaneLock: $5c8203742f0e3062$export$1125ac57be52258c,
    faTag: $5c8203742f0e3062$export$cb61f447f29887e,
    faComment: $5c8203742f0e3062$export$805cd88398a70581,
    faCakeCandles: $5c8203742f0e3062$export$e4019fe302a972e1,
    faBirthdayCake: $5c8203742f0e3062$export$bdcf98f725a7241a,
    faCake: $5c8203742f0e3062$export$707bc1c80c0177c1,
    faEnvelope: $5c8203742f0e3062$export$6f095630677adc,
    faAnglesUp: $5c8203742f0e3062$export$152ef92a4f9d80a7,
    faAngleDoubleUp: $5c8203742f0e3062$export$9bb51e1a2c07db7c,
    faPaperclip: $5c8203742f0e3062$export$4b24ca1552f410af,
    faArrowRightToCity: $5c8203742f0e3062$export$e201217e5046cd15,
    faRibbon: $5c8203742f0e3062$export$838459d11f3971df,
    faLungs: $5c8203742f0e3062$export$ba9b387e84727819,
    faArrowUp91: $5c8203742f0e3062$export$25218e5886296cb9,
    faSortNumericUpAlt: $5c8203742f0e3062$export$d41859f1bbb9e086,
    faLitecoinSign: $5c8203742f0e3062$export$4a157bd81dcd8d80,
    faBorderNone: $5c8203742f0e3062$export$2b488402ec335d97,
    faCircleNodes: $5c8203742f0e3062$export$de462dd5a18e80d4,
    faParachuteBox: $5c8203742f0e3062$export$ca9e3368f1d9500a,
    faIndent: $5c8203742f0e3062$export$318208bc30aeebcc,
    faTruckFieldUn: $5c8203742f0e3062$export$40cb0a4a3a74dc03,
    faHourglass: $5c8203742f0e3062$export$b9098a890f61e022,
    faHourglassEmpty: $5c8203742f0e3062$export$a2f8176a0161e891,
    faMountain: $5c8203742f0e3062$export$64f9eb99c9749cce,
    faUserDoctor: $5c8203742f0e3062$export$9884bf227eeb829,
    faUserMd: $5c8203742f0e3062$export$ab0d33a2c03f1794,
    faCircleInfo: $5c8203742f0e3062$export$317f99f46b39906e,
    faInfoCircle: $5c8203742f0e3062$export$aa9288aeadf882fa,
    faCloudMeatball: $5c8203742f0e3062$export$5d120e8b87ad33f4,
    faCamera: $5c8203742f0e3062$export$84ffbd7161ca2008,
    faCameraAlt: $5c8203742f0e3062$export$8872b5664e88e793,
    faSquareVirus: $5c8203742f0e3062$export$f9409a7b020dbec4,
    faMeteor: $5c8203742f0e3062$export$1439f0d6365138da,
    faCarOn: $5c8203742f0e3062$export$d901d50df5cf8d91,
    faSleigh: $5c8203742f0e3062$export$26a8fd1143d2d6c0,
    faArrowDown19: $5c8203742f0e3062$export$9a40d582bd4628fb,
    faSortNumericAsc: $5c8203742f0e3062$export$a4fb1aa2cdfb18d7,
    faSortNumericDown: $5c8203742f0e3062$export$835db7eb35b3c29b,
    faHandHoldingDroplet: $5c8203742f0e3062$export$b9c3f9a906f96b82,
    faHandHoldingWater: $5c8203742f0e3062$export$4265371b99d38b95,
    faWater: $5c8203742f0e3062$export$efaeddad0a6e901b,
    faCalendarCheck: $5c8203742f0e3062$export$5655108e1162ba45,
    faBraille: $5c8203742f0e3062$export$983e9c27cac7ed1c,
    faPrescriptionBottleMedical: $5c8203742f0e3062$export$99cfe064ff0b71c9,
    faPrescriptionBottleAlt: $5c8203742f0e3062$export$65d1c884b8581d1a,
    faLandmark: $5c8203742f0e3062$export$2bebc54c51db6505,
    faTruck: $5c8203742f0e3062$export$d7895f386f8bd8b8,
    faCrosshairs: $5c8203742f0e3062$export$721c101130c40043,
    faPersonCane: $5c8203742f0e3062$export$c48422e9da776c1b,
    faTent: $5c8203742f0e3062$export$e5075400db564e24,
    faVestPatches: $5c8203742f0e3062$export$750a64470c2e0f3f,
    faCheckDouble: $5c8203742f0e3062$export$f178c8c2ad3cc861,
    faArrowDownAZ: $5c8203742f0e3062$export$43b642fac7053978,
    faSortAlphaAsc: $5c8203742f0e3062$export$cb87697f2fa77cfc,
    faSortAlphaDown: $5c8203742f0e3062$export$7658045270aafde3,
    faMoneyBillWheat: $5c8203742f0e3062$export$6a4ef2ef77625063,
    faCookie: $5c8203742f0e3062$export$b3e64f5f68c6623f,
    faArrowRotateLeft: $5c8203742f0e3062$export$89b706873769c180,
    faArrowLeftRotate: $5c8203742f0e3062$export$1aea864c3e1d79b,
    faArrowRotateBack: $5c8203742f0e3062$export$a34701878babe5fc,
    faArrowRotateBackward: $5c8203742f0e3062$export$fce381d12e4535cd,
    faUndo: $5c8203742f0e3062$export$a5e5ba60b1dfe2b2,
    faHardDrive: $5c8203742f0e3062$export$4cb736b866cbb7ec,
    faHdd: $5c8203742f0e3062$export$62551e9c5ba7093f,
    faFaceGrinSquintTears: $5c8203742f0e3062$export$8ff56f5ebb8416a0,
    faGrinSquintTears: $5c8203742f0e3062$export$542206d6a85f3b42,
    faDumbbell: $5c8203742f0e3062$export$56700074cf37be5c,
    faRectangleList: $5c8203742f0e3062$export$1f7600fa9fdb3978,
    faListAlt: $5c8203742f0e3062$export$c6327a203ffc65a3,
    faTarpDroplet: $5c8203742f0e3062$export$1585b7c3c7109751,
    faHouseMedicalCircleCheck: $5c8203742f0e3062$export$5d08d08f88a96aac,
    faPersonSkiingNordic: $5c8203742f0e3062$export$c8cd1786449517d3,
    faSkiingNordic: $5c8203742f0e3062$export$6ea48260d7d09b1b,
    faCalendarPlus: $5c8203742f0e3062$export$16768a660ae3ca9d,
    faPlaneArrival: $5c8203742f0e3062$export$9b2dbe133273f284,
    faCircleLeft: $5c8203742f0e3062$export$5ae86b9da9cca3bd,
    faArrowAltCircleLeft: $5c8203742f0e3062$export$5460a5b11a24996f,
    faTrainSubway: $5c8203742f0e3062$export$cda326cc3bce41c,
    faSubway: $5c8203742f0e3062$export$4cabc8a12d4e2f9,
    faChartGantt: $5c8203742f0e3062$export$dce43b02b3fe0c18,
    faIndianRupeeSign: $5c8203742f0e3062$export$1d2b135cc5a2c852,
    faIndianRupee: $5c8203742f0e3062$export$be886a4def17c565,
    faInr: $5c8203742f0e3062$export$12c6d8b3e052490b,
    faCropSimple: $5c8203742f0e3062$export$c3605731beb92daf,
    faCropAlt: $5c8203742f0e3062$export$d932915fde4f1010,
    faMoneyBill1: $5c8203742f0e3062$export$a312c7d58dd44a75,
    faMoneyBillAlt: $5c8203742f0e3062$export$a35d573395884c3d,
    faLeftLong: $5c8203742f0e3062$export$1db7e2ee10d36035,
    faLongArrowAltLeft: $5c8203742f0e3062$export$a8b3226b2bf323d,
    faDna: $5c8203742f0e3062$export$c062100d54a2da00,
    faVirusSlash: $5c8203742f0e3062$export$c4ff5306c5470939,
    faMinus: $5c8203742f0e3062$export$fee0376c250cdef,
    faSubtract: $5c8203742f0e3062$export$f8cb2531ef1fc4a2,
    faChess: $5c8203742f0e3062$export$442fddbbd741c590,
    faArrowLeftLong: $5c8203742f0e3062$export$6e5225f0e6c0bacd,
    faLongArrowLeft: $5c8203742f0e3062$export$80896efc906118b4,
    faPlugCircleCheck: $5c8203742f0e3062$export$2bd45e99b9afa947,
    faStreetView: $5c8203742f0e3062$export$6aab6c3359c2554c,
    faFrancSign: $5c8203742f0e3062$export$acef3e5c2029d285,
    faVolumeOff: $5c8203742f0e3062$export$d94ba52e980ea0f1,
    faHandsAslInterpreting: $5c8203742f0e3062$export$bc43eb4655c78f49,
    faAmericanSignLanguageInterpreting: $5c8203742f0e3062$export$23a7517099ab1b86,
    faAslInterpreting: $5c8203742f0e3062$export$beb51abfb05a4eca,
    faHandsAmericanSignLanguageInterpreting: $5c8203742f0e3062$export$82846008645b0301,
    faGear: $5c8203742f0e3062$export$ec05accb7226d001,
    faCog: $5c8203742f0e3062$export$d6298bbfd1912a78,
    faDropletSlash: $5c8203742f0e3062$export$1d6c5a49025d720b,
    faTintSlash: $5c8203742f0e3062$export$5d6f0943039b898f,
    faMosque: $5c8203742f0e3062$export$4999586d7e1087fb,
    faMosquito: $5c8203742f0e3062$export$67c7a1518d0715ff,
    faStarOfDavid: $5c8203742f0e3062$export$f823fee3712b2601,
    faPersonMilitaryRifle: $5c8203742f0e3062$export$842b988dae95ccb8,
    faCartShopping: $5c8203742f0e3062$export$c790b41dc166ae13,
    faShoppingCart: $5c8203742f0e3062$export$51da406e5aa1388c,
    faVials: $5c8203742f0e3062$export$507e8edd7676b2e9,
    faPlugCirclePlus: $5c8203742f0e3062$export$f193138a7d21971c,
    faPlaceOfWorship: $5c8203742f0e3062$export$c5a9302c8c13c79a,
    faGripVertical: $5c8203742f0e3062$export$cacbd95c283996ec,
    faArrowTurnUp: $5c8203742f0e3062$export$2d3ccb9b2099f3fe,
    faLevelUp: $5c8203742f0e3062$export$c227d3ba1de97ceb,
    faU: $5c8203742f0e3062$export$4f39e8dbaf09ea8b,
    faSquareRootVariable: $5c8203742f0e3062$export$60b44cfa7af18422,
    faSquareRootAlt: $5c8203742f0e3062$export$28e4b96627e00057,
    faClock: $5c8203742f0e3062$export$95b9968e7fceb821,
    faClockFour: $5c8203742f0e3062$export$9a575facf1cab48f,
    faBackwardStep: $5c8203742f0e3062$export$5d2b6a700940df16,
    faStepBackward: $5c8203742f0e3062$export$2884e379aed297d4,
    faPallet: $5c8203742f0e3062$export$d7ff2047dbc34562,
    faFaucet: $5c8203742f0e3062$export$a0856b225f3b0614,
    faBaseballBatBall: $5c8203742f0e3062$export$59669f486ab41d86,
    faS: $5c8203742f0e3062$export$cb39585371b75720,
    faTimeline: $5c8203742f0e3062$export$5e239d90ef904a84,
    faKeyboard: $5c8203742f0e3062$export$fb61df5d98785fa8,
    faCaretDown: $5c8203742f0e3062$export$f9395ef707603e40,
    faHouseChimneyMedical: $5c8203742f0e3062$export$9c73560282dceccd,
    faClinicMedical: $5c8203742f0e3062$export$20d8a680febc7434,
    faTemperatureThreeQuarters: $5c8203742f0e3062$export$7ed2bad15ae6237f,
    faTemperature3: $5c8203742f0e3062$export$89def3268ed9b4bc,
    faThermometer3: $5c8203742f0e3062$export$2f653125f4e6463,
    faThermometerThreeQuarters: $5c8203742f0e3062$export$6c632d1dc30d4a77,
    faMobileScreen: $5c8203742f0e3062$export$8867e7da34bb8bf4,
    faMobileAndroidAlt: $5c8203742f0e3062$export$cb39d7b468ba5838,
    faPlaneUp: $5c8203742f0e3062$export$a5f2976a01fdc970,
    faPiggyBank: $5c8203742f0e3062$export$46d49a6734c4872a,
    faBatteryHalf: $5c8203742f0e3062$export$e6dadc1155c4ee48,
    faBattery3: $5c8203742f0e3062$export$f9138caac2aedaed,
    faMountainCity: $5c8203742f0e3062$export$28f06bbf9c17c3af,
    faCoins: $5c8203742f0e3062$export$bc5da164799a0e,
    faKhanda: $5c8203742f0e3062$export$8d41d1f1ba3f9217,
    faSliders: $5c8203742f0e3062$export$ea6970ed5a15feb6,
    faSlidersH: $5c8203742f0e3062$export$94d4dcb523f95563,
    faFolderTree: $5c8203742f0e3062$export$54d16fa2e445d3fe,
    faNetworkWired: $5c8203742f0e3062$export$882cabd11f4943b8,
    faMapPin: $5c8203742f0e3062$export$184725965b3402dc,
    faHamsa: $5c8203742f0e3062$export$38d20d399463edf9,
    faCentSign: $5c8203742f0e3062$export$875b6c94a4b00ea8,
    faFlask: $5c8203742f0e3062$export$f9b579ba06048af,
    faPersonPregnant: $5c8203742f0e3062$export$e7b4c26b5857fe9c,
    faWandSparkles: $5c8203742f0e3062$export$76cc39f249b6864e,
    faEllipsisVertical: $5c8203742f0e3062$export$7480721bf113be3e,
    faEllipsisV: $5c8203742f0e3062$export$e58494c7fcb5380,
    faTicket: $5c8203742f0e3062$export$3604f15924cf0b98,
    faPowerOff: $5c8203742f0e3062$export$a1cca9928dcf9798,
    faRightLong: $5c8203742f0e3062$export$b356b1dbe7d7f736,
    faLongArrowAltRight: $5c8203742f0e3062$export$533e1f578f74c066,
    faFlagUsa: $5c8203742f0e3062$export$19357abad396e723,
    faLaptopFile: $5c8203742f0e3062$export$e1046cf83da9b7ef,
    faTty: $5c8203742f0e3062$export$7c85aba0f9624b29,
    faTeletype: $5c8203742f0e3062$export$14bcd5c43dc736f9,
    faDiagramNext: $5c8203742f0e3062$export$2faddf1690e14e11,
    faPersonRifle: $5c8203742f0e3062$export$b16df914812cedbe,
    faHouseMedicalCircleExclamation: $5c8203742f0e3062$export$bc50edea6e121df5,
    faClosedCaptioning: $5c8203742f0e3062$export$8e047801a8603af7,
    faPersonHiking: $5c8203742f0e3062$export$baf9f153991b2ea,
    faHiking: $5c8203742f0e3062$export$b2ab0105a901499e,
    faVenusDouble: $5c8203742f0e3062$export$6a6f9cba7a1e5fe4,
    faImages: $5c8203742f0e3062$export$74f06b41ed2ca28a,
    faCalculator: $5c8203742f0e3062$export$693bd40950ed2c3a,
    faPeoplePulling: $5c8203742f0e3062$export$dace56f632fecf6f,
    faN: $5c8203742f0e3062$export$328a9baf0f9e3405,
    faCableCar: $5c8203742f0e3062$export$85cb04eaefaf2d8b,
    faTram: $5c8203742f0e3062$export$a7a36674c079f293,
    faCloudRain: $5c8203742f0e3062$export$a6c308ee087b4ded,
    faBuildingCircleXmark: $5c8203742f0e3062$export$c4c015418a1f24df,
    faShip: $5c8203742f0e3062$export$6c645741140616af,
    faArrowsDownToLine: $5c8203742f0e3062$export$8f2463c7b2fc6ae4,
    faDownload: $5c8203742f0e3062$export$8f734e51d72ca13a,
    faFaceGrin: $5c8203742f0e3062$export$92292137ef3cf4c8,
    faGrin: $5c8203742f0e3062$export$37e1f10b6de76621,
    faDeleteLeft: $5c8203742f0e3062$export$bbcc9e0b6022772b,
    faBackspace: $5c8203742f0e3062$export$e43e3f67102fc526,
    faEyeDropper: $5c8203742f0e3062$export$1bc3e0ad56dc9eb0,
    faEyeDropperEmpty: $5c8203742f0e3062$export$ef304e9b7524c1f9,
    faEyedropper: $5c8203742f0e3062$export$91549a375c0b6d25,
    faFileCircleCheck: $5c8203742f0e3062$export$8547e9f3a2ddab5b,
    faForward: $5c8203742f0e3062$export$a8710cdb23198d53,
    faMobile: $5c8203742f0e3062$export$59edacfad04cd121,
    faMobileAndroid: $5c8203742f0e3062$export$82f602311a698c32,
    faMobilePhone: $5c8203742f0e3062$export$475a9be8da747e57,
    faFaceMeh: $5c8203742f0e3062$export$dc130582748497c6,
    faMeh: $5c8203742f0e3062$export$6d2db489aaeeecd2,
    faAlignCenter: $5c8203742f0e3062$export$70e29dd05344623e,
    faBookSkull: $5c8203742f0e3062$export$a57d448e8969ce8a,
    faBookDead: $5c8203742f0e3062$export$b98a3f8c3941a74a,
    faIdCard: $5c8203742f0e3062$export$782ac893fc22249b,
    faDriversLicense: $5c8203742f0e3062$export$8359c70e609eff64,
    faOutdent: $5c8203742f0e3062$export$e21cfc4f23776bff,
    faDedent: $5c8203742f0e3062$export$cbffb369d9299db7,
    faHeartCircleExclamation: $5c8203742f0e3062$export$3772719b170306e2,
    faHouse: $5c8203742f0e3062$export$dcadc0d67468dfa8,
    faHome: $5c8203742f0e3062$export$48f10d71ec526479,
    faHomeAlt: $5c8203742f0e3062$export$279659c4b23dbedb,
    faHomeLgAlt: $5c8203742f0e3062$export$20d6d52d45f53262,
    faCalendarWeek: $5c8203742f0e3062$export$39be5cb4aed5a521,
    faLaptopMedical: $5c8203742f0e3062$export$ba2fa38f7bcc6930,
    faB: $5c8203742f0e3062$export$fa30fcd1e0d0d8,
    faFileMedical: $5c8203742f0e3062$export$56cbcd962389b090,
    faDiceOne: $5c8203742f0e3062$export$d91800b7be5303b0,
    faKiwiBird: $5c8203742f0e3062$export$d9933d91e1314d02,
    faArrowRightArrowLeft: $5c8203742f0e3062$export$56b6d3d7d0e67a1c,
    faExchange: $5c8203742f0e3062$export$1aab915ca61b734a,
    faRotateRight: $5c8203742f0e3062$export$7f465bf410c6eff7,
    faRedoAlt: $5c8203742f0e3062$export$50c037520c6cfdc1,
    faRotateForward: $5c8203742f0e3062$export$2507849a0fdd7f64,
    faUtensils: $5c8203742f0e3062$export$750d52edc1dafc7,
    faCutlery: $5c8203742f0e3062$export$7034e54a8036c5c8,
    faArrowUpWideShort: $5c8203742f0e3062$export$63f4908401ded049,
    faSortAmountUp: $5c8203742f0e3062$export$28ef3e933e4b5364,
    faMillSign: $5c8203742f0e3062$export$9b53510cf4010e4d,
    faBowlRice: $5c8203742f0e3062$export$86079bc65a716451,
    faSkull: $5c8203742f0e3062$export$138b45e2afb1dfa4,
    faTowerBroadcast: $5c8203742f0e3062$export$fd06ff4ce9799eb0,
    faBroadcastTower: $5c8203742f0e3062$export$f68b38d51f5c0ed,
    faTruckPickup: $5c8203742f0e3062$export$f846b848b3ba3064,
    faUpLong: $5c8203742f0e3062$export$5608156cc81126e7,
    faLongArrowAltUp: $5c8203742f0e3062$export$43c8f2a46326c55f,
    faStop: $5c8203742f0e3062$export$51577929c676143b,
    faCodeMerge: $5c8203742f0e3062$export$e151fe5abf6db993,
    faUpload: $5c8203742f0e3062$export$a9578350255b2b79,
    faHurricane: $5c8203742f0e3062$export$4cf54a379be7e59a,
    faMound: $5c8203742f0e3062$export$ac54ffffdb218383,
    faToiletPortable: $5c8203742f0e3062$export$a3a5de5f6e2513ba,
    faCompactDisc: $5c8203742f0e3062$export$84021631df0f831b,
    faFileArrowDown: $5c8203742f0e3062$export$148bcede94488555,
    faFileDownload: $5c8203742f0e3062$export$1013b9966d758343,
    faCaravan: $5c8203742f0e3062$export$afb5d0eee7c1bdb,
    faShieldCat: $5c8203742f0e3062$export$1639f087457d4f58,
    faBolt: $5c8203742f0e3062$export$6869964aa308dd31,
    faZap: $5c8203742f0e3062$export$d62abb82664f55ca,
    faGlassWater: $5c8203742f0e3062$export$b80f542550a05ea7,
    faOilWell: $5c8203742f0e3062$export$b69c6757012a2267,
    faVault: $5c8203742f0e3062$export$4689a147513594a7,
    faMars: $5c8203742f0e3062$export$a9f5c0b9c1e77a6f,
    faToilet: $5c8203742f0e3062$export$505476859b9691c0,
    faPlaneCircleXmark: $5c8203742f0e3062$export$94ef668f5108e431,
    faYenSign: $5c8203742f0e3062$export$30f1437f5a4e991d,
    faCny: $5c8203742f0e3062$export$268a23eee8f089a2,
    faJpy: $5c8203742f0e3062$export$5460a9192eb79bf5,
    faRmb: $5c8203742f0e3062$export$e2a8016afc962883,
    faYen: $5c8203742f0e3062$export$cf914b1afb9455a2,
    faRubleSign: $5c8203742f0e3062$export$1ae0a94c8ba4131a,
    faRouble: $5c8203742f0e3062$export$c5dc3d98c4d8f2a5,
    faRub: $5c8203742f0e3062$export$9c4d936240e1f0b1,
    faRuble: $5c8203742f0e3062$export$6c0cf65134387046,
    faSun: $5c8203742f0e3062$export$2fa35dcbc038dbe9,
    faGuitar: $5c8203742f0e3062$export$790dd5b32282b6fb,
    faFaceLaughWink: $5c8203742f0e3062$export$600a1b26b33c3d47,
    faLaughWink: $5c8203742f0e3062$export$77ac40095f39933e,
    faHorseHead: $5c8203742f0e3062$export$5bcca85203ebd1e8,
    faBoreHole: $5c8203742f0e3062$export$cd79eeea6201e9d4,
    faIndustry: $5c8203742f0e3062$export$5548c3eb51060fa8,
    faCircleDown: $5c8203742f0e3062$export$531badb89cf01312,
    faArrowAltCircleDown: $5c8203742f0e3062$export$ff3afbc8c0bc5d59,
    faArrowsTurnToDots: $5c8203742f0e3062$export$b9d8fdf63999a76d,
    faFlorinSign: $5c8203742f0e3062$export$6248ec7440b2ffcb,
    faArrowDownShortWide: $5c8203742f0e3062$export$a51c464b699200ae,
    faSortAmountDesc: $5c8203742f0e3062$export$93835bc31892b5c3,
    faSortAmountDownAlt: $5c8203742f0e3062$export$e7d80d8c226cb77,
    faLessThan: $5c8203742f0e3062$export$7f24f1bf98af5411,
    faAngleDown: $5c8203742f0e3062$export$4b5be0142d10f342,
    faCarTunnel: $5c8203742f0e3062$export$ec5cfe409de2ed37,
    faHeadSideCough: $5c8203742f0e3062$export$3cd04b7c1624f598,
    faGripLines: $5c8203742f0e3062$export$1412f35381064d7d,
    faThumbsDown: $5c8203742f0e3062$export$aba24ca305bbe8c1,
    faUserLock: $5c8203742f0e3062$export$d9b89b5872b67a4f,
    faArrowRightLong: $5c8203742f0e3062$export$becbc35d3541bcc,
    faLongArrowRight: $5c8203742f0e3062$export$7ec6527cf8651899,
    faAnchorCircleXmark: $5c8203742f0e3062$export$f6773af4219eebd,
    faEllipsis: $5c8203742f0e3062$export$37fe3659ba7b6b54,
    faEllipsisH: $5c8203742f0e3062$export$c9f2fedd4489a2ee,
    faChessPawn: $5c8203742f0e3062$export$3db75d5ac9e98468,
    faKitMedical: $5c8203742f0e3062$export$f04e7a0f1033a0cd,
    faFirstAid: $5c8203742f0e3062$export$5b01ccb2da4c4387,
    faPersonThroughWindow: $5c8203742f0e3062$export$a77a2f6da72f89e3,
    faToolbox: $5c8203742f0e3062$export$b34d64c205c732a9,
    faHandsHoldingCircle: $5c8203742f0e3062$export$3aa81d0e606b08b6,
    faBug: $5c8203742f0e3062$export$a18cfac400116d9f,
    faCreditCard: $5c8203742f0e3062$export$3e7437bf6535bef0,
    faCreditCardAlt: $5c8203742f0e3062$export$5fffe8e3c36964a2,
    faCar: $5c8203742f0e3062$export$9eefe7fcdf123b76,
    faAutomobile: $5c8203742f0e3062$export$240a6c53cf7ac525,
    faHandHoldingHand: $5c8203742f0e3062$export$6638511b28df3be5,
    faBookOpenReader: $5c8203742f0e3062$export$cb6e40528b98a5b,
    faBookReader: $5c8203742f0e3062$export$cee14fe33262fa7d,
    faMountainSun: $5c8203742f0e3062$export$af9eaee7db3ba7a9,
    faArrowsLeftRightToLine: $5c8203742f0e3062$export$a63cecc8a4166c49,
    faDiceD20: $5c8203742f0e3062$export$b06003a02c9055bd,
    faTruckDroplet: $5c8203742f0e3062$export$41ce20639e8fef2b,
    faFileCircleXmark: $5c8203742f0e3062$export$e4686afbe882e24a,
    faTemperatureArrowUp: $5c8203742f0e3062$export$d7a5da41ce01461d,
    faTemperatureUp: $5c8203742f0e3062$export$872345a0157330a3,
    faMedal: $5c8203742f0e3062$export$b48a5be96314835a,
    faBed: $5c8203742f0e3062$export$f24e0fce77994d4d,
    faSquareH: $5c8203742f0e3062$export$51e3c5be06a49e32,
    faHSquare: $5c8203742f0e3062$export$f08bbcf8f59eafc2,
    faPodcast: $5c8203742f0e3062$export$5c0b4709125e92f8,
    faTemperatureFull: $5c8203742f0e3062$export$bf4d97a79734997f,
    faTemperature4: $5c8203742f0e3062$export$db946f8dc50a57ca,
    faThermometer4: $5c8203742f0e3062$export$92b2e2293472dd50,
    faThermometerFull: $5c8203742f0e3062$export$74e07083cef79a6f,
    faBell: $5c8203742f0e3062$export$9b6162797ab1b255,
    faSuperscript: $5c8203742f0e3062$export$4fa56a54e822dd25,
    faPlugCircleXmark: $5c8203742f0e3062$export$12ef959394d63192,
    faStarOfLife: $5c8203742f0e3062$export$aa3c4c1c5a47bf98,
    faPhoneSlash: $5c8203742f0e3062$export$4c60a3aade08b6c2,
    faPaintRoller: $5c8203742f0e3062$export$d1de8d1b815d6a5,
    faHandshakeAngle: $5c8203742f0e3062$export$503f458ca5cf64c2,
    faHandsHelping: $5c8203742f0e3062$export$287dbb1632da0d44,
    faLocationDot: $5c8203742f0e3062$export$90a475e93ff4bb8a,
    faMapMarkerAlt: $5c8203742f0e3062$export$4be92fa780613f93,
    faFile: $5c8203742f0e3062$export$cad54bead856a678,
    faGreaterThan: $5c8203742f0e3062$export$da07b6bc24a496ca,
    faPersonSwimming: $5c8203742f0e3062$export$3fb4da6af843d39f,
    faSwimmer: $5c8203742f0e3062$export$67daf2e2f88c1365,
    faArrowDown: $5c8203742f0e3062$export$9686eff8d817f770,
    faDroplet: $5c8203742f0e3062$export$cc1b6e60cb98fb90,
    faTint: $5c8203742f0e3062$export$60dd975bd5938c15,
    faEraser: $5c8203742f0e3062$export$e7fc4fe34e767f28,
    faEarthAmericas: $5c8203742f0e3062$export$9c4218a898614082,
    faEarth: $5c8203742f0e3062$export$c2118d3775773870,
    faEarthAmerica: $5c8203742f0e3062$export$8b0f3a26397cf632,
    faGlobeAmericas: $5c8203742f0e3062$export$e96bcc7bde9498db,
    faPersonBurst: $5c8203742f0e3062$export$ae02241644924482,
    faDove: $5c8203742f0e3062$export$a1ab1e69a300089f,
    faBatteryEmpty: $5c8203742f0e3062$export$1344b64f6e922e12,
    faBattery0: $5c8203742f0e3062$export$de8d0338927394c1,
    faSocks: $5c8203742f0e3062$export$8d36a54dbf1e6bce,
    faInbox: $5c8203742f0e3062$export$366b69cbdce46334,
    faSection: $5c8203742f0e3062$export$a6f4f4a005d91fbd,
    faGaugeHigh: $5c8203742f0e3062$export$d262c1f5912046e6,
    faTachometerAlt: $5c8203742f0e3062$export$38dd17b9f064c10f,
    faTachometerAltFast: $5c8203742f0e3062$export$e99d8b85f35b8ca5,
    faEnvelopeOpenText: $5c8203742f0e3062$export$f5c53ce8ec380d11,
    faHospital: $5c8203742f0e3062$export$7a76c9d35b42d691,
    faHospitalAlt: $5c8203742f0e3062$export$cea7736417b94a3b,
    faHospitalWide: $5c8203742f0e3062$export$69c8cc0360f017e8,
    faWineBottle: $5c8203742f0e3062$export$770be8b3d5776043,
    faChessRook: $5c8203742f0e3062$export$5d65c40a109eb09c,
    faBarsStaggered: $5c8203742f0e3062$export$2f8a7938c06a2142,
    faReorder: $5c8203742f0e3062$export$75d2bb378a2fc102,
    faStream: $5c8203742f0e3062$export$ed81ab40fc4e904,
    faDharmachakra: $5c8203742f0e3062$export$45cbd92c28deb2c7,
    faHotdog: $5c8203742f0e3062$export$9fae219b4d3ce0be,
    faPersonWalkingWithCane: $5c8203742f0e3062$export$2ffee5b2bc935c1f,
    faBlind: $5c8203742f0e3062$export$923de21def6ea9b6,
    faDrum: $5c8203742f0e3062$export$5b9205e1042594b7,
    faIceCream: $5c8203742f0e3062$export$dd52741c60cc638f,
    faHeartCircleBolt: $5c8203742f0e3062$export$2a376a9d0d8fee96,
    faFax: $5c8203742f0e3062$export$b5698497901d7197,
    faParagraph: $5c8203742f0e3062$export$dec46f8df1860e0,
    faCheckToSlot: $5c8203742f0e3062$export$6999832247e52c2b,
    faVoteYea: $5c8203742f0e3062$export$e87bb3db1608b850,
    faStarHalf: $5c8203742f0e3062$export$228008b5e11032fa,
    faBoxesStacked: $5c8203742f0e3062$export$2088efcf62cf3b1,
    faBoxes: $5c8203742f0e3062$export$2007320dd6cde6db,
    faBoxesAlt: $5c8203742f0e3062$export$e6ef1d896ed63b3e,
    faLink: $5c8203742f0e3062$export$88bc01ff8dbecc55,
    faChain: $5c8203742f0e3062$export$b5d071e02a25554f,
    faEarListen: $5c8203742f0e3062$export$837bc776b490934d,
    faAssistiveListeningSystems: $5c8203742f0e3062$export$8eeef3dc0035b165,
    faTreeCity: $5c8203742f0e3062$export$ad95e4f80f98ebe0,
    faPlay: $5c8203742f0e3062$export$436587205947bca5,
    faFont: $5c8203742f0e3062$export$a5dc297d3f60936,
    faTableCellsRowLock: $5c8203742f0e3062$export$2c0ab34218da6651,
    faRupiahSign: $5c8203742f0e3062$export$fe44d4c71644ea0,
    faMagnifyingGlass: $5c8203742f0e3062$export$34c8b97060c09ff,
    faSearch: $5c8203742f0e3062$export$871a78837687ffe8,
    faTableTennisPaddleBall: $5c8203742f0e3062$export$eabe53838d45ac6a,
    faPingPongPaddleBall: $5c8203742f0e3062$export$ebb246c621751737,
    faTableTennis: $5c8203742f0e3062$export$f378fbb4e0ef7edf,
    faPersonDotsFromLine: $5c8203742f0e3062$export$cdcec8ca7ec0d381,
    faDiagnoses: $5c8203742f0e3062$export$68bad2b52a90d1fa,
    faTrashCanArrowUp: $5c8203742f0e3062$export$60430351cdb4ba89,
    faTrashRestoreAlt: $5c8203742f0e3062$export$d075b19b21cb9856,
    faNairaSign: $5c8203742f0e3062$export$58b7558ca9822358,
    faCartArrowDown: $5c8203742f0e3062$export$9206260ff0c0c616,
    faWalkieTalkie: $5c8203742f0e3062$export$8a322f740d64e9fc,
    faFilePen: $5c8203742f0e3062$export$27f34878d8ed7a76,
    faFileEdit: $5c8203742f0e3062$export$e343e19f1757c5ae,
    faReceipt: $5c8203742f0e3062$export$32b0cd6133c2742,
    faSquarePen: $5c8203742f0e3062$export$3643b719db23d46e,
    faPenSquare: $5c8203742f0e3062$export$fbb231ccb3d960bc,
    faPencilSquare: $5c8203742f0e3062$export$35d253ecd249e771,
    faSuitcaseRolling: $5c8203742f0e3062$export$957e62a9b80ff4e3,
    faPersonCircleExclamation: $5c8203742f0e3062$export$38c8c32017dd9cc,
    faChevronDown: $5c8203742f0e3062$export$8db9bc521720fccd,
    faBatteryFull: $5c8203742f0e3062$export$9338fc4614cfc0cf,
    faBattery: $5c8203742f0e3062$export$214720d39635cea8,
    faBattery5: $5c8203742f0e3062$export$e426617482c711a7,
    faSkullCrossbones: $5c8203742f0e3062$export$8717352b90217272,
    faCodeCompare: $5c8203742f0e3062$export$ca4c5b4dcff58860,
    faListUl: $5c8203742f0e3062$export$f8a219cf4f516384,
    faListDots: $5c8203742f0e3062$export$e6f4ba30d84fa6ea,
    faSchoolLock: $5c8203742f0e3062$export$8845cce2a763ee07,
    faTowerCell: $5c8203742f0e3062$export$f4b64c3a138c1b59,
    faDownLong: $5c8203742f0e3062$export$e88ba08d4f4d65b6,
    faLongArrowAltDown: $5c8203742f0e3062$export$8b92530ca6418c2f,
    faRankingStar: $5c8203742f0e3062$export$e6fd420a918b43b5,
    faChessKing: $5c8203742f0e3062$export$d5713874f8fefe1b,
    faPersonHarassing: $5c8203742f0e3062$export$dcd74f2821882a49,
    faBrazilianRealSign: $5c8203742f0e3062$export$9d355b4e79216962,
    faLandmarkDome: $5c8203742f0e3062$export$8a56136f40511e5d,
    faLandmarkAlt: $5c8203742f0e3062$export$8b9c180efffc50ab,
    faArrowUp: $5c8203742f0e3062$export$8e144ed4d52eef49,
    faTv: $5c8203742f0e3062$export$e0cfed4ba2fe562c,
    faTelevision: $5c8203742f0e3062$export$9803b0176917be28,
    faTvAlt: $5c8203742f0e3062$export$6aa64ad5a1974ad7,
    faShrimp: $5c8203742f0e3062$export$ac094c06f566cca3,
    faListCheck: $5c8203742f0e3062$export$350a84fd0f833f4d,
    faTasks: $5c8203742f0e3062$export$2f6d5b2fec286d63,
    faJugDetergent: $5c8203742f0e3062$export$3fe50bd8062cd141,
    faCircleUser: $5c8203742f0e3062$export$9a5c11a5e3d7f1e7,
    faUserCircle: $5c8203742f0e3062$export$be7d974e9e0dba1a,
    faUserShield: $5c8203742f0e3062$export$d1886bc596424e6c,
    faWind: $5c8203742f0e3062$export$cc58cb0f2257a6a9,
    faCarBurst: $5c8203742f0e3062$export$6d2be7c5d395dd16,
    faCarCrash: $5c8203742f0e3062$export$8ff55566398404cd,
    faY: $5c8203742f0e3062$export$b8c4c058fe7d193c,
    faPersonSnowboarding: $5c8203742f0e3062$export$22c642403aeeaeaf,
    faSnowboarding: $5c8203742f0e3062$export$72683772d587302a,
    faTruckFast: $5c8203742f0e3062$export$27de16299ddd171,
    faShippingFast: $5c8203742f0e3062$export$5e419f47aaeb3c05,
    faFish: $5c8203742f0e3062$export$24228a855c5f6812,
    faUserGraduate: $5c8203742f0e3062$export$10f5839059d22f7e,
    faCircleHalfStroke: $5c8203742f0e3062$export$625fb3848216f28c,
    faAdjust: $5c8203742f0e3062$export$cfa06e4b68edca2d,
    faClapperboard: $5c8203742f0e3062$export$add3b381ced12554,
    faCircleRadiation: $5c8203742f0e3062$export$55c8e3afd9f6c0b4,
    faRadiationAlt: $5c8203742f0e3062$export$2f048fa82bbddf6f,
    faBaseball: $5c8203742f0e3062$export$dc3654cf8a596fbf,
    faBaseballBall: $5c8203742f0e3062$export$63a3f8ceae07c7f3,
    faJetFighterUp: $5c8203742f0e3062$export$b024a52a4ccf5e69,
    faDiagramProject: $5c8203742f0e3062$export$59c351869dc27435,
    faProjectDiagram: $5c8203742f0e3062$export$30bf9f5b96509df1,
    faCopy: $5c8203742f0e3062$export$e9bd786d30cb716c,
    faVolumeXmark: $5c8203742f0e3062$export$28cc565c11db6f2e,
    faVolumeMute: $5c8203742f0e3062$export$aa8decd057dfd29b,
    faVolumeTimes: $5c8203742f0e3062$export$a1c7b36ba71dbeca,
    faHandSparkles: $5c8203742f0e3062$export$72e2d874a963de0c,
    faGrip: $5c8203742f0e3062$export$eb83fb404127db75,
    faGripHorizontal: $5c8203742f0e3062$export$4a45308d6c8decc1,
    faShareFromSquare: $5c8203742f0e3062$export$928280bdd54fa173,
    faShareSquare: $5c8203742f0e3062$export$ae9e1434571f373c,
    faChildCombatant: $5c8203742f0e3062$export$f7367a7301f2dc0f,
    faChildRifle: $5c8203742f0e3062$export$9b027cdb5db3ae5c,
    faGun: $5c8203742f0e3062$export$e18f576a7b31ba46,
    faSquarePhone: $5c8203742f0e3062$export$318ed022991eef56,
    faPhoneSquare: $5c8203742f0e3062$export$8ba22605a641ebdf,
    faPlus: $5c8203742f0e3062$export$a105e7b44ca0eb9e,
    faAdd: $5c8203742f0e3062$export$9e8f9a9d4ad32c0f,
    faExpand: $5c8203742f0e3062$export$1fe4a9976a241685,
    faComputer: $5c8203742f0e3062$export$9835883ce9d0fe78,
    faXmark: $5c8203742f0e3062$export$e6e44779b2fa1a5c,
    faClose: $5c8203742f0e3062$export$23c717133fd81476,
    faMultiply: $5c8203742f0e3062$export$4ed4ff13d4dbc862,
    faRemove: $5c8203742f0e3062$export$34810740c1bd6c54,
    faTimes: $5c8203742f0e3062$export$174bd7f477b115b4,
    faArrowsUpDownLeftRight: $5c8203742f0e3062$export$ff9a43e3a9cb653c,
    faArrows: $5c8203742f0e3062$export$d5ae09a305d70340,
    faChalkboardUser: $5c8203742f0e3062$export$fd7622d4b8d3674b,
    faChalkboardTeacher: $5c8203742f0e3062$export$443fcf69b0155291,
    faPesoSign: $5c8203742f0e3062$export$c8f99b9b5ea83555,
    faBuildingShield: $5c8203742f0e3062$export$18ba6a500873dba9,
    faBaby: $5c8203742f0e3062$export$8afab767536f59ad,
    faUsersLine: $5c8203742f0e3062$export$d7e538fddb81da68,
    faQuoteLeft: $5c8203742f0e3062$export$932a67a1b1a7a724,
    faQuoteLeftAlt: $5c8203742f0e3062$export$95bb9ad3aa35c741,
    faTractor: $5c8203742f0e3062$export$e87e41787bbedc98,
    faTrashArrowUp: $5c8203742f0e3062$export$940cea0f5451895c,
    faTrashRestore: $5c8203742f0e3062$export$d32f45a64ed40e8d,
    faArrowDownUpLock: $5c8203742f0e3062$export$fc9f7bd981c34c45,
    faLinesLeaning: $5c8203742f0e3062$export$4d384ffc907ddaff,
    faRulerCombined: $5c8203742f0e3062$export$613f406c1b5802a8,
    faCopyright: $5c8203742f0e3062$export$da61665fff8aebfe,
    faEquals: $5c8203742f0e3062$export$a7c5f5e4805fdab,
    faBlender: $5c8203742f0e3062$export$db34f7a6de38784f,
    faTeeth: $5c8203742f0e3062$export$b4619aeaf0b9d18e,
    faShekelSign: $5c8203742f0e3062$export$3570be7b68efb8db,
    faIls: $5c8203742f0e3062$export$ecadeff45b05a451,
    faShekel: $5c8203742f0e3062$export$27e0e10e74d98736,
    faSheqel: $5c8203742f0e3062$export$28b3b26a80030d4e,
    faSheqelSign: $5c8203742f0e3062$export$d84993fb5e8c6edd,
    faMap: $5c8203742f0e3062$export$fc82fb79180cd17c,
    faRocket: $5c8203742f0e3062$export$b24d84ed5657d89a,
    faPhotoFilm: $5c8203742f0e3062$export$ed36ad335b36be22,
    faPhotoVideo: $5c8203742f0e3062$export$739f6a6a12dfb6ed,
    faFolderMinus: $5c8203742f0e3062$export$758f1fb3784e4080,
    faStore: $5c8203742f0e3062$export$de59c2657a8ace67,
    faArrowTrendUp: $5c8203742f0e3062$export$cf36928a9c52e98a,
    faPlugCircleMinus: $5c8203742f0e3062$export$2a44d62160972254,
    faSignHanging: $5c8203742f0e3062$export$5c1f29f4c7cad367,
    faSign: $5c8203742f0e3062$export$d21d0d6c8e9e8bf9,
    faBezierCurve: $5c8203742f0e3062$export$a527a6267c55a54c,
    faBellSlash: $5c8203742f0e3062$export$6b31a1e5968b2378,
    faTablet: $5c8203742f0e3062$export$1c92b67c45a4b4fc,
    faTabletAndroid: $5c8203742f0e3062$export$5eddbb7c71278268,
    faSchoolFlag: $5c8203742f0e3062$export$9b263780a7312c8c,
    faFill: $5c8203742f0e3062$export$d3c2bcfd3b861e4a,
    faAngleUp: $5c8203742f0e3062$export$887340269e6d6cac,
    faDrumstickBite: $5c8203742f0e3062$export$482976e9a4ab10f3,
    faHollyBerry: $5c8203742f0e3062$export$273296afacf93991,
    faChevronLeft: $5c8203742f0e3062$export$75702e3e3dd44a44,
    faBacteria: $5c8203742f0e3062$export$7fc18cf2d526c341,
    faHandLizard: $5c8203742f0e3062$export$54608d0a883fea4d,
    faNotdef: $5c8203742f0e3062$export$3db5bca65a1be8dc,
    faDisease: $5c8203742f0e3062$export$c7675a37487adc45,
    faBriefcaseMedical: $5c8203742f0e3062$export$5000f52ca9819bf5,
    faGenderless: $5c8203742f0e3062$export$c093cc22e88981c2,
    faChevronRight: $5c8203742f0e3062$export$930de8c26eb20490,
    faRetweet: $5c8203742f0e3062$export$cebc76f79478e40e,
    faCarRear: $5c8203742f0e3062$export$ff2b8d5628da5f14,
    faCarAlt: $5c8203742f0e3062$export$7937ed2462a665c0,
    faPumpSoap: $5c8203742f0e3062$export$821aeede187f23c9,
    faVideoSlash: $5c8203742f0e3062$export$a714fc79f58cc9ef,
    faBatteryQuarter: $5c8203742f0e3062$export$acec92052ac2183,
    faBattery2: $5c8203742f0e3062$export$23ca8a94c555576,
    faRadio: $5c8203742f0e3062$export$11b26516cae2104f,
    faBabyCarriage: $5c8203742f0e3062$export$3b3ab4d86bad7d26,
    faCarriageBaby: $5c8203742f0e3062$export$9f117d92ccd36cf1,
    faTrafficLight: $5c8203742f0e3062$export$bf0b19daceaec9c2,
    faThermometer: $5c8203742f0e3062$export$f576739e9b18ea4f,
    faVrCardboard: $5c8203742f0e3062$export$248171cb6dad4307,
    faHandMiddleFinger: $5c8203742f0e3062$export$bd40d3a3a16fb147,
    faPercent: $5c8203742f0e3062$export$89a1764fbb7ad2cb,
    faPercentage: $5c8203742f0e3062$export$89333857fc063a2e,
    faTruckMoving: $5c8203742f0e3062$export$a06617a1a4ccea67,
    faGlassWaterDroplet: $5c8203742f0e3062$export$b7ae54b4078b2060,
    faDisplay: $5c8203742f0e3062$export$e9d85839f7751f01,
    faFaceSmile: $5c8203742f0e3062$export$b5023c446f10324,
    faSmile: $5c8203742f0e3062$export$c632b2334f0913bc,
    faThumbtack: $5c8203742f0e3062$export$b6314cdc01bb5c43,
    faThumbTack: $5c8203742f0e3062$export$b63d0c7b519a9aae,
    faTrophy: $5c8203742f0e3062$export$29c432d69ccf85a5,
    faPersonPraying: $5c8203742f0e3062$export$8ecd436ef91fc02e,
    faPray: $5c8203742f0e3062$export$3b32c982141cad51,
    faHammer: $5c8203742f0e3062$export$6310f315e1ebbca5,
    faHandPeace: $5c8203742f0e3062$export$e49e3cfceea441cc,
    faRotate: $5c8203742f0e3062$export$decde496a29c5b23,
    faSyncAlt: $5c8203742f0e3062$export$2ff2056be8c281e4,
    faSpinner: $5c8203742f0e3062$export$1025ad641edb49c2,
    faRobot: $5c8203742f0e3062$export$30a5bb4ad3fa716c,
    faPeace: $5c8203742f0e3062$export$8614cb1326eacd7a,
    faGears: $5c8203742f0e3062$export$4aac79b9ae3cfdb8,
    faCogs: $5c8203742f0e3062$export$af1575770afc9559,
    faWarehouse: $5c8203742f0e3062$export$e3a174a50618c208,
    faArrowUpRightDots: $5c8203742f0e3062$export$bc804c6ab898f610,
    faSplotch: $5c8203742f0e3062$export$d6f21e17ea797702,
    faFaceGrinHearts: $5c8203742f0e3062$export$fbb22081b65e4f33,
    faGrinHearts: $5c8203742f0e3062$export$c56cf0e0c3bc5ed2,
    faDiceFour: $5c8203742f0e3062$export$2df6451abf70a6ff,
    faSimCard: $5c8203742f0e3062$export$3bee83bf278fddbe,
    faTransgender: $5c8203742f0e3062$export$7e3f1701aa95ef01,
    faTransgenderAlt: $5c8203742f0e3062$export$9c36cf9334c052f,
    faMercury: $5c8203742f0e3062$export$e134ecd00b622a47,
    faArrowTurnDown: $5c8203742f0e3062$export$fd4d6cfd52703f50,
    faLevelDown: $5c8203742f0e3062$export$3794c07e7a666c94,
    faPersonFallingBurst: $5c8203742f0e3062$export$a75569baaf4a6c3a,
    faAward: $5c8203742f0e3062$export$f8db2747dadd48f7,
    faTicketSimple: $5c8203742f0e3062$export$68ddda3b30ba09f0,
    faTicketAlt: $5c8203742f0e3062$export$75e38ba471fd89c4,
    faBuilding: $5c8203742f0e3062$export$f26673f8b10c3d46,
    faAnglesLeft: $5c8203742f0e3062$export$2ebd565813951f81,
    faAngleDoubleLeft: $5c8203742f0e3062$export$21b0833b3cf929a7,
    faQrcode: $5c8203742f0e3062$export$fc19ca0fe15e73bc,
    faClockRotateLeft: $5c8203742f0e3062$export$29be1665d1b36a3b,
    faHistory: $5c8203742f0e3062$export$76d1986559ca7b7a,
    faFaceGrinBeamSweat: $5c8203742f0e3062$export$2ff38f330c834084,
    faGrinBeamSweat: $5c8203742f0e3062$export$14d0ccc54c5b6826,
    faFileExport: $5c8203742f0e3062$export$364f19abcfac1b0a,
    faArrowRightFromFile: $5c8203742f0e3062$export$b9c76255b38e1df1,
    faShield: $5c8203742f0e3062$export$8241bd5b9163ca12,
    faShieldBlank: $5c8203742f0e3062$export$64f54da8fbaba8ee,
    faArrowUpShortWide: $5c8203742f0e3062$export$be9d5060a4bc3b4b,
    faSortAmountUpAlt: $5c8203742f0e3062$export$6e87844b0f151b6a,
    faHouseMedical: $5c8203742f0e3062$export$2d077da983246a68,
    faGolfBallTee: $5c8203742f0e3062$export$14c9f1d85e53ae99,
    faGolfBall: $5c8203742f0e3062$export$2251487a9a33c682,
    faCircleChevronLeft: $5c8203742f0e3062$export$f2b13ad44c03c40f,
    faChevronCircleLeft: $5c8203742f0e3062$export$4a42c8c2451a33fd,
    faHouseChimneyWindow: $5c8203742f0e3062$export$792391babe46862d,
    faPenNib: $5c8203742f0e3062$export$a82594dcc75a49f5,
    faTentArrowTurnLeft: $5c8203742f0e3062$export$89af87b7d6c15adf,
    faTents: $5c8203742f0e3062$export$c93b950e845a4ee7,
    faWandMagic: $5c8203742f0e3062$export$8282f5f5dcf6b009,
    faMagic: $5c8203742f0e3062$export$e58f9b502d4dd52d,
    faDog: $5c8203742f0e3062$export$c6406747800cf702,
    faCarrot: $5c8203742f0e3062$export$28e93ec9f5e2ddf3,
    faMoon: $5c8203742f0e3062$export$c4c2f69a53bab720,
    faWineGlassEmpty: $5c8203742f0e3062$export$b86d7336e68a3f57,
    faWineGlassAlt: $5c8203742f0e3062$export$b8ff3fe2b78aef2f,
    faCheese: $5c8203742f0e3062$export$549b99473b7201e6,
    faYinYang: $5c8203742f0e3062$export$6ec1acbf3f610b8f,
    faMusic: $5c8203742f0e3062$export$fcb0647a5340b5b8,
    faCodeCommit: $5c8203742f0e3062$export$d5d870c10bc9f1ce,
    faTemperatureLow: $5c8203742f0e3062$export$9e9af12b90a1abd2,
    faPersonBiking: $5c8203742f0e3062$export$cf152282d5de300d,
    faBiking: $5c8203742f0e3062$export$a5bcf835dbf9c0b,
    faBroom: $5c8203742f0e3062$export$2a533051418ff4ca,
    faShieldHeart: $5c8203742f0e3062$export$7b96388ca2be471b,
    faGopuram: $5c8203742f0e3062$export$31f89d8ac1d14ed6,
    faEarthOceania: $5c8203742f0e3062$export$bd931e906edf2f47,
    faGlobeOceania: $5c8203742f0e3062$export$8ac3f5271448657d,
    faSquareXmark: $5c8203742f0e3062$export$5a17e58bb7afb1d7,
    faTimesSquare: $5c8203742f0e3062$export$c0248ac97142ea2a,
    faXmarkSquare: $5c8203742f0e3062$export$9a364781d6b7602b,
    faHashtag: $5c8203742f0e3062$export$c92c903bade56844,
    faUpRightAndDownLeftFromCenter: $5c8203742f0e3062$export$95457ede07b81517,
    faExpandAlt: $5c8203742f0e3062$export$bcb8d86a3a1d6eb6,
    faOilCan: $5c8203742f0e3062$export$2599126c3a57f727,
    faT: $5c8203742f0e3062$export$6e625d2e7790c860,
    faHippo: $5c8203742f0e3062$export$d4c909619093de2d,
    faChartColumn: $5c8203742f0e3062$export$d01ddcc9efe7b149,
    faInfinity: $5c8203742f0e3062$export$a590003279d671b8,
    faVialCircleCheck: $5c8203742f0e3062$export$2db4f9712313eafa,
    faPersonArrowDownToLine: $5c8203742f0e3062$export$f9a5161975928326,
    faVoicemail: $5c8203742f0e3062$export$4f1ce88b2b4cd5cd,
    faFan: $5c8203742f0e3062$export$55145a3dae4f984a,
    faPersonWalkingLuggage: $5c8203742f0e3062$export$1ae0a37b36ace746,
    faUpDown: $5c8203742f0e3062$export$e36c32dd5cba9b90,
    faArrowsAltV: $5c8203742f0e3062$export$138cb56a3f8f7040,
    faCloudMoonRain: $5c8203742f0e3062$export$301c3fab0c4545bd,
    faCalendar: $5c8203742f0e3062$export$34f5c36a3e80efa2,
    faTrailer: $5c8203742f0e3062$export$3a48b9820e92f5ab,
    faBahai: $5c8203742f0e3062$export$6d636565b3ec36b4,
    faHaykal: $5c8203742f0e3062$export$5c15e34e0e43f15c,
    faSdCard: $5c8203742f0e3062$export$303efb6031da122,
    faDragon: $5c8203742f0e3062$export$ae1875ba975aa0e9,
    faShoePrints: $5c8203742f0e3062$export$cdbdd2118099ae07,
    faCirclePlus: $5c8203742f0e3062$export$eeda28b8ca4cb18e,
    faPlusCircle: $5c8203742f0e3062$export$d9cc3a81499af48c,
    faFaceGrinTongueWink: $5c8203742f0e3062$export$4272e56f2429da88,
    faGrinTongueWink: $5c8203742f0e3062$export$58099903d50aefb3,
    faHandHolding: $5c8203742f0e3062$export$e6094d25274088ab,
    faPlugCircleExclamation: $5c8203742f0e3062$export$d893dd9509763a17,
    faLinkSlash: $5c8203742f0e3062$export$22965c7f4d903953,
    faChainBroken: $5c8203742f0e3062$export$382551e04f32620a,
    faChainSlash: $5c8203742f0e3062$export$12f09d657be59586,
    faUnlink: $5c8203742f0e3062$export$2f546f7d8ba01e18,
    faClone: $5c8203742f0e3062$export$76c1aa4bf9a39458,
    faPersonWalkingArrowLoopLeft: $5c8203742f0e3062$export$5a200e8504b7367a,
    faArrowUpZA: $5c8203742f0e3062$export$a0a53d8e3c68e9f1,
    faSortAlphaUpAlt: $5c8203742f0e3062$export$95ef20828693fb0f,
    faFireFlameCurved: $5c8203742f0e3062$export$769724fc1434d618,
    faFireAlt: $5c8203742f0e3062$export$70dc26b4926d0b1b,
    faTornado: $5c8203742f0e3062$export$6d274258ba4b0089,
    faFileCirclePlus: $5c8203742f0e3062$export$430d63b54b1d4009,
    faBookQuran: $5c8203742f0e3062$export$ad3212bc3fa1595b,
    faQuran: $5c8203742f0e3062$export$46f29ea84ed4c5f1,
    faAnchor: $5c8203742f0e3062$export$12a35719f889cd1,
    faBorderAll: $5c8203742f0e3062$export$93a5eb721c9c0d25,
    faFaceAngry: $5c8203742f0e3062$export$67a047c738fb34da,
    faAngry: $5c8203742f0e3062$export$3c96c08e234498c5,
    faCookieBite: $5c8203742f0e3062$export$317dde8664f7de71,
    faArrowTrendDown: $5c8203742f0e3062$export$d2caed5e37174c23,
    faRss: $5c8203742f0e3062$export$7329a1ca27b90c5b,
    faFeed: $5c8203742f0e3062$export$67ad3d0233cd7b33,
    faDrawPolygon: $5c8203742f0e3062$export$df9bd3777d1154d2,
    faScaleBalanced: $5c8203742f0e3062$export$33fb4280dc20f0dd,
    faBalanceScale: $5c8203742f0e3062$export$fec323dcfd81d750,
    faGaugeSimpleHigh: $5c8203742f0e3062$export$cc4351eb13da27d8,
    faTachometer: $5c8203742f0e3062$export$362d0f652c3fbca2,
    faTachometerFast: $5c8203742f0e3062$export$375b6a8680f980ed,
    faShower: $5c8203742f0e3062$export$f7f7c15f18cc19a1,
    faDesktop: $5c8203742f0e3062$export$6e6ddc253102e596,
    faDesktopAlt: $5c8203742f0e3062$export$ff09a62b9e0fa899,
    faM: $5c8203742f0e3062$export$bd6a7788954842b5,
    faTableList: $5c8203742f0e3062$export$6e989c3c7050dbb,
    faThList: $5c8203742f0e3062$export$daf2614a457122c0,
    faCommentSms: $5c8203742f0e3062$export$435fe17e9d6170d6,
    faSms: $5c8203742f0e3062$export$9dbcc3443daa7323,
    faBook: $5c8203742f0e3062$export$c9d7ef726d1a8742,
    faUserPlus: $5c8203742f0e3062$export$4c17261776a709f2,
    faCheck: $5c8203742f0e3062$export$62b2c752fccc6a9c,
    faBatteryThreeQuarters: $5c8203742f0e3062$export$cfb37069d38f379e,
    faBattery4: $5c8203742f0e3062$export$35ffefed200d123c,
    faHouseCircleCheck: $5c8203742f0e3062$export$c9382fa3394ef53a,
    faAngleLeft: $5c8203742f0e3062$export$3cbcd1b7e35945d2,
    faDiagramSuccessor: $5c8203742f0e3062$export$ff7f40159cadb0ac,
    faTruckArrowRight: $5c8203742f0e3062$export$d69fa2b7839ce76,
    faArrowsSplitUpAndLeft: $5c8203742f0e3062$export$7df274119d2469d1,
    faHandFist: $5c8203742f0e3062$export$ca492f58fe30a42f,
    faFistRaised: $5c8203742f0e3062$export$fa0323a4d7489a8d,
    faCloudMoon: $5c8203742f0e3062$export$482eb125aaf0fbc2,
    faBriefcase: $5c8203742f0e3062$export$8da450d063b0eb37,
    faPersonFalling: $5c8203742f0e3062$export$e94ab3a30cf4aca5,
    faImagePortrait: $5c8203742f0e3062$export$c23fd8b91a7ed48,
    faPortrait: $5c8203742f0e3062$export$e3d25f819c7ee7d7,
    faUserTag: $5c8203742f0e3062$export$9eec597148166b36,
    faRug: $5c8203742f0e3062$export$7cee7480f25f5289,
    faEarthEurope: $5c8203742f0e3062$export$7adefae4a1be1d97,
    faGlobeEurope: $5c8203742f0e3062$export$5318b8ede86cc96b,
    faCartFlatbedSuitcase: $5c8203742f0e3062$export$ab81ff863770d996,
    faLuggageCart: $5c8203742f0e3062$export$bd1e24dd3cde8514,
    faRectangleXmark: $5c8203742f0e3062$export$3896694b3e81fba7,
    faRectangleTimes: $5c8203742f0e3062$export$eaaf26416a51dc1,
    faTimesRectangle: $5c8203742f0e3062$export$10147c0014152a3f,
    faWindowClose: $5c8203742f0e3062$export$18b7775f78a3e16,
    faBahtSign: $5c8203742f0e3062$export$ffc7123046a28ee,
    faBookOpen: $5c8203742f0e3062$export$8a3071811b2b7979,
    faBookJournalWhills: $5c8203742f0e3062$export$d3d49030d557a09b,
    faJournalWhills: $5c8203742f0e3062$export$66a0d8d45aab6631,
    faHandcuffs: $5c8203742f0e3062$export$74d1f89b5feb9d42,
    faTriangleExclamation: $5c8203742f0e3062$export$1cbf6e649ce86166,
    faExclamationTriangle: $5c8203742f0e3062$export$3d249b63b52cce7c,
    faWarning: $5c8203742f0e3062$export$2e470a35c38b096a,
    faDatabase: $5c8203742f0e3062$export$24680dede86b1883,
    faShare: $5c8203742f0e3062$export$c08b4b0e2b0dc027,
    faMailForward: $5c8203742f0e3062$export$81df7693d3f2f8da,
    faBottleDroplet: $5c8203742f0e3062$export$8f534e1e0ab75bfe,
    faMaskFace: $5c8203742f0e3062$export$140d4da0adbaf435,
    faHillRockslide: $5c8203742f0e3062$export$7ec15a32285f6c22,
    faRightLeft: $5c8203742f0e3062$export$a082af56be9786ae,
    faExchangeAlt: $5c8203742f0e3062$export$f6c6fb20d374b128,
    faPaperPlane: $5c8203742f0e3062$export$b5378818301da1be,
    faRoadCircleExclamation: $5c8203742f0e3062$export$79753c2153535b01,
    faDungeon: $5c8203742f0e3062$export$1156dc6acb0058bd,
    faAlignRight: $5c8203742f0e3062$export$7370f36a39a38737,
    faMoneyBill1Wave: $5c8203742f0e3062$export$52e3e96cd1564779,
    faMoneyBillWaveAlt: $5c8203742f0e3062$export$1613858e873cbb3e,
    faLifeRing: $5c8203742f0e3062$export$53dd2cacf674142a,
    faHands: $5c8203742f0e3062$export$f9712d0cf5150f0c,
    faSignLanguage: $5c8203742f0e3062$export$20993813350f9671,
    faSigning: $5c8203742f0e3062$export$5cc0e6f5191f4f02,
    faCalendarDay: $5c8203742f0e3062$export$80968bcfef6481ca,
    faWaterLadder: $5c8203742f0e3062$export$5930e9bdfd790d77,
    faLadderWater: $5c8203742f0e3062$export$c5ea6eeef2db2b3b,
    faSwimmingPool: $5c8203742f0e3062$export$4dee691631c67d5c,
    faArrowsUpDown: $5c8203742f0e3062$export$64185f27d82c259f,
    faArrowsV: $5c8203742f0e3062$export$cec5f1bc9e068e48,
    faFaceGrimace: $5c8203742f0e3062$export$bd5bd2ef56b793b1,
    faGrimace: $5c8203742f0e3062$export$3d08cd36ac1ef231,
    faWheelchairMove: $5c8203742f0e3062$export$1482162f7fe04ac,
    faWheelchairAlt: $5c8203742f0e3062$export$7db9460785019040,
    faTurnDown: $5c8203742f0e3062$export$b5dc9dd0347bbb6,
    faLevelDownAlt: $5c8203742f0e3062$export$c07eb6ff5a382cbd,
    faPersonWalkingArrowRight: $5c8203742f0e3062$export$3e15790fe68c095b,
    faSquareEnvelope: $5c8203742f0e3062$export$15da4ef8c0fb20d6,
    faEnvelopeSquare: $5c8203742f0e3062$export$354e159473e73552,
    faDice: $5c8203742f0e3062$export$4ed8206e6619cc8f,
    faBowlingBall: $5c8203742f0e3062$export$5ee2640fe105312d,
    faBrain: $5c8203742f0e3062$export$97fa4f4c1006ab1,
    faBandage: $5c8203742f0e3062$export$658a137d3845bca7,
    faBandAid: $5c8203742f0e3062$export$b14a1014df2fdf46,
    faCalendarMinus: $5c8203742f0e3062$export$23e8b4955c2d951b,
    faCircleXmark: $5c8203742f0e3062$export$30262489773a79a3,
    faTimesCircle: $5c8203742f0e3062$export$ab0ec50720a747eb,
    faXmarkCircle: $5c8203742f0e3062$export$90ac4096df8efdee,
    faGifts: $5c8203742f0e3062$export$de9a67b55dbe819a,
    faHotel: $5c8203742f0e3062$export$c402efcf01d5ca07,
    faEarthAsia: $5c8203742f0e3062$export$807cdd395fe012cb,
    faGlobeAsia: $5c8203742f0e3062$export$796fdfc909e603f4,
    faIdCardClip: $5c8203742f0e3062$export$31e6961064ddac7b,
    faIdCardAlt: $5c8203742f0e3062$export$dc37ebbac31f6c6c,
    faMagnifyingGlassPlus: $5c8203742f0e3062$export$f48a3ba52a0a9e56,
    faSearchPlus: $5c8203742f0e3062$export$378f00e6b1a8185,
    faThumbsUp: $5c8203742f0e3062$export$47e4e0d519d33497,
    faUserClock: $5c8203742f0e3062$export$b00596a09aa07311,
    faHandDots: $5c8203742f0e3062$export$8846d49caaed1c0a,
    faAllergies: $5c8203742f0e3062$export$dcae2101babbffff,
    faFileInvoice: $5c8203742f0e3062$export$bef39294aed2281a,
    faWindowMinimize: $5c8203742f0e3062$export$26a3f9d2784b90d8,
    faMugSaucer: $5c8203742f0e3062$export$60048819854688c5,
    faCoffee: $5c8203742f0e3062$export$1d24a9e457278011,
    faBrush: $5c8203742f0e3062$export$5824ffe6f8983c83,
    faMask: $5c8203742f0e3062$export$7b028758c03b9655,
    faMagnifyingGlassMinus: $5c8203742f0e3062$export$56d810b9ab2e30bc,
    faSearchMinus: $5c8203742f0e3062$export$efca97eef6a7a17d,
    faRulerVertical: $5c8203742f0e3062$export$a6ad5df9d9f29553,
    faUserLarge: $5c8203742f0e3062$export$50a28538498238f,
    faUserAlt: $5c8203742f0e3062$export$ae9b19c2ac726cfc,
    faTrainTram: $5c8203742f0e3062$export$d401d4aeba21cdf3,
    faUserNurse: $5c8203742f0e3062$export$ab9af5aa013d2162,
    faSyringe: $5c8203742f0e3062$export$1aa9423ec6b1d609,
    faCloudSun: $5c8203742f0e3062$export$dcaadfd9c98e42a1,
    faStopwatch20: $5c8203742f0e3062$export$df6244b0501f2112,
    faSquareFull: $5c8203742f0e3062$export$7ec6541fee081990,
    faMagnet: $5c8203742f0e3062$export$78932e9c9abea6b7,
    faJar: $5c8203742f0e3062$export$53583b459a87a01,
    faNoteSticky: $5c8203742f0e3062$export$4a4e034527c933f5,
    faStickyNote: $5c8203742f0e3062$export$80889adc5d98bf4a,
    faBugSlash: $5c8203742f0e3062$export$fc4dd5feed8df23,
    faArrowUpFromWaterPump: $5c8203742f0e3062$export$1a093e7861c5e48f,
    faBone: $5c8203742f0e3062$export$5902c007d5703f2d,
    faUserInjured: $5c8203742f0e3062$export$c950c1ba7f227d5b,
    faFaceSadTear: $5c8203742f0e3062$export$8a5a0dbb2a17e253,
    faSadTear: $5c8203742f0e3062$export$4b5241926f692f91,
    faPlane: $5c8203742f0e3062$export$f654c69e66b466c0,
    faTentArrowsDown: $5c8203742f0e3062$export$51adfe7c9ee4f428,
    faExclamation: $5c8203742f0e3062$export$de6218b649cbb6a9,
    faArrowsSpin: $5c8203742f0e3062$export$7e05388be208e313,
    faPrint: $5c8203742f0e3062$export$ae64371e02ee8e56,
    faTurkishLiraSign: $5c8203742f0e3062$export$b458d393151b6960,
    faTry: $5c8203742f0e3062$export$970dda513e46c41f,
    faTurkishLira: $5c8203742f0e3062$export$40e66e5966827199,
    faDollarSign: $5c8203742f0e3062$export$fb420d3e4d8c6a18,
    faDollar: $5c8203742f0e3062$export$a4ffb0775547fcdf,
    faUsd: $5c8203742f0e3062$export$72cca07d38a28589,
    faX: $5c8203742f0e3062$export$476af662c0c32cbc,
    faMagnifyingGlassDollar: $5c8203742f0e3062$export$fa4f1ead37dc1dce,
    faSearchDollar: $5c8203742f0e3062$export$65b49a6767630708,
    faUsersGear: $5c8203742f0e3062$export$3a18218720110fc0,
    faUsersCog: $5c8203742f0e3062$export$5e0b06753fc69b81,
    faPersonMilitaryPointing: $5c8203742f0e3062$export$50b6dcaa9ec03439,
    faBuildingColumns: $5c8203742f0e3062$export$a411e7e26cb63d5e,
    faBank: $5c8203742f0e3062$export$6e379b829ea8b99,
    faInstitution: $5c8203742f0e3062$export$1dba320226a34c1f,
    faMuseum: $5c8203742f0e3062$export$9b3953adff472ad2,
    faUniversity: $5c8203742f0e3062$export$f2e1460ebe1a8cb0,
    faUmbrella: $5c8203742f0e3062$export$9ff64ffae70e08c0,
    faTrowel: $5c8203742f0e3062$export$12ca996a6f686fe1,
    faD: $5c8203742f0e3062$export$56c73b799aac2555,
    faStapler: $5c8203742f0e3062$export$c7e014b7e3ac3d83,
    faMasksTheater: $5c8203742f0e3062$export$bf5896cc1ce4d55,
    faTheaterMasks: $5c8203742f0e3062$export$3dbedc487b0159ac,
    faKipSign: $5c8203742f0e3062$export$a6df39524c41472c,
    faHandPointLeft: $5c8203742f0e3062$export$b276ec3dc9760d39,
    faHandshakeSimple: $5c8203742f0e3062$export$e8485db4dab0ab30,
    faHandshakeAlt: $5c8203742f0e3062$export$e9aa3c6f9f47aa1a,
    faJetFighter: $5c8203742f0e3062$export$2130e629ab767ab3,
    faFighterJet: $5c8203742f0e3062$export$102b809faf56e033,
    faSquareShareNodes: $5c8203742f0e3062$export$1bdb0ec5af3fea99,
    faShareAltSquare: $5c8203742f0e3062$export$3799c2d8fd7e493b,
    faBarcode: $5c8203742f0e3062$export$3825a842b5afc5aa,
    faPlusMinus: $5c8203742f0e3062$export$37bd38cf96417095,
    faVideo: $5c8203742f0e3062$export$5c6bd8729527871b,
    faVideoCamera: $5c8203742f0e3062$export$3a530df752193ccf,
    faGraduationCap: $5c8203742f0e3062$export$874e305fd7920cce,
    faMortarBoard: $5c8203742f0e3062$export$dd0a013bf23a9d86,
    faHandHoldingMedical: $5c8203742f0e3062$export$bb2a6b1b5e852300,
    faPersonCircleCheck: $5c8203742f0e3062$export$30294c81ac4031ca,
    faTurnUp: $5c8203742f0e3062$export$314f5cab62fc6968,
    faLevelUpAlt: $5c8203742f0e3062$export$d6f21a309b179c3d
};


var $0d2235779b32f00d$var$MenuCarousel = function() {
    var _imgCarousel_gridElements_infoWithStyle, _imgCarousel_gridElements;
    var imgCarousel = (0, $e38adb64246a2e8a$export$2e2bcd8739ae039)();
    var images = imgCarousel === null || imgCarousel === void 0 ? void 0 : (_imgCarousel_gridElements = imgCarousel.gridElements) === null || _imgCarousel_gridElements === void 0 ? void 0 : (_imgCarousel_gridElements_infoWithStyle = _imgCarousel_gridElements.infoWithStyle) === null || _imgCarousel_gridElements_infoWithStyle === void 0 ? void 0 : _imgCarousel_gridElements_infoWithStyle.info;
    var sliderRef = (0, $fIwXP.useRef)(null);
    var next = function() {
        sliderRef.slickNext();
    };
    var previous = function() {
        sliderRef.slickPrev();
    };
    var settings = {
        className: "center",
        infinite: false,
        centerPadding: "60px",
        slidesToShow: 5.5,
        swipeToSlide: true
    };
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "pb-3 px-3 text-2xl font-bold flex justify-between",
                children: [
                    imgCarousel === null || imgCarousel === void 0 ? void 0 : imgCarousel.header.title,
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "rounded-full bg-gray-300 !w-10 h-10 flex items-center justify-center mr-3 focus:outline-none",
                                onClick: previous,
                                children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $69bac3e467faf0d3$export$2b9260d4a45c8710), {
                                    icon: (0, $5c8203742f0e3062$export$b7fac681e7d09400),
                                    className: "text-gray-700 text-sm"
                                })
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "rounded-full bg-gray-300 !w-10 h-10 flex items-center justify-center focus:outline-none",
                                onClick: next,
                                children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $69bac3e467faf0d3$export$2b9260d4a45c8710), {
                                    icon: (0, $5c8203742f0e3062$export$b4da69a0247f3620),
                                    className: "text-gray-700 text-sm"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1580051cd03fa60e$exports))), (0, $f17388ede13a49cc$export$4fa2f4023c9cbda5)((0, $ad1c00e896d27009$export$581ff339ea0ba762)({
                ref: function(slider) {
                    sliderRef = slider;
                }
            }, settings), {
                children: images && images.map(function(image) {
                    return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                        className: " h-[180px]",
                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                            className: "flex justify-center items-center",
                            children: /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                src: (0, $cc25cc9a913d8a70$export$c77d3f7c7cde7bd0) + image.imageId,
                                alt: image.accessibility.altText
                            })
                        })
                    }, image.id);
                })
            }))
        ]
    });
};
var $0d2235779b32f00d$export$2e2bcd8739ae039 = $0d2235779b32f00d$var$MenuCarousel;





var $kB67t = parcelRequire("kB67t");

var $cc6u1 = parcelRequire("cc6u1");

var $fIwXP = parcelRequire("fIwXP");


var $kB67t = parcelRequire("kB67t");


var $fIwXP = parcelRequire("fIwXP");

var $e2a3d1cd2c3a40d8$var$useTopRatedRestaurants = function() {
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)([]), 2), listOfRestaurants = _useState[0], setListOfRestaurants = _useState[1];
    var _useState1 = (0, $kB67t._)((0, $fIwXP.useState)([]), 2), filteredRestaurant = _useState1[0], setFilteredRestaurant = _useState1[1];
    var _useState2 = (0, $kB67t._)((0, $fIwXP.useState)(true), 2), loading = _useState2[0], setLoading = _useState2[1];
    (0, $fIwXP.useEffect)(function() {
        fetchData();
    }, []);
    var fetchData = function() {
        var _ref = (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function() {
            return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                try {
                    // Simulating asynchronous behavior with a timeout
                    setTimeout(function() {
                        var _MOCK_DATA_data_cards__card_card_gridElements_infoWithStyle, _MOCK_DATA_data_cards__card_card_gridElements, _MOCK_DATA_data_cards__card_card, _MOCK_DATA_data_cards__card, _MOCK_DATA_data_cards_, _MOCK_DATA_data;
                        // Use mock data instead of fetching from an API
                        var restaurants = (0, (/*@__PURE__*/$parcel$interopDefault($932a91628d18df1f$exports))) === null || (0, (/*@__PURE__*/$parcel$interopDefault($932a91628d18df1f$exports))) === void 0 ? void 0 : (_MOCK_DATA_data = (0, (/*@__PURE__*/$parcel$interopDefault($932a91628d18df1f$exports))).data) === null || _MOCK_DATA_data === void 0 ? void 0 : (_MOCK_DATA_data_cards_ = _MOCK_DATA_data.cards[4]) === null || _MOCK_DATA_data_cards_ === void 0 ? void 0 : (_MOCK_DATA_data_cards__card = _MOCK_DATA_data_cards_.card) === null || _MOCK_DATA_data_cards__card === void 0 ? void 0 : (_MOCK_DATA_data_cards__card_card = _MOCK_DATA_data_cards__card.card) === null || _MOCK_DATA_data_cards__card_card === void 0 ? void 0 : (_MOCK_DATA_data_cards__card_card_gridElements = _MOCK_DATA_data_cards__card_card.gridElements) === null || _MOCK_DATA_data_cards__card_card_gridElements === void 0 ? void 0 : (_MOCK_DATA_data_cards__card_card_gridElements_infoWithStyle = _MOCK_DATA_data_cards__card_card_gridElements.infoWithStyle) === null || _MOCK_DATA_data_cards__card_card_gridElements_infoWithStyle === void 0 ? void 0 : _MOCK_DATA_data_cards__card_card_gridElements_infoWithStyle.restaurants;
                        setListOfRestaurants(restaurants);
                        setFilteredRestaurant(restaurants);
                        setLoading(false);
                    }, 1000); // Simulate 1 second delay
                } catch (error) {
                    console.error("Error fetching data:", error);
                    setLoading(false);
                }
                return [
                    2
                ];
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        listOfRestaurants: listOfRestaurants,
        filteredRestaurant: filteredRestaurant,
        loading: loading
    };
};
var $e2a3d1cd2c3a40d8$export$2e2bcd8739ae039 = $e2a3d1cd2c3a40d8$var$useTopRatedRestaurants;









var $b56eb78789fbb2f9$var$TopRatedRestaurantsPage = function() {
    var filteredRestaurant = (0, $e2a3d1cd2c3a40d8$export$2e2bcd8739ae039)().filteredRestaurant;
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(0), 2), sliderIndex = _useState[0], setSliderIndex = _useState[1];
    var sliderRef = (0, $fIwXP.useRef)(null);
    // Settings for the slider
    var settings = {
        className: "center",
        infinite: false,
        centerPadding: "60px",
        slidesToShow: 4,
        swipeToSlide: true
    };
    var next = function() {
        sliderRef.current.slickNext(); // Access slickNext through the current property
    };
    var previous = function() {
        sliderRef.current.slickPrev(); // Access slickPrev through the current property
    };
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "pb-3 px-3 text-2xl font-bold flex justify-between",
                children: [
                    "Top restaurant chains in Chennai",
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "rounded-full bg-gray-300 !w-10 h-10 flex items-center justify-center mr-3 focus:outline-none",
                                onClick: previous,
                                children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $69bac3e467faf0d3$export$2b9260d4a45c8710), {
                                    icon: (0, $5c8203742f0e3062$export$b7fac681e7d09400),
                                    className: "text-gray-700 text-sm"
                                })
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "rounded-full bg-gray-300 !w-10 h-10 flex items-center justify-center focus:outline-none",
                                onClick: next,
                                children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $69bac3e467faf0d3$export$2b9260d4a45c8710), {
                                    icon: (0, $5c8203742f0e3062$export$b4da69a0247f3620),
                                    className: "text-gray-700 text-sm"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1580051cd03fa60e$exports))), (0, $f17388ede13a49cc$export$4fa2f4023c9cbda5)((0, $ad1c00e896d27009$export$581ff339ea0ba762)({
                ref: sliderRef
            }, settings), {
                children: filteredRestaurant.map(function(restaurant) {
                    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "mx-2",
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                to: "/restaurants/" + (restaurant === null || restaurant === void 0 ? void 0 : restaurant.info.id),
                                children: (restaurant === null || restaurant === void 0 ? void 0 : restaurant.info.promoted) ? /*#__PURE__*/ (0, $cc6u1.jsx)(RestaurantCardPromoted, {
                                    resData: restaurant === null || restaurant === void 0 ? void 0 : restaurant.info
                                }) : /*#__PURE__*/ (0, $cc6u1.jsx)((0, $d6e6ef2e667bbda8$export$2e2bcd8739ae039), {
                                    resData: restaurant === null || restaurant === void 0 ? void 0 : restaurant.info
                                })
                            })
                        ]
                    }, restaurant === null || restaurant === void 0 ? void 0 : restaurant.info.id);
                })
            }))
        ]
    });
};
var $b56eb78789fbb2f9$export$2e2bcd8739ae039 = $b56eb78789fbb2f9$var$TopRatedRestaurantsPage;




var $373b11f276a41253$var$Body = function() {
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)([]), 2), listOfRestaurants = _useState[0], setListOfRestaurants = _useState[1];
    var _useState1 = (0, $kB67t._)((0, $fIwXP.useState)([]), 2), filteredRestaurant = _useState1[0], setFilteredRestaurant = _useState1[1];
    var _useState2 = (0, $kB67t._)((0, $fIwXP.useState)([]), 2), title = _useState2[0], setTitle = _useState2[1];
    var _useState3 = (0, $kB67t._)((0, $fIwXP.useState)(""), 2), searchText = _useState3[0], setSearchText = _useState3[1];
    var _useState4 = (0, $kB67t._)((0, $fIwXP.useState)(false), 2), searchClicked = _useState4[0], setSearchClicked = _useState4[1];
    var _useState5 = (0, $kB67t._)((0, $fIwXP.useState)(true), 2), loading = _useState5[0], setLoading = _useState5[1];
    (0, $fIwXP.useEffect)(function() {
        fetchData();
    }, []);
    var fetchData = function() {
        try {
            var _json_data_cards__card_card_gridElements_infoWithStyle, _json_data_cards__card_card_gridElements, _json_data_cards__card_card, _json_data_cards__card, _json_data_cards_, _json_data, _json_data_cards__card_card_gridElements_infoWithStyle1, _json_data_cards__card_card_gridElements1, _json_data_cards__card_card1, _json_data_cards__card1, _json_data_cards_1, _json_data1, _json_data_cards__card_card2, _json_data_cards__card2, _json_data_cards_2, _json_data2;
            setLoading(true); // Set loading state to true before fetching data
            // Directly use imported JSON data
            var json = (0, (/*@__PURE__*/$parcel$interopDefault($932a91628d18df1f$exports)));
            // Update state with fetched data
            setListOfRestaurants((json === null || json === void 0 ? void 0 : (_json_data = json.data) === null || _json_data === void 0 ? void 0 : (_json_data_cards_ = _json_data.cards[4]) === null || _json_data_cards_ === void 0 ? void 0 : (_json_data_cards__card = _json_data_cards_.card) === null || _json_data_cards__card === void 0 ? void 0 : (_json_data_cards__card_card = _json_data_cards__card.card) === null || _json_data_cards__card_card === void 0 ? void 0 : (_json_data_cards__card_card_gridElements = _json_data_cards__card_card.gridElements) === null || _json_data_cards__card_card_gridElements === void 0 ? void 0 : (_json_data_cards__card_card_gridElements_infoWithStyle = _json_data_cards__card_card_gridElements.infoWithStyle) === null || _json_data_cards__card_card_gridElements_infoWithStyle === void 0 ? void 0 : _json_data_cards__card_card_gridElements_infoWithStyle.restaurants) || []);
            setFilteredRestaurant((json === null || json === void 0 ? void 0 : (_json_data1 = json.data) === null || _json_data1 === void 0 ? void 0 : (_json_data_cards_1 = _json_data1.cards[4]) === null || _json_data_cards_1 === void 0 ? void 0 : (_json_data_cards__card1 = _json_data_cards_1.card) === null || _json_data_cards__card1 === void 0 ? void 0 : (_json_data_cards__card_card1 = _json_data_cards__card1.card) === null || _json_data_cards__card_card1 === void 0 ? void 0 : (_json_data_cards__card_card_gridElements1 = _json_data_cards__card_card1.gridElements) === null || _json_data_cards__card_card_gridElements1 === void 0 ? void 0 : (_json_data_cards__card_card_gridElements_infoWithStyle1 = _json_data_cards__card_card_gridElements1.infoWithStyle) === null || _json_data_cards__card_card_gridElements_infoWithStyle1 === void 0 ? void 0 : _json_data_cards__card_card_gridElements_infoWithStyle1.restaurants) || []);
            setTitle((json === null || json === void 0 ? void 0 : (_json_data2 = json.data) === null || _json_data2 === void 0 ? void 0 : (_json_data_cards_2 = _json_data2.cards[2]) === null || _json_data_cards_2 === void 0 ? void 0 : (_json_data_cards__card2 = _json_data_cards_2.card) === null || _json_data_cards__card2 === void 0 ? void 0 : (_json_data_cards__card_card2 = _json_data_cards__card2.card) === null || _json_data_cards__card_card2 === void 0 ? void 0 : _json_data_cards__card_card2.title) || "");
        } catch (error) {
            console.error("Error fetching data:", error);
        // Handle error state
        } finally{
            setLoading(false); // Set loading state to false after fetch operation
        }
    };
    /*const fetchData = async () => {
    try {
      setLoading(true); // Set loading state to true before fetching data
      const response = await fetch(
        "https://corsproxy.io/?https://www.swiggy.com/dapi/restaurants/list/v5?lat=13.0826802&lng=80.2707184&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING"
      );
  
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
  
      const json = await response.json();
  
      // Update state with fetched data
      setListOfRestaurants(
        json?.data?.cards[4]?.card?.card?.gridElements?.infoWithStyle?.restaurants
      );
      setFilteredRestaurant(
        json?.data?.cards[4]?.card?.card?.gridElements?.infoWithStyle?.restaurants
      );
      setTitle(json?.data?.cards[2]?.card?.card?.title);
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle error state
    } finally {
      setLoading(false); // Set loading state to false after fetch operation
    }
  };*/ var onlineStatus = (0, $3c7428cbea0d9bb7$export$2e2bcd8739ae039)();
    if (onlineStatus === false) return /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
        children: "Looks like you're offline!! Please check your internet connection;"
    });
    var handleSearch = function() {
        var filteredRestaurant = listOfRestaurants.filter(function(res) {
            return res.info.name.toLowerCase().includes(searchText.toLowerCase());
        });
        setFilteredRestaurant(filteredRestaurant);
        setSearchClicked(true);
    };
    return listOfRestaurants.length === 0 ? /*#__PURE__*/ (0, $cc6u1.jsx)((0, $68ce1d77bc18c07c$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "mx-20",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "search m-4 p-4 text-center",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)("input", {
                        type: "text",
                        "data-testid": "searchInput",
                        className: "border border-solid border-black",
                        value: searchText,
                        onChange: function(e) {
                            return setSearchText(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                        className: "px-4 py-2 bg-green-100 m-4 rounded-lg",
                        onClick: handleSearch,
                        children: "Search"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "mx-[5.5rem]",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)((0, $0d2235779b32f00d$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("hr", {
                        className: "h-px my-8 bg-gray-200 border-0 dark:bg-gray-700"
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)((0, $b56eb78789fbb2f9$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("hr", {
                        className: "h-px my-8 bg-gray-200 border-0 dark:bg-gray-700"
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                        className: "pb-3 px-3 text-2xl font-bold",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                        className: "grid grid-cols-4 gap-4 justify-center",
                        children: filteredRestaurant.map(function(restaurant, index) {
                            return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "mx-2",
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                        to: "/restaurants/" + (restaurant === null || restaurant === void 0 ? void 0 : restaurant.info.id),
                                        children: (restaurant === null || restaurant === void 0 ? void 0 : restaurant.info.promoted) ? /*#__PURE__*/ (0, $cc6u1.jsx)(RestaurantCardPromoted, {
                                            resData: restaurant === null || restaurant === void 0 ? void 0 : restaurant.info
                                        }) : /*#__PURE__*/ (0, $cc6u1.jsx)((0, $d6e6ef2e667bbda8$export$2e2bcd8739ae039), {
                                            resData: restaurant === null || restaurant === void 0 ? void 0 : restaurant.info
                                        })
                                    })
                                ]
                            }, restaurant === null || restaurant === void 0 ? void 0 : restaurant.info.id);
                        })
                    })
                ]
            })
        ]
    });
};
var $373b11f276a41253$export$2e2bcd8739ae039 = $373b11f276a41253$var$Body;




var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $5dLwP = parcelRequire("5dLwP");

var $lMNAp = parcelRequire("lMNAp");

var $cc6u1 = parcelRequire("cc6u1");

var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $5dLwP = parcelRequire("5dLwP");

var $lMNAp = parcelRequire("lMNAp");

var $cc6u1 = parcelRequire("cc6u1");

var $fIwXP = parcelRequire("fIwXP");
var $24207a1288b5d218$var$UserClass = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $5dLwP._)(UserClass, _React_Component);
    var _super = (0, $lMNAp._)(UserClass);
    function UserClass(props) {
        (0, $bB0zn._)(this, UserClass);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            count: 0,
            count2: 2
        };
        console.log("Child Constructor");
        return _this;
    }
    (0, $6QEWP._)(UserClass, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                console.log(this.props.name + "Child Component Did Mount");
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, name = _this_props.name, location = _this_props.location, contact = _this_props.contact;
                console.log("Child Render");
                return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                    className: "user-card justify-between",
                    children: [
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("h2", {
                            className: "font-bold pt-10",
                            children: [
                                "Name: ",
                                name
                            ]
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("h3", {
                            children: [
                                "Location: ",
                                location
                            ]
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("h4", {
                            children: [
                                "Contact: ",
                                contact
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return UserClass;
}((0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).Component);
var $24207a1288b5d218$export$2e2bcd8739ae039 = $24207a1288b5d218$var$UserClass;



var $fIwXP = parcelRequire("fIwXP");
var $601c1599e979598b$var$About = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $5dLwP._)(About, _React_Component);
    var _super = (0, $lMNAp._)(About);
    function About(props) {
        (0, $bB0zn._)(this, About);
        var _this = _super.call(this, props);
        console.log("Parent Consturctor");
        return _this;
    }
    (0, $6QEWP._)(About, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                console.log("Parent Component Did Mount");
            }
        },
        {
            key: "render",
            value: function render() {
                console.log("Parent Render");
                return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                    className: "text-center p-10 ",
                    children: [
                        /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                            children: "About"
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("h2", {
                            children: "*This is swiggy clone web app for learing React*"
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)((0, $24207a1288b5d218$export$2e2bcd8739ae039), {
                            name: "Deepa EV",
                            location: "Chennai",
                            contact: "+91 9080702627"
                        })
                    ]
                });
            }
        }
    ]);
    return About;
}((0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).Component);
var $601c1599e979598b$export$2e2bcd8739ae039 = $601c1599e979598b$var$About;



var $cc6u1 = parcelRequire("cc6u1");
var $717a2f0a6a708d12$var$Contact = function() {
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                className: "font-bold text-3xl p-4 m-4",
                children: "Contact Us Page"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)("input", {
                        type: "text",
                        className: "border border-black p-2 m-2",
                        placeholder: "name"
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("input", {
                        type: "text",
                        className: "border border-black p-2 m-2",
                        placeholder: "message"
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                        className: "border border-black p-2 m-2 bg-zinc-950 text-white rounded-md",
                        children: "Submit"
                    })
                ]
            })
        ]
    });
};
var $717a2f0a6a708d12$export$2e2bcd8739ae039 = $717a2f0a6a708d12$var$Contact;



var $cc6u1 = parcelRequire("cc6u1");

var $eb9ea4566ac52960$var$Error = function() {
    var err = (0, $9e36fd5982483bee$export$ed527bf60f6e05f2)();
    console.log(err);
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                children: "Oops!!!"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("h2", {
                children: " Something went wrong!!"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("h3", {
                children: [
                    err.status,
                    ": ",
                    err.statusText
                ]
            })
        ]
    });
};
var $eb9ea4566ac52960$export$2e2bcd8739ae039 = $eb9ea4566ac52960$var$Error;



var $kB67t = parcelRequire("kB67t");

var $cc6u1 = parcelRequire("cc6u1");




var $kB67t = parcelRequire("kB67t");


var $fIwXP = parcelRequire("fIwXP");
var $1c82672e18f22827$exports = {};
$1c82672e18f22827$exports = JSON.parse('{"statusCode":0,"data":{"statusMessage":"done successfully","cards":[{"card":{"card":{"@type":"type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2","text":"Pizza Hut","headerStyling":{"textColor":"text_Highest_Emphasis","textVariant":"header_H3_Black"}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab","tabs":[{"id":"Order Online","title":"Order Online"}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Restaurant","info":{"id":"806891","name":"Pizza Hut","city":"Chennai","slugs":{"restaurant":"pizza-hut-anna-salai-royapettah","city":"chennai"},"uniqueId":"e51e6528-4859-48c8-8fed-e84c17dc2d76","cloudinaryImageId":"978358a0d0caba4f4555b8e2147b467d","locality":"Anna Salai","areaName":"Triplicane","costForTwo":"35000","costForTwoMessage":"\u20B9350 for two","cuisines":["Pizzas"],"avgRating":4.3,"feeDetails":{"restaurantId":"806891","fees":[{"name":"TYPE_DISTANCE","fee":4100},{"name":"TYPE_TIME"}],"totalFee":4100,"title":"Delivery Charge","amount":"4100","icon":"v1648635511/Delivery_fee_new_cjxumu","message":"<b>3.0 kms</b> | \u20B941 Delivery fee will apply"},"parentId":"721","avgRatingString":"4.3","totalRatingsString":"100+ ratings","sla":{"restaurantId":"806891","deliveryTime":36,"minDeliveryTime":35,"maxDeliveryTime":40,"lastMileTravel":3,"serviceability":"SERVICEABLE","stressFactor":1,"rainMode":"RAIN_MODE_NONE","longDistance":"LONG_DISTANCE_NOT_LONG_DISTANCE","zoneId":183,"slaString":"35-40 MINS","lastMileTravelString":"3.0 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2024-05-17 01:00:00","visibility":true,"opened":true,"restaurantClosedMeta":{}},"aggregatedDiscountInfo":{"header":"50% off","shortDescriptionList":[{"meta":"50% off | Use SWIGGY50","discountType":"Percentage","operationType":"RESTAURANT"},{"meta":"30% off | Use TRYNEW","discountType":"Percentage","operationType":"RESTAURANT"}],"descriptionList":[{"meta":"50% off up to \u20B9100 | Use code SWIGGY50","discountType":"Percentage","operationType":"RESTAURANT"},{"meta":"30% off up to \u20B975 | Use code TRYNEW","discountType":"Percentage","operationType":"RESTAURANT"}],"visible":true},"badges":{},"slugString":"pizza-hut-anna-salai-royapettah","multiOutlet":true,"isOpen":true,"labels":[{"title":"Timings","message":"null"},{"title":"Address","message":"Old No - 57-62, New No -111, First Floor, Wallajah Road, Anna Salai, Chennai, Tamilnadu - 600002"},{"title":"Cuisines","message":"Pizzas"}],"logo":"rng/md/carousel/production/cztbor82z4wcxssgnaje","totalRatings":100,"aggregatedDiscountInfoV2":{"header":"50% off","shortDescriptionList":[{"meta":"50% off | Use SWIGGY50","discountType":"Percentage","operationType":"RESTAURANT"},{"meta":"30% off | Use TRYNEW","discountType":"Percentage","operationType":"RESTAURANT"}],"descriptionList":[{"meta":"50% off up to \u20B9100 | Use code SWIGGY50","discountType":"Percentage","operationType":"RESTAURANT"},{"meta":"30% off up to \u20B975 | Use code TRYNEW","discountType":"Percentage","operationType":"RESTAURANT"}],"couponDetailsCta":"View coupon details"},"type":"F","nudgeBanners":[{"minValue":125,"maxValue":179,"priority":2,"couponCode":"TRYNEW","discountInfo":{"discountType":"Percentage","value":30},"lockedMessage":"Add items worth \u20B9<amount> to save upto \u20B975 | Code TRYNEW","unlockedMessage":"TRYNEW Coupon Unlocked! Use it to save upto \u20B975","logoCtx":{}}],"headerBanner":{"url":"swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/806891"},"expectationNotifiers":[{"text":"<b>3.0 kms</b> | \u20B941 Delivery fee will apply","icon":{"imageId":"v1648635511/Delivery_fee_new_cjxumu"},"popup":{"cta":{}},"type":"DISTANCE_FEE_NON_FOOD_LM","enrichedText":"<b>3.0 kms</b> | \u20B941 Delivery fee will apply","halfCardPopup":{"halfCardPopupHeader":{}},"trailingIcon":{}}],"ratingSlab":"RATING_SLAB_5","orderabilityCommunication":{"title":{},"subTitle":{},"message":{},"customIcon":{}},"hasBestsellerItems":true,"cartOrderabilityNudgeBanner":{"parameters":{},"presentation":{}},"latLong":"13.0667561,80.2735799","backgroundImageOverlayInfo":{}},"analytics":{}},"relevance":{"type":"RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD","sectionId":"POP_UP_CROUTON_MENU"}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget","layout":{"rows":1,"columns":5,"horizontalScrollEnabled":true,"itemSpacing":12,"lineSpacing":10,"widgetPadding":{},"containerStyle":{"containerPadding":{"left":10,"right":10,"bottom":16}},"scrollBar":{}},"id":"offerCollectionWidget_UX4","gridElements":{"infoWithStyle":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle","offers":[{"info":{"header":"50% OFF UPTO \u20B9100","offerTagColor":"#E46D47","offerIds":["cebd66f5-6aaa-4c7a-80af-0429947646f6"],"expiryTime":"1970-01-01T00:00:00Z","couponCode":"USE SWIGGY50","description":"ABOVE \u20B9149","offerType":"offers","restId":"806891","offerLogo":"offers/generic","descriptionTextColor":"#7302060C"},"cta":{"type":"OFFER_HALF_CARD"}},{"info":{"header":"30% OFF UPTO \u20B975","offerTagColor":"#E46D47","offerIds":["5187de8e-3b35-47d5-88c1-85bdab73413a"],"expiryTime":"1970-01-01T00:00:00Z","couponCode":"USE TRYNEW","description":"ON SELECT ITEMS","offerType":"offers","restId":"806891","offerLogo":"offers/generic","descriptionTextColor":"#7302060C"},"cta":{"type":"OFFER_HALF_CARD"}},{"info":{"header":"20% OFF UPTO \u20B9125","offerTagColor":"#E46D47","logoBottom":"MARKETING_BANNERS/IMAGES/OFFERS/2024/4/30/dfb04dfd-509e-4fe2-896f-75e78e398330_Kotak.png","offerIds":["686370b9-7afb-435f-a8c9-c6f29cc3ac54"],"expiryTime":"1970-01-01T00:00:00Z","couponCode":"USE KOTAK811","description":"ABOVE \u20B9499","offerType":"offers","restId":"806891","offerLogo":"MARKETING_BANNERS/IMAGES/OFFERS/2024/4/30/dfb04dfd-509e-4fe2-896f-75e78e398330_Kotak.png","descriptionTextColor":"#7302060C"},"cta":{"type":"OFFER_HALF_CARD"}},{"info":{"header":"15% OFF UPTO \u20B9150","offerTagColor":"#E46D47","logoBottom":"MARKETING_BANNERS/IMAGES/OFFERS/2024/4/30/b26ac2f6-045e-4633-99a4-74992eedbc68_HSBC.png","offerIds":["b5f40c6c-2083-44d1-abd3-e5183f69f018"],"expiryTime":"1970-01-01T00:00:00Z","couponCode":"USE HSBCMANIA","description":"ABOVE \u20B9499","offerType":"offers","restId":"806891","offerLogo":"MARKETING_BANNERS/IMAGES/OFFERS/2024/4/30/b26ac2f6-045e-4633-99a4-74992eedbc68_HSBC.png","descriptionTextColor":"#7302060C"},"cta":{"type":"OFFER_HALF_CARD"}},{"info":{"header":"FLAT \u20B940 OFF","offerTagColor":"#E46D47","logoBottom":"MARKETING_BANNERS/IMAGES/OFFERS/2024/5/1/a5e0c2ad-ca03-42e7-b4ce-000d04acc0c5_Simpl.png","offerIds":["d5d1fe9e-409a-4691-8866-c37130b7a59a"],"expiryTime":"1970-01-01T00:00:00Z","couponCode":"NO CODE REQUIRED","description":"ABOVE \u20B9499","offerType":"offers","restId":"806891","offerLogo":"MARKETING_BANNERS/IMAGES/OFFERS/2024/5/1/a5e0c2ad-ca03-42e7-b4ce-000d04acc0c5_Simpl.png","descriptionTextColor":"#7302060C"},"cta":{"type":"OFFER_HALF_CARD"}}],"habitMilestoneInfo":{"callout":{}},"loyaltyDiscoverPresentationInfo":{"logoCtx":{}}}}}}},{"groupedCard":{"cardGroupMap":{"REGULAR":{"cards":[{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge","badges":{},"vegOnlyDetails":{"imageId":"AutoVegOnly_qkjowj","title":"Showing only vegetarian options.","description":"Tap on the VEG ONLY button to turn off the setting"},"offersFilter":{"attributes":{"displayText":"30% OFF"}},"topRatedFilter":{"attributes":{"displayText":"Ratings 4.0+"}},"kidsCategoryFilter":{"attributes":{"displayText":"Kids Favourites","tooltip":{"enabled":true,"displayText":"Kids Favourites Filter applied. Remove this filter to see the full Menu."}}},"vegFilter":{"attributes":{"displayText":"VEG"}},"nonvegFilter":{"attributes":{"displayText":"NONVEG"}}},"relevance":{"type":"RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED","sectionId":"MENU_FILTER_TOGGLE"}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel","title":"Top Picks","carousel":[{"type":"TopCarousel","subtype":"image","bannerId":"1968789","creativeId":"TopPicks/MeMealFries","title":"Melts Meal for 1 with Fries - Veg","description":" ","fontColor":"#FFFFFF","dish":{"info":{"id":"135326956","name":"Melts Meal for 1 with Fries - Veg","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 1 | Choose your favourite Melts & Fries. Customize your satisfaction. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g).","imageId":"77b13d58799f70f670be31e6fe53374e","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344688","name":"Choose your Melt","variations":[{"name":"Loaded Veggie BBQ","price":199,"default":1,"id":"135515512","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344690","variationId":"135515519"}},{"name":"Cheezy Cheese Veg","price":219,"id":"135515514","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344690","variationId":"135515519"}},{"name":"Magical Makhni Paneer","price":299,"id":"135515517","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344690","variationId":"135515519"}}]},{"groupId":"42344690","name":"Side","variations":[{"name":"Sprinkled Fries","price":60,"default":1,"id":"135515519","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344688","variationId":"135515512"},{"groupId":"42344690","variationId":"135515519"}],"price":25900},{"variations":[{"groupId":"42344688","variationId":"135515514"},{"groupId":"42344690","variationId":"135515519"}],"price":27900},{"variations":[{"groupId":"42344688","variationId":"135515517"},{"groupId":"42344690","variationId":"135515519"}],"price":35900}]},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":25900,"ribbon":{},"itemBadge":{},"badgesV2":{}},"analytics":{},"hideRestaurantDetails":true}},{"type":"TopCarousel","subtype":"image","bannerId":"1963858","creativeId":"TopPicks/CreMeBVeg","title":"Create your Melts Box of 2 - Veg","description":" ","fontColor":"#FFFFFF","dish":{"info":{"id":"135326957","name":"Create your Melts Box of 2 - Veg","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 2 | Choose any 2 Melts. Double the flavour, double the satisfaction. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g).","imageId":"e6072e97754de0c6c6030103e0fb50d3","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344700","name":"Choose your 1st Melt","variations":[{"name":"Loaded Veggie BBQ","price":189.5,"default":1,"id":"135515557","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344701","variationId":"135515565"}},{"name":"Cheezy Cheese Veg","price":219,"id":"135515559","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344701","variationId":"135515565"}},{"name":"Magical Makhni Paneer","price":299,"id":"135515561","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344701","variationId":"135515565"}}]},{"groupId":"42344701","name":"Choose your 2nd Melt","variations":[{"name":"Loaded Veggie BBQ","price":189.5,"default":1,"id":"135515565","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Cheezy Cheese Veg","price":219,"id":"135515567","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Magical Makhni Paneer","price":299,"id":"135515569","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344700","variationId":"135515557"},{"groupId":"42344701","variationId":"135515565"}],"price":37900},{"variations":[{"groupId":"42344700","variationId":"135515557"},{"groupId":"42344701","variationId":"135515567"}],"price":40850},{"variations":[{"groupId":"42344700","variationId":"135515557"},{"groupId":"42344701","variationId":"135515569"}],"price":48850},{"variations":[{"groupId":"42344700","variationId":"135515559"},{"groupId":"42344701","variationId":"135515565"}],"price":40850},{"variations":[{"groupId":"42344700","variationId":"135515559"},{"groupId":"42344701","variationId":"135515567"}],"price":43800},{"variations":[{"groupId":"42344700","variationId":"135515559"},{"groupId":"42344701","variationId":"135515569"}],"price":51800},{"variations":[{"groupId":"42344700","variationId":"135515561"},{"groupId":"42344701","variationId":"135515565"}],"price":48850},{"variations":[{"groupId":"42344700","variationId":"135515561"},{"groupId":"42344701","variationId":"135515567"}],"price":51800},{"variations":[{"groupId":"42344700","variationId":"135515561"},{"groupId":"42344701","variationId":"135515569"}],"price":59800}]},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 2"},"defaultPrice":37900,"ribbon":{},"itemBadge":{},"badgesV2":{}},"analytics":{},"hideRestaurantDetails":true}},{"type":"TopCarousel","subtype":"image","bannerId":"1964980","creativeId":"TopPicks/M3CM1Veg","title":"Melts 3 Course Meal for 1 - Veg","description":" ","fontColor":"#FFFFFF","dish":{"info":{"id":"135326958","name":"Melts 3 Course Meal for 1 - Veg","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 1 | The perfect \\"Me Time\\" meal. Choose your favourite Melts & Fries accompanied with 1 Pepsi PET. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g).","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/14/bfee1036-41ea-40c1-addc-4fcbfb9475ee_37545bf3-2f63-458b-a7bc-fbeeaa7c41bc.jpg_compressed","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344711","name":"Choose your Melt","variations":[{"name":"Loaded Veggie BBQ","price":309,"default":1,"id":"135515601","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Cheezy Cheese Veg","price":329,"id":"135515604","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Magical Makhni Paneer","price":409,"id":"135515607","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344711","variationId":"135515601"}],"price":30900},{"variations":[{"groupId":"42344711","variationId":"135515604"}],"price":32900},{"variations":[{"groupId":"42344711","variationId":"135515607"}],"price":40900}]},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":30900,"ribbon":{},"itemBadge":{},"badgesV2":{}},"analytics":{},"hideRestaurantDetails":true}},{"type":"TopCarousel","subtype":"image","bannerId":"2217923","creativeId":"TopPicks/BBBQVCrispy","title":"Bold BBQ Veggie Thin n Crispy","description":" ","fontColor":"#FFFFFF","dish":{"info":{"id":"136105859","name":"Bold BBQ Veggie Thin n Crispy","category":"New Thin n Crispy Pizzas","description":"Serves 4 | New Thin n Crispy crust with our signature pan sauce, with BBQ sauce drizzle, topped with mushroom, onion, green capsicum, & red paprika (TnC-266 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"e2f207fda70413b191db2683e4d471df","inStock":1,"isVeg":1,"price":74900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 4"},"ribbon":{},"offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{}},"analytics":{},"hideRestaurantDetails":true}},{"type":"TopCarousel","subtype":"image","bannerId":"1965559","creativeId":"TopPicks/ChPanSizzle","title":"Chilli Paneer Sizzle","description":" ","fontColor":"#FFFFFF","dish":{"info":{"id":"133116149","name":"Chilli Paneer Sizzle","category":"Flavour Fun Range.","description":"Pizza topped with spiced paneer, a spicy schezwan sauce, juicy tomato, crunchy onion & capsicum and cheesy dressing (298 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"fc2d0de600d6649eaea5ca50d84ab5ec","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37483143","name":"Size","variations":[{"name":"Personal","default":1,"id":"117298894","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37483144","variationId":"117298895"}}]},{"groupId":"37483144","name":"Choose your Crust","variations":[{"name":"Pan","price":179,"default":1,"id":"117298895","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37483143","variationId":"117298894"},{"groupId":"37483144","variationId":"117298895"}],"price":17900}]},"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":17900,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"isBestseller":true},"analytics":{},"hideRestaurantDetails":true}},{"type":"TopCarousel","subtype":"image","bannerId":"2218733","creativeId":"TopPicks/DDaKCrispy","title":"Dhabe Da Keema Thin n Crispy","description":" ","fontColor":"#FFFFFF","dish":{"info":{"id":"136105862","name":"Dhabe Da Keema Thin n Crispy","category":"New Thin n Crispy Pizzas","description":"Serves 4 | New Thin n Crispy crust with dhaba style chicken keema masala, green chiili, crunchy onion with flavourful pan sauce, 100 % mozzarella cheese & a generous drizzle of mint mayo (TnC-290 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/7/74ad756e-dc60-4b84-bdc2-2ddf65fda8f7_b340bd7e-a978-47fb-9fc1-d08ed1ad35b1_compressed","inStock":1,"price":74900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 4"},"ribbon":{},"offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{}},"analytics":{},"hideRestaurantDetails":true}},{"type":"TopCarousel","subtype":"image","bannerId":"1966419","creativeId":"TopPicks/ClaOniCaps","title":"Classic Onion Capsicum","description":" ","fontColor":"#FFFFFF","dish":{"info":{"id":"132859658","name":"Classic Onion Capsicum","category":"Flavour Fun Range.","description":"Serves 1 | Personal pizza topped with our classic pan sauce, crunchy onion & capsicum and cheesy dressing (307 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"ed6a84173f69cdd4f676e94c2332c5e7","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266321","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400794","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266322","variationId":"116400795"}}]},{"groupId":"37266322","name":"Choose your Crust","variations":[{"name":"Pan","price":99,"default":1,"id":"116400795","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266321","variationId":"116400794"},{"groupId":"37266322","variationId":"116400795"}],"price":9900,"addonCombinations":[{"groupId":"133692619","addonId":"112193863"},{"groupId":"133692619","addonId":"112193860"},{"groupId":"133692619","addonId":"112193859"},{"groupId":"133692619","addonId":"115290079"},{"groupId":"133692619","addonId":"112193858"},{"groupId":"133692619","addonId":"112193861"}]}]},"addons":[{"groupId":"133692619","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":9900,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"isBestseller":true},"analytics":{},"hideRestaurantDetails":true}},{"type":"TopCarousel","subtype":"image","bannerId":"1967808","creativeId":"TopPicks/ClasCorn","title":"Classic Corn","description":" ","fontColor":"#FFFFFF","dish":{"info":{"id":"132859656","name":"Classic Corn","category":"Flavour Fun Range.","description":"Serves 1 | Personal pizza topped with our classic pan sauce, sweet corn and cheesy dressing. An all-time favorite (319 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"aed52ab0d028996e060b772f11ff31d8","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266317","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400783","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266318","variationId":"116400787"}}]},{"groupId":"37266318","name":"Choose your Crust","variations":[{"name":"Pan","price":109,"default":1,"id":"116400787","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266317","variationId":"116400783"},{"groupId":"37266318","variationId":"116400787"}],"price":10900,"addonCombinations":[{"groupId":"133692615","addonId":"112193863"},{"groupId":"133692615","addonId":"112193860"},{"groupId":"133692615","addonId":"112193859"},{"groupId":"133692615","addonId":"115290079"},{"groupId":"133692615","addonId":"112193858"},{"groupId":"133692615","addonId":"112193861"}]}]},"addons":[{"groupId":"133692615","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":10900,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"isBestseller":true},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Recommended","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135326956","name":"Melts Meal for 1 with Fries - Veg","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 1 | Choose your favourite Melts & Fries. Customize your satisfaction. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g).","imageId":"77b13d58799f70f670be31e6fe53374e","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344688","name":"Choose your Melt","variations":[{"name":"Loaded Veggie BBQ","price":199,"default":1,"id":"135515512","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344690","variationId":"135515519"}},{"name":"Cheezy Cheese Veg","price":219,"id":"135515514","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344690","variationId":"135515519"}},{"name":"Magical Makhni Paneer","price":299,"id":"135515517","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344690","variationId":"135515519"}}]},{"groupId":"42344690","name":"Side","variations":[{"name":"Sprinkled Fries","price":60,"default":1,"id":"135515519","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344688","variationId":"135515512"},{"groupId":"42344690","variationId":"135515519"}],"price":25900},{"variations":[{"groupId":"42344688","variationId":"135515514"},{"groupId":"42344690","variationId":"135515519"}],"price":27900},{"variations":[{"groupId":"42344688","variationId":"135515517"},{"groupId":"42344690","variationId":"135515519"}],"price":35900}]},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":25900,"ribbon":{},"showImage":true,"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"9 ratings","ratingCountV2":"9"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135326959","name":"Melts Meal for 1 with Fries Non-Veg","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 1 | Choose your favourite Melts & Fries combo. Customize your satisfaction.Cheezy Cheese Chicken Melts : (268 Kcal/100g), Loaded BBQ Non-Veg Melts : (330 Kcal/100g), Chicken Tikka Keema Melts : (283 Kcal/100g).","imageId":"da8429720566b8992d5c1c6bfeecdd2c","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344720","name":"Choose your Melt","variations":[{"name":"Loaded Chicken BBQ","price":249,"default":1,"id":"135515671","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344722","variationId":"135515682"}},{"name":"Cheezy Cheese Chicken","price":269,"id":"135515673","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344722","variationId":"135515682"}},{"name":"Chicken Tikka & Keema","price":309,"id":"135515676","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344722","variationId":"135515682"}}]},{"groupId":"42344722","name":"Side","variations":[{"name":"Sprinkled Fries","price":60,"default":1,"id":"135515682","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344720","variationId":"135515671"},{"groupId":"42344722","variationId":"135515682"}],"price":30900},{"variations":[{"groupId":"42344720","variationId":"135515673"},{"groupId":"42344722","variationId":"135515682"}],"price":32900},{"variations":[{"groupId":"42344720","variationId":"135515676"},{"groupId":"42344722","variationId":"135515682"}],"price":36900}]},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":30900,"ribbon":{},"showImage":true,"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135326961","name":"Melts 3 Course Meal for 1 Non-Veg","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 1 | The perfect \\"Me Time\\" meal. Choose your favourite Melts & Fries accompanied with 1 Pepsi PET. Cheezy Cheese Chicken Melts : (268 Kcal/100g), Loaded BBQ Non-Veg Melts : (330 Kcal/100g), Chicken Tikka Keema Melts : (283 Kcal/100g).","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/14/26d48552-a554-4b30-93d0-7462c255adc2_cc625cc1-b13b-44d4-a394-969d224b4c6c.jpg_compressed","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344733","name":"Choose your Melt","variations":[{"name":"Loaded Chicken BBQ","price":359,"default":1,"id":"135515737","inStock":1,"isEnabled":1},{"name":"Cheezy Cheese Chicken","price":379,"id":"135515738","inStock":1,"isEnabled":1},{"name":"Chicken Tikka & Keema","price":419,"id":"135515740","inStock":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344733","variationId":"135515737"}],"price":35900},{"variations":[{"groupId":"42344733","variationId":"135515738"}],"price":37900},{"variations":[{"groupId":"42344733","variationId":"135515740"}],"price":41900}]},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":35900,"ribbon":{},"showImage":true,"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135326958","name":"Melts 3 Course Meal for 1 - Veg","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 1 | The perfect \\"Me Time\\" meal. Choose your favourite Melts & Fries accompanied with 1 Pepsi PET. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g).","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/14/bfee1036-41ea-40c1-addc-4fcbfb9475ee_37545bf3-2f63-458b-a7bc-fbeeaa7c41bc.jpg_compressed","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344711","name":"Choose your Melt","variations":[{"name":"Loaded Veggie BBQ","price":309,"default":1,"id":"135515601","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Cheezy Cheese Veg","price":329,"id":"135515604","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Magical Makhni Paneer","price":409,"id":"135515607","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344711","variationId":"135515601"}],"price":30900},{"variations":[{"groupId":"42344711","variationId":"135515604"}],"price":32900},{"variations":[{"groupId":"42344711","variationId":"135515607"}],"price":40900}]},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":30900,"ribbon":{},"showImage":true,"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135326957","name":"Create your Melts Box of 2 - Veg","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 2 | Choose any 2 Melts. Double the flavour, double the satisfaction. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g).","imageId":"e6072e97754de0c6c6030103e0fb50d3","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344700","name":"Choose your 1st Melt","variations":[{"name":"Loaded Veggie BBQ","price":189.5,"default":1,"id":"135515557","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344701","variationId":"135515565"}},{"name":"Cheezy Cheese Veg","price":219,"id":"135515559","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344701","variationId":"135515565"}},{"name":"Magical Makhni Paneer","price":299,"id":"135515561","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344701","variationId":"135515565"}}]},{"groupId":"42344701","name":"Choose your 2nd Melt","variations":[{"name":"Loaded Veggie BBQ","price":189.5,"default":1,"id":"135515565","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Cheezy Cheese Veg","price":219,"id":"135515567","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Magical Makhni Paneer","price":299,"id":"135515569","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344700","variationId":"135515557"},{"groupId":"42344701","variationId":"135515565"}],"price":37900},{"variations":[{"groupId":"42344700","variationId":"135515557"},{"groupId":"42344701","variationId":"135515567"}],"price":40850},{"variations":[{"groupId":"42344700","variationId":"135515557"},{"groupId":"42344701","variationId":"135515569"}],"price":48850},{"variations":[{"groupId":"42344700","variationId":"135515559"},{"groupId":"42344701","variationId":"135515565"}],"price":40850},{"variations":[{"groupId":"42344700","variationId":"135515559"},{"groupId":"42344701","variationId":"135515567"}],"price":43800},{"variations":[{"groupId":"42344700","variationId":"135515559"},{"groupId":"42344701","variationId":"135515569"}],"price":51800},{"variations":[{"groupId":"42344700","variationId":"135515561"},{"groupId":"42344701","variationId":"135515565"}],"price":48850},{"variations":[{"groupId":"42344700","variationId":"135515561"},{"groupId":"42344701","variationId":"135515567"}],"price":51800},{"variations":[{"groupId":"42344700","variationId":"135515561"},{"groupId":"42344701","variationId":"135515569"}],"price":59800}]},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 2"},"defaultPrice":37900,"ribbon":{},"showImage":true,"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.5","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135326960","name":"Create your Melts Box of 2 Non-Veg","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 2 | Choose any 2 Melts. Double the flavour, double the satisfaction. Cheezy Cheese Chicken : (268 Kcal/100g), Loaded BBQ Non-Veg : (330 Kcal/100g), Chicken Tikka Keema : (283 Kcal/100g).","imageId":"e7620274ab99ba415f3e00480020cb48","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344725","name":"Choose your 1st Melt","variations":[{"name":"Loaded Chicken BBQ","price":249,"default":1,"id":"135515716","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344726","variationId":"135515724"}},{"name":"Cheezy Cheese Chicken","price":269,"id":"135515719","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344726","variationId":"135515724"}},{"name":"Chicken Tikka & Keema","price":309,"id":"135515721","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344726","variationId":"135515724"}}]},{"groupId":"42344726","name":"Choose your 2nd Melt","variations":[{"name":"Loaded Chicken BBQ","price":249,"default":1,"id":"135515724","inStock":1,"isEnabled":1},{"name":"Cheezy Cheese Chicken","price":269,"id":"135515725","inStock":1,"isEnabled":1},{"name":"Chicken Tikka & Keema","price":309,"id":"135515727","inStock":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344725","variationId":"135515716"},{"groupId":"42344726","variationId":"135515724"}],"price":49800},{"variations":[{"groupId":"42344725","variationId":"135515716"},{"groupId":"42344726","variationId":"135515725"}],"price":51800},{"variations":[{"groupId":"42344725","variationId":"135515716"},{"groupId":"42344726","variationId":"135515727"}],"price":55800},{"variations":[{"groupId":"42344725","variationId":"135515719"},{"groupId":"42344726","variationId":"135515724"}],"price":51800},{"variations":[{"groupId":"42344725","variationId":"135515719"},{"groupId":"42344726","variationId":"135515725"}],"price":53800},{"variations":[{"groupId":"42344725","variationId":"135515719"},{"groupId":"42344726","variationId":"135515727"}],"price":57800},{"variations":[{"groupId":"42344725","variationId":"135515721"},{"groupId":"42344726","variationId":"135515724"}],"price":55800},{"variations":[{"groupId":"42344725","variationId":"135515721"},{"groupId":"42344726","variationId":"135515725"}],"price":57800},{"variations":[{"groupId":"42344725","variationId":"135515721"},{"groupId":"42344726","variationId":"135515727"}],"price":61800}]},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 2"},"defaultPrice":49800,"ribbon":{},"showImage":true,"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135337391","name":"Cheezy Cheese Chicken & Loaded BBQ Non-Veg Combo","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 1 | Satisfy your non veg cravings with Cheezy Cheese Chicken & Loaded Chicken BBQ Melts. Cheezy Cheese Chicken Melts : (268 Kcal/100g), Loaded BBQ Non-Veg Melts: (330 Kcal/100g).","imageId":"3779ffaf02380c80f951a1ed2b90c997","inStock":1,"price":48900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"ribbon":{},"showImage":true,"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135703516","name":"Cheezy Cheese Veg & Loaded BBQ Veg Combo","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 2 | Double the satisfaction with Cheezy Cheese Veg & Loaded BBQ Veg Melts. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g).","imageId":"0b816322be7e8731246e9492e4b44b84","inStock":1,"isVeg":1,"price":39900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 2"},"ribbon":{},"showImage":true,"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135337392","name":"Makhni Paneer & Chicken Tikka Keema Combo","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 2 | Satisfy your desi flavour cravings with Makhni Paneer & Chicken Tikka Keema Melts. Makhni Paneer Melts: (265 Kcal/100g), Chicken Tikka Keema Melts : (283 Kcal/100g).","imageId":"a6c351a9a53ae0c5fa2e5e401b8bf27a","inStock":1,"price":54900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 2"},"ribbon":{},"showImage":true,"offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859678","name":"My Box - Non Veg","category":"Meals and Deals : Better With Pepsi (Save upto 38%)","description":"Serves 1 | 1 personal non veg pizza, 2 pc garlic bread & 1 Pepsi PET. For Meals, refer to the nutritional data for individual products.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/14/3330ac68-19aa-4598-a9f9-ac1f538ab52c_e1e7be34-7ff1-475b-a69b-4b99de6a2b09.png","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344507","name":"Pizza","variations":[{"name":"Chicken Sausage","price":212,"default":1,"id":"135514405","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Sausage & Sweet Corn","price":252,"id":"135514407","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Dhabe Da Keema","price":252,"id":"135514408","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Sizzling Schezwan Chicken","price":252,"id":"135514411","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Murg Malai Chicken","price":272,"id":"135514413","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Awesome American Cheesy Chicken","price":272,"id":"135514416","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Chicken Tikka","price":272,"id":"135514418","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Chicken Pepperoni","price":272,"id":"135514421","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Nawabi Murg Makhni","price":292,"id":"135514424","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Chicken Supreme","price":292,"id":"135514427","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Chicken Tikka Supreme","price":292,"id":"135514430","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Triple Chicken Feast","price":292,"id":"135514432","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}}]},{"groupId":"42344512","name":"Garlic Bread","variations":[{"name":"2 Pcs Cheese Garlic Bread","price":70,"id":"135514434","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344514","variationId":"135514439"}},{"name":"2 Pcs Garlic Bread","price":50,"default":1,"id":"135514436","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344514","variationId":"135514439"}}]},{"groupId":"42344514","name":"Beverage","variations":[{"name":"Pepsi Pet Bottle","price":57,"default":1,"id":"135514439","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344507","variationId":"135514405"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":33900},{"variations":[{"groupId":"42344507","variationId":"135514405"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":31900},{"variations":[{"groupId":"42344507","variationId":"135514407"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":37900},{"variations":[{"groupId":"42344507","variationId":"135514407"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":35900},{"variations":[{"groupId":"42344507","variationId":"135514408"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":37900},{"variations":[{"groupId":"42344507","variationId":"135514408"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":35900},{"variations":[{"groupId":"42344507","variationId":"135514411"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":37900},{"variations":[{"groupId":"42344507","variationId":"135514411"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":35900},{"variations":[{"groupId":"42344507","variationId":"135514413"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":39900},{"variations":[{"groupId":"42344507","variationId":"135514413"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":37900},{"variations":[{"groupId":"42344507","variationId":"135514416"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":39900},{"variations":[{"groupId":"42344507","variationId":"135514416"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":37900},{"variations":[{"groupId":"42344507","variationId":"135514418"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":39900},{"variations":[{"groupId":"42344507","variationId":"135514418"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":37900},{"variations":[{"groupId":"42344507","variationId":"135514421"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":39900},{"variations":[{"groupId":"42344507","variationId":"135514421"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":37900},{"variations":[{"groupId":"42344507","variationId":"135514424"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":41900},{"variations":[{"groupId":"42344507","variationId":"135514424"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":39900},{"variations":[{"groupId":"42344507","variationId":"135514427"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":41900},{"variations":[{"groupId":"42344507","variationId":"135514427"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":39900},{"variations":[{"groupId":"42344507","variationId":"135514430"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":41900},{"variations":[{"groupId":"42344507","variationId":"135514430"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":39900},{"variations":[{"groupId":"42344507","variationId":"135514432"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":41900},{"variations":[{"groupId":"42344507","variationId":"135514432"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":39900}]},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":31900,"ribbon":{},"showImage":true,"offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.8","ratingCount":"6 ratings","ratingCountV2":"6"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859680","name":"My Box - Veg","category":"Meals and Deals : Better With Pepsi (Save upto 38%)","description":"Serves 1 | 1 personal veg pizza, 2 pc garlic bread & 1 Pepsi PET ! For Meals, refer to the nutritional data for individual products.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/14/a1efbc7d-6165-4b69-8fe8-e88335921678_0c2d69b5-8aef-4ff2-962c-7c9d75bb84ce.png","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344517","name":"Pizza","variations":[{"name":"Margherita","price":142,"default":1,"id":"135514454","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Schezwan Margherita","price":142,"id":"135514456","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Corn & Cheese","price":192,"id":"135514457","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Veggie Feast","price":212,"id":"135514459","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Spiced Paneer","price":212,"id":"135514460","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Mexican Fiesta","price":232,"id":"135514462","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Bold BBQ Veggies","price":232,"id":"135514464","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Tandoori Paneer","price":232,"id":"135514466","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Country Feast","price":232,"id":"135514468","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Ultimate Tandoori Veggie","price":252,"id":"135514469","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Mazedar Makhni Paneer","price":252,"id":"135514470","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Awesome American Cheesy","price":252,"id":"135514473","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Veggie Supreme","price":252,"id":"135514476","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}}]},{"groupId":"42344523","name":"Garlic Bread","variations":[{"name":"2 Pcs Cheese Garlic Bread","price":70,"id":"135514480","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344525","variationId":"135514488"}},{"name":"2 Pcs Garlic Bread","price":50,"default":1,"id":"135514483","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344525","variationId":"135514488"}}]},{"groupId":"42344525","name":"Beverage","variations":[{"name":"Pepsi Pet Bottle","price":57,"default":1,"id":"135514488","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344517","variationId":"135514454"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":26900},{"variations":[{"groupId":"42344517","variationId":"135514454"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":24900},{"variations":[{"groupId":"42344517","variationId":"135514456"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":26900},{"variations":[{"groupId":"42344517","variationId":"135514456"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":24900},{"variations":[{"groupId":"42344517","variationId":"135514457"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":31900},{"variations":[{"groupId":"42344517","variationId":"135514457"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":29900},{"variations":[{"groupId":"42344517","variationId":"135514459"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":33900},{"variations":[{"groupId":"42344517","variationId":"135514459"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":31900},{"variations":[{"groupId":"42344517","variationId":"135514460"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":33900},{"variations":[{"groupId":"42344517","variationId":"135514460"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":31900},{"variations":[{"groupId":"42344517","variationId":"135514462"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":35900},{"variations":[{"groupId":"42344517","variationId":"135514462"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":33900},{"variations":[{"groupId":"42344517","variationId":"135514464"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":35900},{"variations":[{"groupId":"42344517","variationId":"135514464"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":33900},{"variations":[{"groupId":"42344517","variationId":"135514466"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":35900},{"variations":[{"groupId":"42344517","variationId":"135514466"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":33900},{"variations":[{"groupId":"42344517","variationId":"135514468"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":35900},{"variations":[{"groupId":"42344517","variationId":"135514468"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":33900},{"variations":[{"groupId":"42344517","variationId":"135514469"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":37900},{"variations":[{"groupId":"42344517","variationId":"135514469"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":35900},{"variations":[{"groupId":"42344517","variationId":"135514470"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":37900},{"variations":[{"groupId":"42344517","variationId":"135514470"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":35900},{"variations":[{"groupId":"42344517","variationId":"135514473"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":37900},{"variations":[{"groupId":"42344517","variationId":"135514473"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":35900},{"variations":[{"groupId":"42344517","variationId":"135514476"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":37900},{"variations":[{"groupId":"42344517","variationId":"135514476"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":35900}]},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":24900,"ribbon":{},"showImage":true,"offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"8 ratings","ratingCountV2":"8"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859672","name":"Hut Treat Meal for 2 - Non Veg","category":"Meals and Deals : Better With Pepsi (Save upto 38%)","description":"Serves 2 | 1 medium non-veg pizza upto signature, 1 classic bread stix, 1 Pepsi PET. For Meals, refer to the nutritional data for individual products.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/14/fc115b57-9536-4c2d-8876-bcedf630ea7b_b7818aa0-4ccb-4cfa-acb5-df7a9cace4e5.png_compressed","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344462","name":"Choose Your Pizza","variations":[{"name":"Chicken Sausage","price":433,"default":1,"id":"135514147","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Sausage & Sweet Corn","price":433,"id":"135514151","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Dhabe Da Keema","price":433,"id":"135514154","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Sizzling Schezwan Chicken","price":433,"id":"135514159","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Murg Malai Chicken","price":483,"id":"135514162","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Awesome American Cheesy Chicken","price":483,"id":"135514165","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Chicken Tikka","price":483,"id":"135514168","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Chicken Pepperoni","price":433,"id":"135514170","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Nawabi Murg Makhni","price":483,"id":"135514171","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Chicken Supreme","price":483,"id":"135514172","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Chicken Tikka Supreme","price":483,"id":"135514173","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Triple Chicken Feast","price":483,"id":"135514174","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}}]},{"groupId":"42344464","name":"Side","variations":[{"name":"Classic BreadStix","price":99,"default":1,"id":"135514175","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344465","variationId":"135514176"}}]},{"groupId":"42344465","name":"Beverage","variations":[{"name":"Pepsi PET Bottle","price":57,"default":1,"id":"135514176","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344462","variationId":"135514147"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":58900},{"variations":[{"groupId":"42344462","variationId":"135514151"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":58900},{"variations":[{"groupId":"42344462","variationId":"135514154"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":58900},{"variations":[{"groupId":"42344462","variationId":"135514159"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":58900},{"variations":[{"groupId":"42344462","variationId":"135514162"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":63900},{"variations":[{"groupId":"42344462","variationId":"135514165"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":63900},{"variations":[{"groupId":"42344462","variationId":"135514168"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":63900},{"variations":[{"groupId":"42344462","variationId":"135514170"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":58900},{"variations":[{"groupId":"42344462","variationId":"135514171"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":63900},{"variations":[{"groupId":"42344462","variationId":"135514172"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":63900},{"variations":[{"groupId":"42344462","variationId":"135514173"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":63900},{"variations":[{"groupId":"42344462","variationId":"135514174"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":63900}]},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 2"},"defaultPrice":58900,"ribbon":{},"showImage":true,"offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859673","name":"Hut Treat Meal for 2 - Veg","category":"Meals and Deals : Better With Pepsi (Save upto 38%)","description":"Serves 2 | 1 medium veg pizza upto signature, 1 classic bread stix, 1 Pepsi PET. For Meals, refer to the nutritional data for individual products.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/14/9004b4ef-3454-40d3-babb-641082675270_4fd584b6-55b0-4a17-b519-d42e6fff8af9.png","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344471","name":"Choose Your Pizza","variations":[{"name":"Margherita","price":373,"default":1,"id":"135514221","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}},{"name":"Schezwan Margherita","price":373,"id":"135514224","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}},{"name":"Corn & Cheese","price":373,"id":"135514226","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}},{"name":"Veggie Feast","price":373,"id":"135514227","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}},{"name":"Spiced Paneer","price":373,"id":"135514228","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}},{"name":"Mexican Fiesta","price":433,"id":"135514229","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}},{"name":"Bold BBQ Veggies","price":433,"id":"135514230","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}},{"name":"Tandoori Paneer","price":433,"id":"135514231","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}},{"name":"Country Feast","price":433,"id":"135514232","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}},{"name":"Veggie Supreme","price":433,"id":"135514235","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}}]},{"groupId":"42344474","name":"Side","variations":[{"name":"Classic BreadStix","price":99,"default":1,"id":"135514238","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344475","variationId":"135514239"}}]},{"groupId":"42344475","name":"Beverage","variations":[{"name":"Pepsi PET Bottle","price":57,"default":1,"id":"135514239","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344471","variationId":"135514221"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":52900},{"variations":[{"groupId":"42344471","variationId":"135514224"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":52900},{"variations":[{"groupId":"42344471","variationId":"135514226"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":52900},{"variations":[{"groupId":"42344471","variationId":"135514227"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":52900},{"variations":[{"groupId":"42344471","variationId":"135514228"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":52900},{"variations":[{"groupId":"42344471","variationId":"135514229"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":58900},{"variations":[{"groupId":"42344471","variationId":"135514230"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":58900},{"variations":[{"groupId":"42344471","variationId":"135514231"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":58900},{"variations":[{"groupId":"42344471","variationId":"135514232"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":58900},{"variations":[{"groupId":"42344471","variationId":"135514235"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":58900}]},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 2"},"defaultPrice":52900,"ribbon":{},"showImage":true,"offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859675","name":"Hut Treat Meal for 4 - Non Veg","category":"Meals and Deals : Better With Pepsi (Save upto 38%)","description":"Serves 4 | Super saver meal combo @ 959 - 2 med non veg pizza of choice, 2 classic bread stix, 2 Pepsi PET. For Meals, refer to the nutritional data for individual products.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/14/4bf86218-e9b2-4ff2-9c8b-bfc20e115efc_e6e2dc0f-10ed-4389-918b-45d3e32bfeda.png","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344479","name":"Choose 1st Pizza","variations":[{"name":"Chicken Sausage","price":616,"default":1,"id":"135514258","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344481","variationId":"135514269"}},{"name":"Sausage & Sweet Corn","price":616,"id":"135514259","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344481","variationId":"135514269"}},{"name":"Dhabe Da Keema","price":616,"id":"135514260","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344481","variationId":"135514269"}},{"name":"Sizzling Schezwan Chicken","price":616,"id":"135514261","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344481","variationId":"135514269"}},{"name":"Murg Malai Chicken","price":671,"id":"135514263","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344481","variationId":"135514269"}},{"name":"Chicken Tikka","price":671,"id":"135514266","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344481","variationId":"135514269"}},{"name":"Chicken Pepperoni","price":671,"id":"135514267","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344481","variationId":"135514269"}},{"name":"Nawabi Murg Makhni","price":671,"id":"135514268","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344481","variationId":"135514269"}}]},{"groupId":"42344481","name":"Choose 2nd Pizza","variations":[{"name":"Chicken Sausage","price":343,"default":1,"id":"135514269","inStock":1,"isEnabled":1},{"name":"Sausage & Sweet Corn","price":343,"id":"135514270","inStock":1,"isEnabled":1},{"name":"Dhabe Da Keema","price":343,"id":"135514271","inStock":1,"isEnabled":1},{"name":"Sizzling Schezwan Chicken","price":343,"id":"135514273","inStock":1,"isEnabled":1},{"name":"Murg Malai Chicken","price":398,"id":"135514275","inStock":1,"isEnabled":1},{"name":"Chicken Tikka","price":398,"id":"135514277","inStock":1,"isEnabled":1},{"name":"Chicken Pepperoni","price":398,"id":"135514279","inStock":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344479","variationId":"135514258"},{"groupId":"42344481","variationId":"135514269"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514258"},{"groupId":"42344481","variationId":"135514270"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514258"},{"groupId":"42344481","variationId":"135514271"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514258"},{"groupId":"42344481","variationId":"135514273"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514258"},{"groupId":"42344481","variationId":"135514275"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514258"},{"groupId":"42344481","variationId":"135514277"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514258"},{"groupId":"42344481","variationId":"135514279"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514259"},{"groupId":"42344481","variationId":"135514269"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514259"},{"groupId":"42344481","variationId":"135514270"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514259"},{"groupId":"42344481","variationId":"135514271"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514259"},{"groupId":"42344481","variationId":"135514273"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514259"},{"groupId":"42344481","variationId":"135514275"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514259"},{"groupId":"42344481","variationId":"135514277"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514259"},{"groupId":"42344481","variationId":"135514279"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514260"},{"groupId":"42344481","variationId":"135514269"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514260"},{"groupId":"42344481","variationId":"135514270"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514260"},{"groupId":"42344481","variationId":"135514271"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514260"},{"groupId":"42344481","variationId":"135514273"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514260"},{"groupId":"42344481","variationId":"135514275"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514260"},{"groupId":"42344481","variationId":"135514277"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514260"},{"groupId":"42344481","variationId":"135514279"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514261"},{"groupId":"42344481","variationId":"135514269"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514261"},{"groupId":"42344481","variationId":"135514270"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514261"},{"groupId":"42344481","variationId":"135514271"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514261"},{"groupId":"42344481","variationId":"135514273"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514261"},{"groupId":"42344481","variationId":"135514275"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514261"},{"groupId":"42344481","variationId":"135514277"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514261"},{"groupId":"42344481","variationId":"135514279"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514263"},{"groupId":"42344481","variationId":"135514269"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514263"},{"groupId":"42344481","variationId":"135514270"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514263"},{"groupId":"42344481","variationId":"135514271"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514263"},{"groupId":"42344481","variationId":"135514273"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514263"},{"groupId":"42344481","variationId":"135514275"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514263"},{"groupId":"42344481","variationId":"135514277"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514263"},{"groupId":"42344481","variationId":"135514279"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514266"},{"groupId":"42344481","variationId":"135514269"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514266"},{"groupId":"42344481","variationId":"135514270"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514266"},{"groupId":"42344481","variationId":"135514271"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514266"},{"groupId":"42344481","variationId":"135514273"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514266"},{"groupId":"42344481","variationId":"135514275"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514266"},{"groupId":"42344481","variationId":"135514277"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514266"},{"groupId":"42344481","variationId":"135514279"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514267"},{"groupId":"42344481","variationId":"135514269"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514267"},{"groupId":"42344481","variationId":"135514270"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514267"},{"groupId":"42344481","variationId":"135514271"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514267"},{"groupId":"42344481","variationId":"135514273"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514267"},{"groupId":"42344481","variationId":"135514275"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514267"},{"groupId":"42344481","variationId":"135514277"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514267"},{"groupId":"42344481","variationId":"135514279"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514268"},{"groupId":"42344481","variationId":"135514269"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514268"},{"groupId":"42344481","variationId":"135514270"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514268"},{"groupId":"42344481","variationId":"135514271"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514268"},{"groupId":"42344481","variationId":"135514273"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514268"},{"groupId":"42344481","variationId":"135514275"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514268"},{"groupId":"42344481","variationId":"135514277"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514268"},{"groupId":"42344481","variationId":"135514279"}],"price":106900}]},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 4"},"defaultPrice":95900,"ribbon":{},"showImage":true,"offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859676","name":"Hut Treat Meal for 4 - Veg","category":"Meals and Deals : Better With Pepsi (Save upto 38%)","description":"Serves 4 | Super saver meal combo @ 859 - 2 med veg pizza of choice, 2 classic bread stix, 2 Pepsi PET. For Meals, refer to the nutritional data for individual products.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/14/ca00e969-c65f-4436-85fc-a64408ddaa09_6f0ea04a-c96c-4a1e-893a-be49ead80ae0.png","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344492","name":"Choose 1st Pizza","variations":[{"name":"Margherita","price":566,"default":1,"id":"135514325","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344495","variationId":"135514345"}},{"name":"Schezwan Margherita","price":566,"id":"135514328","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344495","variationId":"135514345"}},{"name":"Corn & Cheese","price":566,"id":"135514330","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344495","variationId":"135514345"}},{"name":"Veggie Feast","price":566,"id":"135514332","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344495","variationId":"135514345"}},{"name":"Spiced Paneer","price":566,"id":"135514334","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344495","variationId":"135514345"}},{"name":"Mexican Fiesta","price":616,"id":"135514336","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344495","variationId":"135514345"}},{"name":"Bold BBQ Veggies","price":616,"id":"135514338","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344495","variationId":"135514345"}},{"name":"Tandoori Paneer","price":616,"id":"135514341","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344495","variationId":"135514345"}},{"name":"Country Feast","price":616,"id":"135514343","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344495","variationId":"135514345"}}]},{"groupId":"42344495","name":"Choose 2nd Pizza","variations":[{"name":"Margherita","price":293,"default":1,"id":"135514345","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Schezwan Margherita","price":293,"id":"135514348","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Corn & Cheese","price":293,"id":"135514350","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Veggie Feast","price":293,"id":"135514353","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Spiced Paneer","price":293,"id":"135514354","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Mexican Fiesta","price":343,"id":"135514356","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Bold BBQ Veggies","price":343,"id":"135514358","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Tandoori Paneer","price":343,"id":"135514361","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Country Feast","price":343,"id":"135514363","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344492","variationId":"135514325"},{"groupId":"42344495","variationId":"135514345"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514325"},{"groupId":"42344495","variationId":"135514348"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514325"},{"groupId":"42344495","variationId":"135514350"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514325"},{"groupId":"42344495","variationId":"135514353"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514325"},{"groupId":"42344495","variationId":"135514354"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514325"},{"groupId":"42344495","variationId":"135514356"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514325"},{"groupId":"42344495","variationId":"135514358"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514325"},{"groupId":"42344495","variationId":"135514361"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514325"},{"groupId":"42344495","variationId":"135514363"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514328"},{"groupId":"42344495","variationId":"135514345"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514328"},{"groupId":"42344495","variationId":"135514348"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514328"},{"groupId":"42344495","variationId":"135514350"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514328"},{"groupId":"42344495","variationId":"135514353"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514328"},{"groupId":"42344495","variationId":"135514354"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514328"},{"groupId":"42344495","variationId":"135514356"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514328"},{"groupId":"42344495","variationId":"135514358"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514328"},{"groupId":"42344495","variationId":"135514361"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514328"},{"groupId":"42344495","variationId":"135514363"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514330"},{"groupId":"42344495","variationId":"135514345"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514330"},{"groupId":"42344495","variationId":"135514348"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514330"},{"groupId":"42344495","variationId":"135514350"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514330"},{"groupId":"42344495","variationId":"135514353"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514330"},{"groupId":"42344495","variationId":"135514354"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514330"},{"groupId":"42344495","variationId":"135514356"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514330"},{"groupId":"42344495","variationId":"135514358"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514330"},{"groupId":"42344495","variationId":"135514361"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514330"},{"groupId":"42344495","variationId":"135514363"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514332"},{"groupId":"42344495","variationId":"135514345"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514332"},{"groupId":"42344495","variationId":"135514348"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514332"},{"groupId":"42344495","variationId":"135514350"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514332"},{"groupId":"42344495","variationId":"135514353"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514332"},{"groupId":"42344495","variationId":"135514354"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514332"},{"groupId":"42344495","variationId":"135514356"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514332"},{"groupId":"42344495","variationId":"135514358"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514332"},{"groupId":"42344495","variationId":"135514361"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514332"},{"groupId":"42344495","variationId":"135514363"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514334"},{"groupId":"42344495","variationId":"135514345"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514334"},{"groupId":"42344495","variationId":"135514348"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514334"},{"groupId":"42344495","variationId":"135514350"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514334"},{"groupId":"42344495","variationId":"135514353"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514334"},{"groupId":"42344495","variationId":"135514354"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514334"},{"groupId":"42344495","variationId":"135514356"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514334"},{"groupId":"42344495","variationId":"135514358"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514334"},{"groupId":"42344495","variationId":"135514361"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514334"},{"groupId":"42344495","variationId":"135514363"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514336"},{"groupId":"42344495","variationId":"135514345"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514336"},{"groupId":"42344495","variationId":"135514348"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514336"},{"groupId":"42344495","variationId":"135514350"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514336"},{"groupId":"42344495","variationId":"135514353"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514336"},{"groupId":"42344495","variationId":"135514354"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514336"},{"groupId":"42344495","variationId":"135514356"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514336"},{"groupId":"42344495","variationId":"135514358"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514336"},{"groupId":"42344495","variationId":"135514361"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514336"},{"groupId":"42344495","variationId":"135514363"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514338"},{"groupId":"42344495","variationId":"135514345"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514338"},{"groupId":"42344495","variationId":"135514348"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514338"},{"groupId":"42344495","variationId":"135514350"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514338"},{"groupId":"42344495","variationId":"135514353"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514338"},{"groupId":"42344495","variationId":"135514354"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514338"},{"groupId":"42344495","variationId":"135514356"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514338"},{"groupId":"42344495","variationId":"135514358"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514338"},{"groupId":"42344495","variationId":"135514361"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514338"},{"groupId":"42344495","variationId":"135514363"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514341"},{"groupId":"42344495","variationId":"135514345"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514341"},{"groupId":"42344495","variationId":"135514348"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514341"},{"groupId":"42344495","variationId":"135514350"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514341"},{"groupId":"42344495","variationId":"135514353"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514341"},{"groupId":"42344495","variationId":"135514354"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514341"},{"groupId":"42344495","variationId":"135514356"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514341"},{"groupId":"42344495","variationId":"135514358"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514341"},{"groupId":"42344495","variationId":"135514361"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514341"},{"groupId":"42344495","variationId":"135514363"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514343"},{"groupId":"42344495","variationId":"135514345"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514343"},{"groupId":"42344495","variationId":"135514348"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514343"},{"groupId":"42344495","variationId":"135514350"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514343"},{"groupId":"42344495","variationId":"135514353"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514343"},{"groupId":"42344495","variationId":"135514354"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514343"},{"groupId":"42344495","variationId":"135514356"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514343"},{"groupId":"42344495","variationId":"135514358"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514343"},{"groupId":"42344495","variationId":"135514361"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514343"},{"groupId":"42344495","variationId":"135514363"}],"price":95900}]},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 4"},"defaultPrice":85900,"ribbon":{},"showImage":true,"offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859682","name":"Super Value Deal : 2 Medium Non-Veg Pizzas starting at Rs 749 (Save Upto 39%).","category":"One Plus One Medium @649","description":"Serves 4 | Choose any 2 of your favorite non-veg medium pizzas. For Meals, refer to the nutritional data for individual products.","imageId":"6110f28b77f670194674bbf318970656","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344533","name":"Choose 1st Pizza","variations":[{"name":"Chicken Sausage","price":374.5,"default":1,"id":"135514521","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Sausage & Sweet Corn","price":374.5,"id":"135514523","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Dhabe Da Keema","price":424.5,"id":"135514524","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Sizzling Schezwan Chicken","price":374.5,"id":"135514526","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Murg Malai Chicken","price":424.5,"id":"135514527","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Awesome American Cheesy Chicken","price":424.5,"id":"135514528","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Chicken Tikka","price":424.5,"id":"135514529","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Chicken Pepperoni","price":424.5,"id":"135514530","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Nawabi Murg Makhni","price":424.5,"id":"135514531","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Chicken Supreme","price":424.5,"id":"135514532","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Chicken Tikka Supreme","price":424.5,"id":"135514533","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Triple Chicken Feast","price":424.5,"id":"135514534","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}}]},{"groupId":"42344536","name":"Choose 2nd Pizza","variations":[{"name":"Chicken Sausage","price":374.5,"default":1,"id":"135514535","inStock":1,"isEnabled":1},{"name":"Sausage & Sweet Corn","price":374.5,"id":"135514536","inStock":1,"isEnabled":1},{"name":"Dhabe Da Keema","price":424.5,"id":"135514537","inStock":1,"isEnabled":1},{"name":"Sizzling Schezwan Chicken","price":374.5,"id":"135514538","inStock":1,"isEnabled":1},{"name":"Murg Malai Chicken","price":424.5,"id":"135514540","inStock":1,"isEnabled":1},{"name":"Awesome American Cheesy Chicken","price":424.5,"id":"135514541","inStock":1,"isEnabled":1},{"name":"Chicken Tikka","price":424.5,"id":"135514543","inStock":1,"isEnabled":1},{"name":"Chicken Pepperoni","price":424.5,"id":"135514546","inStock":1,"isEnabled":1},{"name":"Nawabi Murg Makhni","price":424.5,"id":"135514549","inStock":1,"isEnabled":1},{"name":"Chicken Supreme","price":424.5,"id":"135514552","inStock":1,"isEnabled":1},{"name":"Chicken Tikka Supreme","price":424.5,"id":"135514555","inStock":1,"isEnabled":1},{"name":"Triple Chicken Feast","price":424.5,"id":"135514558","inStock":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514535"}],"price":74900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514536"}],"price":74900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514537"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514538"}],"price":74900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514540"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514541"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514543"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514546"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514549"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514552"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514555"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514558"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514535"}],"price":74900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514536"}],"price":74900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514537"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514538"}],"price":74900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514540"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514541"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514543"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514546"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514549"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514552"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514555"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514558"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514535"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514536"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514537"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514538"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514540"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514541"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514543"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514546"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514549"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514552"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514555"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514558"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514535"}],"price":74900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514536"}],"price":74900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514537"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514538"}],"price":74900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514540"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514541"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514543"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514546"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514549"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514552"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514555"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514558"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514535"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514536"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514537"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514538"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514540"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514541"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514543"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514546"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514549"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514552"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514555"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514558"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514535"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514536"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514537"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514538"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514540"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514541"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514543"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514546"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514549"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514552"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514555"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514558"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514535"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514536"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514537"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514538"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514540"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514541"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514543"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514546"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514549"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514552"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514555"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514558"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514535"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514536"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514537"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514538"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514540"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514541"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514543"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514546"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514549"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514552"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514555"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514558"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514535"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514536"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514537"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514538"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514540"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514541"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514543"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514546"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514549"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514552"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514555"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514558"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514535"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514536"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514537"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514538"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514540"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514541"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514543"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514546"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514549"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514552"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514555"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514558"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514535"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514536"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514537"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514538"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514540"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514541"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514543"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514546"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514549"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514552"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514555"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514558"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514535"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514536"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514537"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514538"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514540"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514541"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514543"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514546"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514549"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514552"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514555"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514558"}],"price":84900}]},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 4"},"defaultPrice":74900,"ribbon":{},"showImage":true,"offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859684","name":"Super Value Deal : 2 Medium Veg Pizzas starting at Rs 649 (Save Upto 41%).","category":"One Plus One Medium @649","description":"Serves 4 | Choose any 2 of your favorite veg medium pizzas. For Meals, refer to the nutritional data for individual products.","imageId":"2d34f1c2c669eab6821dd0ee068590e4","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344566","name":"Choose 1st Pizza","variations":[{"name":"Margherita","price":324.5,"default":1,"id":"135514699","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Schezwan Margherita","price":324.5,"id":"135514702","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Corn & Cheese","price":324.5,"id":"135514707","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Veggie Feast","price":324.5,"id":"135514712","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Spiced Paneer","price":324.5,"id":"135514716","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Mexican Fiesta","price":374.5,"id":"135514721","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Bold BBQ Veggies","price":374.5,"id":"135514727","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Tandoori Paneer","price":374.5,"id":"135514732","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Country Feast","price":374.5,"id":"135514736","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Ultimate Tandoori Veggie","price":374.5,"id":"135514740","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Mazedar Makhni Paneer","price":374.5,"id":"135514743","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Awesome American Cheesy","price":374.5,"id":"135514745","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Veggie Supreme","price":374.5,"id":"135514747","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}}]},{"groupId":"42344575","name":"Choose 2nd Pizza","variations":[{"name":"Margherita","price":324.5,"default":1,"id":"135514750","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Schezwan Margherita","price":324.5,"id":"135514752","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Corn & Cheese","price":324.5,"id":"135514754","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Veggie Feast","price":324.5,"id":"135514756","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Spiced Paneer","price":324.5,"id":"135514759","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Mexican Fiesta","price":374.5,"id":"135514761","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Bold BBQ Veggies","price":374.5,"id":"135514763","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Tandoori Paneer","price":374.5,"id":"135514764","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Country Feast","price":374.5,"id":"135514765","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Ultimate Tandoori Veggie","price":374.5,"id":"135514766","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Mazedar Makhni Paneer","price":374.5,"id":"135514767","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Awesome American Cheesy","price":374.5,"id":"135514768","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Veggie Supreme","price":374.5,"id":"135514769","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514750"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514752"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514754"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514756"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514759"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514761"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514763"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514764"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514765"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514766"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514767"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514768"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514769"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514750"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514752"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514754"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514756"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514759"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514761"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514763"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514764"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514765"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514766"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514767"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514768"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514769"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514750"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514752"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514754"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514756"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514759"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514761"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514763"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514764"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514765"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514766"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514767"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514768"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514769"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514750"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514752"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514754"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514756"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514759"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514761"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514763"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514764"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514765"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514766"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514767"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514768"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514769"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514750"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514752"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514754"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514756"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514759"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514761"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514763"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514764"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514765"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514766"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514767"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514768"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514769"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514750"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514752"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514754"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514756"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514759"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514761"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514763"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514764"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514765"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514766"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514767"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514768"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514769"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514750"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514752"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514754"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514756"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514759"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514761"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514763"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514764"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514765"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514766"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514767"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514768"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514769"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514750"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514752"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514754"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514756"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514759"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514761"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514763"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514764"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514765"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514766"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514767"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514768"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514769"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514750"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514752"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514754"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514756"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514759"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514761"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514763"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514764"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514765"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514766"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514767"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514768"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514769"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514750"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514752"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514754"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514756"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514759"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514761"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514763"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514764"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514765"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514766"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514767"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514768"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514769"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514750"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514752"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514754"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514756"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514759"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514761"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514763"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514764"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514765"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514766"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514767"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514768"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514769"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514750"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514752"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514754"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514756"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514759"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514761"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514763"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514764"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514765"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514766"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514767"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514768"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514769"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514750"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514752"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514754"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514756"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514759"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514761"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514763"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514764"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514765"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514766"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514767"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514768"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514769"}],"price":74900}]},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 4"},"defaultPrice":64900,"ribbon":{},"showImage":true,"offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859589","name":"Margherita","category":"Veg Pizza","description":"Pizza topped with our herb-infused signature pan sauce and 100% mozzarella cheese. A classic treat for all cheese lovers out there! (PAN Per/Med-292 Kcal/100g | TnC-293 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"dpventcrozvfni0lqb10","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266243","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400554","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266244","variationId":"116400556"}},{"name":"Medium","id":"116400555","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266244","variationId":"116400557"}},{"name":"Thin n Large","id":"124962348","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266244","variationId":"124962349"}}]},{"groupId":"37266244","name":"Choose your Crust","variations":[{"name":"Pan","price":169,"default":1,"id":"116400556","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Pan","price":329,"id":"116400557","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Thin n Crispy","price":479,"id":"124962349","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":244,"id":"126057679","isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":428,"id":"126057680","isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266243","variationId":"116400554"},{"groupId":"37266244","variationId":"116400556"}],"price":16900,"addonCombinations":[{"groupId":"133692544","addonId":"112193863"},{"groupId":"133692544","addonId":"112193860"},{"groupId":"133692544","addonId":"112193859"},{"groupId":"133692544","addonId":"115290079"},{"groupId":"133692544","addonId":"112193858"},{"groupId":"133692544","addonId":"112193861"},{"groupId":"133692546","addonId":"112193873"},{"groupId":"133692546","addonId":"112193870"},{"groupId":"133692546","addonId":"112193872"},{"groupId":"133692546","addonId":"112193878"},{"groupId":"133692546","addonId":"112193838"},{"groupId":"133692546","addonId":"112193840"},{"groupId":"133692546","addonId":"112193842"},{"groupId":"133692546","addonId":"112193844"},{"groupId":"133692546","addonId":"112193849"},{"groupId":"133692546","addonId":"112193845"},{"groupId":"133692546","addonId":"112193851"},{"groupId":"133692546","addonId":"112193853"},{"groupId":"151869389","addonId":"112193873"}]},{"variations":[{"groupId":"37266243","variationId":"116400554"},{"groupId":"37266244","variationId":"126057679"}],"price":24400,"addonCombinations":[{"groupId":"133692544","addonId":"112193863"},{"groupId":"133692544","addonId":"112193860"},{"groupId":"133692544","addonId":"112193859"},{"groupId":"133692544","addonId":"115290079"},{"groupId":"133692544","addonId":"112193858"},{"groupId":"133692544","addonId":"112193861"},{"groupId":"133692546","addonId":"112193873"},{"groupId":"133692546","addonId":"112193870"},{"groupId":"133692546","addonId":"112193872"},{"groupId":"133692546","addonId":"112193878"},{"groupId":"133692546","addonId":"112193838"},{"groupId":"133692546","addonId":"112193840"},{"groupId":"133692546","addonId":"112193842"},{"groupId":"133692546","addonId":"112193844"},{"groupId":"133692546","addonId":"112193849"},{"groupId":"133692546","addonId":"112193845"},{"groupId":"133692546","addonId":"112193851"},{"groupId":"133692546","addonId":"112193853"},{"groupId":"151869389","addonId":"112193873"}]},{"variations":[{"groupId":"37266243","variationId":"116400555"},{"groupId":"37266244","variationId":"116400557"}],"price":32900,"addonCombinations":[{"groupId":"133692544","addonId":"112193863"},{"groupId":"133692544","addonId":"112193860"},{"groupId":"133692544","addonId":"112193859"},{"groupId":"133692544","addonId":"115290079"},{"groupId":"133692544","addonId":"112193858"},{"groupId":"133692544","addonId":"112193861"},{"groupId":"151869396","addonId":"117361301"},{"groupId":"133692545","addonId":"112193843"},{"groupId":"133692545","addonId":"112193839"},{"groupId":"133692545","addonId":"112193841"},{"groupId":"133692545","addonId":"112193877"},{"groupId":"133692545","addonId":"112193848"},{"groupId":"133692545","addonId":"112193850"},{"groupId":"133692545","addonId":"112193852"},{"groupId":"133692545","addonId":"112193854"},{"groupId":"133692545","addonId":"112193856"},{"groupId":"133692545","addonId":"112193855"},{"groupId":"133692545","addonId":"112193865"},{"groupId":"133692545","addonId":"112193866"}]},{"variations":[{"groupId":"37266243","variationId":"116400555"},{"groupId":"37266244","variationId":"126057680"}],"price":42800,"addonCombinations":[{"groupId":"133692544","addonId":"112193863"},{"groupId":"133692544","addonId":"112193860"},{"groupId":"133692544","addonId":"112193859"},{"groupId":"133692544","addonId":"115290079"},{"groupId":"133692544","addonId":"112193858"},{"groupId":"133692544","addonId":"112193861"},{"groupId":"151869396","addonId":"117361301"},{"groupId":"133692545","addonId":"112193843"},{"groupId":"133692545","addonId":"112193839"},{"groupId":"133692545","addonId":"112193841"},{"groupId":"133692545","addonId":"112193877"},{"groupId":"133692545","addonId":"112193848"},{"groupId":"133692545","addonId":"112193850"},{"groupId":"133692545","addonId":"112193852"},{"groupId":"133692545","addonId":"112193854"},{"groupId":"133692545","addonId":"112193856"},{"groupId":"133692545","addonId":"112193855"},{"groupId":"133692545","addonId":"112193865"},{"groupId":"133692545","addonId":"112193866"}]},{"variations":[{"groupId":"37266243","variationId":"124962348"},{"groupId":"37266244","variationId":"124962349"}],"price":47900,"addonCombinations":[{"groupId":"133692544","addonId":"112193863"},{"groupId":"133692544","addonId":"112193860"},{"groupId":"133692544","addonId":"112193859"},{"groupId":"133692544","addonId":"115290079"},{"groupId":"133692544","addonId":"112193858"},{"groupId":"133692544","addonId":"112193861"},{"groupId":"151869399","addonId":"114785288"},{"groupId":"140439439","addonId":"114785287"},{"groupId":"140439439","addonId":"114785288"},{"groupId":"140439439","addonId":"114785289"},{"groupId":"140439439","addonId":"114785290"},{"groupId":"140439439","addonId":"114785286"},{"groupId":"140439439","addonId":"114785301"},{"groupId":"140439439","addonId":"114785302"},{"groupId":"140439439","addonId":"114785297"},{"groupId":"140439439","addonId":"114785298"},{"groupId":"140439439","addonId":"114785299"},{"groupId":"140439439","addonId":"114785300"},{"groupId":"140439439","addonId":"114785293"},{"groupId":"140439439","addonId":"114785294"}]}]},"addons":[{"groupId":"151869389","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"151869399","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140439439","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692544","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"133692545","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692546","groupName":"Add. Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193878","name":"Herbed Veggies","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":16900,"ribbon":{},"showImage":true,"offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"11 ratings","ratingCountV2":"11"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859593","name":"Tandoori Paneer","category":"Veg Pizza","description":"Serves 1 | It\'s our signature. Spiced paneer, crunchy onions & green capsicum, spicy red paprika with delicious tandoori sauce and 100% mozzarella cheese! (PAN Per/Med-335 Kcal/100g | TnC-326 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"s5ld93rsknx0fhj6xarn","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266251","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400578","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266252","variationId":"116400580"}},{"name":"Medium","id":"116400579","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266252","variationId":"116400581"}},{"name":"Thin n Large","id":"124962356","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266252","variationId":"124962357"}}]},{"groupId":"37266252","name":"Choose your Crust","variations":[{"name":"Pan","price":319,"default":1,"id":"116400580","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Pan","price":569,"id":"116400581","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Thin n Crispy","price":749,"id":"124962357","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":394,"id":"126057569","isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":668,"id":"126057570","isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266251","variationId":"116400578"},{"groupId":"37266252","variationId":"116400580"}],"price":31900,"addonCombinations":[{"groupId":"133692556","addonId":"112193863"},{"groupId":"133692556","addonId":"112193860"},{"groupId":"133692556","addonId":"112193859"},{"groupId":"133692556","addonId":"115290079"},{"groupId":"133692556","addonId":"112193858"},{"groupId":"133692556","addonId":"112193861"},{"groupId":"133692558","addonId":"112193873"},{"groupId":"133692558","addonId":"112193870"},{"groupId":"133692558","addonId":"112193872"},{"groupId":"133692558","addonId":"112193878"},{"groupId":"133692558","addonId":"112193838"},{"groupId":"133692558","addonId":"112193840"},{"groupId":"133692558","addonId":"112193842"},{"groupId":"133692558","addonId":"112193844"},{"groupId":"133692558","addonId":"112193849"},{"groupId":"133692558","addonId":"112193845"},{"groupId":"133692558","addonId":"112193851"},{"groupId":"133692558","addonId":"112193853"},{"groupId":"151869110","addonId":"112193873"}]},{"variations":[{"groupId":"37266251","variationId":"116400578"},{"groupId":"37266252","variationId":"126057569"}],"price":39400,"addonCombinations":[{"groupId":"133692556","addonId":"112193863"},{"groupId":"133692556","addonId":"112193860"},{"groupId":"133692556","addonId":"112193859"},{"groupId":"133692556","addonId":"115290079"},{"groupId":"133692556","addonId":"112193858"},{"groupId":"133692556","addonId":"112193861"},{"groupId":"133692558","addonId":"112193873"},{"groupId":"133692558","addonId":"112193870"},{"groupId":"133692558","addonId":"112193872"},{"groupId":"133692558","addonId":"112193878"},{"groupId":"133692558","addonId":"112193838"},{"groupId":"133692558","addonId":"112193840"},{"groupId":"133692558","addonId":"112193842"},{"groupId":"133692558","addonId":"112193844"},{"groupId":"133692558","addonId":"112193849"},{"groupId":"133692558","addonId":"112193845"},{"groupId":"133692558","addonId":"112193851"},{"groupId":"133692558","addonId":"112193853"},{"groupId":"151869110","addonId":"112193873"}]},{"variations":[{"groupId":"37266251","variationId":"116400579"},{"groupId":"37266252","variationId":"116400581"}],"price":56900,"addonCombinations":[{"groupId":"133692556","addonId":"112193863"},{"groupId":"133692556","addonId":"112193860"},{"groupId":"133692556","addonId":"112193859"},{"groupId":"133692556","addonId":"115290079"},{"groupId":"133692556","addonId":"112193858"},{"groupId":"133692556","addonId":"112193861"},{"groupId":"151869111","addonId":"117361301"},{"groupId":"133692557","addonId":"112193843"},{"groupId":"133692557","addonId":"112193839"},{"groupId":"133692557","addonId":"112193841"},{"groupId":"133692557","addonId":"112193877"},{"groupId":"133692557","addonId":"112193848"},{"groupId":"133692557","addonId":"112193850"},{"groupId":"133692557","addonId":"112193852"},{"groupId":"133692557","addonId":"112193854"},{"groupId":"133692557","addonId":"112193856"},{"groupId":"133692557","addonId":"112193855"},{"groupId":"133692557","addonId":"112193865"},{"groupId":"133692557","addonId":"112193866"}]},{"variations":[{"groupId":"37266251","variationId":"116400579"},{"groupId":"37266252","variationId":"126057570"}],"price":66800,"addonCombinations":[{"groupId":"133692556","addonId":"112193863"},{"groupId":"133692556","addonId":"112193860"},{"groupId":"133692556","addonId":"112193859"},{"groupId":"133692556","addonId":"115290079"},{"groupId":"133692556","addonId":"112193858"},{"groupId":"133692556","addonId":"112193861"},{"groupId":"151869111","addonId":"117361301"},{"groupId":"133692557","addonId":"112193843"},{"groupId":"133692557","addonId":"112193839"},{"groupId":"133692557","addonId":"112193841"},{"groupId":"133692557","addonId":"112193877"},{"groupId":"133692557","addonId":"112193848"},{"groupId":"133692557","addonId":"112193850"},{"groupId":"133692557","addonId":"112193852"},{"groupId":"133692557","addonId":"112193854"},{"groupId":"133692557","addonId":"112193856"},{"groupId":"133692557","addonId":"112193855"},{"groupId":"133692557","addonId":"112193865"},{"groupId":"133692557","addonId":"112193866"}]},{"variations":[{"groupId":"37266251","variationId":"124962356"},{"groupId":"37266252","variationId":"124962357"}],"price":74900,"addonCombinations":[{"groupId":"133692556","addonId":"112193863"},{"groupId":"133692556","addonId":"112193860"},{"groupId":"133692556","addonId":"112193859"},{"groupId":"133692556","addonId":"115290079"},{"groupId":"133692556","addonId":"112193858"},{"groupId":"133692556","addonId":"112193861"},{"groupId":"151869112","addonId":"114785288"},{"groupId":"140439443","addonId":"114785287"},{"groupId":"140439443","addonId":"114785288"},{"groupId":"140439443","addonId":"114785289"},{"groupId":"140439443","addonId":"114785290"},{"groupId":"140439443","addonId":"114785286"},{"groupId":"140439443","addonId":"114785301"},{"groupId":"140439443","addonId":"114785302"},{"groupId":"140439443","addonId":"114785297"},{"groupId":"140439443","addonId":"114785298"},{"groupId":"140439443","addonId":"114785299"},{"groupId":"140439443","addonId":"114785300"},{"groupId":"140439443","addonId":"114785293"},{"groupId":"140439443","addonId":"114785294"}]}]},"addons":[{"groupId":"151869110","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"151869112","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140439443","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692556","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"133692557","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692558","groupName":"Add. Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193878","name":"Herbed Veggies","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":31900,"ribbon":{},"showImage":true,"offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.7","ratingCount":"13 ratings","ratingCountV2":"13"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859596","name":"Veggie Supreme","category":"Veg Pizza","description":"Serves 1 | A supreme combination of black olives, green capsicum, mushroom, onion, spicy red paprika & juicy sweet corn with flavourful pan sauce and 100% mozzarella cheese. (PAN Per/Med-254 Kcal/100g | TnC-258 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"z0c4xpovma1qtmu4tlls","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266257","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400596","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266258","variationId":"116400598"}},{"name":"Medium","id":"116400597","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266258","variationId":"116400599"}},{"name":"Thin n Large","id":"124962362","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266258","variationId":"124962363"}}]},{"groupId":"37266258","name":"Choose your Crust","variations":[{"name":"Pan","price":379,"default":1,"id":"116400598","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Pan","price":639,"id":"116400599","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Thin n Crispy","price":849,"id":"124962363","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":454,"id":"126057651","isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":738,"id":"126057652","isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266257","variationId":"116400596"},{"groupId":"37266258","variationId":"116400598"}],"price":37900,"addonCombinations":[{"groupId":"133692565","addonId":"112193863"},{"groupId":"133692565","addonId":"112193860"},{"groupId":"133692565","addonId":"112193859"},{"groupId":"133692565","addonId":"115290079"},{"groupId":"133692565","addonId":"112193858"},{"groupId":"133692565","addonId":"112193861"},{"groupId":"133692567","addonId":"112193873"},{"groupId":"133692567","addonId":"112193870"},{"groupId":"133692567","addonId":"112193872"},{"groupId":"133692567","addonId":"112193878"},{"groupId":"133692567","addonId":"112193838"},{"groupId":"133692567","addonId":"112193840"},{"groupId":"133692567","addonId":"112193842"},{"groupId":"133692567","addonId":"112193844"},{"groupId":"133692567","addonId":"112193849"},{"groupId":"133692567","addonId":"112193845"},{"groupId":"133692567","addonId":"112193851"},{"groupId":"133692567","addonId":"112193853"},{"groupId":"151869037","addonId":"112193873"}]},{"variations":[{"groupId":"37266257","variationId":"116400596"},{"groupId":"37266258","variationId":"126057651"}],"price":45400,"addonCombinations":[{"groupId":"133692565","addonId":"112193863"},{"groupId":"133692565","addonId":"112193860"},{"groupId":"133692565","addonId":"112193859"},{"groupId":"133692565","addonId":"115290079"},{"groupId":"133692565","addonId":"112193858"},{"groupId":"133692565","addonId":"112193861"},{"groupId":"133692567","addonId":"112193873"},{"groupId":"133692567","addonId":"112193870"},{"groupId":"133692567","addonId":"112193872"},{"groupId":"133692567","addonId":"112193878"},{"groupId":"133692567","addonId":"112193838"},{"groupId":"133692567","addonId":"112193840"},{"groupId":"133692567","addonId":"112193842"},{"groupId":"133692567","addonId":"112193844"},{"groupId":"133692567","addonId":"112193849"},{"groupId":"133692567","addonId":"112193845"},{"groupId":"133692567","addonId":"112193851"},{"groupId":"133692567","addonId":"112193853"},{"groupId":"151869037","addonId":"112193873"}]},{"variations":[{"groupId":"37266257","variationId":"116400597"},{"groupId":"37266258","variationId":"116400599"}],"price":63900,"addonCombinations":[{"groupId":"133692565","addonId":"112193863"},{"groupId":"133692565","addonId":"112193860"},{"groupId":"133692565","addonId":"112193859"},{"groupId":"133692565","addonId":"115290079"},{"groupId":"133692565","addonId":"112193858"},{"groupId":"133692565","addonId":"112193861"},{"groupId":"151869041","addonId":"117361301"},{"groupId":"133692566","addonId":"112193843"},{"groupId":"133692566","addonId":"112193839"},{"groupId":"133692566","addonId":"112193841"},{"groupId":"133692566","addonId":"112193877"},{"groupId":"133692566","addonId":"112193848"},{"groupId":"133692566","addonId":"112193850"},{"groupId":"133692566","addonId":"112193852"},{"groupId":"133692566","addonId":"112193854"},{"groupId":"133692566","addonId":"112193856"},{"groupId":"133692566","addonId":"112193855"},{"groupId":"133692566","addonId":"112193865"},{"groupId":"133692566","addonId":"112193866"}]},{"variations":[{"groupId":"37266257","variationId":"116400597"},{"groupId":"37266258","variationId":"126057652"}],"price":73800,"addonCombinations":[{"groupId":"133692565","addonId":"112193863"},{"groupId":"133692565","addonId":"112193860"},{"groupId":"133692565","addonId":"112193859"},{"groupId":"133692565","addonId":"115290079"},{"groupId":"133692565","addonId":"112193858"},{"groupId":"133692565","addonId":"112193861"},{"groupId":"151869041","addonId":"117361301"},{"groupId":"133692566","addonId":"112193843"},{"groupId":"133692566","addonId":"112193839"},{"groupId":"133692566","addonId":"112193841"},{"groupId":"133692566","addonId":"112193877"},{"groupId":"133692566","addonId":"112193848"},{"groupId":"133692566","addonId":"112193850"},{"groupId":"133692566","addonId":"112193852"},{"groupId":"133692566","addonId":"112193854"},{"groupId":"133692566","addonId":"112193856"},{"groupId":"133692566","addonId":"112193855"},{"groupId":"133692566","addonId":"112193865"},{"groupId":"133692566","addonId":"112193866"}]},{"variations":[{"groupId":"37266257","variationId":"124962362"},{"groupId":"37266258","variationId":"124962363"}],"price":84900,"addonCombinations":[{"groupId":"133692565","addonId":"112193863"},{"groupId":"133692565","addonId":"112193860"},{"groupId":"133692565","addonId":"112193859"},{"groupId":"133692565","addonId":"115290079"},{"groupId":"133692565","addonId":"112193858"},{"groupId":"133692565","addonId":"112193861"},{"groupId":"151869042","addonId":"114785288"},{"groupId":"140439446","addonId":"114785287"},{"groupId":"140439446","addonId":"114785288"},{"groupId":"140439446","addonId":"114785289"},{"groupId":"140439446","addonId":"114785290"},{"groupId":"140439446","addonId":"114785286"},{"groupId":"140439446","addonId":"114785301"},{"groupId":"140439446","addonId":"114785302"},{"groupId":"140439446","addonId":"114785297"},{"groupId":"140439446","addonId":"114785298"},{"groupId":"140439446","addonId":"114785299"},{"groupId":"140439446","addonId":"114785300"},{"groupId":"140439446","addonId":"114785293"},{"groupId":"140439446","addonId":"114785294"}]}]},"addons":[{"groupId":"151869037","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"151869042","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140439446","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692565","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"133692566","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692567","groupName":"Add. Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193878","name":"Herbed Veggies","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":37900,"ribbon":{},"showImage":true,"offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.7","ratingCount":"8 ratings","ratingCountV2":"8"}}},"analytics":{},"hideRestaurantDetails":true}}],"type":"CATEGORY_TYPE_RECOMMENDED"}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory","title":"Flavour Fun Range.","categories":[{"title":"Combos and Deals","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859635","name":"Create Your Flavour Fun Combo - Box Of 2 - Veg Pizza","category":"Flavour Fun Range.","description":"Serves 2 | Choose any 2 veg personal pizzas from our flavour fun range. For Meals, refer to the nutritional data for individual products.","imageId":"a58a3816c547ed1bc93f44818dd9e882","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266297","name":"Choose your 1st Pizza","variations":[{"name":"Classic Corn","price":109,"id":"116400694","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266298","variationId":"116400702"}},{"name":"Chatpata Tomato Onion & Chilli","price":149,"id":"117298545","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266298","variationId":"116400702"}},{"name":"Cheesy Spicy Delight","price":159,"id":"117298546","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266298","variationId":"116400702"}},{"name":"Chilli Paneer Sizzle","price":179,"id":"117298547","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266298","variationId":"116400702"}},{"name":"Spicy Sweet corn, Onion, Green Chilli","price":139,"id":"117298548","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266298","variationId":"116400702"}},{"name":"Classic Onion Capsicum","price":99,"default":1,"id":"116400695","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266298","variationId":"116400702"}}]},{"groupId":"37266298","name":"Choose your 2nd Pizza","variations":[{"name":"Classic Corn","price":109,"id":"116400701","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Chatpata Tomato Onion & Chilli","price":149,"id":"117298549","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Cheesy Spicy Delight","price":159,"id":"117298550","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Chilli Paneer Sizzle","price":179,"id":"117298551","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Spicy Sweet corn, Onion, Green Chilli","price":139,"id":"117298552","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Classic Onion Capsicum","price":99,"default":1,"id":"116400702","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266297","variationId":"116400694"},{"groupId":"37266298","variationId":"116400701"}],"price":21800},{"variations":[{"groupId":"37266297","variationId":"116400694"},{"groupId":"37266298","variationId":"117298549"}],"price":25800},{"variations":[{"groupId":"37266297","variationId":"116400694"},{"groupId":"37266298","variationId":"117298550"}],"price":26800},{"variations":[{"groupId":"37266297","variationId":"116400694"},{"groupId":"37266298","variationId":"117298551"}],"price":28800},{"variations":[{"groupId":"37266297","variationId":"116400694"},{"groupId":"37266298","variationId":"117298552"}],"price":24800},{"variations":[{"groupId":"37266297","variationId":"116400694"},{"groupId":"37266298","variationId":"116400702"}],"price":20800},{"variations":[{"groupId":"37266297","variationId":"117298545"},{"groupId":"37266298","variationId":"116400701"}],"price":25800},{"variations":[{"groupId":"37266297","variationId":"117298545"},{"groupId":"37266298","variationId":"117298549"}],"price":29800},{"variations":[{"groupId":"37266297","variationId":"117298545"},{"groupId":"37266298","variationId":"117298550"}],"price":30800},{"variations":[{"groupId":"37266297","variationId":"117298545"},{"groupId":"37266298","variationId":"117298551"}],"price":32800},{"variations":[{"groupId":"37266297","variationId":"117298545"},{"groupId":"37266298","variationId":"117298552"}],"price":28800},{"variations":[{"groupId":"37266297","variationId":"117298545"},{"groupId":"37266298","variationId":"116400702"}],"price":24800},{"variations":[{"groupId":"37266297","variationId":"117298546"},{"groupId":"37266298","variationId":"116400701"}],"price":26800},{"variations":[{"groupId":"37266297","variationId":"117298546"},{"groupId":"37266298","variationId":"117298549"}],"price":30800},{"variations":[{"groupId":"37266297","variationId":"117298546"},{"groupId":"37266298","variationId":"117298550"}],"price":31800},{"variations":[{"groupId":"37266297","variationId":"117298546"},{"groupId":"37266298","variationId":"117298551"}],"price":33800},{"variations":[{"groupId":"37266297","variationId":"117298546"},{"groupId":"37266298","variationId":"117298552"}],"price":29800},{"variations":[{"groupId":"37266297","variationId":"117298546"},{"groupId":"37266298","variationId":"116400702"}],"price":25800},{"variations":[{"groupId":"37266297","variationId":"117298547"},{"groupId":"37266298","variationId":"116400701"}],"price":28800},{"variations":[{"groupId":"37266297","variationId":"117298547"},{"groupId":"37266298","variationId":"117298549"}],"price":32800},{"variations":[{"groupId":"37266297","variationId":"117298547"},{"groupId":"37266298","variationId":"117298550"}],"price":33800},{"variations":[{"groupId":"37266297","variationId":"117298547"},{"groupId":"37266298","variationId":"117298551"}],"price":35800},{"variations":[{"groupId":"37266297","variationId":"117298547"},{"groupId":"37266298","variationId":"117298552"}],"price":31800},{"variations":[{"groupId":"37266297","variationId":"117298547"},{"groupId":"37266298","variationId":"116400702"}],"price":27800},{"variations":[{"groupId":"37266297","variationId":"117298548"},{"groupId":"37266298","variationId":"116400701"}],"price":24800},{"variations":[{"groupId":"37266297","variationId":"117298548"},{"groupId":"37266298","variationId":"117298549"}],"price":28800},{"variations":[{"groupId":"37266297","variationId":"117298548"},{"groupId":"37266298","variationId":"117298550"}],"price":29800},{"variations":[{"groupId":"37266297","variationId":"117298548"},{"groupId":"37266298","variationId":"117298551"}],"price":31800},{"variations":[{"groupId":"37266297","variationId":"117298548"},{"groupId":"37266298","variationId":"117298552"}],"price":27800},{"variations":[{"groupId":"37266297","variationId":"117298548"},{"groupId":"37266298","variationId":"116400702"}],"price":23800},{"variations":[{"groupId":"37266297","variationId":"116400695"},{"groupId":"37266298","variationId":"116400701"}],"price":20800},{"variations":[{"groupId":"37266297","variationId":"116400695"},{"groupId":"37266298","variationId":"117298549"}],"price":24800},{"variations":[{"groupId":"37266297","variationId":"116400695"},{"groupId":"37266298","variationId":"117298550"}],"price":25800},{"variations":[{"groupId":"37266297","variationId":"116400695"},{"groupId":"37266298","variationId":"117298551"}],"price":27800},{"variations":[{"groupId":"37266297","variationId":"116400695"},{"groupId":"37266298","variationId":"117298552"}],"price":23800},{"variations":[{"groupId":"37266297","variationId":"116400695"},{"groupId":"37266298","variationId":"116400702"}],"price":19800}]},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 2"},"defaultPrice":19800,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.3","ratingCount":"96 ratings","ratingCountV2":"96"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859632","name":"Create Your Flavour Fun Combo - Box Of 2 - Non Veg Pizza","category":"Flavour Fun Range.","description":"Serves 2 | Choose any 2 non veg personal pizzas from our flavour fun range. For Meals, refer to the nutritional data for individual products.","imageId":"3eb63332d8012c536aaa0f1b2c5fb1ba","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266295","name":"Choose your 1st Pizza","variations":[{"name":"Chatpata Chicken Feast","price":189,"id":"117298553","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266296","variationId":"117298557"}},{"name":"Classic Chicken Pepperoni & Onion","price":149,"default":1,"id":"117298554","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266296","variationId":"117298557"}},{"name":"Classic Herbed Chicken & Capsicum","price":169,"id":"117298555","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266296","variationId":"117298557"}}]},{"groupId":"37266296","name":"Choose your 2nd Pizza","variations":[{"name":"Chatpata Chicken Feast","price":189,"id":"117298556","inStock":1,"isEnabled":1},{"name":"Classic Chicken Pepperoni & Onion","price":149,"default":1,"id":"117298557","inStock":1,"isEnabled":1},{"name":"Classic Herbed Chicken & Capsicum","price":169,"id":"117298558","inStock":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266295","variationId":"117298553"},{"groupId":"37266296","variationId":"117298556"}],"price":37800},{"variations":[{"groupId":"37266295","variationId":"117298553"},{"groupId":"37266296","variationId":"117298557"}],"price":33800},{"variations":[{"groupId":"37266295","variationId":"117298553"},{"groupId":"37266296","variationId":"117298558"}],"price":35800},{"variations":[{"groupId":"37266295","variationId":"117298554"},{"groupId":"37266296","variationId":"117298556"}],"price":33800},{"variations":[{"groupId":"37266295","variationId":"117298554"},{"groupId":"37266296","variationId":"117298557"}],"price":29800},{"variations":[{"groupId":"37266295","variationId":"117298554"},{"groupId":"37266296","variationId":"117298558"}],"price":31800},{"variations":[{"groupId":"37266295","variationId":"117298555"},{"groupId":"37266296","variationId":"117298556"}],"price":35800},{"variations":[{"groupId":"37266295","variationId":"117298555"},{"groupId":"37266296","variationId":"117298557"}],"price":31800},{"variations":[{"groupId":"37266295","variationId":"117298555"},{"groupId":"37266296","variationId":"117298558"}],"price":33800}]},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 2"},"defaultPrice":29800,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"16 ratings","ratingCountV2":"16"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859653","name":"Create Your Flavour Fun Combo - Box Of 4 - Non Veg","category":"Flavour Fun Range.","description":"Get 4 assorted flavor fun personal pizzas. Perfect personal pizza crust topped with exciting new sauces, cheesy dressing & your favorite toppings. For Meals, refer to the nutritional data for individual products.","imageId":"c35b484cdf1cde4831b0a6283768bf43","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344445","name":"Choose your 1st Pizza","variations":[{"name":"Chatpata Chicken Feast","price":166.25,"id":"135514078","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344448","variationId":"135514089"}},{"name":"Classic Chicken Pepperoni & Onion","price":136.25,"default":1,"id":"135514080","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344448","variationId":"135514089"}},{"name":"Classic Herbed Chicken & Capsicum","price":146.25,"id":"135514084","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344448","variationId":"135514089"}}]},{"groupId":"42344448","name":"Choose your 2nd Pizza","variations":[{"name":"Chatpata Chicken Feast","price":166.25,"id":"135514088","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344450","variationId":"135514093"}},{"name":"Classic Chicken Pepperoni & Onion","price":136.25,"default":1,"id":"135514089","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344450","variationId":"135514093"}},{"name":"Classic Herbed Chicken & Capsicum","price":146.25,"id":"135514091","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344450","variationId":"135514093"}}]},{"groupId":"42344450","name":"Choose your 3rd Pizza","variations":[{"name":"Chatpata Chicken Feast","price":166.25,"id":"135514092","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344451","variationId":"135514097"}},{"name":"Classic Chicken Pepperoni & Onion","price":136.25,"default":1,"id":"135514093","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344451","variationId":"135514097"}},{"name":"Classic Herbed Chicken & Capsicum","price":146.25,"id":"135514094","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344451","variationId":"135514097"}}]},{"groupId":"42344451","name":"Choose your 4th Pizza","variations":[{"name":"Chatpata Chicken Feast","price":166.25,"id":"135514095","inStock":1,"isEnabled":1},{"name":"Classic Chicken Pepperoni & Onion","price":136.25,"default":1,"id":"135514097","inStock":1,"isEnabled":1},{"name":"Classic Herbed Chicken & Capsicum","price":146.25,"id":"135514101","inStock":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514095"}],"price":66500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514097"}],"price":63500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514101"}],"price":64500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514095"}],"price":63500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514097"}],"price":60500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514101"}],"price":61500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514095"}],"price":64500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514097"}],"price":61500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514101"}],"price":62500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514095"}],"price":63500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514097"}],"price":60500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514101"}],"price":61500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514095"}],"price":60500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514097"}],"price":57500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514101"}],"price":58500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514095"}],"price":61500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514097"}],"price":58500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514101"}],"price":59500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514095"}],"price":64500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514097"}],"price":61500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514101"}],"price":62500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514095"}],"price":61500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514097"}],"price":58500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514101"}],"price":59500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514095"}],"price":62500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514097"}],"price":59500},{"variations":[{"groupId":"42344445","variationId":"135514078"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514101"}],"price":60500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514095"}],"price":63500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514097"}],"price":60500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514101"}],"price":61500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514095"}],"price":60500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514097"}],"price":57500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514101"}],"price":58500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514095"}],"price":61500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514097"}],"price":58500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514101"}],"price":59500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514095"}],"price":60500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514097"}],"price":57500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514101"}],"price":58500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514095"}],"price":57500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514097"}],"price":54500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514101"}],"price":55500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514095"}],"price":58500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514097"}],"price":55500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514101"}],"price":56500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514095"}],"price":61500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514097"}],"price":58500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514101"}],"price":59500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514095"}],"price":58500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514097"}],"price":55500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514101"}],"price":56500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514095"}],"price":59500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514097"}],"price":56500},{"variations":[{"groupId":"42344445","variationId":"135514080"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514101"}],"price":57500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514095"}],"price":64500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514097"}],"price":61500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514101"}],"price":62500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514095"}],"price":61500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514097"}],"price":58500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514101"}],"price":59500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514095"}],"price":62500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514097"}],"price":59500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514088"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514101"}],"price":60500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514095"}],"price":61500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514097"}],"price":58500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514101"}],"price":59500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514095"}],"price":58500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514097"}],"price":55500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514101"}],"price":56500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514095"}],"price":59500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514097"}],"price":56500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514089"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514101"}],"price":57500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514095"}],"price":62500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514097"}],"price":59500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514092"},{"groupId":"42344451","variationId":"135514101"}],"price":60500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514095"}],"price":59500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514097"}],"price":56500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514093"},{"groupId":"42344451","variationId":"135514101"}],"price":57500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514095"}],"price":60500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514097"}],"price":57500},{"variations":[{"groupId":"42344445","variationId":"135514084"},{"groupId":"42344448","variationId":"135514091"},{"groupId":"42344450","variationId":"135514094"},{"groupId":"42344451","variationId":"135514101"}],"price":58500}]},"itemAttribute":{"vegClassifier":"NONVEG"},"defaultPrice":54500,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859650","name":"Create Your Flavour Fun Combo - Box Of 4 - Veg","category":"Flavour Fun Range.","description":"Get 4 assorted flavor fun personal pizzas. Perfect personal pizza crust topped with exciting new sauces, cheesy dressing & your favorite toppings. For Meals, refer to the nutritional data for individual products.","imageId":"5ab57368f8d7c4c5d546776135fa4f63","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344424","name":"Choose your 1st Pizza","variations":[{"name":"Classic Corn","price":106.25,"default":1,"id":"135513981","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344426","variationId":"135513994"}},{"name":"Chatpata Tomato Onion & Chilli","price":136.25,"id":"135513982","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344426","variationId":"135513994"}},{"name":"Cheesy Spicy Delight","price":146.25,"id":"135513983","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344426","variationId":"135513994"}},{"name":"Chilli Paneer Sizzle","price":156.25,"id":"135513984","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344426","variationId":"135513994"}},{"name":"Spicy Sweet corn, Onion, Green Chilli","price":126.25,"id":"135513985","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344426","variationId":"135513994"}},{"name":"Classic Onion Capsicum","price":106.25,"id":"135513988","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344426","variationId":"135513994"}}]},{"groupId":"42344426","name":"Choose your 2nd Pizza","variations":[{"name":"Classic Corn","price":106.25,"default":1,"id":"135513994","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344429","variationId":"135514008"}},{"name":"Chatpata Tomato Onion & Chilli","price":136.25,"id":"135513997","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344429","variationId":"135514008"}},{"name":"Cheesy Spicy Delight","price":146.25,"id":"135514000","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344429","variationId":"135514008"}},{"name":"Chilli Paneer Sizzle","price":156.25,"id":"135514002","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344429","variationId":"135514008"}},{"name":"Spicy Sweet corn, Onion, Green Chilli","price":126.25,"id":"135514004","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344429","variationId":"135514008"}},{"name":"Classic Onion Capsicum","price":106.25,"id":"135514006","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344429","variationId":"135514008"}}]},{"groupId":"42344429","name":"Choose your 3rd Pizza","variations":[{"name":"Classic Corn","price":106.25,"default":1,"id":"135514008","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344431","variationId":"135514015"}},{"name":"Chatpata Tomato Onion & Chilli","price":136.25,"id":"135514009","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344431","variationId":"135514015"}},{"name":"Cheesy Spicy Delight","price":146.25,"id":"135514010","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344431","variationId":"135514015"}},{"name":"Chilli Paneer Sizzle","price":156.25,"id":"135514011","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344431","variationId":"135514015"}},{"name":"Spicy Sweet corn, Onion, Green Chilli","price":126.25,"id":"135514012","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344431","variationId":"135514015"}},{"name":"Classic Onion Capsicum","price":106.25,"id":"135514013","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344431","variationId":"135514015"}}]},{"groupId":"42344431","name":"Choose your 4th Pizza","variations":[{"name":"Classic Corn","price":106.25,"default":1,"id":"135514015","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Chatpata Tomato Onion & Chilli","price":136.25,"id":"135514017","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Cheesy Spicy Delight","price":146.25,"id":"135514019","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Chilli Paneer Sizzle","price":156.25,"id":"135514022","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Spicy Sweet corn, Onion, Green Chilli","price":126.25,"id":"135514024","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Classic Onion Capsicum","price":106.25,"id":"135514026","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":42500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":42500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":42500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":42500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":42500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":42500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":42500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513981"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":42500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":60500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513982"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":60500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":60500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":60500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":61500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513983"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":60500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":60500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":60500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":61500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":60500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":60500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":61500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":60500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":61500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":62500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513984"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":58500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":59500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513985"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":42500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":42500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":42500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513994"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":42500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135513997"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514000"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":55500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":56500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":57500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514002"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":53500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":54500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514004"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514015"}],"price":42500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514017"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514019"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514022"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514024"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514008"},{"groupId":"42344431","variationId":"135514026"}],"price":42500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514015"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514017"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514019"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514022"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514024"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514009"},{"groupId":"42344431","variationId":"135514026"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514015"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514017"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514019"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514022"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514024"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514010"},{"groupId":"42344431","variationId":"135514026"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514015"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514017"}],"price":50500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514019"}],"price":51500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514022"}],"price":52500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514024"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514011"},{"groupId":"42344431","variationId":"135514026"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514015"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514017"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514019"}],"price":48500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514022"}],"price":49500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514024"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514012"},{"groupId":"42344431","variationId":"135514026"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514015"}],"price":42500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514017"}],"price":45500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514019"}],"price":46500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514022"}],"price":47500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514024"}],"price":44500},{"variations":[{"groupId":"42344424","variationId":"135513988"},{"groupId":"42344426","variationId":"135514006"},{"groupId":"42344429","variationId":"135514013"},{"groupId":"42344431","variationId":"135514026"}],"price":42500}]},"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":42500,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]},{"title":"Veg Pizza","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859656","name":"Classic Corn","category":"Flavour Fun Range.","description":"Serves 1 | Personal pizza topped with our classic pan sauce, sweet corn and cheesy dressing. An all-time favorite (319 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"aed52ab0d028996e060b772f11ff31d8","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266317","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400783","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266318","variationId":"116400787"}}]},{"groupId":"37266318","name":"Choose your Crust","variations":[{"name":"Pan","price":109,"default":1,"id":"116400787","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266317","variationId":"116400783"},{"groupId":"37266318","variationId":"116400787"}],"price":10900,"addonCombinations":[{"groupId":"133692615","addonId":"112193863"},{"groupId":"133692615","addonId":"112193860"},{"groupId":"133692615","addonId":"112193859"},{"groupId":"133692615","addonId":"115290079"},{"groupId":"133692615","addonId":"112193858"},{"groupId":"133692615","addonId":"112193861"}]}]},"addons":[{"groupId":"133692615","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":10900,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"33 ratings","ratingCountV2":"33"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859658","name":"Classic Onion Capsicum","category":"Flavour Fun Range.","description":"Serves 1 | Personal pizza topped with our classic pan sauce, crunchy onion & capsicum and cheesy dressing (307 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"ed6a84173f69cdd4f676e94c2332c5e7","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266321","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400794","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266322","variationId":"116400795"}}]},{"groupId":"37266322","name":"Choose your Crust","variations":[{"name":"Pan","price":99,"default":1,"id":"116400795","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266321","variationId":"116400794"},{"groupId":"37266322","variationId":"116400795"}],"price":9900,"addonCombinations":[{"groupId":"133692619","addonId":"112193863"},{"groupId":"133692619","addonId":"112193860"},{"groupId":"133692619","addonId":"112193859"},{"groupId":"133692619","addonId":"115290079"},{"groupId":"133692619","addonId":"112193858"},{"groupId":"133692619","addonId":"112193861"}]}]},"addons":[{"groupId":"133692619","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":9900,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.6","ratingCount":"23 ratings","ratingCountV2":"23"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"133116149","name":"Chilli Paneer Sizzle","category":"Flavour Fun Range.","description":"Pizza topped with spiced paneer, a spicy schezwan sauce, juicy tomato, crunchy onion & capsicum and cheesy dressing (298 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"fc2d0de600d6649eaea5ca50d84ab5ec","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37483143","name":"Size","variations":[{"name":"Personal","default":1,"id":"117298894","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37483144","variationId":"117298895"}}]},{"groupId":"37483144","name":"Choose your Crust","variations":[{"name":"Pan","price":179,"default":1,"id":"117298895","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37483143","variationId":"117298894"},{"groupId":"37483144","variationId":"117298895"}],"price":17900}]},"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":17900,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.5","ratingCount":"8 ratings","ratingCountV2":"8"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"133116146","name":"Cheesy Spicy Delight","category":"Flavour Fun Range.","description":"Pizza topped 100% mozzarella cheese, cheesy dressing for thst extraaa cheesy flavour, onion and spicy green chilli, sprinkled with our signature spiced seasoning (367 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"2d16764980d14b46323559a539f77910","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37483137","name":"Size","variations":[{"name":"Personal","default":1,"id":"117298888","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37483138","variationId":"117298889"}}]},{"groupId":"37483138","name":"Choose your Crust","variations":[{"name":"Pan","price":159,"default":1,"id":"117298889","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37483137","variationId":"117298888"},{"groupId":"37483138","variationId":"117298889"}],"price":15900}]},"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":15900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"5 ratings","ratingCountV2":"5"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"133116147","name":"Spicy Sweet Corn, Onion, Green Chilli","category":"Flavour Fun Range.","description":"Pizza topped with a spicy tandoori sauce, juicy sweet corn, crunchy onion & spicy green chilli and cheesy dressing (327 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"04b1310428ad6814cf48e3544e4fd00e","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37483139","name":"Size","variations":[{"name":"Personal","default":1,"id":"117298890","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37483140","variationId":"117298891"}}]},{"groupId":"37483140","name":"Choose your Crust","variations":[{"name":"Pan","price":139,"default":1,"id":"117298891","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37483139","variationId":"117298890"},{"groupId":"37483140","variationId":"117298891"}],"price":13900}]},"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":13900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"133116148","name":"Chatpata Tomato Onion & Chilli","category":"Flavour Fun Range.","description":"Pizza topped with a spicy tandoori sauce, juicy tomato, crunchy onion & green chilli for an extra zing and cheesy dressing (328 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"3b229da1719952a564c2bf297bb731b3","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37483141","name":"Size","variations":[{"name":"Personal","default":1,"id":"117298892","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37483142","variationId":"117298893"}}]},{"groupId":"37483142","name":"Choose your Crust","variations":[{"name":"Pan","price":149,"default":1,"id":"117298893","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37483141","variationId":"117298892"},{"groupId":"37483142","variationId":"117298893"}],"price":14900}]},"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":14900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]},{"title":"Non-Veg Pizza","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"133116151","name":"Classic Chicken Pepperoni & Onion","category":"Flavour Fun Range.","description":"Pizza topped with our classic signature pan sauce, chicken pepperoni, crunchy onion and cheesy dressing (332 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"e35bac2a83cd54e364af7b62305da271","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37483147","name":"Size","variations":[{"name":"Personal","default":1,"id":"117298898","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37483148","variationId":"117298899"}}]},{"groupId":"37483148","name":"Choose your Crust","variations":[{"name":"Pan","price":149,"default":1,"id":"117298899","inStock":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37483147","variationId":"117298898"},{"groupId":"37483148","variationId":"117298899"}],"price":14900}]},"itemAttribute":{"vegClassifier":"NONVEG"},"defaultPrice":14900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.6","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"133116150","name":"Chatpata Chicken Feast","category":"Flavour Fun Range.","description":"Pizza topped with a spicy tandoori sauce, schezwan chicken meatballs, crunchy onion & capsisum, green chilli, juicy tomato and cheesy dressing (294 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"ca7df89f4cbf23526d4a440eb6ad2be3","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37483145","name":"Size","variations":[{"name":"Personal","default":1,"id":"117298896","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37483146","variationId":"117298897"}}]},{"groupId":"37483146","name":"Choose your Crust","variations":[{"name":"Pan","price":189,"default":1,"id":"117298897","inStock":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37483145","variationId":"117298896"},{"groupId":"37483146","variationId":"117298897"}],"price":18900}]},"itemAttribute":{"vegClassifier":"NONVEG"},"defaultPrice":18900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.3","ratingCount":"5 ratings","ratingCountV2":"5"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"133116152","name":"Classic Herbed Chicken & Capsicum","category":"Flavour Fun Range.","description":"Pizza topped with our classic signature pan sauce, herbed chicken, crunchy capsicum and cheesy dressing (331 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"1dd1e4c79a90aa5e70e2fa44493b8c6e","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37483149","name":"Size","variations":[{"name":"Personal","default":1,"id":"117298900","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37483150","variationId":"117298901"}}]},{"groupId":"37483150","name":"Choose your Crust","variations":[{"name":"Pan","price":169,"default":1,"id":"117298901","inStock":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37483149","variationId":"117298900"},{"groupId":"37483150","variationId":"117298901"}],"price":16900}]},"itemAttribute":{"vegClassifier":"NONVEG"},"defaultPrice":16900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Veg Pizza","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859609","name":"Margherita Pizza","category":"Veg Pizza","description":"Serves 1 | Pizza topped with our herb-infused signature pan sauce and 100% mozzarella cheese. A classic treat for all cheese lovers out there! (292 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"dpventcrozvfni0lqb10","inStock":1,"isVeg":1,"price":16900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"3.8","ratingCount":"55 ratings","ratingCountV2":"55"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859589","name":"Margherita","category":"Veg Pizza","description":"Pizza topped with our herb-infused signature pan sauce and 100% mozzarella cheese. A classic treat for all cheese lovers out there! (PAN Per/Med-292 Kcal/100g | TnC-293 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"dpventcrozvfni0lqb10","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266243","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400554","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266244","variationId":"116400556"}},{"name":"Medium","id":"116400555","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266244","variationId":"116400557"}},{"name":"Thin n Large","id":"124962348","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266244","variationId":"124962349"}}]},{"groupId":"37266244","name":"Choose your Crust","variations":[{"name":"Pan","price":169,"default":1,"id":"116400556","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Pan","price":329,"id":"116400557","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Thin n Crispy","price":479,"id":"124962349","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":244,"id":"126057679","isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":428,"id":"126057680","isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266243","variationId":"116400554"},{"groupId":"37266244","variationId":"116400556"}],"price":16900,"addonCombinations":[{"groupId":"133692544","addonId":"112193863"},{"groupId":"133692544","addonId":"112193860"},{"groupId":"133692544","addonId":"112193859"},{"groupId":"133692544","addonId":"115290079"},{"groupId":"133692544","addonId":"112193858"},{"groupId":"133692544","addonId":"112193861"},{"groupId":"133692546","addonId":"112193873"},{"groupId":"133692546","addonId":"112193870"},{"groupId":"133692546","addonId":"112193872"},{"groupId":"133692546","addonId":"112193878"},{"groupId":"133692546","addonId":"112193838"},{"groupId":"133692546","addonId":"112193840"},{"groupId":"133692546","addonId":"112193842"},{"groupId":"133692546","addonId":"112193844"},{"groupId":"133692546","addonId":"112193849"},{"groupId":"133692546","addonId":"112193845"},{"groupId":"133692546","addonId":"112193851"},{"groupId":"133692546","addonId":"112193853"},{"groupId":"151869389","addonId":"112193873"}]},{"variations":[{"groupId":"37266243","variationId":"116400554"},{"groupId":"37266244","variationId":"126057679"}],"price":24400,"addonCombinations":[{"groupId":"133692544","addonId":"112193863"},{"groupId":"133692544","addonId":"112193860"},{"groupId":"133692544","addonId":"112193859"},{"groupId":"133692544","addonId":"115290079"},{"groupId":"133692544","addonId":"112193858"},{"groupId":"133692544","addonId":"112193861"},{"groupId":"133692546","addonId":"112193873"},{"groupId":"133692546","addonId":"112193870"},{"groupId":"133692546","addonId":"112193872"},{"groupId":"133692546","addonId":"112193878"},{"groupId":"133692546","addonId":"112193838"},{"groupId":"133692546","addonId":"112193840"},{"groupId":"133692546","addonId":"112193842"},{"groupId":"133692546","addonId":"112193844"},{"groupId":"133692546","addonId":"112193849"},{"groupId":"133692546","addonId":"112193845"},{"groupId":"133692546","addonId":"112193851"},{"groupId":"133692546","addonId":"112193853"},{"groupId":"151869389","addonId":"112193873"}]},{"variations":[{"groupId":"37266243","variationId":"116400555"},{"groupId":"37266244","variationId":"116400557"}],"price":32900,"addonCombinations":[{"groupId":"133692544","addonId":"112193863"},{"groupId":"133692544","addonId":"112193860"},{"groupId":"133692544","addonId":"112193859"},{"groupId":"133692544","addonId":"115290079"},{"groupId":"133692544","addonId":"112193858"},{"groupId":"133692544","addonId":"112193861"},{"groupId":"151869396","addonId":"117361301"},{"groupId":"133692545","addonId":"112193843"},{"groupId":"133692545","addonId":"112193839"},{"groupId":"133692545","addonId":"112193841"},{"groupId":"133692545","addonId":"112193877"},{"groupId":"133692545","addonId":"112193848"},{"groupId":"133692545","addonId":"112193850"},{"groupId":"133692545","addonId":"112193852"},{"groupId":"133692545","addonId":"112193854"},{"groupId":"133692545","addonId":"112193856"},{"groupId":"133692545","addonId":"112193855"},{"groupId":"133692545","addonId":"112193865"},{"groupId":"133692545","addonId":"112193866"}]},{"variations":[{"groupId":"37266243","variationId":"116400555"},{"groupId":"37266244","variationId":"126057680"}],"price":42800,"addonCombinations":[{"groupId":"133692544","addonId":"112193863"},{"groupId":"133692544","addonId":"112193860"},{"groupId":"133692544","addonId":"112193859"},{"groupId":"133692544","addonId":"115290079"},{"groupId":"133692544","addonId":"112193858"},{"groupId":"133692544","addonId":"112193861"},{"groupId":"151869396","addonId":"117361301"},{"groupId":"133692545","addonId":"112193843"},{"groupId":"133692545","addonId":"112193839"},{"groupId":"133692545","addonId":"112193841"},{"groupId":"133692545","addonId":"112193877"},{"groupId":"133692545","addonId":"112193848"},{"groupId":"133692545","addonId":"112193850"},{"groupId":"133692545","addonId":"112193852"},{"groupId":"133692545","addonId":"112193854"},{"groupId":"133692545","addonId":"112193856"},{"groupId":"133692545","addonId":"112193855"},{"groupId":"133692545","addonId":"112193865"},{"groupId":"133692545","addonId":"112193866"}]},{"variations":[{"groupId":"37266243","variationId":"124962348"},{"groupId":"37266244","variationId":"124962349"}],"price":47900,"addonCombinations":[{"groupId":"133692544","addonId":"112193863"},{"groupId":"133692544","addonId":"112193860"},{"groupId":"133692544","addonId":"112193859"},{"groupId":"133692544","addonId":"115290079"},{"groupId":"133692544","addonId":"112193858"},{"groupId":"133692544","addonId":"112193861"},{"groupId":"151869399","addonId":"114785288"},{"groupId":"140439439","addonId":"114785287"},{"groupId":"140439439","addonId":"114785288"},{"groupId":"140439439","addonId":"114785289"},{"groupId":"140439439","addonId":"114785290"},{"groupId":"140439439","addonId":"114785286"},{"groupId":"140439439","addonId":"114785301"},{"groupId":"140439439","addonId":"114785302"},{"groupId":"140439439","addonId":"114785297"},{"groupId":"140439439","addonId":"114785298"},{"groupId":"140439439","addonId":"114785299"},{"groupId":"140439439","addonId":"114785300"},{"groupId":"140439439","addonId":"114785293"},{"groupId":"140439439","addonId":"114785294"}]}]},"addons":[{"groupId":"151869389","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"151869399","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140439439","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692544","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"133692545","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692546","groupName":"Add. Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193878","name":"Herbed Veggies","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":16900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"11 ratings","ratingCountV2":"11"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859593","name":"Tandoori Paneer","category":"Veg Pizza","description":"Serves 1 | It\'s our signature. Spiced paneer, crunchy onions & green capsicum, spicy red paprika with delicious tandoori sauce and 100% mozzarella cheese! (PAN Per/Med-335 Kcal/100g | TnC-326 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"s5ld93rsknx0fhj6xarn","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266251","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400578","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266252","variationId":"116400580"}},{"name":"Medium","id":"116400579","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266252","variationId":"116400581"}},{"name":"Thin n Large","id":"124962356","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266252","variationId":"124962357"}}]},{"groupId":"37266252","name":"Choose your Crust","variations":[{"name":"Pan","price":319,"default":1,"id":"116400580","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Pan","price":569,"id":"116400581","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Thin n Crispy","price":749,"id":"124962357","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":394,"id":"126057569","isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":668,"id":"126057570","isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266251","variationId":"116400578"},{"groupId":"37266252","variationId":"116400580"}],"price":31900,"addonCombinations":[{"groupId":"133692556","addonId":"112193863"},{"groupId":"133692556","addonId":"112193860"},{"groupId":"133692556","addonId":"112193859"},{"groupId":"133692556","addonId":"115290079"},{"groupId":"133692556","addonId":"112193858"},{"groupId":"133692556","addonId":"112193861"},{"groupId":"133692558","addonId":"112193873"},{"groupId":"133692558","addonId":"112193870"},{"groupId":"133692558","addonId":"112193872"},{"groupId":"133692558","addonId":"112193878"},{"groupId":"133692558","addonId":"112193838"},{"groupId":"133692558","addonId":"112193840"},{"groupId":"133692558","addonId":"112193842"},{"groupId":"133692558","addonId":"112193844"},{"groupId":"133692558","addonId":"112193849"},{"groupId":"133692558","addonId":"112193845"},{"groupId":"133692558","addonId":"112193851"},{"groupId":"133692558","addonId":"112193853"},{"groupId":"151869110","addonId":"112193873"}]},{"variations":[{"groupId":"37266251","variationId":"116400578"},{"groupId":"37266252","variationId":"126057569"}],"price":39400,"addonCombinations":[{"groupId":"133692556","addonId":"112193863"},{"groupId":"133692556","addonId":"112193860"},{"groupId":"133692556","addonId":"112193859"},{"groupId":"133692556","addonId":"115290079"},{"groupId":"133692556","addonId":"112193858"},{"groupId":"133692556","addonId":"112193861"},{"groupId":"133692558","addonId":"112193873"},{"groupId":"133692558","addonId":"112193870"},{"groupId":"133692558","addonId":"112193872"},{"groupId":"133692558","addonId":"112193878"},{"groupId":"133692558","addonId":"112193838"},{"groupId":"133692558","addonId":"112193840"},{"groupId":"133692558","addonId":"112193842"},{"groupId":"133692558","addonId":"112193844"},{"groupId":"133692558","addonId":"112193849"},{"groupId":"133692558","addonId":"112193845"},{"groupId":"133692558","addonId":"112193851"},{"groupId":"133692558","addonId":"112193853"},{"groupId":"151869110","addonId":"112193873"}]},{"variations":[{"groupId":"37266251","variationId":"116400579"},{"groupId":"37266252","variationId":"116400581"}],"price":56900,"addonCombinations":[{"groupId":"133692556","addonId":"112193863"},{"groupId":"133692556","addonId":"112193860"},{"groupId":"133692556","addonId":"112193859"},{"groupId":"133692556","addonId":"115290079"},{"groupId":"133692556","addonId":"112193858"},{"groupId":"133692556","addonId":"112193861"},{"groupId":"151869111","addonId":"117361301"},{"groupId":"133692557","addonId":"112193843"},{"groupId":"133692557","addonId":"112193839"},{"groupId":"133692557","addonId":"112193841"},{"groupId":"133692557","addonId":"112193877"},{"groupId":"133692557","addonId":"112193848"},{"groupId":"133692557","addonId":"112193850"},{"groupId":"133692557","addonId":"112193852"},{"groupId":"133692557","addonId":"112193854"},{"groupId":"133692557","addonId":"112193856"},{"groupId":"133692557","addonId":"112193855"},{"groupId":"133692557","addonId":"112193865"},{"groupId":"133692557","addonId":"112193866"}]},{"variations":[{"groupId":"37266251","variationId":"116400579"},{"groupId":"37266252","variationId":"126057570"}],"price":66800,"addonCombinations":[{"groupId":"133692556","addonId":"112193863"},{"groupId":"133692556","addonId":"112193860"},{"groupId":"133692556","addonId":"112193859"},{"groupId":"133692556","addonId":"115290079"},{"groupId":"133692556","addonId":"112193858"},{"groupId":"133692556","addonId":"112193861"},{"groupId":"151869111","addonId":"117361301"},{"groupId":"133692557","addonId":"112193843"},{"groupId":"133692557","addonId":"112193839"},{"groupId":"133692557","addonId":"112193841"},{"groupId":"133692557","addonId":"112193877"},{"groupId":"133692557","addonId":"112193848"},{"groupId":"133692557","addonId":"112193850"},{"groupId":"133692557","addonId":"112193852"},{"groupId":"133692557","addonId":"112193854"},{"groupId":"133692557","addonId":"112193856"},{"groupId":"133692557","addonId":"112193855"},{"groupId":"133692557","addonId":"112193865"},{"groupId":"133692557","addonId":"112193866"}]},{"variations":[{"groupId":"37266251","variationId":"124962356"},{"groupId":"37266252","variationId":"124962357"}],"price":74900,"addonCombinations":[{"groupId":"133692556","addonId":"112193863"},{"groupId":"133692556","addonId":"112193860"},{"groupId":"133692556","addonId":"112193859"},{"groupId":"133692556","addonId":"115290079"},{"groupId":"133692556","addonId":"112193858"},{"groupId":"133692556","addonId":"112193861"},{"groupId":"151869112","addonId":"114785288"},{"groupId":"140439443","addonId":"114785287"},{"groupId":"140439443","addonId":"114785288"},{"groupId":"140439443","addonId":"114785289"},{"groupId":"140439443","addonId":"114785290"},{"groupId":"140439443","addonId":"114785286"},{"groupId":"140439443","addonId":"114785301"},{"groupId":"140439443","addonId":"114785302"},{"groupId":"140439443","addonId":"114785297"},{"groupId":"140439443","addonId":"114785298"},{"groupId":"140439443","addonId":"114785299"},{"groupId":"140439443","addonId":"114785300"},{"groupId":"140439443","addonId":"114785293"},{"groupId":"140439443","addonId":"114785294"}]}]},"addons":[{"groupId":"151869110","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"151869112","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140439443","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692556","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"133692557","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692558","groupName":"Add. Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193878","name":"Herbed Veggies","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":31900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.7","ratingCount":"13 ratings","ratingCountV2":"13"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859709","name":"Mexican Fiesta","category":"Veg Pizza","description":"Serves 1 | Flavourful mix of red capsicum, green capsicum, jalapeno, onion, black olives, sweet corn and 100% mozzarella cheese with a signature spice sprinkle & our flavourful pan sauce (PAN Per/Med-266 Kcal/100g | TnC-258 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"0c4c12819d98a35144e3f08451ae64f3","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266399","name":"Size","variations":[{"name":"Personal","default":1,"id":"116401086","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266401","variationId":"116401089"}},{"name":"Medium","id":"116401087","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266401","variationId":"116401091"}},{"name":"Thin n Large","id":"124962408","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266401","variationId":"124962409"}}]},{"groupId":"37266401","name":"Choose your Crust","variations":[{"name":"Pan","price":319,"default":1,"id":"116401089","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Pan","price":569,"id":"116401091","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Thin n Crispy","price":749,"id":"124962409","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":394,"id":"126057975","isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":668,"id":"126057978","isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266399","variationId":"116401086"},{"groupId":"37266401","variationId":"116401089"}],"price":31900,"addonCombinations":[{"groupId":"133692677","addonId":"112193863"},{"groupId":"133692677","addonId":"112193860"},{"groupId":"133692677","addonId":"112193859"},{"groupId":"133692677","addonId":"115290079"},{"groupId":"133692677","addonId":"112193858"},{"groupId":"133692677","addonId":"112193861"},{"groupId":"133692680","addonId":"112193873"},{"groupId":"133692680","addonId":"112193870"},{"groupId":"133692680","addonId":"112193872"},{"groupId":"133692680","addonId":"112193878"},{"groupId":"133692680","addonId":"112193838"},{"groupId":"133692680","addonId":"112193840"},{"groupId":"133692680","addonId":"112193842"},{"groupId":"133692680","addonId":"112193844"},{"groupId":"133692680","addonId":"112193849"},{"groupId":"133692680","addonId":"112193845"},{"groupId":"133692680","addonId":"112193851"},{"groupId":"133692680","addonId":"112193853"},{"groupId":"150927359","addonId":"112193873"}]},{"variations":[{"groupId":"37266399","variationId":"116401086"},{"groupId":"37266401","variationId":"126057975"}],"price":39400,"addonCombinations":[{"groupId":"133692677","addonId":"112193863"},{"groupId":"133692677","addonId":"112193860"},{"groupId":"133692677","addonId":"112193859"},{"groupId":"133692677","addonId":"115290079"},{"groupId":"133692677","addonId":"112193858"},{"groupId":"133692677","addonId":"112193861"},{"groupId":"133692680","addonId":"112193873"},{"groupId":"133692680","addonId":"112193870"},{"groupId":"133692680","addonId":"112193872"},{"groupId":"133692680","addonId":"112193878"},{"groupId":"133692680","addonId":"112193838"},{"groupId":"133692680","addonId":"112193840"},{"groupId":"133692680","addonId":"112193842"},{"groupId":"133692680","addonId":"112193844"},{"groupId":"133692680","addonId":"112193849"},{"groupId":"133692680","addonId":"112193845"},{"groupId":"133692680","addonId":"112193851"},{"groupId":"133692680","addonId":"112193853"},{"groupId":"150927359","addonId":"112193873"}]},{"variations":[{"groupId":"37266399","variationId":"116401087"},{"groupId":"37266401","variationId":"116401091"}],"price":56900,"addonCombinations":[{"groupId":"133692677","addonId":"112193863"},{"groupId":"133692677","addonId":"112193860"},{"groupId":"133692677","addonId":"112193859"},{"groupId":"133692677","addonId":"115290079"},{"groupId":"133692677","addonId":"112193858"},{"groupId":"133692677","addonId":"112193861"},{"groupId":"150927360","addonId":"117361301"},{"groupId":"133692679","addonId":"112193843"},{"groupId":"133692679","addonId":"112193839"},{"groupId":"133692679","addonId":"112193841"},{"groupId":"133692679","addonId":"112193877"},{"groupId":"133692679","addonId":"112193848"},{"groupId":"133692679","addonId":"112193850"},{"groupId":"133692679","addonId":"112193852"},{"groupId":"133692679","addonId":"112193854"},{"groupId":"133692679","addonId":"112193856"},{"groupId":"133692679","addonId":"112193855"},{"groupId":"133692679","addonId":"112193865"},{"groupId":"133692679","addonId":"112193866"}]},{"variations":[{"groupId":"37266399","variationId":"116401087"},{"groupId":"37266401","variationId":"126057978"}],"price":66800,"addonCombinations":[{"groupId":"133692677","addonId":"112193863"},{"groupId":"133692677","addonId":"112193860"},{"groupId":"133692677","addonId":"112193859"},{"groupId":"133692677","addonId":"115290079"},{"groupId":"133692677","addonId":"112193858"},{"groupId":"133692677","addonId":"112193861"},{"groupId":"150927360","addonId":"117361301"},{"groupId":"133692679","addonId":"112193843"},{"groupId":"133692679","addonId":"112193839"},{"groupId":"133692679","addonId":"112193841"},{"groupId":"133692679","addonId":"112193877"},{"groupId":"133692679","addonId":"112193848"},{"groupId":"133692679","addonId":"112193850"},{"groupId":"133692679","addonId":"112193852"},{"groupId":"133692679","addonId":"112193854"},{"groupId":"133692679","addonId":"112193856"},{"groupId":"133692679","addonId":"112193855"},{"groupId":"133692679","addonId":"112193865"},{"groupId":"133692679","addonId":"112193866"}]},{"variations":[{"groupId":"37266399","variationId":"124962408"},{"groupId":"37266401","variationId":"124962409"}],"price":74900,"addonCombinations":[{"groupId":"133692677","addonId":"112193863"},{"groupId":"133692677","addonId":"112193860"},{"groupId":"133692677","addonId":"112193859"},{"groupId":"133692677","addonId":"115290079"},{"groupId":"133692677","addonId":"112193858"},{"groupId":"133692677","addonId":"112193861"},{"groupId":"150927361","addonId":"114785288"},{"groupId":"140439470","addonId":"114785287"},{"groupId":"140439470","addonId":"114785288"},{"groupId":"140439470","addonId":"114785289"},{"groupId":"140439470","addonId":"114785290"},{"groupId":"140439470","addonId":"114785286"},{"groupId":"140439470","addonId":"114785301"},{"groupId":"140439470","addonId":"114785302"},{"groupId":"140439470","addonId":"114785297"},{"groupId":"140439470","addonId":"114785298"},{"groupId":"140439470","addonId":"114785299"},{"groupId":"140439470","addonId":"114785300"},{"groupId":"140439470","addonId":"114785293"},{"groupId":"140439470","addonId":"114785294"}]}]},"addons":[{"groupId":"150927359","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"150927361","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140439470","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692677","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"133692679","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692680","groupName":"Add. Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193878","name":"Herbed Veggies","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":31900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"5 ratings","ratingCountV2":"5"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859698","name":"Mazedar Makhni Paneer","category":"Veg Pizza","description":"Serves 1 | A treat for all makhni lovers. Spiced paneer, onion, juicy red bell peppers with our new flavourful makhni sauce, topped with 100% mozzarella cheese and buttery spice sprinkle (PAN Per/Med-288 Kcal/100g | TnC-290 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"bf62afee565475fb92a204206321a41c","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266377","name":"Size","variations":[{"name":"Personal","default":1,"id":"116401050","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266378","variationId":"116401052"}},{"name":"Medium","id":"116401051","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266378","variationId":"116401053"}},{"name":"Thin n Large","id":"124962400","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266378","variationId":"124962401"}}]},{"groupId":"37266378","name":"Choose your Crust","variations":[{"name":"Pan","price":379,"default":1,"id":"116401052","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Pan","price":639,"id":"116401053","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Thin n Crispy","price":849,"id":"124962401","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":454,"id":"126057723","isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":738,"id":"126057724","isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266377","variationId":"116401050"},{"groupId":"37266378","variationId":"116401052"}],"price":37900,"addonCombinations":[{"groupId":"133692660","addonId":"112193863"},{"groupId":"133692660","addonId":"112193860"},{"groupId":"133692660","addonId":"112193859"},{"groupId":"133692660","addonId":"115290079"},{"groupId":"133692660","addonId":"112193858"},{"groupId":"133692660","addonId":"112193861"},{"groupId":"133692663","addonId":"112193873"},{"groupId":"133692663","addonId":"112193870"},{"groupId":"133692663","addonId":"112193872"},{"groupId":"133692663","addonId":"112193878"},{"groupId":"133692663","addonId":"112193838"},{"groupId":"133692663","addonId":"112193840"},{"groupId":"133692663","addonId":"112193842"},{"groupId":"133692663","addonId":"112193844"},{"groupId":"133692663","addonId":"112193849"},{"groupId":"133692663","addonId":"112193845"},{"groupId":"133692663","addonId":"112193851"},{"groupId":"133692663","addonId":"112193853"},{"groupId":"151868772","addonId":"112193873"}]},{"variations":[{"groupId":"37266377","variationId":"116401050"},{"groupId":"37266378","variationId":"126057723"}],"price":45400,"addonCombinations":[{"groupId":"133692660","addonId":"112193863"},{"groupId":"133692660","addonId":"112193860"},{"groupId":"133692660","addonId":"112193859"},{"groupId":"133692660","addonId":"115290079"},{"groupId":"133692660","addonId":"112193858"},{"groupId":"133692660","addonId":"112193861"},{"groupId":"133692663","addonId":"112193873"},{"groupId":"133692663","addonId":"112193870"},{"groupId":"133692663","addonId":"112193872"},{"groupId":"133692663","addonId":"112193878"},{"groupId":"133692663","addonId":"112193838"},{"groupId":"133692663","addonId":"112193840"},{"groupId":"133692663","addonId":"112193842"},{"groupId":"133692663","addonId":"112193844"},{"groupId":"133692663","addonId":"112193849"},{"groupId":"133692663","addonId":"112193845"},{"groupId":"133692663","addonId":"112193851"},{"groupId":"133692663","addonId":"112193853"},{"groupId":"151868772","addonId":"112193873"}]},{"variations":[{"groupId":"37266377","variationId":"116401051"},{"groupId":"37266378","variationId":"116401053"}],"price":63900,"addonCombinations":[{"groupId":"133692660","addonId":"112193863"},{"groupId":"133692660","addonId":"112193860"},{"groupId":"133692660","addonId":"112193859"},{"groupId":"133692660","addonId":"115290079"},{"groupId":"133692660","addonId":"112193858"},{"groupId":"133692660","addonId":"112193861"},{"groupId":"151868778","addonId":"117361301"},{"groupId":"133692661","addonId":"112193843"},{"groupId":"133692661","addonId":"112193839"},{"groupId":"133692661","addonId":"112193841"},{"groupId":"133692661","addonId":"112193877"},{"groupId":"133692661","addonId":"112193848"},{"groupId":"133692661","addonId":"112193850"},{"groupId":"133692661","addonId":"112193852"},{"groupId":"133692661","addonId":"112193854"},{"groupId":"133692661","addonId":"112193856"},{"groupId":"133692661","addonId":"112193855"},{"groupId":"133692661","addonId":"112193865"},{"groupId":"133692661","addonId":"112193866"}]},{"variations":[{"groupId":"37266377","variationId":"116401051"},{"groupId":"37266378","variationId":"126057724"}],"price":73800,"addonCombinations":[{"groupId":"133692660","addonId":"112193863"},{"groupId":"133692660","addonId":"112193860"},{"groupId":"133692660","addonId":"112193859"},{"groupId":"133692660","addonId":"115290079"},{"groupId":"133692660","addonId":"112193858"},{"groupId":"133692660","addonId":"112193861"},{"groupId":"151868778","addonId":"117361301"},{"groupId":"133692661","addonId":"112193843"},{"groupId":"133692661","addonId":"112193839"},{"groupId":"133692661","addonId":"112193841"},{"groupId":"133692661","addonId":"112193877"},{"groupId":"133692661","addonId":"112193848"},{"groupId":"133692661","addonId":"112193850"},{"groupId":"133692661","addonId":"112193852"},{"groupId":"133692661","addonId":"112193854"},{"groupId":"133692661","addonId":"112193856"},{"groupId":"133692661","addonId":"112193855"},{"groupId":"133692661","addonId":"112193865"},{"groupId":"133692661","addonId":"112193866"}]},{"variations":[{"groupId":"37266377","variationId":"124962400"},{"groupId":"37266378","variationId":"124962401"}],"price":84900,"addonCombinations":[{"groupId":"133692660","addonId":"112193863"},{"groupId":"133692660","addonId":"112193860"},{"groupId":"133692660","addonId":"112193859"},{"groupId":"133692660","addonId":"115290079"},{"groupId":"133692660","addonId":"112193858"},{"groupId":"133692660","addonId":"112193861"},{"groupId":"151868780","addonId":"114785288"},{"groupId":"140439465","addonId":"114785287"},{"groupId":"140439465","addonId":"114785288"},{"groupId":"140439465","addonId":"114785289"},{"groupId":"140439465","addonId":"114785290"},{"groupId":"140439465","addonId":"114785286"},{"groupId":"140439465","addonId":"114785301"},{"groupId":"140439465","addonId":"114785302"},{"groupId":"140439465","addonId":"114785297"},{"groupId":"140439465","addonId":"114785298"},{"groupId":"140439465","addonId":"114785299"},{"groupId":"140439465","addonId":"114785300"},{"groupId":"140439465","addonId":"114785293"},{"groupId":"140439465","addonId":"114785294"}]}]},"addons":[{"groupId":"151868772","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"151868780","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140439465","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692660","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"133692661","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692663","groupName":"Add. Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193878","name":"Herbed Veggies","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":37900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859596","name":"Veggie Supreme","category":"Veg Pizza","description":"Serves 1 | A supreme combination of black olives, green capsicum, mushroom, onion, spicy red paprika & juicy sweet corn with flavourful pan sauce and 100% mozzarella cheese. (PAN Per/Med-254 Kcal/100g | TnC-258 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"z0c4xpovma1qtmu4tlls","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266257","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400596","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266258","variationId":"116400598"}},{"name":"Medium","id":"116400597","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266258","variationId":"116400599"}},{"name":"Thin n Large","id":"124962362","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266258","variationId":"124962363"}}]},{"groupId":"37266258","name":"Choose your Crust","variations":[{"name":"Pan","price":379,"default":1,"id":"116400598","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Pan","price":639,"id":"116400599","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Thin n Crispy","price":849,"id":"124962363","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":454,"id":"126057651","isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":738,"id":"126057652","isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266257","variationId":"116400596"},{"groupId":"37266258","variationId":"116400598"}],"price":37900,"addonCombinations":[{"groupId":"133692565","addonId":"112193863"},{"groupId":"133692565","addonId":"112193860"},{"groupId":"133692565","addonId":"112193859"},{"groupId":"133692565","addonId":"115290079"},{"groupId":"133692565","addonId":"112193858"},{"groupId":"133692565","addonId":"112193861"},{"groupId":"133692567","addonId":"112193873"},{"groupId":"133692567","addonId":"112193870"},{"groupId":"133692567","addonId":"112193872"},{"groupId":"133692567","addonId":"112193878"},{"groupId":"133692567","addonId":"112193838"},{"groupId":"133692567","addonId":"112193840"},{"groupId":"133692567","addonId":"112193842"},{"groupId":"133692567","addonId":"112193844"},{"groupId":"133692567","addonId":"112193849"},{"groupId":"133692567","addonId":"112193845"},{"groupId":"133692567","addonId":"112193851"},{"groupId":"133692567","addonId":"112193853"},{"groupId":"151869037","addonId":"112193873"}]},{"variations":[{"groupId":"37266257","variationId":"116400596"},{"groupId":"37266258","variationId":"126057651"}],"price":45400,"addonCombinations":[{"groupId":"133692565","addonId":"112193863"},{"groupId":"133692565","addonId":"112193860"},{"groupId":"133692565","addonId":"112193859"},{"groupId":"133692565","addonId":"115290079"},{"groupId":"133692565","addonId":"112193858"},{"groupId":"133692565","addonId":"112193861"},{"groupId":"133692567","addonId":"112193873"},{"groupId":"133692567","addonId":"112193870"},{"groupId":"133692567","addonId":"112193872"},{"groupId":"133692567","addonId":"112193878"},{"groupId":"133692567","addonId":"112193838"},{"groupId":"133692567","addonId":"112193840"},{"groupId":"133692567","addonId":"112193842"},{"groupId":"133692567","addonId":"112193844"},{"groupId":"133692567","addonId":"112193849"},{"groupId":"133692567","addonId":"112193845"},{"groupId":"133692567","addonId":"112193851"},{"groupId":"133692567","addonId":"112193853"},{"groupId":"151869037","addonId":"112193873"}]},{"variations":[{"groupId":"37266257","variationId":"116400597"},{"groupId":"37266258","variationId":"116400599"}],"price":63900,"addonCombinations":[{"groupId":"133692565","addonId":"112193863"},{"groupId":"133692565","addonId":"112193860"},{"groupId":"133692565","addonId":"112193859"},{"groupId":"133692565","addonId":"115290079"},{"groupId":"133692565","addonId":"112193858"},{"groupId":"133692565","addonId":"112193861"},{"groupId":"151869041","addonId":"117361301"},{"groupId":"133692566","addonId":"112193843"},{"groupId":"133692566","addonId":"112193839"},{"groupId":"133692566","addonId":"112193841"},{"groupId":"133692566","addonId":"112193877"},{"groupId":"133692566","addonId":"112193848"},{"groupId":"133692566","addonId":"112193850"},{"groupId":"133692566","addonId":"112193852"},{"groupId":"133692566","addonId":"112193854"},{"groupId":"133692566","addonId":"112193856"},{"groupId":"133692566","addonId":"112193855"},{"groupId":"133692566","addonId":"112193865"},{"groupId":"133692566","addonId":"112193866"}]},{"variations":[{"groupId":"37266257","variationId":"116400597"},{"groupId":"37266258","variationId":"126057652"}],"price":73800,"addonCombinations":[{"groupId":"133692565","addonId":"112193863"},{"groupId":"133692565","addonId":"112193860"},{"groupId":"133692565","addonId":"112193859"},{"groupId":"133692565","addonId":"115290079"},{"groupId":"133692565","addonId":"112193858"},{"groupId":"133692565","addonId":"112193861"},{"groupId":"151869041","addonId":"117361301"},{"groupId":"133692566","addonId":"112193843"},{"groupId":"133692566","addonId":"112193839"},{"groupId":"133692566","addonId":"112193841"},{"groupId":"133692566","addonId":"112193877"},{"groupId":"133692566","addonId":"112193848"},{"groupId":"133692566","addonId":"112193850"},{"groupId":"133692566","addonId":"112193852"},{"groupId":"133692566","addonId":"112193854"},{"groupId":"133692566","addonId":"112193856"},{"groupId":"133692566","addonId":"112193855"},{"groupId":"133692566","addonId":"112193865"},{"groupId":"133692566","addonId":"112193866"}]},{"variations":[{"groupId":"37266257","variationId":"124962362"},{"groupId":"37266258","variationId":"124962363"}],"price":84900,"addonCombinations":[{"groupId":"133692565","addonId":"112193863"},{"groupId":"133692565","addonId":"112193860"},{"groupId":"133692565","addonId":"112193859"},{"groupId":"133692565","addonId":"115290079"},{"groupId":"133692565","addonId":"112193858"},{"groupId":"133692565","addonId":"112193861"},{"groupId":"151869042","addonId":"114785288"},{"groupId":"140439446","addonId":"114785287"},{"groupId":"140439446","addonId":"114785288"},{"groupId":"140439446","addonId":"114785289"},{"groupId":"140439446","addonId":"114785290"},{"groupId":"140439446","addonId":"114785286"},{"groupId":"140439446","addonId":"114785301"},{"groupId":"140439446","addonId":"114785302"},{"groupId":"140439446","addonId":"114785297"},{"groupId":"140439446","addonId":"114785298"},{"groupId":"140439446","addonId":"114785299"},{"groupId":"140439446","addonId":"114785300"},{"groupId":"140439446","addonId":"114785293"},{"groupId":"140439446","addonId":"114785294"}]}]},"addons":[{"groupId":"151869037","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"151869042","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140439446","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692565","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"133692566","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692567","groupName":"Add. Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193878","name":"Herbed Veggies","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":37900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.7","ratingCount":"8 ratings","ratingCountV2":"8"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859595","name":"Country Feast","category":"Veg Pizza","description":"Serves 1 | Loaded with herbed onion & green capsicum, sweet corn, tomato with signature pan sauce and 100% mozzarella cheese. It\'s a feast you can\'t refuse (PAN Per/Med-244 Kcal/100g | TnC-282 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"c3832837392378cca98e484b89c313ba","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266255","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400590","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266256","variationId":"116400592"}},{"name":"Medium","id":"116400591","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266256","variationId":"116400593"}},{"name":"Thin n Large","id":"124962376","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266256","variationId":"124962377"}}]},{"groupId":"37266256","name":"Choose your Crust","variations":[{"name":"Pan","price":319,"default":1,"id":"116400592","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Pan","price":569,"id":"116400593","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Thin n Crispy","price":749,"id":"124962377","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":394,"id":"126057615","isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":668,"id":"126057616","isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266255","variationId":"116400590"},{"groupId":"37266256","variationId":"116400592"}],"price":31900,"addonCombinations":[{"groupId":"133692562","addonId":"112193863"},{"groupId":"133692562","addonId":"112193860"},{"groupId":"133692562","addonId":"112193859"},{"groupId":"133692562","addonId":"115290079"},{"groupId":"133692562","addonId":"112193858"},{"groupId":"133692562","addonId":"112193861"},{"groupId":"133692564","addonId":"112193873"},{"groupId":"133692564","addonId":"112193870"},{"groupId":"133692564","addonId":"112193872"},{"groupId":"133692564","addonId":"112193878"},{"groupId":"133692564","addonId":"112193838"},{"groupId":"133692564","addonId":"112193840"},{"groupId":"133692564","addonId":"112193842"},{"groupId":"133692564","addonId":"112193844"},{"groupId":"133692564","addonId":"112193849"},{"groupId":"133692564","addonId":"112193845"},{"groupId":"133692564","addonId":"112193851"},{"groupId":"133692564","addonId":"112193853"},{"groupId":"151869346","addonId":"112193873"}]},{"variations":[{"groupId":"37266255","variationId":"116400590"},{"groupId":"37266256","variationId":"126057615"}],"price":39400,"addonCombinations":[{"groupId":"133692562","addonId":"112193863"},{"groupId":"133692562","addonId":"112193860"},{"groupId":"133692562","addonId":"112193859"},{"groupId":"133692562","addonId":"115290079"},{"groupId":"133692562","addonId":"112193858"},{"groupId":"133692562","addonId":"112193861"},{"groupId":"133692564","addonId":"112193873"},{"groupId":"133692564","addonId":"112193870"},{"groupId":"133692564","addonId":"112193872"},{"groupId":"133692564","addonId":"112193878"},{"groupId":"133692564","addonId":"112193838"},{"groupId":"133692564","addonId":"112193840"},{"groupId":"133692564","addonId":"112193842"},{"groupId":"133692564","addonId":"112193844"},{"groupId":"133692564","addonId":"112193849"},{"groupId":"133692564","addonId":"112193845"},{"groupId":"133692564","addonId":"112193851"},{"groupId":"133692564","addonId":"112193853"},{"groupId":"151869346","addonId":"112193873"}]},{"variations":[{"groupId":"37266255","variationId":"116400591"},{"groupId":"37266256","variationId":"116400593"}],"price":56900,"addonCombinations":[{"groupId":"133692562","addonId":"112193863"},{"groupId":"133692562","addonId":"112193860"},{"groupId":"133692562","addonId":"112193859"},{"groupId":"133692562","addonId":"115290079"},{"groupId":"133692562","addonId":"112193858"},{"groupId":"133692562","addonId":"112193861"},{"groupId":"133692563","addonId":"112193843"},{"groupId":"133692563","addonId":"112193839"},{"groupId":"133692563","addonId":"112193841"},{"groupId":"133692563","addonId":"112193877"},{"groupId":"133692563","addonId":"112193848"},{"groupId":"133692563","addonId":"112193850"},{"groupId":"133692563","addonId":"112193852"},{"groupId":"133692563","addonId":"112193854"},{"groupId":"133692563","addonId":"112193856"},{"groupId":"133692563","addonId":"112193855"},{"groupId":"133692563","addonId":"112193865"},{"groupId":"133692563","addonId":"112193866"}]},{"variations":[{"groupId":"37266255","variationId":"116400591"},{"groupId":"37266256","variationId":"126057616"}],"price":66800,"addonCombinations":[{"groupId":"133692562","addonId":"112193863"},{"groupId":"133692562","addonId":"112193860"},{"groupId":"133692562","addonId":"112193859"},{"groupId":"133692562","addonId":"115290079"},{"groupId":"133692562","addonId":"112193858"},{"groupId":"133692562","addonId":"112193861"},{"groupId":"133692563","addonId":"112193843"},{"groupId":"133692563","addonId":"112193839"},{"groupId":"133692563","addonId":"112193841"},{"groupId":"133692563","addonId":"112193877"},{"groupId":"133692563","addonId":"112193848"},{"groupId":"133692563","addonId":"112193850"},{"groupId":"133692563","addonId":"112193852"},{"groupId":"133692563","addonId":"112193854"},{"groupId":"133692563","addonId":"112193856"},{"groupId":"133692563","addonId":"112193855"},{"groupId":"133692563","addonId":"112193865"},{"groupId":"133692563","addonId":"112193866"}]},{"variations":[{"groupId":"37266255","variationId":"124962376"},{"groupId":"37266256","variationId":"124962377"}],"price":74900,"addonCombinations":[{"groupId":"133692562","addonId":"112193863"},{"groupId":"133692562","addonId":"112193860"},{"groupId":"133692562","addonId":"112193859"},{"groupId":"133692562","addonId":"115290079"},{"groupId":"133692562","addonId":"112193858"},{"groupId":"133692562","addonId":"112193861"},{"groupId":"151869343","addonId":"114785288"},{"groupId":"140439453","addonId":"114785287"},{"groupId":"140439453","addonId":"114785288"},{"groupId":"140439453","addonId":"114785289"},{"groupId":"140439453","addonId":"114785290"},{"groupId":"140439453","addonId":"114785286"},{"groupId":"140439453","addonId":"114785301"},{"groupId":"140439453","addonId":"114785302"},{"groupId":"140439453","addonId":"114785297"},{"groupId":"140439453","addonId":"114785298"},{"groupId":"140439453","addonId":"114785299"},{"groupId":"140439453","addonId":"114785300"},{"groupId":"140439453","addonId":"114785293"},{"groupId":"140439453","addonId":"114785294"}]}]},"addons":[{"groupId":"151869343","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"151869346","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140439453","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692562","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"133692563","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692564","groupName":"Add. Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193878","name":"Herbed Veggies","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":31900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859590","name":"Corn & Cheese","category":"Veg Pizza","description":"Serves 1 | A combination of juicy sweet corn & 100% mozzarella cheese with flavourful signature pan sauce (PAN Per/Med-320 Kcal/100g | TnC-304 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"ckbnw98n6tffy50wvuzm","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266245","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400560","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266246","variationId":"116400562"}},{"name":"Medium","id":"116400561","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266246","variationId":"116400563"}},{"name":"Thin n Large","id":"124962366","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266246","variationId":"124962367"}}]},{"groupId":"37266246","name":"Choose your Crust","variations":[{"name":"Pan","price":219,"default":1,"id":"116400562","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Pan","price":409,"id":"116400563","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Thin n Crispy","price":575,"id":"124962367","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":294,"id":"126057631","isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":508,"id":"126057632","isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266245","variationId":"116400560"},{"groupId":"37266246","variationId":"116400562"}],"price":21900,"addonCombinations":[{"groupId":"133692547","addonId":"112193863"},{"groupId":"133692547","addonId":"112193860"},{"groupId":"133692547","addonId":"112193859"},{"groupId":"133692547","addonId":"115290079"},{"groupId":"133692547","addonId":"112193858"},{"groupId":"133692547","addonId":"112193861"},{"groupId":"133692549","addonId":"112193873"},{"groupId":"133692549","addonId":"112193870"},{"groupId":"133692549","addonId":"112193872"},{"groupId":"133692549","addonId":"112193878"},{"groupId":"133692549","addonId":"112193838"},{"groupId":"133692549","addonId":"112193840"},{"groupId":"133692549","addonId":"112193842"},{"groupId":"133692549","addonId":"112193844"},{"groupId":"133692549","addonId":"112193849"},{"groupId":"133692549","addonId":"112193845"},{"groupId":"133692549","addonId":"112193851"},{"groupId":"133692549","addonId":"112193853"},{"groupId":"151869243","addonId":"112193873"}]},{"variations":[{"groupId":"37266245","variationId":"116400560"},{"groupId":"37266246","variationId":"126057631"}],"price":29400,"addonCombinations":[{"groupId":"133692547","addonId":"112193863"},{"groupId":"133692547","addonId":"112193860"},{"groupId":"133692547","addonId":"112193859"},{"groupId":"133692547","addonId":"115290079"},{"groupId":"133692547","addonId":"112193858"},{"groupId":"133692547","addonId":"112193861"},{"groupId":"133692549","addonId":"112193873"},{"groupId":"133692549","addonId":"112193870"},{"groupId":"133692549","addonId":"112193872"},{"groupId":"133692549","addonId":"112193878"},{"groupId":"133692549","addonId":"112193838"},{"groupId":"133692549","addonId":"112193840"},{"groupId":"133692549","addonId":"112193842"},{"groupId":"133692549","addonId":"112193844"},{"groupId":"133692549","addonId":"112193849"},{"groupId":"133692549","addonId":"112193845"},{"groupId":"133692549","addonId":"112193851"},{"groupId":"133692549","addonId":"112193853"},{"groupId":"151869243","addonId":"112193873"}]},{"variations":[{"groupId":"37266245","variationId":"116400561"},{"groupId":"37266246","variationId":"116400563"}],"price":40900,"addonCombinations":[{"groupId":"133692547","addonId":"112193863"},{"groupId":"133692547","addonId":"112193860"},{"groupId":"133692547","addonId":"112193859"},{"groupId":"133692547","addonId":"115290079"},{"groupId":"133692547","addonId":"112193858"},{"groupId":"133692547","addonId":"112193861"},{"groupId":"151869245","addonId":"117361301"},{"groupId":"133692548","addonId":"112193843"},{"groupId":"133692548","addonId":"112193839"},{"groupId":"133692548","addonId":"112193841"},{"groupId":"133692548","addonId":"112193877"},{"groupId":"133692548","addonId":"112193848"},{"groupId":"133692548","addonId":"112193850"},{"groupId":"133692548","addonId":"112193852"},{"groupId":"133692548","addonId":"112193854"},{"groupId":"133692548","addonId":"112193856"},{"groupId":"133692548","addonId":"112193855"},{"groupId":"133692548","addonId":"112193865"},{"groupId":"133692548","addonId":"112193866"}]},{"variations":[{"groupId":"37266245","variationId":"116400561"},{"groupId":"37266246","variationId":"126057632"}],"price":50800,"addonCombinations":[{"groupId":"133692547","addonId":"112193863"},{"groupId":"133692547","addonId":"112193860"},{"groupId":"133692547","addonId":"112193859"},{"groupId":"133692547","addonId":"115290079"},{"groupId":"133692547","addonId":"112193858"},{"groupId":"133692547","addonId":"112193861"},{"groupId":"151869245","addonId":"117361301"},{"groupId":"133692548","addonId":"112193843"},{"groupId":"133692548","addonId":"112193839"},{"groupId":"133692548","addonId":"112193841"},{"groupId":"133692548","addonId":"112193877"},{"groupId":"133692548","addonId":"112193848"},{"groupId":"133692548","addonId":"112193850"},{"groupId":"133692548","addonId":"112193852"},{"groupId":"133692548","addonId":"112193854"},{"groupId":"133692548","addonId":"112193856"},{"groupId":"133692548","addonId":"112193855"},{"groupId":"133692548","addonId":"112193865"},{"groupId":"133692548","addonId":"112193866"}]},{"variations":[{"groupId":"37266245","variationId":"124962366"},{"groupId":"37266246","variationId":"124962367"}],"price":57500,"addonCombinations":[{"groupId":"133692547","addonId":"112193863"},{"groupId":"133692547","addonId":"112193860"},{"groupId":"133692547","addonId":"112193859"},{"groupId":"133692547","addonId":"115290079"},{"groupId":"133692547","addonId":"112193858"},{"groupId":"133692547","addonId":"112193861"},{"groupId":"151869248","addonId":"114785288"},{"groupId":"140439448","addonId":"114785287"},{"groupId":"140439448","addonId":"114785288"},{"groupId":"140439448","addonId":"114785289"},{"groupId":"140439448","addonId":"114785290"},{"groupId":"140439448","addonId":"114785286"},{"groupId":"140439448","addonId":"114785301"},{"groupId":"140439448","addonId":"114785302"},{"groupId":"140439448","addonId":"114785297"},{"groupId":"140439448","addonId":"114785298"},{"groupId":"140439448","addonId":"114785299"},{"groupId":"140439448","addonId":"114785300"},{"groupId":"140439448","addonId":"114785293"},{"groupId":"140439448","addonId":"114785294"}]}]},"addons":[{"groupId":"151869243","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"151869248","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140439448","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692547","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"133692548","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692549","groupName":"Add. Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193878","name":"Herbed Veggies","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":21900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859702","name":"Ultimate Tandoori Veggie","category":"Veg Pizza","description":"Serves 1 | An ultimate combination of your favourite veggies-onion, green capsicum, mushroom, tomato, spicy jalapeno on tandoori sauce, topped with 100% mozzarella cheese & generous drizzle of mint mayo (PAN Per/Med-314 Kcal/100g | TnC-395 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"b7d1f56df6414f8b6e49001af95e259a","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266385","name":"Size","variations":[{"name":"Personal","default":1,"id":"116401062","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266387","variationId":"116401065"}},{"name":"Medium","id":"116401063","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266387","variationId":"116401067"}},{"name":"Thin n Large","id":"124962346","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266387","variationId":"124962347"}}]},{"groupId":"37266387","name":"Choose your Crust","variations":[{"name":"Pan","price":379,"default":1,"id":"116401065","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Pan","price":639,"id":"116401067","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Thin n Crispy","price":849,"id":"124962347","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":454,"id":"126057761","isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":738,"id":"126057762","isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266385","variationId":"116401062"},{"groupId":"37266387","variationId":"116401065"}],"price":37900,"addonCombinations":[{"groupId":"133692667","addonId":"112193863"},{"groupId":"133692667","addonId":"112193860"},{"groupId":"133692667","addonId":"112193859"},{"groupId":"133692667","addonId":"115290079"},{"groupId":"133692667","addonId":"112193858"},{"groupId":"133692667","addonId":"112193861"},{"groupId":"133692670","addonId":"112193873"},{"groupId":"133692670","addonId":"112193870"},{"groupId":"133692670","addonId":"112193872"},{"groupId":"133692670","addonId":"112193878"},{"groupId":"133692670","addonId":"112193838"},{"groupId":"133692670","addonId":"112193840"},{"groupId":"133692670","addonId":"112193842"},{"groupId":"133692670","addonId":"112193844"},{"groupId":"133692670","addonId":"112193849"},{"groupId":"133692670","addonId":"112193845"},{"groupId":"133692670","addonId":"112193851"},{"groupId":"133692670","addonId":"112193853"},{"groupId":"151868970","addonId":"112193873"}]},{"variations":[{"groupId":"37266385","variationId":"116401062"},{"groupId":"37266387","variationId":"126057761"}],"price":45400,"addonCombinations":[{"groupId":"133692667","addonId":"112193863"},{"groupId":"133692667","addonId":"112193860"},{"groupId":"133692667","addonId":"112193859"},{"groupId":"133692667","addonId":"115290079"},{"groupId":"133692667","addonId":"112193858"},{"groupId":"133692667","addonId":"112193861"},{"groupId":"133692670","addonId":"112193873"},{"groupId":"133692670","addonId":"112193870"},{"groupId":"133692670","addonId":"112193872"},{"groupId":"133692670","addonId":"112193878"},{"groupId":"133692670","addonId":"112193838"},{"groupId":"133692670","addonId":"112193840"},{"groupId":"133692670","addonId":"112193842"},{"groupId":"133692670","addonId":"112193844"},{"groupId":"133692670","addonId":"112193849"},{"groupId":"133692670","addonId":"112193845"},{"groupId":"133692670","addonId":"112193851"},{"groupId":"133692670","addonId":"112193853"},{"groupId":"151868970","addonId":"112193873"}]},{"variations":[{"groupId":"37266385","variationId":"116401063"},{"groupId":"37266387","variationId":"116401067"}],"price":63900,"addonCombinations":[{"groupId":"133692667","addonId":"112193863"},{"groupId":"133692667","addonId":"112193860"},{"groupId":"133692667","addonId":"112193859"},{"groupId":"133692667","addonId":"115290079"},{"groupId":"133692667","addonId":"112193858"},{"groupId":"133692667","addonId":"112193861"},{"groupId":"151868974","addonId":"117361301"},{"groupId":"133692668","addonId":"112193843"},{"groupId":"133692668","addonId":"112193839"},{"groupId":"133692668","addonId":"112193841"},{"groupId":"133692668","addonId":"112193877"},{"groupId":"133692668","addonId":"112193848"},{"groupId":"133692668","addonId":"112193850"},{"groupId":"133692668","addonId":"112193852"},{"groupId":"133692668","addonId":"112193854"},{"groupId":"133692668","addonId":"112193856"},{"groupId":"133692668","addonId":"112193855"},{"groupId":"133692668","addonId":"112193865"},{"groupId":"133692668","addonId":"112193866"}]},{"variations":[{"groupId":"37266385","variationId":"116401063"},{"groupId":"37266387","variationId":"126057762"}],"price":73800,"addonCombinations":[{"groupId":"133692667","addonId":"112193863"},{"groupId":"133692667","addonId":"112193860"},{"groupId":"133692667","addonId":"112193859"},{"groupId":"133692667","addonId":"115290079"},{"groupId":"133692667","addonId":"112193858"},{"groupId":"133692667","addonId":"112193861"},{"groupId":"151868974","addonId":"117361301"},{"groupId":"133692668","addonId":"112193843"},{"groupId":"133692668","addonId":"112193839"},{"groupId":"133692668","addonId":"112193841"},{"groupId":"133692668","addonId":"112193877"},{"groupId":"133692668","addonId":"112193848"},{"groupId":"133692668","addonId":"112193850"},{"groupId":"133692668","addonId":"112193852"},{"groupId":"133692668","addonId":"112193854"},{"groupId":"133692668","addonId":"112193856"},{"groupId":"133692668","addonId":"112193855"},{"groupId":"133692668","addonId":"112193865"},{"groupId":"133692668","addonId":"112193866"}]},{"variations":[{"groupId":"37266385","variationId":"124962346"},{"groupId":"37266387","variationId":"124962347"}],"price":84900,"addonCombinations":[{"groupId":"133692667","addonId":"112193863"},{"groupId":"133692667","addonId":"112193860"},{"groupId":"133692667","addonId":"112193859"},{"groupId":"133692667","addonId":"115290079"},{"groupId":"133692667","addonId":"112193858"},{"groupId":"133692667","addonId":"112193861"},{"groupId":"151868976","addonId":"114785288"},{"groupId":"140439438","addonId":"114785287"},{"groupId":"140439438","addonId":"114785288"},{"groupId":"140439438","addonId":"114785289"},{"groupId":"140439438","addonId":"114785290"},{"groupId":"140439438","addonId":"114785286"},{"groupId":"140439438","addonId":"114785301"},{"groupId":"140439438","addonId":"114785302"},{"groupId":"140439438","addonId":"114785297"},{"groupId":"140439438","addonId":"114785298"},{"groupId":"140439438","addonId":"114785299"},{"groupId":"140439438","addonId":"114785300"},{"groupId":"140439438","addonId":"114785293"},{"groupId":"140439438","addonId":"114785294"}]}]},"addons":[{"groupId":"151868970","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"151868976","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140439438","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692667","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"133692668","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692670","groupName":"Add. Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193878","name":"Herbed Veggies","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":37900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859591","name":"Veggie Feast","category":"Veg Pizza","description":"Serves 1 | Herbed onion and green capsicum, juicy sweet corn & 100% mozzarella cheese with flavourful pan sauce (PAN Per/Med-269 Kcal/100g | TnC-274 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"cbye9x7wxeopwqvenn7g","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266247","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400566","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266248","variationId":"116400568"}},{"name":"Medium","id":"116400567","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266248","variationId":"116400569"}},{"name":"Thin n Large","id":"124962414","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266248","variationId":"124962415"}}]},{"groupId":"37266248","name":"Choose your Crust","variations":[{"name":"Pan","price":259,"default":1,"id":"116400568","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Pan","price":489,"id":"116400569","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Thin n Crispy","price":649,"id":"124962415","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":334,"id":"126057598","isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":588,"id":"126057600","isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266247","variationId":"116400566"},{"groupId":"37266248","variationId":"116400568"}],"price":25900,"addonCombinations":[{"groupId":"133692550","addonId":"112193863"},{"groupId":"133692550","addonId":"112193860"},{"groupId":"133692550","addonId":"112193859"},{"groupId":"133692550","addonId":"115290079"},{"groupId":"133692550","addonId":"112193858"},{"groupId":"133692550","addonId":"112193861"},{"groupId":"133692552","addonId":"112193873"},{"groupId":"133692552","addonId":"112193870"},{"groupId":"133692552","addonId":"112193872"},{"groupId":"133692552","addonId":"112193878"},{"groupId":"133692552","addonId":"112193838"},{"groupId":"133692552","addonId":"112193840"},{"groupId":"133692552","addonId":"112193842"},{"groupId":"133692552","addonId":"112193844"},{"groupId":"133692552","addonId":"112193849"},{"groupId":"133692552","addonId":"112193845"},{"groupId":"133692552","addonId":"112193851"},{"groupId":"133692552","addonId":"112193853"},{"groupId":"151869562","addonId":"112193873"}]},{"variations":[{"groupId":"37266247","variationId":"116400566"},{"groupId":"37266248","variationId":"126057598"}],"price":33400,"addonCombinations":[{"groupId":"133692550","addonId":"112193863"},{"groupId":"133692550","addonId":"112193860"},{"groupId":"133692550","addonId":"112193859"},{"groupId":"133692550","addonId":"115290079"},{"groupId":"133692550","addonId":"112193858"},{"groupId":"133692550","addonId":"112193861"},{"groupId":"133692552","addonId":"112193873"},{"groupId":"133692552","addonId":"112193870"},{"groupId":"133692552","addonId":"112193872"},{"groupId":"133692552","addonId":"112193878"},{"groupId":"133692552","addonId":"112193838"},{"groupId":"133692552","addonId":"112193840"},{"groupId":"133692552","addonId":"112193842"},{"groupId":"133692552","addonId":"112193844"},{"groupId":"133692552","addonId":"112193849"},{"groupId":"133692552","addonId":"112193845"},{"groupId":"133692552","addonId":"112193851"},{"groupId":"133692552","addonId":"112193853"},{"groupId":"151869562","addonId":"112193873"}]},{"variations":[{"groupId":"37266247","variationId":"116400567"},{"groupId":"37266248","variationId":"116400569"}],"price":48900,"addonCombinations":[{"groupId":"133692550","addonId":"112193863"},{"groupId":"133692550","addonId":"112193860"},{"groupId":"133692550","addonId":"112193859"},{"groupId":"133692550","addonId":"115290079"},{"groupId":"133692550","addonId":"112193858"},{"groupId":"133692550","addonId":"112193861"},{"groupId":"151869567","addonId":"117361301"},{"groupId":"133692551","addonId":"112193843"},{"groupId":"133692551","addonId":"112193839"},{"groupId":"133692551","addonId":"112193841"},{"groupId":"133692551","addonId":"112193877"},{"groupId":"133692551","addonId":"112193848"},{"groupId":"133692551","addonId":"112193850"},{"groupId":"133692551","addonId":"112193852"},{"groupId":"133692551","addonId":"112193854"},{"groupId":"133692551","addonId":"112193856"},{"groupId":"133692551","addonId":"112193855"},{"groupId":"133692551","addonId":"112193865"},{"groupId":"133692551","addonId":"112193866"}]},{"variations":[{"groupId":"37266247","variationId":"116400567"},{"groupId":"37266248","variationId":"126057600"}],"price":58800,"addonCombinations":[{"groupId":"133692550","addonId":"112193863"},{"groupId":"133692550","addonId":"112193860"},{"groupId":"133692550","addonId":"112193859"},{"groupId":"133692550","addonId":"115290079"},{"groupId":"133692550","addonId":"112193858"},{"groupId":"133692550","addonId":"112193861"},{"groupId":"151869567","addonId":"117361301"},{"groupId":"133692551","addonId":"112193843"},{"groupId":"133692551","addonId":"112193839"},{"groupId":"133692551","addonId":"112193841"},{"groupId":"133692551","addonId":"112193877"},{"groupId":"133692551","addonId":"112193848"},{"groupId":"133692551","addonId":"112193850"},{"groupId":"133692551","addonId":"112193852"},{"groupId":"133692551","addonId":"112193854"},{"groupId":"133692551","addonId":"112193856"},{"groupId":"133692551","addonId":"112193855"},{"groupId":"133692551","addonId":"112193865"},{"groupId":"133692551","addonId":"112193866"}]},{"variations":[{"groupId":"37266247","variationId":"124962414"},{"groupId":"37266248","variationId":"124962415"}],"price":64900,"addonCombinations":[{"groupId":"133692550","addonId":"112193863"},{"groupId":"133692550","addonId":"112193860"},{"groupId":"133692550","addonId":"112193859"},{"groupId":"133692550","addonId":"115290079"},{"groupId":"133692550","addonId":"112193858"},{"groupId":"133692550","addonId":"112193861"},{"groupId":"151869569","addonId":"114785288"},{"groupId":"140439473","addonId":"114785287"},{"groupId":"140439473","addonId":"114785288"},{"groupId":"140439473","addonId":"114785289"},{"groupId":"140439473","addonId":"114785290"},{"groupId":"140439473","addonId":"114785286"},{"groupId":"140439473","addonId":"114785301"},{"groupId":"140439473","addonId":"114785302"},{"groupId":"140439473","addonId":"114785297"},{"groupId":"140439473","addonId":"114785298"},{"groupId":"140439473","addonId":"114785299"},{"groupId":"140439473","addonId":"114785300"},{"groupId":"140439473","addonId":"114785293"},{"groupId":"140439473","addonId":"114785294"}]}]},"addons":[{"groupId":"151869562","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"151869569","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140439473","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692550","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"133692551","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692552","groupName":"Add. Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193878","name":"Herbed Veggies","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":25900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859730","name":"Schezwan Margherita","category":"Veg Pizza","description":"Serves 1 | Your very own margherita, now with a spicy twist! Loaded with our signature spicy schezwan sauce & 100% mozzarella cheese (PAN Per/Med-300 Kcal/100g | TnC-309 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"0e7df98b7cffdb0b88856464014ad2ff","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266425","name":"Size","variations":[{"name":"Personal","default":1,"id":"116401198","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266426","variationId":"116401200"}},{"name":"Medium","id":"116401199","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266426","variationId":"116401201"}},{"name":"Thin n Large","id":"124962406","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266426","variationId":"124962407"}}]},{"groupId":"37266426","name":"Choose your Crust","variations":[{"name":"Pan","price":219,"default":1,"id":"116401200","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Pan","price":409,"id":"116401201","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Thin n Crispy","price":575,"id":"124962407","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":294,"id":"126057841","isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":508,"id":"126057842","isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266425","variationId":"116401198"},{"groupId":"37266426","variationId":"116401200"}],"price":21900,"addonCombinations":[{"groupId":"133692699","addonId":"112193863"},{"groupId":"133692699","addonId":"112193860"},{"groupId":"133692699","addonId":"112193859"},{"groupId":"133692699","addonId":"115290079"},{"groupId":"133692699","addonId":"112193858"},{"groupId":"133692699","addonId":"112193861"},{"groupId":"133692701","addonId":"112193873"},{"groupId":"133692701","addonId":"112193870"},{"groupId":"133692701","addonId":"112193872"},{"groupId":"133692701","addonId":"112193878"},{"groupId":"133692701","addonId":"112193838"},{"groupId":"133692701","addonId":"112193840"},{"groupId":"133692701","addonId":"112193842"},{"groupId":"133692701","addonId":"112193844"},{"groupId":"133692701","addonId":"112193849"},{"groupId":"133692701","addonId":"112193845"},{"groupId":"133692701","addonId":"112193851"},{"groupId":"133692701","addonId":"112193853"},{"groupId":"150927424","addonId":"112193873"}]},{"variations":[{"groupId":"37266425","variationId":"116401198"},{"groupId":"37266426","variationId":"126057841"}],"price":29400,"addonCombinations":[{"groupId":"133692699","addonId":"112193863"},{"groupId":"133692699","addonId":"112193860"},{"groupId":"133692699","addonId":"112193859"},{"groupId":"133692699","addonId":"115290079"},{"groupId":"133692699","addonId":"112193858"},{"groupId":"133692699","addonId":"112193861"},{"groupId":"133692701","addonId":"112193873"},{"groupId":"133692701","addonId":"112193870"},{"groupId":"133692701","addonId":"112193872"},{"groupId":"133692701","addonId":"112193878"},{"groupId":"133692701","addonId":"112193838"},{"groupId":"133692701","addonId":"112193840"},{"groupId":"133692701","addonId":"112193842"},{"groupId":"133692701","addonId":"112193844"},{"groupId":"133692701","addonId":"112193849"},{"groupId":"133692701","addonId":"112193845"},{"groupId":"133692701","addonId":"112193851"},{"groupId":"133692701","addonId":"112193853"},{"groupId":"150927424","addonId":"112193873"}]},{"variations":[{"groupId":"37266425","variationId":"116401199"},{"groupId":"37266426","variationId":"116401201"}],"price":40900,"addonCombinations":[{"groupId":"133692699","addonId":"112193863"},{"groupId":"133692699","addonId":"112193860"},{"groupId":"133692699","addonId":"112193859"},{"groupId":"133692699","addonId":"115290079"},{"groupId":"133692699","addonId":"112193858"},{"groupId":"133692699","addonId":"112193861"},{"groupId":"150927425","addonId":"117361301"},{"groupId":"133692700","addonId":"112193843"},{"groupId":"133692700","addonId":"112193839"},{"groupId":"133692700","addonId":"112193841"},{"groupId":"133692700","addonId":"112193877"},{"groupId":"133692700","addonId":"112193848"},{"groupId":"133692700","addonId":"112193850"},{"groupId":"133692700","addonId":"112193852"},{"groupId":"133692700","addonId":"112193854"},{"groupId":"133692700","addonId":"112193856"},{"groupId":"133692700","addonId":"112193855"},{"groupId":"133692700","addonId":"112193865"},{"groupId":"133692700","addonId":"112193866"}]},{"variations":[{"groupId":"37266425","variationId":"116401199"},{"groupId":"37266426","variationId":"126057842"}],"price":50800,"addonCombinations":[{"groupId":"133692699","addonId":"112193863"},{"groupId":"133692699","addonId":"112193860"},{"groupId":"133692699","addonId":"112193859"},{"groupId":"133692699","addonId":"115290079"},{"groupId":"133692699","addonId":"112193858"},{"groupId":"133692699","addonId":"112193861"},{"groupId":"150927425","addonId":"117361301"},{"groupId":"133692700","addonId":"112193843"},{"groupId":"133692700","addonId":"112193839"},{"groupId":"133692700","addonId":"112193841"},{"groupId":"133692700","addonId":"112193877"},{"groupId":"133692700","addonId":"112193848"},{"groupId":"133692700","addonId":"112193850"},{"groupId":"133692700","addonId":"112193852"},{"groupId":"133692700","addonId":"112193854"},{"groupId":"133692700","addonId":"112193856"},{"groupId":"133692700","addonId":"112193855"},{"groupId":"133692700","addonId":"112193865"},{"groupId":"133692700","addonId":"112193866"}]},{"variations":[{"groupId":"37266425","variationId":"124962406"},{"groupId":"37266426","variationId":"124962407"}],"price":57500,"addonCombinations":[{"groupId":"133692699","addonId":"112193863"},{"groupId":"133692699","addonId":"112193860"},{"groupId":"133692699","addonId":"112193859"},{"groupId":"133692699","addonId":"115290079"},{"groupId":"133692699","addonId":"112193858"},{"groupId":"133692699","addonId":"112193861"},{"groupId":"150927426","addonId":"114785288"},{"groupId":"140439469","addonId":"114785287"},{"groupId":"140439469","addonId":"114785288"},{"groupId":"140439469","addonId":"114785289"},{"groupId":"140439469","addonId":"114785290"},{"groupId":"140439469","addonId":"114785286"},{"groupId":"140439469","addonId":"114785301"},{"groupId":"140439469","addonId":"114785302"},{"groupId":"140439469","addonId":"114785297"},{"groupId":"140439469","addonId":"114785298"},{"groupId":"140439469","addonId":"114785299"},{"groupId":"140439469","addonId":"114785300"},{"groupId":"140439469","addonId":"114785293"},{"groupId":"140439469","addonId":"114785294"}]}]},"addons":[{"groupId":"150927424","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"150927426","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140439469","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692699","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"133692700","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692701","groupName":"Add. Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193878","name":"Herbed Veggies","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":21900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"5 ratings","ratingCountV2":"5"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859592","name":"Spiced Paneer","category":"Veg Pizza","description":"Serves 1 | Spiced paneer, crunchy onion, juicy tomato & 100% mozzarella cheese, with our classic pan sauce (PAN Per/Med-276 Kcal/100g | TnC-283 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"a89yqx09ppwlecyqterp","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266249","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400572","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266250","variationId":"116400574"}},{"name":"Medium","id":"116400573","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266250","variationId":"116400575"}},{"name":"Thin n Large","id":"124962374","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266250","variationId":"124962375"}}]},{"groupId":"37266250","name":"Choose your Crust","variations":[{"name":"Pan","price":259,"default":1,"id":"116400574","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Pan","price":489,"id":"116400575","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Thin n Crispy","price":649,"id":"124962375","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":334,"id":"126057770","isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":588,"id":"126057772","isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266249","variationId":"116400572"},{"groupId":"37266250","variationId":"116400574"}],"price":25900,"addonCombinations":[{"groupId":"133692553","addonId":"112193863"},{"groupId":"133692553","addonId":"112193860"},{"groupId":"133692553","addonId":"112193859"},{"groupId":"133692553","addonId":"115290079"},{"groupId":"133692553","addonId":"112193858"},{"groupId":"133692553","addonId":"112193861"},{"groupId":"133692555","addonId":"112193873"},{"groupId":"133692555","addonId":"112193870"},{"groupId":"133692555","addonId":"112193872"},{"groupId":"133692555","addonId":"112193878"},{"groupId":"133692555","addonId":"112193838"},{"groupId":"133692555","addonId":"112193840"},{"groupId":"133692555","addonId":"112193842"},{"groupId":"133692555","addonId":"112193844"},{"groupId":"133692555","addonId":"112193849"},{"groupId":"133692555","addonId":"112193845"},{"groupId":"133692555","addonId":"112193851"},{"groupId":"133692555","addonId":"112193853"},{"groupId":"151869166","addonId":"112193873"}]},{"variations":[{"groupId":"37266249","variationId":"116400572"},{"groupId":"37266250","variationId":"126057770"}],"price":33400,"addonCombinations":[{"groupId":"133692553","addonId":"112193863"},{"groupId":"133692553","addonId":"112193860"},{"groupId":"133692553","addonId":"112193859"},{"groupId":"133692553","addonId":"115290079"},{"groupId":"133692553","addonId":"112193858"},{"groupId":"133692553","addonId":"112193861"},{"groupId":"133692555","addonId":"112193873"},{"groupId":"133692555","addonId":"112193870"},{"groupId":"133692555","addonId":"112193872"},{"groupId":"133692555","addonId":"112193878"},{"groupId":"133692555","addonId":"112193838"},{"groupId":"133692555","addonId":"112193840"},{"groupId":"133692555","addonId":"112193842"},{"groupId":"133692555","addonId":"112193844"},{"groupId":"133692555","addonId":"112193849"},{"groupId":"133692555","addonId":"112193845"},{"groupId":"133692555","addonId":"112193851"},{"groupId":"133692555","addonId":"112193853"},{"groupId":"151869166","addonId":"112193873"}]},{"variations":[{"groupId":"37266249","variationId":"116400573"},{"groupId":"37266250","variationId":"116400575"}],"price":48900,"addonCombinations":[{"groupId":"133692553","addonId":"112193863"},{"groupId":"133692553","addonId":"112193860"},{"groupId":"133692553","addonId":"112193859"},{"groupId":"133692553","addonId":"115290079"},{"groupId":"133692553","addonId":"112193858"},{"groupId":"133692553","addonId":"112193861"},{"groupId":"151869168","addonId":"117361301"},{"groupId":"133692554","addonId":"112193843"},{"groupId":"133692554","addonId":"112193839"},{"groupId":"133692554","addonId":"112193841"},{"groupId":"133692554","addonId":"112193877"},{"groupId":"133692554","addonId":"112193848"},{"groupId":"133692554","addonId":"112193850"},{"groupId":"133692554","addonId":"112193852"},{"groupId":"133692554","addonId":"112193854"},{"groupId":"133692554","addonId":"112193856"},{"groupId":"133692554","addonId":"112193855"},{"groupId":"133692554","addonId":"112193865"},{"groupId":"133692554","addonId":"112193866"}]},{"variations":[{"groupId":"37266249","variationId":"116400573"},{"groupId":"37266250","variationId":"126057772"}],"price":58800,"addonCombinations":[{"groupId":"133692553","addonId":"112193863"},{"groupId":"133692553","addonId":"112193860"},{"groupId":"133692553","addonId":"112193859"},{"groupId":"133692553","addonId":"115290079"},{"groupId":"133692553","addonId":"112193858"},{"groupId":"133692553","addonId":"112193861"},{"groupId":"151869168","addonId":"117361301"},{"groupId":"133692554","addonId":"112193843"},{"groupId":"133692554","addonId":"112193839"},{"groupId":"133692554","addonId":"112193841"},{"groupId":"133692554","addonId":"112193877"},{"groupId":"133692554","addonId":"112193848"},{"groupId":"133692554","addonId":"112193850"},{"groupId":"133692554","addonId":"112193852"},{"groupId":"133692554","addonId":"112193854"},{"groupId":"133692554","addonId":"112193856"},{"groupId":"133692554","addonId":"112193855"},{"groupId":"133692554","addonId":"112193865"},{"groupId":"133692554","addonId":"112193866"}]},{"variations":[{"groupId":"37266249","variationId":"124962374"},{"groupId":"37266250","variationId":"124962375"}],"price":64900,"addonCombinations":[{"groupId":"133692553","addonId":"112193863"},{"groupId":"133692553","addonId":"112193860"},{"groupId":"133692553","addonId":"112193859"},{"groupId":"133692553","addonId":"115290079"},{"groupId":"133692553","addonId":"112193858"},{"groupId":"133692553","addonId":"112193861"},{"groupId":"151869169","addonId":"114785288"},{"groupId":"140439452","addonId":"114785287"},{"groupId":"140439452","addonId":"114785288"},{"groupId":"140439452","addonId":"114785289"},{"groupId":"140439452","addonId":"114785290"},{"groupId":"140439452","addonId":"114785286"},{"groupId":"140439452","addonId":"114785301"},{"groupId":"140439452","addonId":"114785302"},{"groupId":"140439452","addonId":"114785297"},{"groupId":"140439452","addonId":"114785298"},{"groupId":"140439452","addonId":"114785299"},{"groupId":"140439452","addonId":"114785300"},{"groupId":"140439452","addonId":"114785293"},{"groupId":"140439452","addonId":"114785294"}]}]},"addons":[{"groupId":"151869166","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"151869169","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140439452","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692553","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"133692554","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692555","groupName":"Add. Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193878","name":"Herbed Veggies","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":25900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859726","name":"Awesome American Cheesy","category":"Veg Pizza","description":"Serves 1 | Our divine peruvian flavoured cheesy sauce, topped with sweet corn, green capsicum, red paprika and 100% mozzarella cheese, finished with a generous drizzle of texas garlic sauce (PAN Per/Med-290 Kcal/100g | TnC-300 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"9bd233c76aaf2d2745c5c07332609a8c","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266423","name":"Size","variations":[{"name":"Personal","default":1,"id":"116401192","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266424","variationId":"116401194"}},{"name":"Medium","id":"116401193","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266424","variationId":"116401195"}},{"name":"Thin n Large","id":"124962396","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"37266424","variationId":"124962397"}}]},{"groupId":"37266424","name":"Choose your Crust","variations":[{"name":"Pan","price":379,"default":1,"id":"116401194","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Pan","price":639,"id":"116401195","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Thin n Crispy","price":849,"id":"124962397","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":454,"id":"126057919","isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":738,"id":"126057921","isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266423","variationId":"116401192"},{"groupId":"37266424","variationId":"116401194"}],"price":37900,"addonCombinations":[{"groupId":"133692695","addonId":"112193863"},{"groupId":"133692695","addonId":"112193860"},{"groupId":"133692695","addonId":"112193859"},{"groupId":"133692695","addonId":"115290079"},{"groupId":"133692695","addonId":"112193858"},{"groupId":"133692695","addonId":"112193861"},{"groupId":"133692698","addonId":"112193873"},{"groupId":"133692698","addonId":"112193870"},{"groupId":"133692698","addonId":"112193872"},{"groupId":"133692698","addonId":"112193878"},{"groupId":"133692698","addonId":"112193838"},{"groupId":"133692698","addonId":"112193840"},{"groupId":"133692698","addonId":"112193842"},{"groupId":"133692698","addonId":"112193844"},{"groupId":"133692698","addonId":"112193849"},{"groupId":"133692698","addonId":"112193845"},{"groupId":"133692698","addonId":"112193851"},{"groupId":"133692698","addonId":"112193853"},{"groupId":"151869473","addonId":"112193873"}]},{"variations":[{"groupId":"37266423","variationId":"116401192"},{"groupId":"37266424","variationId":"126057919"}],"price":45400,"addonCombinations":[{"groupId":"133692695","addonId":"112193863"},{"groupId":"133692695","addonId":"112193860"},{"groupId":"133692695","addonId":"112193859"},{"groupId":"133692695","addonId":"115290079"},{"groupId":"133692695","addonId":"112193858"},{"groupId":"133692695","addonId":"112193861"},{"groupId":"133692698","addonId":"112193873"},{"groupId":"133692698","addonId":"112193870"},{"groupId":"133692698","addonId":"112193872"},{"groupId":"133692698","addonId":"112193878"},{"groupId":"133692698","addonId":"112193838"},{"groupId":"133692698","addonId":"112193840"},{"groupId":"133692698","addonId":"112193842"},{"groupId":"133692698","addonId":"112193844"},{"groupId":"133692698","addonId":"112193849"},{"groupId":"133692698","addonId":"112193845"},{"groupId":"133692698","addonId":"112193851"},{"groupId":"133692698","addonId":"112193853"},{"groupId":"151869473","addonId":"112193873"}]},{"variations":[{"groupId":"37266423","variationId":"116401193"},{"groupId":"37266424","variationId":"116401195"}],"price":63900,"addonCombinations":[{"groupId":"133692695","addonId":"112193863"},{"groupId":"133692695","addonId":"112193860"},{"groupId":"133692695","addonId":"112193859"},{"groupId":"133692695","addonId":"115290079"},{"groupId":"133692695","addonId":"112193858"},{"groupId":"133692695","addonId":"112193861"},{"groupId":"151869474","addonId":"117361301"},{"groupId":"133692696","addonId":"112193843"},{"groupId":"133692696","addonId":"112193839"},{"groupId":"133692696","addonId":"112193841"},{"groupId":"133692696","addonId":"112193877"},{"groupId":"133692696","addonId":"112193848"},{"groupId":"133692696","addonId":"112193850"},{"groupId":"133692696","addonId":"112193852"},{"groupId":"133692696","addonId":"112193854"},{"groupId":"133692696","addonId":"112193856"},{"groupId":"133692696","addonId":"112193855"},{"groupId":"133692696","addonId":"112193865"},{"groupId":"133692696","addonId":"112193866"}]},{"variations":[{"groupId":"37266423","variationId":"116401193"},{"groupId":"37266424","variationId":"126057921"}],"price":73800,"addonCombinations":[{"groupId":"133692695","addonId":"112193863"},{"groupId":"133692695","addonId":"112193860"},{"groupId":"133692695","addonId":"112193859"},{"groupId":"133692695","addonId":"115290079"},{"groupId":"133692695","addonId":"112193858"},{"groupId":"133692695","addonId":"112193861"},{"groupId":"151869474","addonId":"117361301"},{"groupId":"133692696","addonId":"112193843"},{"groupId":"133692696","addonId":"112193839"},{"groupId":"133692696","addonId":"112193841"},{"groupId":"133692696","addonId":"112193877"},{"groupId":"133692696","addonId":"112193848"},{"groupId":"133692696","addonId":"112193850"},{"groupId":"133692696","addonId":"112193852"},{"groupId":"133692696","addonId":"112193854"},{"groupId":"133692696","addonId":"112193856"},{"groupId":"133692696","addonId":"112193855"},{"groupId":"133692696","addonId":"112193865"},{"groupId":"133692696","addonId":"112193866"}]},{"variations":[{"groupId":"37266423","variationId":"124962396"},{"groupId":"37266424","variationId":"124962397"}],"price":84900,"addonCombinations":[{"groupId":"133692695","addonId":"112193863"},{"groupId":"133692695","addonId":"112193860"},{"groupId":"133692695","addonId":"112193859"},{"groupId":"133692695","addonId":"115290079"},{"groupId":"133692695","addonId":"112193858"},{"groupId":"133692695","addonId":"112193861"},{"groupId":"151869475","addonId":"114785288"},{"groupId":"140439463","addonId":"114785287"},{"groupId":"140439463","addonId":"114785288"},{"groupId":"140439463","addonId":"114785289"},{"groupId":"140439463","addonId":"114785290"},{"groupId":"140439463","addonId":"114785286"},{"groupId":"140439463","addonId":"114785301"},{"groupId":"140439463","addonId":"114785302"},{"groupId":"140439463","addonId":"114785297"},{"groupId":"140439463","addonId":"114785298"},{"groupId":"140439463","addonId":"114785299"},{"groupId":"140439463","addonId":"114785300"},{"groupId":"140439463","addonId":"114785293"},{"groupId":"140439463","addonId":"114785294"}]}]},"addons":[{"groupId":"151869473","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"151869475","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140439463","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692695","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"133692696","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692698","groupName":"Add. Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193878","name":"Herbed Veggies","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":37900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135326954","name":"Bold BBQ Veggies","category":"Veg Pizza","description":"Serves 1 | Our signature pan sauce, with BBQ Sauce drizzle, topped with mushroom, onion, green capsicum, & red paprika (PAN Per/Med-242 Kcal/100g | TnC-266 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"d4d697a58b3a97a46676fa8712e90ed7","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"39237178","name":"Size","variations":[{"name":"Personal","default":1,"id":"124781099","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"39237179","variationId":"124781102"}},{"name":"Medium","id":"124781100","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"39237179","variationId":"124781103"}},{"name":"Thin n Large","id":"124781101","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"39237179","variationId":"124781104"}}]},{"groupId":"39237179","name":"Choose your Crust","variations":[{"name":"Pan","price":319,"default":1,"id":"124781102","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Pan","price":569,"id":"124781103","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Thin n Crispy","price":749,"id":"124781104","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":394,"id":"126057929","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":668,"id":"126057930","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"39237178","variationId":"124781099"},{"groupId":"39237179","variationId":"124781102"}],"price":31900,"addonCombinations":[{"groupId":"150927376","addonId":"112193873"},{"groupId":"150927376","addonId":"112193870"},{"groupId":"150927376","addonId":"112193872"},{"groupId":"150927376","addonId":"112193878"},{"groupId":"150927376","addonId":"112193838"},{"groupId":"150927376","addonId":"112193840"},{"groupId":"150927376","addonId":"112193842"},{"groupId":"150927376","addonId":"112193844"},{"groupId":"150927376","addonId":"112193849"},{"groupId":"150927376","addonId":"112193845"},{"groupId":"150927376","addonId":"112193851"},{"groupId":"150927376","addonId":"112193853"},{"groupId":"150927372","addonId":"112193873"}]},{"variations":[{"groupId":"39237178","variationId":"124781099"},{"groupId":"39237179","variationId":"126057929"}],"price":39400,"addonCombinations":[{"groupId":"150927376","addonId":"112193873"},{"groupId":"150927376","addonId":"112193870"},{"groupId":"150927376","addonId":"112193872"},{"groupId":"150927376","addonId":"112193878"},{"groupId":"150927376","addonId":"112193838"},{"groupId":"150927376","addonId":"112193840"},{"groupId":"150927376","addonId":"112193842"},{"groupId":"150927376","addonId":"112193844"},{"groupId":"150927376","addonId":"112193849"},{"groupId":"150927376","addonId":"112193845"},{"groupId":"150927376","addonId":"112193851"},{"groupId":"150927376","addonId":"112193853"},{"groupId":"150927372","addonId":"112193873"}]},{"variations":[{"groupId":"39237178","variationId":"124781100"},{"groupId":"39237179","variationId":"124781103"}],"price":56900,"addonCombinations":[{"groupId":"150927373","addonId":"117361301"},{"groupId":"150927375","addonId":"112193843"},{"groupId":"150927375","addonId":"112193839"},{"groupId":"150927375","addonId":"112193841"},{"groupId":"150927375","addonId":"112193877"},{"groupId":"150927375","addonId":"112193848"},{"groupId":"150927375","addonId":"112193850"},{"groupId":"150927375","addonId":"112193852"},{"groupId":"150927375","addonId":"112193854"},{"groupId":"150927375","addonId":"112193856"},{"groupId":"150927375","addonId":"112193855"},{"groupId":"150927375","addonId":"112193865"},{"groupId":"150927375","addonId":"112193866"}]},{"variations":[{"groupId":"39237178","variationId":"124781100"},{"groupId":"39237179","variationId":"126057930"}],"price":66800,"addonCombinations":[{"groupId":"150927373","addonId":"117361301"},{"groupId":"150927375","addonId":"112193843"},{"groupId":"150927375","addonId":"112193839"},{"groupId":"150927375","addonId":"112193841"},{"groupId":"150927375","addonId":"112193877"},{"groupId":"150927375","addonId":"112193848"},{"groupId":"150927375","addonId":"112193850"},{"groupId":"150927375","addonId":"112193852"},{"groupId":"150927375","addonId":"112193854"},{"groupId":"150927375","addonId":"112193856"},{"groupId":"150927375","addonId":"112193855"},{"groupId":"150927375","addonId":"112193865"},{"groupId":"150927375","addonId":"112193866"}]},{"variations":[{"groupId":"39237178","variationId":"124781101"},{"groupId":"39237179","variationId":"124781104"}],"price":74900,"addonCombinations":[{"groupId":"150927374","addonId":"114785288"},{"groupId":"140233255","addonId":"114785287"},{"groupId":"140233255","addonId":"114785288"},{"groupId":"140233255","addonId":"114785289"},{"groupId":"140233255","addonId":"114785290"},{"groupId":"140233255","addonId":"114785286"},{"groupId":"140233255","addonId":"114785301"},{"groupId":"140233255","addonId":"114785302"},{"groupId":"140233255","addonId":"114785297"},{"groupId":"140233255","addonId":"114785298"},{"groupId":"140233255","addonId":"114785299"},{"groupId":"140233255","addonId":"114785300"},{"groupId":"140233255","addonId":"114785293"},{"groupId":"140233255","addonId":"114785294"}]}]},"addons":[{"groupId":"150927372","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"150927374","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140233255","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"150927375","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"150927376","groupName":"Add. Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193878","name":"Herbed Veggies","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":31900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Non Veg Pizza","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859601","name":"Chicken Tikka","category":"Non Veg Pizza","description":"Serves 1 | Mouth-watering chicken tikka, crunchy onion & tomato with delicious tandoori sauce and 100% mozzarella cheese (PAN Per/Med-275 Kcal/100g | TnC-283 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"juplqft4tmub5hqocwxk","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266267","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400632","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266268","variationId":"116400634"}},{"name":"Medium","id":"116400633","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266268","variationId":"116400635"}},{"name":"Thin n Large","id":"124780879","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266268","variationId":"124780881"}}]},{"groupId":"37266268","name":"Choose your Crust","variations":[{"name":"Pan","price":379,"default":1,"id":"116400634","inStock":1,"isEnabled":1},{"name":"Pan","price":639,"id":"116400635","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":454,"id":"116400636","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":738,"id":"116400637","inStock":1,"isEnabled":1},{"name":"Thin n Crispy","price":849,"id":"124780881","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":454,"id":"126057701","isEnabled":1},{"name":"Stuffed Crust - Maxx","price":738,"id":"126057702","isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266267","variationId":"116400632"},{"groupId":"37266268","variationId":"116400634"}],"price":37900,"addonCombinations":[{"groupId":"133692580","addonId":"112193863"},{"groupId":"133692580","addonId":"112193860"},{"groupId":"133692580","addonId":"112193859"},{"groupId":"133692580","addonId":"115290079"},{"groupId":"133692580","addonId":"112193858"},{"groupId":"133692580","addonId":"112193861"},{"groupId":"152144173","addonId":"112193873"},{"groupId":"152144173","addonId":"112193870"},{"groupId":"152144173","addonId":"112193872"},{"groupId":"152144173","addonId":"112193838"},{"groupId":"152144173","addonId":"112193840"},{"groupId":"152144173","addonId":"112193842"},{"groupId":"152144173","addonId":"112193844"},{"groupId":"152144173","addonId":"112193849"},{"groupId":"152144173","addonId":"112193845"},{"groupId":"152144173","addonId":"112193851"},{"groupId":"152144173","addonId":"112193853"},{"groupId":"133692581","addonId":"112193837"},{"groupId":"133692581","addonId":"112193876"},{"groupId":"133692581","addonId":"112193869"},{"groupId":"133692581","addonId":"112193864"},{"groupId":"133692581","addonId":"112193835"},{"groupId":"133692581","addonId":"112193868"},{"groupId":"133692581","addonId":"112193846"},{"groupId":"152144159","addonId":"112193873"}]},{"variations":[{"groupId":"37266267","variationId":"116400632"},{"groupId":"37266268","variationId":"116400636"}],"price":45400,"addonCombinations":[{"groupId":"133692580","addonId":"112193863"},{"groupId":"133692580","addonId":"112193860"},{"groupId":"133692580","addonId":"112193859"},{"groupId":"133692580","addonId":"115290079"},{"groupId":"133692580","addonId":"112193858"},{"groupId":"133692580","addonId":"112193861"},{"groupId":"152144173","addonId":"112193873"},{"groupId":"152144173","addonId":"112193870"},{"groupId":"152144173","addonId":"112193872"},{"groupId":"152144173","addonId":"112193838"},{"groupId":"152144173","addonId":"112193840"},{"groupId":"152144173","addonId":"112193842"},{"groupId":"152144173","addonId":"112193844"},{"groupId":"152144173","addonId":"112193849"},{"groupId":"152144173","addonId":"112193845"},{"groupId":"152144173","addonId":"112193851"},{"groupId":"152144173","addonId":"112193853"},{"groupId":"133692581","addonId":"112193837"},{"groupId":"133692581","addonId":"112193876"},{"groupId":"133692581","addonId":"112193869"},{"groupId":"133692581","addonId":"112193864"},{"groupId":"133692581","addonId":"112193835"},{"groupId":"133692581","addonId":"112193868"},{"groupId":"133692581","addonId":"112193846"},{"groupId":"152144159","addonId":"112193873"}]},{"variations":[{"groupId":"37266267","variationId":"116400632"},{"groupId":"37266268","variationId":"126057701"}],"price":45400,"addonCombinations":[{"groupId":"133692580","addonId":"112193863"},{"groupId":"133692580","addonId":"112193860"},{"groupId":"133692580","addonId":"112193859"},{"groupId":"133692580","addonId":"115290079"},{"groupId":"133692580","addonId":"112193858"},{"groupId":"133692580","addonId":"112193861"},{"groupId":"133692581","addonId":"112193837"},{"groupId":"133692581","addonId":"112193876"},{"groupId":"133692581","addonId":"112193869"},{"groupId":"133692581","addonId":"112193864"},{"groupId":"133692581","addonId":"112193835"},{"groupId":"133692581","addonId":"112193868"},{"groupId":"133692581","addonId":"112193846"}]},{"variations":[{"groupId":"37266267","variationId":"116400633"},{"groupId":"37266268","variationId":"116400635"}],"price":63900,"addonCombinations":[{"groupId":"133692580","addonId":"112193863"},{"groupId":"133692580","addonId":"112193860"},{"groupId":"133692580","addonId":"112193859"},{"groupId":"133692580","addonId":"115290079"},{"groupId":"133692580","addonId":"112193858"},{"groupId":"133692580","addonId":"112193861"},{"groupId":"152144160","addonId":"117361301"},{"groupId":"152144184","addonId":"112193843"},{"groupId":"152144184","addonId":"112193839"},{"groupId":"152144184","addonId":"112193841"},{"groupId":"152144184","addonId":"112193877"},{"groupId":"152144184","addonId":"112193848"},{"groupId":"152144184","addonId":"112193850"},{"groupId":"152144184","addonId":"112193852"},{"groupId":"152144184","addonId":"112193854"},{"groupId":"152144184","addonId":"112193856"},{"groupId":"152144184","addonId":"112193855"},{"groupId":"152144184","addonId":"112193865"},{"groupId":"152144184","addonId":"112193866"},{"groupId":"133692582","addonId":"112193847"},{"groupId":"133692582","addonId":"112193875"},{"groupId":"133692582","addonId":"112193879"},{"groupId":"133692582","addonId":"112193862"},{"groupId":"133692582","addonId":"112193834"},{"groupId":"133692582","addonId":"112193836"},{"groupId":"133692582","addonId":"112193874"}]},{"variations":[{"groupId":"37266267","variationId":"116400633"},{"groupId":"37266268","variationId":"116400637"}],"price":73800,"addonCombinations":[{"groupId":"133692580","addonId":"112193863"},{"groupId":"133692580","addonId":"112193860"},{"groupId":"133692580","addonId":"112193859"},{"groupId":"133692580","addonId":"115290079"},{"groupId":"133692580","addonId":"112193858"},{"groupId":"133692580","addonId":"112193861"},{"groupId":"152144160","addonId":"117361301"},{"groupId":"152144184","addonId":"112193843"},{"groupId":"152144184","addonId":"112193839"},{"groupId":"152144184","addonId":"112193841"},{"groupId":"152144184","addonId":"112193877"},{"groupId":"152144184","addonId":"112193848"},{"groupId":"152144184","addonId":"112193850"},{"groupId":"152144184","addonId":"112193852"},{"groupId":"152144184","addonId":"112193854"},{"groupId":"152144184","addonId":"112193856"},{"groupId":"152144184","addonId":"112193855"},{"groupId":"152144184","addonId":"112193865"},{"groupId":"152144184","addonId":"112193866"},{"groupId":"133692582","addonId":"112193847"},{"groupId":"133692582","addonId":"112193875"},{"groupId":"133692582","addonId":"112193879"},{"groupId":"133692582","addonId":"112193862"},{"groupId":"133692582","addonId":"112193834"},{"groupId":"133692582","addonId":"112193836"},{"groupId":"133692582","addonId":"112193874"}]},{"variations":[{"groupId":"37266267","variationId":"116400633"},{"groupId":"37266268","variationId":"126057702"}],"price":73800,"addonCombinations":[{"groupId":"133692580","addonId":"112193863"},{"groupId":"133692580","addonId":"112193860"},{"groupId":"133692580","addonId":"112193859"},{"groupId":"133692580","addonId":"115290079"},{"groupId":"133692580","addonId":"112193858"},{"groupId":"133692580","addonId":"112193861"},{"groupId":"152144160","addonId":"117361301"},{"groupId":"152144184","addonId":"112193843"},{"groupId":"152144184","addonId":"112193839"},{"groupId":"152144184","addonId":"112193841"},{"groupId":"152144184","addonId":"112193877"},{"groupId":"152144184","addonId":"112193848"},{"groupId":"152144184","addonId":"112193850"},{"groupId":"152144184","addonId":"112193852"},{"groupId":"152144184","addonId":"112193854"},{"groupId":"152144184","addonId":"112193856"},{"groupId":"152144184","addonId":"112193855"},{"groupId":"152144184","addonId":"112193865"},{"groupId":"152144184","addonId":"112193866"},{"groupId":"133692582","addonId":"112193847"},{"groupId":"133692582","addonId":"112193875"},{"groupId":"133692582","addonId":"112193879"},{"groupId":"133692582","addonId":"112193862"},{"groupId":"133692582","addonId":"112193834"},{"groupId":"133692582","addonId":"112193836"},{"groupId":"133692582","addonId":"112193874"}]},{"variations":[{"groupId":"37266267","variationId":"124780879"},{"groupId":"37266268","variationId":"124780881"}],"price":84900,"addonCombinations":[{"groupId":"133692580","addonId":"112193863"},{"groupId":"133692580","addonId":"112193860"},{"groupId":"133692580","addonId":"112193859"},{"groupId":"133692580","addonId":"115290079"},{"groupId":"133692580","addonId":"112193858"},{"groupId":"133692580","addonId":"112193861"},{"groupId":"152144161","addonId":"114785288"},{"groupId":"152144166","addonId":"114785287"},{"groupId":"152144166","addonId":"114785288"},{"groupId":"152144166","addonId":"114785289"},{"groupId":"152144166","addonId":"114785290"},{"groupId":"152144166","addonId":"114785286"},{"groupId":"152144166","addonId":"114785301"},{"groupId":"152144166","addonId":"114785302"},{"groupId":"152144166","addonId":"114785297"},{"groupId":"152144166","addonId":"114785298"},{"groupId":"152144166","addonId":"114785299"},{"groupId":"152144166","addonId":"114785300"},{"groupId":"152144166","addonId":"114785293"},{"groupId":"152144166","addonId":"114785294"},{"groupId":"140233218","addonId":"114785291"},{"groupId":"140233218","addonId":"114785295"},{"groupId":"140233218","addonId":"114785296"},{"groupId":"140233218","addonId":"114785305"},{"groupId":"140233218","addonId":"114785306"},{"groupId":"140233218","addonId":"114785307"},{"groupId":"140233218","addonId":"114785304"}]}]},"addons":[{"groupId":"152144159","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"152144161","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140233218","groupName":"Add Non Veg Toppings","choices":[{"id":"114785291","name":"Chicken Keema Masala","price":9900,"inStock":1,"isEnabled":1},{"id":"114785295","name":"Chicken Malai Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785296","name":"Chicken Pepperoni","price":9900,"inStock":1,"isEnabled":1},{"id":"114785305","name":"Chicken sausage","price":9900,"inStock":1,"isEnabled":1},{"id":"114785306","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785307","name":"Herbed Chicken","price":9900,"inStock":1,"isEnabled":1},{"id":"114785304","name":"Schezwan Chicken Meatball","price":9900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144166","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144173","groupName":"Add Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692581","groupName":"Add Non-Veg Toppings","choices":[{"id":"112193837","name":"Chicken Pepperoni","price":6500,"inStock":1,"isEnabled":1},{"id":"112193876","name":"Chicken Sausage","price":6500,"inStock":1,"isEnabled":1},{"id":"112193869","name":"Chicken Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193864","name":"Chicken Malai Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193835","name":"Herbed Chicken","price":6500,"inStock":1,"isEnabled":1},{"id":"112193868","name":"Schezwan Chicken Meatball","price":6500,"inStock":1,"isEnabled":1},{"id":"112193846","name":"Chicken Keema Masala","price":6000,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692580","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"152144184","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692582","groupName":"Add. Non-Veg Toppings","choices":[{"id":"112193847","name":"Chicken Pepperoni","price":8500,"inStock":1,"isEnabled":1},{"id":"112193875","name":"Chicken Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193879","name":"Chicken Sausage","price":8500,"inStock":1,"isEnabled":1},{"id":"112193862","name":"Chicken Malai Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193834","name":"Herbed Chicken","price":8500,"inStock":1,"isEnabled":1},{"id":"112193836","name":"Chicken Keema Masala","price":8000,"inStock":1,"isEnabled":1},{"id":"112193874","name":"Schezwan Chicken Meatball","price":8500,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":37900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.8","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859603","name":"Chicken Tikka Supreme","category":"Non Veg Pizza","description":"Serves 1 | A divine combination of delicious chicken tikka & malai chicken tikka, onion, spicy red paprika with flavourful pan sauce and 100% mozzarella cheese (PAN Per/Med-267 Kcal/100g |TnC-274 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"d3bnas8nxt9dr13jhipu","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266271","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400648","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266272","variationId":"116400650"}},{"name":"Medium","id":"116400649","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266272","variationId":"116400651"}},{"name":"Thin n Large","id":"124780658","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266272","variationId":"124780662"}}]},{"groupId":"37266272","name":"Choose your Crust","variations":[{"name":"Pan","price":409,"default":1,"id":"116400650","inStock":1,"isEnabled":1},{"name":"Pan","price":699,"id":"116400651","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":484,"id":"116400652","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":798,"id":"116400653","inStock":1,"isEnabled":1},{"name":"Thin n Crispy","price":949,"id":"124780662","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":484,"id":"126057825","isEnabled":1},{"name":"Stuffed Crust - Maxx","price":798,"id":"126057826","isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266271","variationId":"116400648"},{"groupId":"37266272","variationId":"116400650"}],"price":40900,"addonCombinations":[{"groupId":"133692586","addonId":"112193863"},{"groupId":"133692586","addonId":"112193860"},{"groupId":"133692586","addonId":"112193859"},{"groupId":"133692586","addonId":"115290079"},{"groupId":"133692586","addonId":"112193858"},{"groupId":"133692586","addonId":"112193861"},{"groupId":"152144687","addonId":"112193873"},{"groupId":"152144687","addonId":"112193870"},{"groupId":"152144687","addonId":"112193872"},{"groupId":"152144687","addonId":"112193838"},{"groupId":"152144687","addonId":"112193840"},{"groupId":"152144687","addonId":"112193842"},{"groupId":"152144687","addonId":"112193844"},{"groupId":"152144687","addonId":"112193849"},{"groupId":"152144687","addonId":"112193845"},{"groupId":"152144687","addonId":"112193851"},{"groupId":"152144687","addonId":"112193853"},{"groupId":"133692587","addonId":"112193837"},{"groupId":"133692587","addonId":"112193876"},{"groupId":"133692587","addonId":"112193869"},{"groupId":"133692587","addonId":"112193864"},{"groupId":"133692587","addonId":"112193835"},{"groupId":"133692587","addonId":"112193868"},{"groupId":"133692587","addonId":"112193846"},{"groupId":"152144679","addonId":"112193873"}]},{"variations":[{"groupId":"37266271","variationId":"116400648"},{"groupId":"37266272","variationId":"116400652"}],"price":48400,"addonCombinations":[{"groupId":"133692586","addonId":"112193863"},{"groupId":"133692586","addonId":"112193860"},{"groupId":"133692586","addonId":"112193859"},{"groupId":"133692586","addonId":"115290079"},{"groupId":"133692586","addonId":"112193858"},{"groupId":"133692586","addonId":"112193861"},{"groupId":"152144687","addonId":"112193873"},{"groupId":"152144687","addonId":"112193870"},{"groupId":"152144687","addonId":"112193872"},{"groupId":"152144687","addonId":"112193838"},{"groupId":"152144687","addonId":"112193840"},{"groupId":"152144687","addonId":"112193842"},{"groupId":"152144687","addonId":"112193844"},{"groupId":"152144687","addonId":"112193849"},{"groupId":"152144687","addonId":"112193845"},{"groupId":"152144687","addonId":"112193851"},{"groupId":"152144687","addonId":"112193853"},{"groupId":"133692587","addonId":"112193837"},{"groupId":"133692587","addonId":"112193876"},{"groupId":"133692587","addonId":"112193869"},{"groupId":"133692587","addonId":"112193864"},{"groupId":"133692587","addonId":"112193835"},{"groupId":"133692587","addonId":"112193868"},{"groupId":"133692587","addonId":"112193846"},{"groupId":"152144679","addonId":"112193873"}]},{"variations":[{"groupId":"37266271","variationId":"116400648"},{"groupId":"37266272","variationId":"126057825"}],"price":48400,"addonCombinations":[{"groupId":"133692586","addonId":"112193863"},{"groupId":"133692586","addonId":"112193860"},{"groupId":"133692586","addonId":"112193859"},{"groupId":"133692586","addonId":"115290079"},{"groupId":"133692586","addonId":"112193858"},{"groupId":"133692586","addonId":"112193861"},{"groupId":"152144687","addonId":"112193873"},{"groupId":"152144687","addonId":"112193870"},{"groupId":"152144687","addonId":"112193872"},{"groupId":"152144687","addonId":"112193838"},{"groupId":"152144687","addonId":"112193840"},{"groupId":"152144687","addonId":"112193842"},{"groupId":"152144687","addonId":"112193844"},{"groupId":"152144687","addonId":"112193849"},{"groupId":"152144687","addonId":"112193845"},{"groupId":"152144687","addonId":"112193851"},{"groupId":"152144687","addonId":"112193853"},{"groupId":"133692587","addonId":"112193837"},{"groupId":"133692587","addonId":"112193876"},{"groupId":"133692587","addonId":"112193869"},{"groupId":"133692587","addonId":"112193864"},{"groupId":"133692587","addonId":"112193835"},{"groupId":"133692587","addonId":"112193868"},{"groupId":"133692587","addonId":"112193846"},{"groupId":"152144679","addonId":"112193873"}]},{"variations":[{"groupId":"37266271","variationId":"116400649"},{"groupId":"37266272","variationId":"116400651"}],"price":69900,"addonCombinations":[{"groupId":"133692586","addonId":"112193863"},{"groupId":"133692586","addonId":"112193860"},{"groupId":"133692586","addonId":"112193859"},{"groupId":"133692586","addonId":"115290079"},{"groupId":"133692586","addonId":"112193858"},{"groupId":"133692586","addonId":"112193861"},{"groupId":"152144681","addonId":"117361301"},{"groupId":"152144691","addonId":"112193843"},{"groupId":"152144691","addonId":"112193839"},{"groupId":"152144691","addonId":"112193841"},{"groupId":"152144691","addonId":"112193877"},{"groupId":"152144691","addonId":"112193848"},{"groupId":"152144691","addonId":"112193850"},{"groupId":"152144691","addonId":"112193852"},{"groupId":"152144691","addonId":"112193854"},{"groupId":"152144691","addonId":"112193856"},{"groupId":"152144691","addonId":"112193855"},{"groupId":"152144691","addonId":"112193865"},{"groupId":"152144691","addonId":"112193866"},{"groupId":"133692588","addonId":"112193847"},{"groupId":"133692588","addonId":"112193875"},{"groupId":"133692588","addonId":"112193879"},{"groupId":"133692588","addonId":"112193862"},{"groupId":"133692588","addonId":"112193834"},{"groupId":"133692588","addonId":"112193836"},{"groupId":"133692588","addonId":"112193874"}]},{"variations":[{"groupId":"37266271","variationId":"116400649"},{"groupId":"37266272","variationId":"116400653"}],"price":79800,"addonCombinations":[{"groupId":"133692586","addonId":"112193863"},{"groupId":"133692586","addonId":"112193860"},{"groupId":"133692586","addonId":"112193859"},{"groupId":"133692586","addonId":"115290079"},{"groupId":"133692586","addonId":"112193858"},{"groupId":"133692586","addonId":"112193861"},{"groupId":"152144681","addonId":"117361301"},{"groupId":"152144691","addonId":"112193843"},{"groupId":"152144691","addonId":"112193839"},{"groupId":"152144691","addonId":"112193841"},{"groupId":"152144691","addonId":"112193877"},{"groupId":"152144691","addonId":"112193848"},{"groupId":"152144691","addonId":"112193850"},{"groupId":"152144691","addonId":"112193852"},{"groupId":"152144691","addonId":"112193854"},{"groupId":"152144691","addonId":"112193856"},{"groupId":"152144691","addonId":"112193855"},{"groupId":"152144691","addonId":"112193865"},{"groupId":"152144691","addonId":"112193866"},{"groupId":"133692588","addonId":"112193847"},{"groupId":"133692588","addonId":"112193875"},{"groupId":"133692588","addonId":"112193879"},{"groupId":"133692588","addonId":"112193862"},{"groupId":"133692588","addonId":"112193834"},{"groupId":"133692588","addonId":"112193836"},{"groupId":"133692588","addonId":"112193874"}]},{"variations":[{"groupId":"37266271","variationId":"116400649"},{"groupId":"37266272","variationId":"126057826"}],"price":79800,"addonCombinations":[{"groupId":"133692586","addonId":"112193863"},{"groupId":"133692586","addonId":"112193860"},{"groupId":"133692586","addonId":"112193859"},{"groupId":"133692586","addonId":"115290079"},{"groupId":"133692586","addonId":"112193858"},{"groupId":"133692586","addonId":"112193861"},{"groupId":"152144681","addonId":"117361301"},{"groupId":"152144691","addonId":"112193843"},{"groupId":"152144691","addonId":"112193839"},{"groupId":"152144691","addonId":"112193841"},{"groupId":"152144691","addonId":"112193877"},{"groupId":"152144691","addonId":"112193848"},{"groupId":"152144691","addonId":"112193850"},{"groupId":"152144691","addonId":"112193852"},{"groupId":"152144691","addonId":"112193854"},{"groupId":"152144691","addonId":"112193856"},{"groupId":"152144691","addonId":"112193855"},{"groupId":"152144691","addonId":"112193865"},{"groupId":"152144691","addonId":"112193866"},{"groupId":"133692588","addonId":"112193847"},{"groupId":"133692588","addonId":"112193875"},{"groupId":"133692588","addonId":"112193879"},{"groupId":"133692588","addonId":"112193862"},{"groupId":"133692588","addonId":"112193834"},{"groupId":"133692588","addonId":"112193836"},{"groupId":"133692588","addonId":"112193874"}]},{"variations":[{"groupId":"37266271","variationId":"124780658"},{"groupId":"37266272","variationId":"124780662"}],"price":94900,"addonCombinations":[{"groupId":"133692586","addonId":"112193863"},{"groupId":"133692586","addonId":"112193860"},{"groupId":"133692586","addonId":"112193859"},{"groupId":"133692586","addonId":"115290079"},{"groupId":"133692586","addonId":"112193858"},{"groupId":"133692586","addonId":"112193861"},{"groupId":"152144683","addonId":"114785288"},{"groupId":"152144685","addonId":"114785287"},{"groupId":"152144685","addonId":"114785288"},{"groupId":"152144685","addonId":"114785289"},{"groupId":"152144685","addonId":"114785290"},{"groupId":"152144685","addonId":"114785286"},{"groupId":"152144685","addonId":"114785301"},{"groupId":"152144685","addonId":"114785302"},{"groupId":"152144685","addonId":"114785297"},{"groupId":"152144685","addonId":"114785298"},{"groupId":"152144685","addonId":"114785299"},{"groupId":"152144685","addonId":"114785300"},{"groupId":"152144685","addonId":"114785293"},{"groupId":"152144685","addonId":"114785294"},{"groupId":"140233178","addonId":"114785291"},{"groupId":"140233178","addonId":"114785295"},{"groupId":"140233178","addonId":"114785296"},{"groupId":"140233178","addonId":"114785305"},{"groupId":"140233178","addonId":"114785306"},{"groupId":"140233178","addonId":"114785307"},{"groupId":"140233178","addonId":"114785304"}]}]},"addons":[{"groupId":"152144679","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"152144683","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140233178","groupName":"Add Non Veg Toppings","choices":[{"id":"114785291","name":"Chicken Keema Masala","price":9900,"inStock":1,"isEnabled":1},{"id":"114785295","name":"Chicken Malai Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785296","name":"Chicken Pepperoni","price":9900,"inStock":1,"isEnabled":1},{"id":"114785305","name":"Chicken sausage","price":9900,"inStock":1,"isEnabled":1},{"id":"114785306","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785307","name":"Herbed Chicken","price":9900,"inStock":1,"isEnabled":1},{"id":"114785304","name":"Schezwan Chicken Meatball","price":9900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144685","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144687","groupName":"Add Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692587","groupName":"Add Non-Veg Toppings","choices":[{"id":"112193837","name":"Chicken Pepperoni","price":6500,"inStock":1,"isEnabled":1},{"id":"112193876","name":"Chicken Sausage","price":6500,"inStock":1,"isEnabled":1},{"id":"112193869","name":"Chicken Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193864","name":"Chicken Malai Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193835","name":"Herbed Chicken","price":6500,"inStock":1,"isEnabled":1},{"id":"112193868","name":"Schezwan Chicken Meatball","price":6500,"inStock":1,"isEnabled":1},{"id":"112193846","name":"Chicken Keema Masala","price":6000,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692586","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"152144691","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692588","groupName":"Add. Non-Veg Toppings","choices":[{"id":"112193847","name":"Chicken Pepperoni","price":8500,"inStock":1,"isEnabled":1},{"id":"112193875","name":"Chicken Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193879","name":"Chicken Sausage","price":8500,"inStock":1,"isEnabled":1},{"id":"112193862","name":"Chicken Malai Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193834","name":"Herbed Chicken","price":8500,"inStock":1,"isEnabled":1},{"id":"112193836","name":"Chicken Keema Masala","price":8000,"inStock":1,"isEnabled":1},{"id":"112193874","name":"Schezwan Chicken Meatball","price":8500,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":40900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.7","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859600","name":"Murg Malai Chicken","category":"Non Veg Pizza","description":"Serves 1 | Amazingly flavourful chicken malai tikka, herbed onion & green capsicum, spicy red paprika with flavourful pan sauce and 100% mozzarella cheese (PAN Per/Med-269 Kcal/100g | TnC-299 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"t1stinhga3alitdpr6yt","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266265","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400624","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266266","variationId":"116400626"}},{"name":"Medium","id":"116400625","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266266","variationId":"116400627"}},{"name":"Thin n Large","id":"124780555","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266266","variationId":"124780556"}}]},{"groupId":"37266266","name":"Choose your Crust","variations":[{"name":"Pan","price":379,"default":1,"id":"116400626","inStock":1,"isEnabled":1},{"name":"Pan","price":639,"id":"116400627","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":454,"id":"116400628","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":738,"id":"116400629","inStock":1,"isEnabled":1},{"name":"Thin n Crispy","price":849,"id":"124780556","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":454,"id":"126057911","isEnabled":1},{"name":"Stuffed Crust - Maxx","price":738,"id":"126057912","isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266265","variationId":"116400624"},{"groupId":"37266266","variationId":"116400626"}],"price":37900,"addonCombinations":[{"groupId":"133692577","addonId":"112193863"},{"groupId":"133692577","addonId":"112193860"},{"groupId":"133692577","addonId":"112193859"},{"groupId":"133692577","addonId":"115290079"},{"groupId":"133692577","addonId":"112193858"},{"groupId":"133692577","addonId":"112193861"},{"groupId":"152143991","addonId":"112193873"},{"groupId":"152143991","addonId":"112193870"},{"groupId":"152143991","addonId":"112193872"},{"groupId":"152143991","addonId":"112193838"},{"groupId":"152143991","addonId":"112193840"},{"groupId":"152143991","addonId":"112193842"},{"groupId":"152143991","addonId":"112193844"},{"groupId":"152143991","addonId":"112193849"},{"groupId":"152143991","addonId":"112193845"},{"groupId":"152143991","addonId":"112193851"},{"groupId":"152143991","addonId":"112193853"},{"groupId":"133692578","addonId":"112193837"},{"groupId":"133692578","addonId":"112193876"},{"groupId":"133692578","addonId":"112193869"},{"groupId":"133692578","addonId":"112193864"},{"groupId":"133692578","addonId":"112193835"},{"groupId":"133692578","addonId":"112193868"},{"groupId":"133692578","addonId":"112193846"},{"groupId":"152143987","addonId":"112193873"}]},{"variations":[{"groupId":"37266265","variationId":"116400624"},{"groupId":"37266266","variationId":"116400628"}],"price":45400,"addonCombinations":[{"groupId":"133692577","addonId":"112193863"},{"groupId":"133692577","addonId":"112193860"},{"groupId":"133692577","addonId":"112193859"},{"groupId":"133692577","addonId":"115290079"},{"groupId":"133692577","addonId":"112193858"},{"groupId":"133692577","addonId":"112193861"},{"groupId":"152143991","addonId":"112193873"},{"groupId":"152143991","addonId":"112193870"},{"groupId":"152143991","addonId":"112193872"},{"groupId":"152143991","addonId":"112193838"},{"groupId":"152143991","addonId":"112193840"},{"groupId":"152143991","addonId":"112193842"},{"groupId":"152143991","addonId":"112193844"},{"groupId":"152143991","addonId":"112193849"},{"groupId":"152143991","addonId":"112193845"},{"groupId":"152143991","addonId":"112193851"},{"groupId":"152143991","addonId":"112193853"},{"groupId":"133692578","addonId":"112193837"},{"groupId":"133692578","addonId":"112193876"},{"groupId":"133692578","addonId":"112193869"},{"groupId":"133692578","addonId":"112193864"},{"groupId":"133692578","addonId":"112193835"},{"groupId":"133692578","addonId":"112193868"},{"groupId":"133692578","addonId":"112193846"},{"groupId":"152143987","addonId":"112193873"}]},{"variations":[{"groupId":"37266265","variationId":"116400624"},{"groupId":"37266266","variationId":"126057911"}],"price":45400,"addonCombinations":[{"groupId":"133692577","addonId":"112193863"},{"groupId":"133692577","addonId":"112193860"},{"groupId":"133692577","addonId":"112193859"},{"groupId":"133692577","addonId":"115290079"},{"groupId":"133692577","addonId":"112193858"},{"groupId":"133692577","addonId":"112193861"},{"groupId":"152143991","addonId":"112193873"},{"groupId":"152143991","addonId":"112193870"},{"groupId":"152143991","addonId":"112193872"},{"groupId":"152143991","addonId":"112193838"},{"groupId":"152143991","addonId":"112193840"},{"groupId":"152143991","addonId":"112193842"},{"groupId":"152143991","addonId":"112193844"},{"groupId":"152143991","addonId":"112193849"},{"groupId":"152143991","addonId":"112193845"},{"groupId":"152143991","addonId":"112193851"},{"groupId":"152143991","addonId":"112193853"},{"groupId":"133692578","addonId":"112193837"},{"groupId":"133692578","addonId":"112193876"},{"groupId":"133692578","addonId":"112193869"},{"groupId":"133692578","addonId":"112193864"},{"groupId":"133692578","addonId":"112193835"},{"groupId":"133692578","addonId":"112193868"},{"groupId":"133692578","addonId":"112193846"},{"groupId":"152143987","addonId":"112193873"}]},{"variations":[{"groupId":"37266265","variationId":"116400625"},{"groupId":"37266266","variationId":"116400627"}],"price":63900,"addonCombinations":[{"groupId":"133692577","addonId":"112193863"},{"groupId":"133692577","addonId":"112193860"},{"groupId":"133692577","addonId":"112193859"},{"groupId":"133692577","addonId":"115290079"},{"groupId":"133692577","addonId":"112193858"},{"groupId":"133692577","addonId":"112193861"},{"groupId":"152143988","addonId":"117361301"},{"groupId":"152143994","addonId":"112193843"},{"groupId":"152143994","addonId":"112193839"},{"groupId":"152143994","addonId":"112193841"},{"groupId":"152143994","addonId":"112193877"},{"groupId":"152143994","addonId":"112193848"},{"groupId":"152143994","addonId":"112193850"},{"groupId":"152143994","addonId":"112193852"},{"groupId":"152143994","addonId":"112193854"},{"groupId":"152143994","addonId":"112193856"},{"groupId":"152143994","addonId":"112193855"},{"groupId":"152143994","addonId":"112193865"},{"groupId":"152143994","addonId":"112193866"},{"groupId":"133692579","addonId":"112193847"},{"groupId":"133692579","addonId":"112193875"},{"groupId":"133692579","addonId":"112193879"},{"groupId":"133692579","addonId":"112193862"},{"groupId":"133692579","addonId":"112193834"},{"groupId":"133692579","addonId":"112193836"},{"groupId":"133692579","addonId":"112193874"}]},{"variations":[{"groupId":"37266265","variationId":"116400625"},{"groupId":"37266266","variationId":"116400629"}],"price":73800,"addonCombinations":[{"groupId":"133692577","addonId":"112193863"},{"groupId":"133692577","addonId":"112193860"},{"groupId":"133692577","addonId":"112193859"},{"groupId":"133692577","addonId":"115290079"},{"groupId":"133692577","addonId":"112193858"},{"groupId":"133692577","addonId":"112193861"},{"groupId":"152143988","addonId":"117361301"},{"groupId":"152143994","addonId":"112193843"},{"groupId":"152143994","addonId":"112193839"},{"groupId":"152143994","addonId":"112193841"},{"groupId":"152143994","addonId":"112193877"},{"groupId":"152143994","addonId":"112193848"},{"groupId":"152143994","addonId":"112193850"},{"groupId":"152143994","addonId":"112193852"},{"groupId":"152143994","addonId":"112193854"},{"groupId":"152143994","addonId":"112193856"},{"groupId":"152143994","addonId":"112193855"},{"groupId":"152143994","addonId":"112193865"},{"groupId":"152143994","addonId":"112193866"},{"groupId":"133692579","addonId":"112193847"},{"groupId":"133692579","addonId":"112193875"},{"groupId":"133692579","addonId":"112193879"},{"groupId":"133692579","addonId":"112193862"},{"groupId":"133692579","addonId":"112193834"},{"groupId":"133692579","addonId":"112193836"},{"groupId":"133692579","addonId":"112193874"}]},{"variations":[{"groupId":"37266265","variationId":"116400625"},{"groupId":"37266266","variationId":"126057912"}],"price":73800,"addonCombinations":[{"groupId":"133692577","addonId":"112193863"},{"groupId":"133692577","addonId":"112193860"},{"groupId":"133692577","addonId":"112193859"},{"groupId":"133692577","addonId":"115290079"},{"groupId":"133692577","addonId":"112193858"},{"groupId":"133692577","addonId":"112193861"},{"groupId":"152143988","addonId":"117361301"},{"groupId":"152143994","addonId":"112193843"},{"groupId":"152143994","addonId":"112193839"},{"groupId":"152143994","addonId":"112193841"},{"groupId":"152143994","addonId":"112193877"},{"groupId":"152143994","addonId":"112193848"},{"groupId":"152143994","addonId":"112193850"},{"groupId":"152143994","addonId":"112193852"},{"groupId":"152143994","addonId":"112193854"},{"groupId":"152143994","addonId":"112193856"},{"groupId":"152143994","addonId":"112193855"},{"groupId":"152143994","addonId":"112193865"},{"groupId":"152143994","addonId":"112193866"},{"groupId":"133692579","addonId":"112193847"},{"groupId":"133692579","addonId":"112193875"},{"groupId":"133692579","addonId":"112193879"},{"groupId":"133692579","addonId":"112193862"},{"groupId":"133692579","addonId":"112193834"},{"groupId":"133692579","addonId":"112193836"},{"groupId":"133692579","addonId":"112193874"}]},{"variations":[{"groupId":"37266265","variationId":"124780555"},{"groupId":"37266266","variationId":"124780556"}],"price":84900,"addonCombinations":[{"groupId":"133692577","addonId":"112193863"},{"groupId":"133692577","addonId":"112193860"},{"groupId":"133692577","addonId":"112193859"},{"groupId":"133692577","addonId":"115290079"},{"groupId":"133692577","addonId":"112193858"},{"groupId":"133692577","addonId":"112193861"},{"groupId":"152143989","addonId":"114785288"},{"groupId":"152143990","addonId":"114785287"},{"groupId":"152143990","addonId":"114785288"},{"groupId":"152143990","addonId":"114785289"},{"groupId":"152143990","addonId":"114785290"},{"groupId":"152143990","addonId":"114785286"},{"groupId":"152143990","addonId":"114785301"},{"groupId":"152143990","addonId":"114785302"},{"groupId":"152143990","addonId":"114785297"},{"groupId":"152143990","addonId":"114785298"},{"groupId":"152143990","addonId":"114785299"},{"groupId":"152143990","addonId":"114785300"},{"groupId":"152143990","addonId":"114785293"},{"groupId":"152143990","addonId":"114785294"},{"groupId":"140233165","addonId":"114785291"},{"groupId":"140233165","addonId":"114785295"},{"groupId":"140233165","addonId":"114785296"},{"groupId":"140233165","addonId":"114785305"},{"groupId":"140233165","addonId":"114785306"},{"groupId":"140233165","addonId":"114785307"},{"groupId":"140233165","addonId":"114785304"}]}]},"addons":[{"groupId":"152143987","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"152143989","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140233165","groupName":"Add Non Veg Toppings","choices":[{"id":"114785291","name":"Chicken Keema Masala","price":9900,"inStock":1,"isEnabled":1},{"id":"114785295","name":"Chicken Malai Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785296","name":"Chicken Pepperoni","price":9900,"inStock":1,"isEnabled":1},{"id":"114785305","name":"Chicken sausage","price":9900,"inStock":1,"isEnabled":1},{"id":"114785306","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785307","name":"Herbed Chicken","price":9900,"inStock":1,"isEnabled":1},{"id":"114785304","name":"Schezwan Chicken Meatball","price":9900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152143990","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152143991","groupName":"Add Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692578","groupName":"Add Non-Veg Toppings","choices":[{"id":"112193837","name":"Chicken Pepperoni","price":6500,"inStock":1,"isEnabled":1},{"id":"112193876","name":"Chicken Sausage","price":6500,"inStock":1,"isEnabled":1},{"id":"112193869","name":"Chicken Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193864","name":"Chicken Malai Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193835","name":"Herbed Chicken","price":6500,"inStock":1,"isEnabled":1},{"id":"112193868","name":"Schezwan Chicken Meatball","price":6500,"inStock":1,"isEnabled":1},{"id":"112193846","name":"Chicken Keema Masala","price":6000,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692577","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"152143994","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692579","groupName":"Add. Non-Veg Toppings","choices":[{"id":"112193847","name":"Chicken Pepperoni","price":8500,"inStock":1,"isEnabled":1},{"id":"112193875","name":"Chicken Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193879","name":"Chicken Sausage","price":8500,"inStock":1,"isEnabled":1},{"id":"112193862","name":"Chicken Malai Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193834","name":"Herbed Chicken","price":8500,"inStock":1,"isEnabled":1},{"id":"112193836","name":"Chicken Keema Masala","price":8000,"inStock":1,"isEnabled":1},{"id":"112193874","name":"Schezwan Chicken Meatball","price":8500,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":37900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859604","name":"Chicken Supreme","category":"Non Veg Pizza","description":"Serves 1 | Loaded with delicious chicken tikka, flavourful herbed chicken, spicy schezwan chicken meatball with flavourful pan sauce and 100% mozzarella cheese. (PAN Per/Med-273 Kcal/100g | TnC-284 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"dlvdmsn1uotbdn4vzvap","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266273","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400656","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266274","variationId":"116400658"}},{"name":"Medium","id":"116400657","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266274","variationId":"116400659"}},{"name":"Thin n Large","id":"124780636","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266274","variationId":"124780638"}}]},{"groupId":"37266274","name":"Choose your Crust","variations":[{"name":"Pan","price":409,"default":1,"id":"116400658","inStock":1,"isEnabled":1},{"name":"Pan","price":699,"id":"116400659","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":484,"id":"116400660","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":798,"id":"116400661","inStock":1,"isEnabled":1},{"name":"Thin n Crispy","price":949,"id":"124780638","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":484,"id":"126057559","isEnabled":1},{"name":"Stuffed Crust - Maxx","price":798,"id":"126057560","isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266273","variationId":"116400656"},{"groupId":"37266274","variationId":"116400658"}],"price":40900,"addonCombinations":[{"groupId":"133692589","addonId":"112193863"},{"groupId":"133692589","addonId":"112193860"},{"groupId":"133692589","addonId":"112193859"},{"groupId":"133692589","addonId":"115290079"},{"groupId":"133692589","addonId":"112193858"},{"groupId":"133692589","addonId":"112193861"},{"groupId":"152144551","addonId":"112193873"},{"groupId":"152144551","addonId":"112193870"},{"groupId":"152144551","addonId":"112193872"},{"groupId":"152144551","addonId":"112193838"},{"groupId":"152144551","addonId":"112193840"},{"groupId":"152144551","addonId":"112193842"},{"groupId":"152144551","addonId":"112193844"},{"groupId":"152144551","addonId":"112193849"},{"groupId":"152144551","addonId":"112193845"},{"groupId":"152144551","addonId":"112193851"},{"groupId":"152144551","addonId":"112193853"},{"groupId":"133692590","addonId":"112193837"},{"groupId":"133692590","addonId":"112193876"},{"groupId":"133692590","addonId":"112193869"},{"groupId":"133692590","addonId":"112193864"},{"groupId":"133692590","addonId":"112193835"},{"groupId":"133692590","addonId":"112193868"},{"groupId":"133692590","addonId":"112193846"},{"groupId":"152144540","addonId":"112193873"}]},{"variations":[{"groupId":"37266273","variationId":"116400656"},{"groupId":"37266274","variationId":"116400660"}],"price":48400,"addonCombinations":[{"groupId":"133692589","addonId":"112193863"},{"groupId":"133692589","addonId":"112193860"},{"groupId":"133692589","addonId":"112193859"},{"groupId":"133692589","addonId":"115290079"},{"groupId":"133692589","addonId":"112193858"},{"groupId":"133692589","addonId":"112193861"},{"groupId":"152144551","addonId":"112193873"},{"groupId":"152144551","addonId":"112193870"},{"groupId":"152144551","addonId":"112193872"},{"groupId":"152144551","addonId":"112193838"},{"groupId":"152144551","addonId":"112193840"},{"groupId":"152144551","addonId":"112193842"},{"groupId":"152144551","addonId":"112193844"},{"groupId":"152144551","addonId":"112193849"},{"groupId":"152144551","addonId":"112193845"},{"groupId":"152144551","addonId":"112193851"},{"groupId":"152144551","addonId":"112193853"},{"groupId":"133692590","addonId":"112193837"},{"groupId":"133692590","addonId":"112193876"},{"groupId":"133692590","addonId":"112193869"},{"groupId":"133692590","addonId":"112193864"},{"groupId":"133692590","addonId":"112193835"},{"groupId":"133692590","addonId":"112193868"},{"groupId":"133692590","addonId":"112193846"},{"groupId":"152144540","addonId":"112193873"}]},{"variations":[{"groupId":"37266273","variationId":"116400656"},{"groupId":"37266274","variationId":"126057559"}],"price":48400,"addonCombinations":[{"groupId":"133692589","addonId":"112193863"},{"groupId":"133692589","addonId":"112193860"},{"groupId":"133692589","addonId":"112193859"},{"groupId":"133692589","addonId":"115290079"},{"groupId":"133692589","addonId":"112193858"},{"groupId":"133692589","addonId":"112193861"},{"groupId":"152144551","addonId":"112193873"},{"groupId":"152144551","addonId":"112193870"},{"groupId":"152144551","addonId":"112193872"},{"groupId":"152144551","addonId":"112193838"},{"groupId":"152144551","addonId":"112193840"},{"groupId":"152144551","addonId":"112193842"},{"groupId":"152144551","addonId":"112193844"},{"groupId":"152144551","addonId":"112193849"},{"groupId":"152144551","addonId":"112193845"},{"groupId":"152144551","addonId":"112193851"},{"groupId":"152144551","addonId":"112193853"},{"groupId":"133692590","addonId":"112193837"},{"groupId":"133692590","addonId":"112193876"},{"groupId":"133692590","addonId":"112193869"},{"groupId":"133692590","addonId":"112193864"},{"groupId":"133692590","addonId":"112193835"},{"groupId":"133692590","addonId":"112193868"},{"groupId":"133692590","addonId":"112193846"},{"groupId":"152144540","addonId":"112193873"}]},{"variations":[{"groupId":"37266273","variationId":"116400657"},{"groupId":"37266274","variationId":"116400659"}],"price":69900,"addonCombinations":[{"groupId":"133692589","addonId":"112193863"},{"groupId":"133692589","addonId":"112193860"},{"groupId":"133692589","addonId":"112193859"},{"groupId":"133692589","addonId":"115290079"},{"groupId":"133692589","addonId":"112193858"},{"groupId":"133692589","addonId":"112193861"},{"groupId":"152144543","addonId":"117361301"},{"groupId":"152144558","addonId":"112193843"},{"groupId":"152144558","addonId":"112193839"},{"groupId":"152144558","addonId":"112193841"},{"groupId":"152144558","addonId":"112193877"},{"groupId":"152144558","addonId":"112193848"},{"groupId":"152144558","addonId":"112193850"},{"groupId":"152144558","addonId":"112193852"},{"groupId":"152144558","addonId":"112193854"},{"groupId":"152144558","addonId":"112193856"},{"groupId":"152144558","addonId":"112193855"},{"groupId":"152144558","addonId":"112193865"},{"groupId":"152144558","addonId":"112193866"},{"groupId":"133692591","addonId":"112193847"},{"groupId":"133692591","addonId":"112193875"},{"groupId":"133692591","addonId":"112193879"},{"groupId":"133692591","addonId":"112193862"},{"groupId":"133692591","addonId":"112193834"},{"groupId":"133692591","addonId":"112193836"},{"groupId":"133692591","addonId":"112193874"}]},{"variations":[{"groupId":"37266273","variationId":"116400657"},{"groupId":"37266274","variationId":"116400661"}],"price":79800,"addonCombinations":[{"groupId":"133692589","addonId":"112193863"},{"groupId":"133692589","addonId":"112193860"},{"groupId":"133692589","addonId":"112193859"},{"groupId":"133692589","addonId":"115290079"},{"groupId":"133692589","addonId":"112193858"},{"groupId":"133692589","addonId":"112193861"},{"groupId":"152144543","addonId":"117361301"},{"groupId":"152144558","addonId":"112193843"},{"groupId":"152144558","addonId":"112193839"},{"groupId":"152144558","addonId":"112193841"},{"groupId":"152144558","addonId":"112193877"},{"groupId":"152144558","addonId":"112193848"},{"groupId":"152144558","addonId":"112193850"},{"groupId":"152144558","addonId":"112193852"},{"groupId":"152144558","addonId":"112193854"},{"groupId":"152144558","addonId":"112193856"},{"groupId":"152144558","addonId":"112193855"},{"groupId":"152144558","addonId":"112193865"},{"groupId":"152144558","addonId":"112193866"},{"groupId":"133692591","addonId":"112193847"},{"groupId":"133692591","addonId":"112193875"},{"groupId":"133692591","addonId":"112193879"},{"groupId":"133692591","addonId":"112193862"},{"groupId":"133692591","addonId":"112193834"},{"groupId":"133692591","addonId":"112193836"},{"groupId":"133692591","addonId":"112193874"}]},{"variations":[{"groupId":"37266273","variationId":"116400657"},{"groupId":"37266274","variationId":"126057560"}],"price":79800,"addonCombinations":[{"groupId":"133692589","addonId":"112193863"},{"groupId":"133692589","addonId":"112193860"},{"groupId":"133692589","addonId":"112193859"},{"groupId":"133692589","addonId":"115290079"},{"groupId":"133692589","addonId":"112193858"},{"groupId":"133692589","addonId":"112193861"},{"groupId":"152144543","addonId":"117361301"},{"groupId":"152144558","addonId":"112193843"},{"groupId":"152144558","addonId":"112193839"},{"groupId":"152144558","addonId":"112193841"},{"groupId":"152144558","addonId":"112193877"},{"groupId":"152144558","addonId":"112193848"},{"groupId":"152144558","addonId":"112193850"},{"groupId":"152144558","addonId":"112193852"},{"groupId":"152144558","addonId":"112193854"},{"groupId":"152144558","addonId":"112193856"},{"groupId":"152144558","addonId":"112193855"},{"groupId":"152144558","addonId":"112193865"},{"groupId":"152144558","addonId":"112193866"},{"groupId":"133692591","addonId":"112193847"},{"groupId":"133692591","addonId":"112193875"},{"groupId":"133692591","addonId":"112193879"},{"groupId":"133692591","addonId":"112193862"},{"groupId":"133692591","addonId":"112193834"},{"groupId":"133692591","addonId":"112193836"},{"groupId":"133692591","addonId":"112193874"}]},{"variations":[{"groupId":"37266273","variationId":"124780636"},{"groupId":"37266274","variationId":"124780638"}],"price":94900,"addonCombinations":[{"groupId":"133692589","addonId":"112193863"},{"groupId":"133692589","addonId":"112193860"},{"groupId":"133692589","addonId":"112193859"},{"groupId":"133692589","addonId":"115290079"},{"groupId":"133692589","addonId":"112193858"},{"groupId":"133692589","addonId":"112193861"},{"groupId":"152144546","addonId":"114785288"},{"groupId":"152144549","addonId":"114785287"},{"groupId":"152144549","addonId":"114785288"},{"groupId":"152144549","addonId":"114785289"},{"groupId":"152144549","addonId":"114785290"},{"groupId":"152144549","addonId":"114785286"},{"groupId":"152144549","addonId":"114785301"},{"groupId":"152144549","addonId":"114785302"},{"groupId":"152144549","addonId":"114785297"},{"groupId":"152144549","addonId":"114785298"},{"groupId":"152144549","addonId":"114785299"},{"groupId":"152144549","addonId":"114785300"},{"groupId":"152144549","addonId":"114785293"},{"groupId":"152144549","addonId":"114785294"},{"groupId":"140233176","addonId":"114785291"},{"groupId":"140233176","addonId":"114785295"},{"groupId":"140233176","addonId":"114785296"},{"groupId":"140233176","addonId":"114785305"},{"groupId":"140233176","addonId":"114785306"},{"groupId":"140233176","addonId":"114785307"},{"groupId":"140233176","addonId":"114785304"}]}]},"addons":[{"groupId":"152144540","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"152144546","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140233176","groupName":"Add Non Veg Toppings","choices":[{"id":"114785291","name":"Chicken Keema Masala","price":9900,"inStock":1,"isEnabled":1},{"id":"114785295","name":"Chicken Malai Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785296","name":"Chicken Pepperoni","price":9900,"inStock":1,"isEnabled":1},{"id":"114785305","name":"Chicken sausage","price":9900,"inStock":1,"isEnabled":1},{"id":"114785306","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785307","name":"Herbed Chicken","price":9900,"inStock":1,"isEnabled":1},{"id":"114785304","name":"Schezwan Chicken Meatball","price":9900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144549","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144551","groupName":"Add Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692590","groupName":"Add Non-Veg Toppings","choices":[{"id":"112193837","name":"Chicken Pepperoni","price":6500,"inStock":1,"isEnabled":1},{"id":"112193876","name":"Chicken Sausage","price":6500,"inStock":1,"isEnabled":1},{"id":"112193869","name":"Chicken Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193864","name":"Chicken Malai Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193835","name":"Herbed Chicken","price":6500,"inStock":1,"isEnabled":1},{"id":"112193868","name":"Schezwan Chicken Meatball","price":6500,"inStock":1,"isEnabled":1},{"id":"112193846","name":"Chicken Keema Masala","price":6000,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692589","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"152144558","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692591","groupName":"Add. Non-Veg Toppings","choices":[{"id":"112193847","name":"Chicken Pepperoni","price":8500,"inStock":1,"isEnabled":1},{"id":"112193875","name":"Chicken Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193879","name":"Chicken Sausage","price":8500,"inStock":1,"isEnabled":1},{"id":"112193862","name":"Chicken Malai Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193834","name":"Herbed Chicken","price":8500,"inStock":1,"isEnabled":1},{"id":"112193836","name":"Chicken Keema Masala","price":8000,"inStock":1,"isEnabled":1},{"id":"112193874","name":"Schezwan Chicken Meatball","price":8500,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":40900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"7 ratings","ratingCountV2":"7"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859599","name":"Chicken Pepperoni","category":"Non Veg Pizza","description":"Serves 1 | Yummy chicken pepperoni & 100% mozzarella cheese with signature pan sauce. Its a classic! (PAN Per/Med-301 Kcal/100g | TnC-311 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"gdz44c9hirco09bdafoq","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266263","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400616","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266264","variationId":"116400618"}},{"name":"Medium","id":"116400617","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266264","variationId":"116400619"}},{"name":"Thin n Large","id":"124780453","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266264","variationId":"124780458"}}]},{"groupId":"37266264","name":"Choose your Crust","variations":[{"name":"Pan","price":379,"default":1,"id":"116400618","inStock":1,"isEnabled":1},{"name":"Pan","price":639,"id":"116400619","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":454,"id":"116400620","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":738,"id":"116400621","inStock":1,"isEnabled":1},{"name":"Thin n Crispy","price":849,"id":"124780458","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":454,"id":"126057893","isEnabled":1},{"name":"Stuffed Crust - Maxx","price":738,"id":"126057894","isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266263","variationId":"116400616"},{"groupId":"37266264","variationId":"116400618"}],"price":37900,"addonCombinations":[{"groupId":"133692574","addonId":"112193863"},{"groupId":"133692574","addonId":"112193860"},{"groupId":"133692574","addonId":"112193859"},{"groupId":"133692574","addonId":"115290079"},{"groupId":"133692574","addonId":"112193858"},{"groupId":"133692574","addonId":"112193861"},{"groupId":"152144481","addonId":"112193873"},{"groupId":"152144481","addonId":"112193870"},{"groupId":"152144481","addonId":"112193872"},{"groupId":"152144481","addonId":"112193838"},{"groupId":"152144481","addonId":"112193840"},{"groupId":"152144481","addonId":"112193842"},{"groupId":"152144481","addonId":"112193844"},{"groupId":"152144481","addonId":"112193849"},{"groupId":"152144481","addonId":"112193845"},{"groupId":"152144481","addonId":"112193851"},{"groupId":"152144481","addonId":"112193853"},{"groupId":"133692575","addonId":"112193837"},{"groupId":"133692575","addonId":"112193876"},{"groupId":"133692575","addonId":"112193869"},{"groupId":"133692575","addonId":"112193864"},{"groupId":"133692575","addonId":"112193835"},{"groupId":"133692575","addonId":"112193868"},{"groupId":"133692575","addonId":"112193846"},{"groupId":"152144469","addonId":"112193873"}]},{"variations":[{"groupId":"37266263","variationId":"116400616"},{"groupId":"37266264","variationId":"116400620"}],"price":45400,"addonCombinations":[{"groupId":"133692574","addonId":"112193863"},{"groupId":"133692574","addonId":"112193860"},{"groupId":"133692574","addonId":"112193859"},{"groupId":"133692574","addonId":"115290079"},{"groupId":"133692574","addonId":"112193858"},{"groupId":"133692574","addonId":"112193861"},{"groupId":"152144481","addonId":"112193873"},{"groupId":"152144481","addonId":"112193870"},{"groupId":"152144481","addonId":"112193872"},{"groupId":"152144481","addonId":"112193838"},{"groupId":"152144481","addonId":"112193840"},{"groupId":"152144481","addonId":"112193842"},{"groupId":"152144481","addonId":"112193844"},{"groupId":"152144481","addonId":"112193849"},{"groupId":"152144481","addonId":"112193845"},{"groupId":"152144481","addonId":"112193851"},{"groupId":"152144481","addonId":"112193853"},{"groupId":"133692575","addonId":"112193837"},{"groupId":"133692575","addonId":"112193876"},{"groupId":"133692575","addonId":"112193869"},{"groupId":"133692575","addonId":"112193864"},{"groupId":"133692575","addonId":"112193835"},{"groupId":"133692575","addonId":"112193868"},{"groupId":"133692575","addonId":"112193846"},{"groupId":"152144469","addonId":"112193873"}]},{"variations":[{"groupId":"37266263","variationId":"116400616"},{"groupId":"37266264","variationId":"126057893"}],"price":45400,"addonCombinations":[{"groupId":"133692574","addonId":"112193863"},{"groupId":"133692574","addonId":"112193860"},{"groupId":"133692574","addonId":"112193859"},{"groupId":"133692574","addonId":"115290079"},{"groupId":"133692574","addonId":"112193858"},{"groupId":"133692574","addonId":"112193861"},{"groupId":"152144481","addonId":"112193873"},{"groupId":"152144481","addonId":"112193870"},{"groupId":"152144481","addonId":"112193872"},{"groupId":"152144481","addonId":"112193838"},{"groupId":"152144481","addonId":"112193840"},{"groupId":"152144481","addonId":"112193842"},{"groupId":"152144481","addonId":"112193844"},{"groupId":"152144481","addonId":"112193849"},{"groupId":"152144481","addonId":"112193845"},{"groupId":"152144481","addonId":"112193851"},{"groupId":"152144481","addonId":"112193853"},{"groupId":"133692575","addonId":"112193837"},{"groupId":"133692575","addonId":"112193876"},{"groupId":"133692575","addonId":"112193869"},{"groupId":"133692575","addonId":"112193864"},{"groupId":"133692575","addonId":"112193835"},{"groupId":"133692575","addonId":"112193868"},{"groupId":"133692575","addonId":"112193846"},{"groupId":"152144469","addonId":"112193873"}]},{"variations":[{"groupId":"37266263","variationId":"116400617"},{"groupId":"37266264","variationId":"116400619"}],"price":63900,"addonCombinations":[{"groupId":"133692574","addonId":"112193863"},{"groupId":"133692574","addonId":"112193860"},{"groupId":"133692574","addonId":"112193859"},{"groupId":"133692574","addonId":"115290079"},{"groupId":"133692574","addonId":"112193858"},{"groupId":"133692574","addonId":"112193861"},{"groupId":"152144471","addonId":"117361301"},{"groupId":"152144486","addonId":"112193843"},{"groupId":"152144486","addonId":"112193839"},{"groupId":"152144486","addonId":"112193841"},{"groupId":"152144486","addonId":"112193877"},{"groupId":"152144486","addonId":"112193848"},{"groupId":"152144486","addonId":"112193850"},{"groupId":"152144486","addonId":"112193852"},{"groupId":"152144486","addonId":"112193854"},{"groupId":"152144486","addonId":"112193856"},{"groupId":"152144486","addonId":"112193855"},{"groupId":"152144486","addonId":"112193865"},{"groupId":"152144486","addonId":"112193866"},{"groupId":"133692576","addonId":"112193847"},{"groupId":"133692576","addonId":"112193875"},{"groupId":"133692576","addonId":"112193879"},{"groupId":"133692576","addonId":"112193862"},{"groupId":"133692576","addonId":"112193834"},{"groupId":"133692576","addonId":"112193836"},{"groupId":"133692576","addonId":"112193874"}]},{"variations":[{"groupId":"37266263","variationId":"116400617"},{"groupId":"37266264","variationId":"116400621"}],"price":73800,"addonCombinations":[{"groupId":"133692574","addonId":"112193863"},{"groupId":"133692574","addonId":"112193860"},{"groupId":"133692574","addonId":"112193859"},{"groupId":"133692574","addonId":"115290079"},{"groupId":"133692574","addonId":"112193858"},{"groupId":"133692574","addonId":"112193861"},{"groupId":"152144471","addonId":"117361301"},{"groupId":"152144486","addonId":"112193843"},{"groupId":"152144486","addonId":"112193839"},{"groupId":"152144486","addonId":"112193841"},{"groupId":"152144486","addonId":"112193877"},{"groupId":"152144486","addonId":"112193848"},{"groupId":"152144486","addonId":"112193850"},{"groupId":"152144486","addonId":"112193852"},{"groupId":"152144486","addonId":"112193854"},{"groupId":"152144486","addonId":"112193856"},{"groupId":"152144486","addonId":"112193855"},{"groupId":"152144486","addonId":"112193865"},{"groupId":"152144486","addonId":"112193866"},{"groupId":"133692576","addonId":"112193847"},{"groupId":"133692576","addonId":"112193875"},{"groupId":"133692576","addonId":"112193879"},{"groupId":"133692576","addonId":"112193862"},{"groupId":"133692576","addonId":"112193834"},{"groupId":"133692576","addonId":"112193836"},{"groupId":"133692576","addonId":"112193874"}]},{"variations":[{"groupId":"37266263","variationId":"116400617"},{"groupId":"37266264","variationId":"126057894"}],"price":73800,"addonCombinations":[{"groupId":"133692574","addonId":"112193863"},{"groupId":"133692574","addonId":"112193860"},{"groupId":"133692574","addonId":"112193859"},{"groupId":"133692574","addonId":"115290079"},{"groupId":"133692574","addonId":"112193858"},{"groupId":"133692574","addonId":"112193861"},{"groupId":"152144471","addonId":"117361301"},{"groupId":"152144486","addonId":"112193843"},{"groupId":"152144486","addonId":"112193839"},{"groupId":"152144486","addonId":"112193841"},{"groupId":"152144486","addonId":"112193877"},{"groupId":"152144486","addonId":"112193848"},{"groupId":"152144486","addonId":"112193850"},{"groupId":"152144486","addonId":"112193852"},{"groupId":"152144486","addonId":"112193854"},{"groupId":"152144486","addonId":"112193856"},{"groupId":"152144486","addonId":"112193855"},{"groupId":"152144486","addonId":"112193865"},{"groupId":"152144486","addonId":"112193866"},{"groupId":"133692576","addonId":"112193847"},{"groupId":"133692576","addonId":"112193875"},{"groupId":"133692576","addonId":"112193879"},{"groupId":"133692576","addonId":"112193862"},{"groupId":"133692576","addonId":"112193834"},{"groupId":"133692576","addonId":"112193836"},{"groupId":"133692576","addonId":"112193874"}]},{"variations":[{"groupId":"37266263","variationId":"124780453"},{"groupId":"37266264","variationId":"124780458"}],"price":84900,"addonCombinations":[{"groupId":"133692574","addonId":"112193863"},{"groupId":"133692574","addonId":"112193860"},{"groupId":"133692574","addonId":"112193859"},{"groupId":"133692574","addonId":"115290079"},{"groupId":"133692574","addonId":"112193858"},{"groupId":"133692574","addonId":"112193861"},{"groupId":"152144473","addonId":"114785288"},{"groupId":"152144476","addonId":"114785287"},{"groupId":"152144476","addonId":"114785288"},{"groupId":"152144476","addonId":"114785289"},{"groupId":"152144476","addonId":"114785290"},{"groupId":"152144476","addonId":"114785286"},{"groupId":"152144476","addonId":"114785301"},{"groupId":"152144476","addonId":"114785302"},{"groupId":"152144476","addonId":"114785297"},{"groupId":"152144476","addonId":"114785298"},{"groupId":"152144476","addonId":"114785299"},{"groupId":"152144476","addonId":"114785300"},{"groupId":"152144476","addonId":"114785293"},{"groupId":"152144476","addonId":"114785294"},{"groupId":"140233146","addonId":"114785291"},{"groupId":"140233146","addonId":"114785295"},{"groupId":"140233146","addonId":"114785296"},{"groupId":"140233146","addonId":"114785305"},{"groupId":"140233146","addonId":"114785306"},{"groupId":"140233146","addonId":"114785307"},{"groupId":"140233146","addonId":"114785304"}]}]},"addons":[{"groupId":"152144469","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"152144473","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140233146","groupName":"Add Non Veg Toppings","choices":[{"id":"114785291","name":"Chicken Keema Masala","price":9900,"inStock":1,"isEnabled":1},{"id":"114785295","name":"Chicken Malai Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785296","name":"Chicken Pepperoni","price":9900,"inStock":1,"isEnabled":1},{"id":"114785305","name":"Chicken sausage","price":9900,"inStock":1,"isEnabled":1},{"id":"114785306","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785307","name":"Herbed Chicken","price":9900,"inStock":1,"isEnabled":1},{"id":"114785304","name":"Schezwan Chicken Meatball","price":9900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144476","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144481","groupName":"Add Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692575","groupName":"Add Non-Veg Toppings","choices":[{"id":"112193837","name":"Chicken Pepperoni","price":6500,"inStock":1,"isEnabled":1},{"id":"112193876","name":"Chicken Sausage","price":6500,"inStock":1,"isEnabled":1},{"id":"112193869","name":"Chicken Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193864","name":"Chicken Malai Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193835","name":"Herbed Chicken","price":6500,"inStock":1,"isEnabled":1},{"id":"112193868","name":"Schezwan Chicken Meatball","price":6500,"inStock":1,"isEnabled":1},{"id":"112193846","name":"Chicken Keema Masala","price":6000,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692574","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"152144486","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692576","groupName":"Add. Non-Veg Toppings","choices":[{"id":"112193847","name":"Chicken Pepperoni","price":8500,"inStock":1,"isEnabled":1},{"id":"112193875","name":"Chicken Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193879","name":"Chicken Sausage","price":8500,"inStock":1,"isEnabled":1},{"id":"112193862","name":"Chicken Malai Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193834","name":"Herbed Chicken","price":8500,"inStock":1,"isEnabled":1},{"id":"112193836","name":"Chicken Keema Masala","price":8000,"inStock":1,"isEnabled":1},{"id":"112193874","name":"Schezwan Chicken Meatball","price":8500,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":37900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859602","name":"Triple Chicken Feast","category":"Non Veg Pizza","description":"Serves 1 | Spicy schezwan chicken meatball, flavourful herbed chicken, juicy chicken sausage, green capsicum & onion, spicy red paprika with classic pan sauce and 100% mozzarella cheese (PAN Per/Med-262 Kcal/100g | TnC-277 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"quxirmjttzksp7xlhysc","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266269","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400640","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266270","variationId":"116400642"}},{"name":"Medium","id":"116400641","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266270","variationId":"116400643"}},{"name":"Thin n Large","id":"124781073","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266270","variationId":"124781074"}}]},{"groupId":"37266270","name":"Choose your Crust","variations":[{"name":"Pan","price":409,"default":1,"id":"116400642","inStock":1,"isEnabled":1},{"name":"Pan","price":699,"id":"116400643","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":484,"id":"116400644","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":798,"id":"116400645","inStock":1,"isEnabled":1},{"name":"Thin n Crispy","price":949,"id":"124781074","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":484,"id":"126057733","isEnabled":1},{"name":"Stuffed Crust - Maxx","price":798,"id":"126057735","isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266269","variationId":"116400640"},{"groupId":"37266270","variationId":"116400642"}],"price":40900,"addonCombinations":[{"groupId":"133692583","addonId":"112193863"},{"groupId":"133692583","addonId":"112193860"},{"groupId":"133692583","addonId":"112193859"},{"groupId":"133692583","addonId":"115290079"},{"groupId":"133692583","addonId":"112193858"},{"groupId":"133692583","addonId":"112193861"},{"groupId":"152144594","addonId":"112193873"},{"groupId":"152144594","addonId":"112193870"},{"groupId":"152144594","addonId":"112193872"},{"groupId":"152144594","addonId":"112193838"},{"groupId":"152144594","addonId":"112193840"},{"groupId":"152144594","addonId":"112193842"},{"groupId":"152144594","addonId":"112193844"},{"groupId":"152144594","addonId":"112193849"},{"groupId":"152144594","addonId":"112193845"},{"groupId":"152144594","addonId":"112193851"},{"groupId":"152144594","addonId":"112193853"},{"groupId":"133692584","addonId":"112193837"},{"groupId":"133692584","addonId":"112193876"},{"groupId":"133692584","addonId":"112193869"},{"groupId":"133692584","addonId":"112193864"},{"groupId":"133692584","addonId":"112193835"},{"groupId":"133692584","addonId":"112193868"},{"groupId":"133692584","addonId":"112193846"},{"groupId":"152144590","addonId":"112193873"}]},{"variations":[{"groupId":"37266269","variationId":"116400640"},{"groupId":"37266270","variationId":"116400644"}],"price":48400,"addonCombinations":[{"groupId":"133692583","addonId":"112193863"},{"groupId":"133692583","addonId":"112193860"},{"groupId":"133692583","addonId":"112193859"},{"groupId":"133692583","addonId":"115290079"},{"groupId":"133692583","addonId":"112193858"},{"groupId":"133692583","addonId":"112193861"},{"groupId":"152144594","addonId":"112193873"},{"groupId":"152144594","addonId":"112193870"},{"groupId":"152144594","addonId":"112193872"},{"groupId":"152144594","addonId":"112193838"},{"groupId":"152144594","addonId":"112193840"},{"groupId":"152144594","addonId":"112193842"},{"groupId":"152144594","addonId":"112193844"},{"groupId":"152144594","addonId":"112193849"},{"groupId":"152144594","addonId":"112193845"},{"groupId":"152144594","addonId":"112193851"},{"groupId":"152144594","addonId":"112193853"},{"groupId":"133692584","addonId":"112193837"},{"groupId":"133692584","addonId":"112193876"},{"groupId":"133692584","addonId":"112193869"},{"groupId":"133692584","addonId":"112193864"},{"groupId":"133692584","addonId":"112193835"},{"groupId":"133692584","addonId":"112193868"},{"groupId":"133692584","addonId":"112193846"},{"groupId":"152144590","addonId":"112193873"}]},{"variations":[{"groupId":"37266269","variationId":"116400640"},{"groupId":"37266270","variationId":"126057733"}],"price":48400,"addonCombinations":[{"groupId":"133692583","addonId":"112193863"},{"groupId":"133692583","addonId":"112193860"},{"groupId":"133692583","addonId":"112193859"},{"groupId":"133692583","addonId":"115290079"},{"groupId":"133692583","addonId":"112193858"},{"groupId":"133692583","addonId":"112193861"},{"groupId":"152144594","addonId":"112193873"},{"groupId":"152144594","addonId":"112193870"},{"groupId":"152144594","addonId":"112193872"},{"groupId":"152144594","addonId":"112193838"},{"groupId":"152144594","addonId":"112193840"},{"groupId":"152144594","addonId":"112193842"},{"groupId":"152144594","addonId":"112193844"},{"groupId":"152144594","addonId":"112193849"},{"groupId":"152144594","addonId":"112193845"},{"groupId":"152144594","addonId":"112193851"},{"groupId":"152144594","addonId":"112193853"},{"groupId":"133692584","addonId":"112193837"},{"groupId":"133692584","addonId":"112193876"},{"groupId":"133692584","addonId":"112193869"},{"groupId":"133692584","addonId":"112193864"},{"groupId":"133692584","addonId":"112193835"},{"groupId":"133692584","addonId":"112193868"},{"groupId":"133692584","addonId":"112193846"},{"groupId":"152144590","addonId":"112193873"}]},{"variations":[{"groupId":"37266269","variationId":"116400641"},{"groupId":"37266270","variationId":"116400643"}],"price":69900,"addonCombinations":[{"groupId":"133692583","addonId":"112193863"},{"groupId":"133692583","addonId":"112193860"},{"groupId":"133692583","addonId":"112193859"},{"groupId":"133692583","addonId":"115290079"},{"groupId":"133692583","addonId":"112193858"},{"groupId":"133692583","addonId":"112193861"},{"groupId":"152144591","addonId":"117361301"},{"groupId":"152144596","addonId":"112193843"},{"groupId":"152144596","addonId":"112193839"},{"groupId":"152144596","addonId":"112193841"},{"groupId":"152144596","addonId":"112193877"},{"groupId":"152144596","addonId":"112193848"},{"groupId":"152144596","addonId":"112193850"},{"groupId":"152144596","addonId":"112193852"},{"groupId":"152144596","addonId":"112193854"},{"groupId":"152144596","addonId":"112193856"},{"groupId":"152144596","addonId":"112193855"},{"groupId":"152144596","addonId":"112193865"},{"groupId":"152144596","addonId":"112193866"},{"groupId":"133692585","addonId":"112193847"},{"groupId":"133692585","addonId":"112193875"},{"groupId":"133692585","addonId":"112193879"},{"groupId":"133692585","addonId":"112193862"},{"groupId":"133692585","addonId":"112193834"},{"groupId":"133692585","addonId":"112193836"},{"groupId":"133692585","addonId":"112193874"}]},{"variations":[{"groupId":"37266269","variationId":"116400641"},{"groupId":"37266270","variationId":"116400645"}],"price":79800,"addonCombinations":[{"groupId":"133692583","addonId":"112193863"},{"groupId":"133692583","addonId":"112193860"},{"groupId":"133692583","addonId":"112193859"},{"groupId":"133692583","addonId":"115290079"},{"groupId":"133692583","addonId":"112193858"},{"groupId":"133692583","addonId":"112193861"},{"groupId":"152144591","addonId":"117361301"},{"groupId":"152144596","addonId":"112193843"},{"groupId":"152144596","addonId":"112193839"},{"groupId":"152144596","addonId":"112193841"},{"groupId":"152144596","addonId":"112193877"},{"groupId":"152144596","addonId":"112193848"},{"groupId":"152144596","addonId":"112193850"},{"groupId":"152144596","addonId":"112193852"},{"groupId":"152144596","addonId":"112193854"},{"groupId":"152144596","addonId":"112193856"},{"groupId":"152144596","addonId":"112193855"},{"groupId":"152144596","addonId":"112193865"},{"groupId":"152144596","addonId":"112193866"},{"groupId":"133692585","addonId":"112193847"},{"groupId":"133692585","addonId":"112193875"},{"groupId":"133692585","addonId":"112193879"},{"groupId":"133692585","addonId":"112193862"},{"groupId":"133692585","addonId":"112193834"},{"groupId":"133692585","addonId":"112193836"},{"groupId":"133692585","addonId":"112193874"}]},{"variations":[{"groupId":"37266269","variationId":"116400641"},{"groupId":"37266270","variationId":"126057735"}],"price":79800,"addonCombinations":[{"groupId":"133692583","addonId":"112193863"},{"groupId":"133692583","addonId":"112193860"},{"groupId":"133692583","addonId":"112193859"},{"groupId":"133692583","addonId":"115290079"},{"groupId":"133692583","addonId":"112193858"},{"groupId":"133692583","addonId":"112193861"},{"groupId":"152144591","addonId":"117361301"},{"groupId":"152144596","addonId":"112193843"},{"groupId":"152144596","addonId":"112193839"},{"groupId":"152144596","addonId":"112193841"},{"groupId":"152144596","addonId":"112193877"},{"groupId":"152144596","addonId":"112193848"},{"groupId":"152144596","addonId":"112193850"},{"groupId":"152144596","addonId":"112193852"},{"groupId":"152144596","addonId":"112193854"},{"groupId":"152144596","addonId":"112193856"},{"groupId":"152144596","addonId":"112193855"},{"groupId":"152144596","addonId":"112193865"},{"groupId":"152144596","addonId":"112193866"},{"groupId":"133692585","addonId":"112193847"},{"groupId":"133692585","addonId":"112193875"},{"groupId":"133692585","addonId":"112193879"},{"groupId":"133692585","addonId":"112193862"},{"groupId":"133692585","addonId":"112193834"},{"groupId":"133692585","addonId":"112193836"},{"groupId":"133692585","addonId":"112193874"}]},{"variations":[{"groupId":"37266269","variationId":"124781073"},{"groupId":"37266270","variationId":"124781074"}],"price":94900,"addonCombinations":[{"groupId":"133692583","addonId":"112193863"},{"groupId":"133692583","addonId":"112193860"},{"groupId":"133692583","addonId":"112193859"},{"groupId":"133692583","addonId":"115290079"},{"groupId":"133692583","addonId":"112193858"},{"groupId":"133692583","addonId":"112193861"},{"groupId":"152144592","addonId":"114785288"},{"groupId":"152144593","addonId":"114785287"},{"groupId":"152144593","addonId":"114785288"},{"groupId":"152144593","addonId":"114785289"},{"groupId":"152144593","addonId":"114785290"},{"groupId":"152144593","addonId":"114785286"},{"groupId":"152144593","addonId":"114785301"},{"groupId":"152144593","addonId":"114785302"},{"groupId":"152144593","addonId":"114785297"},{"groupId":"152144593","addonId":"114785298"},{"groupId":"152144593","addonId":"114785299"},{"groupId":"152144593","addonId":"114785300"},{"groupId":"152144593","addonId":"114785293"},{"groupId":"152144593","addonId":"114785294"},{"groupId":"140233247","addonId":"114785291"},{"groupId":"140233247","addonId":"114785295"},{"groupId":"140233247","addonId":"114785296"},{"groupId":"140233247","addonId":"114785305"},{"groupId":"140233247","addonId":"114785306"},{"groupId":"140233247","addonId":"114785307"},{"groupId":"140233247","addonId":"114785304"}]}]},"addons":[{"groupId":"152144590","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"152144592","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140233247","groupName":"Add Non Veg Toppings","choices":[{"id":"114785291","name":"Chicken Keema Masala","price":9900,"inStock":1,"isEnabled":1},{"id":"114785295","name":"Chicken Malai Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785296","name":"Chicken Pepperoni","price":9900,"inStock":1,"isEnabled":1},{"id":"114785305","name":"Chicken sausage","price":9900,"inStock":1,"isEnabled":1},{"id":"114785306","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785307","name":"Herbed Chicken","price":9900,"inStock":1,"isEnabled":1},{"id":"114785304","name":"Schezwan Chicken Meatball","price":9900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144593","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144594","groupName":"Add Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692584","groupName":"Add Non-Veg Toppings","choices":[{"id":"112193837","name":"Chicken Pepperoni","price":6500,"inStock":1,"isEnabled":1},{"id":"112193876","name":"Chicken Sausage","price":6500,"inStock":1,"isEnabled":1},{"id":"112193869","name":"Chicken Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193864","name":"Chicken Malai Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193835","name":"Herbed Chicken","price":6500,"inStock":1,"isEnabled":1},{"id":"112193868","name":"Schezwan Chicken Meatball","price":6500,"inStock":1,"isEnabled":1},{"id":"112193846","name":"Chicken Keema Masala","price":6000,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692583","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"152144596","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692585","groupName":"Add. Non-Veg Toppings","choices":[{"id":"112193847","name":"Chicken Pepperoni","price":8500,"inStock":1,"isEnabled":1},{"id":"112193875","name":"Chicken Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193879","name":"Chicken Sausage","price":8500,"inStock":1,"isEnabled":1},{"id":"112193862","name":"Chicken Malai Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193834","name":"Herbed Chicken","price":8500,"inStock":1,"isEnabled":1},{"id":"112193836","name":"Chicken Keema Masala","price":8000,"inStock":1,"isEnabled":1},{"id":"112193874","name":"Schezwan Chicken Meatball","price":8500,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":40900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859688","name":"Nawabi Murg Makhni","category":"Non Veg Pizza","description":"Serves 1 | A chicken lovers delight! Combination of chicken malai tikka, flavourful chicken keema masala, crunchy onion, juicy tomato on our new makhni sauce with 100% mozzarella cheese and buttery spice sprinkle (PAN Per/Med-252 Kcal/100g | TnC-269 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"eb7467f9836bde6741eff6cf81b996da","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266369","name":"Size","variations":[{"name":"Personal","default":1,"id":"116401032","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266370","variationId":"116401034"}},{"name":"Medium","id":"116401033","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266370","variationId":"116401035"}},{"name":"Thin n Large","id":"124780852","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266370","variationId":"124780855"}}]},{"groupId":"37266370","name":"Choose your Crust","variations":[{"name":"Pan","price":409,"default":1,"id":"116401034","inStock":1,"isEnabled":1},{"name":"Pan","price":699,"id":"116401035","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":484,"id":"116401038","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":798,"id":"116401039","inStock":1,"isEnabled":1},{"name":"Thin n Crispy","price":949,"id":"124780855","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":484,"id":"126057747","isEnabled":1},{"name":"Stuffed Crust - Maxx","price":798,"id":"126057748","isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266369","variationId":"116401032"},{"groupId":"37266370","variationId":"116401034"}],"price":40900,"addonCombinations":[{"groupId":"133692652","addonId":"112193863"},{"groupId":"133692652","addonId":"112193860"},{"groupId":"133692652","addonId":"112193859"},{"groupId":"133692652","addonId":"115290079"},{"groupId":"133692652","addonId":"112193858"},{"groupId":"133692652","addonId":"112193861"},{"groupId":"152144450","addonId":"112193873"},{"groupId":"152144450","addonId":"112193870"},{"groupId":"152144450","addonId":"112193872"},{"groupId":"152144450","addonId":"112193838"},{"groupId":"152144450","addonId":"112193840"},{"groupId":"152144450","addonId":"112193842"},{"groupId":"152144450","addonId":"112193844"},{"groupId":"152144450","addonId":"112193849"},{"groupId":"152144450","addonId":"112193845"},{"groupId":"152144450","addonId":"112193851"},{"groupId":"152144450","addonId":"112193853"},{"groupId":"133692653","addonId":"112193837"},{"groupId":"133692653","addonId":"112193876"},{"groupId":"133692653","addonId":"112193869"},{"groupId":"133692653","addonId":"112193864"},{"groupId":"133692653","addonId":"112193835"},{"groupId":"133692653","addonId":"112193868"},{"groupId":"133692653","addonId":"112193846"},{"groupId":"152144439","addonId":"112193873"}]},{"variations":[{"groupId":"37266369","variationId":"116401032"},{"groupId":"37266370","variationId":"126057747"}],"price":48400,"addonCombinations":[{"groupId":"133692652","addonId":"112193863"},{"groupId":"133692652","addonId":"112193860"},{"groupId":"133692652","addonId":"112193859"},{"groupId":"133692652","addonId":"115290079"},{"groupId":"133692652","addonId":"112193858"},{"groupId":"133692652","addonId":"112193861"},{"groupId":"152144450","addonId":"112193873"},{"groupId":"152144450","addonId":"112193870"},{"groupId":"152144450","addonId":"112193872"},{"groupId":"152144450","addonId":"112193838"},{"groupId":"152144450","addonId":"112193840"},{"groupId":"152144450","addonId":"112193842"},{"groupId":"152144450","addonId":"112193844"},{"groupId":"152144450","addonId":"112193849"},{"groupId":"152144450","addonId":"112193845"},{"groupId":"152144450","addonId":"112193851"},{"groupId":"152144450","addonId":"112193853"},{"groupId":"133692653","addonId":"112193837"},{"groupId":"133692653","addonId":"112193876"},{"groupId":"133692653","addonId":"112193869"},{"groupId":"133692653","addonId":"112193864"},{"groupId":"133692653","addonId":"112193835"},{"groupId":"133692653","addonId":"112193868"},{"groupId":"133692653","addonId":"112193846"},{"groupId":"152144439","addonId":"112193873"}]},{"variations":[{"groupId":"37266369","variationId":"116401032"},{"groupId":"37266370","variationId":"116401038"}],"price":48400,"addonCombinations":[{"groupId":"133692652","addonId":"112193863"},{"groupId":"133692652","addonId":"112193860"},{"groupId":"133692652","addonId":"112193859"},{"groupId":"133692652","addonId":"115290079"},{"groupId":"133692652","addonId":"112193858"},{"groupId":"133692652","addonId":"112193861"},{"groupId":"152144450","addonId":"112193873"},{"groupId":"152144450","addonId":"112193870"},{"groupId":"152144450","addonId":"112193872"},{"groupId":"152144450","addonId":"112193838"},{"groupId":"152144450","addonId":"112193840"},{"groupId":"152144450","addonId":"112193842"},{"groupId":"152144450","addonId":"112193844"},{"groupId":"152144450","addonId":"112193849"},{"groupId":"152144450","addonId":"112193845"},{"groupId":"152144450","addonId":"112193851"},{"groupId":"152144450","addonId":"112193853"},{"groupId":"133692653","addonId":"112193837"},{"groupId":"133692653","addonId":"112193876"},{"groupId":"133692653","addonId":"112193869"},{"groupId":"133692653","addonId":"112193864"},{"groupId":"133692653","addonId":"112193835"},{"groupId":"133692653","addonId":"112193868"},{"groupId":"133692653","addonId":"112193846"},{"groupId":"152144439","addonId":"112193873"}]},{"variations":[{"groupId":"37266369","variationId":"116401033"},{"groupId":"37266370","variationId":"116401035"}],"price":69900,"addonCombinations":[{"groupId":"133692652","addonId":"112193863"},{"groupId":"133692652","addonId":"112193860"},{"groupId":"133692652","addonId":"112193859"},{"groupId":"133692652","addonId":"115290079"},{"groupId":"133692652","addonId":"112193858"},{"groupId":"133692652","addonId":"112193861"},{"groupId":"152144442","addonId":"117361301"},{"groupId":"152144451","addonId":"112193843"},{"groupId":"152144451","addonId":"112193839"},{"groupId":"152144451","addonId":"112193841"},{"groupId":"152144451","addonId":"112193877"},{"groupId":"152144451","addonId":"112193848"},{"groupId":"152144451","addonId":"112193850"},{"groupId":"152144451","addonId":"112193852"},{"groupId":"152144451","addonId":"112193854"},{"groupId":"152144451","addonId":"112193856"},{"groupId":"152144451","addonId":"112193855"},{"groupId":"152144451","addonId":"112193865"},{"groupId":"152144451","addonId":"112193866"},{"groupId":"133692654","addonId":"112193847"},{"groupId":"133692654","addonId":"112193875"},{"groupId":"133692654","addonId":"112193879"},{"groupId":"133692654","addonId":"112193862"},{"groupId":"133692654","addonId":"112193834"},{"groupId":"133692654","addonId":"112193836"},{"groupId":"133692654","addonId":"112193874"}]},{"variations":[{"groupId":"37266369","variationId":"116401033"},{"groupId":"37266370","variationId":"126057748"}],"price":79800,"addonCombinations":[{"groupId":"133692652","addonId":"112193863"},{"groupId":"133692652","addonId":"112193860"},{"groupId":"133692652","addonId":"112193859"},{"groupId":"133692652","addonId":"115290079"},{"groupId":"133692652","addonId":"112193858"},{"groupId":"133692652","addonId":"112193861"},{"groupId":"152144442","addonId":"117361301"},{"groupId":"152144451","addonId":"112193843"},{"groupId":"152144451","addonId":"112193839"},{"groupId":"152144451","addonId":"112193841"},{"groupId":"152144451","addonId":"112193877"},{"groupId":"152144451","addonId":"112193848"},{"groupId":"152144451","addonId":"112193850"},{"groupId":"152144451","addonId":"112193852"},{"groupId":"152144451","addonId":"112193854"},{"groupId":"152144451","addonId":"112193856"},{"groupId":"152144451","addonId":"112193855"},{"groupId":"152144451","addonId":"112193865"},{"groupId":"152144451","addonId":"112193866"},{"groupId":"133692654","addonId":"112193847"},{"groupId":"133692654","addonId":"112193875"},{"groupId":"133692654","addonId":"112193879"},{"groupId":"133692654","addonId":"112193862"},{"groupId":"133692654","addonId":"112193834"},{"groupId":"133692654","addonId":"112193836"},{"groupId":"133692654","addonId":"112193874"}]},{"variations":[{"groupId":"37266369","variationId":"116401033"},{"groupId":"37266370","variationId":"116401039"}],"price":79800,"addonCombinations":[{"groupId":"133692652","addonId":"112193863"},{"groupId":"133692652","addonId":"112193860"},{"groupId":"133692652","addonId":"112193859"},{"groupId":"133692652","addonId":"115290079"},{"groupId":"133692652","addonId":"112193858"},{"groupId":"133692652","addonId":"112193861"},{"groupId":"152144442","addonId":"117361301"},{"groupId":"152144451","addonId":"112193843"},{"groupId":"152144451","addonId":"112193839"},{"groupId":"152144451","addonId":"112193841"},{"groupId":"152144451","addonId":"112193877"},{"groupId":"152144451","addonId":"112193848"},{"groupId":"152144451","addonId":"112193850"},{"groupId":"152144451","addonId":"112193852"},{"groupId":"152144451","addonId":"112193854"},{"groupId":"152144451","addonId":"112193856"},{"groupId":"152144451","addonId":"112193855"},{"groupId":"152144451","addonId":"112193865"},{"groupId":"152144451","addonId":"112193866"},{"groupId":"133692654","addonId":"112193847"},{"groupId":"133692654","addonId":"112193875"},{"groupId":"133692654","addonId":"112193879"},{"groupId":"133692654","addonId":"112193862"},{"groupId":"133692654","addonId":"112193834"},{"groupId":"133692654","addonId":"112193836"},{"groupId":"133692654","addonId":"112193874"}]},{"variations":[{"groupId":"37266369","variationId":"124780852"},{"groupId":"37266370","variationId":"124780855"}],"price":94900,"addonCombinations":[{"groupId":"133692652","addonId":"112193863"},{"groupId":"133692652","addonId":"112193860"},{"groupId":"133692652","addonId":"112193859"},{"groupId":"133692652","addonId":"115290079"},{"groupId":"133692652","addonId":"112193858"},{"groupId":"133692652","addonId":"112193861"},{"groupId":"152144444","addonId":"114785288"},{"groupId":"152144448","addonId":"114785287"},{"groupId":"152144448","addonId":"114785288"},{"groupId":"152144448","addonId":"114785289"},{"groupId":"152144448","addonId":"114785290"},{"groupId":"152144448","addonId":"114785286"},{"groupId":"152144448","addonId":"114785301"},{"groupId":"152144448","addonId":"114785302"},{"groupId":"152144448","addonId":"114785297"},{"groupId":"152144448","addonId":"114785298"},{"groupId":"152144448","addonId":"114785299"},{"groupId":"152144448","addonId":"114785300"},{"groupId":"152144448","addonId":"114785293"},{"groupId":"152144448","addonId":"114785294"},{"groupId":"140233208","addonId":"114785291"},{"groupId":"140233208","addonId":"114785295"},{"groupId":"140233208","addonId":"114785296"},{"groupId":"140233208","addonId":"114785305"},{"groupId":"140233208","addonId":"114785306"},{"groupId":"140233208","addonId":"114785307"},{"groupId":"140233208","addonId":"114785304"}]}]},"addons":[{"groupId":"152144439","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"152144444","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140233208","groupName":"Add Non Veg Toppings","choices":[{"id":"114785291","name":"Chicken Keema Masala","price":9900,"inStock":1,"isEnabled":1},{"id":"114785295","name":"Chicken Malai Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785296","name":"Chicken Pepperoni","price":9900,"inStock":1,"isEnabled":1},{"id":"114785305","name":"Chicken sausage","price":9900,"inStock":1,"isEnabled":1},{"id":"114785306","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785307","name":"Herbed Chicken","price":9900,"inStock":1,"isEnabled":1},{"id":"114785304","name":"Schezwan Chicken Meatball","price":9900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144448","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144450","groupName":"Add Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692653","groupName":"Add Non-Veg Toppings","choices":[{"id":"112193837","name":"Chicken Pepperoni","price":6500,"inStock":1,"isEnabled":1},{"id":"112193876","name":"Chicken Sausage","price":6500,"inStock":1,"isEnabled":1},{"id":"112193869","name":"Chicken Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193864","name":"Chicken Malai Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193835","name":"Herbed Chicken","price":6500,"inStock":1,"isEnabled":1},{"id":"112193868","name":"Schezwan Chicken Meatball","price":6500,"inStock":1,"isEnabled":1},{"id":"112193846","name":"Chicken Keema Masala","price":6000,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692652","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"152144451","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692654","groupName":"Add. Non-Veg Toppings","choices":[{"id":"112193847","name":"Chicken Pepperoni","price":8500,"inStock":1,"isEnabled":1},{"id":"112193875","name":"Chicken Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193879","name":"Chicken Sausage","price":8500,"inStock":1,"isEnabled":1},{"id":"112193862","name":"Chicken Malai Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193834","name":"Herbed Chicken","price":8500,"inStock":1,"isEnabled":1},{"id":"112193836","name":"Chicken Keema Masala","price":8000,"inStock":1,"isEnabled":1},{"id":"112193874","name":"Schezwan Chicken Meatball","price":8500,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":40900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859713","name":"Sizzling Schezwan Chicken","category":"Non Veg Pizza","description":"Serves 1 | Loaded with our signature spicy schezwan sauce, juicy schezwan chicken meatballs & 100% mozzarella cheese (PAN Per/Med-277 Kcal/100g | TnC-286 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"4061af0525c00c89f0d1edbe7216765c","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266405","name":"Size","variations":[{"name":"Personal","default":1,"id":"116401116","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266406","variationId":"116401118"}},{"name":"Medium","id":"116401117","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266406","variationId":"116401119"}},{"name":"Thin n Large","id":"124780591","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266406","variationId":"124780596"}}]},{"groupId":"37266406","name":"Choose your Crust","variations":[{"name":"Pan","price":319,"default":1,"id":"116401118","inStock":1,"isEnabled":1},{"name":"Pan","price":569,"id":"116401119","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":394,"id":"116401122","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":668,"id":"116401123","inStock":1,"isEnabled":1},{"name":"Thin n Crispy","price":749,"id":"124780596","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":394,"id":"126057908","isEnabled":1},{"name":"Stuffed Crust - Maxx","price":668,"id":"126057910","isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266405","variationId":"116401116"},{"groupId":"37266406","variationId":"116401118"}],"price":31900,"addonCombinations":[{"groupId":"133692682","addonId":"112193863"},{"groupId":"133692682","addonId":"112193860"},{"groupId":"133692682","addonId":"112193859"},{"groupId":"133692682","addonId":"115290079"},{"groupId":"133692682","addonId":"112193858"},{"groupId":"133692682","addonId":"112193861"},{"groupId":"152144423","addonId":"112193873"},{"groupId":"152144423","addonId":"112193870"},{"groupId":"152144423","addonId":"112193872"},{"groupId":"152144423","addonId":"112193838"},{"groupId":"152144423","addonId":"112193840"},{"groupId":"152144423","addonId":"112193842"},{"groupId":"152144423","addonId":"112193844"},{"groupId":"152144423","addonId":"112193849"},{"groupId":"152144423","addonId":"112193845"},{"groupId":"152144423","addonId":"112193851"},{"groupId":"152144423","addonId":"112193853"},{"groupId":"133692684","addonId":"112193837"},{"groupId":"133692684","addonId":"112193876"},{"groupId":"133692684","addonId":"112193869"},{"groupId":"133692684","addonId":"112193864"},{"groupId":"133692684","addonId":"112193835"},{"groupId":"133692684","addonId":"112193868"},{"groupId":"133692684","addonId":"112193846"},{"groupId":"152144408","addonId":"112193873"}]},{"variations":[{"groupId":"37266405","variationId":"116401116"},{"groupId":"37266406","variationId":"126057908"}],"price":39400,"addonCombinations":[{"groupId":"133692682","addonId":"112193863"},{"groupId":"133692682","addonId":"112193860"},{"groupId":"133692682","addonId":"112193859"},{"groupId":"133692682","addonId":"115290079"},{"groupId":"133692682","addonId":"112193858"},{"groupId":"133692682","addonId":"112193861"},{"groupId":"152144423","addonId":"112193873"},{"groupId":"152144423","addonId":"112193870"},{"groupId":"152144423","addonId":"112193872"},{"groupId":"152144423","addonId":"112193838"},{"groupId":"152144423","addonId":"112193840"},{"groupId":"152144423","addonId":"112193842"},{"groupId":"152144423","addonId":"112193844"},{"groupId":"152144423","addonId":"112193849"},{"groupId":"152144423","addonId":"112193845"},{"groupId":"152144423","addonId":"112193851"},{"groupId":"152144423","addonId":"112193853"},{"groupId":"133692684","addonId":"112193837"},{"groupId":"133692684","addonId":"112193876"},{"groupId":"133692684","addonId":"112193869"},{"groupId":"133692684","addonId":"112193864"},{"groupId":"133692684","addonId":"112193835"},{"groupId":"133692684","addonId":"112193868"},{"groupId":"133692684","addonId":"112193846"},{"groupId":"152144408","addonId":"112193873"}]},{"variations":[{"groupId":"37266405","variationId":"116401116"},{"groupId":"37266406","variationId":"116401122"}],"price":39400,"addonCombinations":[{"groupId":"133692682","addonId":"112193863"},{"groupId":"133692682","addonId":"112193860"},{"groupId":"133692682","addonId":"112193859"},{"groupId":"133692682","addonId":"115290079"},{"groupId":"133692682","addonId":"112193858"},{"groupId":"133692682","addonId":"112193861"},{"groupId":"152144423","addonId":"112193873"},{"groupId":"152144423","addonId":"112193870"},{"groupId":"152144423","addonId":"112193872"},{"groupId":"152144423","addonId":"112193838"},{"groupId":"152144423","addonId":"112193840"},{"groupId":"152144423","addonId":"112193842"},{"groupId":"152144423","addonId":"112193844"},{"groupId":"152144423","addonId":"112193849"},{"groupId":"152144423","addonId":"112193845"},{"groupId":"152144423","addonId":"112193851"},{"groupId":"152144423","addonId":"112193853"},{"groupId":"133692684","addonId":"112193837"},{"groupId":"133692684","addonId":"112193876"},{"groupId":"133692684","addonId":"112193869"},{"groupId":"133692684","addonId":"112193864"},{"groupId":"133692684","addonId":"112193835"},{"groupId":"133692684","addonId":"112193868"},{"groupId":"133692684","addonId":"112193846"},{"groupId":"152144408","addonId":"112193873"}]},{"variations":[{"groupId":"37266405","variationId":"116401117"},{"groupId":"37266406","variationId":"116401119"}],"price":56900,"addonCombinations":[{"groupId":"133692682","addonId":"112193863"},{"groupId":"133692682","addonId":"112193860"},{"groupId":"133692682","addonId":"112193859"},{"groupId":"133692682","addonId":"115290079"},{"groupId":"133692682","addonId":"112193858"},{"groupId":"133692682","addonId":"112193861"},{"groupId":"152144409","addonId":"117361301"},{"groupId":"152144426","addonId":"112193843"},{"groupId":"152144426","addonId":"112193839"},{"groupId":"152144426","addonId":"112193841"},{"groupId":"152144426","addonId":"112193877"},{"groupId":"152144426","addonId":"112193848"},{"groupId":"152144426","addonId":"112193850"},{"groupId":"152144426","addonId":"112193852"},{"groupId":"152144426","addonId":"112193854"},{"groupId":"152144426","addonId":"112193856"},{"groupId":"152144426","addonId":"112193855"},{"groupId":"152144426","addonId":"112193865"},{"groupId":"152144426","addonId":"112193866"},{"groupId":"133692685","addonId":"112193847"},{"groupId":"133692685","addonId":"112193875"},{"groupId":"133692685","addonId":"112193879"},{"groupId":"133692685","addonId":"112193862"},{"groupId":"133692685","addonId":"112193834"},{"groupId":"133692685","addonId":"112193836"},{"groupId":"133692685","addonId":"112193874"}]},{"variations":[{"groupId":"37266405","variationId":"116401117"},{"groupId":"37266406","variationId":"126057910"}],"price":66800,"addonCombinations":[{"groupId":"133692682","addonId":"112193863"},{"groupId":"133692682","addonId":"112193860"},{"groupId":"133692682","addonId":"112193859"},{"groupId":"133692682","addonId":"115290079"},{"groupId":"133692682","addonId":"112193858"},{"groupId":"133692682","addonId":"112193861"},{"groupId":"152144409","addonId":"117361301"},{"groupId":"152144426","addonId":"112193843"},{"groupId":"152144426","addonId":"112193839"},{"groupId":"152144426","addonId":"112193841"},{"groupId":"152144426","addonId":"112193877"},{"groupId":"152144426","addonId":"112193848"},{"groupId":"152144426","addonId":"112193850"},{"groupId":"152144426","addonId":"112193852"},{"groupId":"152144426","addonId":"112193854"},{"groupId":"152144426","addonId":"112193856"},{"groupId":"152144426","addonId":"112193855"},{"groupId":"152144426","addonId":"112193865"},{"groupId":"152144426","addonId":"112193866"},{"groupId":"133692685","addonId":"112193847"},{"groupId":"133692685","addonId":"112193875"},{"groupId":"133692685","addonId":"112193879"},{"groupId":"133692685","addonId":"112193862"},{"groupId":"133692685","addonId":"112193834"},{"groupId":"133692685","addonId":"112193836"},{"groupId":"133692685","addonId":"112193874"}]},{"variations":[{"groupId":"37266405","variationId":"116401117"},{"groupId":"37266406","variationId":"116401123"}],"price":66800,"addonCombinations":[{"groupId":"133692682","addonId":"112193863"},{"groupId":"133692682","addonId":"112193860"},{"groupId":"133692682","addonId":"112193859"},{"groupId":"133692682","addonId":"115290079"},{"groupId":"133692682","addonId":"112193858"},{"groupId":"133692682","addonId":"112193861"},{"groupId":"152144409","addonId":"117361301"},{"groupId":"152144426","addonId":"112193843"},{"groupId":"152144426","addonId":"112193839"},{"groupId":"152144426","addonId":"112193841"},{"groupId":"152144426","addonId":"112193877"},{"groupId":"152144426","addonId":"112193848"},{"groupId":"152144426","addonId":"112193850"},{"groupId":"152144426","addonId":"112193852"},{"groupId":"152144426","addonId":"112193854"},{"groupId":"152144426","addonId":"112193856"},{"groupId":"152144426","addonId":"112193855"},{"groupId":"152144426","addonId":"112193865"},{"groupId":"152144426","addonId":"112193866"},{"groupId":"133692685","addonId":"112193847"},{"groupId":"133692685","addonId":"112193875"},{"groupId":"133692685","addonId":"112193879"},{"groupId":"133692685","addonId":"112193862"},{"groupId":"133692685","addonId":"112193834"},{"groupId":"133692685","addonId":"112193836"},{"groupId":"133692685","addonId":"112193874"}]},{"variations":[{"groupId":"37266405","variationId":"124780591"},{"groupId":"37266406","variationId":"124780596"}],"price":74900,"addonCombinations":[{"groupId":"133692682","addonId":"112193863"},{"groupId":"133692682","addonId":"112193860"},{"groupId":"133692682","addonId":"112193859"},{"groupId":"133692682","addonId":"115290079"},{"groupId":"133692682","addonId":"112193858"},{"groupId":"133692682","addonId":"112193861"},{"groupId":"152144412","addonId":"114785288"},{"groupId":"152144419","addonId":"114785287"},{"groupId":"152144419","addonId":"114785288"},{"groupId":"152144419","addonId":"114785289"},{"groupId":"152144419","addonId":"114785290"},{"groupId":"152144419","addonId":"114785286"},{"groupId":"152144419","addonId":"114785301"},{"groupId":"152144419","addonId":"114785302"},{"groupId":"152144419","addonId":"114785297"},{"groupId":"152144419","addonId":"114785298"},{"groupId":"152144419","addonId":"114785299"},{"groupId":"152144419","addonId":"114785300"},{"groupId":"152144419","addonId":"114785293"},{"groupId":"152144419","addonId":"114785294"},{"groupId":"140233170","addonId":"114785291"},{"groupId":"140233170","addonId":"114785295"},{"groupId":"140233170","addonId":"114785296"},{"groupId":"140233170","addonId":"114785305"},{"groupId":"140233170","addonId":"114785306"},{"groupId":"140233170","addonId":"114785307"},{"groupId":"140233170","addonId":"114785304"}]}]},"addons":[{"groupId":"152144408","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"152144412","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140233170","groupName":"Add Non Veg Toppings","choices":[{"id":"114785291","name":"Chicken Keema Masala","price":9900,"inStock":1,"isEnabled":1},{"id":"114785295","name":"Chicken Malai Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785296","name":"Chicken Pepperoni","price":9900,"inStock":1,"isEnabled":1},{"id":"114785305","name":"Chicken sausage","price":9900,"inStock":1,"isEnabled":1},{"id":"114785306","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785307","name":"Herbed Chicken","price":9900,"inStock":1,"isEnabled":1},{"id":"114785304","name":"Schezwan Chicken Meatball","price":9900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144419","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144423","groupName":"Add Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692684","groupName":"Add Non-Veg Toppings","choices":[{"id":"112193837","name":"Chicken Pepperoni","price":6500,"inStock":1,"isEnabled":1},{"id":"112193876","name":"Chicken Sausage","price":6500,"inStock":1,"isEnabled":1},{"id":"112193869","name":"Chicken Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193864","name":"Chicken Malai Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193835","name":"Herbed Chicken","price":6500,"inStock":1,"isEnabled":1},{"id":"112193868","name":"Schezwan Chicken Meatball","price":6500,"inStock":1,"isEnabled":1},{"id":"112193846","name":"Chicken Keema Masala","price":6000,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692682","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"152144426","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692685","groupName":"Add. Non-Veg Toppings","choices":[{"id":"112193847","name":"Chicken Pepperoni","price":8500,"inStock":1,"isEnabled":1},{"id":"112193875","name":"Chicken Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193879","name":"Chicken Sausage","price":8500,"inStock":1,"isEnabled":1},{"id":"112193862","name":"Chicken Malai Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193834","name":"Herbed Chicken","price":8500,"inStock":1,"isEnabled":1},{"id":"112193836","name":"Chicken Keema Masala","price":8000,"inStock":1,"isEnabled":1},{"id":"112193874","name":"Schezwan Chicken Meatball","price":8500,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":31900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859721","name":"Awesome American Cheesy Chicken","category":"Non Veg Pizza","description":"Serves 1 | Our divine peruvian flavoured cheesy sauce, topped with classic chicken pepperoni, cheese and chicken sausage black olives, spicy jalapeno and 100% mozzarella cheese, finished with a generous drizzle of texas garlic sauce. (PAN Per/Med-297 Kcal/100g | TnC-301 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"f55016931d13f7489c6140de76fa16aa","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266413","name":"Size","variations":[{"name":"Personal","default":1,"id":"116401160","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266414","variationId":"116401162"}},{"name":"Medium","id":"116401161","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266414","variationId":"116401163"}},{"name":"Thin n Large","id":"124781041","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266414","variationId":"124781042"}}]},{"groupId":"37266414","name":"Choose your Crust","variations":[{"name":"Pan","price":379,"default":1,"id":"116401162","inStock":1,"isEnabled":1},{"name":"Pan","price":639,"id":"116401163","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":454,"id":"116401166","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":738,"id":"116401167","inStock":1,"isEnabled":1},{"name":"Thin n Crispy","price":949,"id":"124781042","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":454,"id":"126057639","isEnabled":1},{"name":"Stuffed Crust - Maxx","price":738,"id":"126057640","isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266413","variationId":"116401160"},{"groupId":"37266414","variationId":"116401162"}],"price":37900,"addonCombinations":[{"groupId":"133692689","addonId":"112193863"},{"groupId":"133692689","addonId":"112193860"},{"groupId":"133692689","addonId":"112193859"},{"groupId":"133692689","addonId":"115290079"},{"groupId":"133692689","addonId":"112193858"},{"groupId":"133692689","addonId":"112193861"},{"groupId":"152144252","addonId":"112193873"},{"groupId":"152144252","addonId":"112193870"},{"groupId":"152144252","addonId":"112193872"},{"groupId":"152144252","addonId":"112193838"},{"groupId":"152144252","addonId":"112193840"},{"groupId":"152144252","addonId":"112193842"},{"groupId":"152144252","addonId":"112193844"},{"groupId":"152144252","addonId":"112193849"},{"groupId":"152144252","addonId":"112193845"},{"groupId":"152144252","addonId":"112193851"},{"groupId":"152144252","addonId":"112193853"},{"groupId":"133692690","addonId":"112193837"},{"groupId":"133692690","addonId":"112193876"},{"groupId":"133692690","addonId":"112193869"},{"groupId":"133692690","addonId":"112193864"},{"groupId":"133692690","addonId":"112193835"},{"groupId":"133692690","addonId":"112193868"},{"groupId":"133692690","addonId":"112193846"},{"groupId":"152144237","addonId":"112193873"}]},{"variations":[{"groupId":"37266413","variationId":"116401160"},{"groupId":"37266414","variationId":"126057639"}],"price":45400,"addonCombinations":[{"groupId":"133692689","addonId":"112193863"},{"groupId":"133692689","addonId":"112193860"},{"groupId":"133692689","addonId":"112193859"},{"groupId":"133692689","addonId":"115290079"},{"groupId":"133692689","addonId":"112193858"},{"groupId":"133692689","addonId":"112193861"},{"groupId":"152144252","addonId":"112193873"},{"groupId":"152144252","addonId":"112193870"},{"groupId":"152144252","addonId":"112193872"},{"groupId":"152144252","addonId":"112193838"},{"groupId":"152144252","addonId":"112193840"},{"groupId":"152144252","addonId":"112193842"},{"groupId":"152144252","addonId":"112193844"},{"groupId":"152144252","addonId":"112193849"},{"groupId":"152144252","addonId":"112193845"},{"groupId":"152144252","addonId":"112193851"},{"groupId":"152144252","addonId":"112193853"},{"groupId":"133692690","addonId":"112193837"},{"groupId":"133692690","addonId":"112193876"},{"groupId":"133692690","addonId":"112193869"},{"groupId":"133692690","addonId":"112193864"},{"groupId":"133692690","addonId":"112193835"},{"groupId":"133692690","addonId":"112193868"},{"groupId":"133692690","addonId":"112193846"},{"groupId":"152144237","addonId":"112193873"}]},{"variations":[{"groupId":"37266413","variationId":"116401160"},{"groupId":"37266414","variationId":"116401166"}],"price":45400,"addonCombinations":[{"groupId":"133692689","addonId":"112193863"},{"groupId":"133692689","addonId":"112193860"},{"groupId":"133692689","addonId":"112193859"},{"groupId":"133692689","addonId":"115290079"},{"groupId":"133692689","addonId":"112193858"},{"groupId":"133692689","addonId":"112193861"},{"groupId":"152144252","addonId":"112193873"},{"groupId":"152144252","addonId":"112193870"},{"groupId":"152144252","addonId":"112193872"},{"groupId":"152144252","addonId":"112193838"},{"groupId":"152144252","addonId":"112193840"},{"groupId":"152144252","addonId":"112193842"},{"groupId":"152144252","addonId":"112193844"},{"groupId":"152144252","addonId":"112193849"},{"groupId":"152144252","addonId":"112193845"},{"groupId":"152144252","addonId":"112193851"},{"groupId":"152144252","addonId":"112193853"},{"groupId":"133692690","addonId":"112193837"},{"groupId":"133692690","addonId":"112193876"},{"groupId":"133692690","addonId":"112193869"},{"groupId":"133692690","addonId":"112193864"},{"groupId":"133692690","addonId":"112193835"},{"groupId":"133692690","addonId":"112193868"},{"groupId":"133692690","addonId":"112193846"},{"groupId":"152144237","addonId":"112193873"}]},{"variations":[{"groupId":"37266413","variationId":"116401161"},{"groupId":"37266414","variationId":"116401163"}],"price":63900,"addonCombinations":[{"groupId":"133692689","addonId":"112193863"},{"groupId":"133692689","addonId":"112193860"},{"groupId":"133692689","addonId":"112193859"},{"groupId":"133692689","addonId":"115290079"},{"groupId":"133692689","addonId":"112193858"},{"groupId":"133692689","addonId":"112193861"},{"groupId":"152144240","addonId":"117361301"},{"groupId":"152144258","addonId":"112193843"},{"groupId":"152144258","addonId":"112193839"},{"groupId":"152144258","addonId":"112193841"},{"groupId":"152144258","addonId":"112193877"},{"groupId":"152144258","addonId":"112193848"},{"groupId":"152144258","addonId":"112193850"},{"groupId":"152144258","addonId":"112193852"},{"groupId":"152144258","addonId":"112193854"},{"groupId":"152144258","addonId":"112193856"},{"groupId":"152144258","addonId":"112193855"},{"groupId":"152144258","addonId":"112193865"},{"groupId":"152144258","addonId":"112193866"},{"groupId":"133692691","addonId":"112193847"},{"groupId":"133692691","addonId":"112193875"},{"groupId":"133692691","addonId":"112193879"},{"groupId":"133692691","addonId":"112193862"},{"groupId":"133692691","addonId":"112193834"},{"groupId":"133692691","addonId":"112193836"},{"groupId":"133692691","addonId":"112193874"}]},{"variations":[{"groupId":"37266413","variationId":"116401161"},{"groupId":"37266414","variationId":"126057640"}],"price":73800,"addonCombinations":[{"groupId":"133692689","addonId":"112193863"},{"groupId":"133692689","addonId":"112193860"},{"groupId":"133692689","addonId":"112193859"},{"groupId":"133692689","addonId":"115290079"},{"groupId":"133692689","addonId":"112193858"},{"groupId":"133692689","addonId":"112193861"},{"groupId":"152144240","addonId":"117361301"},{"groupId":"152144258","addonId":"112193843"},{"groupId":"152144258","addonId":"112193839"},{"groupId":"152144258","addonId":"112193841"},{"groupId":"152144258","addonId":"112193877"},{"groupId":"152144258","addonId":"112193848"},{"groupId":"152144258","addonId":"112193850"},{"groupId":"152144258","addonId":"112193852"},{"groupId":"152144258","addonId":"112193854"},{"groupId":"152144258","addonId":"112193856"},{"groupId":"152144258","addonId":"112193855"},{"groupId":"152144258","addonId":"112193865"},{"groupId":"152144258","addonId":"112193866"},{"groupId":"133692691","addonId":"112193847"},{"groupId":"133692691","addonId":"112193875"},{"groupId":"133692691","addonId":"112193879"},{"groupId":"133692691","addonId":"112193862"},{"groupId":"133692691","addonId":"112193834"},{"groupId":"133692691","addonId":"112193836"},{"groupId":"133692691","addonId":"112193874"}]},{"variations":[{"groupId":"37266413","variationId":"116401161"},{"groupId":"37266414","variationId":"116401167"}],"price":73800,"addonCombinations":[{"groupId":"133692689","addonId":"112193863"},{"groupId":"133692689","addonId":"112193860"},{"groupId":"133692689","addonId":"112193859"},{"groupId":"133692689","addonId":"115290079"},{"groupId":"133692689","addonId":"112193858"},{"groupId":"133692689","addonId":"112193861"},{"groupId":"152144240","addonId":"117361301"},{"groupId":"152144258","addonId":"112193843"},{"groupId":"152144258","addonId":"112193839"},{"groupId":"152144258","addonId":"112193841"},{"groupId":"152144258","addonId":"112193877"},{"groupId":"152144258","addonId":"112193848"},{"groupId":"152144258","addonId":"112193850"},{"groupId":"152144258","addonId":"112193852"},{"groupId":"152144258","addonId":"112193854"},{"groupId":"152144258","addonId":"112193856"},{"groupId":"152144258","addonId":"112193855"},{"groupId":"152144258","addonId":"112193865"},{"groupId":"152144258","addonId":"112193866"},{"groupId":"133692691","addonId":"112193847"},{"groupId":"133692691","addonId":"112193875"},{"groupId":"133692691","addonId":"112193879"},{"groupId":"133692691","addonId":"112193862"},{"groupId":"133692691","addonId":"112193834"},{"groupId":"133692691","addonId":"112193836"},{"groupId":"133692691","addonId":"112193874"}]},{"variations":[{"groupId":"37266413","variationId":"124781041"},{"groupId":"37266414","variationId":"124781042"}],"price":94900,"addonCombinations":[{"groupId":"133692689","addonId":"112193863"},{"groupId":"133692689","addonId":"112193860"},{"groupId":"133692689","addonId":"112193859"},{"groupId":"133692689","addonId":"115290079"},{"groupId":"133692689","addonId":"112193858"},{"groupId":"133692689","addonId":"112193861"},{"groupId":"152144242","addonId":"114785288"},{"groupId":"152144248","addonId":"114785287"},{"groupId":"152144248","addonId":"114785288"},{"groupId":"152144248","addonId":"114785289"},{"groupId":"152144248","addonId":"114785290"},{"groupId":"152144248","addonId":"114785286"},{"groupId":"152144248","addonId":"114785301"},{"groupId":"152144248","addonId":"114785302"},{"groupId":"152144248","addonId":"114785297"},{"groupId":"152144248","addonId":"114785298"},{"groupId":"152144248","addonId":"114785299"},{"groupId":"152144248","addonId":"114785300"},{"groupId":"152144248","addonId":"114785293"},{"groupId":"152144248","addonId":"114785294"},{"groupId":"140233238","addonId":"114785291"},{"groupId":"140233238","addonId":"114785295"},{"groupId":"140233238","addonId":"114785296"},{"groupId":"140233238","addonId":"114785305"},{"groupId":"140233238","addonId":"114785306"},{"groupId":"140233238","addonId":"114785307"},{"groupId":"140233238","addonId":"114785304"}]}]},"addons":[{"groupId":"152144237","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"152144242","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140233238","groupName":"Add Non Veg Toppings","choices":[{"id":"114785291","name":"Chicken Keema Masala","price":9900,"inStock":1,"isEnabled":1},{"id":"114785295","name":"Chicken Malai Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785296","name":"Chicken Pepperoni","price":9900,"inStock":1,"isEnabled":1},{"id":"114785305","name":"Chicken sausage","price":9900,"inStock":1,"isEnabled":1},{"id":"114785306","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785307","name":"Herbed Chicken","price":9900,"inStock":1,"isEnabled":1},{"id":"114785304","name":"Schezwan Chicken Meatball","price":9900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144248","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144252","groupName":"Add Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692690","groupName":"Add Non-Veg Toppings","choices":[{"id":"112193837","name":"Chicken Pepperoni","price":6500,"inStock":1,"isEnabled":1},{"id":"112193876","name":"Chicken Sausage","price":6500,"inStock":1,"isEnabled":1},{"id":"112193869","name":"Chicken Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193864","name":"Chicken Malai Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193835","name":"Herbed Chicken","price":6500,"inStock":1,"isEnabled":1},{"id":"112193868","name":"Schezwan Chicken Meatball","price":6500,"inStock":1,"isEnabled":1},{"id":"112193846","name":"Chicken Keema Masala","price":6000,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692689","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"152144258","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692691","groupName":"Add. Non-Veg Toppings","choices":[{"id":"112193847","name":"Chicken Pepperoni","price":8500,"inStock":1,"isEnabled":1},{"id":"112193875","name":"Chicken Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193879","name":"Chicken Sausage","price":8500,"inStock":1,"isEnabled":1},{"id":"112193862","name":"Chicken Malai Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193834","name":"Herbed Chicken","price":8500,"inStock":1,"isEnabled":1},{"id":"112193836","name":"Chicken Keema Masala","price":8000,"inStock":1,"isEnabled":1},{"id":"112193874","name":"Schezwan Chicken Meatball","price":8500,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":37900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859598","name":"Chicken Sausage","category":"Non Veg Pizza","description":"Serves 1 | Pizza topped with chicken n cheese sausages & crunchy onions, flavourful pan sauce and 100% mozzarella cheese (PAN Per/Med-310 Kcal/100g | TnC-312 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"aylqpxx08pltowbzxhd3","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266261","name":"Size","variations":[{"name":"Personal","default":1,"id":"116400608","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266262","variationId":"116400610"}},{"name":"Medium","id":"116400609","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266262","variationId":"116400611"}},{"name":"Thin n Large","id":"124780743","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266262","variationId":"124780748"}}]},{"groupId":"37266262","name":"Choose your Crust","variations":[{"name":"Pan","price":259,"default":1,"id":"116400610","inStock":1,"isEnabled":1},{"name":"Pan","price":489,"id":"116400611","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":334,"id":"116400612","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":588,"id":"116400613","inStock":1,"isEnabled":1},{"name":"Thin n Crispy","price":649,"id":"124780748","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":334,"id":"126057765","isEnabled":1},{"name":"Stuffed Crust - Maxx","price":588,"id":"126057766","isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266261","variationId":"116400608"},{"groupId":"37266262","variationId":"116400610"}],"price":25900,"addonCombinations":[{"groupId":"133692571","addonId":"112193863"},{"groupId":"133692571","addonId":"112193860"},{"groupId":"133692571","addonId":"112193859"},{"groupId":"133692571","addonId":"115290079"},{"groupId":"133692571","addonId":"112193858"},{"groupId":"133692571","addonId":"112193861"},{"groupId":"152144213","addonId":"112193873"},{"groupId":"152144213","addonId":"112193870"},{"groupId":"152144213","addonId":"112193872"},{"groupId":"152144213","addonId":"112193838"},{"groupId":"152144213","addonId":"112193840"},{"groupId":"152144213","addonId":"112193842"},{"groupId":"152144213","addonId":"112193844"},{"groupId":"152144213","addonId":"112193849"},{"groupId":"152144213","addonId":"112193845"},{"groupId":"152144213","addonId":"112193851"},{"groupId":"152144213","addonId":"112193853"},{"groupId":"133692572","addonId":"112193837"},{"groupId":"133692572","addonId":"112193876"},{"groupId":"133692572","addonId":"112193869"},{"groupId":"133692572","addonId":"112193864"},{"groupId":"133692572","addonId":"112193835"},{"groupId":"133692572","addonId":"112193868"},{"groupId":"133692572","addonId":"112193846"},{"groupId":"152144208","addonId":"112193873"}]},{"variations":[{"groupId":"37266261","variationId":"116400608"},{"groupId":"37266262","variationId":"116400612"}],"price":33400,"addonCombinations":[{"groupId":"133692571","addonId":"112193863"},{"groupId":"133692571","addonId":"112193860"},{"groupId":"133692571","addonId":"112193859"},{"groupId":"133692571","addonId":"115290079"},{"groupId":"133692571","addonId":"112193858"},{"groupId":"133692571","addonId":"112193861"},{"groupId":"152144213","addonId":"112193873"},{"groupId":"152144213","addonId":"112193870"},{"groupId":"152144213","addonId":"112193872"},{"groupId":"152144213","addonId":"112193838"},{"groupId":"152144213","addonId":"112193840"},{"groupId":"152144213","addonId":"112193842"},{"groupId":"152144213","addonId":"112193844"},{"groupId":"152144213","addonId":"112193849"},{"groupId":"152144213","addonId":"112193845"},{"groupId":"152144213","addonId":"112193851"},{"groupId":"152144213","addonId":"112193853"},{"groupId":"133692572","addonId":"112193837"},{"groupId":"133692572","addonId":"112193876"},{"groupId":"133692572","addonId":"112193869"},{"groupId":"133692572","addonId":"112193864"},{"groupId":"133692572","addonId":"112193835"},{"groupId":"133692572","addonId":"112193868"},{"groupId":"133692572","addonId":"112193846"},{"groupId":"152144208","addonId":"112193873"}]},{"variations":[{"groupId":"37266261","variationId":"116400608"},{"groupId":"37266262","variationId":"126057765"}],"price":33400,"addonCombinations":[{"groupId":"133692571","addonId":"112193863"},{"groupId":"133692571","addonId":"112193860"},{"groupId":"133692571","addonId":"112193859"},{"groupId":"133692571","addonId":"115290079"},{"groupId":"133692571","addonId":"112193858"},{"groupId":"133692571","addonId":"112193861"},{"groupId":"152144213","addonId":"112193873"},{"groupId":"152144213","addonId":"112193870"},{"groupId":"152144213","addonId":"112193872"},{"groupId":"152144213","addonId":"112193838"},{"groupId":"152144213","addonId":"112193840"},{"groupId":"152144213","addonId":"112193842"},{"groupId":"152144213","addonId":"112193844"},{"groupId":"152144213","addonId":"112193849"},{"groupId":"152144213","addonId":"112193845"},{"groupId":"152144213","addonId":"112193851"},{"groupId":"152144213","addonId":"112193853"},{"groupId":"133692572","addonId":"112193837"},{"groupId":"133692572","addonId":"112193876"},{"groupId":"133692572","addonId":"112193869"},{"groupId":"133692572","addonId":"112193864"},{"groupId":"133692572","addonId":"112193835"},{"groupId":"133692572","addonId":"112193868"},{"groupId":"133692572","addonId":"112193846"},{"groupId":"152144208","addonId":"112193873"}]},{"variations":[{"groupId":"37266261","variationId":"116400609"},{"groupId":"37266262","variationId":"116400611"}],"price":48900,"addonCombinations":[{"groupId":"133692571","addonId":"112193863"},{"groupId":"133692571","addonId":"112193860"},{"groupId":"133692571","addonId":"112193859"},{"groupId":"133692571","addonId":"115290079"},{"groupId":"133692571","addonId":"112193858"},{"groupId":"133692571","addonId":"112193861"},{"groupId":"152144209","addonId":"117361301"},{"groupId":"152144220","addonId":"112193843"},{"groupId":"152144220","addonId":"112193839"},{"groupId":"152144220","addonId":"112193841"},{"groupId":"152144220","addonId":"112193877"},{"groupId":"152144220","addonId":"112193848"},{"groupId":"152144220","addonId":"112193850"},{"groupId":"152144220","addonId":"112193852"},{"groupId":"152144220","addonId":"112193854"},{"groupId":"152144220","addonId":"112193856"},{"groupId":"152144220","addonId":"112193855"},{"groupId":"152144220","addonId":"112193865"},{"groupId":"152144220","addonId":"112193866"},{"groupId":"133692573","addonId":"112193847"},{"groupId":"133692573","addonId":"112193875"},{"groupId":"133692573","addonId":"112193879"},{"groupId":"133692573","addonId":"112193862"},{"groupId":"133692573","addonId":"112193834"},{"groupId":"133692573","addonId":"112193836"},{"groupId":"133692573","addonId":"112193874"}]},{"variations":[{"groupId":"37266261","variationId":"116400609"},{"groupId":"37266262","variationId":"116400613"}],"price":58800,"addonCombinations":[{"groupId":"133692571","addonId":"112193863"},{"groupId":"133692571","addonId":"112193860"},{"groupId":"133692571","addonId":"112193859"},{"groupId":"133692571","addonId":"115290079"},{"groupId":"133692571","addonId":"112193858"},{"groupId":"133692571","addonId":"112193861"},{"groupId":"152144209","addonId":"117361301"},{"groupId":"152144220","addonId":"112193843"},{"groupId":"152144220","addonId":"112193839"},{"groupId":"152144220","addonId":"112193841"},{"groupId":"152144220","addonId":"112193877"},{"groupId":"152144220","addonId":"112193848"},{"groupId":"152144220","addonId":"112193850"},{"groupId":"152144220","addonId":"112193852"},{"groupId":"152144220","addonId":"112193854"},{"groupId":"152144220","addonId":"112193856"},{"groupId":"152144220","addonId":"112193855"},{"groupId":"152144220","addonId":"112193865"},{"groupId":"152144220","addonId":"112193866"},{"groupId":"133692573","addonId":"112193847"},{"groupId":"133692573","addonId":"112193875"},{"groupId":"133692573","addonId":"112193879"},{"groupId":"133692573","addonId":"112193862"},{"groupId":"133692573","addonId":"112193834"},{"groupId":"133692573","addonId":"112193836"},{"groupId":"133692573","addonId":"112193874"}]},{"variations":[{"groupId":"37266261","variationId":"116400609"},{"groupId":"37266262","variationId":"126057766"}],"price":58800,"addonCombinations":[{"groupId":"133692571","addonId":"112193863"},{"groupId":"133692571","addonId":"112193860"},{"groupId":"133692571","addonId":"112193859"},{"groupId":"133692571","addonId":"115290079"},{"groupId":"133692571","addonId":"112193858"},{"groupId":"133692571","addonId":"112193861"},{"groupId":"152144209","addonId":"117361301"},{"groupId":"152144220","addonId":"112193843"},{"groupId":"152144220","addonId":"112193839"},{"groupId":"152144220","addonId":"112193841"},{"groupId":"152144220","addonId":"112193877"},{"groupId":"152144220","addonId":"112193848"},{"groupId":"152144220","addonId":"112193850"},{"groupId":"152144220","addonId":"112193852"},{"groupId":"152144220","addonId":"112193854"},{"groupId":"152144220","addonId":"112193856"},{"groupId":"152144220","addonId":"112193855"},{"groupId":"152144220","addonId":"112193865"},{"groupId":"152144220","addonId":"112193866"},{"groupId":"133692573","addonId":"112193847"},{"groupId":"133692573","addonId":"112193875"},{"groupId":"133692573","addonId":"112193879"},{"groupId":"133692573","addonId":"112193862"},{"groupId":"133692573","addonId":"112193834"},{"groupId":"133692573","addonId":"112193836"},{"groupId":"133692573","addonId":"112193874"}]},{"variations":[{"groupId":"37266261","variationId":"124780743"},{"groupId":"37266262","variationId":"124780748"}],"price":64900,"addonCombinations":[{"groupId":"133692571","addonId":"112193863"},{"groupId":"133692571","addonId":"112193860"},{"groupId":"133692571","addonId":"112193859"},{"groupId":"133692571","addonId":"115290079"},{"groupId":"133692571","addonId":"112193858"},{"groupId":"133692571","addonId":"112193861"},{"groupId":"152144210","addonId":"114785288"},{"groupId":"152144211","addonId":"114785287"},{"groupId":"152144211","addonId":"114785288"},{"groupId":"152144211","addonId":"114785289"},{"groupId":"152144211","addonId":"114785290"},{"groupId":"152144211","addonId":"114785286"},{"groupId":"152144211","addonId":"114785301"},{"groupId":"152144211","addonId":"114785302"},{"groupId":"152144211","addonId":"114785297"},{"groupId":"152144211","addonId":"114785298"},{"groupId":"152144211","addonId":"114785299"},{"groupId":"152144211","addonId":"114785300"},{"groupId":"152144211","addonId":"114785293"},{"groupId":"152144211","addonId":"114785294"},{"groupId":"140233188","addonId":"114785291"},{"groupId":"140233188","addonId":"114785295"},{"groupId":"140233188","addonId":"114785296"},{"groupId":"140233188","addonId":"114785305"},{"groupId":"140233188","addonId":"114785306"},{"groupId":"140233188","addonId":"114785307"},{"groupId":"140233188","addonId":"114785304"}]}]},"addons":[{"groupId":"152144208","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"152144210","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140233188","groupName":"Add Non Veg Toppings","choices":[{"id":"114785291","name":"Chicken Keema Masala","price":9900,"inStock":1,"isEnabled":1},{"id":"114785295","name":"Chicken Malai Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785296","name":"Chicken Pepperoni","price":9900,"inStock":1,"isEnabled":1},{"id":"114785305","name":"Chicken sausage","price":9900,"inStock":1,"isEnabled":1},{"id":"114785306","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785307","name":"Herbed Chicken","price":9900,"inStock":1,"isEnabled":1},{"id":"114785304","name":"Schezwan Chicken Meatball","price":9900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144211","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144213","groupName":"Add Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692572","groupName":"Add Non-Veg Toppings","choices":[{"id":"112193837","name":"Chicken Pepperoni","price":6500,"inStock":1,"isEnabled":1},{"id":"112193876","name":"Chicken Sausage","price":6500,"inStock":1,"isEnabled":1},{"id":"112193869","name":"Chicken Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193864","name":"Chicken Malai Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193835","name":"Herbed Chicken","price":6500,"inStock":1,"isEnabled":1},{"id":"112193868","name":"Schezwan Chicken Meatball","price":6500,"inStock":1,"isEnabled":1},{"id":"112193846","name":"Chicken Keema Masala","price":6000,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692571","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"152144220","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692573","groupName":"Add. Non-Veg Toppings","choices":[{"id":"112193847","name":"Chicken Pepperoni","price":8500,"inStock":1,"isEnabled":1},{"id":"112193875","name":"Chicken Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193879","name":"Chicken Sausage","price":8500,"inStock":1,"isEnabled":1},{"id":"112193862","name":"Chicken Malai Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193834","name":"Herbed Chicken","price":8500,"inStock":1,"isEnabled":1},{"id":"112193836","name":"Chicken Keema Masala","price":8000,"inStock":1,"isEnabled":1},{"id":"112193874","name":"Schezwan Chicken Meatball","price":8500,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":25900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859706","name":"Dhabe Da Keema","category":"Non Veg Pizza","description":"Serves 1 | Dhaba style chicken keema masala, with green chiili, crunchy onion with flavourful pan sauce, 100 % mozzarella cheese & a generous drizzle of mint mayo (PAN Per/Med-270 Kcal/100g | TnC-290 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"d9eddb1993da4e5dc65ef2ceaa8503f7","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266393","name":"Size","variations":[{"name":"Personal","default":1,"id":"116401074","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266394","variationId":"116401076"}},{"name":"Medium","id":"116401075","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266394","variationId":"116401077"}},{"name":"Thin n Large","id":"124781089","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266394","variationId":"124781092"}}]},{"groupId":"37266394","name":"Choose your Crust","variations":[{"name":"Pan","price":319,"default":1,"id":"116401076","inStock":1,"isEnabled":1},{"name":"Pan","price":569,"id":"116401077","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":394,"id":"116401080","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":668,"id":"116401081","inStock":1,"isEnabled":1},{"name":"Thin n Crispy","price":749,"id":"124781092","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":394,"id":"126057811","isEnabled":1},{"name":"Stuffed Crust - Maxx","price":668,"id":"126057812","isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266393","variationId":"116401074"},{"groupId":"37266394","variationId":"116401076"}],"price":31900,"addonCombinations":[{"groupId":"133692672","addonId":"112193863"},{"groupId":"133692672","addonId":"112193860"},{"groupId":"133692672","addonId":"112193859"},{"groupId":"133692672","addonId":"115290079"},{"groupId":"133692672","addonId":"112193858"},{"groupId":"133692672","addonId":"112193861"},{"groupId":"152143876","addonId":"112193873"},{"groupId":"152143876","addonId":"112193870"},{"groupId":"152143876","addonId":"112193872"},{"groupId":"152143876","addonId":"112193838"},{"groupId":"152143876","addonId":"112193840"},{"groupId":"152143876","addonId":"112193842"},{"groupId":"152143876","addonId":"112193844"},{"groupId":"152143876","addonId":"112193849"},{"groupId":"152143876","addonId":"112193845"},{"groupId":"152143876","addonId":"112193851"},{"groupId":"152143876","addonId":"112193853"},{"groupId":"133692673","addonId":"112193837"},{"groupId":"133692673","addonId":"112193876"},{"groupId":"133692673","addonId":"112193869"},{"groupId":"133692673","addonId":"112193864"},{"groupId":"133692673","addonId":"112193835"},{"groupId":"133692673","addonId":"112193868"},{"groupId":"133692673","addonId":"112193846"},{"groupId":"152143873","addonId":"112193873"}]},{"variations":[{"groupId":"37266393","variationId":"116401074"},{"groupId":"37266394","variationId":"126057811"}],"price":39400,"addonCombinations":[{"groupId":"133692672","addonId":"112193863"},{"groupId":"133692672","addonId":"112193860"},{"groupId":"133692672","addonId":"112193859"},{"groupId":"133692672","addonId":"115290079"},{"groupId":"133692672","addonId":"112193858"},{"groupId":"133692672","addonId":"112193861"},{"groupId":"133692673","addonId":"112193837"},{"groupId":"133692673","addonId":"112193876"},{"groupId":"133692673","addonId":"112193869"},{"groupId":"133692673","addonId":"112193864"},{"groupId":"133692673","addonId":"112193835"},{"groupId":"133692673","addonId":"112193868"},{"groupId":"133692673","addonId":"112193846"}]},{"variations":[{"groupId":"37266393","variationId":"116401074"},{"groupId":"37266394","variationId":"116401080"}],"price":39400,"addonCombinations":[{"groupId":"133692672","addonId":"112193863"},{"groupId":"133692672","addonId":"112193860"},{"groupId":"133692672","addonId":"112193859"},{"groupId":"133692672","addonId":"115290079"},{"groupId":"133692672","addonId":"112193858"},{"groupId":"133692672","addonId":"112193861"},{"groupId":"133692673","addonId":"112193837"},{"groupId":"133692673","addonId":"112193876"},{"groupId":"133692673","addonId":"112193869"},{"groupId":"133692673","addonId":"112193864"},{"groupId":"133692673","addonId":"112193835"},{"groupId":"133692673","addonId":"112193868"},{"groupId":"133692673","addonId":"112193846"}]},{"variations":[{"groupId":"37266393","variationId":"116401075"},{"groupId":"37266394","variationId":"116401077"}],"price":56900,"addonCombinations":[{"groupId":"133692672","addonId":"112193863"},{"groupId":"133692672","addonId":"112193860"},{"groupId":"133692672","addonId":"112193859"},{"groupId":"133692672","addonId":"115290079"},{"groupId":"133692672","addonId":"112193858"},{"groupId":"133692672","addonId":"112193861"},{"groupId":"133692675","addonId":"112193847"},{"groupId":"133692675","addonId":"112193875"},{"groupId":"133692675","addonId":"112193879"},{"groupId":"133692675","addonId":"112193862"},{"groupId":"133692675","addonId":"112193834"},{"groupId":"133692675","addonId":"112193836"},{"groupId":"133692675","addonId":"112193874"}]},{"variations":[{"groupId":"37266393","variationId":"116401075"},{"groupId":"37266394","variationId":"126057812"}],"price":66800,"addonCombinations":[{"groupId":"133692672","addonId":"112193863"},{"groupId":"133692672","addonId":"112193860"},{"groupId":"133692672","addonId":"112193859"},{"groupId":"133692672","addonId":"115290079"},{"groupId":"133692672","addonId":"112193858"},{"groupId":"133692672","addonId":"112193861"},{"groupId":"133692675","addonId":"112193847"},{"groupId":"133692675","addonId":"112193875"},{"groupId":"133692675","addonId":"112193879"},{"groupId":"133692675","addonId":"112193862"},{"groupId":"133692675","addonId":"112193834"},{"groupId":"133692675","addonId":"112193836"},{"groupId":"133692675","addonId":"112193874"}]},{"variations":[{"groupId":"37266393","variationId":"116401075"},{"groupId":"37266394","variationId":"116401081"}],"price":66800,"addonCombinations":[{"groupId":"133692672","addonId":"112193863"},{"groupId":"133692672","addonId":"112193860"},{"groupId":"133692672","addonId":"112193859"},{"groupId":"133692672","addonId":"115290079"},{"groupId":"133692672","addonId":"112193858"},{"groupId":"133692672","addonId":"112193861"},{"groupId":"133692675","addonId":"112193847"},{"groupId":"133692675","addonId":"112193875"},{"groupId":"133692675","addonId":"112193879"},{"groupId":"133692675","addonId":"112193862"},{"groupId":"133692675","addonId":"112193834"},{"groupId":"133692675","addonId":"112193836"},{"groupId":"133692675","addonId":"112193874"}]},{"variations":[{"groupId":"37266393","variationId":"124781089"},{"groupId":"37266394","variationId":"124781092"}],"price":74900,"addonCombinations":[{"groupId":"133692672","addonId":"112193863"},{"groupId":"133692672","addonId":"112193860"},{"groupId":"133692672","addonId":"112193859"},{"groupId":"133692672","addonId":"115290079"},{"groupId":"133692672","addonId":"112193858"},{"groupId":"133692672","addonId":"112193861"},{"groupId":"152143874","addonId":"114785288"},{"groupId":"152143875","addonId":"114785287"},{"groupId":"152143875","addonId":"114785288"},{"groupId":"152143875","addonId":"114785289"},{"groupId":"152143875","addonId":"114785290"},{"groupId":"152143875","addonId":"114785286"},{"groupId":"152143875","addonId":"114785301"},{"groupId":"152143875","addonId":"114785302"},{"groupId":"152143875","addonId":"114785297"},{"groupId":"152143875","addonId":"114785298"},{"groupId":"152143875","addonId":"114785299"},{"groupId":"152143875","addonId":"114785300"},{"groupId":"152143875","addonId":"114785293"},{"groupId":"152143875","addonId":"114785294"},{"groupId":"140233252","addonId":"114785291"},{"groupId":"140233252","addonId":"114785295"},{"groupId":"140233252","addonId":"114785296"},{"groupId":"140233252","addonId":"114785305"},{"groupId":"140233252","addonId":"114785306"},{"groupId":"140233252","addonId":"114785307"},{"groupId":"140233252","addonId":"114785304"}]}]},"addons":[{"groupId":"152143873","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"152143874","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140233252","groupName":"Add Non Veg Toppings","choices":[{"id":"114785291","name":"Chicken Keema Masala","price":9900,"inStock":1,"isEnabled":1},{"id":"114785295","name":"Chicken Malai Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785296","name":"Chicken Pepperoni","price":9900,"inStock":1,"isEnabled":1},{"id":"114785305","name":"Chicken sausage","price":9900,"inStock":1,"isEnabled":1},{"id":"114785306","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785307","name":"Herbed Chicken","price":9900,"inStock":1,"isEnabled":1},{"id":"114785304","name":"Schezwan Chicken Meatball","price":9900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152143875","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152143876","groupName":"Add Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692673","groupName":"Add Non-Veg Toppings","choices":[{"id":"112193837","name":"Chicken Pepperoni","price":6500,"inStock":1,"isEnabled":1},{"id":"112193876","name":"Chicken Sausage","price":6500,"inStock":1,"isEnabled":1},{"id":"112193869","name":"Chicken Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193864","name":"Chicken Malai Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193835","name":"Herbed Chicken","price":6500,"inStock":1,"isEnabled":1},{"id":"112193868","name":"Schezwan Chicken Meatball","price":6500,"inStock":1,"isEnabled":1},{"id":"112193846","name":"Chicken Keema Masala","price":6000,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692672","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"133692675","groupName":"Add. Non-Veg Toppings","choices":[{"id":"112193847","name":"Chicken Pepperoni","price":8500,"inStock":1,"isEnabled":1},{"id":"112193875","name":"Chicken Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193879","name":"Chicken Sausage","price":8500,"inStock":1,"isEnabled":1},{"id":"112193862","name":"Chicken Malai Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193834","name":"Herbed Chicken","price":8500,"inStock":1,"isEnabled":1},{"id":"112193836","name":"Chicken Keema Masala","price":8000,"inStock":1,"isEnabled":1},{"id":"112193874","name":"Schezwan Chicken Meatball","price":8500,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":31900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859718","name":"Sausage & Sweet Corn.","category":"Non Veg Pizza","description":"Serves 1 | Our classic chicken & cheese sausage, juicy sweet corn and 100% mozzarella cheese with flavourful pan sauce (PAN Per/Med-277 Kcal/100g | TnC-282 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"190c84ffc8773254c38b3b993e31ba73","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"37266407","name":"Size","variations":[{"name":"Personal","default":1,"id":"116401124","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266408","variationId":"116401126"}},{"name":"Medium","id":"116401125","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266408","variationId":"116401127"}},{"name":"Thin n Large","id":"124780864","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"37266408","variationId":"124780867"}}]},{"groupId":"37266408","name":"Choose your Crust","variations":[{"name":"Pan","price":289,"default":1,"id":"116401126","inStock":1,"isEnabled":1},{"name":"Pan","price":529,"id":"116401127","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":388,"id":"116401130","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Chicken Seekh Kebab","price":628,"id":"116401131","inStock":1,"isEnabled":1},{"name":"Thin n Crispy","price":699,"id":"124780867","inStock":1,"isEnabled":1},{"name":"Stuffed Crust - Maxx","price":388,"id":"126057787","isEnabled":1},{"name":"Stuffed Crust - Maxx","price":628,"id":"126057788","isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"37266407","variationId":"116401124"},{"groupId":"37266408","variationId":"116401126"}],"price":28900,"addonCombinations":[{"groupId":"133692686","addonId":"112193863"},{"groupId":"133692686","addonId":"112193860"},{"groupId":"133692686","addonId":"112193859"},{"groupId":"133692686","addonId":"115290079"},{"groupId":"133692686","addonId":"112193858"},{"groupId":"133692686","addonId":"112193861"},{"groupId":"152144367","addonId":"112193873"},{"groupId":"152144367","addonId":"112193870"},{"groupId":"152144367","addonId":"112193872"},{"groupId":"152144367","addonId":"112193838"},{"groupId":"152144367","addonId":"112193840"},{"groupId":"152144367","addonId":"112193842"},{"groupId":"152144367","addonId":"112193844"},{"groupId":"152144367","addonId":"112193849"},{"groupId":"152144367","addonId":"112193845"},{"groupId":"152144367","addonId":"112193851"},{"groupId":"152144367","addonId":"112193853"},{"groupId":"133692687","addonId":"112193837"},{"groupId":"133692687","addonId":"112193876"},{"groupId":"133692687","addonId":"112193869"},{"groupId":"133692687","addonId":"112193864"},{"groupId":"133692687","addonId":"112193835"},{"groupId":"133692687","addonId":"112193868"},{"groupId":"133692687","addonId":"112193846"},{"groupId":"152144354","addonId":"112193873"}]},{"variations":[{"groupId":"37266407","variationId":"116401124"},{"groupId":"37266408","variationId":"126057787"}],"price":38800,"addonCombinations":[{"groupId":"133692686","addonId":"112193863"},{"groupId":"133692686","addonId":"112193860"},{"groupId":"133692686","addonId":"112193859"},{"groupId":"133692686","addonId":"115290079"},{"groupId":"133692686","addonId":"112193858"},{"groupId":"133692686","addonId":"112193861"},{"groupId":"152144367","addonId":"112193873"},{"groupId":"152144367","addonId":"112193870"},{"groupId":"152144367","addonId":"112193872"},{"groupId":"152144367","addonId":"112193838"},{"groupId":"152144367","addonId":"112193840"},{"groupId":"152144367","addonId":"112193842"},{"groupId":"152144367","addonId":"112193844"},{"groupId":"152144367","addonId":"112193849"},{"groupId":"152144367","addonId":"112193845"},{"groupId":"152144367","addonId":"112193851"},{"groupId":"152144367","addonId":"112193853"},{"groupId":"133692687","addonId":"112193837"},{"groupId":"133692687","addonId":"112193876"},{"groupId":"133692687","addonId":"112193869"},{"groupId":"133692687","addonId":"112193864"},{"groupId":"133692687","addonId":"112193835"},{"groupId":"133692687","addonId":"112193868"},{"groupId":"133692687","addonId":"112193846"},{"groupId":"152144354","addonId":"112193873"}]},{"variations":[{"groupId":"37266407","variationId":"116401124"},{"groupId":"37266408","variationId":"116401130"}],"price":38800,"addonCombinations":[{"groupId":"133692686","addonId":"112193863"},{"groupId":"133692686","addonId":"112193860"},{"groupId":"133692686","addonId":"112193859"},{"groupId":"133692686","addonId":"115290079"},{"groupId":"133692686","addonId":"112193858"},{"groupId":"133692686","addonId":"112193861"},{"groupId":"152144367","addonId":"112193873"},{"groupId":"152144367","addonId":"112193870"},{"groupId":"152144367","addonId":"112193872"},{"groupId":"152144367","addonId":"112193838"},{"groupId":"152144367","addonId":"112193840"},{"groupId":"152144367","addonId":"112193842"},{"groupId":"152144367","addonId":"112193844"},{"groupId":"152144367","addonId":"112193849"},{"groupId":"152144367","addonId":"112193845"},{"groupId":"152144367","addonId":"112193851"},{"groupId":"152144367","addonId":"112193853"},{"groupId":"133692687","addonId":"112193837"},{"groupId":"133692687","addonId":"112193876"},{"groupId":"133692687","addonId":"112193869"},{"groupId":"133692687","addonId":"112193864"},{"groupId":"133692687","addonId":"112193835"},{"groupId":"133692687","addonId":"112193868"},{"groupId":"133692687","addonId":"112193846"},{"groupId":"152144354","addonId":"112193873"}]},{"variations":[{"groupId":"37266407","variationId":"116401125"},{"groupId":"37266408","variationId":"116401127"}],"price":52900,"addonCombinations":[{"groupId":"133692686","addonId":"112193863"},{"groupId":"133692686","addonId":"112193860"},{"groupId":"133692686","addonId":"112193859"},{"groupId":"133692686","addonId":"115290079"},{"groupId":"133692686","addonId":"112193858"},{"groupId":"133692686","addonId":"112193861"},{"groupId":"152144356","addonId":"117361301"},{"groupId":"152144369","addonId":"112193843"},{"groupId":"152144369","addonId":"112193839"},{"groupId":"152144369","addonId":"112193841"},{"groupId":"152144369","addonId":"112193877"},{"groupId":"152144369","addonId":"112193848"},{"groupId":"152144369","addonId":"112193850"},{"groupId":"152144369","addonId":"112193852"},{"groupId":"152144369","addonId":"112193854"},{"groupId":"152144369","addonId":"112193856"},{"groupId":"152144369","addonId":"112193855"},{"groupId":"152144369","addonId":"112193865"},{"groupId":"152144369","addonId":"112193866"},{"groupId":"133692688","addonId":"112193847"},{"groupId":"133692688","addonId":"112193875"},{"groupId":"133692688","addonId":"112193879"},{"groupId":"133692688","addonId":"112193862"},{"groupId":"133692688","addonId":"112193834"},{"groupId":"133692688","addonId":"112193836"},{"groupId":"133692688","addonId":"112193874"}]},{"variations":[{"groupId":"37266407","variationId":"116401125"},{"groupId":"37266408","variationId":"126057788"}],"price":62800,"addonCombinations":[{"groupId":"133692686","addonId":"112193863"},{"groupId":"133692686","addonId":"112193860"},{"groupId":"133692686","addonId":"112193859"},{"groupId":"133692686","addonId":"115290079"},{"groupId":"133692686","addonId":"112193858"},{"groupId":"133692686","addonId":"112193861"},{"groupId":"152144356","addonId":"117361301"},{"groupId":"152144369","addonId":"112193843"},{"groupId":"152144369","addonId":"112193839"},{"groupId":"152144369","addonId":"112193841"},{"groupId":"152144369","addonId":"112193877"},{"groupId":"152144369","addonId":"112193848"},{"groupId":"152144369","addonId":"112193850"},{"groupId":"152144369","addonId":"112193852"},{"groupId":"152144369","addonId":"112193854"},{"groupId":"152144369","addonId":"112193856"},{"groupId":"152144369","addonId":"112193855"},{"groupId":"152144369","addonId":"112193865"},{"groupId":"152144369","addonId":"112193866"},{"groupId":"133692688","addonId":"112193847"},{"groupId":"133692688","addonId":"112193875"},{"groupId":"133692688","addonId":"112193879"},{"groupId":"133692688","addonId":"112193862"},{"groupId":"133692688","addonId":"112193834"},{"groupId":"133692688","addonId":"112193836"},{"groupId":"133692688","addonId":"112193874"}]},{"variations":[{"groupId":"37266407","variationId":"116401125"},{"groupId":"37266408","variationId":"116401131"}],"price":62800,"addonCombinations":[{"groupId":"133692686","addonId":"112193863"},{"groupId":"133692686","addonId":"112193860"},{"groupId":"133692686","addonId":"112193859"},{"groupId":"133692686","addonId":"115290079"},{"groupId":"133692686","addonId":"112193858"},{"groupId":"133692686","addonId":"112193861"},{"groupId":"152144356","addonId":"117361301"},{"groupId":"152144369","addonId":"112193843"},{"groupId":"152144369","addonId":"112193839"},{"groupId":"152144369","addonId":"112193841"},{"groupId":"152144369","addonId":"112193877"},{"groupId":"152144369","addonId":"112193848"},{"groupId":"152144369","addonId":"112193850"},{"groupId":"152144369","addonId":"112193852"},{"groupId":"152144369","addonId":"112193854"},{"groupId":"152144369","addonId":"112193856"},{"groupId":"152144369","addonId":"112193855"},{"groupId":"152144369","addonId":"112193865"},{"groupId":"152144369","addonId":"112193866"},{"groupId":"133692688","addonId":"112193847"},{"groupId":"133692688","addonId":"112193875"},{"groupId":"133692688","addonId":"112193879"},{"groupId":"133692688","addonId":"112193862"},{"groupId":"133692688","addonId":"112193834"},{"groupId":"133692688","addonId":"112193836"},{"groupId":"133692688","addonId":"112193874"}]},{"variations":[{"groupId":"37266407","variationId":"124780864"},{"groupId":"37266408","variationId":"124780867"}],"price":69900,"addonCombinations":[{"groupId":"133692686","addonId":"112193863"},{"groupId":"133692686","addonId":"112193860"},{"groupId":"133692686","addonId":"112193859"},{"groupId":"133692686","addonId":"115290079"},{"groupId":"133692686","addonId":"112193858"},{"groupId":"133692686","addonId":"112193861"},{"groupId":"152144359","addonId":"114785288"},{"groupId":"152144363","addonId":"114785287"},{"groupId":"152144363","addonId":"114785288"},{"groupId":"152144363","addonId":"114785289"},{"groupId":"152144363","addonId":"114785290"},{"groupId":"152144363","addonId":"114785286"},{"groupId":"152144363","addonId":"114785301"},{"groupId":"152144363","addonId":"114785302"},{"groupId":"152144363","addonId":"114785297"},{"groupId":"152144363","addonId":"114785298"},{"groupId":"152144363","addonId":"114785299"},{"groupId":"152144363","addonId":"114785300"},{"groupId":"152144363","addonId":"114785293"},{"groupId":"152144363","addonId":"114785294"},{"groupId":"140233211","addonId":"114785291"},{"groupId":"140233211","addonId":"114785295"},{"groupId":"140233211","addonId":"114785296"},{"groupId":"140233211","addonId":"114785305"},{"groupId":"140233211","addonId":"114785306"},{"groupId":"140233211","addonId":"114785307"},{"groupId":"140233211","addonId":"114785304"}]}]},"addons":[{"groupId":"152144354","groupName":"Extra Cheese Topping","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"152144359","groupName":"Extra-Cheese Topping","choices":[{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"140233211","groupName":"Add Non Veg Toppings","choices":[{"id":"114785291","name":"Chicken Keema Masala","price":9900,"inStock":1,"isEnabled":1},{"id":"114785295","name":"Chicken Malai Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785296","name":"Chicken Pepperoni","price":9900,"inStock":1,"isEnabled":1},{"id":"114785305","name":"Chicken sausage","price":9900,"inStock":1,"isEnabled":1},{"id":"114785306","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"114785307","name":"Herbed Chicken","price":9900,"inStock":1,"isEnabled":1},{"id":"114785304","name":"Schezwan Chicken Meatball","price":9900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144363","groupName":"Add Veg Toppings,","choices":[{"id":"114785287","name":"Black Olives","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785288","name":"Cheese","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785289","name":"Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785290","name":"Herbed Veggies","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785286","name":"Jalapeno","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785301","name":"Paneer","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785302","name":"Mushroom","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785297","name":"Onion","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785298","name":"Red Capsicum","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785299","name":"Red Paprika","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785300","name":"Sweet Corn","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785293","name":"Tomato","price":8000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"114785294","name":"Veg Kebab","price":8000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"152144367","groupName":"Add Veg Toppings","choices":[{"id":"112193873","name":"Cheese","price":6500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193870","name":"Black Olives","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193872","name":"Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193838","name":"Jalapeno","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193840","name":"Mushroom","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193842","name":"Onion","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193844","name":"Paneer","price":5500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193849","name":"Red Paprika","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193845","name":"Red Capsicum","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193851","name":"Sweet Corn","price":4500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193853","name":"Tomato","price":4500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692687","groupName":"Add Non-Veg Toppings","choices":[{"id":"112193837","name":"Chicken Pepperoni","price":6500,"inStock":1,"isEnabled":1},{"id":"112193876","name":"Chicken Sausage","price":6500,"inStock":1,"isEnabled":1},{"id":"112193869","name":"Chicken Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193864","name":"Chicken Malai Tikka","price":6500,"inStock":1,"isEnabled":1},{"id":"112193835","name":"Herbed Chicken","price":6500,"inStock":1,"isEnabled":1},{"id":"112193868","name":"Schezwan Chicken Meatball","price":6500,"inStock":1,"isEnabled":1},{"id":"112193846","name":"Chicken Keema Masala","price":6000,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692686","groupName":"Make it a Meal","choices":[{"id":"112193863","name":"Pepsi Pet Bottle","price":5700,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193860","name":"Classic BreadStix : Flat Rs 20 Off","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193859","name":"Cheese Garlic Bread : Flat Rs 20 Off","price":13900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193858","name":"Zesty Paneer Pocket : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193861","name":"Choco Volcano : Flat Rs 20 Off","price":10900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"115290079","name":"Loaded BreadStix : Flat Rs 20 Off","price":14900,"isVeg":1,"isEnabled":1}],"maxAddons":6,"maxFreeAddons":-1},{"groupId":"152144369","groupName":"Add. Veg Toppings..","choices":[{"id":"112193843","name":"Cheese","price":8500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193839","name":"Black Olives","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193841","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193877","name":"Herbed Veggies","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193848","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193850","name":"Mushroom","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193852","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193854","name":"Paneer","price":7500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193856","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193855","name":"Red Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193865","name":"Sweet Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"112193866","name":"Tomato","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1},{"groupId":"133692688","groupName":"Add. Non-Veg Toppings","choices":[{"id":"112193847","name":"Chicken Pepperoni","price":8500,"inStock":1,"isEnabled":1},{"id":"112193875","name":"Chicken Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193879","name":"Chicken Sausage","price":8500,"inStock":1,"isEnabled":1},{"id":"112193862","name":"Chicken Malai Tikka","price":8500,"inStock":1,"isEnabled":1},{"id":"112193834","name":"Herbed Chicken","price":8500,"inStock":1,"isEnabled":1},{"id":"112193836","name":"Chicken Keema Masala","price":8000,"inStock":1,"isEnabled":1},{"id":"112193874","name":"Schezwan Chicken Meatball","price":8500,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":28900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory","title":"New MELTS - Crispy. Cheesy. Loaded.","categories":[{"title":"Melts - Meal for 2","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135326957","name":"Create your Melts Box of 2 - Veg","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 2 | Choose any 2 Melts. Double the flavour, double the satisfaction. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g).","imageId":"e6072e97754de0c6c6030103e0fb50d3","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344700","name":"Choose your 1st Melt","variations":[{"name":"Loaded Veggie BBQ","price":189.5,"default":1,"id":"135515557","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344701","variationId":"135515565"}},{"name":"Cheezy Cheese Veg","price":219,"id":"135515559","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344701","variationId":"135515565"}},{"name":"Magical Makhni Paneer","price":299,"id":"135515561","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344701","variationId":"135515565"}}]},{"groupId":"42344701","name":"Choose your 2nd Melt","variations":[{"name":"Loaded Veggie BBQ","price":189.5,"default":1,"id":"135515565","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Cheezy Cheese Veg","price":219,"id":"135515567","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Magical Makhni Paneer","price":299,"id":"135515569","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344700","variationId":"135515557"},{"groupId":"42344701","variationId":"135515565"}],"price":37900},{"variations":[{"groupId":"42344700","variationId":"135515557"},{"groupId":"42344701","variationId":"135515567"}],"price":40850},{"variations":[{"groupId":"42344700","variationId":"135515557"},{"groupId":"42344701","variationId":"135515569"}],"price":48850},{"variations":[{"groupId":"42344700","variationId":"135515559"},{"groupId":"42344701","variationId":"135515565"}],"price":40850},{"variations":[{"groupId":"42344700","variationId":"135515559"},{"groupId":"42344701","variationId":"135515567"}],"price":43800},{"variations":[{"groupId":"42344700","variationId":"135515559"},{"groupId":"42344701","variationId":"135515569"}],"price":51800},{"variations":[{"groupId":"42344700","variationId":"135515561"},{"groupId":"42344701","variationId":"135515565"}],"price":48850},{"variations":[{"groupId":"42344700","variationId":"135515561"},{"groupId":"42344701","variationId":"135515567"}],"price":51800},{"variations":[{"groupId":"42344700","variationId":"135515561"},{"groupId":"42344701","variationId":"135515569"}],"price":59800}]},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 2"},"defaultPrice":37900,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.5","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135326960","name":"Create your Melts Box of 2 Non-Veg","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 2 | Choose any 2 Melts. Double the flavour, double the satisfaction. Cheezy Cheese Chicken : (268 Kcal/100g), Loaded BBQ Non-Veg : (330 Kcal/100g), Chicken Tikka Keema : (283 Kcal/100g).","imageId":"e7620274ab99ba415f3e00480020cb48","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344725","name":"Choose your 1st Melt","variations":[{"name":"Loaded Chicken BBQ","price":249,"default":1,"id":"135515716","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344726","variationId":"135515724"}},{"name":"Cheezy Cheese Chicken","price":269,"id":"135515719","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344726","variationId":"135515724"}},{"name":"Chicken Tikka & Keema","price":309,"id":"135515721","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344726","variationId":"135515724"}}]},{"groupId":"42344726","name":"Choose your 2nd Melt","variations":[{"name":"Loaded Chicken BBQ","price":249,"default":1,"id":"135515724","inStock":1,"isEnabled":1},{"name":"Cheezy Cheese Chicken","price":269,"id":"135515725","inStock":1,"isEnabled":1},{"name":"Chicken Tikka & Keema","price":309,"id":"135515727","inStock":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344725","variationId":"135515716"},{"groupId":"42344726","variationId":"135515724"}],"price":49800},{"variations":[{"groupId":"42344725","variationId":"135515716"},{"groupId":"42344726","variationId":"135515725"}],"price":51800},{"variations":[{"groupId":"42344725","variationId":"135515716"},{"groupId":"42344726","variationId":"135515727"}],"price":55800},{"variations":[{"groupId":"42344725","variationId":"135515719"},{"groupId":"42344726","variationId":"135515724"}],"price":51800},{"variations":[{"groupId":"42344725","variationId":"135515719"},{"groupId":"42344726","variationId":"135515725"}],"price":53800},{"variations":[{"groupId":"42344725","variationId":"135515719"},{"groupId":"42344726","variationId":"135515727"}],"price":57800},{"variations":[{"groupId":"42344725","variationId":"135515721"},{"groupId":"42344726","variationId":"135515724"}],"price":55800},{"variations":[{"groupId":"42344725","variationId":"135515721"},{"groupId":"42344726","variationId":"135515725"}],"price":57800},{"variations":[{"groupId":"42344725","variationId":"135515721"},{"groupId":"42344726","variationId":"135515727"}],"price":61800}]},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 2"},"defaultPrice":49800,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135337391","name":"Cheezy Cheese Chicken & Loaded BBQ Non-Veg Combo","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 1 | Satisfy your non veg cravings with Cheezy Cheese Chicken & Loaded Chicken BBQ Melts. Cheezy Cheese Chicken Melts : (268 Kcal/100g), Loaded BBQ Non-Veg Melts: (330 Kcal/100g).","imageId":"3779ffaf02380c80f951a1ed2b90c997","inStock":1,"price":48900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135703516","name":"Cheezy Cheese Veg & Loaded BBQ Veg Combo","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 2 | Double the satisfaction with Cheezy Cheese Veg & Loaded BBQ Veg Melts. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g).","imageId":"0b816322be7e8731246e9492e4b44b84","inStock":1,"isVeg":1,"price":39900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 2"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135337392","name":"Makhni Paneer & Chicken Tikka Keema Combo","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 2 | Satisfy your desi flavour cravings with Makhni Paneer & Chicken Tikka Keema Melts. Makhni Paneer Melts: (265 Kcal/100g), Chicken Tikka Keema Melts : (283 Kcal/100g).","imageId":"a6c351a9a53ae0c5fa2e5e401b8bf27a","inStock":1,"price":54900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 2"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]},{"title":"Melts","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"138775924","name":"Cheezy Cheese Chicken","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 1 | Thin & Crispy crust, loaded with juicy Chicken Sausage, Crunchy Onion, Green Capsicum, Red Bell Pepper, 100% mozzarella cheese, flavorful sauce, folded over and baked then brushed with herbed butter and sprinkled with cheezy seasoning. (268 Kcal/100g)","imageId":"ddccb1c56496e83496c4975840beaada","inStock":1,"price":26900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"138775923","name":"Chicken Tikka & Keema","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 1 | Thin & Crispy crust, loaded with flavorful chicken tikka, dhaba style masala keema, crunchy onion, green capsicum, 100% mozzarella cheese, flavorful sauce folded over and baked , then brushed with herbed butter and sprinkled with a flavor packed Makhni seasoning (283 Kcal/100g)","imageId":"51e91bd6deadd0e8fd1bae5a94c0c6ff","inStock":1,"price":30900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"138775925","name":"Loaded Chicken BBQ","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 1 | Thin & Crispy crust, loaded with Juicy Chicken Sausage, Herbed Chicken, 100% mozzarella cheese, flavorful sauce and a generous drizzle of signature barbeque sauce, folded over and baked, then brushed with herbed butter and sprinkled with our signature spice seasoning (330 Kcal/100g)","imageId":"5410d354e29d05ebbdc0337436c1f67e","inStock":1,"price":24900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"138775926","name":"Magical Makhni Paneer","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 1 | Thin & Crispy crust, loaded with Spiced paneer, crunchy onion, green capsicum, 100% mozzarella cheese, flavorful sauce your favourite delicious Makhni sauce folded over and baked, then brushed with herbed butter and sprinkled with a flavor packed Makhni seasoning (265 Kcal/100g)","imageId":"f696af5ddf972eba40b75e0af840e2c8","inStock":1,"isVeg":1,"price":29900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"138775927","name":"Cheezy Cheese Veg","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 1 | Thin & Crispy crust, loaded with Crunchy Onion, Green Capsicum, Red Bell Pepper, Juicy Sweet Corn, 100% mozzarella cheese, flavorful sauce, folded over and baked then brushed with herbed butter and sprinkled with cheezy seasoning. (296 Kcal/100g)","imageId":"bb4e4f27e81fc6c6714d4ce9cbc2ffe8","inStock":1,"isVeg":1,"price":21900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"138775922","name":"Loaded Veggie BBQ","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 1 | Thin & Crispy crust, loaded with Crunchy Onion, Green Capsicum, Red Bell Pepper, Juicy Corn, Mushroom, 100% mozzarella cheese, flavorful sauce and a generous drizzle of signature barbeque sauce, folded over and baked, then brushed with herbed butter and sprinkled with our signature spice seasoning (255 Kcal/100g)","imageId":"8d4fcd37ebb334f0e9f347445722313e","inStock":1,"isVeg":1,"price":19900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]},{"title":"Melts - Meal for 1","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135326956","name":"Melts Meal for 1 with Fries - Veg","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 1 | Choose your favourite Melts & Fries. Customize your satisfaction. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g).","imageId":"77b13d58799f70f670be31e6fe53374e","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344688","name":"Choose your Melt","variations":[{"name":"Loaded Veggie BBQ","price":199,"default":1,"id":"135515512","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344690","variationId":"135515519"}},{"name":"Cheezy Cheese Veg","price":219,"id":"135515514","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344690","variationId":"135515519"}},{"name":"Magical Makhni Paneer","price":299,"id":"135515517","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344690","variationId":"135515519"}}]},{"groupId":"42344690","name":"Side","variations":[{"name":"Sprinkled Fries","price":60,"default":1,"id":"135515519","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344688","variationId":"135515512"},{"groupId":"42344690","variationId":"135515519"}],"price":25900},{"variations":[{"groupId":"42344688","variationId":"135515514"},{"groupId":"42344690","variationId":"135515519"}],"price":27900},{"variations":[{"groupId":"42344688","variationId":"135515517"},{"groupId":"42344690","variationId":"135515519"}],"price":35900}]},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":25900,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"9 ratings","ratingCountV2":"9"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135326959","name":"Melts Meal for 1 with Fries Non-Veg","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 1 | Choose your favourite Melts & Fries combo. Customize your satisfaction.Cheezy Cheese Chicken Melts : (268 Kcal/100g), Loaded BBQ Non-Veg Melts : (330 Kcal/100g), Chicken Tikka Keema Melts : (283 Kcal/100g).","imageId":"da8429720566b8992d5c1c6bfeecdd2c","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344720","name":"Choose your Melt","variations":[{"name":"Loaded Chicken BBQ","price":249,"default":1,"id":"135515671","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344722","variationId":"135515682"}},{"name":"Cheezy Cheese Chicken","price":269,"id":"135515673","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344722","variationId":"135515682"}},{"name":"Chicken Tikka & Keema","price":309,"id":"135515676","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344722","variationId":"135515682"}}]},{"groupId":"42344722","name":"Side","variations":[{"name":"Sprinkled Fries","price":60,"default":1,"id":"135515682","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344720","variationId":"135515671"},{"groupId":"42344722","variationId":"135515682"}],"price":30900},{"variations":[{"groupId":"42344720","variationId":"135515673"},{"groupId":"42344722","variationId":"135515682"}],"price":32900},{"variations":[{"groupId":"42344720","variationId":"135515676"},{"groupId":"42344722","variationId":"135515682"}],"price":36900}]},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":30900,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135326961","name":"Melts 3 Course Meal for 1 Non-Veg","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 1 | The perfect \\"Me Time\\" meal. Choose your favourite Melts & Fries accompanied with 1 Pepsi PET. Cheezy Cheese Chicken Melts : (268 Kcal/100g), Loaded BBQ Non-Veg Melts : (330 Kcal/100g), Chicken Tikka Keema Melts : (283 Kcal/100g).","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/14/26d48552-a554-4b30-93d0-7462c255adc2_cc625cc1-b13b-44d4-a394-969d224b4c6c.jpg_compressed","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344733","name":"Choose your Melt","variations":[{"name":"Loaded Chicken BBQ","price":359,"default":1,"id":"135515737","inStock":1,"isEnabled":1},{"name":"Cheezy Cheese Chicken","price":379,"id":"135515738","inStock":1,"isEnabled":1},{"name":"Chicken Tikka & Keema","price":419,"id":"135515740","inStock":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344733","variationId":"135515737"}],"price":35900},{"variations":[{"groupId":"42344733","variationId":"135515738"}],"price":37900},{"variations":[{"groupId":"42344733","variationId":"135515740"}],"price":41900}]},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":35900,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135326958","name":"Melts 3 Course Meal for 1 - Veg","category":"New MELTS - Crispy. Cheesy. Loaded.","description":"Serves 1 | The perfect \\"Me Time\\" meal. Choose your favourite Melts & Fries accompanied with 1 Pepsi PET. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g).","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/14/bfee1036-41ea-40c1-addc-4fcbfb9475ee_37545bf3-2f63-458b-a7bc-fbeeaa7c41bc.jpg_compressed","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344711","name":"Choose your Melt","variations":[{"name":"Loaded Veggie BBQ","price":309,"default":1,"id":"135515601","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Cheezy Cheese Veg","price":329,"id":"135515604","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Magical Makhni Paneer","price":409,"id":"135515607","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344711","variationId":"135515601"}],"price":30900},{"variations":[{"groupId":"42344711","variationId":"135515604"}],"price":32900},{"variations":[{"groupId":"42344711","variationId":"135515607"}],"price":40900}]},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":30900,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory","title":"Meals and Deals : Better With Pepsi (Save upto 38%)","categories":[{"title":"Meal for 4","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859675","name":"Hut Treat Meal for 4 - Non Veg","category":"Meals and Deals : Better With Pepsi (Save upto 38%)","description":"Serves 4 | Super saver meal combo @ 959 - 2 med non veg pizza of choice, 2 classic bread stix, 2 Pepsi PET. For Meals, refer to the nutritional data for individual products.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/14/4bf86218-e9b2-4ff2-9c8b-bfc20e115efc_e6e2dc0f-10ed-4389-918b-45d3e32bfeda.png","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344479","name":"Choose 1st Pizza","variations":[{"name":"Chicken Sausage","price":616,"default":1,"id":"135514258","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344481","variationId":"135514269"}},{"name":"Sausage & Sweet Corn","price":616,"id":"135514259","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344481","variationId":"135514269"}},{"name":"Dhabe Da Keema","price":616,"id":"135514260","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344481","variationId":"135514269"}},{"name":"Sizzling Schezwan Chicken","price":616,"id":"135514261","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344481","variationId":"135514269"}},{"name":"Murg Malai Chicken","price":671,"id":"135514263","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344481","variationId":"135514269"}},{"name":"Chicken Tikka","price":671,"id":"135514266","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344481","variationId":"135514269"}},{"name":"Chicken Pepperoni","price":671,"id":"135514267","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344481","variationId":"135514269"}},{"name":"Nawabi Murg Makhni","price":671,"id":"135514268","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344481","variationId":"135514269"}}]},{"groupId":"42344481","name":"Choose 2nd Pizza","variations":[{"name":"Chicken Sausage","price":343,"default":1,"id":"135514269","inStock":1,"isEnabled":1},{"name":"Sausage & Sweet Corn","price":343,"id":"135514270","inStock":1,"isEnabled":1},{"name":"Dhabe Da Keema","price":343,"id":"135514271","inStock":1,"isEnabled":1},{"name":"Sizzling Schezwan Chicken","price":343,"id":"135514273","inStock":1,"isEnabled":1},{"name":"Murg Malai Chicken","price":398,"id":"135514275","inStock":1,"isEnabled":1},{"name":"Chicken Tikka","price":398,"id":"135514277","inStock":1,"isEnabled":1},{"name":"Chicken Pepperoni","price":398,"id":"135514279","inStock":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344479","variationId":"135514258"},{"groupId":"42344481","variationId":"135514269"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514258"},{"groupId":"42344481","variationId":"135514270"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514258"},{"groupId":"42344481","variationId":"135514271"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514258"},{"groupId":"42344481","variationId":"135514273"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514258"},{"groupId":"42344481","variationId":"135514275"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514258"},{"groupId":"42344481","variationId":"135514277"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514258"},{"groupId":"42344481","variationId":"135514279"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514259"},{"groupId":"42344481","variationId":"135514269"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514259"},{"groupId":"42344481","variationId":"135514270"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514259"},{"groupId":"42344481","variationId":"135514271"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514259"},{"groupId":"42344481","variationId":"135514273"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514259"},{"groupId":"42344481","variationId":"135514275"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514259"},{"groupId":"42344481","variationId":"135514277"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514259"},{"groupId":"42344481","variationId":"135514279"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514260"},{"groupId":"42344481","variationId":"135514269"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514260"},{"groupId":"42344481","variationId":"135514270"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514260"},{"groupId":"42344481","variationId":"135514271"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514260"},{"groupId":"42344481","variationId":"135514273"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514260"},{"groupId":"42344481","variationId":"135514275"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514260"},{"groupId":"42344481","variationId":"135514277"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514260"},{"groupId":"42344481","variationId":"135514279"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514261"},{"groupId":"42344481","variationId":"135514269"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514261"},{"groupId":"42344481","variationId":"135514270"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514261"},{"groupId":"42344481","variationId":"135514271"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514261"},{"groupId":"42344481","variationId":"135514273"}],"price":95900},{"variations":[{"groupId":"42344479","variationId":"135514261"},{"groupId":"42344481","variationId":"135514275"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514261"},{"groupId":"42344481","variationId":"135514277"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514261"},{"groupId":"42344481","variationId":"135514279"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514263"},{"groupId":"42344481","variationId":"135514269"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514263"},{"groupId":"42344481","variationId":"135514270"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514263"},{"groupId":"42344481","variationId":"135514271"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514263"},{"groupId":"42344481","variationId":"135514273"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514263"},{"groupId":"42344481","variationId":"135514275"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514263"},{"groupId":"42344481","variationId":"135514277"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514263"},{"groupId":"42344481","variationId":"135514279"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514266"},{"groupId":"42344481","variationId":"135514269"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514266"},{"groupId":"42344481","variationId":"135514270"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514266"},{"groupId":"42344481","variationId":"135514271"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514266"},{"groupId":"42344481","variationId":"135514273"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514266"},{"groupId":"42344481","variationId":"135514275"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514266"},{"groupId":"42344481","variationId":"135514277"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514266"},{"groupId":"42344481","variationId":"135514279"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514267"},{"groupId":"42344481","variationId":"135514269"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514267"},{"groupId":"42344481","variationId":"135514270"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514267"},{"groupId":"42344481","variationId":"135514271"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514267"},{"groupId":"42344481","variationId":"135514273"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514267"},{"groupId":"42344481","variationId":"135514275"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514267"},{"groupId":"42344481","variationId":"135514277"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514267"},{"groupId":"42344481","variationId":"135514279"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514268"},{"groupId":"42344481","variationId":"135514269"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514268"},{"groupId":"42344481","variationId":"135514270"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514268"},{"groupId":"42344481","variationId":"135514271"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514268"},{"groupId":"42344481","variationId":"135514273"}],"price":101400},{"variations":[{"groupId":"42344479","variationId":"135514268"},{"groupId":"42344481","variationId":"135514275"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514268"},{"groupId":"42344481","variationId":"135514277"}],"price":106900},{"variations":[{"groupId":"42344479","variationId":"135514268"},{"groupId":"42344481","variationId":"135514279"}],"price":106900}]},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 4"},"defaultPrice":95900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859676","name":"Hut Treat Meal for 4 - Veg","category":"Meals and Deals : Better With Pepsi (Save upto 38%)","description":"Serves 4 | Super saver meal combo @ 859 - 2 med veg pizza of choice, 2 classic bread stix, 2 Pepsi PET. For Meals, refer to the nutritional data for individual products.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/14/ca00e969-c65f-4436-85fc-a64408ddaa09_6f0ea04a-c96c-4a1e-893a-be49ead80ae0.png","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344492","name":"Choose 1st Pizza","variations":[{"name":"Margherita","price":566,"default":1,"id":"135514325","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344495","variationId":"135514345"}},{"name":"Schezwan Margherita","price":566,"id":"135514328","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344495","variationId":"135514345"}},{"name":"Corn & Cheese","price":566,"id":"135514330","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344495","variationId":"135514345"}},{"name":"Veggie Feast","price":566,"id":"135514332","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344495","variationId":"135514345"}},{"name":"Spiced Paneer","price":566,"id":"135514334","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344495","variationId":"135514345"}},{"name":"Mexican Fiesta","price":616,"id":"135514336","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344495","variationId":"135514345"}},{"name":"Bold BBQ Veggies","price":616,"id":"135514338","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344495","variationId":"135514345"}},{"name":"Tandoori Paneer","price":616,"id":"135514341","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344495","variationId":"135514345"}},{"name":"Country Feast","price":616,"id":"135514343","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344495","variationId":"135514345"}}]},{"groupId":"42344495","name":"Choose 2nd Pizza","variations":[{"name":"Margherita","price":293,"default":1,"id":"135514345","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Schezwan Margherita","price":293,"id":"135514348","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Corn & Cheese","price":293,"id":"135514350","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Veggie Feast","price":293,"id":"135514353","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Spiced Paneer","price":293,"id":"135514354","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Mexican Fiesta","price":343,"id":"135514356","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Bold BBQ Veggies","price":343,"id":"135514358","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Tandoori Paneer","price":343,"id":"135514361","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Country Feast","price":343,"id":"135514363","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344492","variationId":"135514325"},{"groupId":"42344495","variationId":"135514345"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514325"},{"groupId":"42344495","variationId":"135514348"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514325"},{"groupId":"42344495","variationId":"135514350"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514325"},{"groupId":"42344495","variationId":"135514353"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514325"},{"groupId":"42344495","variationId":"135514354"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514325"},{"groupId":"42344495","variationId":"135514356"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514325"},{"groupId":"42344495","variationId":"135514358"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514325"},{"groupId":"42344495","variationId":"135514361"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514325"},{"groupId":"42344495","variationId":"135514363"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514328"},{"groupId":"42344495","variationId":"135514345"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514328"},{"groupId":"42344495","variationId":"135514348"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514328"},{"groupId":"42344495","variationId":"135514350"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514328"},{"groupId":"42344495","variationId":"135514353"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514328"},{"groupId":"42344495","variationId":"135514354"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514328"},{"groupId":"42344495","variationId":"135514356"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514328"},{"groupId":"42344495","variationId":"135514358"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514328"},{"groupId":"42344495","variationId":"135514361"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514328"},{"groupId":"42344495","variationId":"135514363"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514330"},{"groupId":"42344495","variationId":"135514345"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514330"},{"groupId":"42344495","variationId":"135514348"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514330"},{"groupId":"42344495","variationId":"135514350"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514330"},{"groupId":"42344495","variationId":"135514353"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514330"},{"groupId":"42344495","variationId":"135514354"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514330"},{"groupId":"42344495","variationId":"135514356"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514330"},{"groupId":"42344495","variationId":"135514358"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514330"},{"groupId":"42344495","variationId":"135514361"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514330"},{"groupId":"42344495","variationId":"135514363"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514332"},{"groupId":"42344495","variationId":"135514345"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514332"},{"groupId":"42344495","variationId":"135514348"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514332"},{"groupId":"42344495","variationId":"135514350"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514332"},{"groupId":"42344495","variationId":"135514353"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514332"},{"groupId":"42344495","variationId":"135514354"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514332"},{"groupId":"42344495","variationId":"135514356"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514332"},{"groupId":"42344495","variationId":"135514358"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514332"},{"groupId":"42344495","variationId":"135514361"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514332"},{"groupId":"42344495","variationId":"135514363"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514334"},{"groupId":"42344495","variationId":"135514345"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514334"},{"groupId":"42344495","variationId":"135514348"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514334"},{"groupId":"42344495","variationId":"135514350"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514334"},{"groupId":"42344495","variationId":"135514353"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514334"},{"groupId":"42344495","variationId":"135514354"}],"price":85900},{"variations":[{"groupId":"42344492","variationId":"135514334"},{"groupId":"42344495","variationId":"135514356"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514334"},{"groupId":"42344495","variationId":"135514358"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514334"},{"groupId":"42344495","variationId":"135514361"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514334"},{"groupId":"42344495","variationId":"135514363"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514336"},{"groupId":"42344495","variationId":"135514345"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514336"},{"groupId":"42344495","variationId":"135514348"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514336"},{"groupId":"42344495","variationId":"135514350"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514336"},{"groupId":"42344495","variationId":"135514353"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514336"},{"groupId":"42344495","variationId":"135514354"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514336"},{"groupId":"42344495","variationId":"135514356"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514336"},{"groupId":"42344495","variationId":"135514358"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514336"},{"groupId":"42344495","variationId":"135514361"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514336"},{"groupId":"42344495","variationId":"135514363"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514338"},{"groupId":"42344495","variationId":"135514345"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514338"},{"groupId":"42344495","variationId":"135514348"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514338"},{"groupId":"42344495","variationId":"135514350"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514338"},{"groupId":"42344495","variationId":"135514353"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514338"},{"groupId":"42344495","variationId":"135514354"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514338"},{"groupId":"42344495","variationId":"135514356"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514338"},{"groupId":"42344495","variationId":"135514358"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514338"},{"groupId":"42344495","variationId":"135514361"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514338"},{"groupId":"42344495","variationId":"135514363"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514341"},{"groupId":"42344495","variationId":"135514345"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514341"},{"groupId":"42344495","variationId":"135514348"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514341"},{"groupId":"42344495","variationId":"135514350"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514341"},{"groupId":"42344495","variationId":"135514353"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514341"},{"groupId":"42344495","variationId":"135514354"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514341"},{"groupId":"42344495","variationId":"135514356"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514341"},{"groupId":"42344495","variationId":"135514358"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514341"},{"groupId":"42344495","variationId":"135514361"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514341"},{"groupId":"42344495","variationId":"135514363"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514343"},{"groupId":"42344495","variationId":"135514345"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514343"},{"groupId":"42344495","variationId":"135514348"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514343"},{"groupId":"42344495","variationId":"135514350"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514343"},{"groupId":"42344495","variationId":"135514353"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514343"},{"groupId":"42344495","variationId":"135514354"}],"price":90900},{"variations":[{"groupId":"42344492","variationId":"135514343"},{"groupId":"42344495","variationId":"135514356"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514343"},{"groupId":"42344495","variationId":"135514358"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514343"},{"groupId":"42344495","variationId":"135514361"}],"price":95900},{"variations":[{"groupId":"42344492","variationId":"135514343"},{"groupId":"42344495","variationId":"135514363"}],"price":95900}]},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 4"},"defaultPrice":85900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]},{"title":"Meal for 1","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859678","name":"My Box - Non Veg","category":"Meals and Deals : Better With Pepsi (Save upto 38%)","description":"Serves 1 | 1 personal non veg pizza, 2 pc garlic bread & 1 Pepsi PET. For Meals, refer to the nutritional data for individual products.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/14/3330ac68-19aa-4598-a9f9-ac1f538ab52c_e1e7be34-7ff1-475b-a69b-4b99de6a2b09.png","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344507","name":"Pizza","variations":[{"name":"Chicken Sausage","price":212,"default":1,"id":"135514405","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Sausage & Sweet Corn","price":252,"id":"135514407","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Dhabe Da Keema","price":252,"id":"135514408","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Sizzling Schezwan Chicken","price":252,"id":"135514411","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Murg Malai Chicken","price":272,"id":"135514413","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Awesome American Cheesy Chicken","price":272,"id":"135514416","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Chicken Tikka","price":272,"id":"135514418","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Chicken Pepperoni","price":272,"id":"135514421","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Nawabi Murg Makhni","price":292,"id":"135514424","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Chicken Supreme","price":292,"id":"135514427","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Chicken Tikka Supreme","price":292,"id":"135514430","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}},{"name":"Triple Chicken Feast","price":292,"id":"135514432","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344512","variationId":"135514436"}}]},{"groupId":"42344512","name":"Garlic Bread","variations":[{"name":"2 Pcs Cheese Garlic Bread","price":70,"id":"135514434","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344514","variationId":"135514439"}},{"name":"2 Pcs Garlic Bread","price":50,"default":1,"id":"135514436","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344514","variationId":"135514439"}}]},{"groupId":"42344514","name":"Beverage","variations":[{"name":"Pepsi Pet Bottle","price":57,"default":1,"id":"135514439","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344507","variationId":"135514405"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":33900},{"variations":[{"groupId":"42344507","variationId":"135514405"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":31900},{"variations":[{"groupId":"42344507","variationId":"135514407"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":37900},{"variations":[{"groupId":"42344507","variationId":"135514407"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":35900},{"variations":[{"groupId":"42344507","variationId":"135514408"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":37900},{"variations":[{"groupId":"42344507","variationId":"135514408"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":35900},{"variations":[{"groupId":"42344507","variationId":"135514411"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":37900},{"variations":[{"groupId":"42344507","variationId":"135514411"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":35900},{"variations":[{"groupId":"42344507","variationId":"135514413"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":39900},{"variations":[{"groupId":"42344507","variationId":"135514413"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":37900},{"variations":[{"groupId":"42344507","variationId":"135514416"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":39900},{"variations":[{"groupId":"42344507","variationId":"135514416"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":37900},{"variations":[{"groupId":"42344507","variationId":"135514418"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":39900},{"variations":[{"groupId":"42344507","variationId":"135514418"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":37900},{"variations":[{"groupId":"42344507","variationId":"135514421"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":39900},{"variations":[{"groupId":"42344507","variationId":"135514421"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":37900},{"variations":[{"groupId":"42344507","variationId":"135514424"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":41900},{"variations":[{"groupId":"42344507","variationId":"135514424"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":39900},{"variations":[{"groupId":"42344507","variationId":"135514427"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":41900},{"variations":[{"groupId":"42344507","variationId":"135514427"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":39900},{"variations":[{"groupId":"42344507","variationId":"135514430"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":41900},{"variations":[{"groupId":"42344507","variationId":"135514430"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":39900},{"variations":[{"groupId":"42344507","variationId":"135514432"},{"groupId":"42344512","variationId":"135514434"},{"groupId":"42344514","variationId":"135514439"}],"price":41900},{"variations":[{"groupId":"42344507","variationId":"135514432"},{"groupId":"42344512","variationId":"135514436"},{"groupId":"42344514","variationId":"135514439"}],"price":39900}]},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":31900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.8","ratingCount":"6 ratings","ratingCountV2":"6"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859680","name":"My Box - Veg","category":"Meals and Deals : Better With Pepsi (Save upto 38%)","description":"Serves 1 | 1 personal veg pizza, 2 pc garlic bread & 1 Pepsi PET ! For Meals, refer to the nutritional data for individual products.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/14/a1efbc7d-6165-4b69-8fe8-e88335921678_0c2d69b5-8aef-4ff2-962c-7c9d75bb84ce.png","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344517","name":"Pizza","variations":[{"name":"Margherita","price":142,"default":1,"id":"135514454","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Schezwan Margherita","price":142,"id":"135514456","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Corn & Cheese","price":192,"id":"135514457","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Veggie Feast","price":212,"id":"135514459","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Spiced Paneer","price":212,"id":"135514460","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Mexican Fiesta","price":232,"id":"135514462","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Bold BBQ Veggies","price":232,"id":"135514464","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Tandoori Paneer","price":232,"id":"135514466","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Country Feast","price":232,"id":"135514468","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Ultimate Tandoori Veggie","price":252,"id":"135514469","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Mazedar Makhni Paneer","price":252,"id":"135514470","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Awesome American Cheesy","price":252,"id":"135514473","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}},{"name":"Veggie Supreme","price":252,"id":"135514476","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344523","variationId":"135514483"}}]},{"groupId":"42344523","name":"Garlic Bread","variations":[{"name":"2 Pcs Cheese Garlic Bread","price":70,"id":"135514480","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344525","variationId":"135514488"}},{"name":"2 Pcs Garlic Bread","price":50,"default":1,"id":"135514483","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344525","variationId":"135514488"}}]},{"groupId":"42344525","name":"Beverage","variations":[{"name":"Pepsi Pet Bottle","price":57,"default":1,"id":"135514488","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344517","variationId":"135514454"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":26900},{"variations":[{"groupId":"42344517","variationId":"135514454"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":24900},{"variations":[{"groupId":"42344517","variationId":"135514456"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":26900},{"variations":[{"groupId":"42344517","variationId":"135514456"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":24900},{"variations":[{"groupId":"42344517","variationId":"135514457"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":31900},{"variations":[{"groupId":"42344517","variationId":"135514457"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":29900},{"variations":[{"groupId":"42344517","variationId":"135514459"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":33900},{"variations":[{"groupId":"42344517","variationId":"135514459"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":31900},{"variations":[{"groupId":"42344517","variationId":"135514460"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":33900},{"variations":[{"groupId":"42344517","variationId":"135514460"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":31900},{"variations":[{"groupId":"42344517","variationId":"135514462"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":35900},{"variations":[{"groupId":"42344517","variationId":"135514462"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":33900},{"variations":[{"groupId":"42344517","variationId":"135514464"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":35900},{"variations":[{"groupId":"42344517","variationId":"135514464"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":33900},{"variations":[{"groupId":"42344517","variationId":"135514466"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":35900},{"variations":[{"groupId":"42344517","variationId":"135514466"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":33900},{"variations":[{"groupId":"42344517","variationId":"135514468"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":35900},{"variations":[{"groupId":"42344517","variationId":"135514468"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":33900},{"variations":[{"groupId":"42344517","variationId":"135514469"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":37900},{"variations":[{"groupId":"42344517","variationId":"135514469"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":35900},{"variations":[{"groupId":"42344517","variationId":"135514470"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":37900},{"variations":[{"groupId":"42344517","variationId":"135514470"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":35900},{"variations":[{"groupId":"42344517","variationId":"135514473"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":37900},{"variations":[{"groupId":"42344517","variationId":"135514473"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":35900},{"variations":[{"groupId":"42344517","variationId":"135514476"},{"groupId":"42344523","variationId":"135514480"},{"groupId":"42344525","variationId":"135514488"}],"price":37900},{"variations":[{"groupId":"42344517","variationId":"135514476"},{"groupId":"42344523","variationId":"135514483"},{"groupId":"42344525","variationId":"135514488"}],"price":35900}]},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":24900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"8 ratings","ratingCountV2":"8"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859611","name":"Garlic Breadstix with Pepsi","category":"Meals and Deals : Better With Pepsi (Save upto 38%)","description":"Serves 1 | Get a Garlic Breadstix and Pepsi. For Meals, refer to the nutritional data for individual products.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/14/ed7774f7-4466-4217-8a96-77b376b2fe4a_b7199cb3-6f82-4ccb-b701-2636fb99686e.jpg_compressed","inStock":1,"isVeg":1,"price":17600,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]},{"title":"Meal for 2","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859672","name":"Hut Treat Meal for 2 - Non Veg","category":"Meals and Deals : Better With Pepsi (Save upto 38%)","description":"Serves 2 | 1 medium non-veg pizza upto signature, 1 classic bread stix, 1 Pepsi PET. For Meals, refer to the nutritional data for individual products.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/14/fc115b57-9536-4c2d-8876-bcedf630ea7b_b7818aa0-4ccb-4cfa-acb5-df7a9cace4e5.png_compressed","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344462","name":"Choose Your Pizza","variations":[{"name":"Chicken Sausage","price":433,"default":1,"id":"135514147","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Sausage & Sweet Corn","price":433,"id":"135514151","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Dhabe Da Keema","price":433,"id":"135514154","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Sizzling Schezwan Chicken","price":433,"id":"135514159","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Murg Malai Chicken","price":483,"id":"135514162","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Awesome American Cheesy Chicken","price":483,"id":"135514165","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Chicken Tikka","price":483,"id":"135514168","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Chicken Pepperoni","price":433,"id":"135514170","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Nawabi Murg Makhni","price":483,"id":"135514171","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Chicken Supreme","price":483,"id":"135514172","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Chicken Tikka Supreme","price":483,"id":"135514173","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}},{"name":"Triple Chicken Feast","price":483,"id":"135514174","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344464","variationId":"135514175"}}]},{"groupId":"42344464","name":"Side","variations":[{"name":"Classic BreadStix","price":99,"default":1,"id":"135514175","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344465","variationId":"135514176"}}]},{"groupId":"42344465","name":"Beverage","variations":[{"name":"Pepsi PET Bottle","price":57,"default":1,"id":"135514176","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344462","variationId":"135514147"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":58900},{"variations":[{"groupId":"42344462","variationId":"135514151"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":58900},{"variations":[{"groupId":"42344462","variationId":"135514154"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":58900},{"variations":[{"groupId":"42344462","variationId":"135514159"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":58900},{"variations":[{"groupId":"42344462","variationId":"135514162"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":63900},{"variations":[{"groupId":"42344462","variationId":"135514165"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":63900},{"variations":[{"groupId":"42344462","variationId":"135514168"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":63900},{"variations":[{"groupId":"42344462","variationId":"135514170"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":58900},{"variations":[{"groupId":"42344462","variationId":"135514171"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":63900},{"variations":[{"groupId":"42344462","variationId":"135514172"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":63900},{"variations":[{"groupId":"42344462","variationId":"135514173"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":63900},{"variations":[{"groupId":"42344462","variationId":"135514174"},{"groupId":"42344464","variationId":"135514175"},{"groupId":"42344465","variationId":"135514176"}],"price":63900}]},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 2"},"defaultPrice":58900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859673","name":"Hut Treat Meal for 2 - Veg","category":"Meals and Deals : Better With Pepsi (Save upto 38%)","description":"Serves 2 | 1 medium veg pizza upto signature, 1 classic bread stix, 1 Pepsi PET. For Meals, refer to the nutritional data for individual products.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/14/9004b4ef-3454-40d3-babb-641082675270_4fd584b6-55b0-4a17-b519-d42e6fff8af9.png","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344471","name":"Choose Your Pizza","variations":[{"name":"Margherita","price":373,"default":1,"id":"135514221","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}},{"name":"Schezwan Margherita","price":373,"id":"135514224","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}},{"name":"Corn & Cheese","price":373,"id":"135514226","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}},{"name":"Veggie Feast","price":373,"id":"135514227","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}},{"name":"Spiced Paneer","price":373,"id":"135514228","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}},{"name":"Mexican Fiesta","price":433,"id":"135514229","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}},{"name":"Bold BBQ Veggies","price":433,"id":"135514230","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}},{"name":"Tandoori Paneer","price":433,"id":"135514231","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}},{"name":"Country Feast","price":433,"id":"135514232","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}},{"name":"Veggie Supreme","price":433,"id":"135514235","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344474","variationId":"135514238"}}]},{"groupId":"42344474","name":"Side","variations":[{"name":"Classic BreadStix","price":99,"default":1,"id":"135514238","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344475","variationId":"135514239"}}]},{"groupId":"42344475","name":"Beverage","variations":[{"name":"Pepsi PET Bottle","price":57,"default":1,"id":"135514239","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344471","variationId":"135514221"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":52900},{"variations":[{"groupId":"42344471","variationId":"135514224"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":52900},{"variations":[{"groupId":"42344471","variationId":"135514226"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":52900},{"variations":[{"groupId":"42344471","variationId":"135514227"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":52900},{"variations":[{"groupId":"42344471","variationId":"135514228"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":52900},{"variations":[{"groupId":"42344471","variationId":"135514229"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":58900},{"variations":[{"groupId":"42344471","variationId":"135514230"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":58900},{"variations":[{"groupId":"42344471","variationId":"135514231"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":58900},{"variations":[{"groupId":"42344471","variationId":"135514232"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":58900},{"variations":[{"groupId":"42344471","variationId":"135514235"},{"groupId":"42344474","variationId":"135514238"},{"groupId":"42344475","variationId":"135514239"}],"price":58900}]},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 2"},"defaultPrice":52900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"New Thin n Crispy Pizzas","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"136105864","name":"Chicken Supreme Thin n Crispy","category":"New Thin n Crispy Pizzas","description":"Serves 4 | New Thin n Crispy crust with delicious chicken tikka, flavourful herbed chicken, spicy schezwan chicken meatball with flavourful pan sauce and 100% mozzarella cheese. (TnC-284 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"252a01784a4caa78e1d7d1a4206f8b2f","inStock":1,"price":94900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 4"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"136105863","name":"Chicken Pepperoni Thin n Crispy","category":"New Thin n Crispy Pizzas","description":"Serves 4 | New Thin n Crispy crust with yummy chicken pepperoni & 100% mozzarella cheese with signature pan sauce. Its a classic! (TnC-311 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"364fbbed964a25498f7413762ebed513","inStock":1,"price":84900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 4"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"136105860","name":"Tandoori Paneer Thin n Crispy","category":"New Thin n Crispy Pizzas","description":"Serves 4 | New Thin n Crispy crust topped with spiced paneer, crunchy onions & green capsicum, spicy red paprika, delicious tandoori sauce and 100% mozzarella cheese (TnC-326 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/7/a365b1af-5d17-4639-994b-1f4e177c757e_f2e7acc3-9370-49e3-829b-296ea2754eaf_compressed","inStock":1,"isVeg":1,"price":74900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 4"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"136105861","name":"Mexican Fiesta Thin n Crispy","category":"New Thin n Crispy Pizzas","description":"Serves 4 | New Thin n Crispy crust topped with red capsicum, green capsicum, jalapeno, onion, black olives, sweet corn, 100% mozzarella cheese, signature spice sprinkle & our flavourful pan sauce (TnC-258 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"fcdc4615f6c0fa952da88c394d732fad","inStock":1,"isVeg":1,"price":74900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 4"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"136105862","name":"Dhabe Da Keema Thin n Crispy","category":"New Thin n Crispy Pizzas","description":"Serves 4 | New Thin n Crispy crust with dhaba style chicken keema masala, green chiili, crunchy onion with flavourful pan sauce, 100 % mozzarella cheese & a generous drizzle of mint mayo (TnC-290 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/7/74ad756e-dc60-4b84-bdc2-2ddf65fda8f7_b340bd7e-a978-47fb-9fc1-d08ed1ad35b1_compressed","inStock":1,"price":74900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 4"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"136105859","name":"Bold BBQ Veggie Thin n Crispy","category":"New Thin n Crispy Pizzas","description":"Serves 4 | New Thin n Crispy crust with our signature pan sauce, with BBQ sauce drizzle, topped with mushroom, onion, green capsicum, & red paprika (TnC-266 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"e2f207fda70413b191db2683e4d471df","inStock":1,"isVeg":1,"price":74900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 4"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Appetizer","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859608","name":"Cheesy Dip","category":"Appetizer","description":"Serves 1 | Cheesy jalapeno dip 20 gm (49 Kcal/100g) Contains Cereals containing Gluten (Wheat) & Soya.","imageId":"l7twhqhybkdlsvkyq3pj","inStock":1,"isVeg":1,"price":2375,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"15 ratings","ratingCountV2":"15"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859575","name":"Zesty Chicken Pocket","category":"Appetizer","description":"Serves 1 | Freshly baked pocket stuffed with chicken, veggies & smoked texas garlic sauce (216 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"wukqmbrmv0vngtlrczgw","inStock":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"6 ratings","ratingCountV2":"6"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859610","name":"Sprinkled Fries - New","category":"Appetizer","description":"Serves 1 | Baked fries seasoned with our signature peruvian seasoning (204 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"frgza6cm1sjezw79pjtu","inStock":1,"isVeg":1,"price":10900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.5","ratingCount":"9 ratings","ratingCountV2":"9"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135326955","name":"Cheezy Sprinkled Fries","category":"Appetizer","description":"Serves 1 | Baked fries seasoned with cheezy seasoning (213 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"8bef47cab8863c1bcd113a28e30ffee4","inStock":1,"isVeg":1,"price":10900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"9 ratings","ratingCountV2":"9"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859581","name":"Jalapeno Poppers","category":"Appetizer","description":"Serves 1 | Jalapano poppers with gooey white sauce. (250 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"oqfrpjaw6v4q3p3qafww","inStock":1,"isVeg":1,"price":11900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.8","ratingCount":"7 ratings","ratingCountV2":"7"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859574","name":"Zesty Paneer Pocket","category":"Appetizer","description":"Serves 1 | Freshly baked pocket stuffed with flavourful paneer, veggies & smoked texas garlic sauce (264 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"spmefmk8u9ftwbvdk6ay","inStock":1,"isVeg":1,"price":12900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.1","ratingCount":"4 ratings","ratingCountV2":"4"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859606","name":"Tomato Ketchup","category":"Appetizer","description":"Serves 1 | Ketchup sachet (11 Kcal/100g)","imageId":"hovlvq3ceumkhyivd0ik","inStock":1,"isVeg":1,"price":95,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.7","ratingCount":"23 ratings","ratingCountV2":"23"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859605","name":"Momo Dip","category":"Appetizer","description":"Serves 1 | Schezwan dip (18 Kcal/100g)","imageId":"ygx3tiuj7ygbp1jyw1ce","inStock":1,"isVeg":1,"price":3000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Pasta","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"137422757","name":"Penne McN Cheese Pasta","category":"Pasta","description":"Serves 1 | Penne pasta baked in flavourful sauce along with green capsicum, onion and red capsicum topped with 100% mozzarella cheese & cheesy dressing (227 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"skfbhz264euhvsoayprt","inStock":1,"isVeg":1,"price":20900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"137422755","name":"Penne McN Cheese & Chicken Pasta","category":"Pasta","description":"Serves 1 | Penne pasta baked in flavourful sauce along with herbed chicken, green capsicum, onion and red capsicum topped with 100% mozzarella cheese & cheesy dressing (224 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"pfwyjsgapi6u5hswj302","inStock":1,"price":22900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.6","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"136550635","name":"Tandoori Paneer Pasta","category":"Pasta","description":"Serves 1 | Baked penne pasta with your favorite tandoori sauce topped with flavorful soft paneer and green capsicum, onion, red capsicum & cheesy dressing (232 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"f1bnld6zrlutewe7vi9a","inStock":1,"isVeg":1,"price":16900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.3","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859671","name":"Spicy Schezwan Pasta Chicken","category":"Pasta","description":"Serves 1 | Fusilli pasta baked in spicy schezwan sauce with schezwan chicken meatballs, green capsicum, onion, red capsicum and red paprika, topped with cheesy dressing (178 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"e4d3b61ab38a0e86db994a9c1db2d0a9","inStock":1,"price":19900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"136550634","name":"Tandoori Murg Pasta","category":"Pasta","description":"Serves 1 | Baked penne pasta with your favorite tandoori sauce topped with chicken tikka, green capsicum, onion, red capsicum and cheesy dressing (214 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"afetxjkwly3qhzheetjm","inStock":1,"price":18900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"136550633","name":"Spicy Red Schezwan Pasta","category":"Pasta","description":"Serves 1 | Fusilli pasta baked in spicy schezwan sauce, green capsicum, onion and red capsicum topped with paprika for an added zing & cheesy dressing (191 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"c6aea671a74704ce9f39dba98d5846dd","inStock":1,"isVeg":1,"price":17900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"136550632","name":"Tomato Twist Red Sauce Pasta","category":"Pasta","description":"Serves 1 | Fusilli pasta baked in tangy flavorful tomato sauce infused with heavenly herbs & spices topped with green capsicum, onion and red capsicum and cheesy dressing (175 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"nzq6soxhtqgeslmqufrq","inStock":1,"isVeg":1,"price":16900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Garlic Bread","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859573","name":"Classic Bread Stix","category":"Garlic Bread","description":"Serves 1 | Freshly baked buttery bread stix, sprinkled with herbs (287 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"n2ycmete7ehes9mrerlw","inStock":1,"isVeg":1,"price":11900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"15 ratings","ratingCountV2":"15"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"135775465","name":"Loaded Bread Stix","category":"Garlic Bread","description":"Serves 1 | Freshly baked bread stix, topped with cheesy dressing & herbs (320 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"o0zibtrbtyjwznptrsgy","inStock":1,"isVeg":1,"price":16900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.6","ratingCount":"10 ratings","ratingCountV2":"10"}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory","title":"Drinks & Desserts","categories":[{"title":"Beverages","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859579","name":"Pepsi 475ml","category":"Drinks & Desserts","description":"Serves 1 | Pepsi PET 475ml. Contains Caffeine (43 Kcal/100ml)","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/19/8df1017a-bfa8-45c0-a643-be8dc39b36d6_f2aec0bf-0d44-4a94-ab17-e75f87c2c128.png","inStock":1,"isVeg":1,"price":5700,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"3.8","ratingCount":"14 ratings","ratingCountV2":"14"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859578","name":"Mirinda 475ml","category":"Drinks & Desserts","description":"Serves 1 | Mirinda PET 475ml. Contains Caffeine (55 Kcal/100ml)","imageId":"wjmrbgifbxdmqnumj84h","inStock":1,"isVeg":1,"price":5700,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.6","ratingCount":"5 ratings","ratingCountV2":"5"}}},"analytics":{},"hideRestaurantDetails":true}}]},{"title":"Dessert","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859660","name":"Brow-wow-nie","category":"Drinks & Desserts","description":"Serves 1 | A divine choco brownie for your all time chocolate cravings (273 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"7ac7f4004c86ebb381fa1c0c3bd58722","inStock":1,"isVeg":1,"price":10900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.6","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859576","name":"Choco Volcano","category":"Drinks & Desserts","description":"Serves 1 | Warm choco cake with gooey center (262 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.","imageId":"k76b8gwkiskwhc9p7nbt","inStock":1,"isVeg":1,"price":12900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"1.7","ratingCount":"4 ratings","ratingCountV2":"4"}}},"analytics":{},"hideRestaurantDetails":true}}]}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"One Plus One Medium @649","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859682","name":"Super Value Deal : 2 Medium Non-Veg Pizzas starting at Rs 749 (Save Upto 39%).","category":"One Plus One Medium @649","description":"Serves 4 | Choose any 2 of your favorite non-veg medium pizzas. For Meals, refer to the nutritional data for individual products.","imageId":"6110f28b77f670194674bbf318970656","inStock":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344533","name":"Choose 1st Pizza","variations":[{"name":"Chicken Sausage","price":374.5,"default":1,"id":"135514521","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Sausage & Sweet Corn","price":374.5,"id":"135514523","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Dhabe Da Keema","price":424.5,"id":"135514524","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Sizzling Schezwan Chicken","price":374.5,"id":"135514526","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Murg Malai Chicken","price":424.5,"id":"135514527","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Awesome American Cheesy Chicken","price":424.5,"id":"135514528","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Chicken Tikka","price":424.5,"id":"135514529","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Chicken Pepperoni","price":424.5,"id":"135514530","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Nawabi Murg Makhni","price":424.5,"id":"135514531","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Chicken Supreme","price":424.5,"id":"135514532","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Chicken Tikka Supreme","price":424.5,"id":"135514533","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}},{"name":"Triple Chicken Feast","price":424.5,"id":"135514534","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344536","variationId":"135514535"}}]},{"groupId":"42344536","name":"Choose 2nd Pizza","variations":[{"name":"Chicken Sausage","price":374.5,"default":1,"id":"135514535","inStock":1,"isEnabled":1},{"name":"Sausage & Sweet Corn","price":374.5,"id":"135514536","inStock":1,"isEnabled":1},{"name":"Dhabe Da Keema","price":424.5,"id":"135514537","inStock":1,"isEnabled":1},{"name":"Sizzling Schezwan Chicken","price":374.5,"id":"135514538","inStock":1,"isEnabled":1},{"name":"Murg Malai Chicken","price":424.5,"id":"135514540","inStock":1,"isEnabled":1},{"name":"Awesome American Cheesy Chicken","price":424.5,"id":"135514541","inStock":1,"isEnabled":1},{"name":"Chicken Tikka","price":424.5,"id":"135514543","inStock":1,"isEnabled":1},{"name":"Chicken Pepperoni","price":424.5,"id":"135514546","inStock":1,"isEnabled":1},{"name":"Nawabi Murg Makhni","price":424.5,"id":"135514549","inStock":1,"isEnabled":1},{"name":"Chicken Supreme","price":424.5,"id":"135514552","inStock":1,"isEnabled":1},{"name":"Chicken Tikka Supreme","price":424.5,"id":"135514555","inStock":1,"isEnabled":1},{"name":"Triple Chicken Feast","price":424.5,"id":"135514558","inStock":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514535"}],"price":74900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514536"}],"price":74900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514537"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514538"}],"price":74900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514540"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514541"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514543"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514546"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514549"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514552"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514555"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514521"},{"groupId":"42344536","variationId":"135514558"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514535"}],"price":74900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514536"}],"price":74900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514537"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514538"}],"price":74900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514540"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514541"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514543"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514546"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514549"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514552"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514555"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514523"},{"groupId":"42344536","variationId":"135514558"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514535"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514536"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514537"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514538"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514540"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514541"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514543"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514546"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514549"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514552"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514555"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514524"},{"groupId":"42344536","variationId":"135514558"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514535"}],"price":74900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514536"}],"price":74900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514537"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514538"}],"price":74900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514540"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514541"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514543"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514546"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514549"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514552"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514555"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514526"},{"groupId":"42344536","variationId":"135514558"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514535"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514536"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514537"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514538"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514540"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514541"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514543"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514546"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514549"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514552"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514555"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514527"},{"groupId":"42344536","variationId":"135514558"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514535"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514536"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514537"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514538"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514540"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514541"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514543"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514546"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514549"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514552"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514555"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514528"},{"groupId":"42344536","variationId":"135514558"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514535"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514536"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514537"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514538"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514540"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514541"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514543"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514546"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514549"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514552"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514555"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514529"},{"groupId":"42344536","variationId":"135514558"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514535"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514536"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514537"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514538"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514540"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514541"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514543"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514546"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514549"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514552"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514555"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514530"},{"groupId":"42344536","variationId":"135514558"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514535"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514536"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514537"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514538"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514540"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514541"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514543"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514546"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514549"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514552"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514555"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514531"},{"groupId":"42344536","variationId":"135514558"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514535"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514536"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514537"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514538"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514540"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514541"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514543"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514546"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514549"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514552"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514555"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514532"},{"groupId":"42344536","variationId":"135514558"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514535"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514536"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514537"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514538"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514540"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514541"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514543"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514546"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514549"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514552"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514555"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514533"},{"groupId":"42344536","variationId":"135514558"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514535"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514536"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514537"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514538"}],"price":79900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514540"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514541"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514543"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514546"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514549"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514552"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514555"}],"price":84900},{"variations":[{"groupId":"42344533","variationId":"135514534"},{"groupId":"42344536","variationId":"135514558"}],"price":84900}]},"itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 4"},"defaultPrice":74900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"132859684","name":"Super Value Deal : 2 Medium Veg Pizzas starting at Rs 649 (Save Upto 41%).","category":"One Plus One Medium @649","description":"Serves 4 | Choose any 2 of your favorite veg medium pizzas. For Meals, refer to the nutritional data for individual products.","imageId":"2d34f1c2c669eab6821dd0ee068590e4","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344566","name":"Choose 1st Pizza","variations":[{"name":"Margherita","price":324.5,"default":1,"id":"135514699","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Schezwan Margherita","price":324.5,"id":"135514702","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Corn & Cheese","price":324.5,"id":"135514707","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Veggie Feast","price":324.5,"id":"135514712","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Spiced Paneer","price":324.5,"id":"135514716","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Mexican Fiesta","price":374.5,"id":"135514721","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Bold BBQ Veggies","price":374.5,"id":"135514727","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Tandoori Paneer","price":374.5,"id":"135514732","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Country Feast","price":374.5,"id":"135514736","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Ultimate Tandoori Veggie","price":374.5,"id":"135514740","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Mazedar Makhni Paneer","price":374.5,"id":"135514743","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Awesome American Cheesy","price":374.5,"id":"135514745","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}},{"name":"Veggie Supreme","price":374.5,"id":"135514747","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344575","variationId":"135514750"}}]},{"groupId":"42344575","name":"Choose 2nd Pizza","variations":[{"name":"Margherita","price":324.5,"default":1,"id":"135514750","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Schezwan Margherita","price":324.5,"id":"135514752","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Corn & Cheese","price":324.5,"id":"135514754","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Veggie Feast","price":324.5,"id":"135514756","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Spiced Paneer","price":324.5,"id":"135514759","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Mexican Fiesta","price":374.5,"id":"135514761","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Bold BBQ Veggies","price":374.5,"id":"135514763","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Tandoori Paneer","price":374.5,"id":"135514764","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Country Feast","price":374.5,"id":"135514765","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Ultimate Tandoori Veggie","price":374.5,"id":"135514766","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Mazedar Makhni Paneer","price":374.5,"id":"135514767","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Awesome American Cheesy","price":374.5,"id":"135514768","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Veggie Supreme","price":374.5,"id":"135514769","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514750"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514752"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514754"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514756"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514759"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514761"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514763"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514764"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514765"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514766"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514767"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514768"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514699"},{"groupId":"42344575","variationId":"135514769"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514750"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514752"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514754"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514756"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514759"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514761"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514763"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514764"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514765"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514766"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514767"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514768"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514702"},{"groupId":"42344575","variationId":"135514769"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514750"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514752"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514754"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514756"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514759"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514761"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514763"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514764"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514765"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514766"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514767"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514768"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514707"},{"groupId":"42344575","variationId":"135514769"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514750"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514752"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514754"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514756"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514759"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514761"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514763"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514764"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514765"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514766"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514767"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514768"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514712"},{"groupId":"42344575","variationId":"135514769"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514750"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514752"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514754"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514756"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514759"}],"price":64900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514761"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514763"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514764"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514765"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514766"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514767"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514768"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514716"},{"groupId":"42344575","variationId":"135514769"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514750"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514752"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514754"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514756"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514759"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514761"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514763"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514764"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514765"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514766"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514767"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514768"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514721"},{"groupId":"42344575","variationId":"135514769"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514750"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514752"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514754"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514756"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514759"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514761"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514763"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514764"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514765"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514766"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514767"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514768"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514727"},{"groupId":"42344575","variationId":"135514769"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514750"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514752"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514754"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514756"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514759"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514761"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514763"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514764"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514765"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514766"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514767"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514768"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514732"},{"groupId":"42344575","variationId":"135514769"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514750"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514752"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514754"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514756"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514759"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514761"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514763"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514764"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514765"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514766"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514767"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514768"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514736"},{"groupId":"42344575","variationId":"135514769"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514750"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514752"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514754"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514756"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514759"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514761"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514763"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514764"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514765"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514766"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514767"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514768"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514740"},{"groupId":"42344575","variationId":"135514769"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514750"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514752"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514754"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514756"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514759"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514761"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514763"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514764"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514765"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514766"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514767"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514768"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514743"},{"groupId":"42344575","variationId":"135514769"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514750"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514752"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514754"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514756"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514759"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514761"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514763"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514764"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514765"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514766"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514767"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514768"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514745"},{"groupId":"42344575","variationId":"135514769"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514750"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514752"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514754"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514756"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514759"}],"price":69900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514761"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514763"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514764"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514765"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514766"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514767"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514768"}],"price":74900},{"variations":[{"groupId":"42344566","variationId":"135514747"},{"groupId":"42344575","variationId":"135514769"}],"price":74900}]},"itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 4"},"defaultPrice":64900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Late Night Specials","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"133116142","name":"2 Medium Veg Pizzas @ 279 each","category":"Late Night Specials","description":"Serves 1 | Get 2 delicious veg medium pizzas of your choice & say goodbye to your midnight cravings. For Meals, refer to the nutritional data for individual products.","imageId":"2d34f1c2c669eab6821dd0ee068590e4","isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344618","name":"Choose 1st Pizza","variations":[{"name":"Margherita","price":279,"default":1,"id":"135515094","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344621","variationId":"135515120"}},{"name":"Schezwan Margherita","price":279,"id":"135515096","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344621","variationId":"135515120"}},{"name":"Corn & Cheese","price":279,"id":"135515098","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344621","variationId":"135515120"}},{"name":"Veggie Feast","price":279,"id":"135515099","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344621","variationId":"135515120"}},{"name":"Spiced Paneer","price":279,"id":"135515101","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344621","variationId":"135515120"}},{"name":"Mexican Fiesta","price":329,"id":"135515103","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344621","variationId":"135515120"}},{"name":"Bold BBQ Veggies","price":329,"id":"135515105","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344621","variationId":"135515120"}},{"name":"Tandoori Paneer","price":329,"id":"135515107","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344621","variationId":"135515120"}},{"name":"Country Feast","price":329,"id":"135515109","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344621","variationId":"135515120"}},{"name":"Ultimate Tandoori Veggie","price":329,"id":"135515111","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344621","variationId":"135515120"}},{"name":"Mazedar Makhni Paneer","price":329,"id":"135515112","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344621","variationId":"135515120"}},{"name":"Awesome American Cheesy","price":329,"id":"135515115","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344621","variationId":"135515120"}},{"name":"Veggie Supreme","price":329,"id":"135515116","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344621","variationId":"135515120"}}]},{"groupId":"42344621","name":"Choose 2nd Pizza","variations":[{"name":"Margherita","price":279,"default":1,"id":"135515120","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Schezwan Margherita","price":279,"id":"135515123","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Corn & Cheese","price":279,"id":"135515128","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Veggie Feast","price":279,"id":"135515132","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Spiced Paneer","price":279,"id":"135515136","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Mexican Fiesta","price":329,"id":"135515140","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Bold BBQ Veggies","price":329,"id":"135515142","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Tandoori Paneer","price":329,"id":"135515143","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Country Feast","price":329,"id":"135515145","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Ultimate Tandoori Veggie","price":329,"id":"135515147","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Mazedar Makhni Paneer","price":329,"id":"135515149","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Awesome American Cheesy","price":329,"id":"135515151","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Veggie Supreme","price":329,"id":"135515153","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344618","variationId":"135515094"},{"groupId":"42344621","variationId":"135515120"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515094"},{"groupId":"42344621","variationId":"135515123"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515094"},{"groupId":"42344621","variationId":"135515128"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515094"},{"groupId":"42344621","variationId":"135515132"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515094"},{"groupId":"42344621","variationId":"135515136"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515094"},{"groupId":"42344621","variationId":"135515140"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515094"},{"groupId":"42344621","variationId":"135515142"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515094"},{"groupId":"42344621","variationId":"135515143"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515094"},{"groupId":"42344621","variationId":"135515145"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515094"},{"groupId":"42344621","variationId":"135515147"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515094"},{"groupId":"42344621","variationId":"135515149"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515094"},{"groupId":"42344621","variationId":"135515151"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515094"},{"groupId":"42344621","variationId":"135515153"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515096"},{"groupId":"42344621","variationId":"135515120"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515096"},{"groupId":"42344621","variationId":"135515123"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515096"},{"groupId":"42344621","variationId":"135515128"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515096"},{"groupId":"42344621","variationId":"135515132"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515096"},{"groupId":"42344621","variationId":"135515136"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515096"},{"groupId":"42344621","variationId":"135515140"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515096"},{"groupId":"42344621","variationId":"135515142"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515096"},{"groupId":"42344621","variationId":"135515143"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515096"},{"groupId":"42344621","variationId":"135515145"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515096"},{"groupId":"42344621","variationId":"135515147"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515096"},{"groupId":"42344621","variationId":"135515149"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515096"},{"groupId":"42344621","variationId":"135515151"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515096"},{"groupId":"42344621","variationId":"135515153"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515098"},{"groupId":"42344621","variationId":"135515120"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515098"},{"groupId":"42344621","variationId":"135515123"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515098"},{"groupId":"42344621","variationId":"135515128"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515098"},{"groupId":"42344621","variationId":"135515132"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515098"},{"groupId":"42344621","variationId":"135515136"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515098"},{"groupId":"42344621","variationId":"135515140"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515098"},{"groupId":"42344621","variationId":"135515142"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515098"},{"groupId":"42344621","variationId":"135515143"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515098"},{"groupId":"42344621","variationId":"135515145"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515098"},{"groupId":"42344621","variationId":"135515147"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515098"},{"groupId":"42344621","variationId":"135515149"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515098"},{"groupId":"42344621","variationId":"135515151"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515098"},{"groupId":"42344621","variationId":"135515153"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515099"},{"groupId":"42344621","variationId":"135515120"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515099"},{"groupId":"42344621","variationId":"135515123"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515099"},{"groupId":"42344621","variationId":"135515128"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515099"},{"groupId":"42344621","variationId":"135515132"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515099"},{"groupId":"42344621","variationId":"135515136"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515099"},{"groupId":"42344621","variationId":"135515140"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515099"},{"groupId":"42344621","variationId":"135515142"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515099"},{"groupId":"42344621","variationId":"135515143"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515099"},{"groupId":"42344621","variationId":"135515145"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515099"},{"groupId":"42344621","variationId":"135515147"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515099"},{"groupId":"42344621","variationId":"135515149"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515099"},{"groupId":"42344621","variationId":"135515151"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515099"},{"groupId":"42344621","variationId":"135515153"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515101"},{"groupId":"42344621","variationId":"135515120"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515101"},{"groupId":"42344621","variationId":"135515123"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515101"},{"groupId":"42344621","variationId":"135515128"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515101"},{"groupId":"42344621","variationId":"135515132"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515101"},{"groupId":"42344621","variationId":"135515136"}],"price":55800},{"variations":[{"groupId":"42344618","variationId":"135515101"},{"groupId":"42344621","variationId":"135515140"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515101"},{"groupId":"42344621","variationId":"135515142"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515101"},{"groupId":"42344621","variationId":"135515143"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515101"},{"groupId":"42344621","variationId":"135515145"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515101"},{"groupId":"42344621","variationId":"135515147"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515101"},{"groupId":"42344621","variationId":"135515149"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515101"},{"groupId":"42344621","variationId":"135515151"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515101"},{"groupId":"42344621","variationId":"135515153"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515103"},{"groupId":"42344621","variationId":"135515120"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515103"},{"groupId":"42344621","variationId":"135515123"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515103"},{"groupId":"42344621","variationId":"135515128"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515103"},{"groupId":"42344621","variationId":"135515132"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515103"},{"groupId":"42344621","variationId":"135515136"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515103"},{"groupId":"42344621","variationId":"135515140"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515103"},{"groupId":"42344621","variationId":"135515142"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515103"},{"groupId":"42344621","variationId":"135515143"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515103"},{"groupId":"42344621","variationId":"135515145"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515103"},{"groupId":"42344621","variationId":"135515147"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515103"},{"groupId":"42344621","variationId":"135515149"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515103"},{"groupId":"42344621","variationId":"135515151"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515103"},{"groupId":"42344621","variationId":"135515153"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515105"},{"groupId":"42344621","variationId":"135515120"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515105"},{"groupId":"42344621","variationId":"135515123"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515105"},{"groupId":"42344621","variationId":"135515128"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515105"},{"groupId":"42344621","variationId":"135515132"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515105"},{"groupId":"42344621","variationId":"135515136"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515105"},{"groupId":"42344621","variationId":"135515140"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515105"},{"groupId":"42344621","variationId":"135515142"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515105"},{"groupId":"42344621","variationId":"135515143"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515105"},{"groupId":"42344621","variationId":"135515145"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515105"},{"groupId":"42344621","variationId":"135515147"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515105"},{"groupId":"42344621","variationId":"135515149"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515105"},{"groupId":"42344621","variationId":"135515151"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515105"},{"groupId":"42344621","variationId":"135515153"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515107"},{"groupId":"42344621","variationId":"135515120"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515107"},{"groupId":"42344621","variationId":"135515123"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515107"},{"groupId":"42344621","variationId":"135515128"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515107"},{"groupId":"42344621","variationId":"135515132"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515107"},{"groupId":"42344621","variationId":"135515136"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515107"},{"groupId":"42344621","variationId":"135515140"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515107"},{"groupId":"42344621","variationId":"135515142"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515107"},{"groupId":"42344621","variationId":"135515143"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515107"},{"groupId":"42344621","variationId":"135515145"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515107"},{"groupId":"42344621","variationId":"135515147"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515107"},{"groupId":"42344621","variationId":"135515149"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515107"},{"groupId":"42344621","variationId":"135515151"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515107"},{"groupId":"42344621","variationId":"135515153"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515109"},{"groupId":"42344621","variationId":"135515120"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515109"},{"groupId":"42344621","variationId":"135515123"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515109"},{"groupId":"42344621","variationId":"135515128"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515109"},{"groupId":"42344621","variationId":"135515132"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515109"},{"groupId":"42344621","variationId":"135515136"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515109"},{"groupId":"42344621","variationId":"135515140"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515109"},{"groupId":"42344621","variationId":"135515142"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515109"},{"groupId":"42344621","variationId":"135515143"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515109"},{"groupId":"42344621","variationId":"135515145"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515109"},{"groupId":"42344621","variationId":"135515147"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515109"},{"groupId":"42344621","variationId":"135515149"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515109"},{"groupId":"42344621","variationId":"135515151"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515109"},{"groupId":"42344621","variationId":"135515153"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515111"},{"groupId":"42344621","variationId":"135515120"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515111"},{"groupId":"42344621","variationId":"135515123"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515111"},{"groupId":"42344621","variationId":"135515128"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515111"},{"groupId":"42344621","variationId":"135515132"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515111"},{"groupId":"42344621","variationId":"135515136"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515111"},{"groupId":"42344621","variationId":"135515140"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515111"},{"groupId":"42344621","variationId":"135515142"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515111"},{"groupId":"42344621","variationId":"135515143"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515111"},{"groupId":"42344621","variationId":"135515145"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515111"},{"groupId":"42344621","variationId":"135515147"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515111"},{"groupId":"42344621","variationId":"135515149"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515111"},{"groupId":"42344621","variationId":"135515151"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515111"},{"groupId":"42344621","variationId":"135515153"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515112"},{"groupId":"42344621","variationId":"135515120"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515112"},{"groupId":"42344621","variationId":"135515123"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515112"},{"groupId":"42344621","variationId":"135515128"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515112"},{"groupId":"42344621","variationId":"135515132"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515112"},{"groupId":"42344621","variationId":"135515136"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515112"},{"groupId":"42344621","variationId":"135515140"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515112"},{"groupId":"42344621","variationId":"135515142"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515112"},{"groupId":"42344621","variationId":"135515143"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515112"},{"groupId":"42344621","variationId":"135515145"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515112"},{"groupId":"42344621","variationId":"135515147"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515112"},{"groupId":"42344621","variationId":"135515149"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515112"},{"groupId":"42344621","variationId":"135515151"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515112"},{"groupId":"42344621","variationId":"135515153"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515115"},{"groupId":"42344621","variationId":"135515120"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515115"},{"groupId":"42344621","variationId":"135515123"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515115"},{"groupId":"42344621","variationId":"135515128"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515115"},{"groupId":"42344621","variationId":"135515132"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515115"},{"groupId":"42344621","variationId":"135515136"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515115"},{"groupId":"42344621","variationId":"135515140"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515115"},{"groupId":"42344621","variationId":"135515142"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515115"},{"groupId":"42344621","variationId":"135515143"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515115"},{"groupId":"42344621","variationId":"135515145"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515115"},{"groupId":"42344621","variationId":"135515147"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515115"},{"groupId":"42344621","variationId":"135515149"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515115"},{"groupId":"42344621","variationId":"135515151"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515115"},{"groupId":"42344621","variationId":"135515153"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515116"},{"groupId":"42344621","variationId":"135515120"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515116"},{"groupId":"42344621","variationId":"135515123"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515116"},{"groupId":"42344621","variationId":"135515128"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515116"},{"groupId":"42344621","variationId":"135515132"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515116"},{"groupId":"42344621","variationId":"135515136"}],"price":60800},{"variations":[{"groupId":"42344618","variationId":"135515116"},{"groupId":"42344621","variationId":"135515140"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515116"},{"groupId":"42344621","variationId":"135515142"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515116"},{"groupId":"42344621","variationId":"135515143"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515116"},{"groupId":"42344621","variationId":"135515145"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515116"},{"groupId":"42344621","variationId":"135515147"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515116"},{"groupId":"42344621","variationId":"135515149"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515116"},{"groupId":"42344621","variationId":"135515151"}],"price":65800},{"variations":[{"groupId":"42344618","variationId":"135515116"},{"groupId":"42344621","variationId":"135515153"}],"price":65800}]},"nextAvailableAtMessage":"Next available at 11 pm, today","itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":55800,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"133116141","name":"2 Personal Veg Pizzas @ 149 each","category":"Late Night Specials","description":"Serves 1 | Get 2 delicious personal Veg pizzas of your choice & satisfy those midnight cravings! For Meals, refer to the nutritional data for individual products.","imageId":"rw0irqot3gy3x66z2eyt","isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344602","name":"Choose 1st Pizza","variations":[{"name":"Margherita","price":149,"default":1,"id":"135514963","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344605","variationId":"135514996"}},{"name":"Schezwan Margherita","price":149,"id":"135514966","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344605","variationId":"135514996"}},{"name":"Corn & Cheese","price":149,"id":"135514969","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344605","variationId":"135514996"}},{"name":"Veggie Feast","price":149,"id":"135514974","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344605","variationId":"135514996"}},{"name":"Spiced Paneer","price":149,"id":"135514978","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344605","variationId":"135514996"}},{"name":"Mexican Fiesta","price":199,"id":"135514980","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344605","variationId":"135514996"}},{"name":"Bold BBQ Veggies","price":199,"id":"135514982","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344605","variationId":"135514996"}},{"name":"Tandoori Paneer","price":199,"id":"135514984","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344605","variationId":"135514996"}},{"name":"Country Feast","price":199,"id":"135514986","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344605","variationId":"135514996"}},{"name":"Ultimate Tandoori Veggie","price":199,"id":"135514988","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344605","variationId":"135514996"}},{"name":"Mazedar Makhni Paneer","price":199,"id":"135514989","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344605","variationId":"135514996"}},{"name":"Awesome American Cheesy","price":199,"id":"135514991","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344605","variationId":"135514996"}},{"name":"Veggie Supreme","price":199,"id":"135514993","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344605","variationId":"135514996"}}]},{"groupId":"42344605","name":"Choose 2nd Pizza","variations":[{"name":"Margherita","price":149,"default":1,"id":"135514996","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Schezwan Margherita","price":149,"id":"135514997","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Corn & Cheese","price":149,"id":"135514999","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Veggie Feast","price":149,"id":"135515000","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Spiced Paneer","price":149,"id":"135515001","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Mexican Fiesta","price":199,"id":"135515002","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Bold BBQ Veggies","price":199,"id":"135515003","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Tandoori Paneer","price":199,"id":"135515004","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Country Feast","price":199,"id":"135515007","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Ultimate Tandoori Veggie","price":199,"id":"135515011","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Mazedar Makhni Paneer","price":199,"id":"135515014","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Awesome American Cheesy","price":199,"id":"135515019","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Veggie Supreme","price":199,"id":"135515023","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344602","variationId":"135514963"},{"groupId":"42344605","variationId":"135514996"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514963"},{"groupId":"42344605","variationId":"135514997"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514963"},{"groupId":"42344605","variationId":"135514999"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514963"},{"groupId":"42344605","variationId":"135515000"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514963"},{"groupId":"42344605","variationId":"135515001"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514963"},{"groupId":"42344605","variationId":"135515002"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514963"},{"groupId":"42344605","variationId":"135515003"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514963"},{"groupId":"42344605","variationId":"135515004"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514963"},{"groupId":"42344605","variationId":"135515007"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514963"},{"groupId":"42344605","variationId":"135515011"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514963"},{"groupId":"42344605","variationId":"135515014"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514963"},{"groupId":"42344605","variationId":"135515019"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514963"},{"groupId":"42344605","variationId":"135515023"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514966"},{"groupId":"42344605","variationId":"135514996"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514966"},{"groupId":"42344605","variationId":"135514997"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514966"},{"groupId":"42344605","variationId":"135514999"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514966"},{"groupId":"42344605","variationId":"135515000"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514966"},{"groupId":"42344605","variationId":"135515001"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514966"},{"groupId":"42344605","variationId":"135515002"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514966"},{"groupId":"42344605","variationId":"135515003"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514966"},{"groupId":"42344605","variationId":"135515004"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514966"},{"groupId":"42344605","variationId":"135515007"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514966"},{"groupId":"42344605","variationId":"135515011"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514966"},{"groupId":"42344605","variationId":"135515014"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514966"},{"groupId":"42344605","variationId":"135515019"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514966"},{"groupId":"42344605","variationId":"135515023"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514969"},{"groupId":"42344605","variationId":"135514996"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514969"},{"groupId":"42344605","variationId":"135514997"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514969"},{"groupId":"42344605","variationId":"135514999"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514969"},{"groupId":"42344605","variationId":"135515000"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514969"},{"groupId":"42344605","variationId":"135515001"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514969"},{"groupId":"42344605","variationId":"135515002"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514969"},{"groupId":"42344605","variationId":"135515003"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514969"},{"groupId":"42344605","variationId":"135515004"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514969"},{"groupId":"42344605","variationId":"135515007"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514969"},{"groupId":"42344605","variationId":"135515011"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514969"},{"groupId":"42344605","variationId":"135515014"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514969"},{"groupId":"42344605","variationId":"135515019"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514969"},{"groupId":"42344605","variationId":"135515023"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514974"},{"groupId":"42344605","variationId":"135514996"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514974"},{"groupId":"42344605","variationId":"135514997"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514974"},{"groupId":"42344605","variationId":"135514999"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514974"},{"groupId":"42344605","variationId":"135515000"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514974"},{"groupId":"42344605","variationId":"135515001"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514974"},{"groupId":"42344605","variationId":"135515002"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514974"},{"groupId":"42344605","variationId":"135515003"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514974"},{"groupId":"42344605","variationId":"135515004"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514974"},{"groupId":"42344605","variationId":"135515007"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514974"},{"groupId":"42344605","variationId":"135515011"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514974"},{"groupId":"42344605","variationId":"135515014"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514974"},{"groupId":"42344605","variationId":"135515019"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514974"},{"groupId":"42344605","variationId":"135515023"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514978"},{"groupId":"42344605","variationId":"135514996"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514978"},{"groupId":"42344605","variationId":"135514997"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514978"},{"groupId":"42344605","variationId":"135514999"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514978"},{"groupId":"42344605","variationId":"135515000"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514978"},{"groupId":"42344605","variationId":"135515001"}],"price":29800},{"variations":[{"groupId":"42344602","variationId":"135514978"},{"groupId":"42344605","variationId":"135515002"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514978"},{"groupId":"42344605","variationId":"135515003"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514978"},{"groupId":"42344605","variationId":"135515004"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514978"},{"groupId":"42344605","variationId":"135515007"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514978"},{"groupId":"42344605","variationId":"135515011"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514978"},{"groupId":"42344605","variationId":"135515014"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514978"},{"groupId":"42344605","variationId":"135515019"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514978"},{"groupId":"42344605","variationId":"135515023"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514980"},{"groupId":"42344605","variationId":"135514996"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514980"},{"groupId":"42344605","variationId":"135514997"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514980"},{"groupId":"42344605","variationId":"135514999"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514980"},{"groupId":"42344605","variationId":"135515000"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514980"},{"groupId":"42344605","variationId":"135515001"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514980"},{"groupId":"42344605","variationId":"135515002"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514980"},{"groupId":"42344605","variationId":"135515003"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514980"},{"groupId":"42344605","variationId":"135515004"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514980"},{"groupId":"42344605","variationId":"135515007"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514980"},{"groupId":"42344605","variationId":"135515011"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514980"},{"groupId":"42344605","variationId":"135515014"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514980"},{"groupId":"42344605","variationId":"135515019"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514980"},{"groupId":"42344605","variationId":"135515023"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514982"},{"groupId":"42344605","variationId":"135514996"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514982"},{"groupId":"42344605","variationId":"135514997"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514982"},{"groupId":"42344605","variationId":"135514999"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514982"},{"groupId":"42344605","variationId":"135515000"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514982"},{"groupId":"42344605","variationId":"135515001"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514982"},{"groupId":"42344605","variationId":"135515002"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514982"},{"groupId":"42344605","variationId":"135515003"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514982"},{"groupId":"42344605","variationId":"135515004"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514982"},{"groupId":"42344605","variationId":"135515007"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514982"},{"groupId":"42344605","variationId":"135515011"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514982"},{"groupId":"42344605","variationId":"135515014"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514982"},{"groupId":"42344605","variationId":"135515019"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514982"},{"groupId":"42344605","variationId":"135515023"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514984"},{"groupId":"42344605","variationId":"135514996"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514984"},{"groupId":"42344605","variationId":"135514997"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514984"},{"groupId":"42344605","variationId":"135514999"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514984"},{"groupId":"42344605","variationId":"135515000"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514984"},{"groupId":"42344605","variationId":"135515001"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514984"},{"groupId":"42344605","variationId":"135515002"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514984"},{"groupId":"42344605","variationId":"135515003"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514984"},{"groupId":"42344605","variationId":"135515004"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514984"},{"groupId":"42344605","variationId":"135515007"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514984"},{"groupId":"42344605","variationId":"135515011"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514984"},{"groupId":"42344605","variationId":"135515014"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514984"},{"groupId":"42344605","variationId":"135515019"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514984"},{"groupId":"42344605","variationId":"135515023"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514986"},{"groupId":"42344605","variationId":"135514996"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514986"},{"groupId":"42344605","variationId":"135514997"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514986"},{"groupId":"42344605","variationId":"135514999"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514986"},{"groupId":"42344605","variationId":"135515000"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514986"},{"groupId":"42344605","variationId":"135515001"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514986"},{"groupId":"42344605","variationId":"135515002"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514986"},{"groupId":"42344605","variationId":"135515003"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514986"},{"groupId":"42344605","variationId":"135515004"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514986"},{"groupId":"42344605","variationId":"135515007"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514986"},{"groupId":"42344605","variationId":"135515011"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514986"},{"groupId":"42344605","variationId":"135515014"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514986"},{"groupId":"42344605","variationId":"135515019"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514986"},{"groupId":"42344605","variationId":"135515023"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514988"},{"groupId":"42344605","variationId":"135514996"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514988"},{"groupId":"42344605","variationId":"135514997"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514988"},{"groupId":"42344605","variationId":"135514999"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514988"},{"groupId":"42344605","variationId":"135515000"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514988"},{"groupId":"42344605","variationId":"135515001"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514988"},{"groupId":"42344605","variationId":"135515002"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514988"},{"groupId":"42344605","variationId":"135515003"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514988"},{"groupId":"42344605","variationId":"135515004"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514988"},{"groupId":"42344605","variationId":"135515007"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514988"},{"groupId":"42344605","variationId":"135515011"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514988"},{"groupId":"42344605","variationId":"135515014"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514988"},{"groupId":"42344605","variationId":"135515019"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514988"},{"groupId":"42344605","variationId":"135515023"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514989"},{"groupId":"42344605","variationId":"135514996"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514989"},{"groupId":"42344605","variationId":"135514997"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514989"},{"groupId":"42344605","variationId":"135514999"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514989"},{"groupId":"42344605","variationId":"135515000"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514989"},{"groupId":"42344605","variationId":"135515001"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514989"},{"groupId":"42344605","variationId":"135515002"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514989"},{"groupId":"42344605","variationId":"135515003"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514989"},{"groupId":"42344605","variationId":"135515004"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514989"},{"groupId":"42344605","variationId":"135515007"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514989"},{"groupId":"42344605","variationId":"135515011"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514989"},{"groupId":"42344605","variationId":"135515014"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514989"},{"groupId":"42344605","variationId":"135515019"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514989"},{"groupId":"42344605","variationId":"135515023"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514991"},{"groupId":"42344605","variationId":"135514996"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514991"},{"groupId":"42344605","variationId":"135514997"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514991"},{"groupId":"42344605","variationId":"135514999"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514991"},{"groupId":"42344605","variationId":"135515000"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514991"},{"groupId":"42344605","variationId":"135515001"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514991"},{"groupId":"42344605","variationId":"135515002"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514991"},{"groupId":"42344605","variationId":"135515003"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514991"},{"groupId":"42344605","variationId":"135515004"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514991"},{"groupId":"42344605","variationId":"135515007"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514991"},{"groupId":"42344605","variationId":"135515011"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514991"},{"groupId":"42344605","variationId":"135515014"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514991"},{"groupId":"42344605","variationId":"135515019"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514991"},{"groupId":"42344605","variationId":"135515023"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514993"},{"groupId":"42344605","variationId":"135514996"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514993"},{"groupId":"42344605","variationId":"135514997"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514993"},{"groupId":"42344605","variationId":"135514999"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514993"},{"groupId":"42344605","variationId":"135515000"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514993"},{"groupId":"42344605","variationId":"135515001"}],"price":34800},{"variations":[{"groupId":"42344602","variationId":"135514993"},{"groupId":"42344605","variationId":"135515002"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514993"},{"groupId":"42344605","variationId":"135515003"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514993"},{"groupId":"42344605","variationId":"135515004"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514993"},{"groupId":"42344605","variationId":"135515007"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514993"},{"groupId":"42344605","variationId":"135515011"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514993"},{"groupId":"42344605","variationId":"135515014"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514993"},{"groupId":"42344605","variationId":"135515019"}],"price":39800},{"variations":[{"groupId":"42344602","variationId":"135514993"},{"groupId":"42344605","variationId":"135515023"}],"price":39800}]},"nextAvailableAtMessage":"Next available at 11 pm, today","itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":29800,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"133116145","name":"My Box @ Rs 199 - Non-Veg","category":"Late Night Specials","description":"Serves 1 | Any Non-Veg Pizza of your choice & 2 Pc of Exotica Veggie Garlic Bread. For Meals, refer to the nutritional data for individual products.","imageId":"615bbfc352c578cc5a7f348a4ce98a60","variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344671","name":"Choose Your Pizza","variations":[{"name":"Chicken Sausage","price":149,"default":1,"id":"135515440","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344677","variationId":"135515464"}},{"name":"Sausage & Sweet Corn","price":149,"id":"135515442","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344677","variationId":"135515464"}},{"name":"Dhabe Da Keema","price":149,"id":"135515446","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344677","variationId":"135515464"}},{"name":"Sizzling Schezwan Chicken","price":149,"id":"135515448","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344677","variationId":"135515464"}},{"name":"Murg Malai Chicken","price":149,"id":"135515452","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344677","variationId":"135515464"}},{"name":"Awesome American Cheesy Chicken","price":149,"id":"135515454","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344677","variationId":"135515464"}},{"name":"Chicken Tikka","price":149,"id":"135515455","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344677","variationId":"135515464"}},{"name":"Chicken Pepperoni","price":149,"id":"135515457","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344677","variationId":"135515464"}},{"name":"Nawabi Murg Makhni","price":149,"id":"135515459","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344677","variationId":"135515464"}},{"name":"Chicken Supreme","price":149,"id":"135515460","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344677","variationId":"135515464"}},{"name":"Chicken Tikka Supreme","price":149,"id":"135515462","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344677","variationId":"135515464"}},{"name":"Triple Chicken Feast","price":149,"id":"135515463","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344677","variationId":"135515464"}}]},{"groupId":"42344677","name":"Choose your appetizer","variations":[{"name":"2 Pc Exotica Veggie Garlic Bread","price":50,"default":1,"id":"135515464","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344671","variationId":"135515440"},{"groupId":"42344677","variationId":"135515464"}],"price":19900},{"variations":[{"groupId":"42344671","variationId":"135515442"},{"groupId":"42344677","variationId":"135515464"}],"price":19900},{"variations":[{"groupId":"42344671","variationId":"135515446"},{"groupId":"42344677","variationId":"135515464"}],"price":19900},{"variations":[{"groupId":"42344671","variationId":"135515448"},{"groupId":"42344677","variationId":"135515464"}],"price":19900},{"variations":[{"groupId":"42344671","variationId":"135515452"},{"groupId":"42344677","variationId":"135515464"}],"price":19900},{"variations":[{"groupId":"42344671","variationId":"135515454"},{"groupId":"42344677","variationId":"135515464"}],"price":19900},{"variations":[{"groupId":"42344671","variationId":"135515455"},{"groupId":"42344677","variationId":"135515464"}],"price":19900},{"variations":[{"groupId":"42344671","variationId":"135515457"},{"groupId":"42344677","variationId":"135515464"}],"price":19900},{"variations":[{"groupId":"42344671","variationId":"135515459"},{"groupId":"42344677","variationId":"135515464"}],"price":19900},{"variations":[{"groupId":"42344671","variationId":"135515460"},{"groupId":"42344677","variationId":"135515464"}],"price":19900},{"variations":[{"groupId":"42344671","variationId":"135515462"},{"groupId":"42344677","variationId":"135515464"}],"price":19900},{"variations":[{"groupId":"42344671","variationId":"135515463"},{"groupId":"42344677","variationId":"135515464"}],"price":19900}]},"nextAvailableAtMessage":"Next available at 11 pm, today","itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":19900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"133116144","name":"My Box @ Rs 179 - Veg","category":"Late Night Specials","description":"Serves 1 | Any Veg Pizza of your choice & 2 Pc of Exotica Veggie Garlic Bread. For Meals, refer to the nutritional data for individual products.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/3/12/0ae0003e-b596-4885-8fc7-ade1a7a251f3_9b5eb5ac-e685-40f4-b19e-45e1c782804a.png_compressed","isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344655","name":"Choose Your Pizza","variations":[{"name":"Margherita","price":129,"default":1,"id":"135515326","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344663","variationId":"135515371"}},{"name":"Schezwan Margherita","price":129,"id":"135515329","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344663","variationId":"135515371"}},{"name":"Corn & Cheese","price":129,"id":"135515331","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344663","variationId":"135515371"}},{"name":"Veggie Feast","price":129,"id":"135515334","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344663","variationId":"135515371"}},{"name":"Spiced Paneer","price":129,"id":"135515337","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344663","variationId":"135515371"}},{"name":"Mexican Fiesta","price":129,"id":"135515340","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344663","variationId":"135515371"}},{"name":"Bold BBQ Veggies","price":129,"id":"135515343","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344663","variationId":"135515371"}},{"name":"Tandoori Paneer","price":129,"id":"135515345","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344663","variationId":"135515371"}},{"name":"Country Feast","price":129,"id":"135515347","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344663","variationId":"135515371"}},{"name":"Ultimate Tandoori Veggie","price":129,"id":"135515351","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344663","variationId":"135515371"}},{"name":"Mazedar Makhni Paneer","price":129,"id":"135515355","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344663","variationId":"135515371"}},{"name":"Awesome American Cheesy","price":129,"id":"135515357","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344663","variationId":"135515371"}},{"name":"Veggie Supreme","price":129,"id":"135515361","inStock":1,"isVeg":1,"isEnabled":1,"dependantVariation":{"groupId":"42344663","variationId":"135515371"}}]},{"groupId":"42344663","name":"Choose your appetizer","variations":[{"name":"2 Pc Exotica Veggie Garlic Bread","price":50,"default":1,"id":"135515371","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344655","variationId":"135515326"},{"groupId":"42344663","variationId":"135515371"}],"price":17900},{"variations":[{"groupId":"42344655","variationId":"135515329"},{"groupId":"42344663","variationId":"135515371"}],"price":17900},{"variations":[{"groupId":"42344655","variationId":"135515331"},{"groupId":"42344663","variationId":"135515371"}],"price":17900},{"variations":[{"groupId":"42344655","variationId":"135515334"},{"groupId":"42344663","variationId":"135515371"}],"price":17900},{"variations":[{"groupId":"42344655","variationId":"135515337"},{"groupId":"42344663","variationId":"135515371"}],"price":17900},{"variations":[{"groupId":"42344655","variationId":"135515340"},{"groupId":"42344663","variationId":"135515371"}],"price":17900},{"variations":[{"groupId":"42344655","variationId":"135515343"},{"groupId":"42344663","variationId":"135515371"}],"price":17900},{"variations":[{"groupId":"42344655","variationId":"135515345"},{"groupId":"42344663","variationId":"135515371"}],"price":17900},{"variations":[{"groupId":"42344655","variationId":"135515347"},{"groupId":"42344663","variationId":"135515371"}],"price":17900},{"variations":[{"groupId":"42344655","variationId":"135515351"},{"groupId":"42344663","variationId":"135515371"}],"price":17900},{"variations":[{"groupId":"42344655","variationId":"135515355"},{"groupId":"42344663","variationId":"135515371"}],"price":17900},{"variations":[{"groupId":"42344655","variationId":"135515357"},{"groupId":"42344663","variationId":"135515371"}],"price":17900},{"variations":[{"groupId":"42344655","variationId":"135515361"},{"groupId":"42344663","variationId":"135515371"}],"price":17900}]},"nextAvailableAtMessage":"Next available at 11 pm, today","itemAttribute":{"vegClassifier":"VEG","portionSize":"Serves 1"},"defaultPrice":17900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"133116140","name":"2 Personal Non-Veg Pizzas @ Rs 179 each","category":"Late Night Specials","description":"Serves 1 | Get 2 delicious personal Non-Veg pizzas of your choice & satisfy those midnight cravings! For Meals, refer to the nutritional data for individual products.","imageId":"b55utd4ludogin1ftnhh","variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344584","name":"Choose 1st Pizza","variations":[{"name":"Chicken Sausage","price":179,"id":"135514836","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344586","variationId":"135514860"}},{"name":"Sausage & Sweet Corn","price":174.5,"default":1,"id":"135514839","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344586","variationId":"135514860"}},{"name":"Dhabe Da Keema","price":174.5,"id":"135514842","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344586","variationId":"135514860"}},{"name":"Sizzling Schezwan Chicken","price":174.5,"id":"135514844","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344586","variationId":"135514860"}},{"name":"Murg Malai Chicken","price":224.5,"id":"135514845","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344586","variationId":"135514860"}},{"name":"Awesome American Cheesy Chicken","price":224.5,"id":"135514847","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344586","variationId":"135514860"}},{"name":"Chicken Tikka","price":224.5,"id":"135514849","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344586","variationId":"135514860"}},{"name":"Chicken Pepperoni","price":224.5,"id":"135514851","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344586","variationId":"135514860"}},{"name":"Nawabi Murg Makhni","price":224.5,"id":"135514853","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344586","variationId":"135514860"}},{"name":"Chicken Supreme","price":224.5,"id":"135514855","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344586","variationId":"135514860"}},{"name":"Chicken Tikka Supreme","price":224.5,"id":"135514856","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344586","variationId":"135514860"}},{"name":"Triple Chicken Feast","price":224.5,"id":"135514858","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344586","variationId":"135514860"}}]},{"groupId":"42344586","name":"Choose 2nd Pizza","variations":[{"name":"Chicken Sausage","price":174.5,"default":1,"id":"135514860","inStock":1,"isEnabled":1},{"name":"Sausage & Sweet Corn","price":174.5,"id":"135514861","inStock":1,"isEnabled":1},{"name":"Dhabe Da Keema","price":174.5,"id":"135514862","inStock":1,"isEnabled":1},{"name":"Sizzling Schezwan Chicken","price":174.5,"id":"135514863","inStock":1,"isEnabled":1},{"name":"Murg Malai Chicken","price":224.5,"id":"135514864","inStock":1,"isEnabled":1},{"name":"Awesome American Cheesy Chicken","price":224.5,"id":"135514865","inStock":1,"isEnabled":1},{"name":"Chicken Tikka","price":224.5,"id":"135514866","inStock":1,"isEnabled":1},{"name":"Chicken Pepperoni","price":224.5,"id":"135514867","inStock":1,"isEnabled":1},{"name":"Nawabi Murg Makhni","price":224.5,"id":"135514868","inStock":1,"isEnabled":1},{"name":"Chicken Supreme","price":224.5,"id":"135514869","inStock":1,"isEnabled":1},{"name":"Chicken Tikka Supreme","price":224.5,"id":"135514870","inStock":1,"isEnabled":1},{"name":"Triple Chicken Feast","price":224.5,"id":"135514871","inStock":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344584","variationId":"135514836"},{"groupId":"42344586","variationId":"135514860"}],"price":35350},{"variations":[{"groupId":"42344584","variationId":"135514836"},{"groupId":"42344586","variationId":"135514861"}],"price":35350},{"variations":[{"groupId":"42344584","variationId":"135514836"},{"groupId":"42344586","variationId":"135514862"}],"price":35350},{"variations":[{"groupId":"42344584","variationId":"135514836"},{"groupId":"42344586","variationId":"135514863"}],"price":35350},{"variations":[{"groupId":"42344584","variationId":"135514836"},{"groupId":"42344586","variationId":"135514864"}],"price":40350},{"variations":[{"groupId":"42344584","variationId":"135514836"},{"groupId":"42344586","variationId":"135514865"}],"price":40350},{"variations":[{"groupId":"42344584","variationId":"135514836"},{"groupId":"42344586","variationId":"135514866"}],"price":40350},{"variations":[{"groupId":"42344584","variationId":"135514836"},{"groupId":"42344586","variationId":"135514867"}],"price":40350},{"variations":[{"groupId":"42344584","variationId":"135514836"},{"groupId":"42344586","variationId":"135514868"}],"price":40350},{"variations":[{"groupId":"42344584","variationId":"135514836"},{"groupId":"42344586","variationId":"135514869"}],"price":40350},{"variations":[{"groupId":"42344584","variationId":"135514836"},{"groupId":"42344586","variationId":"135514870"}],"price":40350},{"variations":[{"groupId":"42344584","variationId":"135514836"},{"groupId":"42344586","variationId":"135514871"}],"price":40350},{"variations":[{"groupId":"42344584","variationId":"135514839"},{"groupId":"42344586","variationId":"135514860"}],"price":34900},{"variations":[{"groupId":"42344584","variationId":"135514839"},{"groupId":"42344586","variationId":"135514861"}],"price":34900},{"variations":[{"groupId":"42344584","variationId":"135514839"},{"groupId":"42344586","variationId":"135514862"}],"price":34900},{"variations":[{"groupId":"42344584","variationId":"135514839"},{"groupId":"42344586","variationId":"135514863"}],"price":34900},{"variations":[{"groupId":"42344584","variationId":"135514839"},{"groupId":"42344586","variationId":"135514864"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514839"},{"groupId":"42344586","variationId":"135514865"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514839"},{"groupId":"42344586","variationId":"135514866"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514839"},{"groupId":"42344586","variationId":"135514867"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514839"},{"groupId":"42344586","variationId":"135514868"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514839"},{"groupId":"42344586","variationId":"135514869"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514839"},{"groupId":"42344586","variationId":"135514870"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514839"},{"groupId":"42344586","variationId":"135514871"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514842"},{"groupId":"42344586","variationId":"135514860"}],"price":34900},{"variations":[{"groupId":"42344584","variationId":"135514842"},{"groupId":"42344586","variationId":"135514861"}],"price":34900},{"variations":[{"groupId":"42344584","variationId":"135514842"},{"groupId":"42344586","variationId":"135514862"}],"price":34900},{"variations":[{"groupId":"42344584","variationId":"135514842"},{"groupId":"42344586","variationId":"135514863"}],"price":34900},{"variations":[{"groupId":"42344584","variationId":"135514842"},{"groupId":"42344586","variationId":"135514864"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514842"},{"groupId":"42344586","variationId":"135514865"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514842"},{"groupId":"42344586","variationId":"135514866"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514842"},{"groupId":"42344586","variationId":"135514867"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514842"},{"groupId":"42344586","variationId":"135514868"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514842"},{"groupId":"42344586","variationId":"135514869"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514842"},{"groupId":"42344586","variationId":"135514870"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514842"},{"groupId":"42344586","variationId":"135514871"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514844"},{"groupId":"42344586","variationId":"135514860"}],"price":34900},{"variations":[{"groupId":"42344584","variationId":"135514844"},{"groupId":"42344586","variationId":"135514861"}],"price":34900},{"variations":[{"groupId":"42344584","variationId":"135514844"},{"groupId":"42344586","variationId":"135514862"}],"price":34900},{"variations":[{"groupId":"42344584","variationId":"135514844"},{"groupId":"42344586","variationId":"135514863"}],"price":34900},{"variations":[{"groupId":"42344584","variationId":"135514844"},{"groupId":"42344586","variationId":"135514864"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514844"},{"groupId":"42344586","variationId":"135514865"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514844"},{"groupId":"42344586","variationId":"135514866"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514844"},{"groupId":"42344586","variationId":"135514867"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514844"},{"groupId":"42344586","variationId":"135514868"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514844"},{"groupId":"42344586","variationId":"135514869"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514844"},{"groupId":"42344586","variationId":"135514870"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514844"},{"groupId":"42344586","variationId":"135514871"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514845"},{"groupId":"42344586","variationId":"135514860"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514845"},{"groupId":"42344586","variationId":"135514861"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514845"},{"groupId":"42344586","variationId":"135514862"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514845"},{"groupId":"42344586","variationId":"135514863"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514845"},{"groupId":"42344586","variationId":"135514864"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514845"},{"groupId":"42344586","variationId":"135514865"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514845"},{"groupId":"42344586","variationId":"135514866"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514845"},{"groupId":"42344586","variationId":"135514867"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514845"},{"groupId":"42344586","variationId":"135514868"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514845"},{"groupId":"42344586","variationId":"135514869"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514845"},{"groupId":"42344586","variationId":"135514870"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514845"},{"groupId":"42344586","variationId":"135514871"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514847"},{"groupId":"42344586","variationId":"135514860"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514847"},{"groupId":"42344586","variationId":"135514861"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514847"},{"groupId":"42344586","variationId":"135514862"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514847"},{"groupId":"42344586","variationId":"135514863"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514847"},{"groupId":"42344586","variationId":"135514864"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514847"},{"groupId":"42344586","variationId":"135514865"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514847"},{"groupId":"42344586","variationId":"135514866"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514847"},{"groupId":"42344586","variationId":"135514867"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514847"},{"groupId":"42344586","variationId":"135514868"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514847"},{"groupId":"42344586","variationId":"135514869"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514847"},{"groupId":"42344586","variationId":"135514870"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514847"},{"groupId":"42344586","variationId":"135514871"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514849"},{"groupId":"42344586","variationId":"135514860"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514849"},{"groupId":"42344586","variationId":"135514861"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514849"},{"groupId":"42344586","variationId":"135514862"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514849"},{"groupId":"42344586","variationId":"135514863"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514849"},{"groupId":"42344586","variationId":"135514864"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514849"},{"groupId":"42344586","variationId":"135514865"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514849"},{"groupId":"42344586","variationId":"135514866"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514849"},{"groupId":"42344586","variationId":"135514867"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514849"},{"groupId":"42344586","variationId":"135514868"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514849"},{"groupId":"42344586","variationId":"135514869"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514849"},{"groupId":"42344586","variationId":"135514870"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514849"},{"groupId":"42344586","variationId":"135514871"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514851"},{"groupId":"42344586","variationId":"135514860"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514851"},{"groupId":"42344586","variationId":"135514861"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514851"},{"groupId":"42344586","variationId":"135514862"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514851"},{"groupId":"42344586","variationId":"135514863"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514851"},{"groupId":"42344586","variationId":"135514864"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514851"},{"groupId":"42344586","variationId":"135514865"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514851"},{"groupId":"42344586","variationId":"135514866"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514851"},{"groupId":"42344586","variationId":"135514867"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514851"},{"groupId":"42344586","variationId":"135514868"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514851"},{"groupId":"42344586","variationId":"135514869"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514851"},{"groupId":"42344586","variationId":"135514870"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514851"},{"groupId":"42344586","variationId":"135514871"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514853"},{"groupId":"42344586","variationId":"135514860"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514853"},{"groupId":"42344586","variationId":"135514861"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514853"},{"groupId":"42344586","variationId":"135514862"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514853"},{"groupId":"42344586","variationId":"135514863"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514853"},{"groupId":"42344586","variationId":"135514864"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514853"},{"groupId":"42344586","variationId":"135514865"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514853"},{"groupId":"42344586","variationId":"135514866"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514853"},{"groupId":"42344586","variationId":"135514867"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514853"},{"groupId":"42344586","variationId":"135514868"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514853"},{"groupId":"42344586","variationId":"135514869"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514853"},{"groupId":"42344586","variationId":"135514870"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514853"},{"groupId":"42344586","variationId":"135514871"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514855"},{"groupId":"42344586","variationId":"135514860"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514855"},{"groupId":"42344586","variationId":"135514861"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514855"},{"groupId":"42344586","variationId":"135514862"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514855"},{"groupId":"42344586","variationId":"135514863"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514855"},{"groupId":"42344586","variationId":"135514864"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514855"},{"groupId":"42344586","variationId":"135514865"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514855"},{"groupId":"42344586","variationId":"135514866"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514855"},{"groupId":"42344586","variationId":"135514867"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514855"},{"groupId":"42344586","variationId":"135514868"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514855"},{"groupId":"42344586","variationId":"135514869"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514855"},{"groupId":"42344586","variationId":"135514870"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514855"},{"groupId":"42344586","variationId":"135514871"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514856"},{"groupId":"42344586","variationId":"135514860"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514856"},{"groupId":"42344586","variationId":"135514861"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514856"},{"groupId":"42344586","variationId":"135514862"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514856"},{"groupId":"42344586","variationId":"135514863"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514856"},{"groupId":"42344586","variationId":"135514864"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514856"},{"groupId":"42344586","variationId":"135514865"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514856"},{"groupId":"42344586","variationId":"135514866"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514856"},{"groupId":"42344586","variationId":"135514867"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514856"},{"groupId":"42344586","variationId":"135514868"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514856"},{"groupId":"42344586","variationId":"135514869"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514856"},{"groupId":"42344586","variationId":"135514870"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514856"},{"groupId":"42344586","variationId":"135514871"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514858"},{"groupId":"42344586","variationId":"135514860"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514858"},{"groupId":"42344586","variationId":"135514861"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514858"},{"groupId":"42344586","variationId":"135514862"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514858"},{"groupId":"42344586","variationId":"135514863"}],"price":39900},{"variations":[{"groupId":"42344584","variationId":"135514858"},{"groupId":"42344586","variationId":"135514864"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514858"},{"groupId":"42344586","variationId":"135514865"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514858"},{"groupId":"42344586","variationId":"135514866"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514858"},{"groupId":"42344586","variationId":"135514867"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514858"},{"groupId":"42344586","variationId":"135514868"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514858"},{"groupId":"42344586","variationId":"135514869"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514858"},{"groupId":"42344586","variationId":"135514870"}],"price":44900},{"variations":[{"groupId":"42344584","variationId":"135514858"},{"groupId":"42344586","variationId":"135514871"}],"price":44900}]},"nextAvailableAtMessage":"Next available at 11 pm, today","itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":34900,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"133116143","name":"2 Medium Non-Veg Pizzas @ 329 each","category":"Late Night Specials","description":"Serves 1 | Get 2 delicious non-veg medium pizzas of your choice & say goodbye to your midnight cravings. For Meals, refer to the nutritional data for individual products.","imageId":"6110f28b77f670194674bbf318970656","variants":{},"variantsV2":{"variantGroups":[{"groupId":"42344635","name":"Choose 1st Pizza","variations":[{"name":"Chicken Sausage","price":329,"default":1,"id":"135515200","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344640","variationId":"135515238"}},{"name":"Sausage & Sweet Corn","price":329,"id":"135515201","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344640","variationId":"135515238"}},{"name":"Dhabe Da Keema","price":329,"id":"135515202","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344640","variationId":"135515238"}},{"name":"Sizzling Schezwan Chicken","price":329,"id":"135515204","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344640","variationId":"135515238"}},{"name":"Murg Malai Chicken","price":379,"id":"135515206","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344640","variationId":"135515238"}},{"name":"Awesome American Cheesy Chicken","price":379,"id":"135515207","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344640","variationId":"135515238"}},{"name":"Chicken Tikka","price":379,"id":"135515210","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344640","variationId":"135515238"}},{"name":"Chicken Pepperoni","price":379,"id":"135515213","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344640","variationId":"135515238"}},{"name":"Nawabi Murg Makhni","price":379,"id":"135515216","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344640","variationId":"135515238"}},{"name":"Chicken Supreme","price":379,"id":"135515219","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344640","variationId":"135515238"}},{"name":"Chicken Tikka Supreme","price":379,"id":"135515224","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344640","variationId":"135515238"}},{"name":"Triple Chicken Feast","price":379,"id":"135515229","inStock":1,"isEnabled":1,"dependantVariation":{"groupId":"42344640","variationId":"135515238"}}]},{"groupId":"42344640","name":"Choose 2nd Pizza","variations":[{"name":"Chicken Sausage","price":329,"default":1,"id":"135515238","inStock":1,"isEnabled":1},{"name":"Sausage & Sweet Corn","price":329,"id":"135515243","inStock":1,"isEnabled":1},{"name":"Dhabe Da Keema","price":329,"id":"135515248","inStock":1,"isEnabled":1},{"name":"Sizzling Schezwan Chicken","price":329,"id":"135515251","inStock":1,"isEnabled":1},{"name":"Murg Malai Chicken","price":379,"id":"135515254","inStock":1,"isEnabled":1},{"name":"Awesome American Cheesy Chicken","price":379,"id":"135515257","inStock":1,"isEnabled":1},{"name":"Chicken Tikka","price":379,"id":"135515260","inStock":1,"isEnabled":1},{"name":"Chicken Pepperoni","price":379,"id":"135515261","inStock":1,"isEnabled":1},{"name":"Nawabi Murg Makhni","price":379,"id":"135515264","inStock":1,"isEnabled":1},{"name":"Chicken Supreme","price":379,"id":"135515266","inStock":1,"isEnabled":1},{"name":"Chicken Tikka Supreme","price":379,"id":"135515268","inStock":1,"isEnabled":1},{"name":"Triple Chicken Feast","price":379,"id":"135515270","inStock":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"42344635","variationId":"135515200"},{"groupId":"42344640","variationId":"135515238"}],"price":65800},{"variations":[{"groupId":"42344635","variationId":"135515200"},{"groupId":"42344640","variationId":"135515243"}],"price":65800},{"variations":[{"groupId":"42344635","variationId":"135515200"},{"groupId":"42344640","variationId":"135515248"}],"price":65800},{"variations":[{"groupId":"42344635","variationId":"135515200"},{"groupId":"42344640","variationId":"135515251"}],"price":65800},{"variations":[{"groupId":"42344635","variationId":"135515200"},{"groupId":"42344640","variationId":"135515254"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515200"},{"groupId":"42344640","variationId":"135515257"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515200"},{"groupId":"42344640","variationId":"135515260"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515200"},{"groupId":"42344640","variationId":"135515261"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515200"},{"groupId":"42344640","variationId":"135515264"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515200"},{"groupId":"42344640","variationId":"135515266"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515200"},{"groupId":"42344640","variationId":"135515268"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515200"},{"groupId":"42344640","variationId":"135515270"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515201"},{"groupId":"42344640","variationId":"135515238"}],"price":65800},{"variations":[{"groupId":"42344635","variationId":"135515201"},{"groupId":"42344640","variationId":"135515243"}],"price":65800},{"variations":[{"groupId":"42344635","variationId":"135515201"},{"groupId":"42344640","variationId":"135515248"}],"price":65800},{"variations":[{"groupId":"42344635","variationId":"135515201"},{"groupId":"42344640","variationId":"135515251"}],"price":65800},{"variations":[{"groupId":"42344635","variationId":"135515201"},{"groupId":"42344640","variationId":"135515254"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515201"},{"groupId":"42344640","variationId":"135515257"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515201"},{"groupId":"42344640","variationId":"135515260"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515201"},{"groupId":"42344640","variationId":"135515261"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515201"},{"groupId":"42344640","variationId":"135515264"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515201"},{"groupId":"42344640","variationId":"135515266"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515201"},{"groupId":"42344640","variationId":"135515268"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515201"},{"groupId":"42344640","variationId":"135515270"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515202"},{"groupId":"42344640","variationId":"135515238"}],"price":65800},{"variations":[{"groupId":"42344635","variationId":"135515202"},{"groupId":"42344640","variationId":"135515243"}],"price":65800},{"variations":[{"groupId":"42344635","variationId":"135515202"},{"groupId":"42344640","variationId":"135515248"}],"price":65800},{"variations":[{"groupId":"42344635","variationId":"135515202"},{"groupId":"42344640","variationId":"135515251"}],"price":65800},{"variations":[{"groupId":"42344635","variationId":"135515202"},{"groupId":"42344640","variationId":"135515254"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515202"},{"groupId":"42344640","variationId":"135515257"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515202"},{"groupId":"42344640","variationId":"135515260"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515202"},{"groupId":"42344640","variationId":"135515261"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515202"},{"groupId":"42344640","variationId":"135515264"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515202"},{"groupId":"42344640","variationId":"135515266"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515202"},{"groupId":"42344640","variationId":"135515268"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515202"},{"groupId":"42344640","variationId":"135515270"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515204"},{"groupId":"42344640","variationId":"135515238"}],"price":65800},{"variations":[{"groupId":"42344635","variationId":"135515204"},{"groupId":"42344640","variationId":"135515243"}],"price":65800},{"variations":[{"groupId":"42344635","variationId":"135515204"},{"groupId":"42344640","variationId":"135515248"}],"price":65800},{"variations":[{"groupId":"42344635","variationId":"135515204"},{"groupId":"42344640","variationId":"135515251"}],"price":65800},{"variations":[{"groupId":"42344635","variationId":"135515204"},{"groupId":"42344640","variationId":"135515254"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515204"},{"groupId":"42344640","variationId":"135515257"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515204"},{"groupId":"42344640","variationId":"135515260"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515204"},{"groupId":"42344640","variationId":"135515261"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515204"},{"groupId":"42344640","variationId":"135515264"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515204"},{"groupId":"42344640","variationId":"135515266"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515204"},{"groupId":"42344640","variationId":"135515268"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515204"},{"groupId":"42344640","variationId":"135515270"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515206"},{"groupId":"42344640","variationId":"135515238"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515206"},{"groupId":"42344640","variationId":"135515243"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515206"},{"groupId":"42344640","variationId":"135515248"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515206"},{"groupId":"42344640","variationId":"135515251"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515206"},{"groupId":"42344640","variationId":"135515254"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515206"},{"groupId":"42344640","variationId":"135515257"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515206"},{"groupId":"42344640","variationId":"135515260"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515206"},{"groupId":"42344640","variationId":"135515261"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515206"},{"groupId":"42344640","variationId":"135515264"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515206"},{"groupId":"42344640","variationId":"135515266"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515206"},{"groupId":"42344640","variationId":"135515268"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515206"},{"groupId":"42344640","variationId":"135515270"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515207"},{"groupId":"42344640","variationId":"135515238"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515207"},{"groupId":"42344640","variationId":"135515243"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515207"},{"groupId":"42344640","variationId":"135515248"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515207"},{"groupId":"42344640","variationId":"135515251"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515207"},{"groupId":"42344640","variationId":"135515254"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515207"},{"groupId":"42344640","variationId":"135515257"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515207"},{"groupId":"42344640","variationId":"135515260"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515207"},{"groupId":"42344640","variationId":"135515261"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515207"},{"groupId":"42344640","variationId":"135515264"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515207"},{"groupId":"42344640","variationId":"135515266"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515207"},{"groupId":"42344640","variationId":"135515268"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515207"},{"groupId":"42344640","variationId":"135515270"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515210"},{"groupId":"42344640","variationId":"135515238"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515210"},{"groupId":"42344640","variationId":"135515243"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515210"},{"groupId":"42344640","variationId":"135515248"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515210"},{"groupId":"42344640","variationId":"135515251"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515210"},{"groupId":"42344640","variationId":"135515254"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515210"},{"groupId":"42344640","variationId":"135515257"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515210"},{"groupId":"42344640","variationId":"135515260"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515210"},{"groupId":"42344640","variationId":"135515261"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515210"},{"groupId":"42344640","variationId":"135515264"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515210"},{"groupId":"42344640","variationId":"135515266"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515210"},{"groupId":"42344640","variationId":"135515268"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515210"},{"groupId":"42344640","variationId":"135515270"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515213"},{"groupId":"42344640","variationId":"135515238"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515213"},{"groupId":"42344640","variationId":"135515243"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515213"},{"groupId":"42344640","variationId":"135515248"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515213"},{"groupId":"42344640","variationId":"135515251"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515213"},{"groupId":"42344640","variationId":"135515254"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515213"},{"groupId":"42344640","variationId":"135515257"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515213"},{"groupId":"42344640","variationId":"135515260"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515213"},{"groupId":"42344640","variationId":"135515261"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515213"},{"groupId":"42344640","variationId":"135515264"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515213"},{"groupId":"42344640","variationId":"135515266"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515213"},{"groupId":"42344640","variationId":"135515268"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515213"},{"groupId":"42344640","variationId":"135515270"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515216"},{"groupId":"42344640","variationId":"135515238"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515216"},{"groupId":"42344640","variationId":"135515243"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515216"},{"groupId":"42344640","variationId":"135515248"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515216"},{"groupId":"42344640","variationId":"135515251"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515216"},{"groupId":"42344640","variationId":"135515254"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515216"},{"groupId":"42344640","variationId":"135515257"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515216"},{"groupId":"42344640","variationId":"135515260"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515216"},{"groupId":"42344640","variationId":"135515261"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515216"},{"groupId":"42344640","variationId":"135515264"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515216"},{"groupId":"42344640","variationId":"135515266"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515216"},{"groupId":"42344640","variationId":"135515268"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515216"},{"groupId":"42344640","variationId":"135515270"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515219"},{"groupId":"42344640","variationId":"135515238"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515219"},{"groupId":"42344640","variationId":"135515243"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515219"},{"groupId":"42344640","variationId":"135515248"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515219"},{"groupId":"42344640","variationId":"135515251"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515219"},{"groupId":"42344640","variationId":"135515254"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515219"},{"groupId":"42344640","variationId":"135515257"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515219"},{"groupId":"42344640","variationId":"135515260"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515219"},{"groupId":"42344640","variationId":"135515261"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515219"},{"groupId":"42344640","variationId":"135515264"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515219"},{"groupId":"42344640","variationId":"135515266"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515219"},{"groupId":"42344640","variationId":"135515268"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515219"},{"groupId":"42344640","variationId":"135515270"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515224"},{"groupId":"42344640","variationId":"135515238"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515224"},{"groupId":"42344640","variationId":"135515243"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515224"},{"groupId":"42344640","variationId":"135515248"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515224"},{"groupId":"42344640","variationId":"135515251"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515224"},{"groupId":"42344640","variationId":"135515254"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515224"},{"groupId":"42344640","variationId":"135515257"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515224"},{"groupId":"42344640","variationId":"135515260"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515224"},{"groupId":"42344640","variationId":"135515261"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515224"},{"groupId":"42344640","variationId":"135515264"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515224"},{"groupId":"42344640","variationId":"135515266"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515224"},{"groupId":"42344640","variationId":"135515268"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515224"},{"groupId":"42344640","variationId":"135515270"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515229"},{"groupId":"42344640","variationId":"135515238"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515229"},{"groupId":"42344640","variationId":"135515243"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515229"},{"groupId":"42344640","variationId":"135515248"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515229"},{"groupId":"42344640","variationId":"135515251"}],"price":70800},{"variations":[{"groupId":"42344635","variationId":"135515229"},{"groupId":"42344640","variationId":"135515254"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515229"},{"groupId":"42344640","variationId":"135515257"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515229"},{"groupId":"42344640","variationId":"135515260"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515229"},{"groupId":"42344640","variationId":"135515261"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515229"},{"groupId":"42344640","variationId":"135515264"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515229"},{"groupId":"42344640","variationId":"135515266"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515229"},{"groupId":"42344640","variationId":"135515268"}],"price":75800},{"variations":[{"groupId":"42344635","variationId":"135515229"},{"groupId":"42344640","variationId":"135515270"}],"price":75800}]},"nextAvailableAtMessage":"Next available at 11 pm, today","itemAttribute":{"vegClassifier":"NONVEG","portionSize":"Serves 1"},"defaultPrice":65800,"ribbon":{},"type":"ITEM","offerTags":[{"title":"30% OFF","subTitle":"USE TRYNEW","textColor":"#DB6742","backgroundColor":"#FAE8E3"}],"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo","type":"FSSAI","imageId":"fssai_final_edss9i","text":["License No. 10020022011450"]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress","name":"Pizza Hut","area":"Triplicane","completeAddress":"Old No - 57-62, New No -111, First Floor, Wallajah Road, Anna Salai, Chennai, Tamilnadu - 600002"}}}]}}}}],"firstOffsetRequest":true,"isQCLink":false},"tid":"14bcccd1-cdcf-4a08-91c8-977f61adfbfe","sid":"dv6e2f9e-7d3f-4cf4-8859-6b66bca4e526","deviceId":"e4466909-d139-ec90-fb1a-adde4ac70f80","csrfToken":null}');


var $6d359334c042511a$var$useRestaurantMenu = function(resId) {
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(null), 2), resInfo = _useState[0], setResInfo = _useState[1];
    (0, $fIwXP.useEffect)(function() {
        fetchData();
    }, []);
    var fetchData = function() {
        var _ref = (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function() {
            var json;
            return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                json = (0, (/*@__PURE__*/$parcel$interopDefault($1c82672e18f22827$exports)));
                setResInfo(json.data);
                return [
                    2
                ];
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    return resInfo;
};
var $6d359334c042511a$export$2e2bcd8739ae039 = $6d359334c042511a$var$useRestaurantMenu;



var $cc6u1 = parcelRequire("cc6u1");

var $cc6u1 = parcelRequire("cc6u1");


// cartSlice.js



var $fWfWu = parcelRequire("fWfWu");


var $bB0zn = parcelRequire("bB0zn");

var $f5KHm = parcelRequire("f5KHm");

var $6QEWP = parcelRequire("6QEWP");

var $hD5pT = parcelRequire("hD5pT");

var $ZhYhU = parcelRequire("ZhYhU");
function $5f0e95e6df7a47eb$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $ZhYhU._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}


function $04ca9dac0ceac2e2$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $04ca9dac0ceac2e2$export$afb3516d9d608401 = Reflect.get;
    else $04ca9dac0ceac2e2$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $5f0e95e6df7a47eb$export$e4187255aefbc259)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $04ca9dac0ceac2e2$export$afb3516d9d608401(target, property, receiver || target);
}



var $ZhYhU = parcelRequire("ZhYhU");

var $5dLwP = parcelRequire("5dLwP");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");

var $fPaN7 = parcelRequire("fPaN7");

var $lMNAp = parcelRequire("lMNAp");

// src/utils/formatProdErrorMessage.ts

var $hD5pT = parcelRequire("hD5pT");



var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");
function $a039f9c7168ef4c9$var$formatProdErrorMessage(code) {
    return "Minified Redux error #".concat(code, "; visit https://redux.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}
// src/utils/symbol-observable.ts
var $a039f9c7168ef4c9$var$$$observable = /* @__PURE__ */ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
var $a039f9c7168ef4c9$var$symbol_observable_default = $a039f9c7168ef4c9$var$$$observable;
// src/utils/actionTypes.ts
var $a039f9c7168ef4c9$var$randomString = function() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $a039f9c7168ef4c9$var$ActionTypes = {
    INIT: "@@redux/INIT".concat($a039f9c7168ef4c9$var$randomString()),
    REPLACE: "@@redux/REPLACE".concat($a039f9c7168ef4c9$var$randomString()),
    PROBE_UNKNOWN_ACTION: function() {
        return "@@redux/PROBE_UNKNOWN_ACTION".concat($a039f9c7168ef4c9$var$randomString());
    }
};
var $a039f9c7168ef4c9$export$4219e499db7ca678 = $a039f9c7168ef4c9$var$ActionTypes;
// src/utils/isPlainObject.ts
function $a039f9c7168ef4c9$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $a039f9c7168ef4c9$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val === "undefined" ? "undefined" : (0, $YtE9h._)(val);
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($a039f9c7168ef4c9$var$isDate(val)) return "date";
    if ($a039f9c7168ef4c9$var$isError(val)) return "error";
    var constructorName = $a039f9c7168ef4c9$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $a039f9c7168ef4c9$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $a039f9c7168ef4c9$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $a039f9c7168ef4c9$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $a039f9c7168ef4c9$var$kindOf(val) {
    var typeOfVal = typeof val === "undefined" ? "undefined" : (0, $YtE9h._)(val);
    return typeOfVal;
}
// src/createStore.ts
function $a039f9c7168ef4c9$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(1));
        return enhancer($a039f9c7168ef4c9$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = /* @__PURE__ */ new Map();
    var nextListeners = currentListeners;
    var listenerIdCounter = 0;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach(function(listener, key) {
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        var listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$a039f9c7168ef4c9$export$53b83ca8eaab0383(action)) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        listeners.forEach(function(listener) {
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $a039f9c7168ef4c9$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        var outerSubscribe = subscribe;
        return (0, $hD5pT._)({
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(11));
                function observeState() {
                    var observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, $a039f9c7168ef4c9$var$symbol_observable_default, function() {
            return this;
        });
    }
    dispatch({
        type: $a039f9c7168ef4c9$export$4219e499db7ca678.INIT
    });
    var store = (0, $hD5pT._)({
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, $a039f9c7168ef4c9$var$symbol_observable_default, observable);
    return store;
}
function $a039f9c7168ef4c9$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $a039f9c7168ef4c9$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $a039f9c7168ef4c9$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $a039f9c7168ef4c9$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $a039f9c7168ef4c9$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$a039f9c7168ef4c9$export$53b83ca8eaab0383(inputState)) return "The ".concat(argumentName, ' has unexpected type of "').concat($a039f9c7168ef4c9$var$kindOf(inputState), '". Expected argument to be an object with the following keys: "').concat(reducerKeys.join('", "'), '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $a039f9c7168ef4c9$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected ".concat(unexpectedKeys.length > 1 ? "keys" : "key", ' "').concat(unexpectedKeys.join('", "'), '" found in ').concat(argumentName, '. Expected to find one of the known reducer keys instead: "').concat(reducerKeys.join('", "'), '". Unexpected keys will be ignored.');
}
function $a039f9c7168ef4c9$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(void 0, {
            type: $a039f9c7168ef4c9$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $a039f9c7168ef4c9$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(13));
    });
}
function $a039f9c7168ef4c9$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $a039f9c7168ef4c9$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, action = arguments.length > 1 ? arguments[1] : void 0;
        if (shapeAssertionError) throw shapeAssertionError;
        var hasChanged = false;
        var nextState = {};
        for(var i = 0; i < finalReducerKeys.length; i++){
            var key = finalReducerKeys[i];
            var reducer = finalReducers[key];
            var previousStateForKey = state[key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $a039f9c7168ef4c9$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return dispatch(actionCreator.apply(this, args));
    };
}
function $a039f9c7168ef4c9$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $a039f9c7168ef4c9$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $a039f9c7168ef4c9$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $a039f9c7168ef4c9$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++){
        funcs[_key] = arguments[_key];
    }
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return a(b.apply(void 0, (0, $2Xzd1._)(args)));
        };
    });
}
// src/applyMiddleware.ts
function $a039f9c7168ef4c9$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
        middlewares[_key] = arguments[_key];
    }
    return function(createStore2) {
        return function(reducer, preloadedState) {
            var store = createStore2(reducer, preloadedState);
            var dispatch = function() {
                throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function(action) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    return dispatch.apply(void 0, [
                        action
                    ].concat((0, $2Xzd1._)(args)));
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            dispatch = $a039f9c7168ef4c9$export$f672e0b6f7222cd7.apply(void 0, (0, $2Xzd1._)(chain))(store.dispatch);
            return (0, $f17388ede13a49cc$export$4fa2f4023c9cbda5)((0, $ad1c00e896d27009$export$581ff339ea0ba762)({}, store), {
                dispatch: dispatch
            });
        };
    };
}
// src/utils/isAction.ts
function $a039f9c7168ef4c9$export$b956e38827fca970(action) {
    return $a039f9c7168ef4c9$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}



var $5icQr = parcelRequire("5icQr");

var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");
var $874a87fa87407f05$var$__defProp = Object.defineProperty;
var $874a87fa87407f05$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $874a87fa87407f05$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $874a87fa87407f05$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $874a87fa87407f05$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $874a87fa87407f05$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $874a87fa87407f05$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($874a87fa87407f05$var$__hasOwnProp.call(b, prop)) $874a87fa87407f05$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($874a87fa87407f05$var$__getOwnPropSymbols) try {
        for(var _iterator = $874a87fa87407f05$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($874a87fa87407f05$var$__propIsEnum.call(b, prop)) $874a87fa87407f05$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $874a87fa87407f05$var$__publicField = function(obj, key, value) {
    $874a87fa87407f05$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $YtE9h._)(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $874a87fa87407f05$var$runIdentityFunctionCheck = function(resultFunc, inputSelectorsResults, outputSelectorResult) {
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        var isInputSameAsOutput = false;
        try {
            var emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            var stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                stack = e.stack;
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $874a87fa87407f05$var$runInputStabilityCheck = function(inputSelectorResultsObject, options, inputSelectorArgs) {
    var memoize = options.memoize, memoizeOptions = options.memoizeOptions;
    var inputSelectorResults = inputSelectorResultsObject.inputSelectorResults, inputSelectorResultsCopy = inputSelectorResultsObject.inputSelectorResultsCopy;
    var createAnEmptyObject = memoize.apply(void 0, [
        function() {
            return {};
        }
    ].concat((0, $2Xzd1._)(memoizeOptions)));
    var areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        var stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            stack = e.stack;
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $874a87fa87407f05$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $874a87fa87407f05$export$1e290349de99e28c = function(devModeChecks) {
    Object.assign($874a87fa87407f05$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $874a87fa87407f05$var$NOT_FOUND = "NOT_FOUND";
function $874a87fa87407f05$var$assertIsFunction(func) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected a function, instead received ".concat(typeof func === "undefined" ? "undefined" : (0, $YtE9h._)(func));
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $874a87fa87407f05$var$assertIsObject(object) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected an object, instead received ".concat(typeof object === "undefined" ? "undefined" : (0, $YtE9h._)(object));
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $874a87fa87407f05$var$assertIsArrayOfFunctions(array) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected all items to be functions, instead received the following types: ";
    if (!array.every(function(item) {
        return typeof item === "function";
    })) {
        var itemTypes = array.map(function(item) {
            return typeof item === "function" ? "function ".concat(item.name || "unnamed", "()") : typeof item === "undefined" ? "undefined" : (0, $YtE9h._)(item);
        }).join(", ");
        throw new TypeError("".concat(errorMessage, "[").concat(itemTypes, "]"));
    }
}
var $874a87fa87407f05$var$ensureIsArray = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
function $874a87fa87407f05$var$getDependencies(createSelectorArgs) {
    var dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $874a87fa87407f05$var$assertIsArrayOfFunctions(dependencies, "createSelector expects all input-selectors to be functions, but received the following types: ");
    return dependencies;
}
function $874a87fa87407f05$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    var inputSelectorResults = [];
    var length = dependencies.length;
    for(var i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $874a87fa87407f05$var$getDevModeChecksExecutionInfo = function(firstRun, devModeChecks) {
    var __spreadValues1 = $874a87fa87407f05$var$__spreadValues($874a87fa87407f05$var$__spreadValues({}, $874a87fa87407f05$var$globalDevModeChecks), devModeChecks), identityFunctionCheck = __spreadValues1.identityFunctionCheck, inputStabilityCheck = __spreadValues1.inputStabilityCheck;
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $874a87fa87407f05$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $874a87fa87407f05$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $874a87fa87407f05$var$$REVISION = 0;
var $874a87fa87407f05$var$CURRENT_TRACKER = null;
var $874a87fa87407f05$var$Cell = /*#__PURE__*/ function() {
    "use strict";
    function Cell(initialValue) {
        var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $874a87fa87407f05$var$tripleEq;
        (0, $bB0zn._)(this, Cell);
        $874a87fa87407f05$var$__publicField(this, "revision", $874a87fa87407f05$var$$REVISION);
        $874a87fa87407f05$var$__publicField(this, "_value");
        $874a87fa87407f05$var$__publicField(this, "_lastValue");
        $874a87fa87407f05$var$__publicField(this, "_isEqual", $874a87fa87407f05$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    (0, $6QEWP._)(Cell, [
        {
            key: "value",
            get: // Whenever a storage value is read, it'll add itself to the current tracker if
            // one exists, entangling its state with that cache.
            function get() {
                $874a87fa87407f05$var$CURRENT_TRACKER == null || $874a87fa87407f05$var$CURRENT_TRACKER.add(this);
                return this._value;
            },
            set: // Whenever a storage value is updated, we bump the global revision clock,
            // assign the revision for this storage to the new value, _and_ we schedule a
            // rerender. This is important, and it's what makes autotracking  _pull_
            // based. We don't actively tell the caches which depend on the storage that
            // anything has happened. Instead, we recompute the caches when needed.
            function set(newValue) {
                if (this.value === newValue) return;
                this._value = newValue;
                this.revision = ++$874a87fa87407f05$var$$REVISION;
            }
        }
    ]);
    return Cell;
}();
function $874a87fa87407f05$var$tripleEq(a, b) {
    return a === b;
}
var $874a87fa87407f05$var$TrackingCache = /*#__PURE__*/ function() {
    "use strict";
    function TrackingCache(fn) {
        (0, $bB0zn._)(this, TrackingCache);
        $874a87fa87407f05$var$__publicField(this, "_cachedValue");
        $874a87fa87407f05$var$__publicField(this, "_cachedRevision", -1);
        $874a87fa87407f05$var$__publicField(this, "_deps", []);
        $874a87fa87407f05$var$__publicField(this, "hits", 0);
        $874a87fa87407f05$var$__publicField(this, "fn");
        this.fn = fn;
    }
    (0, $6QEWP._)(TrackingCache, [
        {
            key: "clear",
            value: function clear() {
                this._cachedValue = void 0;
                this._cachedRevision = -1;
                this._deps = [];
                this.hits = 0;
            }
        },
        {
            key: "value",
            get: function get() {
                if (this.revision > this._cachedRevision) {
                    var fn = this.fn;
                    var currentTracker = /* @__PURE__ */ new Set();
                    var prevTracker = $874a87fa87407f05$var$CURRENT_TRACKER;
                    $874a87fa87407f05$var$CURRENT_TRACKER = currentTracker;
                    this._cachedValue = fn();
                    $874a87fa87407f05$var$CURRENT_TRACKER = prevTracker;
                    this.hits++;
                    this._deps = Array.from(currentTracker);
                    this._cachedRevision = this.revision;
                }
                $874a87fa87407f05$var$CURRENT_TRACKER == null || $874a87fa87407f05$var$CURRENT_TRACKER.add(this);
                return this._cachedValue;
            }
        },
        {
            key: "revision",
            get: function get() {
                var _Math;
                return (_Math = Math).max.apply(_Math, (0, $2Xzd1._)(this._deps.map(function(d) {
                    return d.revision;
                })).concat([
                    0
                ]));
            }
        }
    ]);
    return TrackingCache;
}();
function $874a87fa87407f05$var$getValue(cell) {
    if (!(cell instanceof $874a87fa87407f05$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $874a87fa87407f05$var$setValue(storage, value) {
    if (!(storage instanceof $874a87fa87407f05$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $874a87fa87407f05$var$createCell(initialValue) {
    var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $874a87fa87407f05$var$tripleEq;
    return new $874a87fa87407f05$var$Cell(initialValue, isEqual);
}
function $874a87fa87407f05$var$createCache(fn) {
    $874a87fa87407f05$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $874a87fa87407f05$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $874a87fa87407f05$var$neverEq = function(a, b) {
    return false;
};
function $874a87fa87407f05$var$createTag() {
    return $874a87fa87407f05$var$createCell(null, $874a87fa87407f05$var$neverEq);
}
function $874a87fa87407f05$var$dirtyTag(tag, value) {
    $874a87fa87407f05$var$setValue(tag, value);
}
var $874a87fa87407f05$var$consumeCollection = function(node) {
    var tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $874a87fa87407f05$var$createTag();
    $874a87fa87407f05$var$getValue(tag);
};
var $874a87fa87407f05$var$dirtyCollection = function(node) {
    var tag = node.collectionTag;
    if (tag !== null) $874a87fa87407f05$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $874a87fa87407f05$var$REDUX_PROXY_LABEL = Symbol();
var $874a87fa87407f05$var$nextId = 0;
var $874a87fa87407f05$var$proto = Object.getPrototypeOf({});
var $874a87fa87407f05$var$ObjectTreeNode = function ObjectTreeNode(value) {
    "use strict";
    (0, $bB0zn._)(this, ObjectTreeNode);
    this.value = value;
    $874a87fa87407f05$var$__publicField(this, "proxy", new Proxy(this, $874a87fa87407f05$var$objectProxyHandler));
    $874a87fa87407f05$var$__publicField(this, "tag", $874a87fa87407f05$var$createTag());
    $874a87fa87407f05$var$__publicField(this, "tags", {});
    $874a87fa87407f05$var$__publicField(this, "children", {});
    $874a87fa87407f05$var$__publicField(this, "collectionTag", null);
    $874a87fa87407f05$var$__publicField(this, "id", $874a87fa87407f05$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $874a87fa87407f05$var$objectProxyHandler = {
    get: function(node, key) {
        function calculateResult() {
            var value = node.value;
            var childValue = Reflect.get(value, key);
            if ((typeof key === "undefined" ? "undefined" : (0, $YtE9h._)(key)) === "symbol") return childValue;
            if (key in $874a87fa87407f05$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                var childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $874a87fa87407f05$var$createNode(childValue);
                if (childNode.tag) $874a87fa87407f05$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                var tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $874a87fa87407f05$var$createTag();
                    tag.value = childValue;
                }
                $874a87fa87407f05$var$getValue(tag);
                return childValue;
            }
        }
        var res = calculateResult();
        return res;
    },
    ownKeys: function(node) {
        $874a87fa87407f05$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor: function(node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has: function(node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $874a87fa87407f05$var$ArrayTreeNode = function ArrayTreeNode(value) {
    "use strict";
    (0, $bB0zn._)(this, ArrayTreeNode);
    this.value = value;
    $874a87fa87407f05$var$__publicField(this, "proxy", new Proxy([
        this
    ], $874a87fa87407f05$var$arrayProxyHandler));
    $874a87fa87407f05$var$__publicField(this, "tag", $874a87fa87407f05$var$createTag());
    $874a87fa87407f05$var$__publicField(this, "tags", {});
    $874a87fa87407f05$var$__publicField(this, "children", {});
    $874a87fa87407f05$var$__publicField(this, "collectionTag", null);
    $874a87fa87407f05$var$__publicField(this, "id", $874a87fa87407f05$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $874a87fa87407f05$var$arrayProxyHandler = {
    get: function(param, key) {
        var _param = (0, $kB67t._)(param, 1), node = _param[0];
        if (key === "length") $874a87fa87407f05$var$consumeCollection(node);
        return $874a87fa87407f05$var$objectProxyHandler.get(node, key);
    },
    ownKeys: function(param) {
        var _param = (0, $kB67t._)(param, 1), node = _param[0];
        return $874a87fa87407f05$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor: function(param, prop) {
        var _param = (0, $kB67t._)(param, 1), node = _param[0];
        return $874a87fa87407f05$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has: function(param, prop) {
        var _param = (0, $kB67t._)(param, 1), node = _param[0];
        return $874a87fa87407f05$var$objectProxyHandler.has(node, prop);
    }
};
function $874a87fa87407f05$var$createNode(value) {
    if (Array.isArray(value)) return new $874a87fa87407f05$var$ArrayTreeNode(value);
    return new $874a87fa87407f05$var$ObjectTreeNode(value);
}
function $874a87fa87407f05$var$updateNode(node, newValue) {
    var value = node.value, tags = node.tags, children = node.children;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $874a87fa87407f05$var$dirtyCollection(node);
    else if (value !== newValue) {
        var oldKeysSize = 0;
        var newKeysSize = 0;
        var anyKeysAdded = false;
        for(var _key in value)oldKeysSize++;
        for(var key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        var isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $874a87fa87407f05$var$dirtyCollection(node);
    }
    for(var key1 in tags){
        var childValue = value[key1];
        var newChildValue = newValue[key1];
        if (childValue !== newChildValue) {
            $874a87fa87407f05$var$dirtyCollection(node);
            $874a87fa87407f05$var$dirtyTag(tags[key1], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key1];
    }
    for(var key2 in children){
        var childNode = children[key2];
        var newChildValue1 = newValue[key2];
        var childValue1 = childNode.value;
        if (childValue1 === newChildValue1) continue;
        else if (typeof newChildValue1 === "object" && newChildValue1 !== null) $874a87fa87407f05$var$updateNode(childNode, newChildValue1);
        else {
            $874a87fa87407f05$var$deleteNode(childNode);
            delete children[key2];
        }
    }
}
function $874a87fa87407f05$var$deleteNode(node) {
    if (node.tag) $874a87fa87407f05$var$dirtyTag(node.tag, null);
    $874a87fa87407f05$var$dirtyCollection(node);
    for(var key in node.tags)$874a87fa87407f05$var$dirtyTag(node.tags[key], null);
    for(var key1 in node.children)$874a87fa87407f05$var$deleteNode(node.children[key1]);
}
// src/lruMemoize.ts
function $874a87fa87407f05$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $874a87fa87407f05$var$NOT_FOUND;
        },
        put: function(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function() {
            entry = void 0;
        }
    };
}
function $874a87fa87407f05$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        });
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $874a87fa87407f05$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $874a87fa87407f05$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $874a87fa87407f05$export$3f025202a230c6dd = function(a, b) {
    return a === b;
};
function $874a87fa87407f05$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $874a87fa87407f05$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions_equalityCheck = providedOptions.equalityCheck, equalityCheck = _providedOptions_equalityCheck === void 0 ? $874a87fa87407f05$export$3f025202a230c6dd : _providedOptions_equalityCheck, _providedOptions_maxSize = providedOptions.maxSize, maxSize = _providedOptions_maxSize === void 0 ? 1 : _providedOptions_maxSize, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $874a87fa87407f05$var$createCacheKeyComparator(equalityCheck);
    var resultsCount = 0;
    var cache = maxSize === 1 ? $874a87fa87407f05$var$createSingletonCache(comparator) : $874a87fa87407f05$var$createLruCache(maxSize, comparator);
    function memoized() {
        var value = cache.get(arguments);
        if (value === $874a87fa87407f05$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $874a87fa87407f05$export$c8f9cf88d9fdee55(func) {
    var node = $874a87fa87407f05$var$createNode([]);
    var lastArgs = null;
    var shallowEqual = $874a87fa87407f05$var$createCacheKeyComparator($874a87fa87407f05$export$3f025202a230c6dd);
    var cache = $874a87fa87407f05$var$createCache(function() {
        var res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $874a87fa87407f05$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $874a87fa87407f05$var$StrongRef = /*#__PURE__*/ function() {
    "use strict";
    function StrongRef(value) {
        (0, $bB0zn._)(this, StrongRef);
        this.value = value;
    }
    (0, $6QEWP._)(StrongRef, [
        {
            key: "deref",
            value: function deref() {
                return this.value;
            }
        }
    ]);
    return StrongRef;
}();
var $874a87fa87407f05$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $874a87fa87407f05$var$StrongRef;
var $874a87fa87407f05$var$UNTERMINATED = 0;
var $874a87fa87407f05$var$TERMINATED = 1;
function $874a87fa87407f05$var$createCacheNode() {
    return {
        s: $874a87fa87407f05$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $874a87fa87407f05$export$8402dc26d96f6902(func) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var fnNode = $874a87fa87407f05$var$createCacheNode();
    var resultEqualityCheck = options.resultEqualityCheck;
    var lastResult;
    var resultsCount = 0;
    function memoized() {
        var _a, _b;
        var cacheNode = fnNode;
        var length = arguments.length;
        for(var i = 0, l = length; i < l; i++){
            var arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                var objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                var objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $874a87fa87407f05$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                var primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                var primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $874a87fa87407f05$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        var terminatedNode = cacheNode;
        var result;
        if (cacheNode.s === $874a87fa87407f05$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
        }
        terminatedNode.s = $874a87fa87407f05$var$TERMINATED;
        if (resultEqualityCheck) {
            var lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            var needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? new $874a87fa87407f05$var$Ref(result) : result;
        }
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = function() {
        fnNode = $874a87fa87407f05$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $874a87fa87407f05$export$5943f4447f6ef248(memoizeOrOptions) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    }
    var createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    var createSelector2 = function() {
        for(var _len = arguments.length, createSelectorArgs = new Array(_len), _key = 0; _key < _len; _key++){
            createSelectorArgs[_key] = arguments[_key];
        }
        var recomputations = 0;
        var dependencyRecomputations = 0;
        var lastResult;
        var directlyPassedOptions = {};
        var resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $874a87fa87407f05$var$assertIsFunction(resultFunc, "createSelector expects an output function after the inputs, but received: [".concat(typeof resultFunc === "undefined" ? "undefined" : (0, $YtE9h._)(resultFunc), "]"));
        var combinedOptions = $874a87fa87407f05$var$__spreadValues($874a87fa87407f05$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        var memoize = combinedOptions.memoize, _combinedOptions_memoizeOptions = combinedOptions.memoizeOptions, memoizeOptions = _combinedOptions_memoizeOptions === void 0 ? [] : _combinedOptions_memoizeOptions, _combinedOptions_argsMemoize = combinedOptions.argsMemoize, argsMemoize = _combinedOptions_argsMemoize === void 0 ? $874a87fa87407f05$export$8402dc26d96f6902 : _combinedOptions_argsMemoize, _combinedOptions_argsMemoizeOptions = combinedOptions.argsMemoizeOptions, argsMemoizeOptions = _combinedOptions_argsMemoizeOptions === void 0 ? [] : _combinedOptions_argsMemoizeOptions, _combinedOptions_devModeChecks = combinedOptions.devModeChecks, devModeChecks = _combinedOptions_devModeChecks === void 0 ? {} : _combinedOptions_devModeChecks;
        var finalMemoizeOptions = $874a87fa87407f05$var$ensureIsArray(memoizeOptions);
        var finalArgsMemoizeOptions = $874a87fa87407f05$var$ensureIsArray(argsMemoizeOptions);
        var dependencies = $874a87fa87407f05$var$getDependencies(createSelectorArgs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                recomputations++;
                return resultFunc.apply(null, arguments);
            }
        ].concat((0, $2Xzd1._)(finalMemoizeOptions)));
        var firstRun = true;
        var selector = argsMemoize.apply(void 0, [
            function dependenciesChecker() {
                dependencyRecomputations++;
                var inputSelectorResults = $874a87fa87407f05$var$collectInputSelectorResults(dependencies, arguments);
                lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
                return lastResult;
            }
        ].concat((0, $2Xzd1._)(finalArgsMemoizeOptions)));
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: function() {
                return dependencyRecomputations;
            },
            resetDependencyRecomputations: function() {
                dependencyRecomputations = 0;
            },
            lastResult: function() {
                return lastResult;
            },
            recomputations: function() {
                return recomputations;
            },
            resetRecomputations: function() {
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: function() {
            return createSelector2;
        }
    });
    return createSelector2;
}
var $874a87fa87407f05$export$595d22ed68ca2841 = /* @__PURE__ */ $874a87fa87407f05$export$5943f4447f6ef248($874a87fa87407f05$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $874a87fa87407f05$export$75979cfcd91bf38f = Object.assign(function(inputSelectorsObject) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $874a87fa87407f05$export$595d22ed68ca2841;
    $874a87fa87407f05$var$assertIsObject(inputSelectorsObject, "createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ".concat(typeof inputSelectorsObject === "undefined" ? "undefined" : (0, $YtE9h._)(inputSelectorsObject)));
    var inputSelectorKeys = Object.keys(inputSelectorsObject);
    var dependencies = inputSelectorKeys.map(function(key) {
        return inputSelectorsObject[key];
    });
    var structuredSelector = selectorCreator(dependencies, function() {
        for(var _len = arguments.length, inputSelectorResults = new Array(_len), _key = 0; _key < _len; _key++){
            inputSelectorResults[_key] = arguments[_key];
        }
        return inputSelectorResults.reduce(function(composition, value, index) {
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: function() {
        return $874a87fa87407f05$export$75979cfcd91bf38f;
    }
});


// src/index.ts
function $2193944b4716daad$var$createThunkMiddleware(extraArgument) {
    var middleware = function(param) {
        var dispatch = param.dispatch, getState = param.getState;
        return function(next) {
            return function(action) {
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
        };
    };
    return middleware;
}
var $2193944b4716daad$export$dd164f5517779f15 = $2193944b4716daad$var$createThunkMiddleware();
var $2193944b4716daad$export$16d06542a1949d9e = $2193944b4716daad$var$createThunkMiddleware;


var $d3e3033a14238d9e$exports = {};
// shim for using process in browser
var $d3e3033a14238d9e$var$process = $d3e3033a14238d9e$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3e3033a14238d9e$var$cachedSetTimeout;
var $d3e3033a14238d9e$var$cachedClearTimeout;
function $d3e3033a14238d9e$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $d3e3033a14238d9e$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $d3e3033a14238d9e$var$cachedSetTimeout = setTimeout;
        else $d3e3033a14238d9e$var$cachedSetTimeout = $d3e3033a14238d9e$var$defaultSetTimout;
    } catch (e) {
        $d3e3033a14238d9e$var$cachedSetTimeout = $d3e3033a14238d9e$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $d3e3033a14238d9e$var$cachedClearTimeout = clearTimeout;
        else $d3e3033a14238d9e$var$cachedClearTimeout = $d3e3033a14238d9e$var$defaultClearTimeout;
    } catch (e) {
        $d3e3033a14238d9e$var$cachedClearTimeout = $d3e3033a14238d9e$var$defaultClearTimeout;
    }
})();
function $d3e3033a14238d9e$var$runTimeout(fun) {
    if ($d3e3033a14238d9e$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3e3033a14238d9e$var$cachedSetTimeout === $d3e3033a14238d9e$var$defaultSetTimout || !$d3e3033a14238d9e$var$cachedSetTimeout) && setTimeout) {
        $d3e3033a14238d9e$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3e3033a14238d9e$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3e3033a14238d9e$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3e3033a14238d9e$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3e3033a14238d9e$var$runClearTimeout(marker) {
    if ($d3e3033a14238d9e$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3e3033a14238d9e$var$cachedClearTimeout === $d3e3033a14238d9e$var$defaultClearTimeout || !$d3e3033a14238d9e$var$cachedClearTimeout) && clearTimeout) {
        $d3e3033a14238d9e$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3e3033a14238d9e$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3e3033a14238d9e$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3e3033a14238d9e$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3e3033a14238d9e$var$queue = [];
var $d3e3033a14238d9e$var$draining = false;
var $d3e3033a14238d9e$var$currentQueue;
var $d3e3033a14238d9e$var$queueIndex = -1;
function $d3e3033a14238d9e$var$cleanUpNextTick() {
    if (!$d3e3033a14238d9e$var$draining || !$d3e3033a14238d9e$var$currentQueue) return;
    $d3e3033a14238d9e$var$draining = false;
    if ($d3e3033a14238d9e$var$currentQueue.length) $d3e3033a14238d9e$var$queue = $d3e3033a14238d9e$var$currentQueue.concat($d3e3033a14238d9e$var$queue);
    else $d3e3033a14238d9e$var$queueIndex = -1;
    if ($d3e3033a14238d9e$var$queue.length) $d3e3033a14238d9e$var$drainQueue();
}
function $d3e3033a14238d9e$var$drainQueue() {
    if ($d3e3033a14238d9e$var$draining) return;
    var timeout = $d3e3033a14238d9e$var$runTimeout($d3e3033a14238d9e$var$cleanUpNextTick);
    $d3e3033a14238d9e$var$draining = true;
    var len = $d3e3033a14238d9e$var$queue.length;
    while(len){
        $d3e3033a14238d9e$var$currentQueue = $d3e3033a14238d9e$var$queue;
        $d3e3033a14238d9e$var$queue = [];
        while(++$d3e3033a14238d9e$var$queueIndex < len)if ($d3e3033a14238d9e$var$currentQueue) $d3e3033a14238d9e$var$currentQueue[$d3e3033a14238d9e$var$queueIndex].run();
        $d3e3033a14238d9e$var$queueIndex = -1;
        len = $d3e3033a14238d9e$var$queue.length;
    }
    $d3e3033a14238d9e$var$currentQueue = null;
    $d3e3033a14238d9e$var$draining = false;
    $d3e3033a14238d9e$var$runClearTimeout(timeout);
}
$d3e3033a14238d9e$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3e3033a14238d9e$var$queue.push(new $d3e3033a14238d9e$var$Item(fun, args));
    if ($d3e3033a14238d9e$var$queue.length === 1 && !$d3e3033a14238d9e$var$draining) $d3e3033a14238d9e$var$runTimeout($d3e3033a14238d9e$var$drainQueue);
};
// v8 likes predictible objects
function $d3e3033a14238d9e$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3e3033a14238d9e$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3e3033a14238d9e$var$process.title = "browser";
$d3e3033a14238d9e$var$process.browser = true;
$d3e3033a14238d9e$var$process.env = {};
$d3e3033a14238d9e$var$process.argv = [];
$d3e3033a14238d9e$var$process.version = ""; // empty string to avoid regexp issues
$d3e3033a14238d9e$var$process.versions = {};
function $d3e3033a14238d9e$var$noop() {}
$d3e3033a14238d9e$var$process.on = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.addListener = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.once = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.off = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.removeListener = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.removeAllListeners = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.emit = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.prependListener = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.prependOnceListener = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.listeners = function(name) {
    return [];
};
$d3e3033a14238d9e$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$d3e3033a14238d9e$var$process.cwd = function() {
    return "/";
};
$d3e3033a14238d9e$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$d3e3033a14238d9e$var$process.umask = function() {
    return 0;
};


var $44e97ff44f917989$var$__defProp = Object.defineProperty;
var $44e97ff44f917989$var$__defProps = Object.defineProperties;
var $44e97ff44f917989$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $44e97ff44f917989$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $44e97ff44f917989$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $44e97ff44f917989$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $44e97ff44f917989$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $44e97ff44f917989$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $44e97ff44f917989$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($44e97ff44f917989$var$__hasOwnProp.call(b, prop)) $44e97ff44f917989$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($44e97ff44f917989$var$__getOwnPropSymbols) try {
        for(var _iterator = $44e97ff44f917989$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($44e97ff44f917989$var$__propIsEnum.call(b, prop)) $44e97ff44f917989$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $44e97ff44f917989$var$__spreadProps = function(a, b) {
    return $44e97ff44f917989$var$__defProps(a, $44e97ff44f917989$var$__getOwnPropDescs(b));
};
var $44e97ff44f917989$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($44e97ff44f917989$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $44e97ff44f917989$var$__getOwnPropSymbols) try {
        for(var _iterator = $44e97ff44f917989$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $44e97ff44f917989$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
var $44e97ff44f917989$var$__publicField = function(obj, key, value) {
    $44e97ff44f917989$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $YtE9h._)(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
var $44e97ff44f917989$export$aab6de9e3dbb1473 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var createSelector2 = (0, $874a87fa87407f05$export$5943f4447f6ef248).apply(void 0, (0, $2Xzd1._)(args));
    var createDraftSafeSelector2 = Object.assign(function() {
        for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
            args2[_key] = arguments[_key];
        }
        var selector = createSelector2.apply(void 0, (0, $2Xzd1._)(args2));
        var wrappedSelector = function(value) {
            for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                rest[_key - 1] = arguments[_key];
            }
            return selector.apply(void 0, [
                (0, $5icQr.isDraft)(value) ? (0, $5icQr.current)(value) : value
            ].concat((0, $2Xzd1._)(rest)));
        };
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: function() {
            return createDraftSafeSelector2;
        }
    });
    return createDraftSafeSelector2;
};
var $44e97ff44f917989$export$a5d3c27355e35910 = $44e97ff44f917989$export$aab6de9e3dbb1473((0, $874a87fa87407f05$export$8402dc26d96f6902));
var $44e97ff44f917989$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function composeWithDevTools() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $a039f9c7168ef4c9$export$f672e0b6f7222cd7;
    return (0, $a039f9c7168ef4c9$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $44e97ff44f917989$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function devToolsEnhancer() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $44e97ff44f917989$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $44e97ff44f917989$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, (0, $2Xzd1._)(args));
            if (!prepared) throw new Error($44e97ff44f917989$export$378fa86b259c0280(0));
            return $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "".concat(type);
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return (0, $a039f9c7168ef4c9$export$b956e38827fca970)(action) && action.type === type;
    };
    return actionCreator;
}
function $44e97ff44f917989$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $44e97ff44f917989$var$hasMatchFunction(action);
}
function $44e97ff44f917989$export$ebd532f9034651f3(action) {
    return (0, $a039f9c7168ef4c9$export$b956e38827fca970)(action) && Object.keys(action).every($44e97ff44f917989$var$isValidKey);
}
function $44e97ff44f917989$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $44e97ff44f917989$var$getMessage(type) {
    var splitType = type ? "".concat(type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "'.concat(type || "unknown", "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(").concat(actionName, "())` instead of `dispatch(").concat(actionName, ")`. This is necessary even if the action has no payload.");
}
function $44e97ff44f917989$export$6a1fcb4ceef578f() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $44e97ff44f917989$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn("".concat(fnName, " took ").concat(elapsed, "ms, which is more than the warning threshold of ").concat(maxDelay, "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that."));
        }
    };
}
function $44e97ff44f917989$var$find(iterable, comparator) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = iterable[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            if (comparator(entry)) return entry;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return void 0;
}
var $44e97ff44f917989$export$1908877435b1d5e9 = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $5dLwP._)(_Tuple, Array1);
    var _super = (0, $lMNAp._)(_Tuple);
    function _Tuple() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        (0, $bB0zn._)(this, _Tuple);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, $2Xzd1._)(items)));
        Object.setPrototypeOf((0, $fWfWu._)(_this), _Tuple.prototype);
        return _this;
    }
    (0, $6QEWP._)(_Tuple, [
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                return (0, $04ca9dac0ceac2e2$export$afb3516d9d608401)((0, $ZhYhU._)(_Tuple.prototype), "concat", this).apply(this, arr);
            }
        },
        {
            key: "prepend",
            value: function prepend() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                if (arr.length === 1 && Array.isArray(arr[0])) return (0, $f5KHm._)(_Tuple, (0, $2Xzd1._)(arr[0].concat(this)));
                return (0, $f5KHm._)(_Tuple, (0, $2Xzd1._)(arr.concat(this)));
            }
        }
    ], [
        {
            key: Symbol.species,
            get: function get() {
                return _Tuple;
            }
        }
    ]);
    return _Tuple;
}((0, $fPaN7._)(Array));
function $44e97ff44f917989$var$freezeDraftable(val) {
    return (0, $5icQr.isDraftable)(val) ? (0, $5icQr.produce)(val, function() {}) : val;
}
function $44e97ff44f917989$var$emplace(map, key, handler) {
    if (map.has(key)) {
        var value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($44e97ff44f917989$export$378fa86b259c0280(10));
    var inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $44e97ff44f917989$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $44e97ff44f917989$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $44e97ff44f917989$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $44e97ff44f917989$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $44e97ff44f917989$var$trackProperties(isImmutable) {
    var ignorePaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], obj = arguments.length > 2 ? arguments[2] : void 0, path = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", checkedObjects = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : /* @__PURE__ */ new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $44e97ff44f917989$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $44e97ff44f917989$var$detectMutations(isImmutable) {
    var _loop = function(key2) {
        var nestedPath = path ? path + "." + key2 : key2;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $44e97ff44f917989$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key2], obj[key2], sameRef, nestedPath);
        if (result.wasMutated) return {
            v: result
        };
    };
    var ignoredPaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], trackedProperty = arguments.length > 2 ? arguments[2] : void 0, obj = arguments.length > 3 ? arguments[3] : void 0, sameParentRef = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, path = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key1 in obj)keysToDetect[key1] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for(var key2 in keysToDetect){
        var _ret = _loop(key2);
        if ((0, $YtE9h._)(_ret) === "object") return _ret.v;
    }
    return {
        wasMutated: false
    };
}
function $44e97ff44f917989$export$9181bb1a5474289() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var stringify, getSerialize, getState, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $44e97ff44f917989$export$77670485918dab4e(val) {
    var type = typeof val === "undefined" ? "undefined" : (0, $YtE9h._)(val);
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $a039f9c7168ef4c9$export$53b83ca8eaab0383)(val);
}
function $44e97ff44f917989$export$ada5dca0b571bc7(value) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", isSerializable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $44e97ff44f917989$export$77670485918dab4e, getEntries = arguments.length > 3 ? arguments[3] : void 0, ignoredPaths = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], cache = arguments.length > 5 ? arguments[5] : void 0;
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], nestedValue = _step_value[1];
            var nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                var hasMatches = ignoredPaths.some(function(ignored) {
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) return "continue";
            }
            if (!isSerializable(nestedValue)) return {
                v: {
                    keyPath: nestedPath,
                    value: nestedValue
                }
            };
            if (typeof nestedValue === "object") {
                foundNestedSerializable = $44e97ff44f917989$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
                if (foundNestedSerializable) return {
                    v: foundNestedSerializable
                };
            }
        };
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, $YtE9h._)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (cache && $44e97ff44f917989$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $44e97ff44f917989$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var nestedValue = _step.value;
            if (typeof nestedValue !== "object" || nestedValue === null) continue;
            if (!$44e97ff44f917989$var$isNestedFrozen(nestedValue)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $44e97ff44f917989$export$6dea1aad6dac5ac2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var storeAPI, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $44e97ff44f917989$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $44e97ff44f917989$var$buildGetDefaultMiddleware = function() {
    return function getDefaultMiddleware(options) {
        var _ref = options != null ? options : {}, _ref_thunk = _ref.thunk, thunk = _ref_thunk === void 0 ? true : _ref_thunk, _ref_immutableCheck = _ref.immutableCheck, immutableCheck = _ref_immutableCheck === void 0 ? true : _ref_immutableCheck, _ref_serializableCheck = _ref.serializableCheck, serializableCheck = _ref_serializableCheck === void 0 ? true : _ref_serializableCheck, _ref_actionCreatorCheck = _ref.actionCreatorCheck, actionCreatorCheck = _ref_actionCreatorCheck === void 0 ? true : _ref_actionCreatorCheck;
        var middlewareArray = new $44e97ff44f917989$export$1908877435b1d5e9();
        if (thunk) {
            if ($44e97ff44f917989$var$isBoolean(thunk)) middlewareArray.push((0, $2193944b4716daad$export$dd164f5517779f15));
            else middlewareArray.push((0, $2193944b4716daad$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
};
// src/autoBatchEnhancer.ts
var $44e97ff44f917989$export$8fb31c0f05df007b = "RTK_autoBatch";
var $44e97ff44f917989$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        return {
            payload: payload,
            meta: (0, $hD5pT._)({}, $44e97ff44f917989$export$8fb31c0f05df007b, true)
        };
    };
};
var $44e97ff44f917989$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $44e97ff44f917989$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $44e97ff44f917989$var$createQueueWithTimer(10);
var $44e97ff44f917989$export$676277d7dca0f396 = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        type: "raf"
    };
    return function(next) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var store = next.apply(void 0, (0, $2Xzd1._)(args));
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = /* @__PURE__ */ new Set();
            var queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $44e97ff44f917989$var$rAF : options.type === "callback" ? options.queueNotification : $44e97ff44f917989$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$44e97ff44f917989$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/getDefaultEnhancers.ts
var $44e97ff44f917989$var$buildGetDefaultEnhancers = function(middlewareEnhancer) {
    return function getDefaultEnhancers(options) {
        var _ref = options != null ? options : {}, _ref_autoBatch = _ref.autoBatch, autoBatch = _ref_autoBatch === void 0 ? true : _ref_autoBatch;
        var enhancerArray = new $44e97ff44f917989$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($44e97ff44f917989$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
};
// src/configureStore.ts
var $44e97ff44f917989$var$IS_PRODUCTION = true;
function $44e97ff44f917989$export$7d8a5b498da695ac(options) {
    var getDefaultMiddleware = $44e97ff44f917989$var$buildGetDefaultMiddleware();
    var _ref = options || {}, reducer = _ref.reducer, middleware = _ref.middleware, _ref_devTools = _ref.devTools, devTools = _ref_devTools === void 0 ? true : _ref_devTools, preloadedState = _ref.preloadedState, enhancers = _ref.enhancers;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $a039f9c7168ef4c9$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $a039f9c7168ef4c9$export$66e4520cdb265d18)(reducer);
    else throw new Error($44e97ff44f917989$export$378fa86b259c0280(1));
    if (!$44e97ff44f917989$var$IS_PRODUCTION && middleware && typeof middleware !== "function") throw new Error($44e97ff44f917989$export$378fa86b259c0280(2));
    var finalMiddleware;
    if (typeof middleware === "function") {
        finalMiddleware = middleware(getDefaultMiddleware);
        if (!$44e97ff44f917989$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error($44e97ff44f917989$export$378fa86b259c0280(3));
    } else finalMiddleware = getDefaultMiddleware();
    if (!$44e97ff44f917989$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error($44e97ff44f917989$export$378fa86b259c0280(4));
    var finalCompose = (0, $a039f9c7168ef4c9$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $44e97ff44f917989$var$composeWithDevTools($44e97ff44f917989$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: !$44e97ff44f917989$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var middlewareEnhancer = (0, $a039f9c7168ef4c9$export$9ff26e0402cc7b7).apply(void 0, (0, $2Xzd1._)(finalMiddleware));
    var getDefaultEnhancers = $44e97ff44f917989$var$buildGetDefaultEnhancers(middlewareEnhancer);
    if (!$44e97ff44f917989$var$IS_PRODUCTION && enhancers && typeof enhancers !== "function") throw new Error($44e97ff44f917989$export$378fa86b259c0280(5));
    var storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    if (!$44e97ff44f917989$var$IS_PRODUCTION && !Array.isArray(storeEnhancers)) throw new Error($44e97ff44f917989$export$378fa86b259c0280(6));
    if (!$44e97ff44f917989$var$IS_PRODUCTION && storeEnhancers.some(function(item) {
        return typeof item !== "function";
    })) throw new Error($44e97ff44f917989$export$378fa86b259c0280(7));
    if (!$44e97ff44f917989$var$IS_PRODUCTION && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
    var composedEnhancer = finalCompose.apply(void 0, (0, $2Xzd1._)(storeEnhancers));
    return (0, $a039f9c7168ef4c9$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $44e97ff44f917989$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($44e97ff44f917989$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($44e97ff44f917989$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $44e97ff44f917989$var$isStateFunction(x) {
    return typeof x === "function";
}
function $44e97ff44f917989$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    var _executeReducerBuilderCallback = (0, $kB67t._)($44e97ff44f917989$var$executeReducerBuilderCallback(mapOrBuilderCallback), 3), actionsMap = _executeReducerBuilderCallback[0], finalActionMatchers = _executeReducerBuilderCallback[1], finalDefaultCaseReducer = _executeReducerBuilderCallback[2];
    var getInitialState;
    if ($44e97ff44f917989$var$isStateFunction(initialState)) getInitialState = function() {
        return $44e97ff44f917989$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState = $44e97ff44f917989$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState;
        };
    }
    function reducer() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getInitialState(), action = arguments.length > 1 ? arguments[1] : void 0;
        var caseReducers = [
            actionsMap[action.type]
        ].concat((0, $2Xzd1._)(finalActionMatchers.filter(function(param) {
            var matcher = param.matcher;
            return matcher(action);
        }).map(function(param) {
            var reducer2 = param.reducer;
            return reducer2;
        })));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $5icQr.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $5icQr.isDraftable)(previousState)) {
                    var result1 = caseReducer(previousState, action);
                    if (result1 === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($44e97ff44f917989$export$378fa86b259c0280(9));
                    }
                    return result1;
                } else return (0, $5icQr.produce)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/nanoid.ts
var $44e97ff44f917989$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $44e97ff44f917989$export$ac4959f4f1338dfc = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    var id = "";
    var i = size;
    while(i--)id += $44e97ff44f917989$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/matchers.ts
var $44e97ff44f917989$var$matches = function(matcher, action) {
    if ($44e97ff44f917989$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $44e97ff44f917989$export$2c3435c7647f7b0d() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.some(function(matcher) {
            return $44e97ff44f917989$var$matches(matcher, action);
        });
    };
}
function $44e97ff44f917989$export$9dd1fb32974da385() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.every(function(matcher) {
            return $44e97ff44f917989$var$matches(matcher, action);
        });
    };
}
function $44e97ff44f917989$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $44e97ff44f917989$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $44e97ff44f917989$export$872dec21e9a69476() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $44e97ff44f917989$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $44e97ff44f917989$export$2c3435c7647f7b0d.apply(void 0, (0, $2Xzd1._)(matchers));
        return combinedMatcher(action);
    };
}
function $44e97ff44f917989$export$a5c5d27e3994c5be() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $44e97ff44f917989$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $44e97ff44f917989$export$2c3435c7647f7b0d.apply(void 0, (0, $2Xzd1._)(matchers));
        return combinedMatcher(action);
    };
}
function $44e97ff44f917989$export$fcc3388fb56de601() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $44e97ff44f917989$export$9dd1fb32974da385($44e97ff44f917989$export$a5c5d27e3994c5be.apply(void 0, (0, $2Xzd1._)(asyncThunks)), hasFlag);
        return combinedMatcher(action);
    };
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $44e97ff44f917989$export$9dd1fb32974da385($44e97ff44f917989$export$a5c5d27e3994c5be.apply(void 0, (0, $2Xzd1._)(asyncThunks)), hasFlag);
        return combinedMatcher(action);
    };
}
function $44e97ff44f917989$export$1da80a6ef1307441() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $44e97ff44f917989$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $44e97ff44f917989$export$2c3435c7647f7b0d.apply(void 0, (0, $2Xzd1._)(matchers));
        return combinedMatcher(action);
    };
}
function $44e97ff44f917989$export$6aa4142d99c1abce() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $44e97ff44f917989$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = asyncThunks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var asyncThunk = _step.value;
                matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var combinedMatcher = $44e97ff44f917989$export$2c3435c7647f7b0d.apply(void 0, (0, $2Xzd1._)(matchers));
        return combinedMatcher(action);
    };
}
// src/createAsyncThunk.ts
var $44e97ff44f917989$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $44e97ff44f917989$var$RejectWithValue = function RejectWithValue(payload, meta) {
    "use strict";
    (0, $bB0zn._)(this, RejectWithValue);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $44e97ff44f917989$var$__publicField(this, "_type");
};
var $44e97ff44f917989$var$FulfillWithMeta = function FulfillWithMeta(payload, meta) {
    "use strict";
    (0, $bB0zn._)(this, FulfillWithMeta);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $44e97ff44f917989$var$__publicField(this, "_type");
};
var $44e97ff44f917989$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $44e97ff44f917989$var$commonProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var property = _step.value;
                if (typeof value[property] === "string") simpleError[property] = value[property];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $44e97ff44f917989$export$6abd22dc03e5063f = /* @__PURE__ */ function() {
    var createAsyncThunk2 = function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $44e97ff44f917989$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $44e97ff44f917989$var$__spreadProps($44e97ff44f917989$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $44e97ff44f917989$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $44e97ff44f917989$var$__spreadProps($44e97ff44f917989$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $44e97ff44f917989$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $44e97ff44f917989$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $44e97ff44f917989$var$__spreadProps($44e97ff44f917989$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var abort = function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                };
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $44e97ff44f917989$export$ac4959f4f1338dfc();
                var abortController = new AbortController();
                var abortHandler;
                var abortReason;
                var promise = (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function() {
                    var _a, _b, finalAction, conditionResult, abortedPromise, err, skipDispatch;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    5,
                                    6
                                ]);
                                conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                    getState: getState,
                                    extra: extra
                                });
                                if (!$44e97ff44f917989$var$isThenable(conditionResult)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    conditionResult
                                ];
                            case 1:
                                conditionResult = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (conditionResult === false || abortController.signal.aborted) throw {
                                    name: "ConditionError",
                                    message: "Aborted due to condition callback returning false."
                                };
                                abortedPromise = new Promise(function(_, reject) {
                                    abortHandler = function() {
                                        reject({
                                            name: "AbortError",
                                            message: abortReason || "Aborted"
                                        });
                                    };
                                    abortController.signal.addEventListener("abort", abortHandler);
                                });
                                dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                    requestId: requestId,
                                    arg: arg
                                }, {
                                    getState: getState,
                                    extra: extra
                                })));
                                return [
                                    4,
                                    Promise.race([
                                        abortedPromise,
                                        Promise.resolve(payloadCreator(arg, {
                                            dispatch: dispatch,
                                            getState: getState,
                                            extra: extra,
                                            requestId: requestId,
                                            signal: abortController.signal,
                                            abort: abort,
                                            rejectWithValue: function(value, meta) {
                                                return new $44e97ff44f917989$var$RejectWithValue(value, meta);
                                            },
                                            fulfillWithValue: function(value, meta) {
                                                return new $44e97ff44f917989$var$FulfillWithMeta(value, meta);
                                            }
                                        })).then(function(result) {
                                            if (result instanceof $44e97ff44f917989$var$RejectWithValue) throw result;
                                            if (result instanceof $44e97ff44f917989$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                            return fulfilled(result, requestId, arg);
                                        })
                                    ])
                                ];
                            case 3:
                                finalAction = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                err = _state.sent();
                                finalAction = err instanceof $44e97ff44f917989$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                                return [
                                    7
                                ];
                            case 6:
                                skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                if (!skipDispatch) dispatch(finalAction);
                                return [
                                    2,
                                    finalAction
                                ];
                        }
                    });
                })();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise.then($44e97ff44f917989$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $44e97ff44f917989$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    };
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $44e97ff44f917989$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $44e97ff44f917989$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $44e97ff44f917989$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $44e97ff44f917989$export$343355ed40c51c46 = (0, $hD5pT._)({}, $44e97ff44f917989$var$asyncThunkSymbol, $44e97ff44f917989$export$6abd22dc03e5063f);
var $44e97ff44f917989$export$23a094319a4b586 = /* @__PURE__ */ function(ReducerType2) {
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
}($44e97ff44f917989$export$23a094319a4b586 || {});
function $44e97ff44f917989$var$getType(slice, actionKey) {
    return "".concat(slice, "/").concat(actionKey);
}
function $44e97ff44f917989$export$affdea4146de9cf5() {
    var creators = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).creators;
    var _a;
    var cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$44e97ff44f917989$var$asyncThunkSymbol];
    return function createSlice2(options) {
        var name = options.name, _options_reducerPath = options.reducerPath, reducerPath = _options_reducerPath === void 0 ? name : _options_reducerPath;
        if (!name) throw new Error($44e97ff44f917989$export$378fa86b259c0280(11));
        typeof $d3e3033a14238d9e$exports === "undefined" ? "undefined" : (0, $YtE9h._)($d3e3033a14238d9e$exports);
        var reducers = (typeof options.reducers === "function" ? options.reducers($44e97ff44f917989$var$buildReducerCreators()) : options.reducers) || {};
        var reducerNames = Object.keys(reducers);
        var context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        var contextMethods = {
            addCase: function(typeOrActionCreator, reducer2) {
                var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($44e97ff44f917989$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($44e97ff44f917989$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher: function(matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction: function(name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer: function(name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach(function(reducerName) {
            var reducerDefinition = reducers[reducerName];
            var reducerDetails = {
                reducerName: reducerName,
                type: $44e97ff44f917989$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($44e97ff44f917989$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $44e97ff44f917989$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $44e97ff44f917989$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            var _ref = (0, $kB67t._)(typeof options.extraReducers === "function" ? $44e97ff44f917989$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ], 3), tmp = _ref[0], extraReducers = tmp === void 0 ? {} : tmp, tmp1 = _ref[1], actionMatchers = tmp1 === void 0 ? [] : tmp1, defaultCaseReducer = _ref[2];
            var finalCaseReducers = $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $44e97ff44f917989$export$473eb76d322d0290(options.initialState, function(builder) {
                for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = context.sliceMatchers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sM = _step.value;
                        builder.addMatcher(sM.matcher, sM.reducer);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = actionMatchers[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var m = _step1.value;
                        builder.addMatcher(m.matcher, m.reducer);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        var selectSelf = function(state) {
            return state;
        };
        var injectedSelectorCache = /* @__PURE__ */ new Map();
        var _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2) {
            var injected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            function selectSlice(state) {
                var sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors() {
                var selectState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : selectSelf;
                var selectorCache = $44e97ff44f917989$var$emplace(injectedSelectorCache, injected, {
                    insert: function() {
                        return /* @__PURE__ */ new WeakMap();
                    }
                });
                return $44e97ff44f917989$var$emplace(selectorCache, selectState, {
                    insert: function() {
                        var _a2;
                        var map = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.entries((_a2 = options.selectors) != null ? _a2 : {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = (0, $kB67t._)(_step.value, 2), name2 = _step_value[0], selector = _step_value[1];
                                map[name2] = $44e97ff44f917989$var$wrapSelector(selector, selectState, getInitialState, injected);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        var slice = $44e97ff44f917989$var$__spreadProps($44e97ff44f917989$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto: function(injectable) {
                var _a2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _b = _a2, pathOpt = _b.reducerPath, config = $44e97ff44f917989$var$__objRest(_b, [
                    "reducerPath"
                ]);
                var newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $44e97ff44f917989$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector.apply(void 0, [
            sliceState
        ].concat((0, $2Xzd1._)(args)));
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $44e97ff44f917989$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $44e97ff44f917989$export$affdea4146de9cf5();
function $44e97ff44f917989$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $44e97ff44f917989$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = function() {
        return asyncThunk;
    };
    return {
        reducer: function(caseReducer) {
            return Object.assign(// hack so the wrapping function has the same name as the original
            // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
            (0, $hD5pT._)({}, caseReducer.name, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return caseReducer.apply(void 0, (0, $2Xzd1._)(args));
            })[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer: function(prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $44e97ff44f917989$var$handleNormalReducerDefinition(param, maybeReducerWithPrepare, context) {
    var type = param.type, reducerName = param.reducerName, createNotation = param.createNotation;
    var caseReducer;
    var prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$44e97ff44f917989$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($44e97ff44f917989$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $44e97ff44f917989$export$309c7a02b0b0bc62(type, prepareCallback) : $44e97ff44f917989$export$309c7a02b0b0bc62(type));
}
function $44e97ff44f917989$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $44e97ff44f917989$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $44e97ff44f917989$var$handleThunkCaseReducerDefinition(param, reducerDefinition, context, cAT) {
    var type = param.type, reducerName = param.reducerName;
    if (!cAT) throw new Error($44e97ff44f917989$export$378fa86b259c0280(18));
    var payloadCreator = reducerDefinition.payloadCreator, fulfilled = reducerDefinition.fulfilled, pending = reducerDefinition.pending, rejected = reducerDefinition.rejected, settled = reducerDefinition.settled, options = reducerDefinition.options;
    var thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $44e97ff44f917989$var$noop,
        pending: pending || $44e97ff44f917989$var$noop,
        rejected: rejected || $44e97ff44f917989$var$noop,
        settled: settled || $44e97ff44f917989$var$noop
    });
}
function $44e97ff44f917989$var$noop() {}
// src/entities/entity_state.ts
function $44e97ff44f917989$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $44e97ff44f917989$var$createInitialStateFactory(stateAdapter) {
    function getInitialState() {
        var additionalState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, entities = arguments.length > 1 ? arguments[1] : void 0;
        var state = Object.assign($44e97ff44f917989$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $44e97ff44f917989$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var tmp = options.createSelector, createSelector2 = tmp === void 0 ? $44e97ff44f917989$export$a5d3c27355e35910 : tmp;
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = createSelector2(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = createSelector2(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $44e97ff44f917989$var$isDraftTyped = (0, $5icQr.isDraft);
function $44e97ff44f917989$var$createSingleArgumentStateOperator(mutator) {
    var operator = $44e97ff44f917989$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $44e97ff44f917989$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $44e97ff44f917989$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($44e97ff44f917989$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $5icQr.produce)(state, runMutator);
    };
}
// src/entities/utils.ts
function $44e97ff44f917989$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $44e97ff44f917989$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $44e97ff44f917989$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entity = _step.value;
            var id = $44e97ff44f917989$var$selectIdValue(entity, selectId);
            if (id in state.entities) updated.push({
                id: id,
                changes: entity
            });
            else added.push(entity);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $44e97ff44f917989$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $44e97ff44f917989$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                addOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setOneMutably(entity, state) {
        var key = $44e97ff44f917989$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                setOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        var updated = Object.assign({}, original3, update.changes);
        var newKey = $44e97ff44f917989$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map(function(e) {
                return $44e97ff44f917989$var$selectIdValue(e, selectId);
            });
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $kB67t._)($44e97ff44f917989$var$splitAddedUpdatedEntities(newEntities, selectId, state), 2), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $44e97ff44f917989$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $44e97ff44f917989$var$createStateOperator(addOneMutably),
        addMany: $44e97ff44f917989$var$createStateOperator(addManyMutably),
        setOne: $44e97ff44f917989$var$createStateOperator(setOneMutably),
        setMany: $44e97ff44f917989$var$createStateOperator(setManyMutably),
        setAll: $44e97ff44f917989$var$createStateOperator(setAllMutably),
        updateOne: $44e97ff44f917989$var$createStateOperator(updateOneMutably),
        updateMany: $44e97ff44f917989$var$createStateOperator(updateManyMutably),
        upsertOne: $44e97ff44f917989$var$createStateOperator(upsertOneMutably),
        upsertMany: $44e97ff44f917989$var$createStateOperator(upsertManyMutably),
        removeOne: $44e97ff44f917989$var$createStateOperator(removeOneMutably),
        removeMany: $44e97ff44f917989$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $44e97ff44f917989$var$createSortedStateAdapter(selectId, sort) {
    var _createUnsortedStateAdapter = $44e97ff44f917989$var$createUnsortedStateAdapter(selectId), removeOne = _createUnsortedStateAdapter.removeOne, removeMany = _createUnsortedStateAdapter.removeMany, removeAll = _createUnsortedStateAdapter.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($44e97ff44f917989$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = updates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var update = _step.value;
                var entity = state.entities[update.id];
                if (!entity) continue;
                appliedUpdates = true;
                Object.assign(entity, update.changes);
                var newId = selectId(entity);
                if (update.id !== newId) {
                    delete state.entities[update.id];
                    state.entities[newId] = entity;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $kB67t._)($44e97ff44f917989$var$splitAddedUpdatedEntities(newEntities, selectId, state), 2), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $44e97ff44f917989$var$createStateOperator(addOneMutably),
        updateOne: $44e97ff44f917989$var$createStateOperator(updateOneMutably),
        upsertOne: $44e97ff44f917989$var$createStateOperator(upsertOneMutably),
        setOne: $44e97ff44f917989$var$createStateOperator(setOneMutably),
        setMany: $44e97ff44f917989$var$createStateOperator(setManyMutably),
        setAll: $44e97ff44f917989$var$createStateOperator(setAllMutably),
        addMany: $44e97ff44f917989$var$createStateOperator(addManyMutably),
        updateMany: $44e97ff44f917989$var$createStateOperator(updateManyMutably),
        upsertMany: $44e97ff44f917989$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $44e97ff44f917989$export$abcf4037b41e0df() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var __spreadValues1 = $44e97ff44f917989$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = __spreadValues1.selectId, sortComparer = __spreadValues1.sortComparer;
    var stateAdapter = sortComparer ? $44e97ff44f917989$var$createSortedStateAdapter(selectId, sortComparer) : $44e97ff44f917989$var$createUnsortedStateAdapter(selectId);
    var stateFactory = $44e97ff44f917989$var$createInitialStateFactory(stateAdapter);
    var selectorsFactory = $44e97ff44f917989$var$createSelectorsFactory();
    return $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $44e97ff44f917989$var$task = "task";
var $44e97ff44f917989$var$listener = "listener";
var $44e97ff44f917989$var$completed = "completed";
var $44e97ff44f917989$var$cancelled = "cancelled";
var $44e97ff44f917989$var$taskCancelled = "task-".concat($44e97ff44f917989$var$cancelled);
var $44e97ff44f917989$var$taskCompleted = "task-".concat($44e97ff44f917989$var$completed);
var $44e97ff44f917989$var$listenerCancelled = "".concat($44e97ff44f917989$var$listener, "-").concat($44e97ff44f917989$var$cancelled);
var $44e97ff44f917989$var$listenerCompleted = "".concat($44e97ff44f917989$var$listener, "-").concat($44e97ff44f917989$var$completed);
var $44e97ff44f917989$export$cb1bdac908fed7f = function TaskAbortError(code) {
    "use strict";
    (0, $bB0zn._)(this, TaskAbortError);
    this.code = code;
    $44e97ff44f917989$var$__publicField(this, "name", "TaskAbortError");
    $44e97ff44f917989$var$__publicField(this, "message");
    this.message = "".concat($44e97ff44f917989$var$task, " ").concat($44e97ff44f917989$var$cancelled, " (reason: ").concat(code, ")");
};
// src/listenerMiddleware/utils.ts
var $44e97ff44f917989$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new Error($44e97ff44f917989$export$378fa86b259c0280(32));
};
var $44e97ff44f917989$var$noop2 = function() {};
var $44e97ff44f917989$var$catchRejection = function(promise) {
    var onError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $44e97ff44f917989$var$noop2;
    promise.catch(onError);
    return promise;
};
var $44e97ff44f917989$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $44e97ff44f917989$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $44e97ff44f917989$var$validateActive = function(signal) {
    if (signal.aborted) {
        var reason = signal.reason;
        throw new $44e97ff44f917989$export$cb1bdac908fed7f(reason);
    }
};
function $44e97ff44f917989$var$raceWithSignal(signal, promise) {
    var cleanup = $44e97ff44f917989$var$noop2;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $44e97ff44f917989$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $44e97ff44f917989$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $44e97ff44f917989$var$noop2;
    });
}
var $44e97ff44f917989$var$runTask = function() {
    var _ref = (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(task2, cleanUp) {
        var value, error;
        return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        Promise.resolve()
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        task2()
                    ];
                case 2:
                    value = _state.sent();
                    return [
                        2,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            status: error instanceof $44e97ff44f917989$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function runTask(task2, cleanUp) {
        return _ref.apply(this, arguments);
    };
}();
var $44e97ff44f917989$var$createPause = function(signal) {
    return function(promise) {
        return $44e97ff44f917989$var$catchRejection($44e97ff44f917989$var$raceWithSignal(signal, promise).then(function(output) {
            $44e97ff44f917989$var$validateActive(signal);
            return output;
        }));
    };
};
var $44e97ff44f917989$var$createDelay = function(signal) {
    var pause = $44e97ff44f917989$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $44e97ff44f917989$var$assign = Object.assign;
var $44e97ff44f917989$var$INTERNAL_NIL_TOKEN = {};
var $44e97ff44f917989$var$alm = "listenerMiddleware";
var $44e97ff44f917989$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $44e97ff44f917989$var$addAbortSignalListener(parentAbortSignal, function() {
            return $44e97ff44f917989$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $44e97ff44f917989$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $44e97ff44f917989$var$runTask(/*#__PURE__*/ (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function() {
            var result2;
            return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $44e97ff44f917989$var$validateActive(parentAbortSignal);
                        $44e97ff44f917989$var$validateActive(childAbortController.signal);
                        return [
                            4,
                            taskExecutor({
                                pause: $44e97ff44f917989$var$createPause(childAbortController.signal),
                                delay: $44e97ff44f917989$var$createDelay(childAbortController.signal),
                                signal: childAbortController.signal
                            })
                        ];
                    case 1:
                        result2 = _state.sent();
                        $44e97ff44f917989$var$validateActive(childAbortController.signal);
                        return [
                            2,
                            result2
                        ];
                }
            });
        }), function() {
            return $44e97ff44f917989$var$abortControllerWithReason(childAbortController, $44e97ff44f917989$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($44e97ff44f917989$var$noop2));
        return {
            result: $44e97ff44f917989$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $44e97ff44f917989$var$abortControllerWithReason(childAbortController, $44e97ff44f917989$var$taskCancelled);
            }
        };
    };
};
var $44e97ff44f917989$var$createTakePattern = function(startListening, signal) {
    var take = function() {
        var _ref = (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(predicate, timeout) {
            var unsubscribe, tuplePromise, promises, output;
            return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $44e97ff44f917989$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            $44e97ff44f917989$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _state.sent();
                        $44e97ff44f917989$var$validateActive(signal);
                        return [
                            2,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function take(predicate, timeout) {
            return _ref.apply(this, arguments);
        };
    }();
    return function(predicate, timeout) {
        return $44e97ff44f917989$var$catchRejection(take(predicate, timeout));
    };
};
var $44e97ff44f917989$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $44e97ff44f917989$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($44e97ff44f917989$export$378fa86b259c0280(21));
    $44e97ff44f917989$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $44e97ff44f917989$var$createListenerEntry = Object.assign(function(options) {
    var _getListenerEntryPropsFrom = $44e97ff44f917989$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, predicate = _getListenerEntryPropsFrom.predicate, effect = _getListenerEntryPropsFrom.effect;
    var id = $44e97ff44f917989$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: function() {
            throw new Error($44e97ff44f917989$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: function() {
        return $44e97ff44f917989$var$createListenerEntry;
    }
});
var $44e97ff44f917989$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $44e97ff44f917989$var$abortControllerWithReason(controller, $44e97ff44f917989$var$listenerCancelled);
    });
};
var $44e97ff44f917989$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($44e97ff44f917989$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $44e97ff44f917989$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $44e97ff44f917989$export$f03a6b845d3fb58b = Object.assign($44e97ff44f917989$export$309c7a02b0b0bc62("".concat($44e97ff44f917989$var$alm, "/add")), {
    withTypes: function() {
        return $44e97ff44f917989$export$f03a6b845d3fb58b;
    }
});
var $44e97ff44f917989$export$b1b8022855fb2b71 = $44e97ff44f917989$export$309c7a02b0b0bc62("".concat($44e97ff44f917989$var$alm, "/removeAll"));
var $44e97ff44f917989$export$b03e9483f936dccb = Object.assign($44e97ff44f917989$export$309c7a02b0b0bc62("".concat($44e97ff44f917989$var$alm, "/remove")), {
    withTypes: function() {
        return $44e97ff44f917989$export$b03e9483f936dccb;
    }
});
var $44e97ff44f917989$var$defaultErrorHandler = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    (_console = console).error.apply(_console, [
        "".concat($44e97ff44f917989$var$alm, "/error")
    ].concat((0, $2Xzd1._)(args)));
};
var $44e97ff44f917989$export$1228acebbbcb485b = function() {
    var middlewareOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var listenerMap = /* @__PURE__ */ new Map();
    var extra = middlewareOptions.extra, _middlewareOptions_onError = middlewareOptions.onError, onError = _middlewareOptions_onError === void 0 ? $44e97ff44f917989$var$defaultErrorHandler : _middlewareOptions_onError;
    $44e97ff44f917989$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $44e97ff44f917989$var$cancelActiveListeners(entry);
        };
    };
    var startListening = function(options) {
        var entry = $44e97ff44f917989$var$find(Array.from(listenerMap.values()), function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $44e97ff44f917989$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    Object.assign(startListening, {
        withTypes: function() {
            return startListening;
        }
    });
    var stopListening = function(options) {
        var _getListenerEntryPropsFrom = $44e97ff44f917989$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, effect = _getListenerEntryPropsFrom.effect, predicate = _getListenerEntryPropsFrom.predicate;
        var entry = $44e97ff44f917989$var$find(Array.from(listenerMap.values()), function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $44e97ff44f917989$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    Object.assign(stopListening, {
        withTypes: function() {
            return stopListening;
        }
    });
    var notifyListener = function() {
        var _ref = (0, $554ed4b40b13e16f$export$7c398597f8905a1)(function(entry, action, api, getOriginalState) {
            var internalTaskController, take, autoJoinPromises, listenerError;
            return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $44e97ff44f917989$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4,
                            Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
                            $44e97ff44f917989$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $44e97ff44f917989$var$createDelay(internalTaskController.signal),
                                pause: $44e97ff44f917989$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $44e97ff44f917989$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $44e97ff44f917989$var$abortControllerWithReason(controller, $44e97ff44f917989$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                },
                                cancel: function() {
                                    $44e97ff44f917989$var$abortControllerWithReason(internalTaskController, $44e97ff44f917989$var$listenerCancelled);
                                    entry.pending.delete(internalTaskController);
                                },
                                throwIfCancelled: function() {
                                    $44e97ff44f917989$var$validateActive(internalTaskController.signal);
                                }
                            })))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 3:
                        listenerError = _state.sent();
                        if (!(listenerError instanceof $44e97ff44f917989$export$cb1bdac908fed7f)) $44e97ff44f917989$var$safelyNotifyError(onError, listenerError, {
                            raisedBy: "effect"
                        });
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            Promise.all(autoJoinPromises)
                        ];
                    case 5:
                        _state.sent();
                        $44e97ff44f917989$var$abortControllerWithReason(internalTaskController, $44e97ff44f917989$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function notifyListener(entry, action, api, getOriginalState) {
            return _ref.apply(this, arguments);
        };
    }();
    var clearListenerMiddleware = $44e97ff44f917989$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!(0, $a039f9c7168ef4c9$export$b956e38827fca970)(action)) return next(action);
                if ($44e97ff44f917989$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($44e97ff44f917989$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($44e97ff44f917989$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $44e97ff44f917989$var$INTERNAL_NIL_TOKEN) throw new Error($44e97ff44f917989$export$378fa86b259c0280(23));
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = listenerEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var entry = _step.value;
                                var runListener = false;
                                try {
                                    runListener = entry.predicate(action, currentState, originalState);
                                } catch (predicateError) {
                                    runListener = false;
                                    $44e97ff44f917989$var$safelyNotifyError(onError, predicateError, {
                                        raisedBy: "predicate"
                                    });
                                }
                                if (!runListener) continue;
                                notifyListener(entry, action, api, getOriginalState);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } finally{
                    originalState = $44e97ff44f917989$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $44e97ff44f917989$var$createMiddlewareEntry = function(middleware) {
    return {
        id: $44e97ff44f917989$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    };
};
var $44e97ff44f917989$var$matchInstance = function(instanceId) {
    return function(action) {
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
};
var $44e97ff44f917989$export$4bb1606a79445586 = function() {
    var instanceId = $44e97ff44f917989$export$ac4959f4f1338dfc();
    var middlewareMap = /* @__PURE__ */ new Map();
    var withMiddleware = Object.assign($44e97ff44f917989$export$309c7a02b0b0bc62("dynamicMiddleware/add", function() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        return {
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        };
    }), {
        withTypes: function() {
            return withMiddleware;
        }
    });
    var addMiddleware = Object.assign(function addMiddleware2() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        middlewares.forEach(function(middleware2) {
            var entry = $44e97ff44f917989$var$find(Array.from(middlewareMap.values()), function(entry2) {
                return entry2.middleware === middleware2;
            });
            if (!entry) entry = $44e97ff44f917989$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: function() {
            return addMiddleware;
        }
    });
    var getFinalMiddleware = function(api) {
        var appliedMiddleware = Array.from(middlewareMap.values()).map(function(entry) {
            return $44e97ff44f917989$var$emplace(entry.applied, api, {
                insert: function() {
                    return entry.middleware(api);
                }
            });
        });
        return (0, $a039f9c7168ef4c9$export$f672e0b6f7222cd7).apply(void 0, (0, $2Xzd1._)(appliedMiddleware));
    };
    var isWithMiddleware = $44e97ff44f917989$export$9dd1fb32974da385(withMiddleware, $44e97ff44f917989$var$matchInstance(instanceId));
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (isWithMiddleware(action)) {
                    addMiddleware.apply(void 0, (0, $2Xzd1._)(action.payload));
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
        };
    };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $44e97ff44f917989$var$isSliceLike = function(maybeSliceLike) {
    return "reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
};
var $44e97ff44f917989$var$getReducers = function(slices) {
    return slices.flatMap(function(sliceOrMap) {
        return $44e97ff44f917989$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap);
    });
};
var $44e97ff44f917989$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $44e97ff44f917989$var$isStateProxy = function(value) {
    return !!value && !!value[$44e97ff44f917989$var$ORIGINAL_STATE];
};
var $44e97ff44f917989$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $44e97ff44f917989$var$createStateProxy = function(state, reducerMap) {
    return $44e97ff44f917989$var$emplace($44e97ff44f917989$var$stateProxyMap, state, {
        insert: function() {
            return new Proxy(state, {
                get: function(target, prop, receiver) {
                    if (prop === $44e97ff44f917989$var$ORIGINAL_STATE) return target;
                    var result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        var reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            var reducerResult = reducer(void 0, {
                                type: $44e97ff44f917989$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($44e97ff44f917989$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            });
        }
    });
};
var $44e97ff44f917989$var$original = function(state) {
    if (!$44e97ff44f917989$var$isStateProxy(state)) throw new Error($44e97ff44f917989$export$378fa86b259c0280(25));
    return state[$44e97ff44f917989$var$ORIGINAL_STATE];
};
var $44e97ff44f917989$var$noopReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return state;
};
function $44e97ff44f917989$export$a3734c7614660b9() {
    for(var _len = arguments.length, slices = new Array(_len), _key = 0; _key < _len; _key++){
        slices[_key] = arguments[_key];
    }
    var reducerMap = Object.fromEntries($44e97ff44f917989$var$getReducers(slices));
    var getReducer = function() {
        return Object.keys(reducerMap).length ? (0, $a039f9c7168ef4c9$export$66e4520cdb265d18)(reducerMap) : $44e97ff44f917989$var$noopReducer;
    };
    var reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = function() {
        return combinedReducer;
    };
    var inject = function(slice) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var reducerPath = slice.reducerPath, reducerToInject = slice.reducer;
        var currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $d3e3033a14238d9e$exports === "undefined" ? "undefined" : (0, $YtE9h._)($d3e3033a14238d9e$exports);
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    var selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return selectorFn.apply(void 0, [
                $44e97ff44f917989$var$createStateProxy(selectState ? selectState.apply(void 0, [
                    state
                ].concat((0, $2Xzd1._)(args))) : state, reducerMap)
            ].concat((0, $2Xzd1._)(args)));
        };
    }, {
        original: $44e97ff44f917989$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $44e97ff44f917989$export$378fa86b259c0280(code) {
    return "Minified Redux Toolkit error #".concat(code, "; visit https://redux-toolkit.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}


var $2767c9397776ff73$var$cartSlice = (0, $44e97ff44f917989$export$4d8d9bd83c24ae8b)({
    name: "cart",
    initialState: {
        items: []
    },
    reducers: {
        addItem: function(state, action) {
            var newItem = action.payload;
            var existingItem = state.items.find(function(item) {
                return item.card.info.id === newItem.card.info.id;
            });
            if (existingItem) existingItem.quantity++; // Increment quantity if the item already exists
            else state.items.push((0, $f17388ede13a49cc$export$4fa2f4023c9cbda5)((0, $ad1c00e896d27009$export$581ff339ea0ba762)({}, newItem), {
                quantity: 1
            })); // Add new item with quantity 1
        },
        removeItem: function(state, action) {
            var itemId = action.payload.card.info.id;
            state.items = state.items.filter(function(item) {
                return item.card.info.id !== itemId;
            });
        },
        incrementItemQuantity: function(state, action) {
            var itemId = action.payload;
            var item = state.items.find(function(item) {
                return item.card.info.id === itemId;
            });
            if (item) item.quantity++; // Increment item quantity
        },
        decrementItemQuantity: function(state, action) {
            var itemId = action.payload;
            var item = state.items.find(function(item) {
                return item.card.info.id === itemId;
            });
            if (item && item.quantity > 1) item.quantity--; // Decrement item quantity, but keep at least 1
        },
        clearCart: function(state) {
            state.items = []; // Clear the cart
        }
    }
});
var $2767c9397776ff73$var$_cartSlice_actions = $2767c9397776ff73$var$cartSlice.actions;
var $2767c9397776ff73$export$fb9705de59d96855 = $2767c9397776ff73$var$_cartSlice_actions.addItem, $2767c9397776ff73$export$fe2d9b4e03920b4c = $2767c9397776ff73$var$_cartSlice_actions.removeItem, $2767c9397776ff73$export$a6c91e66104ffdf1 = $2767c9397776ff73$var$_cartSlice_actions.incrementItemQuantity, $2767c9397776ff73$export$48212958f03f98d4 = $2767c9397776ff73$var$_cartSlice_actions.decrementItemQuantity, $2767c9397776ff73$export$810121176e3e3671 = $2767c9397776ff73$var$_cartSlice_actions.clearCart;
var $2767c9397776ff73$export$2e2bcd8739ae039 = $2767c9397776ff73$var$cartSlice.reducer;


var $3a63efcc8c0a1cc1$var$ItemList = function(param) {
    var items = param.items, dummy = param.dummy;
    var dispatch = (0, $c7b80bd183211e5d$export$8ad76b76a4c905f8)();
    var handleAddItem = function(item) {
        dispatch((0, $2767c9397776ff73$export$fb9705de59d96855)(item));
    };
    return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
        children: items.map(function(item) {
            return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                "data-testid": "foodItems",
                className: "p-2 m-2 border-gray-200 border-b-2 text-left flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "w-9/12",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "py-2",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                        className: "font-bold",
                                        children: item.card.info.name
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                        children: [
                                            " ",
                                            "- \u20B9",
                                            item.card.info.price ? item.card.info.price / 100 : item.card.info.defaultPrice / 100
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                                className: "text-sm pb-4",
                                children: item.card.info.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "w-3/12 p-4",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                className: "absolute",
                                children: /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                    className: "p-2 mx-16 rounded-lg bg-black text-white shadow-lg",
                                    onClick: function() {
                                        return handleAddItem(item);
                                    },
                                    children: "Add +"
                                })
                            }),
                            item.card.info.imageId && /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                src: (0, $cc25cc9a913d8a70$export$31adfacaf07ffe63) + item.card.info.imageId,
                                className: "h-28 object-cover aspect-auto rounded-lg w-[156px]"
                            })
                        ]
                    })
                ]
            }, item.card.info.id);
        })
    });
};
var $3a63efcc8c0a1cc1$export$2e2bcd8739ae039 = $3a63efcc8c0a1cc1$var$ItemList;


var $d61e5d477b89ad78$var$RestaurantCategory = function(param) {
    var data = param.data, showItems = param.showItems, setShowIndex = param.setShowIndex, dummy = param.dummy;
    var handleClick = function() {
        setShowIndex();
    };
    return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
        children: /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
            className: "w-6/12 mx-auto my-4 bg-gray-50 shadow-lg p-4",
            children: [
                /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                    className: "flex justify-between cursor-pointer",
                    onClick: handleClick,
                    children: [
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                            className: "font-bold text-lg",
                            children: [
                                data.title,
                                " (",
                                data.itemCards.length,
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                            children: showItems ? "\u2B06\uFE0F" : "\u2B07\uFE0F"
                        })
                    ]
                }),
                showItems && /*#__PURE__*/ (0, $cc6u1.jsx)((0, $3a63efcc8c0a1cc1$export$2e2bcd8739ae039), {
                    items: data.itemCards,
                    dummy: dummy
                })
            ]
        })
    });
};
var $d61e5d477b89ad78$export$2e2bcd8739ae039 = $d61e5d477b89ad78$var$RestaurantCategory;



var $fIwXP = parcelRequire("fIwXP");
var $d1dc02be9882a390$var$RestaurantMenu = function() {
    var _resInfo_cards__card_card, _resInfo_cards__card, _resInfo_cards_, _resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards__card, _resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards_, _resInfo_cards__groupedCard_cardGroupMap_REGULAR, _resInfo_cards__groupedCard_cardGroupMap, _resInfo_cards__groupedCard, _resInfo_cards_1, _resInfo_cards__groupedCard_cardGroupMap_REGULAR1, _resInfo_cards__groupedCard_cardGroupMap1, _resInfo_cards__groupedCard1, _resInfo_cards_2;
    var resId = (0, $9e36fd5982483bee$export$99eaa27ddbbb95ef)().resId;
    var dummy = "Dummy Data";
    var resInfo = (0, $6d359334c042511a$export$2e2bcd8739ae039)(resId);
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(null), 2), showIndex = _useState[0], setShowIndex = _useState[1];
    if (resInfo === null) return /*#__PURE__*/ (0, $cc6u1.jsx)((0, $68ce1d77bc18c07c$export$2e2bcd8739ae039), {});
    var _ref = resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards_ = resInfo.cards[2]) === null || _resInfo_cards_ === void 0 ? void 0 : (_resInfo_cards__card = _resInfo_cards_.card) === null || _resInfo_cards__card === void 0 ? void 0 : (_resInfo_cards__card_card = _resInfo_cards__card.card) === null || _resInfo_cards__card_card === void 0 ? void 0 : _resInfo_cards__card_card.info, name = _ref.name, cuisines = _ref.cuisines, costForTwoMessage = _ref.costForTwoMessage;
    var itemCards = (resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards_1 = resInfo.cards[4]) === null || _resInfo_cards_1 === void 0 ? void 0 : (_resInfo_cards__groupedCard = _resInfo_cards_1.groupedCard) === null || _resInfo_cards__groupedCard === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap = _resInfo_cards__groupedCard.cardGroupMap) === null || _resInfo_cards__groupedCard_cardGroupMap === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap_REGULAR = _resInfo_cards__groupedCard_cardGroupMap.REGULAR) === null || _resInfo_cards__groupedCard_cardGroupMap_REGULAR === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards_ = _resInfo_cards__groupedCard_cardGroupMap_REGULAR.cards[2]) === null || _resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards_ === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards__card = _resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards_.card) === null || _resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards__card === void 0 ? void 0 : _resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards__card.card).itemCards;
    var categories = resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards_2 = resInfo.cards[4]) === null || _resInfo_cards_2 === void 0 ? void 0 : (_resInfo_cards__groupedCard1 = _resInfo_cards_2.groupedCard) === null || _resInfo_cards__groupedCard1 === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap1 = _resInfo_cards__groupedCard1.cardGroupMap) === null || _resInfo_cards__groupedCard_cardGroupMap1 === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap_REGULAR1 = _resInfo_cards__groupedCard_cardGroupMap1.REGULAR) === null || _resInfo_cards__groupedCard_cardGroupMap_REGULAR1 === void 0 ? void 0 : _resInfo_cards__groupedCard_cardGroupMap_REGULAR1.cards.filter(function(c) {
        var _c_card_card, _c_card;
        return ((_c_card = c.card) === null || _c_card === void 0 ? void 0 : (_c_card_card = _c_card.card) === null || _c_card_card === void 0 ? void 0 : _c_card_card["@type"]) === "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory";
    });
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "text-center",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                className: "font-bold my-6 text-2xl",
                children: name
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("p", {
                className: "font-bold text-lg",
                children: [
                    cuisines.join(", "),
                    " - ",
                    costForTwoMessage
                ]
            }),
            categories.map(function(category, index) {
                var _category_card, _category_card_card, _category_card1;
                return(//Controlled component
                /*#__PURE__*/ (0, $cc6u1.jsx)((0, $d61e5d477b89ad78$export$2e2bcd8739ae039), {
                    data: category === null || category === void 0 ? void 0 : (_category_card = category.card) === null || _category_card === void 0 ? void 0 : _category_card.card,
                    showItems: index === showIndex ? true : false,
                    setShowIndex: function() {
                        return setShowIndex(index === showIndex ? null : index);
                    },
                    dummy: dummy
                }, category === null || category === void 0 ? void 0 : (_category_card1 = category.card) === null || _category_card1 === void 0 ? void 0 : (_category_card_card = _category_card1.card) === null || _category_card_card === void 0 ? void 0 : _category_card_card.title));
            })
        ]
    });
};
var $d1dc02be9882a390$export$2e2bcd8739ae039 = $d1dc02be9882a390$var$RestaurantMenu;





var $cc6u1 = parcelRequire("cc6u1");


var $cc6u1 = parcelRequire("cc6u1");





var $04103b6696800a9c$var$CartItemList = function(param) {
    var items = param.items;
    var dispatch = (0, $c7b80bd183211e5d$export$8ad76b76a4c905f8)();
    var totalCartPrice = 0;
    var handleAddItem = function(item) {
        dispatch((0, $2767c9397776ff73$export$fb9705de59d96855)(item));
    };
    var handleRemoveItem = function(item) {
        dispatch((0, $2767c9397776ff73$export$fe2d9b4e03920b4c)(item));
    };
    var handleIncrementQuantity = function(item) {
        dispatch((0, $2767c9397776ff73$export$a6c91e66104ffdf1)(item.card.info.id));
    };
    var handleDecrementQuantity = function(item) {
        dispatch((0, $2767c9397776ff73$export$48212958f03f98d4)(item.card.info.id));
    };
    var handleClearCart = function() {
        dispatch((0, $2767c9397776ff73$export$810121176e3e3671)());
        // Display order on the way message
        alert("Order Placed Successfully!");
    };
    var handleCheckout = function() {
        handleClearCart();
    };
    items.forEach(function(item) {
        totalCartPrice += (item.card.info.price ? item.card.info.price / 100 : item.card.info.defaultPrice / 100) * item.quantity;
    });
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                    className: "p-2 m-2 bg-black text-white rounded-lg",
                    onClick: handleClearCart,
                    children: "Clear Cart"
                })
            }),
            items.map(function(item) {
                return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                    className: "p-2 m-2 border-gray-200 border-b-2 text-left flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                            className: "w-9/12",
                            children: [
                                /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                    className: "py-2",
                                    children: [
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                            className: "font-bold",
                                            children: item.card.info.name
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                            children: [
                                                " ",
                                                " - \u20B9",
                                                item.card.info.price ? item.card.info.price / 100 : item.card.info.defaultPrice / 100
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                                    className: "text-sm pb-4",
                                    children: item.card.info.description
                                }),
                                /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                    className: "border flex items-center w-fit",
                                    children: [
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                            className: "p-3 font-bold",
                                            onClick: function() {
                                                return handleDecrementQuantity(item);
                                            },
                                            children: "-"
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                            className: "px-3",
                                            children: item.quantity
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                            className: "p-3 font-bold",
                                            onClick: function() {
                                                return handleIncrementQuantity(item);
                                            },
                                            children: "+"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                            className: "w-3/12 p-4 relative",
                            children: [
                                /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                    className: "absolute top-0 right-0",
                                    children: /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                        className: "p-2 px-[13px] rounded-full bg-red-500 text-white shadow-lg",
                                        onClick: function() {
                                            return handleRemoveItem(item);
                                        },
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $69bac3e467faf0d3$export$2b9260d4a45c8710), {
                                            icon: (0, $5c8203742f0e3062$export$ed8c149a0ea54bb4)
                                        })
                                    })
                                }),
                                item.card.info.imageId && /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                    src: (0, $cc25cc9a913d8a70$export$31adfacaf07ffe63) + item.card.info.imageId,
                                    className: "h-28 object-cover aspect-auto rounded-lg w-[156px]",
                                    alt: item.card.info.name
                                })
                            ]
                        })
                    ]
                }, item.card.info.id);
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "text-right pr-4",
                children: /*#__PURE__*/ (0, $cc6u1.jsxs)("p", {
                    className: "font-bold",
                    children: [
                        "Total Amount: \u20B9",
                        totalCartPrice.toFixed(2)
                    ]
                })
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                children: /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                    className: "p-2 px-4 font-bold my-10 m-2 bg-[#fc8019] text-white",
                    onClick: handleCheckout,
                    children: "CheckOut"
                })
            })
        ]
    });
};
var $04103b6696800a9c$export$2e2bcd8739ae039 = $04103b6696800a9c$var$CartItemList;



var $b47241cf3d81c34b$var$Cart = function() {
    var cartItems = (0, $c7b80bd183211e5d$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    var dispatch = (0, $c7b80bd183211e5d$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "text-center m-4 p-4",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                className: "text-2xl font-bold",
                children: "Cart"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "w-6/12 m-auto",
                children: cartItems.length === 0 ? /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                            className: "font-bold text-lg text-black",
                            children: "Your cart is empty"
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                            children: "You can go to the home page to view more restaurants"
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                            className: "p-2 px-4 font-bold my-10 m-2 bg-[#fc8019] text-white",
                            children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: "SEE RESTAURANTS NEAR YOU"
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $cc6u1.jsx)((0, $04103b6696800a9c$export$2e2bcd8739ae039), {
                    items: cartItems
                })
            })
        ]
    });
};
var $b47241cf3d81c34b$export$2e2bcd8739ae039 = $b47241cf3d81c34b$var$Cart;




var $8c21c4a485ab61ca$var$appStore = (0, $44e97ff44f917989$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $2767c9397776ff73$export$2e2bcd8739ae039)
    }
});
var $8c21c4a485ab61ca$export$2e2bcd8739ae039 = $8c21c4a485ab61ca$var$appStore;



var $cc6u1 = parcelRequire("cc6u1");
parcelRequire("fIwXP");
var $6709bac9fe63cf1c$var$Footer = function() {
    return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
        className: "bg-black text-white p-5 text-center",
        children: /*#__PURE__*/ (0, $cc6u1.jsx)("h3", {
            children: "Swiggy clone | 2024 | Deepa E V"
        })
    });
};
var $6709bac9fe63cf1c$export$2e2bcd8739ae039 = $6709bac9fe63cf1c$var$Footer;



// chunking
// code splitting
// dynamic bundling
// Lazy loading
// on demand loading
// dynamic import
var $0daa6d02c6c97a55$var$Grocery = /*#__PURE__*/ (0, $fIwXP.lazy)(function() {
    return (parcelRequire("c38Wl"));
});
var $0daa6d02c6c97a55$var$AppLayout = function() {
    //authentication
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(), 2), userName = _useState[0], setUserInfo = _useState[1];
    (0, $fIwXP.useEffect)(function() {
        var data = {
            name: "Deepa E V"
        };
        setUserInfo(data.name);
    }, []);
    return /*#__PURE__*/ (0, $cc6u1.jsx)((0, $c7b80bd183211e5d$export$2881499e37b75b9a), {
        store: (0, $8c21c4a485ab61ca$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $0cf10ba694782b3e$export$2e2bcd8739ae039).Provider, {
            value: {
                loggedInUser: userName
            },
            children: /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: " w-[1263px] min-h-screen flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "flex-grow",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)((0, $f310bc4ea983f747$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $cc6u1.jsx)((0, $9e36fd5982483bee$export$910ae8079b2c2852), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)((0, $6709bac9fe63cf1c$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
};
var $0daa6d02c6c97a55$var$appRouter = (0, $76a326218c469af1$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $cc6u1.jsx)($0daa6d02c6c97a55$var$AppLayout, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $373b11f276a41253$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $fIwXP.Suspense), {
                    fallback: /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                        children: "Loading...."
                    }),
                    children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $601c1599e979598b$export$2e2bcd8739ae039), {})
                })
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $717a2f0a6a708d12$export$2e2bcd8739ae039), {})
            },
            {
                path: "/restaurants/:resId",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $d1dc02be9882a390$export$2e2bcd8739ae039), {})
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $b47241cf3d81c34b$export$2e2bcd8739ae039), {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $eb9ea4566ac52960$export$2e2bcd8739ae039), {})
    }
]);
var $0daa6d02c6c97a55$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($fb34d4b6d3b01836$exports))).createRoot(document.getElementById("root"));
$0daa6d02c6c97a55$var$root.render(/*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$323e4fc2fa4753fb), {
    router: $0daa6d02c6c97a55$var$appRouter
}));

})();
//# sourceMappingURL=index.0df21711.js.map
